/*! For license information please see salesteam-bo.js.LICENSE.txt */
!(function () {
  var e,
    t,
    n = {
      2898: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return ae;
          },
        });
        var r = (function () {
            function e(e) {
              var t = this;
              (this._insertTag = function (e) {
                var n;
                (n =
                  0 === t.tags.length
                    ? t.insertionPoint
                      ? t.insertionPoint.nextSibling
                      : t.prepend
                      ? t.container.firstChild
                      : t.before
                    : t.tags[t.tags.length - 1].nextSibling),
                  t.container.insertBefore(e, n),
                  t.tags.push(e);
              }),
                (this.isSpeedy = void 0 === e.speedy || e.speedy),
                (this.tags = []),
                (this.ctr = 0),
                (this.nonce = e.nonce),
                (this.key = e.key),
                (this.container = e.container),
                (this.prepend = e.prepend),
                (this.insertionPoint = e.insertionPoint),
                (this.before = null);
            }
            var t = e.prototype;
            return (
              (t.hydrate = function (e) {
                e.forEach(this._insertTag);
              }),
              (t.insert = function (e) {
                this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 &&
                  this._insertTag(
                    (function (e) {
                      var t = document.createElement("style");
                      return (
                        t.setAttribute("data-emotion", e.key),
                        void 0 !== e.nonce && t.setAttribute("nonce", e.nonce),
                        t.appendChild(document.createTextNode("")),
                        t.setAttribute("data-s", ""),
                        t
                      );
                    })(this)
                  );
                var t = this.tags[this.tags.length - 1];
                if (this.isSpeedy) {
                  var n = (function (e) {
                    if (e.sheet) return e.sheet;
                    for (var t = 0; t < document.styleSheets.length; t++)
                      if (document.styleSheets[t].ownerNode === e)
                        return document.styleSheets[t];
                  })(t);
                  try {
                    n.insertRule(e, n.cssRules.length);
                  } catch (e) {}
                } else t.appendChild(document.createTextNode(e));
                this.ctr++;
              }),
              (t.flush = function () {
                this.tags.forEach(function (e) {
                  return e.parentNode && e.parentNode.removeChild(e);
                }),
                  (this.tags = []),
                  (this.ctr = 0);
              }),
              e
            );
          })(),
          o = Math.abs,
          a = String.fromCharCode,
          i = Object.assign;
        function s(e) {
          return e.trim();
        }
        function l(e, t, n) {
          return e.replace(t, n);
        }
        function c(e, t) {
          return e.indexOf(t);
        }
        function u(e, t) {
          return 0 | e.charCodeAt(t);
        }
        function d(e, t, n) {
          return e.slice(t, n);
        }
        function p(e) {
          return e.length;
        }
        function m(e) {
          return e.length;
        }
        function h(e, t) {
          return t.push(e), e;
        }
        var f = 1,
          g = 1,
          v = 0,
          b = 0,
          _ = 0,
          y = "";
        function x(e, t, n, r, o, a, i) {
          return {
            value: e,
            root: t,
            parent: n,
            type: r,
            props: o,
            children: a,
            line: f,
            column: g,
            length: i,
            return: "",
          };
        }
        function C(e, t) {
          return i(
            x("", null, null, "", null, null, 0),
            e,
            { length: -e.length },
            t
          );
        }
        function S() {
          return (
            (_ = b > 0 ? u(y, --b) : 0), g--, 10 === _ && ((g = 1), f--), _
          );
        }
        function k() {
          return (
            (_ = b < v ? u(y, b++) : 0), g++, 10 === _ && ((g = 1), f++), _
          );
        }
        function w() {
          return u(y, b);
        }
        function P() {
          return b;
        }
        function O(e, t) {
          return d(y, e, t);
        }
        function I(e) {
          switch (e) {
            case 0:
            case 9:
            case 10:
            case 13:
            case 32:
              return 5;
            case 33:
            case 43:
            case 44:
            case 47:
            case 62:
            case 64:
            case 126:
            case 59:
            case 123:
            case 125:
              return 4;
            case 58:
              return 3;
            case 34:
            case 39:
            case 40:
            case 91:
              return 2;
            case 41:
            case 93:
              return 1;
          }
          return 0;
        }
        function T(e) {
          return (f = g = 1), (v = p((y = e))), (b = 0), [];
        }
        function M(e) {
          return (y = ""), e;
        }
        function E(e) {
          return s(O(b - 1, R(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
        }
        function D(e) {
          for (; (_ = w()) && _ < 33; ) k();
          return I(e) > 2 || I(_) > 3 ? "" : " ";
        }
        function j(e, t) {
          for (
            ;
            --t &&
            k() &&
            !(_ < 48 || _ > 102 || (_ > 57 && _ < 65) || (_ > 70 && _ < 97));

          );
          return O(e, P() + (t < 6 && 32 == w() && 32 == k()));
        }
        function R(e) {
          for (; k(); )
            switch (_) {
              case e:
                return b;
              case 34:
              case 39:
                34 !== e && 39 !== e && R(_);
                break;
              case 40:
                41 === e && R(e);
                break;
              case 92:
                k();
            }
          return b;
        }
        function N(e, t) {
          for (; k() && e + _ !== 57 && (e + _ !== 84 || 47 !== w()); );
          return "/*" + O(t, b - 1) + "*" + a(47 === e ? e : k());
        }
        function A(e) {
          for (; !I(w()); ) k();
          return O(e, b);
        }
        var L = "-ms-",
          z = "-moz-",
          B = "-webkit-",
          Z = "comm",
          F = "rule",
          H = "decl",
          V = "@import",
          W = "@keyframes",
          $ = "@layer";
        function U(e, t) {
          for (var n = "", r = m(e), o = 0; o < r; o++)
            n += t(e[o], o, e, t) || "";
          return n;
        }
        function K(e, t, n, r) {
          switch (e.type) {
            case $:
              if (e.children.length) break;
            case V:
            case H:
              return (e.return = e.return || e.value);
            case Z:
              return "";
            case W:
              return (e.return = e.value + "{" + U(e.children, r) + "}");
            case F:
              e.value = e.props.join(",");
          }
          return p((n = U(e.children, r)))
            ? (e.return = e.value + "{" + n + "}")
            : "";
        }
        function G(e) {
          return M(q("", null, null, null, [""], (e = T(e)), 0, [0], e));
        }
        function q(e, t, n, r, o, i, s, d, m) {
          for (
            var f = 0,
              g = 0,
              v = s,
              b = 0,
              _ = 0,
              y = 0,
              x = 1,
              C = 1,
              O = 1,
              I = 0,
              T = "",
              M = o,
              R = i,
              L = r,
              z = T;
            C;

          )
            switch (((y = I), (I = k()))) {
              case 40:
                if (108 != y && 58 == u(z, v - 1)) {
                  -1 != c((z += l(E(I), "&", "&\f")), "&\f") && (O = -1);
                  break;
                }
              case 34:
              case 39:
              case 91:
                z += E(I);
                break;
              case 9:
              case 10:
              case 13:
              case 32:
                z += D(y);
                break;
              case 92:
                z += j(P() - 1, 7);
                continue;
              case 47:
                switch (w()) {
                  case 42:
                  case 47:
                    h(J(N(k(), P()), t, n), m);
                    break;
                  default:
                    z += "/";
                }
                break;
              case 123 * x:
                d[f++] = p(z) * O;
              case 125 * x:
              case 59:
              case 0:
                switch (I) {
                  case 0:
                  case 125:
                    C = 0;
                  case 59 + g:
                    -1 == O && (z = l(z, /\f/g, "")),
                      _ > 0 &&
                        p(z) - v &&
                        h(
                          _ > 32
                            ? Q(z + ";", r, n, v - 1)
                            : Q(l(z, " ", "") + ";", r, n, v - 2),
                          m
                        );
                    break;
                  case 59:
                    z += ";";
                  default:
                    if (
                      (h(
                        (L = Y(z, t, n, f, g, o, d, T, (M = []), (R = []), v)),
                        i
                      ),
                      123 === I)
                    )
                      if (0 === g) q(z, t, L, L, M, i, v, d, R);
                      else
                        switch (99 === b && 110 === u(z, 3) ? 100 : b) {
                          case 100:
                          case 108:
                          case 109:
                          case 115:
                            q(
                              e,
                              L,
                              L,
                              r &&
                                h(Y(e, L, L, 0, 0, o, d, T, o, (M = []), v), R),
                              o,
                              R,
                              v,
                              d,
                              r ? M : R
                            );
                            break;
                          default:
                            q(z, L, L, L, [""], R, 0, d, R);
                        }
                }
                (f = g = _ = 0), (x = O = 1), (T = z = ""), (v = s);
                break;
              case 58:
                (v = 1 + p(z)), (_ = y);
              default:
                if (x < 1)
                  if (123 == I) --x;
                  else if (125 == I && 0 == x++ && 125 == S()) continue;
                switch (((z += a(I)), I * x)) {
                  case 38:
                    O = g > 0 ? 1 : ((z += "\f"), -1);
                    break;
                  case 44:
                    (d[f++] = (p(z) - 1) * O), (O = 1);
                    break;
                  case 64:
                    45 === w() && (z += E(k())),
                      (b = w()),
                      (g = v = p((T = z += A(P())))),
                      I++;
                    break;
                  case 45:
                    45 === y && 2 == p(z) && (x = 0);
                }
            }
          return i;
        }
        function Y(e, t, n, r, a, i, c, u, p, h, f) {
          for (
            var g = a - 1,
              v = 0 === a ? i : [""],
              b = m(v),
              _ = 0,
              y = 0,
              C = 0;
            _ < r;
            ++_
          )
            for (
              var S = 0, k = d(e, g + 1, (g = o((y = c[_])))), w = e;
              S < b;
              ++S
            )
              (w = s(y > 0 ? v[S] + " " + k : l(k, /&\f/g, v[S]))) &&
                (p[C++] = w);
          return x(e, t, n, 0 === a ? F : u, p, h, f);
        }
        function J(e, t, n) {
          return x(e, t, n, Z, a(_), d(e, 2, -2), 0);
        }
        function Q(e, t, n, r) {
          return x(e, t, n, H, d(e, 0, r), d(e, r + 1, -1), r);
        }
        var X = function (e, t, n) {
            for (
              var r = 0, o = 0;
              (r = o), (o = w()), 38 === r && 12 === o && (t[n] = 1), !I(o);

            )
              k();
            return O(e, b);
          },
          ee = new WeakMap(),
          te = function (e) {
            if ("rule" === e.type && e.parent && !(e.length < 1)) {
              for (
                var t = e.value,
                  n = e.parent,
                  r = e.column === n.column && e.line === n.line;
                "rule" !== n.type;

              )
                if (!(n = n.parent)) return;
              if (
                (1 !== e.props.length || 58 === t.charCodeAt(0) || ee.get(n)) &&
                !r
              ) {
                ee.set(e, !0);
                for (
                  var o = [],
                    i = (function (e, t) {
                      return M(
                        (function (e, t) {
                          var n = -1,
                            r = 44;
                          do {
                            switch (I(r)) {
                              case 0:
                                38 === r && 12 === w() && (t[n] = 1),
                                  (e[n] += X(b - 1, t, n));
                                break;
                              case 2:
                                e[n] += E(r);
                                break;
                              case 4:
                                if (44 === r) {
                                  (e[++n] = 58 === w() ? "&\f" : ""),
                                    (t[n] = e[n].length);
                                  break;
                                }
                              default:
                                e[n] += a(r);
                            }
                          } while ((r = k()));
                          return e;
                        })(T(e), t)
                      );
                    })(t, o),
                    s = n.props,
                    l = 0,
                    c = 0;
                  l < i.length;
                  l++
                )
                  for (var u = 0; u < s.length; u++, c++)
                    e.props[c] = o[l]
                      ? i[l].replace(/&\f/g, s[u])
                      : s[u] + " " + i[l];
              }
            }
          },
          ne = function (e) {
            if ("decl" === e.type) {
              var t = e.value;
              108 === t.charCodeAt(0) &&
                98 === t.charCodeAt(2) &&
                ((e.return = ""), (e.value = ""));
            }
          };
        function re(e, t) {
          switch (
            (function (e, t) {
              return 45 ^ u(e, 0)
                ? (((((((t << 2) ^ u(e, 0)) << 2) ^ u(e, 1)) << 2) ^ u(e, 2)) <<
                    2) ^
                    u(e, 3)
                : 0;
            })(e, t)
          ) {
            case 5103:
              return B + "print-" + e + e;
            case 5737:
            case 4201:
            case 3177:
            case 3433:
            case 1641:
            case 4457:
            case 2921:
            case 5572:
            case 6356:
            case 5844:
            case 3191:
            case 6645:
            case 3005:
            case 6391:
            case 5879:
            case 5623:
            case 6135:
            case 4599:
            case 4855:
            case 4215:
            case 6389:
            case 5109:
            case 5365:
            case 5621:
            case 3829:
              return B + e + e;
            case 5349:
            case 4246:
            case 4810:
            case 6968:
            case 2756:
              return B + e + z + e + L + e + e;
            case 6828:
            case 4268:
              return B + e + L + e + e;
            case 6165:
              return B + e + L + "flex-" + e + e;
            case 5187:
              return (
                B +
                e +
                l(e, /(\w+).+(:[^]+)/, B + "box-$1$2" + L + "flex-$1$2") +
                e
              );
            case 5443:
              return B + e + L + "flex-item-" + l(e, /flex-|-self/, "") + e;
            case 4675:
              return (
                B +
                e +
                L +
                "flex-line-pack" +
                l(e, /align-content|flex-|-self/, "") +
                e
              );
            case 5548:
              return B + e + L + l(e, "shrink", "negative") + e;
            case 5292:
              return B + e + L + l(e, "basis", "preferred-size") + e;
            case 6060:
              return (
                B +
                "box-" +
                l(e, "-grow", "") +
                B +
                e +
                L +
                l(e, "grow", "positive") +
                e
              );
            case 4554:
              return B + l(e, /([^-])(transform)/g, "$1" + B + "$2") + e;
            case 6187:
              return (
                l(
                  l(l(e, /(zoom-|grab)/, B + "$1"), /(image-set)/, B + "$1"),
                  e,
                  ""
                ) + e
              );
            case 5495:
            case 3959:
              return l(e, /(image-set\([^]*)/, B + "$1$`$1");
            case 4968:
              return (
                l(
                  l(
                    e,
                    /(.+:)(flex-)?(.*)/,
                    B + "box-pack:$3" + L + "flex-pack:$3"
                  ),
                  /s.+-b[^;]+/,
                  "justify"
                ) +
                B +
                e +
                e
              );
            case 4095:
            case 3583:
            case 4068:
            case 2532:
              return l(e, /(.+)-inline(.+)/, B + "$1$2") + e;
            case 8116:
            case 7059:
            case 5753:
            case 5535:
            case 5445:
            case 5701:
            case 4933:
            case 4677:
            case 5533:
            case 5789:
            case 5021:
            case 4765:
              if (p(e) - 1 - t > 6)
                switch (u(e, t + 1)) {
                  case 109:
                    if (45 !== u(e, t + 4)) break;
                  case 102:
                    return (
                      l(
                        e,
                        /(.+:)(.+)-([^]+)/,
                        "$1" +
                          B +
                          "$2-$3$1" +
                          z +
                          (108 == u(e, t + 3) ? "$3" : "$2-$3")
                      ) + e
                    );
                  case 115:
                    return ~c(e, "stretch")
                      ? re(l(e, "stretch", "fill-available"), t) + e
                      : e;
                }
              break;
            case 4949:
              if (115 !== u(e, t + 1)) break;
            case 6444:
              switch (u(e, p(e) - 3 - (~c(e, "!important") && 10))) {
                case 107:
                  return l(e, ":", ":" + B) + e;
                case 101:
                  return (
                    l(
                      e,
                      /(.+:)([^;!]+)(;|!.+)?/,
                      "$1" +
                        B +
                        (45 === u(e, 14) ? "inline-" : "") +
                        "box$3$1" +
                        B +
                        "$2$3$1" +
                        L +
                        "$2box$3"
                    ) + e
                  );
              }
              break;
            case 5936:
              switch (u(e, t + 11)) {
                case 114:
                  return B + e + L + l(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
                case 108:
                  return B + e + L + l(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
                case 45:
                  return B + e + L + l(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
              }
              return B + e + L + e + e;
          }
          return e;
        }
        var oe = [
            function (e, t, n, r) {
              if (e.length > -1 && !e.return)
                switch (e.type) {
                  case H:
                    e.return = re(e.value, e.length);
                    break;
                  case W:
                    return U([C(e, { value: l(e.value, "@", "@" + B) })], r);
                  case F:
                    if (e.length)
                      return (function (e, t) {
                        return e.map(t).join("");
                      })(e.props, function (t) {
                        switch (
                          (function (e, t) {
                            return (e = /(::plac\w+|:read-\w+)/.exec(e))
                              ? e[0]
                              : e;
                          })(t)
                        ) {
                          case ":read-only":
                          case ":read-write":
                            return U(
                              [
                                C(e, {
                                  props: [l(t, /:(read-\w+)/, ":" + z + "$1")],
                                }),
                              ],
                              r
                            );
                          case "::placeholder":
                            return U(
                              [
                                C(e, {
                                  props: [
                                    l(t, /:(plac\w+)/, ":" + B + "input-$1"),
                                  ],
                                }),
                                C(e, {
                                  props: [l(t, /:(plac\w+)/, ":" + z + "$1")],
                                }),
                                C(e, {
                                  props: [l(t, /:(plac\w+)/, L + "input-$1")],
                                }),
                              ],
                              r
                            );
                        }
                        return "";
                      });
                }
            },
          ],
          ae = function (e) {
            var t = e.key;
            if ("css" === t) {
              var n = document.querySelectorAll(
                "style[data-emotion]:not([data-s])"
              );
              Array.prototype.forEach.call(n, function (e) {
                -1 !== e.getAttribute("data-emotion").indexOf(" ") &&
                  (document.head.appendChild(e), e.setAttribute("data-s", ""));
              });
            }
            var o,
              a,
              i = e.stylisPlugins || oe,
              s = {},
              l = [];
            (o = e.container || document.head),
              Array.prototype.forEach.call(
                document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
                function (e) {
                  for (
                    var t = e.getAttribute("data-emotion").split(" "), n = 1;
                    n < t.length;
                    n++
                  )
                    s[t[n]] = !0;
                  l.push(e);
                }
              );
            var c,
              u,
              d,
              p,
              h = [
                K,
                ((p = function (e) {
                  c.insert(e);
                }),
                function (e) {
                  e.root || ((e = e.return) && p(e));
                }),
              ],
              f =
                ((u = [te, ne].concat(i, h)),
                (d = m(u)),
                function (e, t, n, r) {
                  for (var o = "", a = 0; a < d; a++)
                    o += u[a](e, t, n, r) || "";
                  return o;
                });
            a = function (e, t, n, r) {
              (c = n),
                U(G(e ? e + "{" + t.styles + "}" : t.styles), f),
                r && (g.inserted[t.name] = !0);
            };
            var g = {
              key: t,
              sheet: new r({
                key: t,
                container: o,
                nonce: e.nonce,
                speedy: e.speedy,
                prepend: e.prepend,
                insertionPoint: e.insertionPoint,
              }),
              nonce: e.nonce,
              inserted: s,
              registered: {},
              insert: a,
            };
            return g.sheet.hydrate(l), g;
          };
      },
      5042: function (e, t, n) {
        "use strict";
        function r(e) {
          var t = Object.create(null);
          return function (n) {
            return void 0 === t[n] && (t[n] = e(n)), t[n];
          };
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      2443: function (e, t, n) {
        "use strict";
        n.d(t, {
          C: function () {
            return i;
          },
          T: function () {
            return l;
          },
          w: function () {
            return s;
          },
        });
        var r = n(7294),
          o = n(2898),
          a =
            (n(6797),
            n(7278),
            (0, r.createContext)(
              "undefined" != typeof HTMLElement
                ? (0, o.Z)({ key: "css" })
                : null
            )),
          i = a.Provider,
          s = function (e) {
            return (0, r.forwardRef)(function (t, n) {
              var o = (0, r.useContext)(a);
              return e(t, o, n);
            });
          },
          l = (0, r.createContext)({});
      },
      917: function (e, t, n) {
        "use strict";
        n.d(t, {
          F4: function () {
            return u;
          },
          iv: function () {
            return c;
          },
          xB: function () {
            return l;
          },
        });
        var r = n(7294),
          o = (n(2898), n(2443)),
          a = (n(8679), n(444)),
          i = n(6797),
          s = n(7278),
          l = (0, o.w)(function (e, t) {
            var n = e.styles,
              l = (0, i.O)([n], void 0, (0, r.useContext)(o.T)),
              c = (0, r.useRef)();
            return (
              (0, s.j)(
                function () {
                  var e = t.key + "-global",
                    n = new t.sheet.constructor({
                      key: e,
                      nonce: t.sheet.nonce,
                      container: t.sheet.container,
                      speedy: t.sheet.isSpeedy,
                    }),
                    r = !1,
                    o = document.querySelector(
                      'style[data-emotion="' + e + " " + l.name + '"]'
                    );
                  return (
                    t.sheet.tags.length && (n.before = t.sheet.tags[0]),
                    null !== o &&
                      ((r = !0),
                      o.setAttribute("data-emotion", e),
                      n.hydrate([o])),
                    (c.current = [n, r]),
                    function () {
                      n.flush();
                    }
                  );
                },
                [t]
              ),
              (0, s.j)(
                function () {
                  var e = c.current,
                    n = e[0];
                  if (e[1]) e[1] = !1;
                  else {
                    if (
                      (void 0 !== l.next && (0, a.My)(t, l.next, !0),
                      n.tags.length)
                    ) {
                      var r = n.tags[n.tags.length - 1].nextElementSibling;
                      (n.before = r), n.flush();
                    }
                    t.insert("", l, n, !1);
                  }
                },
                [t, l.name]
              ),
              null
            );
          });
        function c() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          return (0, i.O)(t);
        }
        var u = function () {
          var e = c.apply(void 0, arguments),
            t = "animation-" + e.name;
          return {
            name: t,
            styles: "@keyframes " + t + "{" + e.styles + "}",
            anim: 1,
            toString: function () {
              return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
            },
          };
        };
      },
      6797: function (e, t, n) {
        "use strict";
        n.d(t, {
          O: function () {
            return f;
          },
        });
        var r = function (e) {
            for (var t, n = 0, r = 0, o = e.length; o >= 4; ++r, o -= 4)
              (t =
                1540483477 *
                  (65535 &
                    (t =
                      (255 & e.charCodeAt(r)) |
                      ((255 & e.charCodeAt(++r)) << 8) |
                      ((255 & e.charCodeAt(++r)) << 16) |
                      ((255 & e.charCodeAt(++r)) << 24))) +
                ((59797 * (t >>> 16)) << 16)),
                (n =
                  (1540483477 * (65535 & (t ^= t >>> 24)) +
                    ((59797 * (t >>> 16)) << 16)) ^
                  (1540483477 * (65535 & n) + ((59797 * (n >>> 16)) << 16)));
            switch (o) {
              case 3:
                n ^= (255 & e.charCodeAt(r + 2)) << 16;
              case 2:
                n ^= (255 & e.charCodeAt(r + 1)) << 8;
              case 1:
                n =
                  1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) +
                  ((59797 * (n >>> 16)) << 16);
            }
            return (
              ((n =
                1540483477 * (65535 & (n ^= n >>> 13)) +
                ((59797 * (n >>> 16)) << 16)) ^
                (n >>> 15)) >>>
              0
            ).toString(36);
          },
          o = {
            animationIterationCount: 1,
            borderImageOutset: 1,
            borderImageSlice: 1,
            borderImageWidth: 1,
            boxFlex: 1,
            boxFlexGroup: 1,
            boxOrdinalGroup: 1,
            columnCount: 1,
            columns: 1,
            flex: 1,
            flexGrow: 1,
            flexPositive: 1,
            flexShrink: 1,
            flexNegative: 1,
            flexOrder: 1,
            gridRow: 1,
            gridRowEnd: 1,
            gridRowSpan: 1,
            gridRowStart: 1,
            gridColumn: 1,
            gridColumnEnd: 1,
            gridColumnSpan: 1,
            gridColumnStart: 1,
            msGridRow: 1,
            msGridRowSpan: 1,
            msGridColumn: 1,
            msGridColumnSpan: 1,
            fontWeight: 1,
            lineHeight: 1,
            opacity: 1,
            order: 1,
            orphans: 1,
            tabSize: 1,
            widows: 1,
            zIndex: 1,
            zoom: 1,
            WebkitLineClamp: 1,
            fillOpacity: 1,
            floodOpacity: 1,
            stopOpacity: 1,
            strokeDasharray: 1,
            strokeDashoffset: 1,
            strokeMiterlimit: 1,
            strokeOpacity: 1,
            strokeWidth: 1,
          },
          a = n(5042),
          i = /[A-Z]|^ms/g,
          s = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
          l = function (e) {
            return 45 === e.charCodeAt(1);
          },
          c = function (e) {
            return null != e && "boolean" != typeof e;
          },
          u = (0, a.Z)(function (e) {
            return l(e) ? e : e.replace(i, "-$&").toLowerCase();
          }),
          d = function (e, t) {
            switch (e) {
              case "animation":
              case "animationName":
                if ("string" == typeof t)
                  return t.replace(s, function (e, t, n) {
                    return (m = { name: t, styles: n, next: m }), t;
                  });
            }
            return 1 === o[e] || l(e) || "number" != typeof t || 0 === t
              ? t
              : t + "px";
          };
        function p(e, t, n) {
          if (null == n) return "";
          if (void 0 !== n.__emotion_styles) return n;
          switch (typeof n) {
            case "boolean":
              return "";
            case "object":
              if (1 === n.anim)
                return (
                  (m = { name: n.name, styles: n.styles, next: m }), n.name
                );
              if (void 0 !== n.styles) {
                var r = n.next;
                if (void 0 !== r)
                  for (; void 0 !== r; )
                    (m = { name: r.name, styles: r.styles, next: m }),
                      (r = r.next);
                return n.styles + ";";
              }
              return (function (e, t, n) {
                var r = "";
                if (Array.isArray(n))
                  for (var o = 0; o < n.length; o++) r += p(e, t, n[o]) + ";";
                else
                  for (var a in n) {
                    var i = n[a];
                    if ("object" != typeof i)
                      null != t && void 0 !== t[i]
                        ? (r += a + "{" + t[i] + "}")
                        : c(i) && (r += u(a) + ":" + d(a, i) + ";");
                    else if (
                      !Array.isArray(i) ||
                      "string" != typeof i[0] ||
                      (null != t && void 0 !== t[i[0]])
                    ) {
                      var s = p(e, t, i);
                      switch (a) {
                        case "animation":
                        case "animationName":
                          r += u(a) + ":" + s + ";";
                          break;
                        default:
                          r += a + "{" + s + "}";
                      }
                    } else
                      for (var l = 0; l < i.length; l++)
                        c(i[l]) && (r += u(a) + ":" + d(a, i[l]) + ";");
                  }
                return r;
              })(e, t, n);
            case "function":
              if (void 0 !== e) {
                var o = m,
                  a = n(e);
                return (m = o), p(e, t, a);
              }
          }
          if (null == t) return n;
          var i = t[n];
          return void 0 !== i ? i : n;
        }
        var m,
          h = /label:\s*([^\s;\n{]+)\s*(;|$)/g,
          f = function (e, t, n) {
            if (
              1 === e.length &&
              "object" == typeof e[0] &&
              null !== e[0] &&
              void 0 !== e[0].styles
            )
              return e[0];
            var o = !0,
              a = "";
            m = void 0;
            var i = e[0];
            null == i || void 0 === i.raw
              ? ((o = !1), (a += p(n, t, i)))
              : (a += i[0]);
            for (var s = 1; s < e.length; s++)
              (a += p(n, t, e[s])), o && (a += i[s]);
            h.lastIndex = 0;
            for (var l, c = ""; null !== (l = h.exec(a)); ) c += "-" + l[1];
            return { name: r(a) + c, styles: a, next: m };
          };
      },
      7278: function (e, t, n) {
        "use strict";
        var r;
        n.d(t, {
          L: function () {
            return i;
          },
          j: function () {
            return s;
          },
        });
        var o = n(7294),
          a =
            !!(r || (r = n.t(o, 2))).useInsertionEffect &&
            (r || (r = n.t(o, 2))).useInsertionEffect,
          i =
            a ||
            function (e) {
              return e();
            },
          s = a || o.useLayoutEffect;
      },
      444: function (e, t, n) {
        "use strict";
        function r(e, t, n) {
          var r = "";
          return (
            n.split(" ").forEach(function (n) {
              void 0 !== e[n] ? t.push(e[n] + ";") : (r += n + " ");
            }),
            r
          );
        }
        n.d(t, {
          My: function () {
            return a;
          },
          fp: function () {
            return r;
          },
          hC: function () {
            return o;
          },
        });
        var o = function (e, t, n) {
            var r = e.key + "-" + t.name;
            !1 === n &&
              void 0 === e.registered[r] &&
              (e.registered[r] = t.styles);
          },
          a = function (e, t, n) {
            o(e, t, n);
            var r = e.key + "-" + t.name;
            if (void 0 === e.inserted[t.name]) {
              var a = t;
              do {
                e.insert(t === a ? "." + r : "", a, e.sheet, !0), (a = a.next);
              } while (void 0 !== a);
            }
          };
      },
      6693: function (e, t, n) {
        "use strict";
        var r = n(4836);
        t.Z = void 0;
        var o = r(n(4938)),
          a = n(5893);
        t.Z = (0, o.default)(
          (0, a.jsx)("path", {
            d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z",
          }),
          "Image"
        );
      },
      4938: function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          Object.defineProperty(t, "default", {
            enumerable: !0,
            get: function () {
              return r.createSvgIcon;
            },
          });
        var r = n(5294);
      },
      3502: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return b;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(7294),
          i = n(3961),
          s = n(8510),
          l = n(8216),
          c = n(1657),
          u = n(948),
          d = n(1977),
          p = n(5463);
        function m(e) {
          return (0, p.ZP)("MuiSvgIcon", e);
        }
        (0, d.Z)("MuiSvgIcon", [
          "root",
          "colorPrimary",
          "colorSecondary",
          "colorAction",
          "colorError",
          "colorDisabled",
          "fontSizeInherit",
          "fontSizeSmall",
          "fontSizeMedium",
          "fontSizeLarge",
        ]);
        var h = n(5893);
        const f = [
            "children",
            "className",
            "color",
            "component",
            "fontSize",
            "htmlColor",
            "inheritViewBox",
            "titleAccess",
            "viewBox",
          ],
          g = (0, u.ZP)("svg", {
            name: "MuiSvgIcon",
            slot: "Root",
            overridesResolver: (e, t) => {
              const { ownerState: n } = e;
              return [
                t.root,
                "inherit" !== n.color && t[`color${(0, l.Z)(n.color)}`],
                t[`fontSize${(0, l.Z)(n.fontSize)}`],
              ];
            },
          })(({ theme: e, ownerState: t }) => {
            var n, r, o, a, i, s, l, c, u, d, p, m, h;
            return {
              userSelect: "none",
              width: "1em",
              height: "1em",
              display: "inline-block",
              fill: t.hasSvgAsChild ? void 0 : "currentColor",
              flexShrink: 0,
              transition:
                null == (n = e.transitions) || null == (r = n.create)
                  ? void 0
                  : r.call(n, "fill", {
                      duration:
                        null == (o = e.transitions) || null == (o = o.duration)
                          ? void 0
                          : o.shorter,
                    }),
              fontSize: {
                inherit: "inherit",
                small:
                  (null == (a = e.typography) || null == (i = a.pxToRem)
                    ? void 0
                    : i.call(a, 20)) || "1.25rem",
                medium:
                  (null == (s = e.typography) || null == (l = s.pxToRem)
                    ? void 0
                    : l.call(s, 24)) || "1.5rem",
                large:
                  (null == (c = e.typography) || null == (u = c.pxToRem)
                    ? void 0
                    : u.call(c, 35)) || "2.1875rem",
              }[t.fontSize],
              color:
                null !=
                (d =
                  null == (p = (e.vars || e).palette) ||
                  null == (p = p[t.color])
                    ? void 0
                    : p.main)
                  ? d
                  : {
                      action:
                        null == (m = (e.vars || e).palette) ||
                        null == (m = m.action)
                          ? void 0
                          : m.active,
                      disabled:
                        null == (h = (e.vars || e).palette) ||
                        null == (h = h.action)
                          ? void 0
                          : h.disabled,
                      inherit: void 0,
                    }[t.color],
            };
          }),
          v = a.forwardRef(function (e, t) {
            const n = (0, c.Z)({ props: e, name: "MuiSvgIcon" }),
              {
                children: u,
                className: d,
                color: p = "inherit",
                component: v = "svg",
                fontSize: b = "medium",
                htmlColor: _,
                inheritViewBox: y = !1,
                titleAccess: x,
                viewBox: C = "0 0 24 24",
              } = n,
              S = (0, o.Z)(n, f),
              k = a.isValidElement(u) && "svg" === u.type,
              w = (0, r.Z)({}, n, {
                color: p,
                component: v,
                fontSize: b,
                instanceFontSize: e.fontSize,
                inheritViewBox: y,
                viewBox: C,
                hasSvgAsChild: k,
              }),
              P = {};
            y || (P.viewBox = C);
            const O = ((e) => {
              const { color: t, fontSize: n, classes: r } = e,
                o = {
                  root: [
                    "root",
                    "inherit" !== t && `color${(0, l.Z)(t)}`,
                    `fontSize${(0, l.Z)(n)}`,
                  ],
                };
              return (0, s.Z)(o, m, r);
            })(w);
            return (0,
            h.jsxs)(g, (0, r.Z)({ as: v, className: (0, i.Z)(O.root, d), focusable: "false", color: _, "aria-hidden": !x || void 0, role: x ? "img" : void 0, ref: t }, P, S, k && u.props, { ownerState: w, children: [k ? u.props.children : u, x ? (0, h.jsx)("title", { children: x }) : null] }));
          });
        v.muiName = "SvgIcon";
        var b = v;
      },
      3023: function (e, t) {
        "use strict";
        Symbol.for("react.element"),
          Symbol.for("react.portal"),
          Symbol.for("react.fragment"),
          Symbol.for("react.strict_mode"),
          Symbol.for("react.profiler"),
          Symbol.for("react.provider"),
          Symbol.for("react.context"),
          Symbol.for("react.server_context"),
          Symbol.for("react.forward_ref"),
          Symbol.for("react.suspense"),
          Symbol.for("react.suspense_list"),
          Symbol.for("react.memo"),
          Symbol.for("react.lazy"),
          Symbol.for("react.offscreen");
        Symbol.for("react.module.reference");
      },
      6607: function (e, t, n) {
        "use strict";
        n(3023);
      },
      9617: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return Z;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(8758),
          i = n(8027),
          s = n(8010),
          l = n(6523),
          c = n(7408),
          u = n(2101),
          d = { black: "#000", white: "#fff" },
          p = {
            50: "#fafafa",
            100: "#f5f5f5",
            200: "#eeeeee",
            300: "#e0e0e0",
            400: "#bdbdbd",
            500: "#9e9e9e",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            A100: "#f5f5f5",
            A200: "#eeeeee",
            A400: "#bdbdbd",
            A700: "#616161",
          },
          m = {
            50: "#f3e5f5",
            100: "#e1bee7",
            200: "#ce93d8",
            300: "#ba68c8",
            400: "#ab47bc",
            500: "#9c27b0",
            600: "#8e24aa",
            700: "#7b1fa2",
            800: "#6a1b9a",
            900: "#4a148c",
            A100: "#ea80fc",
            A200: "#e040fb",
            A400: "#d500f9",
            A700: "#aa00ff",
          },
          h = {
            50: "#ffebee",
            100: "#ffcdd2",
            200: "#ef9a9a",
            300: "#e57373",
            400: "#ef5350",
            500: "#f44336",
            600: "#e53935",
            700: "#d32f2f",
            800: "#c62828",
            900: "#b71c1c",
            A100: "#ff8a80",
            A200: "#ff5252",
            A400: "#ff1744",
            A700: "#d50000",
          },
          f = {
            50: "#fff3e0",
            100: "#ffe0b2",
            200: "#ffcc80",
            300: "#ffb74d",
            400: "#ffa726",
            500: "#ff9800",
            600: "#fb8c00",
            700: "#f57c00",
            800: "#ef6c00",
            900: "#e65100",
            A100: "#ffd180",
            A200: "#ffab40",
            A400: "#ff9100",
            A700: "#ff6d00",
          },
          g = {
            50: "#e3f2fd",
            100: "#bbdefb",
            200: "#90caf9",
            300: "#64b5f6",
            400: "#42a5f5",
            500: "#2196f3",
            600: "#1e88e5",
            700: "#1976d2",
            800: "#1565c0",
            900: "#0d47a1",
            A100: "#82b1ff",
            A200: "#448aff",
            A400: "#2979ff",
            A700: "#2962ff",
          },
          v = {
            50: "#e1f5fe",
            100: "#b3e5fc",
            200: "#81d4fa",
            300: "#4fc3f7",
            400: "#29b6f6",
            500: "#03a9f4",
            600: "#039be5",
            700: "#0288d1",
            800: "#0277bd",
            900: "#01579b",
            A100: "#80d8ff",
            A200: "#40c4ff",
            A400: "#00b0ff",
            A700: "#0091ea",
          },
          b = {
            50: "#e8f5e9",
            100: "#c8e6c9",
            200: "#a5d6a7",
            300: "#81c784",
            400: "#66bb6a",
            500: "#4caf50",
            600: "#43a047",
            700: "#388e3c",
            800: "#2e7d32",
            900: "#1b5e20",
            A100: "#b9f6ca",
            A200: "#69f0ae",
            A400: "#00e676",
            A700: "#00c853",
          };
        const _ = ["mode", "contrastThreshold", "tonalOffset"],
          y = {
            text: {
              primary: "rgba(0, 0, 0, 0.87)",
              secondary: "rgba(0, 0, 0, 0.6)",
              disabled: "rgba(0, 0, 0, 0.38)",
            },
            divider: "rgba(0, 0, 0, 0.12)",
            background: { paper: d.white, default: d.white },
            action: {
              active: "rgba(0, 0, 0, 0.54)",
              hover: "rgba(0, 0, 0, 0.04)",
              hoverOpacity: 0.04,
              selected: "rgba(0, 0, 0, 0.08)",
              selectedOpacity: 0.08,
              disabled: "rgba(0, 0, 0, 0.26)",
              disabledBackground: "rgba(0, 0, 0, 0.12)",
              disabledOpacity: 0.38,
              focus: "rgba(0, 0, 0, 0.12)",
              focusOpacity: 0.12,
              activatedOpacity: 0.12,
            },
          },
          x = {
            text: {
              primary: d.white,
              secondary: "rgba(255, 255, 255, 0.7)",
              disabled: "rgba(255, 255, 255, 0.5)",
              icon: "rgba(255, 255, 255, 0.5)",
            },
            divider: "rgba(255, 255, 255, 0.12)",
            background: { paper: "#121212", default: "#121212" },
            action: {
              active: d.white,
              hover: "rgba(255, 255, 255, 0.08)",
              hoverOpacity: 0.08,
              selected: "rgba(255, 255, 255, 0.16)",
              selectedOpacity: 0.16,
              disabled: "rgba(255, 255, 255, 0.3)",
              disabledBackground: "rgba(255, 255, 255, 0.12)",
              disabledOpacity: 0.38,
              focus: "rgba(255, 255, 255, 0.12)",
              focusOpacity: 0.12,
              activatedOpacity: 0.24,
            },
          };
        function C(e, t, n, r) {
          const o = r.light || r,
            a = r.dark || 1.5 * r;
          e[t] ||
            (e.hasOwnProperty(n)
              ? (e[t] = e[n])
              : "light" === t
              ? (e.light = (0, u.$n)(e.main, o))
              : "dark" === t && (e.dark = (0, u._j)(e.main, a)));
        }
        const S = [
            "fontFamily",
            "fontSize",
            "fontWeightLight",
            "fontWeightRegular",
            "fontWeightMedium",
            "fontWeightBold",
            "htmlFontSize",
            "allVariants",
            "pxToRem",
          ],
          k = { textTransform: "uppercase" },
          w = '"Roboto", "Helvetica", "Arial", sans-serif';
        function P(e, t) {
          const n = "function" == typeof t ? t(e) : t,
            {
              fontFamily: a = w,
              fontSize: s = 14,
              fontWeightLight: l = 300,
              fontWeightRegular: c = 400,
              fontWeightMedium: u = 500,
              fontWeightBold: d = 700,
              htmlFontSize: p = 16,
              allVariants: m,
              pxToRem: h,
            } = n,
            f = (0, o.Z)(n, S),
            g = s / 14,
            v = h || ((e) => (e / p) * g + "rem"),
            b = (e, t, n, o, i) => {
              return (0, r.Z)(
                { fontFamily: a, fontWeight: e, fontSize: v(t), lineHeight: n },
                a === w
                  ? {
                      letterSpacing:
                        ((s = o / t), Math.round(1e5 * s) / 1e5 + "em"),
                    }
                  : {},
                i,
                m
              );
              var s;
            },
            _ = {
              h1: b(l, 96, 1.167, -1.5),
              h2: b(l, 60, 1.2, -0.5),
              h3: b(c, 48, 1.167, 0),
              h4: b(c, 34, 1.235, 0.25),
              h5: b(c, 24, 1.334, 0),
              h6: b(u, 20, 1.6, 0.15),
              subtitle1: b(c, 16, 1.75, 0.15),
              subtitle2: b(u, 14, 1.57, 0.1),
              body1: b(c, 16, 1.5, 0.15),
              body2: b(c, 14, 1.43, 0.15),
              button: b(u, 14, 1.75, 0.4, k),
              caption: b(c, 12, 1.66, 0.4),
              overline: b(c, 12, 2.66, 1, k),
              inherit: {
                fontFamily: "inherit",
                fontWeight: "inherit",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              },
            };
          return (0, i.Z)(
            (0, r.Z)(
              {
                htmlFontSize: p,
                pxToRem: v,
                fontFamily: a,
                fontSize: s,
                fontWeightLight: l,
                fontWeightRegular: c,
                fontWeightMedium: u,
                fontWeightBold: d,
              },
              _
            ),
            f,
            { clone: !1 }
          );
        }
        const O = 0.2,
          I = 0.14,
          T = 0.12;
        function M(...e) {
          return [
            `${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${O})`,
            `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${I})`,
            `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${T})`,
          ].join(",");
        }
        var E = [
          "none",
          M(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
          M(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
          M(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
          M(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
          M(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
          M(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
          M(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
          M(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
          M(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
          M(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
          M(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
          M(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
          M(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
          M(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
          M(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
          M(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
          M(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
          M(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
          M(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
          M(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
          M(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
          M(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
          M(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
          M(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8),
        ];
        const D = ["duration", "easing", "delay"],
          j = {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
          },
          R = {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195,
          };
        function N(e) {
          return `${Math.round(e)}ms`;
        }
        function A(e) {
          if (!e) return 0;
          const t = e / 36;
          return Math.round(10 * (4 + 15 * t ** 0.25 + t / 5));
        }
        function L(e) {
          const t = (0, r.Z)({}, j, e.easing),
            n = (0, r.Z)({}, R, e.duration);
          return (0, r.Z)(
            {
              getAutoHeightDuration: A,
              create: (e = ["all"], r = {}) => {
                const {
                  duration: a = n.standard,
                  easing: i = t.easeInOut,
                  delay: s = 0,
                } = r;
                return (
                  (0, o.Z)(r, D),
                  (Array.isArray(e) ? e : [e])
                    .map(
                      (e) =>
                        `${e} ${"string" == typeof a ? a : N(a)} ${i} ${
                          "string" == typeof s ? s : N(s)
                        }`
                    )
                    .join(",")
                );
              },
            },
            e,
            { easing: t, duration: n }
          );
        }
        var z = {
          mobileStepper: 1e3,
          fab: 1050,
          speedDial: 1050,
          appBar: 1100,
          drawer: 1200,
          modal: 1300,
          snackbar: 1400,
          tooltip: 1500,
        };
        const B = [
          "breakpoints",
          "mixins",
          "spacing",
          "palette",
          "transitions",
          "typography",
          "shape",
        ];
        var Z = function (e = {}, ...t) {
          const {
              mixins: n = {},
              palette: S = {},
              transitions: k = {},
              typography: w = {},
            } = e,
            O = (0, o.Z)(e, B);
          if (e.vars) throw new Error((0, a.Z)(18));
          const I = (function (e) {
              const {
                  mode: t = "light",
                  contrastThreshold: n = 3,
                  tonalOffset: s = 0.2,
                } = e,
                l = (0, o.Z)(e, _),
                c =
                  e.primary ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: g[200], light: g[50], dark: g[400] }
                      : { main: g[700], light: g[400], dark: g[800] };
                  })(t),
                S =
                  e.secondary ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: m[200], light: m[50], dark: m[400] }
                      : { main: m[500], light: m[300], dark: m[700] };
                  })(t),
                k =
                  e.error ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: h[500], light: h[300], dark: h[700] }
                      : { main: h[700], light: h[400], dark: h[800] };
                  })(t),
                w =
                  e.info ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: v[400], light: v[300], dark: v[700] }
                      : { main: v[700], light: v[500], dark: v[900] };
                  })(t),
                P =
                  e.success ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: b[400], light: b[300], dark: b[700] }
                      : { main: b[800], light: b[500], dark: b[900] };
                  })(t),
                O =
                  e.warning ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: f[400], light: f[300], dark: f[700] }
                      : { main: "#ed6c02", light: f[500], dark: f[900] };
                  })(t);
              function I(e) {
                return (0, u.mi)(e, x.text.primary) >= n
                  ? x.text.primary
                  : y.text.primary;
              }
              const T = ({
                  color: e,
                  name: t,
                  mainShade: n = 500,
                  lightShade: o = 300,
                  darkShade: i = 700,
                }) => {
                  if (
                    (!(e = (0, r.Z)({}, e)).main && e[n] && (e.main = e[n]),
                    !e.hasOwnProperty("main"))
                  )
                    throw new Error((0, a.Z)(11, t ? ` (${t})` : "", n));
                  if ("string" != typeof e.main)
                    throw new Error(
                      (0, a.Z)(12, t ? ` (${t})` : "", JSON.stringify(e.main))
                    );
                  return (
                    C(e, "light", o, s),
                    C(e, "dark", i, s),
                    e.contrastText || (e.contrastText = I(e.main)),
                    e
                  );
                },
                M = { dark: x, light: y };
              return (0, i.Z)(
                (0, r.Z)(
                  {
                    common: (0, r.Z)({}, d),
                    mode: t,
                    primary: T({ color: c, name: "primary" }),
                    secondary: T({
                      color: S,
                      name: "secondary",
                      mainShade: "A400",
                      lightShade: "A200",
                      darkShade: "A700",
                    }),
                    error: T({ color: k, name: "error" }),
                    warning: T({ color: O, name: "warning" }),
                    info: T({ color: w, name: "info" }),
                    success: T({ color: P, name: "success" }),
                    grey: p,
                    contrastThreshold: n,
                    getContrastText: I,
                    augmentColor: T,
                    tonalOffset: s,
                  },
                  M[t]
                ),
                l
              );
            })(S),
            T = (0, c.Z)(e);
          let M = (0, i.Z)(T, {
            mixins:
              ((D = T.breakpoints),
              (j = n),
              (0, r.Z)(
                {
                  toolbar: {
                    minHeight: 56,
                    [D.up("xs")]: {
                      "@media (orientation: landscape)": { minHeight: 48 },
                    },
                    [D.up("sm")]: { minHeight: 64 },
                  },
                },
                j
              )),
            palette: I,
            shadows: E.slice(),
            typography: P(I, w),
            transitions: L(k),
            zIndex: (0, r.Z)({}, z),
          });
          var D, j;
          return (
            (M = (0, i.Z)(M, O)),
            (M = t.reduce((e, t) => (0, i.Z)(e, t), M)),
            (M.unstable_sxConfig = (0, r.Z)(
              {},
              s.Z,
              null == O ? void 0 : O.unstable_sxConfig
            )),
            (M.unstable_sx = function (e) {
              return (0, l.Z)({ sx: e, theme: this });
            }),
            M
          );
        };
      },
      247: function (e, t, n) {
        "use strict";
        const r = (0, n(9617).Z)();
        t.Z = r;
      },
      606: function (e, t) {
        "use strict";
        t.Z = "$$material";
      },
      4136: function (e, t, n) {
        "use strict";
        var r = n(5536);
        t.Z = (e) => (0, r.Z)(e) && "classes" !== e;
      },
      5536: function (e, t) {
        "use strict";
        t.Z = function (e) {
          return (
            "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e
          );
        };
      },
      948: function (e, t, n) {
        "use strict";
        var r = n(8128),
          o = n(247),
          a = n(606),
          i = n(4136);
        const s = (0, r.ZP)({
          themeId: a.Z,
          defaultTheme: o.Z,
          rootShouldForwardProp: i.Z,
        });
        t.ZP = s;
      },
      1657: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return i;
          },
        });
        var r = n(9628),
          o = n(247),
          a = n(606);
        function i({ props: e, name: t }) {
          return (0, r.Z)({
            props: e,
            name: t,
            defaultTheme: o.Z,
            themeId: a.Z,
          });
        }
      },
      8216: function (e, t, n) {
        "use strict";
        var r = n(2908);
        t.Z = r.Z;
      },
      7450: function (e, t, n) {
        "use strict";
        var r = n(5725);
        t.Z = r.Z;
      },
      2066: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return s;
          },
        });
        var r = n(7462),
          o = n(7294),
          a = n(3502),
          i = n(5893);
        function s(e, t) {
          function n(n, o) {
            return (0, i.jsx)(
              a.Z,
              (0, r.Z)({ "data-testid": `${t}Icon`, ref: o }, n, {
                children: e,
              })
            );
          }
          return (n.muiName = a.Z.muiName), o.memo(o.forwardRef(n));
        }
      },
      7144: function (e, t, n) {
        "use strict";
        var r = n(6145);
        t.Z = r.Z;
      },
      5294: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            capitalize: function () {
              return o.Z;
            },
            createChainedFunction: function () {
              return a.Z;
            },
            createSvgIcon: function () {
              return i.Z;
            },
            debounce: function () {
              return s.Z;
            },
            deprecatedPropType: function () {
              return l;
            },
            isMuiElement: function () {
              return c.Z;
            },
            ownerDocument: function () {
              return u.Z;
            },
            ownerWindow: function () {
              return d.Z;
            },
            requirePropFactory: function () {
              return p;
            },
            setRef: function () {
              return m;
            },
            unstable_ClassNameGenerator: function () {
              return x;
            },
            unstable_useEnhancedEffect: function () {
              return h.Z;
            },
            unstable_useId: function () {
              return f.Z;
            },
            unsupportedProp: function () {
              return g;
            },
            useControlled: function () {
              return v.Z;
            },
            useEventCallback: function () {
              return b.Z;
            },
            useForkRef: function () {
              return _.Z;
            },
            useIsFocusVisible: function () {
              return y.Z;
            },
          });
        var r = n(1983),
          o = n(8216),
          a = n(7450),
          i = n(2066),
          s = n(7144),
          l = function (e, t) {
            return () => null;
          },
          c = n(2282),
          u = n(8038),
          d = n(5340);
        n(7462);
        var p = function (e, t) {
            return () => null;
          },
          m = n(5091).Z,
          h = n(8974),
          f = n(7909),
          g = function (e, t, n, r, o) {
            return null;
          },
          v = n(9299),
          b = n(2068),
          _ = n(1705),
          y = n(8992);
        const x = {
          configure: (e) => {
            r.Z.configure(e);
          },
        };
      },
      2282: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(7294),
          o = function (e, t) {
            var n, o;
            return (
              r.isValidElement(e) &&
              -1 !==
                t.indexOf(
                  null != (n = e.type.muiName)
                    ? n
                    : null == (o = e.type) ||
                      null == (o = o._payload) ||
                      null == (o = o.value)
                    ? void 0
                    : o.muiName
                )
            );
          };
      },
      8038: function (e, t, n) {
        "use strict";
        var r = n(6425);
        t.Z = r.Z;
      },
      5340: function (e, t, n) {
        "use strict";
        var r = n(6613);
        t.Z = r.Z;
      },
      9299: function (e, t, n) {
        "use strict";
        var r = n(1222);
        t.Z = r.Z;
      },
      8974: function (e, t, n) {
        "use strict";
        var r = n(4895);
        t.Z = r.Z;
      },
      2068: function (e, t, n) {
        "use strict";
        var r = n(2010);
        t.Z = r.Z;
      },
      1705: function (e, t, n) {
        "use strict";
        var r = n(2760);
        t.Z = r.Z;
      },
      7909: function (e, t, n) {
        "use strict";
        var r = n(9326);
        t.Z = r.Z;
      },
      8992: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return p;
          },
        });
        var r = n(7294),
          o = n(8849);
        let a = !0,
          i = !1;
        const s = new o.V(),
          l = {
            text: !0,
            search: !0,
            url: !0,
            tel: !0,
            email: !0,
            password: !0,
            number: !0,
            date: !0,
            month: !0,
            week: !0,
            time: !0,
            datetime: !0,
            "datetime-local": !0,
          };
        function c(e) {
          e.metaKey || e.altKey || e.ctrlKey || (a = !0);
        }
        function u() {
          a = !1;
        }
        function d() {
          "hidden" === this.visibilityState && i && (a = !0);
        }
        var p = function () {
          const e = r.useCallback((e) => {
              var t;
              null != e &&
                ((t = e.ownerDocument).addEventListener("keydown", c, !0),
                t.addEventListener("mousedown", u, !0),
                t.addEventListener("pointerdown", u, !0),
                t.addEventListener("touchstart", u, !0),
                t.addEventListener("visibilitychange", d, !0));
            }, []),
            t = r.useRef(!1);
          return {
            isFocusVisibleRef: t,
            onFocus: function (e) {
              return (
                !!(function (e) {
                  const { target: t } = e;
                  try {
                    return t.matches(":focus-visible");
                  } catch (e) {}
                  return (
                    a ||
                    (function (e) {
                      const { type: t, tagName: n } = e;
                      return (
                        !("INPUT" !== n || !l[t] || e.readOnly) ||
                        ("TEXTAREA" === n && !e.readOnly) ||
                        !!e.isContentEditable
                      );
                    })(t)
                  );
                })(e) && ((t.current = !0), !0)
              );
            },
            onBlur: function () {
              return (
                !!t.current &&
                ((i = !0),
                s.start(100, () => {
                  i = !1;
                }),
                (t.current = !1),
                !0)
              );
            },
            ref: e,
          };
        };
      },
      1234: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return a;
          },
        }),
          n(7294);
        var r = n(917),
          o = n(5893);
        function a(e) {
          const { styles: t, defaultTheme: n = {} } = e,
            a =
              "function" == typeof t
                ? (e) => {
                    return t(
                      null == (r = e) || 0 === Object.keys(r).length ? n : e
                    );
                    var r;
                  }
                : t;
          return (0, o.jsx)(r.xB, { styles: a });
        }
      },
      4742: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            GlobalStyles: function () {
              return k.Z;
            },
            StyledEngineProvider: function () {
              return S;
            },
            ThemeContext: function () {
              return l.T;
            },
            css: function () {
              return _.iv;
            },
            default: function () {
              return w;
            },
            internal_processStyles: function () {
              return P;
            },
            keyframes: function () {
              return _.F4;
            },
          });
        var r = n(7294),
          o = n(7462),
          a = n(5042),
          i =
            /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
          s = (0, a.Z)(function (e) {
            return (
              i.test(e) ||
              (111 === e.charCodeAt(0) &&
                110 === e.charCodeAt(1) &&
                e.charCodeAt(2) < 91)
            );
          }),
          l = n(2443),
          c = n(444),
          u = n(6797),
          d = n(7278),
          p = s,
          m = function (e) {
            return "theme" !== e;
          },
          h = function (e) {
            return "string" == typeof e && e.charCodeAt(0) > 96 ? p : m;
          },
          f = function (e, t, n) {
            var r;
            if (t) {
              var o = t.shouldForwardProp;
              r =
                e.__emotion_forwardProp && o
                  ? function (t) {
                      return e.__emotion_forwardProp(t) && o(t);
                    }
                  : o;
            }
            return (
              "function" != typeof r && n && (r = e.__emotion_forwardProp), r
            );
          },
          g = function (e) {
            var t = e.cache,
              n = e.serialized,
              r = e.isStringTag;
            return (
              (0, c.hC)(t, n, r),
              (0, d.L)(function () {
                return (0, c.My)(t, n, r);
              }),
              null
            );
          },
          v = function e(t, n) {
            var a,
              i,
              s = t.__emotion_real === t,
              d = (s && t.__emotion_base) || t;
            void 0 !== n && ((a = n.label), (i = n.target));
            var p = f(t, n, s),
              m = p || h(d),
              v = !m("as");
            return function () {
              var b = arguments,
                _ =
                  s && void 0 !== t.__emotion_styles
                    ? t.__emotion_styles.slice(0)
                    : [];
              if (
                (void 0 !== a && _.push("label:" + a + ";"),
                null == b[0] || void 0 === b[0].raw)
              )
                _.push.apply(_, b);
              else {
                _.push(b[0][0]);
                for (var y = b.length, x = 1; x < y; x++) _.push(b[x], b[0][x]);
              }
              var C = (0, l.w)(function (e, t, n) {
                var o = (v && e.as) || d,
                  a = "",
                  s = [],
                  f = e;
                if (null == e.theme) {
                  for (var b in ((f = {}), e)) f[b] = e[b];
                  f.theme = (0, r.useContext)(l.T);
                }
                "string" == typeof e.className
                  ? (a = (0, c.fp)(t.registered, s, e.className))
                  : null != e.className && (a = e.className + " ");
                var y = (0, u.O)(_.concat(s), t.registered, f);
                (a += t.key + "-" + y.name), void 0 !== i && (a += " " + i);
                var x = v && void 0 === p ? h(o) : m,
                  C = {};
                for (var S in e) (v && "as" === S) || (x(S) && (C[S] = e[S]));
                return (
                  (C.className = a),
                  (C.ref = n),
                  (0, r.createElement)(
                    r.Fragment,
                    null,
                    (0, r.createElement)(g, {
                      cache: t,
                      serialized: y,
                      isStringTag: "string" == typeof o,
                    }),
                    (0, r.createElement)(o, C)
                  )
                );
              });
              return (
                (C.displayName =
                  void 0 !== a
                    ? a
                    : "Styled(" +
                      ("string" == typeof d
                        ? d
                        : d.displayName || d.name || "Component") +
                      ")"),
                (C.defaultProps = t.defaultProps),
                (C.__emotion_real = C),
                (C.__emotion_base = d),
                (C.__emotion_styles = _),
                (C.__emotion_forwardProp = p),
                Object.defineProperty(C, "toString", {
                  value: function () {
                    return "." + i;
                  },
                }),
                (C.withComponent = function (t, r) {
                  return e(
                    t,
                    (0, o.Z)({}, n, r, { shouldForwardProp: f(C, r, !0) })
                  ).apply(void 0, _);
                }),
                C
              );
            };
          }.bind();
        [
          "a",
          "abbr",
          "address",
          "area",
          "article",
          "aside",
          "audio",
          "b",
          "base",
          "bdi",
          "bdo",
          "big",
          "blockquote",
          "body",
          "br",
          "button",
          "canvas",
          "caption",
          "cite",
          "code",
          "col",
          "colgroup",
          "data",
          "datalist",
          "dd",
          "del",
          "details",
          "dfn",
          "dialog",
          "div",
          "dl",
          "dt",
          "em",
          "embed",
          "fieldset",
          "figcaption",
          "figure",
          "footer",
          "form",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "head",
          "header",
          "hgroup",
          "hr",
          "html",
          "i",
          "iframe",
          "img",
          "input",
          "ins",
          "kbd",
          "keygen",
          "label",
          "legend",
          "li",
          "link",
          "main",
          "map",
          "mark",
          "marquee",
          "menu",
          "menuitem",
          "meta",
          "meter",
          "nav",
          "noscript",
          "object",
          "ol",
          "optgroup",
          "option",
          "output",
          "p",
          "param",
          "picture",
          "pre",
          "progress",
          "q",
          "rp",
          "rt",
          "ruby",
          "s",
          "samp",
          "script",
          "section",
          "select",
          "small",
          "source",
          "span",
          "strong",
          "style",
          "sub",
          "summary",
          "sup",
          "table",
          "tbody",
          "td",
          "textarea",
          "tfoot",
          "th",
          "thead",
          "time",
          "title",
          "tr",
          "track",
          "u",
          "ul",
          "var",
          "video",
          "wbr",
          "circle",
          "clipPath",
          "defs",
          "ellipse",
          "foreignObject",
          "g",
          "image",
          "line",
          "linearGradient",
          "mask",
          "path",
          "pattern",
          "polygon",
          "polyline",
          "radialGradient",
          "rect",
          "stop",
          "svg",
          "text",
          "tspan",
        ].forEach(function (e) {
          v[e] = v(e);
        });
        var b = v,
          _ = n(917),
          y = n(2898),
          x = n(5893);
        let C;
        function S(e) {
          const { injectFirst: t, children: n } = e;
          return t && C ? (0, x.jsx)(l.C, { value: C, children: n }) : n;
        }
        "object" == typeof document &&
          (C = (0, y.Z)({ key: "css", prepend: !0 }));
        var k = n(1234);
        function w(e, t) {
          return b(e, t);
        }
        const P = (e, t) => {
          Array.isArray(e.__emotion_styles) &&
            (e.__emotion_styles = t(e.__emotion_styles));
        };
      },
      2101: function (e, t, n) {
        "use strict";
        var r = n(4836);
        (t.Fq = function (e, t) {
          return (
            (e = s(e)),
            (t = i(t)),
            ("rgb" !== e.type && "hsl" !== e.type) || (e.type += "a"),
            "color" === e.type ? (e.values[3] = `/${t}`) : (e.values[3] = t),
            l(e)
          );
        }),
          (t._j = u),
          (t._4 = function (e, t = 0.15) {
            return c(e) > 0.5 ? u(e, t) : d(e, t);
          }),
          (t.mi = function (e, t) {
            const n = c(e),
              r = c(t);
            return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
          }),
          (t.$n = d);
        var o = r(n(743)),
          a = r(n(1495));
        function i(e, t = 0, n = 1) {
          return (0, a.default)(e, t, n);
        }
        function s(e) {
          if (e.type) return e;
          if ("#" === e.charAt(0))
            return s(
              (function (e) {
                e = e.slice(1);
                const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
                let n = e.match(t);
                return (
                  n && 1 === n[0].length && (n = n.map((e) => e + e)),
                  n
                    ? `rgb${4 === n.length ? "a" : ""}(${n
                        .map((e, t) =>
                          t < 3
                            ? parseInt(e, 16)
                            : Math.round((parseInt(e, 16) / 255) * 1e3) / 1e3
                        )
                        .join(", ")})`
                    : ""
                );
              })(e)
            );
          const t = e.indexOf("("),
            n = e.substring(0, t);
          if (-1 === ["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n))
            throw new Error((0, o.default)(9, e));
          let r,
            a = e.substring(t + 1, e.length - 1);
          if ("color" === n) {
            if (
              ((a = a.split(" ")),
              (r = a.shift()),
              4 === a.length &&
                "/" === a[3].charAt(0) &&
                (a[3] = a[3].slice(1)),
              -1 ===
                [
                  "srgb",
                  "display-p3",
                  "a98-rgb",
                  "prophoto-rgb",
                  "rec-2020",
                ].indexOf(r))
            )
              throw new Error((0, o.default)(10, r));
          } else a = a.split(",");
          return (
            (a = a.map((e) => parseFloat(e))),
            { type: n, values: a, colorSpace: r }
          );
        }
        function l(e) {
          const { type: t, colorSpace: n } = e;
          let { values: r } = e;
          return (
            -1 !== t.indexOf("rgb")
              ? (r = r.map((e, t) => (t < 3 ? parseInt(e, 10) : e)))
              : -1 !== t.indexOf("hsl") &&
                ((r[1] = `${r[1]}%`), (r[2] = `${r[2]}%`)),
            (r =
              -1 !== t.indexOf("color")
                ? `${n} ${r.join(" ")}`
                : `${r.join(", ")}`),
            `${t}(${r})`
          );
        }
        function c(e) {
          let t =
            "hsl" === (e = s(e)).type || "hsla" === e.type
              ? s(
                  (function (e) {
                    e = s(e);
                    const { values: t } = e,
                      n = t[0],
                      r = t[1] / 100,
                      o = t[2] / 100,
                      a = r * Math.min(o, 1 - o),
                      i = (e, t = (e + n / 30) % 12) =>
                        o - a * Math.max(Math.min(t - 3, 9 - t, 1), -1);
                    let c = "rgb";
                    const u = [
                      Math.round(255 * i(0)),
                      Math.round(255 * i(8)),
                      Math.round(255 * i(4)),
                    ];
                    return (
                      "hsla" === e.type && ((c += "a"), u.push(t[3])),
                      l({ type: c, values: u })
                    );
                  })(e)
                ).values
              : e.values;
          return (
            (t = t.map(
              (t) => (
                "color" !== e.type && (t /= 255),
                t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4
              )
            )),
            Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3))
          );
        }
        function u(e, t) {
          if (((e = s(e)), (t = i(t)), -1 !== e.type.indexOf("hsl")))
            e.values[2] *= 1 - t;
          else if (
            -1 !== e.type.indexOf("rgb") ||
            -1 !== e.type.indexOf("color")
          )
            for (let n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
          return l(e);
        }
        function d(e, t) {
          if (((e = s(e)), (t = i(t)), -1 !== e.type.indexOf("hsl")))
            e.values[2] += (100 - e.values[2]) * t;
          else if (-1 !== e.type.indexOf("rgb"))
            for (let n = 0; n < 3; n += 1)
              e.values[n] += (255 - e.values[n]) * t;
          else if (-1 !== e.type.indexOf("color"))
            for (let n = 0; n < 3; n += 1) e.values[n] += (1 - e.values[n]) * t;
          return l(e);
        }
      },
      8128: function (e, t, n) {
        "use strict";
        var r = n(4836);
        t.ZP = function (e = {}) {
          const {
              themeId: t,
              defaultTheme: n = f,
              rootShouldForwardProp: r = h,
              slotShouldForwardProp: l = h,
            } = e,
            u = (e) =>
              (0, c.default)(
                (0, o.default)({}, e, {
                  theme: v(
                    (0, o.default)({}, e, { defaultTheme: n, themeId: t })
                  ),
                })
              );
          return (
            (u.__mui_systemSx = !0),
            (e, c = {}) => {
              (0, i.internal_processStyles)(e, (e) =>
                e.filter((e) => !(null != e && e.__mui_systemSx))
              );
              const {
                  name: d,
                  slot: m,
                  skipVariantsResolver: f,
                  skipSx: y,
                  overridesResolver: x = b(g(m)),
                } = c,
                C = (0, a.default)(c, p),
                S =
                  void 0 !== f ? f : (m && "Root" !== m && "root" !== m) || !1,
                k = y || !1;
              let w = h;
              "Root" === m || "root" === m
                ? (w = r)
                : m
                ? (w = l)
                : (function (e) {
                    return "string" == typeof e && e.charCodeAt(0) > 96;
                  })(e) && (w = void 0);
              const P = (0, i.default)(
                  e,
                  (0, o.default)({ shouldForwardProp: w, label: void 0 }, C)
                ),
                O = (e) =>
                  ("function" == typeof e && e.__emotion_real !== e) ||
                  (0, s.isPlainObject)(e)
                    ? (r) =>
                        _(
                          e,
                          (0, o.default)({}, r, {
                            theme: v({
                              theme: r.theme,
                              defaultTheme: n,
                              themeId: t,
                            }),
                          })
                        )
                    : e,
                I = (r, ...a) => {
                  let i = O(r);
                  const s = a ? a.map(O) : [];
                  d &&
                    x &&
                    s.push((e) => {
                      const r = v(
                        (0, o.default)({}, e, { defaultTheme: n, themeId: t })
                      );
                      if (
                        !r.components ||
                        !r.components[d] ||
                        !r.components[d].styleOverrides
                      )
                        return null;
                      const a = r.components[d].styleOverrides,
                        i = {};
                      return (
                        Object.entries(a).forEach(([t, n]) => {
                          i[t] = _(n, (0, o.default)({}, e, { theme: r }));
                        }),
                        x(e, i)
                      );
                    }),
                    d &&
                      !S &&
                      s.push((e) => {
                        var r;
                        const a = v(
                          (0, o.default)({}, e, { defaultTheme: n, themeId: t })
                        );
                        return _(
                          {
                            variants:
                              null == a ||
                              null == (r = a.components) ||
                              null == (r = r[d])
                                ? void 0
                                : r.variants,
                          },
                          (0, o.default)({}, e, { theme: a })
                        );
                      }),
                    k || s.push(u);
                  const l = s.length - a.length;
                  if (Array.isArray(r) && l > 0) {
                    const e = new Array(l).fill("");
                    (i = [...r, ...e]), (i.raw = [...r.raw, ...e]);
                  }
                  const c = P(i, ...s);
                  return e.muiName && (c.muiName = e.muiName), c;
                };
              return P.withConfig && (I.withConfig = P.withConfig), I;
            }
          );
        };
        var o = r(n(434)),
          a = r(n(7071)),
          i = (function (e, t) {
            if (e && e.__esModule) return e;
            if (null === e || ("object" != typeof e && "function" != typeof e))
              return { default: e };
            var n = m(t);
            if (n && n.has(e)) return n.get(e);
            var r = { __proto__: null },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var a in e)
              if (
                "default" !== a &&
                Object.prototype.hasOwnProperty.call(e, a)
              ) {
                var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
                i && (i.get || i.set)
                  ? Object.defineProperty(r, a, i)
                  : (r[a] = e[a]);
              }
            return (r.default = e), n && n.set(e, r), r;
          })(n(4742)),
          s = n(211),
          l = (r(n(9698)), r(n(2240)), r(n(9926))),
          c = r(n(386));
        const u = ["ownerState"],
          d = ["variants"],
          p = [
            "name",
            "slot",
            "skipVariantsResolver",
            "skipSx",
            "overridesResolver",
          ];
        function m(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
            n = new WeakMap();
          return (m = function (e) {
            return e ? n : t;
          })(e);
        }
        function h(e) {
          return (
            "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e
          );
        }
        const f = (0, l.default)(),
          g = (e) => (e ? e.charAt(0).toLowerCase() + e.slice(1) : e);
        function v({ defaultTheme: e, theme: t, themeId: n }) {
          return (r = t), 0 === Object.keys(r).length ? e : t[n] || t;
          var r;
        }
        function b(e) {
          return e ? (t, n) => n[e] : null;
        }
        function _(e, t) {
          let { ownerState: n } = t,
            r = (0, a.default)(t, u);
          const i =
            "function" == typeof e
              ? e((0, o.default)({ ownerState: n }, r))
              : e;
          if (Array.isArray(i))
            return i.flatMap((e) => _(e, (0, o.default)({ ownerState: n }, r)));
          if (i && "object" == typeof i && Array.isArray(i.variants)) {
            const { variants: e = [] } = i;
            let t = (0, a.default)(i, d);
            return (
              e.forEach((e) => {
                let a = !0;
                "function" == typeof e.props
                  ? (a = e.props((0, o.default)({ ownerState: n }, r, n)))
                  : Object.keys(e.props).forEach((t) => {
                      (null == n ? void 0 : n[t]) !== e.props[t] &&
                        r[t] !== e.props[t] &&
                        (a = !1);
                    }),
                  a &&
                    (Array.isArray(t) || (t = [t]),
                    t.push(
                      "function" == typeof e.style
                        ? e.style((0, o.default)({ ownerState: n }, r, n))
                        : e.style
                    ));
              }),
              t
            );
          }
          return i;
        }
      },
      5408: function (e, t, n) {
        "use strict";
        n.d(t, {
          L7: function () {
            return l;
          },
          P$: function () {
            return u;
          },
          VO: function () {
            return o;
          },
          W8: function () {
            return s;
          },
          dt: function () {
            return c;
          },
          k9: function () {
            return i;
          },
        });
        var r = n(8027);
        const o = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
          a = {
            keys: ["xs", "sm", "md", "lg", "xl"],
            up: (e) => `@media (min-width:${o[e]}px)`,
          };
        function i(e, t, n) {
          const r = e.theme || {};
          if (Array.isArray(t)) {
            const e = r.breakpoints || a;
            return t.reduce(
              (r, o, a) => ((r[e.up(e.keys[a])] = n(t[a])), r),
              {}
            );
          }
          if ("object" == typeof t) {
            const e = r.breakpoints || a;
            return Object.keys(t).reduce((r, a) => {
              if (-1 !== Object.keys(e.values || o).indexOf(a))
                r[e.up(a)] = n(t[a], a);
              else {
                const e = a;
                r[e] = t[e];
              }
              return r;
            }, {});
          }
          return n(t);
        }
        function s(e = {}) {
          var t;
          return (
            (null == (t = e.keys)
              ? void 0
              : t.reduce((t, n) => ((t[e.up(n)] = {}), t), {})) || {}
          );
        }
        function l(e, t) {
          return e.reduce((e, t) => {
            const n = e[t];
            return (!n || 0 === Object.keys(n).length) && delete e[t], e;
          }, t);
        }
        function c(e, ...t) {
          const n = s(e),
            o = [n, ...t].reduce((e, t) => (0, r.Z)(e, t), {});
          return l(Object.keys(n), o);
        }
        function u({ values: e, breakpoints: t, base: n }) {
          const r =
              n ||
              (function (e, t) {
                if ("object" != typeof e) return {};
                const n = {},
                  r = Object.keys(t);
                return (
                  Array.isArray(e)
                    ? r.forEach((t, r) => {
                        r < e.length && (n[t] = !0);
                      })
                    : r.forEach((t) => {
                        null != e[t] && (n[t] = !0);
                      }),
                  n
                );
              })(e, t),
            o = Object.keys(r);
          if (0 === o.length) return e;
          let a;
          return o.reduce(
            (t, n, r) => (
              Array.isArray(e)
                ? ((t[n] = null != e[r] ? e[r] : e[a]), (a = r))
                : "object" == typeof e
                ? ((t[n] = null != e[n] ? e[n] : e[a]), (a = n))
                : (t[n] = e),
              t
            ),
            {}
          );
        }
      },
      7064: function (e, t, n) {
        "use strict";
        function r(e, t) {
          const n = this;
          return n.vars && "function" == typeof n.getColorSchemeSelector
            ? {
                [n
                  .getColorSchemeSelector(e)
                  .replace(/(\[[^\]]+\])/, "*:where($1)")]: t,
              }
            : n.palette.mode === e
            ? t
            : {};
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      1512: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return s;
          },
        });
        var r = n(3366),
          o = n(7462);
        const a = ["values", "unit", "step"],
          i = (e) => {
            const t = Object.keys(e).map((t) => ({ key: t, val: e[t] })) || [];
            return (
              t.sort((e, t) => e.val - t.val),
              t.reduce((e, t) => (0, o.Z)({}, e, { [t.key]: t.val }), {})
            );
          };
        function s(e) {
          const {
              values: t = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
              unit: n = "px",
              step: s = 5,
            } = e,
            l = (0, r.Z)(e, a),
            c = i(t),
            u = Object.keys(c);
          function d(e) {
            return `@media (min-width:${
              "number" == typeof t[e] ? t[e] : e
            }${n})`;
          }
          function p(e) {
            return `@media (max-width:${
              ("number" == typeof t[e] ? t[e] : e) - s / 100
            }${n})`;
          }
          function m(e, r) {
            const o = u.indexOf(r);
            return `@media (min-width:${
              "number" == typeof t[e] ? t[e] : e
            }${n}) and (max-width:${
              (-1 !== o && "number" == typeof t[u[o]] ? t[u[o]] : r) - s / 100
            }${n})`;
          }
          return (0, o.Z)(
            {
              keys: u,
              values: c,
              up: d,
              down: p,
              between: m,
              only: function (e) {
                return u.indexOf(e) + 1 < u.length
                  ? m(e, u[u.indexOf(e) + 1])
                  : d(e);
              },
              not: function (e) {
                const t = u.indexOf(e);
                return 0 === t
                  ? d(u[1])
                  : t === u.length - 1
                  ? p(u[t])
                  : m(e, u[u.indexOf(e) + 1]).replace(
                      "@media",
                      "@media not all and"
                    );
              },
              unit: n,
            },
            l
          );
        }
      },
      7408: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return m;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(8027),
          i = n(1512),
          s = { borderRadius: 4 },
          l = n(2605),
          c = n(6523),
          u = n(8010),
          d = n(7064);
        const p = ["breakpoints", "palette", "spacing", "shape"];
        var m = function (e = {}, ...t) {
          const {
              breakpoints: n = {},
              palette: m = {},
              spacing: h,
              shape: f = {},
            } = e,
            g = (0, o.Z)(e, p),
            v = (0, i.Z)(n),
            b = (function (e = 8) {
              if (e.mui) return e;
              const t = (0, l.hB)({ spacing: e }),
                n = (...e) =>
                  (0 === e.length ? [1] : e)
                    .map((e) => {
                      const n = t(e);
                      return "number" == typeof n ? `${n}px` : n;
                    })
                    .join(" ");
              return (n.mui = !0), n;
            })(h);
          let _ = (0, a.Z)(
            {
              breakpoints: v,
              direction: "ltr",
              components: {},
              palette: (0, r.Z)({ mode: "light" }, m),
              spacing: b,
              shape: (0, r.Z)({}, s, f),
            },
            g
          );
          return (
            (_.applyStyles = d.Z),
            (_ = t.reduce((e, t) => (0, a.Z)(e, t), _)),
            (_.unstable_sxConfig = (0, r.Z)(
              {},
              u.Z,
              null == g ? void 0 : g.unstable_sxConfig
            )),
            (_.unstable_sx = function (e) {
              return (0, c.Z)({ sx: e, theme: this });
            }),
            _
          );
        };
      },
      9926: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
            private_createBreakpoints: function () {
              return o.Z;
            },
            unstable_applyStyles: function () {
              return a.Z;
            },
          });
        var r = n(7408),
          o = n(1512),
          a = n(7064);
      },
      7730: function (e, t, n) {
        "use strict";
        var r = n(8027);
        t.Z = function (e, t) {
          return t ? (0, r.Z)(e, t, { clone: !1 }) : e;
        };
      },
      2605: function (e, t, n) {
        "use strict";
        n.d(t, {
          hB: function () {
            return h;
          },
          eI: function () {
            return m;
          },
          NA: function () {
            return f;
          },
          e6: function () {
            return v;
          },
          o3: function () {
            return b;
          },
        });
        var r = n(5408),
          o = n(4844),
          a = n(7730);
        const i = { m: "margin", p: "padding" },
          s = {
            t: "Top",
            r: "Right",
            b: "Bottom",
            l: "Left",
            x: ["Left", "Right"],
            y: ["Top", "Bottom"],
          },
          l = { marginX: "mx", marginY: "my", paddingX: "px", paddingY: "py" },
          c = (function (e) {
            const t = {};
            return (e) => (
              void 0 === t[e] &&
                (t[e] = ((e) => {
                  if (e.length > 2) {
                    if (!l[e]) return [e];
                    e = l[e];
                  }
                  const [t, n] = e.split(""),
                    r = i[t],
                    o = s[n] || "";
                  return Array.isArray(o) ? o.map((e) => r + e) : [r + o];
                })(e)),
              t[e]
            );
          })(),
          u = [
            "m",
            "mt",
            "mr",
            "mb",
            "ml",
            "mx",
            "my",
            "margin",
            "marginTop",
            "marginRight",
            "marginBottom",
            "marginLeft",
            "marginX",
            "marginY",
            "marginInline",
            "marginInlineStart",
            "marginInlineEnd",
            "marginBlock",
            "marginBlockStart",
            "marginBlockEnd",
          ],
          d = [
            "p",
            "pt",
            "pr",
            "pb",
            "pl",
            "px",
            "py",
            "padding",
            "paddingTop",
            "paddingRight",
            "paddingBottom",
            "paddingLeft",
            "paddingX",
            "paddingY",
            "paddingInline",
            "paddingInlineStart",
            "paddingInlineEnd",
            "paddingBlock",
            "paddingBlockStart",
            "paddingBlockEnd",
          ],
          p = [...u, ...d];
        function m(e, t, n, r) {
          var a;
          const i = null != (a = (0, o.DW)(e, t, !1)) ? a : n;
          return "number" == typeof i
            ? (e) => ("string" == typeof e ? e : i * e)
            : Array.isArray(i)
            ? (e) => ("string" == typeof e ? e : i[e])
            : "function" == typeof i
            ? i
            : () => {};
        }
        function h(e) {
          return m(e, "spacing", 8);
        }
        function f(e, t) {
          if ("string" == typeof t || null == t) return t;
          const n = e(Math.abs(t));
          return t >= 0 ? n : "number" == typeof n ? -n : `-${n}`;
        }
        function g(e, t) {
          const n = h(e.theme);
          return Object.keys(e)
            .map((o) =>
              (function (e, t, n, o) {
                if (-1 === t.indexOf(n)) return null;
                const a = (function (e, t) {
                    return (n) => e.reduce((e, r) => ((e[r] = f(t, n)), e), {});
                  })(c(n), o),
                  i = e[n];
                return (0, r.k9)(e, i, a);
              })(e, t, o, n)
            )
            .reduce(a.Z, {});
        }
        function v(e) {
          return g(e, u);
        }
        function b(e) {
          return g(e, d);
        }
        function _(e) {
          return g(e, p);
        }
        (v.propTypes = {}),
          (v.filterProps = u),
          (b.propTypes = {}),
          (b.filterProps = d),
          (_.propTypes = {}),
          (_.filterProps = p);
      },
      4844: function (e, t, n) {
        "use strict";
        n.d(t, {
          DW: function () {
            return a;
          },
          Jq: function () {
            return i;
          },
        });
        var r = n(2908),
          o = n(5408);
        function a(e, t, n = !0) {
          if (!t || "string" != typeof t) return null;
          if (e && e.vars && n) {
            const n = `vars.${t}`
              .split(".")
              .reduce((e, t) => (e && e[t] ? e[t] : null), e);
            if (null != n) return n;
          }
          return t
            .split(".")
            .reduce((e, t) => (e && null != e[t] ? e[t] : null), e);
        }
        function i(e, t, n, r = n) {
          let o;
          return (
            (o =
              "function" == typeof e
                ? e(n)
                : Array.isArray(e)
                ? e[n] || r
                : a(e, n) || r),
            t && (o = t(o, r, e)),
            o
          );
        }
        t.ZP = function (e) {
          const {
              prop: t,
              cssProperty: n = e.prop,
              themeKey: s,
              transform: l,
            } = e,
            c = (e) => {
              if (null == e[t]) return null;
              const c = e[t],
                u = a(e.theme, s) || {};
              return (0, o.k9)(e, c, (e) => {
                let o = i(u, l, e);
                return (
                  e === o &&
                    "string" == typeof e &&
                    (o = i(
                      u,
                      l,
                      `${t}${"default" === e ? "" : (0, r.Z)(e)}`,
                      e
                    )),
                  !1 === n ? o : { [n]: o }
                );
              });
            };
          return (c.propTypes = {}), (c.filterProps = [t]), c;
        };
      },
      8010: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return R;
          },
        });
        var r = n(2605),
          o = n(4844),
          a = n(7730),
          i = function (...e) {
            const t = e.reduce(
                (e, t) => (
                  t.filterProps.forEach((n) => {
                    e[n] = t;
                  }),
                  e
                ),
                {}
              ),
              n = (e) =>
                Object.keys(e).reduce(
                  (n, r) => (t[r] ? (0, a.Z)(n, t[r](e)) : n),
                  {}
                );
            return (
              (n.propTypes = {}),
              (n.filterProps = e.reduce((e, t) => e.concat(t.filterProps), [])),
              n
            );
          },
          s = n(5408);
        function l(e) {
          return "number" != typeof e ? e : `${e}px solid`;
        }
        function c(e, t) {
          return (0, o.ZP)({ prop: e, themeKey: "borders", transform: t });
        }
        const u = c("border", l),
          d = c("borderTop", l),
          p = c("borderRight", l),
          m = c("borderBottom", l),
          h = c("borderLeft", l),
          f = c("borderColor"),
          g = c("borderTopColor"),
          v = c("borderRightColor"),
          b = c("borderBottomColor"),
          _ = c("borderLeftColor"),
          y = c("outline", l),
          x = c("outlineColor"),
          C = (e) => {
            if (void 0 !== e.borderRadius && null !== e.borderRadius) {
              const t = (0, r.eI)(
                  e.theme,
                  "shape.borderRadius",
                  4,
                  "borderRadius"
                ),
                n = (e) => ({ borderRadius: (0, r.NA)(t, e) });
              return (0, s.k9)(e, e.borderRadius, n);
            }
            return null;
          };
        (C.propTypes = {}),
          (C.filterProps = ["borderRadius"]),
          i(u, d, p, m, h, f, g, v, b, _, C, y, x);
        const S = (e) => {
          if (void 0 !== e.gap && null !== e.gap) {
            const t = (0, r.eI)(e.theme, "spacing", 8, "gap"),
              n = (e) => ({ gap: (0, r.NA)(t, e) });
            return (0, s.k9)(e, e.gap, n);
          }
          return null;
        };
        (S.propTypes = {}), (S.filterProps = ["gap"]);
        const k = (e) => {
          if (void 0 !== e.columnGap && null !== e.columnGap) {
            const t = (0, r.eI)(e.theme, "spacing", 8, "columnGap"),
              n = (e) => ({ columnGap: (0, r.NA)(t, e) });
            return (0, s.k9)(e, e.columnGap, n);
          }
          return null;
        };
        (k.propTypes = {}), (k.filterProps = ["columnGap"]);
        const w = (e) => {
          if (void 0 !== e.rowGap && null !== e.rowGap) {
            const t = (0, r.eI)(e.theme, "spacing", 8, "rowGap"),
              n = (e) => ({ rowGap: (0, r.NA)(t, e) });
            return (0, s.k9)(e, e.rowGap, n);
          }
          return null;
        };
        function P(e, t) {
          return "grey" === t ? t : e;
        }
        function O(e) {
          return e <= 1 && 0 !== e ? 100 * e + "%" : e;
        }
        (w.propTypes = {}),
          (w.filterProps = ["rowGap"]),
          i(
            S,
            k,
            w,
            (0, o.ZP)({ prop: "gridColumn" }),
            (0, o.ZP)({ prop: "gridRow" }),
            (0, o.ZP)({ prop: "gridAutoFlow" }),
            (0, o.ZP)({ prop: "gridAutoColumns" }),
            (0, o.ZP)({ prop: "gridAutoRows" }),
            (0, o.ZP)({ prop: "gridTemplateColumns" }),
            (0, o.ZP)({ prop: "gridTemplateRows" }),
            (0, o.ZP)({ prop: "gridTemplateAreas" }),
            (0, o.ZP)({ prop: "gridArea" })
          ),
          i(
            (0, o.ZP)({ prop: "color", themeKey: "palette", transform: P }),
            (0, o.ZP)({
              prop: "bgcolor",
              cssProperty: "backgroundColor",
              themeKey: "palette",
              transform: P,
            }),
            (0, o.ZP)({
              prop: "backgroundColor",
              themeKey: "palette",
              transform: P,
            })
          );
        const I = (0, o.ZP)({ prop: "width", transform: O }),
          T = (e) => {
            if (void 0 !== e.maxWidth && null !== e.maxWidth) {
              const t = (t) => {
                var n, r;
                const o =
                  (null == (n = e.theme) ||
                  null == (n = n.breakpoints) ||
                  null == (n = n.values)
                    ? void 0
                    : n[t]) || s.VO[t];
                return o
                  ? "px" !==
                    (null == (r = e.theme) || null == (r = r.breakpoints)
                      ? void 0
                      : r.unit)
                    ? { maxWidth: `${o}${e.theme.breakpoints.unit}` }
                    : { maxWidth: o }
                  : { maxWidth: O(t) };
              };
              return (0, s.k9)(e, e.maxWidth, t);
            }
            return null;
          };
        T.filterProps = ["maxWidth"];
        const M = (0, o.ZP)({ prop: "minWidth", transform: O }),
          E = (0, o.ZP)({ prop: "height", transform: O }),
          D = (0, o.ZP)({ prop: "maxHeight", transform: O }),
          j = (0, o.ZP)({ prop: "minHeight", transform: O });
        (0, o.ZP)({ prop: "size", cssProperty: "width", transform: O }),
          (0, o.ZP)({ prop: "size", cssProperty: "height", transform: O }),
          i(I, T, M, E, D, j, (0, o.ZP)({ prop: "boxSizing" }));
        var R = {
          border: { themeKey: "borders", transform: l },
          borderTop: { themeKey: "borders", transform: l },
          borderRight: { themeKey: "borders", transform: l },
          borderBottom: { themeKey: "borders", transform: l },
          borderLeft: { themeKey: "borders", transform: l },
          borderColor: { themeKey: "palette" },
          borderTopColor: { themeKey: "palette" },
          borderRightColor: { themeKey: "palette" },
          borderBottomColor: { themeKey: "palette" },
          borderLeftColor: { themeKey: "palette" },
          outline: { themeKey: "borders", transform: l },
          outlineColor: { themeKey: "palette" },
          borderRadius: { themeKey: "shape.borderRadius", style: C },
          color: { themeKey: "palette", transform: P },
          bgcolor: {
            themeKey: "palette",
            cssProperty: "backgroundColor",
            transform: P,
          },
          backgroundColor: { themeKey: "palette", transform: P },
          p: { style: r.o3 },
          pt: { style: r.o3 },
          pr: { style: r.o3 },
          pb: { style: r.o3 },
          pl: { style: r.o3 },
          px: { style: r.o3 },
          py: { style: r.o3 },
          padding: { style: r.o3 },
          paddingTop: { style: r.o3 },
          paddingRight: { style: r.o3 },
          paddingBottom: { style: r.o3 },
          paddingLeft: { style: r.o3 },
          paddingX: { style: r.o3 },
          paddingY: { style: r.o3 },
          paddingInline: { style: r.o3 },
          paddingInlineStart: { style: r.o3 },
          paddingInlineEnd: { style: r.o3 },
          paddingBlock: { style: r.o3 },
          paddingBlockStart: { style: r.o3 },
          paddingBlockEnd: { style: r.o3 },
          m: { style: r.e6 },
          mt: { style: r.e6 },
          mr: { style: r.e6 },
          mb: { style: r.e6 },
          ml: { style: r.e6 },
          mx: { style: r.e6 },
          my: { style: r.e6 },
          margin: { style: r.e6 },
          marginTop: { style: r.e6 },
          marginRight: { style: r.e6 },
          marginBottom: { style: r.e6 },
          marginLeft: { style: r.e6 },
          marginX: { style: r.e6 },
          marginY: { style: r.e6 },
          marginInline: { style: r.e6 },
          marginInlineStart: { style: r.e6 },
          marginInlineEnd: { style: r.e6 },
          marginBlock: { style: r.e6 },
          marginBlockStart: { style: r.e6 },
          marginBlockEnd: { style: r.e6 },
          displayPrint: {
            cssProperty: !1,
            transform: (e) => ({ "@media print": { display: e } }),
          },
          display: {},
          overflow: {},
          textOverflow: {},
          visibility: {},
          whiteSpace: {},
          flexBasis: {},
          flexDirection: {},
          flexWrap: {},
          justifyContent: {},
          alignItems: {},
          alignContent: {},
          order: {},
          flex: {},
          flexGrow: {},
          flexShrink: {},
          alignSelf: {},
          justifyItems: {},
          justifySelf: {},
          gap: { style: S },
          rowGap: { style: w },
          columnGap: { style: k },
          gridColumn: {},
          gridRow: {},
          gridAutoFlow: {},
          gridAutoColumns: {},
          gridAutoRows: {},
          gridTemplateColumns: {},
          gridTemplateRows: {},
          gridTemplateAreas: {},
          gridArea: {},
          position: {},
          zIndex: { themeKey: "zIndex" },
          top: {},
          right: {},
          bottom: {},
          left: {},
          boxShadow: { themeKey: "shadows" },
          width: { transform: O },
          maxWidth: { style: T },
          minWidth: { transform: O },
          height: { transform: O },
          maxHeight: { transform: O },
          minHeight: { transform: O },
          boxSizing: {},
          fontFamily: { themeKey: "typography" },
          fontSize: { themeKey: "typography" },
          fontStyle: { themeKey: "typography" },
          fontWeight: { themeKey: "typography" },
          letterSpacing: {},
          textTransform: {},
          lineHeight: {},
          textAlign: {},
          typography: { cssProperty: !1, themeKey: "typography" },
        };
      },
      9707: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return c;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(8027),
          i = n(8010);
        const s = ["sx"],
          l = (e) => {
            var t, n;
            const r = { systemProps: {}, otherProps: {} },
              o =
                null !=
                (t =
                  null == e || null == (n = e.theme)
                    ? void 0
                    : n.unstable_sxConfig)
                  ? t
                  : i.Z;
            return (
              Object.keys(e).forEach((t) => {
                o[t] ? (r.systemProps[t] = e[t]) : (r.otherProps[t] = e[t]);
              }),
              r
            );
          };
        function c(e) {
          const { sx: t } = e,
            n = (0, o.Z)(e, s),
            { systemProps: i, otherProps: c } = l(n);
          let u;
          return (
            (u = Array.isArray(t)
              ? [i, ...t]
              : "function" == typeof t
              ? (...e) => {
                  const n = t(...e);
                  return (0, a.P)(n) ? (0, r.Z)({}, i, n) : i;
                }
              : (0, r.Z)({}, i, t)),
            (0, r.Z)({}, c, { sx: u })
          );
        }
      },
      386: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
            extendSxProp: function () {
              return o.Z;
            },
            unstable_createStyleFunctionSx: function () {
              return r.n;
            },
            unstable_defaultSxConfig: function () {
              return a.Z;
            },
          });
        var r = n(6523),
          o = n(9707),
          a = n(8010);
      },
      6523: function (e, t, n) {
        "use strict";
        n.d(t, {
          n: function () {
            return l;
          },
        });
        var r = n(2908),
          o = n(7730),
          a = n(4844),
          i = n(5408),
          s = n(8010);
        function l() {
          function e(e, t, n, o) {
            const s = { [e]: t, theme: n },
              l = o[e];
            if (!l) return { [e]: t };
            const {
              cssProperty: c = e,
              themeKey: u,
              transform: d,
              style: p,
            } = l;
            if (null == t) return null;
            if ("typography" === u && "inherit" === t) return { [e]: t };
            const m = (0, a.DW)(n, u) || {};
            return p
              ? p(s)
              : (0, i.k9)(s, t, (t) => {
                  let n = (0, a.Jq)(m, d, t);
                  return (
                    t === n &&
                      "string" == typeof t &&
                      (n = (0, a.Jq)(
                        m,
                        d,
                        `${e}${"default" === t ? "" : (0, r.Z)(t)}`,
                        t
                      )),
                    !1 === c ? n : { [c]: n }
                  );
                });
          }
          return function t(n) {
            var r;
            const { sx: a, theme: l = {} } = n || {};
            if (!a) return null;
            const c = null != (r = l.unstable_sxConfig) ? r : s.Z;
            function u(n) {
              let r = n;
              if ("function" == typeof n) r = n(l);
              else if ("object" != typeof n) return n;
              if (!r) return null;
              const a = (0, i.W8)(l.breakpoints),
                s = Object.keys(a);
              let u = a;
              return (
                Object.keys(r).forEach((n) => {
                  const a = "function" == typeof (s = r[n]) ? s(l) : s;
                  var s;
                  if (null != a)
                    if ("object" == typeof a)
                      if (c[n]) u = (0, o.Z)(u, e(n, a, l, c));
                      else {
                        const e = (0, i.k9)({ theme: l }, a, (e) => ({
                          [n]: e,
                        }));
                        !(function (...e) {
                          const t = e.reduce(
                              (e, t) => e.concat(Object.keys(t)),
                              []
                            ),
                            n = new Set(t);
                          return e.every(
                            (e) => n.size === Object.keys(e).length
                          );
                        })(e, a)
                          ? (u = (0, o.Z)(u, e))
                          : (u[n] = t({ sx: a, theme: l }));
                      }
                    else u = (0, o.Z)(u, e(n, a, l, c));
                }),
                (0, i.L7)(s, u)
              );
            }
            return Array.isArray(a) ? a.map(u) : u(a);
          };
        }
        const c = l();
        (c.filterProps = ["sx"]), (t.Z = c);
      },
      6682: function (e, t, n) {
        "use strict";
        var r = n(7408),
          o = n(4168);
        const a = (0, r.Z)();
        t.Z = function (e = a) {
          return (0, o.Z)(e);
        };
      },
      539: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(2236);
        function o(e) {
          const { theme: t, name: n, props: o } = e;
          return t &&
            t.components &&
            t.components[n] &&
            t.components[n].defaultProps
            ? (0, r.Z)(t.components[n].defaultProps, o)
            : o;
        }
      },
      9628: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return a;
          },
        });
        var r = n(539),
          o = n(6682);
        function a({ props: e, name: t, defaultTheme: n, themeId: a }) {
          let i = (0, o.Z)(n);
          return (
            a && (i = i[a] || i), (0, r.Z)({ theme: i, name: t, props: e })
          );
        }
      },
      4168: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = n(2443);
        t.Z = function (e = null) {
          const t = r.useContext(o.T);
          return t && ((n = t), 0 !== Object.keys(n).length) ? t : e;
          var n;
        };
      },
      1070: function (e, t, n) {
        "use strict";
        t.Z = void 0;
        var r = (function (e, t) {
            if (e && e.__esModule) return e;
            if (null === e || ("object" != typeof e && "function" != typeof e))
              return { default: e };
            var n = a(t);
            if (n && n.has(e)) return n.get(e);
            var r = { __proto__: null },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var i in e)
              if (
                "default" !== i &&
                Object.prototype.hasOwnProperty.call(e, i)
              ) {
                var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
                s && (s.get || s.set)
                  ? Object.defineProperty(r, i, s)
                  : (r[i] = e[i]);
              }
            return (r.default = e), n && n.set(e, r), r;
          })(n(7294)),
          o = n(4742);
        function a(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
            n = new WeakMap();
          return (a = function (e) {
            return e ? n : t;
          })(e);
        }
        t.Z = function (e = null) {
          const t = r.useContext(o.ThemeContext);
          return t && ((n = t), 0 !== Object.keys(n).length) ? t : e;
          var n;
        };
      },
      1983: function (e, t) {
        "use strict";
        const n = (e) => e,
          r = (() => {
            let e = n;
            return {
              configure(t) {
                e = t;
              },
              generate(t) {
                return e(t);
              },
              reset() {
                e = n;
              },
            };
          })();
        t.Z = r;
      },
      2908: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(8758);
        function o(e) {
          if ("string" != typeof e) throw new Error((0, r.Z)(7));
          return e.charAt(0).toUpperCase() + e.slice(1);
        }
      },
      9698: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
          });
        var r = n(2908);
      },
      1495: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
        var r = function (
          e,
          t = Number.MIN_SAFE_INTEGER,
          n = Number.MAX_SAFE_INTEGER
        ) {
          return Math.max(t, Math.min(e, n));
        };
      },
      8510: function (e, t, n) {
        "use strict";
        function r(e, t, n = undefined) {
          const r = {};
          return (
            Object.keys(e).forEach((o) => {
              r[o] = e[o]
                .reduce((e, r) => {
                  if (r) {
                    const o = t(r);
                    "" !== o && e.push(o), n && n[r] && e.push(n[r]);
                  }
                  return e;
                }, [])
                .join(" ");
            }),
            r
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      5725: function (e, t, n) {
        "use strict";
        function r(...e) {
          return e.reduce(
            (e, t) =>
              null == t
                ? e
                : function (...n) {
                    e.apply(this, n), t.apply(this, n);
                  },
            () => {}
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      6145: function (e, t, n) {
        "use strict";
        function r(e, t = 166) {
          let n;
          function r(...r) {
            clearTimeout(n),
              (n = setTimeout(() => {
                e.apply(this, r);
              }, t));
          }
          return (
            (r.clear = () => {
              clearTimeout(n);
            }),
            r
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      8027: function (e, t, n) {
        "use strict";
        n.d(t, {
          P: function () {
            return o;
          },
          Z: function () {
            return i;
          },
        });
        var r = n(7462);
        function o(e) {
          if ("object" != typeof e || null === e) return !1;
          const t = Object.getPrototypeOf(e);
          return !(
            (null !== t &&
              t !== Object.prototype &&
              null !== Object.getPrototypeOf(t)) ||
            Symbol.toStringTag in e ||
            Symbol.iterator in e
          );
        }
        function a(e) {
          if (!o(e)) return e;
          const t = {};
          return (
            Object.keys(e).forEach((n) => {
              t[n] = a(e[n]);
            }),
            t
          );
        }
        function i(e, t, n = { clone: !0 }) {
          const s = n.clone ? (0, r.Z)({}, e) : e;
          return (
            o(e) &&
              o(t) &&
              Object.keys(t).forEach((r) => {
                "__proto__" !== r &&
                  (o(t[r]) && r in e && o(e[r])
                    ? (s[r] = i(e[r], t[r], n))
                    : n.clone
                    ? (s[r] = o(t[r]) ? a(t[r]) : t[r])
                    : (s[r] = t[r]));
              }),
            s
          );
        }
      },
      211: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
            isPlainObject: function () {
              return r.P;
            },
          });
        var r = n(8027);
      },
      8758: function (e, t, n) {
        "use strict";
        function r(e) {
          let t = "https://mui.com/production-error/?code=" + e;
          for (let e = 1; e < arguments.length; e += 1)
            t += "&args[]=" + encodeURIComponent(arguments[e]);
          return (
            "Minified MUI error #" +
            e +
            "; visit " +
            t +
            " for the full message."
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      743: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
          });
        var r = n(8758);
      },
      5463: function (e, t, n) {
        "use strict";
        n.d(t, {
          ZP: function () {
            return a;
          },
          _v: function () {
            return o;
          },
        });
        var r = n(1983);
        const o = {
          active: "active",
          checked: "checked",
          completed: "completed",
          disabled: "disabled",
          error: "error",
          expanded: "expanded",
          focused: "focused",
          focusVisible: "focusVisible",
          open: "open",
          readOnly: "readOnly",
          required: "required",
          selected: "selected",
        };
        function a(e, t, n = "Mui") {
          const a = o[t];
          return a ? `${n}-${a}` : `${r.Z.generate(e)}-${t}`;
        }
      },
      1977: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(5463);
        function o(e, t, n = "Mui") {
          const o = {};
          return (
            t.forEach((t) => {
              o[t] = (0, r.ZP)(e, t, n);
            }),
            o
          );
        }
      },
      2240: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return l;
            },
            getFunctionName: function () {
              return a;
            },
          });
        var r = n(217);
        const o = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
        function a(e) {
          const t = `${e}`.match(o);
          return (t && t[1]) || "";
        }
        function i(e, t = "") {
          return e.displayName || e.name || a(e) || t;
        }
        function s(e, t, n) {
          const r = i(t);
          return e.displayName || ("" !== r ? `${n}(${r})` : n);
        }
        function l(e) {
          if (null != e) {
            if ("string" == typeof e) return e;
            if ("function" == typeof e) return i(e, "Component");
            if ("object" == typeof e)
              switch (e.$$typeof) {
                case r.ForwardRef:
                  return s(e, e.render, "ForwardRef");
                case r.Memo:
                  return s(e, e.type, "memo");
                default:
                  return;
              }
          }
        }
      },
      7001: function (e, t) {
        "use strict";
        Symbol.for("react.element"),
          Symbol.for("react.portal"),
          Symbol.for("react.fragment"),
          Symbol.for("react.strict_mode"),
          Symbol.for("react.profiler"),
          Symbol.for("react.provider"),
          Symbol.for("react.context"),
          Symbol.for("react.server_context");
        var n = Symbol.for("react.forward_ref"),
          r =
            (Symbol.for("react.suspense"),
            Symbol.for("react.suspense_list"),
            Symbol.for("react.memo"));
        Symbol.for("react.lazy"), Symbol.for("react.offscreen");
        Symbol.for("react.module.reference"), (t.ForwardRef = n), (t.Memo = r);
      },
      217: function (e, t, n) {
        "use strict";
        e.exports = n(7001);
      },
      6425: function (e, t, n) {
        "use strict";
        function r(e) {
          return (e && e.ownerDocument) || document;
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      6613: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(6425);
        function o(e) {
          return (0, r.Z)(e).defaultView || window;
        }
      },
      2236: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(7462);
        function o(e, t) {
          const n = (0, r.Z)({}, t);
          return (
            Object.keys(e).forEach((a) => {
              if (a.toString().match(/^(components|slots)$/))
                n[a] = (0, r.Z)({}, e[a], n[a]);
              else if (a.toString().match(/^(componentsProps|slotProps)$/)) {
                const i = e[a] || {},
                  s = t[a];
                (n[a] = {}),
                  s && Object.keys(s)
                    ? i && Object.keys(i)
                      ? ((n[a] = (0, r.Z)({}, s)),
                        Object.keys(i).forEach((e) => {
                          n[a][e] = o(i[e], s[e]);
                        }))
                      : (n[a] = s)
                    : (n[a] = i);
              } else void 0 === n[a] && (n[a] = e[a]);
            }),
            n
          );
        }
      },
      5091: function (e, t, n) {
        "use strict";
        function r(e, t) {
          "function" == typeof e ? e(t) : e && (e.current = t);
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      1222: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(7294);
        function o({ controlled: e, default: t, name: n, state: o = "value" }) {
          const { current: a } = r.useRef(void 0 !== e),
            [i, s] = r.useState(t);
          return [
            a ? e : i,
            r.useCallback((e) => {
              a || s(e);
            }, []),
          ];
        }
      },
      4895: function (e, t, n) {
        "use strict";
        var r = n(7294);
        const o =
          "undefined" != typeof window ? r.useLayoutEffect : r.useEffect;
        t.Z = o;
      },
      2010: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = n(4895);
        t.Z = function (e) {
          const t = r.useRef(e);
          return (
            (0, o.Z)(() => {
              t.current = e;
            }),
            r.useRef((...e) => (0, t.current)(...e)).current
          );
        };
      },
      2760: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return a;
          },
        });
        var r = n(7294),
          o = n(5091);
        function a(...e) {
          return r.useMemo(
            () =>
              e.every((e) => null == e)
                ? null
                : (t) => {
                    e.forEach((e) => {
                      (0, o.Z)(e, t);
                    });
                  },
            e
          );
        }
      },
      9326: function (e, t, n) {
        "use strict";
        var r;
        n.d(t, {
          Z: function () {
            return s;
          },
        });
        var o = n(7294);
        let a = 0;
        const i = (r || (r = n.t(o, 2)))["useId".toString()];
        function s(e) {
          if (void 0 !== i) {
            const t = i();
            return null != e ? e : t;
          }
          return (function (e) {
            const [t, n] = o.useState(e),
              r = e || t;
            return (
              o.useEffect(() => {
                null == t && ((a += 1), n(`mui-${a}`));
              }, [t]),
              r
            );
          })(e);
        }
      },
      8849: function (e, t, n) {
        "use strict";
        n.d(t, {
          V: function () {
            return i;
          },
          Z: function () {
            return s;
          },
        });
        var r = n(7294);
        const o = {},
          a = [];
        class i {
          constructor() {
            (this.currentId = null),
              (this.clear = () => {
                null !== this.currentId &&
                  (clearTimeout(this.currentId), (this.currentId = null));
              }),
              (this.disposeEffect = () => this.clear);
          }
          static create() {
            return new i();
          }
          start(e, t) {
            this.clear(),
              (this.currentId = setTimeout(() => {
                (this.currentId = null), t();
              }, e));
          }
        }
        function s() {
          const e = (function (e, t) {
            const n = r.useRef(o);
            return n.current === o && (n.current = e(void 0)), n;
          })(i.create).current;
          var t;
          return (t = e.disposeEffect), r.useEffect(t, a), e;
        }
      },
      9669: function (e, t, n) {
        e.exports = n(1609);
      },
      5448: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(6026),
          a = n(4372),
          i = n(5327),
          s = n(4097),
          l = n(4109),
          c = n(7985),
          u = n(5061),
          d = n(7874),
          p = n(5263);
        e.exports = function (e) {
          return new Promise(function (t, n) {
            var m,
              h = e.data,
              f = e.headers,
              g = e.responseType;
            function v() {
              e.cancelToken && e.cancelToken.unsubscribe(m),
                e.signal && e.signal.removeEventListener("abort", m);
            }
            r.isFormData(h) && delete f["Content-Type"];
            var b = new XMLHttpRequest();
            if (e.auth) {
              var _ = e.auth.username || "",
                y = e.auth.password
                  ? unescape(encodeURIComponent(e.auth.password))
                  : "";
              f.Authorization = "Basic " + btoa(_ + ":" + y);
            }
            var x = s(e.baseURL, e.url);
            function C() {
              if (b) {
                var r =
                    "getAllResponseHeaders" in b
                      ? l(b.getAllResponseHeaders())
                      : null,
                  a = {
                    data:
                      g && "text" !== g && "json" !== g
                        ? b.response
                        : b.responseText,
                    status: b.status,
                    statusText: b.statusText,
                    headers: r,
                    config: e,
                    request: b,
                  };
                o(
                  function (e) {
                    t(e), v();
                  },
                  function (e) {
                    n(e), v();
                  },
                  a
                ),
                  (b = null);
              }
            }
            if (
              (b.open(
                e.method.toUpperCase(),
                i(x, e.params, e.paramsSerializer),
                !0
              ),
              (b.timeout = e.timeout),
              "onloadend" in b
                ? (b.onloadend = C)
                : (b.onreadystatechange = function () {
                    b &&
                      4 === b.readyState &&
                      (0 !== b.status ||
                        (b.responseURL &&
                          0 === b.responseURL.indexOf("file:"))) &&
                      setTimeout(C);
                  }),
              (b.onabort = function () {
                b &&
                  (n(u("Request aborted", e, "ECONNABORTED", b)), (b = null));
              }),
              (b.onerror = function () {
                n(u("Network Error", e, null, b)), (b = null);
              }),
              (b.ontimeout = function () {
                var t = e.timeout
                    ? "timeout of " + e.timeout + "ms exceeded"
                    : "timeout exceeded",
                  r = e.transitional || d;
                e.timeoutErrorMessage && (t = e.timeoutErrorMessage),
                  n(
                    u(
                      t,
                      e,
                      r.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
                      b
                    )
                  ),
                  (b = null);
              }),
              r.isStandardBrowserEnv())
            ) {
              var S =
                (e.withCredentials || c(x)) && e.xsrfCookieName
                  ? a.read(e.xsrfCookieName)
                  : void 0;
              S && (f[e.xsrfHeaderName] = S);
            }
            "setRequestHeader" in b &&
              r.forEach(f, function (e, t) {
                void 0 === h && "content-type" === t.toLowerCase()
                  ? delete f[t]
                  : b.setRequestHeader(t, e);
              }),
              r.isUndefined(e.withCredentials) ||
                (b.withCredentials = !!e.withCredentials),
              g && "json" !== g && (b.responseType = e.responseType),
              "function" == typeof e.onDownloadProgress &&
                b.addEventListener("progress", e.onDownloadProgress),
              "function" == typeof e.onUploadProgress &&
                b.upload &&
                b.upload.addEventListener("progress", e.onUploadProgress),
              (e.cancelToken || e.signal) &&
                ((m = function (e) {
                  b &&
                    (n(!e || (e && e.type) ? new p("canceled") : e),
                    b.abort(),
                    (b = null));
                }),
                e.cancelToken && e.cancelToken.subscribe(m),
                e.signal &&
                  (e.signal.aborted
                    ? m()
                    : e.signal.addEventListener("abort", m))),
              h || (h = null),
              b.send(h);
          });
        };
      },
      1609: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(1849),
          a = n(321),
          i = n(7185),
          s = (function e(t) {
            var n = new a(t),
              s = o(a.prototype.request, n);
            return (
              r.extend(s, a.prototype, n),
              r.extend(s, n),
              (s.create = function (n) {
                return e(i(t, n));
              }),
              s
            );
          })(n(5546));
        (s.Axios = a),
          (s.Cancel = n(5263)),
          (s.CancelToken = n(4972)),
          (s.isCancel = n(6502)),
          (s.VERSION = n(7288).version),
          (s.all = function (e) {
            return Promise.all(e);
          }),
          (s.spread = n(8713)),
          (s.isAxiosError = n(6268)),
          (e.exports = s),
          (e.exports.default = s);
      },
      5263: function (e) {
        "use strict";
        function t(e) {
          this.message = e;
        }
        (t.prototype.toString = function () {
          return "Cancel" + (this.message ? ": " + this.message : "");
        }),
          (t.prototype.__CANCEL__ = !0),
          (e.exports = t);
      },
      4972: function (e, t, n) {
        "use strict";
        var r = n(5263);
        function o(e) {
          if ("function" != typeof e)
            throw new TypeError("executor must be a function.");
          var t;
          this.promise = new Promise(function (e) {
            t = e;
          });
          var n = this;
          this.promise.then(function (e) {
            if (n._listeners) {
              var t,
                r = n._listeners.length;
              for (t = 0; t < r; t++) n._listeners[t](e);
              n._listeners = null;
            }
          }),
            (this.promise.then = function (e) {
              var t,
                r = new Promise(function (e) {
                  n.subscribe(e), (t = e);
                }).then(e);
              return (
                (r.cancel = function () {
                  n.unsubscribe(t);
                }),
                r
              );
            }),
            e(function (e) {
              n.reason || ((n.reason = new r(e)), t(n.reason));
            });
        }
        (o.prototype.throwIfRequested = function () {
          if (this.reason) throw this.reason;
        }),
          (o.prototype.subscribe = function (e) {
            this.reason
              ? e(this.reason)
              : this._listeners
              ? this._listeners.push(e)
              : (this._listeners = [e]);
          }),
          (o.prototype.unsubscribe = function (e) {
            if (this._listeners) {
              var t = this._listeners.indexOf(e);
              -1 !== t && this._listeners.splice(t, 1);
            }
          }),
          (o.source = function () {
            var e;
            return {
              token: new o(function (t) {
                e = t;
              }),
              cancel: e,
            };
          }),
          (e.exports = o);
      },
      6502: function (e) {
        "use strict";
        e.exports = function (e) {
          return !(!e || !e.__CANCEL__);
        };
      },
      321: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(5327),
          a = n(782),
          i = n(3572),
          s = n(7185),
          l = n(4875),
          c = l.validators;
        function u(e) {
          (this.defaults = e),
            (this.interceptors = { request: new a(), response: new a() });
        }
        (u.prototype.request = function (e, t) {
          "string" == typeof e ? ((t = t || {}).url = e) : (t = e || {}),
            (t = s(this.defaults, t)).method
              ? (t.method = t.method.toLowerCase())
              : this.defaults.method
              ? (t.method = this.defaults.method.toLowerCase())
              : (t.method = "get");
          var n = t.transitional;
          void 0 !== n &&
            l.assertOptions(
              n,
              {
                silentJSONParsing: c.transitional(c.boolean),
                forcedJSONParsing: c.transitional(c.boolean),
                clarifyTimeoutError: c.transitional(c.boolean),
              },
              !1
            );
          var r = [],
            o = !0;
          this.interceptors.request.forEach(function (e) {
            ("function" == typeof e.runWhen && !1 === e.runWhen(t)) ||
              ((o = o && e.synchronous), r.unshift(e.fulfilled, e.rejected));
          });
          var a,
            u = [];
          if (
            (this.interceptors.response.forEach(function (e) {
              u.push(e.fulfilled, e.rejected);
            }),
            !o)
          ) {
            var d = [i, void 0];
            for (
              Array.prototype.unshift.apply(d, r),
                d = d.concat(u),
                a = Promise.resolve(t);
              d.length;

            )
              a = a.then(d.shift(), d.shift());
            return a;
          }
          for (var p = t; r.length; ) {
            var m = r.shift(),
              h = r.shift();
            try {
              p = m(p);
            } catch (e) {
              h(e);
              break;
            }
          }
          try {
            a = i(p);
          } catch (e) {
            return Promise.reject(e);
          }
          for (; u.length; ) a = a.then(u.shift(), u.shift());
          return a;
        }),
          (u.prototype.getUri = function (e) {
            return (
              (e = s(this.defaults, e)),
              o(e.url, e.params, e.paramsSerializer).replace(/^\?/, "")
            );
          }),
          r.forEach(["delete", "get", "head", "options"], function (e) {
            u.prototype[e] = function (t, n) {
              return this.request(
                s(n || {}, { method: e, url: t, data: (n || {}).data })
              );
            };
          }),
          r.forEach(["post", "put", "patch"], function (e) {
            u.prototype[e] = function (t, n, r) {
              return this.request(s(r || {}, { method: e, url: t, data: n }));
            };
          }),
          (e.exports = u);
      },
      782: function (e, t, n) {
        "use strict";
        var r = n(4867);
        function o() {
          this.handlers = [];
        }
        (o.prototype.use = function (e, t, n) {
          return (
            this.handlers.push({
              fulfilled: e,
              rejected: t,
              synchronous: !!n && n.synchronous,
              runWhen: n ? n.runWhen : null,
            }),
            this.handlers.length - 1
          );
        }),
          (o.prototype.eject = function (e) {
            this.handlers[e] && (this.handlers[e] = null);
          }),
          (o.prototype.forEach = function (e) {
            r.forEach(this.handlers, function (t) {
              null !== t && e(t);
            });
          }),
          (e.exports = o);
      },
      4097: function (e, t, n) {
        "use strict";
        var r = n(1793),
          o = n(7303);
        e.exports = function (e, t) {
          return e && !r(t) ? o(e, t) : t;
        };
      },
      5061: function (e, t, n) {
        "use strict";
        var r = n(481);
        e.exports = function (e, t, n, o, a) {
          var i = new Error(e);
          return r(i, t, n, o, a);
        };
      },
      3572: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(8527),
          a = n(6502),
          i = n(5546),
          s = n(5263);
        function l(e) {
          if (
            (e.cancelToken && e.cancelToken.throwIfRequested(),
            e.signal && e.signal.aborted)
          )
            throw new s("canceled");
        }
        e.exports = function (e) {
          return (
            l(e),
            (e.headers = e.headers || {}),
            (e.data = o.call(e, e.data, e.headers, e.transformRequest)),
            (e.headers = r.merge(
              e.headers.common || {},
              e.headers[e.method] || {},
              e.headers
            )),
            r.forEach(
              ["delete", "get", "head", "post", "put", "patch", "common"],
              function (t) {
                delete e.headers[t];
              }
            ),
            (e.adapter || i.adapter)(e).then(
              function (t) {
                return (
                  l(e),
                  (t.data = o.call(e, t.data, t.headers, e.transformResponse)),
                  t
                );
              },
              function (t) {
                return (
                  a(t) ||
                    (l(e),
                    t &&
                      t.response &&
                      (t.response.data = o.call(
                        e,
                        t.response.data,
                        t.response.headers,
                        e.transformResponse
                      ))),
                  Promise.reject(t)
                );
              }
            )
          );
        };
      },
      481: function (e) {
        "use strict";
        e.exports = function (e, t, n, r, o) {
          return (
            (e.config = t),
            n && (e.code = n),
            (e.request = r),
            (e.response = o),
            (e.isAxiosError = !0),
            (e.toJSON = function () {
              return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code,
                status:
                  this.response && this.response.status
                    ? this.response.status
                    : null,
              };
            }),
            e
          );
        };
      },
      7185: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = function (e, t) {
          t = t || {};
          var n = {};
          function o(e, t) {
            return r.isPlainObject(e) && r.isPlainObject(t)
              ? r.merge(e, t)
              : r.isPlainObject(t)
              ? r.merge({}, t)
              : r.isArray(t)
              ? t.slice()
              : t;
          }
          function a(n) {
            return r.isUndefined(t[n])
              ? r.isUndefined(e[n])
                ? void 0
                : o(void 0, e[n])
              : o(e[n], t[n]);
          }
          function i(e) {
            if (!r.isUndefined(t[e])) return o(void 0, t[e]);
          }
          function s(n) {
            return r.isUndefined(t[n])
              ? r.isUndefined(e[n])
                ? void 0
                : o(void 0, e[n])
              : o(void 0, t[n]);
          }
          function l(n) {
            return n in t ? o(e[n], t[n]) : n in e ? o(void 0, e[n]) : void 0;
          }
          var c = {
            url: i,
            method: i,
            data: i,
            baseURL: s,
            transformRequest: s,
            transformResponse: s,
            paramsSerializer: s,
            timeout: s,
            timeoutMessage: s,
            withCredentials: s,
            adapter: s,
            responseType: s,
            xsrfCookieName: s,
            xsrfHeaderName: s,
            onUploadProgress: s,
            onDownloadProgress: s,
            decompress: s,
            maxContentLength: s,
            maxBodyLength: s,
            transport: s,
            httpAgent: s,
            httpsAgent: s,
            cancelToken: s,
            socketPath: s,
            responseEncoding: s,
            validateStatus: l,
          };
          return (
            r.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
              var t = c[e] || a,
                o = t(e);
              (r.isUndefined(o) && t !== l) || (n[e] = o);
            }),
            n
          );
        };
      },
      6026: function (e, t, n) {
        "use strict";
        var r = n(5061);
        e.exports = function (e, t, n) {
          var o = n.config.validateStatus;
          n.status && o && !o(n.status)
            ? t(
                r(
                  "Request failed with status code " + n.status,
                  n.config,
                  null,
                  n.request,
                  n
                )
              )
            : e(n);
        };
      },
      8527: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(5546);
        e.exports = function (e, t, n) {
          var a = this || o;
          return (
            r.forEach(n, function (n) {
              e = n.call(a, e, t);
            }),
            e
          );
        };
      },
      5546: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(6016),
          a = n(481),
          i = n(7874),
          s = { "Content-Type": "application/x-www-form-urlencoded" };
        function l(e, t) {
          !r.isUndefined(e) &&
            r.isUndefined(e["Content-Type"]) &&
            (e["Content-Type"] = t);
        }
        var c,
          u = {
            transitional: i,
            adapter:
              (("undefined" != typeof XMLHttpRequest ||
                ("undefined" != typeof process &&
                  "[object process]" ===
                    Object.prototype.toString.call(process))) &&
                (c = n(5448)),
              c),
            transformRequest: [
              function (e, t) {
                return (
                  o(t, "Accept"),
                  o(t, "Content-Type"),
                  r.isFormData(e) ||
                  r.isArrayBuffer(e) ||
                  r.isBuffer(e) ||
                  r.isStream(e) ||
                  r.isFile(e) ||
                  r.isBlob(e)
                    ? e
                    : r.isArrayBufferView(e)
                    ? e.buffer
                    : r.isURLSearchParams(e)
                    ? (l(t, "application/x-www-form-urlencoded;charset=utf-8"),
                      e.toString())
                    : r.isObject(e) ||
                      (t && "application/json" === t["Content-Type"])
                    ? (l(t, "application/json"),
                      (function (e, t, n) {
                        if (r.isString(e))
                          try {
                            return (0, JSON.parse)(e), r.trim(e);
                          } catch (e) {
                            if ("SyntaxError" !== e.name) throw e;
                          }
                        return (0, JSON.stringify)(e);
                      })(e))
                    : e
                );
              },
            ],
            transformResponse: [
              function (e) {
                var t = this.transitional || u.transitional,
                  n = t && t.silentJSONParsing,
                  o = t && t.forcedJSONParsing,
                  i = !n && "json" === this.responseType;
                if (i || (o && r.isString(e) && e.length))
                  try {
                    return JSON.parse(e);
                  } catch (e) {
                    if (i) {
                      if ("SyntaxError" === e.name)
                        throw a(e, this, "E_JSON_PARSE");
                      throw e;
                    }
                  }
                return e;
              },
            ],
            timeout: 0,
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            maxContentLength: -1,
            maxBodyLength: -1,
            validateStatus: function (e) {
              return e >= 200 && e < 300;
            },
            headers: {
              common: { Accept: "application/json, text/plain, */*" },
            },
          };
        r.forEach(["delete", "get", "head"], function (e) {
          u.headers[e] = {};
        }),
          r.forEach(["post", "put", "patch"], function (e) {
            u.headers[e] = r.merge(s);
          }),
          (e.exports = u);
      },
      7874: function (e) {
        "use strict";
        e.exports = {
          silentJSONParsing: !0,
          forcedJSONParsing: !0,
          clarifyTimeoutError: !1,
        };
      },
      7288: function (e) {
        e.exports = { version: "0.26.1" };
      },
      1849: function (e) {
        "use strict";
        e.exports = function (e, t) {
          return function () {
            for (var n = new Array(arguments.length), r = 0; r < n.length; r++)
              n[r] = arguments[r];
            return e.apply(t, n);
          };
        };
      },
      5327: function (e, t, n) {
        "use strict";
        var r = n(4867);
        function o(e) {
          return encodeURIComponent(e)
            .replace(/%3A/gi, ":")
            .replace(/%24/g, "$")
            .replace(/%2C/gi, ",")
            .replace(/%20/g, "+")
            .replace(/%5B/gi, "[")
            .replace(/%5D/gi, "]");
        }
        e.exports = function (e, t, n) {
          if (!t) return e;
          var a;
          if (n) a = n(t);
          else if (r.isURLSearchParams(t)) a = t.toString();
          else {
            var i = [];
            r.forEach(t, function (e, t) {
              null != e &&
                (r.isArray(e) ? (t += "[]") : (e = [e]),
                r.forEach(e, function (e) {
                  r.isDate(e)
                    ? (e = e.toISOString())
                    : r.isObject(e) && (e = JSON.stringify(e)),
                    i.push(o(t) + "=" + o(e));
                }));
            }),
              (a = i.join("&"));
          }
          if (a) {
            var s = e.indexOf("#");
            -1 !== s && (e = e.slice(0, s)),
              (e += (-1 === e.indexOf("?") ? "?" : "&") + a);
          }
          return e;
        };
      },
      7303: function (e) {
        "use strict";
        e.exports = function (e, t) {
          return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
        };
      },
      4372: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = r.isStandardBrowserEnv()
          ? {
              write: function (e, t, n, o, a, i) {
                var s = [];
                s.push(e + "=" + encodeURIComponent(t)),
                  r.isNumber(n) &&
                    s.push("expires=" + new Date(n).toGMTString()),
                  r.isString(o) && s.push("path=" + o),
                  r.isString(a) && s.push("domain=" + a),
                  !0 === i && s.push("secure"),
                  (document.cookie = s.join("; "));
              },
              read: function (e) {
                var t = document.cookie.match(
                  new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
                );
                return t ? decodeURIComponent(t[3]) : null;
              },
              remove: function (e) {
                this.write(e, "", Date.now() - 864e5);
              },
            }
          : {
              write: function () {},
              read: function () {
                return null;
              },
              remove: function () {},
            };
      },
      1793: function (e) {
        "use strict";
        e.exports = function (e) {
          return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
        };
      },
      6268: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = function (e) {
          return r.isObject(e) && !0 === e.isAxiosError;
        };
      },
      7985: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = r.isStandardBrowserEnv()
          ? (function () {
              var e,
                t = /(msie|trident)/i.test(navigator.userAgent),
                n = document.createElement("a");
              function o(e) {
                var r = e;
                return (
                  t && (n.setAttribute("href", r), (r = n.href)),
                  n.setAttribute("href", r),
                  {
                    href: n.href,
                    protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                    host: n.host,
                    search: n.search ? n.search.replace(/^\?/, "") : "",
                    hash: n.hash ? n.hash.replace(/^#/, "") : "",
                    hostname: n.hostname,
                    port: n.port,
                    pathname:
                      "/" === n.pathname.charAt(0)
                        ? n.pathname
                        : "/" + n.pathname,
                  }
                );
              }
              return (
                (e = o(window.location.href)),
                function (t) {
                  var n = r.isString(t) ? o(t) : t;
                  return n.protocol === e.protocol && n.host === e.host;
                }
              );
            })()
          : function () {
              return !0;
            };
      },
      6016: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = function (e, t) {
          r.forEach(e, function (n, r) {
            r !== t &&
              r.toUpperCase() === t.toUpperCase() &&
              ((e[t] = n), delete e[r]);
          });
        };
      },
      4109: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = [
            "age",
            "authorization",
            "content-length",
            "content-type",
            "etag",
            "expires",
            "from",
            "host",
            "if-modified-since",
            "if-unmodified-since",
            "last-modified",
            "location",
            "max-forwards",
            "proxy-authorization",
            "referer",
            "retry-after",
            "user-agent",
          ];
        e.exports = function (e) {
          var t,
            n,
            a,
            i = {};
          return e
            ? (r.forEach(e.split("\n"), function (e) {
                if (
                  ((a = e.indexOf(":")),
                  (t = r.trim(e.substr(0, a)).toLowerCase()),
                  (n = r.trim(e.substr(a + 1))),
                  t)
                ) {
                  if (i[t] && o.indexOf(t) >= 0) return;
                  i[t] =
                    "set-cookie" === t
                      ? (i[t] ? i[t] : []).concat([n])
                      : i[t]
                      ? i[t] + ", " + n
                      : n;
                }
              }),
              i)
            : i;
        };
      },
      8713: function (e) {
        "use strict";
        e.exports = function (e) {
          return function (t) {
            return e.apply(null, t);
          };
        };
      },
      4875: function (e, t, n) {
        "use strict";
        var r = n(7288).version,
          o = {};
        ["object", "boolean", "number", "function", "string", "symbol"].forEach(
          function (e, t) {
            o[e] = function (n) {
              return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
            };
          }
        );
        var a = {};
        (o.transitional = function (e, t, n) {
          function o(e, t) {
            return (
              "[Axios v" +
              r +
              "] Transitional option '" +
              e +
              "'" +
              t +
              (n ? ". " + n : "")
            );
          }
          return function (n, r, i) {
            if (!1 === e)
              throw new Error(
                o(r, " has been removed" + (t ? " in " + t : ""))
              );
            return (
              t &&
                !a[r] &&
                ((a[r] = !0),
                console.warn(
                  o(
                    r,
                    " has been deprecated since v" +
                      t +
                      " and will be removed in the near future"
                  )
                )),
              !e || e(n, r, i)
            );
          };
        }),
          (e.exports = {
            assertOptions: function (e, t, n) {
              if ("object" != typeof e)
                throw new TypeError("options must be an object");
              for (var r = Object.keys(e), o = r.length; o-- > 0; ) {
                var a = r[o],
                  i = t[a];
                if (i) {
                  var s = e[a],
                    l = void 0 === s || i(s, a, e);
                  if (!0 !== l)
                    throw new TypeError("option " + a + " must be " + l);
                } else if (!0 !== n) throw Error("Unknown option " + a);
              }
            },
            validators: o,
          });
      },
      4867: function (e, t, n) {
        "use strict";
        var r = n(1849),
          o = Object.prototype.toString;
        function a(e) {
          return Array.isArray(e);
        }
        function i(e) {
          return void 0 === e;
        }
        function s(e) {
          return "[object ArrayBuffer]" === o.call(e);
        }
        function l(e) {
          return null !== e && "object" == typeof e;
        }
        function c(e) {
          if ("[object Object]" !== o.call(e)) return !1;
          var t = Object.getPrototypeOf(e);
          return null === t || t === Object.prototype;
        }
        function u(e) {
          return "[object Function]" === o.call(e);
        }
        function d(e, t) {
          if (null != e)
            if (("object" != typeof e && (e = [e]), a(e)))
              for (var n = 0, r = e.length; n < r; n++)
                t.call(null, e[n], n, e);
            else
              for (var o in e)
                Object.prototype.hasOwnProperty.call(e, o) &&
                  t.call(null, e[o], o, e);
        }
        e.exports = {
          isArray: a,
          isArrayBuffer: s,
          isBuffer: function (e) {
            return (
              null !== e &&
              !i(e) &&
              null !== e.constructor &&
              !i(e.constructor) &&
              "function" == typeof e.constructor.isBuffer &&
              e.constructor.isBuffer(e)
            );
          },
          isFormData: function (e) {
            return "[object FormData]" === o.call(e);
          },
          isArrayBufferView: function (e) {
            return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
              ? ArrayBuffer.isView(e)
              : e && e.buffer && s(e.buffer);
          },
          isString: function (e) {
            return "string" == typeof e;
          },
          isNumber: function (e) {
            return "number" == typeof e;
          },
          isObject: l,
          isPlainObject: c,
          isUndefined: i,
          isDate: function (e) {
            return "[object Date]" === o.call(e);
          },
          isFile: function (e) {
            return "[object File]" === o.call(e);
          },
          isBlob: function (e) {
            return "[object Blob]" === o.call(e);
          },
          isFunction: u,
          isStream: function (e) {
            return l(e) && u(e.pipe);
          },
          isURLSearchParams: function (e) {
            return "[object URLSearchParams]" === o.call(e);
          },
          isStandardBrowserEnv: function () {
            return (
              ("undefined" == typeof navigator ||
                ("ReactNative" !== navigator.product &&
                  "NativeScript" !== navigator.product &&
                  "NS" !== navigator.product)) &&
              "undefined" != typeof window &&
              "undefined" != typeof document
            );
          },
          forEach: d,
          merge: function e() {
            var t = {};
            function n(n, r) {
              c(t[r]) && c(n)
                ? (t[r] = e(t[r], n))
                : c(n)
                ? (t[r] = e({}, n))
                : a(n)
                ? (t[r] = n.slice())
                : (t[r] = n);
            }
            for (var r = 0, o = arguments.length; r < o; r++)
              d(arguments[r], n);
            return t;
          },
          extend: function (e, t, n) {
            return (
              d(t, function (t, o) {
                e[o] = n && "function" == typeof t ? r(t, n) : t;
              }),
              e
            );
          },
          trim: function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          },
          stripBOM: function (e) {
            return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
          },
        };
      },
      4929: function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.default = [
            { name: "Afghanistan", code: "af", dial_code: "+93" },
            { name: "Albania", code: "al", dial_code: "+355" },
            { name: "Algeria", code: "dz", dial_code: "+213" },
            { name: "Andorra", code: "ad", dial_code: "+376" },
            { name: "Angola", code: "ao", dial_code: "+244" },
            { name: "Anguilla", code: "ai", dial_code: "+1264" },
            { name: "Antigua and Barbuda", code: "ag", dial_code: "+1268" },
            { name: "Argentina", code: "ar", dial_code: "+54" },
            { name: "Armenia", code: "am", dial_code: "+374" },
            { name: "Aruba", code: "aw", dial_code: "+297" },
            { name: "Australia", code: "au", dial_code: "+61" },
            { name: "Austria", code: "at", dial_code: "+43" },
            { name: "Azerbaijan", code: "az", dial_code: "+994" },
            { name: "Bahamas", code: "bs", dial_code: "+1242" },
            { name: "Bahrain", code: "bh", dial_code: "+973" },
            { name: "Bangladesh", code: "bd", dial_code: "+880" },
            { name: "Barbados", code: "bb", dial_code: "+1246" },
            { name: "Belarus", code: "by", dial_code: "+375" },
            { name: "Belgium", code: "be", dial_code: "+32" },
            { name: "Belize", code: "bz", dial_code: "+501" },
            { name: "Benin", code: "bj", dial_code: "+229" },
            { name: "Bermuda", code: "bm", dial_code: "+1441" },
            { name: "Bhutan", code: "bt", dial_code: "+975" },
            { name: "Bolivia", code: "bo", dial_code: "+591" },
            { name: "Bosnia and Herzegovina", code: "ba", dial_code: "+387" },
            { name: "Botswana", code: "bw", dial_code: "+267" },
            { name: "Brazil", code: "br", dial_code: "+55" },
            { name: "Brunei Darussalam", code: "bn", dial_code: "+673" },
            { name: "Bulgaria", code: "bg", dial_code: "+359" },
            { name: "Burkina Faso", code: "bf", dial_code: "+226" },
            { name: "Burundi", code: "bi", dial_code: "+257" },
            { name: "Cambodia", code: "kh", dial_code: "+855" },
            { name: "Cameroon", code: "cm", dial_code: "+237" },
            { name: "Canada", code: "ca", dial_code: "+1" },
            { name: "Cape Verde", code: "cv", dial_code: "+238" },
            { name: "Cayman Islands", code: "ky", dial_code: "+ 345" },
            { name: "Central African Republic", code: "cf", dial_code: "+236" },
            { name: "Chad", code: "td", dial_code: "+235" },
            { name: "Chile", code: "cl", dial_code: "+56" },
            { name: "China", code: "cn", dial_code: "+86" },
            { name: "Christmas Island", code: "cx", dial_code: "+61" },
            { name: "Cocos (Keeling) Islands", code: "cc", dial_code: "+61" },
            { name: "Colombia", code: "co", dial_code: "+57" },
            { name: "Comoros", code: "km", dial_code: "+269" },
            { name: "Congo", code: "cg", dial_code: "+242" },
            { name: "Cook Islands", code: "ck", dial_code: "+682" },
            { name: "Costa Rica", code: "cr", dial_code: "+506" },
            { name: "Cote D'Ivoire", code: "ci", dial_code: "+225" },
            { name: "Croatia", code: "hr", dial_code: "+385" },
            { name: "Cuba", code: "cu", dial_code: "+53" },
            { name: "Cyprus", code: "cy", dial_code: "+537" },
            { name: "Czech Republic", code: "cz", dial_code: "+420" },
            {
              name: "Democratic Republic of the Congo",
              code: "cd",
              dial_code: "+243",
            },
            { name: "Denmark", code: "dk", dial_code: "+45" },
            { name: "Djibouti", code: "dj", dial_code: "+253" },
            { name: "Dominica", code: "dm", dial_code: "+1767" },
            { name: "Dominican Republic", code: "do", dial_code: "+1849" },
            { name: "Ecuador", code: "ec", dial_code: "+593" },
            { name: "Egypt", code: "eg", dial_code: "+20" },
            { name: "El Salvador", code: "sv", dial_code: "+503" },
            { name: "Equatorial Guinea", code: "gq", dial_code: "+240" },
            { name: "Eritrea", code: "er", dial_code: "+291" },
            { name: "Estonia", code: "ee", dial_code: "+372" },
            { name: "Ethiopia", code: "et", dial_code: "+251" },
            { name: "Falkland Islands", code: "fk", dial_code: "+500" },
            { name: "Faroe Islands", code: "fo", dial_code: "+298" },
            {
              name: "Federated States of Micronesia",
              code: "fm",
              dial_code: "+691",
            },
            { name: "Fiji", code: "fj", dial_code: "+679" },
            { name: "Finland", code: "fi", dial_code: "+358" },
            { name: "France", code: "fr", dial_code: "+33" },
            { name: "French Guiana", code: "gf", dial_code: "+594" },
            { name: "French Polynesia", code: "pf", dial_code: "+689" },
            {
              name: "French Southern Territories",
              code: "tf",
              dial_code: "+262",
            },
            { name: "Gabon", code: "ga", dial_code: "+241" },
            { name: "Gambia", code: "gm", dial_code: "+220" },
            { name: "Georgia", code: "ge", dial_code: "+995" },
            { name: "Germany", code: "de", dial_code: "+49" },
            { name: "Ghana", code: "gh", dial_code: "+233" },
            { name: "Gibraltar", code: "gi", dial_code: "+350" },
            { name: "Great Britain (UK)", code: "gb", dial_code: "+44" },
            { name: "Greece", code: "gr", dial_code: "+30" },
            { name: "Greenland", code: "gl", dial_code: "+299" },
            { name: "Grenada", code: "gd", dial_code: "+1473" },
            { name: "Guadeloupe", code: "gp", dial_code: "+590" },
            { name: "Guatemala", code: "gt", dial_code: "+502" },
            { name: "Guinea", code: "gn", dial_code: "+224" },
            { name: "Guinea-Bissau", code: "gw", dial_code: "+245" },
            { name: "Guyana", code: "gy", dial_code: "+595" },
            { name: "Haiti", code: "ht", dial_code: "+509" },
            { name: "Honduras", code: "hn", dial_code: "+504" },
            { name: "Hong Kong", code: "hk", dial_code: "+852" },
            { name: "Hungary", code: "hu", dial_code: "+36" },
            { name: "Iceland", code: "is", dial_code: "+354" },
            { name: "India", code: "in", dial_code: "+91" },
            { name: "Indonesia", code: "id", dial_code: "+62" },
            { name: "Iran", code: "ir", dial_code: "+98" },
            { name: "Iraq", code: "iq", dial_code: "+964" },
            { name: "Ireland", code: "ie", dial_code: "+353" },
            { name: "Israel", code: "il", dial_code: "+972" },
            { name: "Italy", code: "it", dial_code: "+39" },
            { name: "Jamaica", code: "jm", dial_code: "+1876" },
            { name: "Japan", code: "jp", dial_code: "+81" },
            { name: "Jordan", code: "jo", dial_code: "+962" },
            { name: "Kazakhstan", code: "kz", dial_code: "+7 7" },
            { name: "Kenya", code: "ke", dial_code: "+254" },
            { name: "Kiribati", code: "ki", dial_code: "+686" },
            { name: "North Korea", code: "kp", dial_code: "+850" },
            { name: "South Korea", code: "kr", dial_code: "+82" },
            { name: "Kuwait", code: "kw", dial_code: "+965" },
            { name: "Kyrgyzstan", code: "kg", dial_code: "+996" },
            { name: "Laos", code: "la", dial_code: "+856" },
            { name: "Latvia", code: "lv", dial_code: "+371" },
            { name: "Lebanon", code: "lb", dial_code: "+961" },
            { name: "Lesotho", code: "ls", dial_code: "+266" },
            { name: "Liberia", code: "lr", dial_code: "+231" },
            { name: "Libya", code: "ly", dial_code: "+218" },
            { name: "Liechtenstein", code: "li", dial_code: "+423" },
            { name: "Lithuania", code: "lt", dial_code: "+370" },
            { name: "Luxembourg", code: "lu", dial_code: "+352" },
            { name: "Macao", code: "mo", dial_code: "+853" },
            { name: "Macedonia", code: "mk", dial_code: "+389" },
            { name: "Madagascar", code: "mg", dial_code: "+261" },
            { name: "Malawi", code: "mw", dial_code: "+265" },
            { name: "Malaysia", code: "my", dial_code: "+60" },
            { name: "Maldives", code: "mv", dial_code: "+960" },
            { name: "Mali", code: "ml", dial_code: "+223" },
            { name: "Malta", code: "mt", dial_code: "+356" },
            { name: "Marshall Islands", code: "mh", dial_code: "+692" },
            { name: "Martinique", code: "mq", dial_code: "+596" },
            { name: "Mauritania", code: "mr", dial_code: "+222" },
            { name: "Mauritius", code: "mu", dial_code: "+230" },
            { name: "Mayotte", code: "yt", dial_code: "+262" },
            { name: "Mexico", code: "mx", dial_code: "+52" },
            { name: "Moldova", code: "md", dial_code: "+373" },
            { name: "Monaco", code: "mc", dial_code: "+377" },
            { name: "Mongolia", code: "mn", dial_code: "+976" },
            { name: "Montserrat", code: "ms", dial_code: "+1664" },
            { name: "Morocco", code: "ma", dial_code: "+212" },
            { name: "Mozambique", code: "mz", dial_code: "+258" },
            { name: "Myanmar", code: "mm", dial_code: "+95" },
            { name: "Namibia", code: "na", dial_code: "+264" },
            { name: "Nauru", code: "nr", dial_code: "+674" },
            { name: "Nepal", code: "np", dial_code: "+977" },
            { name: "Netherlands", code: "nl", dial_code: "+31" },
            { name: "Netherlands Antilles", code: "an", dial_code: "+599" },
            { name: "New Caledonia", code: "nc", dial_code: "+687" },
            { name: "New Zealand", code: "nz", dial_code: "+64" },
            { name: "Nicaragua", code: "ni", dial_code: "+505" },
            { name: "Niger", code: "ne", dial_code: "+227" },
            { name: "Nigeria", code: "ng", dial_code: "+234" },
            { name: "Niue", code: "nu", dial_code: "+683" },
            { name: "Norfolk Island", code: "nf", dial_code: "+672" },
            {
              name: "Northern Mariana Islands",
              code: "mp",
              dial_code: "+1670",
            },
            { name: "Norway", code: "no", dial_code: "+47" },
            { name: "NULL", code: "gg", dial_code: "+44" },
            { name: "Oman", code: "om", dial_code: "+968" },
            { name: "Pakistan", code: "pk", dial_code: "+92" },
            { name: "Palau", code: "pw", dial_code: "+680" },
            { name: "Palestinian Territory", code: "ps", dial_code: "+970" },
            { name: "Panama", code: "pa", dial_code: "+507" },
            { name: "Papua New Guinea", code: "pg", dial_code: "+675" },
            { name: "Paraguay", code: "py", dial_code: "+595" },
            { name: "Peru", code: "pe", dial_code: "+51" },
            { name: "Philippines", code: "ph", dial_code: "+63" },
            { name: "Pitcairn", code: "pn", dial_code: "+872" },
            { name: "Poland", code: "pl", dial_code: "+48" },
            { name: "Portugal", code: "pt", dial_code: "+351" },
            { name: "Qatar", code: "qa", dial_code: "+974" },
            { name: "Reunion", code: "re", dial_code: "+262" },
            { name: "Romania", code: "ro", dial_code: "+40" },
            { name: "Russian Federation", code: "ru", dial_code: "+7" },
            { name: "Rwanda", code: "rw", dial_code: "+250" },
            {
              name: "S. Georgia and S. Sandwich Islands",
              code: "gs",
              dial_code: "+500",
            },
            { name: "Saint Helena", code: "sh", dial_code: "+290" },
            { name: "Saint Kitts and Nevis", code: "kn", dial_code: "+1869" },
            { name: "Saint Lucia", code: "lc", dial_code: "+1758" },
            {
              name: "Saint Pierre and Miquelon",
              code: "pm",
              dial_code: "+508",
            },
            {
              name: "Saint Vincent and the Grenadines",
              code: "vc",
              dial_code: "+1784",
            },
            { name: "Samoa", code: "ws", dial_code: "+685" },
            { name: "San Marino", code: "sm", dial_code: "+378" },
            { name: "Sao Tome and Principe", code: "st", dial_code: "+239" },
            { name: "Saudi Arabia", code: "sa", dial_code: "+966" },
            { name: "Senegal", code: "sn", dial_code: "+221" },
            { name: "Seychelles", code: "sc", dial_code: "+248" },
            { name: "Sierra Leone", code: "sl", dial_code: "+232" },
            { name: "Singapore", code: "sg", dial_code: "+65" },
            { name: "Slovakia", code: "sk", dial_code: "+421" },
            { name: "Slovenia", code: "si", dial_code: "+386" },
            { name: "Solomon Islands", code: "sb", dial_code: "+677" },
            { name: "Somalia", code: "so", dial_code: "+252" },
            { name: "South Africa", code: "za", dial_code: "+27" },
            { name: "Spain", code: "es", dial_code: "+34" },
            { name: "Sri Lanka", code: "lk", dial_code: "+94" },
            { name: "Sudan", code: "sd", dial_code: "+249" },
            { name: "Suriname", code: "sr", dial_code: "+597" },
            { name: "Svalbard and Jan Mayen", code: "sj", dial_code: "+47" },
            { name: "Swaziland", code: "sz", dial_code: "+268" },
            { name: "Sweden", code: "se", dial_code: "+46" },
            { name: "Switzerland", code: "ch", dial_code: "+41" },
            { name: "Syria", code: "sy", dial_code: "+963" },
            { name: "Taiwan", code: "tw", dial_code: "+886" },
            { name: "Tajikistan", code: "tj", dial_code: "+992" },
            { name: "Tanzania", code: "tz", dial_code: "+255" },
            { name: "Thailand", code: "th", dial_code: "+66" },
            { name: "Togo", code: "tg", dial_code: "+228" },
            { name: "Tokelau", code: "tk", dial_code: "+690" },
            { name: "Tonga", code: "to", dial_code: "+676" },
            { name: "Trinidad and Tobago", code: "tt", dial_code: "+1868" },
            { name: "Tunisia", code: "tn", dial_code: "+216" },
            { name: "Turkey", code: "tr", dial_code: "+90" },
            { name: "Turkmenistan", code: "tm", dial_code: "+993" },
            {
              name: "Turks and Caicos Islands",
              code: "tc",
              dial_code: "+1649",
            },
            { name: "Tuvalu", code: "tv", dial_code: "+688" },
            { name: "Uganda", code: "ug", dial_code: "+256" },
            { name: "Ukraine", code: "ua", dial_code: "+380" },
            { name: "United Arab Emirates", code: "ae", dial_code: "+971" },
            { name: "United States of America", code: "us", dial_code: "+1" },
            { name: "Uruguay", code: "uy", dial_code: "+598" },
            { name: "Uzbekistan", code: "uz", dial_code: "+998" },
            { name: "Vanuatu", code: "vu", dial_code: "+678" },
            { name: "Venezuela", code: "ve", dial_code: "+58" },
            { name: "Vietnam", code: "vn", dial_code: "+84" },
            {
              name: "Virgin Islands (British)",
              code: "vg",
              dial_code: "+1284",
            },
            { name: "Virgin Islands (U.S.)", code: "vi", dial_code: "+1340" },
            { name: "Wallis and Futuna", code: "wf", dial_code: "+681" },
            { name: "Western Sahara", code: "eh", dial_code: "+212" },
            { name: "Yemen", code: "ye", dial_code: "+967" },
            { name: "Zambia", code: "zm", dial_code: "+260" },
            { name: "Zimbabwe", code: "zw", dial_code: "+263" },
          ]);
      },
      1564: function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.default = {
            af: [
              "Badakhshan",
              "Badghis",
              "Balkh",
              "Daykundi Province",
              "Farah",
              "Faryab Province",
              "Helmand",
              "Herat",
              "Kandahar",
              "Kunduz",
              "Nangarhar",
              "Panjshir",
              "Parwan",
              "Samangan",
              "Sar-e Pul",
              "Uruzgan",
              "Velayat-e Khowst",
              "Velayat-e Nurestan",
              "Wardak",
              "Wilayat-e Baghlan",
              "Wilayat-e Bamyan",
              "Wilayat-e Ghazni",
              "Wilayat-e Ghor",
              "Wilayat-e Jowzjan",
              "Wilayat-e Kabul",
              "Wilayat-e Kapisa",
              "Wilayat-e Kunar",
              "Wilayat-e Laghman",
              "Wilayat-e Logar",
              "Wilayat-e Nimroz",
              "Wilayat-e Paktika",
              "Wilayat-e Paktiya",
              "Wilayat-e Takhar",
              "Wilayat-e Zabul",
            ],
            al: [
              "Qarku i Beratit",
              "Qarku i Dibres",
              "Qarku i Durresit",
              "Qarku i Elbasanit",
              "Qarku i Fierit",
              "Qarku i Gjirokastres",
              "Qarku i Korces",
              "Qarku i Kukesit",
              "Qarku i Lezhes",
              "Qarku i Shkodres",
              "Qarku i Tiranes",
              "Qarku i Vlores",
            ],
            dz: [
              "Adrar",
              "Annaba",
              "El Bayadh",
              "El Oued",
              "El Tarf",
              "Illizi",
              "Oran",
              "Oum el Bouaghi",
              "Wilaya d' Alger",
              "Wilaya de Ain Defla",
              "Wilaya de Ain Temouchent",
              "Wilaya de Batna",
              "Wilaya de Bechar",
              "Wilaya de Bejaia",
              "Wilaya de Biskra",
              "Wilaya de Blida",
              "Wilaya de Bordj Bou Arreridj",
              "Wilaya de Bouira",
              "Wilaya de Boumerdes",
              "Wilaya de Chlef",
              "Wilaya de Constantine",
              "Wilaya de Djelfa",
              "Wilaya de Ghardaia",
              "Wilaya de Guelma",
              "Wilaya de Jijel",
              "Wilaya de Khenchela",
              "Wilaya de Laghouat",
              "Wilaya de M'Sila",
              "Wilaya de Mascara",
              "Wilaya de Medea",
              "Wilaya de Mila",
              "Wilaya de Mostaganem",
              "Wilaya de Naama",
              "Wilaya de Ouargla",
              "Wilaya de Relizane",
              "Wilaya de Saida",
              "Wilaya de Setif",
              "Wilaya de Sidi Bel Abbes",
              "Wilaya de Skikda",
              "Wilaya de Souk Ahras",
              "Wilaya de Tamanrasset",
              "Wilaya de Tebessa",
              "Wilaya de Tiaret",
              "Wilaya de Tindouf",
              "Wilaya de Tipaza",
              "Wilaya de Tissemsilt",
              "Wilaya de Tizi Ouzo",
              "Wilaya de Tlemcen",
            ],
            ad: [
              "Andorra la Vella",
              "Canillo",
              "Encamp",
              "Escaldes-Engordany",
              "La Massana",
              "Ordino",
              "Sant Julia de Loria",
            ],
            ao: [
              "Bengo Province",
              "Benguela",
              "Cabinda",
              "Cuanza Norte Province",
              "Cunene Province",
              "Huambo",
              "Huila Province",
              "Kuando Kubango",
              "Kwanza Sul",
              "Luanda Province",
              "Lunda Norte Province",
              "Lunda Sul",
              "Malanje Province",
              "Moxico",
              "Namibe Province",
              "Provincia do Bie",
              "Provincia do Uige",
              "Zaire",
            ],
            ai: [
              "Blowing Point",
              "East End",
              "George Hill",
              "Island Harbour",
              "North Hill",
              "North Side",
              "Sandy Ground",
              "Sandy Hill",
              "South Hill",
              "Stoney Ground",
              "The Farrington",
              "The Quarter",
              "The Valley",
              "West End",
            ],
            ag: [
              "Barbuda",
              "Parish of Saint George",
              "Parish of Saint John",
              "Parish of Saint Mary",
              "Parish of Saint Paul",
              "Parish of Saint Peter",
              "Parish of Saint Philip",
              "Redonda",
            ],
            ar: [
              "Catamarca Province",
              "Chaco Province",
              "Chubut Province",
              "Ciudad Autonoma de Buenos Aires",
              "Cordoba Province",
              "Corrientes Province",
              "Entre Rios Province",
              "Formosa Province",
              "Jujuy Province",
              "La Pampa Province",
              "La Rioja Province",
              "Mendoza Province",
              "Misiones Province",
              "Neuquen Province",
              "Provincia de Buenos Aires",
              "Rio Negro Province",
              "Salta Province",
              "San Juan Province",
              "San Luis Province",
              "Santa Cruz Province",
              "Santa Fe Province",
              "Santiago del Estero Province",
              "Tierra del Fuego Province",
              "Tucuman Province",
            ],
            am: [
              "Aragatsotni Marz",
              "Ararati Marz",
              "Armaviri Marz",
              "Geghark'unik'i Marz",
              "Kotayk'i Marz",
              "Lorru Marz",
              "Shiraki Marz",
              "Syunik'i Marz",
              "Tavushi Marz",
              "Vayots' Dzor",
              "Yerevan",
            ],
            aw: [],
            au: [
              "Australian Capital Territory",
              "Northern Territory",
              "New South Wales",
              "Queensland",
              "South Australia",
              "Tasmania",
              "Victoria",
              "Western Australia",
            ],
            at: [
              "Burgenland",
              "Kaernten",
              "Niederoesterreich",
              "Oberoesterreich",
              "Salzburg",
              "Steiermark",
              "Tirol",
              "Vorarlberg",
              "Wien",
            ],
            az: [
              "Absheron Rayon",
              "Aghdam Rayon",
              "Aghdash Rayon",
              "Aghjabadi Rayon",
              "Aghstafa Rayon",
              "Aghsu Rayon",
              "Astara District",
              "Baku City",
              "Balakan Rayon",
              "Barda Rayon",
              "Beylagan Rayon",
              "Bilasuvar Rayon",
              "Dashkasan Rayon",
              "Fizuli Rayon",
              "Gadabay Rayon",
              "Ganja City",
              "Gobustan Rayon",
              "Goranboy Rayon",
              "Goychay Rayon",
              "Goygol Rayon",
              "Hajigabul Rayon",
              "Imishli Rayon",
              "Ismayilli Rayon",
              "Jabrayil District",
              "Jalilabad",
              "Kalbajar District",
              "Khachmaz Rayon",
              "Khizi Rayon",
              "Khojavend District",
              "Kurdamir Rayon",
              "Lacin Rayon",
              "Lankaran Rayon",
              "Lankaran Sahari",
              "Lerik Rayon",
              "Masally District",
              "Mingacevir City",
              "Naftalan City",
              "Nakhchivan",
              "Nakhchivan Autonomous Republic",
              "Neftchala Rayon",
              "Oghuz Rayon",
              "Qabala Rayon",
              "Qakh Rayon",
              "Qazakh Rayon",
              "Quba Rayon",
              "Qubadli Rayon",
              "Qusar Rayon",
              "Saatly Rayon",
              "Sabirabad Rayon",
              "Salyan Rayon",
              "Samukh Rayon",
              "Shabran Rayon",
              "Shaki city",
              "Shaki Rayon",
              "Shamakhi Rayon",
              "Shamkir Rayon",
              "Shirvan",
              "Shusha",
              "Siazan Rayon",
              "Sumqayit City",
              "Susa Rayon",
              "Tartar Rayon",
              "Tovuz Rayon",
              "Ujar Rayon",
              "Xankandi Sahari",
              "Xocali Rayon",
              "Yardymli Rayon",
              "Yevlakh City",
              "Yevlakh Rayon",
              "Zangilan Rayon",
              "Zaqatala Rayon",
              "Zardab Rayon",
            ],
            bs: [
              "Acklins Island District",
              "Berry Islands District",
              "Bimini District",
              "Black Point District",
              "Cat Island",
              "Central Abaco District",
              "Central Andros District",
              "Central Eleuthera District",
              "City of Freeport District",
              "Crooked Island and Long Cay District",
              "East Grand Bahama District",
              "Exuma District",
              "Grand Cay District",
              "Harbour Island District",
              "Hope Town District",
              "Inagua",
              "Long Island",
              "Mangrove Cay",
              "Mayaguana District",
              "Moore's Island District",
              "New Providence District",
              "North Abaco District",
              "North Andros District",
              "North Eleuthera District",
              "Ragged Island District",
              "Rum Cay",
              "San Salvador District",
              "South Abaco District",
              "South Andros",
              "South Eleuthera",
              "Spanish Wells District",
              "West Grand Bahama District",
            ],
            bh: [
              "Capital Governorate",
              "Muharraq Governorate",
              "Northern Governorate",
              "Southern Governorate",
            ],
            bd: [
              "Barisal Division",
              "Chittagong",
              "Dhaka Division",
              "Khulna Division",
              "Mymensingh Division",
              "Rajshahi Division",
              "Rangpur Division",
              "Sylhet Division",
            ],
            bb: [
              "Christ Church",
              "Saint Andrew",
              "Saint George",
              "Saint James",
              "Saint John",
              "Saint Joseph",
              "Saint Lucy",
              "Saint Michael",
              "Saint Peter",
              "Saint Philip",
              "Saint Thomas",
            ],
            by: [
              "Brest Oblast",
              "Gomel Oblast",
              "Grodno Oblast",
              "Horad Minsk",
              "Minsk Oblast",
              "Mogilyov Oblast",
              "Vitebsk Oblast",
            ],
            be: ["Bruxelles-Capitale", "Flanders", "Wallonia"],
            bz: [
              "Belize District",
              "Cayo District",
              "Corozal District",
              "Orange Walk District",
              "Stann Creek District",
              "Toledo District",
            ],
            bj: [
              "Alibori",
              "Atakora Department",
              "Atlantique Department",
              "Borgou Department",
              "Collines Department",
              "Departement de l'Oueme",
              "Donga",
              "Kouffo Department",
              "Littoral",
              "Mono",
              "Plateau Department",
              "Zou Department",
            ],
            bm: [
              "Devonshire Parish",
              "Hamilton",
              "Paget Parish",
              "Pembroke Parish",
              "Saint George",
              "Saint George's Parish",
              "Sandys Parish",
              "Smith's Parish",
              "Southampton Parish",
              "Warwick Parish",
            ],
            bt: [
              "Bumthang Dzongkhag",
              "Chhukha Dzongkhag",
              "Dagana Dzongkhag",
              "Gasa",
              "Haa Dzongkhag",
              "Lhuentse Dzongkhag",
              "Mongar Dzongkhag",
              "Paro Dzongkhag",
              "Pemagatshel Dzongkhag",
              "Punakha Dzongkhag",
              "Samdrup Jongkhar Dzongkhag",
              "Samtse Dzongkhag",
              "Sarpang Dzongkhag",
              "Thimphu Dzongkhag",
              "Trashi Yangste",
              "Trashigang Dzongkhag",
              "Trongsa Dzongkhag",
              "Tsirang Dzongkhag",
              "Wangdue Phodrang Dzongkhag",
              "Zhemgang Dzongkhag",
            ],
            bo: [
              "Departamento de Chuquisaca",
              "Departamento de Cochabamba",
              "Departamento de La Paz",
              "Departamento de Oruro",
              "Departamento de Pando",
              "Departamento de Potosi",
              "Departamento de Santa Cruz",
              "Departamento de Tarija",
              "El Beni",
            ],
            ba: [
              "Brcko",
              "Federation of Bosnia and Herzegovina",
              "Republika Srpska",
            ],
            bw: [
              "Central District",
              "Ghanzi District",
              "Kgalagadi District",
              "Kgatleng District",
              "Kweneng District",
              "North East District",
              "North West District",
              "South East District",
              "Southern District",
            ],
            br: [
              "Acre",
              "Alagoas",
              "Amapa",
              "Amazonas",
              "Bahia",
              "Ceara",
              "Espirito Santo",
              "Federal District",
              "Goias",
              "Maranhao",
              "Mato Grosso",
              "Mato Grosso do Sul",
              "Minas Gerais",
              "Para",
              "Paraiba",
              "Parana",
              "Pernambuco",
              "Piaui",
              "Rio de Janeiro",
              "Rio Grande do Norte",
              "Rio Grande do Sul",
              "Rondonia",
              "Roraima",
              "Santa Catarina",
              "Sao Paulo",
              "Sergipe",
              "Tocantins",
            ],
            bn: [
              "Belait District",
              "Brunei and Muara District",
              "Temburong District",
              "Tutong District",
            ],
            bg: [
              "Blagoevgrad",
              "Burgas",
              "Gabrovo",
              "Haskovo",
              "Lovech",
              "Oblast Dobrich",
              "Oblast Kardzhali",
              "Oblast Kyustendil",
              "Oblast Montana",
              "Oblast Pleven",
              "Oblast Razgrad",
              "Oblast Ruse",
              "Oblast Shumen",
              "Oblast Silistra",
              "Oblast Sliven",
              "Oblast Smolyan",
              "Oblast Stara Zagora",
              "Oblast Targovishte",
              "Oblast Veliko Tarnovo",
              "Oblast Vidin",
              "Oblast Vratsa",
              "Oblast Yambol",
              "Pazardzhik",
              "Pernik",
              "Plovdiv",
              "Sofia",
              "Sofia-Grad",
              "Varna",
            ],
            bf: [
              "Boucle du Mouhoun Region",
              "Cascades Region",
              "Centre",
              "Centre-Est",
              "Centre-Nord",
              "Centre-Ouest",
              "Centre-Sud",
              "Est",
              "High-Basins Region",
              "Nord",
              "Plateau-Central",
              "Sahel",
              "Southwest Region",
            ],
            bi: [
              "Bubanza Province",
              "Bujumbura Mairie Province",
              "Bujumbura Rural Province",
              "Bururi Province",
              "Cankuzo Province",
              "Cibitoke Province",
              "Gitega Province",
              "Karuzi Province",
              "Kayanza Province",
              "Kirundo Province",
              "Makamba Province",
              "Muramvya Province",
              "Muyinga Province",
              "Ngozi Province",
              "Province de Mwaro",
              "Rumonge Province",
              "Rutana Province",
              "Ruyigi Province",
            ],
            kh: [
              "Banteay Meanchey",
              "Battambang",
              "Kampong Cham",
              "Kampong Chhnang",
              "Kampong Spe",
              "Kampong Thom",
              "Kampot",
              "Kandal",
              "Kep",
              "Koh Kong",
              "Kratie",
              "Mondolkiri",
              "Otar Meanchey",
              "Pailin",
              "Phnom Penh",
              "Preah Vihear",
              "Prey Veng",
              "Pursat",
              "Ratanakiri",
              "Siem Reap",
              "Sihanoukville",
              "Stung Treng",
              "Svay Rieng",
              "Takeo",
              "Tboung Khmum",
            ],
            cm: [
              "Adamaoua Region",
              "Centre Region",
              "East Region",
              "Far North Region",
              "Littoral Region",
              "North Region",
              "North-West Region",
              "South Region",
              "South-West Region",
              "West Region",
            ],
            ca: [
              "Alberta",
              "British Columbia",
              "Manitoba",
              "New Brunswick/Nouveau-Brunswick",
              "Newfoundland and Labrador",
              "Northwest Territories",
              "Nova Scotia",
              "Nunavut",
              "Ontario",
              "Prince Edward Island",
              "Quebec",
              "Saskatchewan",
              "Yukon",
            ],
            cv: [
              "Concelho da Boa Vista",
              "Concelho da Brava",
              "Concelho da Praia",
              "Concelho da Ribeira Brava",
              "Concelho da Ribeira Grande",
              "Concelho de Ribeira Grande de Santiago",
              "Concelho de Santa Catarina",
              "Concelho de Santa Catarina do Fogo",
              "Concelho de Santa Cruz",
              "Concelho de Sao Domingos",
              "Concelho de Sao Miguel",
              "Concelho de Sao Salvador do Mundo",
              "Concelho de Sao Vicente",
              "Concelho do Maio",
              "Concelho do Paul",
              "Concelho do Porto Novo",
              "Concelho do Sao Filipe",
              "Concelho do Tarrafal",
              "Concelho do Tarrafal de Sao Nicola",
              "Concelho dos Mosteiros",
              "Sal Municipality",
              "Sao Lourenco dos Orgaos",
            ],
            ky: [
              "Bodden Town",
              "East End",
              "George Town",
              "North Side",
              "Sister Island",
              "West Bay",
            ],
            cf: [
              "Bamingui-Bangoran",
              "Basse-Kotto",
              "Commune de Bangui",
              "Haut-Mbomo",
              "Haute-Kotto",
              "Lobaye",
              "Mambere-Kadei",
              "Mbomo",
              "Ombella-Mpoko",
              "Ouaka",
              "Ouham",
              "Prefecture de l'Ouham-Pende",
              "Prefecture de la Kemo",
              "Prefecture de la Nana-Grebizi",
              "Prefecture de la Nana-Mambere",
              "Prefecture de la Sangha-Mbaere",
              "Vakaga",
            ],
            td: [
              "Barh el Gazel",
              "Batha Region",
              "Borkou Region",
              "Chari-Baguirmi Region",
              "Ennedi-Est",
              "Ennedi-Ouest",
              "Guera Region",
              "Hadjer-Lamis",
              "Kanem Region",
              "Lac Region",
              "Logone Occidental Region",
              "Logone Oriental Region",
              "Mandoul",
              "Mayo-Kebbi East Region",
              "Mayo-Kebbi West Region",
              "Moyen-Chari Region",
              "Ouaddai Region",
              "Region de la Ville de N'Djamena",
              "Salamat Region",
              "Sila",
              "Tandjile Region",
              "Tibesti Region",
              "Wadi Fira Region",
            ],
            cl: [
              "Antofagasta",
              "Atacama",
              "Aysen",
              "Coquimbo",
              "Los Lagos",
              "Maule",
              "Region de Arica y Parinacota",
              "Region de la Araucania",
              "Region de Los Rios",
              "Region de Magallanes y de la Antartica Chilena",
              "Region de Tarapaca",
              "Region de Valparaiso",
              "Region del Biobio",
              "Region del Libertador General Bernardo O'Higgins",
              "Region Metropolitana de Santiago",
            ],
            cn: [
              "Anhui Sheng",
              "Beijing Shi",
              "Chongqing Shi",
              "Fujian Sheng",
              "Gansu Sheng",
              "Guangdong Sheng",
              "Guangxi Zhuangzu Zizhiq",
              "Guizhou Sheng",
              "Hainan Sheng",
              "Hebei Sheng",
              "Heilongjiang Sheng",
              "Henan Sheng",
              "Hubei Sheng",
              "Hunan Sheng",
              "Inner Mongolia Autonomous Region",
              "Jiangsu Sheng",
              "Jiangxi Sheng",
              "Jilin Sheng",
              "Liaoning Sheng",
              "Ningxia Huizu Zizhiq",
              "Qinghai Sheng",
              "Shaanxi",
              "Shandong Sheng",
              "Shanghai Shi",
              "Shanxi Sheng",
              "Sichuan Sheng",
              "Tianjin Shi",
              "Tibet Autonomous Region",
              "Xinjiang Uygur Zizhiq",
              "Yunnan Sheng",
              "Zhejiang Sheng",
            ],
            cx: [],
            cc: [],
            co: [
              "Amazonas",
              "Departamento de Antioquia",
              "Departamento de Arauca",
              "Departamento de Bolivar",
              "Departamento de Boyaca",
              "Departamento de Caldas",
              "Departamento de Casanare",
              "Departamento de Cordoba",
              "Departamento de Cundinamarca",
              "Departamento de La Guajira",
              "Departamento de Narino",
              "Departamento de Norte de Santander",
              "Departamento de Risaralda",
              "Departamento de Santander",
              "Departamento de Sucre",
              "Departamento de Tolima",
              "Departamento del Atlantico",
              "Departamento del Caqueta",
              "Departamento del Cauca",
              "Departamento del Cesar",
              "Departamento del Choco",
              "Departamento del Guainia",
              "Departamento del Guaviare",
              "Departamento del Huila",
              "Departamento del Magdalena",
              "Departamento del Meta",
              "Departamento del Putumayo",
              "Departamento del Valle del Cauca",
              "Departamento del Vaupes",
              "Departamento del Vichada",
              "Distrito Capital de Bogota",
              "Providencia y Santa Catalina, Departamento de Archipielago de San Andres",
              "Quindio Department",
            ],
            km: ["Grande Comore", "Moheli", "Ndzuwani"],
            cg: [
              "Commune de Brazzaville",
              "Cuvette",
              "Cuvette-Ouest",
              "Lekoumo",
              "Likouala",
              "Plateaux",
              "Pointe-Noire",
              "Pool",
              "Region de la Bouenza",
              "Region du Kouilo",
              "Region du Niari",
              "Sangha",
            ],
            ck: [
              "Aitutaki",
              "Ati",
              "Ma'uke",
              "Mangaia",
              "Manihiki",
              "Mitiaro",
              "Palmerston",
              "Penrhyn",
              "Pukapuka",
              "Rakahanga",
              "Rarotonga",
            ],
            cr: [
              "Provincia de Alajuela",
              "Provincia de Cartago",
              "Provincia de Guanacaste",
              "Provincia de Heredia",
              "Provincia de Limon",
              "Provincia de Puntarenas",
              "Provincia de San Jose",
            ],
            ci: [
              "Abidjan",
              "Bas-Sassandra",
              "Comoe",
              "Denguele",
              "Goh-Djiboua",
              "Lacs",
              "Lagunes",
              "Montagnes",
              "Sassandra-Marahoue",
              "Savanes",
              "Vallee du Bandama",
              "Woroba",
              "Yamoussoukro Autonomous District",
              "Zanzan",
            ],
            hr: [
              "Bjelovarsko-Bilogorska Zupanija",
              "Brodsko-Posavska Zupanija",
              "Dubrovacko-Neretvanska Zupanija",
              "Grad Zagreb",
              "Istarska Zupanija",
              "Karlovacka Zupanija",
              "Koprivnicko-Krizevacka Zupanija",
              "Krapinsko-Zagorska Zupanija",
              "Licko-Senjska Zupanija",
              "Megimurska Zupanija",
              "Osjecko-Baranjska Zupanija",
              "Pozesko-Slavonska Zupanija",
              "Primorsko-Goranska Zupanija",
              "Sibensko-Kninska Zupanija",
              "Sisacko-Moslavacka Zupanija",
              "Splitsko-Dalmatinska Zupanija",
              "Varazdinska Zupanija",
              "Viroviticko-Podravska Zupanija",
              "Vukovarsko-Srijemska Zupanija",
              "Zadarska Zupanija",
              "Zagreb County",
            ],
            cu: [
              "Artemisa",
              "La Habana",
              "Las Tunas",
              "Municipio Especial Isla de la Juventud",
              "Provincia de Camagueey",
              "Provincia de Ciego de Avila",
              "Provincia de Cienfuegos",
              "Provincia de Guantanamo",
              "Provincia de Holguin",
              "Provincia de Matanzas",
              "Provincia de Pinar del Rio",
              "Provincia de Sancti Spiritus",
              "Provincia de Santiago de Cuba",
              "Provincia de Villa Clara",
              "Provincia Granma",
              "Provincia Mayabeque",
            ],
            cy: [
              "Eparchia Ammochosto",
              "Eparchia Keryneias",
              "Eparchia Larnakas",
              "Eparchia Lefkosias",
              "Eparchia Lemeso",
              "Eparchia Pafo",
            ],
            cz: [
              "Hlavni mesto Praha",
              "Jihocesky kraj",
              "Jihomoravsky kraj",
              "Karlovarsky kraj",
              "Kraj Vysocina",
              "Kralovehradecky kraj",
              "Liberecky kraj",
              "Moravskoslezsky kraj",
              "Olomoucky kraj",
              "Pardubicky kraj",
              "Plzensky kraj",
              "Stredocesky kraj",
              "Ustecky kraj",
              "Zlinsky kraj",
            ],
            cd: [
              "Bas Uele",
              "Haut Uele",
              "Haut-Lomani",
              "Ituri",
              "Kasai District",
              "Kasai-Central",
              "Kinshasa City",
              "Kwango",
              "Kwil",
              "Lomami",
              "Lualaba",
              "Mai Ndombe",
              "Mongala",
              "Province de l'Equateur",
              "Province du Haut-Katanga",
              "Province du Kasai Oriental",
              "Province du Kongo Central",
              "Province du Maniema",
              "Province du Nord-Kiv",
              "Province du Nord-Ubangi",
              "Province du Sud-Ubangi",
              "Sankur",
              "South Kivu Province",
              "Tanganika",
              "Tshopo",
              "Tshuapa",
            ],
            dk: [
              "North Denmark Region",
              "Region Hovedstaden",
              "Region Midtjylland",
              "Region Sjaelland",
              "Region Syddanmark",
            ],
            dj: [
              "Ali Sabieh Region",
              "Arta Region",
              "Dikhil",
              "Djibouti Region",
              "Obock",
              "Tadjourah",
            ],
            dm: [
              "Saint Andrew",
              "Saint David",
              "Saint George",
              "Saint John",
              "Saint Joseph",
              "Saint Luke",
              "Saint Mark",
              "Saint Patrick",
              "Saint Paul",
              "Saint Peter",
            ],
            do: [
              "Distrito Nacional",
              "Provincia de Azua",
              "Provincia de Baoruco",
              "Provincia de Barahona",
              "Provincia de Dajabon",
              "Provincia de El Seibo",
              "Provincia de Elias Pina",
              "Provincia de Hato Mayor",
              "Provincia de Hermanas Mirabal",
              "Provincia de Independencia",
              "Provincia de La Altagracia",
              "Provincia de La Romana",
              "Provincia de La Vega",
              "Provincia de Monsenor Nouel",
              "Provincia de Monte Cristi",
              "Provincia de Monte Plata",
              "Provincia de Pedernales",
              "Provincia de Peravia",
              "Provincia de Puerto Plata",
              "Provincia de San Cristobal",
              "Provincia de San Jose de Ocoa",
              "Provincia de San Juan",
              "Provincia de San Pedro de Macoris",
              "Provincia de Santiago",
              "Provincia de Santiago Rodriguez",
              "Provincia de Santo Domingo",
              "Provincia de Valverde",
              "Provincia Duarte",
              "Provincia Espaillat",
              "Provincia Maria Trinidad Sanchez",
              "Provincia Sanchez Ramirez",
              "Samana Province",
            ],
            ec: [
              "Provincia de Bolivar",
              "Provincia de Cotopaxi",
              "Provincia de El Oro",
              "Provincia de Esmeraldas",
              "Provincia de Francisco de Orellana",
              "Provincia de Galapagos",
              "Provincia de Imbabura",
              "Provincia de Loja",
              "Provincia de Los Rios",
              "Provincia de Manabi",
              "Provincia de Morona-Santiago",
              "Provincia de Napo",
              "Provincia de Pichincha",
              "Provincia de Santa Elena",
              "Provincia de Santo Domingo de los Tsachilas",
              "Provincia de Sucumbios",
              "Provincia de Zamora-Chinchipe",
              "Provincia del Azuay",
              "Provincia del Canar",
              "Provincia del Carchi",
              "Provincia del Chimborazo",
              "Provincia del Guayas",
              "Provincia del Pastaza",
              "Provincia del Tungurahua",
            ],
            eg: [
              "As Suways",
              "Beheira Governorate",
              "Cairo Governorate",
              "Damietta Governorate",
              "Ismailia Governorate",
              "Kafr ash Shaykh",
              "Muhafazat ad Daqahliyah",
              "Muhafazat al Fayyum",
              "Muhafazat al Gharbiyah",
              "Muhafazat al Iskandariyah",
              "Muhafazat al Jizah",
              "Muhafazat al Minufiyah",
              "Muhafazat al Minya",
              "Muhafazat al Qalyubiyah",
              "Muhafazat al Uqsur",
              "Muhafazat al Wadi al Jadid",
              "Muhafazat ash Sharqiyah",
              "Muhafazat Aswan",
              "Muhafazat Asyut",
              "Muhafazat Bani Suwayf",
              "Muhafazat Bur Sa'id",
              "Muhafazat Matruh",
              "Muhafazat Qina",
              "Muhafazat Shamal Sina'",
              "Muhafazat Suhaj",
              "Red Sea Governorate",
              "South Sinai Governorate",
            ],
            sv: [
              "Departamento de Ahuachapan",
              "Departamento de Cabanas",
              "Departamento de Chalatenango",
              "Departamento de Cuscatlan",
              "Departamento de La Libertad",
              "Departamento de La Paz",
              "Departamento de La Union",
              "Departamento de Morazan",
              "Departamento de San Miguel",
              "Departamento de San Salvador",
              "Departamento de San Vicente",
              "Departamento de Santa Ana",
              "Departamento de Sonsonate",
              "Departamento de Usulutan",
            ],
            gq: [
              "Provincia de Annobon",
              "Provincia de Bioko Norte",
              "Provincia de Bioko Sur",
              "Provincia de Centro Sur",
              "Provincia de Kie-Ntem",
              "Provincia de Litoral",
              "Provincia de Wele-Nzas",
            ],
            er: [
              "Anseba Region",
              "Debub Region",
              "Gash-Barka Region",
              "Maekel Region",
              "Northern Red Sea Region",
              "Southern Red Sea Region",
            ],
            ee: [
              "Harjumaa",
              "Hiiumaa",
              "Ida-Virumaa",
              "Jarvamaa",
              "Jogevamaa",
              "Laane-Virumaa",
              "Laeaenemaa",
              "Paernumaa",
              "Polvamaa",
              "Raplamaa",
              "Saaremaa",
              "Tartumaa",
              "Valgamaa",
              "Viljandimaa",
              "Vorumaa",
            ],
            et: [
              "Adis Abeba Astedader",
              "Afar Region",
              "Amhara Region",
              "Benishangul-Gumuz Region",
              "Dire Dawa Region",
              "Gambela Region",
              "Harari Region",
              "Oromiya Region",
              "Somali Region",
              "Southern Nations, Nationalities, and People's Region",
              "Tigray Region",
            ],
            fk: [],
            fo: [
              "Eysturoyar sysla",
              "Nordoyar sysla",
              "Sandoyar Sysla",
              "Streymoyar Sysla",
              "Suduroyar sysla",
              "Vaga Sysla",
            ],
            fm: ["Chuuk", "Kosrae", "Pohnpei", "Yap"],
            fj: [
              "Central Division",
              "Eastern Division",
              "Northern Division",
              "Rotuma",
              "Western Division",
            ],
            fi: [
              "Etela-Pohjanmaa",
              "Etelae-Karjala",
              "Kainu",
              "Kanta-Haeme",
              "Keski-Pohjanmaa",
              "Keski-Suomi",
              "Kymenlaakso",
              "Lapland",
              "Paijanne-Tavastland",
              "Pirkanmaa",
              "Pohjanmaa",
              "Pohjois-Karjala",
              "Pohjois-Pohjanmaa",
              "Pohjois-Savo",
              "Satakunta",
              "Southern Savonia",
              "Uusimaa",
              "Varsinais-Suomi",
            ],
            fr: [
              "Auvergne-Rhone-Alpes",
              "Bourgogne-Franche-Comte",
              "Bretagne",
              "Centre-Val de Loire",
              "Corse",
              "Grand-Est",
              "Hauts-de-France",
              "Ile-de-France",
              "Normandy",
              "Nouvelle-Aquitaine",
              "Occitanie",
              "Pays de la Loire",
              "Provence-Alpes-Cote d'Azur",
            ],
            gf: ["Guyane"],
            pf: [
              "Iles Australes",
              "Iles du Vent",
              "Iles Marquises",
              "Iles Sous-le-Vent",
              "Iles Tuamotu-Gambier",
            ],
            tf: [
              "Archipel des Crozet",
              "Archipel des Kerguelen",
              "Iles Eparses de l'ocean Indien",
              "Iles Saint-Paul et Nouvelle-Amsterdam",
              "La Terre-Adelie",
            ],
            ga: [
              "Estuaire",
              "Province de l'Ogooue-Ivindo",
              "Province de l'Ogooue-Lolo",
              "Province de l'Ogooue-Maritime",
              "Province de la Ngounie",
              "Province de la Nyanga",
              "Province du Haut-Ogooue",
              "Province du Moyen-Ogooue",
              "Province du Woleu-Ntem",
            ],
            gm: [
              "Banjul",
              "Central River",
              "Lower River Division",
              "North Bank",
              "Upper River",
              "West Coast",
            ],
            ge: [
              "Abkhazia",
              "Ajaria",
              "Guria",
              "Imereti",
              "K'alak'i T'bilisi",
              "Kakheti",
              "Kvemo Kartli",
              "Mtskheta-Mtianeti",
              "Racha-Lechkhumi and Kvemo Svaneti",
              "Samegrelo-Zemo Svanetis Mkhare",
              "Samtskhe-Javakheti",
              "Shida Kartli",
            ],
            de: [
              "Baden-Wuerttemberg Region",
              "Bavaria",
              "Brandenburg",
              "Bremen",
              "Free and Hanseatic City of Hamburg",
              "Hessen",
              "Land Berlin",
              "Lower Saxony",
              "Mecklenburg-Western Pomerania",
              "Nordrhein-Westfalen",
              "Rheinland-Pfalz",
              "Saarland",
              "Saxony",
              "Saxony-Anhalt",
              "Schleswig-Holstein",
              "Thuringia",
            ],
            gh: [
              "Ashanti Region",
              "Brong-Ahafo Region",
              "Central Region",
              "Eastern Region",
              "Greater Accra Region",
              "Northern Region",
              "Upper East Region",
              "Upper West Region",
              "Volta Region",
              "Western Region",
            ],
            gi: [],
            gb: ["England", "Northern Ireland", "Scotland", "Wales"],
            gr: [
              "Attica",
              "Central Greece",
              "Central Macedonia",
              "Crete",
              "Eastern Macedonia and Thrace",
              "Epirus",
              "Ionian Islands",
              "Mount Athos",
              "North Aegean",
              "Peloponnese",
              "South Aegean",
              "Thessaly",
              "Western Greece",
              "Western Macedonia",
            ],
            gl: ["Kujalleq", "Qaasuitsup", "Qeqqata", "Sermersooq"],
            gd: [
              "Carriacou and Petite Martinique",
              "Saint Andrew",
              "Saint David",
              "Saint George",
              "Saint John",
              "Saint Mark",
              "Saint Patrick",
            ],
            gp: ["Guadeloupe"],
            gt: [
              "Departamento de Alta Verapaz",
              "Departamento de Baja Verapaz",
              "Departamento de Chimaltenango",
              "Departamento de Chiquimula",
              "Departamento de El Progreso",
              "Departamento de Escuintla",
              "Departamento de Guatemala",
              "Departamento de Huehuetenango",
              "Departamento de Izabal",
              "Departamento de Jalapa",
              "Departamento de Jutiapa",
              "Departamento de Quetzaltenango",
              "Departamento de Retalhule",
              "Departamento de Sacatepequez",
              "Departamento de San Marcos",
              "Departamento de Santa Rosa",
              "Departamento de Solola",
              "Departamento de Suchitepequez",
              "Departamento de Totonicapan",
              "Departamento de Zacapa",
              "Departamento del Peten",
              "Departamento del Quiche",
            ],
            gn: [
              "Boke Region",
              "Conakry Region",
              "Faranah Region",
              "Kankan Region",
              "Kindia Region",
              "Labe Region",
              "Mamou Region",
              "Nzerekore Region",
            ],
            gw: [
              "Bafata",
              "Biombo",
              "Bissau Region",
              "Bolama",
              "Cacheu Region",
              "Gab",
              "Oio Region",
              "Quinara",
              "Tombali",
            ],
            gy: [
              "Barima-Waini Region",
              "Cuyuni-Mazaruni Region",
              "Demerara-Mahaica Region",
              "East Berbice-Corentyne Region",
              "Essequibo Islands-West Demerara Region",
              "Mahaica-Berbice Region",
              "Pomeroon-Supenaam Region",
              "Potaro-Siparuni Region",
              "Upper Demerara-Berbice Region",
              "Upper Takutu-Upper Essequibo Region",
            ],
            ht: [
              "Centre",
              "Departement de l'Artibonite",
              "Departement de l'Ouest",
              "Departement de Nippes",
              "Departement du Nord-Est",
              "Grandans",
              "Nord",
              "Nord-Ouest",
              "Sud",
              "Sud-Est",
            ],
            hn: [
              "Departamento de Atlantida",
              "Departamento de Choluteca",
              "Departamento de Colon",
              "Departamento de Comayagua",
              "Departamento de Copan",
              "Departamento de Cortes",
              "Departamento de El Paraiso",
              "Departamento de Francisco Morazan",
              "Departamento de Gracias a Dios",
              "Departamento de Intibuca",
              "Departamento de Islas de la Bahia",
              "Departamento de La Paz",
              "Departamento de Lempira",
              "Departamento de Ocotepeque",
              "Departamento de Olancho",
              "Departamento de Santa Barbara",
              "Departamento de Valle",
              "Departamento de Yoro",
            ],
            hk: [
              "Central and Western District",
              "Eastern",
              "Islands District",
              "Kowloon City",
              "Kwai Tsing",
              "Kwun Tong",
              "North",
              "Sai Kung District",
              "Sha Tin",
              "Sham Shui Po",
              "Southern",
              "Tai Po District",
              "Tsuen Wan District",
              "Tuen Mun",
              "Wan Chai",
              "Wong Tai Sin",
              "Yau Tsim Mong",
              "Yuen Long District",
            ],
            hu: [
              "Bacs-Kiskun county",
              "Baranya county",
              "Bekes County",
              "Borsod-Abauj Zemplen county",
              "Budapest",
              "Csongrad megye",
              "Fejer megye",
              "Gyor-Moson-Sopron megye",
              "Hajdu-Bihar",
              "Heves megye",
              "Jasz-Nagykun-Szolnok",
              "Komarom-Esztergom",
              "Nograd megye",
              "Pest megye",
              "Somogy megye",
              "Szabolcs-Szatmar-Bereg",
              "Tolna megye",
              "Vas megye",
              "Veszprem megye",
              "Zala megye",
            ],
            is: [
              "Austurland",
              "Hoefudborgarsvaedi",
              "Nordurland Eystra",
              "Nordurland Vestra",
              "Sudurland",
              "Sudurnes",
              "Vestfirdir",
              "Vesturland",
            ],
            in: [
              "Andaman and Nicobar Islands",
              "Andhra Pradesh",
              "Arunachal Pradesh",
              "Assam",
              "Bihar",
              "Chandigarh",
              "Chhattisgarh",
              "Dadra and Nagar Haveli and Daman and Diu",
              "Delhi",
              "Gujarat",
              "Goa",
              "Haryana",
              "Himachal Pradesh",
              "Jammu and Kashmir",
              "Jharkhand",
              "Karnataka",
              "Kerala",
              "Ladhak",
              "Lakshadweep",
              "Madhya Pradesh",
              "Maharashtra",
              "Manipur",
              "Meghalaya",
              "Mizoram",
              "Nagaland",
              "Odisha",
              "Puducherry",
              "Punjab",
              "Rajasthan",
              "Sikkim",
              "Tamil Nadu",
              "Telangana",
              "Tripura",
              "Uttarakhand",
              "Uttar Pradesh",
              "West Bengal",
            ],
            id: [
              "Banten",
              "Daerah Istimewa Yogyakarta",
              "Daerah Khusus Ibukota Jakarta",
              "Jawa Barat",
              "Jawa Timur",
              "Kepulauan Bangka Belitung",
              "Nanggroe Aceh Darussalam Province",
              "North Kalimantan",
              "Propinsi Bengkul",
              "Provinsi Bali",
              "Provinsi Gorontalo",
              "Provinsi Jambi",
              "Provinsi Jawa Tengah",
              "Provinsi Kalimantan Barat",
              "Provinsi Kalimantan Selatan",
              "Provinsi Kalimantan Tengah",
              "Provinsi Kalimantan Timur",
              "Provinsi Kepulauan Ria",
              "Provinsi Lampung",
              "Provinsi Maluk",
              "Provinsi Maluku Utara",
              "Provinsi Nusa Tenggara Timur",
              "Provinsi Papua",
              "Provinsi Papua Barat",
              "Provinsi Ria",
              "Provinsi Sulawesi Barat",
              "Provinsi Sulawesi Selatan",
              "Provinsi Sumatera Barat",
              "Sulawesi Tengah",
              "Sulawesi Tenggara",
              "Sulawesi Utara",
              "Sumatera Selatan",
              "Sumatera Utara",
              "West Nusa Tenggara",
            ],
            ir: [
              "Alborz",
              "Bushehr",
              "East Azerbaijan",
              "Fars",
              "Hormozgan",
              "Isfahan",
              "Kerman",
              "Khuzestan",
              "Ostan-e Ardabil",
              "Ostan-e Azarbayjan-e Gharbi",
              "Ostan-e Chahar Mahal va Bakhtiari",
              "Ostan-e Gilan",
              "Ostan-e Golestan",
              "Ostan-e Hamadan",
              "Ostan-e Ilam",
              "Ostan-e Kermanshah",
              "Ostan-e Khorasan-e Jonubi",
              "Ostan-e Khorasan-e Razavi",
              "Ostan-e Khorasan-e Shomali",
              "Ostan-e Kohgiluyeh va Bowyer Ahmad",
              "Ostan-e Kordestan",
              "Ostan-e Lorestan",
              "Ostan-e Markazi",
              "Ostan-e Mazandaran",
              "Ostan-e Qazvin",
              "Ostan-e Semnan",
              "Ostan-e Tehran",
              "Ostan-e Zanjan",
              "Qom",
              "Sistan and Baluchestan",
              "Yazd",
            ],
            iq: [
              "An Najaf",
              "Dihok",
              "Diyala",
              "Muhafazat al Anbar",
              "Muhafazat al Basrah",
              "Muhafazat al Muthanna",
              "Muhafazat al Qadisiyah",
              "Muhafazat Arbil",
              "Muhafazat as Sulaymaniyah",
              "Muhafazat Babil",
              "Muhafazat Baghdad",
              "Muhafazat Dhi Qar",
              "Muhafazat Karbala'",
              "Muhafazat Kirkuk",
              "Muhafazat Maysan",
              "Muhafazat Ninawa",
              "Muhafazat Salah ad Din",
              "Muhafazat Wasit",
            ],
            ie: ["Connaught", "Leinster", "Munster", "Ulster"],
            il: [
              "Central District",
              "Haifa",
              "Jerusalem",
              "Northern District",
              "Southern District",
              "Tel Aviv District",
            ],
            it: [
              "Abruzzo",
              "Basilicata",
              "Calabria",
              "Campania",
              "Emilia-Romagna",
              "Friuli Venezia Giulia",
              "Lazio",
              "Liguria",
              "Lombardia",
              "Marche",
              "Molise",
              "Piemonte",
              "Puglia",
              "Regione Autonoma Valle d'Aosta",
              "Sardegna",
              "Sicilia",
              "Toscana",
              "Trentino-Alto Adige",
              "Umbria",
              "Veneto",
            ],
            jm: [
              "Clarendon",
              "Kingston",
              "Manchester",
              "Parish of Hanover",
              "Parish of Saint Ann",
              "Portland",
              "Saint Andrew",
              "Saint Catherine",
              "Saint Elizabeth",
              "Saint James",
              "Saint Mary",
              "Saint Thomas",
              "Trelawny",
              "Westmoreland",
            ],
            jp: [
              "Aichi-ken",
              "Akita",
              "Aomori-ken",
              "Chiba-ken",
              "Ehime",
              "Fukui",
              "Fukuoka Prefecture",
              "Fukushima-ken",
              "Gif",
              "Gunma-ken",
              "Hiroshima-ken",
              "Hokkaido",
              "Hyogo",
              "Ibaraki",
              "Ishikawa-ken",
              "Iwate",
              "Kagawa-ken",
              "Kagoshima-ken",
              "Kanagawa",
              "Kochi Prefecture",
              "Kumamoto",
              "Kyoto Prefecture",
              "Mie-ken",
              "Miyagi-ken",
              "Miyazaki",
              "Nagano-ken",
              "Nagasaki Prefecture",
              "Nara-ken",
              "Niigata-ken",
              "Oita Prefecture",
              "Okayama-ken",
              "Okinawa",
              "Osaka-f",
              "Saga-ken",
              "Saitama-ken",
              "Shiga",
              "Shimane-ken",
              "Shizuoka",
              "Tochigi",
              "Tokushima-ken",
              "Tokyo Prefecture",
              "Tottori",
              "Toyama-ken",
              "Wakayama",
              "Yamagata-ken",
              "Yamaguchi",
              "Yamanashi",
            ],
            jo: [
              "Ajloun",
              "Al Karak",
              "Al Mafraq",
              "Amman Governorate",
              "Irbid",
              "Jerash",
              "Muhafazat al 'Aqabah",
              "Muhafazat al Balqa'",
              "Muhafazat at Tafilah",
              "Muhafazat az Zarqa'",
              "Muhafazat Ma'an",
              "Muhafazat Madaba",
            ],
            kz: [
              "Aktyubinskaya Oblast'",
              "Almaty Oblysy",
              "Almaty Qalasy",
              "Aqmola Oblysy",
              "Astana Qalasy",
              "Atyrau Oblysy",
              "Baikonur",
              "East Kazakhstan",
              "Mangistauskaya Oblast'",
              "North Kazakhstan",
              "Pavlodar Oblysy",
              "Qaraghandy Oblysy",
              "Qostanay Oblysy",
              "Qyzylorda Oblysy",
              "South Kazakhstan",
              "West Kazakhstan",
              "Zhambyl Oblysy",
            ],
            ke: [
              "Baringo District",
              "Bomet District",
              "Bungoma District",
              "Busia District",
              "Embu District",
              "Garissa District",
              "Homa Bay District",
              "Isiolo District",
              "Kajiado District",
              "Kakamega District",
              "Kericho District",
              "Kiambu District",
              "Kilifi District",
              "Kirinyaga District",
              "Kisii District",
              "Kisum",
              "Kitui District",
              "Kwale District",
              "Laikipia District",
              "Lam",
              "Machakos District",
              "Makueni District",
              "Mandera District",
              "Marakwet District",
              "Marsabit District",
              "Mer",
              "Migori District",
              "Mombasa District",
              "Murang'a District",
              "Nairobi Province",
              "Nakuru District",
              "Nandi South District",
              "Narok District",
              "Nyamira District",
              "Nyandarua District",
              "Nyeri District",
              "Samburu District",
              "Siaya District",
              "Taita Taveta District",
              "Tana River District",
              "Tharaka District",
              "Trans Nzoia District",
              "Turkana District",
              "Uasin Gish",
              "Vihiga District",
              "Wajir District",
              "West Pokot District",
            ],
            ki: ["Gilbert Islands", "Line Islands", "Phoenix Islands"],
            kp: [
              "Chagang-do",
              "Hambuk",
              "Hamnam",
              "Hwanghae-bukto",
              "Hwanghae-namdo",
              "Kangwon-do",
              "P'yongan-bukto",
              "P'yongan-namdo",
              "Pyongyang",
              "Rason",
              "Ryanggang",
            ],
            kr: [
              "Busan",
              "Chungcheongbuk-do",
              "Chungcheongnam-do",
              "Daeg",
              "Daejeon",
              "Gangwon-do",
              "Gwangj",
              "Gyeonggi-do",
              "Gyeongsangbuk-do",
              "Gyeongsangnam-do",
              "Incheon",
              "Jeju-do",
              "Jeollabuk-do",
              "Jeollanam-do",
              "Sejong-si",
              "Seoul",
              "Ulsan",
            ],
            kw: [
              "Al Asimah Governorate",
              "Muhafazat al Ahmadi",
              "Muhafazat al Farwaniyah",
              "Muhafazat al Jahra'",
              "Muhafazat Hawalli",
              "Muhafazat Mubarak al Kabir",
            ],
            kg: [
              "Batken",
              "Chuyskaya Oblast'",
              "Gorod Bishkek",
              "Issyk-Kul Region",
              "Jalal-Abad oblast",
              "Naryn oblast",
              "Osh City",
              "Osh Oblasty",
              "Talas",
            ],
            la: [
              "Attap",
              "Bolikhamxai",
              "Champasak",
              "Houaphan",
              "Khammouan",
              "Khoueng Bokeo",
              "Khoueng Oudomxai",
              "Khoueng Phongsali",
              "Khoueng Savannakhet",
              "Khoueng Xekong",
              "Louangnamtha",
              "Luang Prabang Province",
              "Salavan",
              "Vientiane Prefecture",
              "Vientiane Province",
              "Xaignabouli",
              "Xaisomboun Province",
              "Xiangkhouang",
            ],
            lv: [
              "Adazu Novads",
              "Aglonas Novads",
              "Aizkraukles Rajons",
              "Aizputes Novads",
              "Aknistes Novads",
              "Alojas Novads",
              "Alsungas Novads",
              "Aluksnes Novads",
              "Amatas Novads",
              "Apes Novads",
              "Auces Novads",
              "Babites Novads",
              "Baldones Novads",
              "Baltinavas Novads",
              "Balvu Novads",
              "Bauskas Novads",
              "Beverinas Novads",
              "Brocenu Novads",
              "Burtnieku Novads",
              "Carnikavas Novads",
              "Cesu Novads",
              "Cesvaines Novads",
              "Ciblas Novads",
              "Dagdas Novads",
              "Daugavpils",
              "Daugavpils municipality",
              "Dobeles Rajons",
              "Dundagas Novads",
              "Durbes Novads",
              "Engures Novads",
              "Erglu Novads",
              "Garkalne Municipality",
              "Grobinas Novads",
              "Gulbenes Rajons",
              "Iecavas Novads",
              "Ikskiles Novads",
              "Ilukstes Novads",
              "Incukalna Novads",
              "Jaunjelgavas Novads",
              "Jaunpiebalgas Novads",
              "Jaunpils Novads",
              "Jekabpils",
              "Jekabpils Municipality",
              "Jelgava",
              "Jelgavas Rajons",
              "Jurmala",
              "Kandavas Novads",
              "Karsavas Novads",
              "Keguma Novads",
              "Kekavas Novads",
              "Kocenu Novads",
              "Kokneses Novads",
              "Kraslavas Rajons",
              "Krimuldas Novads",
              "Krustpils Novads",
              "Kuldigas Rajons",
              "Lielvardes Novads",
              "Liepaja",
              "Ligatnes Novads",
              "Limbazu Rajons",
              "Livanu Novads",
              "Lubanas Novads",
              "Ludzas Rajons",
              "Madona Municipality",
              "Malpils Novads",
              "Marupes Novads",
              "Mazsalacas Novads",
              "Mersraga Novads",
              "Nauksenu Novads",
              "Neretas Novads",
              "Nicas Novads",
              "Ogres novads",
              "Olaines Novads",
              "Ozolnieku Novads",
              "Pargaujas Novads",
              "Pavilostas Novads",
              "Plavinu Novads",
              "Preili Municipality",
              "Priekules Novads",
              "Priekuli Municipality",
              "Raunas Novads",
              "Rezekne",
              "Rezeknes Novads",
              "Riebinu Novads",
              "Riga",
              "Rojas Novads",
              "Ropazu Novads",
              "Rucavas Novads",
              "Rugaju Novads",
              "Rujienas Novads",
              "Rundales Novads",
              "Salacgrivas Novads",
              "Salas Novads",
              "Salaspils Novads",
              "Saldus Municipality",
              "Saulkrastu Novads",
              "Sejas Novads",
              "Siguldas Novads",
              "Skriveru Novads",
              "Skrundas Novads",
              "Smiltenes Novads",
              "Stopinu Novads",
              "Strencu Novads",
              "Talsi Municipality",
              "Tervetes Novads",
              "Tukuma Rajons",
              "Vainodes Novads",
              "Valka Municipality",
              "Valmiera District",
              "Varaklanu Novads",
              "Varkavas Novads",
              "Vecpiebalgas Novads",
              "Vecumnieku Novads",
              "Ventspils",
              "Ventspils Municipality",
              "Viesites Novads",
              "Vilakas Novads",
              "Vilanu Novads",
              "Zilupes Novads",
            ],
            lb: [
              "Beyrouth",
              "Mohafazat Aakkar",
              "Mohafazat Baalbek-Hermel",
              "Mohafazat Beqaa",
              "Mohafazat Liban-Nord",
              "Mohafazat Liban-Sud",
              "Mohafazat Mont-Liban",
              "Mohafazat Nabatiye",
            ],
            ls: [
              "Berea",
              "Butha-Buthe",
              "Leribe District",
              "Mafeteng District",
              "Maser",
              "Mohale's Hoek District",
              "Mokhotlong",
              "Qacha's Nek",
              "Quthing",
              "Thaba-Tseka",
            ],
            lr: [
              "Bomi County",
              "Bong County",
              "Gbarpolu County",
              "Grand Bassa County",
              "Grand Cape Mount County",
              "Grand Gedeh County",
              "Grand Kru County",
              "Lofa County",
              "Margibi County",
              "Maryland County",
              "Montserrado County",
              "Nimba County",
              "River Cess County",
              "River Gee County",
              "Sinoe County",
            ],
            ly: [
              "Al Jufrah",
              "Al Kufrah",
              "Al Marj",
              "Al Marqab",
              "Darnah",
              "Jabal al Gharbi District",
              "Murzuq",
              "Sha`biyat Nalut",
              "Sha'biyat al Butnan",
              "Sha'biyat al Jabal al Akhdar",
              "Sha'biyat al Jafarah",
              "Sha'biyat al Wahat",
              "Sha'biyat an Nuqat al Khams",
              "Sha'biyat az Zawiyah",
              "Sha'biyat Banghazi",
              "Sha'biyat Ghat",
              "Sha'biyat Misratah",
              "Sha'biyat Sabha",
              "Sha'biyat Wadi al Hayat",
              "Sha'biyat Wadi ash Shati'",
              "Surt",
              "Tripoli",
            ],
            li: [
              "Balzers",
              "Eschen",
              "Gamprin",
              "Mauren",
              "Planken",
              "Ruggell",
              "Schaan",
              "Schellenberg",
              "Triesen",
              "Triesenberg",
              "Vaduz",
            ],
            lt: [
              "Alytus County",
              "Kaunas County",
              "Klaipeda County",
              "Marijampole County",
              "Panevezys",
              "Siauliai County",
              "Taurage County",
              "Telsiu apskritis",
              "Utena County",
              "Vilniaus apskritis",
            ],
            lu: [
              "Canton d'Echternach",
              "Canton d'Esch-sur-Alzette",
              "Capellen",
              "Clervaux",
              "Diekirch",
              "Grevenmacher",
              "Luxembourg",
              "Mersch",
              "Redange",
              "Remich",
              "Vianden",
              "Wiltz",
            ],
            mo: [],
            mk: [
              "Aerodrom",
              "Berovo",
              "Bitola",
              "Bogdanci",
              "Bogovinje",
              "Bosilovo",
              "Brvenica",
              "Butel",
              "Cair",
              "Cesinovo-Oblesevo",
              "Debar",
              "Debarca",
              "Demir Hisar",
              "Demir Kapija",
              "Dolneni",
              "Drugovo",
              "Gazi Baba",
              "Gevgelija",
              "Gostivar",
              "Grad Skopje",
              "Gradsko",
              "Ilinden",
              "Jegunovce",
              "Karbinci",
              "Kavadarci",
              "Kisela Voda",
              "Kratovo",
              "Kriva Palanka",
              "Kumanovo",
              "Lozovo",
              "Makedonska Kamenica",
              "Makedonski Brod",
              "Mogila",
              "Negotino",
              "Novaci",
              "Novo Selo",
              "Ohrid",
              "Opstina Aracinovo",
              "Opstina Caska",
              "Opstina Centar",
              "Opstina Centar Zupa",
              "Opstina Cucer-Sandevo",
              "Opstina Delcevo",
              "Opstina Dojran",
              "Opstina Gjorce Petrov",
              "Opstina Karpos",
              "Opstina Kicevo",
              "Opstina Kocani",
              "Opstina Konce",
              "Opstina Krivogastani",
              "Opstina Krusevo",
              "Opstina Lipkovo",
              "Opstina Mavrovo i Rostusa",
              "Opstina Pehcevo",
              "Opstina Probistip",
              "Opstina Radovis",
              "Opstina Rankovce",
              "Opstina Sopiste",
              "Opstina Staro Nagoricane",
              "Opstina Stip",
              "Opstina Studenicani",
              "Opstina Vevcani",
              "Opstina Vranestica",
              "Opstina Vrapciste",
              "Opstina Zelino",
              "Oslomej",
              "Petrovec",
              "Plasnica",
              "Prilep",
              "Resen",
              "Rosoman",
              "Saraj",
              "Struga",
              "Strumica",
              "Suto Orizari",
              "Sveti Nikole",
              "Tearce",
              "Tetovo",
              "Valandovo",
              "Vasilevo",
              "Veles",
              "Vinica",
              "Zajas",
              "Zelenikovo",
              "Zrnovci",
            ],
            mg: [
              "Alaotra Mangoro Region",
              "Amoron'i Mania Region",
              "Analamanga Region",
              "Analanjirofo Region",
              "Androy Region",
              "Anosy Region",
              "Atsimo-Andrefana Region",
              "Atsimo-Atsinanana Region",
              "Atsinanana Region",
              "Betsiboka Region",
              "Boeny Region",
              "Bongolava Region",
              "Diana Region",
              "Haute Matsiatra Region",
              "Ihorombe Region",
              "Itasy Region",
              "Melaky Region",
              "Menabe Region",
              "Sava Region",
              "Sofia Region",
              "Vakinankaratra Region",
              "Vatovavy Fitovinany Region",
            ],
            mw: ["Central Region", "Northern Region", "Southern Region"],
            my: [
              "Johor",
              "Kedah",
              "Kelantan",
              "Kuala Lumpur",
              "Labuan",
              "Melaka",
              "Negeri Sembilan",
              "Pahang",
              "Perak",
              "Perlis",
              "Pulau Pinang",
              "Putrajaya",
              "Sabah",
              "Sarawak",
              "Selangor",
              "Terenggan",
            ],
            mv: [
              "Alifu Atholh",
              "Baa Atholh",
              "Dhaalu Atholh",
              "Faafu Atholh",
              "Gaafu Alifu Atholh",
              "Gaafu Dhaalu Atholh",
              "Gnaviyani Atholh",
              "Haa Alifu Atholh",
              "Haa Dhaalu Atholh",
              "Kaafu Atoll",
              "Laamu Atholh",
              "Lhaviyani Atholh",
              "Meemu Atholh",
              "Noonu Atoll",
              "Raa Atholh",
              "Seenu Atholh",
              "Shaviyani Atholh",
              "Southern Ari Atoll",
              "Thaa Atholh",
              "Vaavu Atholh",
            ],
            ml: [
              "Bamako Region",
              "Gao Region",
              "Kayes Region",
              "Kidal Region",
              "Koulikoro Region",
              "Mopti Region",
              "Segou Region",
              "Sikasso Region",
              "Tombouctou Region",
            ],
            mt: [
              "Attard",
              "Balzan",
              "Birkirkara",
              "Birzebbuga",
              "Bormla",
              "Dingli",
              "Ghajnsielem",
              "Hal Gharghur",
              "Hal Ghaxaq",
              "Haz-Zabbar",
              "Haz-Zebbug",
              "Il-Belt Valletta",
              "Il-Birg",
              "Il-Fgura",
              "Il-Fontana",
              "Il-Furjana",
              "Il-Gudja",
              "Il-Gzira",
              "Il-Hamrun",
              "Il-Kalkara",
              "Il-Marsa",
              "Il-Mellieha",
              "Il-Mosta",
              "Il-Munxar",
              "Il-Qala",
              "Il-Qrendi",
              "In-Nadur",
              "In-Naxxar",
              "Ir-Rabat",
              "Is-Siggiewi",
              "Is-Swieqi",
              "Ix-Xaghra",
              "Ix-Xewkija",
              "Ix-Xghajra",
              "Iz-Zebbug",
              "Iz-Zejtun",
              "Iz-Zurrieq",
              "Kirkop",
              "L-Gharb",
              "L-Ghasri",
              "L-Iklin",
              "L-Imdina",
              "L-Imgarr",
              "L-Imqabba",
              "L-Imsida",
              "L-Imtarfa",
              "L-Isla",
              "Lija",
              "Luqa",
              "Marsaskala",
              "Marsaxlokk",
              "Paola",
              "Pembroke",
              "Qormi",
              "Safi",
              "Saint John",
              "Saint Julian's",
              "Saint Lawrence",
              "Saint Lucia",
              "Saint Paul's Bay",
              "Saint Venera",
              "Sannat",
              "Ta' Kercem",
              "Ta' Xbiex",
              "Tal-Pieta",
              "Tarxien",
              "Tas-Sliema",
              "Victoria",
            ],
            mh: [
              "Ailinginae Atoll",
              "Ailinglaplap Atoll",
              "Ailuk Atoll",
              "Arno Atoll",
              "Aur Atoll",
              "Bikar Atoll",
              "Bikini Atoll",
              "Bokak Atoll",
              "Ebon Atoll",
              "Enewetak Atoll",
              "Erikub Atoll",
              "Jabat Island",
              "Jaluit Atoll",
              "Jemo Island",
              "Kili Island",
              "Kwajalein Atoll",
              "Lae Atoll",
              "Lib Island",
              "Likiep Atoll",
              "Majuro Atoll",
              "Maloelap Atoll",
              "Mejit Island",
              "Mili Atoll",
              "Namdrik Atoll",
              "Namu Atoll",
              "Rongelap Atoll",
              "Rongrik Atoll",
              "Taka Atoll",
              "Ujae Atoll",
              "Ujelang Atoll",
              "Utrik Atoll",
              "Wotho Atoll",
              "Wotje Atoll",
            ],
            mq: ["Martinique"],
            mr: [
              "Adrar",
              "Assaba",
              "Brakna",
              "Dakhlet Nouadhibo",
              "Gorgol",
              "Guidimaka",
              "Hodh ech Chargui",
              "Hodh El Gharbi",
              "Inchiri",
              "Nouakchott Nord",
              "Nouakchott Ouest",
              "Nouakchott Sud",
              "Tagant",
              "Tiris Zemmour",
              "Wilaya du Trarza",
            ],
            mu: [
              "Agalega Islands",
              "Black River District",
              "Cargados Carajos",
              "Flacq District",
              "Grand Port District",
              "Moka District",
              "Pamplemousses District",
              "Plaines Wilhems District",
              "Port Louis District",
              "Riviere du Rempart District",
              "Rodrigues",
              "Savanne District",
            ],
            yt: [
              "Acoua",
              "Bandraboua",
              "Bandrele",
              "Boueni",
              "Chiconi",
              "Chirongui",
              "Dembeni",
              "Dzaoudzi",
              "Kani-Keli",
              "Koungo",
              "M'Tsangamouji",
              "Mamoudzo",
              "Mtsamboro",
              "Ouangani",
              "Pamandzi",
              "Sada",
              "Tsingoni",
            ],
            mx: [
              "Ciudad de Mexico",
              "Estado de Aguascalientes",
              "Estado de Baja California",
              "Estado de Baja California Sur",
              "Estado de Campeche",
              "Estado de Chiapas",
              "Estado de Chihuahua",
              "Estado de Coahuila de Zaragoza",
              "Estado de Colima",
              "Estado de Durango",
              "Estado de Guanajuato",
              "Estado de Guerrero",
              "Estado de Hidalgo",
              "Estado de Jalisco",
              "Estado de Mexico",
              "Estado de Michoacan de Ocampo",
              "Estado de Morelos",
              "Estado de Nayarit",
              "Estado de Nuevo Leon",
              "Estado de Oaxaca",
              "Estado de Puebla",
              "Estado de Queretaro",
              "Estado de Quintana Roo",
              "Estado de San Luis Potosi",
              "Estado de Sinaloa",
              "Estado de Sonora",
              "Estado de Tabasco",
              "Estado de Tamaulipas",
              "Estado de Tlaxcala",
              "Estado de Veracruz-Llave",
              "Estado de Yucatan",
              "Estado de Zacatecas",
            ],
            md: [
              "Anenii Noi",
              "Basarabeasca",
              "Briceni",
              "Cantemir",
              "Cimislia",
              "Criuleni",
              "Donduseni",
              "Falesti",
              "Floresti",
              "Gagauzia",
              "Glodeni",
              "Hincesti",
              "Ialoveni",
              "Leova",
              "Municipiul Balti",
              "Municipiul Bender",
              "Municipiul Chisina",
              "Nisporeni",
              "Orhei",
              "Raionul Cahul",
              "Raionul Calarasi",
              "Raionul Causeni",
              "Raionul Drochia",
              "Raionul Dubasari",
              "Raionul Edinet",
              "Raionul Ocnita",
              "Raionul Soroca",
              "Raionul Stefan Voda",
              "Raionul Straseni",
              "Raionul Ungheni",
              "Rezina",
              "Riscani",
              "Singerei",
              "Soldanesti",
              "Taraclia",
              "Telenesti",
              "Unitatea Teritoriala din Stinga Nistrului",
            ],
            mc: ["Commune de Monaco"],
            mn: [
              "Arhangay Aymag",
              "Bayan-OElgiy Aymag",
              "Bayanhongor Aymag",
              "Bulgan",
              "Darhan-Uul Aymag",
              "Dornod Aymag",
              "Dornogovi Aymag",
              "Dundgovi Aymag",
              "Dzavhan Aymag",
              "Govi-Altay Aymag",
              "Govi-Sumber",
              "Hentiy Aymag",
              "Hovd",
              "Hovsgol Aymag",
              "OEmnoegovi Province",
              "OEvoerhangay Aymag",
              "Orhon Aymag",
              "Selenge Aymag",
              "Suhbaatar Aymag",
              "Tov Aymag",
              "Ulaanbaatar Hot",
              "Uvs Aymag",
            ],
            ms: [
              "Parish of Saint Anthony",
              "Parish of Saint Georges",
              "Parish of Saint Peter",
            ],
            ma: [
              "Beni Mellal-Khenifra",
              "Casablanca-Settat",
              "Dakhla-Oued Ed-Dahab",
              "Draa-Tafilalet",
              "Fes-Meknes",
              "Guelmim-Oued Noun",
              "Laayoune-Sakia El Hamra",
              "Marrakesh-Safi",
              "Oriental",
              "Rabat-Sale-Kenitra",
              "Souss-Massa",
              "Tanger-Tetouan-Al Hoceima",
            ],
            mz: [
              "Cabo Delgado Province",
              "Cidade de Maputo",
              "Gaza Province",
              "Inhambane Province",
              "Manica Province",
              "Maputo Province",
              "Nampula",
              "Niassa Province",
              "Provincia de Zambezia",
              "Sofala Province",
              "Tete",
            ],
            mm: [
              "Ayeyawady Region",
              "Bago Region",
              "Chin State",
              "Kachin State",
              "Kayah State",
              "Kayin State",
              "Magway Region",
              "Mandalay Region",
              "Mon State",
              "Nay Pyi Taw",
              "Rakhine State",
              "Sagaing Region",
              "Shan State",
              "Taninthayi Region",
              "Yangon Region",
            ],
            na: [
              "Erongo",
              "Hardap",
              "Karas",
              "Kavango East Region",
              "Kavango West Region",
              "Khomas",
              "Kunene",
              "Ohangwena",
              "Omaheke",
              "Omusati",
              "Oshana",
              "Oshikoto",
              "Otjozondjupa",
              "Zambezi Region",
            ],
            nr: [
              "Aiwo District",
              "Anabar District",
              "Anetan District",
              "Anibare District",
              "Baiti District",
              "Boe District",
              "Buada District",
              "Denigomodu District",
              "Ewa District",
              "Ijuw District",
              "Meneng District",
              "Nibok District",
              "Uaboe District",
              "Yaren",
            ],
            np: [
              "Madhya Pashchimanchal",
              "Madhyamanchal",
              "Pashchimanchal",
              "Patheka",
              "Purwanchal",
              "Sudur Pashchimanchal",
            ],
            nl: [
              "Provincie Drenthe",
              "Provincie Flevoland",
              "Provincie Friesland",
              "Provincie Gelderland",
              "Provincie Groningen",
              "Provincie Limburg",
              "Provincie Noord-Brabant",
              "Provincie Noord-Holland",
              "Provincie Overijssel",
              "Provincie Utrecht",
              "Provincie Zeeland",
              "Provincie Zuid-Holland",
            ],
            an: [],
            nc: ["Province des iles Loyaute", "Province Nord", "Province Sud"],
            nz: [
              "Auckland",
              "Bay of Plenty",
              "Canterbury",
              "Chatham Islands",
              "Gisborne",
              "Hawke's Bay",
              "Manawatu-Wanganui",
              "Marlborough",
              "Nelson",
              "Northland",
              "Otago",
              "Southland",
              "Taranaki",
              "Tasman",
              "Waikato",
              "Wellington",
              "West Coast",
            ],
            ni: [
              "Costa Caribe Sur",
              "Departamento de Boaco",
              "Departamento de Carazo",
              "Departamento de Chinandega",
              "Departamento de Chontales",
              "Departamento de Esteli",
              "Departamento de Granada",
              "Departamento de Jinotega",
              "Departamento de Leon",
              "Departamento de Madriz",
              "Departamento de Managua",
              "Departamento de Masaya",
              "Departamento de Matagalpa",
              "Departamento de Nueva Segovia",
              "Departamento de Rio San Juan",
              "Departamento de Rivas",
              "North Atlantic Autonomous Region (RAAN)",
            ],
            ne: [
              "Agadez",
              "Diffa",
              "Dosso Region",
              "Maradi",
              "Niamey",
              "Tahoua",
              "Tillaberi Region",
              "Zinder",
            ],
            ng: [
              "Abia State",
              "Adamawa State",
              "Akwa Ibom State",
              "Anambra State",
              "Bauchi State",
              "Bayelsa State",
              "Benue State",
              "Borno State",
              "Cross River State",
              "Delta State",
              "Ebonyi State",
              "Edo",
              "Ekiti State",
              "Enugu State",
              "Federal Capital Territory",
              "Gombe State",
              "Imo State",
              "Jigawa State",
              "Kaduna State",
              "Kano State",
              "Katsina State",
              "Kebbi State",
              "Kogi State",
              "Kwara State",
              "Lagos State",
              "Nasarawa State",
              "Niger State",
              "Ogun State",
              "Ondo State",
              "Osun State",
              "Oyo State",
              "Plateau State",
              "Rivers State",
              "Sokoto State",
              "Taraba State",
              "Yobe State",
              "Zamfara State",
            ],
            nu: [],
            nf: [],
            mp: [
              "Northern Islands Municipality",
              "Rota Municipality",
              "Saipan Municipality",
              "Tinian Municipality",
            ],
            no: [
              "Akershus fylke",
              "Aust-Agder fylke",
              "Buskerud fylke",
              "Finnmark Fylke",
              "Hedmark fylke",
              "Hordaland Fylke",
              "More og Romsdal fylke",
              "Nord-Trondelag Fylke",
              "Nordland Fylke",
              "Oppland fylke",
              "Oslo County",
              "Ostfold fylke",
              "Rogaland Fylke",
              "Sogn og Fjordane Fylke",
              "Sor-Trondelag Fylke",
              "Telemark fylke",
              "Troms Fylke",
              "Vest-Agder Fylke",
              "Vestfold fylke",
            ],
            gg: [
              "Alderney",
              "Castel",
              "Forest",
              "Saint Andrew",
              "Saint Martin",
              "Saint Peter Port",
              "Saint Pierre du Bois",
              "Saint Sampson",
              "Saint Saviour",
              "Torteval",
              "Vale",
            ],
            om: [
              "Al Batinah North Governorate",
              "Al Batinah South Governorate",
              "Ash Sharqiyah South",
              "Az Zahirah",
              "Muhafazat ad Dakhiliyah",
              "Muhafazat al Buraymi",
              "Muhafazat al Wusta",
              "Muhafazat Masqat",
              "Muhafazat Shamal ash Sharqiyah",
              "Muhafazat Zufar",
              "Musandam",
            ],
            pk: [
              "Azad Kashmir",
              "Balochistan",
              "Federally Administered Tribal Areas",
              "Gilgit-Baltistan",
              "Islamabad",
              "Khyber Pakhtunkhwa Province",
              "Punjab Province",
              "Sindh",
            ],
            pw: [
              "Aimeliik",
              "Airai",
              "Angaur",
              "Hatohobei",
              "Kayangel",
              "Koror",
              "Melekeok",
              "Ngaraard",
              "Ngarchelong",
              "Ngardma",
              "Ngatpang",
              "Ngchesar",
              "Ngeremlengui",
              "Ngiwal",
              "Peleli",
              "Sonsorol",
            ],
            ps: ["Gaza Strip", "West Bank"],
            pa: [
              "Embera-Wounaan",
              "Guna Yala",
              "Ngoebe-Bugle",
              "Panama Oeste",
              "Provincia de Bocas del Toro",
              "Provincia de Chiriqui",
              "Provincia de Cocle",
              "Provincia de Colon",
              "Provincia de Herrera",
              "Provincia de Los Santos",
              "Provincia de Panama",
              "Provincia de Veraguas",
              "Provincia del Darien",
            ],
            pg: [
              "Bougainville",
              "Central Province",
              "Chimbu Province",
              "East New Britain Province",
              "East Sepik Province",
              "Eastern Highlands Province",
              "Enga Province",
              "Gulf Province",
              "Hela",
              "Jiwaka",
              "Madang Province",
              "Manus Province",
              "Milne Bay Province",
              "Morobe Province",
              "National Capital District",
              "New Ireland Province",
              "Northern Province",
              "Southern Highlands Province",
              "West New Britain Province",
              "West Sepik Province",
              "Western Highlands Province",
              "Western Province",
            ],
            py: [
              "Asuncion",
              "Departamento Central",
              "Departamento de Alto Paraguay",
              "Departamento de Boqueron",
              "Departamento de Caaguaz",
              "Departamento de Caazapa",
              "Departamento de Canindey",
              "Departamento de Concepcion",
              "Departamento de Itapua",
              "Departamento de la Cordillera",
              "Departamento de Misiones",
              "Departamento de Neembuc",
              "Departamento de Paraguari",
              "Departamento de Presidente Hayes",
              "Departamento de San Pedro",
              "Departamento del Alto Parana",
              "Departamento del Amambay",
              "Departamento del Guaira",
            ],
            pe: [
              "Amazonas",
              "Ancash",
              "Apurimac",
              "Arequipa",
              "Ayacucho",
              "Cajamarca",
              "Callao",
              "Cusco",
              "Departamento de Moquegua",
              "Huancavelica",
              "Ica",
              "Junin",
              "La Libertad",
              "Lambayeque",
              "Lima",
              "Loreto",
              "Madre de Dios",
              "Pasco",
              "Piura",
              "Provincia de Lima",
              "Puno",
              "Region de Huanuco",
              "Region de San Martin",
              "Tacna",
              "Tumbes",
              "Ucayali",
            ],
            ph: [
              "Autonomous Region in Muslim Mindanao",
              "Bicol",
              "Cagayan Valley",
              "Calabarzon",
              "Caraga",
              "Central Luzon",
              "Central Visayas",
              "Cordillera Administrative Region",
              "Davao",
              "Eastern Visayas",
              "Ilocos",
              "Mimaropa",
              "National Capital Region",
              "Negros Island Region",
              "Northern Mindanao",
              "Soccsksargen",
              "Western Visayas",
              "Zamboanga Peninsula",
            ],
            pn: [],
            pl: [
              "Wojewodztwo Dolnoslaskie",
              "Wojewodztwo Kujawsko-Pomorskie",
              "Wojewodztwo Lodzkie",
              "Wojewodztwo Lubelskie",
              "Wojewodztwo Lubuskie",
              "Wojewodztwo Malopolskie",
              "Wojewodztwo Mazowieckie",
              "Wojewodztwo Opolskie",
              "Wojewodztwo Podkarpackie",
              "Wojewodztwo Podlaskie",
              "Wojewodztwo Pomorskie",
              "Wojewodztwo Slaskie",
              "Wojewodztwo Swietokrzyskie",
              "Wojewodztwo Warminsko-Mazurskie",
              "Wojewodztwo Wielkopolskie",
              "Wojewodztwo Zachodniopomorskie",
            ],
            pt: [
              "Azores",
              "Distrito da Guarda",
              "Distrito de Aveiro",
              "Distrito de Beja",
              "Distrito de Braga",
              "Distrito de Braganca",
              "Distrito de Castelo Branco",
              "Distrito de Coimbra",
              "Distrito de Evora",
              "Distrito de Faro",
              "Distrito de Leiria",
              "Distrito de Lisboa",
              "Distrito de Portalegre",
              "Distrito de Santarem",
              "Distrito de Setubal",
              "Distrito de Viana do Castelo",
              "Distrito de Vila Real",
              "Distrito de Vise",
              "Distrito do Porto",
              "Madeira",
            ],
            qa: [
              "Al Wakrah",
              "Baladiyat ad Dawhah",
              "Baladiyat al Khawr wa adh Dhakhirah",
              "Baladiyat ar Rayyan",
              "Baladiyat ash Shamal",
              "Baladiyat az Za'ayin",
              "Baladiyat Umm Salal",
            ],
            re: ["Reunion"],
            ro: [
              "Arad",
              "Bihor",
              "Bucuresti",
              "Constanta",
              "Covasna",
              "Dolj",
              "Giurgi",
              "Gorj",
              "Harghita",
              "Hunedoara",
              "Ilfov",
              "Judetul Alba",
              "Judetul Arges",
              "Judetul Baca",
              "Judetul Bistrita-Nasaud",
              "Judetul Botosani",
              "Judetul Braila",
              "Judetul Brasov",
              "Judetul Buza",
              "Judetul Calarasi",
              "Judetul Caras-Severin",
              "Judetul Cluj",
              "Judetul Dambovita",
              "Judetul Galati",
              "Judetul Ialomita",
              "Judetul Iasi",
              "Judetul Maramures",
              "Judetul Mehedinti",
              "Judetul Mures",
              "Judetul Neamt",
              "Judetul Salaj",
              "Judetul Sibi",
              "Judetul Timis",
              "Judetul Valcea",
              "Olt",
              "Prahova",
              "Satu Mare",
              "Suceava",
              "Teleorman",
              "Tulcea",
              "Vaslui",
              "Vrancea",
            ],
            ru: [
              "Altayskiy Kray",
              "Amurskaya Oblast'",
              "Arkhangel'skaya Oblast'",
              "Astrakhanskaya Oblast'",
              "Bashkortostan",
              "Belgorodskaya Oblast'",
              "Bryanskaya Oblast'",
              "Chechenskaya Respublika",
              "Chelyabinskaya Oblast'",
              "Chukotskiy Avtonomnyy Okrug",
              "Chuvashskaya Respublika",
              "Dagestan",
              "Irkutskaya Oblast'",
              "Ivanovskaya Oblast'",
              "Kabardino-Balkarskaya Respublika",
              "Kaliningradskaya Oblast'",
              "Kalmykiya",
              "Kaluzhskaya Oblast'",
              "Kamtchatski Kray",
              "Karachayevo-Cherkesiya",
              "Kemerovskaya Oblast'",
              "Khabarovskiy Kray",
              "Khanty-Mansiyskiy Avtonomnyy Okrug-Yugra",
              "Kirovskaya Oblast'",
              "Komi",
              "Kostromskaya Oblast'",
              "Krasnodarskiy Kray",
              "Krasnoyarskiy Kray",
              "Kurganskaya Oblast'",
              "Kurskaya Oblast'",
              "Leningradskaya Oblast'",
              "Lipetskaya Oblast'",
              "Magadanskaya Oblast'",
              "Moscow Oblast",
              "Moskva",
              "Murmanskaya Oblast'",
              "Nenetskiy Avtonomnyy Okrug",
              "Nizhegorodskaya Oblast'",
              "North Ossetia",
              "Novgorodskaya Oblast'",
              "Novosibirskaya Oblast'",
              "Omskaya Oblast'",
              "Orenburgskaya Oblast'",
              "Orlovskaya Oblast'",
              "Penzenskaya Oblast'",
              "Perm Krai",
              "Primorskiy Kray",
              "Pskovskaya Oblast'",
              "Respublika Adygeya",
              "Respublika Altay",
              "Respublika Buryatiya",
              "Respublika Ingushetiya",
              "Respublika Kareliya",
              "Respublika Khakasiya",
              "Respublika Mariy-El",
              "Respublika Mordoviya",
              "Respublika Sakha (Yakutiya)",
              "Respublika Tyva",
              "Rostovskaya Oblast'",
              "Ryazanskaya Oblast'",
              "Sakhalinskaya Oblast'",
              "Samarskaya Oblast'",
              "Sankt-Peterburg",
              "Saratovskaya Oblast'",
              "Smolenskaya Oblast'",
              "Stavropol'skiy Kray",
              "Sverdlovskaya Oblast'",
              "Tambovskaya Oblast'",
              "Tatarstan",
              "Tomskaya Oblast'",
              "Tul'skaya Oblast'",
              "Tverskaya Oblast'",
              "Tyumenskaya Oblast'",
              "Udmurtskaya Respublika",
              "Ulyanovsk Oblast",
              "Vladimirskaya Oblast'",
              "Volgogradskaya Oblast'",
              "Vologodskaya Oblast'",
              "Voronezhskaya Oblast'",
              "Yamalo-Nenetskiy Avtonomnyy Okrug",
              "Yaroslavskaya Oblast'",
              "Yevreyskaya Avtonomnaya Oblast'",
              "Zabaykal'skiy Kray",
            ],
            rw: [
              "Eastern Province",
              "Kigali Province",
              "Northern Province",
              "Southern Province",
              "Western Province",
            ],
            gs: [],
            sh: ["Ascension", "Saint Helena", "Tristan da Cunha"],
            kn: [
              "Christ Church Nichola Town",
              "Saint Anne Sandy Point",
              "Saint George Basseterre",
              "Saint George Gingerland",
              "Saint James Windward",
              "Saint John Capesterre",
              "Saint John Figtree",
              "Saint Mary Cayon",
              "Saint Paul Capesterre",
              "Saint Paul Charlestown",
              "Saint Peter Basseterre",
              "Saint Thomas Lowland",
              "Saint Thomas Middle Island",
              "Trinity Palmetto Point",
            ],
            lc: [
              "Anse-la-Raye",
              "Canaries",
              "Castries",
              "Choiseul",
              "Dennery",
              "Gros-Islet",
              "Laborie",
              "Micoud",
              "Soufriere",
              "Vieux-Fort",
            ],
            pm: ["Commune de Saint-Pierre", "Miquelon-Langlade"],
            vc: [
              "Grenadines",
              "Parish of Charlotte",
              "Parish of Saint Andrew",
              "Parish of Saint David",
              "Parish of Saint George",
              "Parish of Saint Patrick",
            ],
            ws: [
              "A'ana",
              "Aiga-i-le-Tai",
              "Atua",
              "Fa'asaleleaga",
              "Gaga'emauga",
              "Gagaifomauga",
              "Palauli",
              "Satupa'itea",
              "Tuamasaga",
              "Va'a-o-Fonoti",
              "Vaisigano",
            ],
            sm: [
              "Castello di Acquaviva",
              "Castello di Borgo Maggiore",
              "Castello di Domagnano",
              "Castello di Faetano",
              "Castello di Fiorentino",
              "Castello di Montegiardino",
              "Castello di San Marino Citta",
              "Chiesanuova",
              "Serravalle",
            ],
            st: ["Principe", "Sao Tome"],
            sa: [
              "Al Jawf",
              "Al Madinah al Munawwarah",
              "Al Mintaqah ash Sharqiyah",
              "Al-Qassim Province",
              "Hai'l Region",
              "Jizan Region",
              "Makkah Province",
              "Mintaqat 'Asir",
              "Mintaqat al Bahah",
              "Mintaqat al Hudud ash Shamaliyah",
              "Mintaqat ar Riyad",
              "Mintaqat Najran",
              "Mintaqat Tabuk",
            ],
            sn: [
              "Dakar",
              "Diourbel",
              "Fatick",
              "Kaolack",
              "Kolda",
              "Louga",
              "Matam",
              "Region de Kaffrine",
              "Region de Kedougo",
              "Region de Sedhio",
              "Region de Thies",
              "Saint-Louis",
              "Tambacounda",
              "Ziguinchor",
            ],
            sc: [
              "Anse aux Pins",
              "Anse Boilea",
              "Anse Etoile",
              "Anse Royale",
              "Au Cap",
              "Baie Lazare",
              "Baie Sainte Anne",
              "Beau Vallon",
              "Bel Air",
              "Bel Ombre",
              "Cascade",
              "English River",
              "Glacis",
              "Grand Anse Mahe",
              "Grand Anse Praslin",
              "Inner Islands",
              "Les Mamelles",
              "Mont Buxton",
              "Mont Fleuri",
              "Plaisance",
              "Pointe Larue",
              "Port Glaud",
              "Roche Caiman",
              "Saint Louis",
              "Takamaka",
            ],
            sl: [
              "Eastern Province",
              "Northern Province",
              "Southern Province",
              "Western Area",
            ],
            sg: [
              "Central Singapore Community Development Council",
              "North East Community Development Region",
              "North West Community Development Council",
              "South East Community Development Council",
              "South West Community Development Council",
            ],
            sk: [
              "Banska Bystrica",
              "Bratislava",
              "Kosice",
              "Nitra",
              "Presov",
              "Trencin",
              "Trnava",
              "Zilina",
            ],
            si: [
              "Ankaran",
              "Beltinci",
              "Benedikt",
              "Bistrica ob Sotli",
              "Bloke",
              "Bohinj",
              "Borovnica",
              "Brda",
              "Brezovica",
              "Cankova",
              "Celje",
              "Cerklje na Gorenjskem",
              "Cerknica",
              "Cerkno",
              "Cerkvenjak",
              "Cirkulane",
              "Destrnik",
              "Dobje",
              "Dobrepolje",
              "Dobrna",
              "Dobrova-Polhov Gradec",
              "Dobrovnik",
              "Dol pri Ljubljani",
              "Dolenjske Toplice",
              "Dornava",
              "Dravograd",
              "Duplek",
              "Gorenja Vas-Poljane",
              "Gorje",
              "Gornja Radgona",
              "Gornji Grad",
              "Gornji Petrovci",
              "Grad",
              "Grosuplje",
              "Hajdina",
              "Hodos",
              "Horjul",
              "Hrastnik",
              "Hrpelje-Kozina",
              "Idrija",
              "Ig",
              "Ilirska Bistrica",
              "Izola",
              "Jesenice",
              "Jezersko",
              "Kamnik",
              "Kanal",
              "Kobilje",
              "Komen",
              "Komenda",
              "Koper",
              "Kostanjevica na Krki",
              "Kostel",
              "Kozje",
              "Kranj",
              "Kranjska Gora",
              "Kungota",
              "Kuzma",
              "Lenart",
              "Lendava",
              "Litija",
              "Ljubno",
              "Ljutomer",
              "Log-Dragomer",
              "Logatec",
              "Lovrenc na Pohorj",
              "Lukovica",
              "Makole",
              "Maribor",
              "Markovci",
              "Medvode",
              "Mestna Obcina Ljubljana",
              "Mestna Obcina Novo mesto",
              "Metlika",
              "Miren-Kostanjevica",
              "Mirna",
              "Mislinja",
              "Mokronog-Trebelno",
              "Moravske Toplice",
              "Mozirje",
              "Murska Sobota",
              "Muta",
              "Naklo",
              "Nazarje",
              "Nova Gorica",
              "Obcina Ajdovscina",
              "Obcina Apace",
              "Obcina Bled",
              "Obcina Bovec",
              "Obcina Braslovce",
              "Obcina Brezice",
              "Obcina Crensovci",
              "Obcina Crna na Koroskem",
              "Obcina Crnomelj",
              "Obcina Divaca",
              "Obcina Domzale",
              "Obcina Gorisnica",
              "Obcina Hoce-Slivnica",
              "Obcina Ivancna Gorica",
              "Obcina Jursinci",
              "Obcina Kidricevo",
              "Obcina Kobarid",
              "Obcina Kocevje",
              "Obcina Krizevci",
              "Obcina Krsko",
              "Obcina Lasko",
              "Obcina Loska Dolina",
              "Obcina Loski Potok",
              "Obcina Luce",
              "Obcina Majsperk",
              "Obcina Menges",
              "Obcina Mezica",
              "Obcina Miklavz na Dravskem Polj",
              "Obcina Mirna Pec",
              "Obcina Moravce",
              "Obcina Ormoz",
              "Obcina Podcetrtek",
              "Obcina Poljcane",
              "Obcina Race-Fram",
              "Obcina Radece",
              "Obcina Ravne na Koroskem",
              "Obcina Razkrizje",
              "Obcina Recica ob Savinji",
              "Obcina Rence-Vogrsko",
              "Obcina Rogaska Slatina",
              "Obcina Rogasovci",
              "Obcina Ruse",
              "Obcina Salovci",
              "Obcina Semic",
              "Obcina Sempeter-Vrtojba",
              "Obcina Sencur",
              "Obcina Sentilj",
              "Obcina Sentjernej",
              "Obcina Sentjur",
              "Obcina Sentrupert",
              "Obcina Sezana",
              "Obcina Skocjan",
              "Obcina Skofja Loka",
              "Obcina Skofljica",
              "Obcina Smarje pri Jelsah",
              "Obcina Smarjeske Toplice",
              "Obcina Smartno ob Paki",
              "Obcina Smartno pri Litiji",
              "Obcina Sodrazica",
              "Obcina Solcava",
              "Obcina Sostanj",
              "Obcina Sredisce ob Dravi",
              "Obcina Starse",
              "Obcina Store",
              "Obcina Straza",
              "Obcina Sveti Andraz v Slovenskih Goricah",
              "Obcina Sveti Jurij ob Scavnici",
              "Obcina Sveti Tomaz",
              "Obcina Tisina",
              "Obcina Tolmin",
              "Obcina Trnovska vas",
              "Obcina Trzic",
              "Obcina Turnisce",
              "Obcina Velike Lasce",
              "Obcina Verzej",
              "Obcina Zalec",
              "Obcina Zavrc",
              "Obcina Zelezniki",
              "Obcina Zetale",
              "Obcina Ziri",
              "Obcina Zirovnica",
              "Obcina Zrece",
              "Obcina Zuzemberk",
              "Odranci",
              "Oplotnica",
              "Osilnica",
              "Pesnica",
              "Piran",
              "Pivka",
              "Podlehnik",
              "Podvelka",
              "Polzela",
              "Postojna",
              "Prebold",
              "Preddvor",
              "Prevalje",
              "Ptuj",
              "Puconci",
              "Radenci",
              "Radlje ob Dravi",
              "Radovljica",
              "Ribnica",
              "Ribnica na Pohorj",
              "Rogatec",
              "Selnica ob Dravi",
              "Sevnica",
              "Slovenj Gradec",
              "Slovenska Bistrica",
              "Slovenske Konjice",
              "Sveta Ana",
              "Sveta Trojica v Slovenskih Goricah",
              "Sveti Jurij v Slovenskih Goricah",
              "Tabor",
              "Trbovlje",
              "Trebnje",
              "Trzin",
              "Velenje",
              "Velika Polana",
              "Videm",
              "Vipava",
              "Vitanje",
              "Vodice",
              "Vojnik",
              "Vransko",
              "Vrhnika",
              "Vuzenica",
              "Zagorje ob Savi",
            ],
            sb: [
              "Central Province",
              "Choiseul",
              "Guadalcanal Province",
              "Honiara",
              "Isabel Province",
              "Makira-Ulawa Province",
              "Malaita Province",
              "Rennell and Bellona",
              "Temotu Province",
              "Western Province",
            ],
            so: [
              "Gobolka Awdal",
              "Gobolka Bakool",
              "Gobolka Banaadir",
              "Gobolka Bari",
              "Gobolka Bay",
              "Gobolka Galguduud",
              "Gobolka Gedo",
              "Gobolka Hiiraan",
              "Gobolka Jubbada Dhexe",
              "Gobolka Jubbada Hoose",
              "Gobolka Mudug",
              "Gobolka Nugaal",
              "Gobolka Sanaag",
              "Gobolka Shabeellaha Dhexe",
              "Gobolka Shabeellaha Hoose",
              "Gobolka Sool",
              "Gobolka Togdheer",
              "Gobolka Woqooyi Galbeed",
            ],
            za: [
              "Eastern Cape",
              "Free State",
              "Gauteng",
              "Limpopo",
              "Mpumalanga",
              "Province of KwaZulu-Natal",
              "Province of North West",
              "Province of Northern Cape",
              "Western Cape",
            ],
            es: [
              "Andalucia",
              "Aragon",
              "Canary Islands",
              "Cantabria",
              "Castilla y Leon",
              "Castilla-La Mancha",
              "Catalunya",
              "Ceuta",
              "Comunidad de Madrid",
              "Comunitat Autonoma de les Illes Balears",
              "Comunitat Valenciana",
              "Euskal Autonomia Erkidegoa",
              "Extremadura",
              "Galicia",
              "La Rioja",
              "Melilla",
              "Navarra",
              "Principality of Asturias",
              "Region de Murcia",
            ],
            lk: [
              "Central Province",
              "Eastern Province",
              "North Central Province",
              "North Western Province",
              "Northern Province",
              "Province of Sabaragamuwa",
              "Province of Uva",
              "Southern Province",
              "Western Province",
            ],
            sd: [
              "Al Jazirah State",
              "Al Qadarif State",
              "Blue Nile",
              "Central Darfur State",
              "East Darfur",
              "Kassala State",
              "Khartoum",
              "North Darfur",
              "North Kordofan",
              "Northern",
              "Red Sea",
              "River Nile",
              "Sennar",
              "South Darfur",
              "South Kordofan",
              "West Darfur",
              "West Kordofan State",
              "White Nile",
            ],
            sr: [
              "Distrikt Brokopondo",
              "Distrikt Commewijne",
              "Distrikt Coronie",
              "Distrikt Marowijne",
              "Distrikt Nickerie",
              "Distrikt Para",
              "Distrikt Paramaribo",
              "Distrikt Saramacca",
              "Distrikt Sipaliwini",
              "Distrikt Wanica",
            ],
            sj: ["Jan Mayen", "Svalbard"],
            sz: [
              "Hhohho District",
              "Lubombo District",
              "Manzini District",
              "Shiselweni District",
            ],
            se: [
              "Blekinge",
              "Dalarna",
              "Gaevleborgs laen",
              "Gotland",
              "Halland",
              "Jaemtlands laen",
              "Joenkoepings laen",
              "Kalmar",
              "Kronoberg",
              "Norrbotten",
              "OErebro laen",
              "OEstergoetlands laen",
              "Skane laen",
              "Soedermanlands laen",
              "Stockholm",
              "Uppsala",
              "Vaermlands laen",
              "Vaesterbottens laen",
              "Vaesternorrlands laen",
              "Vaestmanlands laen",
              "Vaestra Goetalands laen",
            ],
            ch: [
              "Canton de Berne",
              "Canton de Fribourg",
              "Canton de Vaud",
              "Canton du Valais",
              "Geneve",
              "Jura",
              "Kanton Aarga",
              "Kanton Appenzell Ausserrhoden",
              "Kanton Appenzell Innerrhoden",
              "Kanton Basel-Landschaft",
              "Kanton Basel-Stadt",
              "Kanton Glarus",
              "Kanton Graubunden",
              "Kanton Luzern",
              "Kanton Nidwalden",
              "Kanton Obwalden",
              "Kanton Schaffhausen",
              "Kanton Schwyz",
              "Kanton Solothurn",
              "Kanton St. Gallen",
              "Kanton Thurga",
              "Kanton Uri",
              "Kanton Zug",
              "Kanton Zurich",
              "Neuchatel",
              "Ticino",
            ],
            sy: [
              "Al-Hasakah Governorate",
              "Aleppo Governorate",
              "Ar-Raqqah Governorate",
              "As-Suwayda Governorate",
              "Damascus Governorate",
              "Daraa Governorate",
              "Deir ez-Zor Governorate",
              "Hama Governorate",
              "Homs Governorate",
              "Idlib Governorate",
              "Latakia Governorate",
              "Muhafazat Rif Dimashq",
              "Quneitra Governorate",
              "Tartus Governorate",
            ],
            tw: ["Fukien", "Kaohsiung", "Taipei", "Taiwan"],
            tj: [
              "Districts of Republican Subordination",
              "Dushanbe",
              "Viloyati Khatlon",
              "Viloyati Mukhtori Kuhistoni Badakhshon",
              "Viloyati Sughd",
            ],
            tz: [
              "Arusha Region",
              "Coast Region",
              "Dar es Salaam Region",
              "Dodoma Region",
              "Geita Region",
              "Iringa Region",
              "Kagera Region",
              "Katavi Region",
              "Kigoma Region",
              "Kilimanjaro Region",
              "Lindi Region",
              "Manyara Region",
              "Mara Region",
              "Mbeya Region",
              "Morogoro Region",
              "Mtwara Region",
              "Mwanza Region",
              "Njombe Region",
              "Pemba North Region",
              "Pemba South Region",
              "Rukwa Region",
              "Ruvuma Region",
              "Shinyanga Region",
              "Simiyu Region",
              "Singida Region",
              "Tabora Region",
              "Tanga Region",
              "Zanzibar Central/South Region",
              "Zanzibar North Region",
              "Zanzibar Urban/West Region",
            ],
            th: [
              "Bangkok",
              "Changwat Amnat Charoen",
              "Changwat Ang Thong",
              "Changwat Bueng Kan",
              "Changwat Buri Ram",
              "Changwat Chachoengsao",
              "Changwat Chai Nat",
              "Changwat Chaiyaphum",
              "Changwat Chanthaburi",
              "Changwat Chiang Rai",
              "Changwat Chon Buri",
              "Changwat Chumphon",
              "Changwat Kalasin",
              "Changwat Kamphaeng Phet",
              "Changwat Kanchanaburi",
              "Changwat Khon Kaen",
              "Changwat Krabi",
              "Changwat Lampang",
              "Changwat Lamphun",
              "Changwat Loei",
              "Changwat Lop Buri",
              "Changwat Mae Hong Son",
              "Changwat Maha Sarakham",
              "Changwat Mukdahan",
              "Changwat Nakhon Nayok",
              "Changwat Nakhon Pathom",
              "Changwat Nakhon Phanom",
              "Changwat Nakhon Ratchasima",
              "Changwat Nakhon Sawan",
              "Changwat Nakhon Si Thammarat",
              "Changwat Nan",
              "Changwat Narathiwat",
              "Changwat Nong Bua Lamph",
              "Changwat Nong Khai",
              "Changwat Nonthaburi",
              "Changwat Pathum Thani",
              "Changwat Pattani",
              "Changwat Phangnga",
              "Changwat Phatthalung",
              "Changwat Phayao",
              "Changwat Phetchabun",
              "Changwat Phetchaburi",
              "Changwat Phichit",
              "Changwat Phitsanulok",
              "Changwat Phra Nakhon Si Ayutthaya",
              "Changwat Phrae",
              "Changwat Prachin Buri",
              "Changwat Prachuap Khiri Khan",
              "Changwat Ranong",
              "Changwat Ratchaburi",
              "Changwat Rayong",
              "Changwat Roi Et",
              "Changwat Sa Kaeo",
              "Changwat Sakon Nakhon",
              "Changwat Samut Prakan",
              "Changwat Samut Sakhon",
              "Changwat Samut Songkhram",
              "Changwat Saraburi",
              "Changwat Satun",
              "Changwat Si Sa Ket",
              "Changwat Sing Buri",
              "Changwat Songkhla",
              "Changwat Sukhothai",
              "Changwat Suphan Buri",
              "Changwat Surat Thani",
              "Changwat Surin",
              "Changwat Tak",
              "Changwat Trang",
              "Changwat Trat",
              "Changwat Ubon Ratchathani",
              "Changwat Udon Thani",
              "Changwat Uthai Thani",
              "Changwat Uttaradit",
              "Changwat Yala",
              "Changwat Yasothon",
              "Chiang Mai Province",
              "Phuket Province",
            ],
            tg: ["Centrale", "Kara", "Maritime", "Plateaux", "Savanes"],
            tk: ["Ataf", "Fakaofo", "Nukunon"],
            to: ["Eua", "Ha`apai", "Niuas", "Tongatap", "Vava'"],
            tt: [
              "Arima",
              "Chaguanas",
              "City of Port of Spain",
              "Couva-Tabaquite-Talparo",
              "Diego Martin",
              "Mayaro",
              "Penal/Debe",
              "Point Fortin",
              "Princes Town",
              "San Fernando",
              "San Juan/Laventille",
              "Sangre Grande",
              "Siparia",
              "Tobago",
              "Tunapuna/Piarco",
            ],
            tn: [
              "Gafsa Governorate",
              "Gouvernorat de Beja",
              "Gouvernorat de Ben Arous",
              "Gouvernorat de Bizerte",
              "Gouvernorat de Gabes",
              "Gouvernorat de Jendouba",
              "Gouvernorat de Kairouan",
              "Gouvernorat de Kasserine",
              "Gouvernorat de Kebili",
              "Gouvernorat de Kef",
              "Gouvernorat de l'Ariana",
              "Gouvernorat de Mahdia",
              "Gouvernorat de Medenine",
              "Gouvernorat de Monastir",
              "Gouvernorat de Nabeul",
              "Gouvernorat de Sfax",
              "Gouvernorat de Sidi Bouzid",
              "Gouvernorat de Siliana",
              "Gouvernorat de Sousse",
              "Gouvernorat de Tozeur",
              "Gouvernorat de Tunis",
              "Gouvernorat de Zaghouan",
              "Manouba",
              "Tataouine",
            ],
            tr: [
              "Adana",
              "Adiyaman",
              "Afyonkarahisar",
              "Agri",
              "Aksaray",
              "Amasya",
              "Ankara",
              "Antalya",
              "Ardahan",
              "Artvin",
              "Aydin",
              "Balikesir",
              "Bartin",
              "Batman",
              "Bayburt",
              "Bilecik",
              "Bingoel",
              "Bitlis",
              "Bol",
              "Burdur",
              "Bursa",
              "Canakkale",
              "Cankiri",
              "Corum",
              "Denizli",
              "Diyarbakir",
              "Duezce",
              "Edirne",
              "Elazig",
              "Erzincan",
              "Erzurum",
              "Eskisehir",
              "Gaziantep",
              "Giresun",
              "Guemueshane",
              "Hakkari",
              "Hatay",
              "Igdir",
              "Isparta",
              "Istanbul",
              "Izmir",
              "Kahramanmaras",
              "Karabuek",
              "Karaman",
              "Kars",
              "Kastamon",
              "Kayseri",
              "Kilis",
              "Kirikkale",
              "Kirklareli",
              "Kirsehir",
              "Kocaeli",
              "Konya",
              "Kuetahya",
              "Malatya",
              "Manisa",
              "Mardin",
              "Mersin",
              "Mugla",
              "Mus",
              "Nevsehir",
              "Nigde",
              "Ord",
              "Osmaniye",
              "Rize",
              "Sakarya",
              "Samsun",
              "Sanliurfa",
              "Siirt",
              "Sinop",
              "Sirnak",
              "Sivas",
              "Tekirdag",
              "Tokat",
              "Trabzon",
              "Tunceli",
              "Usak",
              "Van",
              "Yalova",
              "Yozgat",
              "Zonguldak",
            ],
            tm: [
              "Ahal",
              "Ashgabat",
              "Balkan",
              "Dasoguz Welayaty",
              "Lebap",
              "Mary",
            ],
            tc: [],
            tv: [
              "Funafuti",
              "Nanumanga",
              "Nanumea",
              "Niutao",
              "Nui",
              "Nukufeta",
              "Nukulaelae",
              "Vaitup",
            ],
            ug: [
              "Central Region",
              "Eastern Region",
              "Northern Region",
              "Western Region",
            ],
            ua: [
              "Cherkas'ka Oblast'",
              "Chernihivs'ka Oblast'",
              "Chernivets'ka Oblast'",
              "Dnipropetrovska Oblast'",
              "Donets'ka Oblast'",
              "Gorod Sevastopol",
              "Ivano-Frankivs'ka Oblast'",
              "Kharkivs'ka Oblast'",
              "Khersons'ka Oblast'",
              "Khmel'nyts'ka Oblast'",
              "Kirovohrads'ka Oblast'",
              "Kyiv Oblast",
              "L'vivs'ka Oblast'",
              "Luhans'ka Oblast'",
              "Misto Kyyiv",
              "Mykolayivs'ka Oblast'",
              "Odes'ka Oblast'",
              "Poltavs'ka Oblast'",
              "Republic of Crimea",
              "Rivnens'ka Oblast'",
              "Sums'ka Oblast'",
              "Ternopil's'ka Oblast'",
              "Vinnyts'ka Oblast'",
              "Volyns'ka Oblast'",
              "Zakarpattia Oblast",
              "Zaporiz'ka Oblast'",
              "Zhytomyrs'ka Oblast'",
            ],
            ae: [
              "`Ajman",
              "Abu Zaby",
              "Al Fujayrah",
              "Ash Shariqah",
              "Dubai",
              "Ra's al Khaymah",
              "Umm al Qaywayn",
            ],
            us: [
              "Alabama",
              "Alaska",
              "Arizona",
              "Arkansas",
              "California",
              "Colorado",
              "Connecticut",
              "Delaware",
              "District of Columbia",
              "Florida",
              "Georgia",
              "Hawaii",
              "Idaho",
              "Illinois",
              "Indiana",
              "Iowa",
              "Kansas",
              "Kentucky",
              "Louisiana",
              "Maine",
              "Maryland",
              "Massachusetts",
              "Michigan",
              "Minnesota",
              "Mississippi",
              "Missouri",
              "Montana",
              "Nebraska",
              "Nevada",
              "New Hampshire",
              "New Jersey",
              "New Mexico",
              "New York",
              "North Carolina",
              "North Dakota",
              "Ohio",
              "Oklahoma",
              "Oregon",
              "Pennsylvania",
              "Rhode Island",
              "South Carolina",
              "South Dakota",
              "Tennessee",
              "Texas",
              "Utah",
              "Vermont",
              "Virginia",
              "Washington",
              "West Virginia",
              "Wisconsin",
              "Wyoming",
            ],
            uy: [
              "Departamento de Artigas",
              "Departamento de Canelones",
              "Departamento de Cerro Largo",
              "Departamento de Colonia",
              "Departamento de Durazno",
              "Departamento de Flores",
              "Departamento de Florida",
              "Departamento de Lavalleja",
              "Departamento de Maldonado",
              "Departamento de Montevideo",
              "Departamento de Paysand",
              "Departamento de Rio Negro",
              "Departamento de Rivera",
              "Departamento de Rocha",
              "Departamento de Salto",
              "Departamento de San Jose",
              "Departamento de Soriano",
              "Departamento de Tacuarembo",
              "Departamento de Treinta y Tres",
            ],
            uz: [
              "Andijan",
              "Bukhara Province",
              "Fergana",
              "Jizzakh Province",
              "Karakalpakstan",
              "Namangan Province",
              "Navoiy Province",
              "Qashqadaryo Province",
              "Samarqand Viloyati",
              "Sirdaryo",
              "Surxondaryo Viloyati",
              "Toshkent Shahri",
              "Toshkent Viloyati",
              "Xorazm Viloyati",
            ],
            vu: [
              "Malampa Province",
              "Penama Province",
              "Sanma Province",
              "Shefa Province",
              "Tafea Province",
              "Torba Province",
            ],
            ve: [
              "Delta Amacuro",
              "Dependencias Federales",
              "Distrito Capital",
              "Estado Amazonas",
              "Estado Anzoategui",
              "Estado Apure",
              "Estado Aragua",
              "Estado Barinas",
              "Estado Bolivar",
              "Estado Carabobo",
              "Estado Cojedes",
              "Estado Falcon",
              "Estado Guarico",
              "Estado Lara",
              "Estado Merida",
              "Estado Monagas",
              "Estado Nueva Esparta",
              "Estado Portuguesa",
              "Estado Sucre",
              "Estado Tachira",
              "Estado Trujillo",
              "Estado Vargas",
              "Estado Yaracuy",
              "Estado Zulia",
              "Miranda",
            ],
            vn: [
              "An Giang",
              "Bà Rịa-Vũng Tàu",
              "Bình Dương",
              "Bình Phước",
              "Bình Thuận",
              "Bình Định",
              "Bạc Liêu",
              "Bắc Giang",
              "Bắc Kạn",
              "Bắc Ninh",
              "Bến Tre",
              "Cao Bằng",
              "Cà Mau",
              "Da Nang",
              "Gia Lai",
              "Haiphong",
              "Hanoi",
              "Ho Chi Minh City",
              "Hà Giang",
              "Hà Nam",
              "Hà Tây",
              "Hà Tĩnh",
              "Hòa Bình",
              "Hưng Yên",
              "Hải Dương",
              "Hậu Giang",
              "Khánh Hòa",
              "Kiên Giang",
              "Kon Tum",
              "Lai Châu",
              "Long An",
              "Lào Cai",
              "Lâm Đồng",
              "Lạng Sơn",
              "Nam Định",
              "Nghệ An",
              "Ninh Bình",
              "Ninh Thuận",
              "Phú Thọ",
              "Phú Yên",
              "Quảng Bình",
              "Quảng Nam",
              "Quảng Ngãi",
              "Quảng Ninh",
              "Quảng Trị",
              "Sóc Trăng",
              "Sơn La",
              "Thanh Hóa",
              "Thái Bình",
              "Thái Nguyên",
              "Thừa Thiên-Huế",
              "Tiền Giang",
              "Trà Vinh",
              "Tuyên Quang",
              "Tây Ninh",
              "Vĩnh Long",
              "Vĩnh Phúc",
              "Yên Bái",
              "Điện Biên",
              "Đắk Lắk",
              "Đắk Nông",
              "Đồng Nai",
              "Đồng Tháp",
            ],
            vg: [],
            vi: [
              "Saint Croix Island",
              "Saint John Island",
              "Saint Thomas Island",
            ],
            wf: ["Alo", "Sigave", "Uvea"],
            eh: [],
            ye: [
              "Al Bayda Governorate",
              "Al Mahrah",
              "Al Mahwit",
              "Amanat Al Asimah",
              "Ibb",
              "Muhafazat `Amran",
              "Muhafazat 'Adan",
              "Muhafazat Abyan",
              "Muhafazat ad Dali'",
              "Muhafazat al Hudaydah",
              "Muhafazat al Jawf",
              "Muhafazat Dhamar",
              "Muhafazat Hadramawt",
              "Muhafazat Hajjah",
              "Muhafazat Lahij",
              "Muhafazat Ma'rib",
              "Muhafazat Raymah",
              "Muhafazat Sa'dah",
              "Muhafazat Ta`izz",
              "Sanaa",
              "Shabwah",
              "Socotra",
            ],
            zm: [
              "Central Province",
              "Copperbelt Province",
              "Eastern Province",
              "Luapula Province",
              "Lusaka Province",
              "Muchinga Province",
              "North-Western Province",
              "Northern Province",
              "Southern Province",
              "Western Province",
            ],
            zw: [
              "Bulawayo Province",
              "Harare Province",
              "Manicaland Province",
              "Mashonaland Central Province",
              "Mashonaland East Province",
              "Mashonaland West Province",
              "Masvingo Province",
              "Matabeleland North Province",
              "Matabeleland South Province",
              "Midlands Province",
            ],
          });
      },
      8699: function (e, t, n) {
        "use strict";
        var r =
          (this && this.__importDefault) ||
          function (e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.getStates =
            t.getFilteredCountries =
            t.getCountry =
            t.getCountries =
              void 0);
        var o = r(n(4929)),
          a = r(n(1564)),
          i = function (e, t) {
            return (
              (t = t.toLowerCase()),
              e.code.toLowerCase() === t ||
                e.name.toLowerCase() === t ||
                e.dial_code.toLowerCase() === t
            );
          };
        (t.getCountries = function () {
          return o.default;
        }),
          (t.getCountry = function (e) {
            for (var n = 0, r = t.getCountries(); n < r.length; n++) {
              var o = r[n];
              if (i(o, e)) return o;
            }
            return null;
          }),
          (t.getFilteredCountries = function (e) {
            for (
              var n = t.getCountries(), r = [], o = 0, a = e;
              o < a.length;
              o++
            )
              for (var s = a[o], l = 0, c = n; l < c.length; l++) {
                var u = c[l];
                if (i(u, s)) {
                  r.push(u);
                  break;
                }
              }
            return r;
          }),
          (t.getStates = function (e) {
            try {
              return a.default[e];
            } catch (e) {
              return "Invalid country code";
            }
          });
      },
      3162: function (e, t, n) {
        var r, o;
        void 0 ===
          (o =
            "function" ==
            typeof (r = function () {
              "use strict";
              function t(e, t, n) {
                var r = new XMLHttpRequest();
                r.open("GET", e),
                  (r.responseType = "blob"),
                  (r.onload = function () {
                    s(r.response, t, n);
                  }),
                  (r.onerror = function () {
                    console.error("could not download file");
                  }),
                  r.send();
              }
              function r(e) {
                var t = new XMLHttpRequest();
                t.open("HEAD", e, !1);
                try {
                  t.send();
                } catch (e) {}
                return 200 <= t.status && 299 >= t.status;
              }
              function o(e) {
                try {
                  e.dispatchEvent(new MouseEvent("click"));
                } catch (n) {
                  var t = document.createEvent("MouseEvents");
                  t.initMouseEvent(
                    "click",
                    !0,
                    !0,
                    window,
                    0,
                    0,
                    0,
                    80,
                    20,
                    !1,
                    !1,
                    !1,
                    !1,
                    0,
                    null
                  ),
                    e.dispatchEvent(t);
                }
              }
              var a =
                  "object" == typeof window && window.window === window
                    ? window
                    : "object" == typeof self && self.self === self
                    ? self
                    : "object" == typeof n.g && n.g.global === n.g
                    ? n.g
                    : void 0,
                i =
                  a.navigator &&
                  /Macintosh/.test(navigator.userAgent) &&
                  /AppleWebKit/.test(navigator.userAgent) &&
                  !/Safari/.test(navigator.userAgent),
                s =
                  a.saveAs ||
                  ("object" != typeof window || window !== a
                    ? function () {}
                    : "download" in HTMLAnchorElement.prototype && !i
                    ? function (e, n, i) {
                        var s = a.URL || a.webkitURL,
                          l = document.createElement("a");
                        (n = n || e.name || "download"),
                          (l.download = n),
                          (l.rel = "noopener"),
                          "string" == typeof e
                            ? ((l.href = e),
                              l.origin === location.origin
                                ? o(l)
                                : r(l.href)
                                ? t(e, n, i)
                                : o(l, (l.target = "_blank")))
                            : ((l.href = s.createObjectURL(e)),
                              setTimeout(function () {
                                s.revokeObjectURL(l.href);
                              }, 4e4),
                              setTimeout(function () {
                                o(l);
                              }, 0));
                      }
                    : "msSaveOrOpenBlob" in navigator
                    ? function (e, n, a) {
                        if (
                          ((n = n || e.name || "download"),
                          "string" != typeof e)
                        )
                          navigator.msSaveOrOpenBlob(
                            (function (e, t) {
                              return (
                                void 0 === t
                                  ? (t = { autoBom: !1 })
                                  : "object" != typeof t &&
                                    (console.warn(
                                      "Deprecated: Expected third argument to be a object"
                                    ),
                                    (t = { autoBom: !t })),
                                t.autoBom &&
                                /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(
                                  e.type
                                )
                                  ? new Blob(["\ufeff", e], { type: e.type })
                                  : e
                              );
                            })(e, a),
                            n
                          );
                        else if (r(e)) t(e, n, a);
                        else {
                          var i = document.createElement("a");
                          (i.href = e),
                            (i.target = "_blank"),
                            setTimeout(function () {
                              o(i);
                            });
                        }
                      }
                    : function (e, n, r, o) {
                        if (
                          ((o = o || open("", "_blank")) &&
                            (o.document.title = o.document.body.innerText =
                              "downloading..."),
                          "string" == typeof e)
                        )
                          return t(e, n, r);
                        var s = "application/octet-stream" === e.type,
                          l = /constructor/i.test(a.HTMLElement) || a.safari,
                          c = /CriOS\/[\d]+/.test(navigator.userAgent);
                        if (
                          (c || (s && l) || i) &&
                          "undefined" != typeof FileReader
                        ) {
                          var u = new FileReader();
                          (u.onloadend = function () {
                            var e = u.result;
                            (e = c
                              ? e
                              : e.replace(
                                  /^data:[^;]*;/,
                                  "data:attachment/file;"
                                )),
                              o ? (o.location.href = e) : (location = e),
                              (o = null);
                          }),
                            u.readAsDataURL(e);
                        } else {
                          var d = a.URL || a.webkitURL,
                            p = d.createObjectURL(e);
                          o ? (o.location = p) : (location.href = p),
                            (o = null),
                            setTimeout(function () {
                              d.revokeObjectURL(p);
                            }, 4e4);
                        }
                      });
              (a.saveAs = s.saveAs = s), (e.exports = s);
            })
              ? r.apply(t, [])
              : r) || (e.exports = o);
      },
      8679: function (e, t, n) {
        "use strict";
        var r = n(9864),
          o = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0,
          },
          a = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0,
          },
          i = {
            $$typeof: !0,
            compare: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
            type: !0,
          },
          s = {};
        function l(e) {
          return r.isMemo(e) ? i : s[e.$$typeof] || o;
        }
        (s[r.ForwardRef] = {
          $$typeof: !0,
          render: !0,
          defaultProps: !0,
          displayName: !0,
          propTypes: !0,
        }),
          (s[r.Memo] = i);
        var c = Object.defineProperty,
          u = Object.getOwnPropertyNames,
          d = Object.getOwnPropertySymbols,
          p = Object.getOwnPropertyDescriptor,
          m = Object.getPrototypeOf,
          h = Object.prototype;
        e.exports = function e(t, n, r) {
          if ("string" != typeof n) {
            if (h) {
              var o = m(n);
              o && o !== h && e(t, o, r);
            }
            var i = u(n);
            d && (i = i.concat(d(n)));
            for (var s = l(t), f = l(n), g = 0; g < i.length; ++g) {
              var v = i[g];
              if (!(a[v] || (r && r[v]) || (f && f[v]) || (s && s[v]))) {
                var b = p(n, v);
                try {
                  c(t, v, b);
                } catch (e) {}
              }
            }
          }
          return t;
        };
      },
      4448: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = n(3840);
        function a(e) {
          for (
            var t =
                "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
              n = 1;
            n < arguments.length;
            n++
          )
            t += "&args[]=" + encodeURIComponent(arguments[n]);
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        var i = new Set(),
          s = {};
        function l(e, t) {
          c(e, t), c(e + "Capture", t);
        }
        function c(e, t) {
          for (s[e] = t, e = 0; e < t.length; e++) i.add(t[e]);
        }
        var u = !(
            "undefined" == typeof window ||
            void 0 === window.document ||
            void 0 === window.document.createElement
          ),
          d = Object.prototype.hasOwnProperty,
          p =
            /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          m = {},
          h = {};
        function f(e, t, n, r, o, a, i) {
          (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
            (this.attributeName = r),
            (this.attributeNamespace = o),
            (this.mustUseProperty = n),
            (this.propertyName = e),
            (this.type = t),
            (this.sanitizeURL = a),
            (this.removeEmptyString = i);
        }
        var g = {};
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
          .split(" ")
          .forEach(function (e) {
            g[e] = new f(e, 0, !1, e, null, !1, !1);
          }),
          [
            ["acceptCharset", "accept-charset"],
            ["className", "class"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
          ].forEach(function (e) {
            var t = e[0];
            g[t] = new f(t, 1, !1, e[1], null, !1, !1);
          }),
          ["contentEditable", "draggable", "spellCheck", "value"].forEach(
            function (e) {
              g[e] = new f(e, 2, !1, e.toLowerCase(), null, !1, !1);
            }
          ),
          [
            "autoReverse",
            "externalResourcesRequired",
            "focusable",
            "preserveAlpha",
          ].forEach(function (e) {
            g[e] = new f(e, 2, !1, e, null, !1, !1);
          }),
          "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
            .split(" ")
            .forEach(function (e) {
              g[e] = new f(e, 3, !1, e.toLowerCase(), null, !1, !1);
            }),
          ["checked", "multiple", "muted", "selected"].forEach(function (e) {
            g[e] = new f(e, 3, !0, e, null, !1, !1);
          }),
          ["capture", "download"].forEach(function (e) {
            g[e] = new f(e, 4, !1, e, null, !1, !1);
          }),
          ["cols", "rows", "size", "span"].forEach(function (e) {
            g[e] = new f(e, 6, !1, e, null, !1, !1);
          }),
          ["rowSpan", "start"].forEach(function (e) {
            g[e] = new f(e, 5, !1, e.toLowerCase(), null, !1, !1);
          });
        var v = /[\-:]([a-z])/g;
        function b(e) {
          return e[1].toUpperCase();
        }
        function _(e, t, n, r) {
          var o = g.hasOwnProperty(t) ? g[t] : null;
          (null !== o
            ? 0 !== o.type
            : r ||
              !(2 < t.length) ||
              ("o" !== t[0] && "O" !== t[0]) ||
              ("n" !== t[1] && "N" !== t[1])) &&
            ((function (e, t, n, r) {
              if (
                null == t ||
                (function (e, t, n, r) {
                  if (null !== n && 0 === n.type) return !1;
                  switch (typeof t) {
                    case "function":
                    case "symbol":
                      return !0;
                    case "boolean":
                      return (
                        !r &&
                        (null !== n
                          ? !n.acceptsBooleans
                          : "data-" !== (e = e.toLowerCase().slice(0, 5)) &&
                            "aria-" !== e)
                      );
                    default:
                      return !1;
                  }
                })(e, t, n, r)
              )
                return !0;
              if (r) return !1;
              if (null !== n)
                switch (n.type) {
                  case 3:
                    return !t;
                  case 4:
                    return !1 === t;
                  case 5:
                    return isNaN(t);
                  case 6:
                    return isNaN(t) || 1 > t;
                }
              return !1;
            })(t, n, o, r) && (n = null),
            r || null === o
              ? (function (e) {
                  return (
                    !!d.call(h, e) ||
                    (!d.call(m, e) &&
                      (p.test(e) ? (h[e] = !0) : ((m[e] = !0), !1)))
                  );
                })(t) &&
                (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
              : o.mustUseProperty
              ? (e[o.propertyName] = null === n ? 3 !== o.type && "" : n)
              : ((t = o.attributeName),
                (r = o.attributeNamespace),
                null === n
                  ? e.removeAttribute(t)
                  : ((n =
                      3 === (o = o.type) || (4 === o && !0 === n)
                        ? ""
                        : "" + n),
                    r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
        }
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
          .split(" ")
          .forEach(function (e) {
            var t = e.replace(v, b);
            g[t] = new f(t, 1, !1, e, null, !1, !1);
          }),
          "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
            .split(" ")
            .forEach(function (e) {
              var t = e.replace(v, b);
              g[t] = new f(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
            }),
          ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
            var t = e.replace(v, b);
            g[t] = new f(
              t,
              1,
              !1,
              e,
              "http://www.w3.org/XML/1998/namespace",
              !1,
              !1
            );
          }),
          ["tabIndex", "crossOrigin"].forEach(function (e) {
            g[e] = new f(e, 1, !1, e.toLowerCase(), null, !1, !1);
          }),
          (g.xlinkHref = new f(
            "xlinkHref",
            1,
            !1,
            "xlink:href",
            "http://www.w3.org/1999/xlink",
            !0,
            !1
          )),
          ["src", "href", "action", "formAction"].forEach(function (e) {
            g[e] = new f(e, 1, !1, e.toLowerCase(), null, !0, !0);
          });
        var y = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          x = Symbol.for("react.element"),
          C = Symbol.for("react.portal"),
          S = Symbol.for("react.fragment"),
          k = Symbol.for("react.strict_mode"),
          w = Symbol.for("react.profiler"),
          P = Symbol.for("react.provider"),
          O = Symbol.for("react.context"),
          I = Symbol.for("react.forward_ref"),
          T = Symbol.for("react.suspense"),
          M = Symbol.for("react.suspense_list"),
          E = Symbol.for("react.memo"),
          D = Symbol.for("react.lazy");
        Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
        var j = Symbol.for("react.offscreen");
        Symbol.for("react.legacy_hidden"),
          Symbol.for("react.cache"),
          Symbol.for("react.tracing_marker");
        var R = Symbol.iterator;
        function N(e) {
          return null === e || "object" != typeof e
            ? null
            : "function" == typeof (e = (R && e[R]) || e["@@iterator"])
            ? e
            : null;
        }
        var A,
          L = Object.assign;
        function z(e) {
          if (void 0 === A)
            try {
              throw Error();
            } catch (e) {
              var t = e.stack.trim().match(/\n( *(at )?)/);
              A = (t && t[1]) || "";
            }
          return "\n" + A + e;
        }
        var B = !1;
        function Z(e, t) {
          if (!e || B) return "";
          B = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (t)
              if (
                ((t = function () {
                  throw Error();
                }),
                Object.defineProperty(t.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                "object" == typeof Reflect && Reflect.construct)
              ) {
                try {
                  Reflect.construct(t, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], t);
              } else {
                try {
                  t.call();
                } catch (e) {
                  r = e;
                }
                e.call(t.prototype);
              }
            else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              e();
            }
          } catch (t) {
            if (t && r && "string" == typeof t.stack) {
              for (
                var o = t.stack.split("\n"),
                  a = r.stack.split("\n"),
                  i = o.length - 1,
                  s = a.length - 1;
                1 <= i && 0 <= s && o[i] !== a[s];

              )
                s--;
              for (; 1 <= i && 0 <= s; i--, s--)
                if (o[i] !== a[s]) {
                  if (1 !== i || 1 !== s)
                    do {
                      if ((i--, 0 > --s || o[i] !== a[s])) {
                        var l = "\n" + o[i].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            l.includes("<anonymous>") &&
                            (l = l.replace("<anonymous>", e.displayName)),
                          l
                        );
                      }
                    } while (1 <= i && 0 <= s);
                  break;
                }
            }
          } finally {
            (B = !1), (Error.prepareStackTrace = n);
          }
          return (e = e ? e.displayName || e.name : "") ? z(e) : "";
        }
        function F(e) {
          switch (e.tag) {
            case 5:
              return z(e.type);
            case 16:
              return z("Lazy");
            case 13:
              return z("Suspense");
            case 19:
              return z("SuspenseList");
            case 0:
            case 2:
            case 15:
              return Z(e.type, !1);
            case 11:
              return Z(e.type.render, !1);
            case 1:
              return Z(e.type, !0);
            default:
              return "";
          }
        }
        function H(e) {
          if (null == e) return null;
          if ("function" == typeof e) return e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case S:
              return "Fragment";
            case C:
              return "Portal";
            case w:
              return "Profiler";
            case k:
              return "StrictMode";
            case T:
              return "Suspense";
            case M:
              return "SuspenseList";
          }
          if ("object" == typeof e)
            switch (e.$$typeof) {
              case O:
                return (e.displayName || "Context") + ".Consumer";
              case P:
                return (e._context.displayName || "Context") + ".Provider";
              case I:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case E:
                return null !== (t = e.displayName || null)
                  ? t
                  : H(e.type) || "Memo";
              case D:
                (t = e._payload), (e = e._init);
                try {
                  return H(e(t));
                } catch (e) {}
            }
          return null;
        }
        function V(e) {
          var t = e.type;
          switch (e.tag) {
            case 24:
              return "Cache";
            case 9:
              return (t.displayName || "Context") + ".Consumer";
            case 10:
              return (t._context.displayName || "Context") + ".Provider";
            case 18:
              return "DehydratedFragment";
            case 11:
              return (
                (e = (e = t.render).displayName || e.name || ""),
                t.displayName ||
                  ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef")
              );
            case 7:
              return "Fragment";
            case 5:
              return t;
            case 4:
              return "Portal";
            case 3:
              return "Root";
            case 6:
              return "Text";
            case 16:
              return H(t);
            case 8:
              return t === k ? "StrictMode" : "Mode";
            case 22:
              return "Offscreen";
            case 12:
              return "Profiler";
            case 21:
              return "Scope";
            case 13:
              return "Suspense";
            case 19:
              return "SuspenseList";
            case 25:
              return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if ("function" == typeof t)
                return t.displayName || t.name || null;
              if ("string" == typeof t) return t;
          }
          return null;
        }
        function W(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function $(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function U(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = $(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                void 0 !== n &&
                "function" == typeof n.get &&
                "function" == typeof n.set
              ) {
                var o = n.get,
                  a = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return o.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), a.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function K(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = $(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function G(e) {
          if (
            void 0 ===
            (e = e || ("undefined" != typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        function q(e, t) {
          var n = t.checked;
          return L({}, t, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != n ? n : e._wrapperState.initialChecked,
          });
        }
        function Y(e, t) {
          var n = null == t.defaultValue ? "" : t.defaultValue,
            r = null != t.checked ? t.checked : t.defaultChecked;
          (n = W(null != t.value ? t.value : n)),
            (e._wrapperState = {
              initialChecked: r,
              initialValue: n,
              controlled:
                "checkbox" === t.type || "radio" === t.type
                  ? null != t.checked
                  : null != t.value,
            });
        }
        function J(e, t) {
          null != (t = t.checked) && _(e, "checked", t, !1);
        }
        function Q(e, t) {
          J(e, t);
          var n = W(t.value),
            r = t.type;
          if (null != n)
            "number" === r
              ? ((0 === n && "" === e.value) || e.value != n) &&
                (e.value = "" + n)
              : e.value !== "" + n && (e.value = "" + n);
          else if ("submit" === r || "reset" === r)
            return void e.removeAttribute("value");
          t.hasOwnProperty("value")
            ? ee(e, t.type, n)
            : t.hasOwnProperty("defaultValue") &&
              ee(e, t.type, W(t.defaultValue)),
            null == t.checked &&
              null != t.defaultChecked &&
              (e.defaultChecked = !!t.defaultChecked);
        }
        function X(e, t, n) {
          if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
            var r = t.type;
            if (
              !(
                ("submit" !== r && "reset" !== r) ||
                (void 0 !== t.value && null !== t.value)
              )
            )
              return;
            (t = "" + e._wrapperState.initialValue),
              n || t === e.value || (e.value = t),
              (e.defaultValue = t);
          }
          "" !== (n = e.name) && (e.name = ""),
            (e.defaultChecked = !!e._wrapperState.initialChecked),
            "" !== n && (e.name = n);
        }
        function ee(e, t, n) {
          ("number" === t && G(e.ownerDocument) === e) ||
            (null == n
              ? (e.defaultValue = "" + e._wrapperState.initialValue)
              : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
        }
        var te = Array.isArray;
        function ne(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < n.length; o++) t["$" + n[o]] = !0;
            for (n = 0; n < e.length; n++)
              (o = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== o && (e[n].selected = o),
                o && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + W(n), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === n)
                return (
                  (e[o].selected = !0), void (r && (e[o].defaultSelected = !0))
                );
              null !== t || e[o].disabled || (t = e[o]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function re(e, t) {
          if (null != t.dangerouslySetInnerHTML) throw Error(a(91));
          return L({}, t, {
            value: void 0,
            defaultValue: void 0,
            children: "" + e._wrapperState.initialValue,
          });
        }
        function oe(e, t) {
          var n = t.value;
          if (null == n) {
            if (((n = t.children), (t = t.defaultValue), null != n)) {
              if (null != t) throw Error(a(92));
              if (te(n)) {
                if (1 < n.length) throw Error(a(93));
                n = n[0];
              }
              t = n;
            }
            null == t && (t = ""), (n = t);
          }
          e._wrapperState = { initialValue: W(n) };
        }
        function ae(e, t) {
          var n = W(t.value),
            r = W(t.defaultValue);
          null != n &&
            ((n = "" + n) !== e.value && (e.value = n),
            null == t.defaultValue &&
              e.defaultValue !== n &&
              (e.defaultValue = n)),
            null != r && (e.defaultValue = "" + r);
        }
        function ie(e) {
          var t = e.textContent;
          t === e._wrapperState.initialValue &&
            "" !== t &&
            null !== t &&
            (e.value = t);
        }
        function se(e) {
          switch (e) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function le(e, t) {
          return null == e || "http://www.w3.org/1999/xhtml" === e
            ? se(t)
            : "http://www.w3.org/2000/svg" === e && "foreignObject" === t
            ? "http://www.w3.org/1999/xhtml"
            : e;
        }
        var ce,
          ue,
          de =
            ((ue = function (e, t) {
              if (
                "http://www.w3.org/2000/svg" !== e.namespaceURI ||
                "innerHTML" in e
              )
                e.innerHTML = t;
              else {
                for (
                  (ce = ce || document.createElement("div")).innerHTML =
                    "<svg>" + t.valueOf().toString() + "</svg>",
                    t = ce.firstChild;
                  e.firstChild;

                )
                  e.removeChild(e.firstChild);
                for (; t.firstChild; ) e.appendChild(t.firstChild);
              }
            }),
            "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction
              ? function (e, t, n, r) {
                  MSApp.execUnsafeLocalFunction(function () {
                    return ue(e, t);
                  });
                }
              : ue);
        function pe(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var me = {
            animationIterationCount: !0,
            aspectRatio: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0,
          },
          he = ["Webkit", "ms", "Moz", "O"];
        function fe(e, t, n) {
          return null == t || "boolean" == typeof t || "" === t
            ? ""
            : n ||
              "number" != typeof t ||
              0 === t ||
              (me.hasOwnProperty(e) && me[e])
            ? ("" + t).trim()
            : t + "px";
        }
        function ge(e, t) {
          for (var n in ((e = e.style), t))
            if (t.hasOwnProperty(n)) {
              var r = 0 === n.indexOf("--"),
                o = fe(n, t[n], r);
              "float" === n && (n = "cssFloat"),
                r ? e.setProperty(n, o) : (e[n] = o);
            }
        }
        Object.keys(me).forEach(function (e) {
          he.forEach(function (t) {
            (t = t + e.charAt(0).toUpperCase() + e.substring(1)),
              (me[t] = me[e]);
          });
        });
        var ve = L(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          }
        );
        function be(e, t) {
          if (t) {
            if (
              ve[e] &&
              (null != t.children || null != t.dangerouslySetInnerHTML)
            )
              throw Error(a(137, e));
            if (null != t.dangerouslySetInnerHTML) {
              if (null != t.children) throw Error(a(60));
              if (
                "object" != typeof t.dangerouslySetInnerHTML ||
                !("__html" in t.dangerouslySetInnerHTML)
              )
                throw Error(a(61));
            }
            if (null != t.style && "object" != typeof t.style)
              throw Error(a(62));
          }
        }
        function _e(e, t) {
          if (-1 === e.indexOf("-")) return "string" == typeof t.is;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var ye = null;
        function xe(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var Ce = null,
          Se = null,
          ke = null;
        function we(e) {
          if ((e = yo(e))) {
            if ("function" != typeof Ce) throw Error(a(280));
            var t = e.stateNode;
            t && ((t = Co(t)), Ce(e.stateNode, e.type, t));
          }
        }
        function Pe(e) {
          Se ? (ke ? ke.push(e) : (ke = [e])) : (Se = e);
        }
        function Oe() {
          if (Se) {
            var e = Se,
              t = ke;
            if (((ke = Se = null), we(e), t))
              for (e = 0; e < t.length; e++) we(t[e]);
          }
        }
        function Ie(e, t) {
          return e(t);
        }
        function Te() {}
        var Me = !1;
        function Ee(e, t, n) {
          if (Me) return e(t, n);
          Me = !0;
          try {
            return Ie(e, t, n);
          } finally {
            (Me = !1), (null !== Se || null !== ke) && (Te(), Oe());
          }
        }
        function De(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = Co(n);
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" != typeof n) throw Error(a(231, t, typeof n));
          return n;
        }
        var je = !1;
        if (u)
          try {
            var Re = {};
            Object.defineProperty(Re, "passive", {
              get: function () {
                je = !0;
              },
            }),
              window.addEventListener("test", Re, Re),
              window.removeEventListener("test", Re, Re);
          } catch (ue) {
            je = !1;
          }
        function Ne(e, t, n, r, o, a, i, s, l) {
          var c = Array.prototype.slice.call(arguments, 3);
          try {
            t.apply(n, c);
          } catch (e) {
            this.onError(e);
          }
        }
        var Ae = !1,
          Le = null,
          ze = !1,
          Be = null,
          Ze = {
            onError: function (e) {
              (Ae = !0), (Le = e);
            },
          };
        function Fe(e, t, n, r, o, a, i, s, l) {
          (Ae = !1), (Le = null), Ne.apply(Ze, arguments);
        }
        function He(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              0 != (4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function Ve(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function We(e) {
          if (He(e) !== e) throw Error(a(188));
        }
        function $e(e) {
          return null !==
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = He(e))) throw Error(a(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var o = n.return;
                if (null === o) break;
                var i = o.alternate;
                if (null === i) {
                  if (null !== (r = o.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (o.child === i.child) {
                  for (i = o.child; i; ) {
                    if (i === n) return We(o), e;
                    if (i === r) return We(o), t;
                    i = i.sibling;
                  }
                  throw Error(a(188));
                }
                if (n.return !== r.return) (n = o), (r = i);
                else {
                  for (var s = !1, l = o.child; l; ) {
                    if (l === n) {
                      (s = !0), (n = o), (r = i);
                      break;
                    }
                    if (l === r) {
                      (s = !0), (r = o), (n = i);
                      break;
                    }
                    l = l.sibling;
                  }
                  if (!s) {
                    for (l = i.child; l; ) {
                      if (l === n) {
                        (s = !0), (n = i), (r = o);
                        break;
                      }
                      if (l === r) {
                        (s = !0), (r = i), (n = o);
                        break;
                      }
                      l = l.sibling;
                    }
                    if (!s) throw Error(a(189));
                  }
                }
                if (n.alternate !== r) throw Error(a(190));
              }
              if (3 !== n.tag) throw Error(a(188));
              return n.stateNode.current === n ? e : t;
            })(e))
            ? Ue(e)
            : null;
        }
        function Ue(e) {
          if (5 === e.tag || 6 === e.tag) return e;
          for (e = e.child; null !== e; ) {
            var t = Ue(e);
            if (null !== t) return t;
            e = e.sibling;
          }
          return null;
        }
        var Ke = o.unstable_scheduleCallback,
          Ge = o.unstable_cancelCallback,
          qe = o.unstable_shouldYield,
          Ye = o.unstable_requestPaint,
          Je = o.unstable_now,
          Qe = o.unstable_getCurrentPriorityLevel,
          Xe = o.unstable_ImmediatePriority,
          et = o.unstable_UserBlockingPriority,
          tt = o.unstable_NormalPriority,
          nt = o.unstable_LowPriority,
          rt = o.unstable_IdlePriority,
          ot = null,
          at = null,
          it = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 === (e >>>= 0) ? 32 : (31 - ((st(e) / lt) | 0)) | 0;
              },
          st = Math.log,
          lt = Math.LN2,
          ct = 64,
          ut = 4194304;
        function dt(e) {
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194240 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return 130023424 & e;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 1073741824;
            default:
              return e;
          }
        }
        function pt(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            o = e.suspendedLanes,
            a = e.pingedLanes,
            i = 268435455 & n;
          if (0 !== i) {
            var s = i & ~o;
            0 !== s ? (r = dt(s)) : 0 != (a &= i) && (r = dt(a));
          } else 0 != (i = n & ~o) ? (r = dt(i)) : 0 !== a && (r = dt(a));
          if (0 === r) return 0;
          if (
            0 !== t &&
            t !== r &&
            0 == (t & o) &&
            ((o = r & -r) >= (a = t & -t) || (16 === o && 0 != (4194240 & a)))
          )
            return t;
          if ((0 != (4 & r) && (r |= 16 & n), 0 !== (t = e.entangledLanes)))
            for (e = e.entanglements, t &= r; 0 < t; )
              (o = 1 << (n = 31 - it(t))), (r |= e[n]), (t &= ~o);
          return r;
        }
        function mt(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
              return t + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function ht(e) {
          return 0 != (e = -1073741825 & e.pendingLanes)
            ? e
            : 1073741824 & e
            ? 1073741824
            : 0;
        }
        function ft() {
          var e = ct;
          return 0 == (4194240 & (ct <<= 1)) && (ct = 64), e;
        }
        function gt(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function vt(e, t, n) {
          (e.pendingLanes |= t),
            536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
            ((e = e.eventTimes)[(t = 31 - it(t))] = n);
        }
        function bt(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - it(n),
              o = 1 << r;
            (o & t) | (e[r] & t) && (e[r] |= t), (n &= ~o);
          }
        }
        var _t = 0;
        function yt(e) {
          return 1 < (e &= -e)
            ? 4 < e
              ? 0 != (268435455 & e)
                ? 16
                : 536870912
              : 4
            : 1;
        }
        var xt,
          Ct,
          St,
          kt,
          wt,
          Pt = !1,
          Ot = [],
          It = null,
          Tt = null,
          Mt = null,
          Et = new Map(),
          Dt = new Map(),
          jt = [],
          Rt =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
              " "
            );
        function Nt(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              It = null;
              break;
            case "dragenter":
            case "dragleave":
              Tt = null;
              break;
            case "mouseover":
            case "mouseout":
              Mt = null;
              break;
            case "pointerover":
            case "pointerout":
              Et.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              Dt.delete(t.pointerId);
          }
        }
        function At(e, t, n, r, o, a) {
          return null === e || e.nativeEvent !== a
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: a,
                targetContainers: [o],
              }),
              null !== t && null !== (t = yo(t)) && Ct(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== o && -1 === t.indexOf(o) && t.push(o),
              e);
        }
        function Lt(e) {
          var t = _o(e.target);
          if (null !== t) {
            var n = He(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = Ve(n)))
                  return (
                    (e.blockedOn = t),
                    void wt(e.priority, function () {
                      St(n);
                    })
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function zt(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = qt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
            if (null !== n)
              return null !== (t = yo(n)) && Ct(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (ye = r), n.target.dispatchEvent(r), (ye = null), t.shift();
          }
          return !0;
        }
        function Bt(e, t, n) {
          zt(e) && n.delete(t);
        }
        function Zt() {
          (Pt = !1),
            null !== It && zt(It) && (It = null),
            null !== Tt && zt(Tt) && (Tt = null),
            null !== Mt && zt(Mt) && (Mt = null),
            Et.forEach(Bt),
            Dt.forEach(Bt);
        }
        function Ft(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            Pt ||
              ((Pt = !0),
              o.unstable_scheduleCallback(o.unstable_NormalPriority, Zt)));
        }
        function Ht(e) {
          function t(t) {
            return Ft(t, e);
          }
          if (0 < Ot.length) {
            Ft(Ot[0], e);
            for (var n = 1; n < Ot.length; n++) {
              var r = Ot[n];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (
            null !== It && Ft(It, e),
              null !== Tt && Ft(Tt, e),
              null !== Mt && Ft(Mt, e),
              Et.forEach(t),
              Dt.forEach(t),
              n = 0;
            n < jt.length;
            n++
          )
            (r = jt[n]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < jt.length && null === (n = jt[0]).blockedOn; )
            Lt(n), null === n.blockedOn && jt.shift();
        }
        var Vt = y.ReactCurrentBatchConfig,
          Wt = !0;
        function $t(e, t, n, r) {
          var o = _t,
            a = Vt.transition;
          Vt.transition = null;
          try {
            (_t = 1), Kt(e, t, n, r);
          } finally {
            (_t = o), (Vt.transition = a);
          }
        }
        function Ut(e, t, n, r) {
          var o = _t,
            a = Vt.transition;
          Vt.transition = null;
          try {
            (_t = 4), Kt(e, t, n, r);
          } finally {
            (_t = o), (Vt.transition = a);
          }
        }
        function Kt(e, t, n, r) {
          if (Wt) {
            var o = qt(e, t, n, r);
            if (null === o) Wr(e, t, r, Gt, n), Nt(e, r);
            else if (
              (function (e, t, n, r, o) {
                switch (t) {
                  case "focusin":
                    return (It = At(It, e, t, n, r, o)), !0;
                  case "dragenter":
                    return (Tt = At(Tt, e, t, n, r, o)), !0;
                  case "mouseover":
                    return (Mt = At(Mt, e, t, n, r, o)), !0;
                  case "pointerover":
                    var a = o.pointerId;
                    return Et.set(a, At(Et.get(a) || null, e, t, n, r, o)), !0;
                  case "gotpointercapture":
                    return (
                      (a = o.pointerId),
                      Dt.set(a, At(Dt.get(a) || null, e, t, n, r, o)),
                      !0
                    );
                }
                return !1;
              })(o, e, t, n, r)
            )
              r.stopPropagation();
            else if ((Nt(e, r), 4 & t && -1 < Rt.indexOf(e))) {
              for (; null !== o; ) {
                var a = yo(o);
                if (
                  (null !== a && xt(a),
                  null === (a = qt(e, t, n, r)) && Wr(e, t, r, Gt, n),
                  a === o)
                )
                  break;
                o = a;
              }
              null !== o && r.stopPropagation();
            } else Wr(e, t, r, null, n);
          }
        }
        var Gt = null;
        function qt(e, t, n, r) {
          if (((Gt = null), null !== (e = _o((e = xe(r))))))
            if (null === (t = He(e))) e = null;
            else if (13 === (n = t.tag)) {
              if (null !== (e = Ve(t))) return e;
              e = null;
            } else if (3 === n) {
              if (t.stateNode.current.memoizedState.isDehydrated)
                return 3 === t.tag ? t.stateNode.containerInfo : null;
              e = null;
            } else t !== e && (e = null);
          return (Gt = e), null;
        }
        function Yt(e) {
          switch (e) {
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 1;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 4;
            case "message":
              switch (Qe()) {
                case Xe:
                  return 1;
                case et:
                  return 4;
                case tt:
                case nt:
                  return 16;
                case rt:
                  return 536870912;
                default:
                  return 16;
              }
            default:
              return 16;
          }
        }
        var Jt = null,
          Qt = null,
          Xt = null;
        function en() {
          if (Xt) return Xt;
          var e,
            t,
            n = Qt,
            r = n.length,
            o = "value" in Jt ? Jt.value : Jt.textContent,
            a = o.length;
          for (e = 0; e < r && n[e] === o[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === o[a - t]; t++);
          return (Xt = o.slice(e, 1 < t ? 1 - t : void 0));
        }
        function tn(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function nn() {
          return !0;
        }
        function rn() {
          return !1;
        }
        function on(e) {
          function t(t, n, r, o, a) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = o),
            (this.target = a),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(o) : o[i]));
            return (
              (this.isDefaultPrevented = (
                null != o.defaultPrevented
                  ? o.defaultPrevented
                  : !1 === o.returnValue
              )
                ? nn
                : rn),
              (this.isPropagationStopped = rn),
              this
            );
          }
          return (
            L(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" != typeof e.returnValue && (e.returnValue = !1),
                  (this.isDefaultPrevented = nn));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" != typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = nn));
              },
              persist: function () {},
              isPersistent: nn,
            }),
            t
          );
        }
        var an,
          sn,
          ln,
          cn = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          un = on(cn),
          dn = L({}, cn, { view: 0, detail: 0 }),
          pn = on(dn),
          mn = L({}, dn, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: wn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== ln &&
                    (ln && "mousemove" === e.type
                      ? ((an = e.screenX - ln.screenX),
                        (sn = e.screenY - ln.screenY))
                      : (sn = an = 0),
                    (ln = e)),
                  an);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : sn;
            },
          }),
          hn = on(mn),
          fn = on(L({}, mn, { dataTransfer: 0 })),
          gn = on(L({}, dn, { relatedTarget: 0 })),
          vn = on(
            L({}, cn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          bn = L({}, cn, {
            clipboardData: function (e) {
              return "clipboardData" in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          _n = on(bn),
          yn = on(L({}, cn, { data: 0 })),
          xn = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          Cn = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          Sn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function kn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = Sn[e]) && !!t[e];
        }
        function wn() {
          return kn;
        }
        var Pn = L({}, dn, {
            key: function (e) {
              if (e.key) {
                var t = xn[e.key] || e.key;
                if ("Unidentified" !== t) return t;
              }
              return "keypress" === e.type
                ? 13 === (e = tn(e))
                  ? "Enter"
                  : String.fromCharCode(e)
                : "keydown" === e.type || "keyup" === e.type
                ? Cn[e.keyCode] || "Unidentified"
                : "";
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: wn,
            charCode: function (e) {
              return "keypress" === e.type ? tn(e) : 0;
            },
            keyCode: function (e) {
              return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return "keypress" === e.type
                ? tn(e)
                : "keydown" === e.type || "keyup" === e.type
                ? e.keyCode
                : 0;
            },
          }),
          On = on(Pn),
          In = on(
            L({}, mn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          Tn = on(
            L({}, dn, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: wn,
            })
          ),
          Mn = on(
            L({}, cn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          En = L({}, mn, {
            deltaX: function (e) {
              return "deltaX" in e
                ? e.deltaX
                : "wheelDeltaX" in e
                ? -e.wheelDeltaX
                : 0;
            },
            deltaY: function (e) {
              return "deltaY" in e
                ? e.deltaY
                : "wheelDeltaY" in e
                ? -e.wheelDeltaY
                : "wheelDelta" in e
                ? -e.wheelDelta
                : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Dn = on(En),
          jn = [9, 13, 27, 32],
          Rn = u && "CompositionEvent" in window,
          Nn = null;
        u && "documentMode" in document && (Nn = document.documentMode);
        var An = u && "TextEvent" in window && !Nn,
          Ln = u && (!Rn || (Nn && 8 < Nn && 11 >= Nn)),
          zn = String.fromCharCode(32),
          Bn = !1;
        function Zn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== jn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function Fn(e) {
          return "object" == typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var Hn = !1,
          Vn = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
          };
        function Wn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Vn[e.type] : "textarea" === t;
        }
        function $n(e, t, n, r) {
          Pe(r),
            0 < (t = Ur(t, "onChange")).length &&
              ((n = new un("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t }));
        }
        var Un = null,
          Kn = null;
        function Gn(e) {
          zr(e, 0);
        }
        function qn(e) {
          if (K(xo(e))) return e;
        }
        function Yn(e, t) {
          if ("change" === e) return t;
        }
        var Jn = !1;
        if (u) {
          var Qn;
          if (u) {
            var Xn = "oninput" in document;
            if (!Xn) {
              var er = document.createElement("div");
              er.setAttribute("oninput", "return;"),
                (Xn = "function" == typeof er.oninput);
            }
            Qn = Xn;
          } else Qn = !1;
          Jn = Qn && (!document.documentMode || 9 < document.documentMode);
        }
        function tr() {
          Un && (Un.detachEvent("onpropertychange", nr), (Kn = Un = null));
        }
        function nr(e) {
          if ("value" === e.propertyName && qn(Kn)) {
            var t = [];
            $n(t, Kn, e, xe(e)), Ee(Gn, t);
          }
        }
        function rr(e, t, n) {
          "focusin" === e
            ? (tr(), (Kn = n), (Un = t).attachEvent("onpropertychange", nr))
            : "focusout" === e && tr();
        }
        function or(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return qn(Kn);
        }
        function ar(e, t) {
          if ("click" === e) return qn(t);
        }
        function ir(e, t) {
          if ("input" === e || "change" === e) return qn(t);
        }
        var sr =
          "function" == typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t)
                );
              };
        function lr(e, t) {
          if (sr(e, t)) return !0;
          if (
            "object" != typeof e ||
            null === e ||
            "object" != typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var o = n[r];
            if (!d.call(t, o) || !sr(e[o], t[o])) return !1;
          }
          return !0;
        }
        function cr(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function ur(e, t) {
          var n,
            r = cr(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = cr(r);
          }
        }
        function dr(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? dr(e, t.parentNode)
                  : "contains" in e
                  ? e.contains(t)
                  : !!e.compareDocumentPosition &&
                    !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function pr() {
          for (var e = window, t = G(); t instanceof e.HTMLIFrameElement; ) {
            try {
              var n = "string" == typeof t.contentWindow.location.href;
            } catch (e) {
              n = !1;
            }
            if (!n) break;
            t = G((e = t.contentWindow).document);
          }
          return t;
        }
        function mr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        function hr(e) {
          var t = pr(),
            n = e.focusedElem,
            r = e.selectionRange;
          if (
            t !== n &&
            n &&
            n.ownerDocument &&
            dr(n.ownerDocument.documentElement, n)
          ) {
            if (null !== r && mr(n))
              if (
                ((t = r.start),
                void 0 === (e = r.end) && (e = t),
                "selectionStart" in n)
              )
                (n.selectionStart = t),
                  (n.selectionEnd = Math.min(e, n.value.length));
              else if (
                (e =
                  ((t = n.ownerDocument || document) && t.defaultView) ||
                  window).getSelection
              ) {
                e = e.getSelection();
                var o = n.textContent.length,
                  a = Math.min(r.start, o);
                (r = void 0 === r.end ? a : Math.min(r.end, o)),
                  !e.extend && a > r && ((o = r), (r = a), (a = o)),
                  (o = ur(n, a));
                var i = ur(n, r);
                o &&
                  i &&
                  (1 !== e.rangeCount ||
                    e.anchorNode !== o.node ||
                    e.anchorOffset !== o.offset ||
                    e.focusNode !== i.node ||
                    e.focusOffset !== i.offset) &&
                  ((t = t.createRange()).setStart(o.node, o.offset),
                  e.removeAllRanges(),
                  a > r
                    ? (e.addRange(t), e.extend(i.node, i.offset))
                    : (t.setEnd(i.node, i.offset), e.addRange(t)));
              }
            for (t = [], e = n; (e = e.parentNode); )
              1 === e.nodeType &&
                t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
            for (
              "function" == typeof n.focus && n.focus(), n = 0;
              n < t.length;
              n++
            )
              ((e = t[n]).element.scrollLeft = e.left),
                (e.element.scrollTop = e.top);
          }
        }
        var fr = u && "documentMode" in document && 11 >= document.documentMode,
          gr = null,
          vr = null,
          br = null,
          _r = !1;
        function yr(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
              ? n
              : n.ownerDocument;
          _r ||
            null == gr ||
            gr !== G(r) ||
            ((r =
              "selectionStart" in (r = gr) && mr(r)
                ? { start: r.selectionStart, end: r.selectionEnd }
                : {
                    anchorNode: (r = (
                      (r.ownerDocument && r.ownerDocument.defaultView) ||
                      window
                    ).getSelection()).anchorNode,
                    anchorOffset: r.anchorOffset,
                    focusNode: r.focusNode,
                    focusOffset: r.focusOffset,
                  }),
            (br && lr(br, r)) ||
              ((br = r),
              0 < (r = Ur(vr, "onSelect")).length &&
                ((t = new un("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = gr))));
        }
        function xr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var Cr = {
            animationend: xr("Animation", "AnimationEnd"),
            animationiteration: xr("Animation", "AnimationIteration"),
            animationstart: xr("Animation", "AnimationStart"),
            transitionend: xr("Transition", "TransitionEnd"),
          },
          Sr = {},
          kr = {};
        function wr(e) {
          if (Sr[e]) return Sr[e];
          if (!Cr[e]) return e;
          var t,
            n = Cr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in kr) return (Sr[e] = n[t]);
          return e;
        }
        u &&
          ((kr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete Cr.animationend.animation,
            delete Cr.animationiteration.animation,
            delete Cr.animationstart.animation),
          "TransitionEvent" in window || delete Cr.transitionend.transition);
        var Pr = wr("animationend"),
          Or = wr("animationiteration"),
          Ir = wr("animationstart"),
          Tr = wr("transitionend"),
          Mr = new Map(),
          Er =
            "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
              " "
            );
        function Dr(e, t) {
          Mr.set(e, t), l(t, [e]);
        }
        for (var jr = 0; jr < Er.length; jr++) {
          var Rr = Er[jr];
          Dr(Rr.toLowerCase(), "on" + (Rr[0].toUpperCase() + Rr.slice(1)));
        }
        Dr(Pr, "onAnimationEnd"),
          Dr(Or, "onAnimationIteration"),
          Dr(Ir, "onAnimationStart"),
          Dr("dblclick", "onDoubleClick"),
          Dr("focusin", "onFocus"),
          Dr("focusout", "onBlur"),
          Dr(Tr, "onTransitionEnd"),
          c("onMouseEnter", ["mouseout", "mouseover"]),
          c("onMouseLeave", ["mouseout", "mouseover"]),
          c("onPointerEnter", ["pointerout", "pointerover"]),
          c("onPointerLeave", ["pointerout", "pointerover"]),
          l(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " "
            )
          ),
          l(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " "
            )
          ),
          l("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          l(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          l(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          l(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " "
            )
          );
        var Nr =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " "
            ),
          Ar = new Set(
            "cancel close invalid load scroll toggle".split(" ").concat(Nr)
          );
        function Lr(e, t, n) {
          var r = e.type || "unknown-event";
          (e.currentTarget = n),
            (function (e, t, n, r, o, i, s, l, c) {
              if ((Fe.apply(this, arguments), Ae)) {
                if (!Ae) throw Error(a(198));
                var u = Le;
                (Ae = !1), (Le = null), ze || ((ze = !0), (Be = u));
              }
            })(r, t, void 0, e),
            (e.currentTarget = null);
        }
        function zr(e, t) {
          t = 0 != (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              o = r.event;
            r = r.listeners;
            e: {
              var a = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var s = r[i],
                    l = s.instance,
                    c = s.currentTarget;
                  if (((s = s.listener), l !== a && o.isPropagationStopped()))
                    break e;
                  Lr(o, s, c), (a = l);
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((l = (s = r[i]).instance),
                    (c = s.currentTarget),
                    (s = s.listener),
                    l !== a && o.isPropagationStopped())
                  )
                    break e;
                  Lr(o, s, c), (a = l);
                }
            }
          }
          if (ze) throw ((e = Be), (ze = !1), (Be = null), e);
        }
        function Br(e, t) {
          var n = t[go];
          void 0 === n && (n = t[go] = new Set());
          var r = e + "__bubble";
          n.has(r) || (Vr(t, e, 2, !1), n.add(r));
        }
        function Zr(e, t, n) {
          var r = 0;
          t && (r |= 4), Vr(n, e, r, t);
        }
        var Fr = "_reactListening" + Math.random().toString(36).slice(2);
        function Hr(e) {
          if (!e[Fr]) {
            (e[Fr] = !0),
              i.forEach(function (t) {
                "selectionchange" !== t &&
                  (Ar.has(t) || Zr(t, !1, e), Zr(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Fr] || ((t[Fr] = !0), Zr("selectionchange", !1, t));
          }
        }
        function Vr(e, t, n, r) {
          switch (Yt(t)) {
            case 1:
              var o = $t;
              break;
            case 4:
              o = Ut;
              break;
            default:
              o = Kt;
          }
          (n = o.bind(null, t, n, e)),
            (o = void 0),
            !je ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (o = !0),
            r
              ? void 0 !== o
                ? e.addEventListener(t, n, { capture: !0, passive: o })
                : e.addEventListener(t, n, !0)
              : void 0 !== o
              ? e.addEventListener(t, n, { passive: o })
              : e.addEventListener(t, n, !1);
        }
        function Wr(e, t, n, r, o) {
          var a = r;
          if (0 == (1 & t) && 0 == (2 & t) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var s = r.stateNode.containerInfo;
                if (s === o || (8 === s.nodeType && s.parentNode === o)) break;
                if (4 === i)
                  for (i = r.return; null !== i; ) {
                    var l = i.tag;
                    if (
                      (3 === l || 4 === l) &&
                      ((l = i.stateNode.containerInfo) === o ||
                        (8 === l.nodeType && l.parentNode === o))
                    )
                      return;
                    i = i.return;
                  }
                for (; null !== s; ) {
                  if (null === (i = _o(s))) return;
                  if (5 === (l = i.tag) || 6 === l) {
                    r = a = i;
                    continue e;
                  }
                  s = s.parentNode;
                }
              }
              r = r.return;
            }
          Ee(function () {
            var r = a,
              o = xe(n),
              i = [];
            e: {
              var s = Mr.get(e);
              if (void 0 !== s) {
                var l = un,
                  c = e;
                switch (e) {
                  case "keypress":
                    if (0 === tn(n)) break e;
                  case "keydown":
                  case "keyup":
                    l = On;
                    break;
                  case "focusin":
                    (c = "focus"), (l = gn);
                    break;
                  case "focusout":
                    (c = "blur"), (l = gn);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    l = gn;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    l = hn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    l = fn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    l = Tn;
                    break;
                  case Pr:
                  case Or:
                  case Ir:
                    l = vn;
                    break;
                  case Tr:
                    l = Mn;
                    break;
                  case "scroll":
                    l = pn;
                    break;
                  case "wheel":
                    l = Dn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    l = _n;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    l = In;
                }
                var u = 0 != (4 & t),
                  d = !u && "scroll" === e,
                  p = u ? (null !== s ? s + "Capture" : null) : s;
                u = [];
                for (var m, h = r; null !== h; ) {
                  var f = (m = h).stateNode;
                  if (
                    (5 === m.tag &&
                      null !== f &&
                      ((m = f),
                      null !== p &&
                        null != (f = De(h, p)) &&
                        u.push($r(h, f, m))),
                    d)
                  )
                    break;
                  h = h.return;
                }
                0 < u.length &&
                  ((s = new l(s, c, null, n, o)),
                  i.push({ event: s, listeners: u }));
              }
            }
            if (0 == (7 & t)) {
              if (
                ((l = "mouseout" === e || "pointerout" === e),
                (!(s = "mouseover" === e || "pointerover" === e) ||
                  n === ye ||
                  !(c = n.relatedTarget || n.fromElement) ||
                  (!_o(c) && !c[fo])) &&
                  (l || s) &&
                  ((s =
                    o.window === o
                      ? o
                      : (s = o.ownerDocument)
                      ? s.defaultView || s.parentWindow
                      : window),
                  l
                    ? ((l = r),
                      null !==
                        (c = (c = n.relatedTarget || n.toElement)
                          ? _o(c)
                          : null) &&
                        (c !== (d = He(c)) || (5 !== c.tag && 6 !== c.tag)) &&
                        (c = null))
                    : ((l = null), (c = r)),
                  l !== c))
              ) {
                if (
                  ((u = hn),
                  (f = "onMouseLeave"),
                  (p = "onMouseEnter"),
                  (h = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((u = In),
                    (f = "onPointerLeave"),
                    (p = "onPointerEnter"),
                    (h = "pointer")),
                  (d = null == l ? s : xo(l)),
                  (m = null == c ? s : xo(c)),
                  ((s = new u(f, h + "leave", l, n, o)).target = d),
                  (s.relatedTarget = m),
                  (f = null),
                  _o(o) === r &&
                    (((u = new u(p, h + "enter", c, n, o)).target = m),
                    (u.relatedTarget = d),
                    (f = u)),
                  (d = f),
                  l && c)
                )
                  e: {
                    for (p = c, h = 0, m = u = l; m; m = Kr(m)) h++;
                    for (m = 0, f = p; f; f = Kr(f)) m++;
                    for (; 0 < h - m; ) (u = Kr(u)), h--;
                    for (; 0 < m - h; ) (p = Kr(p)), m--;
                    for (; h--; ) {
                      if (u === p || (null !== p && u === p.alternate)) break e;
                      (u = Kr(u)), (p = Kr(p));
                    }
                    u = null;
                  }
                else u = null;
                null !== l && Gr(i, s, l, u, !1),
                  null !== c && null !== d && Gr(i, d, c, u, !0);
              }
              if (
                "select" ===
                  (l =
                    (s = r ? xo(r) : window).nodeName &&
                    s.nodeName.toLowerCase()) ||
                ("input" === l && "file" === s.type)
              )
                var g = Yn;
              else if (Wn(s))
                if (Jn) g = ir;
                else {
                  g = or;
                  var v = rr;
                }
              else
                (l = s.nodeName) &&
                  "input" === l.toLowerCase() &&
                  ("checkbox" === s.type || "radio" === s.type) &&
                  (g = ar);
              switch (
                (g && (g = g(e, r))
                  ? $n(i, g, n, o)
                  : (v && v(e, s, r),
                    "focusout" === e &&
                      (v = s._wrapperState) &&
                      v.controlled &&
                      "number" === s.type &&
                      ee(s, "number", s.value)),
                (v = r ? xo(r) : window),
                e)
              ) {
                case "focusin":
                  (Wn(v) || "true" === v.contentEditable) &&
                    ((gr = v), (vr = r), (br = null));
                  break;
                case "focusout":
                  br = vr = gr = null;
                  break;
                case "mousedown":
                  _r = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (_r = !1), yr(i, n, o);
                  break;
                case "selectionchange":
                  if (fr) break;
                case "keydown":
                case "keyup":
                  yr(i, n, o);
              }
              var b;
              if (Rn)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var _ = "onCompositionStart";
                      break e;
                    case "compositionend":
                      _ = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      _ = "onCompositionUpdate";
                      break e;
                  }
                  _ = void 0;
                }
              else
                Hn
                  ? Zn(e, n) && (_ = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (_ = "onCompositionStart");
              _ &&
                (Ln &&
                  "ko" !== n.locale &&
                  (Hn || "onCompositionStart" !== _
                    ? "onCompositionEnd" === _ && Hn && (b = en())
                    : ((Qt = "value" in (Jt = o) ? Jt.value : Jt.textContent),
                      (Hn = !0))),
                0 < (v = Ur(r, _)).length &&
                  ((_ = new yn(_, e, null, n, o)),
                  i.push({ event: _, listeners: v }),
                  (b || null !== (b = Fn(n))) && (_.data = b))),
                (b = An
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return Fn(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Bn = !0), zn);
                        case "textInput":
                          return (e = t.data) === zn && Bn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (Hn)
                        return "compositionend" === e || (!Rn && Zn(e, t))
                          ? ((e = en()), (Xt = Qt = Jt = null), (Hn = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return Ln && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (r = Ur(r, "onBeforeInput")).length &&
                  ((o = new yn("onBeforeInput", "beforeinput", null, n, o)),
                  i.push({ event: o, listeners: r }),
                  (o.data = b));
            }
            zr(i, t);
          });
        }
        function $r(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function Ur(e, t) {
          for (var n = t + "Capture", r = []; null !== e; ) {
            var o = e,
              a = o.stateNode;
            5 === o.tag &&
              null !== a &&
              ((o = a),
              null != (a = De(e, n)) && r.unshift($r(e, a, o)),
              null != (a = De(e, t)) && r.push($r(e, a, o))),
              (e = e.return);
          }
          return r;
        }
        function Kr(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function Gr(e, t, n, r, o) {
          for (var a = t._reactName, i = []; null !== n && n !== r; ) {
            var s = n,
              l = s.alternate,
              c = s.stateNode;
            if (null !== l && l === r) break;
            5 === s.tag &&
              null !== c &&
              ((s = c),
              o
                ? null != (l = De(n, a)) && i.unshift($r(n, l, s))
                : o || (null != (l = De(n, a)) && i.push($r(n, l, s)))),
              (n = n.return);
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var qr = /\r\n?/g,
          Yr = /\u0000|\uFFFD/g;
        function Jr(e) {
          return ("string" == typeof e ? e : "" + e)
            .replace(qr, "\n")
            .replace(Yr, "");
        }
        function Qr(e, t, n) {
          if (((t = Jr(t)), Jr(e) !== t && n)) throw Error(a(425));
        }
        function Xr() {}
        var eo = null,
          to = null;
        function no(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" == typeof t.children ||
            "number" == typeof t.children ||
            ("object" == typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var ro = "function" == typeof setTimeout ? setTimeout : void 0,
          oo = "function" == typeof clearTimeout ? clearTimeout : void 0,
          ao = "function" == typeof Promise ? Promise : void 0,
          io =
            "function" == typeof queueMicrotask
              ? queueMicrotask
              : void 0 !== ao
              ? function (e) {
                  return ao.resolve(null).then(e).catch(so);
                }
              : ro;
        function so(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function lo(e, t) {
          var n = t,
            r = 0;
          do {
            var o = n.nextSibling;
            if ((e.removeChild(n), o && 8 === o.nodeType))
              if ("/$" === (n = o.data)) {
                if (0 === r) return e.removeChild(o), void Ht(t);
                r--;
              } else ("$" !== n && "$?" !== n && "$!" !== n) || r++;
            n = o;
          } while (n);
          Ht(t);
        }
        function co(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if ("$" === (t = e.data) || "$!" === t || "$?" === t) break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        function uo(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var po = Math.random().toString(36).slice(2),
          mo = "__reactFiber$" + po,
          ho = "__reactProps$" + po,
          fo = "__reactContainer$" + po,
          go = "__reactEvents$" + po,
          vo = "__reactListeners$" + po,
          bo = "__reactHandles$" + po;
        function _o(e) {
          var t = e[mo];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[fo] || n[mo])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = uo(e); null !== e; ) {
                  if ((n = e[mo])) return n;
                  e = uo(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function yo(e) {
          return !(e = e[mo] || e[fo]) ||
            (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
            ? null
            : e;
        }
        function xo(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(a(33));
        }
        function Co(e) {
          return e[ho] || null;
        }
        var So = [],
          ko = -1;
        function wo(e) {
          return { current: e };
        }
        function Po(e) {
          0 > ko || ((e.current = So[ko]), (So[ko] = null), ko--);
        }
        function Oo(e, t) {
          ko++, (So[ko] = e.current), (e.current = t);
        }
        var Io = {},
          To = wo(Io),
          Mo = wo(!1),
          Eo = Io;
        function Do(e, t) {
          var n = e.type.contextTypes;
          if (!n) return Io;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
            return r.__reactInternalMemoizedMaskedChildContext;
          var o,
            a = {};
          for (o in n) a[o] = t[o];
          return (
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                t),
              (e.__reactInternalMemoizedMaskedChildContext = a)),
            a
          );
        }
        function jo(e) {
          return null != e.childContextTypes;
        }
        function Ro() {
          Po(Mo), Po(To);
        }
        function No(e, t, n) {
          if (To.current !== Io) throw Error(a(168));
          Oo(To, t), Oo(Mo, n);
        }
        function Ao(e, t, n) {
          var r = e.stateNode;
          if (
            ((t = t.childContextTypes), "function" != typeof r.getChildContext)
          )
            return n;
          for (var o in (r = r.getChildContext()))
            if (!(o in t)) throw Error(a(108, V(e) || "Unknown", o));
          return L({}, n, r);
        }
        function Lo(e) {
          return (
            (e =
              ((e = e.stateNode) &&
                e.__reactInternalMemoizedMergedChildContext) ||
              Io),
            (Eo = To.current),
            Oo(To, e),
            Oo(Mo, Mo.current),
            !0
          );
        }
        function zo(e, t, n) {
          var r = e.stateNode;
          if (!r) throw Error(a(169));
          n
            ? ((e = Ao(e, t, Eo)),
              (r.__reactInternalMemoizedMergedChildContext = e),
              Po(Mo),
              Po(To),
              Oo(To, e))
            : Po(Mo),
            Oo(Mo, n);
        }
        var Bo = null,
          Zo = !1,
          Fo = !1;
        function Ho(e) {
          null === Bo ? (Bo = [e]) : Bo.push(e);
        }
        function Vo() {
          if (!Fo && null !== Bo) {
            Fo = !0;
            var e = 0,
              t = _t;
            try {
              var n = Bo;
              for (_t = 1; e < n.length; e++) {
                var r = n[e];
                do {
                  r = r(!0);
                } while (null !== r);
              }
              (Bo = null), (Zo = !1);
            } catch (t) {
              throw (null !== Bo && (Bo = Bo.slice(e + 1)), Ke(Xe, Vo), t);
            } finally {
              (_t = t), (Fo = !1);
            }
          }
          return null;
        }
        var Wo = [],
          $o = 0,
          Uo = null,
          Ko = 0,
          Go = [],
          qo = 0,
          Yo = null,
          Jo = 1,
          Qo = "";
        function Xo(e, t) {
          (Wo[$o++] = Ko), (Wo[$o++] = Uo), (Uo = e), (Ko = t);
        }
        function ea(e, t, n) {
          (Go[qo++] = Jo), (Go[qo++] = Qo), (Go[qo++] = Yo), (Yo = e);
          var r = Jo;
          e = Qo;
          var o = 32 - it(r) - 1;
          (r &= ~(1 << o)), (n += 1);
          var a = 32 - it(t) + o;
          if (30 < a) {
            var i = o - (o % 5);
            (a = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (o -= i),
              (Jo = (1 << (32 - it(t) + o)) | (n << o) | r),
              (Qo = a + e);
          } else (Jo = (1 << a) | (n << o) | r), (Qo = e);
        }
        function ta(e) {
          null !== e.return && (Xo(e, 1), ea(e, 1, 0));
        }
        function na(e) {
          for (; e === Uo; )
            (Uo = Wo[--$o]), (Wo[$o] = null), (Ko = Wo[--$o]), (Wo[$o] = null);
          for (; e === Yo; )
            (Yo = Go[--qo]),
              (Go[qo] = null),
              (Qo = Go[--qo]),
              (Go[qo] = null),
              (Jo = Go[--qo]),
              (Go[qo] = null);
        }
        var ra = null,
          oa = null,
          aa = !1,
          ia = null;
        function sa(e, t) {
          var n = Dc(5, null, null, 0);
          (n.elementType = "DELETED"),
            (n.stateNode = t),
            (n.return = e),
            null === (t = e.deletions)
              ? ((e.deletions = [n]), (e.flags |= 16))
              : t.push(n);
        }
        function la(e, t) {
          switch (e.tag) {
            case 5:
              var n = e.type;
              return (
                null !==
                  (t =
                    1 !== t.nodeType ||
                    n.toLowerCase() !== t.nodeName.toLowerCase()
                      ? null
                      : t) &&
                ((e.stateNode = t), (ra = e), (oa = co(t.firstChild)), !0)
              );
            case 6:
              return (
                null !==
                  (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) &&
                ((e.stateNode = t), (ra = e), (oa = null), !0)
              );
            case 13:
              return (
                null !== (t = 8 !== t.nodeType ? null : t) &&
                ((n = null !== Yo ? { id: Jo, overflow: Qo } : null),
                (e.memoizedState = {
                  dehydrated: t,
                  treeContext: n,
                  retryLane: 1073741824,
                }),
                ((n = Dc(18, null, null, 0)).stateNode = t),
                (n.return = e),
                (e.child = n),
                (ra = e),
                (oa = null),
                !0)
              );
            default:
              return !1;
          }
        }
        function ca(e) {
          return 0 != (1 & e.mode) && 0 == (128 & e.flags);
        }
        function ua(e) {
          if (aa) {
            var t = oa;
            if (t) {
              var n = t;
              if (!la(e, t)) {
                if (ca(e)) throw Error(a(418));
                t = co(n.nextSibling);
                var r = ra;
                t && la(e, t)
                  ? sa(r, n)
                  : ((e.flags = (-4097 & e.flags) | 2), (aa = !1), (ra = e));
              }
            } else {
              if (ca(e)) throw Error(a(418));
              (e.flags = (-4097 & e.flags) | 2), (aa = !1), (ra = e);
            }
          }
        }
        function da(e) {
          for (
            e = e.return;
            null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;

          )
            e = e.return;
          ra = e;
        }
        function pa(e) {
          if (e !== ra) return !1;
          if (!aa) return da(e), (aa = !0), !1;
          var t;
          if (
            ((t = 3 !== e.tag) &&
              !(t = 5 !== e.tag) &&
              (t =
                "head" !== (t = e.type) &&
                "body" !== t &&
                !no(e.type, e.memoizedProps)),
            t && (t = oa))
          ) {
            if (ca(e)) throw (ma(), Error(a(418)));
            for (; t; ) sa(e, t), (t = co(t.nextSibling));
          }
          if ((da(e), 13 === e.tag)) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(a(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (8 === e.nodeType) {
                  var n = e.data;
                  if ("/$" === n) {
                    if (0 === t) {
                      oa = co(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else ("$" !== n && "$!" !== n && "$?" !== n) || t++;
                }
                e = e.nextSibling;
              }
              oa = null;
            }
          } else oa = ra ? co(e.stateNode.nextSibling) : null;
          return !0;
        }
        function ma() {
          for (var e = oa; e; ) e = co(e.nextSibling);
        }
        function ha() {
          (oa = ra = null), (aa = !1);
        }
        function fa(e) {
          null === ia ? (ia = [e]) : ia.push(e);
        }
        var ga = y.ReactCurrentBatchConfig;
        function va(e, t) {
          if (e && e.defaultProps) {
            for (var n in ((t = L({}, t)), (e = e.defaultProps)))
              void 0 === t[n] && (t[n] = e[n]);
            return t;
          }
          return t;
        }
        var ba = wo(null),
          _a = null,
          ya = null,
          xa = null;
        function Ca() {
          xa = ya = _a = null;
        }
        function Sa(e) {
          var t = ba.current;
          Po(ba), (e._currentValue = t);
        }
        function ka(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function wa(e, t) {
          (_a = e),
            (xa = ya = null),
            null !== (e = e.dependencies) &&
              null !== e.firstContext &&
              (0 != (e.lanes & t) && (ys = !0), (e.firstContext = null));
        }
        function Pa(e) {
          var t = e._currentValue;
          if (xa !== e)
            if (
              ((e = { context: e, memoizedValue: t, next: null }), null === ya)
            ) {
              if (null === _a) throw Error(a(308));
              (ya = e), (_a.dependencies = { lanes: 0, firstContext: e });
            } else ya = ya.next = e;
          return t;
        }
        var Oa = null;
        function Ia(e) {
          null === Oa ? (Oa = [e]) : Oa.push(e);
        }
        function Ta(e, t, n, r) {
          var o = t.interleaved;
          return (
            null === o
              ? ((n.next = n), Ia(t))
              : ((n.next = o.next), (o.next = n)),
            (t.interleaved = n),
            Ma(e, r)
          );
        }
        function Ma(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e; )
            (e.childLanes |= t),
              null !== (n = e.alternate) && (n.childLanes |= t),
              (n = e),
              (e = e.return);
          return 3 === n.tag ? n.stateNode : null;
        }
        var Ea = !1;
        function Da(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          };
        }
        function ja(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                effects: e.effects,
              });
        }
        function Ra(e, t) {
          return {
            eventTime: e,
            lane: t,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
          };
        }
        function Na(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 0 != (2 & Tl))) {
            var o = r.pending;
            return (
              null === o ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (r.pending = t),
              Ma(e, n)
            );
          }
          return (
            null === (o = r.interleaved)
              ? ((t.next = t), Ia(r))
              : ((t.next = o.next), (o.next = t)),
            (r.interleaved = t),
            Ma(e, n)
          );
        }
        function Aa(e, t, n) {
          if (
            null !== (t = t.updateQueue) &&
            ((t = t.shared), 0 != (4194240 & n))
          ) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), bt(e, n);
          }
        }
        function La(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var o = null,
              a = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  eventTime: n.eventTime,
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: n.callback,
                  next: null,
                };
                null === a ? (o = a = i) : (a = a.next = i), (n = n.next);
              } while (null !== n);
              null === a ? (o = a = t) : (a = a.next = t);
            } else o = a = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: o,
                lastBaseUpdate: a,
                shared: r.shared,
                effects: r.effects,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t);
        }
        function za(e, t, n, r) {
          var o = e.updateQueue;
          Ea = !1;
          var a = o.firstBaseUpdate,
            i = o.lastBaseUpdate,
            s = o.shared.pending;
          if (null !== s) {
            o.shared.pending = null;
            var l = s,
              c = l.next;
            (l.next = null), null === i ? (a = c) : (i.next = c), (i = l);
            var u = e.alternate;
            null !== u &&
              (s = (u = u.updateQueue).lastBaseUpdate) !== i &&
              (null === s ? (u.firstBaseUpdate = c) : (s.next = c),
              (u.lastBaseUpdate = l));
          }
          if (null !== a) {
            var d = o.baseState;
            for (i = 0, u = c = l = null, s = a; ; ) {
              var p = s.lane,
                m = s.eventTime;
              if ((r & p) === p) {
                null !== u &&
                  (u = u.next =
                    {
                      eventTime: m,
                      lane: 0,
                      tag: s.tag,
                      payload: s.payload,
                      callback: s.callback,
                      next: null,
                    });
                e: {
                  var h = e,
                    f = s;
                  switch (((p = t), (m = n), f.tag)) {
                    case 1:
                      if ("function" == typeof (h = f.payload)) {
                        d = h.call(m, d, p);
                        break e;
                      }
                      d = h;
                      break e;
                    case 3:
                      h.flags = (-65537 & h.flags) | 128;
                    case 0:
                      if (
                        null ==
                        (p =
                          "function" == typeof (h = f.payload)
                            ? h.call(m, d, p)
                            : h)
                      )
                        break e;
                      d = L({}, d, p);
                      break e;
                    case 2:
                      Ea = !0;
                  }
                }
                null !== s.callback &&
                  0 !== s.lane &&
                  ((e.flags |= 64),
                  null === (p = o.effects) ? (o.effects = [s]) : p.push(s));
              } else
                (m = {
                  eventTime: m,
                  lane: p,
                  tag: s.tag,
                  payload: s.payload,
                  callback: s.callback,
                  next: null,
                }),
                  null === u ? ((c = u = m), (l = d)) : (u = u.next = m),
                  (i |= p);
              if (null === (s = s.next)) {
                if (null === (s = o.shared.pending)) break;
                (s = (p = s).next),
                  (p.next = null),
                  (o.lastBaseUpdate = p),
                  (o.shared.pending = null);
              }
            }
            if (
              (null === u && (l = d),
              (o.baseState = l),
              (o.firstBaseUpdate = c),
              (o.lastBaseUpdate = u),
              null !== (t = o.shared.interleaved))
            ) {
              o = t;
              do {
                (i |= o.lane), (o = o.next);
              } while (o !== t);
            } else null === a && (o.shared.lanes = 0);
            (Ll |= i), (e.lanes = i), (e.memoizedState = d);
          }
        }
        function Ba(e, t, n) {
          if (((e = t.effects), (t.effects = null), null !== e))
            for (t = 0; t < e.length; t++) {
              var r = e[t],
                o = r.callback;
              if (null !== o) {
                if (((r.callback = null), (r = n), "function" != typeof o))
                  throw Error(a(191, o));
                o.call(r);
              }
            }
        }
        var Za = new r.Component().refs;
        function Fa(e, t, n, r) {
          (n = null == (n = n(r, (t = e.memoizedState))) ? t : L({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        var Ha = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && He(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = tc(),
              o = nc(e),
              a = Ra(r, o);
            (a.payload = t),
              null != n && (a.callback = n),
              null !== (t = Na(e, a, o)) && (rc(t, e, o, r), Aa(t, e, o));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = tc(),
              o = nc(e),
              a = Ra(r, o);
            (a.tag = 1),
              (a.payload = t),
              null != n && (a.callback = n),
              null !== (t = Na(e, a, o)) && (rc(t, e, o, r), Aa(t, e, o));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = tc(),
              r = nc(e),
              o = Ra(n, r);
            (o.tag = 2),
              null != t && (o.callback = t),
              null !== (t = Na(e, o, r)) && (rc(t, e, r, n), Aa(t, e, r));
          },
        };
        function Va(e, t, n, r, o, a, i) {
          return "function" == typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, a, i)
            : !(
                t.prototype &&
                t.prototype.isPureReactComponent &&
                lr(n, r) &&
                lr(o, a)
              );
        }
        function Wa(e, t, n) {
          var r = !1,
            o = Io,
            a = t.contextType;
          return (
            "object" == typeof a && null !== a
              ? (a = Pa(a))
              : ((o = jo(t) ? Eo : To.current),
                (a = (r = null != (r = t.contextTypes)) ? Do(e, o) : Io)),
            (t = new t(n, a)),
            (e.memoizedState =
              null !== t.state && void 0 !== t.state ? t.state : null),
            (t.updater = Ha),
            (e.stateNode = t),
            (t._reactInternals = e),
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                o),
              (e.__reactInternalMemoizedMaskedChildContext = a)),
            t
          );
        }
        function $a(e, t, n, r) {
          (e = t.state),
            "function" == typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" == typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && Ha.enqueueReplaceState(t, t.state, null);
        }
        function Ua(e, t, n, r) {
          var o = e.stateNode;
          (o.props = n), (o.state = e.memoizedState), (o.refs = Za), Da(e);
          var a = t.contextType;
          "object" == typeof a && null !== a
            ? (o.context = Pa(a))
            : ((a = jo(t) ? Eo : To.current), (o.context = Do(e, a))),
            (o.state = e.memoizedState),
            "function" == typeof (a = t.getDerivedStateFromProps) &&
              (Fa(e, t, a, n), (o.state = e.memoizedState)),
            "function" == typeof t.getDerivedStateFromProps ||
              "function" == typeof o.getSnapshotBeforeUpdate ||
              ("function" != typeof o.UNSAFE_componentWillMount &&
                "function" != typeof o.componentWillMount) ||
              ((t = o.state),
              "function" == typeof o.componentWillMount &&
                o.componentWillMount(),
              "function" == typeof o.UNSAFE_componentWillMount &&
                o.UNSAFE_componentWillMount(),
              t !== o.state && Ha.enqueueReplaceState(o, o.state, null),
              za(e, n, o, r),
              (o.state = e.memoizedState)),
            "function" == typeof o.componentDidMount && (e.flags |= 4194308);
        }
        function Ka(e, t, n) {
          if (
            null !== (e = n.ref) &&
            "function" != typeof e &&
            "object" != typeof e
          ) {
            if (n._owner) {
              if ((n = n._owner)) {
                if (1 !== n.tag) throw Error(a(309));
                var r = n.stateNode;
              }
              if (!r) throw Error(a(147, e));
              var o = r,
                i = "" + e;
              return null !== t &&
                null !== t.ref &&
                "function" == typeof t.ref &&
                t.ref._stringRef === i
                ? t.ref
                : ((t = function (e) {
                    var t = o.refs;
                    t === Za && (t = o.refs = {}),
                      null === e ? delete t[i] : (t[i] = e);
                  }),
                  (t._stringRef = i),
                  t);
            }
            if ("string" != typeof e) throw Error(a(284));
            if (!n._owner) throw Error(a(290, e));
          }
          return e;
        }
        function Ga(e, t) {
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(
              a(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e
              )
            ))
          );
        }
        function qa(e) {
          return (0, e._init)(e._payload);
        }
        function Ya(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e, t) {
            for (e = new Map(); null !== t; )
              null !== t.key ? e.set(t.key, t) : e.set(t.index, t),
                (t = t.sibling);
            return e;
          }
          function o(e, t) {
            return ((e = Rc(e, t)).index = 0), (e.sibling = null), e;
          }
          function i(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 2), n)
                    : r
                  : ((t.flags |= 2), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function s(t) {
            return e && null === t.alternate && (t.flags |= 2), t;
          }
          function l(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = zc(n, e.mode, r)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function c(e, t, n, r) {
            var a = n.type;
            return a === S
              ? d(e, t, n.props.children, r, n.key)
              : null !== t &&
                (t.elementType === a ||
                  ("object" == typeof a &&
                    null !== a &&
                    a.$$typeof === D &&
                    qa(a) === t.type))
              ? (((r = o(t, n.props)).ref = Ka(e, t, n)), (r.return = e), r)
              : (((r = Nc(n.type, n.key, n.props, null, e.mode, r)).ref = Ka(
                  e,
                  t,
                  n
                )),
                (r.return = e),
                r);
          }
          function u(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = Bc(n, e.mode, r)).return = e), t)
              : (((t = o(t, n.children || [])).return = e), t);
          }
          function d(e, t, n, r, a) {
            return null === t || 7 !== t.tag
              ? (((t = Ac(n, e.mode, r, a)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function p(e, t, n) {
            if (("string" == typeof t && "" !== t) || "number" == typeof t)
              return ((t = zc("" + t, e.mode, n)).return = e), t;
            if ("object" == typeof t && null !== t) {
              switch (t.$$typeof) {
                case x:
                  return (
                    ((n = Nc(t.type, t.key, t.props, null, e.mode, n)).ref = Ka(
                      e,
                      null,
                      t
                    )),
                    (n.return = e),
                    n
                  );
                case C:
                  return ((t = Bc(t, e.mode, n)).return = e), t;
                case D:
                  return p(e, (0, t._init)(t._payload), n);
              }
              if (te(t) || N(t))
                return ((t = Ac(t, e.mode, n, null)).return = e), t;
              Ga(e, t);
            }
            return null;
          }
          function m(e, t, n, r) {
            var o = null !== t ? t.key : null;
            if (("string" == typeof n && "" !== n) || "number" == typeof n)
              return null !== o ? null : l(e, t, "" + n, r);
            if ("object" == typeof n && null !== n) {
              switch (n.$$typeof) {
                case x:
                  return n.key === o ? c(e, t, n, r) : null;
                case C:
                  return n.key === o ? u(e, t, n, r) : null;
                case D:
                  return m(e, t, (o = n._init)(n._payload), r);
              }
              if (te(n) || N(n)) return null !== o ? null : d(e, t, n, r, null);
              Ga(e, n);
            }
            return null;
          }
          function h(e, t, n, r, o) {
            if (("string" == typeof r && "" !== r) || "number" == typeof r)
              return l(t, (e = e.get(n) || null), "" + r, o);
            if ("object" == typeof r && null !== r) {
              switch (r.$$typeof) {
                case x:
                  return c(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case C:
                  return u(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case D:
                  return h(e, t, n, (0, r._init)(r._payload), o);
              }
              if (te(r) || N(r))
                return d(t, (e = e.get(n) || null), r, o, null);
              Ga(t, r);
            }
            return null;
          }
          function f(o, a, s, l) {
            for (
              var c = null, u = null, d = a, f = (a = 0), g = null;
              null !== d && f < s.length;
              f++
            ) {
              d.index > f ? ((g = d), (d = null)) : (g = d.sibling);
              var v = m(o, d, s[f], l);
              if (null === v) {
                null === d && (d = g);
                break;
              }
              e && d && null === v.alternate && t(o, d),
                (a = i(v, a, f)),
                null === u ? (c = v) : (u.sibling = v),
                (u = v),
                (d = g);
            }
            if (f === s.length) return n(o, d), aa && Xo(o, f), c;
            if (null === d) {
              for (; f < s.length; f++)
                null !== (d = p(o, s[f], l)) &&
                  ((a = i(d, a, f)),
                  null === u ? (c = d) : (u.sibling = d),
                  (u = d));
              return aa && Xo(o, f), c;
            }
            for (d = r(o, d); f < s.length; f++)
              null !== (g = h(d, o, f, s[f], l)) &&
                (e &&
                  null !== g.alternate &&
                  d.delete(null === g.key ? f : g.key),
                (a = i(g, a, f)),
                null === u ? (c = g) : (u.sibling = g),
                (u = g));
            return (
              e &&
                d.forEach(function (e) {
                  return t(o, e);
                }),
              aa && Xo(o, f),
              c
            );
          }
          function g(o, s, l, c) {
            var u = N(l);
            if ("function" != typeof u) throw Error(a(150));
            if (null == (l = u.call(l))) throw Error(a(151));
            for (
              var d = (u = null), f = s, g = (s = 0), v = null, b = l.next();
              null !== f && !b.done;
              g++, b = l.next()
            ) {
              f.index > g ? ((v = f), (f = null)) : (v = f.sibling);
              var _ = m(o, f, b.value, c);
              if (null === _) {
                null === f && (f = v);
                break;
              }
              e && f && null === _.alternate && t(o, f),
                (s = i(_, s, g)),
                null === d ? (u = _) : (d.sibling = _),
                (d = _),
                (f = v);
            }
            if (b.done) return n(o, f), aa && Xo(o, g), u;
            if (null === f) {
              for (; !b.done; g++, b = l.next())
                null !== (b = p(o, b.value, c)) &&
                  ((s = i(b, s, g)),
                  null === d ? (u = b) : (d.sibling = b),
                  (d = b));
              return aa && Xo(o, g), u;
            }
            for (f = r(o, f); !b.done; g++, b = l.next())
              null !== (b = h(f, o, g, b.value, c)) &&
                (e &&
                  null !== b.alternate &&
                  f.delete(null === b.key ? g : b.key),
                (s = i(b, s, g)),
                null === d ? (u = b) : (d.sibling = b),
                (d = b));
            return (
              e &&
                f.forEach(function (e) {
                  return t(o, e);
                }),
              aa && Xo(o, g),
              u
            );
          }
          return function e(r, a, i, l) {
            if (
              ("object" == typeof i &&
                null !== i &&
                i.type === S &&
                null === i.key &&
                (i = i.props.children),
              "object" == typeof i && null !== i)
            ) {
              switch (i.$$typeof) {
                case x:
                  e: {
                    for (var c = i.key, u = a; null !== u; ) {
                      if (u.key === c) {
                        if ((c = i.type) === S) {
                          if (7 === u.tag) {
                            n(r, u.sibling),
                              ((a = o(u, i.props.children)).return = r),
                              (r = a);
                            break e;
                          }
                        } else if (
                          u.elementType === c ||
                          ("object" == typeof c &&
                            null !== c &&
                            c.$$typeof === D &&
                            qa(c) === u.type)
                        ) {
                          n(r, u.sibling),
                            ((a = o(u, i.props)).ref = Ka(r, u, i)),
                            (a.return = r),
                            (r = a);
                          break e;
                        }
                        n(r, u);
                        break;
                      }
                      t(r, u), (u = u.sibling);
                    }
                    i.type === S
                      ? (((a = Ac(i.props.children, r.mode, l, i.key)).return =
                          r),
                        (r = a))
                      : (((l = Nc(
                          i.type,
                          i.key,
                          i.props,
                          null,
                          r.mode,
                          l
                        )).ref = Ka(r, a, i)),
                        (l.return = r),
                        (r = l));
                  }
                  return s(r);
                case C:
                  e: {
                    for (u = i.key; null !== a; ) {
                      if (a.key === u) {
                        if (
                          4 === a.tag &&
                          a.stateNode.containerInfo === i.containerInfo &&
                          a.stateNode.implementation === i.implementation
                        ) {
                          n(r, a.sibling),
                            ((a = o(a, i.children || [])).return = r),
                            (r = a);
                          break e;
                        }
                        n(r, a);
                        break;
                      }
                      t(r, a), (a = a.sibling);
                    }
                    ((a = Bc(i, r.mode, l)).return = r), (r = a);
                  }
                  return s(r);
                case D:
                  return e(r, a, (u = i._init)(i._payload), l);
              }
              if (te(i)) return f(r, a, i, l);
              if (N(i)) return g(r, a, i, l);
              Ga(r, i);
            }
            return ("string" == typeof i && "" !== i) || "number" == typeof i
              ? ((i = "" + i),
                null !== a && 6 === a.tag
                  ? (n(r, a.sibling), ((a = o(a, i)).return = r), (r = a))
                  : (n(r, a), ((a = zc(i, r.mode, l)).return = r), (r = a)),
                s(r))
              : n(r, a);
          };
        }
        var Ja = Ya(!0),
          Qa = Ya(!1),
          Xa = {},
          ei = wo(Xa),
          ti = wo(Xa),
          ni = wo(Xa);
        function ri(e) {
          if (e === Xa) throw Error(a(174));
          return e;
        }
        function oi(e, t) {
          switch ((Oo(ni, t), Oo(ti, e), Oo(ei, Xa), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) ? t.namespaceURI : le(null, "");
              break;
            default:
              t = le(
                (t = (e = 8 === e ? t.parentNode : t).namespaceURI || null),
                (e = e.tagName)
              );
          }
          Po(ei), Oo(ei, t);
        }
        function ai() {
          Po(ei), Po(ti), Po(ni);
        }
        function ii(e) {
          ri(ni.current);
          var t = ri(ei.current),
            n = le(t, e.type);
          t !== n && (Oo(ti, e), Oo(ei, n));
        }
        function si(e) {
          ti.current === e && (Po(ei), Po(ti));
        }
        var li = wo(0);
        function ci(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) ||
                  "$?" === n.data ||
                  "$!" === n.data)
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 != (128 & t.flags)) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        var ui = [];
        function di() {
          for (var e = 0; e < ui.length; e++)
            ui[e]._workInProgressVersionPrimary = null;
          ui.length = 0;
        }
        var pi = y.ReactCurrentDispatcher,
          mi = y.ReactCurrentBatchConfig,
          hi = 0,
          fi = null,
          gi = null,
          vi = null,
          bi = !1,
          _i = !1,
          yi = 0,
          xi = 0;
        function Ci() {
          throw Error(a(321));
        }
        function Si(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!sr(e[n], t[n])) return !1;
          return !0;
        }
        function ki(e, t, n, r, o, i) {
          if (
            ((hi = i),
            (fi = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (pi.current = null === e || null === e.memoizedState ? ss : ls),
            (e = n(r, o)),
            _i)
          ) {
            i = 0;
            do {
              if (((_i = !1), (yi = 0), 25 <= i)) throw Error(a(301));
              (i += 1),
                (vi = gi = null),
                (t.updateQueue = null),
                (pi.current = cs),
                (e = n(r, o));
            } while (_i);
          }
          if (
            ((pi.current = is),
            (t = null !== gi && null !== gi.next),
            (hi = 0),
            (vi = gi = fi = null),
            (bi = !1),
            t)
          )
            throw Error(a(300));
          return e;
        }
        function wi() {
          var e = 0 !== yi;
          return (yi = 0), e;
        }
        function Pi() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === vi ? (fi.memoizedState = vi = e) : (vi = vi.next = e), vi
          );
        }
        function Oi() {
          if (null === gi) {
            var e = fi.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = gi.next;
          var t = null === vi ? fi.memoizedState : vi.next;
          if (null !== t) (vi = t), (gi = e);
          else {
            if (null === e) throw Error(a(310));
            (e = {
              memoizedState: (gi = e).memoizedState,
              baseState: gi.baseState,
              baseQueue: gi.baseQueue,
              queue: gi.queue,
              next: null,
            }),
              null === vi ? (fi.memoizedState = vi = e) : (vi = vi.next = e);
          }
          return vi;
        }
        function Ii(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
        function Ti(e) {
          var t = Oi(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = gi,
            o = r.baseQueue,
            i = n.pending;
          if (null !== i) {
            if (null !== o) {
              var s = o.next;
              (o.next = i.next), (i.next = s);
            }
            (r.baseQueue = o = i), (n.pending = null);
          }
          if (null !== o) {
            (i = o.next), (r = r.baseState);
            var l = (s = null),
              c = null,
              u = i;
            do {
              var d = u.lane;
              if ((hi & d) === d)
                null !== c &&
                  (c = c.next =
                    {
                      lane: 0,
                      action: u.action,
                      hasEagerState: u.hasEagerState,
                      eagerState: u.eagerState,
                      next: null,
                    }),
                  (r = u.hasEagerState ? u.eagerState : e(r, u.action));
              else {
                var p = {
                  lane: d,
                  action: u.action,
                  hasEagerState: u.hasEagerState,
                  eagerState: u.eagerState,
                  next: null,
                };
                null === c ? ((l = c = p), (s = r)) : (c = c.next = p),
                  (fi.lanes |= d),
                  (Ll |= d);
              }
              u = u.next;
            } while (null !== u && u !== i);
            null === c ? (s = r) : (c.next = l),
              sr(r, t.memoizedState) || (ys = !0),
              (t.memoizedState = r),
              (t.baseState = s),
              (t.baseQueue = c),
              (n.lastRenderedState = r);
          }
          if (null !== (e = n.interleaved)) {
            o = e;
            do {
              (i = o.lane), (fi.lanes |= i), (Ll |= i), (o = o.next);
            } while (o !== e);
          } else null === o && (n.lanes = 0);
          return [t.memoizedState, n.dispatch];
        }
        function Mi(e) {
          var t = Oi(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            o = n.pending,
            i = t.memoizedState;
          if (null !== o) {
            n.pending = null;
            var s = (o = o.next);
            do {
              (i = e(i, s.action)), (s = s.next);
            } while (s !== o);
            sr(i, t.memoizedState) || (ys = !0),
              (t.memoizedState = i),
              null === t.baseQueue && (t.baseState = i),
              (n.lastRenderedState = i);
          }
          return [i, r];
        }
        function Ei() {}
        function Di(e, t) {
          var n = fi,
            r = Oi(),
            o = t(),
            i = !sr(r.memoizedState, o);
          if (
            (i && ((r.memoizedState = o), (ys = !0)),
            (r = r.queue),
            Wi(Ni.bind(null, n, r, e), [e]),
            r.getSnapshot !== t ||
              i ||
              (null !== vi && 1 & vi.memoizedState.tag))
          ) {
            if (
              ((n.flags |= 2048),
              Bi(9, Ri.bind(null, n, r, o, t), void 0, null),
              null === Ml)
            )
              throw Error(a(349));
            0 != (30 & hi) || ji(n, t, o);
          }
          return o;
        }
        function ji(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = fi.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (fi.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
              ? (t.stores = [e])
              : n.push(e);
        }
        function Ri(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), Ai(t) && Li(e);
        }
        function Ni(e, t, n) {
          return n(function () {
            Ai(t) && Li(e);
          });
        }
        function Ai(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !sr(e, n);
          } catch (e) {
            return !0;
          }
        }
        function Li(e) {
          var t = Ma(e, 1);
          null !== t && rc(t, e, 1, -1);
        }
        function zi(e) {
          var t = Pi();
          return (
            "function" == typeof e && (e = e()),
            (t.memoizedState = t.baseState = e),
            (e = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ii,
              lastRenderedState: e,
            }),
            (t.queue = e),
            (e = e.dispatch = ns.bind(null, fi, e)),
            [t.memoizedState, e]
          );
        }
        function Bi(e, t, n, r) {
          return (
            (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
            null === (t = fi.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (fi.updateQueue = t),
                (t.lastEffect = e.next = e))
              : null === (n = t.lastEffect)
              ? (t.lastEffect = e.next = e)
              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
            e
          );
        }
        function Zi() {
          return Oi().memoizedState;
        }
        function Fi(e, t, n, r) {
          var o = Pi();
          (fi.flags |= e),
            (o.memoizedState = Bi(1 | t, n, void 0, void 0 === r ? null : r));
        }
        function Hi(e, t, n, r) {
          var o = Oi();
          r = void 0 === r ? null : r;
          var a = void 0;
          if (null !== gi) {
            var i = gi.memoizedState;
            if (((a = i.destroy), null !== r && Si(r, i.deps)))
              return void (o.memoizedState = Bi(t, n, a, r));
          }
          (fi.flags |= e), (o.memoizedState = Bi(1 | t, n, a, r));
        }
        function Vi(e, t) {
          return Fi(8390656, 8, e, t);
        }
        function Wi(e, t) {
          return Hi(2048, 8, e, t);
        }
        function $i(e, t) {
          return Hi(4, 2, e, t);
        }
        function Ui(e, t) {
          return Hi(4, 4, e, t);
        }
        function Ki(e, t) {
          return "function" == typeof t
            ? ((e = e()),
              t(e),
              function () {
                t(null);
              })
            : null != t
            ? ((e = e()),
              (t.current = e),
              function () {
                t.current = null;
              })
            : void 0;
        }
        function Gi(e, t, n) {
          return (
            (n = null != n ? n.concat([e]) : null),
            Hi(4, 4, Ki.bind(null, t, e), n)
          );
        }
        function qi() {}
        function Yi(e, t) {
          var n = Oi();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && Si(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function Ji(e, t) {
          var n = Oi();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && Si(t, r[1])
            ? r[0]
            : ((e = e()), (n.memoizedState = [e, t]), e);
        }
        function Qi(e, t, n) {
          return 0 == (21 & hi)
            ? (e.baseState && ((e.baseState = !1), (ys = !0)),
              (e.memoizedState = n))
            : (sr(n, t) ||
                ((n = ft()), (fi.lanes |= n), (Ll |= n), (e.baseState = !0)),
              t);
        }
        function Xi(e, t) {
          var n = _t;
          (_t = 0 !== n && 4 > n ? n : 4), e(!0);
          var r = mi.transition;
          mi.transition = {};
          try {
            e(!1), t();
          } finally {
            (_t = n), (mi.transition = r);
          }
        }
        function es() {
          return Oi().memoizedState;
        }
        function ts(e, t, n) {
          var r = nc(e);
          (n = {
            lane: r,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            rs(e)
              ? os(t, n)
              : null !== (n = Ta(e, t, n, r)) &&
                (rc(n, e, r, tc()), as(n, t, r));
        }
        function ns(e, t, n) {
          var r = nc(e),
            o = {
              lane: r,
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            };
          if (rs(e)) os(t, o);
          else {
            var a = e.alternate;
            if (
              0 === e.lanes &&
              (null === a || 0 === a.lanes) &&
              null !== (a = t.lastRenderedReducer)
            )
              try {
                var i = t.lastRenderedState,
                  s = a(i, n);
                if (((o.hasEagerState = !0), (o.eagerState = s), sr(s, i))) {
                  var l = t.interleaved;
                  return (
                    null === l
                      ? ((o.next = o), Ia(t))
                      : ((o.next = l.next), (l.next = o)),
                    void (t.interleaved = o)
                  );
                }
              } catch (e) {}
            null !== (n = Ta(e, t, o, r)) &&
              (rc(n, e, r, (o = tc())), as(n, t, r));
          }
        }
        function rs(e) {
          var t = e.alternate;
          return e === fi || (null !== t && t === fi);
        }
        function os(e, t) {
          _i = bi = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t);
        }
        function as(e, t, n) {
          if (0 != (4194240 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), bt(e, n);
          }
        }
        var is = {
            readContext: Pa,
            useCallback: Ci,
            useContext: Ci,
            useEffect: Ci,
            useImperativeHandle: Ci,
            useInsertionEffect: Ci,
            useLayoutEffect: Ci,
            useMemo: Ci,
            useReducer: Ci,
            useRef: Ci,
            useState: Ci,
            useDebugValue: Ci,
            useDeferredValue: Ci,
            useTransition: Ci,
            useMutableSource: Ci,
            useSyncExternalStore: Ci,
            useId: Ci,
            unstable_isNewReconciler: !1,
          },
          ss = {
            readContext: Pa,
            useCallback: function (e, t) {
              return (Pi().memoizedState = [e, void 0 === t ? null : t]), e;
            },
            useContext: Pa,
            useEffect: Vi,
            useImperativeHandle: function (e, t, n) {
              return (
                (n = null != n ? n.concat([e]) : null),
                Fi(4194308, 4, Ki.bind(null, t, e), n)
              );
            },
            useLayoutEffect: function (e, t) {
              return Fi(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              return Fi(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = Pi();
              return (
                (t = void 0 === t ? null : t),
                (e = e()),
                (n.memoizedState = [e, t]),
                e
              );
            },
            useReducer: function (e, t, n) {
              var r = Pi();
              return (
                (t = void 0 !== n ? n(t) : t),
                (r.memoizedState = r.baseState = t),
                (e = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: t,
                }),
                (r.queue = e),
                (e = e.dispatch = ts.bind(null, fi, e)),
                [r.memoizedState, e]
              );
            },
            useRef: function (e) {
              return (e = { current: e }), (Pi().memoizedState = e);
            },
            useState: zi,
            useDebugValue: qi,
            useDeferredValue: function (e) {
              return (Pi().memoizedState = e);
            },
            useTransition: function () {
              var e = zi(!1),
                t = e[0];
              return (
                (e = Xi.bind(null, e[1])), (Pi().memoizedState = e), [t, e]
              );
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (e, t, n) {
              var r = fi,
                o = Pi();
              if (aa) {
                if (void 0 === n) throw Error(a(407));
                n = n();
              } else {
                if (((n = t()), null === Ml)) throw Error(a(349));
                0 != (30 & hi) || ji(r, t, n);
              }
              o.memoizedState = n;
              var i = { value: n, getSnapshot: t };
              return (
                (o.queue = i),
                Vi(Ni.bind(null, r, i, e), [e]),
                (r.flags |= 2048),
                Bi(9, Ri.bind(null, r, i, n, t), void 0, null),
                n
              );
            },
            useId: function () {
              var e = Pi(),
                t = Ml.identifierPrefix;
              if (aa) {
                var n = Qo;
                (t =
                  ":" +
                  t +
                  "R" +
                  (n = (Jo & ~(1 << (32 - it(Jo) - 1))).toString(32) + n)),
                  0 < (n = yi++) && (t += "H" + n.toString(32)),
                  (t += ":");
              } else t = ":" + t + "r" + (n = xi++).toString(32) + ":";
              return (e.memoizedState = t);
            },
            unstable_isNewReconciler: !1,
          },
          ls = {
            readContext: Pa,
            useCallback: Yi,
            useContext: Pa,
            useEffect: Wi,
            useImperativeHandle: Gi,
            useInsertionEffect: $i,
            useLayoutEffect: Ui,
            useMemo: Ji,
            useReducer: Ti,
            useRef: Zi,
            useState: function () {
              return Ti(Ii);
            },
            useDebugValue: qi,
            useDeferredValue: function (e) {
              return Qi(Oi(), gi.memoizedState, e);
            },
            useTransition: function () {
              return [Ti(Ii)[0], Oi().memoizedState];
            },
            useMutableSource: Ei,
            useSyncExternalStore: Di,
            useId: es,
            unstable_isNewReconciler: !1,
          },
          cs = {
            readContext: Pa,
            useCallback: Yi,
            useContext: Pa,
            useEffect: Wi,
            useImperativeHandle: Gi,
            useInsertionEffect: $i,
            useLayoutEffect: Ui,
            useMemo: Ji,
            useReducer: Mi,
            useRef: Zi,
            useState: function () {
              return Mi(Ii);
            },
            useDebugValue: qi,
            useDeferredValue: function (e) {
              var t = Oi();
              return null === gi
                ? (t.memoizedState = e)
                : Qi(t, gi.memoizedState, e);
            },
            useTransition: function () {
              return [Mi(Ii)[0], Oi().memoizedState];
            },
            useMutableSource: Ei,
            useSyncExternalStore: Di,
            useId: es,
            unstable_isNewReconciler: !1,
          };
        function us(e, t) {
          try {
            var n = "",
              r = t;
            do {
              (n += F(r)), (r = r.return);
            } while (r);
            var o = n;
          } catch (e) {
            o = "\nError generating stack: " + e.message + "\n" + e.stack;
          }
          return { value: e, source: t, stack: o, digest: null };
        }
        function ds(e, t, n) {
          return {
            value: e,
            source: null,
            stack: null != n ? n : null,
            digest: null != t ? t : null,
          };
        }
        function ps(e, t) {
          try {
            console.error(t.value);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        var ms = "function" == typeof WeakMap ? WeakMap : Map;
        function hs(e, t, n) {
          ((n = Ra(-1, n)).tag = 3), (n.payload = { element: null });
          var r = t.value;
          return (
            (n.callback = function () {
              $l || (($l = !0), (Ul = r)), ps(0, t);
            }),
            n
          );
        }
        function fs(e, t, n) {
          (n = Ra(-1, n)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ("function" == typeof r) {
            var o = t.value;
            (n.payload = function () {
              return r(o);
            }),
              (n.callback = function () {
                ps(0, t);
              });
          }
          var a = e.stateNode;
          return (
            null !== a &&
              "function" == typeof a.componentDidCatch &&
              (n.callback = function () {
                ps(0, t),
                  "function" != typeof r &&
                    (null === Kl ? (Kl = new Set([this])) : Kl.add(this));
                var e = t.stack;
                this.componentDidCatch(t.value, {
                  componentStack: null !== e ? e : "",
                });
              }),
            n
          );
        }
        function gs(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new ms();
            var o = new Set();
            r.set(t, o);
          } else void 0 === (o = r.get(t)) && ((o = new Set()), r.set(t, o));
          o.has(n) || (o.add(n), (e = Pc.bind(null, e, t, n)), t.then(e, e));
        }
        function vs(e) {
          do {
            var t;
            if (
              ((t = 13 === e.tag) &&
                (t = null === (t = e.memoizedState) || null !== t.dehydrated),
              t)
            )
              return e;
            e = e.return;
          } while (null !== e);
          return null;
        }
        function bs(e, t, n, r, o) {
          return 0 == (1 & e.mode)
            ? (e === t
                ? (e.flags |= 65536)
                : ((e.flags |= 128),
                  (n.flags |= 131072),
                  (n.flags &= -52805),
                  1 === n.tag &&
                    (null === n.alternate
                      ? (n.tag = 17)
                      : (((t = Ra(-1, 1)).tag = 2), Na(n, t, 1))),
                  (n.lanes |= 1)),
              e)
            : ((e.flags |= 65536), (e.lanes = o), e);
        }
        var _s = y.ReactCurrentOwner,
          ys = !1;
        function xs(e, t, n, r) {
          t.child = null === e ? Qa(t, null, n, r) : Ja(t, e.child, n, r);
        }
        function Cs(e, t, n, r, o) {
          n = n.render;
          var a = t.ref;
          return (
            wa(t, o),
            (r = ki(e, t, n, r, a, o)),
            (n = wi()),
            null === e || ys
              ? (aa && n && ta(t), (t.flags |= 1), xs(e, t, r, o), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~o),
                $s(e, t, o))
          );
        }
        function Ss(e, t, n, r, o) {
          if (null === e) {
            var a = n.type;
            return "function" != typeof a ||
              jc(a) ||
              void 0 !== a.defaultProps ||
              null !== n.compare ||
              void 0 !== n.defaultProps
              ? (((e = Nc(n.type, null, r, t, t.mode, o)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = a), ks(e, t, a, r, o));
          }
          if (((a = e.child), 0 == (e.lanes & o))) {
            var i = a.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : lr)(i, r) &&
              e.ref === t.ref
            )
              return $s(e, t, o);
          }
          return (
            (t.flags |= 1),
            ((e = Rc(a, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function ks(e, t, n, r, o) {
          if (null !== e) {
            var a = e.memoizedProps;
            if (lr(a, r) && e.ref === t.ref) {
              if (((ys = !1), (t.pendingProps = r = a), 0 == (e.lanes & o)))
                return (t.lanes = e.lanes), $s(e, t, o);
              0 != (131072 & e.flags) && (ys = !0);
            }
          }
          return Os(e, t, n, r, o);
        }
        function ws(e, t, n) {
          var r = t.pendingProps,
            o = r.children,
            a = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode)
            if (0 == (1 & t.mode))
              (t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                Oo(Rl, jl),
                (jl |= n);
            else {
              if (0 == (1073741824 & n))
                return (
                  (e = null !== a ? a.baseLanes | n : n),
                  (t.lanes = t.childLanes = 1073741824),
                  (t.memoizedState = {
                    baseLanes: e,
                    cachePool: null,
                    transitions: null,
                  }),
                  (t.updateQueue = null),
                  Oo(Rl, jl),
                  (jl |= e),
                  null
                );
              (t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                (r = null !== a ? a.baseLanes : n),
                Oo(Rl, jl),
                (jl |= r);
            }
          else
            null !== a
              ? ((r = a.baseLanes | n), (t.memoizedState = null))
              : (r = n),
              Oo(Rl, jl),
              (jl |= r);
          return xs(e, t, o, n), t.child;
        }
        function Ps(e, t) {
          var n = t.ref;
          ((null === e && null !== n) || (null !== e && e.ref !== n)) &&
            ((t.flags |= 512), (t.flags |= 2097152));
        }
        function Os(e, t, n, r, o) {
          var a = jo(n) ? Eo : To.current;
          return (
            (a = Do(t, a)),
            wa(t, o),
            (n = ki(e, t, n, r, a, o)),
            (r = wi()),
            null === e || ys
              ? (aa && r && ta(t), (t.flags |= 1), xs(e, t, n, o), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~o),
                $s(e, t, o))
          );
        }
        function Is(e, t, n, r, o) {
          if (jo(n)) {
            var a = !0;
            Lo(t);
          } else a = !1;
          if ((wa(t, o), null === t.stateNode))
            Ws(e, t), Wa(t, n, r), Ua(t, n, r, o), (r = !0);
          else if (null === e) {
            var i = t.stateNode,
              s = t.memoizedProps;
            i.props = s;
            var l = i.context,
              c = n.contextType;
            c =
              "object" == typeof c && null !== c
                ? Pa(c)
                : Do(t, (c = jo(n) ? Eo : To.current));
            var u = n.getDerivedStateFromProps,
              d =
                "function" == typeof u ||
                "function" == typeof i.getSnapshotBeforeUpdate;
            d ||
              ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
                "function" != typeof i.componentWillReceiveProps) ||
              ((s !== r || l !== c) && $a(t, i, r, c)),
              (Ea = !1);
            var p = t.memoizedState;
            (i.state = p),
              za(t, r, i, o),
              (l = t.memoizedState),
              s !== r || p !== l || Mo.current || Ea
                ? ("function" == typeof u &&
                    (Fa(t, n, u, r), (l = t.memoizedState)),
                  (s = Ea || Va(t, n, s, r, p, l, c))
                    ? (d ||
                        ("function" != typeof i.UNSAFE_componentWillMount &&
                          "function" != typeof i.componentWillMount) ||
                        ("function" == typeof i.componentWillMount &&
                          i.componentWillMount(),
                        "function" == typeof i.UNSAFE_componentWillMount &&
                          i.UNSAFE_componentWillMount()),
                      "function" == typeof i.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" == typeof i.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = l)),
                  (i.props = r),
                  (i.state = l),
                  (i.context = c),
                  (r = s))
                : ("function" == typeof i.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1));
          } else {
            (i = t.stateNode),
              ja(e, t),
              (s = t.memoizedProps),
              (c = t.type === t.elementType ? s : va(t.type, s)),
              (i.props = c),
              (d = t.pendingProps),
              (p = i.context),
              (l =
                "object" == typeof (l = n.contextType) && null !== l
                  ? Pa(l)
                  : Do(t, (l = jo(n) ? Eo : To.current)));
            var m = n.getDerivedStateFromProps;
            (u =
              "function" == typeof m ||
              "function" == typeof i.getSnapshotBeforeUpdate) ||
              ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
                "function" != typeof i.componentWillReceiveProps) ||
              ((s !== d || p !== l) && $a(t, i, r, l)),
              (Ea = !1),
              (p = t.memoizedState),
              (i.state = p),
              za(t, r, i, o);
            var h = t.memoizedState;
            s !== d || p !== h || Mo.current || Ea
              ? ("function" == typeof m &&
                  (Fa(t, n, m, r), (h = t.memoizedState)),
                (c = Ea || Va(t, n, c, r, p, h, l) || !1)
                  ? (u ||
                      ("function" != typeof i.UNSAFE_componentWillUpdate &&
                        "function" != typeof i.componentWillUpdate) ||
                      ("function" == typeof i.componentWillUpdate &&
                        i.componentWillUpdate(r, h, l),
                      "function" == typeof i.UNSAFE_componentWillUpdate &&
                        i.UNSAFE_componentWillUpdate(r, h, l)),
                    "function" == typeof i.componentDidUpdate && (t.flags |= 4),
                    "function" == typeof i.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" != typeof i.componentDidUpdate ||
                      (s === e.memoizedProps && p === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" != typeof i.getSnapshotBeforeUpdate ||
                      (s === e.memoizedProps && p === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = h)),
                (i.props = r),
                (i.state = h),
                (i.context = l),
                (r = c))
              : ("function" != typeof i.componentDidUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 4),
                "function" != typeof i.getSnapshotBeforeUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return Ts(e, t, n, r, a, o);
        }
        function Ts(e, t, n, r, o, a) {
          Ps(e, t);
          var i = 0 != (128 & t.flags);
          if (!r && !i) return o && zo(t, n, !1), $s(e, t, a);
          (r = t.stateNode), (_s.current = t);
          var s =
            i && "function" != typeof n.getDerivedStateFromError
              ? null
              : r.render();
          return (
            (t.flags |= 1),
            null !== e && i
              ? ((t.child = Ja(t, e.child, null, a)),
                (t.child = Ja(t, null, s, a)))
              : xs(e, t, s, a),
            (t.memoizedState = r.state),
            o && zo(t, n, !0),
            t.child
          );
        }
        function Ms(e) {
          var t = e.stateNode;
          t.pendingContext
            ? No(0, t.pendingContext, t.pendingContext !== t.context)
            : t.context && No(0, t.context, !1),
            oi(e, t.containerInfo);
        }
        function Es(e, t, n, r, o) {
          return ha(), fa(o), (t.flags |= 256), xs(e, t, n, r), t.child;
        }
        var Ds,
          js,
          Rs,
          Ns,
          As = { dehydrated: null, treeContext: null, retryLane: 0 };
        function Ls(e) {
          return { baseLanes: e, cachePool: null, transitions: null };
        }
        function zs(e, t, n) {
          var r,
            o = t.pendingProps,
            i = li.current,
            s = !1,
            l = 0 != (128 & t.flags);
          if (
            ((r = l) ||
              (r = (null === e || null !== e.memoizedState) && 0 != (2 & i)),
            r
              ? ((s = !0), (t.flags &= -129))
              : (null !== e && null === e.memoizedState) || (i |= 1),
            Oo(li, 1 & i),
            null === e)
          )
            return (
              ua(t),
              null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
                ? (0 == (1 & t.mode)
                    ? (t.lanes = 1)
                    : "$!" === e.data
                    ? (t.lanes = 8)
                    : (t.lanes = 1073741824),
                  null)
                : ((l = o.children),
                  (e = o.fallback),
                  s
                    ? ((o = t.mode),
                      (s = t.child),
                      (l = { mode: "hidden", children: l }),
                      0 == (1 & o) && null !== s
                        ? ((s.childLanes = 0), (s.pendingProps = l))
                        : (s = Lc(l, o, 0, null)),
                      (e = Ac(e, o, n, null)),
                      (s.return = t),
                      (e.return = t),
                      (s.sibling = e),
                      (t.child = s),
                      (t.child.memoizedState = Ls(n)),
                      (t.memoizedState = As),
                      e)
                    : Bs(t, l))
            );
          if (null !== (i = e.memoizedState) && null !== (r = i.dehydrated))
            return (function (e, t, n, r, o, i, s) {
              if (n)
                return 256 & t.flags
                  ? ((t.flags &= -257), Zs(e, t, s, (r = ds(Error(a(422))))))
                  : null !== t.memoizedState
                  ? ((t.child = e.child), (t.flags |= 128), null)
                  : ((i = r.fallback),
                    (o = t.mode),
                    (r = Lc(
                      { mode: "visible", children: r.children },
                      o,
                      0,
                      null
                    )),
                    ((i = Ac(i, o, s, null)).flags |= 2),
                    (r.return = t),
                    (i.return = t),
                    (r.sibling = i),
                    (t.child = r),
                    0 != (1 & t.mode) && Ja(t, e.child, null, s),
                    (t.child.memoizedState = Ls(s)),
                    (t.memoizedState = As),
                    i);
              if (0 == (1 & t.mode)) return Zs(e, t, s, null);
              if ("$!" === o.data) {
                if ((r = o.nextSibling && o.nextSibling.dataset))
                  var l = r.dgst;
                return (
                  (r = l), Zs(e, t, s, (r = ds((i = Error(a(419))), r, void 0)))
                );
              }
              if (((l = 0 != (s & e.childLanes)), ys || l)) {
                if (null !== (r = Ml)) {
                  switch (s & -s) {
                    case 4:
                      o = 2;
                      break;
                    case 16:
                      o = 8;
                      break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      o = 32;
                      break;
                    case 536870912:
                      o = 268435456;
                      break;
                    default:
                      o = 0;
                  }
                  0 !== (o = 0 != (o & (r.suspendedLanes | s)) ? 0 : o) &&
                    o !== i.retryLane &&
                    ((i.retryLane = o), Ma(e, o), rc(r, e, o, -1));
                }
                return gc(), Zs(e, t, s, (r = ds(Error(a(421)))));
              }
              return "$?" === o.data
                ? ((t.flags |= 128),
                  (t.child = e.child),
                  (t = Ic.bind(null, e)),
                  (o._reactRetry = t),
                  null)
                : ((e = i.treeContext),
                  (oa = co(o.nextSibling)),
                  (ra = t),
                  (aa = !0),
                  (ia = null),
                  null !== e &&
                    ((Go[qo++] = Jo),
                    (Go[qo++] = Qo),
                    (Go[qo++] = Yo),
                    (Jo = e.id),
                    (Qo = e.overflow),
                    (Yo = t)),
                  ((t = Bs(t, r.children)).flags |= 4096),
                  t);
            })(e, t, l, o, r, i, n);
          if (s) {
            (s = o.fallback), (l = t.mode), (r = (i = e.child).sibling);
            var c = { mode: "hidden", children: o.children };
            return (
              0 == (1 & l) && t.child !== i
                ? (((o = t.child).childLanes = 0),
                  (o.pendingProps = c),
                  (t.deletions = null))
                : ((o = Rc(i, c)).subtreeFlags = 14680064 & i.subtreeFlags),
              null !== r
                ? (s = Rc(r, s))
                : ((s = Ac(s, l, n, null)).flags |= 2),
              (s.return = t),
              (o.return = t),
              (o.sibling = s),
              (t.child = o),
              (o = s),
              (s = t.child),
              (l =
                null === (l = e.child.memoizedState)
                  ? Ls(n)
                  : {
                      baseLanes: l.baseLanes | n,
                      cachePool: null,
                      transitions: l.transitions,
                    }),
              (s.memoizedState = l),
              (s.childLanes = e.childLanes & ~n),
              (t.memoizedState = As),
              o
            );
          }
          return (
            (e = (s = e.child).sibling),
            (o = Rc(s, { mode: "visible", children: o.children })),
            0 == (1 & t.mode) && (o.lanes = n),
            (o.return = t),
            (o.sibling = null),
            null !== e &&
              (null === (n = t.deletions)
                ? ((t.deletions = [e]), (t.flags |= 16))
                : n.push(e)),
            (t.child = o),
            (t.memoizedState = null),
            o
          );
        }
        function Bs(e, t) {
          return (
            ((t = Lc(
              { mode: "visible", children: t },
              e.mode,
              0,
              null
            )).return = e),
            (e.child = t)
          );
        }
        function Zs(e, t, n, r) {
          return (
            null !== r && fa(r),
            Ja(t, e.child, null, n),
            ((e = Bs(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Fs(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), ka(e.return, t, n);
        }
        function Hs(e, t, n, r, o) {
          var a = e.memoizedState;
          null === a
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: o,
              })
            : ((a.isBackwards = t),
              (a.rendering = null),
              (a.renderingStartTime = 0),
              (a.last = r),
              (a.tail = n),
              (a.tailMode = o));
        }
        function Vs(e, t, n) {
          var r = t.pendingProps,
            o = r.revealOrder,
            a = r.tail;
          if ((xs(e, t, r.children, n), 0 != (2 & (r = li.current))))
            (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 0 != (128 & e.flags))
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && Fs(e, n, t);
                else if (19 === e.tag) Fs(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          if ((Oo(li, r), 0 == (1 & t.mode))) t.memoizedState = null;
          else
            switch (o) {
              case "forwards":
                for (n = t.child, o = null; null !== n; )
                  null !== (e = n.alternate) && null === ci(e) && (o = n),
                    (n = n.sibling);
                null === (n = o)
                  ? ((o = t.child), (t.child = null))
                  : ((o = n.sibling), (n.sibling = null)),
                  Hs(t, !1, o, n, a);
                break;
              case "backwards":
                for (n = null, o = t.child, t.child = null; null !== o; ) {
                  if (null !== (e = o.alternate) && null === ci(e)) {
                    t.child = o;
                    break;
                  }
                  (e = o.sibling), (o.sibling = n), (n = o), (o = e);
                }
                Hs(t, !0, n, null, a);
                break;
              case "together":
                Hs(t, !1, null, null, void 0);
                break;
              default:
                t.memoizedState = null;
            }
          return t.child;
        }
        function Ws(e, t) {
          0 == (1 & t.mode) &&
            null !== e &&
            ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
        }
        function $s(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (Ll |= t.lanes),
            0 == (n & t.childLanes))
          )
            return null;
          if (null !== e && t.child !== e.child) throw Error(a(153));
          if (null !== t.child) {
            for (
              n = Rc((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;

            )
              (e = e.sibling),
                ((n = n.sibling = Rc(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function Us(e, t) {
          if (!aa)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t; )
                  null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n; )
                  null !== n.alternate && (r = n), (n = n.sibling);
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function Ks(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= 14680064 & o.subtreeFlags),
                (r |= 14680064 & o.flags),
                (o.return = e),
                (o = o.sibling);
          else
            for (o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= o.subtreeFlags),
                (r |= o.flags),
                (o.return = e),
                (o = o.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function Gs(e, t, n) {
          var r = t.pendingProps;
          switch ((na(t), t.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return Ks(t), null;
            case 1:
            case 17:
              return jo(t.type) && Ro(), Ks(t), null;
            case 3:
              return (
                (r = t.stateNode),
                ai(),
                Po(Mo),
                Po(To),
                di(),
                r.pendingContext &&
                  ((r.context = r.pendingContext), (r.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (pa(t)
                    ? (t.flags |= 4)
                    : null === e ||
                      (e.memoizedState.isDehydrated && 0 == (256 & t.flags)) ||
                      ((t.flags |= 1024),
                      null !== ia && (sc(ia), (ia = null)))),
                js(e, t),
                Ks(t),
                null
              );
            case 5:
              si(t);
              var o = ri(ni.current);
              if (((n = t.type), null !== e && null != t.stateNode))
                Rs(e, t, n, r, o),
                  e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(a(166));
                  return Ks(t), null;
                }
                if (((e = ri(ei.current)), pa(t))) {
                  (r = t.stateNode), (n = t.type);
                  var i = t.memoizedProps;
                  switch (
                    ((r[mo] = t), (r[ho] = i), (e = 0 != (1 & t.mode)), n)
                  ) {
                    case "dialog":
                      Br("cancel", r), Br("close", r);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      Br("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (o = 0; o < Nr.length; o++) Br(Nr[o], r);
                      break;
                    case "source":
                      Br("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      Br("error", r), Br("load", r);
                      break;
                    case "details":
                      Br("toggle", r);
                      break;
                    case "input":
                      Y(r, i), Br("invalid", r);
                      break;
                    case "select":
                      (r._wrapperState = { wasMultiple: !!i.multiple }),
                        Br("invalid", r);
                      break;
                    case "textarea":
                      oe(r, i), Br("invalid", r);
                  }
                  for (var l in (be(n, i), (o = null), i))
                    if (i.hasOwnProperty(l)) {
                      var c = i[l];
                      "children" === l
                        ? "string" == typeof c
                          ? r.textContent !== c &&
                            (!0 !== i.suppressHydrationWarning &&
                              Qr(r.textContent, c, e),
                            (o = ["children", c]))
                          : "number" == typeof c &&
                            r.textContent !== "" + c &&
                            (!0 !== i.suppressHydrationWarning &&
                              Qr(r.textContent, c, e),
                            (o = ["children", "" + c]))
                        : s.hasOwnProperty(l) &&
                          null != c &&
                          "onScroll" === l &&
                          Br("scroll", r);
                    }
                  switch (n) {
                    case "input":
                      U(r), X(r, i, !0);
                      break;
                    case "textarea":
                      U(r), ie(r);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" == typeof i.onClick && (r.onclick = Xr);
                  }
                  (r = o), (t.updateQueue = r), null !== r && (t.flags |= 4);
                } else {
                  (l = 9 === o.nodeType ? o : o.ownerDocument),
                    "http://www.w3.org/1999/xhtml" === e && (e = se(n)),
                    "http://www.w3.org/1999/xhtml" === e
                      ? "script" === n
                        ? (((e = l.createElement("div")).innerHTML =
                            "<script></script>"),
                          (e = e.removeChild(e.firstChild)))
                        : "string" == typeof r.is
                        ? (e = l.createElement(n, { is: r.is }))
                        : ((e = l.createElement(n)),
                          "select" === n &&
                            ((l = e),
                            r.multiple
                              ? (l.multiple = !0)
                              : r.size && (l.size = r.size)))
                      : (e = l.createElementNS(e, n)),
                    (e[mo] = t),
                    (e[ho] = r),
                    Ds(e, t, !1, !1),
                    (t.stateNode = e);
                  e: {
                    switch (((l = _e(n, r)), n)) {
                      case "dialog":
                        Br("cancel", e), Br("close", e), (o = r);
                        break;
                      case "iframe":
                      case "object":
                      case "embed":
                        Br("load", e), (o = r);
                        break;
                      case "video":
                      case "audio":
                        for (o = 0; o < Nr.length; o++) Br(Nr[o], e);
                        o = r;
                        break;
                      case "source":
                        Br("error", e), (o = r);
                        break;
                      case "img":
                      case "image":
                      case "link":
                        Br("error", e), Br("load", e), (o = r);
                        break;
                      case "details":
                        Br("toggle", e), (o = r);
                        break;
                      case "input":
                        Y(e, r), (o = q(e, r)), Br("invalid", e);
                        break;
                      case "option":
                      default:
                        o = r;
                        break;
                      case "select":
                        (e._wrapperState = { wasMultiple: !!r.multiple }),
                          (o = L({}, r, { value: void 0 })),
                          Br("invalid", e);
                        break;
                      case "textarea":
                        oe(e, r), (o = re(e, r)), Br("invalid", e);
                    }
                    for (i in (be(n, o), (c = o)))
                      if (c.hasOwnProperty(i)) {
                        var u = c[i];
                        "style" === i
                          ? ge(e, u)
                          : "dangerouslySetInnerHTML" === i
                          ? null != (u = u ? u.__html : void 0) && de(e, u)
                          : "children" === i
                          ? "string" == typeof u
                            ? ("textarea" !== n || "" !== u) && pe(e, u)
                            : "number" == typeof u && pe(e, "" + u)
                          : "suppressContentEditableWarning" !== i &&
                            "suppressHydrationWarning" !== i &&
                            "autoFocus" !== i &&
                            (s.hasOwnProperty(i)
                              ? null != u && "onScroll" === i && Br("scroll", e)
                              : null != u && _(e, i, u, l));
                      }
                    switch (n) {
                      case "input":
                        U(e), X(e, r, !1);
                        break;
                      case "textarea":
                        U(e), ie(e);
                        break;
                      case "option":
                        null != r.value &&
                          e.setAttribute("value", "" + W(r.value));
                        break;
                      case "select":
                        (e.multiple = !!r.multiple),
                          null != (i = r.value)
                            ? ne(e, !!r.multiple, i, !1)
                            : null != r.defaultValue &&
                              ne(e, !!r.multiple, r.defaultValue, !0);
                        break;
                      default:
                        "function" == typeof o.onClick && (e.onclick = Xr);
                    }
                    switch (n) {
                      case "button":
                      case "input":
                      case "select":
                      case "textarea":
                        r = !!r.autoFocus;
                        break e;
                      case "img":
                        r = !0;
                        break e;
                      default:
                        r = !1;
                    }
                  }
                  r && (t.flags |= 4);
                }
                null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              }
              return Ks(t), null;
            case 6:
              if (e && null != t.stateNode) Ns(e, t, e.memoizedProps, r);
              else {
                if ("string" != typeof r && null === t.stateNode)
                  throw Error(a(166));
                if (((n = ri(ni.current)), ri(ei.current), pa(t))) {
                  if (
                    ((r = t.stateNode),
                    (n = t.memoizedProps),
                    (r[mo] = t),
                    (i = r.nodeValue !== n) && null !== (e = ra))
                  )
                    switch (e.tag) {
                      case 3:
                        Qr(r.nodeValue, n, 0 != (1 & e.mode));
                        break;
                      case 5:
                        !0 !== e.memoizedProps.suppressHydrationWarning &&
                          Qr(r.nodeValue, n, 0 != (1 & e.mode));
                    }
                  i && (t.flags |= 4);
                } else
                  ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(
                    r
                  ))[mo] = t),
                    (t.stateNode = r);
              }
              return Ks(t), null;
            case 13:
              if (
                (Po(li),
                (r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (
                  aa &&
                  null !== oa &&
                  0 != (1 & t.mode) &&
                  0 == (128 & t.flags)
                )
                  ma(), ha(), (t.flags |= 98560), (i = !1);
                else if (((i = pa(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!i) throw Error(a(318));
                    if (
                      !(i =
                        null !== (i = t.memoizedState) ? i.dehydrated : null)
                    )
                      throw Error(a(317));
                    i[mo] = t;
                  } else
                    ha(),
                      0 == (128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4);
                  Ks(t), (i = !1);
                } else null !== ia && (sc(ia), (ia = null)), (i = !0);
                if (!i) return 65536 & t.flags ? t : null;
              }
              return 0 != (128 & t.flags)
                ? ((t.lanes = n), t)
                : ((r = null !== r) !=
                    (null !== e && null !== e.memoizedState) &&
                    r &&
                    ((t.child.flags |= 8192),
                    0 != (1 & t.mode) &&
                      (null === e || 0 != (1 & li.current)
                        ? 0 === Nl && (Nl = 3)
                        : gc())),
                  null !== t.updateQueue && (t.flags |= 4),
                  Ks(t),
                  null);
            case 4:
              return (
                ai(),
                js(e, t),
                null === e && Hr(t.stateNode.containerInfo),
                Ks(t),
                null
              );
            case 10:
              return Sa(t.type._context), Ks(t), null;
            case 19:
              if ((Po(li), null === (i = t.memoizedState))) return Ks(t), null;
              if (((r = 0 != (128 & t.flags)), null === (l = i.rendering)))
                if (r) Us(i, !1);
                else {
                  if (0 !== Nl || (null !== e && 0 != (128 & e.flags)))
                    for (e = t.child; null !== e; ) {
                      if (null !== (l = ci(e))) {
                        for (
                          t.flags |= 128,
                            Us(i, !1),
                            null !== (r = l.updateQueue) &&
                              ((t.updateQueue = r), (t.flags |= 4)),
                            t.subtreeFlags = 0,
                            r = n,
                            n = t.child;
                          null !== n;

                        )
                          (e = r),
                            ((i = n).flags &= 14680066),
                            null === (l = i.alternate)
                              ? ((i.childLanes = 0),
                                (i.lanes = e),
                                (i.child = null),
                                (i.subtreeFlags = 0),
                                (i.memoizedProps = null),
                                (i.memoizedState = null),
                                (i.updateQueue = null),
                                (i.dependencies = null),
                                (i.stateNode = null))
                              : ((i.childLanes = l.childLanes),
                                (i.lanes = l.lanes),
                                (i.child = l.child),
                                (i.subtreeFlags = 0),
                                (i.deletions = null),
                                (i.memoizedProps = l.memoizedProps),
                                (i.memoizedState = l.memoizedState),
                                (i.updateQueue = l.updateQueue),
                                (i.type = l.type),
                                (e = l.dependencies),
                                (i.dependencies =
                                  null === e
                                    ? null
                                    : {
                                        lanes: e.lanes,
                                        firstContext: e.firstContext,
                                      })),
                            (n = n.sibling);
                        return Oo(li, (1 & li.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== i.tail &&
                    Je() > Vl &&
                    ((t.flags |= 128),
                    (r = !0),
                    Us(i, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = ci(l))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      null !== (n = e.updateQueue) &&
                        ((t.updateQueue = n), (t.flags |= 4)),
                      Us(i, !0),
                      null === i.tail &&
                        "hidden" === i.tailMode &&
                        !l.alternate &&
                        !aa)
                    )
                      return Ks(t), null;
                  } else
                    2 * Je() - i.renderingStartTime > Vl &&
                      1073741824 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      Us(i, !1),
                      (t.lanes = 4194304));
                i.isBackwards
                  ? ((l.sibling = t.child), (t.child = l))
                  : (null !== (n = i.last) ? (n.sibling = l) : (t.child = l),
                    (i.last = l));
              }
              return null !== i.tail
                ? ((t = i.tail),
                  (i.rendering = t),
                  (i.tail = t.sibling),
                  (i.renderingStartTime = Je()),
                  (t.sibling = null),
                  (n = li.current),
                  Oo(li, r ? (1 & n) | 2 : 1 & n),
                  t)
                : (Ks(t), null);
            case 22:
            case 23:
              return (
                pc(),
                (r = null !== t.memoizedState),
                null !== e &&
                  (null !== e.memoizedState) !== r &&
                  (t.flags |= 8192),
                r && 0 != (1 & t.mode)
                  ? 0 != (1073741824 & jl) &&
                    (Ks(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : Ks(t),
                null
              );
            case 24:
            case 25:
              return null;
          }
          throw Error(a(156, t.tag));
        }
        function qs(e, t) {
          switch ((na(t), t.tag)) {
            case 1:
              return (
                jo(t.type) && Ro(),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 3:
              return (
                ai(),
                Po(Mo),
                Po(To),
                di(),
                0 != (65536 & (e = t.flags)) && 0 == (128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 5:
              return si(t), null;
            case 13:
              if (
                (Po(li),
                null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(a(340));
                ha();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return Po(li), null;
            case 4:
              return ai(), null;
            case 10:
              return Sa(t.type._context), null;
            case 22:
            case 23:
              return pc(), null;
            default:
              return null;
          }
        }
        (Ds = function (e, t) {
          for (var n = t.child; null !== n; ) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
            else if (4 !== n.tag && null !== n.child) {
              (n.child.return = n), (n = n.child);
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            (n.sibling.return = n.return), (n = n.sibling);
          }
        }),
          (js = function () {}),
          (Rs = function (e, t, n, r) {
            var o = e.memoizedProps;
            if (o !== r) {
              (e = t.stateNode), ri(ei.current);
              var a,
                i = null;
              switch (n) {
                case "input":
                  (o = q(e, o)), (r = q(e, r)), (i = []);
                  break;
                case "select":
                  (o = L({}, o, { value: void 0 })),
                    (r = L({}, r, { value: void 0 })),
                    (i = []);
                  break;
                case "textarea":
                  (o = re(e, o)), (r = re(e, r)), (i = []);
                  break;
                default:
                  "function" != typeof o.onClick &&
                    "function" == typeof r.onClick &&
                    (e.onclick = Xr);
              }
              for (u in (be(n, r), (n = null), o))
                if (!r.hasOwnProperty(u) && o.hasOwnProperty(u) && null != o[u])
                  if ("style" === u) {
                    var l = o[u];
                    for (a in l)
                      l.hasOwnProperty(a) && (n || (n = {}), (n[a] = ""));
                  } else
                    "dangerouslySetInnerHTML" !== u &&
                      "children" !== u &&
                      "suppressContentEditableWarning" !== u &&
                      "suppressHydrationWarning" !== u &&
                      "autoFocus" !== u &&
                      (s.hasOwnProperty(u)
                        ? i || (i = [])
                        : (i = i || []).push(u, null));
              for (u in r) {
                var c = r[u];
                if (
                  ((l = null != o ? o[u] : void 0),
                  r.hasOwnProperty(u) && c !== l && (null != c || null != l))
                )
                  if ("style" === u)
                    if (l) {
                      for (a in l)
                        !l.hasOwnProperty(a) ||
                          (c && c.hasOwnProperty(a)) ||
                          (n || (n = {}), (n[a] = ""));
                      for (a in c)
                        c.hasOwnProperty(a) &&
                          l[a] !== c[a] &&
                          (n || (n = {}), (n[a] = c[a]));
                    } else n || (i || (i = []), i.push(u, n)), (n = c);
                  else
                    "dangerouslySetInnerHTML" === u
                      ? ((c = c ? c.__html : void 0),
                        (l = l ? l.__html : void 0),
                        null != c && l !== c && (i = i || []).push(u, c))
                      : "children" === u
                      ? ("string" != typeof c && "number" != typeof c) ||
                        (i = i || []).push(u, "" + c)
                      : "suppressContentEditableWarning" !== u &&
                        "suppressHydrationWarning" !== u &&
                        (s.hasOwnProperty(u)
                          ? (null != c && "onScroll" === u && Br("scroll", e),
                            i || l === c || (i = []))
                          : (i = i || []).push(u, c));
              }
              n && (i = i || []).push("style", n);
              var u = i;
              (t.updateQueue = u) && (t.flags |= 4);
            }
          }),
          (Ns = function (e, t, n, r) {
            n !== r && (t.flags |= 4);
          });
        var Ys = !1,
          Js = !1,
          Qs = "function" == typeof WeakSet ? WeakSet : Set,
          Xs = null;
        function el(e, t) {
          var n = e.ref;
          if (null !== n)
            if ("function" == typeof n)
              try {
                n(null);
              } catch (n) {
                wc(e, t, n);
              }
            else n.current = null;
        }
        function tl(e, t, n) {
          try {
            n();
          } catch (n) {
            wc(e, t, n);
          }
        }
        var nl = !1;
        function rl(e, t, n) {
          var r = t.updateQueue;
          if (null !== (r = null !== r ? r.lastEffect : null)) {
            var o = (r = r.next);
            do {
              if ((o.tag & e) === e) {
                var a = o.destroy;
                (o.destroy = void 0), void 0 !== a && tl(t, n, a);
              }
              o = o.next;
            } while (o !== r);
          }
        }
        function ol(e, t) {
          if (
            null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)
          ) {
            var n = (t = t.next);
            do {
              if ((n.tag & e) === e) {
                var r = n.create;
                n.destroy = r();
              }
              n = n.next;
            } while (n !== t);
          }
        }
        function al(e) {
          var t = e.ref;
          if (null !== t) {
            var n = e.stateNode;
            e.tag, (e = n), "function" == typeof t ? t(e) : (t.current = e);
          }
        }
        function il(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), il(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag &&
              null !== (t = e.stateNode) &&
              (delete t[mo],
              delete t[ho],
              delete t[go],
              delete t[vo],
              delete t[bo]),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        function sl(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function ll(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || sl(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 18 !== e.tag;

            ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function cl(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType
                    ? (t = n.parentNode).insertBefore(e, n)
                    : (t = n).appendChild(e),
                  null != (n = n._reactRootContainer) ||
                    null !== t.onclick ||
                    (t.onclick = Xr));
          else if (4 !== r && null !== (e = e.child))
            for (cl(e, t, n), e = e.sibling; null !== e; )
              cl(e, t, n), (e = e.sibling);
        }
        function ul(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (4 !== r && null !== (e = e.child))
            for (ul(e, t, n), e = e.sibling; null !== e; )
              ul(e, t, n), (e = e.sibling);
        }
        var dl = null,
          pl = !1;
        function ml(e, t, n) {
          for (n = n.child; null !== n; ) hl(e, t, n), (n = n.sibling);
        }
        function hl(e, t, n) {
          if (at && "function" == typeof at.onCommitFiberUnmount)
            try {
              at.onCommitFiberUnmount(ot, n);
            } catch (e) {}
          switch (n.tag) {
            case 5:
              Js || el(n, t);
            case 6:
              var r = dl,
                o = pl;
              (dl = null),
                ml(e, t, n),
                (pl = o),
                null !== (dl = r) &&
                  (pl
                    ? ((e = dl),
                      (n = n.stateNode),
                      8 === e.nodeType
                        ? e.parentNode.removeChild(n)
                        : e.removeChild(n))
                    : dl.removeChild(n.stateNode));
              break;
            case 18:
              null !== dl &&
                (pl
                  ? ((e = dl),
                    (n = n.stateNode),
                    8 === e.nodeType
                      ? lo(e.parentNode, n)
                      : 1 === e.nodeType && lo(e, n),
                    Ht(e))
                  : lo(dl, n.stateNode));
              break;
            case 4:
              (r = dl),
                (o = pl),
                (dl = n.stateNode.containerInfo),
                (pl = !0),
                ml(e, t, n),
                (dl = r),
                (pl = o);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              if (
                !Js &&
                null !== (r = n.updateQueue) &&
                null !== (r = r.lastEffect)
              ) {
                o = r = r.next;
                do {
                  var a = o,
                    i = a.destroy;
                  (a = a.tag),
                    void 0 !== i &&
                      (0 != (2 & a) || 0 != (4 & a)) &&
                      tl(n, t, i),
                    (o = o.next);
                } while (o !== r);
              }
              ml(e, t, n);
              break;
            case 1:
              if (
                !Js &&
                (el(n, t),
                "function" == typeof (r = n.stateNode).componentWillUnmount)
              )
                try {
                  (r.props = n.memoizedProps),
                    (r.state = n.memoizedState),
                    r.componentWillUnmount();
                } catch (e) {
                  wc(n, t, e);
                }
              ml(e, t, n);
              break;
            case 21:
              ml(e, t, n);
              break;
            case 22:
              1 & n.mode
                ? ((Js = (r = Js) || null !== n.memoizedState),
                  ml(e, t, n),
                  (Js = r))
                : ml(e, t, n);
              break;
            default:
              ml(e, t, n);
          }
        }
        function fl(e) {
          var t = e.updateQueue;
          if (null !== t) {
            e.updateQueue = null;
            var n = e.stateNode;
            null === n && (n = e.stateNode = new Qs()),
              t.forEach(function (t) {
                var r = Tc.bind(null, e, t);
                n.has(t) || (n.add(t), t.then(r, r));
              });
          }
        }
        function gl(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var o = n[r];
              try {
                var i = e,
                  s = t,
                  l = s;
                e: for (; null !== l; ) {
                  switch (l.tag) {
                    case 5:
                      (dl = l.stateNode), (pl = !1);
                      break e;
                    case 3:
                    case 4:
                      (dl = l.stateNode.containerInfo), (pl = !0);
                      break e;
                  }
                  l = l.return;
                }
                if (null === dl) throw Error(a(160));
                hl(i, s, o), (dl = null), (pl = !1);
                var c = o.alternate;
                null !== c && (c.return = null), (o.return = null);
              } catch (e) {
                wc(o, t, e);
              }
            }
          if (12854 & t.subtreeFlags)
            for (t = t.child; null !== t; ) vl(t, e), (t = t.sibling);
        }
        function vl(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if ((gl(t, e), bl(e), 4 & r)) {
                try {
                  rl(3, e, e.return), ol(3, e);
                } catch (t) {
                  wc(e, e.return, t);
                }
                try {
                  rl(5, e, e.return);
                } catch (t) {
                  wc(e, e.return, t);
                }
              }
              break;
            case 1:
              gl(t, e), bl(e), 512 & r && null !== n && el(n, n.return);
              break;
            case 5:
              if (
                (gl(t, e),
                bl(e),
                512 & r && null !== n && el(n, n.return),
                32 & e.flags)
              ) {
                var o = e.stateNode;
                try {
                  pe(o, "");
                } catch (t) {
                  wc(e, e.return, t);
                }
              }
              if (4 & r && null != (o = e.stateNode)) {
                var i = e.memoizedProps,
                  s = null !== n ? n.memoizedProps : i,
                  l = e.type,
                  c = e.updateQueue;
                if (((e.updateQueue = null), null !== c))
                  try {
                    "input" === l &&
                      "radio" === i.type &&
                      null != i.name &&
                      J(o, i),
                      _e(l, s);
                    var u = _e(l, i);
                    for (s = 0; s < c.length; s += 2) {
                      var d = c[s],
                        p = c[s + 1];
                      "style" === d
                        ? ge(o, p)
                        : "dangerouslySetInnerHTML" === d
                        ? de(o, p)
                        : "children" === d
                        ? pe(o, p)
                        : _(o, d, p, u);
                    }
                    switch (l) {
                      case "input":
                        Q(o, i);
                        break;
                      case "textarea":
                        ae(o, i);
                        break;
                      case "select":
                        var m = o._wrapperState.wasMultiple;
                        o._wrapperState.wasMultiple = !!i.multiple;
                        var h = i.value;
                        null != h
                          ? ne(o, !!i.multiple, h, !1)
                          : m !== !!i.multiple &&
                            (null != i.defaultValue
                              ? ne(o, !!i.multiple, i.defaultValue, !0)
                              : ne(o, !!i.multiple, i.multiple ? [] : "", !1));
                    }
                    o[ho] = i;
                  } catch (t) {
                    wc(e, e.return, t);
                  }
              }
              break;
            case 6:
              if ((gl(t, e), bl(e), 4 & r)) {
                if (null === e.stateNode) throw Error(a(162));
                (o = e.stateNode), (i = e.memoizedProps);
                try {
                  o.nodeValue = i;
                } catch (t) {
                  wc(e, e.return, t);
                }
              }
              break;
            case 3:
              if (
                (gl(t, e),
                bl(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  Ht(t.containerInfo);
                } catch (t) {
                  wc(e, e.return, t);
                }
              break;
            case 4:
            default:
              gl(t, e), bl(e);
              break;
            case 13:
              gl(t, e),
                bl(e),
                8192 & (o = e.child).flags &&
                  ((i = null !== o.memoizedState),
                  (o.stateNode.isHidden = i),
                  !i ||
                    (null !== o.alternate &&
                      null !== o.alternate.memoizedState) ||
                    (Hl = Je())),
                4 & r && fl(e);
              break;
            case 22:
              if (
                ((d = null !== n && null !== n.memoizedState),
                1 & e.mode
                  ? ((Js = (u = Js) || d), gl(t, e), (Js = u))
                  : gl(t, e),
                bl(e),
                8192 & r)
              ) {
                if (
                  ((u = null !== e.memoizedState),
                  (e.stateNode.isHidden = u) && !d && 0 != (1 & e.mode))
                )
                  for (Xs = e, d = e.child; null !== d; ) {
                    for (p = Xs = d; null !== Xs; ) {
                      switch (((h = (m = Xs).child), m.tag)) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                          rl(4, m, m.return);
                          break;
                        case 1:
                          el(m, m.return);
                          var f = m.stateNode;
                          if ("function" == typeof f.componentWillUnmount) {
                            (r = m), (n = m.return);
                            try {
                              (t = r),
                                (f.props = t.memoizedProps),
                                (f.state = t.memoizedState),
                                f.componentWillUnmount();
                            } catch (e) {
                              wc(r, n, e);
                            }
                          }
                          break;
                        case 5:
                          el(m, m.return);
                          break;
                        case 22:
                          if (null !== m.memoizedState) {
                            Cl(p);
                            continue;
                          }
                      }
                      null !== h ? ((h.return = m), (Xs = h)) : Cl(p);
                    }
                    d = d.sibling;
                  }
                e: for (d = null, p = e; ; ) {
                  if (5 === p.tag) {
                    if (null === d) {
                      d = p;
                      try {
                        (o = p.stateNode),
                          u
                            ? "function" == typeof (i = o.style).setProperty
                              ? i.setProperty("display", "none", "important")
                              : (i.display = "none")
                            : ((l = p.stateNode),
                              (s =
                                null != (c = p.memoizedProps.style) &&
                                c.hasOwnProperty("display")
                                  ? c.display
                                  : null),
                              (l.style.display = fe("display", s)));
                      } catch (t) {
                        wc(e, e.return, t);
                      }
                    }
                  } else if (6 === p.tag) {
                    if (null === d)
                      try {
                        p.stateNode.nodeValue = u ? "" : p.memoizedProps;
                      } catch (t) {
                        wc(e, e.return, t);
                      }
                  } else if (
                    ((22 !== p.tag && 23 !== p.tag) ||
                      null === p.memoizedState ||
                      p === e) &&
                    null !== p.child
                  ) {
                    (p.child.return = p), (p = p.child);
                    continue;
                  }
                  if (p === e) break e;
                  for (; null === p.sibling; ) {
                    if (null === p.return || p.return === e) break e;
                    d === p && (d = null), (p = p.return);
                  }
                  d === p && (d = null),
                    (p.sibling.return = p.return),
                    (p = p.sibling);
                }
              }
              break;
            case 19:
              gl(t, e), bl(e), 4 & r && fl(e);
            case 21:
          }
        }
        function bl(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              e: {
                for (var n = e.return; null !== n; ) {
                  if (sl(n)) {
                    var r = n;
                    break e;
                  }
                  n = n.return;
                }
                throw Error(a(160));
              }
              switch (r.tag) {
                case 5:
                  var o = r.stateNode;
                  32 & r.flags && (pe(o, ""), (r.flags &= -33)),
                    ul(e, ll(e), o);
                  break;
                case 3:
                case 4:
                  var i = r.stateNode.containerInfo;
                  cl(e, ll(e), i);
                  break;
                default:
                  throw Error(a(161));
              }
            } catch (t) {
              wc(e, e.return, t);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function _l(e, t, n) {
          (Xs = e), yl(e, t, n);
        }
        function yl(e, t, n) {
          for (var r = 0 != (1 & e.mode); null !== Xs; ) {
            var o = Xs,
              a = o.child;
            if (22 === o.tag && r) {
              var i = null !== o.memoizedState || Ys;
              if (!i) {
                var s = o.alternate,
                  l = (null !== s && null !== s.memoizedState) || Js;
                s = Ys;
                var c = Js;
                if (((Ys = i), (Js = l) && !c))
                  for (Xs = o; null !== Xs; )
                    (l = (i = Xs).child),
                      22 === i.tag && null !== i.memoizedState
                        ? Sl(o)
                        : null !== l
                        ? ((l.return = i), (Xs = l))
                        : Sl(o);
                for (; null !== a; ) (Xs = a), yl(a, t, n), (a = a.sibling);
                (Xs = o), (Ys = s), (Js = c);
              }
              xl(e);
            } else
              0 != (8772 & o.subtreeFlags) && null !== a
                ? ((a.return = o), (Xs = a))
                : xl(e);
          }
        }
        function xl(e) {
          for (; null !== Xs; ) {
            var t = Xs;
            if (0 != (8772 & t.flags)) {
              var n = t.alternate;
              try {
                if (0 != (8772 & t.flags))
                  switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Js || ol(5, t);
                      break;
                    case 1:
                      var r = t.stateNode;
                      if (4 & t.flags && !Js)
                        if (null === n) r.componentDidMount();
                        else {
                          var o =
                            t.elementType === t.type
                              ? n.memoizedProps
                              : va(t.type, n.memoizedProps);
                          r.componentDidUpdate(
                            o,
                            n.memoizedState,
                            r.__reactInternalSnapshotBeforeUpdate
                          );
                        }
                      var i = t.updateQueue;
                      null !== i && Ba(t, i, r);
                      break;
                    case 3:
                      var s = t.updateQueue;
                      if (null !== s) {
                        if (((n = null), null !== t.child))
                          switch (t.child.tag) {
                            case 5:
                            case 1:
                              n = t.child.stateNode;
                          }
                        Ba(t, s, n);
                      }
                      break;
                    case 5:
                      var l = t.stateNode;
                      if (null === n && 4 & t.flags) {
                        n = l;
                        var c = t.memoizedProps;
                        switch (t.type) {
                          case "button":
                          case "input":
                          case "select":
                          case "textarea":
                            c.autoFocus && n.focus();
                            break;
                          case "img":
                            c.src && (n.src = c.src);
                        }
                      }
                      break;
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                      break;
                    case 13:
                      if (null === t.memoizedState) {
                        var u = t.alternate;
                        if (null !== u) {
                          var d = u.memoizedState;
                          if (null !== d) {
                            var p = d.dehydrated;
                            null !== p && Ht(p);
                          }
                        }
                      }
                      break;
                    default:
                      throw Error(a(163));
                  }
                Js || (512 & t.flags && al(t));
              } catch (e) {
                wc(t, t.return, e);
              }
            }
            if (t === e) {
              Xs = null;
              break;
            }
            if (null !== (n = t.sibling)) {
              (n.return = t.return), (Xs = n);
              break;
            }
            Xs = t.return;
          }
        }
        function Cl(e) {
          for (; null !== Xs; ) {
            var t = Xs;
            if (t === e) {
              Xs = null;
              break;
            }
            var n = t.sibling;
            if (null !== n) {
              (n.return = t.return), (Xs = n);
              break;
            }
            Xs = t.return;
          }
        }
        function Sl(e) {
          for (; null !== Xs; ) {
            var t = Xs;
            try {
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  var n = t.return;
                  try {
                    ol(4, t);
                  } catch (e) {
                    wc(t, n, e);
                  }
                  break;
                case 1:
                  var r = t.stateNode;
                  if ("function" == typeof r.componentDidMount) {
                    var o = t.return;
                    try {
                      r.componentDidMount();
                    } catch (e) {
                      wc(t, o, e);
                    }
                  }
                  var a = t.return;
                  try {
                    al(t);
                  } catch (e) {
                    wc(t, a, e);
                  }
                  break;
                case 5:
                  var i = t.return;
                  try {
                    al(t);
                  } catch (e) {
                    wc(t, i, e);
                  }
              }
            } catch (e) {
              wc(t, t.return, e);
            }
            if (t === e) {
              Xs = null;
              break;
            }
            var s = t.sibling;
            if (null !== s) {
              (s.return = t.return), (Xs = s);
              break;
            }
            Xs = t.return;
          }
        }
        var kl,
          wl = Math.ceil,
          Pl = y.ReactCurrentDispatcher,
          Ol = y.ReactCurrentOwner,
          Il = y.ReactCurrentBatchConfig,
          Tl = 0,
          Ml = null,
          El = null,
          Dl = 0,
          jl = 0,
          Rl = wo(0),
          Nl = 0,
          Al = null,
          Ll = 0,
          zl = 0,
          Bl = 0,
          Zl = null,
          Fl = null,
          Hl = 0,
          Vl = 1 / 0,
          Wl = null,
          $l = !1,
          Ul = null,
          Kl = null,
          Gl = !1,
          ql = null,
          Yl = 0,
          Jl = 0,
          Ql = null,
          Xl = -1,
          ec = 0;
        function tc() {
          return 0 != (6 & Tl) ? Je() : -1 !== Xl ? Xl : (Xl = Je());
        }
        function nc(e) {
          return 0 == (1 & e.mode)
            ? 1
            : 0 != (2 & Tl) && 0 !== Dl
            ? Dl & -Dl
            : null !== ga.transition
            ? (0 === ec && (ec = ft()), ec)
            : 0 !== (e = _t)
            ? e
            : (e = void 0 === (e = window.event) ? 16 : Yt(e.type));
        }
        function rc(e, t, n, r) {
          if (50 < Jl) throw ((Jl = 0), (Ql = null), Error(a(185)));
          vt(e, n, r),
            (0 != (2 & Tl) && e === Ml) ||
              (e === Ml && (0 == (2 & Tl) && (zl |= n), 4 === Nl && lc(e, Dl)),
              oc(e, r),
              1 === n &&
                0 === Tl &&
                0 == (1 & t.mode) &&
                ((Vl = Je() + 500), Zo && Vo()));
        }
        function oc(e, t) {
          var n = e.callbackNode;
          !(function (e, t) {
            for (
              var n = e.suspendedLanes,
                r = e.pingedLanes,
                o = e.expirationTimes,
                a = e.pendingLanes;
              0 < a;

            ) {
              var i = 31 - it(a),
                s = 1 << i,
                l = o[i];
              -1 === l
                ? (0 != (s & n) && 0 == (s & r)) || (o[i] = mt(s, t))
                : l <= t && (e.expiredLanes |= s),
                (a &= ~s);
            }
          })(e, t);
          var r = pt(e, e === Ml ? Dl : 0);
          if (0 === r)
            null !== n && Ge(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0);
          else if (((t = r & -r), e.callbackPriority !== t)) {
            if ((null != n && Ge(n), 1 === t))
              0 === e.tag
                ? (function (e) {
                    (Zo = !0), Ho(e);
                  })(cc.bind(null, e))
                : Ho(cc.bind(null, e)),
                io(function () {
                  0 == (6 & Tl) && Vo();
                }),
                (n = null);
            else {
              switch (yt(r)) {
                case 1:
                  n = Xe;
                  break;
                case 4:
                  n = et;
                  break;
                case 16:
                default:
                  n = tt;
                  break;
                case 536870912:
                  n = rt;
              }
              n = Mc(n, ac.bind(null, e));
            }
            (e.callbackPriority = t), (e.callbackNode = n);
          }
        }
        function ac(e, t) {
          if (((Xl = -1), (ec = 0), 0 != (6 & Tl))) throw Error(a(327));
          var n = e.callbackNode;
          if (Sc() && e.callbackNode !== n) return null;
          var r = pt(e, e === Ml ? Dl : 0);
          if (0 === r) return null;
          if (0 != (30 & r) || 0 != (r & e.expiredLanes) || t) t = vc(e, r);
          else {
            t = r;
            var o = Tl;
            Tl |= 2;
            var i = fc();
            for (
              (Ml === e && Dl === t) ||
              ((Wl = null), (Vl = Je() + 500), mc(e, t));
              ;

            )
              try {
                _c();
                break;
              } catch (t) {
                hc(e, t);
              }
            Ca(),
              (Pl.current = i),
              (Tl = o),
              null !== El ? (t = 0) : ((Ml = null), (Dl = 0), (t = Nl));
          }
          if (0 !== t) {
            if (
              (2 === t && 0 !== (o = ht(e)) && ((r = o), (t = ic(e, o))),
              1 === t)
            )
              throw ((n = Al), mc(e, 0), lc(e, r), oc(e, Je()), n);
            if (6 === t) lc(e, r);
            else {
              if (
                ((o = e.current.alternate),
                0 == (30 & r) &&
                  !(function (e) {
                    for (var t = e; ; ) {
                      if (16384 & t.flags) {
                        var n = t.updateQueue;
                        if (null !== n && null !== (n = n.stores))
                          for (var r = 0; r < n.length; r++) {
                            var o = n[r],
                              a = o.getSnapshot;
                            o = o.value;
                            try {
                              if (!sr(a(), o)) return !1;
                            } catch (e) {
                              return !1;
                            }
                          }
                      }
                      if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
                        (n.return = t), (t = n);
                      else {
                        if (t === e) break;
                        for (; null === t.sibling; ) {
                          if (null === t.return || t.return === e) return !0;
                          t = t.return;
                        }
                        (t.sibling.return = t.return), (t = t.sibling);
                      }
                    }
                    return !0;
                  })(o) &&
                  (2 === (t = vc(e, r)) &&
                    0 !== (i = ht(e)) &&
                    ((r = i), (t = ic(e, i))),
                  1 === t))
              )
                throw ((n = Al), mc(e, 0), lc(e, r), oc(e, Je()), n);
              switch (((e.finishedWork = o), (e.finishedLanes = r), t)) {
                case 0:
                case 1:
                  throw Error(a(345));
                case 2:
                case 5:
                  Cc(e, Fl, Wl);
                  break;
                case 3:
                  if (
                    (lc(e, r),
                    (130023424 & r) === r && 10 < (t = Hl + 500 - Je()))
                  ) {
                    if (0 !== pt(e, 0)) break;
                    if (((o = e.suspendedLanes) & r) !== r) {
                      tc(), (e.pingedLanes |= e.suspendedLanes & o);
                      break;
                    }
                    e.timeoutHandle = ro(Cc.bind(null, e, Fl, Wl), t);
                    break;
                  }
                  Cc(e, Fl, Wl);
                  break;
                case 4:
                  if ((lc(e, r), (4194240 & r) === r)) break;
                  for (t = e.eventTimes, o = -1; 0 < r; ) {
                    var s = 31 - it(r);
                    (i = 1 << s), (s = t[s]) > o && (o = s), (r &= ~i);
                  }
                  if (
                    ((r = o),
                    10 <
                      (r =
                        (120 > (r = Je() - r)
                          ? 120
                          : 480 > r
                          ? 480
                          : 1080 > r
                          ? 1080
                          : 1920 > r
                          ? 1920
                          : 3e3 > r
                          ? 3e3
                          : 4320 > r
                          ? 4320
                          : 1960 * wl(r / 1960)) - r))
                  ) {
                    e.timeoutHandle = ro(Cc.bind(null, e, Fl, Wl), r);
                    break;
                  }
                  Cc(e, Fl, Wl);
                  break;
                default:
                  throw Error(a(329));
              }
            }
          }
          return oc(e, Je()), e.callbackNode === n ? ac.bind(null, e) : null;
        }
        function ic(e, t) {
          var n = Zl;
          return (
            e.current.memoizedState.isDehydrated && (mc(e, t).flags |= 256),
            2 !== (e = vc(e, t)) && ((t = Fl), (Fl = n), null !== t && sc(t)),
            e
          );
        }
        function sc(e) {
          null === Fl ? (Fl = e) : Fl.push.apply(Fl, e);
        }
        function lc(e, t) {
          for (
            t &= ~Bl,
              t &= ~zl,
              e.suspendedLanes |= t,
              e.pingedLanes &= ~t,
              e = e.expirationTimes;
            0 < t;

          ) {
            var n = 31 - it(t),
              r = 1 << n;
            (e[n] = -1), (t &= ~r);
          }
        }
        function cc(e) {
          if (0 != (6 & Tl)) throw Error(a(327));
          Sc();
          var t = pt(e, 0);
          if (0 == (1 & t)) return oc(e, Je()), null;
          var n = vc(e, t);
          if (0 !== e.tag && 2 === n) {
            var r = ht(e);
            0 !== r && ((t = r), (n = ic(e, r)));
          }
          if (1 === n) throw ((n = Al), mc(e, 0), lc(e, t), oc(e, Je()), n);
          if (6 === n) throw Error(a(345));
          return (
            (e.finishedWork = e.current.alternate),
            (e.finishedLanes = t),
            Cc(e, Fl, Wl),
            oc(e, Je()),
            null
          );
        }
        function uc(e, t) {
          var n = Tl;
          Tl |= 1;
          try {
            return e(t);
          } finally {
            0 === (Tl = n) && ((Vl = Je() + 500), Zo && Vo());
          }
        }
        function dc(e) {
          null !== ql && 0 === ql.tag && 0 == (6 & Tl) && Sc();
          var t = Tl;
          Tl |= 1;
          var n = Il.transition,
            r = _t;
          try {
            if (((Il.transition = null), (_t = 1), e)) return e();
          } finally {
            (_t = r), (Il.transition = n), 0 == (6 & (Tl = t)) && Vo();
          }
        }
        function pc() {
          (jl = Rl.current), Po(Rl);
        }
        function mc(e, t) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var n = e.timeoutHandle;
          if ((-1 !== n && ((e.timeoutHandle = -1), oo(n)), null !== El))
            for (n = El.return; null !== n; ) {
              var r = n;
              switch ((na(r), r.tag)) {
                case 1:
                  null != (r = r.type.childContextTypes) && Ro();
                  break;
                case 3:
                  ai(), Po(Mo), Po(To), di();
                  break;
                case 5:
                  si(r);
                  break;
                case 4:
                  ai();
                  break;
                case 13:
                case 19:
                  Po(li);
                  break;
                case 10:
                  Sa(r.type._context);
                  break;
                case 22:
                case 23:
                  pc();
              }
              n = n.return;
            }
          if (
            ((Ml = e),
            (El = e = Rc(e.current, null)),
            (Dl = jl = t),
            (Nl = 0),
            (Al = null),
            (Bl = zl = Ll = 0),
            (Fl = Zl = null),
            null !== Oa)
          ) {
            for (t = 0; t < Oa.length; t++)
              if (null !== (r = (n = Oa[t]).interleaved)) {
                n.interleaved = null;
                var o = r.next,
                  a = n.pending;
                if (null !== a) {
                  var i = a.next;
                  (a.next = o), (r.next = i);
                }
                n.pending = r;
              }
            Oa = null;
          }
          return e;
        }
        function hc(e, t) {
          for (;;) {
            var n = El;
            try {
              if ((Ca(), (pi.current = is), bi)) {
                for (var r = fi.memoizedState; null !== r; ) {
                  var o = r.queue;
                  null !== o && (o.pending = null), (r = r.next);
                }
                bi = !1;
              }
              if (
                ((hi = 0),
                (vi = gi = fi = null),
                (_i = !1),
                (yi = 0),
                (Ol.current = null),
                null === n || null === n.return)
              ) {
                (Nl = 1), (Al = t), (El = null);
                break;
              }
              e: {
                var i = e,
                  s = n.return,
                  l = n,
                  c = t;
                if (
                  ((t = Dl),
                  (l.flags |= 32768),
                  null !== c &&
                    "object" == typeof c &&
                    "function" == typeof c.then)
                ) {
                  var u = c,
                    d = l,
                    p = d.tag;
                  if (0 == (1 & d.mode) && (0 === p || 11 === p || 15 === p)) {
                    var m = d.alternate;
                    m
                      ? ((d.updateQueue = m.updateQueue),
                        (d.memoizedState = m.memoizedState),
                        (d.lanes = m.lanes))
                      : ((d.updateQueue = null), (d.memoizedState = null));
                  }
                  var h = vs(s);
                  if (null !== h) {
                    (h.flags &= -257),
                      bs(h, s, l, 0, t),
                      1 & h.mode && gs(i, u, t),
                      (c = u);
                    var f = (t = h).updateQueue;
                    if (null === f) {
                      var g = new Set();
                      g.add(c), (t.updateQueue = g);
                    } else f.add(c);
                    break e;
                  }
                  if (0 == (1 & t)) {
                    gs(i, u, t), gc();
                    break e;
                  }
                  c = Error(a(426));
                } else if (aa && 1 & l.mode) {
                  var v = vs(s);
                  if (null !== v) {
                    0 == (65536 & v.flags) && (v.flags |= 256),
                      bs(v, s, l, 0, t),
                      fa(us(c, l));
                    break e;
                  }
                }
                (i = c = us(c, l)),
                  4 !== Nl && (Nl = 2),
                  null === Zl ? (Zl = [i]) : Zl.push(i),
                  (i = s);
                do {
                  switch (i.tag) {
                    case 3:
                      (i.flags |= 65536),
                        (t &= -t),
                        (i.lanes |= t),
                        La(i, hs(0, c, t));
                      break e;
                    case 1:
                      l = c;
                      var b = i.type,
                        _ = i.stateNode;
                      if (
                        0 == (128 & i.flags) &&
                        ("function" == typeof b.getDerivedStateFromError ||
                          (null !== _ &&
                            "function" == typeof _.componentDidCatch &&
                            (null === Kl || !Kl.has(_))))
                      ) {
                        (i.flags |= 65536),
                          (t &= -t),
                          (i.lanes |= t),
                          La(i, fs(i, l, t));
                        break e;
                      }
                  }
                  i = i.return;
                } while (null !== i);
              }
              xc(n);
            } catch (e) {
              (t = e), El === n && null !== n && (El = n = n.return);
              continue;
            }
            break;
          }
        }
        function fc() {
          var e = Pl.current;
          return (Pl.current = is), null === e ? is : e;
        }
        function gc() {
          (0 !== Nl && 3 !== Nl && 2 !== Nl) || (Nl = 4),
            null === Ml ||
              (0 == (268435455 & Ll) && 0 == (268435455 & zl)) ||
              lc(Ml, Dl);
        }
        function vc(e, t) {
          var n = Tl;
          Tl |= 2;
          var r = fc();
          for ((Ml === e && Dl === t) || ((Wl = null), mc(e, t)); ; )
            try {
              bc();
              break;
            } catch (t) {
              hc(e, t);
            }
          if ((Ca(), (Tl = n), (Pl.current = r), null !== El))
            throw Error(a(261));
          return (Ml = null), (Dl = 0), Nl;
        }
        function bc() {
          for (; null !== El; ) yc(El);
        }
        function _c() {
          for (; null !== El && !qe(); ) yc(El);
        }
        function yc(e) {
          var t = kl(e.alternate, e, jl);
          (e.memoizedProps = e.pendingProps),
            null === t ? xc(e) : (El = t),
            (Ol.current = null);
        }
        function xc(e) {
          var t = e;
          do {
            var n = t.alternate;
            if (((e = t.return), 0 == (32768 & t.flags))) {
              if (null !== (n = Gs(n, t, jl))) return void (El = n);
            } else {
              if (null !== (n = qs(n, t)))
                return (n.flags &= 32767), void (El = n);
              if (null === e) return (Nl = 6), void (El = null);
              (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
            }
            if (null !== (t = t.sibling)) return void (El = t);
            El = t = e;
          } while (null !== t);
          0 === Nl && (Nl = 5);
        }
        function Cc(e, t, n) {
          var r = _t,
            o = Il.transition;
          try {
            (Il.transition = null),
              (_t = 1),
              (function (e, t, n, r) {
                do {
                  Sc();
                } while (null !== ql);
                if (0 != (6 & Tl)) throw Error(a(327));
                n = e.finishedWork;
                var o = e.finishedLanes;
                if (null === n) return null;
                if (
                  ((e.finishedWork = null),
                  (e.finishedLanes = 0),
                  n === e.current)
                )
                  throw Error(a(177));
                (e.callbackNode = null), (e.callbackPriority = 0);
                var i = n.lanes | n.childLanes;
                if (
                  ((function (e, t) {
                    var n = e.pendingLanes & ~t;
                    (e.pendingLanes = t),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.expiredLanes &= t),
                      (e.mutableReadLanes &= t),
                      (e.entangledLanes &= t),
                      (t = e.entanglements);
                    var r = e.eventTimes;
                    for (e = e.expirationTimes; 0 < n; ) {
                      var o = 31 - it(n),
                        a = 1 << o;
                      (t[o] = 0), (r[o] = -1), (e[o] = -1), (n &= ~a);
                    }
                  })(e, i),
                  e === Ml && ((El = Ml = null), (Dl = 0)),
                  (0 == (2064 & n.subtreeFlags) && 0 == (2064 & n.flags)) ||
                    Gl ||
                    ((Gl = !0),
                    Mc(tt, function () {
                      return Sc(), null;
                    })),
                  (i = 0 != (15990 & n.flags)),
                  0 != (15990 & n.subtreeFlags) || i)
                ) {
                  (i = Il.transition), (Il.transition = null);
                  var s = _t;
                  _t = 1;
                  var l = Tl;
                  (Tl |= 4),
                    (Ol.current = null),
                    (function (e, t) {
                      if (((eo = Wt), mr((e = pr())))) {
                        if ("selectionStart" in e)
                          var n = {
                            start: e.selectionStart,
                            end: e.selectionEnd,
                          };
                        else
                          e: {
                            var r =
                              (n =
                                ((n = e.ownerDocument) && n.defaultView) ||
                                window).getSelection && n.getSelection();
                            if (r && 0 !== r.rangeCount) {
                              n = r.anchorNode;
                              var o = r.anchorOffset,
                                i = r.focusNode;
                              r = r.focusOffset;
                              try {
                                n.nodeType, i.nodeType;
                              } catch (e) {
                                n = null;
                                break e;
                              }
                              var s = 0,
                                l = -1,
                                c = -1,
                                u = 0,
                                d = 0,
                                p = e,
                                m = null;
                              t: for (;;) {
                                for (
                                  var h;
                                  p !== n ||
                                    (0 !== o && 3 !== p.nodeType) ||
                                    (l = s + o),
                                    p !== i ||
                                      (0 !== r && 3 !== p.nodeType) ||
                                      (c = s + r),
                                    3 === p.nodeType &&
                                      (s += p.nodeValue.length),
                                    null !== (h = p.firstChild);

                                )
                                  (m = p), (p = h);
                                for (;;) {
                                  if (p === e) break t;
                                  if (
                                    (m === n && ++u === o && (l = s),
                                    m === i && ++d === r && (c = s),
                                    null !== (h = p.nextSibling))
                                  )
                                    break;
                                  m = (p = m).parentNode;
                                }
                                p = h;
                              }
                              n =
                                -1 === l || -1 === c
                                  ? null
                                  : { start: l, end: c };
                            } else n = null;
                          }
                        n = n || { start: 0, end: 0 };
                      } else n = null;
                      for (
                        to = { focusedElem: e, selectionRange: n },
                          Wt = !1,
                          Xs = t;
                        null !== Xs;

                      )
                        if (
                          ((e = (t = Xs).child),
                          0 != (1028 & t.subtreeFlags) && null !== e)
                        )
                          (e.return = t), (Xs = e);
                        else
                          for (; null !== Xs; ) {
                            t = Xs;
                            try {
                              var f = t.alternate;
                              if (0 != (1024 & t.flags))
                                switch (t.tag) {
                                  case 0:
                                  case 11:
                                  case 15:
                                  case 5:
                                  case 6:
                                  case 4:
                                  case 17:
                                    break;
                                  case 1:
                                    if (null !== f) {
                                      var g = f.memoizedProps,
                                        v = f.memoizedState,
                                        b = t.stateNode,
                                        _ = b.getSnapshotBeforeUpdate(
                                          t.elementType === t.type
                                            ? g
                                            : va(t.type, g),
                                          v
                                        );
                                      b.__reactInternalSnapshotBeforeUpdate = _;
                                    }
                                    break;
                                  case 3:
                                    var y = t.stateNode.containerInfo;
                                    1 === y.nodeType
                                      ? (y.textContent = "")
                                      : 9 === y.nodeType &&
                                        y.documentElement &&
                                        y.removeChild(y.documentElement);
                                    break;
                                  default:
                                    throw Error(a(163));
                                }
                            } catch (e) {
                              wc(t, t.return, e);
                            }
                            if (null !== (e = t.sibling)) {
                              (e.return = t.return), (Xs = e);
                              break;
                            }
                            Xs = t.return;
                          }
                      (f = nl), (nl = !1);
                    })(e, n),
                    vl(n, e),
                    hr(to),
                    (Wt = !!eo),
                    (to = eo = null),
                    (e.current = n),
                    _l(n, e, o),
                    Ye(),
                    (Tl = l),
                    (_t = s),
                    (Il.transition = i);
                } else e.current = n;
                if (
                  (Gl && ((Gl = !1), (ql = e), (Yl = o)),
                  0 === (i = e.pendingLanes) && (Kl = null),
                  (function (e) {
                    if (at && "function" == typeof at.onCommitFiberRoot)
                      try {
                        at.onCommitFiberRoot(
                          ot,
                          e,
                          void 0,
                          128 == (128 & e.current.flags)
                        );
                      } catch (e) {}
                  })(n.stateNode),
                  oc(e, Je()),
                  null !== t)
                )
                  for (r = e.onRecoverableError, n = 0; n < t.length; n++)
                    r((o = t[n]).value, {
                      componentStack: o.stack,
                      digest: o.digest,
                    });
                if ($l) throw (($l = !1), (e = Ul), (Ul = null), e);
                0 != (1 & Yl) && 0 !== e.tag && Sc(),
                  0 != (1 & (i = e.pendingLanes))
                    ? e === Ql
                      ? Jl++
                      : ((Jl = 0), (Ql = e))
                    : (Jl = 0),
                  Vo();
              })(e, t, n, r);
          } finally {
            (Il.transition = o), (_t = r);
          }
          return null;
        }
        function Sc() {
          if (null !== ql) {
            var e = yt(Yl),
              t = Il.transition,
              n = _t;
            try {
              if (((Il.transition = null), (_t = 16 > e ? 16 : e), null === ql))
                var r = !1;
              else {
                if (((e = ql), (ql = null), (Yl = 0), 0 != (6 & Tl)))
                  throw Error(a(331));
                var o = Tl;
                for (Tl |= 4, Xs = e.current; null !== Xs; ) {
                  var i = Xs,
                    s = i.child;
                  if (0 != (16 & Xs.flags)) {
                    var l = i.deletions;
                    if (null !== l) {
                      for (var c = 0; c < l.length; c++) {
                        var u = l[c];
                        for (Xs = u; null !== Xs; ) {
                          var d = Xs;
                          switch (d.tag) {
                            case 0:
                            case 11:
                            case 15:
                              rl(8, d, i);
                          }
                          var p = d.child;
                          if (null !== p) (p.return = d), (Xs = p);
                          else
                            for (; null !== Xs; ) {
                              var m = (d = Xs).sibling,
                                h = d.return;
                              if ((il(d), d === u)) {
                                Xs = null;
                                break;
                              }
                              if (null !== m) {
                                (m.return = h), (Xs = m);
                                break;
                              }
                              Xs = h;
                            }
                        }
                      }
                      var f = i.alternate;
                      if (null !== f) {
                        var g = f.child;
                        if (null !== g) {
                          f.child = null;
                          do {
                            var v = g.sibling;
                            (g.sibling = null), (g = v);
                          } while (null !== g);
                        }
                      }
                      Xs = i;
                    }
                  }
                  if (0 != (2064 & i.subtreeFlags) && null !== s)
                    (s.return = i), (Xs = s);
                  else
                    e: for (; null !== Xs; ) {
                      if (0 != (2048 & (i = Xs).flags))
                        switch (i.tag) {
                          case 0:
                          case 11:
                          case 15:
                            rl(9, i, i.return);
                        }
                      var b = i.sibling;
                      if (null !== b) {
                        (b.return = i.return), (Xs = b);
                        break e;
                      }
                      Xs = i.return;
                    }
                }
                var _ = e.current;
                for (Xs = _; null !== Xs; ) {
                  var y = (s = Xs).child;
                  if (0 != (2064 & s.subtreeFlags) && null !== y)
                    (y.return = s), (Xs = y);
                  else
                    e: for (s = _; null !== Xs; ) {
                      if (0 != (2048 & (l = Xs).flags))
                        try {
                          switch (l.tag) {
                            case 0:
                            case 11:
                            case 15:
                              ol(9, l);
                          }
                        } catch (e) {
                          wc(l, l.return, e);
                        }
                      if (l === s) {
                        Xs = null;
                        break e;
                      }
                      var x = l.sibling;
                      if (null !== x) {
                        (x.return = l.return), (Xs = x);
                        break e;
                      }
                      Xs = l.return;
                    }
                }
                if (
                  ((Tl = o),
                  Vo(),
                  at && "function" == typeof at.onPostCommitFiberRoot)
                )
                  try {
                    at.onPostCommitFiberRoot(ot, e);
                  } catch (e) {}
                r = !0;
              }
              return r;
            } finally {
              (_t = n), (Il.transition = t);
            }
          }
          return !1;
        }
        function kc(e, t, n) {
          (e = Na(e, (t = hs(0, (t = us(n, t)), 1)), 1)),
            (t = tc()),
            null !== e && (vt(e, 1, t), oc(e, t));
        }
        function wc(e, t, n) {
          if (3 === e.tag) kc(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                kc(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" == typeof t.type.getDerivedStateFromError ||
                  ("function" == typeof r.componentDidCatch &&
                    (null === Kl || !Kl.has(r)))
                ) {
                  (t = Na(t, (e = fs(t, (e = us(n, e)), 1)), 1)),
                    (e = tc()),
                    null !== t && (vt(t, 1, e), oc(t, e));
                  break;
                }
              }
              t = t.return;
            }
        }
        function Pc(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (t = tc()),
            (e.pingedLanes |= e.suspendedLanes & n),
            Ml === e &&
              (Dl & n) === n &&
              (4 === Nl ||
              (3 === Nl && (130023424 & Dl) === Dl && 500 > Je() - Hl)
                ? mc(e, 0)
                : (Bl |= n)),
            oc(e, t);
        }
        function Oc(e, t) {
          0 === t &&
            (0 == (1 & e.mode)
              ? (t = 1)
              : ((t = ut), 0 == (130023424 & (ut <<= 1)) && (ut = 4194304)));
          var n = tc();
          null !== (e = Ma(e, t)) && (vt(e, t, n), oc(e, n));
        }
        function Ic(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), Oc(e, n);
        }
        function Tc(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                o = e.memoizedState;
              null !== o && (n = o.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            default:
              throw Error(a(314));
          }
          null !== r && r.delete(t), Oc(e, n);
        }
        function Mc(e, t) {
          return Ke(e, t);
        }
        function Ec(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function Dc(e, t, n, r) {
          return new Ec(e, t, n, r);
        }
        function jc(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Rc(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = Dc(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 14680064 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            n
          );
        }
        function Nc(e, t, n, r, o, i) {
          var s = 2;
          if (((r = e), "function" == typeof e)) jc(e) && (s = 1);
          else if ("string" == typeof e) s = 5;
          else
            e: switch (e) {
              case S:
                return Ac(n.children, o, i, t);
              case k:
                (s = 8), (o |= 8);
                break;
              case w:
                return (
                  ((e = Dc(12, n, t, 2 | o)).elementType = w), (e.lanes = i), e
                );
              case T:
                return (
                  ((e = Dc(13, n, t, o)).elementType = T), (e.lanes = i), e
                );
              case M:
                return (
                  ((e = Dc(19, n, t, o)).elementType = M), (e.lanes = i), e
                );
              case j:
                return Lc(n, o, i, t);
              default:
                if ("object" == typeof e && null !== e)
                  switch (e.$$typeof) {
                    case P:
                      s = 10;
                      break e;
                    case O:
                      s = 9;
                      break e;
                    case I:
                      s = 11;
                      break e;
                    case E:
                      s = 14;
                      break e;
                    case D:
                      (s = 16), (r = null);
                      break e;
                  }
                throw Error(a(130, null == e ? e : typeof e, ""));
            }
          return (
            ((t = Dc(s, n, t, o)).elementType = e),
            (t.type = r),
            (t.lanes = i),
            t
          );
        }
        function Ac(e, t, n, r) {
          return ((e = Dc(7, e, r, t)).lanes = n), e;
        }
        function Lc(e, t, n, r) {
          return (
            ((e = Dc(22, e, r, t)).elementType = j),
            (e.lanes = n),
            (e.stateNode = { isHidden: !1 }),
            e
          );
        }
        function zc(e, t, n) {
          return ((e = Dc(6, e, null, t)).lanes = n), e;
        }
        function Bc(e, t, n) {
          return (
            ((t = Dc(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        function Zc(e, t, n, r, o) {
          (this.tag = t),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = gt(0)),
            (this.expirationTimes = gt(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = gt(0)),
            (this.identifierPrefix = r),
            (this.onRecoverableError = o),
            (this.mutableSourceEagerHydrationData = null);
        }
        function Fc(e, t, n, r, o, a, i, s, l) {
          return (
            (e = new Zc(e, t, n, s, l)),
            1 === t ? ((t = 1), !0 === a && (t |= 8)) : (t = 0),
            (a = Dc(3, null, null, t)),
            (e.current = a),
            (a.stateNode = e),
            (a.memoizedState = {
              element: r,
              isDehydrated: n,
              cache: null,
              transitions: null,
              pendingSuspenseBoundaries: null,
            }),
            Da(a),
            e
          );
        }
        function Hc(e) {
          if (!e) return Io;
          e: {
            if (He((e = e._reactInternals)) !== e || 1 !== e.tag)
              throw Error(a(170));
            var t = e;
            do {
              switch (t.tag) {
                case 3:
                  t = t.stateNode.context;
                  break e;
                case 1:
                  if (jo(t.type)) {
                    t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                    break e;
                  }
              }
              t = t.return;
            } while (null !== t);
            throw Error(a(171));
          }
          if (1 === e.tag) {
            var n = e.type;
            if (jo(n)) return Ao(e, n, t);
          }
          return t;
        }
        function Vc(e, t, n, r, o, a, i, s, l) {
          return (
            ((e = Fc(n, r, !0, e, 0, a, 0, s, l)).context = Hc(null)),
            (n = e.current),
            ((a = Ra((r = tc()), (o = nc(n)))).callback = null != t ? t : null),
            Na(n, a, o),
            (e.current.lanes = o),
            vt(e, o, r),
            oc(e, r),
            e
          );
        }
        function Wc(e, t, n, r) {
          var o = t.current,
            a = tc(),
            i = nc(o);
          return (
            (n = Hc(n)),
            null === t.context ? (t.context = n) : (t.pendingContext = n),
            ((t = Ra(a, i)).payload = { element: e }),
            null !== (r = void 0 === r ? null : r) && (t.callback = r),
            null !== (e = Na(o, t, i)) && (rc(e, o, i, a), Aa(e, o, i)),
            i
          );
        }
        function $c(e) {
          return (e = e.current).child
            ? (e.child.tag, e.child.stateNode)
            : null;
        }
        function Uc(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function Kc(e, t) {
          Uc(e, t), (e = e.alternate) && Uc(e, t);
        }
        kl = function (e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps || Mo.current) ys = !0;
            else {
              if (0 == (e.lanes & n) && 0 == (128 & t.flags))
                return (
                  (ys = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        Ms(t), ha();
                        break;
                      case 5:
                        ii(t);
                        break;
                      case 1:
                        jo(t.type) && Lo(t);
                        break;
                      case 4:
                        oi(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        var r = t.type._context,
                          o = t.memoizedProps.value;
                        Oo(ba, r._currentValue), (r._currentValue = o);
                        break;
                      case 13:
                        if (null !== (r = t.memoizedState))
                          return null !== r.dehydrated
                            ? (Oo(li, 1 & li.current), (t.flags |= 128), null)
                            : 0 != (n & t.child.childLanes)
                            ? zs(e, t, n)
                            : (Oo(li, 1 & li.current),
                              null !== (e = $s(e, t, n)) ? e.sibling : null);
                        Oo(li, 1 & li.current);
                        break;
                      case 19:
                        if (
                          ((r = 0 != (n & t.childLanes)), 0 != (128 & e.flags))
                        ) {
                          if (r) return Vs(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (o = t.memoizedState) &&
                            ((o.rendering = null),
                            (o.tail = null),
                            (o.lastEffect = null)),
                          Oo(li, li.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), ws(e, t, n);
                    }
                    return $s(e, t, n);
                  })(e, t, n)
                );
              ys = 0 != (131072 & e.flags);
            }
          else (ys = !1), aa && 0 != (1048576 & t.flags) && ea(t, Ko, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 2:
              var r = t.type;
              Ws(e, t), (e = t.pendingProps);
              var o = Do(t, To.current);
              wa(t, n), (o = ki(null, t, r, e, o, n));
              var i = wi();
              return (
                (t.flags |= 1),
                "object" == typeof o &&
                null !== o &&
                "function" == typeof o.render &&
                void 0 === o.$$typeof
                  ? ((t.tag = 1),
                    (t.memoizedState = null),
                    (t.updateQueue = null),
                    jo(r) ? ((i = !0), Lo(t)) : (i = !1),
                    (t.memoizedState =
                      null !== o.state && void 0 !== o.state ? o.state : null),
                    Da(t),
                    (o.updater = Ha),
                    (t.stateNode = o),
                    (o._reactInternals = t),
                    Ua(t, r, e, n),
                    (t = Ts(null, t, r, !0, i, n)))
                  : ((t.tag = 0),
                    aa && i && ta(t),
                    xs(null, t, o, n),
                    (t = t.child)),
                t
              );
            case 16:
              r = t.elementType;
              e: {
                switch (
                  (Ws(e, t),
                  (e = t.pendingProps),
                  (r = (o = r._init)(r._payload)),
                  (t.type = r),
                  (o = t.tag =
                    (function (e) {
                      if ("function" == typeof e) return jc(e) ? 1 : 0;
                      if (null != e) {
                        if ((e = e.$$typeof) === I) return 11;
                        if (e === E) return 14;
                      }
                      return 2;
                    })(r)),
                  (e = va(r, e)),
                  o)
                ) {
                  case 0:
                    t = Os(null, t, r, e, n);
                    break e;
                  case 1:
                    t = Is(null, t, r, e, n);
                    break e;
                  case 11:
                    t = Cs(null, t, r, e, n);
                    break e;
                  case 14:
                    t = Ss(null, t, r, va(r.type, e), n);
                    break e;
                }
                throw Error(a(306, r, ""));
              }
              return t;
            case 0:
              return (
                (r = t.type),
                (o = t.pendingProps),
                Os(e, t, r, (o = t.elementType === r ? o : va(r, o)), n)
              );
            case 1:
              return (
                (r = t.type),
                (o = t.pendingProps),
                Is(e, t, r, (o = t.elementType === r ? o : va(r, o)), n)
              );
            case 3:
              e: {
                if ((Ms(t), null === e)) throw Error(a(387));
                (r = t.pendingProps),
                  (o = (i = t.memoizedState).element),
                  ja(e, t),
                  za(t, r, null, n);
                var s = t.memoizedState;
                if (((r = s.element), i.isDehydrated)) {
                  if (
                    ((i = {
                      element: r,
                      isDehydrated: !1,
                      cache: s.cache,
                      pendingSuspenseBoundaries: s.pendingSuspenseBoundaries,
                      transitions: s.transitions,
                    }),
                    (t.updateQueue.baseState = i),
                    (t.memoizedState = i),
                    256 & t.flags)
                  ) {
                    t = Es(e, t, r, n, (o = us(Error(a(423)), t)));
                    break e;
                  }
                  if (r !== o) {
                    t = Es(e, t, r, n, (o = us(Error(a(424)), t)));
                    break e;
                  }
                  for (
                    oa = co(t.stateNode.containerInfo.firstChild),
                      ra = t,
                      aa = !0,
                      ia = null,
                      n = Qa(t, null, r, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((ha(), r === o)) {
                    t = $s(e, t, n);
                    break e;
                  }
                  xs(e, t, r, n);
                }
                t = t.child;
              }
              return t;
            case 5:
              return (
                ii(t),
                null === e && ua(t),
                (r = t.type),
                (o = t.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (s = o.children),
                no(r, o)
                  ? (s = null)
                  : null !== i && no(r, i) && (t.flags |= 32),
                Ps(e, t),
                xs(e, t, s, n),
                t.child
              );
            case 6:
              return null === e && ua(t), null;
            case 13:
              return zs(e, t, n);
            case 4:
              return (
                oi(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = Ja(t, null, r, n)) : xs(e, t, r, n),
                t.child
              );
            case 11:
              return (
                (r = t.type),
                (o = t.pendingProps),
                Cs(e, t, r, (o = t.elementType === r ? o : va(r, o)), n)
              );
            case 7:
              return xs(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return xs(e, t, t.pendingProps.children, n), t.child;
            case 10:
              e: {
                if (
                  ((r = t.type._context),
                  (o = t.pendingProps),
                  (i = t.memoizedProps),
                  (s = o.value),
                  Oo(ba, r._currentValue),
                  (r._currentValue = s),
                  null !== i)
                )
                  if (sr(i.value, s)) {
                    if (i.children === o.children && !Mo.current) {
                      t = $s(e, t, n);
                      break e;
                    }
                  } else
                    for (
                      null !== (i = t.child) && (i.return = t);
                      null !== i;

                    ) {
                      var l = i.dependencies;
                      if (null !== l) {
                        s = i.child;
                        for (var c = l.firstContext; null !== c; ) {
                          if (c.context === r) {
                            if (1 === i.tag) {
                              (c = Ra(-1, n & -n)).tag = 2;
                              var u = i.updateQueue;
                              if (null !== u) {
                                var d = (u = u.shared).pending;
                                null === d
                                  ? (c.next = c)
                                  : ((c.next = d.next), (d.next = c)),
                                  (u.pending = c);
                              }
                            }
                            (i.lanes |= n),
                              null !== (c = i.alternate) && (c.lanes |= n),
                              ka(i.return, n, t),
                              (l.lanes |= n);
                            break;
                          }
                          c = c.next;
                        }
                      } else if (10 === i.tag)
                        s = i.type === t.type ? null : i.child;
                      else if (18 === i.tag) {
                        if (null === (s = i.return)) throw Error(a(341));
                        (s.lanes |= n),
                          null !== (l = s.alternate) && (l.lanes |= n),
                          ka(s, n, t),
                          (s = i.sibling);
                      } else s = i.child;
                      if (null !== s) s.return = i;
                      else
                        for (s = i; null !== s; ) {
                          if (s === t) {
                            s = null;
                            break;
                          }
                          if (null !== (i = s.sibling)) {
                            (i.return = s.return), (s = i);
                            break;
                          }
                          s = s.return;
                        }
                      i = s;
                    }
                xs(e, t, o.children, n), (t = t.child);
              }
              return t;
            case 9:
              return (
                (o = t.type),
                (r = t.pendingProps.children),
                wa(t, n),
                (r = r((o = Pa(o)))),
                (t.flags |= 1),
                xs(e, t, r, n),
                t.child
              );
            case 14:
              return (
                (o = va((r = t.type), t.pendingProps)),
                Ss(e, t, r, (o = va(r.type, o)), n)
              );
            case 15:
              return ks(e, t, t.type, t.pendingProps, n);
            case 17:
              return (
                (r = t.type),
                (o = t.pendingProps),
                (o = t.elementType === r ? o : va(r, o)),
                Ws(e, t),
                (t.tag = 1),
                jo(r) ? ((e = !0), Lo(t)) : (e = !1),
                wa(t, n),
                Wa(t, r, o),
                Ua(t, r, o, n),
                Ts(null, t, r, !0, e, n)
              );
            case 19:
              return Vs(e, t, n);
            case 22:
              return ws(e, t, n);
          }
          throw Error(a(156, t.tag));
        };
        var Gc =
          "function" == typeof reportError
            ? reportError
            : function (e) {
                console.error(e);
              };
        function qc(e) {
          this._internalRoot = e;
        }
        function Yc(e) {
          this._internalRoot = e;
        }
        function Jc(e) {
          return !(
            !e ||
            (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType)
          );
        }
        function Qc(e) {
          return !(
            !e ||
            (1 !== e.nodeType &&
              9 !== e.nodeType &&
              11 !== e.nodeType &&
              (8 !== e.nodeType ||
                " react-mount-point-unstable " !== e.nodeValue))
          );
        }
        function Xc() {}
        function eu(e, t, n, r, o) {
          var a = n._reactRootContainer;
          if (a) {
            var i = a;
            if ("function" == typeof o) {
              var s = o;
              o = function () {
                var e = $c(i);
                s.call(e);
              };
            }
            Wc(t, i, e, o);
          } else
            i = (function (e, t, n, r, o) {
              if (o) {
                if ("function" == typeof r) {
                  var a = r;
                  r = function () {
                    var e = $c(i);
                    a.call(e);
                  };
                }
                var i = Vc(t, r, e, 0, null, !1, 0, "", Xc);
                return (
                  (e._reactRootContainer = i),
                  (e[fo] = i.current),
                  Hr(8 === e.nodeType ? e.parentNode : e),
                  dc(),
                  i
                );
              }
              for (; (o = e.lastChild); ) e.removeChild(o);
              if ("function" == typeof r) {
                var s = r;
                r = function () {
                  var e = $c(l);
                  s.call(e);
                };
              }
              var l = Fc(e, 0, !1, null, 0, !1, 0, "", Xc);
              return (
                (e._reactRootContainer = l),
                (e[fo] = l.current),
                Hr(8 === e.nodeType ? e.parentNode : e),
                dc(function () {
                  Wc(t, l, n, r);
                }),
                l
              );
            })(n, t, e, o, r);
          return $c(i);
        }
        (Yc.prototype.render = qc.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(a(409));
            Wc(e, t, null, null);
          }),
          (Yc.prototype.unmount = qc.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                dc(function () {
                  Wc(null, e, null, null);
                }),
                  (t[fo] = null);
              }
            }),
          (Yc.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = kt();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < jt.length && 0 !== t && t < jt[n].priority;
                n++
              );
              jt.splice(n, 0, e), 0 === n && Lt(e);
            }
          }),
          (xt = function (e) {
            switch (e.tag) {
              case 3:
                var t = e.stateNode;
                if (t.current.memoizedState.isDehydrated) {
                  var n = dt(t.pendingLanes);
                  0 !== n &&
                    (bt(t, 1 | n),
                    oc(t, Je()),
                    0 == (6 & Tl) && ((Vl = Je() + 500), Vo()));
                }
                break;
              case 13:
                dc(function () {
                  var t = Ma(e, 1);
                  if (null !== t) {
                    var n = tc();
                    rc(t, e, 1, n);
                  }
                }),
                  Kc(e, 1);
            }
          }),
          (Ct = function (e) {
            if (13 === e.tag) {
              var t = Ma(e, 134217728);
              null !== t && rc(t, e, 134217728, tc()), Kc(e, 134217728);
            }
          }),
          (St = function (e) {
            if (13 === e.tag) {
              var t = nc(e),
                n = Ma(e, t);
              null !== n && rc(n, e, t, tc()), Kc(e, t);
            }
          }),
          (kt = function () {
            return _t;
          }),
          (wt = function (e, t) {
            var n = _t;
            try {
              return (_t = e), t();
            } finally {
              _t = n;
            }
          }),
          (Ce = function (e, t, n) {
            switch (t) {
              case "input":
                if ((Q(e, n), (t = n.name), "radio" === n.type && null != t)) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      "input[name=" + JSON.stringify("" + t) + '][type="radio"]'
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var o = Co(r);
                      if (!o) throw Error(a(90));
                      K(r), Q(r, o);
                    }
                  }
                }
                break;
              case "textarea":
                ae(e, n);
                break;
              case "select":
                null != (t = n.value) && ne(e, !!n.multiple, t, !1);
            }
          }),
          (Ie = uc),
          (Te = dc);
        var tu = {
            usingClientEntryPoint: !1,
            Events: [yo, xo, Co, Pe, Oe, uc],
          },
          nu = {
            findFiberByHostInstance: _o,
            bundleType: 0,
            version: "18.2.0",
            rendererPackageName: "react-dom",
          },
          ru = {
            bundleType: nu.bundleType,
            version: nu.version,
            rendererPackageName: nu.rendererPackageName,
            rendererConfig: nu.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: y.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = $e(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance:
              nu.findFiberByHostInstance ||
              function () {
                return null;
              },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.2.0-next-9e3b772b8-20220608",
          };
        if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var ou = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!ou.isDisabled && ou.supportsFiber)
            try {
              (ot = ou.inject(ru)), (at = ou);
            } catch (ue) {}
        }
        (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tu),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (!Jc(t)) throw Error(a(200));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: C,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.createRoot = function (e, t) {
            if (!Jc(e)) throw Error(a(299));
            var n = !1,
              r = "",
              o = Gc;
            return (
              null != t &&
                (!0 === t.unstable_strictMode && (n = !0),
                void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
                void 0 !== t.onRecoverableError && (o = t.onRecoverableError)),
              (t = Fc(e, 1, !1, null, 0, n, 0, r, o)),
              (e[fo] = t.current),
              Hr(8 === e.nodeType ? e.parentNode : e),
              new qc(t)
            );
          }),
          (t.findDOMNode = function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var t = e._reactInternals;
            if (void 0 === t) {
              if ("function" == typeof e.render) throw Error(a(188));
              throw ((e = Object.keys(e).join(",")), Error(a(268, e)));
            }
            return null === (e = $e(t)) ? null : e.stateNode;
          }),
          (t.flushSync = function (e) {
            return dc(e);
          }),
          (t.hydrate = function (e, t, n) {
            if (!Qc(t)) throw Error(a(200));
            return eu(null, e, t, !0, n);
          }),
          (t.hydrateRoot = function (e, t, n) {
            if (!Jc(e)) throw Error(a(405));
            var r = (null != n && n.hydratedSources) || null,
              o = !1,
              i = "",
              s = Gc;
            if (
              (null != n &&
                (!0 === n.unstable_strictMode && (o = !0),
                void 0 !== n.identifierPrefix && (i = n.identifierPrefix),
                void 0 !== n.onRecoverableError && (s = n.onRecoverableError)),
              (t = Vc(t, null, e, 1, null != n ? n : null, o, 0, i, s)),
              (e[fo] = t.current),
              Hr(e),
              r)
            )
              for (e = 0; e < r.length; e++)
                (o = (o = (n = r[e])._getVersion)(n._source)),
                  null == t.mutableSourceEagerHydrationData
                    ? (t.mutableSourceEagerHydrationData = [n, o])
                    : t.mutableSourceEagerHydrationData.push(n, o);
            return new Yc(t);
          }),
          (t.render = function (e, t, n) {
            if (!Qc(t)) throw Error(a(200));
            return eu(null, e, t, !1, n);
          }),
          (t.unmountComponentAtNode = function (e) {
            if (!Qc(e)) throw Error(a(40));
            return (
              !!e._reactRootContainer &&
              (dc(function () {
                eu(null, null, e, !1, function () {
                  (e._reactRootContainer = null), (e[fo] = null);
                });
              }),
              !0)
            );
          }),
          (t.unstable_batchedUpdates = uc),
          (t.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
            if (!Qc(n)) throw Error(a(200));
            if (null == e || void 0 === e._reactInternals) throw Error(a(38));
            return eu(e, t, n, !1, r);
          }),
          (t.version = "18.2.0-next-9e3b772b8-20220608");
      },
      3935: function (e, t, n) {
        "use strict";
        !(function e() {
          if (
            "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (e) {
              console.error(e);
            }
        })(),
          (e.exports = n(4448));
      },
      9921: function (e, t) {
        "use strict";
        var n = "function" == typeof Symbol && Symbol.for,
          r = n ? Symbol.for("react.element") : 60103,
          o = n ? Symbol.for("react.portal") : 60106,
          a = n ? Symbol.for("react.fragment") : 60107,
          i = n ? Symbol.for("react.strict_mode") : 60108,
          s = n ? Symbol.for("react.profiler") : 60114,
          l = n ? Symbol.for("react.provider") : 60109,
          c = n ? Symbol.for("react.context") : 60110,
          u = n ? Symbol.for("react.async_mode") : 60111,
          d = n ? Symbol.for("react.concurrent_mode") : 60111,
          p = n ? Symbol.for("react.forward_ref") : 60112,
          m = n ? Symbol.for("react.suspense") : 60113,
          h = n ? Symbol.for("react.suspense_list") : 60120,
          f = n ? Symbol.for("react.memo") : 60115,
          g = n ? Symbol.for("react.lazy") : 60116,
          v = n ? Symbol.for("react.block") : 60121,
          b = n ? Symbol.for("react.fundamental") : 60117,
          _ = n ? Symbol.for("react.responder") : 60118,
          y = n ? Symbol.for("react.scope") : 60119;
        function x(e) {
          if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
              case r:
                switch ((e = e.type)) {
                  case u:
                  case d:
                  case a:
                  case s:
                  case i:
                  case m:
                    return e;
                  default:
                    switch ((e = e && e.$$typeof)) {
                      case c:
                      case p:
                      case g:
                      case f:
                      case l:
                        return e;
                      default:
                        return t;
                    }
                }
              case o:
                return t;
            }
          }
        }
        function C(e) {
          return x(e) === d;
        }
        (t.AsyncMode = u),
          (t.ConcurrentMode = d),
          (t.ContextConsumer = c),
          (t.ContextProvider = l),
          (t.Element = r),
          (t.ForwardRef = p),
          (t.Fragment = a),
          (t.Lazy = g),
          (t.Memo = f),
          (t.Portal = o),
          (t.Profiler = s),
          (t.StrictMode = i),
          (t.Suspense = m),
          (t.isAsyncMode = function (e) {
            return C(e) || x(e) === u;
          }),
          (t.isConcurrentMode = C),
          (t.isContextConsumer = function (e) {
            return x(e) === c;
          }),
          (t.isContextProvider = function (e) {
            return x(e) === l;
          }),
          (t.isElement = function (e) {
            return "object" == typeof e && null !== e && e.$$typeof === r;
          }),
          (t.isForwardRef = function (e) {
            return x(e) === p;
          }),
          (t.isFragment = function (e) {
            return x(e) === a;
          }),
          (t.isLazy = function (e) {
            return x(e) === g;
          }),
          (t.isMemo = function (e) {
            return x(e) === f;
          }),
          (t.isPortal = function (e) {
            return x(e) === o;
          }),
          (t.isProfiler = function (e) {
            return x(e) === s;
          }),
          (t.isStrictMode = function (e) {
            return x(e) === i;
          }),
          (t.isSuspense = function (e) {
            return x(e) === m;
          }),
          (t.isValidElementType = function (e) {
            return (
              "string" == typeof e ||
              "function" == typeof e ||
              e === a ||
              e === d ||
              e === s ||
              e === i ||
              e === m ||
              e === h ||
              ("object" == typeof e &&
                null !== e &&
                (e.$$typeof === g ||
                  e.$$typeof === f ||
                  e.$$typeof === l ||
                  e.$$typeof === c ||
                  e.$$typeof === p ||
                  e.$$typeof === b ||
                  e.$$typeof === _ ||
                  e.$$typeof === y ||
                  e.$$typeof === v))
            );
          }),
          (t.typeOf = x);
      },
      9864: function (e, t, n) {
        "use strict";
        e.exports = n(9921);
      },
      8359: function (e, t) {
        "use strict";
        if ("function" == typeof Symbol && Symbol.for) {
          var n = Symbol.for;
          n("react.element"),
            n("react.portal"),
            n("react.fragment"),
            n("react.strict_mode"),
            n("react.profiler"),
            n("react.provider"),
            n("react.context"),
            n("react.forward_ref"),
            n("react.suspense"),
            n("react.suspense_list"),
            n("react.memo"),
            n("react.lazy"),
            n("react.block"),
            n("react.server.block"),
            n("react.fundamental"),
            n("react.debug_trace_mode"),
            n("react.legacy_hidden");
        }
      },
      2973: function (e, t, n) {
        "use strict";
        n(8359);
      },
      5251: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = Symbol.for("react.element"),
          a = Symbol.for("react.fragment"),
          i = Object.prototype.hasOwnProperty,
          s =
            r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
              .ReactCurrentOwner,
          l = { key: !0, ref: !0, __self: !0, __source: !0 };
        function c(e, t, n) {
          var r,
            a = {},
            c = null,
            u = null;
          for (r in (void 0 !== n && (c = "" + n),
          void 0 !== t.key && (c = "" + t.key),
          void 0 !== t.ref && (u = t.ref),
          t))
            i.call(t, r) && !l.hasOwnProperty(r) && (a[r] = t[r]);
          if (e && e.defaultProps)
            for (r in (t = e.defaultProps)) void 0 === a[r] && (a[r] = t[r]);
          return {
            $$typeof: o,
            type: e,
            key: c,
            ref: u,
            props: a,
            _owner: s.current,
          };
        }
        (t.Fragment = a), (t.jsx = c), (t.jsxs = c);
      },
      2408: function (e, t) {
        "use strict";
        var n = Symbol.for("react.element"),
          r = Symbol.for("react.portal"),
          o = Symbol.for("react.fragment"),
          a = Symbol.for("react.strict_mode"),
          i = Symbol.for("react.profiler"),
          s = Symbol.for("react.provider"),
          l = Symbol.for("react.context"),
          c = Symbol.for("react.forward_ref"),
          u = Symbol.for("react.suspense"),
          d = Symbol.for("react.memo"),
          p = Symbol.for("react.lazy"),
          m = Symbol.iterator,
          h = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          f = Object.assign,
          g = {};
        function v(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = g),
            (this.updater = n || h);
        }
        function b() {}
        function _(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = g),
            (this.updater = n || h);
        }
        (v.prototype.isReactComponent = {}),
          (v.prototype.setState = function (e, t) {
            if ("object" != typeof e && "function" != typeof e && null != e)
              throw Error(
                "setState(...): takes an object of state variables to update or a function which returns an object of state variables."
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (v.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (b.prototype = v.prototype);
        var y = (_.prototype = new b());
        (y.constructor = _), f(y, v.prototype), (y.isPureReactComponent = !0);
        var x = Array.isArray,
          C = Object.prototype.hasOwnProperty,
          S = { current: null },
          k = { key: !0, ref: !0, __self: !0, __source: !0 };
        function w(e, t, r) {
          var o,
            a = {},
            i = null,
            s = null;
          if (null != t)
            for (o in (void 0 !== t.ref && (s = t.ref),
            void 0 !== t.key && (i = "" + t.key),
            t))
              C.call(t, o) && !k.hasOwnProperty(o) && (a[o] = t[o]);
          var l = arguments.length - 2;
          if (1 === l) a.children = r;
          else if (1 < l) {
            for (var c = Array(l), u = 0; u < l; u++) c[u] = arguments[u + 2];
            a.children = c;
          }
          if (e && e.defaultProps)
            for (o in (l = e.defaultProps)) void 0 === a[o] && (a[o] = l[o]);
          return {
            $$typeof: n,
            type: e,
            key: i,
            ref: s,
            props: a,
            _owner: S.current,
          };
        }
        function P(e) {
          return "object" == typeof e && null !== e && e.$$typeof === n;
        }
        var O = /\/+/g;
        function I(e, t) {
          return "object" == typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                  "$" +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })("" + e.key)
            : t.toString(36);
        }
        function T(e, t, o, a, i) {
          var s = typeof e;
          ("undefined" !== s && "boolean" !== s) || (e = null);
          var l = !1;
          if (null === e) l = !0;
          else
            switch (s) {
              case "string":
              case "number":
                l = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    l = !0;
                }
            }
          if (l)
            return (
              (i = i((l = e))),
              (e = "" === a ? "." + I(l, 0) : a),
              x(i)
                ? ((o = ""),
                  null != e && (o = e.replace(O, "$&/") + "/"),
                  T(i, t, o, "", function (e) {
                    return e;
                  }))
                : null != i &&
                  (P(i) &&
                    (i = (function (e, t) {
                      return {
                        $$typeof: n,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner,
                      };
                    })(
                      i,
                      o +
                        (!i.key || (l && l.key === i.key)
                          ? ""
                          : ("" + i.key).replace(O, "$&/") + "/") +
                        e
                    )),
                  t.push(i)),
              1
            );
          if (((l = 0), (a = "" === a ? "." : a + ":"), x(e)))
            for (var c = 0; c < e.length; c++) {
              var u = a + I((s = e[c]), c);
              l += T(s, t, o, u, i);
            }
          else if (
            ((u = (function (e) {
              return null === e || "object" != typeof e
                ? null
                : "function" == typeof (e = (m && e[m]) || e["@@iterator"])
                ? e
                : null;
            })(e)),
            "function" == typeof u)
          )
            for (e = u.call(e), c = 0; !(s = e.next()).done; )
              l += T((s = s.value), t, o, (u = a + I(s, c++)), i);
          else if ("object" === s)
            throw (
              ((t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead."
              ))
            );
          return l;
        }
        function M(e, t, n) {
          if (null == e) return e;
          var r = [],
            o = 0;
          return (
            T(e, r, "", "", function (e) {
              return t.call(n, e, o++);
            }),
            r
          );
        }
        function E(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              }
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var D = { current: null },
          j = { transition: null },
          R = {
            ReactCurrentDispatcher: D,
            ReactCurrentBatchConfig: j,
            ReactCurrentOwner: S,
          };
        (t.Children = {
          map: M,
          forEach: function (e, t, n) {
            M(
              e,
              function () {
                t.apply(this, arguments);
              },
              n
            );
          },
          count: function (e) {
            var t = 0;
            return (
              M(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              M(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!P(e))
              throw Error(
                "React.Children.only expected to receive a single React element child."
              );
            return e;
          },
        }),
          (t.Component = v),
          (t.Fragment = o),
          (t.Profiler = i),
          (t.PureComponent = _),
          (t.StrictMode = a),
          (t.Suspense = u),
          (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = R),
          (t.cloneElement = function (e, t, r) {
            if (null == e)
              throw Error(
                "React.cloneElement(...): The argument must be a React element, but you passed " +
                  e +
                  "."
              );
            var o = f({}, e.props),
              a = e.key,
              i = e.ref,
              s = e._owner;
            if (null != t) {
              if (
                (void 0 !== t.ref && ((i = t.ref), (s = S.current)),
                void 0 !== t.key && (a = "" + t.key),
                e.type && e.type.defaultProps)
              )
                var l = e.type.defaultProps;
              for (c in t)
                C.call(t, c) &&
                  !k.hasOwnProperty(c) &&
                  (o[c] = void 0 === t[c] && void 0 !== l ? l[c] : t[c]);
            }
            var c = arguments.length - 2;
            if (1 === c) o.children = r;
            else if (1 < c) {
              l = Array(c);
              for (var u = 0; u < c; u++) l[u] = arguments[u + 2];
              o.children = l;
            }
            return {
              $$typeof: n,
              type: e.type,
              key: a,
              ref: i,
              props: o,
              _owner: s,
            };
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: l,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null,
              }).Provider = { $$typeof: s, _context: e }),
              (e.Consumer = e)
            );
          }),
          (t.createElement = w),
          (t.createFactory = function (e) {
            var t = w.bind(null, e);
            return (t.type = e), t;
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: c, render: e };
          }),
          (t.isValidElement = P),
          (t.lazy = function (e) {
            return {
              $$typeof: p,
              _payload: { _status: -1, _result: e },
              _init: E,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: d, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = j.transition;
            j.transition = {};
            try {
              e();
            } finally {
              j.transition = t;
            }
          }),
          (t.unstable_act = function () {
            throw Error(
              "act(...) is not supported in production builds of React."
            );
          }),
          (t.useCallback = function (e, t) {
            return D.current.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return D.current.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e) {
            return D.current.useDeferredValue(e);
          }),
          (t.useEffect = function (e, t) {
            return D.current.useEffect(e, t);
          }),
          (t.useId = function () {
            return D.current.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return D.current.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return D.current.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return D.current.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return D.current.useMemo(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return D.current.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return D.current.useRef(e);
          }),
          (t.useState = function (e) {
            return D.current.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return D.current.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return D.current.useTransition();
          }),
          (t.version = "18.2.0");
      },
      7294: function (e, t, n) {
        "use strict";
        e.exports = n(2408);
      },
      5893: function (e, t, n) {
        "use strict";
        e.exports = n(5251);
      },
      53: function (e, t) {
        "use strict";
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              o = e[r];
            if (!(0 < a(o, t))) break e;
            (e[r] = t), (e[n] = o), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function o(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, o = e.length, i = o >>> 1; r < i; ) {
              var s = 2 * (r + 1) - 1,
                l = e[s],
                c = s + 1,
                u = e[c];
              if (0 > a(l, n))
                c < o && 0 > a(u, l)
                  ? ((e[r] = u), (e[c] = n), (r = c))
                  : ((e[r] = l), (e[s] = n), (r = s));
              else {
                if (!(c < o && 0 > a(u, n))) break e;
                (e[r] = u), (e[c] = n), (r = c);
              }
            }
          }
          return t;
        }
        function a(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          "object" == typeof performance &&
          "function" == typeof performance.now
        ) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var s = Date,
            l = s.now();
          t.unstable_now = function () {
            return s.now() - l;
          };
        }
        var c = [],
          u = [],
          d = 1,
          p = null,
          m = 3,
          h = !1,
          f = !1,
          g = !1,
          v = "function" == typeof setTimeout ? setTimeout : null,
          b = "function" == typeof clearTimeout ? clearTimeout : null,
          _ = "undefined" != typeof setImmediate ? setImmediate : null;
        function y(e) {
          for (var t = r(u); null !== t; ) {
            if (null === t.callback) o(u);
            else {
              if (!(t.startTime <= e)) break;
              o(u), (t.sortIndex = t.expirationTime), n(c, t);
            }
            t = r(u);
          }
        }
        function x(e) {
          if (((g = !1), y(e), !f))
            if (null !== r(c)) (f = !0), j(C);
            else {
              var t = r(u);
              null !== t && R(x, t.startTime - e);
            }
        }
        function C(e, n) {
          (f = !1), g && ((g = !1), b(P), (P = -1)), (h = !0);
          var a = m;
          try {
            for (
              y(n), p = r(c);
              null !== p && (!(p.expirationTime > n) || (e && !T()));

            ) {
              var i = p.callback;
              if ("function" == typeof i) {
                (p.callback = null), (m = p.priorityLevel);
                var s = i(p.expirationTime <= n);
                (n = t.unstable_now()),
                  "function" == typeof s
                    ? (p.callback = s)
                    : p === r(c) && o(c),
                  y(n);
              } else o(c);
              p = r(c);
            }
            if (null !== p) var l = !0;
            else {
              var d = r(u);
              null !== d && R(x, d.startTime - n), (l = !1);
            }
            return l;
          } finally {
            (p = null), (m = a), (h = !1);
          }
        }
        "undefined" != typeof navigator &&
          void 0 !== navigator.scheduling &&
          void 0 !== navigator.scheduling.isInputPending &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var S,
          k = !1,
          w = null,
          P = -1,
          O = 5,
          I = -1;
        function T() {
          return !(t.unstable_now() - I < O);
        }
        function M() {
          if (null !== w) {
            var e = t.unstable_now();
            I = e;
            var n = !0;
            try {
              n = w(!0, e);
            } finally {
              n ? S() : ((k = !1), (w = null));
            }
          } else k = !1;
        }
        if ("function" == typeof _)
          S = function () {
            _(M);
          };
        else if ("undefined" != typeof MessageChannel) {
          var E = new MessageChannel(),
            D = E.port2;
          (E.port1.onmessage = M),
            (S = function () {
              D.postMessage(null);
            });
        } else
          S = function () {
            v(M, 0);
          };
        function j(e) {
          (w = e), k || ((k = !0), S());
        }
        function R(e, n) {
          P = v(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            f || h || ((f = !0), j(C));
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (O = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return m;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(c);
          }),
          (t.unstable_next = function (e) {
            switch (m) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = m;
            }
            var n = m;
            m = t;
            try {
              return e();
            } finally {
              m = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = m;
            m = e;
            try {
              return t();
            } finally {
              m = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, o, a) {
            var i = t.unstable_now();
            switch (
              ((a =
                "object" == typeof a &&
                null !== a &&
                "number" == typeof (a = a.delay) &&
                0 < a
                  ? i + a
                  : i),
              e)
            ) {
              case 1:
                var s = -1;
                break;
              case 2:
                s = 250;
                break;
              case 5:
                s = 1073741823;
                break;
              case 4:
                s = 1e4;
                break;
              default:
                s = 5e3;
            }
            return (
              (e = {
                id: d++,
                callback: o,
                priorityLevel: e,
                startTime: a,
                expirationTime: (s = a + s),
                sortIndex: -1,
              }),
              a > i
                ? ((e.sortIndex = a),
                  n(u, e),
                  null === r(c) &&
                    e === r(u) &&
                    (g ? (b(P), (P = -1)) : (g = !0), R(x, a - i)))
                : ((e.sortIndex = s), n(c, e), f || h || ((f = !0), j(C))),
              e
            );
          }),
          (t.unstable_shouldYield = T),
          (t.unstable_wrapCallback = function (e) {
            var t = m;
            return function () {
              var n = m;
              m = t;
              try {
                return e.apply(this, arguments);
              } finally {
                m = n;
              }
            };
          });
      },
      3840: function (e, t, n) {
        "use strict";
        e.exports = n(53);
      },
      1739: function (e) {
        e.exports = {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0,
        };
      },
      434: function (e) {
        function t() {
          return (
            (e.exports = t =
              Object.assign
                ? Object.assign.bind()
                : function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = arguments[t];
                      for (var r in n)
                        Object.prototype.hasOwnProperty.call(n, r) &&
                          (e[r] = n[r]);
                    }
                    return e;
                  }),
            (e.exports.__esModule = !0),
            (e.exports.default = e.exports),
            t.apply(this, arguments)
          );
        }
        (e.exports = t),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
      },
      4836: function (e) {
        (e.exports = function (e) {
          return e && e.__esModule ? e : { default: e };
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
      },
      7071: function (e) {
        (e.exports = function (e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            a = Object.keys(e);
          for (r = 0; r < a.length; r++)
            (n = a[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
      },
      7462: function (e, t, n) {
        "use strict";
        function r() {
          return (
            (r = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }),
            r.apply(this, arguments)
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      3366: function (e, t, n) {
        "use strict";
        function r(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            a = Object.keys(e);
          for (r = 0; r < a.length; r++)
            (n = a[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      3961: function (e, t, n) {
        "use strict";
        function r(e) {
          var t,
            n,
            o = "";
          if ("string" == typeof e || "number" == typeof e) o += e;
          else if ("object" == typeof e)
            if (Array.isArray(e)) {
              var a = e.length;
              for (t = 0; t < a; t++)
                e[t] && (n = r(e[t])) && (o && (o += " "), (o += n));
            } else for (n in e) e[n] && (o && (o += " "), (o += n));
          return o;
        }
        t.Z = function () {
          for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++)
            (e = arguments[n]) && (t = r(e)) && (o && (o += " "), (o += t));
          return o;
        };
      },
    },
    r = {};
  function o(e) {
    var t = r[e];
    if (void 0 !== t) return t.exports;
    var a = (r[e] = { exports: {} });
    return n[e].call(a.exports, a, a.exports, o), a.exports;
  }
  (o.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return o.d(t, { a: t }), t;
  }),
    (t = Object.getPrototypeOf
      ? function (e) {
          return Object.getPrototypeOf(e);
        }
      : function (e) {
          return e.__proto__;
        }),
    (o.t = function (n, r) {
      if ((1 & r && (n = this(n)), 8 & r)) return n;
      if ("object" == typeof n && n) {
        if (4 & r && n.__esModule) return n;
        if (16 & r && "function" == typeof n.then) return n;
      }
      var a = Object.create(null);
      o.r(a);
      var i = {};
      e = e || [null, t({}), t([]), t(t)];
      for (var s = 2 & r && n; "object" == typeof s && !~e.indexOf(s); s = t(s))
        Object.getOwnPropertyNames(s).forEach(function (e) {
          i[e] = function () {
            return n[e];
          };
        });
      return (
        (i.default = function () {
          return n;
        }),
        o.d(a, i),
        a
      );
    }),
    (o.d = function (e, t) {
      for (var n in t)
        o.o(t, n) &&
          !o.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (o.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (o.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (function () {
      "use strict";
      var e = o(5893),
        t = o(7294),
        n = o.t(t, 2),
        r = o(3935),
        a = t.createContext(null),
        i = function (e) {
          e();
        },
        s = function () {
          return i;
        },
        l = {
          notify: function () {},
          get: function () {
            return [];
          },
        };
      function c(e, t) {
        var n,
          r = l;
        function o() {
          i.onStateChange && i.onStateChange();
        }
        function a() {
          n ||
            ((n = t ? t.addNestedSub(o) : e.subscribe(o)),
            (r = (function () {
              var e = s(),
                t = null,
                n = null;
              return {
                clear: function () {
                  (t = null), (n = null);
                },
                notify: function () {
                  e(function () {
                    for (var e = t; e; ) e.callback(), (e = e.next);
                  });
                },
                get: function () {
                  for (var e = [], n = t; n; ) e.push(n), (n = n.next);
                  return e;
                },
                subscribe: function (e) {
                  var r = !0,
                    o = (n = { callback: e, next: null, prev: n });
                  return (
                    o.prev ? (o.prev.next = o) : (t = o),
                    function () {
                      r &&
                        null !== t &&
                        ((r = !1),
                        o.next ? (o.next.prev = o.prev) : (n = o.prev),
                        o.prev ? (o.prev.next = o.next) : (t = o.next));
                    }
                  );
                },
              };
            })()));
        }
        var i = {
          addNestedSub: function (e) {
            return a(), r.subscribe(e);
          },
          notifyNestedSubs: function () {
            r.notify();
          },
          handleChangeWrapper: o,
          isSubscribed: function () {
            return Boolean(n);
          },
          trySubscribe: a,
          tryUnsubscribe: function () {
            n && (n(), (n = void 0), r.clear(), (r = l));
          },
          getListeners: function () {
            return r;
          },
        };
        return i;
      }
      var u =
        "undefined" != typeof window &&
        void 0 !== window.document &&
        void 0 !== window.document.createElement
          ? t.useLayoutEffect
          : t.useEffect;
      o(8679), o(2973);
      var d = o(7462);
      function p() {
        return (0, t.useContext)(a);
      }
      function m(e) {
        void 0 === e && (e = a);
        var n =
          e === a
            ? p
            : function () {
                return (0, t.useContext)(e);
              };
        return function () {
          return n().store;
        };
      }
      var h = m();
      function f(e) {
        void 0 === e && (e = a);
        var t = e === a ? h : m(e);
        return function () {
          return t().dispatch;
        };
      }
      var g = f(),
        v = function (e, t) {
          return e === t;
        };
      function b(e) {
        void 0 === e && (e = a);
        var n =
          e === a
            ? p
            : function () {
                return (0, t.useContext)(e);
              };
        return function (e, r) {
          void 0 === r && (r = v);
          var o = n(),
            a = (function (e, n, r, o) {
              var a,
                i = (0, t.useReducer)(function (e) {
                  return e + 1;
                }, 0)[1],
                s = (0, t.useMemo)(
                  function () {
                    return c(r, o);
                  },
                  [r, o]
                ),
                l = (0, t.useRef)(),
                d = (0, t.useRef)(),
                p = (0, t.useRef)(),
                m = (0, t.useRef)(),
                h = r.getState();
              try {
                if (e !== d.current || h !== p.current || l.current) {
                  var f = e(h);
                  a = void 0 !== m.current && n(f, m.current) ? m.current : f;
                } else a = m.current;
              } catch (e) {
                throw (
                  (l.current &&
                    (e.message +=
                      "\nThe error may be correlated with this previous error:\n" +
                      l.current.stack +
                      "\n\n"),
                  e)
                );
              }
              return (
                u(function () {
                  (d.current = e),
                    (p.current = h),
                    (m.current = a),
                    (l.current = void 0);
                }),
                u(
                  function () {
                    function e() {
                      try {
                        var e = r.getState();
                        if (e === p.current) return;
                        var t = d.current(e);
                        if (n(t, m.current)) return;
                        (m.current = t), (p.current = e);
                      } catch (e) {
                        l.current = e;
                      }
                      i();
                    }
                    return (
                      (s.onStateChange = e),
                      s.trySubscribe(),
                      e(),
                      function () {
                        return s.tryUnsubscribe();
                      }
                    );
                  },
                  [r, s]
                ),
                a
              );
            })(e, r, o.store, o.subscription);
          return (0, t.useDebugValue)(a), a;
        };
      }
      var _,
        y = b();
      function x(e) {
        return (
          (x =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          x(e)
        );
      }
      function C(e) {
        var t = (function (e, t) {
          if ("object" != x(e) || !e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, "string");
            if ("object" != x(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        })(e);
        return "symbol" == x(t) ? t : t + "";
      }
      function S(e, t, n) {
        return (
          (t = C(t)) in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      function k(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function w(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? k(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : k(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function P(e) {
        return (
          "Minified Redux error #" +
          e +
          "; visit https://redux.js.org/Errors?code=" +
          e +
          " for the full message or use the non-minified dev environment for full errors. "
        );
      }
      (_ = r.unstable_batchedUpdates), (i = _);
      var O =
          ("function" == typeof Symbol && Symbol.observable) || "@@observable",
        I = function () {
          return Math.random().toString(36).substring(7).split("").join(".");
        },
        T = {
          INIT: "@@redux/INIT" + I(),
          REPLACE: "@@redux/REPLACE" + I(),
          PROBE_UNKNOWN_ACTION: function () {
            return "@@redux/PROBE_UNKNOWN_ACTION" + I();
          },
        };
      function M() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        return 0 === t.length
          ? function (e) {
              return e;
            }
          : 1 === t.length
          ? t[0]
          : t.reduce(function (e, t) {
              return function () {
                return e(t.apply(void 0, arguments));
              };
            });
      }
      function E(e) {
        return function (t) {
          var n = t.dispatch,
            r = t.getState;
          return function (t) {
            return function (o) {
              return "function" == typeof o ? o(n, r, e) : t(o);
            };
          };
        };
      }
      var D = E();
      D.withExtraArgument = E;
      var j,
        R = D;
      !(function (e) {
        (e.BASE_DATA = "BASE_DATA"),
          (e.ORDERS_DATA = "ORDERS_DATA"),
          (e.VIEW_COUPON_DATA = "VIEW_COUPON_DATA"),
          (e.UPDATE_SINGLE_SALES_REP = "UPDATE_SINGLE_SALES_REP"),
          (e.UPDATE_REP_PROFILE = "UPDATE_REP_PROFILE"),
          (e.CUSTOMER_ADDRESS_DATA = "CUSTOMER_ADDRESS_DATA"),
          (e.PRODUCTS_DATA = "PRODUCTS"),
          (e.DRAFT_ORDER_DATA = "DRAFT_ORDER_DATA"),
          (e.WHOLESALE_PRICE_DATA = "WHOLESALE_PRICE_DATA"),
          (e.RESET_INITIAL_STATE = "RESET_INITIAL_STATE"),
          (e.EDIT_DRAFT_ORDER = "EDIT_DRAFT_ORDER"),
          (e.ACTIVE_TAB = "ACTIVE_TAB"),
          (e.CREATE_ORDER_TAB = "CREATE_ORDER_TAB");
      })(j || (j = {}));
      var N = function () {
          return (
            (N =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            N.apply(this, arguments)
          );
        },
        A = {
          baseData: {},
          ordersData: {},
          viewCouponData: [],
          customerNewUpdatedData: {},
          productsData: [],
          loggedInRepDetails: window.salesteam_bo_props,
          draftOrderData: [],
          wholesalePriceData: {},
          editDraftOrder: {},
          activeTab: {},
          createOrderTab: {},
        },
        L = (function e(t, n, r) {
          var o;
          if (
            ("function" == typeof n && "function" == typeof r) ||
            ("function" == typeof r && "function" == typeof arguments[3])
          )
            throw new Error(P(0));
          if (
            ("function" == typeof n && void 0 === r && ((r = n), (n = void 0)),
            void 0 !== r)
          ) {
            if ("function" != typeof r) throw new Error(P(1));
            return r(e)(t, n);
          }
          if ("function" != typeof t) throw new Error(P(2));
          var a = t,
            i = n,
            s = [],
            l = s,
            c = !1;
          function u() {
            l === s && (l = s.slice());
          }
          function d() {
            if (c) throw new Error(P(3));
            return i;
          }
          function p(e) {
            if ("function" != typeof e) throw new Error(P(4));
            if (c) throw new Error(P(5));
            var t = !0;
            return (
              u(),
              l.push(e),
              function () {
                if (t) {
                  if (c) throw new Error(P(6));
                  (t = !1), u();
                  var n = l.indexOf(e);
                  l.splice(n, 1), (s = null);
                }
              }
            );
          }
          function m(e) {
            if (
              !(function (e) {
                if ("object" != typeof e || null === e) return !1;
                for (var t = e; null !== Object.getPrototypeOf(t); )
                  t = Object.getPrototypeOf(t);
                return Object.getPrototypeOf(e) === t;
              })(e)
            )
              throw new Error(P(7));
            if (void 0 === e.type) throw new Error(P(8));
            if (c) throw new Error(P(9));
            try {
              (c = !0), (i = a(i, e));
            } finally {
              c = !1;
            }
            for (var t = (s = l), n = 0; n < t.length; n++) (0, t[n])();
            return e;
          }
          return (
            m({ type: T.INIT }),
            ((o = {
              dispatch: m,
              subscribe: p,
              getState: d,
              replaceReducer: function (e) {
                if ("function" != typeof e) throw new Error(P(10));
                (a = e), m({ type: T.REPLACE });
              },
            })[O] = function () {
              var e,
                t = p;
              return (
                ((e = {
                  subscribe: function (e) {
                    if ("object" != typeof e || null === e)
                      throw new Error(P(11));
                    function n() {
                      e.next && e.next(d());
                    }
                    return n(), { unsubscribe: t(n) };
                  },
                })[O] = function () {
                  return this;
                }),
                e
              );
            }),
            o
          );
        })(
          (function (e) {
            for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
              var o = t[r];
              "function" == typeof e[o] && (n[o] = e[o]);
            }
            var a,
              i = Object.keys(n);
            try {
              !(function (e) {
                Object.keys(e).forEach(function (t) {
                  var n = e[t];
                  if (void 0 === n(void 0, { type: T.INIT }))
                    throw new Error(P(12));
                  if (void 0 === n(void 0, { type: T.PROBE_UNKNOWN_ACTION() }))
                    throw new Error(P(13));
                });
              })(n);
            } catch (e) {
              a = e;
            }
            return function (e, t) {
              if ((void 0 === e && (e = {}), a)) throw a;
              for (var r = !1, o = {}, s = 0; s < i.length; s++) {
                var l = i[s],
                  c = n[l],
                  u = e[l],
                  d = c(u, t);
                if (void 0 === d) throw (t && t.type, new Error(P(14)));
                (o[l] = d), (r = r || d !== u);
              }
              return (r = r || i.length !== Object.keys(e).length) ? o : e;
            };
          })({
            salesRepData: function (e, t) {
              switch ((void 0 === e && (e = A), t.type)) {
                case j.BASE_DATA:
                  return N(N({}, e), { baseData: t.payload });
                case j.ORDERS_DATA:
                  return N(N({}, e), { ordersData: t.payload });
                case j.CUSTOMER_ADDRESS_DATA:
                  return N(N({}, e), { customerNewUpdatedData: t.payload });
                case j.PRODUCTS_DATA:
                  return N(N({}, e), { productsData: t.payload });
                case j.VIEW_COUPON_DATA:
                  return N(N({}, e), { viewCouponData: t.payload });
                case j.DRAFT_ORDER_DATA:
                  return N(N({}, e), { draftOrderData: t.payload });
                case j.UPDATE_SINGLE_SALES_REP:
                  return N(N({}, e), {
                    baseData: N(N({}, e.baseData), {
                      SingleSalesRep: t.payload,
                    }),
                  });
                case j.UPDATE_REP_PROFILE:
                  return N(N({}, e), {
                    baseData: N(N({}, e.baseData), {
                      SingleSalesRep: N(N({}, e.baseData.SingleSalesRep), {
                        ProfileImagePath: t.payload,
                      }),
                    }),
                  });
                case j.WHOLESALE_PRICE_DATA:
                  return N(N({}, e), { wholesalePriceData: t.payload });
                case j.RESET_INITIAL_STATE:
                  return N({}, A);
                case j.EDIT_DRAFT_ORDER:
                  return N(N({}, e), { editDraftOrder: t.payload });
                case j.ACTIVE_TAB:
                  return N(N({}, e), { activeTab: t.payload });
                case j.CREATE_ORDER_TAB:
                  return N(N({}, e), { createOrderTab: t.payload });
              }
              return e;
            },
          }),
          (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || M)(
            (function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              return function (e) {
                return function () {
                  var n = e.apply(void 0, arguments),
                    r = function () {
                      throw new Error(P(15));
                    },
                    o = {
                      getState: n.getState,
                      dispatch: function () {
                        return r.apply(void 0, arguments);
                      },
                    },
                    a = t.map(function (e) {
                      return e(o);
                    });
                  return (
                    (r = M.apply(void 0, a)(n.dispatch)),
                    w(w({}, n), {}, { dispatch: r })
                  );
                };
              };
            })(R)
          )
        ),
        z = L;
      o(1739), Object.create(null);
      const B = {};
      function Z() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        ("string" == typeof t[0] && B[t[0]]) ||
          ("string" == typeof t[0] && (B[t[0]] = new Date()),
          (function () {
            if (console && console.warn) {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              "string" == typeof t[0] && (t[0] = `react-i18next:: ${t[0]}`),
                console.warn(...t);
            }
          })(...t));
      }
      const F = (e, t) => () => {
        if (e.isInitialized) t();
        else {
          const n = () => {
            setTimeout(() => {
              e.off("initialized", n);
            }, 0),
              t();
          };
          e.on("initialized", n);
        }
      };
      function H(e, t, n) {
        e.loadNamespaces(t, F(e, n));
      }
      function V(e, t, n, r) {
        "string" == typeof n && (n = [n]),
          n.forEach((t) => {
            e.options.ns.indexOf(t) < 0 && e.options.ns.push(t);
          }),
          e.loadLanguages(t, F(e, r));
      }
      const W =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        $ = {
          "&amp;": "&",
          "&#38;": "&",
          "&lt;": "<",
          "&#60;": "<",
          "&gt;": ">",
          "&#62;": ">",
          "&apos;": "'",
          "&#39;": "'",
          "&quot;": '"',
          "&#34;": '"',
          "&nbsp;": " ",
          "&#160;": " ",
          "&copy;": "©",
          "&#169;": "©",
          "&reg;": "®",
          "&#174;": "®",
          "&hellip;": "…",
          "&#8230;": "…",
          "&#x2F;": "/",
          "&#47;": "/",
        },
        U = (e) => $[e];
      let K,
        G = {
          bindI18n: "languageChanged",
          bindI18nStore: "",
          transEmptyNodeValue: "",
          transSupportBasicHtmlNodes: !0,
          transWrapTextNodes: "",
          transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
          useSuspense: !0,
          unescape: (e) => e.replace(W, U),
        };
      const q = (0, t.createContext)();
      class Y {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(e) {
          e.forEach((e) => {
            this.usedNamespaces[e] || (this.usedNamespaces[e] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      const J = (e, n) => {
        const r = (0, t.useRef)();
        return (
          (0, t.useEffect)(() => {
            r.current = n ? r.current : e;
          }, [e, n]),
          r.current
        );
      };
      function Q(e, t, n, r) {
        return e.getFixedT(t, n, r);
      }
      function X(e) {
        let n =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const { i18n: r } = n,
          { i18n: o, defaultNS: a } = (0, t.useContext)(q) || {},
          i = r || o || K;
        if ((i && !i.reportNamespaces && (i.reportNamespaces = new Y()), !i)) {
          Z(
            "You will need to pass in an i18next instance by using initReactI18next"
          );
          const e = (e, t) =>
              "string" == typeof t
                ? t
                : t && "object" == typeof t && "string" == typeof t.defaultValue
                ? t.defaultValue
                : Array.isArray(e)
                ? e[e.length - 1]
                : e,
            t = [e, {}, !1];
          return (t.t = e), (t.i18n = {}), (t.ready = !1), t;
        }
        i.options.react &&
          void 0 !== i.options.react.wait &&
          Z(
            "It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour."
          );
        const s = { ...G, ...i.options.react, ...n },
          { useSuspense: l, keyPrefix: c } = s;
        let u = e || a || (i.options && i.options.defaultNS);
        (u = "string" == typeof u ? [u] : u || ["translation"]),
          i.reportNamespaces.addUsedNamespaces &&
            i.reportNamespaces.addUsedNamespaces(u);
        const d =
            (i.isInitialized || i.initializedStoreOnce) &&
            u.every((e) =>
              (function (e, t) {
                let n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : {};
                return t.languages && t.languages.length
                  ? void 0 !== t.options.ignoreJSONStructure
                    ? t.hasLoadedNamespace(e, {
                        lng: n.lng,
                        precheck: (t, r) => {
                          if (
                            n.bindI18n &&
                            n.bindI18n.indexOf("languageChanging") > -1 &&
                            t.services.backendConnector.backend &&
                            t.isLanguageChangingTo &&
                            !r(t.isLanguageChangingTo, e)
                          )
                            return !1;
                        },
                      })
                    : (function (e, t) {
                        let n =
                          arguments.length > 2 && void 0 !== arguments[2]
                            ? arguments[2]
                            : {};
                        const r = t.languages[0],
                          o = !!t.options && t.options.fallbackLng,
                          a = t.languages[t.languages.length - 1];
                        if ("cimode" === r.toLowerCase()) return !0;
                        const i = (e, n) => {
                          const r =
                            t.services.backendConnector.state[`${e}|${n}`];
                          return -1 === r || 2 === r;
                        };
                        return !(
                          (n.bindI18n &&
                            n.bindI18n.indexOf("languageChanging") > -1 &&
                            t.services.backendConnector.backend &&
                            t.isLanguageChangingTo &&
                            !i(t.isLanguageChangingTo, e)) ||
                          (!t.hasResourceBundle(r, e) &&
                            t.services.backendConnector.backend &&
                            (!t.options.resources ||
                              t.options.partialBundledLanguages) &&
                            (!i(r, e) || (o && !i(a, e))))
                        );
                      })(e, t, n)
                  : (Z("i18n.languages were undefined or empty", t.languages),
                    !0);
              })(e, i, s)
            ),
          p = (function (e, n, r, o) {
            return (0, t.useCallback)(Q(e, n, r, o), [e, n, r, o]);
          })(i, n.lng || null, "fallback" === s.nsMode ? u : u[0], c),
          m = () => p,
          h = () => Q(i, n.lng || null, "fallback" === s.nsMode ? u : u[0], c),
          [f, g] = (0, t.useState)(m);
        let v = u.join();
        n.lng && (v = `${n.lng}${v}`);
        const b = J(v),
          _ = (0, t.useRef)(!0);
        (0, t.useEffect)(() => {
          const { bindI18n: e, bindI18nStore: t } = s;
          function r() {
            _.current && g(h);
          }
          return (
            (_.current = !0),
            d ||
              l ||
              (n.lng
                ? V(i, n.lng, u, () => {
                    _.current && g(h);
                  })
                : H(i, u, () => {
                    _.current && g(h);
                  })),
            d && b && b !== v && _.current && g(h),
            e && i && i.on(e, r),
            t && i && i.store.on(t, r),
            () => {
              (_.current = !1),
                e && i && e.split(" ").forEach((e) => i.off(e, r)),
                t && i && t.split(" ").forEach((e) => i.store.off(e, r));
            }
          );
        }, [i, v]),
          (0, t.useEffect)(() => {
            _.current && d && g(m);
          }, [i, c, d]);
        const y = [f, i, d];
        if (((y.t = f), (y.i18n = i), (y.ready = d), d)) return y;
        if (!d && !l) return y;
        throw new Promise((e) => {
          n.lng ? V(i, n.lng, u, () => e()) : H(i, u, () => e());
        });
      }
      function ee(e) {
        let { i18n: n, defaultNS: r, children: o } = e;
        const a = (0, t.useMemo)(() => ({ i18n: n, defaultNS: r }), [n, r]);
        return (0, t.createElement)(q.Provider, { value: a }, o);
      }
      function te(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }
      function ne(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, C(r.key), r);
        }
      }
      function re(e, t, n) {
        return (
          t && ne(e.prototype, t),
          n && ne(e, n),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          e
        );
      }
      function oe(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function ae(e, t) {
        return (
          (ae = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (e, t) {
                return (e.__proto__ = t), e;
              }),
          ae(e, t)
        );
      }
      function ie(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: { value: e, writable: !0, configurable: !0 },
        })),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          t && ae(e, t);
      }
      function se(e, t) {
        if (t && ("object" === x(t) || "function" == typeof t)) return t;
        if (void 0 !== t)
          throw new TypeError(
            "Derived constructors may only return object or undefined"
          );
        return oe(e);
      }
      function le(e) {
        return (
          (le = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (e) {
                return e.__proto__ || Object.getPrototypeOf(e);
              }),
          le(e)
        );
      }
      function ce(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function ue(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function de(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? ue(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : ue(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var pe = {
          type: "logger",
          log: function (e) {
            this.output("log", e);
          },
          warn: function (e) {
            this.output("warn", e);
          },
          error: function (e) {
            this.output("error", e);
          },
          output: function (e, t) {
            console && console[e] && console[e].apply(console, t);
          },
        },
        me = (function () {
          function e(t) {
            var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            te(this, e), this.init(t, n);
          }
          return (
            re(e, [
              {
                key: "init",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                  (this.prefix = t.prefix || "i18next:"),
                    (this.logger = e || pe),
                    (this.options = t),
                    (this.debug = t.debug);
                },
              },
              {
                key: "setDebug",
                value: function (e) {
                  this.debug = e;
                },
              },
              {
                key: "log",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "log", "", !0);
                },
              },
              {
                key: "warn",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "warn", "", !0);
                },
              },
              {
                key: "error",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "error", "");
                },
              },
              {
                key: "deprecate",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
                },
              },
              {
                key: "forward",
                value: function (e, t, n, r) {
                  return r && !this.debug
                    ? null
                    : ("string" == typeof e[0] &&
                        (e[0] = ""
                          .concat(n)
                          .concat(this.prefix, " ")
                          .concat(e[0])),
                      this.logger[t](e));
                },
              },
              {
                key: "create",
                value: function (t) {
                  return new e(
                    this.logger,
                    de(
                      de(
                        {},
                        { prefix: "".concat(this.prefix, ":").concat(t, ":") }
                      ),
                      this.options
                    )
                  );
                },
              },
              {
                key: "clone",
                value: function (t) {
                  return (
                    ((t = t || this.options).prefix = t.prefix || this.prefix),
                    new e(this.logger, t)
                  );
                },
              },
            ]),
            e
          );
        })(),
        he = new me(),
        fe = (function () {
          function e() {
            te(this, e), (this.observers = {});
          }
          return (
            re(e, [
              {
                key: "on",
                value: function (e, t) {
                  var n = this;
                  return (
                    e.split(" ").forEach(function (e) {
                      (n.observers[e] = n.observers[e] || []),
                        n.observers[e].push(t);
                    }),
                    this
                  );
                },
              },
              {
                key: "off",
                value: function (e, t) {
                  this.observers[e] &&
                    (t
                      ? (this.observers[e] = this.observers[e].filter(function (
                          e
                        ) {
                          return e !== t;
                        }))
                      : delete this.observers[e]);
                },
              },
              {
                key: "emit",
                value: function (e) {
                  for (
                    var t = arguments.length,
                      n = new Array(t > 1 ? t - 1 : 0),
                      r = 1;
                    r < t;
                    r++
                  )
                    n[r - 1] = arguments[r];
                  this.observers[e] &&
                    [].concat(this.observers[e]).forEach(function (e) {
                      e.apply(void 0, n);
                    }),
                    this.observers["*"] &&
                      [].concat(this.observers["*"]).forEach(function (t) {
                        t.apply(t, [e].concat(n));
                      });
                },
              },
            ]),
            e
          );
        })();
      function ge() {
        var e,
          t,
          n = new Promise(function (n, r) {
            (e = n), (t = r);
          });
        return (n.resolve = e), (n.reject = t), n;
      }
      function ve(e) {
        return null == e ? "" : "" + e;
      }
      function be(e, t, n) {
        function r(e) {
          return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
        }
        function o() {
          return !e || "string" == typeof e;
        }
        for (
          var a = "string" != typeof t ? [].concat(t) : t.split(".");
          a.length > 1;

        ) {
          if (o()) return {};
          var i = r(a.shift());
          !e[i] && n && (e[i] = new n()),
            (e = Object.prototype.hasOwnProperty.call(e, i) ? e[i] : {});
        }
        return o() ? {} : { obj: e, k: r(a.shift()) };
      }
      function _e(e, t, n) {
        var r = be(e, t, Object);
        r.obj[r.k] = n;
      }
      function ye(e, t) {
        var n = be(e, t),
          r = n.obj,
          o = n.k;
        if (r) return r[o];
      }
      function xe(e, t, n) {
        var r = ye(e, n);
        return void 0 !== r ? r : ye(t, n);
      }
      function Ce(e, t, n) {
        for (var r in t)
          "__proto__" !== r &&
            "constructor" !== r &&
            (r in e
              ? "string" == typeof e[r] ||
                e[r] instanceof String ||
                "string" == typeof t[r] ||
                t[r] instanceof String
                ? n && (e[r] = t[r])
                : Ce(e[r], t[r], n)
              : (e[r] = t[r]));
        return e;
      }
      function Se(e) {
        return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      }
      var ke = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
      };
      function we(e) {
        return "string" == typeof e
          ? e.replace(/[&<>"'\/]/g, function (e) {
              return ke[e];
            })
          : e;
      }
      var Pe =
          "undefined" != typeof window &&
          window.navigator &&
          void 0 === window.navigator.userAgentData &&
          window.navigator.userAgent &&
          window.navigator.userAgent.indexOf("MSIE") > -1,
        Oe = [" ", ",", "?", "!", ";"];
      function Ie(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Te(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ie(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Ie(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function Me(e, t) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
        if (e) {
          if (e[t]) return e[t];
          for (var r = t.split(n), o = e, a = 0; a < r.length; ++a) {
            if (!o) return;
            if ("string" == typeof o[r[a]] && a + 1 < r.length) return;
            if (void 0 === o[r[a]]) {
              for (
                var i = 2, s = r.slice(a, a + i).join(n), l = o[s];
                void 0 === l && r.length > a + i;

              )
                i++, (l = o[(s = r.slice(a, a + i).join(n))]);
              if (void 0 === l) return;
              if (null === l) return null;
              if (t.endsWith(s)) {
                if ("string" == typeof l) return l;
                if (s && "string" == typeof l[s]) return l[s];
              }
              var c = r.slice(a + i).join(n);
              return c ? Me(l, c, n) : void 0;
            }
            o = o[r[a]];
          }
          return o;
        }
      }
      var Ee = (function (e) {
          ie(o, e);
          var t,
            n,
            r =
              ((t = o),
              (n = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                  return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return (
                    Boolean.prototype.valueOf.call(
                      Reflect.construct(Boolean, [], function () {})
                    ),
                    !0
                  );
                } catch (e) {
                  return !1;
                }
              })()),
              function () {
                var e,
                  r = le(t);
                if (n) {
                  var o = le(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return se(this, e);
              });
          function o(e) {
            var t,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : { ns: ["translation"], defaultNS: "translation" };
            return (
              te(this, o),
              (t = r.call(this)),
              Pe && fe.call(oe(t)),
              (t.data = e || {}),
              (t.options = n),
              void 0 === t.options.keySeparator &&
                (t.options.keySeparator = "."),
              void 0 === t.options.ignoreJSONStructure &&
                (t.options.ignoreJSONStructure = !0),
              t
            );
          }
          return (
            re(o, [
              {
                key: "addNamespaces",
                value: function (e) {
                  this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
                },
              },
              {
                key: "removeNamespaces",
                value: function (e) {
                  var t = this.options.ns.indexOf(e);
                  t > -1 && this.options.ns.splice(t, 1);
                },
              },
              {
                key: "getResource",
                value: function (e, t, n) {
                  var r =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : {},
                    o =
                      void 0 !== r.keySeparator
                        ? r.keySeparator
                        : this.options.keySeparator,
                    a =
                      void 0 !== r.ignoreJSONStructure
                        ? r.ignoreJSONStructure
                        : this.options.ignoreJSONStructure,
                    i = [e, t];
                  n && "string" != typeof n && (i = i.concat(n)),
                    n &&
                      "string" == typeof n &&
                      (i = i.concat(o ? n.split(o) : n)),
                    e.indexOf(".") > -1 && (i = e.split("."));
                  var s = ye(this.data, i);
                  return s || !a || "string" != typeof n
                    ? s
                    : Me(this.data && this.data[e] && this.data[e][t], n, o);
                },
              },
              {
                key: "addResource",
                value: function (e, t, n, r) {
                  var o =
                      arguments.length > 4 && void 0 !== arguments[4]
                        ? arguments[4]
                        : { silent: !1 },
                    a = this.options.keySeparator;
                  void 0 === a && (a = ".");
                  var i = [e, t];
                  n && (i = i.concat(a ? n.split(a) : n)),
                    e.indexOf(".") > -1 &&
                      ((r = t), (t = (i = e.split("."))[1])),
                    this.addNamespaces(t),
                    _e(this.data, i, r),
                    o.silent || this.emit("added", e, t, n, r);
                },
              },
              {
                key: "addResources",
                value: function (e, t, n) {
                  var r =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : { silent: !1 };
                  for (var o in n)
                    ("string" != typeof n[o] &&
                      "[object Array]" !==
                        Object.prototype.toString.apply(n[o])) ||
                      this.addResource(e, t, o, n[o], { silent: !0 });
                  r.silent || this.emit("added", e, t, n);
                },
              },
              {
                key: "addResourceBundle",
                value: function (e, t, n, r, o) {
                  var a =
                      arguments.length > 5 && void 0 !== arguments[5]
                        ? arguments[5]
                        : { silent: !1 },
                    i = [e, t];
                  e.indexOf(".") > -1 &&
                    ((r = n), (n = t), (t = (i = e.split("."))[1])),
                    this.addNamespaces(t);
                  var s = ye(this.data, i) || {};
                  r ? Ce(s, n, o) : (s = Te(Te({}, s), n)),
                    _e(this.data, i, s),
                    a.silent || this.emit("added", e, t, n);
                },
              },
              {
                key: "removeResourceBundle",
                value: function (e, t) {
                  this.hasResourceBundle(e, t) && delete this.data[e][t],
                    this.removeNamespaces(t),
                    this.emit("removed", e, t);
                },
              },
              {
                key: "hasResourceBundle",
                value: function (e, t) {
                  return void 0 !== this.getResource(e, t);
                },
              },
              {
                key: "getResourceBundle",
                value: function (e, t) {
                  return (
                    t || (t = this.options.defaultNS),
                    "v1" === this.options.compatibilityAPI
                      ? Te(Te({}, {}), this.getResource(e, t))
                      : this.getResource(e, t)
                  );
                },
              },
              {
                key: "getDataByLanguage",
                value: function (e) {
                  return this.data[e];
                },
              },
              {
                key: "hasLanguageSomeTranslations",
                value: function (e) {
                  var t = this.getDataByLanguage(e);
                  return !!((t && Object.keys(t)) || []).find(function (e) {
                    return t[e] && Object.keys(t[e]).length > 0;
                  });
                },
              },
              {
                key: "toJSON",
                value: function () {
                  return this.data;
                },
              },
            ]),
            o
          );
        })(fe),
        De = {
          processors: {},
          addPostProcessor: function (e) {
            this.processors[e.name] = e;
          },
          handle: function (e, t, n, r, o) {
            var a = this;
            return (
              e.forEach(function (e) {
                a.processors[e] && (t = a.processors[e].process(t, n, r, o));
              }),
              t
            );
          },
        };
      function je(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Re(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? je(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : je(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var Ne = {},
        Ae = (function (e) {
          ie(o, e);
          var t,
            n,
            r =
              ((t = o),
              (n = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                  return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return (
                    Boolean.prototype.valueOf.call(
                      Reflect.construct(Boolean, [], function () {})
                    ),
                    !0
                  );
                } catch (e) {
                  return !1;
                }
              })()),
              function () {
                var e,
                  r = le(t);
                if (n) {
                  var o = le(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return se(this, e);
              });
          function o(e) {
            var t,
              n,
              a,
              i =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            return (
              te(this, o),
              (t = r.call(this)),
              Pe && fe.call(oe(t)),
              (n = e),
              (a = oe(t)),
              [
                "resourceStore",
                "languageUtils",
                "pluralResolver",
                "interpolator",
                "backendConnector",
                "i18nFormat",
                "utils",
              ].forEach(function (e) {
                n[e] && (a[e] = n[e]);
              }),
              (t.options = i),
              void 0 === t.options.keySeparator &&
                (t.options.keySeparator = "."),
              (t.logger = he.create("translator")),
              t
            );
          }
          return (
            re(
              o,
              [
                {
                  key: "changeLanguage",
                  value: function (e) {
                    e && (this.language = e);
                  },
                },
                {
                  key: "exists",
                  value: function (e) {
                    var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : { interpolation: {} };
                    if (null == e) return !1;
                    var n = this.resolve(e, t);
                    return n && void 0 !== n.res;
                  },
                },
                {
                  key: "extractFromKey",
                  value: function (e, t) {
                    var n =
                      void 0 !== t.nsSeparator
                        ? t.nsSeparator
                        : this.options.nsSeparator;
                    void 0 === n && (n = ":");
                    var r =
                        void 0 !== t.keySeparator
                          ? t.keySeparator
                          : this.options.keySeparator,
                      o = t.ns || this.options.defaultNS || [],
                      a = n && e.indexOf(n) > -1,
                      i = !(
                        this.options.userDefinedKeySeparator ||
                        t.keySeparator ||
                        this.options.userDefinedNsSeparator ||
                        t.nsSeparator ||
                        (function (e, t, n) {
                          (t = t || ""), (n = n || "");
                          var r = Oe.filter(function (e) {
                            return t.indexOf(e) < 0 && n.indexOf(e) < 0;
                          });
                          if (0 === r.length) return !0;
                          var o = new RegExp(
                              "(".concat(
                                r
                                  .map(function (e) {
                                    return "?" === e ? "\\?" : e;
                                  })
                                  .join("|"),
                                ")"
                              )
                            ),
                            a = !o.test(e);
                          if (!a) {
                            var i = e.indexOf(n);
                            i > 0 && !o.test(e.substring(0, i)) && (a = !0);
                          }
                          return a;
                        })(e, n, r)
                      );
                    if (a && !i) {
                      var s = e.match(this.interpolator.nestingRegexp);
                      if (s && s.length > 0) return { key: e, namespaces: o };
                      var l = e.split(n);
                      (n !== r ||
                        (n === r && this.options.ns.indexOf(l[0]) > -1)) &&
                        (o = l.shift()),
                        (e = l.join(r));
                    }
                    return (
                      "string" == typeof o && (o = [o]),
                      { key: e, namespaces: o }
                    );
                  },
                },
                {
                  key: "translate",
                  value: function (e, t, n) {
                    var r = this;
                    if (
                      ("object" !== x(t) &&
                        this.options.overloadTranslationOptionHandler &&
                        (t =
                          this.options.overloadTranslationOptionHandler(
                            arguments
                          )),
                      t || (t = {}),
                      null == e)
                    )
                      return "";
                    Array.isArray(e) || (e = [String(e)]);
                    var a =
                        void 0 !== t.returnDetails
                          ? t.returnDetails
                          : this.options.returnDetails,
                      i =
                        void 0 !== t.keySeparator
                          ? t.keySeparator
                          : this.options.keySeparator,
                      s = this.extractFromKey(e[e.length - 1], t),
                      l = s.key,
                      c = s.namespaces,
                      u = c[c.length - 1],
                      d = t.lng || this.language,
                      p =
                        t.appendNamespaceToCIMode ||
                        this.options.appendNamespaceToCIMode;
                    if (d && "cimode" === d.toLowerCase()) {
                      if (p) {
                        var m = t.nsSeparator || this.options.nsSeparator;
                        return a
                          ? ((h.res = "".concat(u).concat(m).concat(l)), h)
                          : "".concat(u).concat(m).concat(l);
                      }
                      return a ? ((h.res = l), h) : l;
                    }
                    var h = this.resolve(e, t),
                      f = h && h.res,
                      g = (h && h.usedKey) || l,
                      v = (h && h.exactUsedKey) || l,
                      b = Object.prototype.toString.apply(f),
                      _ =
                        void 0 !== t.joinArrays
                          ? t.joinArrays
                          : this.options.joinArrays,
                      y = !this.i18nFormat || this.i18nFormat.handleAsObject;
                    if (
                      y &&
                      f &&
                      "string" != typeof f &&
                      "boolean" != typeof f &&
                      "number" != typeof f &&
                      [
                        "[object Number]",
                        "[object Function]",
                        "[object RegExp]",
                      ].indexOf(b) < 0 &&
                      ("string" != typeof _ || "[object Array]" !== b)
                    ) {
                      if (!t.returnObjects && !this.options.returnObjects) {
                        this.options.returnedObjectHandler ||
                          this.logger.warn(
                            "accessing an object - but returnObjects options is not enabled!"
                          );
                        var C = this.options.returnedObjectHandler
                          ? this.options.returnedObjectHandler(
                              g,
                              f,
                              Re(Re({}, t), {}, { ns: c })
                            )
                          : "key '"
                              .concat(l, " (")
                              .concat(
                                this.language,
                                ")' returned an object instead of string."
                              );
                        return a ? ((h.res = C), h) : C;
                      }
                      if (i) {
                        var S = "[object Array]" === b,
                          k = S ? [] : {},
                          w = S ? v : g;
                        for (var P in f)
                          if (Object.prototype.hasOwnProperty.call(f, P)) {
                            var O = "".concat(w).concat(i).concat(P);
                            (k[P] = this.translate(
                              O,
                              Re(Re({}, t), { joinArrays: !1, ns: c })
                            )),
                              k[P] === O && (k[P] = f[P]);
                          }
                        f = k;
                      }
                    } else if (
                      y &&
                      "string" == typeof _ &&
                      "[object Array]" === b
                    )
                      (f = f.join(_)) &&
                        (f = this.extendTranslation(f, e, t, n));
                    else {
                      var I = !1,
                        T = !1,
                        M = void 0 !== t.count && "string" != typeof t.count,
                        E = o.hasDefaultValue(t),
                        D = M
                          ? this.pluralResolver.getSuffix(d, t.count, t)
                          : "",
                        j = t["defaultValue".concat(D)] || t.defaultValue;
                      !this.isValidLookup(f) && E && ((I = !0), (f = j)),
                        this.isValidLookup(f) || ((T = !0), (f = l));
                      var R =
                          (t.missingKeyNoValueFallbackToKey ||
                            this.options.missingKeyNoValueFallbackToKey) &&
                          T
                            ? void 0
                            : f,
                        N = E && j !== f && this.options.updateMissing;
                      if (T || I || N) {
                        if (
                          (this.logger.log(
                            N ? "updateKey" : "missingKey",
                            d,
                            u,
                            l,
                            N ? j : f
                          ),
                          i)
                        ) {
                          var A = this.resolve(
                            l,
                            Re(Re({}, t), {}, { keySeparator: !1 })
                          );
                          A &&
                            A.res &&
                            this.logger.warn(
                              "Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format."
                            );
                        }
                        var L = [],
                          z = this.languageUtils.getFallbackCodes(
                            this.options.fallbackLng,
                            t.lng || this.language
                          );
                        if (
                          "fallback" === this.options.saveMissingTo &&
                          z &&
                          z[0]
                        )
                          for (var B = 0; B < z.length; B++) L.push(z[B]);
                        else
                          "all" === this.options.saveMissingTo
                            ? (L = this.languageUtils.toResolveHierarchy(
                                t.lng || this.language
                              ))
                            : L.push(t.lng || this.language);
                        var Z = function (e, n, o) {
                          var a = E && o !== f ? o : R;
                          r.options.missingKeyHandler
                            ? r.options.missingKeyHandler(e, u, n, a, N, t)
                            : r.backendConnector &&
                              r.backendConnector.saveMissing &&
                              r.backendConnector.saveMissing(e, u, n, a, N, t),
                            r.emit("missingKey", e, u, n, f);
                        };
                        this.options.saveMissing &&
                          (this.options.saveMissingPlurals && M
                            ? L.forEach(function (e) {
                                r.pluralResolver
                                  .getSuffixes(e, t)
                                  .forEach(function (n) {
                                    Z(
                                      [e],
                                      l + n,
                                      t["defaultValue".concat(n)] || j
                                    );
                                  });
                              })
                            : Z(L, l, j));
                      }
                      (f = this.extendTranslation(f, e, t, h, n)),
                        T &&
                          f === l &&
                          this.options.appendNamespaceToMissingKey &&
                          (f = "".concat(u, ":").concat(l)),
                        (T || I) &&
                          this.options.parseMissingKeyHandler &&
                          (f =
                            "v1" !== this.options.compatibilityAPI
                              ? this.options.parseMissingKeyHandler(
                                  this.options.appendNamespaceToMissingKey
                                    ? "".concat(u, ":").concat(l)
                                    : l,
                                  I ? f : void 0
                                )
                              : this.options.parseMissingKeyHandler(f));
                    }
                    return a ? ((h.res = f), h) : f;
                  },
                },
                {
                  key: "extendTranslation",
                  value: function (e, t, n, r, o) {
                    var a = this;
                    if (this.i18nFormat && this.i18nFormat.parse)
                      e = this.i18nFormat.parse(
                        e,
                        Re(
                          Re({}, this.options.interpolation.defaultVariables),
                          n
                        ),
                        r.usedLng,
                        r.usedNS,
                        r.usedKey,
                        { resolved: r }
                      );
                    else if (!n.skipInterpolation) {
                      n.interpolation &&
                        this.interpolator.init(
                          Re(Re({}, n), {
                            interpolation: Re(
                              Re({}, this.options.interpolation),
                              n.interpolation
                            ),
                          })
                        );
                      var i,
                        s =
                          "string" == typeof e &&
                          (n &&
                          n.interpolation &&
                          void 0 !== n.interpolation.skipOnVariables
                            ? n.interpolation.skipOnVariables
                            : this.options.interpolation.skipOnVariables);
                      if (s) {
                        var l = e.match(this.interpolator.nestingRegexp);
                        i = l && l.length;
                      }
                      var c =
                        n.replace && "string" != typeof n.replace
                          ? n.replace
                          : n;
                      if (
                        (this.options.interpolation.defaultVariables &&
                          (c = Re(
                            Re({}, this.options.interpolation.defaultVariables),
                            c
                          )),
                        (e = this.interpolator.interpolate(
                          e,
                          c,
                          n.lng || this.language,
                          n
                        )),
                        s)
                      ) {
                        var u = e.match(this.interpolator.nestingRegexp);
                        i < (u && u.length) && (n.nest = !1);
                      }
                      !1 !== n.nest &&
                        (e = this.interpolator.nest(
                          e,
                          function () {
                            for (
                              var e = arguments.length, r = new Array(e), i = 0;
                              i < e;
                              i++
                            )
                              r[i] = arguments[i];
                            return o && o[0] === r[0] && !n.context
                              ? (a.logger.warn(
                                  "It seems you are nesting recursively key: "
                                    .concat(r[0], " in key: ")
                                    .concat(t[0])
                                ),
                                null)
                              : a.translate.apply(a, r.concat([t]));
                          },
                          n
                        )),
                        n.interpolation && this.interpolator.reset();
                    }
                    var d = n.postProcess || this.options.postProcess,
                      p = "string" == typeof d ? [d] : d;
                    return (
                      null != e &&
                        p &&
                        p.length &&
                        !1 !== n.applyPostProcessor &&
                        (e = De.handle(
                          p,
                          e,
                          t,
                          this.options && this.options.postProcessPassResolved
                            ? Re({ i18nResolved: r }, n)
                            : n,
                          this
                        )),
                      e
                    );
                  },
                },
                {
                  key: "resolve",
                  value: function (e) {
                    var t,
                      n,
                      r,
                      o,
                      a,
                      i = this,
                      s =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : {};
                    return (
                      "string" == typeof e && (e = [e]),
                      e.forEach(function (e) {
                        if (!i.isValidLookup(t)) {
                          var l = i.extractFromKey(e, s),
                            c = l.key;
                          n = c;
                          var u = l.namespaces;
                          i.options.fallbackNS &&
                            (u = u.concat(i.options.fallbackNS));
                          var d =
                              void 0 !== s.count && "string" != typeof s.count,
                            p =
                              d &&
                              !s.ordinal &&
                              0 === s.count &&
                              i.pluralResolver.shouldUseIntlApi(),
                            m =
                              void 0 !== s.context &&
                              ("string" == typeof s.context ||
                                "number" == typeof s.context) &&
                              "" !== s.context,
                            h = s.lngs
                              ? s.lngs
                              : i.languageUtils.toResolveHierarchy(
                                  s.lng || i.language,
                                  s.fallbackLng
                                );
                          u.forEach(function (e) {
                            i.isValidLookup(t) ||
                              ((a = e),
                              !Ne["".concat(h[0], "-").concat(e)] &&
                                i.utils &&
                                i.utils.hasLoadedNamespace &&
                                !i.utils.hasLoadedNamespace(a) &&
                                ((Ne["".concat(h[0], "-").concat(e)] = !0),
                                i.logger.warn(
                                  'key "'
                                    .concat(n, '" for languages "')
                                    .concat(
                                      h.join(", "),
                                      '" won\'t get resolved as namespace "'
                                    )
                                    .concat(a, '" was not yet loaded'),
                                  "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!"
                                )),
                              h.forEach(function (n) {
                                if (!i.isValidLookup(t)) {
                                  o = n;
                                  var a,
                                    l = [c];
                                  if (
                                    i.i18nFormat &&
                                    i.i18nFormat.addLookupKeys
                                  )
                                    i.i18nFormat.addLookupKeys(l, c, n, e, s);
                                  else {
                                    var u;
                                    d &&
                                      (u = i.pluralResolver.getSuffix(
                                        n,
                                        s.count,
                                        s
                                      ));
                                    var h = "".concat(
                                      i.options.pluralSeparator,
                                      "zero"
                                    );
                                    if (
                                      (d && (l.push(c + u), p && l.push(c + h)),
                                      m)
                                    ) {
                                      var f = ""
                                        .concat(c)
                                        .concat(i.options.contextSeparator)
                                        .concat(s.context);
                                      l.push(f),
                                        d &&
                                          (l.push(f + u), p && l.push(f + h));
                                    }
                                  }
                                  for (; (a = l.pop()); )
                                    i.isValidLookup(t) ||
                                      ((r = a),
                                      (t = i.getResource(n, e, a, s)));
                                }
                              }));
                          });
                        }
                      }),
                      {
                        res: t,
                        usedKey: n,
                        exactUsedKey: r,
                        usedLng: o,
                        usedNS: a,
                      }
                    );
                  },
                },
                {
                  key: "isValidLookup",
                  value: function (e) {
                    return !(
                      void 0 === e ||
                      (!this.options.returnNull && null === e) ||
                      (!this.options.returnEmptyString && "" === e)
                    );
                  },
                },
                {
                  key: "getResource",
                  value: function (e, t, n) {
                    var r =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : {};
                    return this.i18nFormat && this.i18nFormat.getResource
                      ? this.i18nFormat.getResource(e, t, n, r)
                      : this.resourceStore.getResource(e, t, n, r);
                  },
                },
              ],
              [
                {
                  key: "hasDefaultValue",
                  value: function (e) {
                    var t = "defaultValue";
                    for (var n in e)
                      if (
                        Object.prototype.hasOwnProperty.call(e, n) &&
                        t === n.substring(0, t.length) &&
                        void 0 !== e[n]
                      )
                        return !0;
                    return !1;
                  },
                },
              ]
            ),
            o
          );
        })(fe);
      function Le(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }
      var ze = (function () {
          function e(t) {
            te(this, e),
              (this.options = t),
              (this.supportedLngs = this.options.supportedLngs || !1),
              (this.logger = he.create("languageUtils"));
          }
          return (
            re(e, [
              {
                key: "getScriptPartFromCode",
                value: function (e) {
                  if (!e || e.indexOf("-") < 0) return null;
                  var t = e.split("-");
                  return 2 === t.length
                    ? null
                    : (t.pop(),
                      "x" === t[t.length - 1].toLowerCase()
                        ? null
                        : this.formatLanguageCode(t.join("-")));
                },
              },
              {
                key: "getLanguagePartFromCode",
                value: function (e) {
                  if (!e || e.indexOf("-") < 0) return e;
                  var t = e.split("-");
                  return this.formatLanguageCode(t[0]);
                },
              },
              {
                key: "formatLanguageCode",
                value: function (e) {
                  if ("string" == typeof e && e.indexOf("-") > -1) {
                    var t = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab",
                      ],
                      n = e.split("-");
                    return (
                      this.options.lowerCaseLng
                        ? (n = n.map(function (e) {
                            return e.toLowerCase();
                          }))
                        : 2 === n.length
                        ? ((n[0] = n[0].toLowerCase()),
                          (n[1] = n[1].toUpperCase()),
                          t.indexOf(n[1].toLowerCase()) > -1 &&
                            (n[1] = Le(n[1].toLowerCase())))
                        : 3 === n.length &&
                          ((n[0] = n[0].toLowerCase()),
                          2 === n[1].length && (n[1] = n[1].toUpperCase()),
                          "sgn" !== n[0] &&
                            2 === n[2].length &&
                            (n[2] = n[2].toUpperCase()),
                          t.indexOf(n[1].toLowerCase()) > -1 &&
                            (n[1] = Le(n[1].toLowerCase())),
                          t.indexOf(n[2].toLowerCase()) > -1 &&
                            (n[2] = Le(n[2].toLowerCase()))),
                      n.join("-")
                    );
                  }
                  return this.options.cleanCode || this.options.lowerCaseLng
                    ? e.toLowerCase()
                    : e;
                },
              },
              {
                key: "isSupportedCode",
                value: function (e) {
                  return (
                    ("languageOnly" === this.options.load ||
                      this.options.nonExplicitSupportedLngs) &&
                      (e = this.getLanguagePartFromCode(e)),
                    !this.supportedLngs ||
                      !this.supportedLngs.length ||
                      this.supportedLngs.indexOf(e) > -1
                  );
                },
              },
              {
                key: "getBestMatchFromCodes",
                value: function (e) {
                  var t,
                    n = this;
                  return e
                    ? (e.forEach(function (e) {
                        if (!t) {
                          var r = n.formatLanguageCode(e);
                          (n.options.supportedLngs && !n.isSupportedCode(r)) ||
                            (t = r);
                        }
                      }),
                      !t &&
                        this.options.supportedLngs &&
                        e.forEach(function (e) {
                          if (!t) {
                            var r = n.getLanguagePartFromCode(e);
                            if (n.isSupportedCode(r)) return (t = r);
                            t = n.options.supportedLngs.find(function (e) {
                              if (0 === e.indexOf(r)) return e;
                            });
                          }
                        }),
                      t ||
                        (t = this.getFallbackCodes(
                          this.options.fallbackLng
                        )[0]),
                      t)
                    : null;
                },
              },
              {
                key: "getFallbackCodes",
                value: function (e, t) {
                  if (!e) return [];
                  if (
                    ("function" == typeof e && (e = e(t)),
                    "string" == typeof e && (e = [e]),
                    "[object Array]" === Object.prototype.toString.apply(e))
                  )
                    return e;
                  if (!t) return e.default || [];
                  var n = e[t];
                  return (
                    n || (n = e[this.getScriptPartFromCode(t)]),
                    n || (n = e[this.formatLanguageCode(t)]),
                    n || (n = e[this.getLanguagePartFromCode(t)]),
                    n || (n = e.default),
                    n || []
                  );
                },
              },
              {
                key: "toResolveHierarchy",
                value: function (e, t) {
                  var n = this,
                    r = this.getFallbackCodes(
                      t || this.options.fallbackLng || [],
                      e
                    ),
                    o = [],
                    a = function (e) {
                      e &&
                        (n.isSupportedCode(e)
                          ? o.push(e)
                          : n.logger.warn(
                              "rejecting language code not found in supportedLngs: ".concat(
                                e
                              )
                            ));
                    };
                  return (
                    "string" == typeof e && e.indexOf("-") > -1
                      ? ("languageOnly" !== this.options.load &&
                          a(this.formatLanguageCode(e)),
                        "languageOnly" !== this.options.load &&
                          "currentOnly" !== this.options.load &&
                          a(this.getScriptPartFromCode(e)),
                        "currentOnly" !== this.options.load &&
                          a(this.getLanguagePartFromCode(e)))
                      : "string" == typeof e && a(this.formatLanguageCode(e)),
                    r.forEach(function (e) {
                      o.indexOf(e) < 0 && a(n.formatLanguageCode(e));
                    }),
                    o
                  );
                },
              },
            ]),
            e
          );
        })(),
        Be = [
          {
            lngs: [
              "ach",
              "ak",
              "am",
              "arn",
              "br",
              "fil",
              "gun",
              "ln",
              "mfe",
              "mg",
              "mi",
              "oc",
              "pt",
              "pt-BR",
              "tg",
              "tl",
              "ti",
              "tr",
              "uz",
              "wa",
            ],
            nr: [1, 2],
            fc: 1,
          },
          {
            lngs: [
              "af",
              "an",
              "ast",
              "az",
              "bg",
              "bn",
              "ca",
              "da",
              "de",
              "dev",
              "el",
              "en",
              "eo",
              "es",
              "et",
              "eu",
              "fi",
              "fo",
              "fur",
              "fy",
              "gl",
              "gu",
              "ha",
              "hi",
              "hu",
              "hy",
              "ia",
              "it",
              "kk",
              "kn",
              "ku",
              "lb",
              "mai",
              "ml",
              "mn",
              "mr",
              "nah",
              "nap",
              "nb",
              "ne",
              "nl",
              "nn",
              "no",
              "nso",
              "pa",
              "pap",
              "pms",
              "ps",
              "pt-PT",
              "rm",
              "sco",
              "se",
              "si",
              "so",
              "son",
              "sq",
              "sv",
              "sw",
              "ta",
              "te",
              "tk",
              "ur",
              "yo",
            ],
            nr: [1, 2],
            fc: 2,
          },
          {
            lngs: [
              "ay",
              "bo",
              "cgg",
              "fa",
              "ht",
              "id",
              "ja",
              "jbo",
              "ka",
              "km",
              "ko",
              "ky",
              "lo",
              "ms",
              "sah",
              "su",
              "th",
              "tt",
              "ug",
              "vi",
              "wo",
              "zh",
            ],
            nr: [1],
            fc: 3,
          },
          {
            lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
            nr: [1, 2, 5],
            fc: 4,
          },
          { lngs: ["ar"], nr: [0, 1, 2, 3, 11, 100], fc: 5 },
          { lngs: ["cs", "sk"], nr: [1, 2, 5], fc: 6 },
          { lngs: ["csb", "pl"], nr: [1, 2, 5], fc: 7 },
          { lngs: ["cy"], nr: [1, 2, 3, 8], fc: 8 },
          { lngs: ["fr"], nr: [1, 2], fc: 9 },
          { lngs: ["ga"], nr: [1, 2, 3, 7, 11], fc: 10 },
          { lngs: ["gd"], nr: [1, 2, 3, 20], fc: 11 },
          { lngs: ["is"], nr: [1, 2], fc: 12 },
          { lngs: ["jv"], nr: [0, 1], fc: 13 },
          { lngs: ["kw"], nr: [1, 2, 3, 4], fc: 14 },
          { lngs: ["lt"], nr: [1, 2, 10], fc: 15 },
          { lngs: ["lv"], nr: [1, 2, 0], fc: 16 },
          { lngs: ["mk"], nr: [1, 2], fc: 17 },
          { lngs: ["mnk"], nr: [0, 1, 2], fc: 18 },
          { lngs: ["mt"], nr: [1, 2, 11, 20], fc: 19 },
          { lngs: ["or"], nr: [2, 1], fc: 2 },
          { lngs: ["ro"], nr: [1, 2, 20], fc: 20 },
          { lngs: ["sl"], nr: [5, 1, 2, 3], fc: 21 },
          { lngs: ["he", "iw"], nr: [1, 2, 20, 21], fc: 22 },
        ],
        Ze = {
          1: function (e) {
            return Number(e > 1);
          },
          2: function (e) {
            return Number(1 != e);
          },
          3: function (e) {
            return 0;
          },
          4: function (e) {
            return Number(
              e % 10 == 1 && e % 100 != 11
                ? 0
                : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
                ? 1
                : 2
            );
          },
          5: function (e) {
            return Number(
              0 == e
                ? 0
                : 1 == e
                ? 1
                : 2 == e
                ? 2
                : e % 100 >= 3 && e % 100 <= 10
                ? 3
                : e % 100 >= 11
                ? 4
                : 5
            );
          },
          6: function (e) {
            return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
          },
          7: function (e) {
            return Number(
              1 == e
                ? 0
                : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
                ? 1
                : 2
            );
          },
          8: function (e) {
            return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
          },
          9: function (e) {
            return Number(e >= 2);
          },
          10: function (e) {
            return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
          },
          11: function (e) {
            return Number(
              1 == e || 11 == e
                ? 0
                : 2 == e || 12 == e
                ? 1
                : e > 2 && e < 20
                ? 2
                : 3
            );
          },
          12: function (e) {
            return Number(e % 10 != 1 || e % 100 == 11);
          },
          13: function (e) {
            return Number(0 !== e);
          },
          14: function (e) {
            return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
          },
          15: function (e) {
            return Number(
              e % 10 == 1 && e % 100 != 11
                ? 0
                : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20)
                ? 1
                : 2
            );
          },
          16: function (e) {
            return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
          },
          17: function (e) {
            return Number(1 == e || (e % 10 == 1 && e % 100 != 11) ? 0 : 1);
          },
          18: function (e) {
            return Number(0 == e ? 0 : 1 == e ? 1 : 2);
          },
          19: function (e) {
            return Number(
              1 == e
                ? 0
                : 0 == e || (e % 100 > 1 && e % 100 < 11)
                ? 1
                : e % 100 > 10 && e % 100 < 20
                ? 2
                : 3
            );
          },
          20: function (e) {
            return Number(
              1 == e ? 0 : 0 == e || (e % 100 > 0 && e % 100 < 20) ? 1 : 2
            );
          },
          21: function (e) {
            return Number(
              e % 100 == 1
                ? 1
                : e % 100 == 2
                ? 2
                : e % 100 == 3 || e % 100 == 4
                ? 3
                : 0
            );
          },
          22: function (e) {
            return Number(
              1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
            );
          },
        },
        Fe = ["v1", "v2", "v3"],
        He = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        Ve = (function () {
          function e(t) {
            var n,
              r =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            te(this, e),
              (this.languageUtils = t),
              (this.options = r),
              (this.logger = he.create("pluralResolver")),
              (this.options.compatibilityJSON &&
                "v4" !== this.options.compatibilityJSON) ||
                ("undefined" != typeof Intl && Intl.PluralRules) ||
                ((this.options.compatibilityJSON = "v3"),
                this.logger.error(
                  "Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling."
                )),
              (this.rules =
                ((n = {}),
                Be.forEach(function (e) {
                  e.lngs.forEach(function (t) {
                    n[t] = { numbers: e.nr, plurals: Ze[e.fc] };
                  });
                }),
                n));
          }
          return (
            re(e, [
              {
                key: "addRule",
                value: function (e, t) {
                  this.rules[e] = t;
                },
              },
              {
                key: "getRule",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                  if (this.shouldUseIntlApi())
                    try {
                      return new Intl.PluralRules(e, {
                        type: t.ordinal ? "ordinal" : "cardinal",
                      });
                    } catch (e) {
                      return;
                    }
                  return (
                    this.rules[e] ||
                    this.rules[this.languageUtils.getLanguagePartFromCode(e)]
                  );
                },
              },
              {
                key: "needsPlural",
                value: function (e) {
                  var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    n = this.getRule(e, t);
                  return this.shouldUseIntlApi()
                    ? n && n.resolvedOptions().pluralCategories.length > 1
                    : n && n.numbers.length > 1;
                },
              },
              {
                key: "getPluralFormsOfKey",
                value: function (e, t) {
                  var n =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {};
                  return this.getSuffixes(e, n).map(function (e) {
                    return "".concat(t).concat(e);
                  });
                },
              },
              {
                key: "getSuffixes",
                value: function (e) {
                  var t = this,
                    n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    r = this.getRule(e, n);
                  return r
                    ? this.shouldUseIntlApi()
                      ? r
                          .resolvedOptions()
                          .pluralCategories.sort(function (e, t) {
                            return He[e] - He[t];
                          })
                          .map(function (e) {
                            return "".concat(t.options.prepend).concat(e);
                          })
                      : r.numbers.map(function (r) {
                          return t.getSuffix(e, r, n);
                        })
                    : [];
                },
              },
              {
                key: "getSuffix",
                value: function (e, t) {
                  var n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {},
                    r = this.getRule(e, n);
                  return r
                    ? this.shouldUseIntlApi()
                      ? "".concat(this.options.prepend).concat(r.select(t))
                      : this.getSuffixRetroCompatible(r, t)
                    : (this.logger.warn("no plural rule found for: ".concat(e)),
                      "");
                },
              },
              {
                key: "getSuffixRetroCompatible",
                value: function (e, t) {
                  var n = this,
                    r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t)),
                    o = e.numbers[r];
                  this.options.simplifyPluralSuffix &&
                    2 === e.numbers.length &&
                    1 === e.numbers[0] &&
                    (2 === o ? (o = "plural") : 1 === o && (o = ""));
                  var a = function () {
                    return n.options.prepend && o.toString()
                      ? n.options.prepend + o.toString()
                      : o.toString();
                  };
                  return "v1" === this.options.compatibilityJSON
                    ? 1 === o
                      ? ""
                      : "number" == typeof o
                      ? "_plural_".concat(o.toString())
                      : a()
                    : "v2" === this.options.compatibilityJSON ||
                      (this.options.simplifyPluralSuffix &&
                        2 === e.numbers.length &&
                        1 === e.numbers[0])
                    ? a()
                    : this.options.prepend && r.toString()
                    ? this.options.prepend + r.toString()
                    : r.toString();
                },
              },
              {
                key: "shouldUseIntlApi",
                value: function () {
                  return !Fe.includes(this.options.compatibilityJSON);
                },
              },
            ]),
            e
          );
        })();
      function We(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function $e(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? We(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : We(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var Ue = (function () {
        function e() {
          var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          te(this, e),
            (this.logger = he.create("interpolator")),
            (this.options = t),
            (this.format =
              (t.interpolation && t.interpolation.format) ||
              function (e) {
                return e;
              }),
            this.init(t);
        }
        return (
          re(e, [
            {
              key: "init",
              value: function () {
                var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                e.interpolation || (e.interpolation = { escapeValue: !0 });
                var t = e.interpolation;
                (this.escape = void 0 !== t.escape ? t.escape : we),
                  (this.escapeValue =
                    void 0 === t.escapeValue || t.escapeValue),
                  (this.useRawValueToEscape =
                    void 0 !== t.useRawValueToEscape && t.useRawValueToEscape),
                  (this.prefix = t.prefix
                    ? Se(t.prefix)
                    : t.prefixEscaped || "{{"),
                  (this.suffix = t.suffix
                    ? Se(t.suffix)
                    : t.suffixEscaped || "}}"),
                  (this.formatSeparator = t.formatSeparator
                    ? t.formatSeparator
                    : t.formatSeparator || ","),
                  (this.unescapePrefix = t.unescapeSuffix
                    ? ""
                    : t.unescapePrefix || "-"),
                  (this.unescapeSuffix = this.unescapePrefix
                    ? ""
                    : t.unescapeSuffix || ""),
                  (this.nestingPrefix = t.nestingPrefix
                    ? Se(t.nestingPrefix)
                    : t.nestingPrefixEscaped || Se("$t(")),
                  (this.nestingSuffix = t.nestingSuffix
                    ? Se(t.nestingSuffix)
                    : t.nestingSuffixEscaped || Se(")")),
                  (this.nestingOptionsSeparator = t.nestingOptionsSeparator
                    ? t.nestingOptionsSeparator
                    : t.nestingOptionsSeparator || ","),
                  (this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3),
                  (this.alwaysFormat =
                    void 0 !== t.alwaysFormat && t.alwaysFormat),
                  this.resetRegExp();
              },
            },
            {
              key: "reset",
              value: function () {
                this.options && this.init(this.options);
              },
            },
            {
              key: "resetRegExp",
              value: function () {
                var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(e, "g");
                var t = ""
                  .concat(this.prefix)
                  .concat(this.unescapePrefix, "(.+?)")
                  .concat(this.unescapeSuffix)
                  .concat(this.suffix);
                this.regexpUnescape = new RegExp(t, "g");
                var n = ""
                  .concat(this.nestingPrefix, "(.+?)")
                  .concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(n, "g");
              },
            },
            {
              key: "interpolate",
              value: function (e, t, n, r) {
                var o,
                  a,
                  i,
                  s = this,
                  l =
                    (this.options &&
                      this.options.interpolation &&
                      this.options.interpolation.defaultVariables) ||
                    {};
                function c(e) {
                  return e.replace(/\$/g, "$$$$");
                }
                var u = function (e) {
                  if (e.indexOf(s.formatSeparator) < 0) {
                    var o = xe(t, l, e);
                    return s.alwaysFormat
                      ? s.format(
                          o,
                          void 0,
                          n,
                          $e($e($e({}, r), t), {}, { interpolationkey: e })
                        )
                      : o;
                  }
                  var a = e.split(s.formatSeparator),
                    i = a.shift().trim(),
                    c = a.join(s.formatSeparator).trim();
                  return s.format(
                    xe(t, l, i),
                    c,
                    n,
                    $e($e($e({}, r), t), {}, { interpolationkey: i })
                  );
                };
                this.resetRegExp();
                var d =
                    (r && r.missingInterpolationHandler) ||
                    this.options.missingInterpolationHandler,
                  p =
                    r &&
                    r.interpolation &&
                    void 0 !== r.interpolation.skipOnVariables
                      ? r.interpolation.skipOnVariables
                      : this.options.interpolation.skipOnVariables;
                return (
                  [
                    {
                      regex: this.regexpUnescape,
                      safeValue: function (e) {
                        return c(e);
                      },
                    },
                    {
                      regex: this.regexp,
                      safeValue: function (e) {
                        return s.escapeValue ? c(s.escape(e)) : c(e);
                      },
                    },
                  ].forEach(function (t) {
                    for (i = 0; (o = t.regex.exec(e)); ) {
                      var n = o[1].trim();
                      if (void 0 === (a = u(n)))
                        if ("function" == typeof d) {
                          var l = d(e, o, r);
                          a = "string" == typeof l ? l : "";
                        } else if (r && r.hasOwnProperty(n)) a = "";
                        else {
                          if (p) {
                            a = o[0];
                            continue;
                          }
                          s.logger.warn(
                            "missed to pass in variable "
                              .concat(n, " for interpolating ")
                              .concat(e)
                          ),
                            (a = "");
                        }
                      else
                        "string" == typeof a ||
                          s.useRawValueToEscape ||
                          (a = ve(a));
                      var c = t.safeValue(a);
                      if (
                        ((e = e.replace(o[0], c)),
                        p
                          ? ((t.regex.lastIndex += a.length),
                            (t.regex.lastIndex -= o[0].length))
                          : (t.regex.lastIndex = 0),
                        ++i >= s.maxReplaces)
                      )
                        break;
                    }
                  }),
                  e
                );
              },
            },
            {
              key: "nest",
              value: function (e, t) {
                var n,
                  r,
                  o = this,
                  a =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {},
                  i = $e({}, a);
                function s(e, t) {
                  var n = this.nestingOptionsSeparator;
                  if (e.indexOf(n) < 0) return e;
                  var r = e.split(new RegExp("".concat(n, "[ ]*{"))),
                    o = "{".concat(r[1]);
                  e = r[0];
                  var a = (o = this.interpolate(o, i)).match(/'/g),
                    s = o.match(/"/g);
                  ((a && a.length % 2 == 0 && !s) || s.length % 2 != 0) &&
                    (o = o.replace(/'/g, '"'));
                  try {
                    (i = JSON.parse(o)), t && (i = $e($e({}, t), i));
                  } catch (t) {
                    return (
                      this.logger.warn(
                        "failed parsing options string in nesting for key ".concat(
                          e
                        ),
                        t
                      ),
                      "".concat(e).concat(n).concat(o)
                    );
                  }
                  return delete i.defaultValue, e;
                }
                for (
                  i.applyPostProcessor = !1, delete i.defaultValue;
                  (n = this.nestingRegexp.exec(e));

                ) {
                  var l = [],
                    c = !1;
                  if (
                    -1 !== n[0].indexOf(this.formatSeparator) &&
                    !/{.*}/.test(n[1])
                  ) {
                    var u = n[1].split(this.formatSeparator).map(function (e) {
                      return e.trim();
                    });
                    (n[1] = u.shift()), (l = u), (c = !0);
                  }
                  if (
                    (r = t(s.call(this, n[1].trim(), i), i)) &&
                    n[0] === e &&
                    "string" != typeof r
                  )
                    return r;
                  "string" != typeof r && (r = ve(r)),
                    r ||
                      (this.logger.warn(
                        "missed to resolve "
                          .concat(n[1], " for nesting ")
                          .concat(e)
                      ),
                      (r = "")),
                    c &&
                      (r = l.reduce(function (e, t) {
                        return o.format(
                          e,
                          t,
                          a.lng,
                          $e($e({}, a), {}, { interpolationkey: n[1].trim() })
                        );
                      }, r.trim())),
                    (e = e.replace(n[0], r)),
                    (this.regexp.lastIndex = 0);
                }
                return e;
              },
            },
          ]),
          e
        );
      })();
      function Ke(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Ge(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ke(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Ke(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function qe(e) {
        var t = {};
        return function (n, r, o) {
          var a = r + JSON.stringify(o),
            i = t[a];
          return i || ((i = e(r, o)), (t[a] = i)), i(n);
        };
      }
      var Ye = (function () {
        function e() {
          var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          te(this, e),
            (this.logger = he.create("formatter")),
            (this.options = t),
            (this.formats = {
              number: qe(function (e, t) {
                var n = new Intl.NumberFormat(e, t);
                return function (e) {
                  return n.format(e);
                };
              }),
              currency: qe(function (e, t) {
                var n = new Intl.NumberFormat(
                  e,
                  Ge(Ge({}, t), {}, { style: "currency" })
                );
                return function (e) {
                  return n.format(e);
                };
              }),
              datetime: qe(function (e, t) {
                var n = new Intl.DateTimeFormat(e, Ge({}, t));
                return function (e) {
                  return n.format(e);
                };
              }),
              relativetime: qe(function (e, t) {
                var n = new Intl.RelativeTimeFormat(e, Ge({}, t));
                return function (e) {
                  return n.format(e, t.range || "day");
                };
              }),
              list: qe(function (e, t) {
                var n = new Intl.ListFormat(e, Ge({}, t));
                return function (e) {
                  return n.format(e);
                };
              }),
            }),
            this.init(t);
        }
        return (
          re(e, [
            {
              key: "init",
              value: function (e) {
                var t = (
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : { interpolation: {} }
                ).interpolation;
                this.formatSeparator = t.formatSeparator
                  ? t.formatSeparator
                  : t.formatSeparator || ",";
              },
            },
            {
              key: "add",
              value: function (e, t) {
                this.formats[e.toLowerCase().trim()] = t;
              },
            },
            {
              key: "addCached",
              value: function (e, t) {
                this.formats[e.toLowerCase().trim()] = qe(t);
              },
            },
            {
              key: "format",
              value: function (e, t, n, r) {
                var o = this;
                return t.split(this.formatSeparator).reduce(function (e, t) {
                  var a = (function (e) {
                      var t = e.toLowerCase().trim(),
                        n = {};
                      if (e.indexOf("(") > -1) {
                        var r = e.split("(");
                        t = r[0].toLowerCase().trim();
                        var o = r[1].substring(0, r[1].length - 1);
                        "currency" === t && o.indexOf(":") < 0
                          ? n.currency || (n.currency = o.trim())
                          : "relativetime" === t && o.indexOf(":") < 0
                          ? n.range || (n.range = o.trim())
                          : o.split(";").forEach(function (e) {
                              if (e) {
                                var t = (function (e) {
                                    return (
                                      (function (e) {
                                        if (Array.isArray(e)) return e;
                                      })(e) ||
                                      (function (e) {
                                        if (
                                          ("undefined" != typeof Symbol &&
                                            null != e[Symbol.iterator]) ||
                                          null != e["@@iterator"]
                                        )
                                          return Array.from(e);
                                      })(e) ||
                                      (function (e, t) {
                                        if (e) {
                                          if ("string" == typeof e)
                                            return ce(e, t);
                                          var n = Object.prototype.toString
                                            .call(e)
                                            .slice(8, -1);
                                          return (
                                            "Object" === n &&
                                              e.constructor &&
                                              (n = e.constructor.name),
                                            "Map" === n || "Set" === n
                                              ? Array.from(e)
                                              : "Arguments" === n ||
                                                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(
                                                  n
                                                )
                                              ? ce(e, t)
                                              : void 0
                                          );
                                        }
                                      })(e) ||
                                      (function () {
                                        throw new TypeError(
                                          "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                                        );
                                      })()
                                    );
                                  })(e.split(":")),
                                  r = t[0],
                                  o = t
                                    .slice(1)
                                    .join(":")
                                    .trim()
                                    .replace(/^'+|'+$/g, "");
                                n[r.trim()] || (n[r.trim()] = o),
                                  "false" === o && (n[r.trim()] = !1),
                                  "true" === o && (n[r.trim()] = !0),
                                  isNaN(o) || (n[r.trim()] = parseInt(o, 10));
                              }
                            });
                      }
                      return { formatName: t, formatOptions: n };
                    })(t),
                    i = a.formatName,
                    s = a.formatOptions;
                  if (o.formats[i]) {
                    var l = e;
                    try {
                      var c =
                          (r &&
                            r.formatParams &&
                            r.formatParams[r.interpolationkey]) ||
                          {},
                        u = c.locale || c.lng || r.locale || r.lng || n;
                      l = o.formats[i](e, u, Ge(Ge(Ge({}, s), r), c));
                    } catch (e) {
                      o.logger.warn(e);
                    }
                    return l;
                  }
                  return (
                    o.logger.warn(
                      "there was no format function for ".concat(i)
                    ),
                    e
                  );
                }, e);
              },
            },
          ]),
          e
        );
      })();
      function Je(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Qe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Je(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Je(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var Xe = (function (e) {
        ie(o, e);
        var t,
          n,
          r =
            ((t = o),
            (n = (function () {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Boolean.prototype.valueOf.call(
                    Reflect.construct(Boolean, [], function () {})
                  ),
                  !0
                );
              } catch (e) {
                return !1;
              }
            })()),
            function () {
              var e,
                r = le(t);
              if (n) {
                var o = le(this).constructor;
                e = Reflect.construct(r, arguments, o);
              } else e = r.apply(this, arguments);
              return se(this, e);
            });
        function o(e, t, n) {
          var a,
            i =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : {};
          return (
            te(this, o),
            (a = r.call(this)),
            Pe && fe.call(oe(a)),
            (a.backend = e),
            (a.store = t),
            (a.services = n),
            (a.languageUtils = n.languageUtils),
            (a.options = i),
            (a.logger = he.create("backendConnector")),
            (a.waitingReads = []),
            (a.maxParallelReads = i.maxParallelReads || 10),
            (a.readingCalls = 0),
            (a.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5),
            (a.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350),
            (a.state = {}),
            (a.queue = []),
            a.backend && a.backend.init && a.backend.init(n, i.backend, i),
            a
          );
        }
        return (
          re(o, [
            {
              key: "queueLoad",
              value: function (e, t, n, r) {
                var o = this,
                  a = {},
                  i = {},
                  s = {},
                  l = {};
                return (
                  e.forEach(function (e) {
                    var r = !0;
                    t.forEach(function (t) {
                      var s = "".concat(e, "|").concat(t);
                      !n.reload && o.store.hasResourceBundle(e, t)
                        ? (o.state[s] = 2)
                        : o.state[s] < 0 ||
                          (1 === o.state[s]
                            ? void 0 === i[s] && (i[s] = !0)
                            : ((o.state[s] = 1),
                              (r = !1),
                              void 0 === i[s] && (i[s] = !0),
                              void 0 === a[s] && (a[s] = !0),
                              void 0 === l[t] && (l[t] = !0)));
                    }),
                      r || (s[e] = !0);
                  }),
                  (Object.keys(a).length || Object.keys(i).length) &&
                    this.queue.push({
                      pending: i,
                      pendingCount: Object.keys(i).length,
                      loaded: {},
                      errors: [],
                      callback: r,
                    }),
                  {
                    toLoad: Object.keys(a),
                    pending: Object.keys(i),
                    toLoadLanguages: Object.keys(s),
                    toLoadNamespaces: Object.keys(l),
                  }
                );
              },
            },
            {
              key: "loaded",
              value: function (e, t, n) {
                var r = e.split("|"),
                  o = r[0],
                  a = r[1];
                t && this.emit("failedLoading", o, a, t),
                  n && this.store.addResourceBundle(o, a, n),
                  (this.state[e] = t ? -1 : 2);
                var i = {};
                this.queue.forEach(function (n) {
                  !(function (e, t, n, r) {
                    var o = be(e, t, Object),
                      a = o.obj,
                      i = o.k;
                    (a[i] = a[i] || []), a[i].push(n);
                  })(n.loaded, [o], a),
                    (function (e, t) {
                      void 0 !== e.pending[t] &&
                        (delete e.pending[t], e.pendingCount--);
                    })(n, e),
                    t && n.errors.push(t),
                    0 !== n.pendingCount ||
                      n.done ||
                      (Object.keys(n.loaded).forEach(function (e) {
                        i[e] || (i[e] = {});
                        var t = n.loaded[e];
                        t.length &&
                          t.forEach(function (t) {
                            void 0 === i[e][t] && (i[e][t] = !0);
                          });
                      }),
                      (n.done = !0),
                      n.errors.length ? n.callback(n.errors) : n.callback());
                }),
                  this.emit("loaded", i),
                  (this.queue = this.queue.filter(function (e) {
                    return !e.done;
                  }));
              },
            },
            {
              key: "read",
              value: function (e, t, n) {
                var r = this,
                  o =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : 0,
                  a =
                    arguments.length > 4 && void 0 !== arguments[4]
                      ? arguments[4]
                      : this.retryTimeout,
                  i = arguments.length > 5 ? arguments[5] : void 0;
                return e.length
                  ? this.readingCalls >= this.maxParallelReads
                    ? void this.waitingReads.push({
                        lng: e,
                        ns: t,
                        fcName: n,
                        tried: o,
                        wait: a,
                        callback: i,
                      })
                    : (this.readingCalls++,
                      this.backend[n](e, t, function (s, l) {
                        if ((r.readingCalls--, r.waitingReads.length > 0)) {
                          var c = r.waitingReads.shift();
                          r.read(
                            c.lng,
                            c.ns,
                            c.fcName,
                            c.tried,
                            c.wait,
                            c.callback
                          );
                        }
                        s && l && o < r.maxRetries
                          ? setTimeout(function () {
                              r.read.call(r, e, t, n, o + 1, 2 * a, i);
                            }, a)
                          : i(s, l);
                      }))
                  : i(null, {});
              },
            },
            {
              key: "prepareLoading",
              value: function (e, t) {
                var n = this,
                  r =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {},
                  o = arguments.length > 3 ? arguments[3] : void 0;
                if (!this.backend)
                  return (
                    this.logger.warn(
                      "No backend was added via i18next.use. Will not load resources."
                    ),
                    o && o()
                  );
                "string" == typeof e &&
                  (e = this.languageUtils.toResolveHierarchy(e)),
                  "string" == typeof t && (t = [t]);
                var a = this.queueLoad(e, t, r, o);
                if (!a.toLoad.length) return a.pending.length || o(), null;
                a.toLoad.forEach(function (e) {
                  n.loadOne(e);
                });
              },
            },
            {
              key: "load",
              value: function (e, t, n) {
                this.prepareLoading(e, t, {}, n);
              },
            },
            {
              key: "reload",
              value: function (e, t, n) {
                this.prepareLoading(e, t, { reload: !0 }, n);
              },
            },
            {
              key: "loadOne",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : "",
                  r = e.split("|"),
                  o = r[0],
                  a = r[1];
                this.read(o, a, "read", void 0, void 0, function (r, i) {
                  r &&
                    t.logger.warn(
                      ""
                        .concat(n, "loading namespace ")
                        .concat(a, " for language ")
                        .concat(o, " failed"),
                      r
                    ),
                    !r &&
                      i &&
                      t.logger.log(
                        ""
                          .concat(n, "loaded namespace ")
                          .concat(a, " for language ")
                          .concat(o),
                        i
                      ),
                    t.loaded(e, r, i);
                });
              },
            },
            {
              key: "saveMissing",
              value: function (e, t, n, r, o) {
                var a =
                  arguments.length > 5 && void 0 !== arguments[5]
                    ? arguments[5]
                    : {};
                this.services.utils &&
                this.services.utils.hasLoadedNamespace &&
                !this.services.utils.hasLoadedNamespace(t)
                  ? this.logger.warn(
                      'did not save key "'
                        .concat(n, '" as the namespace "')
                        .concat(t, '" was not yet loaded'),
                      "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!"
                    )
                  : null != n &&
                    "" !== n &&
                    (this.backend &&
                      this.backend.create &&
                      this.backend.create(
                        e,
                        t,
                        n,
                        r,
                        null,
                        Qe(Qe({}, a), {}, { isUpdate: o })
                      ),
                    e && e[0] && this.store.addResource(e[0], t, n, r));
              },
            },
          ]),
          o
        );
      })(fe);
      function et(e) {
        return (
          "string" == typeof e.ns && (e.ns = [e.ns]),
          "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]),
          "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]),
          e.supportedLngs &&
            e.supportedLngs.indexOf("cimode") < 0 &&
            (e.supportedLngs = e.supportedLngs.concat(["cimode"])),
          e
        );
      }
      function tt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function nt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? tt(Object(n), !0).forEach(function (t) {
                S(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : tt(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function rt() {}
      var ot = (function (e) {
        ie(o, e);
        var t,
          n,
          r =
            ((t = o),
            (n = (function () {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Boolean.prototype.valueOf.call(
                    Reflect.construct(Boolean, [], function () {})
                  ),
                  !0
                );
              } catch (e) {
                return !1;
              }
            })()),
            function () {
              var e,
                r = le(t);
              if (n) {
                var o = le(this).constructor;
                e = Reflect.construct(r, arguments, o);
              } else e = r.apply(this, arguments);
              return se(this, e);
            });
        function o() {
          var e,
            t,
            n =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {},
            a = arguments.length > 1 ? arguments[1] : void 0;
          if (
            (te(this, o),
            (e = r.call(this)),
            Pe && fe.call(oe(e)),
            (e.options = et(n)),
            (e.services = {}),
            (e.logger = he),
            (e.modules = { external: [] }),
            (t = oe(e)),
            Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach(
              function (e) {
                "function" == typeof t[e] && (t[e] = t[e].bind(t));
              }
            ),
            a && !e.isInitialized && !n.isClone)
          ) {
            if (!e.options.initImmediate) return e.init(n, a), se(e, oe(e));
            setTimeout(function () {
              e.init(n, a);
            }, 0);
          }
          return e;
        }
        return (
          re(o, [
            {
              key: "init",
              value: function () {
                var e = this,
                  t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : {},
                  n = arguments.length > 1 ? arguments[1] : void 0;
                "function" == typeof t && ((n = t), (t = {})),
                  !t.defaultNS &&
                    !1 !== t.defaultNS &&
                    t.ns &&
                    ("string" == typeof t.ns
                      ? (t.defaultNS = t.ns)
                      : t.ns.indexOf("translation") < 0 &&
                        (t.defaultNS = t.ns[0]));
                var r = {
                  debug: !1,
                  initImmediate: !0,
                  ns: ["translation"],
                  defaultNS: ["translation"],
                  fallbackLng: ["dev"],
                  fallbackNS: !1,
                  supportedLngs: !1,
                  nonExplicitSupportedLngs: !1,
                  load: "all",
                  preload: !1,
                  simplifyPluralSuffix: !0,
                  keySeparator: ".",
                  nsSeparator: ":",
                  pluralSeparator: "_",
                  contextSeparator: "_",
                  partialBundledLanguages: !1,
                  saveMissing: !1,
                  updateMissing: !1,
                  saveMissingTo: "fallback",
                  saveMissingPlurals: !0,
                  missingKeyHandler: !1,
                  missingInterpolationHandler: !1,
                  postProcess: !1,
                  postProcessPassResolved: !1,
                  returnNull: !0,
                  returnEmptyString: !0,
                  returnObjects: !1,
                  joinArrays: !1,
                  returnedObjectHandler: !1,
                  parseMissingKeyHandler: !1,
                  appendNamespaceToMissingKey: !1,
                  appendNamespaceToCIMode: !1,
                  overloadTranslationOptionHandler: function (e) {
                    var t = {};
                    if (
                      ("object" === x(e[1]) && (t = e[1]),
                      "string" == typeof e[1] && (t.defaultValue = e[1]),
                      "string" == typeof e[2] && (t.tDescription = e[2]),
                      "object" === x(e[2]) || "object" === x(e[3]))
                    ) {
                      var n = e[3] || e[2];
                      Object.keys(n).forEach(function (e) {
                        t[e] = n[e];
                      });
                    }
                    return t;
                  },
                  interpolation: {
                    escapeValue: !0,
                    format: function (e, t, n, r) {
                      return e;
                    },
                    prefix: "{{",
                    suffix: "}}",
                    formatSeparator: ",",
                    unescapePrefix: "-",
                    nestingPrefix: "$t(",
                    nestingSuffix: ")",
                    nestingOptionsSeparator: ",",
                    maxReplaces: 1e3,
                    skipOnVariables: !0,
                  },
                };
                function o(e) {
                  return e ? ("function" == typeof e ? new e() : e) : null;
                }
                if (
                  ((this.options = nt(nt(nt({}, r), this.options), et(t))),
                  "v1" !== this.options.compatibilityAPI &&
                    (this.options.interpolation = nt(
                      nt({}, r.interpolation),
                      this.options.interpolation
                    )),
                  void 0 !== t.keySeparator &&
                    (this.options.userDefinedKeySeparator = t.keySeparator),
                  void 0 !== t.nsSeparator &&
                    (this.options.userDefinedNsSeparator = t.nsSeparator),
                  !this.options.isClone)
                ) {
                  var a;
                  this.modules.logger
                    ? he.init(o(this.modules.logger), this.options)
                    : he.init(null, this.options),
                    this.modules.formatter
                      ? (a = this.modules.formatter)
                      : "undefined" != typeof Intl && (a = Ye);
                  var i = new ze(this.options);
                  this.store = new Ee(this.options.resources, this.options);
                  var s = this.services;
                  (s.logger = he),
                    (s.resourceStore = this.store),
                    (s.languageUtils = i),
                    (s.pluralResolver = new Ve(i, {
                      prepend: this.options.pluralSeparator,
                      compatibilityJSON: this.options.compatibilityJSON,
                      simplifyPluralSuffix: this.options.simplifyPluralSuffix,
                    })),
                    !a ||
                      (this.options.interpolation.format &&
                        this.options.interpolation.format !==
                          r.interpolation.format) ||
                      ((s.formatter = o(a)),
                      s.formatter.init(s, this.options),
                      (this.options.interpolation.format =
                        s.formatter.format.bind(s.formatter))),
                    (s.interpolator = new Ue(this.options)),
                    (s.utils = {
                      hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
                    }),
                    (s.backendConnector = new Xe(
                      o(this.modules.backend),
                      s.resourceStore,
                      s,
                      this.options
                    )),
                    s.backendConnector.on("*", function (t) {
                      for (
                        var n = arguments.length,
                          r = new Array(n > 1 ? n - 1 : 0),
                          o = 1;
                        o < n;
                        o++
                      )
                        r[o - 1] = arguments[o];
                      e.emit.apply(e, [t].concat(r));
                    }),
                    this.modules.languageDetector &&
                      ((s.languageDetector = o(this.modules.languageDetector)),
                      s.languageDetector.init(
                        s,
                        this.options.detection,
                        this.options
                      )),
                    this.modules.i18nFormat &&
                      ((s.i18nFormat = o(this.modules.i18nFormat)),
                      s.i18nFormat.init && s.i18nFormat.init(this)),
                    (this.translator = new Ae(this.services, this.options)),
                    this.translator.on("*", function (t) {
                      for (
                        var n = arguments.length,
                          r = new Array(n > 1 ? n - 1 : 0),
                          o = 1;
                        o < n;
                        o++
                      )
                        r[o - 1] = arguments[o];
                      e.emit.apply(e, [t].concat(r));
                    }),
                    this.modules.external.forEach(function (t) {
                      t.init && t.init(e);
                    });
                }
                if (
                  ((this.format = this.options.interpolation.format),
                  n || (n = rt),
                  this.options.fallbackLng &&
                    !this.services.languageDetector &&
                    !this.options.lng)
                ) {
                  var l = this.services.languageUtils.getFallbackCodes(
                    this.options.fallbackLng
                  );
                  l.length > 0 && "dev" !== l[0] && (this.options.lng = l[0]);
                }
                this.services.languageDetector ||
                  this.options.lng ||
                  this.logger.warn(
                    "init: no languageDetector is used and no lng is defined"
                  ),
                  [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage",
                  ].forEach(function (t) {
                    e[t] = function () {
                      var n;
                      return (n = e.store)[t].apply(n, arguments);
                    };
                  }),
                  [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle",
                  ].forEach(function (t) {
                    e[t] = function () {
                      var n;
                      return (n = e.store)[t].apply(n, arguments), e;
                    };
                  });
                var c = ge(),
                  u = function () {
                    var t = function (t, r) {
                      e.isInitialized &&
                        !e.initializedStoreOnce &&
                        e.logger.warn(
                          "init: i18next is already initialized. You should call init just once!"
                        ),
                        (e.isInitialized = !0),
                        e.options.isClone ||
                          e.logger.log("initialized", e.options),
                        e.emit("initialized", e.options),
                        c.resolve(r),
                        n(t, r);
                    };
                    if (
                      e.languages &&
                      "v1" !== e.options.compatibilityAPI &&
                      !e.isInitialized
                    )
                      return t(null, e.t.bind(e));
                    e.changeLanguage(e.options.lng, t);
                  };
                return (
                  this.options.resources || !this.options.initImmediate
                    ? u()
                    : setTimeout(u, 0),
                  c
                );
              },
            },
            {
              key: "loadResources",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : rt,
                  r = "string" == typeof e ? e : this.language;
                if (
                  ("function" == typeof e && (n = e),
                  !this.options.resources ||
                    this.options.partialBundledLanguages)
                ) {
                  if (r && "cimode" === r.toLowerCase()) return n();
                  var o = [],
                    a = function (e) {
                      e &&
                        t.services.languageUtils
                          .toResolveHierarchy(e)
                          .forEach(function (e) {
                            o.indexOf(e) < 0 && o.push(e);
                          });
                    };
                  r
                    ? a(r)
                    : this.services.languageUtils
                        .getFallbackCodes(this.options.fallbackLng)
                        .forEach(function (e) {
                          return a(e);
                        }),
                    this.options.preload &&
                      this.options.preload.forEach(function (e) {
                        return a(e);
                      }),
                    this.services.backendConnector.load(
                      o,
                      this.options.ns,
                      function (e) {
                        e ||
                          t.resolvedLanguage ||
                          !t.language ||
                          t.setResolvedLanguage(t.language),
                          n(e);
                      }
                    );
                } else n(null);
              },
            },
            {
              key: "reloadResources",
              value: function (e, t, n) {
                var r = ge();
                return (
                  e || (e = this.languages),
                  t || (t = this.options.ns),
                  n || (n = rt),
                  this.services.backendConnector.reload(e, t, function (e) {
                    r.resolve(), n(e);
                  }),
                  r
                );
              },
            },
            {
              key: "use",
              value: function (e) {
                if (!e)
                  throw new Error(
                    "You are passing an undefined module! Please check the object you are passing to i18next.use()"
                  );
                if (!e.type)
                  throw new Error(
                    "You are passing a wrong module! Please check the object you are passing to i18next.use()"
                  );
                return (
                  "backend" === e.type && (this.modules.backend = e),
                  ("logger" === e.type || (e.log && e.warn && e.error)) &&
                    (this.modules.logger = e),
                  "languageDetector" === e.type &&
                    (this.modules.languageDetector = e),
                  "i18nFormat" === e.type && (this.modules.i18nFormat = e),
                  "postProcessor" === e.type && De.addPostProcessor(e),
                  "formatter" === e.type && (this.modules.formatter = e),
                  "3rdParty" === e.type && this.modules.external.push(e),
                  this
                );
              },
            },
            {
              key: "setResolvedLanguage",
              value: function (e) {
                if (e && this.languages && !(["cimode", "dev"].indexOf(e) > -1))
                  for (var t = 0; t < this.languages.length; t++) {
                    var n = this.languages[t];
                    if (
                      !(["cimode", "dev"].indexOf(n) > -1) &&
                      this.store.hasLanguageSomeTranslations(n)
                    ) {
                      this.resolvedLanguage = n;
                      break;
                    }
                  }
              },
            },
            {
              key: "changeLanguage",
              value: function (e, t) {
                var n = this;
                this.isLanguageChangingTo = e;
                var r = ge();
                this.emit("languageChanging", e);
                var o = function (e) {
                    (n.language = e),
                      (n.languages =
                        n.services.languageUtils.toResolveHierarchy(e)),
                      (n.resolvedLanguage = void 0),
                      n.setResolvedLanguage(e);
                  },
                  a = function (a) {
                    e || a || !n.services.languageDetector || (a = []);
                    var i =
                      "string" == typeof a
                        ? a
                        : n.services.languageUtils.getBestMatchFromCodes(a);
                    i &&
                      (n.language || o(i),
                      n.translator.language || n.translator.changeLanguage(i),
                      n.services.languageDetector &&
                        n.services.languageDetector.cacheUserLanguage(i)),
                      n.loadResources(i, function (e) {
                        !(function (e, a) {
                          a
                            ? (o(a),
                              n.translator.changeLanguage(a),
                              (n.isLanguageChangingTo = void 0),
                              n.emit("languageChanged", a),
                              n.logger.log("languageChanged", a))
                            : (n.isLanguageChangingTo = void 0),
                            r.resolve(function () {
                              return n.t.apply(n, arguments);
                            }),
                            t &&
                              t(e, function () {
                                return n.t.apply(n, arguments);
                              });
                        })(e, i);
                      });
                  };
                return (
                  e ||
                  !this.services.languageDetector ||
                  this.services.languageDetector.async
                    ? !e &&
                      this.services.languageDetector &&
                      this.services.languageDetector.async
                      ? this.services.languageDetector.detect(a)
                      : a(e)
                    : a(this.services.languageDetector.detect()),
                  r
                );
              },
            },
            {
              key: "getFixedT",
              value: function (e, t, n) {
                var r = this,
                  o = function e(t, o) {
                    var a;
                    if ("object" !== x(o)) {
                      for (
                        var i = arguments.length,
                          s = new Array(i > 2 ? i - 2 : 0),
                          l = 2;
                        l < i;
                        l++
                      )
                        s[l - 2] = arguments[l];
                      a = r.options.overloadTranslationOptionHandler(
                        [t, o].concat(s)
                      );
                    } else a = nt({}, o);
                    (a.lng = a.lng || e.lng),
                      (a.lngs = a.lngs || e.lngs),
                      (a.ns = a.ns || e.ns),
                      (a.keyPrefix = a.keyPrefix || n || e.keyPrefix);
                    var c = r.options.keySeparator || ".",
                      u = a.keyPrefix
                        ? "".concat(a.keyPrefix).concat(c).concat(t)
                        : t;
                    return r.t(u, a);
                  };
                return (
                  "string" == typeof e ? (o.lng = e) : (o.lngs = e),
                  (o.ns = t),
                  (o.keyPrefix = n),
                  o
                );
              },
            },
            {
              key: "t",
              value: function () {
                var e;
                return (
                  this.translator &&
                  (e = this.translator).translate.apply(e, arguments)
                );
              },
            },
            {
              key: "exists",
              value: function () {
                var e;
                return (
                  this.translator &&
                  (e = this.translator).exists.apply(e, arguments)
                );
              },
            },
            {
              key: "setDefaultNamespace",
              value: function (e) {
                this.options.defaultNS = e;
              },
            },
            {
              key: "hasLoadedNamespace",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                if (!this.isInitialized)
                  return (
                    this.logger.warn(
                      "hasLoadedNamespace: i18next was not initialized",
                      this.languages
                    ),
                    !1
                  );
                if (!this.languages || !this.languages.length)
                  return (
                    this.logger.warn(
                      "hasLoadedNamespace: i18n.languages were undefined or empty",
                      this.languages
                    ),
                    !1
                  );
                var r = this.resolvedLanguage || this.languages[0],
                  o = !!this.options && this.options.fallbackLng,
                  a = this.languages[this.languages.length - 1];
                if ("cimode" === r.toLowerCase()) return !0;
                var i = function (e, n) {
                  var r =
                    t.services.backendConnector.state[
                      "".concat(e, "|").concat(n)
                    ];
                  return -1 === r || 2 === r;
                };
                if (n.precheck) {
                  var s = n.precheck(this, i);
                  if (void 0 !== s) return s;
                }
                return !(
                  !this.hasResourceBundle(r, e) &&
                  this.services.backendConnector.backend &&
                  (!this.options.resources ||
                    this.options.partialBundledLanguages) &&
                  (!i(r, e) || (o && !i(a, e)))
                );
              },
            },
            {
              key: "loadNamespaces",
              value: function (e, t) {
                var n = this,
                  r = ge();
                return this.options.ns
                  ? ("string" == typeof e && (e = [e]),
                    e.forEach(function (e) {
                      n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
                    }),
                    this.loadResources(function (e) {
                      r.resolve(), t && t(e);
                    }),
                    r)
                  : (t && t(), Promise.resolve());
              },
            },
            {
              key: "loadLanguages",
              value: function (e, t) {
                var n = ge();
                "string" == typeof e && (e = [e]);
                var r = this.options.preload || [],
                  o = e.filter(function (e) {
                    return r.indexOf(e) < 0;
                  });
                return o.length
                  ? ((this.options.preload = r.concat(o)),
                    this.loadResources(function (e) {
                      n.resolve(), t && t(e);
                    }),
                    n)
                  : (t && t(), Promise.resolve());
              },
            },
            {
              key: "dir",
              value: function (e) {
                return (
                  e ||
                    (e =
                      this.resolvedLanguage ||
                      (this.languages && this.languages.length > 0
                        ? this.languages[0]
                        : this.language)),
                  e
                    ? [
                        "ar",
                        "shu",
                        "sqr",
                        "ssh",
                        "xaa",
                        "yhd",
                        "yud",
                        "aao",
                        "abh",
                        "abv",
                        "acm",
                        "acq",
                        "acw",
                        "acx",
                        "acy",
                        "adf",
                        "ads",
                        "aeb",
                        "aec",
                        "afb",
                        "ajp",
                        "apc",
                        "apd",
                        "arb",
                        "arq",
                        "ars",
                        "ary",
                        "arz",
                        "auz",
                        "avl",
                        "ayh",
                        "ayl",
                        "ayn",
                        "ayp",
                        "bbz",
                        "pga",
                        "he",
                        "iw",
                        "ps",
                        "pbt",
                        "pbu",
                        "pst",
                        "prp",
                        "prd",
                        "ug",
                        "ur",
                        "ydd",
                        "yds",
                        "yih",
                        "ji",
                        "yi",
                        "hbo",
                        "men",
                        "xmn",
                        "fa",
                        "jpr",
                        "peo",
                        "pes",
                        "prs",
                        "dv",
                        "sam",
                        "ckb",
                      ].indexOf(
                        this.services.languageUtils.getLanguagePartFromCode(e)
                      ) > -1 || e.toLowerCase().indexOf("-arab") > 1
                      ? "rtl"
                      : "ltr"
                    : "rtl"
                );
              },
            },
            {
              key: "cloneInstance",
              value: function () {
                var e = this,
                  t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : {},
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : rt,
                  r = nt(nt(nt({}, this.options), t), { isClone: !0 }),
                  a = new o(r);
                return (
                  (void 0 === t.debug && void 0 === t.prefix) ||
                    (a.logger = a.logger.clone(t)),
                  ["store", "services", "language"].forEach(function (t) {
                    a[t] = e[t];
                  }),
                  (a.services = nt({}, this.services)),
                  (a.services.utils = {
                    hasLoadedNamespace: a.hasLoadedNamespace.bind(a),
                  }),
                  (a.translator = new Ae(a.services, a.options)),
                  a.translator.on("*", function (e) {
                    for (
                      var t = arguments.length,
                        n = new Array(t > 1 ? t - 1 : 0),
                        r = 1;
                      r < t;
                      r++
                    )
                      n[r - 1] = arguments[r];
                    a.emit.apply(a, [e].concat(n));
                  }),
                  a.init(r, n),
                  (a.translator.options = a.options),
                  (a.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: a.hasLoadedNamespace.bind(a),
                  }),
                  a
                );
              },
            },
            {
              key: "toJSON",
              value: function () {
                return {
                  options: this.options,
                  store: this.store,
                  language: this.language,
                  languages: this.languages,
                  resolvedLanguage: this.resolvedLanguage,
                };
              },
            },
          ]),
          o
        );
      })(fe);
      S(ot, "createInstance", function () {
        return new ot(
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          arguments.length > 1 ? arguments[1] : void 0
        );
      });
      var at = ot.createInstance();
      (at.createInstance = ot.createInstance),
        at.createInstance,
        at.init,
        at.loadResources,
        at.reloadResources,
        at.use,
        at.changeLanguage,
        at.getFixedT,
        at.t,
        at.exists,
        at.setDefaultNamespace,
        at.hasLoadedNamespace,
        at.loadNamespaces,
        at.loadLanguages;
      var it = at,
        st = [],
        lt = st.forEach,
        ct = st.slice,
        ut = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/,
        dt = function (e, t, n) {
          var r = n || {};
          r.path = r.path || "/";
          var o = encodeURIComponent(t),
            a = "".concat(e, "=").concat(o);
          if (r.maxAge > 0) {
            var i = r.maxAge - 0;
            if (Number.isNaN(i)) throw new Error("maxAge should be a Number");
            a += "; Max-Age=".concat(Math.floor(i));
          }
          if (r.domain) {
            if (!ut.test(r.domain))
              throw new TypeError("option domain is invalid");
            a += "; Domain=".concat(r.domain);
          }
          if (r.path) {
            if (!ut.test(r.path)) throw new TypeError("option path is invalid");
            a += "; Path=".concat(r.path);
          }
          if (r.expires) {
            if ("function" != typeof r.expires.toUTCString)
              throw new TypeError("option expires is invalid");
            a += "; Expires=".concat(r.expires.toUTCString());
          }
          if (
            (r.httpOnly && (a += "; HttpOnly"),
            r.secure && (a += "; Secure"),
            r.sameSite)
          )
            switch (
              "string" == typeof r.sameSite
                ? r.sameSite.toLowerCase()
                : r.sameSite
            ) {
              case !0:
                a += "; SameSite=Strict";
                break;
              case "lax":
                a += "; SameSite=Lax";
                break;
              case "strict":
                a += "; SameSite=Strict";
                break;
              case "none":
                a += "; SameSite=None";
                break;
              default:
                throw new TypeError("option sameSite is invalid");
            }
          return a;
        },
        pt = {
          name: "cookie",
          lookup: function (e) {
            var t;
            if (e.lookupCookie && "undefined" != typeof document) {
              var n = (function (e) {
                for (
                  var t = "".concat(e, "="),
                    n = document.cookie.split(";"),
                    r = 0;
                  r < n.length;
                  r++
                ) {
                  for (var o = n[r]; " " === o.charAt(0); )
                    o = o.substring(1, o.length);
                  if (0 === o.indexOf(t))
                    return o.substring(t.length, o.length);
                }
                return null;
              })(e.lookupCookie);
              n && (t = n);
            }
            return t;
          },
          cacheUserLanguage: function (e, t) {
            t.lookupCookie &&
              "undefined" != typeof document &&
              (function (e, t, n, r) {
                var o =
                  arguments.length > 4 && void 0 !== arguments[4]
                    ? arguments[4]
                    : { path: "/", sameSite: "strict" };
                n &&
                  ((o.expires = new Date()),
                  o.expires.setTime(o.expires.getTime() + 60 * n * 1e3)),
                  r && (o.domain = r),
                  (document.cookie = dt(e, encodeURIComponent(t), o));
              })(
                t.lookupCookie,
                e,
                t.cookieMinutes,
                t.cookieDomain,
                t.cookieOptions
              );
          },
        },
        mt = {
          name: "querystring",
          lookup: function (e) {
            var t;
            if ("undefined" != typeof window) {
              var n = window.location.search;
              !window.location.search &&
                window.location.hash &&
                window.location.hash.indexOf("?") > -1 &&
                (n = window.location.hash.substring(
                  window.location.hash.indexOf("?")
                ));
              for (
                var r = n.substring(1).split("&"), o = 0;
                o < r.length;
                o++
              ) {
                var a = r[o].indexOf("=");
                a > 0 &&
                  r[o].substring(0, a) === e.lookupQuerystring &&
                  (t = r[o].substring(a + 1));
              }
            }
            return t;
          },
        },
        ht = null,
        ft = function () {
          if (null !== ht) return ht;
          try {
            ht = "undefined" !== window && null !== window.localStorage;
            var e = "i18next.translate.boo";
            window.localStorage.setItem(e, "foo"),
              window.localStorage.removeItem(e);
          } catch (e) {
            ht = !1;
          }
          return ht;
        },
        gt = {
          name: "localStorage",
          lookup: function (e) {
            var t;
            if (e.lookupLocalStorage && ft()) {
              var n = window.localStorage.getItem(e.lookupLocalStorage);
              n && (t = n);
            }
            return t;
          },
          cacheUserLanguage: function (e, t) {
            t.lookupLocalStorage &&
              ft() &&
              window.localStorage.setItem(t.lookupLocalStorage, e);
          },
        },
        vt = null,
        bt = function () {
          if (null !== vt) return vt;
          try {
            vt = "undefined" !== window && null !== window.sessionStorage;
            var e = "i18next.translate.boo";
            window.sessionStorage.setItem(e, "foo"),
              window.sessionStorage.removeItem(e);
          } catch (e) {
            vt = !1;
          }
          return vt;
        },
        _t = {
          name: "sessionStorage",
          lookup: function (e) {
            var t;
            if (e.lookupSessionStorage && bt()) {
              var n = window.sessionStorage.getItem(e.lookupSessionStorage);
              n && (t = n);
            }
            return t;
          },
          cacheUserLanguage: function (e, t) {
            t.lookupSessionStorage &&
              bt() &&
              window.sessionStorage.setItem(t.lookupSessionStorage, e);
          },
        },
        yt = {
          name: "navigator",
          lookup: function (e) {
            var t = [];
            if ("undefined" != typeof navigator) {
              if (navigator.languages)
                for (var n = 0; n < navigator.languages.length; n++)
                  t.push(navigator.languages[n]);
              navigator.userLanguage && t.push(navigator.userLanguage),
                navigator.language && t.push(navigator.language);
            }
            return t.length > 0 ? t : void 0;
          },
        },
        xt = {
          name: "htmlTag",
          lookup: function (e) {
            var t,
              n =
                e.htmlTag ||
                ("undefined" != typeof document
                  ? document.documentElement
                  : null);
            return (
              n &&
                "function" == typeof n.getAttribute &&
                (t = n.getAttribute("lang")),
              t
            );
          },
        },
        Ct = {
          name: "path",
          lookup: function (e) {
            var t;
            if ("undefined" != typeof window) {
              var n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
              if (n instanceof Array)
                if ("number" == typeof e.lookupFromPathIndex) {
                  if ("string" != typeof n[e.lookupFromPathIndex]) return;
                  t = n[e.lookupFromPathIndex].replace("/", "");
                } else t = n[0].replace("/", "");
            }
            return t;
          },
        },
        St = {
          name: "subdomain",
          lookup: function (e) {
            var t =
                "number" == typeof e.lookupFromSubdomainIndex
                  ? e.lookupFromSubdomainIndex + 1
                  : 1,
              n =
                "undefined" != typeof window &&
                window.location &&
                window.location.hostname &&
                window.location.hostname.match(
                  /^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i
                );
            if (n) return n[t];
          },
        },
        kt = (function () {
          function e(t) {
            var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            te(this, e),
              (this.type = "languageDetector"),
              (this.detectors = {}),
              this.init(t, n);
          }
          return (
            re(e, [
              {
                key: "init",
                value: function (e) {
                  var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {};
                  (this.services = e),
                    (this.options = (function (e) {
                      return (
                        lt.call(ct.call(arguments, 1), function (t) {
                          if (t)
                            for (var n in t) void 0 === e[n] && (e[n] = t[n]);
                        }),
                        e
                      );
                    })(t, this.options || {}, {
                      order: [
                        "querystring",
                        "cookie",
                        "localStorage",
                        "sessionStorage",
                        "navigator",
                        "htmlTag",
                      ],
                      lookupQuerystring: "lng",
                      lookupCookie: "i18next",
                      lookupLocalStorage: "i18nextLng",
                      lookupSessionStorage: "i18nextLng",
                      caches: ["localStorage"],
                      excludeCacheFor: ["cimode"],
                    })),
                    this.options.lookupFromUrlIndex &&
                      (this.options.lookupFromPathIndex =
                        this.options.lookupFromUrlIndex),
                    (this.i18nOptions = n),
                    this.addDetector(pt),
                    this.addDetector(mt),
                    this.addDetector(gt),
                    this.addDetector(_t),
                    this.addDetector(yt),
                    this.addDetector(xt),
                    this.addDetector(Ct),
                    this.addDetector(St);
                },
              },
              {
                key: "addDetector",
                value: function (e) {
                  this.detectors[e.name] = e;
                },
              },
              {
                key: "detect",
                value: function (e) {
                  var t = this;
                  e || (e = this.options.order);
                  var n = [];
                  return (
                    e.forEach(function (e) {
                      if (t.detectors[e]) {
                        var r = t.detectors[e].lookup(t.options);
                        r && "string" == typeof r && (r = [r]),
                          r && (n = n.concat(r));
                      }
                    }),
                    this.services.languageUtils.getBestMatchFromCodes
                      ? n
                      : n.length > 0
                      ? n[0]
                      : null
                  );
                },
              },
              {
                key: "cacheUserLanguage",
                value: function (e, t) {
                  var n = this;
                  t || (t = this.options.caches),
                    t &&
                      ((this.options.excludeCacheFor &&
                        this.options.excludeCacheFor.indexOf(e) > -1) ||
                        t.forEach(function (t) {
                          n.detectors[t] &&
                            n.detectors[t].cacheUserLanguage(e, n.options);
                        }));
                },
              },
            ]),
            e
          );
        })();
      kt.type = "languageDetector";
      var wt = JSON.parse(
          '{"dashboard_title":"DASHBOARD","dashboard_welcomeMsg":"Welcome to","dashboard_morningMsg":"Good Morning","dashboard_afternoonMsg":"Good Afternoon","dashboard_eveningMsg":"Good Evening","dashboard_subTitle1":"Current Month","dashboard_block1Heading":"CLIENT INVOICE","dashboard_block1Header1":"EARNINGS","dashboard_block1Header2":"INVOICE SENT","dashboard_block1Header3":"INVOICE PAID","dashboard_block2Heading":"WHOLESALE ORDERS","dashboard_block2Header1":"EARNINGS","dashboard_block2Header2":"INVOICE SENT","dashboard_block2Header3":"INVOICE PAID","dashboard_block3Heading":"AFFILIATE ORDERS","dashboard_block3Header1":"EARNINGS","dashboard_block3Header2":"ORDERS PAID","dashboard_block4Heading":"DISCOUNT COUPON","dashboard_block4Header1":"EARNINGS","dashboard_block4Header2":"ORDERS PAID","dashboard_block5Heading":"CUSTOMER COMMISSION","dashboard_block5Header1":"COMMISSION","dashboard_block5Header2":"ORDERS","dashboard_block6Heading":"TEAM LEAD COMMISSION","dashboard_block6Header1":"COMMISSION","dashboard_block7Heading":"POS COMMISSION","dashboard_block7Header1":"COMMISSION","dashboard_block7Header2":"ORDERS","dashboard_tbl1column1":"Month","dashboard_tbl1column2":"Client Invoice Orders","dashboard_tbl1column3":"Client Invoice Commission","dashboard_tbl1column4":"Wholesale Orders","dashboard_tbl1column5":"Total Wholesale Purchase","dashboard_tbl1column6":"Affiliate Orders","dashboard_tbl1column7":"Affilate Commission","dashboard_tbl1column8":"CouponCode Orders","dashboard_tbl1column9":"CouponCode Commission","dashboard_tbl1column10":"Customer Orders","dashboard_tbl1column11":"Customer Commission","dashboard_tbl1column12":"POS Orders","dashboard_tbl1column13":"POS Commission","dashboar_cardHeading1":"Total Order","dashboar_cardHeading2":"Commission","dashboar_cardHeading3":"Sales","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Sales Performance of Last Six Months","dashboard_graphHeading2":"Analyze Feature Wise Order and Commission For Current Month","Graph_Sales_noorderstitle":"No Order to Show","Graph_SalesRepCommission_nocommissiontitle":"No Commission Data to Show","Graph_SalesRepOrders_title":"ORDERS","Graph_SalesRep_XAxisTitle_ForMonth":"6 Month","Graph_SalesRepOrders_YAxisTitle":"Orders","Graph_SalesRepSales_title":"SALES","Graph_SalesRepCommission_title":"COMMISSION","Graph_SalesRepCommissions_YAxisTitle":"Commission","Graph_FeatureWiseOrder_title":"Orders Vs Feature","Graph_featureWiseCommission_title":"Commission Vs Feature","Graph_FeatureWiseOrder_XAxisTitle":"Feature","Graph_FeatureWiseOrder_YAxisTitle":"Orders","Graph_FeatureWiseCommission_title":"COMMISSION","Graph_FeatureWiseCommission_YAxisTitle":"Commission","customerInvoice_title":"Create Order","customerInvoice_button":"Back","customerInvoice_noclientorderMsg":"No Client Invoice Orders","customerInvoice_button1":"View Previous Orders","customerInvoice_contentHeading1":"Discount and Commission On","customerInvoice_table1column1":"Product Type","customerInvoice_table1column2":"Commission","customerInvoice_table1column3":"Discount Name","customerInvoice_table1column4":"Discount","customerInvoice_contentHeading2":"Add customer details and select products to send invoice.","customerInvoice_contentHeading2Title1":"Enter/Search Customer","customerInvoice_title1Placeholder":"Enter/Search Customer","customerInvoice_contentHeading2Title2":"Enter Customer Email Id","customerInvoice_title2Placeholder":"Email Address","customerInvoice_contentHeading2Title3":"Enter Order Notes","customerInvoice_contentHeading2Title4":"Customer Address","customerInvoice_contentHeading2Title5":"Customer Mobile Number","customerInvoice_contentHeading2Title6":"Customer Note","customerInvoice_contentHeading2Title7":"Customer Company Name","customerInvoice_title7Placeholder":"Company Name","customerInvoice_Placeholder_contentHeading2Title6":"Note","customerInvoice_Placeholder_contentHeading2Title5":"Mobile Number","customerInvoice_Placeholder_contentHeading2Title4":"Shipping Address","customerInvoice_title3Placeholder":"Order Notes","customerInvoice_SearchProducts_Label":"Search Products","customerInvoice_table2Column1":"Image","customerInvoice_table2Column2":"Add Quantity","customerInvoice_table2Column3":"Title","customerInvoice_table2Column4":"Variant Title","customerInvoice_ProductTableColumnPrice":"Price","customerInvoice_ProductTableColumnWholeSalePrice":"Wholesale Price","customerInvoice_button2":"Create Invoice","customerInvoice_ProductTableColumnProduct":"Product","customerInvoice_table3Column2":"Product Name","customerInvoice_table3Column3":"Size","customerInvoice_ProductTableColumnQuantity":"Quantity","customerInvoice_table3Column5":"Item Price","customerInvoice_table3Column6":"Total Price","customerInvoice_table3Column7":"Discounted Price for Customer","customerInvoice_table3Column8":"SalesRep Commission","customerInvoice_table3Column9":"DiscountType","customerInvoice_repproInvite":"Select checkbox to send pro invite","customerInvoice_customerOrder_error1":"all customer fields are mandatory. Please enter the customer\'s  email and first name","customerInvoice_productAddedMsg":"Product Added","customerInvoice_AlertErrorMsg":"Error..Please contact support !","wholesaleOrder_title":"Wholesale Order","wholesaleOrder_contentHeading1":"You can purchase products at special wholesale prices","wholesaleOrder_contentHeading2":"Discount On","wholesaleOrder_column1":"SalesRep Name","wholesaleOrder_column2":"Discount","wholesaleOrder_searchtxtPlaceholder":"Search Product","wholesaleOrder_table1Column1":"Image","wholesaleOrder_table1Column2":"Add Quantity","wholesaleOrder_table1Column3":"Title","wholesaleOrder_table1Column4":"Variant Title","wholesaleOrder_table1Column5":"Price","wholesaleOrder_button":"Check Out","wholesaleOrder_Order_btn":"Show/Hide Volume Pricing","wholesaleOrder_contentHeading3":"Total Price","wholesaleOrder_contentHeading4":"Your Discounted Price","wholesaleOrder_table2Column1":"Product","wholesaleOrder_table2Column2":"Product Name","wholesaleOrder_table2Column3":"Size","wholesaleOrder_table2Column4":"Quantity","wholesaleOrder_table2Column5":"Item Price","wholesaleOrder_table2Column6":"Total Price","wholesaleOrder_table2Column7":"Your Discounted Price","affiliateLink_title":"Affiliate Link","affiliate_product_link":"Product Link","affiliateLink_input_error_msg":"Link text field is required and should not contain spaces.","affiliateLink_contentHeading1":"Share your affiliate link on social media and email. You will get an affiliate commission for every order from your affiliate link","affiliateLink_contentHeading2":"Your Affiliate Link","affiliateLink_contentHeading3":"Commission On","affiliateLink_content_Message1":"Search products and share the link of individual products with you customers.","affiliateLink_noaffiliateorderMsg":"No Affiliate Orders","affiliateLink_column1":"SalesRep Name","affiliateLink_column2":"Commission","affiliateLink_searchtxtPlaceholder":"Search Product","affiliateLink_searchColumn1":"Product","affiliateLink_searchColumn2":"Product Title","affiliateLink_searchColumn3":"Price","affiliateLink_searchColumn4":"Commission","affiliateLink_searchColumn5":"Affiliate Link","affiliateLink_searchColumn7":"Copy Link","affiliateLink_searchColumn8":"Copied","affiliateLink_backbtn":"Back","affiliateLink_card_Title":"Contact Card & Affiliate Link","cartSharing_title":"Cart Sharing","cartSharing_CreateCartInformation_Text":"To create a personalized sharable cart, add products to cart from storefront.Those products will be displayed on this page","cartSharing_content2Placeholder":"Cart name","cartSharing_table2Column2":"Product Name","cartSharing_table2Column3":"Size","cartSharing_table2Column6":"Total Price","cartSharing_SharedCartLinkTableColumnCartName":"Cart Name","cartSharing_SharedCartLinkTableColumnLink":"Link","cartSharing_SharedCartLinkTableColumnCartLink":"Shareable Cart Link","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copy Cart Link","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Delete Cart Link","cartSharing_EnterCartName_Label":"Enter Cart Name","cartSharing_ProductTableColumnProduct":"Product","cartSharing_ProductTableColumnQuantity":"Quantity","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Item Price","cartSharing_Copied_Msg":"Copied!!","cartSharing_CartCreating_Msg":"Creating...","cartSharing_SharedCartLinkTableEmpty_Msg":"No Link to show","cartSharing_CartCreatedSuccessfully_Msg":"Cart Created Successfully","cartSharing_CartCreateError_Msg":"Error..please Try Again","cartSharing_AlertError_Msg":"Error..Please contact support !","cartSharing_CopyCartLink_Msg":"Copy Cart Link","cartSharing_DeleteCartLink_Msg":"Delete Cart Link","cartSharing_DeleteConfirmation_Msg":"Are you sure ?","cartSharing_ProductTableEmpty_Msg":"Product Not Available","cartSharing_CreateCart_Btn":"Create Cart","cartSharing_ProductTableQuantityUpdate_Btn":"Please Select Product","cartSharing_Select_product_Title":"Select Product","discountCoupon_titleOne":"Discount Coupon","discountCoupon_contentHeading1":"Share Discount Coupon Code with your customers and whenever your coupon is used you get a commission.","discountCoupon_contentHeading2":"Your Coupon Code is","discountCoupon_contentHeading3":"Discount Amount","discountCoupon_contentHeading4":"Commision ","discountCoupon_contentHeading4PlaceHolder1":"Hey use my discount coupon code","discountCoupon_contentHeading4PlaceHolder2":"and get discounted products","discountCoupon_button1":"Copy text","cartSharing_copiedButtonText":"Copied","discountCoupon_titleTwo":"Create one time use discount coupons for clients","discountCoupon_button2":"View Coupons","discountCoupon_contentHeading5":"Maximum allowed Discount","discountCoupon_contentHeading6":"Commision","discountCoupon_contentHeading7":"Enter Coupon Code","discountCoupon_contentHeading7PlaceHolder":"Please Enter Coupon Code","discountCoupon_contentHeading8":"Enter Discount","discountCoupon_contentHeading8PlaceHolder":"Discount should not be greater than Maximum discount.","discountCoupon_button3":"Create Coupon","discountCoupon_coupon_error1":"Please enter the coupon code and discount","yourBio_title":"Your contact card","yourBio_content1":"Upload Profile","yourBio_button1":"Choose File","yourBio_button1PlaceHolder":"No File chosen","yourBio_error_image_size":"Image size is too large, please upload a image of size less than 5MB. Please Try again.","yourBio_button2":"Upload","yourBio_content2":"Enter custom word to create your unique Affiliate Link","yourBio_content2PlaceHolder":"create your unique Affiliate Link","yourBio_content4":"When your link will be used your contact card will appear on website","yourBio_content3":"Enter Your contact card","yourBio_content3PlaceHolder":"Enter in 100 words","yourBio_button3":"Save","yourBio_button4":"Saved","yourBio_error_link":"This unique link may be taken. Try with different unique link.","yourBio_Linksuccessmsg":"Unique link saved sucessfully.","team_title1":"Add SalesRep","team_content1":"Enter Email","team_content1PlaceHolder":"Email Address","team_emailerrorMsg":"Please enter email","team_content2":"Enter First Name","team_content2PlaceHolder":"First Name","team_fnameerrorMsg":"Please enter first name","team_content3":"Enter Last Name","team_content3PlaceHolder":"Last Name","team_button1":"Add","team_successmsg":"Added successfully! Please check your email for the activation instructions.","team_errorsmsg":"Error while adding. This user email may already have an account on the store.","team_title2":"Team Details","team_content4":"Sign Up Page","team_NoTeamDetailsMsg":"No Team Details","team_content5":"Select SalesRep","team_tableTitle":"LAST TWO MONTHS ORDER DETAILS","team_column1":"Order Number","team_column2":"Order Date","team_column3":"Customer Name","team_column4":"Sales Rep","team_column5":"SubTotal","team_column6":"Sales Rep Commission","team_column7":"Team Manager Commission","team_column8":"Commission Type","addCustomer_title":"Add Customer","addCustomer_content1":"Customer First name ","addCustomer_txt1Placeholder":"First Name","addCustomer_content2":"Customer Last name","addCustomer_content2Placeholder":"Last Name","addCustomer_content3":"Customer Email Id","addCustomer_content3Placeholder":"Email Address","addCustomer_content4":"Note","addCustomer_content4Placeholder":"Note","addCustomer_customerAddress":"Personal Address","addCustomer_customerCity":"City","addCustomer_customerCityPlaceholder":"City","addCustomer_customerCountry":"Country","addCustomer_customerState":"State","addCustomer_customerZipCode":"Zip Code","addCustomer_companyName":"Company Name","addCustomer_companyAddress":"Company Address","addCustomer_companyCity":"City","addCustomer_companyCountry":"Country","addCustomer_companyState":"State","addCustomer_companyZipCode":"Zip Code","addCustomer_button":"Save","addCustomer_leadsuccessmsg":"Customer is added successfully.","addCustomer_leadErrrorMsg":"Error while saving the details.","addCustomer_leadEmptyErrrorMsg":"Please fill the required field.","addCustomer_leadsuccessmsg2":"Customer created & tagged to a sales rep successfully.","addCustomer_leadErrrorMsg2":"This customer is already tagged to a rep.","myCustomers_title":"Your Customers","myCustomers_table1Column1":"Name","myCustomers_table1Column2":"Company Name","myCustomers_table1Column3":"Email Id","myCustomers_table1Column4":"Order","myCustomers_table1Column5":"Total Spent","myCustomers_table2Title":"Customer Details","myCustomers_table3Title":"DRAFT ORDER DETAILS","myCustomers_table3Column1":"Product Name","myCustomers_table3Column2":"Size","myCustomers_table3Column3":"Quantity","myCustomers_table3Column4":"Price","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Subtotal","myCustomers_table2Row1":"Name","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Address","myCustomers_table2Row4":"Company Name","myCustomers_table2Row5":"Customers Notes ","myCustomers_table2Row6":"Total Spent(Subtotal+Tax)","myCustomers_table2Row7":"Number of Orders","myCustomers_table2Row8":"Tags","myCustomers_radioButton0":"Show all customer","myCustomers_radioButton1":"Search By Name","myCustomers_radioButton2":"Search By Company","myCustomers_radioButtonError1":"Please select search type and enter value to search","myCustomers_radioButtonError2":"Please enter value to search","myCustomers_radioButtonError3":"Please select search type","myCustomers_searchButton":"Search","myCustomers_Placeholder1":"Type Customer Name or Company Name to Search","myCustomers_NoOrdersError":"No Orders","myCustomer_no_salesRep_details":"No Sales Rep Details Available.","myCustomer_select_customer_country":"Please select customer country","myCustomer_company_country":"Company Country","myCustomer_company_state":"Company State","myCustomer_select_company_country":"Please select company country","yourSales_SalesOrderDetailsTitle":"Sales-Order Details","yourSales_title":"Last 2 months order details","yourSales_table1Column1":"Order No.","yourSales_table1Column2":"Order Date","yourSales_table1Column3":"Customer Name","yourSales_table1Column4":"SubTotal","yourSales_table1Column5":"Commission","yourSales_table1Column6":"Commission Type","yourSales_table1Column7":"Print Invoice","printOrderInvoice_btn":"Print","yourSales_tableTitle":"Product Details","yourSalesDraft_tableTitle":"Draft Order Details","yourSales_column1":"Product","yourSales_column2":"Title","yourSales_column3":"Quantity","yourSales_column4":"Item Price","yourSales_column5":"Tracking Number","yourSales_column6":"Ship Date","yourSales_column7":"Total Price","yourSales_content1":"SubTotal","yourSales_content2":"Tax","yourSales_content3":"Shipping Cost","yourSales_content4":"Total","yourSales_content5":"Note","yourSales_tabHeading1":"Paid Orders","yourSales_tabHeading4":"Pending Orders","yourSales_tabHeading2":"Draft orders","myOrders_title":"My Orders Details","myOrdersDetails_Message":"Orders placed for yourself","myOrders_table1Column1":"Order Number","myOrders_table1Column2":"Order Date","myOrders_table1Column3":"Customer Name","myOrders_table1Column4":"Payment","myOrders_table1Column5":"Fulfillment","myOrders_table1Column6":"Total","myOrders_tableTitle":"PRODUCT DETAILS","myOrders_table2Column1":"Product","myOrders_table2Column2":"Title","myOrders_table2Column3":"Quantity","myOrders_table2Column4":"Item Price","myOrders_table2Column5":"Tracking Number","myOrders_table2Column6":"Ship Date","myOrders_table2Column7":"Total Price","myOrders_content1":"SubTotal","myOrders_content2":"Tax","myOrders_content3":"Shipping Cost","myOrders_content4":"Total","myOrders_content5":"Note","myOrders_content6":"Draft Id","tab_Dashboard":"Dashboard","dashbord_Tab":"Home","tab_CustomerInvoice":"Create Order","tab3_WholesaleOrder":"Wholesale Order","tab_AffiliateLink":"Affiliate Link","tab_CartSharing":"Cart Sharing","tab_DiscountCoupon":"Discount Coupon","tab7_YourBio":"Your Contact Card","tab8_Team":"Team","tab9_AddCustomer":"Add Customer","tab_MyCustomers":"My Customers","tab_YourSalesOrderDetails":"Sales-Order Details","tab12_MyOrders":"My Orders Details","tab13_Logout":"Logout","signUp_title":"Sales Representative Sign Up","signUp_subTitle":"Please fill in this form to sign up as a sales rep and get access to all Sales Team features.","signUp_content1":"Email","signUp_content2":"First Name","signUp_content3":"Last Name","signUp_content4":"Phone Number","signUp_content5":"Facebook Handle","signUp_content6":"Twitter Handle","signUp_content7":"Instagram Handle","signUp_content8":"Upload Profile Picture","signUp_socialmedialable1":"Social Media Links","signUp_socialmedialable2":"optional","signUp_uploadBtn":"Choose File","signUp_uploadBtnPlaceHolder":"No file chosen","signUp_button3":"Saving Details...","signUp_welcomemsg1":"Hello","signUp_welcomemsg2":"sign up sales rep and get a commission on sales made by reps under you","signUp_emailerror":"Please enter Email","signUp_Fnameerror":"Please enter First Name","signUp_lnameerror":"Please enter Last Name","signUp_phnumbererror":"Please enter Phone Number","signUp_successmsg":"Your request has been successfully registered, you will soon receive account activation E-mail once our admin approves your request.","signUp_errorsmsg":"Error while saving the details. This user email may already have an account on the store.","signUp_RepExistErrorMsg":"This email is already registered as a rep.","addingRep_selectRepsLabel1":"Who helped you?","addingRep_NoSalesRep":"No Sales Rep","addingRep_successMsg":"Added repId to cart note","addingRep_selectRepsLabel2":"Please select an item in the list.","wholesaleOrder_WholesaleDiscountTableColumn1":"Product Title","wholesaleOrder_WholesaleDiscountTableColumn2":"Discount","customerInvoice_ViewClientOrdersColumn1":"Customer Name","customerInvoice_ViewClientOrdersColumn2":"Product Title","customerInvoice_ViewClientOrdersColumn3":"Subtotal Price","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Invoice","salesRep_order_errorMsg":"Error during creating your order.Please contact support","salesRep_order_successMsg":"Order Invoice created successfully!  Invoice has been emailed to Customer!","salesRep_order_errorMsg2":"Error during creating your order.Please contact support","customedraft_btn1":"Create New Invoice","customedraft_btn2":"No Products Selected. Please select products and try again.","customedraft_btn3":"Creating Order...","customedraft_btn4":"Create New Invoice","salesRep_order_NoProductSelected":"No Products Selected. Please select products and try again.","productnotselectforcartsharingtxt1":"No Products Selected. Please select products and try again.","discountCoupons_tblColumn1":"Coupon Code","discountCoupons_tblColumn2":"Coupon Discount","discountCoupons_tblColumn3":"Delete Coupon Code","discountedPriceLabel":"Your Discounted Price:","couponCodeNotSet":"Coupon Code Not Set","dashboard_subTitle2":"Current Month cycle: 5th - 4th","affiliatelink_commissiononlbl":"Product","displaycommission_lbl1":"Product Type","displaycommission_lbl2":"Sales Rep","displaycommission_lbl3":"Quantity Based Discount","discountcommissiononlbl1":"Client Discount Tiers","clientInvoiceCommissionTablecolumn1":"Product Type","clientInvoiceCommissionTablecolumn2":"Commission","clientInvoiceCommissionTablecolumn3":"Product Title","clientInvoiceCommissionTablecolumn4":"SalesRep Name","clientInvoiceQuantityBaseDiscountTablecolumn1":"Product Name","clientInvoiceQuantityBaseDiscountTablecolumn2":"Discount","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantity","affiliateCartProdtableColumn1":"Product","affiliateCartProdtableColumn2":"Product Title","affiliateCartProdtableColumn3":"Price","affiliateCartProdtableColumn4":"Commission","affiliateCartProdtableColumn5":"Affiliate Link","affiliateCartProdtableColumn6":"Share Link","productnotselectforcartsharinglbl1":"Please Enter Cart Name","productnotselectforcartsharinglbl2":"No Products Selected. Please select products and try again.","productnotselectforcartsharinglbl3":"Wait While Processing...","showSharedCartProductcolumn1":"Cart Link","showSharedCartProductcolumn3":"Remove Cart","onSuccessInvoiceSuccessMsg":"Invoice Sent Successfully","onSuccessInvoiceFailedMsg":"Invoice Sending Failed","sendInvoice_successMsg":"Invoice Sent Successfully","deleteInvoice_successMsg":"Invoice deleted Successfully","deleteInvoice_FailedMsg":"Delete Invoice Failed","deleteInvoice_btnlbl":"Deleting Invoice","deleteSharedCartLink_successMsg":"Link Deleted Successfully","deleteSharedCartLink_FailedMsg":"Error in deleting link. Please try again..","deleteSharedCartLink_btnlbl":"Deleting Link","viewInvoiceOrders_btntxt1":"Getting...","viewInvoiceOrders_btntxt2":"View Previous Orders","createCoupon_btnlbl1":"Creating Coupon..","createCoupon_btnlbl2":"Coupon Created","deleteCoupon_successMsg":"Coupon Deleted","deleteCoupon_FailedMsg":"Coupon deleting Failed","deleteCoupon_btnlbl":"Deleting...","viewProductModelColumn1":"Product","viewProductModelColumn2":"Title","viewProductModelColumn3":"Quantity","viewProductModelColumn4":"Refunded Amount","viewProductModelColumn5":"Item Price","viewProductModelColumn6":"Disc. Price","viewProductModelColumn7":"Tracking Number","viewProductModelColumn8":"Ship Date","viewProductModelColumn9":"Total Price","showSharedCartProducts_column2":"Image","showSharedCartProducts_column3":"Add Quantity","showSharedCartProducts_column4":"Title","showSharedCartProducts_column5":"Variant Title","showSharedCartProducts_column6":"Price","viewClientOrders_btn1":"View","viewClientOrders_btn2":"Send","viewClientOrders_btn3":"Delete","showCouponTable_txt1":"Getting...","showCoupon_btn2":"View Coupons","showCoupon_btn1":"Copied","affliateOrder_column1":"Customer Name","affliateOrder_column2":"Customer Email","affliateOrder_column3":"Product Title","affliateOrder_column4":"Order Date","affliateOrder_column5":"Subtotal","affliateOrder_column6":"Commission","affliateOrder_btn1":"Getting...","affliateOrder_btn2":"View Affiliate Orders","affliateOrder_btn3":"View Affiliate Orders","yourBio_btn1":"Save","yourBio_btn2":"Save","yourBio_Uploadbtn1":"Uploading...","yourBio_Uploadbtn2":"Uploaded","yourBio_UploadbtnError":"Sorry, Try Again","yourBio_Savebtn":"Saving..","team_txt1":"Saving..","team_txt2":"Save","viewRepClientOrdersDetails_column1":"Order Number","viewRepClientOrdersDetails_column2":"Order Date","viewRepClientOrdersDetails_column3":"Subtotal","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Product Details","addSalesRep_txt1":"Add SalesRep","addSalesRep_txt2":"Adding SalesRep...","discountCoupons_header":"One Time Discount Coupon","discountCoupons_nodiscountcoupon":"You have not created any Discount Coupon","discountCoupons_deleteBtn":"Delete","discountCoupons_BackBtn":"Back","customerInvoice_selectcustomererror":"Please Select Customer and then add product","createOrderFromCartPage_selectCustomersLabel":"SELECT CUSTOMER","createOrderFromCartPage_selectCustomerAddressLabel":"SHIPPING ADDRESS","createOrderFromCartPage_selectCustomersLabelForDropDown":" Select Customer","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Select Address","createOrderFromCartPage_successMsg":"Order Invoice created successfully! Invoice has been emailed to Customer!","createOrderFromCartPage_toggleButton":"Add New Shipping Address","createOrderFromCartPage_AddNewAddressTitle":"ADD NEW ADDRESS","createOrderFromCartPage_customer_errorMsg1":"No Customer Selected. Please select customer and try again.","createOrderFromCartPage_order_errorMsg1":"No Products Selected. Please select products and try again.","createOrderFromCartPage_Address_errorMsg2":"Please select Address and try again.","createOrderFromCartPage_Address_errorMsg3":"Please fill all address fields.","createOrderFromCartPage_Order_errorMsg2":"Error during creating your order.Please contact support","createOrderFromCartPage_draftOrderButton":"CREATE DRAFT ORDER","createOrderFromCartPage_OrderButton":"CREATE ORDER","createOrderFromCartPage_draftOrderButtonText2":"CREATING ORDER...","createOrderFromCartPage_selectShippingCostTitle":"SHIPPING COST","createOrderFromCartPage_selectShippingCost":"Select Shipping Cost","createOrderFromCartPage_Address_errorMsg4":"There was a problem calculating your shipping rates.","createOrderFromCartPage_Address_errorMsg5":"Something went wrong please try again.","yourSales_tabHeading3":"Refund Orders","refundOrders_column1":"Refund Id","refundOrders_column2":"Order Date","refundOrders_column3":"Order No.","refundOrders_column4":"Order Name","refundOrders_column5":"Commission","refundOrders_column6":"Team Manager Commission","refundOrders_column7":"Team Manager Id","refundOrders_column8":"Refund SubTotal","refundOrders_column9":"Order Status","refundOrders_column10":"Order Type","refundOrderNumber_title":"Refund Order Details","refundOrderNumber_column1":"Name","refundOrderNumber_column2":"Date","refundOrderNumber_column3":"Quantity","refundOrderNumber_column4":"Discount Price","refundOrderNumber_column5":"SubTotal","tableDataError":"No refund order","dashboard_subTitle3":"Commission Details","dashboard_cardHeading5_1":"Commission on","dashboard_cardHeading5_2":"You will get a ","dashboard_cardHeading5_3":"commission on all orders.","dashboard_cardHeading5_4":"You will get a commission based on products you sell","dashboard_cardHeading5_5":"You will get a commission based on product Types","Profit_Margin":"Profit Margin","Product_Type":"Product Type","Sales_Rep":"Sales Rep","show_commission_list":"Show Commission List","commission_list":"Commission List","no_link_to_show":"No Link to show","no_customers_to_show":"No Customers to show","no_sales_to_show":"No Sales to show","no_draft_to_show":"No Draft to show","no_refund_to_show":"No Refund to show","no_orders_to_show":"No Orders to show","customerInvoice_ViewClientOrdersColumn6":"Order Number","customerInvoice_ViewClientOrdersColumn7":"Order Date","Error_commissions_NotUpdated":"Commissions are not updated","sales_chart_msg1":"We need data...","sales_chart_msg2":"Looks like we do not have any data to show yet.","page_refresh_msg":"click to refresh","variant_title":"Variant Title","line_items_properties":"Properties","customer_country":"Customer Country","customer_state":"Customer State","company_country":"Company Country","company_state":"Company State","client_orders":"Client Orders","no_product_details":"No products details to show","submit_btn_text":"Submit","submitting_btn_text":"Submitting","submitted_btn_text":"Submitted","email_id_validation_errmsg":"Please enter valid Email Id","customerInvoice_add_more_details":"Add More Details","customerInvoice_add_shipping_address":"Add New Shipping Address","customerInvoice_HideDetails":"Hide Details","customerInvoice_HideAddress":"Hide Shipping Address","customerInvoice_enterFirstName":"Enter First Name","customerInvoice_enterFirstNamePlaceholder":"First Name","customerInvoice_enterLastName":"Enter Last Name","customerInvoice_enterLastNamePlaceholder":"Last Name","customerInvoice_enterAddress1":"Enter Address Line 1","customerInvoice_enterAddress1Placeholder":"Address Line 1","customerInvoice_enterAddress2":"Enter Address Line 2","customerInvoice_enterAddress2Placeholder":"Address Line 2","customerInvoice_enterCity":"Enter City","customerInvoice_enterCityPlaceholder":"City","customerInvoice_selectCountry":"Select Country","customerInvoice_selectState":"Select State","customerInvoice_enterZipNumber":"Enter Zip Code","customerInvoice_enterZipNumberPlaceholder":"Zip Code","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Product Not Available","customerInvoice_SendInvoiceBtn":"Send Invoice","customerInvoice_CreateOrderBtn":"Create Order","customerInvoice_ProductTableColumnSubTotal":"Sub Total","customerInvoice_SelectShippingAddress":"Select Shipping Address","customerInvoice_ProductsSearchBy_Placeholder":"Search Products by Name, SKU, Price","customerInvoice_AddMoreProducts_Btn":"Add More Products","customerInvoice_RequiredErrorMsg":"This field is required.","customerInvoice_EmailSuggestionErrorMsg":"Please add valid email id","customerInvoice_MobileSuggestionErrorMsg":"Please add valid phone no","customerInvoice_ErrorMsgAddShippingAddress":"Please fill Shipping Address","customerInvoice_Creating_Msg":"Creating...","customerInvoice_Sending_Msg":"Sending...","customerInvoice_OrderCreatedSuccessfullyMsg":"Order Created Successfully","customerInvoice_InvoiceSentSuccessfullyMsg":"Invoice Sent Successfully to Customer","customerInvoice_ErrorMsgTryAgain":"Error..please Try Again","customerInvoice_Selected_Btn":"Selected","customerInvoice_ProductTableQuantityUpdate_Btn":"Please Select Product","customerInvoice_OrderSubTotal":"Order SubTotal","delete_confirmation_text":"Are you sure ?","draftOrder_OrderNumber":"Order Number","draftOrder_CustName":"Customer Name","draftOrder_OrderDate":"Order Date","draftOrder_SubTotal":"Sub Total","draftOrder_Status":"Status","draftOrder_Invoice":"Invoice","draftOrder_DraftId":" Draft Id","draftOrder_ShippingCost":"Shipping Cost","draftOrder_Tax":"Tax","draftOrder_TotalPrice":"Total Price","draftOrder_Note":"Note","draftOrder_Product":"Product","draftOrder_ProductName":"Product Name","draftOrder_Size":"Size","draftOrder_Quantity":"Quantity","draftOrder_Price":"Price","noDraftOrderProducts":"No Draft Order Product Details Available.","noRefundOrderProduct":"No Refund Order Product Details Available.","loading":"Loading...","dashboard_commissionOn_profitMargin":"Commission on Profit Margin","dashboard_clientInvoice":"Client Invoice","dashboard_affiliateLink":"Affiliate Order","dashboard_returnCustomer":"Return Customer","dashboard_discountCoupon":"Discount Coupon","dashboard_SharedCart":"Shared Cart","dashboard_AdminTaggedOrders":"Admin Tagged Order","dashboard_no_data":"No Data Available","dashboard_sales_of_last_six_months":"Sales of Last 6 Months","dashboard_sales_of_current_month":"Sales of Current Month","addCustomer_ErrorMsgOnSubmitBtn":"Please enter a valid phone number","login_welcome_Msg":"Welcome to Sales Team","login_title":"Login","login_email":"Email Id","login_password":"Password","emailValidation_ErrorMsg":"Please enter valid Email Id","login_newUser":"New User?","login_SignUp":"Sign Up","login_forgotPassword_link":"Forgot Password?","login_LogInBtn":"Log In","login_sliderContent_1":"Reps Placing order behalf of clients","login_sliderContent_2":"Rep\'s driving traffic to store","login_sliderContent_3":"Rep’s marketing products using social media platforms","login_sliderContent_4":"Rep can buy in bulk and make profit","login_sliderContent_5":"Reps Placing order behalf of clients","login_sliderContent_6":"Reps can visit customers in person and create orders","required_ErrorMsg":"Please fill required field","signup_title":"Sign Up","signup_BackTo_login":"Back to Login","signup_firstName":"First Name","signup_lastName":"Last Name","signup_BackBtn":"Back","signup_NextBtn":"Next","signup_phone_number":"Phone Number","signup_phone_number_Error":"Please enter atleast 10 digits","signup_uploadPicture":"Upload Profile Picture","signup_fileSizeError":"File size is larger than 5MB","signup_filePath_lable":"Selected File","signup_MediaTitle2":"Social Media Links","signup_facebookHandle":"Facebook Handle","signup_InstaHandle":"Instagram Handle","signup_SaveBtn":"Save Details","forgotPwd_title":"Forgot Password","forgotPwd_ResetBtn":"Reset Password","forgotPwd_SuccessMsg":"Your request for Reset Password is successful, We have sent the new password to your registered Email id.","customerInvoice_selectShippingCost":"Select Shipping Cost","customerInvoice_CalculatingShippingRates_Msg":"Calculating...","customerInvoice_AddShippingAddress_Msg":"Select Address or Add Shipping Address ","customerInvoice_PleaseSetAnyShippingAddressMsg":"Please select any one shipping address","customerInvoice_ShippingCostErrorMsg":"Please Add New Shipping Address,because the address has insufficient information.","customerInvoice_CalculateShippingCost_Btn":"Calculate Shipping Cost","customerInvoice_ShippingCostAddOrNot_Msg":"Would you like to add Shipping cost?","customerInvoice_ShippingCostAddOrNot_Yes":"Yes","customerInvoice_ShippingCostAddOrNot_No":"No","shop_utterly_conkers_ShippingCostCompulsory_ErrorMsg":"Not placed your order unless and until add Shipping Cost","shop_utterly_conkers_AddMoreProducts__ErrorMsg":"Please add more products to calculate Shipping Cost","customerInvoice_ShippingCostIsUnavailable":"Shipping cost for this address is not set from the admin side. Although, order can be placed without calculating the shipping cost.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Please try again","dashboard_BannerMsg":"Graphs are updated every 8 hours","yourSales__BannerMsg":"Order details are updated every 5 mins","customerInvoice_FirstNameErrorMsg":"Please enter first name","customerInvoice_lastNameErrorMsg":"Please enter last name","customerInvoice_Add1ErrorMsg":"Please enter address line 1","customerInvoice_CountryErrorMsg":"Please select country","customerInvoice_StateErrorMsg":"Please select state","customerInvoice_CityErrorMsg":"Please enter city name","customerInvoice_ZipErrorMsg":"Please enter zip code","uploadImage":"Upload Image","dashboard_CardTitle1":"Commission on all orders","dashboard_CardTitle3":"Total Commission","dashboard_CardTitle4":"Total Sales","dashboard_TotalAvg_Ticket_Size":"Avg ticket size","dashboard_TotalRevenue":"Total Revenue","profile_Change_Password":"Change Password","dashboard_Information_Message":"Commission is tracked only for paid orders","resetPassword_validation_Msg":"This field is required","resetPassword_validation_Msg2":"Password should contain minimum 8 characters,1 uppercase,1 lowercase,1 digit etc.","resetPassword_validation_Msg3":"Confirm password should match with New password","dashbord_Msg_New":"How It Works","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Maximum Discount is not configured. Please contact site Admin.","discount_couponErrorMsg2":"Commission is not configured. Please contact site Admin.","dashbord_profile_pic":"Change Profile Pic","Performance_Details":"Performance Details","Show_Performance_Details":"Show Performance Details","Dashboard_Month":"Month","Dashboard_Orders_Total":"Total Orders","Dashboard_Total_Sale":"Total Sale","Dashboard_Commission":"Commission","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Please add customer address.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Please click on calculate shipping cost button and select one.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Cart not updated, please refresh and retry.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Please select product.","customerInvoice_CreatingDraft_Msg":"Draft Creating..","customerInvoice_DraftOrderBtn":"Draft Order","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Draft Order Created Successfully","productTable_error_AlertMsg":"Quantity can not be 0 Or Less, Please Enter Some Valid Value","productTable_error_AlertMsg2":"Please Enter Quantity","click_to_copy":"Click  to copy","discount_code_copy_coupon":"Copy Coupon","createOrder_productSearchGuide":"Not able to find products?","soldOut":"Sold Out","InventoryNotTracked":"Inventory not tracked","productStatus":"Product Status","makeSureInShopify":"Make sure in Shopify","products":"Products","sectionTheProductStatusIs":"section, the product status is","active":"Active","productsMayBeSoldOutPleaseCheck":"Products may be sold out,please check and select","Credit_Limit_Error_Msg":"Credit limit exceeds, please try again..!"}'
        ),
        Pt = JSON.parse(
          '{"dashboard_title":"TABLERO","dashboard_welcomeMsg":"Bienvenido a","dashboard_morningMsg":"Buenos días","dashboard_afternoonMsg":"Buenas tardes","dashboard_eveningMsg":"Buena noches","dashboard_subTitle1":"MES ACTUAL","dashboard_block1Heading":"FACTURA DEL CLIENTE","dashboard_block1Header1":"GANANCIAS","dashboard_block1Header2":"FACTURA ENVIADA","dashboard_block1Header3":"FACTURA PAGADA","dashboard_block2Heading":"PEDIDOS AL POR MAYOR","dashboard_block2Header1":"GANANCIAS","dashboard_block2Header2":"FACTURA ENVIADA","dashboard_block2Header3":"FACTURA PAGADA","dashboard_block3Heading":"ÓRDENES DE AFILIADOS","dashboard_block3Header1":"GANANCIAS","dashboard_block3Header2":"PEDIDOS PAGADOS","dashboard_block4Heading":"CUPÓN DE DESCUENTO","dashboard_block4Header1":"GANANCIAS","dashboard_block4Header2":"PEDIDOS PAGADOS","dashboard_block5Heading":"COMISION CLIENTE","dashboard_block5Header1":"COMISIÓN","dashboard_block5Header2":"PEDIDOS","dashboard_block6Heading":"TEAM LEAD COMMISSION","dashboard_block6Header1":"COMISIÓN","dashboard_block7Heading":"POS COMMISSION","dashboard_block7Header1":"COMISIÓN","dashboard_block7Header2":"PEDIDOS","dashboard_tbl1column1":"Mes","dashboard_tbl1column2":"Órdenes de factura de cliente","dashboard_tbl1column3":"Comisión de factura del cliente","dashboard_tbl1column4":"Pedidos al por mayor","dashboard_tbl1column5":"Compra total al por mayor","dashboard_tbl1column6":"Órdenes de afiliados","dashboard_tbl1column7":"Comisión de afiliados","dashboard_tbl1column8":"Órdenes de código de cupón","dashboard_tbl1column9":"Comisión de código de cupón","dashboard_tbl1column10":"Pedidos de los clientes","dashboard_tbl1column11":"Comisión de cliente","dashboard_tbl1column12":"Órdenes POS","dashboard_tbl1column13":"Comisión POS","dashboar_cardHeading1":"Orden total","dashboar_cardHeading2":"Comisión","dashboar_cardHeading3":"Ventas","dashboar_cardHeading4":"Bonificación","dashboard_graphHeading1":"Rendimiento de ventas de los últimos seis meses","dashboard_graphHeading2":"Analice el orden y la comisión de las funciones para el mes actual","Graph_Sales_noorderstitle":"sin orden","Graph_SalesRepCommission_nocommissiontitle":"No hay datos de comisión para mostrar","Graph_SalesRepOrders_title":"Pedidos","Graph_SalesRep_XAxisTitle_ForMonth":"6 meses","Graph_SalesRepOrders_YAxisTitle":"Pedidos","Graph_SalesRepSales_title":"VENTAS","Graph_SalesRepCommission_title":"COMISIÓN","Graph_SalesRepCommissions_YAxisTitle":"Comisión","Graph_FeatureWiseOrder_title":"Órdenes vs característica","Graph_featureWiseCommission_title":"Comisión vs característica","Graph_FeatureWiseOrder_XAxisTitle":"Característica","Graph_FeatureWiseOrder_YAxisTitle":"Pedidos","Graph_FeatureWiseCommission_title":"COMISIÓN","Graph_FeatureWiseCommission_YAxisTitle":"Comisión","customerInvoice_title":"Crear orden","customerInvoice_button":"atrás","customerInvoice_noclientorderMsg":"Sin pedidos de factura de cliente","customerInvoice_button1":"Ver pedidos anteriores","customerInvoice_contentHeading1":"Descuento y comisión en","customerInvoice_table1column1":"tipo de producto","customerInvoice_table1column2":"Comisión","customerInvoice_table1column3":"Nombre de descuento","customerInvoice_table1column4":"Descuento","customerInvoice_contentHeading2":"Agregue los detalles del cliente y seleccione los productos para enviar la factura","customerInvoice_contentHeading2Title1":"Entrar/Buscar Cliente","customerInvoice_title1Placeholder":"Entrar/Buscar Cliente","customerInvoice_contentHeading2Title2":"Ingrese el ID de correo electrónico del cliente","customerInvoice_title2Placeholder":"Dirección de correo electrónico","customerInvoice_contentHeading2Title3":"Ingresar notas de pedido","customerInvoice_contentHeading2Title4":"Dirección del cliente","customerInvoice_contentHeading2Title5":"Número de móvil del cliente","customerInvoice_contentHeading2Title6":"Nota del cliente","customerInvoice_contentHeading2Title7":"Nombre de la empresa del cliente","customerInvoice_title7Placeholder":"nombre de empresa","customerInvoice_Placeholder_contentHeading2Title6":"Nota","customerInvoice_Placeholder_contentHeading2Title5":"Número de teléfono móvil","customerInvoice_Placeholder_contentHeading2Title4":"Dirección de Envío","customerInvoice_title3Placeholder":"pedidos","customerInvoice_SearchProducts_Label":"Buscar Productos","customerInvoice_table2Column1":"Imagen","customerInvoice_table2Column2":"Agregar cantidad","customerInvoice_table2Column3":"Título","customerInvoice_table2Column4":"Título de la variante","customerInvoice_ProductTableColumnPrice":"Precio","customerInvoice_ProductTableColumnWholeSalePrice":"Precio al por mayor","customerInvoice_button2":"Crear factura","customerInvoice_ProductTableColumnProduct":"Producto","customerInvoice_table3Column2":"nombre del producto","customerInvoice_table3Column3":"Talla","customerInvoice_ProductTableColumnQuantity":"Cantidad","customerInvoice_table3Column5":"Precio del articulo","customerInvoice_table3Column6":"Precio total","customerInvoice_table3Column7":"Precio con descuento para el cliente","customerInvoice_table3Column8":"Comisión SalesRep","customerInvoice_table3Column9":"Tipo de descuento","customerInvoice_repproInvite":"Seleccione la casilla de verificación para enviar una invitación profesional","customerInvoice_customerOrder_error1":"todos los campos del cliente son obligatorios. Ingrese el correo electrónico y el nombre del cliente","customerInvoice_productAddedMsg":"Producto añadido","customerInvoice_AlertErrorMsg":"Error... ¡Por favor, póngase en contacto con el soporte!","wholesaleOrder_title":"Orden al por mayor","wholesaleOrder_contentHeading1":"Puede comprar productos a precios especiales al por mayor","wholesaleOrder_contentHeading2":"Descuento en","wholesaleOrder_column1":"SalesRep Name","wholesaleOrder_column2":"Descuento","wholesaleOrder_searchtxtPlaceholder":"Buscar producto","wholesaleOrder_table1Column1":"Imagen","wholesaleOrder_table1Column2":"Agregar cantidad","wholesaleOrder_table1Column3":"Título","wholesaleOrder_table1Column4":"Título de la variante","wholesaleOrder_table1Column5":"Precio","wholesaleOrder_button":"Echa un vistazo","wholesaleOrder_Order_btn":"Mostrar / Ocultar precios por volumen","wholesaleOrder_contentHeading3":"Precio total","wholesaleOrder_contentHeading4":"Su precio con descuento","wholesaleOrder_table2Column1":"Producto","wholesaleOrder_table2Column2":"nombre del producto","wholesaleOrder_table2Column3":"Talla","wholesaleOrder_table2Column4":"Cantidad","wholesaleOrder_table2Column5":"Precio del articulo","wholesaleOrder_table2Column6":"Precio total","wholesaleOrder_table2Column7":"Su precio con descuento","affiliateLink_title":"Enlace de afiliado","affiliate_product_link":"Enlace de productos","affiliateLink_input_error_msg":"El campo de texto del enlace es obligatorio y no debe contener espacios.","affiliateLink_contentHeading1":"Comparta su enlace de afiliado en las redes sociales y el correo electrónico. Obtendrá una comisión de afiliado por cada pedido de su enlace de afiliado","affiliateLink_contentHeading2":"Tu enlace de afiliado","affiliateLink_contentHeading3":"Comisión en","affiliateLink_content_Message1":"Busque productos y comparta el enlace de productos individuales con sus clientes.","affiliateLink_noaffiliateorderMsg":"Sin pedidos de afiliados","affiliateLink_column1":"SalesRep Name","affiliateLink_column2":"Comisión","affiliateLink_searchtxtPlaceholder":"Buscar producto","affiliateLink_searchColumn1":"Producto","affiliateLink_searchColumn2":"Titulo del producto","affiliateLink_searchColumn3":"Precio","affiliateLink_searchColumn4":"Comisión","affiliateLink_searchColumn5":"Enlace de afiliado","affiliateLink_searchColumn7":"Copiar link","affiliateLink_searchColumn8":"copiada","affiliateLink_backbtn":"atrás","affiliateLink_card_Title":"Tarjeta de contacto y enlace de afiliado","cartSharing_title":"Compartir carro","cartSharing_CreateCartInformation_Text":"Para crear un carrito personalizado para compartir, agregue productos al carrito desde la tienda.Estos productos se mostrarán en esta página","cartSharing_content2Placeholder":"Nombre del carrito","cartSharing_table2Column2":"nombre del producto","cartSharing_table2Column3":"Talla","cartSharing_table2Column6":"Precio total","cartSharing_SharedCartLinkTableColumnCartName":"Nombre del carrito","cartSharing_SharedCartLinkTableColumnLink":"Enlace","cartSharing_SharedCartLinkTableColumnCartLink":"Enlace de carrito compartible","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copiar enlace del carrito","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Eliminar enlace del carrito","cartSharing_EnterCartName_Label":"Ingrese el nombre del carrito","cartSharing_ProductTableColumnProduct":"Producto","cartSharing_ProductTableColumnQuantity":"Cantidad","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Precio del articulo","cartSharing_CartCreating_Msg":"Creando...","cartSharing_Copied_Msg":"Copiada!!","cartSharing_SharedCartLinkTableEmpty_Msg":"Sin enlace para mostrar","cartSharing_CartCreatedSuccessfully_Msg":"Carrito creado con éxito","cartSharing_CartCreateError_Msg":"Error... Inténtalo de nuevo","cartSharing_AlertError_Msg":"Error... ¡Por favor, póngase en contacto con el soporte!","cartSharing_CopyCartLink_Msg":"Copiar enlace del carrito","cartSharing_DeleteCartLink_Msg":"Eliminar enlace del carrito","cartSharing_DeleteConfirmation_Msg":"Estas segura","cartSharing_ProductTableEmpty_Msg":"Producto no disponible","cartSharing_CreateCart_Btn":"Crear carrito","cartSharing_ProductTableQuantityUpdate_Btn":"Seleccione el producto","discountCoupon_titleOne":"Cupón de descuento","discountCoupon_contentHeading1":"Comparta el código de cupón de descuento con sus clientes y cada vez que se use su cupón, obtendrá una comisión.","discountCoupon_contentHeading2":"Su código de cupón es","discountCoupon_contentHeading3":"Importe de descuento","discountCoupon_contentHeading4":"Comisión","discountCoupon_contentHeading4PlaceHolder1":"Oye, usa mi código de cupón de descuento","discountCoupon_contentHeading4PlaceHolder2":"y obtén productos con descuento","discountCoupon_button1":"Copiar texto","cartSharing_copiedButtonText":"Copiado","discountCoupon_titleTwo":"Cree cupones de descuento de un solo uso para los clientes","discountCoupon_button2":"Ver cupones","discountCoupon_contentHeading5":"Descuento máximo permitido","discountCoupon_contentHeading6":"Comisión","discountCoupon_contentHeading7":"Introduce el código de cupón","discountCoupon_contentHeading7PlaceHolder":"Ingrese el código del cupón","discountCoupon_contentHeading8":"Ingrese descuento","discountCoupon_contentHeading8PlaceHolder":"El descuento no debe ser mayor que el descuento máximo.","discountCoupon_button3":"Crear cupón","discountCoupon_coupon_error1":"Ingrese el código del cupón y el descuento","yourBio_title":"Tu tarjeta de contacto","yourBio_content1":"Subir perfil","yourBio_button1":"Elija el archivo","yourBio_button1PlaceHolder":"Ningún archivo elegido","yourBio_error_image_size":"El tamaño de la imagen es demasiado grande, cargue una imagen de menos de 5 MB. Inténtalo de nuevo.","yourBio_button2":"Subir","yourBio_content2":"Ingrese una palabra personalizada para crear su enlace de afiliado único","yourBio_content2PlaceHolder":"crea tu enlace de afiliado único","yourBio_content4":"Cuando se utilice su enlace, su tarjeta de contacto aparecerá en el sitio web","yourBio_content3":"Ingrese su tarjeta de contacto","yourBio_content3PlaceHolder":"Ingrese 100 palabras","yourBio_button3":"Salvar","yourBio_button4":"Salvado","yourBio_error_link":"Este enlace único se puede tomar. Pruebe con un enlace único diferente.","yourBio_Linksuccessmsg":"Enlace único guardado con éxito.","team_title1":"Agregar SalesRep","team_content1":"Ingrese correo electrónico","team_content1PlaceHolder":"Dirección de correo electrónico","team_emailerrorMsg":"Por favor ingrese correo electrónico","team_content2":"Ingrese el nombre","team_content2PlaceHolder":"Primer nombre","team_fnameerrorMsg":"Por favor ingrese su nombre","team_content3":"Introduzca el apellido","team_content3PlaceHolder":"Apellido","team_button1":"Añadir","team_successmsg":"¡Agregado exitosamente! Consulte su correo electrónico para obtener las instrucciones de activación.","team_errorsmsg":"Error al agregar. Es posible que este correo electrónico de usuario ya tenga una cuenta en la tienda","team_title2":"Detalles del equipo","team_content4":"Página de registro","team_NoTeamDetailsMsg":"Sin detalles del equipo","team_content5":"Seleccione SalesRep","team_tableTitle":"DETALLES DEL PEDIDO DE LOS ÚLTIMOS DOS MESES","team_column1":"Número de orden","team_column2":"Fecha de orden","team_column3":"Nombre del cliente","team_column4":"Representante de ventas","team_column5":"Total parcial","team_column6":"Comisión de representante de ventas","team_column7":"Comisión de Team Manager","team_column8":"Tipo de comisión","addCustomer_title":"Agregar cliente","addCustomer_content1":"Ingrese el nombre del cliente","addCustomer_txt1Placeholder":"Primer nombre","addCustomer_content2":"Ingrese el apellido del cliente","addCustomer_content2Placeholder":"Apellido","addCustomer_content3":"Ingrese el ID de correo electrónico del cliente","addCustomer_content3Placeholder":"Dirección de correo electrónico","addCustomer_content4":"Nota","addCustomer_content4Placeholder":"Nota","addCustomer_customerAddress":"Dirección personal","addCustomer_customerCity":"Ciudad","addCustomer_customerCityPlaceholder":"Ciudad","addCustomer_customerCountry":"País","addCustomer_customerState":"Estado","addCustomer_customerZipCode":"Código postal","addCustomer_companyName":"nombre de empresa","addCustomer_companyAddress":"Dirección de la empresa","addCustomer_companyCity":"Ciudad","addCustomer_companyCountry":"País","addCustomer_companyState":"Estado","addCustomer_companyZipCode":"Código postal","addCustomer_button":"Salvar","addCustomer_leadsuccessmsg":"El cliente se agrega con éxito.","addCustomer_leadErrrorMsg":"Error al guardar los detalles.","addCustomer_leadEmptyErrrorMsg":"Por favor complete el campo requerido.","addCustomer_leadsuccessmsg2":"Cliente creado y etiquetado con éxito a un representante de ventas.","addCustomer_leadErrrorMsg2":"Este cliente ya está etiquetado con un representante.","myCustomers_title":"Tus clientes","myCustomers_table1Column1":"Nombre","myCustomers_table1Column2":"nombre de empresa","myCustomers_table1Column3":"Email","myCustomers_table1Column4":"Pedidos","myCustomers_table1Column5":"Total gastado","myCustomers_table2Title":"DETALLES DEL CLIENTE","myCustomers_table3Title":"DETALLES DEL PROYECTO DE PEDIDO","myCustomers_table3Column1":"Nombre del producto","myCustomers_table3Column2":"Tamaño","myCustomers_table3Column3":"Cantidad","myCustomers_table3Column4":"Precio","myCustomers_table3Column5":"Estado","myCustomers_table3Column6":"Total parcial","myCustomers_table2Row1":"Nombre","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Habla a","myCustomers_table2Row4":"nombre de empresa","myCustomers_table2Row5":"Notas de clientes","myCustomers_table2Row6":"Total gastado (subtotal + impuestos)","myCustomers_table2Row7":"Numero de ordenes","myCustomers_table2Row8":"Etiquetas","myCustomers_radioButton0":"Mostrar todos los clientes","myCustomers_radioButton1":"Buscar por nombre","myCustomers_radioButton2":"Buscar por empresa","myCustomers_radioButtonError1":"Seleccione el tipo de búsqueda e ingrese el valor para buscar","myCustomers_radioButtonError2":"Ingrese un valor para buscar","myCustomers_radioButtonError3":"Seleccione el tipo de búsqueda","myCustomers_searchButton":"Buscar","myCustomers_Placeholder1":"Escriba el nombre del cliente o el nombre de la empresa para buscar","myCustomers_NoOrdersError":"Sin pedidos","myCustomer_no_salesRep_details":"No hay detalles de representantes de ventas disponibles.","myCustomer_select_customer_country":"Seleccione el país del cliente","myCustomer_company_country":"País de la empresa","myCustomer_company_state":"Estado de la empresa","myCustomer_select_company_country":"Seleccione el país de la empresa","yourSales_SalesOrderDetailsTitle":"Detalles de órdenes de venta","yourSales_title":"Detalles del pedido de los últimos 2 meses","yourSales_table1Column1":"Número de orden","yourSales_table1Column2":"Fecha de orden","yourSales_table1Column3":"Nombre del cliente","yourSales_table1Column4":"Total parcial","yourSales_table1Column5":"Comisión","yourSales_table1Column6":"Tipo de comisión","yourSales_table1Column7":"Imprimir factura","printOrderInvoice_btn":"Imprimir","yourSales_tableTitle":"DETALLES DE PRODUCTO","yourSalesDraft_tableTitle":"DETALLES DEL PROYECTO DE PEDIDO","yourSales_column1":"Producto","yourSales_column2":"Título","yourSales_column3":"Cantidad","yourSales_column4":"Precio del articulo","yourSales_column5":"El número de rastreo","yourSales_column6":"Fecha de envío","yourSales_column7":"Precio total","yourSales_content1":"Total parcial","yourSales_content2":"Impuesto","yourSales_content3":"Costo de envío","yourSales_content4":"Total","yourSales_content5":"Nota","yourSales_tabHeading1":"Pedidos pagados","yourSales_tabHeading4":"Órdenes pendientes","yourSales_tabHeading2":"Borradores de pedidos","myOrders_title":"Detalles de mis pedidos","myOrdersDetails_Message":"Pedidos realizados para usted","myOrders_table1Column1":"Número de orden","myOrders_table1Column2":"Fecha de orden","myOrders_table1Column3":"Nombre del cliente","myOrders_table1Column4":"Pago","myOrders_table1Column5":"Cumplimiento","myOrders_table1Column6":"Total","myOrders_tableTitle":"DETALLES DE PRODUCTO","myOrders_table2Column1":"Producto","myOrders_table2Column2":"Título","myOrders_table2Column3":"Cantidad","myOrders_table2Column4":"Precio del articulo","myOrders_table2Column5":"El número de rastreo","myOrders_table2Column6":"Fecha de envío","myOrders_table2Column7":"Precio total","myOrders_content1":"Total parcial","myOrders_content2":"Impuesto","myOrders_content3":"Costo de envío","myOrders_content4":"Total","myOrders_content5":"Nota","myOrders_content6":"ID de borrador","tab_Dashboard":"Tablero","dashbord_Tab":"Hogar","tab_CustomerInvoice":"Crear orden","tab3_WholesaleOrder":"Orden al por mayor","tab_AffiliateLink":"Enlace de afiliado","tab_CartSharing":"Compartir carro","tab_DiscountCoupon":"Cupón de descuento","tab7_YourBio":"Tu tarjeta de contacto","tab8_Team":"Equipo","tab9_AddCustomer":"Agregar cliente","tab_MyCustomers":"Mis clientes","tab_YourSalesOrderDetails":"Detalles de su orden de venta","tab12_MyOrders":"Detalles de mis pedidos","tab13_Logout":"Cerrar sesión","signUp_title":"Registro de representante de ventas","signUp_subTitle":"Complete este formulario para registrarse como representante de ventas y obtener acceso a todas las funciones del equipo de ventas.","signUp_content1":"Email","signUp_content2":"Nombre de pila","signUp_content3":"Apellido","signUp_content4":"Número de teléfono","signUp_content5":"Mango de Facebook","signUp_content6":"Usuario de Twitter","signUp_content7":"Mango de Instagram","signUp_content8":"subir foto de perfil","signUp_socialmedialable1":"Enlaces de redes sociales","signUp_socialmedialable2":"Opcional","signUp_uploadBtn":"Elija el archivo","signUp_uploadBtnPlaceHolder":"Ningún archivo elegido","signUp_button3":"Guardando detalles ...","signUp_welcomemsg1":"Hola","signUp_welcomemsg2":"Regístrese como representante de ventas y obtenga una comisión sobre las ventas realizadas por sus representantes","signUp_emailerror":"Por favor ingrese correo electrónico","signUp_Fnameerror":"Por favor ingrese su nombre","signUp_lnameerror":"por favor, introduzca el apellido","signUp_phnumbererror":"Por favor, introduzca el número de teléfono","signUp_successmsg":"Su solicitud se ha registrado con éxito, pronto recibirá un correo electrónico de activación de cuenta una vez que nuestro administrador apruebe su solicitud. ","signUp_errorsmsg":"Error al guardar los detalles. Es posible que este correo electrónico de usuario ya tenga una cuenta en la tienda.","signUp_RepExistErrorMsg":"Este correo electrónico ya está registrado como representante.","addingRep_selectRepsLabel1":"¿Quien te ayudo?","addingRep_NoSalesRep":"Sin representante de ventas","addingRep_selectRepsLabel2":"Seleccione un elemento de la lista.","addingRep_successMsg":"RepId agregado a la nota del carrito","wholesaleOrder_WholesaleDiscountTableColumn1":"Titulo del producto","wholesaleOrder_WholesaleDiscountTableColumn2":"Descuento","customerInvoice_ViewClientOrdersColumn1":"Nombre del cliente","customerInvoice_ViewClientOrdersColumn2":"Titulo del producto","customerInvoice_ViewClientOrdersColumn3":"Precio subtotal","customerInvoice_ViewClientOrdersColumn4":"Estado","customerInvoice_ViewClientOrdersColumn5":"Factura","salesRep_order_errorMsg":"Error durante la creación de su pedido, póngase en contacto con el soporte","salesRep_order_successMsg":"¡Factura de pedido creada correctamente! La factura se ha enviado por correo electrónico al cliente.","salesRep_order_errorMsg2":"Error durante la creación de su pedido, póngase en contacto con el soporte","customedraft_btn1":"Crear nueva factura","customedraft_btn2":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","customedraft_btn3":"Creando orden ...","customedraft_btn4":"Crear nueva factura","salesRep_order_NoProductSelected":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","productnotselectforcartsharingtxt1":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","discountCoupons_tblColumn1":"Código promocional","discountCoupons_tblColumn2":"Descuento","discountCoupons_tblColumn3":"Eliminar cupón","discountedPriceLabel":"Su precio con descuento","couponCodeNotSet":"Código de cupón no establecido","dashboard_subTitle2":"Ciclo del mes actual: 5 ° - 4 °","affiliatelink_commissiononlbl":"Producto","displaycommission_lbl1":"tipo de producto","displaycommission_lbl2":"Representante de ventas","displaycommission_lbl3":"Descuento basado en cantidad","discountcommissiononlbl1":"Niveles de descuento para clientes","clientInvoiceCommissionTablecolumn1":"tipo de producto","clientInvoiceCommissionTablecolumn2":"Comisión","clientInvoiceCommissionTablecolumn3":"Titulo del producto","clientInvoiceCommissionTablecolumn4":"SalesRep Name","clientInvoiceQuantityBaseDiscountTablecolumn1":"nombre del producto","clientInvoiceQuantityBaseDiscountTablecolumn2":"Descuento","clientInvoiceQuantityBaseDiscountTablecolumn3":"Cantidad","affiliateCartProdtableColumn1":"Producto","affiliateCartProdtableColumn2":"Titulo del producto","affiliateCartProdtableColumn3":"Precio","affiliateCartProdtableColumn4":"Comisión","affiliateCartProdtableColumn5":"Enlace de afiliado","affiliateCartProdtableColumn6":"Compartir enlace","productnotselectforcartsharinglbl1":"Ingrese el nombre del carrito","productnotselectforcartsharinglbl2":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","productnotselectforcartsharinglbl3":"Espere mientras se procesa ...","showSharedCartProductcolumn1":"Enlace del carrito","showSharedCartProductcolumn3":"Quitar carrito","onSuccessInvoiceSuccessMsg":"Factura enviada correctamente","onSuccessInvoiceFailedMsg":"Error al enviar la factura","sendInvoice_successMsg":"Factura enviada con éxito","deleteInvoice_successMsg":"Factura eliminada correctamente","deleteInvoice_FailedMsg":"Error al eliminar factura","deleteInvoice_btnlbl":"Eliminar factura","deleteSharedCartLink_successMsg":"Enlace eliminado correctamente","deleteSharedCartLink_FailedMsg":"Error al eliminar el enlace. Inténtalo de nuevo..","deleteSharedCartLink_btnlbl":"Eliminando enlace","viewInvoiceOrders_btntxt1":"Consiguiendo...","viewInvoiceOrders_btntxt2":"Ver pedidos anteriores","createCoupon_btnlbl1":"Creando cupón ...","createCoupon_btnlbl2":"Cupón creado","deleteCoupon_successMsg":"Cupón eliminado","deleteCoupon_FailedMsg":"Error al eliminar el cupón","deleteCoupon_btnlbl":"Eliminando...","viewProductModelColumn1":"Producto","viewProductModelColumn2":"Título","viewProductModelColumn3":"Cantidad","viewProductModelColumn4":"Cantidad reembolsada","viewProductModelColumn5":"Precio del articulo","viewProductModelColumn6":"Precio descontado","viewProductModelColumn7":"El número de rastreo","viewProductModelColumn8":"Fecha de envío","viewProductModelColumn9":"Precio total","showSharedCartProducts_column2":"Imagen","showSharedCartProducts_column3":"Agregar cantidad","showSharedCartProducts_column4":"Título","showSharedCartProducts_column5":"Título de la variante","showSharedCartProducts_column6":"Precio","viewClientOrders_btn1":"Mirar","viewClientOrders_btn2":"Enviar","viewClientOrders_btn3":"Eliminar","showCouponTable_txt1":"Consiguiendo...","showCoupon_btn2":"Ver cupones","showCoupon_btn1":"Copiado","affliateOrder_column1":"Nombre del cliente","affliateOrder_column2":"Correo electrónico del cliente","affliateOrder_column3":"Titulo del producto","affliateOrder_column4":"Fecha de orden","affliateOrder_column5":"Total parcial","affliateOrder_column6":"Comisión","affliateOrder_btn1":"Consiguiendo...","affliateOrder_btn2":"Ver pedidos de afiliados","affliateOrder_btn3":"Ver pedidos de afiliados","yourBio_btn1":"Salvar","yourBio_btn2":"Salvar","yourBio_Uploadbtn1":"Subiendo ...","yourBio_Uploadbtn2":"Subido","yourBio_UploadbtnError":"Perdón intente de nuevo","yourBio_Savebtn":"Ahorro..","team_txt1":"Ahorro..","team_txt2":"Salvar","viewRepClientOrdersDetails_column1":"Número de orden","viewRepClientOrdersDetails_column2":"Fecha de orden","viewRepClientOrdersDetails_column3":"Total parcial","viewRepClientOrdersDetails_column4":"Estado","viewRepClientOrdersDetails_column5":"Detalles de producto","addSalesRep_txt1":"Agregar SalesRep","addSalesRep_txt2":"Añadiendo SalesRep ...","discountCoupons_header":"Cupón de descuento único","discountCoupons_nodiscountcoupon":"No ha creado ningún Cupón de descuento","discountCoupons_deleteBtn":"Borrar","discountCoupons_BackBtn":"atrás","customerInvoice_selectcustomererror":"Seleccione Cliente y luego agregue el producto","createOrderFromCartPage_selectCustomersLabel":"SELECCIONAR CLIENTE","createOrderFromCartPage_selectCustomerAddressLabel":"DIRECCIÓN DE ENVÍO","createOrderFromCartPage_selectCustomersLabelForDropDown":" Seleccionar cliente","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Seleccionar dirección","createOrderFromCartPage_successMsg":"¡Factura de pedido creada con éxito! La factura ha sido enviada por correo electrónico al cliente.","createOrderFromCartPage_toggleButton":"Añadir nueva Dirección de Envío","createOrderFromCartPage_AddNewAddressTitle":"AGREGAR NUEVA DIRECCIÓN","createOrderFromCartPage_customer_errorMsg1":"Ningún cliente seleccionado. Seleccione el cliente y vuelva a intentarlo.","createOrderFromCartPage_order_errorMsg1":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","createOrderFromCartPage_Address_errorMsg2":"Seleccione Dirección y vuelva a intentarlo.","createOrderFromCartPage_Address_errorMsg3":"Por favor complete todos los campos de dirección.","createOrderFromCartPage_Order_errorMsg2":"Error durante la creación de su pedido. Póngase en contacto con el servicio de asistencia.","createOrderFromCartPage_draftOrderButton":"CREAR BORRADOR DE PEDIDO","createOrderFromCartPage_OrderButton":"CREAR ORDEN","createOrderFromCartPage_draftOrderButtonText2":"CREANDO PEDIDO ...","createOrderFromCartPage_selectShippingCostTitle":"COSTO DE ENVÍO","createOrderFromCartPage_selectShippingCost":"Seleccione el costo de envío","createOrderFromCartPage_Address_errorMsg4":"Hubo un problema al calcular las tarifas de envío.","createOrderFromCartPage_Address_errorMsg5":"Algo salió mal. Por favor, vuelva a intentarlo.","yourSales_tabHeading3":"Órdenes de reembolso","refundOrders_column1":"Id de reembolso","refundOrders_column2":"Fecha de orden","refundOrders_column3":"Número de orden","refundOrders_column4":"Nombre de la orden","refundOrders_column5":"Comisión","refundOrders_column6":"Comisión de Team Manager","refundOrders_column7":"ID de jefe de equipo","refundOrders_column8":"Subtotal de reembolso","refundOrders_column9":"Estado de la orden","refundOrders_column10":"Tipo de orden","refundOrderNumber_title":"Detalles del pedido de reembolso","refundOrderNumber_column1":"Nombre","refundOrderNumber_column2":"Fecha","refundOrderNumber_column3":"Cantidad","refundOrderNumber_column4":"Precio de descuento","refundOrderNumber_column5":"Total parcial","tableDataError":"Sin orden de reembolso","dashboard_subTitle3":"Detalles de la comisión","dashboard_cardHeading5_1":"Comisión sobre","dashboard_cardHeading5_2":"obtendrás un","dashboard_cardHeading5_3":"comisión en todos los pedidos.","dashboard_cardHeading5_4":"Recibirás una comisión en función de los productos que vendas","dashboard_cardHeading5_5":"Obtendrá una comisión basada en los tipos de productos","Profit_Margin":"Margen de beneficio","Product_Type":"tipo de producto","Sales_Rep":"Representante de ventas","show_commission_list":"Mostrar lista de comisiones","commission_list":"Lista de comisiones","no_link_to_show":"Sin enlace para mostrar","no_customers_to_show":"No hay clientes para mostrar","no_sales_to_show":"No hay ventas para mostrar","no_draft_to_show":"No hay borrador para mostrar","no_refund_to_show":"Sin reembolso para mostrar","no_orders_to_show":"No hay pedidos para mostrar","customerInvoice_ViewClientOrdersColumn6":"Número de orden","customerInvoice_ViewClientOrdersColumn7":"Fecha de orden","Error_commissions_NotUpdated":"Las comisiones no se actualizan","sales_chart_msg1":"Necesitamos datos...","sales_chart_msg2":"Parece que todavía no tenemos ningún dato para mostrar.","page_refresh_msg":"haga clic para actualizar","variant_title":"título variante","line_items_properties":"Propiedades","customer_country":"País del cliente","customer_state":"Estado del cliente","company_country":"País de la empresa","company_state":"Estado de la empresa","client_orders":"Pedidos de clientes","no_product_details":"No hay detalles de productos para mostrar","submit_btn_text":"Entregar","submitting_btn_text":"Sumisión","submitted_btn_text":"Presentado","email_id_validation_errmsg":"Ingrese una identificación de correo electrónico válida","customerInvoice_add_more_details":"Agregar más detalles","customerInvoice_add_shipping_address":"Añadir nueva Dirección de Envío","customerInvoice_HideDetails":"Ocultar detalles","customerInvoice_HideAddress":"Ocultar dirección de envío","customerInvoice_enterFirstName":"Ingrese el nombre","customerInvoice_enterFirstNamePlaceholder":"Primer nombre","customerInvoice_enterLastName":"Introduzca el apellido","customerInvoice_enterLastNamePlaceholder":"Apellido","customerInvoice_enterAddress1":"Ingrese la línea de dirección 1","customerInvoice_enterAddress1Placeholder":"Dirección Línea 1","customerInvoice_enterAddress2":"Ingrese la línea de dirección 2","customerInvoice_enterAddress2Placeholder":"Línea de dirección 2","customerInvoice_enterCity":"Ingresar ciudad","customerInvoice_enterCityPlaceholder":"Ciudad","customerInvoice_selectCountry":"Seleccionar país","customerInvoice_selectState":"Seleccione estado","customerInvoice_enterZipNumber":"Ingresa tu código postal","customerInvoice_enterZipNumberPlaceholder":"Código postal","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Producto no disponible","customerInvoice_SendInvoiceBtn":"Enviará la factura","customerInvoice_CreateOrderBtn":"Crear orden","customerInvoice_ProductTableColumnSubTotal":"Subtotal","customerInvoice_SelectShippingAddress":"Seleccionar dirección de envío","customerInvoice_ProductsSearchBy_Placeholder":"Buscar productos por nombre, SKU, precio","customerInvoice_AddMoreProducts_Btn":"Agregar más productos","customerInvoice_RequiredErrorMsg":"Este campo es obligatorio","customerInvoice_EmailSuggestionErrorMsg":"Por favor agregue una identificación de correo electrónico válida","customerInvoice_MobileSuggestionErrorMsg":"Agregue un número de teléfono válido","customerInvoice_ErrorMsgAddShippingAddress":"Por favor complete la dirección de envío","customerInvoice_Creating_Msg":"Creando...","customerInvoice_Sending_Msg":"Enviando...","customerInvoice_OrderCreatedSuccessfullyMsg":"Pedido creado con éxito","customerInvoice_InvoiceSentSuccessfullyMsg":"Factura enviada con éxito al cliente","customerInvoice_ErrorMsgTryAgain":"Error... Inténtalo de nuevo","customerInvoice_Selected_Btn":"Seleccionado","customerInvoice_ProductTableQuantityUpdate_Btn":"Seleccione el producto","customerInvoice_OrderSubTotal":"Subtotal de Orden","cartSharing_Select_product_Title":"Seleccionar producto","delete_confirmation_text":"Está seguro ?","draftOrder_OrderNumber":"Número de orden","draftOrder_CustName":"Nombre del cliente","draftOrder_OrderDate":"Fecha de orden","draftOrder_SubTotal":"Subcontrol","draftOrder_Status":"Estado","draftOrder_Invoice":"Factura","draftOrder_DraftId":"Borrador de identificación","draftOrder_ShippingCost":"Costo de envío","draftOrder_Tax":"Impuesto","draftOrder_TotalPrice":"Precio total","draftOrder_Note":"Nota","draftOrder_Product":"Producto","draftOrder_ProductName":"nombre del producto","draftOrder_Size":"Tamaño","draftOrder_Quantity":"Cantidad","draftOrder_Price":"Precio","noDraftOrderProducts":"No hay detalles del producto de pedido de borrador disponibles.","noRefundOrderProduct":"No hay detalles del producto de pedido de reembolso disponibles.","loading":"Cargando...","dashboard_commissionOn_profitMargin":"Comisión sobre el margen de beneficio","dashboard_clientInvoice":"Factura de cliente","dashboard_affiliateLink":"Orden de afiliado","dashboard_returnCustomer":"Devolver cliente","dashboard_discountCoupon":"Cupón de descuento","dashboard_SharedCart":"Carrito compartido","dashboard_AdminTaggedOrders":"Pedido etiquetado por el administrador","dashboard_no_data":"Datos no disponibles","dashboard_sales_of_last_six_months":"Ventas de los últimos 6 meses","dashboard_sales_of_current_month":"Ventas del mes actual","addCustomer_ErrorMsgOnSubmitBtn":"Por favor ingrese un número de teléfono válido","login_welcome_Msg":"Bienvenido al equipo de ventas","login_title":"Acceso","login_email":"Identificación de correo","login_password":"Clave","emailValidation_ErrorMsg":"Ingrese la identificación de correo electrónico válida","login_newUser":"¿Nuevo Usuario?","login_SignUp":"Inscribirse","login_forgotPassword_link":"¿Has olvidado tu contraseña?","login_LogInBtn":"Iniciar sesión","login_sliderContent_1":"Representantes que colocan pedidos en nombre de los clientes","login_sliderContent_2":"Representante de conducción del tráfico para almacenar","login_sliderContent_3":"Productos de marketing de representantes utilizando plataformas de redes sociales","login_sliderContent_4":"El representante puede comprar a granel y obtener ganancias","login_sliderContent_5":"Representantes que colocan pedidos en nombre de los clientes","login_sliderContent_6":"Los representantes pueden visitar a los clientes en persona y crear pedidos","required_ErrorMsg":"Llene el campo requerido","signup_title":"Inscribirse","signup_BackTo_login":"Atrás para iniciar sesión","signup_firstName":"Primer nombre","signup_lastName":"Apellido","signup_BackBtn":"atrás","signup_NextBtn":"próximo","signup_phone_number":"Número de teléfono","signup_phone_number_Error":"Ingrese al menos 10 dígitos","signup_uploadPicture":"Imagen de perfil de carga","signup_fileSizeError":"El tamaño del archivo es mayor que 5MB","signup_filePath_lable":"Archivo seleccionado","signup_MediaTitle2":"Enlaces de redes sociales","signup_facebookHandle":"Mango de Facebook","signup_InstaHandle":"Mango de Instagram","signup_SaveBtn":"Guardar detalles","forgotPwd_title":"Has olvidado tu contraseña","forgotPwd_ResetBtn":"Restablecer la contraseña","forgotPwd_SuccessMsg":"Su solicitud de contraseña de reinicio es exitosa, hemos enviado la nueva contraseña a su ID de correo electrónico registrada.","customerInvoice_selectShippingCost":"Seleccionar costo de envío","customerInvoice_CalculatingShippingRates_Msg":"Calculador...","customerInvoice_AddShippingAddress_Msg":"Seleccione la dirección o agregue la dirección de envío","customerInvoice_PleaseSetAnyShippingAddressMsg":"Seleccione cualquier dirección de envío","customerInvoice_ShippingCostErrorMsg":"Agregue una nueva dirección de envío, porque la dirección no tiene información suficiente.","customerInvoice_CalculateShippingCost_Btn":"Calcular costo de envío","customerInvoice_ShippingCostAddOrNot_Msg":"¿Le gustaría agregar el costo de envío?","customerInvoice_ShippingCostAddOrNot_Yes":"Sí","customerInvoice_ShippingCostAddOrNot_No":"No","customerInvoice_ShippingCostIsUnavailable":"El costo de envío para esta dirección no se establece desde el lado del administrador. Aunque, los pedidos se pueden realizar sin calcular el costo de envío.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Inténtalo de nuevo","dashboard_BannerMsg":"Los gráficos se actualizan cada 8 horas","yourSales__BannerMsg":"Los detalles del pedido se actualizan cada 5 minutos","customerInvoice_FirstNameErrorMsg":"Por favor, introduzca el nombre","customerInvoice_lastNameErrorMsg":"Por favor ingrese apellido","customerInvoice_Add1ErrorMsg":"Ingrese la línea de dirección 1","customerInvoice_CountryErrorMsg":"Por favor seleccione país","customerInvoice_StateErrorMsg":"Por favor seleccione estado","customerInvoice_CityErrorMsg":"Por favor ingrese la ciudad","customerInvoice_ZipErrorMsg":"Por favor ingrese el código postal","uploadImage":"Cargar imagen","dashboard_CardTitle1":"Comisión sobre todas las órdenes","dashboard_CardTitle3":"Comisión total","dashboard_TotalRevenue":"Los ingresos totales","dashboard_TotalAvg_Ticket_Size":"Tamaño del boleto AVG","dashboard_CardTitle4":"Ventas totales","profile_Change_Password":"Cambiar la contraseña","dashboard_Information_Message":"La comisión se rastrea solo para pedidos pagados","resetPassword_validation_Msg":"Este campo es obligatorio","resetPassword_validation_Msg2":"La contraseña debe contener un mínimo de 8 caracteres, 1 mayúscula, 1 minúscula, 1 dígito, etc.","resetPassword_validation_Msg3":"Confirmar que la contraseña debe coincidir con la nueva contraseña","dashbord_Msg_New":"Cómo funciona","dashbord_informationMsg":"Información","discount_couponErrorMsg":"El descuento máximo no está configurado. Póngase en contacto con el Sitio Admin.","discount_couponErrorMsg2":"La comisión no está configurada. Póngase en contacto con el Sitio Admin.","dashbord_profile_pic":"Cambiar foto de perfil","Performance_Details":"Detalles de rendimiento","Show_Performance_Details":"Mostrar detalles de rendimiento","Dashboard_Month":"Mes","Dashboard_Orders_Total":"Total de pedidos","Dashboard_Total_Sale":"Venta total","Dashboard_Commission":"Comisión","Dashboard_Bonus":"Prima","customerInvoice_EditOrder_NoAutoSelectedAddress":"Por favor seleccione producto.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Haga clic en el botón calcular el costo de envío y seleccione uno.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Carrito no actualizado, actualice y vuelva a intentarlo.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Por favor seleccione producto.","customerInvoice_CreatingDraft_Msg":"Borrador creando..","customerInvoice_DraftOrderBtn":"Proyecto de orden","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Borrador de orden creado exitosamente","productTable_error_AlertMsg":"La cantidad no puede ser 0 o menos, ingrese algún valor válido","productTable_error_AlertMsg2":"Por favor ingrese la cantidad","click_to_copy":"Haga clic para copiar","discount_code_copy_coupon":"Copiar cupón","createOrder_productSearchGuide":"¿No puede encontrar productos?","soldOut":"Agotado","InventoryNotTracked":"Inventario no rastreado","productStatus":"Estado del producto","makeSureInShopify":"Asegúrate en Shopify","products":"Productos","sectionTheProductStatusIs":"ssección, el estado del producto es","active":"Activo","productsMayBeSoldOutPleaseCheck":"Los productos pueden estar agotados, verifique y seleccione","Credit_Limit_Error_Msg":"El límite de crédito se excede, por favor, inténtelo de nuevo..!"}'
        ),
        Ot = JSON.parse(
          '{"dashboard_title":"TABLEAU DE BORD","dashboard_welcomeMsg":"Bienvenue à","dashboard_morningMsg":"Bonjour","dashboard_afternoonMsg":"Bonne après-midi","dashboard_eveningMsg":"Bonsoir","dashboard_subTitle1":"MOIS EN COURS","dashboard_block1Heading":"FACTURE CLIENT","dashboard_block1Header1":"GAINS","dashboard_block1Header2":"FACTURE ENVOYÉE","dashboard_block1Header3":"FACTURE PAYEE","dashboard_block2Heading":"COMMANDES EN GROS","dashboard_block2Header1":"GAINS","dashboard_block2Header2":"FACTURE ENVOYÉE","dashboard_block2Header3":"FACTURE PAYEE","dashboard_block3Heading":"COMMANDES AFFILIÉES","dashboard_block3Header1":"GAINS","dashboard_block3Header2":"COMMANDES PAYÉES","dashboard_block4Heading":"COUPON DE RÉDUCTION","dashboard_block4Header1":"GAINS","dashboard_block4Header2":"COMMANDES PAYÉES","dashboard_block5Heading":"COMMISSION CLIENTÈLE","dashboard_block5Header1":"COMMISSION","dashboard_block5Header2":"ORDERS","dashboard_block6Heading":"COMMISSION DE CHEF D\'ÉQUIPE","dashboard_block6Header1":"COMMISSION","dashboard_block7Heading":"COMMISSION POS","dashboard_block7Header1":"COMMISSION","dashboard_block7Header2":"ORDERS","dashboard_tbl1column1":"Mois","dashboard_tbl1column2":"Commandes sur facture client","dashboard_tbl1column3":"Commission de facturation client","dashboard_tbl1column4":"Commandes en gros","dashboard_tbl1column5":"Achat en gros total","dashboard_tbl1column6":"Commandes d\'affiliation","dashboard_tbl1column7":"Commission d\'affiliation","dashboard_tbl1column8":"Commandes avec code coupon","dashboard_tbl1column9":"Commission du code de coupon","dashboard_tbl1column10":"Commandes clients","dashboard_tbl1column11":"Commission client","dashboard_tbl1column12":"Commandes POS","dashboard_tbl1column13":"Commission POS","dashboar_cardHeading1":"Commande totale","dashboar_cardHeading2":"Commission","dashboar_cardHeading3":"Ventes","dashboar_cardHeading4":"Prime","dashboard_graphHeading1":"Performance des ventes des six derniers mois","dashboard_graphHeading2":"Analyser l\'ordre et la commission de Feature Wise pour le mois en cours","Graph_Sales_noorderstitle":"pas d\'ordre à montrer","Graph_SalesRepCommission_nocommissiontitle":"Aucune donnée de commission à afficher","Graph_SalesRepOrders_title":"ORDERS","Graph_SalesRep_XAxisTitle_ForMonth":"6 mois","Graph_SalesRepOrders_YAxisTitle":"Orders","Graph_SalesRepSales_title":"VENTES","Graph_SalesRepCommission_title":"COMMISSION","Graph_SalesRepCommissions_YAxisTitle":"Commission","Graph_FeatureWiseOrder_title":"Commandes vs fonctionnalités","Graph_featureWiseCommission_title":"Commission vs fonctionnalité","Graph_FeatureWiseOrder_XAxisTitle":"Fonctionnalité","Graph_FeatureWiseOrder_YAxisTitle":"Ordres","Graph_FeatureWiseCommission_title":"COMMISSION","Graph_FeatureWiseCommission_YAxisTitle":"Commission","customerInvoice_title":"Créer une commande","customerInvoice_button":"Arrière","customerInvoice_noclientorderMsg":"Aucune commande de facture client","customerInvoice_button1":"Voir les commandes précédentes","customerInvoice_contentHeading1":"Remise et commission sur","customerInvoice_table1column1":"type de produit","customerInvoice_table1column2":"Commission","customerInvoice_table1column3":"Nom de la remise","customerInvoice_table1column4":"Remise","customerInvoice_contentHeading2":"Ajoutez les détails du client et sélectionnez les produits pour envoyer la facture","customerInvoice_contentHeading2Title1":"Saisir/rechercher un client","customerInvoice_title1Placeholder":"Saisir/rechercher un client","customerInvoice_contentHeading2Title2":"Entrez l\'ID de courriel du client","customerInvoice_title2Placeholder":"Adresse e-mail","customerInvoice_contentHeading2Title3":"Saisir les notes de commande","customerInvoice_contentHeading2Title4":"Adresse du client","customerInvoice_contentHeading2Title5":"Numéro de mobile du client","customerInvoice_contentHeading2Title6":"Remarque client","customerInvoice_contentHeading2Title7":"Nom de l\'entreprise cliente","customerInvoice_title7Placeholder":"Nom de la compagnie","customerInvoice_Placeholder_contentHeading2Title6":"Noter","customerInvoice_Placeholder_contentHeading2Title5":"Numéro de portable","customerInvoice_Placeholder_contentHeading2Title4":"Adresse de livraison","customerInvoice_title3Placeholder":"Notes d\'ordre","customerInvoice_SearchProducts_Label":"Recherche de produits","customerInvoice_table2Column1":"Image","customerInvoice_table2Column2":"Ajouter la quantité","customerInvoice_table2Column3":"Titre","customerInvoice_table2Column4":"Titre de la variante","customerInvoice_ProductTableColumnPrice":"Prix","customerInvoice_ProductTableColumnWholeSalePrice":"Prix ​​de gros","customerInvoice_button2":"Créer une facture","customerInvoice_ProductTableColumnProduct":"Produit","customerInvoice_table3Column2":"Nom du produit","customerInvoice_table3Column3":"Taille","customerInvoice_ProductTableColumnQuantity":"Quantité","customerInvoice_table3Column5":"Prix ​​de l\'article","customerInvoice_table3Column6":"Prix ​​total","customerInvoice_table3Column7":"Prix ​​réduit pour le client","customerInvoice_table3Column8":"Commission SalesRep","customerInvoice_table3Column9":"DiscountType","customerInvoice_repproInvite":"Cochez la case pour envoyer une invitation professionnelle","customerInvoice_customerOrder_error1":"tous les champs client sont obligatoires. Veuillez saisir l\'adresse e-mail et le prénom du client","customerInvoice_productAddedMsg":"Produit ajouté","customerInvoice_AlertErrorMsg":"Erreur..Veuillez contacter le support !","cartSharing_Select_product_Title":"Sélectionner un produit","wholesaleOrder_title":"Commande en gros","wholesaleOrder_contentHeading1":"Vous pouvez acheter des produits à des prix de gros spéciaux","wholesaleOrder_contentHeading2":"Remise sur","wholesaleOrder_column1":"Nom SalesRep","wholesaleOrder_column2":"Rabais","wholesaleOrder_searchtxtPlaceholder":"Rechercher un produit","wholesaleOrder_table1Column1":"Image","wholesaleOrder_table1Column2":"Ajouter la quantité","wholesaleOrder_table1Column3":"Titre","wholesaleOrder_table1Column4":"Titre de la variante","wholesaleOrder_table1Column5":"prix","wholesaleOrder_button":"départ","wholesaleOrder_Order_btn":"Afficher/masquer les prix en volume","wholesaleOrder_contentHeading3":"Prix ​​total","wholesaleOrder_contentHeading4":"Votre prix réduit","wholesaleOrder_table2Column1":"Produit","wholesaleOrder_table2Column2":"Nom du produit","wholesaleOrder_table2Column3":"Taille","wholesaleOrder_table2Column4":"Quantité","wholesaleOrder_table2Column5":"Prix ​​de l\'article","wholesaleOrder_table2Column6":"Prix ​​total","wholesaleOrder_table2Column7":"Votre prix réduit","affiliateLink_title":"Votre prix réduit","affiliate_product_link":"Lien de produit","affiliateLink_input_error_msg":"Le champ de texte du lien est obligatoire et ne doit pas contenir d\'espaces.","affiliateLink_contentHeading1":"Partagez votre lien d\'affiliation sur les réseaux sociaux et par e-mail. Vous recevrez une commission d\'affiliation pour chaque commande de votre lien d\'affiliation","affiliateLink_contentHeading2":"Votre lien d\'affiliation","affiliateLink_contentHeading3":"Commission sur","affiliateLink_content_Message1":"Recherchez des produits et partagez le lien des produits individuels avec vos clients.","affiliateLink_noaffiliateorderMsg":"Aucune commande d\'affiliation","affiliateLink_column1":"Nom SalesRep","affiliateLink_column2":"Commission","affiliateLink_searchtxtPlaceholder":"Rechercher un produit","affiliateLink_searchColumn1":"Produit","affiliateLink_searchColumn2":"Titre du produit","affiliateLink_searchColumn3":"Prix","affiliateLink_searchColumn4":"Commission","affiliateLink_searchColumn5":"Lien d\'affiliation","affiliateLink_searchColumn7":"Copier le lien","affiliateLink_searchColumn8":"Copié","affiliateLink_backbtn":"Arrière","affiliateLink_card_Title":"Carte de contact et lien d\'affiliation","cartSharing_title":"Partage de panier","cartSharing_CreateCartInformation_Text":"Pour créer un panier partageable personnalisé, ajoutez des produits au panier à partir de la vitrine. Ces produits seront affichés sur cette page","cartSharing_content2Placeholder":"Nom du panier","cartSharing_table2Column2":"Nom du produit","cartSharing_table2Column3":"Taille","cartSharing_table2Column6":"Prix ​​total","cartSharing_SharedCartLinkTableColumnCartName":"Nom du panier","cartSharing_SharedCartLinkTableColumnLink":"Lien","cartSharing_SharedCartLinkTableColumnCartLink":"Lien de panier partageable","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copier le lien du panier","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Supprimer le lien du panier","cartSharing_EnterCartName_Label":"Entrez le nom du panier","cartSharing_ProductTableColumnProduct":"Produit","cartSharing_ProductTableColumnQuantity":"Quantité","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Prix ​​de l\'article","cartSharing_CartCreating_Msg":"Créer...","cartSharing_Copied_Msg":"Copie!!","cartSharing_SharedCartLinkTableEmpty_Msg":"Aucun lien à afficher","cartSharing_CartCreatedSuccessfully_Msg":"Panier créé avec succès","cartSharing_CartCreateError_Msg":"Erreur..veuillez réessayer","cartSharing_AlertError_Msg":"Erreur..Veuillez contacter le support !","cartSharing_CopyCartLink_Msg":"Copier le lien du panier","cartSharing_DeleteCartLink_Msg":"Supprimer le lien du panier","cartSharing_DeleteConfirmation_Msg":"Êtes-vous sûr ?","cartSharing_ProductTableEmpty_Msg":"Produit non disponible","cartSharing_CreateCart_Btn":"Créer un panier","cartSharing_ProductTableQuantityUpdate_Btn":"Veuillez sélectionner le produit","discountCoupon_titleOne":"Coupon de réduction","discountCoupon_contentHeading1":"Partagez le code de coupon de réduction avec vos clients et chaque fois que votre coupon est utilisé, vous obtenez une commission.","discountCoupon_contentHeading2":"Votre code de coupon est","discountCoupon_contentHeading3":"Montant de la remise","discountCoupon_contentHeading4":"Commission","discountCoupon_contentHeading4PlaceHolder1":"Hé, utilisez mon code de réduction","discountCoupon_contentHeading4PlaceHolder2":"et obtenez des produits à prix réduit","discountCoupon_button1":"Copier le texte","cartSharing_copiedButtonText":"Copié","discountCoupon_titleTwo":"Créez des coupons de réduction à usage unique pour les clients","discountCoupon_button2":"Voir les coupons","discountCoupon_contentHeading5":"Remise maximale autorisée","discountCoupon_contentHeading6":"Commision","discountCoupon_contentHeading7":"Entrer le code promotionnel","discountCoupon_contentHeading7PlaceHolder":"Veuillez entrer le code de coupon","discountCoupon_contentHeading8":"Entrez la remise","discountCoupon_contentHeading8PlaceHolder":"La remise ne doit pas être supérieure à la remise maximale.","discountCoupon_button3":"Créer un coupon","discountCoupon_coupon_error1":"Veuillez saisir le code de réduction et la réduction","yourBio_title":"Votre carte de contact","yourBio_content1":"Télécharger le profil","yourBio_button1":"Choisir le fichier","yourBio_button1PlaceHolder":"Aucun fichier choisi","yourBio_error_image_size":"La taille de l\'image est trop grande, veuillez télécharger une image d\'une taille inférieure à 5 Mo. Veuillez réessayer.","yourBio_button2":"Télécharger","yourBio_content2":"Entrez un mot personnalisé pour créer votre lien d\'affiliation unique","yourBio_content2PlaceHolder":"créez votre lien d\'affiliation unique","yourBio_content4":"Lorsque votre lien sera utilisé, votre carte de contact apparaîtra sur le site Web","yourBio_content3":"Entrez votre carte de contact","yourBio_content3PlaceHolder":"Saisissez 100 mots","yourBio_button3":"Sauvegarder","yourBio_button4":"enregistré","yourBio_error_link":"Ce lien unique peut être pris. Essayez avec un lien unique différent.","yourBio_Linksuccessmsg":"Lien unique enregistré avec succès.","team_title1":"Ajouter SalesRep","team_content1":"Entrez votre e-mail","team_content1PlaceHolder":"Adresse e-mail","team_emailerrorMsg":"Veuillez saisir votre email","team_content2":"Entrez votre prénom","team_content2PlaceHolder":"Prénom","team_fnameerrorMsg":"Veuillez entrer le prénom","team_content3":"Entrer le nom de famille","team_content3PlaceHolder":"Nom de famille","team_button1":"Ajouter","team_successmsg":"Ajouté avec succès! Veuillez vérifier votre e-mail pour les instructions d\'activation","team_errorsmsg":"Erreur lors de l\'ajout. Cet e-mail d\'utilisateur peut déjà avoir un compte sur la boutique","team_title2":"Détails de l\'équipe","team_content4":"Page d\'inscription","team_NoTeamDetailsMsg":"Pas de détails sur l\'équipe","team_content5":"Sélectionnez SalesRep:","team_tableTitle":"DÉTAILS DE LA COMMANDE DE DEUX DERNIERS MOIS","team_column1":"Numéro de commande","team_column2":"Date de commande","team_column3":"Nom du client","team_column4":"Représentant commercial","team_column5":"Total","team_column6":"Commission du représentant des ventes","team_column7":"Commission des chefs d\'équipe","team_column8":"Type de commission","addCustomer_title":"Ajouter un client","addCustomer_content1":"Entrez le prénom du client","addCustomer_txt1Placeholder":"Prénom","addCustomer_content2":"Entrez le nom du client","addCustomer_content2Placeholder":"Nom de famille","addCustomer_content3":"Entrez l\'ID de courriel du client","addCustomer_content3Placeholder":"Adresse e-mail","addCustomer_content4":"Remarque","addCustomer_content4Placeholder":"Remarque","addCustomer_customerAddress":"Adresse personnelle","addCustomer_customerCity":"Ville","addCustomer_customerCityPlaceholder":"Prénom","addCustomer_customerCountry":"Pays","addCustomer_customerState":"Etat","addCustomer_customerZipCode":"Code postal","addCustomer_companyName":"Nom de l\'entreprise","addCustomer_companyAddress":"Adresse de la société","addCustomer_companyCity":"Ville","addCustomer_companyCountry":"Pays","addCustomer_companyState":"Etat","addCustomer_companyZipCode":"Code postal","addCustomer_button":"sauver","addCustomer_leadsuccessmsg":"Le client a été ajouté avec succès","addCustomer_leadErrrorMsg":"Erreur lors de l\'enregistrement des détails","addCustomer_leadEmptyErrrorMsg":"Veuillez remplir les champs requis","addCustomer_leadsuccessmsg2":"Le client a été créé et associé avec succès à un commercial","addCustomer_leadErrrorMsg2":"Ce client est déjà associé à un représentant","myCustomers_title":"Vos clients","myCustomers_table1Column1":"Nom","myCustomers_table1Column2":"Nom de l\'entreprise","myCustomers_table1Column3":"Email","myCustomers_table1Column4":"Commandes","myCustomers_table1Column5":"Total dépensé","myCustomers_table2Title":"DÉTAILS DU CLIENT","myCustomers_table3Title":"PROJET DE DÉTAILS DE LA COMMANDE","myCustomers_table3Column1":"Nom du produit","myCustomers_table3Column2":"Taille","myCustomers_table3Column3":"Quantité","myCustomers_table3Column4":"Prix","myCustomers_table3Column5":"Statut","myCustomers_table3Column6":"Total","myCustomers_table2Row1":"Nom","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Adresse","myCustomers_table2Row4":"Nom de l\'entreprise","myCustomers_table2Row5":"Notes des clients","myCustomers_table2Row6":"Total dépensé (sous-total + taxes)","myCustomers_table2Row7":"Nombre de commandes","myCustomers_table2Row8":"Mots clés","myCustomers_radioButton0":"Afficher tous les clients","myCustomers_radioButton1":"Recherche par nom","myCustomers_radioButton2":"Recherche par entreprise","myCustomers_radioButtonError1":"Veuillez sélectionner le type de recherche et saisir la valeur à rechercher","myCustomers_radioButtonError2":"Veuillez saisir une valeur à rechercher","myCustomers_radioButtonError3":"Veuillez sélectionner le type de recherche","myCustomers_searchButton":"Rechercher","myCustomers_Placeholder1":"Tapez le nom du client ou le nom de l\'entreprise à rechercher","myCustomers_NoOrdersError":"Aucune commande","myCustomer_no_salesRep_details":"Aucun détail des ventes disponibles.","myCustomer_select_customer_country":"Veuillez sélectionner le pays client","myCustomer_company_country":"Pays de compagnie","myCustomer_company_state":"État de l\'entreprise","myCustomer_select_company_country":"Veuillez sélectionner le pays de l\'entreprise","yourSales_SalesOrderDetailsTitle":"Détails de la commande client","yourSales_title":"Détails de la commande des 2 derniers mois","yourSales_table1Column1":"Numéro de commande","yourSales_table1Column2":"Date de commande","yourSales_table1Column3":"Nom du client","yourSales_table1Column4":"Total","yourSales_table1Column5":"Commission","yourSales_table1Column6":"Type de commission","yourSales_table1Column7":"La facture d impressione","printOrderInvoice_btn":"Impression","yourSales_tableTitle":"DÉTAILS DU PRODUIT","yourSalesDraft_tableTitle":"PROJET DE DÉTAILS DE LA COMMANDE","yourSales_column1":"Produit","yourSales_column2":"Titre","yourSales_column3":"Quantité","yourSales_column4":"Prix ​​de l\'article","yourSales_column5":"Numéro de suivi","yourSales_column6":"Date d\'expédition","yourSales_column7":"Prix ​​total","yourSales_content1":"Total","yourSales_content2":"Impôt","yourSales_content3":"Frais de port","yourSales_content4":"Total","yourSales_content5":"Remarque","yourSales_tabHeading1":"Commandes payées","yourSales_tabHeading4":"Commandes en attente","yourSales_tabHeading2":"Projets d\'ordres","myOrders_title":"Détails de mes commandes","myOrdersDetails_Message":"Commandes passées pour vous-même","myOrders_table1Column1":"Numéro de commande","myOrders_table1Column2":"Date de commande","myOrders_table1Column3":"Nom du client","myOrders_table1Column4":"Paiement","myOrders_table1Column5":"Accomplissement","myOrders_table1Column6":"Total","myOrders_tableTitle":"DÉTAILS DU PRODUIT","myOrders_table2Column1":"Produit","myOrders_table2Column2":"Titre","myOrders_table2Column3":"Quantité","myOrders_table2Column4":"Prix ​​de l\'article","myOrders_table2Column5":"Numéro de suivi","myOrders_table2Column6":"Date d\'expédition","myOrders_table2Column7":"Prix ​​total","myOrders_content1":"Total","myOrders_content2":"Impôt","myOrders_content3":"Frais de port","myOrders_content4":"Total","myOrders_content5":"Remarque","myOrders_content6":"ID de brouillon","tab_Dashboard":"Tableau de bord","dashbord_Tab":"Maison","tab_CustomerInvoice":"Créer une commande","tab3_WholesaleOrder":"Commande en gros","tab_AffiliateLink":"Lien d\'affiliation","tab_CartSharing":"Partage de panier","tab_DiscountCoupon":"Coupon de réduction","tab7_YourBio":"Votre carte de contact","tab8_Team":"Équipe","tab9_AddCustomer":"Ajouter un client","tab_MyCustomers":"Mes clients","tab_YourSalesOrderDetails":"Détails de votre commande client","tab12_MyOrders":"Détails de mes commandes","tab13_Logout":"Se déconnecter","signUp_title":"Inscription représentant des ventes","signUp_subTitle":"Veuillez remplir ce formulaire pour vous inscrire en tant que représentant commercial et accéder à toutes les fonctionnalités de l\'équipe commerciale","signUp_content1":"Email","signUp_content2":"Prénom","signUp_content3":"Nom de famille","signUp_content4":"Numéro de téléphone","signUp_content5":"Poignée Facebook","signUp_content6":"Poignée Twitter","signUp_content7":"Poignée Instagram","signUp_content8":"Télécharger une photo de profil","signUp_socialmedialable1":"Liens de médias sociaux ","signUp_socialmedialable2":"optionnel","signUp_uploadBtn":"Choisir le fichier","signUp_uploadBtnPlaceHolder":"Aucun fichier choisi","signUp_button3":"Enregistrement des détails...","signUp_welcomemsg1":"Bonjour","signUp_welcomemsg2":"inscrivez un représentant des ventes et obtenez une commission sur les ventes effectuées par les représentants sous vous","signUp_emailerror":"Veuillez saisir votre email","signUp_Fnameerror":"Veuillez entrer le prénom","signUp_lnameerror":"Veuillez saisir le nom de famille ","signUp_phnumbererror":"Veuillez entrer le numéro de téléphone ","signUp_successmsg":"Votre demande a été enregistrée avec succès, vous recevrez bientôt un e-mail d\'activation de compte une fois que notre administrateur aura approuvé votre demande.","signUp_errorsmsg":"Erreur lors de l\'enregistrement des détails. Cet e-mail d\'utilisateur peut déjà avoir un compte sur la boutique.","signUp_RepExistErrorMsg":"Cet e-mail est déjà enregistré en tant que représentant.","addingRep_selectRepsLabel1":"Qui t\'a aidé?","addingRep_NoSalesRep":"Aucun représentant commercial","addingRep_selectRepsLabel2":"Veuillez sélectionner un élément dans la liste.","addingRep_successMsg":"Ajout de repId à la note du panier","wholesaleOrder_WholesaleDiscountTableColumn1":"Titre du produit","wholesaleOrder_WholesaleDiscountTableColumn2":"Réduction","customerInvoice_ViewClientOrdersColumn1":"Nom du client","customerInvoice_ViewClientOrdersColumn2":"Titre du produit","customerInvoice_ViewClientOrdersColumn3":"Prix subtotal","customerInvoice_ViewClientOrdersColumn4":"Statut","customerInvoice_ViewClientOrdersColumn5":"Facture","salesRep_order_errorMsg":"Erreur lors de la création de votre commande. S’il vous plaît contacter le soutien","salesRep_order_successMsg":"Commandez la facture créée avec succès!  La facture a été envoyée par courriel au client!","salesRep_order_errorMsg2":"Erreur lors de la création de votre commande. S’il vous plaît contacter le soutien","customedraft_btn1":"Créer une nouvelle facture","customedraft_btn2":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","customedraft_btn3":"Création de l’ordre...","customedraft_btn4":"Créer une nouvelle facture","salesRep_order_NoProductSelected":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","productnotselectforcartsharingtxt1":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","discountCoupons_tblColumn1":"Coupon Code","discountCoupons_tblColumn2":"Réduction sur coupon","discountCoupons_tblColumn3":"Supprimer le code coupon","discountedPriceLabel":"Votre prix réduit:","couponCodeNotSet":"Code coupon non défini","dashboard_subTitle2":"Cycle du mois en cours: 5ème - 4ème","affiliatelink_commissiononlbl":"Produit","displaycommission_lbl1":"Type de produit","displaycommission_lbl2":"Représentant","displaycommission_lbl3":"Remise basée sur la quantité","discountcommissiononlbl1":"Niveaux de réduction des clients","clientInvoiceCommissionTablecolumn1":"Type de produit","clientInvoiceCommissionTablecolumn2":"Commission","clientInvoiceCommissionTablecolumn3":"Titre du produit","clientInvoiceCommissionTablecolumn4":"Nom SalesRep","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nom du produit","clientInvoiceQuantityBaseDiscountTablecolumn2":"Réduction","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantité","affiliateCartProdtableColumn1":"Produit","affiliateCartProdtableColumn2":"Titre du produit","affiliateCartProdtableColumn3":"Prix","affiliateCartProdtableColumn4":"Commission","affiliateCartProdtableColumn5":"Lien d’affiliation","affiliateCartProdtableColumn6":"Partager le lien","productnotselectforcartsharinglbl1":"S’il vous plaît entrer le nom du chariot","productnotselectforcartsharinglbl2":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","productnotselectforcartsharinglbl3":"Attendez pendant le traitement ...","showSharedCartProductcolumn1":"Lien chariot","showSharedCartProductcolumn3":"Retirer le chariot","onSuccessInvoiceSuccessMsg":"Facture envoyée avec succès","onSuccessInvoiceFailedMsg":"L’envoi de factures a échoué","sendInvoice_successMsg":"Facture envoyée avec succès","deleteInvoice_successMsg":"Facture supprimée avec succès","deleteInvoice_FailedMsg":"Supprimer la facture a échoué","deleteInvoice_btnlbl":"Suppression de la facture","deleteSharedCartLink_successMsg":"Lien supprimé avec succès","deleteSharedCartLink_FailedMsg":"Erreur dans la suppression du lien. S’ll vous plaît, réessaiez.","deleteSharedCartLink_btnlbl":"Suppression du lien","viewInvoiceOrders_btntxt1":"Obtenir...","viewInvoiceOrders_btntxt2":"Afficher les commandes précédentes","createCoupon_btnlbl1":"Création de Coupon..","createCoupon_btnlbl2":"Coupon créé","deleteCoupon_successMsg":"Coupon supprimé","deleteCoupon_FailedMsg":"Suppression de coupons échoués","deleteCoupon_btnlbl":"Suppression...","viewProductModelColumn1":"Produit","viewProductModelColumn2":"Titre","viewProductModelColumn3":"Quantité","viewProductModelColumn4":"Montant remboursé","viewProductModelColumn5":"Prix de l’article","viewProductModelColumn6":"discounted Price","viewProductModelColumn7":"Numéro de suivi","viewProductModelColumn8":"Date du navire","viewProductModelColumn9":"Prix total","showSharedCartProducts_column2":"Image","showSharedCartProducts_column3":"Ajouter la quantité","showSharedCartProducts_column4":"Titre","showSharedCartProducts_column5":"Titre de variante","showSharedCartProducts_column6":"Prix","viewClientOrders_btn1":"Afficher","viewClientOrders_btn2":"Envoyer","viewClientOrders_btn3":"Supprimer","showCouponTable_txt1":"Obtenir ...","showCoupon_btn2":"Voir les coupons","showCoupon_btn1":"Copié","affliateOrder_column1":"Nom du client","affliateOrder_column2":"Email client","affliateOrder_column3":"Titre du produit","affliateOrder_column4":"Date de commande","affliateOrder_column5":"Total","affliateOrder_column6":"Commission","affliateOrder_btn1":"Obtenir ...","affliateOrder_btn2":"Afficher les commandes des affiliés","affliateOrder_btn3":"Afficher les commandes des affiliés","yourBio_btn1":"sauver","yourBio_btn2":"sauver","yourBio_Uploadbtn1":"Téléchargement...","yourBio_Uploadbtn2":"Téléchargé","yourBio_UploadbtnError":"Désolé réessayez","yourBio_Savebtn":"Économie..","team_txt1":"Économie..","team_txt2":"sauver","viewRepClientOrdersDetails_column1":"Numéro de commande","viewRepClientOrdersDetails_column2":"Date de commande","viewRepClientOrdersDetails_column3":"Total","viewRepClientOrdersDetails_column4":"Statut","viewRepClientOrdersDetails_column5":"détails du produit","addSalesRep_txt1":"Ajouter SalesRep","addSalesRep_txt2":"Ajout de SalesRep ...","discountCoupons_header":"Coupon de réduction une fois","discountCoupons_nodiscountcoupon":"Vous n’avez pas créé de coupon de réduction","discountCoupons_deleteBtn":"Supprimer","discountCoupons_BackBtn":"Précédent","customerInvoice_selectcustomererror":"Veuillez sélectionner le client, puis ajouter le produit","createOrderFromCartPage_selectCustomersLabel":"SÉLECTIONNER LE CLIENT","createOrderFromCartPage_selectCustomerAddressLabel":"ADRESSE DE LIVRAISON","createOrderFromCartPage_selectCustomersLabelForDropDown":" Sélectionnez le client","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Sélectionnez l\'adresse","createOrderFromCartPage_successMsg":"Facture de commande créée avec succès ! La facture a été envoyée par e-mail au client !","createOrderFromCartPage_toggleButton":"Ajouter une nouvelle adresse d\'expédition","createOrderFromCartPage_AddNewAddressTitle":"AJOUTER UNE NOUVELLE ADRESSE","createOrderFromCartPage_customer_errorMsg1":"Aucun client sélectionné. Veuillez sélectionner le client et réessayer.","createOrderFromCartPage_order_errorMsg1":"Aucun produit sélectionné. Veuillez sélectionner des produits et réessayer.","createOrderFromCartPage_Address_errorMsg2":"Veuillez sélectionner l\'adresse et réessayer.","createOrderFromCartPage_Address_errorMsg3":"Veuillez remplir tous les champs d\'adresse.","createOrderFromCartPage_Order_errorMsg2":"Erreur lors de la création de votre commande. Contactez le support","createOrderFromCartPage_draftOrderButton":"CRÉER UN BROUILLON DE COMMANDE","createOrderFromCartPage_OrderButton":"CRÉER UNE COMMANDE","createOrderFromCartPage_draftOrderButtonText2":"CRÉATION DE COMMANDE...","createOrderFromCartPage_selectShippingCostTitle":"FRAIS DE PORT","createOrderFromCartPage_selectShippingCost":"Sélectionnez les frais d\'expédition","createOrderFromCartPage_Address_errorMsg4":"Un problème est survenu lors du calcul de vos tarifs d\'expédition.","createOrderFromCartPage_Address_errorMsg5":"Une erreur s\'est produite. Veuillez réessayer.","yourSales_tabHeading3":"Rembourser les commandes","refundOrders_column1":"Identifiant de remboursement","refundOrders_column2":"Date de commande","refundOrders_column3":"Numéro de commande","refundOrders_column4":"Nom de la commande","refundOrders_column5":"Commission","refundOrders_column6":"Commission de chef d\'équipe","refundOrders_column7":"Identifiant du responsable d\'équipe","refundOrders_column8":"Sous-total des remboursements","refundOrders_column9":"Statut de la commande","refundOrders_column10":"Type de commande","refundOrderNumber_title":"Détails de la commande de remboursement","refundOrderNumber_column1":"Nom","refundOrderNumber_column2":"Date","refundOrderNumber_column3":"Quantité","refundOrderNumber_column4":"Prix ​​bas","refundOrderNumber_column5":"Total","tableDataError":"Aucune commande de remboursement","dashboard_subTitle3":"Détails des commissions","dashboard_cardHeading5_1":"Commission sur","dashboard_cardHeading5_2":"Vous obtiendrez un","dashboard_cardHeading5_3":"commission sur toutes les commandes.","dashboard_cardHeading5_4":"Vous recevrez une commission basée sur les produits que vous vendez","dashboard_cardHeading5_5":"Vous recevrez une commission basée sur les types de produits","Profit_Margin":"Marge bénéficiaire","Product_Type":"type de produit","Sales_Rep":"Représentant commercial","show_commission_list":"Afficher la liste des commissions","commission_list":"Liste des commissions","no_link_to_show":"Aucun lien à afficher","no_customers_to_show":"Aucun client à afficher","no_sales_to_show":"Aucune vente à afficher","no_draft_to_show":"Aucun brouillon à afficher","no_refund_to_show":"Aucun remboursement à afficher","no_orders_to_show":"Aucune commande à afficher","customerInvoice_ViewClientOrdersColumn6":"Numéro de commande","customerInvoice_ViewClientOrdersColumn7":"Date de commande","Error_commissions_NotUpdated":"Les commissions ne sont pas mises à jour","sales_chart_msg1":"Nous avons besoin de données...","sales_chart_msg2":"Il semble que nous n\'ayons pas encore de données à afficher.","page_refresh_msg":"cliquez pour rafraichir","variant_title":"Titre de la variante","line_items_properties":"Propriétés","customer_country":"Pays du client","customer_state":"État du client","company_country":"Pays de la société","company_state":"État de la société","client_orders":"Commandes clients","no_product_details":"Aucun détail de produit à afficher","submit_btn_text":"Soumettre","submitting_btn_text":"Soumission","submitted_btn_text":"Soumis","email_id_validation_errmsg":"Veuillez saisir un identifiant de messagerie valide","customerInvoice_add_more_details":"Ajouter plus de détails","customerInvoice_add_shipping_address":"Ajouter une nouvelle adresse d\'expédition","customerInvoice_HideDetails":"Cacher les détails","customerInvoice_HideAddress":"Masquer l\'adresse de livraison","customerInvoice_enterFirstName":"Entrez votre prénom","customerInvoice_enterFirstNamePlaceholder":"Prénom","customerInvoice_enterLastName":"Entrer le nom de famille","customerInvoice_enterLastNamePlaceholder":"Nom de famille","customerInvoice_enterAddress1":"Entrer la ligne d\'adresse 1","customerInvoice_enterAddress1Placeholder":"Adresse Ligne 1","customerInvoice_enterAddress2":"Entrez l\'adresse ligne 2","customerInvoice_enterAddress2Placeholder":"Adresse Ligne 2","customerInvoice_enterCity":"Entrez la ville","customerInvoice_enterCityPlaceholder":"Ville","customerInvoice_selectCountry":"Choisissez le pays","customerInvoice_selectState":"Sélectionnez l\'état","customerInvoice_enterZipNumber":"Entrer le code postal","customerInvoice_enterZipNumberPlaceholder":"Code postal","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Produit non disponible","customerInvoice_SendInvoiceBtn":"Envoyer une facture","customerInvoice_CreateOrderBtn":"Créer une commande","customerInvoice_ProductTableColumnSubTotal":"Sous-total","customerInvoice_SelectShippingAddress":"Sélectionnez l\'adresse de livraison","customerInvoice_ProductsSearchBy_Placeholder":"Rechercher des produits par nom, SKU, prix","customerInvoice_AddMoreProducts_Btn":"Ajouter plus de produits","customerInvoice_RequiredErrorMsg":"Ce champ est obligatoire","customerInvoice_EmailSuggestionErrorMsg":"Veuillez ajouter un identifiant de messagerie valide","customerInvoice_MobileSuggestionErrorMsg":"Veuillez ajouter un numéro de téléphone valide","customerInvoice_ErrorMsgAddShippingAddress":"Veuillez remplir l\'adresse de livraison","customerInvoice_Creating_Msg":"Créer...","customerInvoice_Sending_Msg":"Envoi en cours...","customerInvoice_OrderCreatedSuccessfullyMsg":"Commande créée avec succès","customerInvoice_InvoiceSentSuccessfullyMsg":"Facture envoyée avec succès au client","customerInvoice_ErrorMsgTryAgain":"Erreur..veuillez réessayer","customerInvoice_Selected_Btn":"Choisi","customerInvoice_ProductTableQuantityUpdate_Btn":"Veuillez sélectionner le produit","customerInvoice_OrderSubTotal":"Sous-total de la commande","delete_confirmation_text":"Es-tu sûr ?","draftOrder_OrderNumber":"Numéro de commande","draftOrder_CustName":"Nom du client","draftOrder_OrderDate":"Date de commande","draftOrder_SubTotal":"Sous-total","draftOrder_Status":"Statut","draftOrder_Invoice":"Facturer","draftOrder_DraftId":"ID brouillon","draftOrder_ShippingCost":"Frais de port","draftOrder_Tax":"Impôt","draftOrder_TotalPrice":"Prix ​​total","draftOrder_Note":"Noter","draftOrder_Product":"Produit","draftOrder_ProductName":"Nom de produit","draftOrder_Size":"Taille","draftOrder_Quantity":"Quantité","draftOrder_Price":"Prix","noDraftOrderProducts":"Aucun projet de détails sur le produit disponible.","noRefundOrderProduct":"Aucune commande de remboursement des détails du produit disponibles.","loading":"Chargement...","dashboard_commissionOn_profitMargin":"Commission sur la marge bénéficiaire","dashboard_clientInvoice":"Facture client","dashboard_affiliateLink":"Ordre d\'affiliation","dashboard_returnCustomer":"Client de retour","dashboard_discountCoupon":"Coupon de réduction","dashboard_SharedCart":"Panier partagé","dashboard_AdminTaggedOrders":"Commande taguée par l\'administrateur","dashboard_no_data":"Pas de données disponibles","dashboard_sales_of_last_six_months":"Ventes des 6 derniers mois","dashboard_sales_of_current_month":"Ventes du mois en cours","addCustomer_ErrorMsgOnSubmitBtn":"s\'il vous plaît entrer un numéro de téléphone valide","login_welcome_Msg":"Bienvenue dans l\'équipe de vente","login_title":"Connexion","login_email":"ID de messagerie","login_password":"Mot de passe","emailValidation_ErrorMsg":"Veuillez saisir l\'ID de messagerie valide","login_newUser":"Nouvel utilisateur?","login_SignUp":"S\'inscrire","login_forgotPassword_link":"Mot de passe oublié?","login_LogInBtn":"Connexion","login_sliderContent_1":"Repins passant le nom des clients","login_sliderContent_2":"Le trafic de conduite du représentant pour stocker","login_sliderContent_3":"Produits de commercialisation du représentant utilisant des plateformes de médias sociaux","login_sliderContent_4":"Le représentant peut acheter en vrac et réaliser des bénéfices","login_sliderContent_5":"Repins passant le nom des clients","login_sliderContent_6":"Les représentants peuvent visiter les clients en personne et créer des commandes","required_ErrorMsg":"Veuillez remplir le champ requis","signup_title":"S\'inscrire","signup_BackTo_login":"Retour connexion","signup_firstName":"Prénom","signup_lastName":"Nom de famille","signup_BackBtn":"Retour","signup_NextBtn":"Prochain","signup_phone_number":"Numéro de téléphone","signup_phone_number_Error":"Veuillez entrer au moins 10 chiffres","signup_uploadPicture":"Télécharger la photo du profil","signup_fileSizeError":"La taille du fichier est supérieure à 5 Mo","signup_filePath_lable":"Fichier sélectionné","signup_MediaTitle2":"Liens de médias sociaux","signup_facebookHandle":"Manche Facebook","signup_InstaHandle":"Poignée Instagram","signup_SaveBtn":"Enregistrer les détails","forgotPwd_title":"Mot de passe oublié","forgotPwd_ResetBtn":"réinitialiser le mot de passe","forgotPwd_SuccessMsg":"Votre demande de mot de passe de réinitialisation est réussie, nous avons envoyé le nouveau mot de passe à votre identifiant de messagerie enregistré.","customerInvoice_selectShippingCost":"Sélectionnez les frais d\'expédition","customerInvoice_CalculatingShippingRates_Msg":"Calculateur...","customerInvoice_AddShippingAddress_Msg":"Sélectionnez une adresse ou ajoutez une adresse de livraison","customerInvoice_PleaseSetAnyShippingAddressMsg":"Veuillez sélectionner une adresse de livraison","customerInvoice_ShippingCostErrorMsg":"Veuillez ajouter une nouvelle adresse de livraison, car l\'adresse contient des informations insuffisantes.","customerInvoice_CalculateShippingCost_Btn":"Calculer les frais d\'expédition","customerInvoice_ShippingCostAddOrNot_Msg":"Souhaitez-vous ajouter des frais de port?","customerInvoice_ShippingCostAddOrNot_Yes":"Oui","customerInvoice_ShippingCostAddOrNot_No":"Non","customerInvoice_ShippingCostIsUnavailable":"Fraktkostnaden för denna adress är inte inställd från administratörssidan. Även om beställningar kan göras utan att beräkna fraktkostnaden.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Veuillez réessayer","dashboard_BannerMsg":"Les graphiques sont mis à jour toutes les 8 heures","yourSales__BannerMsg":"Les détails de la commande sont mis à jour toutes les 5 minutes","customerInvoice_FirstNameErrorMsg":"Veuillez entrer le prénom","customerInvoice_lastNameErrorMsg":"Veuillez entrer le nom de famille","customerInvoice_Add1ErrorMsg":"Veuillez entrer la ligne d\'adresse 1","customerInvoice_CountryErrorMsg":"Veuillez sélectionner le pays","customerInvoice_StateErrorMsg":"Veuillez sélectionner l\'état","customerInvoice_CityErrorMsg":"Veuillez entrer le nom de la ville","customerInvoice_ZipErrorMsg":"Veuillez entrer le code postal","uploadImage":"Télécharger une image","dashboard_CardTitle1":"Commission sur toutes les commandes","dashboard_CardTitle3":"Commission totale","dashboard_TotalRevenue":"Revenu total","dashboard_TotalAvg_Ticket_Size":"Taille du billet AVG","dashboard_CardTitle4":"Ventes totales","profile_Change_Password":"Changer le mot de passe","dashboard_Information_Message":"La commission est suivie uniquement pour les commandes payantes","resetPassword_validation_Msg":"Ce champ est obligatoire","resetPassword_validation_Msg2":"Le mot de passe doit contenir un minimum de 8 caractères, 1 majuscule, 1 minuscules, 1 chiffre, etc.","resetPassword_validation_Msg3":"Confirmer le mot de passe devrait correspondre avec un nouveau mot de passe","dashbord_Msg_New":"Comment ça fonctionne","dashbord_informationMsg":"Information","discount_couponErrorMsg":"La remise maximale n\'est pas configurée. Veuillez contacter le site Admin.","discount_couponErrorMsg2":"La commission n\'est pas configurée. Veuillez contacter le site Admin.","dashbord_profile_pic":"Changer pic profil","Performance_Details":"Détails de performance","Show_Performance_Details":"Afficher les détails des performances","Dashboard_Month":"Mois","Dashboard_Orders_Total":"Commandes totales","Dashboard_Total_Sale":"Vente totale","Dashboard_Commission":"Commission","Dashboard_Bonus":"Prime","customerInvoice_EditOrder_NoAutoSelectedAddress":"Veuillez ajouter l\'adresse du client.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Veuillez cliquer sur le bouton Calculer les frais d\'expédition et en sélectionner un.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Panier non mis à jour, veuillez actualiser et réessayer.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Veuillez sélectionner un produit.","customerInvoice_CreatingDraft_Msg":"Création de brouillon..","customerInvoice_DraftOrderBtn":"Projet d\'ordonnance","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Projet de commande créé avec succès","productTable_error_AlertMsg":"La quantité ne peut pas être 0 ou moins, veuillez saisir une valeur valide","productTable_error_AlertMsg2":"Veuillez saisir la quantité","click_to_copy":"Cliquez pour copier","discount_code_copy_coupon":"Coupon de copie","createOrder_productSearchGuide":"Impossible de trouver des produits?","soldOut":"Épuisé","InventoryNotTracked":"Inventaire non suivi","productStatus":"État du produit","makeSureInShopify":"Assurez-vous dans Shopify","products":"Des produits","sectionTheProductStatusIs":"section, l\'état du produit est","active":"Active","productsMayBeSoldOutPleaseCheck":"Les produits peuvent être épuisés, veuillez vérifier et sélectionner","Credit_Limit_Error_Msg":"Le plafond de crédit est dépassé, veuillez réessayer..!"}'
        ),
        It = JSON.parse(
          '{"dashboard_title":"CRUSCOTTO","dashboard_morningMsg":"Buon giorno","dashboard_afternoonMsg":"Buon pomeriggio","dashboard_welcomeMsg":"Benvenuto/a in","dashboard_eveningMsg":"Buona sera","dashboard_subTitle1":"Mese corrente","dashboard_block1Heading":"ORDINI RETAIL","dashboard_block1Header1":"PROFITTI","dashboard_block1Header2":"FATTURA INVIATA","dashboard_block1Header3":"FATTURA PAGATA","dashboard_block2Heading":"ORDINI ALL\'INGROSSO","dashboard_block2Header1":"PROFITTI","dashboard_block2Header2":"FATTURA INVIATA","dashboard_block2Header3":"FATTURA PAGATA","dashboard_block3Heading":"ORDINI AFFILIATI","dashboard_block3Header1":"PROFITTI","dashboard_block3Header2":"ORDINI PAGATI","dashboard_block4Heading":"COUPON SCONTO","dashboard_block4Header1":"PROFITTI","dashboard_block4Header2":"ORDINI PAGATI","dashboard_block5Heading":"PROVVIGIONE CLIENTE","dashboard_block5Header1":"PROVVIGIONE","dashboard_block5Header2":"ORDINI","dashboard_block6Heading":"PROVVIGIONE CAPO VENDITA","dashboard_block6Header1":"PROVVIGIONE","dashboard_block7Heading":"PROVVIGIONE POS","dashboard_block7Header1":"PROVVIGIONE","dashboard_block7Header2":"ORDINI","dashboard_tbl1column1":"Mese","dashboard_tbl1column2":"Ordini retail","dashboard_tbl1column3":"Provvigione retail","dashboard_tbl1column4":"Ordini ingrosso","dashboard_tbl1column5":"Totale acquisti all ingrosso","dashboard_tbl1column6":"Ordini affiliati","dashboard_tbl1column7":"Provvigione affiliati","dashboard_tbl1column8":"Ordini con codice coupon","dashboard_tbl1column9":"Provvigione codice coupon","dashboard_tbl1column10":"Ordini clienti","dashboard_tbl1column11":"Provvigione clienti","dashboard_tbl1column12":"Ordini POS","dashboard_tbl1column13":"Provvigione POS","dashboar_cardHeading1":"Totale ordine","dashboar_cardHeading2":"Provvigione","dashboar_cardHeading3":"Vendite","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Riepilogo vendite degli ultimi sei mesi","dashboard_graphHeading2":"Analizza ordini e provvigioni per tipologia - mese corrente","Graph_Sales_noorderstitle":"Nessun ordine da mostrare","Graph_SalesRepCommission_nocommissiontitle":"Nessun dato provvigione da mostrare","Graph_SalesRepOrders_title":"ORDINI","Graph_SalesRep_XAxisTitle_ForMonth":"6 mesi","Graph_SalesRepOrders_YAxisTitle":"Ordini","Graph_SalesRepSales_title":"VENDITE","Graph_SalesRepCommission_title":"PROVVIGIONE","Graph_SalesRepCommissions_YAxisTitle":"Provvigione","Graph_FeatureWiseOrder_title":"Ordini vs funzione","Graph_featureWiseCommission_title":"Funzione Commissione vs","Graph_FeatureWiseOrder_XAxisTitle":"Tipologia","Graph_FeatureWiseOrder_YAxisTitle":"Ordini","Graph_FeatureWiseCommission_title":"PROVVIGIONI","Graph_FeatureWiseCommission_YAxisTitle":"Provvigione","customerInvoice_title":"Crea ordine","customerInvoice_button":"Indietro","customerInvoice_noclientorderMsg":"Nessun ordine retail","customerInvoice_button1":"Vedi ordini precedenti","customerInvoice_contentHeading1":"Sconto e provvigione su","customerInvoice_table1column1":"Tipo prodotto","customerInvoice_table1column2":"Provvigione","customerInvoice_table1column3":"Nome sconto","customerInvoice_table1column4":"Sconto","customerInvoice_contentHeading2":"Inserisci dati cliente e seleziona i prodotti per inviare fattura","customerInvoice_contentHeading2Title1":"Entra/Cerca cliente","customerInvoice_title1Placeholder":"Entra/Cerca cliente","customerInvoice_contentHeading2Title2":"email_ID del cliente","customerInvoice_title2Placeholder":"Indirizzo email","customerInvoice_contentHeading2Title3":"Inserisci note dell\'ordine","customerInvoice_contentHeading2Title4":"Indirizzo cliente","customerInvoice_contentHeading2Title5":"Cellulare cliente","customerInvoice_contentHeading2Title6":"Note cliente","customerInvoice_Placeholder_contentHeading2Title6":"Note","customerInvoice_Placeholder_contentHeading2Title5":"Cellulare","customerInvoice_Placeholder_contentHeading2Title4":"Indirizzo di spedizione","customerInvoice_title3Placeholder":"Note dell\'ordine","customerInvoice_SearchProducts_Label":"Cerca prodotti","customerInvoice_table2Column1":"Immagine","customerInvoice_table2Column2":"Aggiungi quantità","customerInvoice_table2Column3":"Titolo","customerInvoice_table2Column4":"Variante Titolo","customerInvoice_ProductTableColumnPrice":"Prezzo","customerInvoice_ProductTableColumnWholeSalePrice":"Prezzo Ingrosso","customerInvoice_button2":"Crea fattura","customerInvoice_ProductTableColumnProduct":"Prodotto","customerInvoice_table3Column2":"Nome prodotto","customerInvoice_table3Column3":"Provenienza","customerInvoice_ProductTableColumnQuantity":"Quantità","customerInvoice_table3Column5":"Prezzo unitario","customerInvoice_table3Column6":"Prezzo totale","customerInvoice_table3Column7":"Prezzo scontato per cliente","customerInvoice_table3Column8":"Provvigione venditore","customerInvoice_table3Column9":"Tipo sconto","customerInvoice_repproInvite":"Seleziona casella per inviare ","customerInvoice_customerOrder_error1":"tutti i campi cliente sono obbligatori. Inserisci email e nome del cliente","customerInvoice_productAddedMsg":"Prodotto aggiunto","customerInvoice_AlertErrorMsg":"Errore..Si prega di contattare l\'assistenza!","cartSharing_Select_product_Title":"Seleziona il prodotto","wholesaleOrder_title":"Ordine ingrosso","wholesaleOrder_contentHeading1":"Puoi acquistare prodotti a prezzi speciali all\'ingrosso","wholesaleOrder_contentHeading2":"Sconto su","wholesaleOrder_column1":"Nome venditore","wholesaleOrder_column2":"Sconto","wholesaleOrder_searchtxtPlaceholder":"Cerca prodotto","wholesaleOrder_table1Column1":"Immagine","wholesaleOrder_table1Column2":"Aggiungi quantità","wholesaleOrder_table1Column3":"Titolo","wholesaleOrder_table1Column4":"Variante Titolo","wholesaleOrder_table1Column5":"Prezzo","wholesaleOrder_button":"Check Out","wholesaleOrder_Order_btn":"Mostra/Nascondi listino volumi","wholesaleOrder_contentHeading3":"Prezzo totale","wholesaleOrder_contentHeading4":"Il tuo prezzo scontato","wholesaleOrder_table2Column1":"Prodotto","wholesaleOrder_table2Column2":"Nome prodotto","wholesaleOrder_table2Column3":"Provenienza","wholesaleOrder_table2Column4":"Quantità","wholesaleOrder_table2Column5":"Prezzo unitario","wholesaleOrder_table2Column6":"Prezzo totale","wholesaleOrder_table2Column7":"Il tuo prezzo scontato","affiliateLink_title":"Collegamento affiliato","affiliate_product_link":"Link del prodotto","affiliateLink_input_error_msg":"Il campo di testo del collegamento è obbligatorio e non deve contenere spazi.","affiliateLink_contentHeading1":"Condividi il tuo collegamento affiliato sui social media e via email. Riceverai una provvigione affiliato per ogni ordine ricevuto dal tuo collegamento","affiliateLink_contentHeading2":"Il tuo collegamento affiliato","affiliateLink_contentHeading3":"Provvigione su","affiliateLink_noaffiliateorderMsg":"Nessun ordine affiliato","affiliateLink_column1":"Nome venditore","affiliateLink_column2":"Provvigione","affiliateLink_searchtxtPlaceholder":"Cerca prodotto","affiliateLink_searchColumn1":"Prodotto","affiliateLink_searchColumn2":"Titolo prodotto","affiliateLink_searchColumn3":"Prezzo","affiliateLink_searchColumn4":"Provvigione","affiliateLink_searchColumn5":"Collegamento affiliato","affiliateLink_backbtn":"Indietro","affiliateLink_card_Title":"Contatto Card & Affiliate Link","cartSharing_title":"Condivisione del carrello","cartSharing_CreateCartInformation_Text":"Per creare un carrello condivisibile personalizzato, aggiungi i prodotti dalla vetrina. I prodotti verranno mostrati in questa pagina","cartSharing_content2Placeholder":"Nome carrello","cartSharing_table2Column2":"Prodotto","cartSharing_table2Column3":"Provenienza","cartSharing_table2Column6":"Prezzo totale","cartSharing_SharedCartLinkTableColumnCartName":"Nome cartello","cartSharing_SharedCartLinkTableColumnLink":"Collegamento","cartSharing_SharedCartLinkTableColumnCartLink":"Link al carrello condivisibile","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copia collegamento carrello","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Cancella collegamento carrello","cartSharing_EnterCartName_Label":"Nome carrello","cartSharing_ProductTableColumnProduct":"Prodotto","cartSharing_ProductTableColumnQuantity":"Quantità","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Prezzo unitario","cartSharing_CartCreating_Msg":"Creazione...","cartSharing_Copied_Msg":"Copiato!!","cartSharing_SharedCartLinkTableEmpty_Msg":"Nessun collegamento da mostrare","cartSharing_CartCreatedSuccessfully_Msg":"Carrello creato con successo","cartSharing_CartCreateError_Msg":"Errore... per favore riprova","cartSharing_AlertError_Msg":"Errore..Si prega di contattare l\'assistenza!","cartSharing_CopyCartLink_Msg":"Copia collegamento carrello","cartSharing_DeleteCartLink_Msg":"Cancella collegamento carrello","cartSharing_DeleteConfirmation_Msg":"Sei sicuro ?","cartSharing_ProductTableEmpty_Msg":"Prodotto non disponibile","cartSharing_CreateCart_Btn":"Crea carrello","cartSharing_ProductTableQuantityUpdate_Btn":"Si prega di selezionare il prodotto","discountCoupon_titleOne":"Coupon sconto","discountCoupon_contentHeading1":"Condividi il codice del buono sconto con i tuoi clienti e ogni volta che il tuo coupon viene utilizzato ricevi una commissione.","discountCoupon_contentHeading2":"Il tuo codice coupon è","discountCoupon_contentHeading3":"Valore sconto","discountCoupon_contentHeading4":"Provvigione","discountCoupon_contentHeading4PlaceHolder1":"Ehi, usa il mio codice coupon sconto","discountCoupon_contentHeading4PlaceHolder2":"e ottieni prodotti scontati","discountCoupon_button1":"Copia testo","discountCoupon_titleTwo":"Crea coupon sconto univoci per i clienti","discountCoupon_button2":"Visualizza coupon","discountCoupon_contentHeading5":"Sconto massimo consentito","discountCoupon_contentHeading6":"Provvigione","discountCoupon_contentHeading7":"Inserisci codice coupon","cartSharing_copiedButtonText":"Copiato","discountCoupon_contentHeading7PlaceHolder":"Inserisci codice coupon","discountCoupon_contentHeading8":"Inserisci sconto","discountCoupon_contentHeading8PlaceHolder":"Lo sconto non deve essere maggiore dello sconto massimo.","discountCoupon_button3":"Crea coupon","discountCoupon_coupon_error1":"Inserisci codice coupon e sconto","yourBio_title":"Il tuo biglietto da visita","yourBio_content1":"Carica profilo","yourBio_button1":"Seleziona file","yourBio_button1PlaceHolder":"Nessun file selezionato","yourBio_button2":"Carica","yourBio_content2":"Inserisci il tuo testo per creare il tuo collegamento univoco di affiliato","yourBio_content2PlaceHolder":"crea il tuo collegamento affiliato univoco","yourBio_content4":"Quando il tuo collegamento verrà usato il tuo biglietto da visita apparirà","yourBio_content3":"Inserisci il tuo biglietto da visita","yourBio_error_image_size":"La dimensione dell\'immagine è troppo grande, carica un\'immagine inferiore a 5 MB. Per favore riprova.","yourBio_content3PlaceHolder":"Inserisci in 100 parole","yourBio_button3":"Salva","yourBio_button4":"Salvato","yourBio_error_link":"Questo collegamento univoco è già stato utilizzato. Prova con un nuovo collegamento univoco","yourBio_Linksuccessmsg":"Collegamento univoco salvato con successo","team_title1":"Aggiungi venditore","team_content1":"Inserisci email","team_content1PlaceHolder":"Indirizzo email","team_emailerrorMsg":"Inserisci indirizzo email","team_content2":"Nome","team_content2PlaceHolder":"Nome","team_fnameerrorMsg":"Inserisci nome","team_content3":"Cognome","team_content3PlaceHolder":"Cognome","team_button1":"Carica","team_successmsg":"Inserimento corretto! Controlla la tua email per le istruzioni di attivazione","team_errorsmsg":"Errore nell\'inserimento. Questa email è già stata registrata nello store","team_title2":"Dettagli del team","team_content4":"Pagina di iscrizione","team_NoTeamDetailsMsg":"Nessun dettaglio di team","team_content5":"Seleziona venditore","team_tableTitle":"DETTAGLI ORDINI DEGLI ULTIMI DUE MESI","team_column1":"Numero ordine","team_column2":"Data ordine","team_column3":"Nome cliente","team_column4":"Venditore","team_column5":"Subtotale","team_column6":"Provvigione Venditore","team_column7":"Provvigione Capo Vendita","team_column8":"Tipo provvigione","addCustomer_title":"Carica cliente","addCustomer_content1":"Cliente nome","addCustomer_txt1Placeholder":"Nome","addCustomer_content2":"Cliente cognome","addCustomer_content2Placeholder":"Cognome","addCustomer_content3":"Cliente email_ID","addCustomer_content3Placeholder":"Indirizzo email","addCustomer_content4":"Note","addCustomer_content4Placeholder":"Note","addCustomer_customerAddress":"Indirizzo privato","addCustomer_customerCity":"Città","addCustomer_customerCityPlaceholder":"Città","addCustomer_customerCountry":"Stato","addCustomer_customerState":"Provincia","addCustomer_customerZipCode":"CAP","addCustomer_companyName":"Nome azienda","addCustomer_companyAddress":"Indirizzo azienda","addCustomer_companyCity":"Città","addCustomer_companyCountry":"Stato","addCustomer_companyState":"Provincia","addCustomer_companyZipCode":"CAP","addCustomer_button":"Salva","addCustomer_leadsuccessmsg":"Il cliente è stato caricato con successo","addCustomer_leadErrrorMsg":"Errore nel salvataggio dati","addCustomer_leadEmptyErrrorMsg":"Compila i campi indicati","addCustomer_leadsuccessmsg2":"Cliente creato e associato a venditore","addCustomer_leadErrrorMsg2":"Questo cliente è già associato a un venditore","myCustomers_title":"I tuoi clienti","myCustomers_table1Column1":"Nome","myCustomers_table1Column2":"Nome azienda","myCustomers_table1Column3":"email","myCustomers_table1Column4":"Oordini","myCustomers_table1Column5":"Totale speso","myCustomers_table2Title":"DETTAGLI CLIENTI","myCustomers_table3Title":"DETTAGLI COPIA COMMISSIONE","myCustomers_table3Column1":"Prodotto","myCustomers_table3Column2":"Provenienza","myCustomers_table3Column3":"Quantità","myCustomers_table3Column4":"Prezzo","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Subtotale","myCustomers_table2Row1":"Nome","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Indirizzo","myCustomers_table2Row4":"Nome azienda","myCustomers_table2Row5":"Note cliente","myCustomers_table2Row6":"Totale spesa (Subtotale + IVA)","myCustomers_table2Row7":"Numero degli ordini","myCustomers_table2Row8":"Tags","myCustomers_radioButton0":"Mostra tutti i clienti","myCustomers_radioButton1":"Cerca per Nome Cliente","myCustomers_radioButton2":"Cerca per Azienda","myCustomers_radioButtonError1":"Seleziona tipo di ricerca e valore da cercare","myCustomers_radioButtonError2":"Inserisci valore da cercare","myCustomers_radioButtonError3":"Seleziona tipo ricerca","myCustomers_searchButton":"Cerca","myCustomers_Placeholder1":"Inserisci nome cliente o nome azienda da cercare","myCustomers_NoOrdersError":"Nessun ordine","myCustomer_no_salesRep_details":"Nessun dettaglio del rappresentante di vendita disponibile.","myCustomer_select_customer_country":"Seleziona il paese del cliente","myCustomer_company_country":"Paese aziendale","myCustomer_company_state":"Stato aziendale","myCustomer_select_company_country":"Seleziona il paese dell\'azienda","yourSales_SalesOrderDetailsTitle":"Dettagli dell\'ordine di vendita","yourSales_title":"Dettagli dell\'ordine degli ultimi 2 mesi","yourSales_table1Column1":"Numero ordine","yourSales_table1Column2":"Data ordine","yourSales_table1Column3":"Nome cliente","yourSales_table1Column4":"Subtotale","yourSales_table1Column5":"Provvigione","yourSales_table1Column6":"Tipo provvigione","yourSales_table1Column7":"Stampa fattura","printOrderInvoice_btn":"Stampa fattura","yourSales_tableTitle":"DETTAGLI PRODOTTO","yourSalesDraft_tableTitle":"DETTAGLI COPIA COMMISSIONE","yourSales_column1":"Prodotto","yourSales_column2":"Titolo","yourSales_column3":"Quantità","yourSales_column4":"Prezzo unitario","yourSales_column5":"Tracking Number","yourSales_column6":"Data spedizione","yourSales_column7":"Prezzo totale","yourSales_content1":"Subtotale","yourSales_content2":"IVA","yourSales_content3":"Contributo trasporto","yourSales_content4":"Totale","yourSales_content5":"Note","yourSales_tabHeading1":"Ordini pagati","yourSales_tabHeading4":"Ordini in sospeso","yourSales_tabHeading2":"Copie commissioni","myOrders_title":"Dettaglio dei miei ordini personali","myOrdersDetails_Message":"Ordini fatti per te stesso","myOrders_table1Column1":"Numero ordine","myOrders_table1Column2":"Data ordine","myOrders_table1Column3":"Nome cliente","myOrders_table1Column4":"Pagamento","myOrders_table1Column5":"Stato di evasione","myOrders_table1Column6":"Totale","myOrders_tableTitle":"DETTAGLI PRODOTTO","myOrders_table2Column1":"Prodotto","myOrders_table2Column2":"Titolo","myOrders_table2Column3":"Quantità","myOrders_table2Column4":"Prezzo unitario","myOrders_table2Column5":"Tracking Number","myOrders_table2Column6":"Data spedizione","myOrders_table2Column7":"Prezzo totale","myOrders_content1":"Subtotale","myOrders_content2":"IVA","myOrders_content3":"Contributo trasporto","myOrders_content4":"Totale","myOrders_content5":"Note","myOrders_content6":"ID copia commiss.","tab_Dashboard":"Cruscotto","dashbord_Tab":"Casa","tab_CustomerInvoice":"Crea ordine","tab3_WholesaleOrder":"Ordine ingrosso","tab_AffiliateLink":"Collegamento affiliato","tab_CartSharing":"Condivisione del carrello","tab_DiscountCoupon":"Coupon sconto","tab7_YourBio":"Il tuo biglietto da visita","tab8_Team":"Team","tab9_AddCustomer":"Aggiungi cliente","tab_MyCustomers":"I miei clienti","tab_YourSalesOrderDetails":"Dettagli dei tuoi ordini di vendita","tab12_MyOrders":"Dettagli dei miei ordini","tab13_Logout":"Logout","signUp_title":"Iscrizione venditore","signUp_subTitle":"Compila questo modulo per iscriverti come venditore e oyyieni accesso a tutte le funzionalità team di vendita","signUp_content1":"Email","signUp_content2":"Nome","signUp_content3":"Cognome","signUp_content4":"Telefono","signUp_content5":"Profilo facebook","signUp_content6":"Profilo twitter","signUp_content7":"Profilo instagram","signUp_content8":"Carica immagine profilo","signUp_socialmedialable1":"Collegamenti social media","signUp_socialmedialable2":"opzionale","signUp_uploadBtn":"Scegli file","signUp_uploadBtnPlaceHolder":"Nessun file scelto","signUp_button3":"sto salvando…","signUp_welcomemsg1":"Salve","signUp_welcomemsg2":"Registra venditori sotto di te e ottieni una provvigione sulle vendite da questi generate","signUp_emailerror":"Inserisci email","signUp_Fnameerror":"Inserisci nome","signUp_lnameerror":"Inserisci cognome","signUp_phnumbererror":"Inserisci numero telefono","signUp_successmsg":"La tua richiesta è stata registrata correttamente, riceverai presto la mail per attivare l\'account dopo l\'approvazione della tua richiesta","signUp_errorsmsg":"Errore nel salvataggio dei dettagli. Questa email ha già un account associato nello store","signUp_RepExistErrorMsg":"Questa email è già registrata come venditore","addingRep_selectRepsLabel1":"Chi ti ha aiutato?","addingRep_NoSalesRep":"Nessun venditore","addingRep_successMsg":"Risposta aggiunta alle note carrello","addingRep_selectRepsLabel2":"Seleziona un oggetto dalla lista","wholesaleOrder_WholesaleDiscountTableColumn1":"Titolo prodotto","wholesaleOrder_WholesaleDiscountTableColumn2":"Sconto","customerInvoice_ViewClientOrdersColumn1":"Nome cliente","customerInvoice_ViewClientOrdersColumn2":"Titolo prodotto","customerInvoice_ViewClientOrdersColumn3":"Subtotale","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Fattura","salesRep_order_errorMsg":"Errore nella creazione del tuo ordine. Contatta il supporto","salesRep_order_successMsg":"Ordine creato con successo! Il documento è stato inviato al cliente","salesRep_order_errorMsg2":"Errore nella creazione del tuo ordine. Contatta il supporto","customedraft_btn1":"Crea nuova fattura","customedraft_btn2":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","customedraft_btn3":"Creazione ordine…","customedraft_btn4":"Crea nuova fattura","salesRep_order_NoProductSelected":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","productnotselectforcartsharingtxt1":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","discountCoupons_tblColumn1":"Codice coupon","discountCoupons_tblColumn2":"Sconto coupon","discountCoupons_tblColumn3":"Cancella codice coupon","discountedPriceLabel":"Il tuo prezzo scontato:","couponCodeNotSet":"Codice coupon non inizializzato","dashboard_subTitle2":"Ciclo mese corrente: dal gg. 5 al gg. 4","affiliatelink_commissiononlbl":"Prodotto","displaycommission_lbl1":"Tipo prodotto","displaycommission_lbl2":"Venditore","displaycommission_lbl3":"Sconto quantità","discountcommissiononlbl1":"Livelli di sconto cliente","clientInvoiceCommissionTablecolumn1":"Tipo prodotto","clientInvoiceCommissionTablecolumn2":"Provvigione","clientInvoiceCommissionTablecolumn3":"Titolo prodotto","clientInvoiceCommissionTablecolumn4":"Nome venditore","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nome prodotto","clientInvoiceQuantityBaseDiscountTablecolumn2":"Sconto","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantità","affiliateCartProdtableColumn1":"Prodotto","affiliateCartProdtableColumn2":"Titolo prodotto","affiliateCartProdtableColumn3":"Prezzo","affiliateCartProdtableColumn4":"Provvigione","affiliateCartProdtableColumn5":"Collegamento affiliato","affiliateCartProdtableColumn6":"Condividi collegamento","productnotselectforcartsharinglbl1":"Inserisci nome carrello","productnotselectforcartsharinglbl2":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","productnotselectforcartsharinglbl3":"Attendi elaborazione in corso…","showSharedCartProductcolumn1":"Collegamento carrello","showSharedCartProductcolumn3":"Rimuovi carrello","onSuccessInvoiceSuccessMsg":"Fattura inviata correttamente","onSuccessInvoiceFailedMsg":"Invio fattura non riuscito","sendInvoice_successMsg":"Fattura inviata correttamente","deleteInvoice_successMsg":"Fattura cancellata correttamente","deleteInvoice_FailedMsg":"Cancellazione fattura non riuscita","deleteInvoice_btnlbl":"Cancellazione fattura","deleteSharedCartLink_successMsg":"Collegamento cancellato correttamente","deleteSharedCartLink_FailedMsg":"Errore nella cancellazione collegamento. Riprova..","deleteSharedCartLink_btnlbl":"Cancello collegamento","viewInvoiceOrders_btntxt1":"Attesa…","viewInvoiceOrders_btntxt2":"Vedi ordini precedenti","createCoupon_btnlbl1":"Creazione coupon..","createCoupon_btnlbl2":"Coupon creato","deleteCoupon_successMsg":"Coupon cancellato","deleteCoupon_FailedMsg":"Cancellazione coupon non riuscita","deleteCoupon_btnlbl":"Cancellazione...","viewProductModelColumn1":"Prodotto","viewProductModelColumn2":"Titolo","viewProductModelColumn3":"Quantità","viewProductModelColumn4":"Importo rimborsato","viewProductModelColumn5":"Prezzo unitario","viewProductModelColumn6":"Prezzo scontato","viewProductModelColumn7":"Tracking Number","viewProductModelColumn8":"Data di spedizione","viewProductModelColumn9":"Prezzo totale","showSharedCartProducts_column2":"Immagine","showSharedCartProducts_column3":"Aggiungi quantità","showSharedCartProducts_column4":"Titolo","showSharedCartProducts_column5":"Titolo variante","showSharedCartProducts_column6":"Prezzo","viewClientOrders_btn1":"Vista","viewClientOrders_btn2":"Invia","viewClientOrders_btn3":"Cancella","showCouponTable_txt1":"Attesa..","showCoupon_btn2":"Vedi coupon","showCoupon_btn1":"Copiato","affliateOrder_column1":"Nome cliente","affliateOrder_column2":"Email cliente","affliateOrder_column3":"Titolo prodotto","affliateOrder_column4":"Data ordine","affliateOrder_column5":"Subtotale","affliateOrder_column6":"Provvigione","affliateOrder_btn1":"Attesa…","affliateOrder_btn2":"Vedi ordini affiliati","affliateOrder_btn3":"Vedi ordini affiliati","yourBio_btn1":"Salva","yourBio_btn2":"Salva","yourBio_Uploadbtn1":"Caricamento…","yourBio_Uploadbtn2":"Caricato","yourBio_UploadbtnError":"Errore, riprova","yourBio_Savebtn":"Salvataggio in corso..","team_txt1":"Salvataggio in corso..","team_txt2":"Salva","viewRepClientOrdersDetails_column1":"Numero ordine","viewRepClientOrdersDetails_column2":"Data ordine","viewRepClientOrdersDetails_column3":"Subtotale","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Dettagli prodotto","addSalesRep_txt1":"Aggiungi venditore","addSalesRep_txt2":"Sto aggiungendo venditore…","discountCoupons_header":"Coupon sconto una tantum","discountCoupons_nodiscountcoupon":"Non hai creato nessun coupon sconto","discountCoupons_deleteBtn":"Cancella","discountCoupons_BackBtn":"Indietro","customerInvoice_selectcustomererror":"Seleziona il cliente e poi aggiungi il prodotto","createOrderFromCartPage_selectCustomersLabel":"SELEZIONA CLIENTE","createOrderFromCartPage_selectCustomerAddressLabel":"INDIRIZZO DI SPEDIZIONE","createOrderFromCartPage_selectCustomersLabelForDropDown":"Seleziona cliente","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Selezione indirizzo","createOrderFromCartPage_successMsg":"Ordine creato correttamente. Il documento è stato inviato via email al cliente","createOrderFromCartPage_toggleButton":"Aggiungi nuovo indirizzo di spedizione","createOrderFromCartPage_AddNewAddressTitle":"AGGIUNGI NUOVO INDIRIZZO","createOrderFromCartPage_customer_errorMsg1":"Nessun cliente selezionato. Seleziona cliente e riprova","createOrderFromCartPage_order_errorMsg1":"Nessun prodotto selezionato. Seleziona prodotto e riprova","createOrderFromCartPage_Address_errorMsg2":"Seleziona un indirizzo e riprova","createOrderFromCartPage_Address_errorMsg3":"Compila tutti i campi indirizzo","createOrderFromCartPage_Order_errorMsg2":"Errore nella creazione del tuo ordine. Contatta il supporto","createOrderFromCartPage_draftOrderButton":"CREA COPIA COMMISSIONE","createOrderFromCartPage_OrderButton":"CREA ORDINE","createOrderFromCartPage_draftOrderButtonText2":"STO CREANDO L\'ORDINE...","createOrderFromCartPage_selectShippingCostTitle":"CONTRIBUTO TRASPORTO","createOrderFromCartPage_selectShippingCost":"Seleziona la tariffa di spedizione","createOrderFromCartPage_Address_errorMsg4":"C\'è un problema nel conteggio delle tariffe di trasporto","createOrderFromCartPage_Address_errorMsg5":"Qualcosa non ha funzionato, riprova più tardi","customerInvoice_contentHeading2Title7":"Nome azienda cliente","customerInvoice_title7Placeholder":"Nome della ditta","affiliateLink_content_Message1":"Cerca prodotti e condividi il link dei singoli prodotti con i tuoi clienti.","dashboard_subTitle3":"Dettagli della Commissione","dashboard_cardHeading5_1":"Commissione su","dashboard_cardHeading5_2":"Otterrai un","dashboard_cardHeading5_3":"commissione su tutti gli ordini.","dashboard_cardHeading5_4":"Riceverai una commissione in base ai prodotti che vendi","dashboard_cardHeading5_5":"Riceverai una commissione in base ai tipi di prodotto","show_commission_list":"Mostra l\'elenco delle commissioni","no_link_to_show":"Nessun collegamento da mostrare","no_customers_to_show":"Nessun cliente da mostrare","no_sales_to_show":"Nessuna vendita da mostrare","no_draft_to_show":"Nessuna bozza da mostrare","no_refund_to_show":"Nessun rimborso da mostrare","no_orders_to_show":"Nessun ordine da mostrare","yourSales_tabHeading3":"Ordini di rimborso","affiliateLink_searchColumn7":"Copia link","affiliateLink_searchColumn8":"copiato","customerInvoice_ViewClientOrdersColumn6":"Numero d\'ordine","customerInvoice_ViewClientOrdersColumn7":"Data dell\'ordine","Error_commissions_NotUpdated":"Le commissioni non sono aggiornate","Profit_Margin":"Margine di profitto","Product_Type":"Tipologia di prodotto","Sales_Rep":"Rappresentante delle vendite","commission_list":"Elenco delle commissioni","refundOrderNumber_title":"Dettagli dell\'ordine di rimborso","refundOrders_column1":"Rimborso Id","refundOrders_column2":"Data dell\'ordine","refundOrders_column3":"Numero d\'ordine","refundOrders_column4":"Nome ordine","refundOrders_column5":"Commissione","refundOrders_column6":"Commissione Team Manager","refundOrders_column7":"ID del team manager","refundOrders_column8":"Rimborso totale parziale","refundOrders_column9":"Stato dell\'ordine","refundOrders_column10":"Tipo di ordine","refundOrderNumber_column1":"Nome","refundOrderNumber_column2":"Data","refundOrderNumber_column3":"Quantità","refundOrderNumber_column4":"Prezzo scontato","refundOrderNumber_column5":"Totale parziale","sales_chart_msg1":"Abbiamo bisogno di dati...","sales_chart_msg2":"Sembra che non abbiamo ancora dati da mostrare.","page_refresh_msg":"fare clic per aggiornare","variant_title":"Titolo variante","line_items_properties":"proprietà","customer_country":"Paese cliente","customer_state":"Stato cliente","company_country":"Paese dell\'azienda","company_state":"Stato della Società","client_orders":"Ordini dei clienti","no_product_details":"Nessun dettaglio dei prodotti da mostrare","submit_btn_text":"Invia","submitting_btn_text":"Invio","submitted_btn_text":"Presentato","email_id_validation_errmsg":"Si prega di inserire un ID e-mail valido","customerInvoice_add_more_details":"Aggiungi più dettagli","customerInvoice_add_shipping_address":"Aggiungi nuovo indirizzo di spedizione","customerInvoice_HideDetails":"Nascondere dettagli","customerInvoice_HideAddress":"Nascondi indirizzo di spedizione","customerInvoice_enterFirstName":"Inserisci il nome","customerInvoice_enterFirstNamePlaceholder":"Nome di battesimo","customerInvoice_enterLastName":"Inserisci il cognome","customerInvoice_enterLastNamePlaceholder":"Cognome","customerInvoice_enterAddress1":"Immettere l\'indirizzo riga 1","customerInvoice_enterAddress1Placeholder":"indirizzo 1","customerInvoice_enterAddress2":"Immettere l\'indirizzo riga 2","customerInvoice_enterAddress2Placeholder":"indirizzo 2","customerInvoice_enterCity":"Entra in Città","customerInvoice_enterCityPlaceholder":"Città","customerInvoice_selectCountry":"Seleziona il paese","customerInvoice_selectState":"Seleziona stato","customerInvoice_enterZipNumber":"Inserisci il codice postale","customerInvoice_enterZipNumberPlaceholder":"Cap","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Prodotto non disponibile","customerInvoice_SendInvoiceBtn":"Inviare la fattura","customerInvoice_CreateOrderBtn":"Crea ordine","customerInvoice_ProductTableColumnSubTotal":"totale parziale","customerInvoice_SelectShippingAddress":"Seleziona Indirizzo di spedizione","customerInvoice_ProductsSearchBy_Placeholder":"Cerca prodotti per nome, SKU, prezzo","customerInvoice_AddMoreProducts_Btn":"Aggiungi più prodotti","customerInvoice_RequiredErrorMsg":"Questo campo è obbligatorio","customerInvoice_EmailSuggestionErrorMsg":"Si prega di aggiungere un ID e-mail valido","customerInvoice_MobileSuggestionErrorMsg":"Si prega di aggiungere un numero di telefono valido","customerInvoice_ErrorMsgAddShippingAddress":"Si prega di compilare l\'indirizzo di spedizione","customerInvoice_Creating_Msg":"Creazione...","customerInvoice_Sending_Msg":"Invio...","customerInvoice_OrderCreatedSuccessfullyMsg":"Ordine creato con successo","customerInvoice_InvoiceSentSuccessfullyMsg":"Fattura inviata con successo al cliente","customerInvoice_ErrorMsgTryAgain":"Errore... per favore riprova","customerInvoice_Selected_Btn":"Selezionato","customerInvoice_ProductTableQuantityUpdate_Btn":"Si prega di selezionare il prodotto","customerInvoice_OrderSubTotal":"Totale parziale dell\'ordine","delete_confirmation_text":"Sei sicuro ?","draftOrder_OrderNumber":"Numero d\'ordine","draftOrder_CustName":"Nome del cliente","draftOrder_OrderDate":"Data dell\'ordine","draftOrder_SubTotal":"Totale parziale","draftOrder_Status":"Stato","draftOrder_Invoice":"Fattura","draftOrder_DraftId":"ID brouillon","draftOrder_ShippingCost":"Spese di spedizione","draftOrder_Tax":"Imposta","draftOrder_TotalPrice":"Prezzo totale","draftOrder_Note":"Nota","draftOrder_Product":"Prodotto","draftOrder_ProductName":"nome del prodotto","draftOrder_Size":"Misurare","draftOrder_Quantity":"Quantità","draftOrder_Price":"Prezzo","noDraftOrderProducts":"Nessun dettaglio dei dettagli del prodotto dell\'ordine disponibili.","noRefundOrderProduct":"Nessun dettaglio del prodotto dell\'ordine di rimborso disponibile.","loading":"Caricamento in corso...","dashboard_commissionOn_profitMargin":"Commissione sul margine di profitto","dashboard_clientInvoice":"Fattura del cliente","dashboard_affiliateLink":"Ordine di affiliazione","dashboard_returnCustomer":"Restituisci il cliente","dashboard_discountCoupon":"Buono sconto","dashboard_SharedCart":"Carrello condiviso","dashboard_AdminTaggedOrders":"Ordine con tag amministratore","dashboard_no_data":"Nessun dato disponibile","dashboard_sales_of_last_six_months":"Vendite degli ultimi 6 mesi","dashboard_sales_of_current_month":"Vendite del mese corrente","addCustomer_ErrorMsgOnSubmitBtn":"Si prega di inserire un numero di telefono valido","login_welcome_Msg":"Benvenuti nel team di vendita","login_title":"Login","login_email":"E-mail identificativo utente","login_password":"Parola d\'ordine","emailValidation_ErrorMsg":"Inserisci l\'ID email valido","login_newUser":"Nuovo utente?","login_SignUp":"Iscrizione","login_forgotPassword_link":"Ha dimenticato la password?","login_LogInBtn":"Accesso","login_sliderContent_1":"Rappresentanti che effettuano l\'ordine per conto dei clienti","login_sliderContent_2":"Il rappresentante del rappresentante al negozio","login_sliderContent_3":"Prodotti di marketing di Rep che utilizzano piattaforme di social media","login_sliderContent_4":"Il rappresentante può acquistare in blocco e trarre profitto","login_sliderContent_5":"Rappresentanti che effettuano l\'ordine per conto dei clienti","login_sliderContent_6":"I rappresentanti possono visitare i clienti di persona e creare ordini","required_ErrorMsg":"Si prega di riempire il campo richiesto","signup_title":"Iscrizione","signup_BackTo_login":"Torna al login","signup_firstName":"Nome di battesimo","signup_lastName":"Cognome","signup_BackBtn":"Di ritorno","signup_NextBtn":"Prossimo","signup_phone_number":"Numero di telefono","signup_phone_number_Error":"Inserisci almeno 10 cifre","signup_uploadPicture":"Carica immagine del profilo","signup_fileSizeError":"La dimensione del file è maggiore di 5 MB","signup_filePath_lable":"File selezionato","signup_MediaTitle2":"Collegamenti sui social media","signup_facebookHandle":"Hand di Facebook","signup_InstaHandle":"Hand di Instagram","signup_SaveBtn":"Salva i dettagli","forgotPwd_title":"Ha dimenticato la password","forgotPwd_ResetBtn":"Resetta la password","forgotPwd_SuccessMsg":"La tua richiesta di reimpostare la password ha esito positivo, abbiamo inviato la nuova password al tuo ID e -mail registrato.","customerInvoice_selectShippingCost":"Seleziona Costo di spedizione","customerInvoice_CalculatingShippingRates_Msg":"Calcolo...","customerInvoice_AddShippingAddress_Msg":"Seleziona Indirizzo o Aggiungi indirizzo di spedizione","customerInvoice_PleaseSetAnyShippingAddressMsg":"Seleziona un qualsiasi indirizzo di spedizione","customerInvoice_ShippingCostErrorMsg":"Si prega di aggiungere un nuovo indirizzo di spedizione, perché l\'indirizzo non ha informazioni sufficienti.","customerInvoice_CalculateShippingCost_Btn":"Calcola il costo di spedizione","customerInvoice_ShippingCostAddOrNot_Msg":"Vuoi aggiungere il costo di spedizione?","customerInvoice_ShippingCostAddOrNot_Yes":"sì","customerInvoice_ShippingCostAddOrNot_No":"No","customerInvoice_ShippingCostIsUnavailable":"Il costo di spedizione per questo indirizzo non è impostato dal lato amministratore. Tuttavia, gli ordini possono essere effettuati senza calcolare il costo di spedizione.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Per favore riprova","dashboard_BannerMsg":"I grafici vengono aggiornati ogni 8 ore","yourSales__BannerMsg":"I dettagli dell\'ordine vengono aggiornati ogni 5 minuti","customerInvoice_FirstNameErrorMsg":"Inserisci il nome","customerInvoice_lastNameErrorMsg":"Inserisci il cognome","customerInvoice_Add1ErrorMsg":"Inserisci la riga dell\'indirizzo 1","customerInvoice_CountryErrorMsg":"Si prega di selezionare il paese","customerInvoice_StateErrorMsg":"Seleziona lo stato","customerInvoice_CityErrorMsg":"Inserisci il nome della città","customerInvoice_ZipErrorMsg":"Inserisci il codice postale","uploadImage":"Carica immagine","dashboard_CardTitle1":"Commissione su tutti gli ordini","dashboard_CardTitle3":"Commissione totale","dashboard_TotalRevenue":"Entrate totali","dashboard_TotalAvg_Ticket_Size":"Dimensione del biglietto AVG","dashboard_CardTitle4":"Vendite totali","profile_Change_Password":"Cambiare la password","dashboard_Information_Message":"La commissione è monitorata solo per ordini retribuiti","resetPassword_validation_Msg":"Questo campo è obbligatorio","resetPassword_validation_Msg2":"La password deve contenere minimo 8 caratteri, 1 maiuscolo, 1 minuscolo, 1 cifra ecc.","resetPassword_validation_Msg3":"Confermare che la password dovrebbe corrispondere con una nuova password","dashbord_Msg_New":"Come funziona","dashbord_informationMsg":"Informazione","discount_couponErrorMsg":"Lo sconto massimo non è configurato. Si prega di contattare l\'amministratore del sito.","discount_couponErrorMsg2":"La commissione non è configurata. Si prega di contattare l\'amministratore del sito.","dashbord_profile_pic":"Cambia la foto del profilo","Performance_Details":"Dettagli delle prestazioni","Show_Performance_Details":"Mostra i dettagli delle prestazioni","Dashboard_Month":"Mese","Dashboard_Orders_Total":"Ordini totali","Dashboard_Total_Sale":"Vendita totale","Dashboard_Commission":"Commissione","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Aggiungi l\'indirizzo del cliente.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Fare clic sul pulsante Calcola costo di spedizione e selezionarne uno.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Carrello non aggiornato, aggiorna e riprova.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Seleziona il prodotto.","customerInvoice_CreatingDraft_Msg":"Bozza in creazione...","customerInvoice_DraftOrderBtn":"Progetto di ordinanza","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Bozza di ordine creata con successo","productTable_error_AlertMsg":"La quantità non può essere 0 o meno, inserisci un valore valido","productTable_error_AlertMsg2":"Inserisci la quantità","click_to_copy":"Fare clic per copiare","discount_code_copy_coupon":"Copia coupon","createOrder_productSearchGuide":"Non sei in grado di trovare prodotti?","soldOut":"Esaurito","InventoryNotTracked":"Inventario non tracciato","productStatus":"Stato del prodotto","makeSureInShopify":"Assicurati su Shopify","products":"Prodotti","sectionTheProductStatusIs":"sezione, lo stato del prodotto è","active":"Attivo","productsMayBeSoldOutPleaseCheck":"I prodotti potrebbero essere esauriti, controlla e seleziona","Credit_Limit_Error_Msg":"Il limite di credito supera, si prega di riprovare..!"}'
        ),
        Tt = JSON.parse(
          '{"dashboard_title":"PAPAN PEMUKA","dashboard_welcomeMsg":"Selamat datang ke","dashboard_morningMsg":"Selamat Pagi","dashboard_afternoonMsg":"Selamat Petang","dashboard_eveningMsg":"Selamat Petang","dashboard_subTitle1":"Bulan semasa","dashboard_block1Heading":"INVOIS PELANGGAN","dashboard_block1Header1":"PENDAPATAN","dashboard_block1Header2":"INVOIS DIHANTAR","dashboard_block1Header3":"INVOIS DIBAYAR","dashboard_block2Heading":"PESANAN BORONG","dashboard_block2Header1":"PENDAPATAN","dashboard_block2Header2":"INVOIS DIHANTAR","dashboard_block2Header3":"INVOIS DIBAYAR","dashboard_block3Heading":"PESANAN AFILIASI","dashboard_block3Header1":"PENDAPATAN","dashboard_block3Header2":"PESANAN DIBAYAR","dashboard_block4Heading":"KUPON DISKAUN","dashboard_block4Header1":"PENDAPATAN","dashboard_block4Header2":"PESANAN DIBAYAR","dashboard_block5Heading":"KOMISYEN PELANGGAN","dashboard_block5Header1":"KOMISYEN","dashboard_block5Header2":"PESANAN","dashboard_block6Heading":"KOMISYEN KETUA PASUKAN","dashboard_block6Header1":"KOMISYEN","dashboard_block7Heading":"KOMISYEN POS","dashboard_block7Header1":"KOMISYEN","dashboard_block7Header2":"PESANAN","dashboard_tbl1column1":"Bulan","dashboard_tbl1column2":"Pesanan Invois Pelanggan","dashboard_tbl1column3":"Komisyen Invois Pelanggan","dashboard_tbl1column4":"Pesanan Borong","dashboard_tbl1column5":"Jumlah Pembelian Borong","dashboard_tbl1column6":"Pesanan Afiliasi","dashboard_tbl1column7":"Komisyen Affilate","dashboard_tbl1column8":"Pesanan Kod Kupon","dashboard_tbl1column9":"Komisyen Kod Kupon","dashboard_tbl1column10":"Pesanan Pelanggan","dashboard_tbl1column11":"Komisyen Pelanggan","dashboard_tbl1column12":"Pesanan POS","dashboard_tbl1column13":"Komisyen POS","dashboar_cardHeading1":"Jumlah Pesanan","dashboar_cardHeading2":"Komisyen","dashboar_cardHeading3":"Jualan","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Prestasi jualan enam bulan lepas","dashboard_graphHeading2":"Menganalisis ciri pesanan bijak dan komisen untuk bulan semasa","Graph_Sales_noorderstitle":"Tiada pesanan untuk dipaparkan","Graph_SalesRepCommission_nocommissiontitle":"Tiada data komisen untuk ditunjukkan","Graph_SalesRepOrders_title":"PESANAN","Graph_SalesRep_XAxisTitle_ForMonth":"6 bulan","Graph_SalesRepOrders_YAxisTitle":"Pesanan","Graph_SalesRepSales_title":"JUALAN","Graph_SalesRepCommission_title":"KOMISYEN","Graph_SalesRepCommissions_YAxisTitle":"Komisyen","Graph_FeatureWiseOrder_title":"Perintah vs ciri","Graph_featureWiseCommission_title":"Suruhanjaya vs Ciri","Graph_FeatureWiseOrder_XAxisTitle":"Ciri","Graph_FeatureWiseOrder_YAxisTitle":"Pesanan","Graph_FeatureWiseCommission_title":"KOMISYEN","Graph_FeatureWiseCommission_YAxisTitle":"Komisyen","customerInvoice_title":"Buat Pesanan","customerInvoice_button":"Kembali","customerInvoice_noclientorderMsg":"Tiada pesanan invois pelanggan","customerInvoice_button1":"Lihat pesanan sebelumnya","customerInvoice_contentHeading1":"Diskaun dan Komisyen","customerInvoice_table1column1":"Jenis Produk","customerInvoice_table1column2":"Komisyen","customerInvoice_table1column3":"Nama Diskaun","customerInvoice_table1column4":"Diskaun","customerInvoice_contentHeading2":"Tambah butiran pelanggan dan pilih produk untuk menghantar invois.","customerInvoice_contentHeading2Title1":"Masukkan/Cari Pelanggan","customerInvoice_title1Placeholder":"Masukkan/Cari Pelanggan","customerInvoice_contentHeading2Title2":"Masukkan ID E-mel Pelanggan","customerInvoice_title2Placeholder":"Alamat Emel","customerInvoice_contentHeading2Title3":"Masukkan mesej","customerInvoice_contentHeading2Title4":"Alamat Pelanggan","customerInvoice_contentHeading2Title5":"Nombor Telefon Pelanggan","customerInvoice_contentHeading2Title6":"Nota Pelanggan","customerInvoice_contentHeading2Title7":"Nama Syarikat Pelanggan","customerInvoice_title7Placeholder":"nama syarikat","customerInvoice_Placeholder_contentHeading2Title6":"Catatan","customerInvoice_Placeholder_contentHeading2Title5":"Nombor Telefon","customerInvoice_Placeholder_contentHeading2Title4":"Alamat Penghantaran","customerInvoice_title3Placeholder":"Mesej","customerInvoice_SearchProducts_Label":"Carian Produk","customerInvoice_table2Column1":"Imej","customerInvoice_table2Column2":"Tambah Kuantiti","customerInvoice_table2Column3":"Tajuk","customerInvoice_table2Column4":"Tajuk Variant","customerInvoice_ProductTableColumnPrice":"Harga","customerInvoice_ProductTableColumnWholeSalePrice":"Harga Borong","customerInvoice_button2":"Cipta invois baru","customerInvoice_ProductTableColumnProduct":"Produk","customerInvoice_table3Column2":"Nama Produk","customerInvoice_table3Column3":"Saiz","customerInvoice_ProductTableColumnQuantity":"Kuantiti","customerInvoice_table3Column5":"Harga Item","customerInvoice_table3Column6":"Harga Keseluruhan","customerInvoice_table3Column7":"Harga Diskaun untuk Pelanggan","customerInvoice_table3Column8":"Komisyen SalesRep","customerInvoice_table3Column9":"Diskaun","customerInvoice_repproInvite":"Pilih kotak semak untuk menghantar pro jemputan","customerInvoice_customerOrder_error1":"Semua maklumat pelanggan adalah wajib. Sila masukkan e-mel pelanggan dan nama pertama","customerInvoice_productAddedMsg":"Produk ditambah","customerInvoice_AlertErrorMsg":"Ralat..Sila hubungi sokongan !","cartSharing_Select_product_Title":"","wholesaleOrder_title":"Pesanan borong","wholesaleOrder_contentHeading1":"Anda boleh membeli produk dengan harga borong","wholesaleOrder_contentHeading2":"Diskaun pada","wholesaleOrder_column1":"Nama SalesRep","wholesaleOrder_column2":"Diskaun","wholesaleOrder_searchtxtPlaceholder":"Carian produk","wholesaleOrder_table1Column1":"Imej","wholesaleOrder_table1Column2":"Tambah Kuantiti","wholesaleOrder_table1Column3":"Tajuk","wholesaleOrder_table1Column4":"Tajuk Variant","wholesaleOrder_table1Column5":"Harga","wholesaleOrder_button":"Semak","wholesaleOrder_Order_btn":"Tunjukkan/sembunyikan harga volum","wholesaleOrder_contentHeading3":"Harga Keseluruhan","wholesaleOrder_contentHeading4":"Harga Diskaun Anda","wholesaleOrder_table2Column1":"Produk","wholesaleOrder_table2Column2":"Nama Produk","wholesaleOrder_table2Column3":"Saiz","wholesaleOrder_table2Column4":"Kuantiti","wholesaleOrder_table2Column5":"Harga Item","wholesaleOrder_table2Column6":"Harga Keseluruhan","wholesaleOrder_table2Column7":"Harga Diskaun Anda","affiliateLink_title":"Pautan Afiliasi","affiliate_product_link":"Pautan produk","affiliateLink_input_error_msg":"Medan teks pautan diperlukan dan tidak boleh mengandungi ruang.","affiliateLink_contentHeading1":"Kongsi pautan afiliasi anda di media sosial dan e-mel anda. Anda akan mendapat komisen affiliate untuk setiap pesanan dari pautan afiliasi anda.","affiliateLink_contentHeading2":"Pautan Afiliasi Anda","affiliateLink_contentHeading3":"Komisyen pada","affiliateLink_content_Message1":"Cari produk dan kongsi pautan produk individu dengan pelanggan anda.","affiliateLink_noaffiliateorderMsg":"Tiada pesanan affiliate","affiliateLink_column1":"Nama SalesRep","affiliateLink_column2":"Komisyen","affiliateLink_searchtxtPlaceholder":"Carian produk","affiliateLink_searchColumn1":"Produk","affiliateLink_searchColumn2":"Tajuk Produk","affiliateLink_searchColumn3":"Harga","affiliateLink_searchColumn4":"Komisyen","affiliateLink_searchColumn5":"Pautan Afiliasi","affiliateLink_searchColumn7":"Salin pautan","affiliateLink_searchColumn8":"disalin","affiliateLink_backbtn":"Kembali","affiliateLink_card_Title":"Kad Kenalan & Pautan Ahli Gabungan","cartSharing_title":"Perkongsian Troli","cartSharing_CreateCartInformation_Text":"Untuk mencipta troli yang diperuntukkan, tambahkan produk ke troli dari web yang akan dipaparkan di halaman ini.","cartSharing_content2Placeholder":"Nama troli","cartSharing_table2Column2":"Nama Produk","cartSharing_table2Column3":"Saiz","cartSharing_table2Column6":"Harga Keseluruhan","cartSharing_SharedCartLinkTableColumnCartName":"Nama Troli","cartSharing_SharedCartLinkTableColumnLink":"Pautan","cartSharing_SharedCartLinkTableColumnCartLink":"Pautan Troli Boleh Kongsi","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Salin pautan troli","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Padamkan pautan troli","cartSharing_EnterCartName_Label":"Masukkan nama troli","cartSharing_ProductTableColumnProduct":"Produk","cartSharing_ProductTableColumnQuantity":"Kuantiti","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Harga Item","cartSharing_CartCreating_Msg":"Mencipta...","cartSharing_Copied_Msg":"Disalin!","cartSharing_SharedCartLinkTableEmpty_Msg":"Tiada Pautan untuk ditunjukkan","cartSharing_CartCreatedSuccessfully_Msg":"Troli Berjaya Dibuat","cartSharing_CartCreateError_Msg":"Ralat..sila Cuba Lagi","cartSharing_AlertError_Msg":"Ralat..Sila hubungi sokongan !","cartSharing_CopyCartLink_Msg":"Salin pautan troli","cartSharing_DeleteCartLink_Msg":"Padamkan pautan troli","cartSharing_DeleteConfirmation_Msg":"Adakah anda pasti ?","cartSharing_ProductTableEmpty_Msg":"Produk Tidak Tersedia","cartSharing_CreateCart_Btn":"Cipta troli","cartSharing_ProductTableQuantityUpdate_Btn":"Sila Pilih Produk","discountCoupon_titleOne":"Kupon Diskaun","discountCoupon_contentHeading1":"Kongsi Kod Kupon Diskaun dengan pelanggan anda dan setiap kali kupon anda digunakan, anda mendapat komisen.","discountCoupon_contentHeading2":"Kod kupon anda adalah","discountCoupon_contentHeading3":"Jumlah Diskaun","discountCoupon_contentHeading4":"Komisyen","discountCoupon_contentHeading4PlaceHolder1":"Hey gunakan kod kupon diskaun saya","discountCoupon_contentHeading4PlaceHolder2":"dan dapatkan produk diskaun","discountCoupon_button1":"Salin teks","cartSharing_copiedButtonText":"Disalin","discountCoupon_titleTwo":"Buat kupon diskaun penggunaan satu kali untuk pelanggan","discountCoupon_button2":"Lihat Kupon","discountCoupon_contentHeading5":"Maksimum diskaun yang dibenarkan","discountCoupon_contentHeading6":"Komisyen","discountCoupon_contentHeading7":"Masukkan kod kupon","discountCoupon_contentHeading7PlaceHolder":"Sila masukkan kod kupon","discountCoupon_contentHeading8":"Masukkan diskaun","discountCoupon_contentHeading8PlaceHolder":"Diskaun tidak boleh melebihi diskaun Maksimum.","discountCoupon_button3":"Buat kupon","discountCoupon_coupon_error1":"Sila masukkan kod kupon dan diskaun","yourBio_title":"Bio Anda","yourBio_content1":"Muat naik profil","yourBio_button1":"Pilih fail","yourBio_button1PlaceHolder":"Tiada fail dipilih","yourBio_error_image_size":"Saiz imej terlalu besar, sila muat naik imej bersaiz kurang daripada 5MB. Sila cuba lagi.","yourBio_button2":"Muat naik","yourBio_content2":"Masukkan pautan unik","yourBio_content3":"Masukkan bio anda","yourBio_content2PlaceHolder":"Buat pautan gabungan unik anda","yourBio_content3PlaceHolder":"Masukkan dalam 100 perkataan","yourBio_content4":"Apabila pautan anda akan digunakan kad kenalan anda akan muncul di tapak web","yourBio_button3":"Simpan","yourBio_button4":"Disimpan","yourBio_error_link":"Pautan unik ini telah diambil. Cuba dengan pautan unik yang lain.","yourBio_Linksuccessmsg":"Pautan unik yang disimpan berjaya.","team_title1":"Tambah SalesRep","team_content1":"Masukkan email","team_content1PlaceHolder":"Alamat Emel","team_emailerrorMsg":"Sila masukkan e-mel","team_content2":"Masukkan nama pertama","team_content2PlaceHolder":"Nama Pertama","team_fnameerrorMsg":"Sila masukkan nama pertama","team_content3":"Masukkan nama terakhir","team_content3PlaceHolder":"Nama Terakhir","team_button1":"Tambah","team_successmsg":"Ditambah dengan jayanya! Sila semak e-mel anda untuk arahan pengaktifan.","team_errorsmsg":"Ralat semasa menambah. E-mel pengguna ini mungkin sudah digunakan","team_title2":"Butiran Pasukan","team_content4":"Halaman Mendaftar","team_NoTeamDetailsMsg":"Tiada butiran pasukan","team_content5":"Pilih SalesRep","team_tableTitle":"BUTIRAN PESANAN DUA BULAN LEPAS","team_column1":"Nombor Pesanan","team_column2":"Tarikh Pesanan","team_column3":"Nama Pelanggan","team_column4":"Sales Rep","team_column5":"Jumlah kecil","team_column6":"Komisyen Rep Sales","team_column7":"Komisyen Pengurus Pasukan","team_column8":"Jenis Komisyen","addCustomer_title":"Tambah pelanggan","addCustomer_content1":"Masukkan Nama Pertama Pelanggan","addCustomer_txt1Placeholder":"Nama Pertama","addCustomer_content2":"Masukkan Nama Akhir Pelanggan","addCustomer_content2Placeholder":"Nama Terakhir","addCustomer_content3":"Masukkan ID E-mel Pelanggan","addCustomer_content3Placeholder":"Alamat Emel","addCustomer_content4":"Catatan","addCustomer_content4Placeholder":"Catatan","addCustomer_customerAddress":"Alamat Peribadi","addCustomer_customerCity":"Bandar","addCustomer_customerCityPlaceholder":"Bandar","addCustomer_customerCountry":"Negara","addCustomer_customerState":"Nyatakan","addCustomer_customerZipCode":"Kod Zip","addCustomer_companyName":"Nama Syarikat","addCustomer_companyAddress":"Alamat Syarikat","addCustomer_companyCity":"Bandar","addCustomer_companyCountry":"Negara","addCustomer_companyState":"Nyatakan","addCustomer_companyZipCode":"Kod Zip","addCustomer_button":"Simpan","addCustomer_leadsuccessmsg":"Pelanggan ditambah dengan jayanya.","addCustomer_leadErrrorMsg":"Ralat semasa menyimpan butiran.","addCustomer_leadEmptyErrrorMsg":"Sila isi ruang yang diwajibkan.","addCustomer_leadsuccessmsg2":"Pelanggan berjaya ditambah dan telah ditandakan kepada wakil rep.","addCustomer_leadErrrorMsg2":"Pelanggan ini sudah ditandakan kepada wakil rep.","myCustomers_title":"Pelanggan Anda","myCustomers_table1Column1":"Nama","myCustomers_table1Column2":"Nama Syarikat","myCustomers_table1Column3":"E-mel","myCustomers_table1Column4":"Pesanan","myCustomers_table1Column5":"Jumlah yang Dibelanjakan","myCustomers_table2Title":"BUTIRAN PELANGGAN","myCustomers_table3Title":"DRAF BUTIRAN PESANAN","myCustomers_table3Column1":"Nama Produk","myCustomers_table3Column2":"Saiz","myCustomers_table3Column3":"Kuantiti","myCustomers_table3Column4":"Harga","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Jumlah kecil","myCustomers_table2Row1":"Nama","myCustomers_table2Row2":"E-mel","myCustomers_table2Row3":"Alamat","myCustomers_table2Row4":"Nama Syarikat","myCustomers_table2Row5":"Nota Pelanggan","myCustomers_table2Row6":"Jumlah yang dibelanjakan (subtotal + cukai)","myCustomers_table2Row7":"Bilangan Pesanan","myCustomers_table2Row8":"Tags","myCustomers_radioButton0":"Tunjukkan semua pelanggan","myCustomers_radioButton1":"Cari mengikut nama","myCustomers_radioButton2":"Cari mengikut syarikat","myCustomers_radioButtonError1":"Sila pilih jenis Carian dan masukkan nilai untuk cari","myCustomers_radioButtonError2":"Sila masukkan nilai untuk mencari","myCustomers_radioButtonError3":"Sila pilih jenis carian","myCustomers_searchButton":"Cari","myCustomers_Placeholder1":"Taip nama pelanggan atau nama syarikat untuk mencari","myCustomers_NoOrdersError":"Tiada pesanan","myCustomer_no_salesRep_details":"Tiada butiran wakil jualan tersedia.","myCustomer_select_customer_country":"Sila pilih Negara Pelanggan","myCustomer_company_country":"Negara syarikat","myCustomer_company_state":"Negeri Syarikat","myCustomer_select_company_country":"Sila pilih Negara Syarikat","yourSales_SalesOrderDetailsTitle":"Butiran Pesanan Jualan","yourSales_title":"Butiran pesanan 2 bulan lepas","yourSales_table1Column1":"Nombor Pesanan","yourSales_table1Column2":"Tarikh Pesanan","yourSales_table1Column3":"Nama Pelanggan","yourSales_table1Column4":"Jumlah kecil","yourSales_table1Column5":"Komisyen","yourSales_table1Column6":"Jenis Komisyen","yourSales_table1Column7":"Cetak Invois","printOrderInvoice_btn":"Cetak","yourSales_tableTitle":"MAKLUMAT PRODUK","yourSalesDraft_tableTitle":"DRAF BUTIRAN PESANAN","yourSales_column1":"Produk","yourSales_column2":"Tajuk","yourSales_column3":"Kuantiti","yourSales_column4":"Harga Item","yourSales_column5":"Nombor Pengesanan","yourSales_column6":"Tarikh Hantar","yourSales_column7":"Harga Keseluruhan","yourSales_content1":"Jumlah kecil","yourSales_content2":"Cukai","yourSales_content3":"Kos Penghantaran","yourSales_content4":"Jumlah","yourSales_content5":"Catatan","yourSales_tabHeading1":"Pesanan Berbayar","yourSales_tabHeading4":"Pending order","yourSales_tabHeading2":"Draf pesanan","myOrders_title":"Maklumat-maklumat Pesanan","myOrdersDetails_Message":"Pesanan dibuat untuk diri sendiri","myOrders_table1Column1":"Nombor Pesanan","myOrders_table1Column2":"Tarikh Pesanan","myOrders_table1Column3":"Nama Pelanggan","myOrders_table1Column4":"Pembayaran","myOrders_table1Column5":"Pemenuhan","myOrders_table1Column6":"Jumlah","myOrders_tableTitle":"MAKLUMAT PRODUK","myOrders_table2Column1":"Produk","myOrders_table2Column2":"Tajuk","myOrders_table2Column3":"Kuantiti","myOrders_table2Column4":"Harga Item","myOrders_table2Column5":"Nombor Pengesanan","myOrders_table2Column6":"Tarikh Hantar","myOrders_table2Column7":"Harga Keseluruhan","myOrders_content1":"Jumlah kecil","myOrders_content2":"Cukai","myOrders_content3":"Kos Penghantaran","myOrders_content4":"Jumlah","myOrders_content5":"Catatan","myOrders_content6":"Draf ID","tab_Dashboard":"Papan pemuka","dashbord_Tab":"Rumah","tab_CustomerInvoice":"Buat Pesanan","tab3_WholesaleOrder":"Pesanan Borong","tab_AffiliateLink":"Pautan Afiliasi","tab_CartSharing":"Perkongsian Troli","tab_DiscountCoupon":"Kupon Diskaun","tab7_YourBio":"Bio Anda","tab8_Team":"Pasukan","tab9_AddCustomer":"Tambah pelanggan","tab_MyCustomers":"Pelanggan Saya","tab_YourSalesOrderDetails":"Butiran pesanan jualan anda","tab12_MyOrders":"Pesanan Saya","tab13_Logout":"Log keluar","signUp_title":"Wakil jualan mendaftar","signUp_subTitle":"Sila isi borang ini untuk mendaftar sebagai wakil jualan dan mendapatkan akses kepada semua ciri pasukan jualan.","signUp_content1":"E-mel","signUp_content2":"Nama Pertama","signUp_content3":"Nama Terakhir","signUp_content4":"Nombor Telefon","signUp_content5":"Nama Facebook","signUp_content6":"Nama Twitter","signUp_content7":"Nama Instagram","signUp_content8":"Muat naik gambar profil","signUp_socialmedialable1":"Pautan Media Sosial","signUp_socialmedialable2":"Pilihannya","signUp_uploadBtn":"Pilih fail","signUp_uploadBtnPlaceHolder":"Tiada fail dipilih","signUp_button3":"Menyimpan butiran ...","signUp_welcomemsg1":"Hello","signUp_welcomemsg2":"Daftar Jualan Rep dan dapatkan komisen mengenai jualan yang dibuat oleh Reps di bawah anda","signUp_emailerror":"Sila masukkan e-mel","signUp_Fnameerror":"Sila masukkan nama pertama","signUp_lnameerror":"Sila masukkan nama terakhir","signUp_phnumbererror":"Sila masukkan nombor telefon","signUp_successmsg":"Permintaan anda telah berjaya didaftarkan, anda akan menerima e-mel pengaktifan akaun sebaik sahaja admin meluluskan permintaan anda.","signUp_errorsmsg":"Ralat semasa menyimpan butiran. E-mel pengguna ini mungkin sudah mempunyai akaun","signUp_RepExistErrorMsg":"E-mel ini sudah didaftarkan sebagai wakil.","addingRep_selectRepsLabel1":"Siapa yang membantu anda?","addingRep_NoSalesRep":"Tiada sales rep","addingRep_successMsg":"Menambah repId ke nota troli","addingRep_selectRepsLabel2":"Sila pilih item dalam senarai.","wholesaleOrder_WholesaleDiscountTableColumn1":"Tajuk Produk","wholesaleOrder_WholesaleDiscountTableColumn2":"Diskaun","customerInvoice_ViewClientOrdersColumn1":"Nama Pelanggan","customerInvoice_ViewClientOrdersColumn2":"Tajuk Produk","customerInvoice_ViewClientOrdersColumn3":"Harga Subtotal","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Invois","salesRep_order_errorMsg":"Ralat semasa membuat pesanan anda. Sila hubungi khidmat pelanggan.","salesRep_order_successMsg":"Invois pesanan berjaya dicipta! Invois telah dihantar melalui e-mel kepada pelanggan!","salesRep_order_errorMsg2":"Ralat semasa membuat pesanan anda. Sila hubungi khidmat pelanggan.","customedraft_btn1":"Buat invois baru","customedraft_btn2":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","customedraft_btn3":"Pesanan sedang dibuat...","customedraft_btn4":"Buat invois baru","salesRep_order_NoProductSelected":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","productnotselectforcartsharingtxt1":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","discountCoupons_tblColumn1":"Kod Kupon","discountCoupons_tblColumn2":"Diskaun Kupon","discountCoupons_tblColumn3":"Padam kod kupon","discountedPriceLabel":"Harga Diskaun Anda:","couponCodeNotSet":"Kod kupon tidak ditetapkan","dashboard_subTitle2":"Kitaran bulan semasa: 5th - 4th","affiliatelink_commissiononlbl":"Produk","displaycommission_lbl1":"Jenis Produk","displaycommission_lbl2":"Sales Rep","displaycommission_lbl3":"Diskaun Berasaskan Kuantiti","discountcommissiononlbl1":"Tiers Diskaun Pelanggan","clientInvoiceCommissionTablecolumn1":"Jenis Produk","clientInvoiceCommissionTablecolumn2":"Komisyen","clientInvoiceCommissionTablecolumn3":"Tajuk Produk","clientInvoiceCommissionTablecolumn4":"Nama SalesRep","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nama Produk","clientInvoiceQuantityBaseDiscountTablecolumn2":"Diskaun","clientInvoiceQuantityBaseDiscountTablecolumn3":"Kuantiti","affiliateCartProdtableColumn1":"Produk","affiliateCartProdtableColumn2":"Tajuk Produk","affiliateCartProdtableColumn3":"Harga","affiliateCartProdtableColumn4":"Komisyen","affiliateCartProdtableColumn5":"Pautan Afiliasi","affiliateCartProdtableColumn6":"Kongsi Pautan","productnotselectforcartsharinglbl1":"Sila masukkan nama troli","productnotselectforcartsharinglbl2":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","productnotselectforcartsharinglbl3":"Tunggu semasa memproses ...","showSharedCartProductcolumn1":"Pautan troli","showSharedCartProductcolumn3":"Keluarkan troli","onSuccessInvoiceSuccessMsg":"Invois berjaya dihantar","onSuccessInvoiceFailedMsg":"Penghantaran invois gagal","sendInvoice_successMsg":"Invois berjaya dihantar","deleteInvoice_successMsg":"Invois berjaya dihapuskan","deleteInvoice_FailedMsg":"Padam invois gagal","deleteInvoice_btnlbl":"Memadam invois","deleteSharedCartLink_successMsg":"Pautan berjaya dihapuskan","deleteSharedCartLink_FailedMsg":"Ralat dalam memadam pautan. Sila cuba lagi.","deleteSharedCartLink_btnlbl":"Memadamkan pautan","viewInvoiceOrders_btntxt1":"Mendapatkan ...","viewInvoiceOrders_btntxt2":"Lihat pesanan sebelumnya","createCoupon_btnlbl1":"Mencipta kupon ...","createCoupon_btnlbl2":"Kupon dibuat","deleteCoupon_successMsg":"Kupon dipadam","deleteCoupon_FailedMsg":"Kupon gagal dipadam","deleteCoupon_btnlbl":"Memadamkan...","viewProductModelColumn1":"Produk","viewProductModelColumn2":"Tajuk","viewProductModelColumn3":"Kuantiti","viewProductModelColumn4":"Jumlah yang Dikembalikan","viewProductModelColumn5":"Harga Item","viewProductModelColumn6":"Harga Diskaun","viewProductModelColumn7":"Nombor Tracking","viewProductModelColumn8":"Tarikh Hantar","viewProductModelColumn9":"Harga Keseluruhan","showSharedCartProducts_column2":"Imej","showSharedCartProducts_column3":"Tambah Kuantiti","showSharedCartProducts_column4":"Tajuk","showSharedCartProducts_column5":"Tajuk Variant","showSharedCartProducts_column6":"Harga","viewClientOrders_btn1":"Lihat","viewClientOrders_btn2":"Hantar","viewClientOrders_btn3":"Memadam","showCouponTable_txt1":"Mendapatkan ...","showCoupon_btn2":"Lihat Kupon","showCoupon_btn1":"Disalin","affliateOrder_column1":"Nama Pelanggan","affliateOrder_column2":"E-mel Pelanggan","affliateOrder_column3":"Tajuk Produk","affliateOrder_column4":"Tarikh Pesanan","affliateOrder_column5":"Jumlah kecil","affliateOrder_column6":"Komisyen","affliateOrder_btn1":"Mendapatkan ...","affliateOrder_btn2":"Lihat pesanan affiliate","affliateOrder_btn3":"Lihat pesanan affiliate","yourBio_btn1":"Simpan","yourBio_btn2":"Simpan","yourBio_Uploadbtn1":"Memuat naik ...","yourBio_Uploadbtn2":"Dimuat naik","yourBio_UploadbtnError":"Maaf, cuba lagi","yourBio_Savebtn":"Menjimatkan ...","team_txt1":"Menjimatkan ...","team_txt2":"Jimat","viewRepClientOrdersDetails_column1":"Nombor Pesanan","viewRepClientOrdersDetails_column2":"Tarikh Pesanan","viewRepClientOrdersDetails_column3":"Jumlah kecil","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Maklumat Produk","addSalesRep_txt1":"Tambah SalesRep","addSalesRep_txt2":"Menambah SalesRep ...","discountCoupons_header":"Satu Kupon Diskaun Satu Masa","discountCoupons_nodiscountcoupon":"Anda belum membuat sebarang kupon diskaun","discountCoupons_deleteBtn":"Memadam","discountCoupons_BackBtn":"Kembali","customerInvoice_selectcustomererror":"Sila pilih Pelanggan dan kemudian Tambah Produk","createOrderFromCartPage_selectCustomersLabel":"PILIH PELANGGAN","createOrderFromCartPage_selectCustomerAddressLabel":"ALAMAT PENGHANTARAN","createOrderFromCartPage_selectCustomersLabelForDropDown":"Pilih pelanggan","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Pilih alamat","createOrderFromCartPage_successMsg":"Invois pesanan berjaya dibuat! Invois telah dihantar melalui e-mel kepada pelanggan!","createOrderFromCartPage_toggleButton":"Tambah alamat penghantaran baru","createOrderFromCartPage_AddNewAddressTitle":"TAMBAH ALAMAT BARU","createOrderFromCartPage_customer_errorMsg1":"Tiada pelanggan yang dipilih. Sila pilih pelanggan dan cuba lagi.","createOrderFromCartPage_order_errorMsg1":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","createOrderFromCartPage_Address_errorMsg2":"Sila pilih alamat dan cuba lagi.","createOrderFromCartPage_Address_errorMsg3":"Sila isi semua medan alamat.","createOrderFromCartPage_Order_errorMsg2":"Ralat semasa membuat pesanan anda. Sila hubungi khidmat pelanggan","createOrderFromCartPage_draftOrderButton":"BUAT PESANAN DRAF","createOrderFromCartPage_OrderButton":"BUAT PESANAN","createOrderFromCartPage_draftOrderButtonText2":"MENCIPTA PESANAN ...","createOrderFromCartPage_selectShippingCostTitle":"KOS PENGHANTARAN","createOrderFromCartPage_selectShippingCost":"Pilih kos penghantaran","createOrderFromCartPage_Address_errorMsg4":"Terdapat masalah semasa mengira kadar harga penghantaran anda.","createOrderFromCartPage_Address_errorMsg5":"Terdapat kesalahan sila cuba lagi.","yourSales_tabHeading3":"Bayaran Balik Pesanan","refundOrders_column1":"Id Bayaran Balik","refundOrders_column2":"Tarikh pesanan","refundOrders_column3":"Nombor Pesanan","refundOrders_column4":"Nama Pesanan","refundOrders_column5":"Suruhanjaya","refundOrders_column6":"Komisen Pengurus Pasukan","refundOrders_column7":"Id Pengurus Pasukan","refundOrders_column8":"Bayar SubTotal","refundOrders_column9":"Status pesanan","refundOrders_column10":"Jenis Pesanan","refundOrderNumber_title":"Butiran Pesanan Bayaran Balik","refundOrderNumber_column1":"nama","refundOrderNumber_column2":"Tarikh","refundOrderNumber_column3":"Kuantiti","refundOrderNumber_column4":"Harga diskaun","refundOrderNumber_column5":"Jumlah kecil","tableDataError":"Tiada pesanan bayaran balik","dashboard_subTitle3":"Butiran Komisen","dashboard_cardHeading5_1":"Suruhanjaya pada","dashboard_cardHeading5_2":"Anda akan mendapat a","dashboard_cardHeading5_3":"komisen ke atas semua pesanan.","dashboard_cardHeading5_4":"Anda akan mendapat komisen berdasarkan produk yang anda jual","dashboard_cardHeading5_5":"Anda akan mendapat komisen berdasarkan Jenis produk","Profit_Margin":"Margin keuntungan","Product_Type":"jenis produk","Sales_Rep":"Wakil Jualan","show_commission_list":"Tunjukkan Senarai Komisen","commission_list":"Senarai Komisen","no_link_to_show":"Tiada Pautan untuk ditunjukkan","no_customers_to_show":"Tiada Pelanggan untuk ditunjukkan","no_sales_to_show":"Tiada Jualan untuk ditunjukkan","no_draft_to_show":"Tiada Draf untuk ditunjukkan","no_refund_to_show":"Tiada Bayaran Balik untuk ditunjukkan","no_orders_to_show":"Tiada Pesanan untuk ditunjukkan","customerInvoice_ViewClientOrdersColumn6":"Nombor Pesanan","customerInvoice_ViewClientOrdersColumn7":"Tarikh pesanan","Error_commissions_NotUpdated":"Komisen tidak dikemas kini","sales_chart_msg1":"Kami memerlukan data...","sales_chart_msg2":"Nampaknya kami belum mempunyai sebarang data untuk ditunjukkan.","page_refresh_msg":"klik untuk muat semula","variant_title":"Tajuk Varian","line_items_properties":"harta benda","customer_country":"Negara Pelanggan","customer_state":"Negeri Pelanggan","company_country":"Negara Syarikat","company_state":"Negeri Syarikat","client_orders":"Pesanan Pelanggan","no_product_details":"Tiada butiran produk untuk ditunjukkan","submit_btn_text":"Hantar","submitting_btn_text":"Menyerahkan","submitted_btn_text":"diserahkan","email_id_validation_errmsg":"Sila masukkan Id E-mel yang sah","customerInvoice_add_more_details":"Tambah Lagi Butiran","customerInvoice_add_shipping_address":"Tambah Alamat Penghantaran Baharu","customerInvoice_HideDetails":"Sembunyikan butiran","customerInvoice_HideAddress":"Sembunyikan Alamat Penghantaran","customerInvoice_enterFirstName":"Masukkan Nama Pertama","customerInvoice_enterFirstNamePlaceholder":"Nama pertama","customerInvoice_enterLastName":"Masukkan Nama Akhir","customerInvoice_enterLastNamePlaceholder":"Nama terakhir","customerInvoice_enterAddress1":"Masukkan Alamat Baris 1","customerInvoice_enterAddress1Placeholder":"Alamat Baris 1","customerInvoice_enterAddress2":"Masukkan Baris Alamat 2","customerInvoice_enterAddress2Placeholder":"Alamat 2","customerInvoice_enterCity":"Masuk Bandar","customerInvoice_enterCityPlaceholder":"Bandar","customerInvoice_selectCountry":"Pilih negara","customerInvoice_selectState":"Pilih Negeri","customerInvoice_enterZipNumber":"Masukkan Kod Pos","customerInvoice_enterZipNumberPlaceholder":"Poskod","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Produk Tidak Tersedia","customerInvoice_SendInvoiceBtn":"Hantar Invois","customerInvoice_CreateOrderBtn":"Buat Pesanan","customerInvoice_ProductTableColumnSubTotal":"jumlah kecil","customerInvoice_SelectShippingAddress":"Pilih Alamat Penghantaran","customerInvoice_ProductsSearchBy_Placeholder":"Cari Produk mengikut Nama, SKU, Harga","customerInvoice_AddMoreProducts_Btn":"Tambah Lebih Banyak Produk","customerInvoice_RequiredErrorMsg":"Medan ini diperlukan","customerInvoice_EmailSuggestionErrorMsg":"Sila tambah id e-mel yang sah","customerInvoice_MobileSuggestionErrorMsg":"Sila tambah no telefon yang sah","customerInvoice_ErrorMsgAddShippingAddress":"Sila isi Alamat Penghantaran","customerInvoice_Creating_Msg":"Mencipta...","customerInvoice_Sending_Msg":"Menghantar...","customerInvoice_OrderCreatedSuccessfullyMsg":"Pesanan Berjaya Dibuat","customerInvoice_InvoiceSentSuccessfullyMsg":"Invois Dihantar Berjaya kepada Pelanggan","customerInvoice_ErrorMsgTryAgain":"Ralat..sila Cuba Lagi","customerInvoice_Selected_Btn":"Dipilih","customerInvoice_ProductTableQuantityUpdate_Btn":"Sila Pilih Produk","customerInvoice_OrderSubTotal":"Pesanan SubTotal","delete_confirmation_text":"Adakah anda pasti ?","draftOrder_OrderNumber":"Nombor pesanan","draftOrder_CustName":"Nama Pelanggan","draftOrder_OrderDate":"Tarikh pesanan","draftOrder_SubTotal":"Jumlah kecil","draftOrder_Status":"Status","draftOrder_Invoice":"Invois","draftOrder_DraftId":"Draf ID","draftOrder_ShippingCost":"Kos penghantaran","draftOrder_Tax":"Cukai","draftOrder_TotalPrice":"Harga keseluruhan","draftOrder_Note":"Catatan","draftOrder_Product":"Produk","draftOrder_ProductName":"Nama Produk","draftOrder_Size":"Saiz","draftOrder_Quantity":"Kuantiti","draftOrder_Price":"Harga","noDraftOrderProducts":"Tiada butiran produk draf pesanan tersedia.","noRefundOrderProduct":"Tiada butiran produk pesanan bayaran balik tersedia.","loading":"Memuatkan ...","dashboard_commissionOn_profitMargin":"Komisen margin keuntungan","dashboard_clientInvoice":"Invois pelanggan","dashboard_affiliateLink":"Perintah afiliasi","dashboard_returnCustomer":"Kembali pelanggan","dashboard_discountCoupon":"Kupon diskaun","dashboard_SharedCart":"Troli Kongsi","dashboard_AdminTaggedOrders":"Pesanan Teg Admin","dashboard_no_data":"Tiada data yang tersedia","dashboard_sales_of_last_six_months":"Jualan 6 bulan terakhir","dashboard_sales_of_current_month":"Jualan bulan semasa","addCustomer_ErrorMsgOnSubmitBtn":"Sila masukkan nombor telefon yang sah","login_welcome_Msg":"Selamat Datang ke Pasukan Jualan","login_title":"Log masuk","login_email":"ID emel","login_password":"Kata laluan","emailValidation_ErrorMsg":"Sila masukkan ID E -mel yang sah","login_newUser":"Pengguna baru?","login_SignUp":"Daftar","login_forgotPassword_link":"Lupa kata laluan?","login_LogInBtn":"Log masuk","login_sliderContent_1":"Wakil membuat pesanan pelanggan","login_sliderContent_2":"Lalu lintas memandu wakil untuk menyimpan","login_sliderContent_3":"Produk pemasaran rep menggunakan platform media sosial","login_sliderContent_4":"Wakil boleh membeli secara pukal dan membuat keuntungan","login_sliderContent_5":"Wakil membuat pesanan pelanggan","login_sliderContent_6":"Wakil boleh melawat pelanggan secara peribadi dan membuat pesanan","required_ErrorMsg":"Sila isi medan yang diperlukan","signup_title":"Daftar","signup_BackTo_login":"Kembali ke log masuk","signup_firstName":"Nama pertama","signup_lastName":"Nama terakhir","signup_BackBtn":"Kembali","signup_NextBtn":"Seterusnya","signup_phone_number":"Nombor telefon","signup_phone_number_Error":"Sila masukkan 10 digit atleast","signup_uploadPicture":"Muat naik gambar profil","signup_fileSizeError":"Saiz fail lebih besar daripada 5MB","signup_filePath_lable":"Fail terpilih","signup_MediaTitle2":"Pautan media sosial","signup_facebookHandle":"Pemegang facebook","signup_InstaHandle":"Pemegang Instagram","signup_SaveBtn":"Simpan perincian","forgotPwd_title":"Lupa kata laluan","forgotPwd_ResetBtn":"Menetapkan semula kata laluan","forgotPwd_SuccessMsg":"Permintaan anda untuk menetapkan semula kata laluan berjaya, kami telah menghantar kata laluan baru ke ID e -mel berdaftar anda.","customerInvoice_selectShippingCost":"Pilih Kos Penghantaran","customerInvoice_CalculatingShippingRates_Msg":"Mengira...","customerInvoice_AddShippingAddress_Msg":"Pilih Alamat atau Tambah Alamat Penghantaran","customerInvoice_PleaseSetAnyShippingAddressMsg":"Sila pilih mana-mana satu alamat penghantaran","customerInvoice_ShippingCostErrorMsg":"Sila Tambah Alamat Penghantaran Baharu, kerana alamat mempunyai maklumat yang tidak mencukupi.","customerInvoice_CalculateShippingCost_Btn":"Kira Kos Penghantaran","customerInvoice_ShippingCostAddOrNot_Msg":"Adakah anda ingin menambah kos penghantaran?","customerInvoice_ShippingCostAddOrNot_Yes":"ya","customerInvoice_ShippingCostAddOrNot_No":"Tidak","customerInvoice_ShippingCostIsUnavailable":"Kos penghantaran untuk alamat ini tidak ditetapkan dari pihak pentadbir. Walaupun, pesanan boleh dibuat tanpa mengira kos penghantaran.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Sila cuba lagi","dashboard_BannerMsg":"Grafik dikemas kini setiap 8 jam","yourSales__BannerMsg":"Butiran pesanan dikemas kini setiap 5 minit","customerInvoice_FirstNameErrorMsg":"Sila masukkan nama pertama","customerInvoice_lastNameErrorMsg":"Sila masukkan nama keluarga","customerInvoice_Add1ErrorMsg":"Sila masukkan alamat baris 1","customerInvoice_CountryErrorMsg":"Sila pilih negara","customerInvoice_StateErrorMsg":"Sila pilih negeri","customerInvoice_CityErrorMsg":"Sila masukkan nama bandar","customerInvoice_ZipErrorMsg":"Sila masukkan poskod","uploadImage":"Muat Naik Imej","dashboard_CardTitle1":"Komisen atas semua pesanan","dashboard_CardTitle3":"Jumlah komisen","dashboard_TotalRevenue":"Jumlah hasil","dashboard_TotalAvg_Ticket_Size":"Saiz tiket AVG","dashboard_CardTitle4":"Jumlah jualan","profile_Change_Password":"Tukar kata laluan","dashboard_Information_Message":"Komisen dikesan hanya untuk pesanan berbayar","resetPassword_validation_Msg":"Bidang ini diperlukan","resetPassword_validation_Msg2":"Kata laluan harus mengandungi minimum 8 aksara, 1 huruf besar, 1 huruf kecil, 1 digit dll.","resetPassword_validation_Msg3":"Sahkan kata laluan harus dipadankan dengan kata laluan baru","dashbord_Msg_New":"Bagaimana ia berfungsi","dashbord_informationMsg":"Maklumat","discount_couponErrorMsg":"Diskaun maksimum tidak dikonfigurasikan. Sila hubungi admin laman web.","discount_couponErrorMsg2":"Suruhanjaya tidak dikonfigurasi. Sila hubungi admin laman web.","dashbord_profile_pic":"Tukar gambar profil","Performance_Details":"Butiran Prestasi","Show_Performance_Details":"Tunjukkan butiran prestasi","Dashboard_Month":"Bulan","Dashboard_Orders_Total":"Jumlah pesanan","Dashboard_Total_Sale":"Jumlah Jualan","Dashboard_Commission":"Suruhanjaya","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Sila tambah alamat pelanggan.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Sila klik pada butang kira kos penghantaran dan pilih satu.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Troli tidak dikemas kini, sila muat semula dan cuba semula.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Sila pilih produk.","customerInvoice_CreatingDraft_Msg":"Mencipta Draf..","customerInvoice_DraftOrderBtn":"Draf Perintah","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Draf Pesanan Berjaya Dibuat","productTable_error_AlertMsg":"Kuantiti tidak boleh 0 atau kurang, sila masukkan nilai yang sah","productTable_error_AlertMsg2":"Sila masukkan kuantiti","click_to_copy":"Klik untuk menyalin","discount_code_copy_coupon":"Salin kupon","createOrder_productSearchGuide":"Tidak dapat mencari produk?","soldOut":"Habis dijual","InventoryNotTracked":"Inventori tidak dijejaki","productStatus":"Status Produk","makeSureInShopify":"Pastikan dalam Shopify","products":"Produk","sectionTheProductStatusIs":"bahagian, status produk ialah","active":"Aktif","productsMayBeSoldOutPleaseCheck":"Produk mungkin habis dijual, sila semak dan pilih","Credit_Limit_Error_Msg":"Had kredit melebihi, sila cuba lagi..!"}'
        ),
        Mt = JSON.parse(
          '{"dashboard_title":"ÖVERSIKT","dashboard_welcomeMsg":"Välkommen Till","dashboard_morningMsg":"God Morgon","dashboard_afternoonMsg":"God Eftermiddag","dashboard_eveningMsg":"God kväll","dashboard_subTitle1":"NUVARANDE MÅNAD","dashboard_block1Heading":"KUNDFÖRTJÄNST","dashboard_block1Header1":"FÖRTJÄNST","dashboard_block1Header2":"SKICKADE FAKTUROR","dashboard_block1Header3":"BETALDA FAKTUROR","dashboard_block2Heading":"ÅTERFÖRSÄJARE ORDRAR","dashboard_block2Header1":"FÖRTJÄNST","dashboard_block2Header2":"SKICKADE FAKTUROR","dashboard_block2Header3":"BETALADA FAKTUROR","dashboard_block3Heading":"AFFILIATE ORDRAR","dashboard_block3Header1":"FÖRTJÄNST","dashboard_block3Header2":"BETALADA ORDRAR","dashboard_block4Heading":"RABATTKUPONG","dashboard_block4Header1":"FÖRTJÄNST","dashboard_block4Header2":"BETALDA ORDRAR","dashboard_block5Heading":"KUNDFÖRTJÄNST","dashboard_block5Header1":"FÖRTJÄNST","dashboard_block5Header2":"ORDRAR","dashboard_block6Heading":"TEAM LEDNINGSFÖRTJÄNST","dashboard_block6Header1":"FÖRTJÄNST","dashboard_block7Heading":"POS FÖRTJÄNST","dashboard_block7Header1":"FÖRTJÄNST","dashboard_block7Header2":"ORDRAR","dashboard_tbl1column1":"Månad","dashboard_tbl1column2":"Klientfaktura Ordrar","dashboard_tbl1column3":"Klientfaktura Förtjänst","dashboard_tbl1column4":"Återförsäljare Ordrar","dashboard_tbl1column5":"Totalt återförsäljare sålt","dashboard_tbl1column6":"Affiliate Ordrar","dashboard_tbl1column7":"Affilate Förtjänst","dashboard_tbl1column8":"Rabattkupong Ordrar","dashboard_tbl1column9":"Rabattkupong Förtjänst","dashboard_tbl1column10":"Kund ordrar","dashboard_tbl1column11":"Kund Förtjänst","dashboard_tbl1column12":"POS Ordrar","dashboard_tbl1column13":"POS Förtjänst","dashboar_cardHeading1":"Total order","dashboar_cardHeading2":"Provision","dashboar_cardHeading3":"Försäljning","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Försäljningsresultat de senaste sex månaderna","dashboard_graphHeading2":"Analysera funktionens kloka ordning och provision för den aktuella månaden","Graph_Sales_noorderstitle":"ingen order att visa","Graph_SalesRepCommission_nocommissiontitle":"Inga kommissionsdata att visa","Graph_SalesRepOrders_title":"ORDER","Graph_SalesRep_XAxisTitle_ForMonth":"6 månader","Graph_SalesRepOrders_YAxisTitle":"Order","Graph_SalesRepSales_title":"SALES","Graph_SalesRepCommission_title":"PROVISION","Graph_SalesRepCommissions_YAxisTitle":"Provision","Graph_FeatureWiseOrder_title":"Beställningar vs -funktionen","Graph_featureWiseCommission_title":"Commission vs Feature","Graph_FeatureWiseOrder_XAxisTitle":"Funktion","Graph_FeatureWiseOrder_YAxisTitle":"Order","Graph_FeatureWiseCommission_title":"PROVISION","Graph_FeatureWiseCommission_YAxisTitle":"Provision","customerInvoice_title":"Skapa order","customerInvoice_button":"Tillbaka","customerInvoice_noclientorderMsg":"Ingen kund faktura ordrar","customerInvoice_button1":"Visa tidigare ordrar","customerInvoice_contentHeading1":"Rabatter och förtjänst på","customerInvoice_table1column1":"Produktyp","customerInvoice_table1column2":"Förtjänst","customerInvoice_table1column3":"Rabattnamn","customerInvoice_table1column4":"Rabatt","customerInvoice_contentHeading2":"Lägg till kunduppgifter och välj produkter att skicka faktura till.","customerInvoice_contentHeading2Title1":"Ange/sök kund","customerInvoice_title1Placeholder":"Ange/sök kund","customerInvoice_contentHeading2Title2":"Skriv in kundens mailadress","customerInvoice_title2Placeholder":"Mailadress","customerInvoice_contentHeading2Title3":"Ange ordernoteringar","customerInvoice_contentHeading2Title4":"Kundadress","customerInvoice_contentHeading2Title5":"Kundens mobilnummer","customerInvoice_contentHeading2Title6":"Kundanmärkning","customerInvoice_contentHeading2Title7":"Kundens företagsnamn","customerInvoice_title7Placeholder":"Företagsnamn","customerInvoice_Placeholder_contentHeading2Title6":"Notera","customerInvoice_Placeholder_contentHeading2Title5":"Mobilnummer","customerInvoice_Placeholder_contentHeading2Title4":"leveransadress","customerInvoice_title3Placeholder":"Beställningsanteckningar","customerInvoice_SearchProducts_Label":"Sök produkter","customerInvoice_table2Column1":"Bild","customerInvoice_table2Column2":"Lägg till kvantiet","customerInvoice_table2Column3":"Titel","customerInvoice_table2Column4":"Varierande titel","customerInvoice_ProductTableColumnPrice":"Pris","customerInvoice_table2Column6":"Grossistpris","customerInvoice_button2":"Skapa Faktura","customerInvoice_ProductTableColumnProduct":"Produkt","customerInvoice_table3Column2":"Produktnamn","customerInvoice_table3Column3":"Storlek","customerInvoice_ProductTableColumnQuantity":"Kvantitet","customerInvoice_table3Column5":"Artikelpris","customerInvoice_table3Column6":"Totalt Pris","customerInvoice_table3Column7":"Rabatterat Pris för Kund","customerInvoice_table3Column8":"SäljRep Förtjänst","customerInvoice_table3Column9":"Rabattyp","customerInvoice_repproInvite":"Välj kryssruta att skicka en Pro-Inbjudan","customerInvoice_customerOrder_error1":"All fält är obligatoriska. Skriv in kundens Mail och Förnamn Please enter the customer\'s  email and Förnamn","customerInvoice_productAddedMsg":"Produkten tillagd","customerInvoice_AlertErrorMsg":"Fel.. Vänligen kontakta support!","wholesaleOrder_title":"Återförsäljare Ordrar","wholesaleOrder_contentHeading1":"Du kan köpa produkterna för återförsälj priser","wholesaleOrder_contentHeading2":"Rabatt på","wholesaleOrder_column1":"FörjäntRep Namn","wholesaleOrder_column2":"Rabatt","wholesaleOrder_searchtxtPlaceholder":"Sök Produkter","wholesaleOrder_table1Column1":"Bild","wholesaleOrder_table1Column2":"Lägg till Kvantitet","wholesaleOrder_table1Column3":"Titel","wholesaleOrder_table1Column4":"Varierad Titel","wholesaleOrder_table1Column5":"Pris","wholesaleOrder_button":"Utcheckning","wholesaleOrder_Order_btn":"Visa/Göm Volympriser","wholesaleOrder_contentHeading3":"Totalt Pris","wholesaleOrder_contentHeading4":"Dina Rabatterade Priser","wholesaleOrder_table2Column1":"Produkt","wholesaleOrder_table2Column2":"Produktnamn","wholesaleOrder_table2Column3":"Storlek","wholesaleOrder_table2Column4":"Kvantitet","wholesaleOrder_table2Column5":"Artikelpris","wholesaleOrder_table2Column6":"Totalt pris","wholesaleOrder_table2Column7":"Ditt Rabatterade Pris","affiliateLink_title":"Affiliatelänk","affiliate_product_link":"Produktlänk","affiliateLink_input_error_msg":"Länktextfält är obligatoriskt och får inte innehålla mellanslag.","affiliateLink_contentHeading1":"Dela din affiliate -länk på sociala medier och e -post. Du kommer att få en affiliate -provision för varje beställning från din affiliate -länk","affiliateLink_contentHeading2":"Din affiliate länk","affiliateLink_contentHeading3":"Förtjänst på","affiliateLink_content_Message1":"Sök efter produkter och dela länken till enskilda produkter med er kunder.","affiliateLink_noaffiliateorderMsg":"Inga Affiliate Ordrar","affiliateLink_column1":"SäljRep Namn","affiliateLink_column2":"Förtjänst","affiliateLink_searchtxtPlaceholder":"Sök Produkter","affiliateLink_searchColumn1":"Produkt","affiliateLink_searchColumn2":"Produkt Titel","affiliateLink_searchColumn3":"Pris","affiliateLink_searchColumn4":"Förtjänst","affiliateLink_searchColumn5":"Affiliate Länk","affiliateLink_searchColumn7":"Kopiera länk","affiliateLink_searchColumn8":"Kopierade","affiliateLink_card_Title":"Kontaktkort och anslutet länk","affiliateLink_backbtn":"Tillbaka","cartSharing_title":"Kundvagnsdelning","cartSharing_CreateCartInformation_Text":"För att skapa en personlig varukorg lägger du till produkter från webbshoppen. Dom produkter kommer visas på denna sidan.","cartSharing_content2Placeholder":"Varukorgens Namn","cartSharing_table2Column2":"Produkt Namn","cartSharing_table2Column3":"Storlek","cartSharing_SharedCartLinkTableColumnCartName":"Varukorgens Namn","cartSharing_SharedCartLinkTableColumnLink":"Länk","cartSharing_SharedCartLinkTableColumnCartLink":"Delbar varukorgslänk","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Kopiera Varukorgens Länk","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Tag bort Varukorgens Länk","cartSharing_EnterCartName_Label":"Skriv in varukorgens namn","cartSharing_ProductTableColumnProduct":"Produkt","cartSharing_ProductTableColumnQuantity":"Kvantitet","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Artikelpris","cartSharing_table2Column6":"Totalt pris","cartSharing_CartCreating_Msg":"Skapande...","cartSharing_Copied_Msg":"Kopierade !!","cartSharing_SharedCartLinkTableEmpty_Msg":"Ingen länk att visa","cartSharing_CartCreatedSuccessfully_Msg":"Varukorgen har skapats framgångsrikt","cartSharing_CartCreateError_Msg":"Fel.. försök igen","cartSharing_AlertError_Msg":"Fel.. Vänligen kontakta support!","cartSharing_CopyCartLink_Msg":"Kopiera Varukorgens Länk","cartSharing_DeleteCartLink_Msg":"Tag bort Varukorgens Länk","cartSharing_DeleteConfirmation_Msg":"Är du säker ?","cartSharing_ProductTableEmpty_Msg":"Produkten är inte tillgänglig","cartSharing_CreateCart_Btn":"Skapa Varukorg","cartSharing_ProductTableQuantityUpdate_Btn":"Välj produkt","cartSharing_Select_product_Title":"Välj produkt","discountCoupon_titleOne":"Rabattkupong","discountCoupon_contentHeading1":"Dela rabattkupongkoden med dina kunder och närhelst din kupong används får du en provision.","discountCoupon_contentHeading2":"Din Rabattkupong kod är","discountCoupon_contentHeading3":"RabattsummaDiscount Amount","discountCoupon_contentHeading4":"Förtjänst ","discountCoupon_contentHeading4PlaceHolder1":"Hej! Använd min Rabattkupongs kod","discountCoupon_contentHeading4PlaceHolder2":"och få rabatt på produkter","discountCoupon_button1":"Kopiera Text","cartSharing_copiedButtonText":"Kopierad","discountCoupon_titleTwo":"Skapa en engångsrabattkupong för dina kunder","discountCoupon_button2":"Visa Kuponger","discountCoupon_contentHeading5":"Maxtillåten Rabatt","discountCoupon_contentHeading6":"Rabatt","discountCoupon_contentHeading7":"Skriv in Rabattskupongens Kod","discountCoupon_contentHeading7PlaceHolder":"Skriv rabattkupongens Kod","discountCoupon_contentHeading8":"Skriv in Rabatten","discountCoupon_contentHeading8PlaceHolder":"Rabatten bör inte vara större än den maximala rabatten.","discountCoupon_button3":"Skapa Rabattkupong","discountCoupon_coupon_error1":"Skriv in Rabbatkupongens kod och Rabatt","yourBio_title":"Ditt kontaktkort","yourBio_content1":"Ladda up Profil","yourBio_button1":"Välj Fil","yourBio_button1PlaceHolder":"Ingen fil Vald","yourBio_error_image_size":"Bildstorleken är för stor, ladda upp en bild som är mindre än 5 MB. Var god försök igen.","yourBio_button2":"Ladda Upp","yourBio_content2":"Ange anpassat ord för att skapa din unika partnerlänk","yourBio_content2PlaceHolder":"skapa din unika affiliate-länk","yourBio_content4":"När din länk kommer att användas kommer ditt kontaktkort att visas på hemsidan","yourBio_content3":"Ange ditt kontaktkort","yourBio_content3PlaceHolder":"Skriv in 100 ord","yourBio_button3":"Spara","yourBio_button4":"Sparad","yourBio_error_link":"Denna unika länken är upptagen. Försök med en annan unik länk.","yourBio_Linksuccessmsg":"Unik länk sparad.","team_title1":"Lägg till SäljareRep","team_content1":"Skriv in din mailadress","team_content1PlaceHolder":"Mailadress","team_emailerrorMsg":"Skriv in mailadress","team_content2":"Skriv Förnamn","team_content2PlaceHolder":"Förnamn","team_fnameerrorMsg":"Skriv in ditt Förnamn","team_content3":"Skriv in ditt Efternamn","team_content3PlaceHolder":"Efternamn","team_button1":"Lägg Till","team_successmsg":"Tillagd! Kolla din mail för aktiveringsinstruktioner.","team_errorsmsg":"Fel vid tilläggning. Det finns redan ett konto med denna mailadressen.","team_title2":"Team Detaljer","team_content4":"Inskrivningsida","team_NoTeamDetailsMsg":"Inga Team Detaljer","team_content5":"Välj SäljRep","team_tableTitle":"SENASTE TVÅ MÅNADERNA ORDERDETALJER","team_column1":"Ordernummer","team_column2":"Orderdatum","team_column3":"Kundens Namn","team_column4":"Försäjningar Rep","team_column5":"Delsumma Totalt","team_column6":"Försäljningskommission","team_column7":"teamchefkommission","team_column8":"FÖRTJÄNST Type","addCustomer_title":"lägg Till Kund","addCustomer_content1":"Skriv in Kundens Förnamn","addCustomer_txt1Placeholder":"Förnamn","addCustomer_content2":"Skriv in Kundens Efternamn","addCustomer_content2Placeholder":"Efternamn","addCustomer_content3":"Skriv in Kundens Mailadress","addCustomer_content3Placeholder":"Mailadress","addCustomer_content4":"Anteckningar","addCustomer_content4Placeholder":"Anteckningar","addCustomer_customerAddress":"Personlig Adress","addCustomer_customerCity":"Stad","addCustomer_customerCityPlaceholder":"Stad","addCustomer_customerCountry":"Land","addCustomer_customerState":"Kommun","addCustomer_customerZipCode":"Postadress","addCustomer_companyName":"Företagsnamn","addCustomer_companyAddress":"Företagets adress","addCustomer_companyCity":"Stad","addCustomer_companyCountry":"Land","addCustomer_companyState":"Kommun","addCustomer_companyZipCode":"Postadress","addCustomer_button":"Spara","addCustomer_leadsuccessmsg":"Kunden är Tillagd.","addCustomer_leadErrrorMsg":"Fel vid sparande utav Uppgifter.","addCustomer_leadEmptyErrrorMsg":"Var god fyll i dom obligatoriska fälten.","addCustomer_leadsuccessmsg2":"Kunden är låst till Represantören.","addCustomer_leadErrrorMsg2":"Den här kunden är redan taggad till en Reprensantör.","myCustomers_title":"Dina Kunder","myCustomers_table1Column1":"Namn","myCustomers_table1Column2":"Företagsnamn","myCustomers_table1Column3":"Mailadress","myCustomers_table1Column4":"Ordrar","myCustomers_table1Column5":"Totalt Spenderat","myCustomers_table2Title":"KUNDENS UPPGIFTER","myCustomers_table3Title":"FÖRSLAG TILL BESTÄLLNINGSDETALJER","myCustomers_table3Column1":"Produktnamn","myCustomers_table3Column2":"Storlek","myCustomers_table3Column3":"Kvantitet","myCustomers_table3Column4":"Pris","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Delsumma","myCustomers_table2Row1":"Namn","myCustomers_table2Row2":"Mailadress","myCustomers_table2Row3":"Adress","myCustomers_table2Row4":"Företagsnamn","myCustomers_table2Row5":"Kundens anteckningar","myCustomers_table2Row6":"Totalt Spenderat(Delsumma+Skatt)","myCustomers_table2Row7":"Antal Ordrar","myCustomers_table2Row8":"Taggar","myCustomers_radioButton0":"Visa alla kunder","myCustomers_radioButton1":"Sök efter namn","myCustomers_radioButton2":"Sök efter företag","myCustomers_radioButtonError1":"Välj söktyp och ange värde för sökning","myCustomers_radioButtonError2":"Ange värde för att söka","myCustomers_radioButtonError3":"Välj söktyp","myCustomers_searchButton":"Sök","myCustomers_Placeholder1":"Skriv kundnamn eller företagsnamn för sökning","myCustomers_NoOrdersError":"Inga beställningar","myCustomer_no_salesRep_details":"Inga försäljningsrepresentanter finns tillgängliga.","myCustomer_select_customer_country":"Välj kundland","myCustomer_company_country":"Företagsland","myCustomer_company_state":"Företagsstat","myCustomer_select_company_country":"Välj företagsland","yourSales_SalesOrderDetailsTitle":"Försäljningsorderdetaljer","yourSales_title":"Senaste 2 månaders beställningsinformation","yourSales_table1Column1":"Ordernummer","yourSales_table1Column2":"Orderdatum","yourSales_table1Column3":"Kundens Namn","yourSales_table1Column4":"Delsumma","yourSales_table1Column5":"Förtjänst","yourSales_table1Column6":"Förtjänst Typ","yourSales_table1Column7":"Skriv ut Faktura","printOrderInvoice_btn":"Skriv ut","yourSales_tableTitle":"Produktdetaljer","yourSalesDraft_tableTitle":"FÖRSLAG TILL BESTÄLLNINGSDETALJER","yourSales_column1":"Produkt","yourSales_column2":"Titel","yourSales_column3":"Kvantitet","yourSales_column4":"Artikelpris","yourSales_column5":"Spårningsnummer","yourSales_column6":"Leveransdatum","yourSales_column7":"Totalt Pris","yourSales_content1":"Delsumma","yourSales_content2":"Skatt","yourSales_content3":"Fraktkostnad","yourSales_content4":"Totalt","yourSales_content5":"Anteckning","yourSales_tabHeading1":"Betalda beställningar","yourSales_tabHeading4":"Väntande beställningar","yourSales_tabHeading2":"Utkast till beställningar","myOrders_title":"Mina beställningsdetaljer","myOrdersDetails_Message":"Beställningar för dig själv","myOrders_table1Column1":"Ordernummer","myOrders_table1Column2":"Orderdatum","myOrders_table1Column3":"Kundens Namn","myOrders_table1Column4":"Betalning","myOrders_table1Column5":"Uppfyllt","myOrders_table1Column6":"Totalt","myOrders_tableTitle":"PRODUKTDETALJER","myOrders_table2Column1":"Produkt","myOrders_table2Column2":"Titel","myOrders_table2Column3":"Kvantitet","myOrders_table2Column4":"Artikelpris","myOrders_table2Column5":"Spårningsnummer","myOrders_table2Column6":"Leveransdatum","myOrders_table2Column7":"Totalt Pris","myOrders_content1":"Delsumma","myOrders_content2":"Skatt","myOrders_content3":"Fraktkostnad","myOrders_content4":"Totalt","myOrders_content5":"Anteckning","myOrders_content6":"Utkast till id","tab_Dashboard":"Översikt","dashbord_Tab":"Hem","tab_CustomerInvoice":"Skapa order","tab3_WholesaleOrder":"Återförsäljare Ordrar","tab_AffiliateLink":"Affiliate Länk","tab_CartSharing":"Kundvagnsdelning","tab_DiscountCoupon":"Rabattkupong","tab7_YourBio":"Ditt kontaktkort","tab8_Team":"Team","tab9_AddCustomer":"Lägg till Kund","tab_MyCustomers":"Mina Kunder","tab_YourSalesOrderDetails":"Dina säljorder Detaljer","tab12_MyOrders":"Mina beställningsdetaljer","tab13_Logout":"Logga ut","signUp_title":"Säljrepresentant inskrivning","signUp_subTitle":"Fyll i detta formuläret för att skriva in dig som Säljrepresentant och få tillgång till alla säljteams funktioner.","signUp_content1":"Mailadress","signUp_content2":"Förnamn","signUp_content3":"Efternamn","signUp_content4":"Telefonnummer","signUp_content5":"Facebookprofil","signUp_content6":"Twitter-handtag ","signUp_content7":"Instagramprofil","signUp_content8":"Ladda upp profilbild ","signUp_socialmedialable1":"Sociala medier","signUp_socialmedialable2":"frivillig ","signUp_uploadBtn":"Välj Fil","signUp_uploadBtnPlaceHolder":"Ingen fil Vald","signUp_button3":"Sparar information ...","signUp_welcomemsg1":"Hej","signUp_welcomemsg2":"skriv in dig som Säljrepresentant och få en Förtjänst från säljare dina säljare","signUp_emailerror":"Ange Mailadress","signUp_Fnameerror":"Ange Förnamn","signUp_lnameerror":"Ange efternamn ","signUp_phnumbererror":"Ange telefonnummer","signUp_successmsg":"Din begäran har registrerats framgångsrikt, du kommer snart att få kontoaktivering via e-post när vår administratör godkänner din begäran.","signUp_errorsmsg":"Fel vid Sparande utav Uppgifter. Den här användarens mailadress har redan konto.","signUp_RepExistErrorMsg":"Den här mailadressen är registrerad som Säljrep.","addingRep_selectRepsLabel1":"Vem hjälpte dig?","addingRep_NoSalesRep":"Ingen SäljRep","addingRep_successMsg":"La till SälRep ID till Varukorgens anteckingar","addingRep_selectRepsLabel2":"Var god välj en artikel i listan.","wholesaleOrder_WholesaleDiscountTableColumn1":"Produkt Titel","wholesaleOrder_WholesaleDiscountTableColumn2":"Rabatt","customerInvoice_ViewClientOrdersColumn1":"Kundens Namn","customerInvoice_ViewClientOrdersColumn2":"Produkt Titel","customerInvoice_ViewClientOrdersColumn3":"Delsumma Pris","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Faktura","salesRep_order_errorMsg":"Fel vid skapande utav din order. Kontakta kundtjänst.","salesRep_order_successMsg":"Orderfaktura skapad! Fakturan har blivit skickad till kunden!","salesRep_order_errorMsg2":"Fel vid skapande utav din order. Kontakta kundtjänst","customedraft_btn1":"Skapa ny Faktura","customedraft_btn2":"Inga produkter valda. Välj produkter och försök igen.","customedraft_btn3":"Skapa Order...","customedraft_btn4":"Skapa ny Faktura","salesRep_order_NoProductSelected":"Ingen produkt vald. Välj produkt och försök igen.","productnotselectforcartsharingtxt1":"Ingen produkt vald. Välj produkt och försök igen.","discountCoupons_tblColumn1":"Rabattkupongs kod","discountCoupons_tblColumn2":"Rabattkupongens rabatt","discountCoupons_tblColumn3":"Tag bort Rabattkupongens Kod","discountedPriceLabel":"Ditt rabatterade Pris:","couponCodeNotSet":"Rabattkupongens kod är inte aktiverad","dashboard_subTitle2":"Nuvarande månadscykel 5:e-4:e","affiliatelink_commissiononlbl":"Produkt","displaycommission_lbl1":"Produkt typ","displaycommission_lbl2":"SäljRep","displaycommission_lbl3":"Kvantitets baserad Rabatt","discountcommissiononlbl1":"Klientens Rabattnivåer","clientInvoiceCommissionTablecolumn1":"Produkt Typ","clientInvoiceCommissionTablecolumn2":"Förtjänst","clientInvoiceCommissionTablecolumn3":"Produkt Titel","clientInvoiceCommissionTablecolumn4":"SäljareRep Namn","clientInvoiceQuantityBaseDiscountTablecolumn1":"Produkt Namn","clientInvoiceQuantityBaseDiscountTablecolumn2":"Rabatt","clientInvoiceQuantityBaseDiscountTablecolumn3":"Kvantitet","affiliateCartProdtableColumn1":"Produkt","affiliateCartProdtableColumn2":"Produkt Titel","affiliateCartProdtableColumn3":"pris","affiliateCartProdtableColumn4":"Förtjänst","affiliateCartProdtableColumn5":"Affiliate Länk","affiliateCartProdtableColumn6":"Delningslänk","productnotselectforcartsharinglbl1":"Skriv in Varukorgens Namn","productnotselectforcartsharinglbl2":"Inga produkter Valda. Välj produkter och försök igen.","productnotselectforcartsharinglbl3":"Vänta, bearbetar...","showSharedCartProductcolumn1":"Varukorgens länk","showSharedCartProductcolumn3":"Tag bort Varukorg","onSuccessInvoiceSuccessMsg":"Faktura Skickad","onSuccessInvoiceFailedMsg":"Fakutrasändning misslyckades","sendInvoice_successMsg":"Faktura skickad","deleteInvoice_successMsg":"Faktura borttage","deleteInvoice_FailedMsg":"Bortagning utav Faktura Misslyckades","deleteInvoice_btnlbl":"Tar bort Faktura","deleteSharedCartLink_successMsg":"Länk Borttagen","deleteSharedCartLink_FailedMsg":"Fel vid borttagning utav länk. Var god försök igen..","deleteSharedCartLink_btnlbl":"Tar bort länk","viewInvoiceOrders_btntxt1":"Mottar...","viewInvoiceOrders_btntxt2":"Visa Tidigare Ordrar","createCoupon_btnlbl1":"Skapar Rabattkupong..","createCoupon_btnlbl2":"Rabattkupong Skapad","deleteCoupon_successMsg":"Rabattkupong Borttagen","deleteCoupon_FailedMsg":"Borttagning utav Rabattkupong Misslyckades","deleteCoupon_btnlbl":"Tar bort...","viewProductModelColumn1":"Produkt","viewProductModelColumn2":"Titel","viewProductModelColumn3":"Kvantitet","viewProductModelColumn4":"Återbetalt belopp","viewProductModelColumn5":"Artikelpris","viewProductModelColumn6":"Rabatterat Pris","viewProductModelColumn7":"Spårningsnummer","viewProductModelColumn8":"Leveransdatum","viewProductModelColumn9":"Totalt Pris","showSharedCartProducts_column2":"Bild","showSharedCartProducts_column3":"Lägg till kvantitet","showSharedCartProducts_column4":"Titel","showSharedCartProducts_column5":"Varierad Titel","showSharedCartProducts_column6":"Pris","viewClientOrders_btn1":"Visa","viewClientOrders_btn2":"Skicka","viewClientOrders_btn3":"Radera","showCouponTable_txt1":"Mottar...","showCoupon_btn2":"Visa Rabattkuponger","showCoupon_btn1":"Kopierad","affliateOrder_column1":"Kundens Namn","affliateOrder_column2":"Kundens Mailadress","affliateOrder_column3":"Produkt Titel","affliateOrder_column4":"Order Datum","affliateOrder_column5":"Delsumma","affliateOrder_column6":"Förtjänst","affliateOrder_btn1":"Mottar...","affliateOrder_btn2":"Visa Affiliate Ordrar","affliateOrder_btn3":"Visa Affiliate Ordrar","yourBio_btn1":"Spara","yourBio_btn2":"Spara","yourBio_Uploadbtn1":"Uppladdning...","yourBio_Uploadbtn2":"Uppladdat","yourBio_UploadbtnError":"Ursäkta, försök igen","yourBio_Savebtn":"Sparar..","team_txt1":"Sparar..","team_txt2":"Spara","viewRepClientOrdersDetails_column1":"Ordernummer","viewRepClientOrdersDetails_column2":"Order Date","viewRepClientOrdersDetails_column3":"Delsumma","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Produktdetaljer","addSalesRep_txt1":"Lägg till SäljareRep","addSalesRep_txt2":"Lägger Till SäljarRep...","discountCoupons_header":"Engångs Rabattkuponger","discountCoupons_nodiscountcoupon":"Du har inte skapat några Rabattkuponger","discountCoupons_deleteBtn":"Tag Bort","discountCoupons_BackBtn":"Tillbaka","customerInvoice_selectcustomererror":"Välj kund och lägg sedan till produkt","createOrderFromCartPage_selectCustomersLabel":"VÄLJ KUND","createOrderFromCartPage_selectCustomerAddressLabel":"LEVERANSADRESS","createOrderFromCartPage_selectCustomersLabelForDropDown":"Välj kund","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Välj Adress","createOrderFromCartPage_successMsg":"Beställningsfaktura skapad! Faktura har skickats till kund!","createOrderFromCartPage_toggleButton":"Lägg till ny leveransadress","createOrderFromCartPage_AddNewAddressTitle":"LÄGG TILL NY ADRESS","createOrderFromCartPage_customer_errorMsg1":"Ingen kund utvald. Välj kund och försök igen.","createOrderFromCartPage_order_errorMsg1":"Inga produkter valda. Välj produkter och försök igen.","createOrderFromCartPage_Address_errorMsg2":"Välj Adress och försök igen.","createOrderFromCartPage_Address_errorMsg3":"Fyll i alla adressfält.","createOrderFromCartPage_Order_errorMsg2":"Ett fel uppstod när din beställning skapades. Kontakta supporten","createOrderFromCartPage_draftOrderButton":"SKAPA KRAFTBESTÄLLNING","createOrderFromCartPage_OrderButton":"SKAPA BESTÄLLNING","createOrderFromCartPage_draftOrderButtonText2":"SKAPA BESTÄLLNING ...","createOrderFromCartPage_selectShippingCostTitle":"FRAKTKOSTNAD","createOrderFromCartPage_selectShippingCost":"Välj fraktkostnad","createOrderFromCartPage_Address_errorMsg4":"Det gick inte att beräkna dina fraktpriser.","createOrderFromCartPage_Address_errorMsg5":"Något gick fel, försök igen.","yourSales_tabHeading3":"Återbetalningsbeställningar","refundOrders_column1":"Återbetalnings-ID","refundOrders_column2":"Orderdatum","refundOrders_column3":"Ordernummer","refundOrders_column4":"Beställningsnamn","refundOrders_column5":"Provision","refundOrders_column6":"Team Manager Commission","refundOrders_column7":"Team Manager ID","refundOrders_column8":"Återbetalning delsumma","refundOrders_column9":"Orderstatus","refundOrders_column10":"Ordertyp","refundOrderNumber_title":"Återbetalningsbeställningsdetaljer","refundOrderNumber_column1":"namn","refundOrderNumber_column2":"Datum","refundOrderNumber_column3":"Kvantitet","refundOrderNumber_column4":"Rea-pris","refundOrderNumber_column5":"delsumma","tableDataError":"Ingen återbetalningsorder","dashboard_subTitle3":"Uppgifter om kommissionen","dashboard_cardHeading5_1":"kommissionen på","dashboard_cardHeading5_2":"Du kommer att få en","dashboard_cardHeading5_3":"provision på alla beställningar.","dashboard_cardHeading5_4":"Du får en provision baserat på produkter du säljer","dashboard_cardHeading5_5":"Du får en provision baserad på produkttyper","Profit_Margin":"Vinstmarginal","Product_Type":"Produkttyp","Sales_Rep":"Säljare","show_commission_list":"Visa provisionslista","commission_list":"Kommissionsförteckning","no_link_to_show":"Ingen länk att visa","no_customers_to_show":"Inga kunder att visa","no_sales_to_show":"Ingen försäljning att visa","no_draft_to_show":"Inget utkast att visa","no_refund_to_show":"Ingen återbetalning att visa","no_orders_to_show":"Inga beställningar att visa","customerInvoice_ViewClientOrdersColumn6":"Ordernummer","customerInvoice_ViewClientOrdersColumn7":"Orderdatum","Error_commissions_NotUpdated":"Provisioner uppdateras inte","sales_chart_msg1":"Vi behöver data...","sales_chart_msg2":"Det verkar som att vi inte har några uppgifter att visa ännu.","page_refresh_msg":"klicka för att uppdatera","variant_title":"Varianttitel","line_items_properties":"Egenskaper","customer_country":"Kundland","customer_state":"Kundstat","company_country":"Företagsland","company_state":"Företagsstat","client_orders":"Kundordrar","no_product_details":"Inga produktdetaljer att visa","submit_btn_text":"Skicka in","submitting_btn_text":"Skickar in","submitted_btn_text":"Lämnats","email_id_validation_errmsg":"Vänligen ange ett giltigt e-post-ID","customerInvoice_add_more_details":"Lägg till fler detaljer","customerInvoice_add_shipping_address":"Lägg till ny leveransadress","customerInvoice_HideDetails":"Gömma detaljer","customerInvoice_HideAddress":"Dölj leveransadress","customerInvoice_enterFirstName":"Ange förnamn","customerInvoice_enterFirstNamePlaceholder":"Förnamn","customerInvoice_enterLastName":"Ange efternamn","customerInvoice_enterLastNamePlaceholder":"Efternamn","customerInvoice_enterAddress1":"Ange adressrad 1","customerInvoice_enterAddress1Placeholder":"Adressrad 1","customerInvoice_enterAddress2":"Ange adressrad 2","customerInvoice_enterAddress2Placeholder":"Adress Linje 2","customerInvoice_enterCity":"Gå in i staden","customerInvoice_enterCityPlaceholder":"Stad","customerInvoice_selectCountry":"Välj land","customerInvoice_selectState":"Välj stat","customerInvoice_enterZipNumber":"Ange postnummer","customerInvoice_enterZipNumberPlaceholder":"Postnummer","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Produkten är inte tillgänglig","customerInvoice_SendInvoiceBtn":"Skicka faktura","customerInvoice_CreateOrderBtn":"Skapa order","customerInvoice_ProductTableColumnSubTotal":"Subsumma","customerInvoice_SelectShippingAddress":"Välj leveransadress","customerInvoice_ProductsSearchBy_Placeholder":"Sök efter produkter efter namn, SKU, pris","customerInvoice_AddMoreProducts_Btn":"Lägg till fler produkter","customerInvoice_RequiredErrorMsg":"Detta fält är obligatoriskt","customerInvoice_EmailSuggestionErrorMsg":"Vänligen lägg till ett giltigt e-post-ID","customerInvoice_MobileSuggestionErrorMsg":"Vänligen lägg till giltigt telefonnummer","customerInvoice_ErrorMsgAddShippingAddress":"Vänligen fyll i leveransadress","customerInvoice_Creating_Msg":"Skapande...","customerInvoice_Sending_Msg":"Sändning...","customerInvoice_OrderCreatedSuccessfullyMsg":"Beställning skapad framgångsrikt","customerInvoice_InvoiceSentSuccessfullyMsg":"Faktura har skickats till kunden","customerInvoice_ErrorMsgTryAgain":"Fel.. försök igen","customerInvoice_Selected_Btn":"Vald","customerInvoice_ProductTableQuantityUpdate_Btn":"Välj produkt","customerInvoice_OrderSubTotal":"Beställningens totala kostnad","delete_confirmation_text":"Är du säker ?","draftOrder_OrderNumber":"Ordernummer","draftOrder_CustName":"Köparens namn","draftOrder_OrderDate":"Orderdatum","draftOrder_SubTotal":"Summan","draftOrder_Status":"Status","draftOrder_Invoice":"Faktura","draftOrder_DraftId":"Utkast till ID","draftOrder_ShippingCost":"Fraktkostnad","draftOrder_Tax":"Beskatta","draftOrder_TotalPrice":"Totalbelopp","draftOrder_Note":"Notera","draftOrder_Product":"Produkt","draftOrder_ProductName":"produktnamn","draftOrder_Size":"Storlek","draftOrder_Quantity":"Kvantitet","draftOrder_Price":"Pris","noDraftOrderProducts":"Inga utkast till beställningsproduktdetaljer tillgängligt.","noRefundOrderProduct":"Inga produktinformation för återbetalningsorder.","loading":"Läser in...","dashboard_commissionOn_profitMargin":"Provision på vinstmarginal","dashboard_clientInvoice":"Klientfaktura","dashboard_affiliateLink":"Affiliate order","dashboard_returnCustomer":"Returnera kunden","dashboard_discountCoupon":"Rabattkupong","dashboard_SharedCart":"Delad kundvagn","dashboard_AdminTaggedOrders":"Admin Tagged Order","dashboard_no_data":"Ingen data tillgänglig","dashboard_sales_of_last_six_months":"Försäljning av de senaste 6 månaderna","dashboard_sales_of_current_month":"Försäljning av den aktuella månaden","addCustomer_ErrorMsgOnSubmitBtn":"var vänlig och slå in ett giltigt telefonnummer","login_welcome_Msg":"Välkommen till säljteamet","login_title":"Logga in","login_email":"E-post ID","login_password":"Lösenord","emailValidation_ErrorMsg":"Ange giltigt e -post -ID","login_newUser":"Ny användare?","login_SignUp":"Bli Medlem","login_forgotPassword_link":"Glömt ditt lösenord?","login_LogInBtn":"Logga in","login_sliderContent_1":"Reps -beställning av klienter","login_sliderContent_2":"Rep driver trafik till butik","login_sliderContent_3":"Reps marknadsföringsprodukter med sociala medieplattformar","login_sliderContent_4":"Rep kan köpa i bulk och tjäna vinst","login_sliderContent_5":"Reps -beställning av klienter","login_sliderContent_6":"Reps kan besöka kunder personligen och skapa beställningar","required_ErrorMsg":"Vänligen fyll obligatorisk fält","signup_title":"Bli Medlem","signup_BackTo_login":"Tillbaka till login","signup_firstName":"Förnamn","signup_lastName":"Efternamn","signup_BackBtn":"Tillbaka","signup_NextBtn":"Nästa","signup_phone_number":"Telefonnummer","signup_phone_number_Error":"Ange minst 10 siffror","signup_uploadPicture":"Ladda upp profilbild","signup_fileSizeError":"Filstorleken är större än 5 MB","signup_filePath_lable":"Vald fil","signup_MediaTitle2":"Länkar på sociala medier","signup_facebookHandle":"Facebookhandtag","signup_InstaHandle":"Instagram -handtag","signup_SaveBtn":"Spara information","forgotPwd_title":"Glömt ditt lösenord","forgotPwd_ResetBtn":"Återställ lösenord","forgotPwd_SuccessMsg":"Din begäran om återställningslösenord är framgångsrik, vi har skickat det nya lösenordet till ditt registrerade e -post -ID.","customerInvoice_selectShippingCost":"Välj Fraktkostnad","customerInvoice_CalculatingShippingRates_Msg":"Beräknande...","customerInvoice_AddShippingAddress_Msg":"Välj Adress eller Lägg till leveransadress","customerInvoice_PleaseSetAnyShippingAddressMsg":"Vänligen välj en leveransadress","customerInvoice_ShippingCostErrorMsg":"Vänligen lägg till ny leveransadress, eftersom adressen har otillräcklig information.","customerInvoice_CalculateShippingCost_Btn":"Beräkna fraktkostnad","customerInvoice_ShippingCostAddOrNot_Msg":"Vill du lägga till fraktkostnad?","customerInvoice_ShippingCostAddOrNot_Yes":"Ja","customerInvoice_ShippingCostAddOrNot_No":"Nej","customerInvoice_ShippingCostIsUnavailable":"Fraktkostnaden för denna adress är inte inställd från administratörssidan. Även om beställningar kan göras utan att beräkna fraktkostnaden.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Var god försök igen","dashboard_BannerMsg":"Grafer uppdateras var 8: e timme","yourSales__BannerMsg":"Beställningsinformation uppdateras var 5:e minut","customerInvoice_FirstNameErrorMsg":"Vänligen ange förnamn","customerInvoice_lastNameErrorMsg":"Vänligen ange efternamn","customerInvoice_Add1ErrorMsg":"Ange adressrad 1","customerInvoice_CountryErrorMsg":"Välj land","customerInvoice_StateErrorMsg":"Vänligen välj stat","customerInvoice_CityErrorMsg":"Ange stadens namn","customerInvoice_ZipErrorMsg":"Vänligen ange postnummer","uploadImage":"Ladda upp bild","dashboard_CardTitle1":"Kommission för alla beställningar","dashboard_CardTitle3":"Total provision","dashboard_TotalRevenue":"Totala intäkter","dashboard_TotalAvg_Ticket_Size":"Genomsnittlig biljettstorlek","dashboard_CardTitle4":"Total rea","profile_Change_Password":"Ändra lösenord","dashboard_Information_Message":"Kommissionen spåras endast för betalda beställningar","resetPassword_validation_Msg":"Detta fält krävs","resetPassword_validation_Msg2":"Lösenordet ska innehålla minst 8 tecken, 1 versaler, 1 små bokstäver, 1 siffra etc.","resetPassword_validation_Msg3":"Bekräfta lösenordet ska matcha med nytt lösenord","dashbord_Msg_New":"Hur det fungerar","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Maximal rabatt är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","discount_couponErrorMsg2":"Kommissionen är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","dashbord_profile_pic":"Ändra profilbild","Performance_Details":"Prestationsdetaljer","Show_Performance_Details":"Visa prestandainformation","Dashboard_Month":"Månad","Dashboard_Orders_Total":"Totala beställningar","Dashboard_Total_Sale":"Total försäljning","Dashboard_Commission":"Provision","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Vänligen lägg till kundadress.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Klicka på knappen Beräkna fraktkostnad och välj en.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Varukorgen har inte uppdaterats, uppdatera och försök igen.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Vänligen välj produkt.","customerInvoice_CreatingDraft_Msg":"Utkast skapas..","customerInvoice_DraftOrderBtn":"Utkast till order","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Utkast till order har skapats framgångsrikt","productTable_error_AlertMsg":"Kvantitet kan inte vara 0 eller mindre, ange något giltigt värde","productTable_error_AlertMsg2":"Ange kvantitet","click_to_copy":"Klicka för att kopiera","discount_code_copy_coupon":"Kopieringskupong","createOrder_productSearchGuide":"Kan du inte hitta produkter?","soldOut":"Utsåld","InventoryNotTracked":"Inventering spåras inte","productStatus":"Produktstatus","makeSureInShopify":"Se till i Shopify","products":"Produkter","sectionTheProductStatusIs":"avsnittet är produktens status","active":"Aktiva","productsMayBeSoldOutPleaseCheck":"Produkter kan vara slutsålda, kontrollera och välj","Credit_Limit_Error_Msg":"Kreditgränsen överskrids, försök igen..!"}'
        ),
        Et = JSON.parse(
          '{"dashboard_title":"PAINEL","dashboard_welcomeMsg":"Bem-vindo ao","dashboard_morningMsg":"Bom dia","dashboard_afternoonMsg":"Boa tarde","dashboard_eveningMsg":"Boa noite","dashboard_subTitle1":"Mês atual","dashboard_block1Heading":"Fatura do cliente","dashboard_block1Header1":"GANHOS","dashboard_block1Header2":"Fatura enviada","dashboard_block1Header3":"FATURA PAGA","dashboard_block2Heading":"Ordens de atacado","dashboard_block2Header1":"GANHOS","dashboard_block2Header2":"Fatura enviada","dashboard_block2Header3":"FATURA PAGA","dashboard_block3Heading":"Ordens de afiliados","dashboard_block3Header1":"GANHOS","dashboard_block3Header2":"Pedidos pagos","dashboard_block4Heading":"CUPOM DE DESCONTO","dashboard_block4Header1":"GANHOS","dashboard_block4Header2":"Pedidos pagos","dashboard_block5Heading":"Comissão de clientes","dashboard_block5Header1":"COMISSÃO","dashboard_block5Header2":"Ordens","dashboard_block6Heading":"Comissão líder da equipe","dashboard_block6Header1":"COMISSÃO","dashboard_block7Heading":"Comissão de POS","dashboard_block7Header1":"COMISSÃO","dashboard_block7Header2":"Pedidos","dashboard_tbl1column1":"Mês","dashboard_tbl1column2":"Pedidos de fatura do cliente","dashboard_tbl1column3":"Comissão de Fatura do Cliente","dashboard_tbl1column4":"Pedido de atacado","dashboard_tbl1column5":"Compra total no atacado","dashboard_tbl1column6":"Pedidos de afiliados","dashboard_tbl1column7":"Comissão de Affilate","dashboard_tbl1column8":"Pedidos de cuponCode","dashboard_tbl1column9":"Comissão de código de cupom","dashboard_tbl1column10":"Pedidos de clientes","dashboard_tbl1column11":"Comissão de clientes","dashboard_tbl1column12":"Pedidos de PDV","dashboard_tbl1column13":"Comissão de POS","dashboar_cardHeading1":"Pedido total","dashboar_cardHeading2":"Comissão","dashboar_cardHeading3":"Vendas","dashboar_cardHeading4":"Bônus","dashboard_graphHeading1":"Desempenho de vendas dos últimos seis meses","dashboard_graphHeading2":"Analise de pedidos e a comissão de recursos para o mês atual","Graph_Sales_noorderstitle":"Sem pedidos para mostrar","Graph_SalesRepCommission_nocommissiontitle":"Nenhum dado de comissão para mostrar","Graph_SalesRepOrders_title":"Pedidos","Graph_SalesRep_XAxisTitle_ForMonth":"6 mesas","Graph_SalesRepOrders_YAxisTitle":"Pedidos","Graph_SalesRepSales_title":"VENDAS","Graph_SalesRepCommission_title":"COMISSÃO","Graph_SalesRepCommissions_YAxisTitle":"Comissão","Graph_FeatureWiseOrder_title":"Beställningar vs -funktionen","Graph_featureWiseCommission_title":"Commission vs Feature","Graph_FeatureWiseOrder_XAxisTitle":"Recurso","Graph_FeatureWiseOrder_YAxisTitle":"Pedidos","Graph_FeatureWiseCommission_title":"COMISSÃO","Graph_FeatureWiseCommission_YAxisTitle":"Comissão","customerInvoice_title":"Criar pedido","customerInvoice_button":"Voltar","customerInvoice_noclientorderMsg":"Sem pedidos de fatura de clientes","customerInvoice_button1":"Ver pedidos anteriores","customerInvoice_contentHeading1":"Desconto e comissão","customerInvoice_table1column1":"Tipo de Produto","customerInvoice_table1column2":"Comissão","customerInvoice_table1column3":"Nome de desconto","customerInvoice_table1column4":"Desconto","customerInvoice_contentHeading2":"Adicione detalhes do cliente e selecione produtos para enviar fatura.","customerInvoice_contentHeading2Title1":"Digite/Pesquisar Cliente","customerInvoice_title1Placeholder":"Digite/Pesquisar Cliente","customerInvoice_contentHeading2Title2":"Digite ID de e -mail do cliente","customerInvoice_title2Placeholder":"Endereço de email","customerInvoice_contentHeading2Title3":"Digite Notas do pedido","customerInvoice_contentHeading2Title4":"Endereço do cliente","customerInvoice_contentHeading2Title5":"Número do celular do cliente","customerInvoice_contentHeading2Title6":"Nota do cliente","customerInvoice_contentHeading2Title7":"Nome da empresa do cliente","customerInvoice_title7Placeholder":"nome da empresa","customerInvoice_Placeholder_contentHeading2Title6":"Observação","customerInvoice_Placeholder_contentHeading2Title5":"Número de celular","customerInvoice_Placeholder_contentHeading2Title4":"Endereço para envio","customerInvoice_title3Placeholder":"Notas de pedidos","customerInvoice_SearchProducts_Label":"procurar produtos","customerInvoice_table2Column1":"Imagem","customerInvoice_table2Column2":"Adicione quantidade","customerInvoice_table2Column3":"Título","customerInvoice_table2Column4":"Título variante","customerInvoice_ProductTableColumnPrice":"Preço","customerInvoice_ProductTableColumnWholeSalePrice":"Preço por atacado","customerInvoice_button2":"Criar recibo","customerInvoice_ProductTableColumnProduct":"produtos","customerInvoice_table3Column2":"Nome do Produto","customerInvoice_table3Column3":"Tamanho","customerInvoice_ProductTableColumnQuantity":"Quantidade","customerInvoice_table3Column5":"Preço do item","customerInvoice_table3Column6":"Preço total","customerInvoice_table3Column7":"Preço com desconto para o cliente","customerInvoice_table3Column8":"Comissão de Representante de Vendas","customerInvoice_table3Column9":"Desconto","customerInvoice_repproInvite":"Selecione a caixa de seleção para enviar um convite profissional","customerInvoice_customerOrder_error1":"Todos os campos de clientes são obrigatórios. Insira o e -mail e o primeiro nome do cliente","customerInvoice_productAddedMsg":"Produto adicionado","customerInvoice_AlertErrorMsg":"Erro...Contate o Suporte!","wholesaleOrder_title":"Pedido por atacado","wholesaleOrder_contentHeading1":"Você pode comprar produtos a preços especiais de atacado","wholesaleOrder_contentHeading2":"Desconto em","wholesaleOrder_column1":"Nome do Representante de Vendas","wholesaleOrder_column2":"Desconto","wholesaleOrder_searchtxtPlaceholder":"Produto de pesquisa","wholesaleOrder_table1Column1":"Imagem","wholesaleOrder_table1Column2":"Adicione quantidade","wholesaleOrder_table1Column3":"Título","wholesaleOrder_table1Column4":"Título variante","wholesaleOrder_table1Column5":"Preço","wholesaleOrder_button":"Confira","wholesaleOrder_Order_btn":"Mostrar/ocultar preços de volume","wholesaleOrder_contentHeading3":"Preço total","wholesaleOrder_contentHeading4":"Seu preço com desconto","wholesaleOrder_table2Column1":"produtos","wholesaleOrder_table2Column2":"Nome do Produto","wholesaleOrder_table2Column3":"Tamanho","wholesaleOrder_table2Column4":"Quantidade","wholesaleOrder_table2Column5":"Preço do item","wholesaleOrder_table2Column6":"Preço total","wholesaleOrder_table2Column7":"Seu preço com desconto","affiliateLink_title":"Link de afiliado","affiliate_product_link":"Link do produto","affiliateLink_input_error_msg":"O campo de texto de link é necessário e não deve conter espaços.","affiliateLink_contentHeading1":"Compartilhe seu link de afiliado nas mídias sociais e email. Você receberá uma comissão de afiliados para cada pedido do seu link de afiliado","affiliateLink_contentHeading2":"Seu link de afiliado","affiliateLink_contentHeading3":"Comissão em","affiliateLink_content_Message1":"Pesquise produtos e compartilhe o link de produtos individuais com seus clientes.","affiliateLink_noaffiliateorderMsg":"Sem pedidos de afiliados","affiliateLink_column1":"Nome do Representante de Vendas","affiliateLink_column2":"Comissão","affiliateLink_searchtxtPlaceholder":"Produto de pesquisa","affiliateLink_searchColumn1":"produtos","affiliateLink_searchColumn2":"Título do produto","affiliateLink_searchColumn3":"Preço","affiliateLink_searchColumn4":"Comissão","affiliateLink_searchColumn5":"Link de afiliado","affiliateLink_searchColumn7":"Link de cópia","affiliateLink_searchColumn8":"Copiado","affiliateLink_backbtn":"Voltar","affiliateLink_card_Title":"Kontaktkort och anslutet länk","cartSharing_title":"Compartilhamento de carrinho","cartSharing_CreateCartInformation_Text":"Para criar um carrinho compartilhável personalizado, adicione produtos ao carrinho da loja. Esses produtos serão exibidos nesta página","cartSharing_content2Placeholder":"Nome do carrinho","cartSharing_table2Column2":"Nome do Produto","cartSharing_table2Column3":"Tamanho","cartSharing_table2Column6":"Preço total","cartSharing_SharedCartLinkTableColumnCartName":"Nome do carrinho","cartSharing_SharedCartLinkTableColumnLink":"Link","cartSharing_SharedCartLinkTableColumnCartLink":"Link de carrinho compartilhável","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copie o link do carrinho","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Exclua o link do carrinho","cartSharing_EnterCartName_Label":"Digite o nome do carrinho","cartSharing_ProductTableColumnProduct":"produtos","cartSharing_ProductTableColumnQuantity":"Quantidade","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventário","cartSharing_ProductTableColumnItemPrice":"Preço do item","cartSharing_Copied_Msg":"Copiado!","cartSharing_CartCreating_Msg":"Criando...","cartSharing_SharedCartLinkTableEmpty_Msg":"Nenhum link para mostrar","cartSharing_CartCreatedSuccessfully_Msg":"Carrinho criado com sucesso","cartSharing_CartCreateError_Msg":"Erro... por favor tente novamente","cartSharing_AlertError_Msg":"Erro... Contate o suporte!","cartSharing_CopyCartLink_Msg":"Copie o link do carrinho","cartSharing_DeleteCartLink_Msg":"Exclua o link do carrinho","cartSharing_DeleteConfirmation_Msg":"Tem certeza?","cartSharing_ProductTableEmpty_Msg":"Produto não disponível","cartSharing_CreateCart_Btn":"Criar carrinho","cartSharing_ProductTableQuantityUpdate_Btn":"Selecione o produto","cartSharing_Select_product_Title":"Välj produkt","discountCoupon_titleOne":"Cupom de desconto","discountCoupon_contentHeading1":"Compartilhe o código do cupom de desconto com seus clientes e sempre que o seu cupom for usado, você recebe uma comissão.","discountCoupon_contentHeading2":"Seu código de cupom é","discountCoupon_contentHeading3":"Valor do desconto","discountCoupon_contentHeading4":"Comissão","discountCoupon_contentHeading4PlaceHolder1":"Ei, use meu código de cupom de desconto","discountCoupon_contentHeading4PlaceHolder2":"e obter produtos com desconto","discountCoupon_button1":"Copiar texto","cartSharing_copiedButtonText":"Copiado","discountCoupon_titleTwo":"Crie cupons de desconto para clientes para clientes","discountCoupon_button2":"Veja cupons","discountCoupon_contentHeading5":"Desconto máximo permitido","discountCoupon_contentHeading6":"Comissão","discountCoupon_contentHeading7":"Digite o código do cupom","discountCoupon_contentHeading7PlaceHolder":"Por favor, insira o código do cupom","discountCoupon_contentHeading8":"Insira desconto","discountCoupon_contentHeading8PlaceHolder":"O desconto não deve ser maior que o desconto máximo.","discountCoupon_button3":"Crie cupom","discountCoupon_coupon_error1":"Por favor, insira o código do cupom e o desconto","yourBio_title":"Seu cartão de contato","yourBio_content1":"Carregar perfil","yourBio_button1":"Escolher arquivo","yourBio_button1PlaceHolder":"Nenhum arquivo selecionado","yourBio_error_image_size":"O tamanho da imagem é muito grande, envie uma imagem de tamanho menor que 5 MB. Por favor, tente novamente.","yourBio_button2":"Carregar","yourBio_content2":"Digite uma palavra personalizada para criar seu link de afiliado exclusivo","yourBio_content2PlaceHolder":"Crie seu link de afiliado exclusivo","yourBio_content4":"Quando seu link será usado, seu cartão de contato aparecerá no site","yourBio_content3":"Digite seu cartão de contato","yourBio_content3PlaceHolder":"Digite até 100 palavras","yourBio_button3":"Salvar","yourBio_button4":"Salvou","yourBio_error_link":"Este link único pode ser tomado. Tente com um link exclusivo diferente.","yourBio_Linksuccessmsg":"Link exclusivo salvo com sucesso.","team_title1":"Adicione Representante de Vendas","team_content1":"Digite email","team_content1PlaceHolder":"Endereço de email","team_emailerrorMsg":"Por favor, insira o email","team_content2":"Introduza o primeiro nome","team_content2PlaceHolder":"Primeiro nome","team_fnameerrorMsg":"Por favor, insira o primeiro nome","team_content3":"Insira o último nome","team_content3PlaceHolder":"Sobrenome","team_button1":"Adicionar","team_successmsg":"Adicionado com sucesso! Verifique seu e -mail para obter as instruções de ativação.","team_errorsmsg":"Erro ao adicionar. Este e -mail de usuário já pode ter uma conta na loja.","team_title2":"Detalhes da equipe","team_content4":"Página de inscrição","team_NoTeamDetailsMsg":"Sem detalhes da equipe","team_content5":"Selecione o Representante de Vendas","team_tableTitle":"Detalhes dos últimos dois meses do pedido","team_column1":"Número do pedido","team_column2":"Data do pedido","team_column3":"nome do cliente","team_column4":"Representante de vendas","team_column5":"Subtotal","team_column6":"Comissão de Representante","team_column7":"Comissão de Gerente de Equipe","team_column8":"Tipo de comissão","addCustomer_title":"Adicionar cliente","addCustomer_content1":"Primeiro nome do cliente","addCustomer_txt1Placeholder":"Primeiro nome","addCustomer_content2":"Sobrenome do cliente","addCustomer_content2Placeholder":"Sobrenome","addCustomer_content3":"ID de e -mail do cliente","addCustomer_content3Placeholder":"Endereço de email","addCustomer_content4":"Observação","addCustomer_content4Placeholder":"Observação","addCustomer_customerAddress":"Endereço pessoal","addCustomer_customerCity":"Cidade","addCustomer_customerCityPlaceholder":"Cidade","addCustomer_customerCountry":"País","addCustomer_customerState":"Estado","addCustomer_customerZipCode":"CEP","addCustomer_companyName":"nome da empresa","addCustomer_companyAddress":"Endereço da companhia","addCustomer_companyCity":"Cidade","addCustomer_companyCountry":"País","addCustomer_companyState":"Estado","addCustomer_companyZipCode":"CEP","addCustomer_button":"Salvar","addCustomer_leadsuccessmsg":"O cliente é adicionado com sucesso.","addCustomer_leadErrrorMsg":"Erro ao salvar os detalhes.","addCustomer_leadEmptyErrrorMsg":"Por favor, preencha o campo requerido.","addCustomer_leadsuccessmsg2":"Cliente criado e marcado para uma representação de vendas com sucesso.","addCustomer_leadErrrorMsg2":"Este cliente já está marcado para um representante.","myCustomers_title":"Seus clientes","myCustomers_table1Column1":"Nome","myCustomers_table1Column2":"nome da empresa","myCustomers_table1Column3":"Identificação do email","myCustomers_table1Column4":"Ordem","myCustomers_table1Column5":"Total gasto","myCustomers_table2Title":"Detalhes do cliente","myCustomers_table3Title":"Detalhes do pedido de rascunho","myCustomers_table3Column1":"Nome do Produto","myCustomers_table3Column2":"Tamanho","myCustomers_table3Column3":"Quantidade","myCustomers_table3Column4":"Preço","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Subtotal","myCustomers_table2Row1":"Nome","myCustomers_table2Row2":"E-mail","myCustomers_table2Row3":"Endereço","myCustomers_table2Row4":"Nome da Empresa","myCustomers_table2Row5":"Notas dos clientes","myCustomers_table2Row6":"Total gasto (subtotal+imposto)","myCustomers_table2Row7":"Número de encomendas","myCustomers_table2Row8":"Tag","myCustomers_radioButton0":"Mostre todo cliente","myCustomers_radioButton1":"Procura por nome","myCustomers_radioButton2":"Pesquisa por empresa","myCustomers_radioButtonError1":"Selecione o tipo de pesquisa e insira o valor para pesquisar","myCustomers_radioButtonError2":"Por favor, insira o valor para pesquisar","myCustomers_radioButtonError3":"Selecione o tipo de pesquisa","myCustomers_searchButton":"Procurar","myCustomers_Placeholder1":"Digite o nome do cliente ou o nome da empresa para pesquisar","myCustomers_NoOrdersError":"Sem ordens","myCustomer_no_salesRep_details":"Nenhum detalhe do representante de vendas disponível.","myCustomer_select_customer_country":"Selecione o país do cliente","myCustomer_company_country":"País da empresa","myCustomer_company_state":"Estado da empresa","myCustomer_select_company_country":"Selecione o país da empresa","yourSales_SalesOrderDetailsTitle":"Detalhes da ordem de vendas","yourSales_title":"Últimos 2 meses de pedido detalhes","yourSales_table1Column1":"Número do pedido","yourSales_table1Column2":"Data do pedido","yourSales_table1Column3":"nome do cliente","yourSales_table1Column4":"Subtotal","yourSales_table1Column5":"Comissão","yourSales_table1Column6":"Tipo de comissão","yourSales_table1Column7":"Imprimir fatura","printOrderInvoice_btn":"Imprimir","yourSales_tableTitle":"Detalhes do produto","yourSalesDraft_tableTitle":"Detalhes do pedido de rascunho","yourSales_column1":"produtos","yourSales_column2":"Título","yourSales_column3":"Quantidade","yourSales_column4":"Preço do item","yourSales_column5":"Numero de rastreio","yourSales_column6":"Data de envio","yourSales_column7":"Preço total","yourSales_content1":"Subtotal","yourSales_content2":"Imposto","yourSales_content3":"Frete","yourSales_content4":"Total","yourSales_content5":"Observação","yourSales_tabHeading1":"Ordens pagas","yourSales_tabHeading4":"Ordens pendentes","yourSales_tabHeading2":"Rascunho de pedidos","myOrders_title":"Meus detalhes dos meus pedidos","myOrdersDetails_Message":"Ordens feitas para você","myOrders_table1Column1":"Número do pedido","myOrders_table1Column2":"Data do pedido","myOrders_table1Column3":"nome do cliente","myOrders_table1Column4":"Pagamento","myOrders_table1Column5":"Cumprimento","myOrders_table1Column6":"Total","myOrders_tableTitle":"DETALHES DO PRODUTO","myOrders_table2Column1":"produtos","myOrders_table2Column2":"Título","myOrders_table2Column3":"Quantidade","myOrders_table2Column4":"Preço do item","myOrders_table2Column5":"Numero de rastreio","myOrders_table2Column6":"Data de envio","myOrders_table2Column7":"Preço total","myOrders_content1":"Subtotal","myOrders_content2":"Imposto","myOrders_content3":"Frete","myOrders_content4":"Total","myOrders_content5":"Observação","myOrders_content6":"ID do rascunho","tab_Dashboard":"Painel","dashbord_Tab":"Hem","tab_CustomerInvoice":"Criar ordem","tab3_WholesaleOrder":"Ordem por atacado","tab_AffiliateLink":"Link de afiliado","tab_CartSharing":"Compartilhamento de carrinho","tab_DiscountCoupon":"Cupom de desconto","tab7_YourBio":"Seu cartão de contato","tab8_Team":"Equipe","tab9_AddCustomer":"Adicionar cliente","tab_MyCustomers":"Meus clientes","tab_YourSalesOrderDetails":"Detalhes da ordem de vendas","tab12_MyOrders":"Meus detalhes dos meus pedidos","tab13_Logout":"Sair","signUp_title":"Representante de vendas Inscreva -se","signUp_subTitle":"Por favor, preencha este formulário para se inscrever como um representante de vendas e obter acesso a todos os recursos da equipe de vendas.","signUp_content1":"E-mail","signUp_content2":"Primeiro nome","signUp_content3":"Sobrenome","signUp_content4":"Número de telefone","signUp_content5":"Identificador do Facebook","signUp_content6":"Identificador do Twitter","signUp_content7":"Identificador do Instagram","signUp_content8":"Faça upload da imagem do perfil","signUp_socialmedialable1":"Links de mídia social","signUp_socialmedialable2":"opcional","signUp_uploadBtn":"Escolher arquivo","signUp_uploadBtnPlaceHolder":"Nenhum arquivo selecionado","signUp_button3":"Economizando detalhes ...","signUp_welcomemsg1":"Olá","signUp_welcomemsg2":"Inscreva o representante de vendas e obtenha uma comissão de vendas feitas por representantes sob você","signUp_emailerror":"Por favor, insira o email","signUp_Fnameerror":"Por favor, insira o primeiro nome","signUp_lnameerror":"Por favor, insira o sobrenome","signUp_phnumbererror":"Por favor, insira o número de telefone","signUp_successmsg":"Sua solicitação foi registrada com sucesso, em breve você receberá um e-mail de ativação da conta quando nosso administrador aprovar sua solicitação.","signUp_errorsmsg":"Erro ao salvar os detalhes. Este e -mail de usuário já pode ter uma conta na loja.","signUp_RepExistErrorMsg":"Este email já está registrado como representante.","addingRep_selectRepsLabel1":"Quem te ajudou?","addingRep_NoSalesRep":"Nenhum representante de vendas","addingRep_successMsg":"Adicionado repid à nota de carrinho","addingRep_selectRepsLabel2":"Selecione um item na lista.","wholesaleOrder_WholesaleDiscountTableColumn1":"Título do produto","wholesaleOrder_WholesaleDiscountTableColumn2":"Desconto","customerInvoice_ViewClientOrdersColumn1":"nome do cliente","customerInvoice_ViewClientOrdersColumn2":"Título do produto","customerInvoice_ViewClientOrdersColumn3":"Preço subtotal","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Fatura","salesRep_order_errorMsg":"Erro durante a criação de seu pedido. Por favor, suporte de contato","salesRep_order_successMsg":"Fatura do pedido criado com sucesso! A fatura foi enviada por e -mail ao cliente!","salesRep_order_errorMsg2":"Erro durante a criação de seu pedido. Por favor, suporte de contato","customedraft_btn1":"Crie uma nova fatura","customedraft_btn2":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","customedraft_btn3":"Criando ordem ...","customedraft_btn4":"Crie uma nova fatura","salesRep_order_NoProductSelected":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","productnotselectforcartsharingtxt1":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","discountCoupons_tblColumn1":"Código do cupom","discountCoupons_tblColumn2":"Desconto do cupom","discountCoupons_tblColumn3":"Excluir código de cupom","discountedPriceLabel":"Seu preço com desconto:","couponCodeNotSet":"Código de cupom não definido","dashboard_subTitle2":"Ciclo atual do mês: 5 - 4º","affiliatelink_commissiononlbl":"produtos","displaycommission_lbl1":"Tipo de Produto","displaycommission_lbl2":"Representante de vendas","displaycommission_lbl3":"Desconto baseado em quantidade","discountcommissiononlbl1":"Níveis de desconto do cliente","clientInvoiceCommissionTablecolumn1":"Tipo de Produto","clientInvoiceCommissionTablecolumn2":"Comissão","clientInvoiceCommissionTablecolumn3":"Título do produto","clientInvoiceCommissionTablecolumn4":"Nome do Representante de Vendas","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nome do Produto","clientInvoiceQuantityBaseDiscountTablecolumn2":"Desconto","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantidade","affiliateCartProdtableColumn1":"produtos","affiliateCartProdtableColumn2":"Título do produto","affiliateCartProdtableColumn3":"Preço","affiliateCartProdtableColumn4":"Comissão","affiliateCartProdtableColumn5":"Link de afiliado","affiliateCartProdtableColumn6":"Compartilhar link","productnotselectforcartsharinglbl1":"Por favor, insira o nome do carrinho","productnotselectforcartsharinglbl2":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","productnotselectforcartsharinglbl3":"Espere durante o processamento ...","showSharedCartProductcolumn1":"Link do carrinho","showSharedCartProductcolumn3":"Remova o carrinho","onSuccessInvoiceSuccessMsg":"Fatura enviada com sucesso","onSuccessInvoiceFailedMsg":"O envio da fatura falhou","sendInvoice_successMsg":"Fatura enviada com sucesso","deleteInvoice_successMsg":"Fatura excluída com sucesso","deleteInvoice_FailedMsg":"Excluir a fatura falhou","deleteInvoice_btnlbl":"Excluindo a fatura","deleteSharedCartLink_successMsg":"Link excluído com sucesso","deleteSharedCartLink_FailedMsg":"Erro na exclusão de link. Por favor, tente novamente..","deleteSharedCartLink_btnlbl":"Excluindo link","viewInvoiceOrders_btntxt1":"Recebendo...","viewInvoiceOrders_btntxt2":"Ver ordens anteriores","createCoupon_btnlbl1":"Criando cupom...","createCoupon_btnlbl2":"Cupom criado","deleteCoupon_successMsg":"Cupom Excluído","deleteCoupon_FailedMsg":"A exclusão de cupom falhou","deleteCoupon_btnlbl":"Excluindo...","viewProductModelColumn1":"produtos","viewProductModelColumn2":"Título","viewProductModelColumn3":"Quantidade","viewProductModelColumn4":"Quantidade reembolsada","viewProductModelColumn5":"Preço do item","viewProductModelColumn6":"Valor do desconto","viewProductModelColumn7":"Numero de rastreio","viewProductModelColumn8":"Data de envio","viewProductModelColumn9":"Preço total","showSharedCartProducts_column2":"Imagem","showSharedCartProducts_column3":"Adicione quantidade","showSharedCartProducts_column4":"Título","showSharedCartProducts_column5":"Título variante","showSharedCartProducts_column6":"Preço","viewClientOrders_btn1":"Visualizar","viewClientOrders_btn2":"Enviar","viewClientOrders_btn3":"Excluir","showCouponTable_txt1":"Recebendo...","showCoupon_btn2":"Veja cupons","showCoupon_btn1":"Copiado","affliateOrder_column1":"nome do cliente","affliateOrder_column2":"Email do cliente","affliateOrder_column3":"Título do produto","affliateOrder_column4":"Data do pedido","affliateOrder_column5":"Subtotal","affliateOrder_column6":"Comissão","affliateOrder_btn1":"Recebendo...","affliateOrder_btn2":"Ver ordens de afiliados","affliateOrder_btn3":"Ver ordens de afiliados","yourBio_btn1":"Salvar","yourBio_btn2":"Salvar","yourBio_Uploadbtn1":"Enviando...","yourBio_Uploadbtn2":"Carregado","yourBio_UploadbtnError":"Desculpe, tente novamente","yourBio_Savebtn":"Salvando...","team_txt1":"Salvando...","team_txt2":"Salvar","viewRepClientOrdersDetails_column1":"Número do pedido","viewRepClientOrdersDetails_column2":"Data do pedido","viewRepClientOrdersDetails_column3":"Subtotal","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Detalhes do produto","addSalesRep_txt1":"Adicione o Representante de Vendas","addSalesRep_txt2":"Adicionando o Representante de Vendas...","discountCoupons_header":"Cupom de desconto único","discountCoupons_nodiscountcoupon":"Você não criou nenhum cupom de desconto","discountCoupons_deleteBtn":"Excluir","discountCoupons_BackBtn":"Voltar","customerInvoice_selectcustomererror":"Selecione o cliente e adicione o produto","createOrderFromCartPage_selectCustomersLabel":"Selecione Cliente","createOrderFromCartPage_selectCustomerAddressLabel":"ENDEREÇO ​​PARA ENVIO","createOrderFromCartPage_selectCustomersLabelForDropDown":"Selecione Cliente","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Selecione o endereço","createOrderFromCartPage_successMsg":"Fatura do pedido criado com sucesso! A fatura foi enviada por e -mail ao cliente!","createOrderFromCartPage_toggleButton":"Adicionar novo endereço de entrega","createOrderFromCartPage_AddNewAddressTitle":"ADICIONAR NOVO ENDEREÇO","createOrderFromCartPage_customer_errorMsg1":"Nenhum cliente selecionado. Selecione o cliente e tente novamente.","createOrderFromCartPage_order_errorMsg1":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","createOrderFromCartPage_Address_errorMsg2":"Selecione o endereço e tente novamente.","createOrderFromCartPage_Address_errorMsg3":"Por favor, preencha todos os campos de endereço.","createOrderFromCartPage_Order_errorMsg2":"Erro durante a criação de seu pedido. Por favor, suporte de contato","createOrderFromCartPage_draftOrderButton":"Crie pedidos de rascunho","createOrderFromCartPage_OrderButton":"Criar ordem","createOrderFromCartPage_draftOrderButtonText2":"Criando ordem ...","createOrderFromCartPage_selectShippingCostTitle":"FRETE","createOrderFromCartPage_selectShippingCost":"Selecione o custo de envio","createOrderFromCartPage_Address_errorMsg4":"Houve um problema em calcular suas taxas de envio.","createOrderFromCartPage_Address_errorMsg5":"Alguma coisa deu errado. Por favor tente outra vez.","yourSales_tabHeading3":"Ordens de reembolso","refundOrders_column1":"ID do reembolso","refundOrders_column2":"Data do pedido","refundOrders_column3":"Número do pedido","refundOrders_column4":"Nome do pedido","refundOrders_column5":"Comissão","refundOrders_column6":"Comissão de Gerente de Equipe","refundOrders_column7":"ID do gerente da equipe","refundOrders_column8":"Reembolso subtotal","refundOrders_column9":"Status do pedido","refundOrders_column10":"Tipo de pedido","refundOrderNumber_title":"Detalhes do pedido de reembolso","refundOrderNumber_column1":"Nome","refundOrderNumber_column2":"Data","refundOrderNumber_column3":"Quantidade","refundOrderNumber_column4":"Preço com desconto","refundOrderNumber_column5":"Subtotal","tableDataError":"Sem ordem de reembolso","dashboard_subTitle3":"Detalhes da comissão","dashboard_cardHeading5_1":"Comissão em","dashboard_cardHeading5_2":"Você vai conseguir um","dashboard_cardHeading5_3":"Comissão de todas as ordens.","dashboard_cardHeading5_4":"Você receberá uma comissão com base em produtos que vende","dashboard_cardHeading5_5":"Você receberá uma comissão com base nos tipos de produtos","Profit_Margin":"Margem de lucro","Product_Type":"Tipo de Produto","Sales_Rep":"Representante de vendas","show_commission_list":"Lista de comissões do show","commission_list":"Lista de comissão","no_link_to_show":"Nenhum link para mostrar","no_customers_to_show":"Nenhum cliente para mostrar","no_sales_to_show":"Sem vendas para mostrar","no_draft_to_show":"Sem rascunho para mostrar","no_refund_to_show":"Sem reembolso para mostrar","no_orders_to_show":"Sem ordens para mostrar","customerInvoice_ViewClientOrdersColumn6":"Número do pedido","customerInvoice_ViewClientOrdersColumn7":"Data do pedido","Error_commissions_NotUpdated":"As comissões não são atualizadas","sales_chart_msg1":"Precisamos de dados...","sales_chart_msg2":"Parece que ainda não temos dados a serem mostrados.","page_refresh_msg":"Clique para atualizar","variant_title":"Título variante","line_items_properties":"Propriedades","customer_country":"País do cliente","customer_state":"Estado do cliente","company_country":"País da empresa","company_state":"Estado da empresa","client_orders":"Pedidos de cliente","no_product_details":"Não há detalhes de produtos para mostrar","submit_btn_text":"Enviar","submitting_btn_text":"Envio","submitted_btn_text":"Submetido","email_id_validation_errmsg":"Por favor, insira ID de e -mail válido","customerInvoice_add_more_details":"Adicione mais detalhes","customerInvoice_add_shipping_address":"Adicionar novo endereço de entrega","customerInvoice_HideDetails":"Detalhes ocultos","customerInvoice_HideAddress":"Ocultar endereço de entrega","customerInvoice_enterFirstName":"Introduza o primeiro nome","customerInvoice_enterFirstNamePlaceholder":"Primeiro nome","customerInvoice_enterLastName":"Insira o último nome","customerInvoice_enterLastNamePlaceholder":"Sobrenome","customerInvoice_enterAddress1":"Digite a linha de endereço 1","customerInvoice_enterAddress1Placeholder":"Endereço Linha 1","customerInvoice_enterAddress2":"Insira a linha de endereço 2","customerInvoice_enterAddress2Placeholder":"endereço linha 2","customerInvoice_enterCity":"Entre na cidade","customerInvoice_enterCityPlaceholder":"Cidade","customerInvoice_selectCountry":"Selecione o pais","customerInvoice_selectState":"Selecione estado","customerInvoice_enterZipNumber":"Digite o código postal","customerInvoice_enterZipNumberPlaceholder":"CEP","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventário","customerInvoice_ProductTableEmpty_Msg":"Produto não disponível","customerInvoice_SendInvoiceBtn":"Enviar fatura","customerInvoice_CreateOrderBtn":"Criar ordem","customerInvoice_ProductTableColumnSubTotal":"Subtono","customerInvoice_SelectShippingAddress":"Selecione o endereço de envio","customerInvoice_ProductsSearchBy_Placeholder":"Pesquisar produtos por nome, SKU, preço","customerInvoice_AddMoreProducts_Btn":"Adicione mais produtos","customerInvoice_RequiredErrorMsg":"Este campo é obrigatório.","customerInvoice_EmailSuggestionErrorMsg":"Adicione ID de e -mail válido","customerInvoice_MobileSuggestionErrorMsg":"Por favor, adicione o telefone válido não","customerInvoice_ErrorMsgAddShippingAddress":"Por favor, preencha o endereço de entrega","customerInvoice_Creating_Msg":"Criando...","customerInvoice_Sending_Msg":"Enviando...","customerInvoice_OrderCreatedSuccessfullyMsg":"Ordem criada com sucesso","customerInvoice_InvoiceSentSuccessfullyMsg":"Fatura enviada com sucesso para o cliente","customerInvoice_ErrorMsgTryAgain":"Erro... por favor tente novamente","customerInvoice_Selected_Btn":"Selecionado","customerInvoice_ProductTableQuantityUpdate_Btn":"Selecione o produto","customerInvoice_OrderSubTotal":"Subtotal do pedido","delete_confirmation_text":"Tem certeza?","draftOrder_OrderNumber":"Número do pedido","draftOrder_CustName":"nome do cliente","draftOrder_OrderDate":"Data do pedido","draftOrder_SubTotal":"Subtono","draftOrder_Status":"Status","draftOrder_Invoice":"Fatura","draftOrder_DraftId":"ID do rascunho","draftOrder_ShippingCost":"Frete","draftOrder_Tax":"Imposto","draftOrder_TotalPrice":"Preço total","draftOrder_Note":"Observação","draftOrder_Product":"produtos","draftOrder_ProductName":"Nome do Produto","draftOrder_Size":"Tamanho","draftOrder_Quantity":"Quantidade","draftOrder_Price":"Preço","noDraftOrderProducts":"Não há detalhes sobre detalhes do produto para pedidos disponíveis.","noRefundOrderProduct":"Não há detalhes do produto de pedido de reembolso disponíveis.","loading":"Carregando...","dashboard_commissionOn_profitMargin":"Comissão sobre Margem de Lucro","dashboard_clientInvoice":"Fatura do cliente","dashboard_affiliateLink":"Ordem de afiliados","dashboard_returnCustomer":"Retorno cliente","dashboard_discountCoupon":"Cupom de desconto","dashboard_no_data":"Nenhum dado disponível","dashboard_sales_of_last_six_months":"Vendas dos últimos 6 meses","dashboard_sales_of_current_month":"Vendas do mês atual","addCustomer_ErrorMsgOnSubmitBtn":"Por favor insira um número de telefone válido","login_welcome_Msg":"Bem -vindo à equipe de vendas","login_title":"Conecte-se","login_email":"Identificação do email","login_password":"Senha","emailValidation_ErrorMsg":"Por favor, insira ID de e -mail válido","login_newUser":"Novo usuário?","login_SignUp":"Inscrever-se","login_forgotPassword_link":"Esqueceu sua senha?","login_LogInBtn":"Conecte-se","login_sliderContent_1":"Representantes que estão colocando a ordem dos clientes","login_sliderContent_2":"O tráfego de condução de representantes para a loja","login_sliderContent_3":"Representante produtos de marketing usando plataformas de mídia social","login_sliderContent_4":"O representante pode comprar a granel e obter lucro","login_sliderContent_5":"Representantes que estão colocando a ordem dos clientes","login_sliderContent_6":"Os representantes podem visitar os clientes pessoalmente e criar pedidos","required_ErrorMsg":"Por favor, preencha o campo necessário","signup_title":"Inscrever-se","signup_BackTo_login":"Volte ao login","signup_firstName":"Primeiro nome","signup_lastName":"Sobrenome","signup_BackBtn":"Voltar","signup_NextBtn":"Próximo","signup_phone_number":"Número de telefone","signup_phone_number_Error":"Por favor, insira pelo menos 10 dígitos","signup_uploadPicture":"Faça upload da imagem do perfil","signup_fileSizeError":"O tamanho do arquivo é maior que 5 MB","signup_filePath_lable":"Arquivo selecionado","signup_MediaTitle2":"Links de mídia social","signup_facebookHandle":"Indentificador do Facebook","signup_InstaHandle":"Identificador do Instagram","signup_SaveBtn":"Salve detalhes","forgotPwd_title":"Esqueceu sua senha","forgotPwd_ResetBtn":"Redefinir senha","forgotPwd_SuccessMsg":"Sua solicitação de senha de redefinição é bem -sucedida, enviamos a nova senha para o seu ID de email registrado.","customerInvoice_selectShippingCost":"Selecione o custo de envio","customerInvoice_CalculatingShippingRates_Msg":"Calculando...","customerInvoice_AddShippingAddress_Msg":"Selecione Endereço ou Adicionar endereço de entrega","customerInvoice_PleaseSetAnyShippingAddressMsg":"Selecione qualquer endereço de entrega","customerInvoice_ShippingCostErrorMsg":"Adicione um novo endereço de entrega, porque o endereço tem informações insuficientes.","customerInvoice_CalculateShippingCost_Btn":"Calcule o custo de envio","customerInvoice_ShippingCostAddOrNot_Msg":"Você gostaria de adicionar custo de envio?","customerInvoice_ShippingCostAddOrNot_Yes":"Sim","customerInvoice_ShippingCostAddOrNot_No":"Não","shop_utterly_conkers_ShippingCostCompulsory_ErrorMsg":"Não fez seu pedido, a menos e até adicionar o custo de envio","shop_utterly_conkers_AddMoreProducts__ErrorMsg":"Adicione mais produtos para calcular o custo de envio","customerInvoice_ShippingCostIsUnavailable":"O custo de envio para este endereço não é definido do lado do administrador. Embora o pedido possa ser feito sem calcular o custo de envio.","customerInvoice_ShippingCostErrorMsg_TryAgain":"Por favor, tente novamente","dashboard_BannerMsg":"Os gráficos são atualizados a cada 8 horas","yourSales__BannerMsg":"Os detalhes do pedido são atualizados a cada 5 minutos","customerInvoice_FirstNameErrorMsg":"Por favor, insira o primeiro nome","customerInvoice_lastNameErrorMsg":"Por favor, insira o sobrenome","customerInvoice_Add1ErrorMsg":"Por favor, insira a linha de endereço 1","customerInvoice_CountryErrorMsg":"Selecione o país","customerInvoice_StateErrorMsg":"Selecione o estado","customerInvoice_CityErrorMsg":"Por favor, insira o nome da cidade","customerInvoice_ZipErrorMsg":"Por favor, insira o CEP","uploadImage":"Enviar Imagem","dashboard_CardTitle1":"Kommission för alla beställningar","dashboard_CardTitle3":"Total provision","dashboard_TotalRevenue":"Totala intäkter","dashboard_TotalAvg_Ticket_Size":"Genomsnittlig biljettstorlek","dashboard_CardTitle4":"Total rea","profile_Change_Password":"Ändra lösenord","dashboard_Information_Message":"Kommissionen spåras endast för betalda beställningar","resetPassword_validation_Msg":"Detta fält krävs","resetPassword_validation_Msg2":"Lösenordet ska innehålla minst 8 tecken, 1 versaler, 1 små bokstäver, 1 siffra etc.","resetPassword_validation_Msg3":"Bekräfta lösenordet ska matcha med nytt lösenord","dashbord_Msg_New":"Hur det fungerar","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Maximal rabatt är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","discount_couponErrorMsg2":"Kommissionen är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","dashbord_profile_pic":"Ändra profilbild","Dashboard_Month":"Månad","Performance_Details":"Prestationsdetaljer","Show_Performance_Details":"Visa prestandainformation","Dashboard_Orders_Total":"Totala beställningar","Dashboard_Total_Sale":"Total försäljning","Dashboard_Commission":"Provision","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Por favor, adicione o endereço do cliente.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Por favor, clique no botão calcular o custo de envio e selecione um.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Carrinho não atualizado, atualize e tente novamente.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Selecione o produto.","customerInvoice_CreatingDraft_Msg":"Rascunho Criando..","customerInvoice_DraftOrderBtn":"Projeto de pedido","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Rascunho de pedido criado com sucesso","productTable_error_AlertMsg":"Kvantitet kan inte vara 0 eller mindre, ange något giltigt värde","productTable_error_AlertMsg2":"Ange kvantitet","click_to_copy":"Klicka för att kopiera","discount_code_copy_coupon":"Kopieringskupong","createOrder_productSearchGuide":"Kan du inte hitta produkter?","soldOut":"Vendido","InventoryNotTracked":"Estoque não rastreado","productStatus":"Status do produto","makeSureInShopify":"Certifique-se no Shopify","products":"Produtos","sectionTheProductStatusIs":"seção, o status do produto é","active":"Ativo","productsMayBeSoldOutPleaseCheck":"Os produtos podem estar esgotados, verifique e selecione","Credit_Limit_Error_Msg":"O limite de crédito excede, por favor, tente novamente..!"}'
        );
      it.use(kt).init({
        debug: !0,
        lng: "en",
        fallbackLng: "en",
        keySeparator: !1,
        interpolation: { escapeValue: !1 },
        resources: {
          en: { translations: wt },
          es: { translations: Pt },
          fr: { translations: Ot },
          it: { translations: It },
          ms: { translations: Tt },
          sv: { translations: Mt },
          pt: { translations: Et },
        },
        ns: ["translations"],
        defaultNS: "translations",
      });
      var Dt = it,
        jt = o(3366),
        Rt = o(3961),
        Nt = o(8510),
        At = o(2101),
        Lt = o(948),
        zt = o(1657),
        Bt = o(1977),
        Zt = o(5463);
      function Ft(e) {
        return (0, Zt.ZP)("MuiDivider", e);
      }
      var Ht = (0, Bt.Z)("MuiDivider", [
        "root",
        "absolute",
        "fullWidth",
        "inset",
        "middle",
        "flexItem",
        "light",
        "vertical",
        "withChildren",
        "withChildrenVertical",
        "textAlignRight",
        "textAlignLeft",
        "wrapper",
        "wrapperVertical",
      ]);
      const Vt = [
          "absolute",
          "children",
          "className",
          "component",
          "flexItem",
          "light",
          "orientation",
          "role",
          "textAlign",
          "variant",
        ],
        Wt = (0, Lt.ZP)("div", {
          name: "MuiDivider",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.absolute && t.absolute,
              t[n.variant],
              n.light && t.light,
              "vertical" === n.orientation && t.vertical,
              n.flexItem && t.flexItem,
              n.children && t.withChildren,
              n.children &&
                "vertical" === n.orientation &&
                t.withChildrenVertical,
              "right" === n.textAlign &&
                "vertical" !== n.orientation &&
                t.textAlignRight,
              "left" === n.textAlign &&
                "vertical" !== n.orientation &&
                t.textAlignLeft,
            ];
          },
        })(
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              {
                margin: 0,
                flexShrink: 0,
                borderWidth: 0,
                borderStyle: "solid",
                borderColor: (e.vars || e).palette.divider,
                borderBottomWidth: "thin",
              },
              t.absolute && {
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
              },
              t.light && {
                borderColor: e.vars
                  ? `rgba(${e.vars.palette.dividerChannel} / 0.08)`
                  : (0, At.Fq)(e.palette.divider, 0.08),
              },
              "inset" === t.variant && { marginLeft: 72 },
              "middle" === t.variant &&
                "horizontal" === t.orientation && {
                  marginLeft: e.spacing(2),
                  marginRight: e.spacing(2),
                },
              "middle" === t.variant &&
                "vertical" === t.orientation && {
                  marginTop: e.spacing(1),
                  marginBottom: e.spacing(1),
                },
              "vertical" === t.orientation && {
                height: "100%",
                borderBottomWidth: 0,
                borderRightWidth: "thin",
              },
              t.flexItem && { alignSelf: "stretch", height: "auto" }
            ),
          ({ ownerState: e }) =>
            (0, d.Z)(
              {},
              e.children && {
                display: "flex",
                whiteSpace: "nowrap",
                textAlign: "center",
                border: 0,
                "&::before, &::after": { content: '""', alignSelf: "center" },
              }
            ),
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              {},
              t.children &&
                "vertical" !== t.orientation && {
                  "&::before, &::after": {
                    width: "100%",
                    borderTop: `thin solid ${(e.vars || e).palette.divider}`,
                  },
                }
            ),
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              {},
              t.children &&
                "vertical" === t.orientation && {
                  flexDirection: "column",
                  "&::before, &::after": {
                    height: "100%",
                    borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
                  },
                }
            ),
          ({ ownerState: e }) =>
            (0, d.Z)(
              {},
              "right" === e.textAlign &&
                "vertical" !== e.orientation && {
                  "&::before": { width: "90%" },
                  "&::after": { width: "10%" },
                },
              "left" === e.textAlign &&
                "vertical" !== e.orientation && {
                  "&::before": { width: "10%" },
                  "&::after": { width: "90%" },
                }
            )
        ),
        $t = (0, Lt.ZP)("span", {
          name: "MuiDivider",
          slot: "Wrapper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.wrapper,
              "vertical" === n.orientation && t.wrapperVertical,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              display: "inline-block",
              paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
              paddingRight: `calc(${e.spacing(1)} * 1.2)`,
            },
            "vertical" === t.orientation && {
              paddingTop: `calc(${e.spacing(1)} * 1.2)`,
              paddingBottom: `calc(${e.spacing(1)} * 1.2)`,
            }
          )
        ),
        Ut = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiDivider" }),
            {
              absolute: o = !1,
              children: a,
              className: i,
              component: s = a ? "div" : "hr",
              flexItem: l = !1,
              light: c = !1,
              orientation: u = "horizontal",
              role: p = "hr" !== s ? "separator" : void 0,
              textAlign: m = "center",
              variant: h = "fullWidth",
            } = r,
            f = (0, jt.Z)(r, Vt),
            g = (0, d.Z)({}, r, {
              absolute: o,
              component: s,
              flexItem: l,
              light: c,
              orientation: u,
              role: p,
              textAlign: m,
              variant: h,
            }),
            v = ((e) => {
              const {
                  absolute: t,
                  children: n,
                  classes: r,
                  flexItem: o,
                  light: a,
                  orientation: i,
                  textAlign: s,
                  variant: l,
                } = e,
                c = {
                  root: [
                    "root",
                    t && "absolute",
                    l,
                    a && "light",
                    "vertical" === i && "vertical",
                    o && "flexItem",
                    n && "withChildren",
                    n && "vertical" === i && "withChildrenVertical",
                    "right" === s && "vertical" !== i && "textAlignRight",
                    "left" === s && "vertical" !== i && "textAlignLeft",
                  ],
                  wrapper: ["wrapper", "vertical" === i && "wrapperVertical"],
                };
              return (0, Nt.Z)(c, Ft, r);
            })(g);
          return (0,
          e.jsx)(Wt, (0, d.Z)({ as: s, className: (0, Rt.Z)(v.root, i), role: p, ref: n, ownerState: g }, f, { children: a ? (0, e.jsx)($t, { className: v.wrapper, ownerState: g, children: a }) : null }));
        });
      Ut.muiSkipListHighlight = !0;
      var Kt = Ut;
      function Gt(e) {
        var t,
          n,
          r = "";
        if ("string" == typeof e || "number" == typeof e) r += e;
        else if ("object" == typeof e)
          if (Array.isArray(e)) {
            var o = e.length;
            for (t = 0; t < o; t++)
              e[t] && (n = Gt(e[t])) && (r && (r += " "), (r += n));
          } else for (n in e) e[n] && (r && (r += " "), (r += n));
        return r;
      }
      var qt = function () {
          for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
            (e = arguments[n]) && (t = Gt(e)) && (r && (r += " "), (r += t));
          return r;
        },
        Yt = o(4742),
        Jt = o(6523),
        Qt = o(9707),
        Xt = o(6682);
      const en = ["className", "component"];
      function tn(n = {}) {
        const {
            themeId: r,
            defaultTheme: o,
            defaultClassName: a = "MuiBox-root",
            generateClassName: i,
          } = n,
          s = (0, Yt.default)("div", {
            shouldForwardProp: (e) => "theme" !== e && "sx" !== e && "as" !== e,
          })(Jt.Z);
        return t.forwardRef(function (t, n) {
          const l = (0, Xt.Z)(o),
            c = (0, Qt.Z)(t),
            { className: u, component: p = "div" } = c,
            m = (0, jt.Z)(c, en);
          return (0,
          e.jsx)(s, (0, d.Z)({ as: p, ref: n, className: qt(u, i ? i(a) : a), theme: (r && l[r]) || l }, m));
        });
      }
      var nn = o(1983),
        rn = o(9617),
        on = o(606),
        an = (0, Bt.Z)("MuiBox", ["root"]);
      const sn = (0, rn.Z)();
      var ln = tn({
          themeId: on.Z,
          defaultTheme: sn,
          defaultClassName: an.root,
          generateClassName: nn.Z.generate,
        }),
        cn = o(1705),
        un = o(2068),
        dn = o(8992);
      function pn(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          ae(e, t);
      }
      var mn = t.createContext(null);
      function hn(e, n) {
        var r = Object.create(null);
        return (
          e &&
            t.Children.map(e, function (e) {
              return e;
            }).forEach(function (e) {
              r[e.key] = (function (e) {
                return n && (0, t.isValidElement)(e) ? n(e) : e;
              })(e);
            }),
          r
        );
      }
      function fn(e, t, n) {
        return null != n[t] ? n[t] : e.props[t];
      }
      function gn(e, n, r) {
        var o = hn(e.children),
          a = (function (e, t) {
            function n(n) {
              return n in t ? t[n] : e[n];
            }
            (e = e || {}), (t = t || {});
            var r,
              o = Object.create(null),
              a = [];
            for (var i in e)
              i in t ? a.length && ((o[i] = a), (a = [])) : a.push(i);
            var s = {};
            for (var l in t) {
              if (o[l])
                for (r = 0; r < o[l].length; r++) {
                  var c = o[l][r];
                  s[o[l][r]] = n(c);
                }
              s[l] = n(l);
            }
            for (r = 0; r < a.length; r++) s[a[r]] = n(a[r]);
            return s;
          })(n, o);
        return (
          Object.keys(a).forEach(function (i) {
            var s = a[i];
            if ((0, t.isValidElement)(s)) {
              var l = i in n,
                c = i in o,
                u = n[i],
                d = (0, t.isValidElement)(u) && !u.props.in;
              !c || (l && !d)
                ? c || !l || d
                  ? c &&
                    l &&
                    (0, t.isValidElement)(u) &&
                    (a[i] = (0, t.cloneElement)(s, {
                      onExited: r.bind(null, s),
                      in: u.props.in,
                      exit: fn(s, "exit", e),
                      enter: fn(s, "enter", e),
                    }))
                  : (a[i] = (0, t.cloneElement)(s, { in: !1 }))
                : (a[i] = (0, t.cloneElement)(s, {
                    onExited: r.bind(null, s),
                    in: !0,
                    exit: fn(s, "exit", e),
                    enter: fn(s, "enter", e),
                  }));
            }
          }),
          a
        );
      }
      var vn =
          Object.values ||
          function (e) {
            return Object.keys(e).map(function (t) {
              return e[t];
            });
          },
        bn = (function (e) {
          function n(t, n) {
            var r,
              o = (r = e.call(this, t, n) || this).handleExited.bind(oe(r));
            return (
              (r.state = {
                contextValue: { isMounting: !0 },
                handleExited: o,
                firstRender: !0,
              }),
              r
            );
          }
          pn(n, e);
          var r = n.prototype;
          return (
            (r.componentDidMount = function () {
              (this.mounted = !0),
                this.setState({ contextValue: { isMounting: !1 } });
            }),
            (r.componentWillUnmount = function () {
              this.mounted = !1;
            }),
            (n.getDerivedStateFromProps = function (e, n) {
              var r,
                o,
                a = n.children,
                i = n.handleExited;
              return {
                children: n.firstRender
                  ? ((r = e),
                    (o = i),
                    hn(r.children, function (e) {
                      return (0,
                      t.cloneElement)(e, { onExited: o.bind(null, e), in: !0, appear: fn(e, "appear", r), enter: fn(e, "enter", r), exit: fn(e, "exit", r) });
                    }))
                  : gn(e, a, i),
                firstRender: !1,
              };
            }),
            (r.handleExited = function (e, t) {
              var n = hn(this.props.children);
              e.key in n ||
                (e.props.onExited && e.props.onExited(t),
                this.mounted &&
                  this.setState(function (t) {
                    var n = (0, d.Z)({}, t.children);
                    return delete n[e.key], { children: n };
                  }));
            }),
            (r.render = function () {
              var e = this.props,
                n = e.component,
                r = e.childFactory,
                o = (0, jt.Z)(e, ["component", "childFactory"]),
                a = this.state.contextValue,
                i = vn(this.state.children).map(r);
              return (
                delete o.appear,
                delete o.enter,
                delete o.exit,
                null === n
                  ? t.createElement(mn.Provider, { value: a }, i)
                  : t.createElement(
                      mn.Provider,
                      { value: a },
                      t.createElement(n, o, i)
                    )
              );
            }),
            n
          );
        })(t.Component);
      (bn.propTypes = {}),
        (bn.defaultProps = {
          component: "div",
          childFactory: function (e) {
            return e;
          },
        });
      var _n = bn,
        yn = o(917),
        xn = o(8849),
        Cn = (0, Bt.Z)("MuiTouchRipple", [
          "root",
          "ripple",
          "rippleVisible",
          "ripplePulsate",
          "child",
          "childLeaving",
          "childPulsate",
        ]);
      const Sn = ["center", "classes", "className"];
      let kn,
        wn,
        Pn,
        On,
        In = (e) => e;
      const Tn = (0, yn.F4)(
          kn ||
            (kn = In`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)
        ),
        Mn = (0, yn.F4)(
          wn ||
            (wn = In`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)
        ),
        En = (0, yn.F4)(
          Pn ||
            (Pn = In`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)
        ),
        Dn = (0, Lt.ZP)("span", { name: "MuiTouchRipple", slot: "Root" })({
          overflow: "hidden",
          pointerEvents: "none",
          position: "absolute",
          zIndex: 0,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          borderRadius: "inherit",
        }),
        jn = (0, Lt.ZP)(
          function (n) {
            const {
                className: r,
                classes: o,
                pulsate: a = !1,
                rippleX: i,
                rippleY: s,
                rippleSize: l,
                in: c,
                onExited: u,
                timeout: d,
              } = n,
              [p, m] = t.useState(!1),
              h = (0, Rt.Z)(r, o.ripple, o.rippleVisible, a && o.ripplePulsate),
              f = { width: l, height: l, top: -l / 2 + s, left: -l / 2 + i },
              g = (0, Rt.Z)(o.child, p && o.childLeaving, a && o.childPulsate);
            return (
              c || p || m(!0),
              t.useEffect(() => {
                if (!c && null != u) {
                  const e = setTimeout(u, d);
                  return () => {
                    clearTimeout(e);
                  };
                }
              }, [u, c, d]),
              (0, e.jsx)("span", {
                className: h,
                style: f,
                children: (0, e.jsx)("span", { className: g }),
              })
            );
          },
          { name: "MuiTouchRipple", slot: "Ripple" }
        )(
          On ||
            (On = In`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`),
          Cn.rippleVisible,
          Tn,
          550,
          ({ theme: e }) => e.transitions.easing.easeInOut,
          Cn.ripplePulsate,
          ({ theme: e }) => e.transitions.duration.shorter,
          Cn.child,
          Cn.childLeaving,
          Mn,
          550,
          ({ theme: e }) => e.transitions.easing.easeInOut,
          Cn.childPulsate,
          En,
          ({ theme: e }) => e.transitions.easing.easeInOut
        ),
        Rn = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiTouchRipple" }),
            { center: a = !1, classes: i = {}, className: s } = o,
            l = (0, jt.Z)(o, Sn),
            [c, u] = t.useState([]),
            p = t.useRef(0),
            m = t.useRef(null);
          t.useEffect(() => {
            m.current && (m.current(), (m.current = null));
          }, [c]);
          const h = t.useRef(!1),
            f = (0, xn.Z)(),
            g = t.useRef(null),
            v = t.useRef(null),
            b = t.useCallback(
              (t) => {
                const {
                  pulsate: n,
                  rippleX: r,
                  rippleY: o,
                  rippleSize: a,
                  cb: s,
                } = t;
                u((t) => [
                  ...t,
                  (0, e.jsx)(
                    jn,
                    {
                      classes: {
                        ripple: (0, Rt.Z)(i.ripple, Cn.ripple),
                        rippleVisible: (0, Rt.Z)(
                          i.rippleVisible,
                          Cn.rippleVisible
                        ),
                        ripplePulsate: (0, Rt.Z)(
                          i.ripplePulsate,
                          Cn.ripplePulsate
                        ),
                        child: (0, Rt.Z)(i.child, Cn.child),
                        childLeaving: (0, Rt.Z)(
                          i.childLeaving,
                          Cn.childLeaving
                        ),
                        childPulsate: (0, Rt.Z)(
                          i.childPulsate,
                          Cn.childPulsate
                        ),
                      },
                      timeout: 550,
                      pulsate: n,
                      rippleX: r,
                      rippleY: o,
                      rippleSize: a,
                    },
                    p.current
                  ),
                ]),
                  (p.current += 1),
                  (m.current = s);
              },
              [i]
            ),
            _ = t.useCallback(
              (e = {}, t = {}, n = () => {}) => {
                const {
                  pulsate: r = !1,
                  center: o = a || t.pulsate,
                  fakeElement: i = !1,
                } = t;
                if ("mousedown" === (null == e ? void 0 : e.type) && h.current)
                  return void (h.current = !1);
                "touchstart" === (null == e ? void 0 : e.type) &&
                  (h.current = !0);
                const s = i ? null : v.current,
                  l = s
                    ? s.getBoundingClientRect()
                    : { width: 0, height: 0, left: 0, top: 0 };
                let c, u, d;
                if (
                  o ||
                  void 0 === e ||
                  (0 === e.clientX && 0 === e.clientY) ||
                  (!e.clientX && !e.touches)
                )
                  (c = Math.round(l.width / 2)), (u = Math.round(l.height / 2));
                else {
                  const { clientX: t, clientY: n } =
                    e.touches && e.touches.length > 0 ? e.touches[0] : e;
                  (c = Math.round(t - l.left)), (u = Math.round(n - l.top));
                }
                if (o)
                  (d = Math.sqrt((2 * l.width ** 2 + l.height ** 2) / 3)),
                    d % 2 == 0 && (d += 1);
                else {
                  const e =
                      2 * Math.max(Math.abs((s ? s.clientWidth : 0) - c), c) +
                      2,
                    t =
                      2 * Math.max(Math.abs((s ? s.clientHeight : 0) - u), u) +
                      2;
                  d = Math.sqrt(e ** 2 + t ** 2);
                }
                null != e && e.touches
                  ? null === g.current &&
                    ((g.current = () => {
                      b({
                        pulsate: r,
                        rippleX: c,
                        rippleY: u,
                        rippleSize: d,
                        cb: n,
                      });
                    }),
                    f.start(80, () => {
                      g.current && (g.current(), (g.current = null));
                    }))
                  : b({
                      pulsate: r,
                      rippleX: c,
                      rippleY: u,
                      rippleSize: d,
                      cb: n,
                    });
              },
              [a, b, f]
            ),
            y = t.useCallback(() => {
              _({}, { pulsate: !0 });
            }, [_]),
            x = t.useCallback(
              (e, t) => {
                if (
                  (f.clear(),
                  "touchend" === (null == e ? void 0 : e.type) && g.current)
                )
                  return (
                    g.current(),
                    (g.current = null),
                    void f.start(0, () => {
                      x(e, t);
                    })
                  );
                (g.current = null),
                  u((e) => (e.length > 0 ? e.slice(1) : e)),
                  (m.current = t);
              },
              [f]
            );
          return (
            t.useImperativeHandle(
              r,
              () => ({ pulsate: y, start: _, stop: x }),
              [y, _, x]
            ),
            (0, e.jsx)(
              Dn,
              (0, d.Z)(
                { className: (0, Rt.Z)(Cn.root, i.root, s), ref: v },
                l,
                {
                  children: (0, e.jsx)(_n, {
                    component: null,
                    exit: !0,
                    children: c,
                  }),
                }
              )
            )
          );
        });
      var Nn = Rn;
      function An(e) {
        return (0, Zt.ZP)("MuiButtonBase", e);
      }
      var Ln = (0, Bt.Z)("MuiButtonBase", ["root", "disabled", "focusVisible"]);
      const zn = [
          "action",
          "centerRipple",
          "children",
          "className",
          "component",
          "disabled",
          "disableRipple",
          "disableTouchRipple",
          "focusRipple",
          "focusVisibleClassName",
          "LinkComponent",
          "onBlur",
          "onClick",
          "onContextMenu",
          "onDragLeave",
          "onFocus",
          "onFocusVisible",
          "onKeyDown",
          "onKeyUp",
          "onMouseDown",
          "onMouseLeave",
          "onMouseUp",
          "onTouchEnd",
          "onTouchMove",
          "onTouchStart",
          "tabIndex",
          "TouchRippleProps",
          "touchRippleRef",
          "type",
        ],
        Bn = (0, Lt.ZP)("button", {
          name: "MuiButtonBase",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          boxSizing: "border-box",
          WebkitTapHighlightColor: "transparent",
          backgroundColor: "transparent",
          outline: 0,
          border: 0,
          margin: 0,
          borderRadius: 0,
          padding: 0,
          cursor: "pointer",
          userSelect: "none",
          verticalAlign: "middle",
          MozAppearance: "none",
          WebkitAppearance: "none",
          textDecoration: "none",
          color: "inherit",
          "&::-moz-focus-inner": { borderStyle: "none" },
          [`&.${Ln.disabled}`]: { pointerEvents: "none", cursor: "default" },
          "@media print": { colorAdjust: "exact" },
        });
      var Zn = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiButtonBase" }),
            {
              action: a,
              centerRipple: i = !1,
              children: s,
              className: l,
              component: c = "button",
              disabled: u = !1,
              disableRipple: p = !1,
              disableTouchRipple: m = !1,
              focusRipple: h = !1,
              LinkComponent: f = "a",
              onBlur: g,
              onClick: v,
              onContextMenu: b,
              onDragLeave: _,
              onFocus: y,
              onFocusVisible: x,
              onKeyDown: C,
              onKeyUp: S,
              onMouseDown: k,
              onMouseLeave: w,
              onMouseUp: P,
              onTouchEnd: O,
              onTouchMove: I,
              onTouchStart: T,
              tabIndex: M = 0,
              TouchRippleProps: E,
              touchRippleRef: D,
              type: j,
            } = o,
            R = (0, jt.Z)(o, zn),
            N = t.useRef(null),
            A = t.useRef(null),
            L = (0, cn.Z)(A, D),
            {
              isFocusVisibleRef: z,
              onFocus: B,
              onBlur: Z,
              ref: F,
            } = (0, dn.Z)(),
            [H, V] = t.useState(!1);
          u && H && V(!1),
            t.useImperativeHandle(
              a,
              () => ({
                focusVisible: () => {
                  V(!0), N.current.focus();
                },
              }),
              []
            );
          const [W, $] = t.useState(!1);
          t.useEffect(() => {
            $(!0);
          }, []);
          const U = W && !p && !u;
          function K(e, t, n = m) {
            return (0,
            un.Z)((r) => (t && t(r), !n && A.current && A.current[e](r), !0));
          }
          t.useEffect(() => {
            H && h && !p && W && A.current.pulsate();
          }, [p, h, H, W]);
          const G = K("start", k),
            q = K("stop", b),
            Y = K("stop", _),
            J = K("stop", P),
            Q = K("stop", (e) => {
              H && e.preventDefault(), w && w(e);
            }),
            X = K("start", T),
            ee = K("stop", O),
            te = K("stop", I),
            ne = K(
              "stop",
              (e) => {
                Z(e), !1 === z.current && V(!1), g && g(e);
              },
              !1
            ),
            re = (0, un.Z)((e) => {
              N.current || (N.current = e.currentTarget),
                B(e),
                !0 === z.current && (V(!0), x && x(e)),
                y && y(e);
            }),
            oe = () => {
              const e = N.current;
              return c && "button" !== c && !("A" === e.tagName && e.href);
            },
            ae = t.useRef(!1),
            ie = (0, un.Z)((e) => {
              h &&
                !ae.current &&
                H &&
                A.current &&
                " " === e.key &&
                ((ae.current = !0),
                A.current.stop(e, () => {
                  A.current.start(e);
                })),
                e.target === e.currentTarget &&
                  oe() &&
                  " " === e.key &&
                  e.preventDefault(),
                C && C(e),
                e.target === e.currentTarget &&
                  oe() &&
                  "Enter" === e.key &&
                  !u &&
                  (e.preventDefault(), v && v(e));
            }),
            se = (0, un.Z)((e) => {
              h &&
                " " === e.key &&
                A.current &&
                H &&
                !e.defaultPrevented &&
                ((ae.current = !1),
                A.current.stop(e, () => {
                  A.current.pulsate(e);
                })),
                S && S(e),
                v &&
                  e.target === e.currentTarget &&
                  oe() &&
                  " " === e.key &&
                  !e.defaultPrevented &&
                  v(e);
            });
          let le = c;
          "button" === le && (R.href || R.to) && (le = f);
          const ce = {};
          "button" === le
            ? ((ce.type = void 0 === j ? "button" : j), (ce.disabled = u))
            : (R.href || R.to || (ce.role = "button"),
              u && (ce["aria-disabled"] = u));
          const ue = (0, cn.Z)(r, F, N),
            de = (0, d.Z)({}, o, {
              centerRipple: i,
              component: c,
              disabled: u,
              disableRipple: p,
              disableTouchRipple: m,
              focusRipple: h,
              tabIndex: M,
              focusVisible: H,
            }),
            pe = ((e) => {
              const {
                  disabled: t,
                  focusVisible: n,
                  focusVisibleClassName: r,
                  classes: o,
                } = e,
                a = { root: ["root", t && "disabled", n && "focusVisible"] },
                i = (0, Nt.Z)(a, An, o);
              return n && r && (i.root += ` ${r}`), i;
            })(de);
          return (0,
          e.jsxs)(Bn, (0, d.Z)({ as: le, className: (0, Rt.Z)(pe.root, l), ownerState: de, onBlur: ne, onClick: v, onContextMenu: q, onFocus: re, onKeyDown: ie, onKeyUp: se, onMouseDown: G, onMouseLeave: Q, onMouseUp: J, onDragLeave: Y, onTouchEnd: ee, onTouchMove: te, onTouchStart: X, ref: ue, tabIndex: u ? -1 : M, type: j }, ce, R, { children: [s, U ? (0, e.jsx)(Nn, (0, d.Z)({ ref: L, center: i }, E)) : null] }));
        }),
        Fn = o(8216);
      function Hn(e) {
        return (0, Zt.ZP)("MuiIconButton", e);
      }
      var Vn = (0, Bt.Z)("MuiIconButton", [
        "root",
        "disabled",
        "colorInherit",
        "colorPrimary",
        "colorSecondary",
        "colorError",
        "colorInfo",
        "colorSuccess",
        "colorWarning",
        "edgeStart",
        "edgeEnd",
        "sizeSmall",
        "sizeMedium",
        "sizeLarge",
      ]);
      const Wn = [
          "edge",
          "children",
          "className",
          "color",
          "disabled",
          "disableFocusRipple",
          "size",
        ],
        $n = (0, Lt.ZP)(Zn, {
          name: "MuiIconButton",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              "default" !== n.color && t[`color${(0, Fn.Z)(n.color)}`],
              n.edge && t[`edge${(0, Fn.Z)(n.edge)}`],
              t[`size${(0, Fn.Z)(n.size)}`],
            ];
          },
        })(
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              {
                textAlign: "center",
                flex: "0 0 auto",
                fontSize: e.typography.pxToRem(24),
                padding: 8,
                borderRadius: "50%",
                overflow: "visible",
                color: (e.vars || e).palette.action.active,
                transition: e.transitions.create("background-color", {
                  duration: e.transitions.duration.shortest,
                }),
              },
              !t.disableRipple && {
                "&:hover": {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})`
                    : (0, At.Fq)(
                        e.palette.action.active,
                        e.palette.action.hoverOpacity
                      ),
                  "@media (hover: none)": { backgroundColor: "transparent" },
                },
              },
              "start" === t.edge && {
                marginLeft: "small" === t.size ? -3 : -12,
              },
              "end" === t.edge && { marginRight: "small" === t.size ? -3 : -12 }
            ),
          ({ theme: e, ownerState: t }) => {
            var n;
            const r = null == (n = (e.vars || e).palette) ? void 0 : n[t.color];
            return (0, d.Z)(
              {},
              "inherit" === t.color && { color: "inherit" },
              "inherit" !== t.color &&
                "default" !== t.color &&
                (0, d.Z)(
                  { color: null == r ? void 0 : r.main },
                  !t.disableRipple && {
                    "&:hover": (0, d.Z)(
                      {},
                      r && {
                        backgroundColor: e.vars
                          ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})`
                          : (0, At.Fq)(r.main, e.palette.action.hoverOpacity),
                      },
                      {
                        "@media (hover: none)": {
                          backgroundColor: "transparent",
                        },
                      }
                    ),
                  }
                ),
              "small" === t.size && {
                padding: 5,
                fontSize: e.typography.pxToRem(18),
              },
              "large" === t.size && {
                padding: 12,
                fontSize: e.typography.pxToRem(28),
              },
              {
                [`&.${Vn.disabled}`]: {
                  backgroundColor: "transparent",
                  color: (e.vars || e).palette.action.disabled,
                },
              }
            );
          }
        ),
        Un = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiIconButton" }),
            {
              edge: o = !1,
              children: a,
              className: i,
              color: s = "default",
              disabled: l = !1,
              disableFocusRipple: c = !1,
              size: u = "medium",
            } = r,
            p = (0, jt.Z)(r, Wn),
            m = (0, d.Z)({}, r, {
              edge: o,
              color: s,
              disabled: l,
              disableFocusRipple: c,
              size: u,
            }),
            h = ((e) => {
              const { classes: t, disabled: n, color: r, edge: o, size: a } = e,
                i = {
                  root: [
                    "root",
                    n && "disabled",
                    "default" !== r && `color${(0, Fn.Z)(r)}`,
                    o && `edge${(0, Fn.Z)(o)}`,
                    `size${(0, Fn.Z)(a)}`,
                  ],
                };
              return (0, Nt.Z)(i, Hn, t);
            })(m);
          return (0,
          e.jsx)($n, (0, d.Z)({ className: (0, Rt.Z)(h.root, i), centerRipple: !0, focusRipple: !c, disabled: l, ref: n }, p, { ownerState: m, children: a }));
        });
      var Kn = Un;
      const Gn = ["value"],
        qn = t.createContext(),
        Yn = () => {
          const e = t.useContext(qn);
          return null != e && e;
        };
      var Jn = function (t) {
          let { value: n } = t,
            r = (0, jt.Z)(t, Gn);
          return (0, e.jsx)(
            qn.Provider,
            (0, d.Z)({ value: null == n || n }, r)
          );
        },
        Qn = o(2760);
      function Xn(e) {
        return "string" == typeof e;
      }
      function er(e, t, n) {
        return void 0 === e || Xn(e)
          ? t
          : (0, d.Z)({}, t, { ownerState: (0, d.Z)({}, t.ownerState, n) });
      }
      function tr(e, t = []) {
        if (void 0 === e) return {};
        const n = {};
        return (
          Object.keys(e)
            .filter(
              (n) =>
                n.match(/^on[A-Z]/) &&
                "function" == typeof e[n] &&
                !t.includes(n)
            )
            .forEach((t) => {
              n[t] = e[t];
            }),
          n
        );
      }
      function nr(e) {
        if (void 0 === e) return {};
        const t = {};
        return (
          Object.keys(e)
            .filter((t) => !(t.match(/^on[A-Z]/) && "function" == typeof e[t]))
            .forEach((n) => {
              t[n] = e[n];
            }),
          t
        );
      }
      function rr(e) {
        const {
          getSlotProps: t,
          additionalProps: n,
          externalSlotProps: r,
          externalForwardedProps: o,
          className: a,
        } = e;
        if (!t) {
          const e = (0, Rt.Z)(
              null == n ? void 0 : n.className,
              a,
              null == o ? void 0 : o.className,
              null == r ? void 0 : r.className
            ),
            t = (0, d.Z)(
              {},
              null == n ? void 0 : n.style,
              null == o ? void 0 : o.style,
              null == r ? void 0 : r.style
            ),
            i = (0, d.Z)({}, n, o, r);
          return (
            e.length > 0 && (i.className = e),
            Object.keys(t).length > 0 && (i.style = t),
            { props: i, internalRef: void 0 }
          );
        }
        const i = tr((0, d.Z)({}, o, r)),
          s = nr(r),
          l = nr(o),
          c = t(i),
          u = (0, Rt.Z)(
            null == c ? void 0 : c.className,
            null == n ? void 0 : n.className,
            a,
            null == o ? void 0 : o.className,
            null == r ? void 0 : r.className
          ),
          p = (0, d.Z)(
            {},
            null == c ? void 0 : c.style,
            null == n ? void 0 : n.style,
            null == o ? void 0 : o.style,
            null == r ? void 0 : r.style
          ),
          m = (0, d.Z)({}, c, n, l, s);
        return (
          u.length > 0 && (m.className = u),
          Object.keys(p).length > 0 && (m.style = p),
          { props: m, internalRef: c.ref }
        );
      }
      function or(e, t, n) {
        return "function" == typeof e ? e(t, n) : e;
      }
      const ar = [
        "elementType",
        "externalSlotProps",
        "ownerState",
        "skipResolvingSlotProps",
      ];
      function ir(e) {
        var t;
        const {
            elementType: n,
            externalSlotProps: r,
            ownerState: o,
            skipResolvingSlotProps: a = !1,
          } = e,
          i = (0, jt.Z)(e, ar),
          s = a ? {} : or(r, o),
          { props: l, internalRef: c } = rr(
            (0, d.Z)({}, i, { externalSlotProps: s })
          ),
          u = (0, Qn.Z)(
            c,
            null == s ? void 0 : s.ref,
            null == (t = e.additionalProps) ? void 0 : t.ref
          );
        return er(n, (0, d.Z)({}, l, { ref: u }), o);
      }
      var sr = o(6425),
        lr = o(2010),
        cr = o(5725),
        ur = o(6613);
      function dr(e) {
        const t = e.documentElement.clientWidth;
        return Math.abs(window.innerWidth - t);
      }
      function pr(e, t) {
        t
          ? e.setAttribute("aria-hidden", "true")
          : e.removeAttribute("aria-hidden");
      }
      function mr(e) {
        return parseInt((0, ur.Z)(e).getComputedStyle(e).paddingRight, 10) || 0;
      }
      function hr(e, t, n, r, o) {
        const a = [t, n, ...r];
        [].forEach.call(e.children, (e) => {
          const t = -1 === a.indexOf(e),
            n = !(function (e) {
              const t =
                  -1 !==
                  [
                    "TEMPLATE",
                    "SCRIPT",
                    "STYLE",
                    "LINK",
                    "MAP",
                    "META",
                    "NOSCRIPT",
                    "PICTURE",
                    "COL",
                    "COLGROUP",
                    "PARAM",
                    "SLOT",
                    "SOURCE",
                    "TRACK",
                  ].indexOf(e.tagName),
                n =
                  "INPUT" === e.tagName && "hidden" === e.getAttribute("type");
              return t || n;
            })(e);
          t && n && pr(e, o);
        });
      }
      function fr(e, t) {
        let n = -1;
        return e.some((e, r) => !!t(e) && ((n = r), !0)), n;
      }
      const gr = new (class {
        constructor() {
          (this.containers = void 0),
            (this.modals = void 0),
            (this.modals = []),
            (this.containers = []);
        }
        add(e, t) {
          let n = this.modals.indexOf(e);
          if (-1 !== n) return n;
          (n = this.modals.length),
            this.modals.push(e),
            e.modalRef && pr(e.modalRef, !1);
          const r = (function (e) {
            const t = [];
            return (
              [].forEach.call(e.children, (e) => {
                "true" === e.getAttribute("aria-hidden") && t.push(e);
              }),
              t
            );
          })(t);
          hr(t, e.mount, e.modalRef, r, !0);
          const o = fr(this.containers, (e) => e.container === t);
          return -1 !== o
            ? (this.containers[o].modals.push(e), n)
            : (this.containers.push({
                modals: [e],
                container: t,
                restore: null,
                hiddenSiblings: r,
              }),
              n);
        }
        mount(e, t) {
          const n = fr(this.containers, (t) => -1 !== t.modals.indexOf(e)),
            r = this.containers[n];
          r.restore ||
            (r.restore = (function (e, t) {
              const n = [],
                r = e.container;
              if (!t.disableScrollLock) {
                if (
                  (function (e) {
                    const t = (0, sr.Z)(e);
                    return t.body === e
                      ? (0, ur.Z)(e).innerWidth > t.documentElement.clientWidth
                      : e.scrollHeight > e.clientHeight;
                  })(r)
                ) {
                  const e = dr((0, sr.Z)(r));
                  n.push({
                    value: r.style.paddingRight,
                    property: "padding-right",
                    el: r,
                  }),
                    (r.style.paddingRight = `${mr(r) + e}px`);
                  const t = (0, sr.Z)(r).querySelectorAll(".mui-fixed");
                  [].forEach.call(t, (t) => {
                    n.push({
                      value: t.style.paddingRight,
                      property: "padding-right",
                      el: t,
                    }),
                      (t.style.paddingRight = `${mr(t) + e}px`);
                  });
                }
                let e;
                if (r.parentNode instanceof DocumentFragment)
                  e = (0, sr.Z)(r).body;
                else {
                  const t = r.parentElement,
                    n = (0, ur.Z)(r);
                  e =
                    "HTML" === (null == t ? void 0 : t.nodeName) &&
                    "scroll" === n.getComputedStyle(t).overflowY
                      ? t
                      : r;
                }
                n.push(
                  { value: e.style.overflow, property: "overflow", el: e },
                  { value: e.style.overflowX, property: "overflow-x", el: e },
                  { value: e.style.overflowY, property: "overflow-y", el: e }
                ),
                  (e.style.overflow = "hidden");
              }
              return () => {
                n.forEach(({ value: e, el: t, property: n }) => {
                  e ? t.style.setProperty(n, e) : t.style.removeProperty(n);
                });
              };
            })(r, t));
        }
        remove(e, t = !0) {
          const n = this.modals.indexOf(e);
          if (-1 === n) return n;
          const r = fr(this.containers, (t) => -1 !== t.modals.indexOf(e)),
            o = this.containers[r];
          if (
            (o.modals.splice(o.modals.indexOf(e), 1),
            this.modals.splice(n, 1),
            0 === o.modals.length)
          )
            o.restore && o.restore(),
              e.modalRef && pr(e.modalRef, t),
              hr(o.container, e.mount, e.modalRef, o.hiddenSiblings, !1),
              this.containers.splice(r, 1);
          else {
            const e = o.modals[o.modals.length - 1];
            e.modalRef && pr(e.modalRef, !1);
          }
          return n;
        }
        isTopModal(e) {
          return (
            this.modals.length > 0 && this.modals[this.modals.length - 1] === e
          );
        }
      })();
      const vr = [
        "input",
        "select",
        "textarea",
        "a[href]",
        "button",
        "[tabindex]",
        "audio[controls]",
        "video[controls]",
        '[contenteditable]:not([contenteditable="false"])',
      ].join(",");
      function br(e) {
        const t = [],
          n = [];
        return (
          Array.from(e.querySelectorAll(vr)).forEach((e, r) => {
            const o = (function (e) {
              const t = parseInt(e.getAttribute("tabindex") || "", 10);
              return Number.isNaN(t)
                ? "true" === e.contentEditable ||
                  (("AUDIO" === e.nodeName ||
                    "VIDEO" === e.nodeName ||
                    "DETAILS" === e.nodeName) &&
                    null === e.getAttribute("tabindex"))
                  ? 0
                  : e.tabIndex
                : t;
            })(e);
            -1 !== o &&
              (function (e) {
                return !(
                  e.disabled ||
                  ("INPUT" === e.tagName && "hidden" === e.type) ||
                  (function (e) {
                    if ("INPUT" !== e.tagName || "radio" !== e.type) return !1;
                    if (!e.name) return !1;
                    const t = (t) =>
                      e.ownerDocument.querySelector(`input[type="radio"]${t}`);
                    let n = t(`[name="${e.name}"]:checked`);
                    return n || (n = t(`[name="${e.name}"]`)), n !== e;
                  })(e)
                );
              })(e) &&
              (0 === o
                ? t.push(e)
                : n.push({ documentOrder: r, tabIndex: o, node: e }));
          }),
          n
            .sort((e, t) =>
              e.tabIndex === t.tabIndex
                ? e.documentOrder - t.documentOrder
                : e.tabIndex - t.tabIndex
            )
            .map((e) => e.node)
            .concat(t)
        );
      }
      function _r() {
        return !0;
      }
      function yr(n) {
        const {
            children: r,
            disableAutoFocus: o = !1,
            disableEnforceFocus: a = !1,
            disableRestoreFocus: i = !1,
            getTabbable: s = br,
            isEnabled: l = _r,
            open: c,
          } = n,
          u = t.useRef(!1),
          d = t.useRef(null),
          p = t.useRef(null),
          m = t.useRef(null),
          h = t.useRef(null),
          f = t.useRef(!1),
          g = t.useRef(null),
          v = (0, Qn.Z)(r.ref, g),
          b = t.useRef(null);
        t.useEffect(() => {
          c && g.current && (f.current = !o);
        }, [o, c]),
          t.useEffect(() => {
            if (!c || !g.current) return;
            const e = (0, sr.Z)(g.current);
            return (
              g.current.contains(e.activeElement) ||
                (g.current.hasAttribute("tabIndex") ||
                  g.current.setAttribute("tabIndex", "-1"),
                f.current && g.current.focus()),
              () => {
                i ||
                  (m.current &&
                    m.current.focus &&
                    ((u.current = !0), m.current.focus()),
                  (m.current = null));
              }
            );
          }, [c]),
          t.useEffect(() => {
            if (!c || !g.current) return;
            const e = (0, sr.Z)(g.current),
              t = (t) => {
                (b.current = t),
                  !a &&
                    l() &&
                    "Tab" === t.key &&
                    e.activeElement === g.current &&
                    t.shiftKey &&
                    ((u.current = !0), p.current && p.current.focus());
              },
              n = () => {
                const t = g.current;
                if (null === t) return;
                if (!e.hasFocus() || !l() || u.current)
                  return void (u.current = !1);
                if (t.contains(e.activeElement)) return;
                if (
                  a &&
                  e.activeElement !== d.current &&
                  e.activeElement !== p.current
                )
                  return;
                if (e.activeElement !== h.current) h.current = null;
                else if (null !== h.current) return;
                if (!f.current) return;
                let n = [];
                if (
                  ((e.activeElement !== d.current &&
                    e.activeElement !== p.current) ||
                    (n = s(g.current)),
                  n.length > 0)
                ) {
                  var r, o;
                  const e = Boolean(
                      (null == (r = b.current) ? void 0 : r.shiftKey) &&
                        "Tab" === (null == (o = b.current) ? void 0 : o.key)
                    ),
                    t = n[0],
                    a = n[n.length - 1];
                  "string" != typeof t &&
                    "string" != typeof a &&
                    (e ? a.focus() : t.focus());
                } else t.focus();
              };
            e.addEventListener("focusin", n),
              e.addEventListener("keydown", t, !0);
            const r = setInterval(() => {
              e.activeElement && "BODY" === e.activeElement.tagName && n();
            }, 50);
            return () => {
              clearInterval(r),
                e.removeEventListener("focusin", n),
                e.removeEventListener("keydown", t, !0);
            };
          }, [o, a, i, l, c, s]);
        const _ = (e) => {
          null === m.current && (m.current = e.relatedTarget), (f.current = !0);
        };
        return (0, e.jsxs)(t.Fragment, {
          children: [
            (0, e.jsx)("div", {
              tabIndex: c ? 0 : -1,
              onFocus: _,
              ref: d,
              "data-testid": "sentinelStart",
            }),
            t.cloneElement(r, {
              ref: v,
              onFocus: (e) => {
                null === m.current && (m.current = e.relatedTarget),
                  (f.current = !0),
                  (h.current = e.target);
                const t = r.props.onFocus;
                t && t(e);
              },
            }),
            (0, e.jsx)("div", {
              tabIndex: c ? 0 : -1,
              onFocus: _,
              ref: p,
              "data-testid": "sentinelEnd",
            }),
          ],
        });
      }
      var xr = o(4895),
        Cr = o(5091);
      const Sr = t.forwardRef(function (n, o) {
        const { children: a, container: i, disablePortal: s = !1 } = n,
          [l, c] = t.useState(null),
          u = (0, Qn.Z)(t.isValidElement(a) ? a.ref : null, o);
        if (
          ((0, xr.Z)(() => {
            s ||
              c(
                (function (e) {
                  return "function" == typeof e ? e() : e;
                })(i) || document.body
              );
          }, [i, s]),
          (0, xr.Z)(() => {
            if (l && !s)
              return (
                (0, Cr.Z)(o, l),
                () => {
                  (0, Cr.Z)(o, null);
                }
              );
          }, [o, l, s]),
          s)
        ) {
          if (t.isValidElement(a)) {
            const e = { ref: u };
            return t.cloneElement(a, e);
          }
          return (0, e.jsx)(t.Fragment, { children: a });
        }
        return (0,
        e.jsx)(t.Fragment, { children: l ? r.createPortal(a, l) : l });
      });
      var kr = "unmounted",
        wr = "exited",
        Pr = "entering",
        Or = "entered",
        Ir = "exiting",
        Tr = (function (e) {
          function n(t, n) {
            var r;
            r = e.call(this, t, n) || this;
            var o,
              a = n && !n.isMounting ? t.enter : t.appear;
            return (
              (r.appearStatus = null),
              t.in
                ? a
                  ? ((o = wr), (r.appearStatus = Pr))
                  : (o = Or)
                : (o = t.unmountOnExit || t.mountOnEnter ? kr : wr),
              (r.state = { status: o }),
              (r.nextCallback = null),
              r
            );
          }
          pn(n, e),
            (n.getDerivedStateFromProps = function (e, t) {
              return e.in && t.status === kr ? { status: wr } : null;
            });
          var o = n.prototype;
          return (
            (o.componentDidMount = function () {
              this.updateStatus(!0, this.appearStatus);
            }),
            (o.componentDidUpdate = function (e) {
              var t = null;
              if (e !== this.props) {
                var n = this.state.status;
                this.props.in
                  ? n !== Pr && n !== Or && (t = Pr)
                  : (n !== Pr && n !== Or) || (t = Ir);
              }
              this.updateStatus(!1, t);
            }),
            (o.componentWillUnmount = function () {
              this.cancelNextCallback();
            }),
            (o.getTimeouts = function () {
              var e,
                t,
                n,
                r = this.props.timeout;
              return (
                (e = t = n = r),
                null != r &&
                  "number" != typeof r &&
                  ((e = r.exit),
                  (t = r.enter),
                  (n = void 0 !== r.appear ? r.appear : t)),
                { exit: e, enter: t, appear: n }
              );
            }),
            (o.updateStatus = function (e, t) {
              if ((void 0 === e && (e = !1), null !== t))
                if ((this.cancelNextCallback(), t === Pr)) {
                  if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var n = this.props.nodeRef
                      ? this.props.nodeRef.current
                      : r.findDOMNode(this);
                    n &&
                      (function (e) {
                        e.scrollTop;
                      })(n);
                  }
                  this.performEnter(e);
                } else this.performExit();
              else
                this.props.unmountOnExit &&
                  this.state.status === wr &&
                  this.setState({ status: kr });
            }),
            (o.performEnter = function (e) {
              var t = this,
                n = this.props.enter,
                o = this.context ? this.context.isMounting : e,
                a = this.props.nodeRef ? [o] : [r.findDOMNode(this), o],
                i = a[0],
                s = a[1],
                l = this.getTimeouts(),
                c = o ? l.appear : l.enter;
              e || n
                ? (this.props.onEnter(i, s),
                  this.safeSetState({ status: Pr }, function () {
                    t.props.onEntering(i, s),
                      t.onTransitionEnd(c, function () {
                        t.safeSetState({ status: Or }, function () {
                          t.props.onEntered(i, s);
                        });
                      });
                  }))
                : this.safeSetState({ status: Or }, function () {
                    t.props.onEntered(i);
                  });
            }),
            (o.performExit = function () {
              var e = this,
                t = this.props.exit,
                n = this.getTimeouts(),
                o = this.props.nodeRef ? void 0 : r.findDOMNode(this);
              t
                ? (this.props.onExit(o),
                  this.safeSetState({ status: Ir }, function () {
                    e.props.onExiting(o),
                      e.onTransitionEnd(n.exit, function () {
                        e.safeSetState({ status: wr }, function () {
                          e.props.onExited(o);
                        });
                      });
                  }))
                : this.safeSetState({ status: wr }, function () {
                    e.props.onExited(o);
                  });
            }),
            (o.cancelNextCallback = function () {
              null !== this.nextCallback &&
                (this.nextCallback.cancel(), (this.nextCallback = null));
            }),
            (o.safeSetState = function (e, t) {
              (t = this.setNextCallback(t)), this.setState(e, t);
            }),
            (o.setNextCallback = function (e) {
              var t = this,
                n = !0;
              return (
                (this.nextCallback = function (r) {
                  n && ((n = !1), (t.nextCallback = null), e(r));
                }),
                (this.nextCallback.cancel = function () {
                  n = !1;
                }),
                this.nextCallback
              );
            }),
            (o.onTransitionEnd = function (e, t) {
              this.setNextCallback(t);
              var n = this.props.nodeRef
                  ? this.props.nodeRef.current
                  : r.findDOMNode(this),
                o = null == e && !this.props.addEndListener;
              if (n && !o) {
                if (this.props.addEndListener) {
                  var a = this.props.nodeRef
                      ? [this.nextCallback]
                      : [n, this.nextCallback],
                    i = a[0],
                    s = a[1];
                  this.props.addEndListener(i, s);
                }
                null != e && setTimeout(this.nextCallback, e);
              } else setTimeout(this.nextCallback, 0);
            }),
            (o.render = function () {
              var e = this.state.status;
              if (e === kr) return null;
              var n = this.props,
                r = n.children,
                o =
                  (n.in,
                  n.mountOnEnter,
                  n.unmountOnExit,
                  n.appear,
                  n.enter,
                  n.exit,
                  n.timeout,
                  n.addEndListener,
                  n.onEnter,
                  n.onEntering,
                  n.onEntered,
                  n.onExit,
                  n.onExiting,
                  n.onExited,
                  n.nodeRef,
                  (0, jt.Z)(n, [
                    "children",
                    "in",
                    "mountOnEnter",
                    "unmountOnExit",
                    "appear",
                    "enter",
                    "exit",
                    "timeout",
                    "addEndListener",
                    "onEnter",
                    "onEntering",
                    "onEntered",
                    "onExit",
                    "onExiting",
                    "onExited",
                    "nodeRef",
                  ]));
              return t.createElement(
                mn.Provider,
                { value: null },
                "function" == typeof r
                  ? r(e, o)
                  : t.cloneElement(t.Children.only(r), o)
              );
            }),
            n
          );
        })(t.Component);
      function Mr() {}
      (Tr.contextType = mn),
        (Tr.propTypes = {}),
        (Tr.defaultProps = {
          in: !1,
          mountOnEnter: !1,
          unmountOnExit: !1,
          appear: !1,
          enter: !0,
          exit: !0,
          onEnter: Mr,
          onEntering: Mr,
          onEntered: Mr,
          onExit: Mr,
          onExiting: Mr,
          onExited: Mr,
        }),
        (Tr.UNMOUNTED = kr),
        (Tr.EXITED = wr),
        (Tr.ENTERING = Pr),
        (Tr.ENTERED = Or),
        (Tr.EXITING = Ir);
      var Er = Tr,
        Dr = o(247);
      function jr() {
        const e = (0, Xt.Z)(Dr.Z);
        return e[on.Z] || e;
      }
      const Rr = (e) => e.scrollTop;
      function Nr(e, t) {
        var n, r;
        const { timeout: o, easing: a, style: i = {} } = e;
        return {
          duration:
            null != (n = i.transitionDuration)
              ? n
              : "number" == typeof o
              ? o
              : o[t.mode] || 0,
          easing:
            null != (r = i.transitionTimingFunction)
              ? r
              : "object" == typeof a
              ? a[t.mode]
              : a,
          delay: i.transitionDelay,
        };
      }
      const Ar = [
          "addEndListener",
          "appear",
          "children",
          "easing",
          "in",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExited",
          "onExiting",
          "style",
          "timeout",
          "TransitionComponent",
        ],
        Lr = { entering: { opacity: 1 }, entered: { opacity: 1 } },
        zr = t.forwardRef(function (n, r) {
          const o = jr(),
            a = {
              enter: o.transitions.duration.enteringScreen,
              exit: o.transitions.duration.leavingScreen,
            },
            {
              addEndListener: i,
              appear: s = !0,
              children: l,
              easing: c,
              in: u,
              onEnter: p,
              onEntered: m,
              onEntering: h,
              onExit: f,
              onExited: g,
              onExiting: v,
              style: b,
              timeout: _ = a,
              TransitionComponent: y = Er,
            } = n,
            x = (0, jt.Z)(n, Ar),
            C = t.useRef(null),
            S = (0, cn.Z)(C, l.ref, r),
            k = (e) => (t) => {
              if (e) {
                const n = C.current;
                void 0 === t ? e(n) : e(n, t);
              }
            },
            w = k(h),
            P = k((e, t) => {
              Rr(e);
              const n = Nr(
                { style: b, timeout: _, easing: c },
                { mode: "enter" }
              );
              (e.style.webkitTransition = o.transitions.create("opacity", n)),
                (e.style.transition = o.transitions.create("opacity", n)),
                p && p(e, t);
            }),
            O = k(m),
            I = k(v),
            T = k((e) => {
              const t = Nr(
                { style: b, timeout: _, easing: c },
                { mode: "exit" }
              );
              (e.style.webkitTransition = o.transitions.create("opacity", t)),
                (e.style.transition = o.transitions.create("opacity", t)),
                f && f(e);
            }),
            M = k(g);
          return (0, e.jsx)(
            y,
            (0, d.Z)(
              {
                appear: s,
                in: u,
                nodeRef: C,
                onEnter: P,
                onEntered: O,
                onEntering: w,
                onExit: T,
                onExited: M,
                onExiting: I,
                addEndListener: (e) => {
                  i && i(C.current, e);
                },
                timeout: _,
              },
              x,
              {
                children: (e, n) =>
                  t.cloneElement(
                    l,
                    (0, d.Z)(
                      {
                        style: (0, d.Z)(
                          {
                            opacity: 0,
                            visibility: "exited" !== e || u ? void 0 : "hidden",
                          },
                          Lr[e],
                          b,
                          l.props.style
                        ),
                        ref: S,
                      },
                      n
                    )
                  ),
              }
            )
          );
        });
      var Br = zr;
      function Zr(e) {
        return (0, Zt.ZP)("MuiBackdrop", e);
      }
      (0, Bt.Z)("MuiBackdrop", ["root", "invisible"]);
      const Fr = [
          "children",
          "className",
          "component",
          "components",
          "componentsProps",
          "invisible",
          "open",
          "slotProps",
          "slots",
          "TransitionComponent",
          "transitionDuration",
        ],
        Hr = (0, Lt.ZP)("div", {
          name: "MuiBackdrop",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.invisible && t.invisible];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              position: "fixed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              right: 0,
              bottom: 0,
              top: 0,
              left: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              WebkitTapHighlightColor: "transparent",
            },
            e.invisible && { backgroundColor: "transparent" }
          )
        );
      var Vr = t.forwardRef(function (t, n) {
        var r, o, a;
        const i = (0, zt.Z)({ props: t, name: "MuiBackdrop" }),
          {
            children: s,
            className: l,
            component: c = "div",
            components: u = {},
            componentsProps: p = {},
            invisible: m = !1,
            open: h,
            slotProps: f = {},
            slots: g = {},
            TransitionComponent: v = Br,
            transitionDuration: b,
          } = i,
          _ = (0, jt.Z)(i, Fr),
          y = (0, d.Z)({}, i, { component: c, invisible: m }),
          x = ((e) => {
            const { classes: t, invisible: n } = e,
              r = { root: ["root", n && "invisible"] };
            return (0, Nt.Z)(r, Zr, t);
          })(y),
          C = null != (r = f.root) ? r : p.root;
        return (0,
        e.jsx)(v, (0, d.Z)({ in: h, timeout: b }, _, { children: (0, e.jsx)(Hr, (0, d.Z)({ "aria-hidden": !0 }, C, { as: null != (o = null != (a = g.root) ? a : u.Root) ? o : c, className: (0, Rt.Z)(x.root, l, null == C ? void 0 : C.className), ownerState: (0, d.Z)({}, y, null == C ? void 0 : C.ownerState), classes: x, ref: n, children: s })) }));
      });
      function Wr(e) {
        return (0, Zt.ZP)("MuiModal", e);
      }
      (0, Bt.Z)("MuiModal", ["root", "hidden", "backdrop"]);
      const $r = [
          "BackdropComponent",
          "BackdropProps",
          "classes",
          "className",
          "closeAfterTransition",
          "children",
          "container",
          "component",
          "components",
          "componentsProps",
          "disableAutoFocus",
          "disableEnforceFocus",
          "disableEscapeKeyDown",
          "disablePortal",
          "disableRestoreFocus",
          "disableScrollLock",
          "hideBackdrop",
          "keepMounted",
          "onBackdropClick",
          "onClose",
          "onTransitionEnter",
          "onTransitionExited",
          "open",
          "slotProps",
          "slots",
          "theme",
        ],
        Ur = (0, Lt.ZP)("div", {
          name: "MuiModal",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, !n.open && n.exited && t.hidden];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              position: "fixed",
              zIndex: (e.vars || e).zIndex.modal,
              right: 0,
              bottom: 0,
              top: 0,
              left: 0,
            },
            !t.open && t.exited && { visibility: "hidden" }
          )
        ),
        Kr = (0, Lt.ZP)(Vr, {
          name: "MuiModal",
          slot: "Backdrop",
          overridesResolver: (e, t) => t.backdrop,
        })({ zIndex: -1 }),
        Gr = t.forwardRef(function (n, r) {
          var o, a, i, s, l, c;
          const u = (0, zt.Z)({ name: "MuiModal", props: n }),
            {
              BackdropComponent: p = Kr,
              BackdropProps: m,
              className: h,
              closeAfterTransition: f = !1,
              children: g,
              container: v,
              component: b,
              components: _ = {},
              componentsProps: y = {},
              disableAutoFocus: x = !1,
              disableEnforceFocus: C = !1,
              disableEscapeKeyDown: S = !1,
              disablePortal: k = !1,
              disableRestoreFocus: w = !1,
              disableScrollLock: P = !1,
              hideBackdrop: O = !1,
              keepMounted: I = !1,
              onBackdropClick: T,
              open: M,
              slotProps: E,
              slots: D,
            } = u,
            j = (0, jt.Z)(u, $r),
            R = (0, d.Z)({}, u, {
              closeAfterTransition: f,
              disableAutoFocus: x,
              disableEnforceFocus: C,
              disableEscapeKeyDown: S,
              disablePortal: k,
              disableRestoreFocus: w,
              disableScrollLock: P,
              hideBackdrop: O,
              keepMounted: I,
            }),
            {
              getRootProps: N,
              getBackdropProps: A,
              getTransitionProps: L,
              portalRef: z,
              isTopModal: B,
              exited: Z,
              hasTransition: F,
            } = (function (e) {
              const {
                  container: n,
                  disableEscapeKeyDown: r = !1,
                  disableScrollLock: o = !1,
                  manager: a = gr,
                  closeAfterTransition: i = !1,
                  onTransitionEnter: s,
                  onTransitionExited: l,
                  children: c,
                  onClose: u,
                  open: p,
                  rootRef: m,
                } = e,
                h = t.useRef({}),
                f = t.useRef(null),
                g = t.useRef(null),
                v = (0, Qn.Z)(g, m),
                [b, _] = t.useState(!p),
                y = (function (e) {
                  return !!e && e.props.hasOwnProperty("in");
                })(c);
              let x = !0;
              ("false" !== e["aria-hidden"] && !1 !== e["aria-hidden"]) ||
                (x = !1);
              const C = () => (
                  (h.current.modalRef = g.current),
                  (h.current.mount = f.current),
                  h.current
                ),
                S = () => {
                  a.mount(C(), { disableScrollLock: o }),
                    g.current && (g.current.scrollTop = 0);
                },
                k = (0, lr.Z)(() => {
                  const e =
                    (function (e) {
                      return "function" == typeof e ? e() : e;
                    })(n) || (0, sr.Z)(f.current).body;
                  a.add(C(), e), g.current && S();
                }),
                w = t.useCallback(() => a.isTopModal(C()), [a]),
                P = (0, lr.Z)((e) => {
                  (f.current = e),
                    e && (p && w() ? S() : g.current && pr(g.current, x));
                }),
                O = t.useCallback(() => {
                  a.remove(C(), x);
                }, [x, a]);
              t.useEffect(
                () => () => {
                  O();
                },
                [O]
              ),
                t.useEffect(() => {
                  p ? k() : (y && i) || O();
                }, [p, O, y, i, k]);
              const I = (e) => (t) => {
                  var n;
                  null == (n = e.onKeyDown) || n.call(e, t),
                    "Escape" === t.key &&
                      229 !== t.which &&
                      w() &&
                      (r || (t.stopPropagation(), u && u(t, "escapeKeyDown")));
                },
                T = (e) => (t) => {
                  var n;
                  null == (n = e.onClick) || n.call(e, t),
                    t.target === t.currentTarget && u && u(t, "backdropClick");
                };
              return {
                getRootProps: (t = {}) => {
                  const n = tr(e);
                  delete n.onTransitionEnter, delete n.onTransitionExited;
                  const r = (0, d.Z)({}, n, t);
                  return (0, d.Z)({ role: "presentation" }, r, {
                    onKeyDown: I(r),
                    ref: v,
                  });
                },
                getBackdropProps: (e = {}) => {
                  const t = e;
                  return (0, d.Z)({ "aria-hidden": !0 }, t, {
                    onClick: T(t),
                    open: p,
                  });
                },
                getTransitionProps: () => ({
                  onEnter: (0, cr.Z)(
                    () => {
                      _(!1), s && s();
                    },
                    null == c ? void 0 : c.props.onEnter
                  ),
                  onExited: (0, cr.Z)(
                    () => {
                      _(!0), l && l(), i && O();
                    },
                    null == c ? void 0 : c.props.onExited
                  ),
                }),
                rootRef: v,
                portalRef: P,
                isTopModal: w,
                exited: b,
                hasTransition: y,
              };
            })((0, d.Z)({}, R, { rootRef: r })),
            H = (0, d.Z)({}, R, { exited: Z }),
            V = ((e) => {
              const { open: t, exited: n, classes: r } = e,
                o = {
                  root: ["root", !t && n && "hidden"],
                  backdrop: ["backdrop"],
                };
              return (0, Nt.Z)(o, Wr, r);
            })(H),
            W = {};
          if ((void 0 === g.props.tabIndex && (W.tabIndex = "-1"), F)) {
            const { onEnter: e, onExited: t } = L();
            (W.onEnter = e), (W.onExited = t);
          }
          const $ =
              null !=
              (o = null != (a = null == D ? void 0 : D.root) ? a : _.Root)
                ? o
                : Ur,
            U =
              null !=
              (i =
                null != (s = null == D ? void 0 : D.backdrop) ? s : _.Backdrop)
                ? i
                : p,
            K = null != (l = null == E ? void 0 : E.root) ? l : y.root,
            G = null != (c = null == E ? void 0 : E.backdrop) ? c : y.backdrop,
            q = ir({
              elementType: $,
              externalSlotProps: K,
              externalForwardedProps: j,
              getSlotProps: N,
              additionalProps: { ref: r, as: b },
              ownerState: H,
              className: (0, Rt.Z)(
                h,
                null == K ? void 0 : K.className,
                null == V ? void 0 : V.root,
                !H.open && H.exited && (null == V ? void 0 : V.hidden)
              ),
            }),
            Y = ir({
              elementType: U,
              externalSlotProps: G,
              additionalProps: m,
              getSlotProps: (e) =>
                A(
                  (0, d.Z)({}, e, {
                    onClick: (t) => {
                      T && T(t), null != e && e.onClick && e.onClick(t);
                    },
                  })
                ),
              className: (0, Rt.Z)(
                null == G ? void 0 : G.className,
                null == m ? void 0 : m.className,
                null == V ? void 0 : V.backdrop
              ),
              ownerState: H,
            });
          return I || M || (F && !Z)
            ? (0, e.jsx)(Sr, {
                ref: z,
                container: v,
                disablePortal: k,
                children: (0, e.jsxs)(
                  $,
                  (0, d.Z)({}, q, {
                    children: [
                      !O && p ? (0, e.jsx)(U, (0, d.Z)({}, Y)) : null,
                      (0, e.jsx)(yr, {
                        disableEnforceFocus: C,
                        disableAutoFocus: x,
                        disableRestoreFocus: w,
                        isEnabled: B,
                        open: M,
                        children: t.cloneElement(g, W),
                      }),
                    ],
                  })
                ),
              })
            : null;
        });
      var qr = Gr,
        Yr = o(7144),
        Jr = o(5340);
      const Qr = [
        "addEndListener",
        "appear",
        "children",
        "container",
        "direction",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent",
      ];
      function Xr(e, t, n) {
        var r;
        const o = (function (e, t, n) {
          const r = t.getBoundingClientRect(),
            o = n && n.getBoundingClientRect(),
            a = (0, Jr.Z)(t);
          let i;
          if (t.fakeTransform) i = t.fakeTransform;
          else {
            const e = a.getComputedStyle(t);
            i =
              e.getPropertyValue("-webkit-transform") ||
              e.getPropertyValue("transform");
          }
          let s = 0,
            l = 0;
          if (i && "none" !== i && "string" == typeof i) {
            const e = i.split("(")[1].split(")")[0].split(",");
            (s = parseInt(e[4], 10)), (l = parseInt(e[5], 10));
          }
          return "left" === e
            ? o
              ? `translateX(${o.right + s - r.left}px)`
              : `translateX(${a.innerWidth + s - r.left}px)`
            : "right" === e
            ? o
              ? `translateX(-${r.right - o.left - s}px)`
              : `translateX(-${r.left + r.width - s}px)`
            : "up" === e
            ? o
              ? `translateY(${o.bottom + l - r.top}px)`
              : `translateY(${a.innerHeight + l - r.top}px)`
            : o
            ? `translateY(-${r.top - o.top + r.height - l}px)`
            : `translateY(-${r.top + r.height - l}px)`;
        })(e, t, "function" == typeof (r = n) ? r() : r);
        o && ((t.style.webkitTransform = o), (t.style.transform = o));
      }
      const eo = t.forwardRef(function (n, r) {
        const o = jr(),
          a = {
            enter: o.transitions.easing.easeOut,
            exit: o.transitions.easing.sharp,
          },
          i = {
            enter: o.transitions.duration.enteringScreen,
            exit: o.transitions.duration.leavingScreen,
          },
          {
            addEndListener: s,
            appear: l = !0,
            children: c,
            container: u,
            direction: p = "down",
            easing: m = a,
            in: h,
            onEnter: f,
            onEntered: g,
            onEntering: v,
            onExit: b,
            onExited: _,
            onExiting: y,
            style: x,
            timeout: C = i,
            TransitionComponent: S = Er,
          } = n,
          k = (0, jt.Z)(n, Qr),
          w = t.useRef(null),
          P = (0, cn.Z)(c.ref, w, r),
          O = (e) => (t) => {
            e && (void 0 === t ? e(w.current) : e(w.current, t));
          },
          I = O((e, t) => {
            Xr(p, e, u), Rr(e), f && f(e, t);
          }),
          T = O((e, t) => {
            const n = Nr(
              { timeout: C, style: x, easing: m },
              { mode: "enter" }
            );
            (e.style.webkitTransition = o.transitions.create(
              "-webkit-transform",
              (0, d.Z)({}, n)
            )),
              (e.style.transition = o.transitions.create(
                "transform",
                (0, d.Z)({}, n)
              )),
              (e.style.webkitTransform = "none"),
              (e.style.transform = "none"),
              v && v(e, t);
          }),
          M = O(g),
          E = O(y),
          D = O((e) => {
            const t = Nr({ timeout: C, style: x, easing: m }, { mode: "exit" });
            (e.style.webkitTransition = o.transitions.create(
              "-webkit-transform",
              t
            )),
              (e.style.transition = o.transitions.create("transform", t)),
              Xr(p, e, u),
              b && b(e);
          }),
          j = O((e) => {
            (e.style.webkitTransition = ""),
              (e.style.transition = ""),
              _ && _(e);
          }),
          R = t.useCallback(() => {
            w.current && Xr(p, w.current, u);
          }, [p, u]);
        return (
          t.useEffect(() => {
            if (h || "down" === p || "right" === p) return;
            const e = (0, Yr.Z)(() => {
                w.current && Xr(p, w.current, u);
              }),
              t = (0, Jr.Z)(w.current);
            return (
              t.addEventListener("resize", e),
              () => {
                e.clear(), t.removeEventListener("resize", e);
              }
            );
          }, [p, h, u]),
          t.useEffect(() => {
            h || R();
          }, [h, R]),
          (0, e.jsx)(
            S,
            (0, d.Z)(
              {
                nodeRef: w,
                onEnter: I,
                onEntered: M,
                onEntering: T,
                onExit: D,
                onExited: j,
                onExiting: E,
                addEndListener: (e) => {
                  s && s(w.current, e);
                },
                appear: l,
                in: h,
                timeout: C,
              },
              k,
              {
                children: (e, n) =>
                  t.cloneElement(
                    c,
                    (0, d.Z)(
                      {
                        ref: P,
                        style: (0, d.Z)(
                          {
                            visibility: "exited" !== e || h ? void 0 : "hidden",
                          },
                          x,
                          c.props.style
                        ),
                      },
                      n
                    )
                  ),
              }
            )
          )
        );
      });
      var to = eo,
        no = (e) => {
          let t;
          return (
            (t = e < 1 ? 5.11916 * e ** 2 : 4.5 * Math.log(e + 1) + 2),
            (t / 100).toFixed(2)
          );
        };
      function ro(e) {
        return (0, Zt.ZP)("MuiPaper", e);
      }
      (0, Bt.Z)("MuiPaper", [
        "root",
        "rounded",
        "outlined",
        "elevation",
        "elevation0",
        "elevation1",
        "elevation2",
        "elevation3",
        "elevation4",
        "elevation5",
        "elevation6",
        "elevation7",
        "elevation8",
        "elevation9",
        "elevation10",
        "elevation11",
        "elevation12",
        "elevation13",
        "elevation14",
        "elevation15",
        "elevation16",
        "elevation17",
        "elevation18",
        "elevation19",
        "elevation20",
        "elevation21",
        "elevation22",
        "elevation23",
        "elevation24",
      ]);
      const oo = ["className", "component", "elevation", "square", "variant"],
        ao = (0, Lt.ZP)("div", {
          name: "MuiPaper",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              !n.square && t.rounded,
              "elevation" === n.variant && t[`elevation${n.elevation}`],
            ];
          },
        })(({ theme: e, ownerState: t }) => {
          var n;
          return (0, d.Z)(
            {
              backgroundColor: (e.vars || e).palette.background.paper,
              color: (e.vars || e).palette.text.primary,
              transition: e.transitions.create("box-shadow"),
            },
            !t.square && { borderRadius: e.shape.borderRadius },
            "outlined" === t.variant && {
              border: `1px solid ${(e.vars || e).palette.divider}`,
            },
            "elevation" === t.variant &&
              (0, d.Z)(
                { boxShadow: (e.vars || e).shadows[t.elevation] },
                !e.vars &&
                  "dark" === e.palette.mode && {
                    backgroundImage: `linear-gradient(${(0, At.Fq)(
                      "#fff",
                      no(t.elevation)
                    )}, ${(0, At.Fq)("#fff", no(t.elevation))})`,
                  },
                e.vars && {
                  backgroundImage:
                    null == (n = e.vars.overlays) ? void 0 : n[t.elevation],
                }
              )
          );
        });
      var io = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiPaper" }),
            {
              className: o,
              component: a = "div",
              elevation: i = 1,
              square: s = !1,
              variant: l = "elevation",
            } = r,
            c = (0, jt.Z)(r, oo),
            u = (0, d.Z)({}, r, {
              component: a,
              elevation: i,
              square: s,
              variant: l,
            }),
            p = ((e) => {
              const { square: t, elevation: n, variant: r, classes: o } = e,
                a = {
                  root: [
                    "root",
                    r,
                    !t && "rounded",
                    "elevation" === r && `elevation${n}`,
                  ],
                };
              return (0, Nt.Z)(a, ro, o);
            })(u);
          return (0,
          e.jsx)(ao, (0, d.Z)({ as: a, ownerState: u, className: (0, Rt.Z)(p.root, o), ref: n }, c));
        }),
        so = o(4136);
      function lo(e) {
        return (0, Zt.ZP)("MuiDrawer", e);
      }
      (0, Bt.Z)("MuiDrawer", [
        "root",
        "docked",
        "paper",
        "paperAnchorLeft",
        "paperAnchorRight",
        "paperAnchorTop",
        "paperAnchorBottom",
        "paperAnchorDockedLeft",
        "paperAnchorDockedRight",
        "paperAnchorDockedTop",
        "paperAnchorDockedBottom",
        "modal",
      ]);
      const co = ["BackdropProps"],
        uo = [
          "anchor",
          "BackdropProps",
          "children",
          "className",
          "elevation",
          "hideBackdrop",
          "ModalProps",
          "onClose",
          "open",
          "PaperProps",
          "SlideProps",
          "TransitionComponent",
          "transitionDuration",
          "variant",
        ],
        po = (e, t) => {
          const { ownerState: n } = e;
          return [
            t.root,
            ("permanent" === n.variant || "persistent" === n.variant) &&
              t.docked,
            t.modal,
          ];
        },
        mo = (0, Lt.ZP)(qr, {
          name: "MuiDrawer",
          slot: "Root",
          overridesResolver: po,
        })(({ theme: e }) => ({ zIndex: (e.vars || e).zIndex.drawer })),
        ho = (0, Lt.ZP)("div", {
          shouldForwardProp: so.Z,
          name: "MuiDrawer",
          slot: "Docked",
          skipVariantsResolver: !1,
          overridesResolver: po,
        })({ flex: "0 0 auto" }),
        fo = (0, Lt.ZP)(io, {
          name: "MuiDrawer",
          slot: "Paper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.paper,
              t[`paperAnchor${(0, Fn.Z)(n.anchor)}`],
              "temporary" !== n.variant &&
                t[`paperAnchorDocked${(0, Fn.Z)(n.anchor)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              flex: "1 0 auto",
              zIndex: (e.vars || e).zIndex.drawer,
              WebkitOverflowScrolling: "touch",
              position: "fixed",
              top: 0,
              outline: 0,
            },
            "left" === t.anchor && { left: 0 },
            "top" === t.anchor && {
              top: 0,
              left: 0,
              right: 0,
              height: "auto",
              maxHeight: "100%",
            },
            "right" === t.anchor && { right: 0 },
            "bottom" === t.anchor && {
              top: "auto",
              left: 0,
              bottom: 0,
              right: 0,
              height: "auto",
              maxHeight: "100%",
            },
            "left" === t.anchor &&
              "temporary" !== t.variant && {
                borderRight: `1px solid ${(e.vars || e).palette.divider}`,
              },
            "top" === t.anchor &&
              "temporary" !== t.variant && {
                borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
              },
            "right" === t.anchor &&
              "temporary" !== t.variant && {
                borderLeft: `1px solid ${(e.vars || e).palette.divider}`,
              },
            "bottom" === t.anchor &&
              "temporary" !== t.variant && {
                borderTop: `1px solid ${(e.vars || e).palette.divider}`,
              }
          )
        ),
        go = { left: "right", right: "left", top: "down", bottom: "up" };
      var vo = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiDrawer" }),
            a = jr(),
            i = Yn(),
            s = {
              enter: a.transitions.duration.enteringScreen,
              exit: a.transitions.duration.leavingScreen,
            },
            {
              anchor: l = "left",
              BackdropProps: c,
              children: u,
              className: p,
              elevation: m = 16,
              hideBackdrop: h = !1,
              ModalProps: { BackdropProps: f } = {},
              onClose: g,
              open: v = !1,
              PaperProps: b = {},
              SlideProps: _,
              TransitionComponent: y = to,
              transitionDuration: x = s,
              variant: C = "temporary",
            } = o,
            S = (0, jt.Z)(o.ModalProps, co),
            k = (0, jt.Z)(o, uo),
            w = t.useRef(!1);
          t.useEffect(() => {
            w.current = !0;
          }, []);
          const P = (function ({ direction: e }, t) {
              return "rtl" === e &&
                (function (e) {
                  return -1 !== ["left", "right"].indexOf(e);
                })(t)
                ? go[t]
                : t;
            })({ direction: i ? "rtl" : "ltr" }, l),
            O = l,
            I = (0, d.Z)(
              {},
              o,
              { anchor: O, elevation: m, open: v, variant: C },
              k
            ),
            T = ((e) => {
              const { classes: t, anchor: n, variant: r } = e,
                o = {
                  root: ["root"],
                  docked: [
                    ("permanent" === r || "persistent" === r) && "docked",
                  ],
                  modal: ["modal"],
                  paper: [
                    "paper",
                    `paperAnchor${(0, Fn.Z)(n)}`,
                    "temporary" !== r && `paperAnchorDocked${(0, Fn.Z)(n)}`,
                  ],
                };
              return (0, Nt.Z)(o, lo, t);
            })(I),
            M = (0, e.jsx)(
              fo,
              (0, d.Z)(
                { elevation: "temporary" === C ? m : 0, square: !0 },
                b,
                {
                  className: (0, Rt.Z)(T.paper, b.className),
                  ownerState: I,
                  children: u,
                }
              )
            );
          if ("permanent" === C)
            return (0, e.jsx)(
              ho,
              (0, d.Z)(
                {
                  className: (0, Rt.Z)(T.root, T.docked, p),
                  ownerState: I,
                  ref: r,
                },
                k,
                { children: M }
              )
            );
          const E = (0, e.jsx)(
            y,
            (0, d.Z)(
              { in: v, direction: go[P], timeout: x, appear: w.current },
              _,
              { children: M }
            )
          );
          return "persistent" === C
            ? (0, e.jsx)(
                ho,
                (0, d.Z)(
                  {
                    className: (0, Rt.Z)(T.root, T.docked, p),
                    ownerState: I,
                    ref: r,
                  },
                  k,
                  { children: E }
                )
              )
            : (0, e.jsx)(
                mo,
                (0, d.Z)(
                  {
                    BackdropProps: (0, d.Z)({}, c, f, {
                      transitionDuration: x,
                    }),
                    className: (0, Rt.Z)(T.root, T.modal, p),
                    open: v,
                    ownerState: I,
                    onClose: g,
                    hideBackdrop: h,
                    ref: r,
                  },
                  k,
                  S,
                  { children: E }
                )
              );
        }),
        bo = o(2066),
        _o = (0, bo.Z)(
          (0, e.jsx)("path", { d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" }),
          "Menu"
        ),
        yo = 260,
        xo = { display: "flex" },
        Co = { mr: 2, display: { sm: "none" } },
        So = { width: { sm: yo }, flexShrink: { sm: 0 }, position: "sticky" },
        ko = {
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: yo },
        },
        wo = {
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: yo },
        },
        Po = {
          flexGrow: 1,
          width: {
            sm: "calc(100% - ".concat(yo, "px)"),
            md: "100%",
            xl: "100%",
          },
          mt: "-2%",
        },
        Oo = {
          left: "50%",
          top: "50%",
          position: "absolute",
          zIndex: 99999999,
          animation: "1.4s linear infinite animation-61bdi0 !important",
        },
        Io = {
          cursor: "pointer",
          textTransform: "capitalize",
          color: "#1976d2",
          textDecoration: "underline",
        },
        To = { textTransform: "capitalize", pointerEvents: "none" },
        Mo = { padding: "10px", fontSize: "12px", whiteSpace: "nowrap" },
        Eo = { display: "none" },
        Do = { cursor: "pointer", color: "#1976d2" },
        jo = {
          maxHeight: 500,
          tableLayout: "fixed",
          border: "1px solid #bfbfbf",
        },
        Ro = { height: 50, width: 50, borderRadius: "4px" },
        No = {
          display: { xs: "none", md: "flex" },
          fontSize: "16px",
          color: "#1565C4",
          fontFamily: "Segoe UI",
        },
        Ao = {
          boxShadow: "none",
          ".MuiOutlinedInput-notchedOutline": { border: 0 },
        },
        Lo = { display: "flex", alignItems: "center" },
        zo = { fontWeight: "bold", fontSize: "1.3rem" },
        Bo = {
          width: 45,
          height: 45,
          borderRadius: "50%",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Zo = { fontSize: "13px" };
      let Fo;
      function Ho() {
        if (Fo) return Fo;
        const e = document.createElement("div"),
          t = document.createElement("div");
        return (
          (t.style.width = "10px"),
          (t.style.height = "1px"),
          e.appendChild(t),
          (e.dir = "rtl"),
          (e.style.fontSize = "14px"),
          (e.style.width = "4px"),
          (e.style.height = "1px"),
          (e.style.position = "absolute"),
          (e.style.top = "-1000px"),
          (e.style.overflow = "scroll"),
          document.body.appendChild(e),
          (Fo = "reverse"),
          e.scrollLeft > 0
            ? (Fo = "default")
            : ((e.scrollLeft = 1), 0 === e.scrollLeft && (Fo = "negative")),
          document.body.removeChild(e),
          Fo
        );
      }
      function Vo(e, t) {
        const n = e.scrollLeft;
        if ("rtl" !== t) return n;
        switch (Ho()) {
          case "negative":
            return e.scrollWidth - e.clientWidth + n;
          case "reverse":
            return e.scrollWidth - e.clientWidth - n;
          default:
            return n;
        }
      }
      function Wo(e) {
        return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
      }
      o(6607);
      var $o = o(8974);
      const Uo = ["onChange"],
        Ko = {
          width: 99,
          height: 99,
          position: "absolute",
          top: -9999,
          overflow: "scroll",
        };
      var Go = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z",
          }),
          "KeyboardArrowLeft"
        ),
        qo = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z",
          }),
          "KeyboardArrowRight"
        );
      function Yo(e) {
        return (0, Zt.ZP)("MuiTabScrollButton", e);
      }
      var Jo = (0, Bt.Z)("MuiTabScrollButton", [
        "root",
        "vertical",
        "horizontal",
        "disabled",
      ]);
      const Qo = [
          "className",
          "slots",
          "slotProps",
          "direction",
          "orientation",
          "disabled",
        ],
        Xo = (0, Lt.ZP)(Zn, {
          name: "MuiTabScrollButton",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.orientation && t[n.orientation]];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              width: 40,
              flexShrink: 0,
              opacity: 0.8,
              [`&.${Jo.disabled}`]: { opacity: 0 },
            },
            "vertical" === e.orientation && {
              width: "100%",
              height: 40,
              "& svg": { transform: `rotate(${e.isRtl ? -90 : 90}deg)` },
            }
          )
        );
      var ea = t.forwardRef(function (t, n) {
        var r, o;
        const a = (0, zt.Z)({ props: t, name: "MuiTabScrollButton" }),
          { className: i, slots: s = {}, slotProps: l = {}, direction: c } = a,
          u = (0, jt.Z)(a, Qo),
          p = Yn(),
          m = (0, d.Z)({ isRtl: p }, a),
          h = ((e) => {
            const { classes: t, orientation: n, disabled: r } = e,
              o = { root: ["root", n, r && "disabled"] };
            return (0, Nt.Z)(o, Yo, t);
          })(m),
          f = null != (r = s.StartScrollButtonIcon) ? r : Go,
          g = null != (o = s.EndScrollButtonIcon) ? o : qo,
          v = ir({
            elementType: f,
            externalSlotProps: l.startScrollButtonIcon,
            additionalProps: { fontSize: "small" },
            ownerState: m,
          }),
          b = ir({
            elementType: g,
            externalSlotProps: l.endScrollButtonIcon,
            additionalProps: { fontSize: "small" },
            ownerState: m,
          });
        return (0,
        e.jsx)(Xo, (0, d.Z)({ component: "div", className: (0, Rt.Z)(h.root, i), ref: n, role: null, ownerState: m, tabIndex: null }, u, { children: "left" === c ? (0, e.jsx)(f, (0, d.Z)({}, v)) : (0, e.jsx)(g, (0, d.Z)({}, b)) }));
      });
      function ta(e) {
        return (0, Zt.ZP)("MuiTabs", e);
      }
      var na = (0, Bt.Z)("MuiTabs", [
          "root",
          "vertical",
          "flexContainer",
          "flexContainerVertical",
          "centered",
          "scroller",
          "fixed",
          "scrollableX",
          "scrollableY",
          "hideScrollbar",
          "scrollButtons",
          "scrollButtonsHideMobile",
          "indicator",
        ]),
        ra = o(8038);
      const oa = [
          "aria-label",
          "aria-labelledby",
          "action",
          "centered",
          "children",
          "className",
          "component",
          "allowScrollButtonsMobile",
          "indicatorColor",
          "onChange",
          "orientation",
          "ScrollButtonComponent",
          "scrollButtons",
          "selectionFollowsFocus",
          "slots",
          "slotProps",
          "TabIndicatorProps",
          "TabScrollButtonProps",
          "textColor",
          "value",
          "variant",
          "visibleScrollbar",
        ],
        aa = (e, t) =>
          e === t
            ? e.firstChild
            : t && t.nextElementSibling
            ? t.nextElementSibling
            : e.firstChild,
        ia = (e, t) =>
          e === t
            ? e.lastChild
            : t && t.previousElementSibling
            ? t.previousElementSibling
            : e.lastChild,
        sa = (e, t, n) => {
          let r = !1,
            o = n(e, t);
          for (; o; ) {
            if (o === e.firstChild) {
              if (r) return;
              r = !0;
            }
            const t = o.disabled || "true" === o.getAttribute("aria-disabled");
            if (o.hasAttribute("tabindex") && !t) return void o.focus();
            o = n(e, o);
          }
        },
        la = (0, Lt.ZP)("div", {
          name: "MuiTabs",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${na.scrollButtons}`]: t.scrollButtons },
              {
                [`& .${na.scrollButtons}`]:
                  n.scrollButtonsHideMobile && t.scrollButtonsHideMobile,
              },
              t.root,
              n.vertical && t.vertical,
            ];
          },
        })(({ ownerState: e, theme: t }) =>
          (0, d.Z)(
            {
              overflow: "hidden",
              minHeight: 48,
              WebkitOverflowScrolling: "touch",
              display: "flex",
            },
            e.vertical && { flexDirection: "column" },
            e.scrollButtonsHideMobile && {
              [`& .${na.scrollButtons}`]: {
                [t.breakpoints.down("sm")]: { display: "none" },
              },
            }
          )
        ),
        ca = (0, Lt.ZP)("div", {
          name: "MuiTabs",
          slot: "Scroller",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.scroller,
              n.fixed && t.fixed,
              n.hideScrollbar && t.hideScrollbar,
              n.scrollableX && t.scrollableX,
              n.scrollableY && t.scrollableY,
            ];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              position: "relative",
              display: "inline-block",
              flex: "1 1 auto",
              whiteSpace: "nowrap",
            },
            e.fixed && { overflowX: "hidden", width: "100%" },
            e.hideScrollbar && {
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            },
            e.scrollableX && { overflowX: "auto", overflowY: "hidden" },
            e.scrollableY && { overflowY: "auto", overflowX: "hidden" }
          )
        ),
        ua = (0, Lt.ZP)("div", {
          name: "MuiTabs",
          slot: "FlexContainer",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.flexContainer,
              n.vertical && t.flexContainerVertical,
              n.centered && t.centered,
            ];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { display: "flex" },
            e.vertical && { flexDirection: "column" },
            e.centered && { justifyContent: "center" }
          )
        ),
        da = (0, Lt.ZP)("span", {
          name: "MuiTabs",
          slot: "Indicator",
          overridesResolver: (e, t) => t.indicator,
        })(({ ownerState: e, theme: t }) =>
          (0, d.Z)(
            {
              position: "absolute",
              height: 2,
              bottom: 0,
              width: "100%",
              transition: t.transitions.create(),
            },
            "primary" === e.indicatorColor && {
              backgroundColor: (t.vars || t).palette.primary.main,
            },
            "secondary" === e.indicatorColor && {
              backgroundColor: (t.vars || t).palette.secondary.main,
            },
            e.vertical && { height: "100%", width: 2, right: 0 }
          )
        ),
        pa = (0, Lt.ZP)(function (n) {
          const { onChange: r } = n,
            o = (0, jt.Z)(n, Uo),
            a = t.useRef(),
            i = t.useRef(null),
            s = () => {
              a.current = i.current.offsetHeight - i.current.clientHeight;
            };
          return (
            (0, $o.Z)(() => {
              const e = (0, Yr.Z)(() => {
                  const e = a.current;
                  s(), e !== a.current && r(a.current);
                }),
                t = (0, Jr.Z)(i.current);
              return (
                t.addEventListener("resize", e),
                () => {
                  e.clear(), t.removeEventListener("resize", e);
                }
              );
            }, [r]),
            t.useEffect(() => {
              s(), r(a.current);
            }, [r]),
            (0, e.jsx)("div", (0, d.Z)({ style: Ko, ref: i }, o))
          );
        })({
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }),
        ma = {},
        ha = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiTabs" }),
            a = jr(),
            i = Yn(),
            {
              "aria-label": s,
              "aria-labelledby": l,
              action: c,
              centered: u = !1,
              children: p,
              className: m,
              component: h = "div",
              allowScrollButtonsMobile: f = !1,
              indicatorColor: g = "primary",
              onChange: v,
              orientation: b = "horizontal",
              ScrollButtonComponent: _ = ea,
              scrollButtons: y = "auto",
              selectionFollowsFocus: x,
              slots: C = {},
              slotProps: S = {},
              TabIndicatorProps: k = {},
              TabScrollButtonProps: w = {},
              textColor: P = "primary",
              value: O,
              variant: I = "standard",
              visibleScrollbar: T = !1,
            } = o,
            M = (0, jt.Z)(o, oa),
            E = "scrollable" === I,
            D = "vertical" === b,
            j = D ? "scrollTop" : "scrollLeft",
            R = D ? "top" : "left",
            N = D ? "bottom" : "right",
            A = D ? "clientHeight" : "clientWidth",
            L = D ? "height" : "width",
            z = (0, d.Z)({}, o, {
              component: h,
              allowScrollButtonsMobile: f,
              indicatorColor: g,
              orientation: b,
              vertical: D,
              scrollButtons: y,
              textColor: P,
              variant: I,
              visibleScrollbar: T,
              fixed: !E,
              hideScrollbar: E && !T,
              scrollableX: E && !D,
              scrollableY: E && D,
              centered: u && !E,
              scrollButtonsHideMobile: !f,
            }),
            B = ((e) => {
              const {
                  vertical: t,
                  fixed: n,
                  hideScrollbar: r,
                  scrollableX: o,
                  scrollableY: a,
                  centered: i,
                  scrollButtonsHideMobile: s,
                  classes: l,
                } = e,
                c = {
                  root: ["root", t && "vertical"],
                  scroller: [
                    "scroller",
                    n && "fixed",
                    r && "hideScrollbar",
                    o && "scrollableX",
                    a && "scrollableY",
                  ],
                  flexContainer: [
                    "flexContainer",
                    t && "flexContainerVertical",
                    i && "centered",
                  ],
                  indicator: ["indicator"],
                  scrollButtons: [
                    "scrollButtons",
                    s && "scrollButtonsHideMobile",
                  ],
                  scrollableX: [o && "scrollableX"],
                  hideScrollbar: [r && "hideScrollbar"],
                };
              return (0, Nt.Z)(c, ta, l);
            })(z),
            Z = ir({
              elementType: C.StartScrollButtonIcon,
              externalSlotProps: S.startScrollButtonIcon,
              ownerState: z,
            }),
            F = ir({
              elementType: C.EndScrollButtonIcon,
              externalSlotProps: S.endScrollButtonIcon,
              ownerState: z,
            }),
            [H, V] = t.useState(!1),
            [W, $] = t.useState(ma),
            [U, K] = t.useState(!1),
            [G, q] = t.useState(!1),
            [Y, J] = t.useState(!1),
            [Q, X] = t.useState({ overflow: "hidden", scrollbarWidth: 0 }),
            ee = new Map(),
            te = t.useRef(null),
            ne = t.useRef(null),
            re = () => {
              const e = te.current;
              let t, n;
              if (e) {
                const n = e.getBoundingClientRect();
                t = {
                  clientWidth: e.clientWidth,
                  scrollLeft: e.scrollLeft,
                  scrollTop: e.scrollTop,
                  scrollLeftNormalized: Vo(e, i ? "rtl" : "ltr"),
                  scrollWidth: e.scrollWidth,
                  top: n.top,
                  bottom: n.bottom,
                  left: n.left,
                  right: n.right,
                };
              }
              if (e && !1 !== O) {
                const e = ne.current.children;
                if (e.length > 0) {
                  const t = e[ee.get(O)];
                  n = t ? t.getBoundingClientRect() : null;
                }
              }
              return { tabsMeta: t, tabMeta: n };
            },
            oe = (0, un.Z)(() => {
              const { tabsMeta: e, tabMeta: t } = re();
              let n,
                r = 0;
              if (D) (n = "top"), t && e && (r = t.top - e.top + e.scrollTop);
              else if (((n = i ? "right" : "left"), t && e)) {
                const o = i
                  ? e.scrollLeftNormalized + e.clientWidth - e.scrollWidth
                  : e.scrollLeft;
                r = (i ? -1 : 1) * (t[n] - e[n] + o);
              }
              const o = { [n]: r, [L]: t ? t[L] : 0 };
              if (isNaN(W[n]) || isNaN(W[L])) $(o);
              else {
                const e = Math.abs(W[n] - o[n]),
                  t = Math.abs(W[L] - o[L]);
                (e >= 1 || t >= 1) && $(o);
              }
            }),
            ae = (e, { animation: t = !0 } = {}) => {
              t
                ? (function (e, t, n, r = {}, o = () => {}) {
                    const { ease: a = Wo, duration: i = 300 } = r;
                    let s = null;
                    const l = t[e];
                    let c = !1;
                    const u = (r) => {
                      if (c) return void o(new Error("Animation cancelled"));
                      null === s && (s = r);
                      const d = Math.min(1, (r - s) / i);
                      (t[e] = a(d) * (n - l) + l),
                        d >= 1
                          ? requestAnimationFrame(() => {
                              o(null);
                            })
                          : requestAnimationFrame(u);
                    };
                    l === n
                      ? o(new Error("Element already at target position"))
                      : requestAnimationFrame(u);
                  })(j, te.current, e, {
                    duration: a.transitions.duration.standard,
                  })
                : (te.current[j] = e);
            },
            ie = (e) => {
              let t = te.current[j];
              D
                ? (t += e)
                : ((t += e * (i ? -1 : 1)),
                  (t *= i && "reverse" === Ho() ? -1 : 1)),
                ae(t);
            },
            se = () => {
              const e = te.current[A];
              let t = 0;
              const n = Array.from(ne.current.children);
              for (let r = 0; r < n.length; r += 1) {
                const o = n[r];
                if (t + o[A] > e) {
                  0 === r && (t = e);
                  break;
                }
                t += o[A];
              }
              return t;
            },
            le = () => {
              ie(-1 * se());
            },
            ce = () => {
              ie(se());
            },
            ue = t.useCallback((e) => {
              X({ overflow: null, scrollbarWidth: e });
            }, []),
            de = (0, un.Z)((e) => {
              const { tabsMeta: t, tabMeta: n } = re();
              if (n && t)
                if (n[R] < t[R]) {
                  const r = t[j] + (n[R] - t[R]);
                  ae(r, { animation: e });
                } else if (n[N] > t[N]) {
                  const r = t[j] + (n[N] - t[N]);
                  ae(r, { animation: e });
                }
            }),
            pe = (0, un.Z)(() => {
              E && !1 !== y && J(!Y);
            });
          t.useEffect(() => {
            const e = (0, Yr.Z)(() => {
              te.current && oe();
            });
            let t;
            const n = (0, Jr.Z)(te.current);
            let r;
            return (
              n.addEventListener("resize", e),
              "undefined" != typeof ResizeObserver &&
                ((t = new ResizeObserver(e)),
                Array.from(ne.current.children).forEach((e) => {
                  t.observe(e);
                })),
              "undefined" != typeof MutationObserver &&
                ((r = new MutationObserver((n) => {
                  n.forEach((e) => {
                    e.removedNodes.forEach((e) => {
                      var n;
                      null == (n = t) || n.unobserve(e);
                    }),
                      e.addedNodes.forEach((e) => {
                        var n;
                        null == (n = t) || n.observe(e);
                      });
                  }),
                    e(),
                    pe();
                })),
                r.observe(ne.current, { childList: !0 })),
              () => {
                var o, a;
                e.clear(),
                  n.removeEventListener("resize", e),
                  null == (o = r) || o.disconnect(),
                  null == (a = t) || a.disconnect();
              }
            );
          }, [oe, pe]),
            t.useEffect(() => {
              const e = Array.from(ne.current.children),
                t = e.length;
              if (
                "undefined" != typeof IntersectionObserver &&
                t > 0 &&
                E &&
                !1 !== y
              ) {
                const n = e[0],
                  r = e[t - 1],
                  o = { root: te.current, threshold: 0.99 },
                  a = new IntersectionObserver((e) => {
                    K(!e[0].isIntersecting);
                  }, o);
                a.observe(n);
                const i = new IntersectionObserver((e) => {
                  q(!e[0].isIntersecting);
                }, o);
                return (
                  i.observe(r),
                  () => {
                    a.disconnect(), i.disconnect();
                  }
                );
              }
            }, [E, y, Y, null == p ? void 0 : p.length]),
            t.useEffect(() => {
              V(!0);
            }, []),
            t.useEffect(() => {
              oe();
            }),
            t.useEffect(() => {
              de(ma !== W);
            }, [de, W]),
            t.useImperativeHandle(
              c,
              () => ({ updateIndicator: oe, updateScrollButtons: pe }),
              [oe, pe]
            );
          const me = (0, e.jsx)(
            da,
            (0, d.Z)({}, k, {
              className: (0, Rt.Z)(B.indicator, k.className),
              ownerState: z,
              style: (0, d.Z)({}, W, k.style),
            })
          );
          let he = 0;
          const fe = t.Children.map(p, (e) => {
              if (!t.isValidElement(e)) return null;
              const n = void 0 === e.props.value ? he : e.props.value;
              ee.set(n, he);
              const r = n === O;
              return (
                (he += 1),
                t.cloneElement(
                  e,
                  (0, d.Z)(
                    {
                      fullWidth: "fullWidth" === I,
                      indicator: r && !H && me,
                      selected: r,
                      selectionFollowsFocus: x,
                      onChange: v,
                      textColor: P,
                      value: n,
                    },
                    1 !== he || !1 !== O || e.props.tabIndex
                      ? {}
                      : { tabIndex: 0 }
                  )
                )
              );
            }),
            ge = (() => {
              const t = {};
              t.scrollbarSizeListener = E
                ? (0, e.jsx)(pa, {
                    onChange: ue,
                    className: (0, Rt.Z)(B.scrollableX, B.hideScrollbar),
                  })
                : null;
              const n = E && (("auto" === y && (U || G)) || !0 === y);
              return (
                (t.scrollButtonStart = n
                  ? (0, e.jsx)(
                      _,
                      (0, d.Z)(
                        {
                          slots: {
                            StartScrollButtonIcon: C.StartScrollButtonIcon,
                          },
                          slotProps: { startScrollButtonIcon: Z },
                          orientation: b,
                          direction: i ? "right" : "left",
                          onClick: le,
                          disabled: !U,
                        },
                        w,
                        { className: (0, Rt.Z)(B.scrollButtons, w.className) }
                      )
                    )
                  : null),
                (t.scrollButtonEnd = n
                  ? (0, e.jsx)(
                      _,
                      (0, d.Z)(
                        {
                          slots: { EndScrollButtonIcon: C.EndScrollButtonIcon },
                          slotProps: { endScrollButtonIcon: F },
                          orientation: b,
                          direction: i ? "left" : "right",
                          onClick: ce,
                          disabled: !G,
                        },
                        w,
                        { className: (0, Rt.Z)(B.scrollButtons, w.className) }
                      )
                    )
                  : null),
                t
              );
            })();
          return (0, e.jsxs)(
            la,
            (0, d.Z)(
              { className: (0, Rt.Z)(B.root, m), ownerState: z, ref: r, as: h },
              M,
              {
                children: [
                  ge.scrollButtonStart,
                  ge.scrollbarSizeListener,
                  (0, e.jsxs)(ca, {
                    className: B.scroller,
                    ownerState: z,
                    style: {
                      overflow: Q.overflow,
                      [D ? "margin" + (i ? "Left" : "Right") : "marginBottom"]:
                        T ? void 0 : -Q.scrollbarWidth,
                    },
                    ref: te,
                    children: [
                      (0, e.jsx)(ua, {
                        "aria-label": s,
                        "aria-labelledby": l,
                        "aria-orientation":
                          "vertical" === b ? "vertical" : null,
                        className: B.flexContainer,
                        ownerState: z,
                        onKeyDown: (e) => {
                          const t = ne.current,
                            n = (0, ra.Z)(t).activeElement;
                          if ("tab" !== n.getAttribute("role")) return;
                          let r = "horizontal" === b ? "ArrowLeft" : "ArrowUp",
                            o = "horizontal" === b ? "ArrowRight" : "ArrowDown";
                          switch (
                            ("horizontal" === b &&
                              i &&
                              ((r = "ArrowRight"), (o = "ArrowLeft")),
                            e.key)
                          ) {
                            case r:
                              e.preventDefault(), sa(t, n, ia);
                              break;
                            case o:
                              e.preventDefault(), sa(t, n, aa);
                              break;
                            case "Home":
                              e.preventDefault(), sa(t, null, aa);
                              break;
                            case "End":
                              e.preventDefault(), sa(t, null, ia);
                          }
                        },
                        ref: ne,
                        role: "tablist",
                        children: fe,
                      }),
                      H && me,
                    ],
                  }),
                  ge.scrollButtonEnd,
                ],
              }
            )
          );
        });
      var fa = ha;
      function ga(e) {
        return (0, Zt.ZP)("MuiTab", e);
      }
      var va = (0, Bt.Z)("MuiTab", [
        "root",
        "labelIcon",
        "textColorInherit",
        "textColorPrimary",
        "textColorSecondary",
        "selected",
        "disabled",
        "fullWidth",
        "wrapped",
        "iconWrapper",
      ]);
      const ba = [
          "className",
          "disabled",
          "disableFocusRipple",
          "fullWidth",
          "icon",
          "iconPosition",
          "indicator",
          "label",
          "onChange",
          "onClick",
          "onFocus",
          "selected",
          "selectionFollowsFocus",
          "textColor",
          "value",
          "wrapped",
        ],
        _a = (0, Lt.ZP)(Zn, {
          name: "MuiTab",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.label && n.icon && t.labelIcon,
              t[`textColor${(0, Fn.Z)(n.textColor)}`],
              n.fullWidth && t.fullWidth,
              n.wrapped && t.wrapped,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {},
            e.typography.button,
            {
              maxWidth: 360,
              minWidth: 90,
              position: "relative",
              minHeight: 48,
              flexShrink: 0,
              padding: "12px 16px",
              overflow: "hidden",
              whiteSpace: "normal",
              textAlign: "center",
            },
            t.label && {
              flexDirection:
                "top" === t.iconPosition || "bottom" === t.iconPosition
                  ? "column"
                  : "row",
            },
            { lineHeight: 1.25 },
            t.icon &&
              t.label && {
                minHeight: 72,
                paddingTop: 9,
                paddingBottom: 9,
                [`& > .${va.iconWrapper}`]: (0, d.Z)(
                  {},
                  "top" === t.iconPosition && { marginBottom: 6 },
                  "bottom" === t.iconPosition && { marginTop: 6 },
                  "start" === t.iconPosition && { marginRight: e.spacing(1) },
                  "end" === t.iconPosition && { marginLeft: e.spacing(1) }
                ),
              },
            "inherit" === t.textColor && {
              color: "inherit",
              opacity: 0.6,
              [`&.${va.selected}`]: { opacity: 1 },
              [`&.${va.disabled}`]: {
                opacity: (e.vars || e).palette.action.disabledOpacity,
              },
            },
            "primary" === t.textColor && {
              color: (e.vars || e).palette.text.secondary,
              [`&.${va.selected}`]: {
                color: (e.vars || e).palette.primary.main,
              },
              [`&.${va.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
            },
            "secondary" === t.textColor && {
              color: (e.vars || e).palette.text.secondary,
              [`&.${va.selected}`]: {
                color: (e.vars || e).palette.secondary.main,
              },
              [`&.${va.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
            },
            t.fullWidth && {
              flexShrink: 1,
              flexGrow: 1,
              flexBasis: 0,
              maxWidth: "none",
            },
            t.wrapped && { fontSize: e.typography.pxToRem(12) }
          )
        );
      var ya = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiTab" }),
            {
              className: a,
              disabled: i = !1,
              disableFocusRipple: s = !1,
              fullWidth: l,
              icon: c,
              iconPosition: u = "top",
              indicator: p,
              label: m,
              onChange: h,
              onClick: f,
              onFocus: g,
              selected: v,
              selectionFollowsFocus: b,
              textColor: _ = "inherit",
              value: y,
              wrapped: x = !1,
            } = o,
            C = (0, jt.Z)(o, ba),
            S = (0, d.Z)({}, o, {
              disabled: i,
              disableFocusRipple: s,
              selected: v,
              icon: !!c,
              iconPosition: u,
              label: !!m,
              fullWidth: l,
              textColor: _,
              wrapped: x,
            }),
            k = ((e) => {
              const {
                  classes: t,
                  textColor: n,
                  fullWidth: r,
                  wrapped: o,
                  icon: a,
                  label: i,
                  selected: s,
                  disabled: l,
                } = e,
                c = {
                  root: [
                    "root",
                    a && i && "labelIcon",
                    `textColor${(0, Fn.Z)(n)}`,
                    r && "fullWidth",
                    o && "wrapped",
                    s && "selected",
                    l && "disabled",
                  ],
                  iconWrapper: ["iconWrapper"],
                };
              return (0, Nt.Z)(c, ga, t);
            })(S),
            w =
              c && m && t.isValidElement(c)
                ? t.cloneElement(c, {
                    className: (0, Rt.Z)(k.iconWrapper, c.props.className),
                  })
                : c;
          return (0, e.jsxs)(
            _a,
            (0, d.Z)(
              {
                focusRipple: !s,
                className: (0, Rt.Z)(k.root, a),
                ref: r,
                role: "tab",
                "aria-selected": v,
                disabled: i,
                onClick: (e) => {
                  !v && h && h(e, y), f && f(e);
                },
                onFocus: (e) => {
                  b && !v && h && h(e, y), g && g(e);
                },
                ownerState: S,
                tabIndex: v ? 0 : -1,
              },
              C,
              {
                children: [
                  "top" === u || "start" === u
                    ? (0, e.jsxs)(t.Fragment, { children: [w, m] })
                    : (0, e.jsxs)(t.Fragment, { children: [m, w] }),
                  p,
                ],
              }
            )
          );
        }),
        xa = (0, bo.Z)(
          (0, e.jsx)("path", { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" }),
          "Home"
        ),
        Ca = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2M1 3c0 .55.45 1 1 1h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1s-.45-1-1-1H7l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.67-1.43c-.16-.35-.52-.57-.9-.57H2c-.55 0-1 .45-1 1m16 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2",
          }),
          "ShoppingCartRounded"
        ),
        Sa = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V17c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V17c0 .55.45 1 1 1h3.5v-1.61c0-.83.23-1.61.63-2.29M20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H23c.55 0 1-.45 1-1zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3",
          }),
          "GroupsRounded"
        ),
        ka = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4",
          }),
          "Person"
        ),
        wa = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M21 2.21c-.13 0-.26.05-.35.15l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.8-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.09-.09-.22-.14-.35-.14V21.8c.13 0 .26-.05.35-.15l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.1.1.23.15.35.15V2.21zM17 17H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1m0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1m0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1",
          }),
          "ReceiptRounded"
        ),
        Pa = o(5408),
        Oa = t.createContext();
      function Ia(e) {
        return (0, Zt.ZP)("MuiGrid", e);
      }
      const Ta = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        Ma = (0, Bt.Z)("MuiGrid", [
          "root",
          "container",
          "item",
          "zeroMinWidth",
          ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => `spacing-xs-${e}`),
          ...["column-reverse", "column", "row-reverse", "row"].map(
            (e) => `direction-xs-${e}`
          ),
          ...["nowrap", "wrap-reverse", "wrap"].map((e) => `wrap-xs-${e}`),
          ...Ta.map((e) => `grid-xs-${e}`),
          ...Ta.map((e) => `grid-sm-${e}`),
          ...Ta.map((e) => `grid-md-${e}`),
          ...Ta.map((e) => `grid-lg-${e}`),
          ...Ta.map((e) => `grid-xl-${e}`),
        ]);
      var Ea = Ma;
      const Da = [
        "className",
        "columns",
        "columnSpacing",
        "component",
        "container",
        "direction",
        "item",
        "rowSpacing",
        "spacing",
        "wrap",
        "zeroMinWidth",
      ];
      function ja(e) {
        const t = parseFloat(e);
        return `${t}${String(e).replace(String(t), "") || "px"}`;
      }
      function Ra({ breakpoints: e, values: t }) {
        let n = "";
        Object.keys(t).forEach((e) => {
          "" === n && 0 !== t[e] && (n = e);
        });
        const r = Object.keys(e).sort((t, n) => e[t] - e[n]);
        return r.slice(0, r.indexOf(n));
      }
      const Na = (0, Lt.ZP)("div", {
          name: "MuiGrid",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              {
                container: r,
                direction: o,
                item: a,
                spacing: i,
                wrap: s,
                zeroMinWidth: l,
                breakpoints: c,
              } = n;
            let u = [];
            r &&
              (u = (function (e, t, n = {}) {
                if (!e || e <= 0) return [];
                if (
                  ("string" == typeof e && !Number.isNaN(Number(e))) ||
                  "number" == typeof e
                )
                  return [n[`spacing-xs-${String(e)}`]];
                const r = [];
                return (
                  t.forEach((t) => {
                    const o = e[t];
                    Number(o) > 0 && r.push(n[`spacing-${t}-${String(o)}`]);
                  }),
                  r
                );
              })(i, c, t));
            const d = [];
            return (
              c.forEach((e) => {
                const r = n[e];
                r && d.push(t[`grid-${e}-${String(r)}`]);
              }),
              [
                t.root,
                r && t.container,
                a && t.item,
                l && t.zeroMinWidth,
                ...u,
                "row" !== o && t[`direction-xs-${String(o)}`],
                "wrap" !== s && t[`wrap-xs-${String(s)}`],
                ...d,
              ]
            );
          },
        })(
          ({ ownerState: e }) =>
            (0, d.Z)(
              { boxSizing: "border-box" },
              e.container && {
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
              },
              e.item && { margin: 0 },
              e.zeroMinWidth && { minWidth: 0 },
              "wrap" !== e.wrap && { flexWrap: e.wrap }
            ),
          function ({ theme: e, ownerState: t }) {
            const n = (0, Pa.P$)({
              values: t.direction,
              breakpoints: e.breakpoints.values,
            });
            return (0, Pa.k9)({ theme: e }, n, (e) => {
              const t = { flexDirection: e };
              return (
                0 === e.indexOf("column") &&
                  (t[`& > .${Ea.item}`] = { maxWidth: "none" }),
                t
              );
            });
          },
          function ({ theme: e, ownerState: t }) {
            const { container: n, rowSpacing: r } = t;
            let o = {};
            if (n && 0 !== r) {
              const t = (0, Pa.P$)({
                values: r,
                breakpoints: e.breakpoints.values,
              });
              let n;
              "object" == typeof t &&
                (n = Ra({ breakpoints: e.breakpoints.values, values: t })),
                (o = (0, Pa.k9)({ theme: e }, t, (t, r) => {
                  var o;
                  const a = e.spacing(t);
                  return "0px" !== a
                    ? {
                        marginTop: `-${ja(a)}`,
                        [`& > .${Ea.item}`]: { paddingTop: ja(a) },
                      }
                    : null != (o = n) && o.includes(r)
                    ? {}
                    : { marginTop: 0, [`& > .${Ea.item}`]: { paddingTop: 0 } };
                }));
            }
            return o;
          },
          function ({ theme: e, ownerState: t }) {
            const { container: n, columnSpacing: r } = t;
            let o = {};
            if (n && 0 !== r) {
              const t = (0, Pa.P$)({
                values: r,
                breakpoints: e.breakpoints.values,
              });
              let n;
              "object" == typeof t &&
                (n = Ra({ breakpoints: e.breakpoints.values, values: t })),
                (o = (0, Pa.k9)({ theme: e }, t, (t, r) => {
                  var o;
                  const a = e.spacing(t);
                  return "0px" !== a
                    ? {
                        width: `calc(100% + ${ja(a)})`,
                        marginLeft: `-${ja(a)}`,
                        [`& > .${Ea.item}`]: { paddingLeft: ja(a) },
                      }
                    : null != (o = n) && o.includes(r)
                    ? {}
                    : {
                        width: "100%",
                        marginLeft: 0,
                        [`& > .${Ea.item}`]: { paddingLeft: 0 },
                      };
                }));
            }
            return o;
          },
          function ({ theme: e, ownerState: t }) {
            let n;
            return e.breakpoints.keys.reduce((r, o) => {
              let a = {};
              if ((t[o] && (n = t[o]), !n)) return r;
              if (!0 === n) a = { flexBasis: 0, flexGrow: 1, maxWidth: "100%" };
              else if ("auto" === n)
                a = {
                  flexBasis: "auto",
                  flexGrow: 0,
                  flexShrink: 0,
                  maxWidth: "none",
                  width: "auto",
                };
              else {
                const i = (0, Pa.P$)({
                    values: t.columns,
                    breakpoints: e.breakpoints.values,
                  }),
                  s = "object" == typeof i ? i[o] : i;
                if (null == s) return r;
                const l = Math.round((n / s) * 1e8) / 1e6 + "%";
                let c = {};
                if (t.container && t.item && 0 !== t.columnSpacing) {
                  const n = e.spacing(t.columnSpacing);
                  if ("0px" !== n) {
                    const e = `calc(${l} + ${ja(n)})`;
                    c = { flexBasis: e, maxWidth: e };
                  }
                }
                a = (0, d.Z)({ flexBasis: l, flexGrow: 0, maxWidth: l }, c);
              }
              return (
                0 === e.breakpoints.values[o]
                  ? Object.assign(r, a)
                  : (r[e.breakpoints.up(o)] = a),
                r
              );
            }, {});
          }
        ),
        Aa = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiGrid" }),
            { breakpoints: a } = jr(),
            i = (0, Qt.Z)(o),
            {
              className: s,
              columns: l,
              columnSpacing: c,
              component: u = "div",
              container: p = !1,
              direction: m = "row",
              item: h = !1,
              rowSpacing: f,
              spacing: g = 0,
              wrap: v = "wrap",
              zeroMinWidth: b = !1,
            } = i,
            _ = (0, jt.Z)(i, Da),
            y = f || g,
            x = c || g,
            C = t.useContext(Oa),
            S = p ? l || 12 : C,
            k = {},
            w = (0, d.Z)({}, _);
          a.keys.forEach((e) => {
            null != _[e] && ((k[e] = _[e]), delete w[e]);
          });
          const P = (0, d.Z)(
              {},
              i,
              {
                columns: S,
                container: p,
                direction: m,
                item: h,
                rowSpacing: y,
                columnSpacing: x,
                wrap: v,
                zeroMinWidth: b,
                spacing: g,
              },
              k,
              { breakpoints: a.keys }
            ),
            O = ((e) => {
              const {
                classes: t,
                container: n,
                direction: r,
                item: o,
                spacing: a,
                wrap: i,
                zeroMinWidth: s,
                breakpoints: l,
              } = e;
              let c = [];
              n &&
                (c = (function (e, t) {
                  if (!e || e <= 0) return [];
                  if (
                    ("string" == typeof e && !Number.isNaN(Number(e))) ||
                    "number" == typeof e
                  )
                    return [`spacing-xs-${String(e)}`];
                  const n = [];
                  return (
                    t.forEach((t) => {
                      const r = e[t];
                      if (Number(r) > 0) {
                        const e = `spacing-${t}-${String(r)}`;
                        n.push(e);
                      }
                    }),
                    n
                  );
                })(a, l));
              const u = [];
              l.forEach((t) => {
                const n = e[t];
                n && u.push(`grid-${t}-${String(n)}`);
              });
              const d = {
                root: [
                  "root",
                  n && "container",
                  o && "item",
                  s && "zeroMinWidth",
                  ...c,
                  "row" !== r && `direction-xs-${String(r)}`,
                  "wrap" !== i && `wrap-xs-${String(i)}`,
                  ...u,
                ],
              };
              return (0, Nt.Z)(d, Ia, t);
            })(P);
          return (0,
          e.jsx)(Oa.Provider, { value: S, children: (0, e.jsx)(Na, (0, d.Z)({ ownerState: P, className: (0, Rt.Z)(O.root, s), as: u, ref: r }, w)) });
        });
      var La = Aa;
      function za(e) {
        return (0, Zt.ZP)("MuiTypography", e);
      }
      (0, Bt.Z)("MuiTypography", [
        "root",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "subtitle1",
        "subtitle2",
        "body1",
        "body2",
        "inherit",
        "button",
        "caption",
        "overline",
        "alignLeft",
        "alignRight",
        "alignCenter",
        "alignJustify",
        "noWrap",
        "gutterBottom",
        "paragraph",
      ]);
      const Ba = [
          "align",
          "className",
          "component",
          "gutterBottom",
          "noWrap",
          "paragraph",
          "variant",
          "variantMapping",
        ],
        Za = (0, Lt.ZP)("span", {
          name: "MuiTypography",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.variant && t[n.variant],
              "inherit" !== n.align && t[`align${(0, Fn.Z)(n.align)}`],
              n.noWrap && t.noWrap,
              n.gutterBottom && t.gutterBottom,
              n.paragraph && t.paragraph,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { margin: 0 },
            "inherit" === t.variant && { font: "inherit" },
            "inherit" !== t.variant && e.typography[t.variant],
            "inherit" !== t.align && { textAlign: t.align },
            t.noWrap && {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            t.gutterBottom && { marginBottom: "0.35em" },
            t.paragraph && { marginBottom: 16 }
          )
        ),
        Fa = {
          h1: "h1",
          h2: "h2",
          h3: "h3",
          h4: "h4",
          h5: "h5",
          h6: "h6",
          subtitle1: "h6",
          subtitle2: "h6",
          body1: "p",
          body2: "p",
          inherit: "p",
        },
        Ha = {
          primary: "primary.main",
          textPrimary: "text.primary",
          secondary: "secondary.main",
          textSecondary: "text.secondary",
          error: "error.main",
        },
        Va = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiTypography" }),
            o = ((e) => Ha[e] || e)(r.color),
            a = (0, Qt.Z)((0, d.Z)({}, r, { color: o })),
            {
              align: i = "inherit",
              className: s,
              component: l,
              gutterBottom: c = !1,
              noWrap: u = !1,
              paragraph: p = !1,
              variant: m = "body1",
              variantMapping: h = Fa,
            } = a,
            f = (0, jt.Z)(a, Ba),
            g = (0, d.Z)({}, a, {
              align: i,
              color: o,
              className: s,
              component: l,
              gutterBottom: c,
              noWrap: u,
              paragraph: p,
              variant: m,
              variantMapping: h,
            }),
            v = l || (p ? "p" : h[m] || Fa[m]) || "span",
            b = ((e) => {
              const {
                  align: t,
                  gutterBottom: n,
                  noWrap: r,
                  paragraph: o,
                  variant: a,
                  classes: i,
                } = e,
                s = {
                  root: [
                    "root",
                    a,
                    "inherit" !== e.align && `align${(0, Fn.Z)(t)}`,
                    n && "gutterBottom",
                    r && "noWrap",
                    o && "paragraph",
                  ],
                };
              return (0, Nt.Z)(s, za, i);
            })(g);
          return (0,
          e.jsx)(Za, (0, d.Z)({ as: v, ref: n, ownerState: g, className: (0, Rt.Z)(b.root, s) }, f));
        });
      var Wa = Va;
      function $a(e) {
        return (0, Zt.ZP)("MuiTableContainer", e);
      }
      (0, Bt.Z)("MuiTableContainer", ["root"]);
      const Ua = ["className", "component"],
        Ka = (0, Lt.ZP)("div", {
          name: "MuiTableContainer",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ width: "100%", overflowX: "auto" });
      var Ga = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiTableContainer" }),
            { className: o, component: a = "div" } = r,
            i = (0, jt.Z)(r, Ua),
            s = (0, d.Z)({}, r, { component: a }),
            l = ((e) => {
              const { classes: t } = e;
              return (0, Nt.Z)({ root: ["root"] }, $a, t);
            })(s);
          return (0,
          e.jsx)(Ka, (0, d.Z)({ ref: n, as: a, className: (0, Rt.Z)(l.root, o), ownerState: s }, i));
        }),
        qa = t.createContext();
      function Ya(e) {
        return (0, Zt.ZP)("MuiTable", e);
      }
      (0, Bt.Z)("MuiTable", ["root", "stickyHeader"]);
      const Ja = ["className", "component", "padding", "size", "stickyHeader"],
        Qa = (0, Lt.ZP)("table", {
          name: "MuiTable",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.stickyHeader && t.stickyHeader];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              display: "table",
              width: "100%",
              borderCollapse: "collapse",
              borderSpacing: 0,
              "& caption": (0, d.Z)({}, e.typography.body2, {
                padding: e.spacing(2),
                color: (e.vars || e).palette.text.secondary,
                textAlign: "left",
                captionSide: "bottom",
              }),
            },
            t.stickyHeader && { borderCollapse: "separate" }
          )
        ),
        Xa = "table";
      var ei = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiTable" }),
            {
              className: a,
              component: i = Xa,
              padding: s = "normal",
              size: l = "medium",
              stickyHeader: c = !1,
            } = o,
            u = (0, jt.Z)(o, Ja),
            p = (0, d.Z)({}, o, {
              component: i,
              padding: s,
              size: l,
              stickyHeader: c,
            }),
            m = ((e) => {
              const { classes: t, stickyHeader: n } = e,
                r = { root: ["root", n && "stickyHeader"] };
              return (0, Nt.Z)(r, Ya, t);
            })(p),
            h = t.useMemo(
              () => ({ padding: s, size: l, stickyHeader: c }),
              [s, l, c]
            );
          return (0,
          e.jsx)(qa.Provider, { value: h, children: (0, e.jsx)(Qa, (0, d.Z)({ as: i, role: i === Xa ? null : "table", ref: r, className: (0, Rt.Z)(m.root, a), ownerState: p }, u)) });
        }),
        ti = t.createContext();
      function ni(e) {
        return (0, Zt.ZP)("MuiTableHead", e);
      }
      (0, Bt.Z)("MuiTableHead", ["root"]);
      const ri = ["className", "component"],
        oi = (0, Lt.ZP)("thead", {
          name: "MuiTableHead",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ display: "table-header-group" }),
        ai = { variant: "head" },
        ii = "thead";
      var si = t.forwardRef(function (t, n) {
        const r = (0, zt.Z)({ props: t, name: "MuiTableHead" }),
          { className: o, component: a = ii } = r,
          i = (0, jt.Z)(r, ri),
          s = (0, d.Z)({}, r, { component: a }),
          l = ((e) => {
            const { classes: t } = e;
            return (0, Nt.Z)({ root: ["root"] }, ni, t);
          })(s);
        return (0,
        e.jsx)(ti.Provider, { value: ai, children: (0, e.jsx)(oi, (0, d.Z)({ as: a, className: (0, Rt.Z)(l.root, o), ref: n, role: a === ii ? null : "rowgroup", ownerState: s }, i)) });
      });
      function li(e) {
        return (0, Zt.ZP)("MuiTableRow", e);
      }
      var ci = (0, Bt.Z)("MuiTableRow", [
        "root",
        "selected",
        "hover",
        "head",
        "footer",
      ]);
      const ui = ["className", "component", "hover", "selected"],
        di = (0, Lt.ZP)("tr", {
          name: "MuiTableRow",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.head && t.head, n.footer && t.footer];
          },
        })(({ theme: e }) => ({
          color: "inherit",
          display: "table-row",
          verticalAlign: "middle",
          outline: 0,
          [`&.${ci.hover}:hover`]: {
            backgroundColor: (e.vars || e).palette.action.hover,
          },
          [`&.${ci.selected}`]: {
            backgroundColor: e.vars
              ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
              : (0, At.Fq)(
                  e.palette.primary.main,
                  e.palette.action.selectedOpacity
                ),
            "&:hover": {
              backgroundColor: e.vars
                ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                : (0, At.Fq)(
                    e.palette.primary.main,
                    e.palette.action.selectedOpacity +
                      e.palette.action.hoverOpacity
                  ),
            },
          },
        })),
        pi = "tr",
        mi = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiTableRow" }),
            {
              className: a,
              component: i = pi,
              hover: s = !1,
              selected: l = !1,
            } = o,
            c = (0, jt.Z)(o, ui),
            u = t.useContext(ti),
            p = (0, d.Z)({}, o, {
              component: i,
              hover: s,
              selected: l,
              head: u && "head" === u.variant,
              footer: u && "footer" === u.variant,
            }),
            m = ((e) => {
              const {
                  classes: t,
                  selected: n,
                  hover: r,
                  head: o,
                  footer: a,
                } = e,
                i = {
                  root: [
                    "root",
                    n && "selected",
                    r && "hover",
                    o && "head",
                    a && "footer",
                  ],
                };
              return (0, Nt.Z)(i, li, t);
            })(p);
          return (0,
          e.jsx)(di, (0, d.Z)({ as: i, ref: r, className: (0, Rt.Z)(m.root, a), role: i === pi ? null : "row", ownerState: p }, c));
        });
      var hi = mi;
      function fi(e) {
        return (0, Zt.ZP)("MuiTableCell", e);
      }
      var gi = (0, Bt.Z)("MuiTableCell", [
        "root",
        "head",
        "body",
        "footer",
        "sizeSmall",
        "sizeMedium",
        "paddingCheckbox",
        "paddingNone",
        "alignLeft",
        "alignCenter",
        "alignRight",
        "alignJustify",
        "stickyHeader",
      ]);
      const vi = [
          "align",
          "className",
          "component",
          "padding",
          "scope",
          "size",
          "sortDirection",
          "variant",
        ],
        bi = (0, Lt.ZP)("td", {
          name: "MuiTableCell",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              t[`size${(0, Fn.Z)(n.size)}`],
              "normal" !== n.padding && t[`padding${(0, Fn.Z)(n.padding)}`],
              "inherit" !== n.align && t[`align${(0, Fn.Z)(n.align)}`],
              n.stickyHeader && t.stickyHeader,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {},
            e.typography.body2,
            {
              display: "table-cell",
              verticalAlign: "inherit",
              borderBottom: e.vars
                ? `1px solid ${e.vars.palette.TableCell.border}`
                : `1px solid\n    ${
                    "light" === e.palette.mode
                      ? (0, At.$n)((0, At.Fq)(e.palette.divider, 1), 0.88)
                      : (0, At._j)((0, At.Fq)(e.palette.divider, 1), 0.68)
                  }`,
              textAlign: "left",
              padding: 16,
            },
            "head" === t.variant && {
              color: (e.vars || e).palette.text.primary,
              lineHeight: e.typography.pxToRem(24),
              fontWeight: e.typography.fontWeightMedium,
            },
            "body" === t.variant && {
              color: (e.vars || e).palette.text.primary,
            },
            "footer" === t.variant && {
              color: (e.vars || e).palette.text.secondary,
              lineHeight: e.typography.pxToRem(21),
              fontSize: e.typography.pxToRem(12),
            },
            "small" === t.size && {
              padding: "6px 16px",
              [`&.${gi.paddingCheckbox}`]: {
                width: 24,
                padding: "0 12px 0 16px",
                "& > *": { padding: 0 },
              },
            },
            "checkbox" === t.padding && { width: 48, padding: "0 0 0 4px" },
            "none" === t.padding && { padding: 0 },
            "left" === t.align && { textAlign: "left" },
            "center" === t.align && { textAlign: "center" },
            "right" === t.align && {
              textAlign: "right",
              flexDirection: "row-reverse",
            },
            "justify" === t.align && { textAlign: "justify" },
            t.stickyHeader && {
              position: "sticky",
              top: 0,
              zIndex: 2,
              backgroundColor: (e.vars || e).palette.background.default,
            }
          )
        ),
        _i = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiTableCell" }),
            {
              align: a = "inherit",
              className: i,
              component: s,
              padding: l,
              scope: c,
              size: u,
              sortDirection: p,
              variant: m,
            } = o,
            h = (0, jt.Z)(o, vi),
            f = t.useContext(qa),
            g = t.useContext(ti),
            v = g && "head" === g.variant;
          let b;
          b = s || (v ? "th" : "td");
          let _ = c;
          "td" === b ? (_ = void 0) : !_ && v && (_ = "col");
          const y = m || (g && g.variant),
            x = (0, d.Z)({}, o, {
              align: a,
              component: b,
              padding: l || (f && f.padding ? f.padding : "normal"),
              size: u || (f && f.size ? f.size : "medium"),
              sortDirection: p,
              stickyHeader: "head" === y && f && f.stickyHeader,
              variant: y,
            }),
            C = ((e) => {
              const {
                  classes: t,
                  variant: n,
                  align: r,
                  padding: o,
                  size: a,
                  stickyHeader: i,
                } = e,
                s = {
                  root: [
                    "root",
                    n,
                    i && "stickyHeader",
                    "inherit" !== r && `align${(0, Fn.Z)(r)}`,
                    "normal" !== o && `padding${(0, Fn.Z)(o)}`,
                    `size${(0, Fn.Z)(a)}`,
                  ],
                };
              return (0, Nt.Z)(s, fi, t);
            })(x);
          let S = null;
          return (
            p && (S = "asc" === p ? "ascending" : "descending"),
            (0, e.jsx)(
              bi,
              (0, d.Z)(
                {
                  as: b,
                  ref: r,
                  className: (0, Rt.Z)(C.root, i),
                  "aria-sort": S,
                  scope: _,
                  ownerState: x,
                },
                h
              )
            )
          );
        });
      var yi = _i;
      function xi(e) {
        return (0, Zt.ZP)("MuiTableBody", e);
      }
      (0, Bt.Z)("MuiTableBody", ["root"]);
      const Ci = ["className", "component"],
        Si = (0, Lt.ZP)("tbody", {
          name: "MuiTableBody",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ display: "table-row-group" }),
        ki = { variant: "body" },
        wi = "tbody";
      var Pi = t.forwardRef(function (t, n) {
        const r = (0, zt.Z)({ props: t, name: "MuiTableBody" }),
          { className: o, component: a = wi } = r,
          i = (0, jt.Z)(r, Ci),
          s = (0, d.Z)({}, r, { component: a }),
          l = ((e) => {
            const { classes: t } = e;
            return (0, Nt.Z)({ root: ["root"] }, xi, t);
          })(s);
        return (0,
        e.jsx)(ti.Provider, { value: ki, children: (0, e.jsx)(Si, (0, d.Z)({ className: (0, Rt.Z)(l.root, o), as: a, ref: n, role: a === wi ? null : "rowgroup", ownerState: s }, i)) });
      });
      const Oi = [
        "addEndListener",
        "appear",
        "children",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent",
      ];
      function Ii(e) {
        return `scale(${e}, ${e ** 2})`;
      }
      const Ti = {
          entering: { opacity: 1, transform: Ii(1) },
          entered: { opacity: 1, transform: "none" },
        },
        Mi =
          "undefined" != typeof navigator &&
          /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) &&
          /(os |version\/)15(.|_)4/i.test(navigator.userAgent),
        Ei = t.forwardRef(function (n, r) {
          const {
              addEndListener: o,
              appear: a = !0,
              children: i,
              easing: s,
              in: l,
              onEnter: c,
              onEntered: u,
              onEntering: p,
              onExit: m,
              onExited: h,
              onExiting: f,
              style: g,
              timeout: v = "auto",
              TransitionComponent: b = Er,
            } = n,
            _ = (0, jt.Z)(n, Oi),
            y = (0, xn.Z)(),
            x = t.useRef(),
            C = jr(),
            S = t.useRef(null),
            k = (0, cn.Z)(S, i.ref, r),
            w = (e) => (t) => {
              if (e) {
                const n = S.current;
                void 0 === t ? e(n) : e(n, t);
              }
            },
            P = w(p),
            O = w((e, t) => {
              Rr(e);
              const {
                duration: n,
                delay: r,
                easing: o,
              } = Nr({ style: g, timeout: v, easing: s }, { mode: "enter" });
              let a;
              "auto" === v
                ? ((a = C.transitions.getAutoHeightDuration(e.clientHeight)),
                  (x.current = a))
                : (a = n),
                (e.style.transition = [
                  C.transitions.create("opacity", { duration: a, delay: r }),
                  C.transitions.create("transform", {
                    duration: Mi ? a : 0.666 * a,
                    delay: r,
                    easing: o,
                  }),
                ].join(",")),
                c && c(e, t);
            }),
            I = w(u),
            T = w(f),
            M = w((e) => {
              const {
                duration: t,
                delay: n,
                easing: r,
              } = Nr({ style: g, timeout: v, easing: s }, { mode: "exit" });
              let o;
              "auto" === v
                ? ((o = C.transitions.getAutoHeightDuration(e.clientHeight)),
                  (x.current = o))
                : (o = t),
                (e.style.transition = [
                  C.transitions.create("opacity", { duration: o, delay: n }),
                  C.transitions.create("transform", {
                    duration: Mi ? o : 0.666 * o,
                    delay: Mi ? n : n || 0.333 * o,
                    easing: r,
                  }),
                ].join(",")),
                (e.style.opacity = 0),
                (e.style.transform = Ii(0.75)),
                m && m(e);
            }),
            E = w(h);
          return (0, e.jsx)(
            b,
            (0, d.Z)(
              {
                appear: a,
                in: l,
                nodeRef: S,
                onEnter: O,
                onEntered: I,
                onEntering: P,
                onExit: M,
                onExited: E,
                onExiting: T,
                addEndListener: (e) => {
                  "auto" === v && y.start(x.current || 0, e),
                    o && o(S.current, e);
                },
                timeout: "auto" === v ? null : v,
              },
              _,
              {
                children: (e, n) =>
                  t.cloneElement(
                    i,
                    (0, d.Z)(
                      {
                        style: (0, d.Z)(
                          {
                            opacity: 0,
                            transform: Ii(0.75),
                            visibility: "exited" !== e || l ? void 0 : "hidden",
                          },
                          Ti[e],
                          g,
                          i.props.style
                        ),
                        ref: k,
                      },
                      n
                    )
                  ),
              }
            )
          );
        });
      Ei.muiSupportAuto = !0;
      var Di = Ei;
      function ji(e) {
        if (null == e) return window;
        if ("[object Window]" !== e.toString()) {
          var t = e.ownerDocument;
          return (t && t.defaultView) || window;
        }
        return e;
      }
      function Ri(e) {
        return e instanceof ji(e).Element || e instanceof Element;
      }
      function Ni(e) {
        return e instanceof ji(e).HTMLElement || e instanceof HTMLElement;
      }
      function Ai(e) {
        return (
          "undefined" != typeof ShadowRoot &&
          (e instanceof ji(e).ShadowRoot || e instanceof ShadowRoot)
        );
      }
      var Li = Math.max,
        zi = Math.min,
        Bi = Math.round;
      function Zi() {
        var e = navigator.userAgentData;
        return null != e && e.brands && Array.isArray(e.brands)
          ? e.brands
              .map(function (e) {
                return e.brand + "/" + e.version;
              })
              .join(" ")
          : navigator.userAgent;
      }
      function Fi() {
        return !/^((?!chrome|android).)*safari/i.test(Zi());
      }
      function Hi(e, t, n) {
        void 0 === t && (t = !1), void 0 === n && (n = !1);
        var r = e.getBoundingClientRect(),
          o = 1,
          a = 1;
        t &&
          Ni(e) &&
          ((o = (e.offsetWidth > 0 && Bi(r.width) / e.offsetWidth) || 1),
          (a = (e.offsetHeight > 0 && Bi(r.height) / e.offsetHeight) || 1));
        var i = (Ri(e) ? ji(e) : window).visualViewport,
          s = !Fi() && n,
          l = (r.left + (s && i ? i.offsetLeft : 0)) / o,
          c = (r.top + (s && i ? i.offsetTop : 0)) / a,
          u = r.width / o,
          d = r.height / a;
        return {
          width: u,
          height: d,
          top: c,
          right: l + u,
          bottom: c + d,
          left: l,
          x: l,
          y: c,
        };
      }
      function Vi(e) {
        var t = ji(e);
        return { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
      }
      function Wi(e) {
        return e ? (e.nodeName || "").toLowerCase() : null;
      }
      function $i(e) {
        return ((Ri(e) ? e.ownerDocument : e.document) || window.document)
          .documentElement;
      }
      function Ui(e) {
        return Hi($i(e)).left + Vi(e).scrollLeft;
      }
      function Ki(e) {
        return ji(e).getComputedStyle(e);
      }
      function Gi(e) {
        var t = Ki(e),
          n = t.overflow,
          r = t.overflowX,
          o = t.overflowY;
        return /auto|scroll|overlay|hidden/.test(n + o + r);
      }
      function qi(e, t, n) {
        void 0 === n && (n = !1);
        var r,
          o,
          a = Ni(t),
          i =
            Ni(t) &&
            (function (e) {
              var t = e.getBoundingClientRect(),
                n = Bi(t.width) / e.offsetWidth || 1,
                r = Bi(t.height) / e.offsetHeight || 1;
              return 1 !== n || 1 !== r;
            })(t),
          s = $i(t),
          l = Hi(e, i, n),
          c = { scrollLeft: 0, scrollTop: 0 },
          u = { x: 0, y: 0 };
        return (
          (a || (!a && !n)) &&
            (("body" !== Wi(t) || Gi(s)) &&
              (c =
                (r = t) !== ji(r) && Ni(r)
                  ? { scrollLeft: (o = r).scrollLeft, scrollTop: o.scrollTop }
                  : Vi(r)),
            Ni(t)
              ? (((u = Hi(t, !0)).x += t.clientLeft), (u.y += t.clientTop))
              : s && (u.x = Ui(s))),
          {
            x: l.left + c.scrollLeft - u.x,
            y: l.top + c.scrollTop - u.y,
            width: l.width,
            height: l.height,
          }
        );
      }
      function Yi(e) {
        var t = Hi(e),
          n = e.offsetWidth,
          r = e.offsetHeight;
        return (
          Math.abs(t.width - n) <= 1 && (n = t.width),
          Math.abs(t.height - r) <= 1 && (r = t.height),
          { x: e.offsetLeft, y: e.offsetTop, width: n, height: r }
        );
      }
      function Ji(e) {
        return "html" === Wi(e)
          ? e
          : e.assignedSlot || e.parentNode || (Ai(e) ? e.host : null) || $i(e);
      }
      function Qi(e) {
        return ["html", "body", "#document"].indexOf(Wi(e)) >= 0
          ? e.ownerDocument.body
          : Ni(e) && Gi(e)
          ? e
          : Qi(Ji(e));
      }
      function Xi(e, t) {
        var n;
        void 0 === t && (t = []);
        var r = Qi(e),
          o = r === (null == (n = e.ownerDocument) ? void 0 : n.body),
          a = ji(r),
          i = o ? [a].concat(a.visualViewport || [], Gi(r) ? r : []) : r,
          s = t.concat(i);
        return o ? s : s.concat(Xi(Ji(i)));
      }
      function es(e) {
        return ["table", "td", "th"].indexOf(Wi(e)) >= 0;
      }
      function ts(e) {
        return Ni(e) && "fixed" !== Ki(e).position ? e.offsetParent : null;
      }
      function ns(e) {
        for (
          var t = ji(e), n = ts(e);
          n && es(n) && "static" === Ki(n).position;

        )
          n = ts(n);
        return n &&
          ("html" === Wi(n) ||
            ("body" === Wi(n) && "static" === Ki(n).position))
          ? t
          : n ||
              (function (e) {
                var t = /firefox/i.test(Zi());
                if (
                  /Trident/i.test(Zi()) &&
                  Ni(e) &&
                  "fixed" === Ki(e).position
                )
                  return null;
                var n = Ji(e);
                for (
                  Ai(n) && (n = n.host);
                  Ni(n) && ["html", "body"].indexOf(Wi(n)) < 0;

                ) {
                  var r = Ki(n);
                  if (
                    "none" !== r.transform ||
                    "none" !== r.perspective ||
                    "paint" === r.contain ||
                    -1 !== ["transform", "perspective"].indexOf(r.willChange) ||
                    (t && "filter" === r.willChange) ||
                    (t && r.filter && "none" !== r.filter)
                  )
                    return n;
                  n = n.parentNode;
                }
                return null;
              })(e) ||
              t;
      }
      var rs = "top",
        os = "bottom",
        as = "right",
        is = "left",
        ss = "auto",
        ls = [rs, os, as, is],
        cs = "start",
        us = "end",
        ds = "clippingParents",
        ps = "viewport",
        ms = "popper",
        hs = "reference",
        fs = ls.reduce(function (e, t) {
          return e.concat([t + "-" + cs, t + "-" + us]);
        }, []),
        gs = [].concat(ls, [ss]).reduce(function (e, t) {
          return e.concat([t, t + "-" + cs, t + "-" + us]);
        }, []),
        vs = [
          "beforeRead",
          "read",
          "afterRead",
          "beforeMain",
          "main",
          "afterMain",
          "beforeWrite",
          "write",
          "afterWrite",
        ];
      function bs(e) {
        var t = new Map(),
          n = new Set(),
          r = [];
        function o(e) {
          n.add(e.name),
            []
              .concat(e.requires || [], e.requiresIfExists || [])
              .forEach(function (e) {
                if (!n.has(e)) {
                  var r = t.get(e);
                  r && o(r);
                }
              }),
            r.push(e);
        }
        return (
          e.forEach(function (e) {
            t.set(e.name, e);
          }),
          e.forEach(function (e) {
            n.has(e.name) || o(e);
          }),
          r
        );
      }
      var _s = { placement: "bottom", modifiers: [], strategy: "absolute" };
      function ys() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        return !t.some(function (e) {
          return !(e && "function" == typeof e.getBoundingClientRect);
        });
      }
      function xs(e) {
        void 0 === e && (e = {});
        var t = e,
          n = t.defaultModifiers,
          r = void 0 === n ? [] : n,
          o = t.defaultOptions,
          a = void 0 === o ? _s : o;
        return function (e, t, n) {
          void 0 === n && (n = a);
          var o,
            i,
            s = {
              placement: "bottom",
              orderedModifiers: [],
              options: Object.assign({}, _s, a),
              modifiersData: {},
              elements: { reference: e, popper: t },
              attributes: {},
              styles: {},
            },
            l = [],
            c = !1,
            u = {
              state: s,
              setOptions: function (n) {
                var o = "function" == typeof n ? n(s.options) : n;
                d(),
                  (s.options = Object.assign({}, a, s.options, o)),
                  (s.scrollParents = {
                    reference: Ri(e)
                      ? Xi(e)
                      : e.contextElement
                      ? Xi(e.contextElement)
                      : [],
                    popper: Xi(t),
                  });
                var i,
                  c,
                  p = (function (e) {
                    var t = bs(e);
                    return vs.reduce(function (e, n) {
                      return e.concat(
                        t.filter(function (e) {
                          return e.phase === n;
                        })
                      );
                    }, []);
                  })(
                    ((i = [].concat(r, s.options.modifiers)),
                    (c = i.reduce(function (e, t) {
                      var n = e[t.name];
                      return (
                        (e[t.name] = n
                          ? Object.assign({}, n, t, {
                              options: Object.assign({}, n.options, t.options),
                              data: Object.assign({}, n.data, t.data),
                            })
                          : t),
                        e
                      );
                    }, {})),
                    Object.keys(c).map(function (e) {
                      return c[e];
                    }))
                  );
                return (
                  (s.orderedModifiers = p.filter(function (e) {
                    return e.enabled;
                  })),
                  s.orderedModifiers.forEach(function (e) {
                    var t = e.name,
                      n = e.options,
                      r = void 0 === n ? {} : n,
                      o = e.effect;
                    if ("function" == typeof o) {
                      var a = o({ state: s, name: t, instance: u, options: r });
                      l.push(a || function () {});
                    }
                  }),
                  u.update()
                );
              },
              forceUpdate: function () {
                if (!c) {
                  var e = s.elements,
                    t = e.reference,
                    n = e.popper;
                  if (ys(t, n)) {
                    (s.rects = {
                      reference: qi(t, ns(n), "fixed" === s.options.strategy),
                      popper: Yi(n),
                    }),
                      (s.reset = !1),
                      (s.placement = s.options.placement),
                      s.orderedModifiers.forEach(function (e) {
                        return (s.modifiersData[e.name] = Object.assign(
                          {},
                          e.data
                        ));
                      });
                    for (var r = 0; r < s.orderedModifiers.length; r++)
                      if (!0 !== s.reset) {
                        var o = s.orderedModifiers[r],
                          a = o.fn,
                          i = o.options,
                          l = void 0 === i ? {} : i,
                          d = o.name;
                        "function" == typeof a &&
                          (s =
                            a({ state: s, options: l, name: d, instance: u }) ||
                            s);
                      } else (s.reset = !1), (r = -1);
                  }
                }
              },
              update:
                ((o = function () {
                  return new Promise(function (e) {
                    u.forceUpdate(), e(s);
                  });
                }),
                function () {
                  return (
                    i ||
                      (i = new Promise(function (e) {
                        Promise.resolve().then(function () {
                          (i = void 0), e(o());
                        });
                      })),
                    i
                  );
                }),
              destroy: function () {
                d(), (c = !0);
              },
            };
          if (!ys(e, t)) return u;
          function d() {
            l.forEach(function (e) {
              return e();
            }),
              (l = []);
          }
          return (
            u.setOptions(n).then(function (e) {
              !c && n.onFirstUpdate && n.onFirstUpdate(e);
            }),
            u
          );
        };
      }
      var Cs = { passive: !0 },
        Ss = {
          name: "eventListeners",
          enabled: !0,
          phase: "write",
          fn: function () {},
          effect: function (e) {
            var t = e.state,
              n = e.instance,
              r = e.options,
              o = r.scroll,
              a = void 0 === o || o,
              i = r.resize,
              s = void 0 === i || i,
              l = ji(t.elements.popper),
              c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
            return (
              a &&
                c.forEach(function (e) {
                  e.addEventListener("scroll", n.update, Cs);
                }),
              s && l.addEventListener("resize", n.update, Cs),
              function () {
                a &&
                  c.forEach(function (e) {
                    e.removeEventListener("scroll", n.update, Cs);
                  }),
                  s && l.removeEventListener("resize", n.update, Cs);
              }
            );
          },
          data: {},
        };
      function ks(e) {
        return e.split("-")[0];
      }
      function ws(e) {
        return e.split("-")[1];
      }
      function Ps(e) {
        return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
      }
      function Os(e) {
        var t,
          n = e.reference,
          r = e.element,
          o = e.placement,
          a = o ? ks(o) : null,
          i = o ? ws(o) : null,
          s = n.x + n.width / 2 - r.width / 2,
          l = n.y + n.height / 2 - r.height / 2;
        switch (a) {
          case rs:
            t = { x: s, y: n.y - r.height };
            break;
          case os:
            t = { x: s, y: n.y + n.height };
            break;
          case as:
            t = { x: n.x + n.width, y: l };
            break;
          case is:
            t = { x: n.x - r.width, y: l };
            break;
          default:
            t = { x: n.x, y: n.y };
        }
        var c = a ? Ps(a) : null;
        if (null != c) {
          var u = "y" === c ? "height" : "width";
          switch (i) {
            case cs:
              t[c] = t[c] - (n[u] / 2 - r[u] / 2);
              break;
            case us:
              t[c] = t[c] + (n[u] / 2 - r[u] / 2);
          }
        }
        return t;
      }
      var Is = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
      function Ts(e) {
        var t,
          n = e.popper,
          r = e.popperRect,
          o = e.placement,
          a = e.variation,
          i = e.offsets,
          s = e.position,
          l = e.gpuAcceleration,
          c = e.adaptive,
          u = e.roundOffsets,
          d = e.isFixed,
          p = i.x,
          m = void 0 === p ? 0 : p,
          h = i.y,
          f = void 0 === h ? 0 : h,
          g = "function" == typeof u ? u({ x: m, y: f }) : { x: m, y: f };
        (m = g.x), (f = g.y);
        var v = i.hasOwnProperty("x"),
          b = i.hasOwnProperty("y"),
          _ = is,
          y = rs,
          x = window;
        if (c) {
          var C = ns(n),
            S = "clientHeight",
            k = "clientWidth";
          C === ji(n) &&
            "static" !== Ki((C = $i(n))).position &&
            "absolute" === s &&
            ((S = "scrollHeight"), (k = "scrollWidth")),
            (o === rs || ((o === is || o === as) && a === us)) &&
              ((y = os),
              (f -=
                (d && C === x && x.visualViewport
                  ? x.visualViewport.height
                  : C[S]) - r.height),
              (f *= l ? 1 : -1)),
            (o !== is && ((o !== rs && o !== os) || a !== us)) ||
              ((_ = as),
              (m -=
                (d && C === x && x.visualViewport
                  ? x.visualViewport.width
                  : C[k]) - r.width),
              (m *= l ? 1 : -1));
        }
        var w,
          P = Object.assign({ position: s }, c && Is),
          O =
            !0 === u
              ? (function (e, t) {
                  var n = e.x,
                    r = e.y,
                    o = t.devicePixelRatio || 1;
                  return { x: Bi(n * o) / o || 0, y: Bi(r * o) / o || 0 };
                })({ x: m, y: f }, ji(n))
              : { x: m, y: f };
        return (
          (m = O.x),
          (f = O.y),
          l
            ? Object.assign(
                {},
                P,
                (((w = {})[y] = b ? "0" : ""),
                (w[_] = v ? "0" : ""),
                (w.transform =
                  (x.devicePixelRatio || 1) <= 1
                    ? "translate(" + m + "px, " + f + "px)"
                    : "translate3d(" + m + "px, " + f + "px, 0)"),
                w)
              )
            : Object.assign(
                {},
                P,
                (((t = {})[y] = b ? f + "px" : ""),
                (t[_] = v ? m + "px" : ""),
                (t.transform = ""),
                t)
              )
        );
      }
      var Ms = {
          name: "applyStyles",
          enabled: !0,
          phase: "write",
          fn: function (e) {
            var t = e.state;
            Object.keys(t.elements).forEach(function (e) {
              var n = t.styles[e] || {},
                r = t.attributes[e] || {},
                o = t.elements[e];
              Ni(o) &&
                Wi(o) &&
                (Object.assign(o.style, n),
                Object.keys(r).forEach(function (e) {
                  var t = r[e];
                  !1 === t
                    ? o.removeAttribute(e)
                    : o.setAttribute(e, !0 === t ? "" : t);
                }));
            });
          },
          effect: function (e) {
            var t = e.state,
              n = {
                popper: {
                  position: t.options.strategy,
                  left: "0",
                  top: "0",
                  margin: "0",
                },
                arrow: { position: "absolute" },
                reference: {},
              };
            return (
              Object.assign(t.elements.popper.style, n.popper),
              (t.styles = n),
              t.elements.arrow &&
                Object.assign(t.elements.arrow.style, n.arrow),
              function () {
                Object.keys(t.elements).forEach(function (e) {
                  var r = t.elements[e],
                    o = t.attributes[e] || {},
                    a = Object.keys(
                      t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]
                    ).reduce(function (e, t) {
                      return (e[t] = ""), e;
                    }, {});
                  Ni(r) &&
                    Wi(r) &&
                    (Object.assign(r.style, a),
                    Object.keys(o).forEach(function (e) {
                      r.removeAttribute(e);
                    }));
                });
              }
            );
          },
          requires: ["computeStyles"],
        },
        Es = { left: "right", right: "left", bottom: "top", top: "bottom" };
      function Ds(e) {
        return e.replace(/left|right|bottom|top/g, function (e) {
          return Es[e];
        });
      }
      var js = { start: "end", end: "start" };
      function Rs(e) {
        return e.replace(/start|end/g, function (e) {
          return js[e];
        });
      }
      function Ns(e, t) {
        var n = t.getRootNode && t.getRootNode();
        if (e.contains(t)) return !0;
        if (n && Ai(n)) {
          var r = t;
          do {
            if (r && e.isSameNode(r)) return !0;
            r = r.parentNode || r.host;
          } while (r);
        }
        return !1;
      }
      function As(e) {
        return Object.assign({}, e, {
          left: e.x,
          top: e.y,
          right: e.x + e.width,
          bottom: e.y + e.height,
        });
      }
      function Ls(e, t, n) {
        return t === ps
          ? As(
              (function (e, t) {
                var n = ji(e),
                  r = $i(e),
                  o = n.visualViewport,
                  a = r.clientWidth,
                  i = r.clientHeight,
                  s = 0,
                  l = 0;
                if (o) {
                  (a = o.width), (i = o.height);
                  var c = Fi();
                  (c || (!c && "fixed" === t)) &&
                    ((s = o.offsetLeft), (l = o.offsetTop));
                }
                return { width: a, height: i, x: s + Ui(e), y: l };
              })(e, n)
            )
          : Ri(t)
          ? (function (e, t) {
              var n = Hi(e, !1, "fixed" === t);
              return (
                (n.top = n.top + e.clientTop),
                (n.left = n.left + e.clientLeft),
                (n.bottom = n.top + e.clientHeight),
                (n.right = n.left + e.clientWidth),
                (n.width = e.clientWidth),
                (n.height = e.clientHeight),
                (n.x = n.left),
                (n.y = n.top),
                n
              );
            })(t, n)
          : As(
              (function (e) {
                var t,
                  n = $i(e),
                  r = Vi(e),
                  o = null == (t = e.ownerDocument) ? void 0 : t.body,
                  a = Li(
                    n.scrollWidth,
                    n.clientWidth,
                    o ? o.scrollWidth : 0,
                    o ? o.clientWidth : 0
                  ),
                  i = Li(
                    n.scrollHeight,
                    n.clientHeight,
                    o ? o.scrollHeight : 0,
                    o ? o.clientHeight : 0
                  ),
                  s = -r.scrollLeft + Ui(e),
                  l = -r.scrollTop;
                return (
                  "rtl" === Ki(o || n).direction &&
                    (s += Li(n.clientWidth, o ? o.clientWidth : 0) - a),
                  { width: a, height: i, x: s, y: l }
                );
              })($i(e))
            );
      }
      function zs(e) {
        return Object.assign({}, { top: 0, right: 0, bottom: 0, left: 0 }, e);
      }
      function Bs(e, t) {
        return t.reduce(function (t, n) {
          return (t[n] = e), t;
        }, {});
      }
      function Zs(e, t) {
        void 0 === t && (t = {});
        var n = t,
          r = n.placement,
          o = void 0 === r ? e.placement : r,
          a = n.strategy,
          i = void 0 === a ? e.strategy : a,
          s = n.boundary,
          l = void 0 === s ? ds : s,
          c = n.rootBoundary,
          u = void 0 === c ? ps : c,
          d = n.elementContext,
          p = void 0 === d ? ms : d,
          m = n.altBoundary,
          h = void 0 !== m && m,
          f = n.padding,
          g = void 0 === f ? 0 : f,
          v = zs("number" != typeof g ? g : Bs(g, ls)),
          b = p === ms ? hs : ms,
          _ = e.rects.popper,
          y = e.elements[h ? b : p],
          x = (function (e, t, n, r) {
            var o =
                "clippingParents" === t
                  ? (function (e) {
                      var t = Xi(Ji(e)),
                        n =
                          ["absolute", "fixed"].indexOf(Ki(e).position) >= 0 &&
                          Ni(e)
                            ? ns(e)
                            : e;
                      return Ri(n)
                        ? t.filter(function (e) {
                            return Ri(e) && Ns(e, n) && "body" !== Wi(e);
                          })
                        : [];
                    })(e)
                  : [].concat(t),
              a = [].concat(o, [n]),
              i = a[0],
              s = a.reduce(function (t, n) {
                var o = Ls(e, n, r);
                return (
                  (t.top = Li(o.top, t.top)),
                  (t.right = zi(o.right, t.right)),
                  (t.bottom = zi(o.bottom, t.bottom)),
                  (t.left = Li(o.left, t.left)),
                  t
                );
              }, Ls(e, i, r));
            return (
              (s.width = s.right - s.left),
              (s.height = s.bottom - s.top),
              (s.x = s.left),
              (s.y = s.top),
              s
            );
          })(Ri(y) ? y : y.contextElement || $i(e.elements.popper), l, u, i),
          C = Hi(e.elements.reference),
          S = Os({
            reference: C,
            element: _,
            strategy: "absolute",
            placement: o,
          }),
          k = As(Object.assign({}, _, S)),
          w = p === ms ? k : C,
          P = {
            top: x.top - w.top + v.top,
            bottom: w.bottom - x.bottom + v.bottom,
            left: x.left - w.left + v.left,
            right: w.right - x.right + v.right,
          },
          O = e.modifiersData.offset;
        if (p === ms && O) {
          var I = O[o];
          Object.keys(P).forEach(function (e) {
            var t = [as, os].indexOf(e) >= 0 ? 1 : -1,
              n = [rs, os].indexOf(e) >= 0 ? "y" : "x";
            P[e] += I[n] * t;
          });
        }
        return P;
      }
      function Fs(e, t, n) {
        return Li(e, zi(t, n));
      }
      function Hs(e, t, n) {
        return (
          void 0 === n && (n = { x: 0, y: 0 }),
          {
            top: e.top - t.height - n.y,
            right: e.right - t.width + n.x,
            bottom: e.bottom - t.height + n.y,
            left: e.left - t.width - n.x,
          }
        );
      }
      function Vs(e) {
        return [rs, as, os, is].some(function (t) {
          return e[t] >= 0;
        });
      }
      var Ws = xs({
        defaultModifiers: [
          Ss,
          {
            name: "popperOffsets",
            enabled: !0,
            phase: "read",
            fn: function (e) {
              var t = e.state,
                n = e.name;
              t.modifiersData[n] = Os({
                reference: t.rects.reference,
                element: t.rects.popper,
                strategy: "absolute",
                placement: t.placement,
              });
            },
            data: {},
          },
          {
            name: "computeStyles",
            enabled: !0,
            phase: "beforeWrite",
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = n.gpuAcceleration,
                o = void 0 === r || r,
                a = n.adaptive,
                i = void 0 === a || a,
                s = n.roundOffsets,
                l = void 0 === s || s,
                c = {
                  placement: ks(t.placement),
                  variation: ws(t.placement),
                  popper: t.elements.popper,
                  popperRect: t.rects.popper,
                  gpuAcceleration: o,
                  isFixed: "fixed" === t.options.strategy,
                };
              null != t.modifiersData.popperOffsets &&
                (t.styles.popper = Object.assign(
                  {},
                  t.styles.popper,
                  Ts(
                    Object.assign({}, c, {
                      offsets: t.modifiersData.popperOffsets,
                      position: t.options.strategy,
                      adaptive: i,
                      roundOffsets: l,
                    })
                  )
                )),
                null != t.modifiersData.arrow &&
                  (t.styles.arrow = Object.assign(
                    {},
                    t.styles.arrow,
                    Ts(
                      Object.assign({}, c, {
                        offsets: t.modifiersData.arrow,
                        position: "absolute",
                        adaptive: !1,
                        roundOffsets: l,
                      })
                    )
                  )),
                (t.attributes.popper = Object.assign({}, t.attributes.popper, {
                  "data-popper-placement": t.placement,
                }));
            },
            data: {},
          },
          Ms,
          {
            name: "offset",
            enabled: !0,
            phase: "main",
            requires: ["popperOffsets"],
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = e.name,
                o = n.offset,
                a = void 0 === o ? [0, 0] : o,
                i = gs.reduce(function (e, n) {
                  return (
                    (e[n] = (function (e, t, n) {
                      var r = ks(e),
                        o = [is, rs].indexOf(r) >= 0 ? -1 : 1,
                        a =
                          "function" == typeof n
                            ? n(Object.assign({}, t, { placement: e }))
                            : n,
                        i = a[0],
                        s = a[1];
                      return (
                        (i = i || 0),
                        (s = (s || 0) * o),
                        [is, as].indexOf(r) >= 0
                          ? { x: s, y: i }
                          : { x: i, y: s }
                      );
                    })(n, t.rects, a)),
                    e
                  );
                }, {}),
                s = i[t.placement],
                l = s.x,
                c = s.y;
              null != t.modifiersData.popperOffsets &&
                ((t.modifiersData.popperOffsets.x += l),
                (t.modifiersData.popperOffsets.y += c)),
                (t.modifiersData[r] = i);
            },
          },
          {
            name: "flip",
            enabled: !0,
            phase: "main",
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = e.name;
              if (!t.modifiersData[r]._skip) {
                for (
                  var o = n.mainAxis,
                    a = void 0 === o || o,
                    i = n.altAxis,
                    s = void 0 === i || i,
                    l = n.fallbackPlacements,
                    c = n.padding,
                    u = n.boundary,
                    d = n.rootBoundary,
                    p = n.altBoundary,
                    m = n.flipVariations,
                    h = void 0 === m || m,
                    f = n.allowedAutoPlacements,
                    g = t.options.placement,
                    v = ks(g),
                    b =
                      l ||
                      (v !== g && h
                        ? (function (e) {
                            if (ks(e) === ss) return [];
                            var t = Ds(e);
                            return [Rs(e), t, Rs(t)];
                          })(g)
                        : [Ds(g)]),
                    _ = [g].concat(b).reduce(function (e, n) {
                      return e.concat(
                        ks(n) === ss
                          ? (function (e, t) {
                              void 0 === t && (t = {});
                              var n = t,
                                r = n.placement,
                                o = n.boundary,
                                a = n.rootBoundary,
                                i = n.padding,
                                s = n.flipVariations,
                                l = n.allowedAutoPlacements,
                                c = void 0 === l ? gs : l,
                                u = ws(r),
                                d = u
                                  ? s
                                    ? fs
                                    : fs.filter(function (e) {
                                        return ws(e) === u;
                                      })
                                  : ls,
                                p = d.filter(function (e) {
                                  return c.indexOf(e) >= 0;
                                });
                              0 === p.length && (p = d);
                              var m = p.reduce(function (t, n) {
                                return (
                                  (t[n] = Zs(e, {
                                    placement: n,
                                    boundary: o,
                                    rootBoundary: a,
                                    padding: i,
                                  })[ks(n)]),
                                  t
                                );
                              }, {});
                              return Object.keys(m).sort(function (e, t) {
                                return m[e] - m[t];
                              });
                            })(t, {
                              placement: n,
                              boundary: u,
                              rootBoundary: d,
                              padding: c,
                              flipVariations: h,
                              allowedAutoPlacements: f,
                            })
                          : n
                      );
                    }, []),
                    y = t.rects.reference,
                    x = t.rects.popper,
                    C = new Map(),
                    S = !0,
                    k = _[0],
                    w = 0;
                  w < _.length;
                  w++
                ) {
                  var P = _[w],
                    O = ks(P),
                    I = ws(P) === cs,
                    T = [rs, os].indexOf(O) >= 0,
                    M = T ? "width" : "height",
                    E = Zs(t, {
                      placement: P,
                      boundary: u,
                      rootBoundary: d,
                      altBoundary: p,
                      padding: c,
                    }),
                    D = T ? (I ? as : is) : I ? os : rs;
                  y[M] > x[M] && (D = Ds(D));
                  var j = Ds(D),
                    R = [];
                  if (
                    (a && R.push(E[O] <= 0),
                    s && R.push(E[D] <= 0, E[j] <= 0),
                    R.every(function (e) {
                      return e;
                    }))
                  ) {
                    (k = P), (S = !1);
                    break;
                  }
                  C.set(P, R);
                }
                if (S)
                  for (
                    var N = function (e) {
                        var t = _.find(function (t) {
                          var n = C.get(t);
                          if (n)
                            return n.slice(0, e).every(function (e) {
                              return e;
                            });
                        });
                        if (t) return (k = t), "break";
                      },
                      A = h ? 3 : 1;
                    A > 0 && "break" !== N(A);
                    A--
                  );
                t.placement !== k &&
                  ((t.modifiersData[r]._skip = !0),
                  (t.placement = k),
                  (t.reset = !0));
              }
            },
            requiresIfExists: ["offset"],
            data: { _skip: !1 },
          },
          {
            name: "preventOverflow",
            enabled: !0,
            phase: "main",
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = e.name,
                o = n.mainAxis,
                a = void 0 === o || o,
                i = n.altAxis,
                s = void 0 !== i && i,
                l = n.boundary,
                c = n.rootBoundary,
                u = n.altBoundary,
                d = n.padding,
                p = n.tether,
                m = void 0 === p || p,
                h = n.tetherOffset,
                f = void 0 === h ? 0 : h,
                g = Zs(t, {
                  boundary: l,
                  rootBoundary: c,
                  padding: d,
                  altBoundary: u,
                }),
                v = ks(t.placement),
                b = ws(t.placement),
                _ = !b,
                y = Ps(v),
                x = "x" === y ? "y" : "x",
                C = t.modifiersData.popperOffsets,
                S = t.rects.reference,
                k = t.rects.popper,
                w =
                  "function" == typeof f
                    ? f(Object.assign({}, t.rects, { placement: t.placement }))
                    : f,
                P =
                  "number" == typeof w
                    ? { mainAxis: w, altAxis: w }
                    : Object.assign({ mainAxis: 0, altAxis: 0 }, w),
                O = t.modifiersData.offset
                  ? t.modifiersData.offset[t.placement]
                  : null,
                I = { x: 0, y: 0 };
              if (C) {
                if (a) {
                  var T,
                    M = "y" === y ? rs : is,
                    E = "y" === y ? os : as,
                    D = "y" === y ? "height" : "width",
                    j = C[y],
                    R = j + g[M],
                    N = j - g[E],
                    A = m ? -k[D] / 2 : 0,
                    L = b === cs ? S[D] : k[D],
                    z = b === cs ? -k[D] : -S[D],
                    B = t.elements.arrow,
                    Z = m && B ? Yi(B) : { width: 0, height: 0 },
                    F = t.modifiersData["arrow#persistent"]
                      ? t.modifiersData["arrow#persistent"].padding
                      : { top: 0, right: 0, bottom: 0, left: 0 },
                    H = F[M],
                    V = F[E],
                    W = Fs(0, S[D], Z[D]),
                    $ = _
                      ? S[D] / 2 - A - W - H - P.mainAxis
                      : L - W - H - P.mainAxis,
                    U = _
                      ? -S[D] / 2 + A + W + V + P.mainAxis
                      : z + W + V + P.mainAxis,
                    K = t.elements.arrow && ns(t.elements.arrow),
                    G = K
                      ? "y" === y
                        ? K.clientTop || 0
                        : K.clientLeft || 0
                      : 0,
                    q = null != (T = null == O ? void 0 : O[y]) ? T : 0,
                    Y = j + U - q,
                    J = Fs(m ? zi(R, j + $ - q - G) : R, j, m ? Li(N, Y) : N);
                  (C[y] = J), (I[y] = J - j);
                }
                if (s) {
                  var Q,
                    X = "x" === y ? rs : is,
                    ee = "x" === y ? os : as,
                    te = C[x],
                    ne = "y" === x ? "height" : "width",
                    re = te + g[X],
                    oe = te - g[ee],
                    ae = -1 !== [rs, is].indexOf(v),
                    ie = null != (Q = null == O ? void 0 : O[x]) ? Q : 0,
                    se = ae ? re : te - S[ne] - k[ne] - ie + P.altAxis,
                    le = ae ? te + S[ne] + k[ne] - ie - P.altAxis : oe,
                    ce =
                      m && ae
                        ? (function (e, t, n) {
                            var r = Fs(e, t, n);
                            return r > n ? n : r;
                          })(se, te, le)
                        : Fs(m ? se : re, te, m ? le : oe);
                  (C[x] = ce), (I[x] = ce - te);
                }
                t.modifiersData[r] = I;
              }
            },
            requiresIfExists: ["offset"],
          },
          {
            name: "arrow",
            enabled: !0,
            phase: "main",
            fn: function (e) {
              var t,
                n = e.state,
                r = e.name,
                o = e.options,
                a = n.elements.arrow,
                i = n.modifiersData.popperOffsets,
                s = ks(n.placement),
                l = Ps(s),
                c = [is, as].indexOf(s) >= 0 ? "height" : "width";
              if (a && i) {
                var u = (function (e, t) {
                    return zs(
                      "number" !=
                        typeof (e =
                          "function" == typeof e
                            ? e(
                                Object.assign({}, t.rects, {
                                  placement: t.placement,
                                })
                              )
                            : e)
                        ? e
                        : Bs(e, ls)
                    );
                  })(o.padding, n),
                  d = Yi(a),
                  p = "y" === l ? rs : is,
                  m = "y" === l ? os : as,
                  h =
                    n.rects.reference[c] +
                    n.rects.reference[l] -
                    i[l] -
                    n.rects.popper[c],
                  f = i[l] - n.rects.reference[l],
                  g = ns(a),
                  v = g
                    ? "y" === l
                      ? g.clientHeight || 0
                      : g.clientWidth || 0
                    : 0,
                  b = h / 2 - f / 2,
                  _ = u[p],
                  y = v - d[c] - u[m],
                  x = v / 2 - d[c] / 2 + b,
                  C = Fs(_, x, y),
                  S = l;
                n.modifiersData[r] =
                  (((t = {})[S] = C), (t.centerOffset = C - x), t);
              }
            },
            effect: function (e) {
              var t = e.state,
                n = e.options.element,
                r = void 0 === n ? "[data-popper-arrow]" : n;
              null != r &&
                ("string" != typeof r ||
                  (r = t.elements.popper.querySelector(r))) &&
                Ns(t.elements.popper, r) &&
                (t.elements.arrow = r);
            },
            requires: ["popperOffsets"],
            requiresIfExists: ["preventOverflow"],
          },
          {
            name: "hide",
            enabled: !0,
            phase: "main",
            requiresIfExists: ["preventOverflow"],
            fn: function (e) {
              var t = e.state,
                n = e.name,
                r = t.rects.reference,
                o = t.rects.popper,
                a = t.modifiersData.preventOverflow,
                i = Zs(t, { elementContext: "reference" }),
                s = Zs(t, { altBoundary: !0 }),
                l = Hs(i, r),
                c = Hs(s, o, a),
                u = Vs(l),
                d = Vs(c);
              (t.modifiersData[n] = {
                referenceClippingOffsets: l,
                popperEscapeOffsets: c,
                isReferenceHidden: u,
                hasPopperEscaped: d,
              }),
                (t.attributes.popper = Object.assign({}, t.attributes.popper, {
                  "data-popper-reference-hidden": u,
                  "data-popper-escaped": d,
                }));
            },
          },
        ],
      });
      const $s = "base";
      function Us(e, t) {
        const n = Zt._v[t];
        return n
          ? `${$s}--${n}`
          : (function (e, t) {
              return `${$s}-${e}-${t}`;
            })(e, t);
      }
      const Ks = "Popper";
      function Gs(e) {
        return Us(Ks, e);
      }
      !(function (e, t) {
        const n = {};
        ["root"].forEach((t) => {
          n[t] = Us(e, t);
        });
      })(Ks);
      const qs = { disableDefaultClasses: !1 },
        Ys = t.createContext(qs),
        Js = [
          "anchorEl",
          "children",
          "direction",
          "disablePortal",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "slotProps",
          "slots",
          "TransitionProps",
          "ownerState",
        ],
        Qs = [
          "anchorEl",
          "children",
          "container",
          "direction",
          "disablePortal",
          "keepMounted",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "style",
          "transition",
          "slotProps",
          "slots",
        ];
      function Xs(e) {
        return "function" == typeof e ? e() : e;
      }
      const el = {},
        tl = t.forwardRef(function (n, r) {
          var o;
          const {
              anchorEl: a,
              children: i,
              direction: s,
              disablePortal: l,
              modifiers: c,
              open: u,
              placement: p,
              popperOptions: m,
              popperRef: h,
              slotProps: f = {},
              slots: g = {},
              TransitionProps: v,
            } = n,
            b = (0, jt.Z)(n, Js),
            _ = t.useRef(null),
            y = (0, Qn.Z)(_, r),
            x = t.useRef(null),
            C = (0, Qn.Z)(x, h),
            S = t.useRef(C);
          (0, xr.Z)(() => {
            S.current = C;
          }, [C]),
            t.useImperativeHandle(h, () => x.current, []);
          const k = (function (e, t) {
              if ("ltr" === t) return e;
              switch (e) {
                case "bottom-end":
                  return "bottom-start";
                case "bottom-start":
                  return "bottom-end";
                case "top-end":
                  return "top-start";
                case "top-start":
                  return "top-end";
                default:
                  return e;
              }
            })(p, s),
            [w, P] = t.useState(k),
            [O, I] = t.useState(Xs(a));
          t.useEffect(() => {
            x.current && x.current.forceUpdate();
          }),
            t.useEffect(() => {
              a && I(Xs(a));
            }, [a]),
            (0, xr.Z)(() => {
              if (!O || !u) return;
              let e = [
                { name: "preventOverflow", options: { altBoundary: l } },
                { name: "flip", options: { altBoundary: l } },
                {
                  name: "onUpdate",
                  enabled: !0,
                  phase: "afterWrite",
                  fn: ({ state: e }) => {
                    P(e.placement);
                  },
                },
              ];
              null != c && (e = e.concat(c)),
                m && null != m.modifiers && (e = e.concat(m.modifiers));
              const t = Ws(
                O,
                _.current,
                (0, d.Z)({ placement: k }, m, { modifiers: e })
              );
              return (
                S.current(t),
                () => {
                  t.destroy(), S.current(null);
                }
              );
            }, [O, l, c, u, m, k]);
          const T = { placement: w };
          null !== v && (T.TransitionProps = v);
          const M = (0, Nt.Z)(
              { root: ["root"] },
              (function (e) {
                const { disableDefaultClasses: n } = t.useContext(Ys);
                return (t) => (n ? "" : e(t));
              })(Gs)
            ),
            E = null != (o = g.root) ? o : "div",
            D = ir({
              elementType: E,
              externalSlotProps: f.root,
              externalForwardedProps: b,
              additionalProps: { role: "tooltip", ref: y },
              ownerState: n,
              className: M.root,
            });
          return (0,
          e.jsx)(E, (0, d.Z)({}, D, { children: "function" == typeof i ? i(T) : i }));
        }),
        nl = t.forwardRef(function (n, r) {
          const {
              anchorEl: o,
              children: a,
              container: i,
              direction: s = "ltr",
              disablePortal: l = !1,
              keepMounted: c = !1,
              modifiers: u,
              open: p,
              placement: m = "bottom",
              popperOptions: h = el,
              popperRef: f,
              style: g,
              transition: v = !1,
              slotProps: b = {},
              slots: _ = {},
            } = n,
            y = (0, jt.Z)(n, Qs),
            [x, C] = t.useState(!0);
          if (!c && !p && (!v || x)) return null;
          let S;
          if (i) S = i;
          else if (o) {
            const e = Xs(o);
            S =
              e && void 0 !== e.nodeType
                ? (0, sr.Z)(e).body
                : (0, sr.Z)(null).body;
          }
          const k = p || !c || (v && !x) ? void 0 : "none",
            w = v
              ? {
                  in: p,
                  onEnter: () => {
                    C(!1);
                  },
                  onExited: () => {
                    C(!0);
                  },
                }
              : void 0;
          return (0,
          e.jsx)(Sr, { disablePortal: l, container: S, children: (0, e.jsx)(tl, (0, d.Z)({ anchorEl: o, direction: s, disablePortal: l, modifiers: u, ref: r, open: v ? !x : p, placement: m, popperOptions: h, popperRef: f, slotProps: b, slots: _ }, y, { style: (0, d.Z)({ position: "fixed", top: 0, left: 0, display: k }, g), TransitionProps: w, children: a })) });
        });
      var rl = o(1070);
      const ol = [
          "anchorEl",
          "component",
          "components",
          "componentsProps",
          "container",
          "disablePortal",
          "keepMounted",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "transition",
          "slots",
          "slotProps",
        ],
        al = (0, Lt.ZP)(nl, {
          name: "MuiPopper",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({});
      var il = t.forwardRef(function (t, n) {
          var r;
          const o = (0, rl.Z)(),
            a = (0, zt.Z)({ props: t, name: "MuiPopper" }),
            {
              anchorEl: i,
              component: s,
              components: l,
              componentsProps: c,
              container: u,
              disablePortal: p,
              keepMounted: m,
              modifiers: h,
              open: f,
              placement: g,
              popperOptions: v,
              popperRef: b,
              transition: _,
              slots: y,
              slotProps: x,
            } = a,
            C = (0, jt.Z)(a, ol),
            S =
              null != (r = null == y ? void 0 : y.root)
                ? r
                : null == l
                ? void 0
                : l.Root,
            k = (0, d.Z)(
              {
                anchorEl: i,
                container: u,
                disablePortal: p,
                keepMounted: m,
                modifiers: h,
                open: f,
                placement: g,
                popperOptions: v,
                popperRef: b,
                transition: _,
              },
              C
            );
          return (0,
          e.jsx)(al, (0, d.Z)({ as: s, direction: null == o ? void 0 : o.direction, slots: { root: S }, slotProps: null != x ? x : c }, k, { ref: n }));
        }),
        sl = o(7909),
        ll = o(9299);
      function cl(e) {
        return (0, Zt.ZP)("MuiTooltip", e);
      }
      var ul = (0, Bt.Z)("MuiTooltip", [
        "popper",
        "popperInteractive",
        "popperArrow",
        "popperClose",
        "tooltip",
        "tooltipArrow",
        "touch",
        "tooltipPlacementLeft",
        "tooltipPlacementRight",
        "tooltipPlacementTop",
        "tooltipPlacementBottom",
        "arrow",
      ]);
      const dl = [
          "arrow",
          "children",
          "classes",
          "components",
          "componentsProps",
          "describeChild",
          "disableFocusListener",
          "disableHoverListener",
          "disableInteractive",
          "disableTouchListener",
          "enterDelay",
          "enterNextDelay",
          "enterTouchDelay",
          "followCursor",
          "id",
          "leaveDelay",
          "leaveTouchDelay",
          "onClose",
          "onOpen",
          "open",
          "placement",
          "PopperComponent",
          "PopperProps",
          "slotProps",
          "slots",
          "title",
          "TransitionComponent",
          "TransitionProps",
        ],
        pl = (0, Lt.ZP)(il, {
          name: "MuiTooltip",
          slot: "Popper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.popper,
              !n.disableInteractive && t.popperInteractive,
              n.arrow && t.popperArrow,
              !n.open && t.popperClose,
            ];
          },
        })(({ theme: e, ownerState: t, open: n }) =>
          (0, d.Z)(
            { zIndex: (e.vars || e).zIndex.tooltip, pointerEvents: "none" },
            !t.disableInteractive && { pointerEvents: "auto" },
            !n && { pointerEvents: "none" },
            t.arrow && {
              [`&[data-popper-placement*="bottom"] .${ul.arrow}`]: {
                top: 0,
                marginTop: "-0.71em",
                "&::before": { transformOrigin: "0 100%" },
              },
              [`&[data-popper-placement*="top"] .${ul.arrow}`]: {
                bottom: 0,
                marginBottom: "-0.71em",
                "&::before": { transformOrigin: "100% 0" },
              },
              [`&[data-popper-placement*="right"] .${ul.arrow}`]: (0, d.Z)(
                {},
                t.isRtl
                  ? { right: 0, marginRight: "-0.71em" }
                  : { left: 0, marginLeft: "-0.71em" },
                {
                  height: "1em",
                  width: "0.71em",
                  "&::before": { transformOrigin: "100% 100%" },
                }
              ),
              [`&[data-popper-placement*="left"] .${ul.arrow}`]: (0, d.Z)(
                {},
                t.isRtl
                  ? { left: 0, marginLeft: "-0.71em" }
                  : { right: 0, marginRight: "-0.71em" },
                {
                  height: "1em",
                  width: "0.71em",
                  "&::before": { transformOrigin: "0 0" },
                }
              ),
            }
          )
        ),
        ml = (0, Lt.ZP)("div", {
          name: "MuiTooltip",
          slot: "Tooltip",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.tooltip,
              n.touch && t.touch,
              n.arrow && t.tooltipArrow,
              t[`tooltipPlacement${(0, Fn.Z)(n.placement.split("-")[0])}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              backgroundColor: e.vars
                ? e.vars.palette.Tooltip.bg
                : (0, At.Fq)(e.palette.grey[700], 0.92),
              borderRadius: (e.vars || e).shape.borderRadius,
              color: (e.vars || e).palette.common.white,
              fontFamily: e.typography.fontFamily,
              padding: "4px 8px",
              fontSize: e.typography.pxToRem(11),
              maxWidth: 300,
              margin: 2,
              wordWrap: "break-word",
              fontWeight: e.typography.fontWeightMedium,
            },
            t.arrow && { position: "relative", margin: 0 },
            t.touch && {
              padding: "8px 16px",
              fontSize: e.typography.pxToRem(14),
              lineHeight:
                (16 / 14, Math.round(114285.71428571428) / 1e5 + "em"),
              fontWeight: e.typography.fontWeightRegular,
            },
            {
              [`.${ul.popper}[data-popper-placement*="left"] &`]: (0, d.Z)(
                { transformOrigin: "right center" },
                t.isRtl
                  ? (0, d.Z)(
                      { marginLeft: "14px" },
                      t.touch && { marginLeft: "24px" }
                    )
                  : (0, d.Z)(
                      { marginRight: "14px" },
                      t.touch && { marginRight: "24px" }
                    )
              ),
              [`.${ul.popper}[data-popper-placement*="right"] &`]: (0, d.Z)(
                { transformOrigin: "left center" },
                t.isRtl
                  ? (0, d.Z)(
                      { marginRight: "14px" },
                      t.touch && { marginRight: "24px" }
                    )
                  : (0, d.Z)(
                      { marginLeft: "14px" },
                      t.touch && { marginLeft: "24px" }
                    )
              ),
              [`.${ul.popper}[data-popper-placement*="top"] &`]: (0, d.Z)(
                { transformOrigin: "center bottom", marginBottom: "14px" },
                t.touch && { marginBottom: "24px" }
              ),
              [`.${ul.popper}[data-popper-placement*="bottom"] &`]: (0, d.Z)(
                { transformOrigin: "center top", marginTop: "14px" },
                t.touch && { marginTop: "24px" }
              ),
            }
          )
        ),
        hl = (0, Lt.ZP)("span", {
          name: "MuiTooltip",
          slot: "Arrow",
          overridesResolver: (e, t) => t.arrow,
        })(({ theme: e }) => ({
          overflow: "hidden",
          position: "absolute",
          width: "1em",
          height: "0.71em",
          boxSizing: "border-box",
          color: e.vars
            ? e.vars.palette.Tooltip.bg
            : (0, At.Fq)(e.palette.grey[700], 0.9),
          "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)",
          },
        }));
      let fl = !1;
      const gl = new xn.V();
      let vl = { x: 0, y: 0 };
      function bl(e, t) {
        return (n, ...r) => {
          t && t(n, ...r), e(n, ...r);
        };
      }
      var _l = t.forwardRef(function (n, r) {
        var o, a, i, s, l, c, u, p, m, h, f, g, v, b, _, y, x, C, S;
        const k = (0, zt.Z)({ props: n, name: "MuiTooltip" }),
          {
            arrow: w = !1,
            children: P,
            components: O = {},
            componentsProps: I = {},
            describeChild: T = !1,
            disableFocusListener: M = !1,
            disableHoverListener: E = !1,
            disableInteractive: D = !1,
            disableTouchListener: j = !1,
            enterDelay: R = 100,
            enterNextDelay: N = 0,
            enterTouchDelay: A = 700,
            followCursor: L = !1,
            id: z,
            leaveDelay: B = 0,
            leaveTouchDelay: Z = 1500,
            onClose: F,
            onOpen: H,
            open: V,
            placement: W = "bottom",
            PopperComponent: $,
            PopperProps: U = {},
            slotProps: K = {},
            slots: G = {},
            title: q,
            TransitionComponent: Y = Di,
            TransitionProps: J,
          } = k,
          Q = (0, jt.Z)(k, dl),
          X = t.isValidElement(P) ? P : (0, e.jsx)("span", { children: P }),
          ee = jr(),
          te = Yn(),
          [ne, re] = t.useState(),
          [oe, ae] = t.useState(null),
          ie = t.useRef(!1),
          se = D || L,
          le = (0, xn.Z)(),
          ce = (0, xn.Z)(),
          ue = (0, xn.Z)(),
          de = (0, xn.Z)(),
          [pe, me] = (0, ll.Z)({
            controlled: V,
            default: !1,
            name: "Tooltip",
            state: "open",
          });
        let he = pe;
        const fe = (0, sl.Z)(z),
          ge = t.useRef(),
          ve = (0, un.Z)(() => {
            void 0 !== ge.current &&
              ((document.body.style.WebkitUserSelect = ge.current),
              (ge.current = void 0)),
              de.clear();
          });
        t.useEffect(() => ve, [ve]);
        const be = (e) => {
            gl.clear(), (fl = !0), me(!0), H && !he && H(e);
          },
          _e = (0, un.Z)((e) => {
            gl.start(800 + B, () => {
              fl = !1;
            }),
              me(!1),
              F && he && F(e),
              le.start(ee.transitions.duration.shortest, () => {
                ie.current = !1;
              });
          }),
          ye = (e) => {
            (ie.current && "touchstart" !== e.type) ||
              (ne && ne.removeAttribute("title"),
              ce.clear(),
              ue.clear(),
              R || (fl && N)
                ? ce.start(fl ? N : R, () => {
                    be(e);
                  })
                : be(e));
          },
          xe = (e) => {
            ce.clear(),
              ue.start(B, () => {
                _e(e);
              });
          },
          {
            isFocusVisibleRef: Ce,
            onBlur: Se,
            onFocus: ke,
            ref: we,
          } = (0, dn.Z)(),
          [, Pe] = t.useState(!1),
          Oe = (e) => {
            Se(e), !1 === Ce.current && (Pe(!1), xe(e));
          },
          Ie = (e) => {
            ne || re(e.currentTarget),
              ke(e),
              !0 === Ce.current && (Pe(!0), ye(e));
          },
          Te = (e) => {
            ie.current = !0;
            const t = X.props;
            t.onTouchStart && t.onTouchStart(e);
          };
        t.useEffect(() => {
          if (he)
            return (
              document.addEventListener("keydown", e),
              () => {
                document.removeEventListener("keydown", e);
              }
            );
          function e(e) {
            ("Escape" !== e.key && "Esc" !== e.key) || _e(e);
          }
        }, [_e, he]);
        const Me = (0, cn.Z)(X.ref, we, re, r);
        q || 0 === q || (he = !1);
        const Ee = t.useRef(),
          De = {},
          je = "string" == typeof q;
        T
          ? ((De.title = he || !je || E ? null : q),
            (De["aria-describedby"] = he ? fe : null))
          : ((De["aria-label"] = je ? q : null),
            (De["aria-labelledby"] = he && !je ? fe : null));
        const Re = (0, d.Z)(
            {},
            De,
            Q,
            X.props,
            {
              className: (0, Rt.Z)(Q.className, X.props.className),
              onTouchStart: Te,
              ref: Me,
            },
            L
              ? {
                  onMouseMove: (e) => {
                    const t = X.props;
                    t.onMouseMove && t.onMouseMove(e),
                      (vl = { x: e.clientX, y: e.clientY }),
                      Ee.current && Ee.current.update();
                  },
                }
              : {}
          ),
          Ne = {};
        j ||
          ((Re.onTouchStart = (e) => {
            Te(e),
              ue.clear(),
              le.clear(),
              ve(),
              (ge.current = document.body.style.WebkitUserSelect),
              (document.body.style.WebkitUserSelect = "none"),
              de.start(A, () => {
                (document.body.style.WebkitUserSelect = ge.current), ye(e);
              });
          }),
          (Re.onTouchEnd = (e) => {
            X.props.onTouchEnd && X.props.onTouchEnd(e),
              ve(),
              ue.start(Z, () => {
                _e(e);
              });
          })),
          E ||
            ((Re.onMouseOver = bl(ye, Re.onMouseOver)),
            (Re.onMouseLeave = bl(xe, Re.onMouseLeave)),
            se || ((Ne.onMouseOver = ye), (Ne.onMouseLeave = xe))),
          M ||
            ((Re.onFocus = bl(Ie, Re.onFocus)),
            (Re.onBlur = bl(Oe, Re.onBlur)),
            se || ((Ne.onFocus = Ie), (Ne.onBlur = Oe)));
        const Ae = t.useMemo(() => {
            var e;
            let t = [
              {
                name: "arrow",
                enabled: Boolean(oe),
                options: { element: oe, padding: 4 },
              },
            ];
            return (
              null != (e = U.popperOptions) &&
                e.modifiers &&
                (t = t.concat(U.popperOptions.modifiers)),
              (0, d.Z)({}, U.popperOptions, { modifiers: t })
            );
          }, [oe, U]),
          Le = (0, d.Z)({}, k, {
            isRtl: te,
            arrow: w,
            disableInteractive: se,
            placement: W,
            PopperComponentProp: $,
            touch: ie.current,
          }),
          ze = ((e) => {
            const {
                classes: t,
                disableInteractive: n,
                arrow: r,
                touch: o,
                placement: a,
              } = e,
              i = {
                popper: [
                  "popper",
                  !n && "popperInteractive",
                  r && "popperArrow",
                ],
                tooltip: [
                  "tooltip",
                  r && "tooltipArrow",
                  o && "touch",
                  `tooltipPlacement${(0, Fn.Z)(a.split("-")[0])}`,
                ],
                arrow: ["arrow"],
              };
            return (0, Nt.Z)(i, cl, t);
          })(Le),
          Be = null != (o = null != (a = G.popper) ? a : O.Popper) ? o : pl,
          Ze =
            null !=
            (i =
              null != (s = null != (l = G.transition) ? l : O.Transition)
                ? s
                : Y)
              ? i
              : Di,
          Fe = null != (c = null != (u = G.tooltip) ? u : O.Tooltip) ? c : ml,
          He = null != (p = null != (m = G.arrow) ? m : O.Arrow) ? p : hl,
          Ve = er(
            Be,
            (0, d.Z)({}, U, null != (h = K.popper) ? h : I.popper, {
              className: (0, Rt.Z)(
                ze.popper,
                null == U ? void 0 : U.className,
                null == (f = null != (g = K.popper) ? g : I.popper)
                  ? void 0
                  : f.className
              ),
            }),
            Le
          ),
          We = er(
            Ze,
            (0, d.Z)({}, J, null != (v = K.transition) ? v : I.transition),
            Le
          ),
          $e = er(
            Fe,
            (0, d.Z)({}, null != (b = K.tooltip) ? b : I.tooltip, {
              className: (0, Rt.Z)(
                ze.tooltip,
                null == (_ = null != (y = K.tooltip) ? y : I.tooltip)
                  ? void 0
                  : _.className
              ),
            }),
            Le
          ),
          Ue = er(
            He,
            (0, d.Z)({}, null != (x = K.arrow) ? x : I.arrow, {
              className: (0, Rt.Z)(
                ze.arrow,
                null == (C = null != (S = K.arrow) ? S : I.arrow)
                  ? void 0
                  : C.className
              ),
            }),
            Le
          );
        return (0,
        e.jsxs)(t.Fragment, { children: [t.cloneElement(X, Re), (0, e.jsx)(Be, (0, d.Z)({ as: null != $ ? $ : il, placement: W, anchorEl: L ? { getBoundingClientRect: () => ({ top: vl.y, left: vl.x, right: vl.x, bottom: vl.y, width: 0, height: 0 }) } : ne, popperRef: Ee, open: !!ne && he, id: fe, transition: !0 }, Ne, Ve, { popperOptions: Ae, children: ({ TransitionProps: t }) => (0, e.jsx)(Ze, (0, d.Z)({ timeout: ee.transitions.duration.shorter }, t, We, { children: (0, e.jsxs)(Fe, (0, d.Z)({}, $e, { children: [q, w ? (0, e.jsx)(He, (0, d.Z)({}, Ue, { ref: ae })) : null] })) })) }))] });
      });
      function yl(e) {
        return (0, Zt.ZP)("MuiLink", e);
      }
      var xl = (0, Bt.Z)("MuiLink", [
          "root",
          "underlineNone",
          "underlineHover",
          "underlineAlways",
          "button",
          "focusVisible",
        ]),
        Cl = o(4844);
      const Sl = {
        primary: "primary.main",
        textPrimary: "text.primary",
        secondary: "secondary.main",
        textSecondary: "text.secondary",
        error: "error.main",
      };
      var kl = ({ theme: e, ownerState: t }) => {
        const n = ((e) => Sl[e] || e)(t.color),
          r = (0, Cl.DW)(e, `palette.${n}`, !1) || t.color,
          o = (0, Cl.DW)(e, `palette.${n}Channel`);
        return "vars" in e && o ? `rgba(${o} / 0.4)` : (0, At.Fq)(r, 0.4);
      };
      const wl = [
          "className",
          "color",
          "component",
          "onBlur",
          "onFocus",
          "TypographyClasses",
          "underline",
          "variant",
          "sx",
        ],
        Pl = (0, Lt.ZP)(Wa, {
          name: "MuiLink",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`underline${(0, Fn.Z)(n.underline)}`],
              "button" === n.component && t.button,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {},
            "none" === t.underline && { textDecoration: "none" },
            "hover" === t.underline && {
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            },
            "always" === t.underline &&
              (0, d.Z)(
                { textDecoration: "underline" },
                "inherit" !== t.color && {
                  textDecorationColor: kl({ theme: e, ownerState: t }),
                },
                { "&:hover": { textDecorationColor: "inherit" } }
              ),
            "button" === t.component && {
              position: "relative",
              WebkitTapHighlightColor: "transparent",
              backgroundColor: "transparent",
              outline: 0,
              border: 0,
              margin: 0,
              borderRadius: 0,
              padding: 0,
              cursor: "pointer",
              userSelect: "none",
              verticalAlign: "middle",
              MozAppearance: "none",
              WebkitAppearance: "none",
              "&::-moz-focus-inner": { borderStyle: "none" },
              [`&.${xl.focusVisible}`]: { outline: "auto" },
            }
          )
        ),
        Ol = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiLink" }),
            {
              className: a,
              color: i = "primary",
              component: s = "a",
              onBlur: l,
              onFocus: c,
              TypographyClasses: u,
              underline: p = "always",
              variant: m = "inherit",
              sx: h,
            } = o,
            f = (0, jt.Z)(o, wl),
            {
              isFocusVisibleRef: g,
              onBlur: v,
              onFocus: b,
              ref: _,
            } = (0, dn.Z)(),
            [y, x] = t.useState(!1),
            C = (0, cn.Z)(r, _),
            S = (0, d.Z)({}, o, {
              color: i,
              component: s,
              focusVisible: y,
              underline: p,
              variant: m,
            }),
            k = ((e) => {
              const {
                  classes: t,
                  component: n,
                  focusVisible: r,
                  underline: o,
                } = e,
                a = {
                  root: [
                    "root",
                    `underline${(0, Fn.Z)(o)}`,
                    "button" === n && "button",
                    r && "focusVisible",
                  ],
                };
              return (0, Nt.Z)(a, yl, t);
            })(S);
          return (0, e.jsx)(
            Pl,
            (0, d.Z)(
              {
                color: i,
                className: (0, Rt.Z)(k.root, a),
                classes: u,
                component: s,
                onBlur: (e) => {
                  v(e), !1 === g.current && x(!1), l && l(e);
                },
                onFocus: (e) => {
                  b(e), !0 === g.current && x(!0), c && c(e);
                },
                ref: C,
                ownerState: S,
                variant: m,
                sx: [
                  ...(Object.keys(Sl).includes(i) ? [] : [{ color: i }]),
                  ...(Array.isArray(h) ? h : [h]),
                ],
              },
              f
            )
          );
        });
      var Il = Ol;
      function Tl(e) {
        return (0, Zt.ZP)("MuiPopover", e);
      }
      (0, Bt.Z)("MuiPopover", ["root", "paper"]);
      const Ml = ["onEntering"],
        El = [
          "action",
          "anchorEl",
          "anchorOrigin",
          "anchorPosition",
          "anchorReference",
          "children",
          "className",
          "container",
          "elevation",
          "marginThreshold",
          "open",
          "PaperProps",
          "slots",
          "slotProps",
          "transformOrigin",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
          "disableScrollLock",
        ],
        Dl = ["slotProps"];
      function jl(e, t) {
        let n = 0;
        return (
          "number" == typeof t
            ? (n = t)
            : "center" === t
            ? (n = e.height / 2)
            : "bottom" === t && (n = e.height),
          n
        );
      }
      function Rl(e, t) {
        let n = 0;
        return (
          "number" == typeof t
            ? (n = t)
            : "center" === t
            ? (n = e.width / 2)
            : "right" === t && (n = e.width),
          n
        );
      }
      function Nl(e) {
        return [e.horizontal, e.vertical]
          .map((e) => ("number" == typeof e ? `${e}px` : e))
          .join(" ");
      }
      function Al(e) {
        return "function" == typeof e ? e() : e;
      }
      const Ll = (0, Lt.ZP)(qr, {
          name: "MuiPopover",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        zl = (0, Lt.ZP)(io, {
          name: "MuiPopover",
          slot: "Paper",
          overridesResolver: (e, t) => t.paper,
        })({
          position: "absolute",
          overflowY: "auto",
          overflowX: "hidden",
          minWidth: 16,
          minHeight: 16,
          maxWidth: "calc(100% - 32px)",
          maxHeight: "calc(100% - 32px)",
          outline: 0,
        }),
        Bl = t.forwardRef(function (n, r) {
          var o, a, i;
          const s = (0, zt.Z)({ props: n, name: "MuiPopover" }),
            {
              action: l,
              anchorEl: c,
              anchorOrigin: u = { vertical: "top", horizontal: "left" },
              anchorPosition: p,
              anchorReference: m = "anchorEl",
              children: h,
              className: f,
              container: g,
              elevation: v = 8,
              marginThreshold: b = 16,
              open: _,
              PaperProps: y = {},
              slots: x,
              slotProps: C,
              transformOrigin: S = { vertical: "top", horizontal: "left" },
              TransitionComponent: k = Di,
              transitionDuration: w = "auto",
              TransitionProps: { onEntering: P } = {},
              disableScrollLock: O = !1,
            } = s,
            I = (0, jt.Z)(s.TransitionProps, Ml),
            T = (0, jt.Z)(s, El),
            M = null != (o = null == C ? void 0 : C.paper) ? o : y,
            E = t.useRef(),
            D = (0, cn.Z)(E, M.ref),
            j = (0, d.Z)({}, s, {
              anchorOrigin: u,
              anchorReference: m,
              elevation: v,
              marginThreshold: b,
              externalPaperSlotProps: M,
              transformOrigin: S,
              TransitionComponent: k,
              transitionDuration: w,
              TransitionProps: I,
            }),
            R = ((e) => {
              const { classes: t } = e;
              return (0, Nt.Z)({ root: ["root"], paper: ["paper"] }, Tl, t);
            })(j),
            N = t.useCallback(() => {
              if ("anchorPosition" === m) return p;
              const e = Al(c),
                t = (
                  e && 1 === e.nodeType ? e : (0, ra.Z)(E.current).body
                ).getBoundingClientRect();
              return {
                top: t.top + jl(t, u.vertical),
                left: t.left + Rl(t, u.horizontal),
              };
            }, [c, u.horizontal, u.vertical, p, m]),
            A = t.useCallback(
              (e) => ({
                vertical: jl(e, S.vertical),
                horizontal: Rl(e, S.horizontal),
              }),
              [S.horizontal, S.vertical]
            ),
            L = t.useCallback(
              (e) => {
                const t = { width: e.offsetWidth, height: e.offsetHeight },
                  n = A(t);
                if ("none" === m)
                  return { top: null, left: null, transformOrigin: Nl(n) };
                const r = N();
                let o = r.top - n.vertical,
                  a = r.left - n.horizontal;
                const i = o + t.height,
                  s = a + t.width,
                  l = (0, Jr.Z)(Al(c)),
                  u = l.innerHeight - b,
                  d = l.innerWidth - b;
                if (null !== b && o < b) {
                  const e = o - b;
                  (o -= e), (n.vertical += e);
                } else if (null !== b && i > u) {
                  const e = i - u;
                  (o -= e), (n.vertical += e);
                }
                if (null !== b && a < b) {
                  const e = a - b;
                  (a -= e), (n.horizontal += e);
                } else if (s > d) {
                  const e = s - d;
                  (a -= e), (n.horizontal += e);
                }
                return {
                  top: `${Math.round(o)}px`,
                  left: `${Math.round(a)}px`,
                  transformOrigin: Nl(n),
                };
              },
              [c, m, N, A, b]
            ),
            [z, B] = t.useState(_),
            Z = t.useCallback(() => {
              const e = E.current;
              if (!e) return;
              const t = L(e);
              null !== t.top && (e.style.top = t.top),
                null !== t.left && (e.style.left = t.left),
                (e.style.transformOrigin = t.transformOrigin),
                B(!0);
            }, [L]);
          t.useEffect(
            () => (
              O && window.addEventListener("scroll", Z),
              () => window.removeEventListener("scroll", Z)
            ),
            [c, O, Z]
          ),
            t.useEffect(() => {
              _ && Z();
            }),
            t.useImperativeHandle(
              l,
              () =>
                _
                  ? {
                      updatePosition: () => {
                        Z();
                      },
                    }
                  : null,
              [_, Z]
            ),
            t.useEffect(() => {
              if (!_) return;
              const e = (0, Yr.Z)(() => {
                  Z();
                }),
                t = (0, Jr.Z)(c);
              return (
                t.addEventListener("resize", e),
                () => {
                  e.clear(), t.removeEventListener("resize", e);
                }
              );
            }, [c, _, Z]);
          let F = w;
          "auto" !== w || k.muiSupportAuto || (F = void 0);
          const H = g || (c ? (0, ra.Z)(Al(c)).body : void 0),
            V = null != (a = null == x ? void 0 : x.root) ? a : Ll,
            W = null != (i = null == x ? void 0 : x.paper) ? i : zl,
            $ = ir({
              elementType: W,
              externalSlotProps: (0, d.Z)({}, M, {
                style: z ? M.style : (0, d.Z)({}, M.style, { opacity: 0 }),
              }),
              additionalProps: { elevation: v, ref: D },
              ownerState: j,
              className: (0, Rt.Z)(R.paper, null == M ? void 0 : M.className),
            }),
            U = ir({
              elementType: V,
              externalSlotProps: (null == C ? void 0 : C.root) || {},
              externalForwardedProps: T,
              additionalProps: {
                ref: r,
                slotProps: { backdrop: { invisible: !0 } },
                container: H,
                open: _,
              },
              ownerState: j,
              className: (0, Rt.Z)(R.root, f),
            }),
            { slotProps: K } = U,
            G = (0, jt.Z)(U, Dl);
          return (0, e.jsx)(
            V,
            (0, d.Z)({}, G, !Xn(V) && { slotProps: K, disableScrollLock: O }, {
              children: (0, e.jsx)(
                k,
                (0, d.Z)(
                  {
                    appear: !0,
                    in: _,
                    onEntering: (e, t) => {
                      P && P(e, t), Z();
                    },
                    onExited: () => {
                      B(!1);
                    },
                    timeout: F,
                  },
                  I,
                  { children: (0, e.jsx)(W, (0, d.Z)({}, $, { children: h })) }
                )
              ),
            })
          );
        });
      var Zl = Bl,
        Fl = o(9326),
        Hl = o(1222),
        Vl = (e) => {
          const n = t.useRef({});
          return (
            t.useEffect(() => {
              n.current = e;
            }),
            n.current
          );
        };
      function Wl(e) {
        return void 0 !== e.normalize
          ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          : e;
      }
      function $l(e, t) {
        for (let n = 0; n < e.length; n += 1) if (t(e[n])) return n;
        return -1;
      }
      const Ul = (function (e = {}) {
          const {
            ignoreAccents: t = !0,
            ignoreCase: n = !0,
            limit: r,
            matchFrom: o = "any",
            stringify: a,
            trim: i = !1,
          } = e;
          return (e, { inputValue: s, getOptionLabel: l }) => {
            let c = i ? s.trim() : s;
            n && (c = c.toLowerCase()), t && (c = Wl(c));
            const u = c
              ? e.filter((e) => {
                  let r = (a || l)(e);
                  return (
                    n && (r = r.toLowerCase()),
                    t && (r = Wl(r)),
                    "start" === o ? 0 === r.indexOf(c) : r.indexOf(c) > -1
                  );
                })
              : e;
            return "number" == typeof r ? u.slice(0, r) : u;
          };
        })(),
        Kl = 5,
        Gl = (e) => {
          var t;
          return (
            null !== e.current &&
            (null == (t = e.current.parentElement)
              ? void 0
              : t.contains(document.activeElement))
          );
        };
      function ql(e) {
        return (0, Zt.ZP)("MuiListSubheader", e);
      }
      (0, Bt.Z)("MuiListSubheader", [
        "root",
        "colorPrimary",
        "colorInherit",
        "gutters",
        "inset",
        "sticky",
      ]);
      const Yl = [
          "className",
          "color",
          "component",
          "disableGutters",
          "disableSticky",
          "inset",
        ],
        Jl = (0, Lt.ZP)("li", {
          name: "MuiListSubheader",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              "default" !== n.color && t[`color${(0, Fn.Z)(n.color)}`],
              !n.disableGutters && t.gutters,
              n.inset && t.inset,
              !n.disableSticky && t.sticky,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              boxSizing: "border-box",
              lineHeight: "48px",
              listStyle: "none",
              color: (e.vars || e).palette.text.secondary,
              fontFamily: e.typography.fontFamily,
              fontWeight: e.typography.fontWeightMedium,
              fontSize: e.typography.pxToRem(14),
            },
            "primary" === t.color && {
              color: (e.vars || e).palette.primary.main,
            },
            "inherit" === t.color && { color: "inherit" },
            !t.disableGutters && { paddingLeft: 16, paddingRight: 16 },
            t.inset && { paddingLeft: 72 },
            !t.disableSticky && {
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: (e.vars || e).palette.background.paper,
            }
          )
        ),
        Ql = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiListSubheader" }),
            {
              className: o,
              color: a = "default",
              component: i = "li",
              disableGutters: s = !1,
              disableSticky: l = !1,
              inset: c = !1,
            } = r,
            u = (0, jt.Z)(r, Yl),
            p = (0, d.Z)({}, r, {
              color: a,
              component: i,
              disableGutters: s,
              disableSticky: l,
              inset: c,
            }),
            m = ((e) => {
              const {
                  classes: t,
                  color: n,
                  disableGutters: r,
                  inset: o,
                  disableSticky: a,
                } = e,
                i = {
                  root: [
                    "root",
                    "default" !== n && `color${(0, Fn.Z)(n)}`,
                    !r && "gutters",
                    o && "inset",
                    !a && "sticky",
                  ],
                };
              return (0, Nt.Z)(i, ql, t);
            })(p);
          return (0,
          e.jsx)(Jl, (0, d.Z)({ as: i, className: (0, Rt.Z)(m.root, o), ref: n, ownerState: p }, u));
        });
      Ql.muiSkipListHighlight = !0;
      var Xl = Ql,
        ec = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
          }),
          "Cancel"
        );
      function tc(e) {
        return (0, Zt.ZP)("MuiChip", e);
      }
      var nc = (0, Bt.Z)("MuiChip", [
        "root",
        "sizeSmall",
        "sizeMedium",
        "colorError",
        "colorInfo",
        "colorPrimary",
        "colorSecondary",
        "colorSuccess",
        "colorWarning",
        "disabled",
        "clickable",
        "clickableColorPrimary",
        "clickableColorSecondary",
        "deletable",
        "deletableColorPrimary",
        "deletableColorSecondary",
        "outlined",
        "filled",
        "outlinedPrimary",
        "outlinedSecondary",
        "filledPrimary",
        "filledSecondary",
        "avatar",
        "avatarSmall",
        "avatarMedium",
        "avatarColorPrimary",
        "avatarColorSecondary",
        "icon",
        "iconSmall",
        "iconMedium",
        "iconColorPrimary",
        "iconColorSecondary",
        "label",
        "labelSmall",
        "labelMedium",
        "deleteIcon",
        "deleteIconSmall",
        "deleteIconMedium",
        "deleteIconColorPrimary",
        "deleteIconColorSecondary",
        "deleteIconOutlinedColorPrimary",
        "deleteIconOutlinedColorSecondary",
        "deleteIconFilledColorPrimary",
        "deleteIconFilledColorSecondary",
        "focusVisible",
      ]);
      const rc = [
          "avatar",
          "className",
          "clickable",
          "color",
          "component",
          "deleteIcon",
          "disabled",
          "icon",
          "label",
          "onClick",
          "onDelete",
          "onKeyDown",
          "onKeyUp",
          "size",
          "variant",
          "tabIndex",
          "skipFocusWhenDisabled",
        ],
        oc = (0, Lt.ZP)("div", {
          name: "MuiChip",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              {
                color: r,
                iconColor: o,
                clickable: a,
                onDelete: i,
                size: s,
                variant: l,
              } = n;
            return [
              { [`& .${nc.avatar}`]: t.avatar },
              { [`& .${nc.avatar}`]: t[`avatar${(0, Fn.Z)(s)}`] },
              { [`& .${nc.avatar}`]: t[`avatarColor${(0, Fn.Z)(r)}`] },
              { [`& .${nc.icon}`]: t.icon },
              { [`& .${nc.icon}`]: t[`icon${(0, Fn.Z)(s)}`] },
              { [`& .${nc.icon}`]: t[`iconColor${(0, Fn.Z)(o)}`] },
              { [`& .${nc.deleteIcon}`]: t.deleteIcon },
              { [`& .${nc.deleteIcon}`]: t[`deleteIcon${(0, Fn.Z)(s)}`] },
              { [`& .${nc.deleteIcon}`]: t[`deleteIconColor${(0, Fn.Z)(r)}`] },
              {
                [`& .${nc.deleteIcon}`]:
                  t[`deleteIcon${(0, Fn.Z)(l)}Color${(0, Fn.Z)(r)}`],
              },
              t.root,
              t[`size${(0, Fn.Z)(s)}`],
              t[`color${(0, Fn.Z)(r)}`],
              a && t.clickable,
              a && "default" !== r && t[`clickableColor${(0, Fn.Z)(r)})`],
              i && t.deletable,
              i && "default" !== r && t[`deletableColor${(0, Fn.Z)(r)}`],
              t[l],
              t[`${l}${(0, Fn.Z)(r)}`],
            ];
          },
        })(
          ({ theme: e, ownerState: t }) => {
            const n =
              "light" === e.palette.mode
                ? e.palette.grey[700]
                : e.palette.grey[300];
            return (0, d.Z)(
              {
                maxWidth: "100%",
                fontFamily: e.typography.fontFamily,
                fontSize: e.typography.pxToRem(13),
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 32,
                color: (e.vars || e).palette.text.primary,
                backgroundColor: (e.vars || e).palette.action.selected,
                borderRadius: 16,
                whiteSpace: "nowrap",
                transition: e.transitions.create([
                  "background-color",
                  "box-shadow",
                ]),
                cursor: "unset",
                outline: 0,
                textDecoration: "none",
                border: 0,
                padding: 0,
                verticalAlign: "middle",
                boxSizing: "border-box",
                [`&.${nc.disabled}`]: {
                  opacity: (e.vars || e).palette.action.disabledOpacity,
                  pointerEvents: "none",
                },
                [`& .${nc.avatar}`]: {
                  marginLeft: 5,
                  marginRight: -6,
                  width: 24,
                  height: 24,
                  color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
                  fontSize: e.typography.pxToRem(12),
                },
                [`& .${nc.avatarColorPrimary}`]: {
                  color: (e.vars || e).palette.primary.contrastText,
                  backgroundColor: (e.vars || e).palette.primary.dark,
                },
                [`& .${nc.avatarColorSecondary}`]: {
                  color: (e.vars || e).palette.secondary.contrastText,
                  backgroundColor: (e.vars || e).palette.secondary.dark,
                },
                [`& .${nc.avatarSmall}`]: {
                  marginLeft: 4,
                  marginRight: -4,
                  width: 18,
                  height: 18,
                  fontSize: e.typography.pxToRem(10),
                },
                [`& .${nc.icon}`]: (0, d.Z)(
                  { marginLeft: 5, marginRight: -6 },
                  "small" === t.size && {
                    fontSize: 18,
                    marginLeft: 4,
                    marginRight: -4,
                  },
                  t.iconColor === t.color &&
                    (0, d.Z)(
                      {
                        color: e.vars
                          ? e.vars.palette.Chip.defaultIconColor
                          : n,
                      },
                      "default" !== t.color && { color: "inherit" }
                    )
                ),
                [`& .${nc.deleteIcon}`]: (0, d.Z)(
                  {
                    WebkitTapHighlightColor: "transparent",
                    color: e.vars
                      ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)`
                      : (0, At.Fq)(e.palette.text.primary, 0.26),
                    fontSize: 22,
                    cursor: "pointer",
                    margin: "0 5px 0 -6px",
                    "&:hover": {
                      color: e.vars
                        ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)`
                        : (0, At.Fq)(e.palette.text.primary, 0.4),
                    },
                  },
                  "small" === t.size && {
                    fontSize: 16,
                    marginRight: 4,
                    marginLeft: -4,
                  },
                  "default" !== t.color && {
                    color: e.vars
                      ? `rgba(${
                          e.vars.palette[t.color].contrastTextChannel
                        } / 0.7)`
                      : (0, At.Fq)(e.palette[t.color].contrastText, 0.7),
                    "&:hover, &:active": {
                      color: (e.vars || e).palette[t.color].contrastText,
                    },
                  }
                ),
              },
              "small" === t.size && { height: 24 },
              "default" !== t.color && {
                backgroundColor: (e.vars || e).palette[t.color].main,
                color: (e.vars || e).palette[t.color].contrastText,
              },
              t.onDelete && {
                [`&.${nc.focusVisible}`]: {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                    : (0, At.Fq)(
                        e.palette.action.selected,
                        e.palette.action.selectedOpacity +
                          e.palette.action.focusOpacity
                      ),
                },
              },
              t.onDelete &&
                "default" !== t.color && {
                  [`&.${nc.focusVisible}`]: {
                    backgroundColor: (e.vars || e).palette[t.color].dark,
                  },
                }
            );
          },
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              {},
              t.clickable && {
                userSelect: "none",
                WebkitTapHighlightColor: "transparent",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                    : (0, At.Fq)(
                        e.palette.action.selected,
                        e.palette.action.selectedOpacity +
                          e.palette.action.hoverOpacity
                      ),
                },
                [`&.${nc.focusVisible}`]: {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                    : (0, At.Fq)(
                        e.palette.action.selected,
                        e.palette.action.selectedOpacity +
                          e.palette.action.focusOpacity
                      ),
                },
                "&:active": { boxShadow: (e.vars || e).shadows[1] },
              },
              t.clickable &&
                "default" !== t.color && {
                  [`&:hover, &.${nc.focusVisible}`]: {
                    backgroundColor: (e.vars || e).palette[t.color].dark,
                  },
                }
            ),
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              {},
              "outlined" === t.variant && {
                backgroundColor: "transparent",
                border: e.vars
                  ? `1px solid ${e.vars.palette.Chip.defaultBorder}`
                  : `1px solid ${
                      "light" === e.palette.mode
                        ? e.palette.grey[400]
                        : e.palette.grey[700]
                    }`,
                [`&.${nc.clickable}:hover`]: {
                  backgroundColor: (e.vars || e).palette.action.hover,
                },
                [`&.${nc.focusVisible}`]: {
                  backgroundColor: (e.vars || e).palette.action.focus,
                },
                [`& .${nc.avatar}`]: { marginLeft: 4 },
                [`& .${nc.avatarSmall}`]: { marginLeft: 2 },
                [`& .${nc.icon}`]: { marginLeft: 4 },
                [`& .${nc.iconSmall}`]: { marginLeft: 2 },
                [`& .${nc.deleteIcon}`]: { marginRight: 5 },
                [`& .${nc.deleteIconSmall}`]: { marginRight: 3 },
              },
              "outlined" === t.variant &&
                "default" !== t.color && {
                  color: (e.vars || e).palette[t.color].main,
                  border: `1px solid ${
                    e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)`
                      : (0, At.Fq)(e.palette[t.color].main, 0.7)
                  }`,
                  [`&.${nc.clickable}:hover`]: {
                    backgroundColor: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                          e.vars.palette.action.hoverOpacity
                        })`
                      : (0, At.Fq)(
                          e.palette[t.color].main,
                          e.palette.action.hoverOpacity
                        ),
                  },
                  [`&.${nc.focusVisible}`]: {
                    backgroundColor: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                          e.vars.palette.action.focusOpacity
                        })`
                      : (0, At.Fq)(
                          e.palette[t.color].main,
                          e.palette.action.focusOpacity
                        ),
                  },
                  [`& .${nc.deleteIcon}`]: {
                    color: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)`
                      : (0, At.Fq)(e.palette[t.color].main, 0.7),
                    "&:hover, &:active": {
                      color: (e.vars || e).palette[t.color].main,
                    },
                  },
                }
            )
        ),
        ac = (0, Lt.ZP)("span", {
          name: "MuiChip",
          slot: "Label",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              { size: r } = n;
            return [t.label, t[`label${(0, Fn.Z)(r)}`]];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              overflow: "hidden",
              textOverflow: "ellipsis",
              paddingLeft: 12,
              paddingRight: 12,
              whiteSpace: "nowrap",
            },
            "outlined" === e.variant && { paddingLeft: 11, paddingRight: 11 },
            "small" === e.size && { paddingLeft: 8, paddingRight: 8 },
            "small" === e.size &&
              "outlined" === e.variant && { paddingLeft: 7, paddingRight: 7 }
          )
        );
      function ic(e) {
        return "Backspace" === e.key || "Delete" === e.key;
      }
      const sc = t.forwardRef(function (n, r) {
        const o = (0, zt.Z)({ props: n, name: "MuiChip" }),
          {
            avatar: a,
            className: i,
            clickable: s,
            color: l = "default",
            component: c,
            deleteIcon: u,
            disabled: p = !1,
            icon: m,
            label: h,
            onClick: f,
            onDelete: g,
            onKeyDown: v,
            onKeyUp: b,
            size: _ = "medium",
            variant: y = "filled",
            tabIndex: x,
            skipFocusWhenDisabled: C = !1,
          } = o,
          S = (0, jt.Z)(o, rc),
          k = t.useRef(null),
          w = (0, cn.Z)(k, r),
          P = (e) => {
            e.stopPropagation(), g && g(e);
          },
          O = !(!1 === s || !f) || s,
          I = O || g ? Zn : c || "div",
          T = (0, d.Z)({}, o, {
            component: I,
            disabled: p,
            size: _,
            color: l,
            iconColor: (t.isValidElement(m) && m.props.color) || l,
            onDelete: !!g,
            clickable: O,
            variant: y,
          }),
          M = ((e) => {
            const {
                classes: t,
                disabled: n,
                size: r,
                color: o,
                iconColor: a,
                onDelete: i,
                clickable: s,
                variant: l,
              } = e,
              c = {
                root: [
                  "root",
                  l,
                  n && "disabled",
                  `size${(0, Fn.Z)(r)}`,
                  `color${(0, Fn.Z)(o)}`,
                  s && "clickable",
                  s && `clickableColor${(0, Fn.Z)(o)}`,
                  i && "deletable",
                  i && `deletableColor${(0, Fn.Z)(o)}`,
                  `${l}${(0, Fn.Z)(o)}`,
                ],
                label: ["label", `label${(0, Fn.Z)(r)}`],
                avatar: [
                  "avatar",
                  `avatar${(0, Fn.Z)(r)}`,
                  `avatarColor${(0, Fn.Z)(o)}`,
                ],
                icon: [
                  "icon",
                  `icon${(0, Fn.Z)(r)}`,
                  `iconColor${(0, Fn.Z)(a)}`,
                ],
                deleteIcon: [
                  "deleteIcon",
                  `deleteIcon${(0, Fn.Z)(r)}`,
                  `deleteIconColor${(0, Fn.Z)(o)}`,
                  `deleteIcon${(0, Fn.Z)(l)}Color${(0, Fn.Z)(o)}`,
                ],
              };
            return (0, Nt.Z)(c, tc, t);
          })(T),
          E =
            I === Zn
              ? (0, d.Z)(
                  {
                    component: c || "div",
                    focusVisibleClassName: M.focusVisible,
                  },
                  g && { disableRipple: !0 }
                )
              : {};
        let D = null;
        g &&
          (D =
            u && t.isValidElement(u)
              ? t.cloneElement(u, {
                  className: (0, Rt.Z)(u.props.className, M.deleteIcon),
                  onClick: P,
                })
              : (0, e.jsx)(ec, {
                  className: (0, Rt.Z)(M.deleteIcon),
                  onClick: P,
                }));
        let j = null;
        a &&
          t.isValidElement(a) &&
          (j = t.cloneElement(a, {
            className: (0, Rt.Z)(M.avatar, a.props.className),
          }));
        let R = null;
        return (
          m &&
            t.isValidElement(m) &&
            (R = t.cloneElement(m, {
              className: (0, Rt.Z)(M.icon, m.props.className),
            })),
          (0, e.jsxs)(
            oc,
            (0, d.Z)(
              {
                as: I,
                className: (0, Rt.Z)(M.root, i),
                disabled: !(!O || !p) || void 0,
                onClick: f,
                onKeyDown: (e) => {
                  e.currentTarget === e.target && ic(e) && e.preventDefault(),
                    v && v(e);
                },
                onKeyUp: (e) => {
                  e.currentTarget === e.target &&
                    (g && ic(e)
                      ? g(e)
                      : "Escape" === e.key && k.current && k.current.blur()),
                    b && b(e);
                },
                ref: w,
                tabIndex: C && p ? -1 : x,
                ownerState: T,
              },
              E,
              S,
              {
                children: [
                  j || R,
                  (0, e.jsx)(ac, {
                    className: (0, Rt.Z)(M.label),
                    ownerState: T,
                    children: h,
                  }),
                  D,
                ],
              }
            )
          )
        );
      });
      var lc = sc;
      function cc(e) {
        return (0, Zt.ZP)("MuiInputBase", e);
      }
      var uc = (0, Bt.Z)("MuiInputBase", [
        "root",
        "formControl",
        "focused",
        "disabled",
        "adornedStart",
        "adornedEnd",
        "error",
        "sizeSmall",
        "multiline",
        "colorSecondary",
        "fullWidth",
        "hiddenLabel",
        "readOnly",
        "input",
        "inputSizeSmall",
        "inputMultiline",
        "inputTypeSearch",
        "inputAdornedStart",
        "inputAdornedEnd",
        "inputHiddenLabel",
      ]);
      function dc(e) {
        return (0, Zt.ZP)("MuiInput", e);
      }
      var pc = (0, d.Z)(
        {},
        uc,
        (0, Bt.Z)("MuiInput", ["root", "underline", "input"])
      );
      function mc(e) {
        return (0, Zt.ZP)("MuiOutlinedInput", e);
      }
      var hc = (0, d.Z)(
        {},
        uc,
        (0, Bt.Z)("MuiOutlinedInput", ["root", "notchedOutline", "input"])
      );
      function fc(e) {
        return (0, Zt.ZP)("MuiFilledInput", e);
      }
      var gc = (0, d.Z)(
          {},
          uc,
          (0, Bt.Z)("MuiFilledInput", ["root", "underline", "input"])
        ),
        vc = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
          }),
          "Close"
        ),
        bc = (0, bo.Z)(
          (0, e.jsx)("path", { d: "M7 10l5 5 5-5z" }),
          "ArrowDropDown"
        );
      function _c(e) {
        return zt.Z;
      }
      function yc(e) {
        return (0, Zt.ZP)("MuiAutocomplete", e);
      }
      var xc,
        Cc,
        Sc = (0, Bt.Z)("MuiAutocomplete", [
          "root",
          "expanded",
          "fullWidth",
          "focused",
          "focusVisible",
          "tag",
          "tagSizeSmall",
          "tagSizeMedium",
          "hasPopupIcon",
          "hasClearIcon",
          "inputRoot",
          "input",
          "inputFocused",
          "endAdornment",
          "clearIndicator",
          "popupIndicator",
          "popupIndicatorOpen",
          "popper",
          "popperDisablePortal",
          "paper",
          "listbox",
          "loading",
          "noOptions",
          "option",
          "groupLabel",
          "groupUl",
        ]);
      const kc = [
          "autoComplete",
          "autoHighlight",
          "autoSelect",
          "blurOnSelect",
          "ChipProps",
          "className",
          "clearIcon",
          "clearOnBlur",
          "clearOnEscape",
          "clearText",
          "closeText",
          "componentsProps",
          "defaultValue",
          "disableClearable",
          "disableCloseOnSelect",
          "disabled",
          "disabledItemsFocusable",
          "disableListWrap",
          "disablePortal",
          "filterOptions",
          "filterSelectedOptions",
          "forcePopupIcon",
          "freeSolo",
          "fullWidth",
          "getLimitTagsText",
          "getOptionDisabled",
          "getOptionKey",
          "getOptionLabel",
          "isOptionEqualToValue",
          "groupBy",
          "handleHomeEndKeys",
          "id",
          "includeInputInList",
          "inputValue",
          "limitTags",
          "ListboxComponent",
          "ListboxProps",
          "loading",
          "loadingText",
          "multiple",
          "noOptionsText",
          "onChange",
          "onClose",
          "onHighlightChange",
          "onInputChange",
          "onOpen",
          "open",
          "openOnFocus",
          "openText",
          "options",
          "PaperComponent",
          "PopperComponent",
          "popupIcon",
          "readOnly",
          "renderGroup",
          "renderInput",
          "renderOption",
          "renderTags",
          "selectOnFocus",
          "size",
          "slotProps",
          "value",
        ],
        wc = ["ref"],
        Pc = _c(),
        Oc = (0, Lt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              {
                fullWidth: r,
                hasClearIcon: o,
                hasPopupIcon: a,
                inputFocused: i,
                size: s,
              } = n;
            return [
              { [`& .${Sc.tag}`]: t.tag },
              { [`& .${Sc.tag}`]: t[`tagSize${(0, Fn.Z)(s)}`] },
              { [`& .${Sc.inputRoot}`]: t.inputRoot },
              { [`& .${Sc.input}`]: t.input },
              { [`& .${Sc.input}`]: i && t.inputFocused },
              t.root,
              r && t.fullWidth,
              a && t.hasPopupIcon,
              o && t.hasClearIcon,
            ];
          },
        })({
          [`&.${Sc.focused} .${Sc.clearIndicator}`]: { visibility: "visible" },
          "@media (pointer: fine)": {
            [`&:hover .${Sc.clearIndicator}`]: { visibility: "visible" },
          },
          [`& .${Sc.tag}`]: { margin: 3, maxWidth: "calc(100% - 6px)" },
          [`& .${Sc.inputRoot}`]: {
            flexWrap: "wrap",
            [`.${Sc.hasPopupIcon}&, .${Sc.hasClearIcon}&`]: {
              paddingRight: 30,
            },
            [`.${Sc.hasPopupIcon}.${Sc.hasClearIcon}&`]: { paddingRight: 56 },
            [`& .${Sc.input}`]: { width: 0, minWidth: 30 },
          },
          [`& .${pc.root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": { padding: "4px 4px 4px 0px" },
          },
          [`& .${pc.root}.${uc.sizeSmall}`]: {
            [`& .${pc.input}`]: { padding: "2px 4px 3px 0" },
          },
          [`& .${hc.root}`]: {
            padding: 9,
            [`.${Sc.hasPopupIcon}&, .${Sc.hasClearIcon}&`]: {
              paddingRight: 39,
            },
            [`.${Sc.hasPopupIcon}.${Sc.hasClearIcon}&`]: { paddingRight: 65 },
            [`& .${Sc.input}`]: { padding: "7.5px 4px 7.5px 5px" },
            [`& .${Sc.endAdornment}`]: { right: 9 },
          },
          [`& .${hc.root}.${uc.sizeSmall}`]: {
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${Sc.input}`]: { padding: "2.5px 4px 2.5px 8px" },
          },
          [`& .${gc.root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${Sc.hasPopupIcon}&, .${Sc.hasClearIcon}&`]: {
              paddingRight: 39,
            },
            [`.${Sc.hasPopupIcon}.${Sc.hasClearIcon}&`]: { paddingRight: 65 },
            [`& .${gc.input}`]: { padding: "7px 4px" },
            [`& .${Sc.endAdornment}`]: { right: 9 },
          },
          [`& .${gc.root}.${uc.sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${gc.input}`]: { padding: "2.5px 4px" },
          },
          [`& .${uc.hiddenLabel}`]: { paddingTop: 8 },
          [`& .${gc.root}.${uc.hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${Sc.input}`]: { paddingTop: 16, paddingBottom: 17 },
          },
          [`& .${gc.root}.${uc.hiddenLabel}.${uc.sizeSmall}`]: {
            [`& .${Sc.input}`]: { paddingTop: 8, paddingBottom: 9 },
          },
          [`& .${Sc.input}`]: {
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0,
          },
          variants: [
            { props: { fullWidth: !0 }, style: { width: "100%" } },
            {
              props: { size: "small" },
              style: {
                [`& .${Sc.tag}`]: { margin: 2, maxWidth: "calc(100% - 4px)" },
              },
            },
            {
              props: { inputFocused: !0 },
              style: { [`& .${Sc.input}`]: { opacity: 1 } },
            },
          ],
        }),
        Ic = (0, Lt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "EndAdornment",
          overridesResolver: (e, t) => t.endAdornment,
        })({
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translate(0, -50%)",
        }),
        Tc = (0, Lt.ZP)(Kn, {
          name: "MuiAutocomplete",
          slot: "ClearIndicator",
          overridesResolver: (e, t) => t.clearIndicator,
        })({ marginRight: -2, padding: 4, visibility: "hidden" }),
        Mc = (0, Lt.ZP)(Kn, {
          name: "MuiAutocomplete",
          slot: "PopupIndicator",
          overridesResolver: ({ ownerState: e }, t) =>
            (0, d.Z)({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen),
        })({
          padding: 2,
          marginRight: -2,
          variants: [
            {
              props: { popupOpen: !0 },
              style: { transform: "rotate(180deg)" },
            },
          ],
        }),
        Ec = (0, Lt.ZP)(il, {
          name: "MuiAutocomplete",
          slot: "Popper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${Sc.option}`]: t.option },
              t.popper,
              n.disablePortal && t.popperDisablePortal,
            ];
          },
        })(({ theme: e }) => ({
          zIndex: (e.vars || e).zIndex.modal,
          variants: [
            { props: { disablePortal: !0 }, style: { position: "absolute" } },
          ],
        })),
        Dc = (0, Lt.ZP)(io, {
          name: "MuiAutocomplete",
          slot: "Paper",
          overridesResolver: (e, t) => t.paper,
        })(({ theme: e }) =>
          (0, d.Z)({}, e.typography.body1, { overflow: "auto" })
        ),
        jc = (0, Lt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "Loading",
          overridesResolver: (e, t) => t.loading,
        })(({ theme: e }) => ({
          color: (e.vars || e).palette.text.secondary,
          padding: "14px 16px",
        })),
        Rc = (0, Lt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "NoOptions",
          overridesResolver: (e, t) => t.noOptions,
        })(({ theme: e }) => ({
          color: (e.vars || e).palette.text.secondary,
          padding: "14px 16px",
        })),
        Nc = (0, Lt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "Listbox",
          overridesResolver: (e, t) => t.listbox,
        })(({ theme: e }) => ({
          listStyle: "none",
          margin: 0,
          padding: "8px 0",
          maxHeight: "40vh",
          overflow: "auto",
          position: "relative",
          [`& .${Sc.option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [e.breakpoints.up("sm")]: { minHeight: "auto" },
            [`&.${Sc.focused}`]: {
              backgroundColor: (e.vars || e).palette.action.hover,
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
            '&[aria-disabled="true"]': {
              opacity: (e.vars || e).palette.action.disabledOpacity,
              pointerEvents: "none",
            },
            [`&.${Sc.focusVisible}`]: {
              backgroundColor: (e.vars || e).palette.action.focus,
            },
            '&[aria-selected="true"]': {
              backgroundColor: e.vars
                ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
                : (0, At.Fq)(
                    e.palette.primary.main,
                    e.palette.action.selectedOpacity
                  ),
              [`&.${Sc.focused}`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                  : (0, At.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity +
                        e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": {
                  backgroundColor: (e.vars || e).palette.action.selected,
                },
              },
              [`&.${Sc.focusVisible}`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                  : (0, At.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity +
                        e.palette.action.focusOpacity
                    ),
              },
            },
          },
        })),
        Ac = (0, Lt.ZP)(Xl, {
          name: "MuiAutocomplete",
          slot: "GroupLabel",
          overridesResolver: (e, t) => t.groupLabel,
        })(({ theme: e }) => ({
          backgroundColor: (e.vars || e).palette.background.paper,
          top: -8,
        })),
        Lc = (0, Lt.ZP)("ul", {
          name: "MuiAutocomplete",
          slot: "GroupUl",
          overridesResolver: (e, t) => t.groupUl,
        })({ padding: 0, [`& .${Sc.option}`]: { paddingLeft: 24 } }),
        zc = t.forwardRef(function (n, r) {
          var o, a, i, s;
          const l = Pc({ props: n, name: "MuiAutocomplete" }),
            {
              autoComplete: c = !1,
              autoHighlight: u = !1,
              autoSelect: p = !1,
              blurOnSelect: m = !1,
              ChipProps: h,
              className: f,
              clearIcon: g = xc || (xc = (0, e.jsx)(vc, { fontSize: "small" })),
              clearOnBlur: v = !l.freeSolo,
              clearOnEscape: b = !1,
              clearText: _ = "Clear",
              closeText: y = "Close",
              componentsProps: x = {},
              defaultValue: C = l.multiple ? [] : null,
              disableClearable: S = !1,
              disableCloseOnSelect: k = !1,
              disabled: w = !1,
              disabledItemsFocusable: P = !1,
              disableListWrap: O = !1,
              disablePortal: I = !1,
              filterSelectedOptions: T = !1,
              forcePopupIcon: M = "auto",
              freeSolo: E = !1,
              fullWidth: D = !1,
              getLimitTagsText: j = (e) => `+${e}`,
              getOptionLabel: R,
              groupBy: N,
              handleHomeEndKeys: A = !l.freeSolo,
              includeInputInList: L = !1,
              limitTags: z = -1,
              ListboxComponent: B = "ul",
              ListboxProps: Z,
              loading: F = !1,
              loadingText: H = "Loading…",
              multiple: V = !1,
              noOptionsText: W = "No options",
              openOnFocus: $ = !1,
              openText: U = "Open",
              PaperComponent: K = io,
              PopperComponent: G = il,
              popupIcon: q = Cc || (Cc = (0, e.jsx)(bc, {})),
              readOnly: Y = !1,
              renderGroup: J,
              renderInput: Q,
              renderOption: X,
              renderTags: ee,
              selectOnFocus: te = !l.freeSolo,
              size: ne = "medium",
              slotProps: re = {},
            } = l,
            oe = (0, jt.Z)(l, kc),
            {
              getRootProps: ae,
              getInputProps: ie,
              getInputLabelProps: se,
              getPopupIndicatorProps: le,
              getClearProps: ce,
              getTagProps: ue,
              getListboxProps: de,
              getOptionProps: pe,
              value: me,
              dirty: he,
              expanded: fe,
              id: ge,
              popupOpen: ve,
              focused: be,
              focusedTag: _e,
              anchorEl: ye,
              setAnchorEl: xe,
              inputValue: Ce,
              groupedOptions: Se,
            } = (function (e) {
              const {
                  unstable_isActiveElementInListbox: n = Gl,
                  unstable_classNamePrefix: r = "Mui",
                  autoComplete: o = !1,
                  autoHighlight: a = !1,
                  autoSelect: i = !1,
                  blurOnSelect: s = !1,
                  clearOnBlur: l = !e.freeSolo,
                  clearOnEscape: c = !1,
                  componentName: u = "useAutocomplete",
                  defaultValue: p = e.multiple ? [] : null,
                  disableClearable: m = !1,
                  disableCloseOnSelect: h = !1,
                  disabled: f,
                  disabledItemsFocusable: g = !1,
                  disableListWrap: v = !1,
                  filterOptions: b = Ul,
                  filterSelectedOptions: _ = !1,
                  freeSolo: y = !1,
                  getOptionDisabled: x,
                  getOptionKey: C,
                  getOptionLabel: S = (e) => {
                    var t;
                    return null != (t = e.label) ? t : e;
                  },
                  groupBy: k,
                  handleHomeEndKeys: w = !e.freeSolo,
                  id: P,
                  includeInputInList: O = !1,
                  inputValue: I,
                  isOptionEqualToValue: T = (e, t) => e === t,
                  multiple: M = !1,
                  onChange: E,
                  onClose: D,
                  onHighlightChange: j,
                  onInputChange: R,
                  onOpen: N,
                  open: A,
                  openOnFocus: L = !1,
                  options: z,
                  readOnly: B = !1,
                  selectOnFocus: Z = !e.freeSolo,
                  value: F,
                } = e,
                H = (0, Fl.Z)(P);
              let V = S;
              V = (e) => {
                const t = S(e);
                return "string" != typeof t ? String(t) : t;
              };
              const W = t.useRef(!1),
                $ = t.useRef(!0),
                U = t.useRef(null),
                K = t.useRef(null),
                [G, q] = t.useState(null),
                [Y, J] = t.useState(-1),
                Q = a ? 0 : -1,
                X = t.useRef(Q),
                [ee, te] = (0, Hl.Z)({ controlled: F, default: p, name: u }),
                [ne, re] = (0, Hl.Z)({
                  controlled: I,
                  default: "",
                  name: u,
                  state: "inputValue",
                }),
                [oe, ae] = t.useState(!1),
                ie = t.useCallback(
                  (e, t) => {
                    if (!(M ? ee.length < t.length : null !== t) && !l) return;
                    let n;
                    if (M) n = "";
                    else if (null == t) n = "";
                    else {
                      const e = V(t);
                      n = "string" == typeof e ? e : "";
                    }
                    ne !== n && (re(n), R && R(e, n, "reset"));
                  },
                  [V, ne, M, R, re, l, ee]
                ),
                [se, le] = (0, Hl.Z)({
                  controlled: A,
                  default: !1,
                  name: u,
                  state: "open",
                }),
                [ce, ue] = t.useState(!0),
                de = !M && null != ee && ne === V(ee),
                pe = se && !B,
                me = pe
                  ? b(
                      z.filter(
                        (e) =>
                          !_ ||
                          !(M ? ee : [ee]).some((t) => null !== t && T(e, t))
                      ),
                      { inputValue: de && ce ? "" : ne, getOptionLabel: V }
                    )
                  : [],
                he = Vl({ filteredOptions: me, value: ee, inputValue: ne });
              t.useEffect(() => {
                const e = ee !== he.value;
                (oe && !e) || (y && !e) || ie(null, ee);
              }, [ee, ie, oe, he.value, y]);
              const fe = se && me.length > 0 && !B,
                ge = (0, lr.Z)((e) => {
                  -1 === e
                    ? U.current.focus()
                    : G.querySelector(`[data-tag-index="${e}"]`).focus();
                });
              t.useEffect(() => {
                M && Y > ee.length - 1 && (J(-1), ge(-1));
              }, [ee, M, Y, ge]);
              const ve = (0, lr.Z)(
                  ({ event: e, index: t, reason: n = "auto" }) => {
                    if (
                      ((X.current = t),
                      -1 === t
                        ? U.current.removeAttribute("aria-activedescendant")
                        : U.current.setAttribute(
                            "aria-activedescendant",
                            `${H}-option-${t}`
                          ),
                      j && j(e, -1 === t ? null : me[t], n),
                      !K.current)
                    )
                      return;
                    const o = K.current.querySelector(
                      `[role="option"].${r}-focused`
                    );
                    o &&
                      (o.classList.remove(`${r}-focused`),
                      o.classList.remove(`${r}-focusVisible`));
                    let a = K.current;
                    if (
                      ("listbox" !== K.current.getAttribute("role") &&
                        (a =
                          K.current.parentElement.querySelector(
                            '[role="listbox"]'
                          )),
                      !a)
                    )
                      return;
                    if (-1 === t) return void (a.scrollTop = 0);
                    const i = K.current.querySelector(
                      `[data-option-index="${t}"]`
                    );
                    if (
                      i &&
                      (i.classList.add(`${r}-focused`),
                      "keyboard" === n && i.classList.add(`${r}-focusVisible`),
                      a.scrollHeight > a.clientHeight &&
                        "mouse" !== n &&
                        "touch" !== n)
                    ) {
                      const e = i,
                        t = a.clientHeight + a.scrollTop,
                        n = e.offsetTop + e.offsetHeight;
                      n > t
                        ? (a.scrollTop = n - a.clientHeight)
                        : e.offsetTop - e.offsetHeight * (k ? 1.3 : 0) <
                            a.scrollTop &&
                          (a.scrollTop =
                            e.offsetTop - e.offsetHeight * (k ? 1.3 : 0));
                    }
                  }
                ),
                be = (0, lr.Z)(
                  ({
                    event: e,
                    diff: t,
                    direction: n = "next",
                    reason: r = "auto",
                  }) => {
                    if (!pe) return;
                    const a = (function (e, t) {
                      if (!K.current || e < 0 || e >= me.length) return -1;
                      let n = e;
                      for (;;) {
                        const r = K.current.querySelector(
                            `[data-option-index="${n}"]`
                          ),
                          o =
                            !g &&
                            (!r ||
                              r.disabled ||
                              "true" === r.getAttribute("aria-disabled"));
                        if (r && r.hasAttribute("tabindex") && !o) return n;
                        if (
                          ((n =
                            "next" === t
                              ? (n + 1) % me.length
                              : (n - 1 + me.length) % me.length),
                          n === e)
                        )
                          return -1;
                      }
                    })(
                      (() => {
                        const e = me.length - 1;
                        if ("reset" === t) return Q;
                        if ("start" === t) return 0;
                        if ("end" === t) return e;
                        const n = X.current + t;
                        return n < 0
                          ? -1 === n && O
                            ? -1
                            : (v && -1 !== X.current) || Math.abs(t) > 1
                            ? 0
                            : e
                          : n > e
                          ? n === e + 1 && O
                            ? -1
                            : v || Math.abs(t) > 1
                            ? e
                            : 0
                          : n;
                      })(),
                      n
                    );
                    if (
                      (ve({ index: a, reason: r, event: e }),
                      o && "reset" !== t)
                    )
                      if (-1 === a) U.current.value = ne;
                      else {
                        const e = V(me[a]);
                        (U.current.value = e),
                          0 === e.toLowerCase().indexOf(ne.toLowerCase()) &&
                            ne.length > 0 &&
                            U.current.setSelectionRange(ne.length, e.length);
                      }
                  }
                ),
                _e = t.useCallback(() => {
                  if (!pe) return;
                  const e = (() => {
                    if (
                      -1 !== X.current &&
                      he.filteredOptions &&
                      he.filteredOptions.length !== me.length &&
                      he.inputValue === ne &&
                      (M
                        ? ee.length === he.value.length &&
                          he.value.every((e, t) => V(ee[t]) === V(e))
                        : ((e = he.value),
                          (t = ee),
                          (e ? V(e) : "") === (t ? V(t) : "")))
                    ) {
                      const e = he.filteredOptions[X.current];
                      if (e) return $l(me, (t) => V(t) === V(e));
                    }
                    var e, t;
                    return -1;
                  })();
                  if (-1 !== e) return void (X.current = e);
                  const t = M ? ee[0] : ee;
                  if (0 !== me.length && null != t) {
                    if (K.current)
                      if (null == t)
                        X.current >= me.length - 1
                          ? ve({ index: me.length - 1 })
                          : ve({ index: X.current });
                      else {
                        const e = me[X.current];
                        if (M && e && -1 !== $l(ee, (t) => T(e, t))) return;
                        const n = $l(me, (e) => T(e, t));
                        -1 === n ? be({ diff: "reset" }) : ve({ index: n });
                      }
                  } else be({ diff: "reset" });
                }, [me.length, !M && ee, _, be, ve, pe, ne, M]),
                ye = (0, lr.Z)((e) => {
                  (0, Cr.Z)(K, e), e && _e();
                });
              t.useEffect(() => {
                _e();
              }, [_e]);
              const xe = (e) => {
                  se || (le(!0), ue(!0), N && N(e));
                },
                Ce = (e, t) => {
                  se && (le(!1), D && D(e, t));
                },
                Se = (e, t, n, r) => {
                  if (M) {
                    if (
                      ee.length === t.length &&
                      ee.every((e, n) => e === t[n])
                    )
                      return;
                  } else if (ee === t) return;
                  E && E(e, t, n, r), te(t);
                },
                ke = t.useRef(!1),
                we = (e, t, n = "selectOption", r = "options") => {
                  let o = n,
                    a = t;
                  if (M) {
                    a = Array.isArray(ee) ? ee.slice() : [];
                    const e = $l(a, (e) => T(t, e));
                    -1 === e
                      ? a.push(t)
                      : "freeSolo" !== r &&
                        (a.splice(e, 1), (o = "removeOption"));
                  }
                  ie(e, a),
                    Se(e, a, o, { option: t }),
                    h || (e && (e.ctrlKey || e.metaKey)) || Ce(e, o),
                    (!0 === s ||
                      ("touch" === s && ke.current) ||
                      ("mouse" === s && !ke.current)) &&
                      U.current.blur();
                },
                Pe = (e, t) => {
                  if (!M) return;
                  "" === ne && Ce(e, "toggleInput");
                  let n = Y;
                  -1 === Y
                    ? "" === ne && "previous" === t && (n = ee.length - 1)
                    : ((n += "next" === t ? 1 : -1),
                      n < 0 && (n = 0),
                      n === ee.length && (n = -1)),
                    (n = (function (e, t) {
                      if (-1 === e) return -1;
                      let n = e;
                      for (;;) {
                        if (
                          ("next" === t && n === ee.length) ||
                          ("previous" === t && -1 === n)
                        )
                          return -1;
                        const e = G.querySelector(`[data-tag-index="${n}"]`);
                        if (
                          e &&
                          e.hasAttribute("tabindex") &&
                          !e.disabled &&
                          "true" !== e.getAttribute("aria-disabled")
                        )
                          return n;
                        n += "next" === t ? 1 : -1;
                      }
                    })(n, t)),
                    J(n),
                    ge(n);
                },
                Oe = (e) => {
                  (W.current = !0),
                    re(""),
                    R && R(e, "", "clear"),
                    Se(e, M ? [] : null, "clear");
                },
                Ie = (e) => (t) => {
                  if (
                    (e.onKeyDown && e.onKeyDown(t),
                    !t.defaultMuiPrevented &&
                      (-1 !== Y &&
                        -1 === ["ArrowLeft", "ArrowRight"].indexOf(t.key) &&
                        (J(-1), ge(-1)),
                      229 !== t.which))
                  )
                    switch (t.key) {
                      case "Home":
                        pe &&
                          w &&
                          (t.preventDefault(),
                          be({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: t,
                          }));
                        break;
                      case "End":
                        pe &&
                          w &&
                          (t.preventDefault(),
                          be({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: t,
                          }));
                        break;
                      case "PageUp":
                        t.preventDefault(),
                          be({
                            diff: -Kl,
                            direction: "previous",
                            reason: "keyboard",
                            event: t,
                          }),
                          xe(t);
                        break;
                      case "PageDown":
                        t.preventDefault(),
                          be({
                            diff: Kl,
                            direction: "next",
                            reason: "keyboard",
                            event: t,
                          }),
                          xe(t);
                        break;
                      case "ArrowDown":
                        t.preventDefault(),
                          be({
                            diff: 1,
                            direction: "next",
                            reason: "keyboard",
                            event: t,
                          }),
                          xe(t);
                        break;
                      case "ArrowUp":
                        t.preventDefault(),
                          be({
                            diff: -1,
                            direction: "previous",
                            reason: "keyboard",
                            event: t,
                          }),
                          xe(t);
                        break;
                      case "ArrowLeft":
                        Pe(t, "previous");
                        break;
                      case "ArrowRight":
                        Pe(t, "next");
                        break;
                      case "Enter":
                        if (-1 !== X.current && pe) {
                          const e = me[X.current],
                            n = !!x && x(e);
                          if ((t.preventDefault(), n)) return;
                          we(t, e, "selectOption"),
                            o &&
                              U.current.setSelectionRange(
                                U.current.value.length,
                                U.current.value.length
                              );
                        } else
                          y &&
                            "" !== ne &&
                            !1 === de &&
                            (M && t.preventDefault(),
                            we(t, ne, "createOption", "freeSolo"));
                        break;
                      case "Escape":
                        pe
                          ? (t.preventDefault(),
                            t.stopPropagation(),
                            Ce(t, "escape"))
                          : c &&
                            ("" !== ne || (M && ee.length > 0)) &&
                            (t.preventDefault(), t.stopPropagation(), Oe(t));
                        break;
                      case "Backspace":
                        if (M && !B && "" === ne && ee.length > 0) {
                          const e = -1 === Y ? ee.length - 1 : Y,
                            n = ee.slice();
                          n.splice(e, 1),
                            Se(t, n, "removeOption", { option: ee[e] });
                        }
                        break;
                      case "Delete":
                        if (M && !B && "" === ne && ee.length > 0 && -1 !== Y) {
                          const e = Y,
                            n = ee.slice();
                          n.splice(e, 1),
                            Se(t, n, "removeOption", { option: ee[e] });
                        }
                    }
                },
                Te = (e) => {
                  ae(!0), L && !W.current && xe(e);
                },
                Me = (e) => {
                  n(K)
                    ? U.current.focus()
                    : (ae(!1),
                      ($.current = !0),
                      (W.current = !1),
                      i && -1 !== X.current && pe
                        ? we(e, me[X.current], "blur")
                        : i && y && "" !== ne
                        ? we(e, ne, "blur", "freeSolo")
                        : l && ie(e, ee),
                      Ce(e, "blur"));
                },
                Ee = (e) => {
                  const t = e.target.value;
                  ne !== t && (re(t), ue(!1), R && R(e, t, "input")),
                    "" === t ? m || M || Se(e, null, "clear") : xe(e);
                },
                De = (e) => {
                  const t = Number(
                    e.currentTarget.getAttribute("data-option-index")
                  );
                  X.current !== t &&
                    ve({ event: e, index: t, reason: "mouse" });
                },
                je = (e) => {
                  ve({
                    event: e,
                    index: Number(
                      e.currentTarget.getAttribute("data-option-index")
                    ),
                    reason: "touch",
                  }),
                    (ke.current = !0);
                },
                Re = (e) => {
                  const t = Number(
                    e.currentTarget.getAttribute("data-option-index")
                  );
                  we(e, me[t], "selectOption"), (ke.current = !1);
                },
                Ne = (e) => (t) => {
                  const n = ee.slice();
                  n.splice(e, 1), Se(t, n, "removeOption", { option: ee[e] });
                },
                Ae = (e) => {
                  se ? Ce(e, "toggleInput") : xe(e);
                },
                Le = (e) => {
                  e.currentTarget.contains(e.target) &&
                    e.target.getAttribute("id") !== H &&
                    e.preventDefault();
                },
                ze = (e) => {
                  e.currentTarget.contains(e.target) &&
                    (U.current.focus(),
                    Z &&
                      $.current &&
                      U.current.selectionEnd - U.current.selectionStart == 0 &&
                      U.current.select(),
                    ($.current = !1));
                },
                Be = (e) => {
                  f || ("" !== ne && se) || Ae(e);
                };
              let Ze = y && ne.length > 0;
              Ze = Ze || (M ? ee.length > 0 : null !== ee);
              let Fe = me;
              return (
                k &&
                  (new Map(),
                  (Fe = me.reduce((e, t, n) => {
                    const r = k(t);
                    return (
                      e.length > 0 && e[e.length - 1].group === r
                        ? e[e.length - 1].options.push(t)
                        : e.push({ key: n, index: n, group: r, options: [t] }),
                      e
                    );
                  }, []))),
                f && oe && Me(),
                {
                  getRootProps: (e = {}) =>
                    (0, d.Z)({ "aria-owns": fe ? `${H}-listbox` : null }, e, {
                      onKeyDown: Ie(e),
                      onMouseDown: Le,
                      onClick: ze,
                    }),
                  getInputLabelProps: () => ({ id: `${H}-label`, htmlFor: H }),
                  getInputProps: () => ({
                    id: H,
                    value: ne,
                    onBlur: Me,
                    onFocus: Te,
                    onChange: Ee,
                    onMouseDown: Be,
                    "aria-activedescendant": pe ? "" : null,
                    "aria-autocomplete": o ? "both" : "list",
                    "aria-controls": fe ? `${H}-listbox` : void 0,
                    "aria-expanded": fe,
                    autoComplete: "off",
                    ref: U,
                    autoCapitalize: "none",
                    spellCheck: "false",
                    role: "combobox",
                    disabled: f,
                  }),
                  getClearProps: () => ({
                    tabIndex: -1,
                    type: "button",
                    onClick: Oe,
                  }),
                  getPopupIndicatorProps: () => ({
                    tabIndex: -1,
                    type: "button",
                    onClick: Ae,
                  }),
                  getTagProps: ({ index: e }) =>
                    (0, d.Z)(
                      { key: e, "data-tag-index": e, tabIndex: -1 },
                      !B && { onDelete: Ne(e) }
                    ),
                  getListboxProps: () => ({
                    role: "listbox",
                    id: `${H}-listbox`,
                    "aria-labelledby": `${H}-label`,
                    ref: ye,
                    onMouseDown: (e) => {
                      e.preventDefault();
                    },
                  }),
                  getOptionProps: ({ index: e, option: t }) => {
                    var n;
                    const r = (M ? ee : [ee]).some((e) => null != e && T(t, e)),
                      o = !!x && x(t);
                    return {
                      key: null != (n = null == C ? void 0 : C(t)) ? n : V(t),
                      tabIndex: -1,
                      role: "option",
                      id: `${H}-option-${e}`,
                      onMouseMove: De,
                      onClick: Re,
                      onTouchStart: je,
                      "data-option-index": e,
                      "aria-disabled": o,
                      "aria-selected": r,
                    };
                  },
                  id: H,
                  inputValue: ne,
                  value: ee,
                  dirty: Ze,
                  expanded: pe && G,
                  popupOpen: pe,
                  focused: oe || -1 !== Y,
                  anchorEl: G,
                  setAnchorEl: q,
                  focusedTag: Y,
                  groupedOptions: Fe,
                }
              );
            })((0, d.Z)({}, l, { componentName: "Autocomplete" })),
            ke = !S && !w && he && !Y,
            we = (!E || !0 === M) && !1 !== M,
            { onMouseDown: Pe } = ie(),
            { ref: Oe } = null != Z ? Z : {},
            Ie = de(),
            { ref: Te } = Ie,
            Me = (0, jt.Z)(Ie, wc),
            Ee = (0, cn.Z)(Te, Oe),
            De =
              R ||
              ((e) => {
                var t;
                return null != (t = e.label) ? t : e;
              }),
            je = (0, d.Z)({}, l, {
              disablePortal: I,
              expanded: fe,
              focused: be,
              fullWidth: D,
              getOptionLabel: De,
              hasClearIcon: ke,
              hasPopupIcon: we,
              inputFocused: -1 === _e,
              popupOpen: ve,
              size: ne,
            }),
            Re = ((e) => {
              const {
                  classes: t,
                  disablePortal: n,
                  expanded: r,
                  focused: o,
                  fullWidth: a,
                  hasClearIcon: i,
                  hasPopupIcon: s,
                  inputFocused: l,
                  popupOpen: c,
                  size: u,
                } = e,
                d = {
                  root: [
                    "root",
                    r && "expanded",
                    o && "focused",
                    a && "fullWidth",
                    i && "hasClearIcon",
                    s && "hasPopupIcon",
                  ],
                  inputRoot: ["inputRoot"],
                  input: ["input", l && "inputFocused"],
                  tag: ["tag", `tagSize${(0, Fn.Z)(u)}`],
                  endAdornment: ["endAdornment"],
                  clearIndicator: ["clearIndicator"],
                  popupIndicator: ["popupIndicator", c && "popupIndicatorOpen"],
                  popper: ["popper", n && "popperDisablePortal"],
                  paper: ["paper"],
                  listbox: ["listbox"],
                  loading: ["loading"],
                  noOptions: ["noOptions"],
                  option: ["option"],
                  groupLabel: ["groupLabel"],
                  groupUl: ["groupUl"],
                };
              return (0, Nt.Z)(d, yc, t);
            })(je);
          let Ne;
          if (V && me.length > 0) {
            const t = (e) =>
              (0, d.Z)({ className: Re.tag, disabled: w }, ue(e));
            Ne = ee
              ? ee(me, t, je)
              : me.map((n, r) =>
                  (0, e.jsx)(
                    lc,
                    (0, d.Z)({ label: De(n), size: ne }, t({ index: r }), h)
                  )
                );
          }
          if (z > -1 && Array.isArray(Ne)) {
            const t = Ne.length - z;
            !be &&
              t > 0 &&
              ((Ne = Ne.splice(0, z)),
              Ne.push(
                (0, e.jsx)(
                  "span",
                  { className: Re.tag, children: j(t) },
                  Ne.length
                )
              ));
          }
          const Ae =
              J ||
              ((t) =>
                (0, e.jsxs)(
                  "li",
                  {
                    children: [
                      (0, e.jsx)(Ac, {
                        className: Re.groupLabel,
                        ownerState: je,
                        component: "div",
                        children: t.group,
                      }),
                      (0, e.jsx)(Lc, {
                        className: Re.groupUl,
                        ownerState: je,
                        children: t.children,
                      }),
                    ],
                  },
                  t.key
                )),
            Le =
              X ||
              ((e, n) =>
                (0, t.createElement)(
                  "li",
                  (0, d.Z)({}, e, { key: e.key }),
                  De(n)
                )),
            ze = (e, t) => {
              const n = pe({ option: e, index: t });
              return Le(
                (0, d.Z)({}, n, { className: Re.option }),
                e,
                { selected: n["aria-selected"], index: t, inputValue: Ce },
                je
              );
            },
            Be = null != (o = re.clearIndicator) ? o : x.clearIndicator,
            Ze = null != (a = re.paper) ? a : x.paper,
            Fe = null != (i = re.popper) ? i : x.popper,
            He = null != (s = re.popupIndicator) ? s : x.popupIndicator,
            Ve = (t) =>
              (0, e.jsx)(
                Ec,
                (0, d.Z)(
                  {
                    as: G,
                    disablePortal: I,
                    style: { width: ye ? ye.clientWidth : null },
                    ownerState: je,
                    role: "presentation",
                    anchorEl: ye,
                    open: ve,
                  },
                  Fe,
                  {
                    className: (0, Rt.Z)(
                      Re.popper,
                      null == Fe ? void 0 : Fe.className
                    ),
                    children: (0, e.jsx)(
                      Dc,
                      (0, d.Z)({ ownerState: je, as: K }, Ze, {
                        className: (0, Rt.Z)(
                          Re.paper,
                          null == Ze ? void 0 : Ze.className
                        ),
                        children: t,
                      })
                    ),
                  }
                )
              );
          let We = null;
          return (
            !F && Se.length > 0
              ? (We = Ve(
                  (0, e.jsx)(
                    Nc,
                    (0, d.Z)(
                      { as: B, className: Re.listbox, ownerState: je },
                      Me,
                      Z,
                      {
                        ref: Ee,
                        children: Se.map((e, t) =>
                          N
                            ? Ae({
                                key: e.key,
                                group: e.group,
                                children: e.options.map((t, n) =>
                                  ze(t, e.index + n)
                                ),
                              })
                            : ze(e, t)
                        ),
                      }
                    )
                  )
                ))
              : F && 0 === Se.length
              ? (We = Ve(
                  (0, e.jsx)(jc, {
                    className: Re.loading,
                    ownerState: je,
                    children: H,
                  })
                ))
              : 0 !== Se.length ||
                E ||
                F ||
                (We = Ve(
                  (0, e.jsx)(Rc, {
                    className: Re.noOptions,
                    ownerState: je,
                    role: "presentation",
                    onMouseDown: (e) => {
                      e.preventDefault();
                    },
                    children: W,
                  })
                )),
            (0, e.jsxs)(t.Fragment, {
              children: [
                (0, e.jsx)(
                  Oc,
                  (0, d.Z)(
                    {
                      ref: r,
                      className: (0, Rt.Z)(Re.root, f),
                      ownerState: je,
                    },
                    ae(oe),
                    {
                      children: Q({
                        id: ge,
                        disabled: w,
                        fullWidth: !0,
                        size: "small" === ne ? "small" : void 0,
                        InputLabelProps: se(),
                        InputProps: (0, d.Z)(
                          {
                            ref: xe,
                            className: Re.inputRoot,
                            startAdornment: Ne,
                            onClick: (e) => {
                              e.target === e.currentTarget && Pe(e);
                            },
                          },
                          (ke || we) && {
                            endAdornment: (0, e.jsxs)(Ic, {
                              className: Re.endAdornment,
                              ownerState: je,
                              children: [
                                ke
                                  ? (0, e.jsx)(
                                      Tc,
                                      (0, d.Z)(
                                        {},
                                        ce(),
                                        {
                                          "aria-label": _,
                                          title: _,
                                          ownerState: je,
                                        },
                                        Be,
                                        {
                                          className: (0, Rt.Z)(
                                            Re.clearIndicator,
                                            null == Be ? void 0 : Be.className
                                          ),
                                          children: g,
                                        }
                                      )
                                    )
                                  : null,
                                we
                                  ? (0, e.jsx)(
                                      Mc,
                                      (0, d.Z)(
                                        {},
                                        le(),
                                        {
                                          disabled: w,
                                          "aria-label": ve ? y : U,
                                          title: ve ? y : U,
                                          ownerState: je,
                                        },
                                        He,
                                        {
                                          className: (0, Rt.Z)(
                                            Re.popupIndicator,
                                            null == He ? void 0 : He.className
                                          ),
                                          children: q,
                                        }
                                      )
                                    )
                                  : null,
                              ],
                            }),
                          }
                        ),
                        inputProps: (0, d.Z)(
                          { className: Re.input, disabled: w, readOnly: Y },
                          ie()
                        ),
                      }),
                    }
                  )
                ),
                ye ? We : null,
              ],
            })
          );
        });
      var Bc = zc,
        Zc = o(8027),
        Fc = o(8758),
        Hc = o(6145);
      const Vc = ["onChange", "maxRows", "minRows", "style", "value"];
      function Wc(e) {
        return parseInt(e, 10) || 0;
      }
      const $c = {
          visibility: "hidden",
          position: "absolute",
          overflow: "hidden",
          height: 0,
          top: 0,
          left: 0,
          transform: "translateZ(0)",
        },
        Uc = t.forwardRef(function (n, r) {
          const {
              onChange: o,
              maxRows: a,
              minRows: i = 1,
              style: s,
              value: l,
            } = n,
            c = (0, jt.Z)(n, Vc),
            { current: u } = t.useRef(null != l),
            p = t.useRef(null),
            m = (0, Qn.Z)(r, p),
            h = t.useRef(null),
            f = t.useCallback(() => {
              const e = p.current,
                t = (0, ur.Z)(e).getComputedStyle(e);
              if ("0px" === t.width)
                return { outerHeightStyle: 0, overflowing: !1 };
              const r = h.current;
              (r.style.width = t.width),
                (r.value = e.value || n.placeholder || "x"),
                "\n" === r.value.slice(-1) && (r.value += " ");
              const o = t.boxSizing,
                s = Wc(t.paddingBottom) + Wc(t.paddingTop),
                l = Wc(t.borderBottomWidth) + Wc(t.borderTopWidth),
                c = r.scrollHeight;
              r.value = "x";
              const u = r.scrollHeight;
              let d = c;
              return (
                i && (d = Math.max(Number(i) * u, d)),
                a && (d = Math.min(Number(a) * u, d)),
                (d = Math.max(d, u)),
                {
                  outerHeightStyle: d + ("border-box" === o ? s + l : 0),
                  overflowing: Math.abs(d - c) <= 1,
                }
              );
            }, [a, i, n.placeholder]),
            g = t.useCallback(() => {
              const e = f();
              if (
                null == (t = e) ||
                0 === Object.keys(t).length ||
                (0 === t.outerHeightStyle && !t.overflowing)
              )
                return;
              var t;
              const n = p.current;
              (n.style.height = `${e.outerHeightStyle}px`),
                (n.style.overflow = e.overflowing ? "hidden" : "");
            }, [f]);
          return (
            (0, xr.Z)(() => {
              const e = () => {
                g();
              };
              const t = (0, Hc.Z)(e),
                n = p.current,
                r = (0, ur.Z)(n);
              let o;
              return (
                r.addEventListener("resize", t),
                "undefined" != typeof ResizeObserver &&
                  ((o = new ResizeObserver(e)), o.observe(n)),
                () => {
                  t.clear(),
                    cancelAnimationFrame(undefined),
                    r.removeEventListener("resize", t),
                    o && o.disconnect();
                }
              );
            }, [f, g]),
            (0, xr.Z)(() => {
              g();
            }),
            (0, e.jsxs)(t.Fragment, {
              children: [
                (0, e.jsx)(
                  "textarea",
                  (0, d.Z)(
                    {
                      value: l,
                      onChange: (e) => {
                        u || g(), o && o(e);
                      },
                      ref: m,
                      rows: i,
                      style: s,
                    },
                    c
                  )
                ),
                (0, e.jsx)("textarea", {
                  "aria-hidden": !0,
                  className: n.className,
                  readOnly: !0,
                  ref: h,
                  tabIndex: -1,
                  style: (0, d.Z)({}, $c, s, {
                    paddingTop: 0,
                    paddingBottom: 0,
                  }),
                }),
              ],
            })
          );
        });
      function Kc({ props: e, states: t, muiFormControl: n }) {
        return t.reduce(
          (t, r) => ((t[r] = e[r]), n && void 0 === e[r] && (t[r] = n[r]), t),
          {}
        );
      }
      var Gc = t.createContext(void 0);
      function qc() {
        return t.useContext(Gc);
      }
      var Yc = o(1234),
        Jc = function ({ styles: t, themeId: n, defaultTheme: r = {} }) {
          const o = (0, Xt.Z)(r),
            a = "function" == typeof t ? t((n && o[n]) || o) : t;
          return (0, e.jsx)(Yc.Z, { styles: a });
        },
        Qc = function (t) {
          return (0, e.jsx)(
            Jc,
            (0, d.Z)({}, t, { defaultTheme: Dr.Z, themeId: on.Z })
          );
        };
      function Xc(e) {
        return null != e && !(Array.isArray(e) && 0 === e.length);
      }
      function eu(e, t = !1) {
        return (
          e &&
          ((Xc(e.value) && "" !== e.value) ||
            (t && Xc(e.defaultValue) && "" !== e.defaultValue))
        );
      }
      const tu = [
          "aria-describedby",
          "autoComplete",
          "autoFocus",
          "className",
          "color",
          "components",
          "componentsProps",
          "defaultValue",
          "disabled",
          "disableInjectingGlobalStyles",
          "endAdornment",
          "error",
          "fullWidth",
          "id",
          "inputComponent",
          "inputProps",
          "inputRef",
          "margin",
          "maxRows",
          "minRows",
          "multiline",
          "name",
          "onBlur",
          "onChange",
          "onClick",
          "onFocus",
          "onKeyDown",
          "onKeyUp",
          "placeholder",
          "readOnly",
          "renderSuffix",
          "rows",
          "size",
          "slotProps",
          "slots",
          "startAdornment",
          "type",
          "value",
        ],
        nu = (e, t) => {
          const { ownerState: n } = e;
          return [
            t.root,
            n.formControl && t.formControl,
            n.startAdornment && t.adornedStart,
            n.endAdornment && t.adornedEnd,
            n.error && t.error,
            "small" === n.size && t.sizeSmall,
            n.multiline && t.multiline,
            n.color && t[`color${(0, Fn.Z)(n.color)}`],
            n.fullWidth && t.fullWidth,
            n.hiddenLabel && t.hiddenLabel,
          ];
        },
        ru = (e, t) => {
          const { ownerState: n } = e;
          return [
            t.input,
            "small" === n.size && t.inputSizeSmall,
            n.multiline && t.inputMultiline,
            "search" === n.type && t.inputTypeSearch,
            n.startAdornment && t.inputAdornedStart,
            n.endAdornment && t.inputAdornedEnd,
            n.hiddenLabel && t.inputHiddenLabel,
          ];
        },
        ou = (0, Lt.ZP)("div", {
          name: "MuiInputBase",
          slot: "Root",
          overridesResolver: nu,
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {},
            e.typography.body1,
            {
              color: (e.vars || e).palette.text.primary,
              lineHeight: "1.4375em",
              boxSizing: "border-box",
              position: "relative",
              cursor: "text",
              display: "inline-flex",
              alignItems: "center",
              [`&.${uc.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
                cursor: "default",
              },
            },
            t.multiline &&
              (0, d.Z)(
                { padding: "4px 0 5px" },
                "small" === t.size && { paddingTop: 1 }
              ),
            t.fullWidth && { width: "100%" }
          )
        ),
        au = (0, Lt.ZP)("input", {
          name: "MuiInputBase",
          slot: "Input",
          overridesResolver: ru,
        })(({ theme: e, ownerState: t }) => {
          const n = "light" === e.palette.mode,
            r = (0, d.Z)(
              { color: "currentColor" },
              e.vars
                ? { opacity: e.vars.opacity.inputPlaceholder }
                : { opacity: n ? 0.42 : 0.5 },
              {
                transition: e.transitions.create("opacity", {
                  duration: e.transitions.duration.shorter,
                }),
              }
            ),
            o = { opacity: "0 !important" },
            a = e.vars
              ? { opacity: e.vars.opacity.inputPlaceholder }
              : { opacity: n ? 0.42 : 0.5 };
          return (0, d.Z)(
            {
              font: "inherit",
              letterSpacing: "inherit",
              color: "currentColor",
              padding: "4px 0 5px",
              border: 0,
              boxSizing: "content-box",
              background: "none",
              height: "1.4375em",
              margin: 0,
              WebkitTapHighlightColor: "transparent",
              display: "block",
              minWidth: 0,
              width: "100%",
              animationName: "mui-auto-fill-cancel",
              animationDuration: "10ms",
              "&::-webkit-input-placeholder": r,
              "&::-moz-placeholder": r,
              "&:-ms-input-placeholder": r,
              "&::-ms-input-placeholder": r,
              "&:focus": { outline: 0 },
              "&:invalid": { boxShadow: "none" },
              "&::-webkit-search-decoration": { WebkitAppearance: "none" },
              [`label[data-shrink=false] + .${uc.formControl} &`]: {
                "&::-webkit-input-placeholder": o,
                "&::-moz-placeholder": o,
                "&:-ms-input-placeholder": o,
                "&::-ms-input-placeholder": o,
                "&:focus::-webkit-input-placeholder": a,
                "&:focus::-moz-placeholder": a,
                "&:focus:-ms-input-placeholder": a,
                "&:focus::-ms-input-placeholder": a,
              },
              [`&.${uc.disabled}`]: {
                opacity: 1,
                WebkitTextFillColor: (e.vars || e).palette.text.disabled,
              },
              "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill",
              },
            },
            "small" === t.size && { paddingTop: 1 },
            t.multiline && {
              height: "auto",
              resize: "none",
              padding: 0,
              paddingTop: 0,
            },
            "search" === t.type && { MozAppearance: "textfield" }
          );
        }),
        iu = (0, e.jsx)(Qc, {
          styles: {
            "@keyframes mui-auto-fill": { from: { display: "block" } },
            "@keyframes mui-auto-fill-cancel": { from: { display: "block" } },
          },
        }),
        su = t.forwardRef(function (n, r) {
          var o;
          const a = (0, zt.Z)({ props: n, name: "MuiInputBase" }),
            {
              "aria-describedby": i,
              autoComplete: s,
              autoFocus: l,
              className: c,
              components: u = {},
              componentsProps: p = {},
              defaultValue: m,
              disabled: h,
              disableInjectingGlobalStyles: f,
              endAdornment: g,
              fullWidth: v = !1,
              id: b,
              inputComponent: _ = "input",
              inputProps: y = {},
              inputRef: x,
              maxRows: C,
              minRows: S,
              multiline: k = !1,
              name: w,
              onBlur: P,
              onChange: O,
              onClick: I,
              onFocus: T,
              onKeyDown: M,
              onKeyUp: E,
              placeholder: D,
              readOnly: j,
              renderSuffix: R,
              rows: N,
              slotProps: A = {},
              slots: L = {},
              startAdornment: z,
              type: B = "text",
              value: Z,
            } = a,
            F = (0, jt.Z)(a, tu),
            H = null != y.value ? y.value : Z,
            { current: V } = t.useRef(null != H),
            W = t.useRef(),
            $ = t.useCallback((e) => {}, []),
            U = (0, cn.Z)(W, x, y.ref, $),
            [K, G] = t.useState(!1),
            q = qc(),
            Y = Kc({
              props: a,
              muiFormControl: q,
              states: [
                "color",
                "disabled",
                "error",
                "hiddenLabel",
                "size",
                "required",
                "filled",
              ],
            });
          (Y.focused = q ? q.focused : K),
            t.useEffect(() => {
              !q && h && K && (G(!1), P && P());
            }, [q, h, K, P]);
          const J = q && q.onFilled,
            Q = q && q.onEmpty,
            X = t.useCallback(
              (e) => {
                eu(e) ? J && J() : Q && Q();
              },
              [J, Q]
            );
          (0, $o.Z)(() => {
            V && X({ value: H });
          }, [H, X, V]),
            t.useEffect(() => {
              X(W.current);
            }, []);
          let ee = _,
            te = y;
          k &&
            "input" === ee &&
            ((te = N
              ? (0, d.Z)({ type: void 0, minRows: N, maxRows: N }, te)
              : (0, d.Z)({ type: void 0, maxRows: C, minRows: S }, te)),
            (ee = Uc)),
            t.useEffect(() => {
              q && q.setAdornedStart(Boolean(z));
            }, [q, z]);
          const ne = (0, d.Z)({}, a, {
              color: Y.color || "primary",
              disabled: Y.disabled,
              endAdornment: g,
              error: Y.error,
              focused: Y.focused,
              formControl: q,
              fullWidth: v,
              hiddenLabel: Y.hiddenLabel,
              multiline: k,
              size: Y.size,
              startAdornment: z,
              type: B,
            }),
            re = ((e) => {
              const {
                  classes: t,
                  color: n,
                  disabled: r,
                  error: o,
                  endAdornment: a,
                  focused: i,
                  formControl: s,
                  fullWidth: l,
                  hiddenLabel: c,
                  multiline: u,
                  readOnly: d,
                  size: p,
                  startAdornment: m,
                  type: h,
                } = e,
                f = {
                  root: [
                    "root",
                    `color${(0, Fn.Z)(n)}`,
                    r && "disabled",
                    o && "error",
                    l && "fullWidth",
                    i && "focused",
                    s && "formControl",
                    p && "medium" !== p && `size${(0, Fn.Z)(p)}`,
                    u && "multiline",
                    m && "adornedStart",
                    a && "adornedEnd",
                    c && "hiddenLabel",
                    d && "readOnly",
                  ],
                  input: [
                    "input",
                    r && "disabled",
                    "search" === h && "inputTypeSearch",
                    u && "inputMultiline",
                    "small" === p && "inputSizeSmall",
                    c && "inputHiddenLabel",
                    m && "inputAdornedStart",
                    a && "inputAdornedEnd",
                    d && "readOnly",
                  ],
                };
              return (0, Nt.Z)(f, cc, t);
            })(ne),
            oe = L.root || u.Root || ou,
            ae = A.root || p.root || {},
            ie = L.input || u.Input || au;
          return (
            (te = (0, d.Z)({}, te, null != (o = A.input) ? o : p.input)),
            (0, e.jsxs)(t.Fragment, {
              children: [
                !f && iu,
                (0, e.jsxs)(
                  oe,
                  (0, d.Z)(
                    {},
                    ae,
                    !Xn(oe) && { ownerState: (0, d.Z)({}, ne, ae.ownerState) },
                    {
                      ref: r,
                      onClick: (e) => {
                        W.current &&
                          e.currentTarget === e.target &&
                          W.current.focus(),
                          I && I(e);
                      },
                    },
                    F,
                    {
                      className: (0, Rt.Z)(
                        re.root,
                        ae.className,
                        c,
                        j && "MuiInputBase-readOnly"
                      ),
                      children: [
                        z,
                        (0, e.jsx)(Gc.Provider, {
                          value: null,
                          children: (0, e.jsx)(
                            ie,
                            (0, d.Z)(
                              {
                                ownerState: ne,
                                "aria-invalid": Y.error,
                                "aria-describedby": i,
                                autoComplete: s,
                                autoFocus: l,
                                defaultValue: m,
                                disabled: Y.disabled,
                                id: b,
                                onAnimationStart: (e) => {
                                  X(
                                    "mui-auto-fill-cancel" === e.animationName
                                      ? W.current
                                      : { value: "x" }
                                  );
                                },
                                name: w,
                                placeholder: D,
                                readOnly: j,
                                required: Y.required,
                                rows: N,
                                value: H,
                                onKeyDown: M,
                                onKeyUp: E,
                                type: B,
                              },
                              te,
                              !Xn(ie) && {
                                as: ee,
                                ownerState: (0, d.Z)({}, ne, te.ownerState),
                              },
                              {
                                ref: U,
                                className: (0, Rt.Z)(
                                  re.input,
                                  te.className,
                                  j && "MuiInputBase-readOnly"
                                ),
                                onBlur: (e) => {
                                  P && P(e),
                                    y.onBlur && y.onBlur(e),
                                    q && q.onBlur ? q.onBlur(e) : G(!1);
                                },
                                onChange: (e, ...t) => {
                                  if (!V) {
                                    const t = e.target || W.current;
                                    if (null == t)
                                      throw new Error((0, Fc.Z)(1));
                                    X({ value: t.value });
                                  }
                                  y.onChange && y.onChange(e, ...t),
                                    O && O(e, ...t);
                                },
                                onFocus: (e) => {
                                  Y.disabled
                                    ? e.stopPropagation()
                                    : (T && T(e),
                                      y.onFocus && y.onFocus(e),
                                      q && q.onFocus ? q.onFocus(e) : G(!0));
                                },
                              }
                            )
                          ),
                        }),
                        g,
                        R ? R((0, d.Z)({}, Y, { startAdornment: z })) : null,
                      ],
                    }
                  )
                ),
              ],
            })
          );
        });
      var lu = su;
      const cu = [
          "disableUnderline",
          "components",
          "componentsProps",
          "fullWidth",
          "inputComponent",
          "multiline",
          "slotProps",
          "slots",
          "type",
        ],
        uu = (0, Lt.ZP)(ou, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiInput",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [...nu(e, t), !n.disableUnderline && t.underline];
          },
        })(({ theme: e, ownerState: t }) => {
          let n =
            "light" === e.palette.mode
              ? "rgba(0, 0, 0, 0.42)"
              : "rgba(255, 255, 255, 0.7)";
          return (
            e.vars &&
              (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`),
            (0, d.Z)(
              { position: "relative" },
              t.formControl && { "label + &": { marginTop: 16 } },
              !t.disableUnderline && {
                "&::after": {
                  borderBottom: `2px solid ${
                    (e.vars || e).palette[t.color].main
                  }`,
                  left: 0,
                  bottom: 0,
                  content: '""',
                  position: "absolute",
                  right: 0,
                  transform: "scaleX(0)",
                  transition: e.transitions.create("transform", {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut,
                  }),
                  pointerEvents: "none",
                },
                [`&.${pc.focused}:after`]: {
                  transform: "scaleX(1) translateX(0)",
                },
                [`&.${pc.error}`]: {
                  "&::before, &::after": {
                    borderBottomColor: (e.vars || e).palette.error.main,
                  },
                },
                "&::before": {
                  borderBottom: `1px solid ${n}`,
                  left: 0,
                  bottom: 0,
                  content: '"\\00a0"',
                  position: "absolute",
                  right: 0,
                  transition: e.transitions.create("border-bottom-color", {
                    duration: e.transitions.duration.shorter,
                  }),
                  pointerEvents: "none",
                },
                [`&:hover:not(.${pc.disabled}, .${pc.error}):before`]: {
                  borderBottom: `2px solid ${
                    (e.vars || e).palette.text.primary
                  }`,
                  "@media (hover: none)": { borderBottom: `1px solid ${n}` },
                },
                [`&.${pc.disabled}:before`]: { borderBottomStyle: "dotted" },
              }
            )
          );
        }),
        du = (0, Lt.ZP)(au, {
          name: "MuiInput",
          slot: "Input",
          overridesResolver: ru,
        })({}),
        pu = t.forwardRef(function (t, n) {
          var r, o, a, i;
          const s = (0, zt.Z)({ props: t, name: "MuiInput" }),
            {
              disableUnderline: l,
              components: c = {},
              componentsProps: u,
              fullWidth: p = !1,
              inputComponent: m = "input",
              multiline: h = !1,
              slotProps: f,
              slots: g = {},
              type: v = "text",
            } = s,
            b = (0, jt.Z)(s, cu),
            _ = ((e) => {
              const { classes: t, disableUnderline: n } = e,
                r = { root: ["root", !n && "underline"], input: ["input"] },
                o = (0, Nt.Z)(r, dc, t);
              return (0, d.Z)({}, t, o);
            })(s),
            y = { root: { ownerState: { disableUnderline: l } } },
            x = (null != f ? f : u) ? (0, Zc.Z)(null != f ? f : u, y) : y,
            C = null != (r = null != (o = g.root) ? o : c.Root) ? r : uu,
            S = null != (a = null != (i = g.input) ? i : c.Input) ? a : du;
          return (0,
          e.jsx)(lu, (0, d.Z)({ slots: { root: C, input: S }, slotProps: x, fullWidth: p, inputComponent: m, multiline: h, ref: n, type: v }, b, { classes: _ }));
        });
      pu.muiName = "Input";
      var mu = pu;
      const hu = [
          "disableUnderline",
          "components",
          "componentsProps",
          "fullWidth",
          "hiddenLabel",
          "inputComponent",
          "multiline",
          "slotProps",
          "slots",
          "type",
        ],
        fu = (0, Lt.ZP)(ou, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiFilledInput",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [...nu(e, t), !n.disableUnderline && t.underline];
          },
        })(({ theme: e, ownerState: t }) => {
          var n;
          const r = "light" === e.palette.mode,
            o = r ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)",
            a = r ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)",
            i = r ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)",
            s = r ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
          return (0, d.Z)(
            {
              position: "relative",
              backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
              borderTopLeftRadius: (e.vars || e).shape.borderRadius,
              borderTopRightRadius: (e.vars || e).shape.borderRadius,
              transition: e.transitions.create("background-color", {
                duration: e.transitions.duration.shorter,
                easing: e.transitions.easing.easeOut,
              }),
              "&:hover": {
                backgroundColor: e.vars
                  ? e.vars.palette.FilledInput.hoverBg
                  : i,
                "@media (hover: none)": {
                  backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
                },
              },
              [`&.${gc.focused}`]: {
                backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
              },
              [`&.${gc.disabled}`]: {
                backgroundColor: e.vars
                  ? e.vars.palette.FilledInput.disabledBg
                  : s,
              },
            },
            !t.disableUnderline && {
              "&::after": {
                borderBottom: `2px solid ${
                  null == (n = (e.vars || e).palette[t.color || "primary"])
                    ? void 0
                    : n.main
                }`,
                left: 0,
                bottom: 0,
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: e.transitions.create("transform", {
                  duration: e.transitions.duration.shorter,
                  easing: e.transitions.easing.easeOut,
                }),
                pointerEvents: "none",
              },
              [`&.${gc.focused}:after`]: {
                transform: "scaleX(1) translateX(0)",
              },
              [`&.${gc.error}`]: {
                "&::before, &::after": {
                  borderBottomColor: (e.vars || e).palette.error.main,
                },
              },
              "&::before": {
                borderBottom: `1px solid ${
                  e.vars
                    ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`
                    : o
                }`,
                left: 0,
                bottom: 0,
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: e.transitions.create("border-bottom-color", {
                  duration: e.transitions.duration.shorter,
                }),
                pointerEvents: "none",
              },
              [`&:hover:not(.${gc.disabled}, .${gc.error}):before`]: {
                borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`,
              },
              [`&.${gc.disabled}:before`]: { borderBottomStyle: "dotted" },
            },
            t.startAdornment && { paddingLeft: 12 },
            t.endAdornment && { paddingRight: 12 },
            t.multiline &&
              (0, d.Z)(
                { padding: "25px 12px 8px" },
                "small" === t.size && { paddingTop: 21, paddingBottom: 4 },
                t.hiddenLabel && { paddingTop: 16, paddingBottom: 17 },
                t.hiddenLabel &&
                  "small" === t.size && { paddingTop: 8, paddingBottom: 9 }
              )
          );
        }),
        gu = (0, Lt.ZP)(au, {
          name: "MuiFilledInput",
          slot: "Input",
          overridesResolver: ru,
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              paddingTop: 25,
              paddingRight: 12,
              paddingBottom: 8,
              paddingLeft: 12,
            },
            !e.vars && {
              "&:-webkit-autofill": {
                WebkitBoxShadow:
                  "light" === e.palette.mode
                    ? null
                    : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "light" === e.palette.mode ? null : "#fff",
                caretColor: "light" === e.palette.mode ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
              },
            },
            e.vars && {
              "&:-webkit-autofill": {
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
              },
              [e.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 100px #266798 inset",
                  WebkitTextFillColor: "#fff",
                  caretColor: "#fff",
                },
              },
            },
            "small" === t.size && { paddingTop: 21, paddingBottom: 4 },
            t.hiddenLabel && { paddingTop: 16, paddingBottom: 17 },
            t.startAdornment && { paddingLeft: 0 },
            t.endAdornment && { paddingRight: 0 },
            t.hiddenLabel &&
              "small" === t.size && { paddingTop: 8, paddingBottom: 9 },
            t.multiline && {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }
          )
        ),
        vu = t.forwardRef(function (t, n) {
          var r, o, a, i;
          const s = (0, zt.Z)({ props: t, name: "MuiFilledInput" }),
            {
              components: l = {},
              componentsProps: c,
              fullWidth: u = !1,
              inputComponent: p = "input",
              multiline: m = !1,
              slotProps: h,
              slots: f = {},
              type: g = "text",
            } = s,
            v = (0, jt.Z)(s, hu),
            b = (0, d.Z)({}, s, {
              fullWidth: u,
              inputComponent: p,
              multiline: m,
              type: g,
            }),
            _ = ((e) => {
              const { classes: t, disableUnderline: n } = e,
                r = { root: ["root", !n && "underline"], input: ["input"] },
                o = (0, Nt.Z)(r, fc, t);
              return (0, d.Z)({}, t, o);
            })(s),
            y = { root: { ownerState: b }, input: { ownerState: b } },
            x = (null != h ? h : c) ? (0, Zc.Z)(y, null != h ? h : c) : y,
            C = null != (r = null != (o = f.root) ? o : l.Root) ? r : fu,
            S = null != (a = null != (i = f.input) ? i : l.Input) ? a : gu;
          return (0,
          e.jsx)(lu, (0, d.Z)({ slots: { root: C, input: S }, componentsProps: x, fullWidth: u, inputComponent: p, multiline: m, ref: n, type: g }, v, { classes: _ }));
        });
      vu.muiName = "Input";
      var bu,
        _u = vu;
      const yu = ["children", "classes", "className", "label", "notched"],
        xu = (0, Lt.ZP)("fieldset", { shouldForwardProp: so.Z })({
          textAlign: "left",
          position: "absolute",
          bottom: 0,
          right: 0,
          top: -5,
          left: 0,
          margin: 0,
          padding: "0 8px",
          pointerEvents: "none",
          borderRadius: "inherit",
          borderStyle: "solid",
          borderWidth: 1,
          overflow: "hidden",
          minWidth: "0%",
        }),
        Cu = (0, Lt.ZP)("legend", { shouldForwardProp: so.Z })(
          ({ ownerState: e, theme: t }) =>
            (0, d.Z)(
              { float: "unset", width: "auto", overflow: "hidden" },
              !e.withLabel && {
                padding: 0,
                lineHeight: "11px",
                transition: t.transitions.create("width", {
                  duration: 150,
                  easing: t.transitions.easing.easeOut,
                }),
              },
              e.withLabel &&
                (0, d.Z)(
                  {
                    display: "block",
                    padding: 0,
                    height: 11,
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: t.transitions.create("max-width", {
                      duration: 50,
                      easing: t.transitions.easing.easeOut,
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                      paddingLeft: 5,
                      paddingRight: 5,
                      display: "inline-block",
                      opacity: 0,
                      visibility: "visible",
                    },
                  },
                  e.notched && {
                    maxWidth: "100%",
                    transition: t.transitions.create("max-width", {
                      duration: 100,
                      easing: t.transitions.easing.easeOut,
                      delay: 50,
                    }),
                  }
                )
            )
        ),
        Su = [
          "components",
          "fullWidth",
          "inputComponent",
          "label",
          "multiline",
          "notched",
          "slots",
          "type",
        ],
        ku = (0, Lt.ZP)(ou, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiOutlinedInput",
          slot: "Root",
          overridesResolver: nu,
        })(({ theme: e, ownerState: t }) => {
          const n =
            "light" === e.palette.mode
              ? "rgba(0, 0, 0, 0.23)"
              : "rgba(255, 255, 255, 0.23)";
          return (0, d.Z)(
            {
              position: "relative",
              borderRadius: (e.vars || e).shape.borderRadius,
              [`&:hover .${hc.notchedOutline}`]: {
                borderColor: (e.vars || e).palette.text.primary,
              },
              "@media (hover: none)": {
                [`&:hover .${hc.notchedOutline}`]: {
                  borderColor: e.vars
                    ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)`
                    : n,
                },
              },
              [`&.${hc.focused} .${hc.notchedOutline}`]: {
                borderColor: (e.vars || e).palette[t.color].main,
                borderWidth: 2,
              },
              [`&.${hc.error} .${hc.notchedOutline}`]: {
                borderColor: (e.vars || e).palette.error.main,
              },
              [`&.${hc.disabled} .${hc.notchedOutline}`]: {
                borderColor: (e.vars || e).palette.action.disabled,
              },
            },
            t.startAdornment && { paddingLeft: 14 },
            t.endAdornment && { paddingRight: 14 },
            t.multiline &&
              (0, d.Z)(
                { padding: "16.5px 14px" },
                "small" === t.size && { padding: "8.5px 14px" }
              )
          );
        }),
        wu = (0, Lt.ZP)(
          function (t) {
            const { className: n, label: r, notched: o } = t,
              a = (0, jt.Z)(t, yu),
              i = null != r && "" !== r,
              s = (0, d.Z)({}, t, { notched: o, withLabel: i });
            return (0, e.jsx)(
              xu,
              (0, d.Z)({ "aria-hidden": !0, className: n, ownerState: s }, a, {
                children: (0, e.jsx)(Cu, {
                  ownerState: s,
                  children: i
                    ? (0, e.jsx)("span", { children: r })
                    : bu ||
                      (bu = (0, e.jsx)("span", {
                        className: "notranslate",
                        children: "​",
                      })),
                }),
              })
            );
          },
          {
            name: "MuiOutlinedInput",
            slot: "NotchedOutline",
            overridesResolver: (e, t) => t.notchedOutline,
          }
        )(({ theme: e }) => {
          const t =
            "light" === e.palette.mode
              ? "rgba(0, 0, 0, 0.23)"
              : "rgba(255, 255, 255, 0.23)";
          return {
            borderColor: e.vars
              ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)`
              : t,
          };
        }),
        Pu = (0, Lt.ZP)(au, {
          name: "MuiOutlinedInput",
          slot: "Input",
          overridesResolver: ru,
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { padding: "16.5px 14px" },
            !e.vars && {
              "&:-webkit-autofill": {
                WebkitBoxShadow:
                  "light" === e.palette.mode
                    ? null
                    : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "light" === e.palette.mode ? null : "#fff",
                caretColor: "light" === e.palette.mode ? null : "#fff",
                borderRadius: "inherit",
              },
            },
            e.vars && {
              "&:-webkit-autofill": { borderRadius: "inherit" },
              [e.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 100px #266798 inset",
                  WebkitTextFillColor: "#fff",
                  caretColor: "#fff",
                },
              },
            },
            "small" === t.size && { padding: "8.5px 14px" },
            t.multiline && { padding: 0 },
            t.startAdornment && { paddingLeft: 0 },
            t.endAdornment && { paddingRight: 0 }
          )
        ),
        Ou = t.forwardRef(function (n, r) {
          var o, a, i, s, l;
          const c = (0, zt.Z)({ props: n, name: "MuiOutlinedInput" }),
            {
              components: u = {},
              fullWidth: p = !1,
              inputComponent: m = "input",
              label: h,
              multiline: f = !1,
              notched: g,
              slots: v = {},
              type: b = "text",
            } = c,
            _ = (0, jt.Z)(c, Su),
            y = ((e) => {
              const { classes: t } = e,
                n = (0, Nt.Z)(
                  {
                    root: ["root"],
                    notchedOutline: ["notchedOutline"],
                    input: ["input"],
                  },
                  mc,
                  t
                );
              return (0, d.Z)({}, t, n);
            })(c),
            x = qc(),
            C = Kc({
              props: c,
              muiFormControl: x,
              states: [
                "color",
                "disabled",
                "error",
                "focused",
                "hiddenLabel",
                "size",
                "required",
              ],
            }),
            S = (0, d.Z)({}, c, {
              color: C.color || "primary",
              disabled: C.disabled,
              error: C.error,
              focused: C.focused,
              formControl: x,
              fullWidth: p,
              hiddenLabel: C.hiddenLabel,
              multiline: f,
              size: C.size,
              type: b,
            }),
            k = null != (o = null != (a = v.root) ? a : u.Root) ? o : ku,
            w = null != (i = null != (s = v.input) ? s : u.Input) ? i : Pu;
          return (0,
          e.jsx)(lu, (0, d.Z)({ slots: { root: k, input: w }, renderSuffix: (n) => (0, e.jsx)(wu, { ownerState: S, className: y.notchedOutline, label: null != h && "" !== h && C.required ? l || (l = (0, e.jsxs)(t.Fragment, { children: [h, " ", "*"] })) : h, notched: void 0 !== g ? g : Boolean(n.startAdornment || n.filled || n.focused) }), fullWidth: p, inputComponent: m, multiline: f, ref: r, type: b }, _, { classes: (0, d.Z)({}, y, { notchedOutline: null }) }));
        });
      Ou.muiName = "Input";
      var Iu = Ou;
      function Tu(e) {
        return (0, Zt.ZP)("MuiFormLabel", e);
      }
      var Mu = (0, Bt.Z)("MuiFormLabel", [
        "root",
        "colorSecondary",
        "focused",
        "disabled",
        "error",
        "filled",
        "required",
        "asterisk",
      ]);
      const Eu = [
          "children",
          "className",
          "color",
          "component",
          "disabled",
          "error",
          "filled",
          "focused",
          "required",
        ],
        Du = (0, Lt.ZP)("label", {
          name: "MuiFormLabel",
          slot: "Root",
          overridesResolver: ({ ownerState: e }, t) =>
            (0, d.Z)(
              {},
              t.root,
              "secondary" === e.color && t.colorSecondary,
              e.filled && t.filled
            ),
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { color: (e.vars || e).palette.text.secondary },
            e.typography.body1,
            {
              lineHeight: "1.4375em",
              padding: 0,
              position: "relative",
              [`&.${Mu.focused}`]: {
                color: (e.vars || e).palette[t.color].main,
              },
              [`&.${Mu.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
              [`&.${Mu.error}`]: { color: (e.vars || e).palette.error.main },
            }
          )
        ),
        ju = (0, Lt.ZP)("span", {
          name: "MuiFormLabel",
          slot: "Asterisk",
          overridesResolver: (e, t) => t.asterisk,
        })(({ theme: e }) => ({
          [`&.${Mu.error}`]: { color: (e.vars || e).palette.error.main },
        })),
        Ru = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiFormLabel" }),
            { children: o, className: a, component: i = "label" } = r,
            s = (0, jt.Z)(r, Eu),
            l = Kc({
              props: r,
              muiFormControl: qc(),
              states: [
                "color",
                "required",
                "focused",
                "disabled",
                "error",
                "filled",
              ],
            }),
            c = (0, d.Z)({}, r, {
              color: l.color || "primary",
              component: i,
              disabled: l.disabled,
              error: l.error,
              filled: l.filled,
              focused: l.focused,
              required: l.required,
            }),
            u = ((e) => {
              const {
                  classes: t,
                  color: n,
                  focused: r,
                  disabled: o,
                  error: a,
                  filled: i,
                  required: s,
                } = e,
                l = {
                  root: [
                    "root",
                    `color${(0, Fn.Z)(n)}`,
                    o && "disabled",
                    a && "error",
                    i && "filled",
                    r && "focused",
                    s && "required",
                  ],
                  asterisk: ["asterisk", a && "error"],
                };
              return (0, Nt.Z)(l, Tu, t);
            })(c);
          return (0,
          e.jsxs)(Du, (0, d.Z)({ as: i, ownerState: c, className: (0, Rt.Z)(u.root, a), ref: n }, s, { children: [o, l.required && (0, e.jsxs)(ju, { ownerState: c, "aria-hidden": !0, className: u.asterisk, children: [" ", "*"] })] }));
        });
      var Nu = Ru;
      function Au(e) {
        return (0, Zt.ZP)("MuiInputLabel", e);
      }
      (0, Bt.Z)("MuiInputLabel", [
        "root",
        "focused",
        "disabled",
        "error",
        "required",
        "asterisk",
        "formControl",
        "sizeSmall",
        "shrink",
        "animated",
        "standard",
        "filled",
        "outlined",
      ]);
      const Lu = [
          "disableAnimation",
          "margin",
          "shrink",
          "variant",
          "className",
        ],
        zu = (0, Lt.ZP)(Nu, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiInputLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${Mu.asterisk}`]: t.asterisk },
              t.root,
              n.formControl && t.formControl,
              "small" === n.size && t.sizeSmall,
              n.shrink && t.shrink,
              !n.disableAnimation && t.animated,
              n.focused && t.focused,
              t[n.variant],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              display: "block",
              transformOrigin: "top left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            },
            t.formControl && {
              position: "absolute",
              left: 0,
              top: 0,
              transform: "translate(0, 20px) scale(1)",
            },
            "small" === t.size && { transform: "translate(0, 17px) scale(1)" },
            t.shrink && {
              transform: "translate(0, -1.5px) scale(0.75)",
              transformOrigin: "top left",
              maxWidth: "133%",
            },
            !t.disableAnimation && {
              transition: e.transitions.create(
                ["color", "transform", "max-width"],
                {
                  duration: e.transitions.duration.shorter,
                  easing: e.transitions.easing.easeOut,
                }
              ),
            },
            "filled" === t.variant &&
              (0, d.Z)(
                {
                  zIndex: 1,
                  pointerEvents: "none",
                  transform: "translate(12px, 16px) scale(1)",
                  maxWidth: "calc(100% - 24px)",
                },
                "small" === t.size && {
                  transform: "translate(12px, 13px) scale(1)",
                },
                t.shrink &&
                  (0, d.Z)(
                    {
                      userSelect: "none",
                      pointerEvents: "auto",
                      transform: "translate(12px, 7px) scale(0.75)",
                      maxWidth: "calc(133% - 24px)",
                    },
                    "small" === t.size && {
                      transform: "translate(12px, 4px) scale(0.75)",
                    }
                  )
              ),
            "outlined" === t.variant &&
              (0, d.Z)(
                {
                  zIndex: 1,
                  pointerEvents: "none",
                  transform: "translate(14px, 16px) scale(1)",
                  maxWidth: "calc(100% - 24px)",
                },
                "small" === t.size && {
                  transform: "translate(14px, 9px) scale(1)",
                },
                t.shrink && {
                  userSelect: "none",
                  pointerEvents: "auto",
                  maxWidth: "calc(133% - 32px)",
                  transform: "translate(14px, -9px) scale(0.75)",
                }
              )
          )
        );
      var Bu = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ name: "MuiInputLabel", props: t }),
            { disableAnimation: o = !1, shrink: a, className: i } = r,
            s = (0, jt.Z)(r, Lu),
            l = qc();
          let c = a;
          void 0 === c && l && (c = l.filled || l.focused || l.adornedStart);
          const u = Kc({
              props: r,
              muiFormControl: l,
              states: ["size", "variant", "required", "focused"],
            }),
            p = (0, d.Z)({}, r, {
              disableAnimation: o,
              formControl: l,
              shrink: c,
              size: u.size,
              variant: u.variant,
              required: u.required,
              focused: u.focused,
            }),
            m = ((e) => {
              const {
                  classes: t,
                  formControl: n,
                  size: r,
                  shrink: o,
                  disableAnimation: a,
                  variant: i,
                  required: s,
                } = e,
                l = {
                  root: [
                    "root",
                    n && "formControl",
                    !a && "animated",
                    o && "shrink",
                    r && "normal" !== r && `size${(0, Fn.Z)(r)}`,
                    i,
                  ],
                  asterisk: [s && "asterisk"],
                },
                c = (0, Nt.Z)(l, Au, t);
              return (0, d.Z)({}, t, c);
            })(p);
          return (0,
          e.jsx)(zu, (0, d.Z)({ "data-shrink": c, ownerState: p, ref: n, className: (0, Rt.Z)(m.root, i) }, s, { classes: m }));
        }),
        Zu = o(2282);
      function Fu(e) {
        return (0, Zt.ZP)("MuiFormControl", e);
      }
      (0, Bt.Z)("MuiFormControl", [
        "root",
        "marginNone",
        "marginNormal",
        "marginDense",
        "fullWidth",
        "disabled",
      ]);
      const Hu = [
          "children",
          "className",
          "color",
          "component",
          "disabled",
          "error",
          "focused",
          "fullWidth",
          "hiddenLabel",
          "margin",
          "required",
          "size",
          "variant",
        ],
        Vu = (0, Lt.ZP)("div", {
          name: "MuiFormControl",
          slot: "Root",
          overridesResolver: ({ ownerState: e }, t) =>
            (0, d.Z)(
              {},
              t.root,
              t[`margin${(0, Fn.Z)(e.margin)}`],
              e.fullWidth && t.fullWidth
            ),
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              display: "inline-flex",
              flexDirection: "column",
              position: "relative",
              minWidth: 0,
              padding: 0,
              margin: 0,
              border: 0,
              verticalAlign: "top",
            },
            "normal" === e.margin && { marginTop: 16, marginBottom: 8 },
            "dense" === e.margin && { marginTop: 8, marginBottom: 4 },
            e.fullWidth && { width: "100%" }
          )
        ),
        Wu = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiFormControl" }),
            {
              children: a,
              className: i,
              color: s = "primary",
              component: l = "div",
              disabled: c = !1,
              error: u = !1,
              focused: p,
              fullWidth: m = !1,
              hiddenLabel: h = !1,
              margin: f = "none",
              required: g = !1,
              size: v = "medium",
              variant: b = "outlined",
            } = o,
            _ = (0, jt.Z)(o, Hu),
            y = (0, d.Z)({}, o, {
              color: s,
              component: l,
              disabled: c,
              error: u,
              fullWidth: m,
              hiddenLabel: h,
              margin: f,
              required: g,
              size: v,
              variant: b,
            }),
            x = ((e) => {
              const { classes: t, margin: n, fullWidth: r } = e,
                o = {
                  root: [
                    "root",
                    "none" !== n && `margin${(0, Fn.Z)(n)}`,
                    r && "fullWidth",
                  ],
                };
              return (0, Nt.Z)(o, Fu, t);
            })(y),
            [C, S] = t.useState(() => {
              let e = !1;
              return (
                a &&
                  t.Children.forEach(a, (t) => {
                    if (!(0, Zu.Z)(t, ["Input", "Select"])) return;
                    const n = (0, Zu.Z)(t, ["Select"]) ? t.props.input : t;
                    n && n.props.startAdornment && (e = !0);
                  }),
                e
              );
            }),
            [k, w] = t.useState(() => {
              let e = !1;
              return (
                a &&
                  t.Children.forEach(a, (t) => {
                    (0, Zu.Z)(t, ["Input", "Select"]) &&
                      (eu(t.props, !0) || eu(t.props.inputProps, !0)) &&
                      (e = !0);
                  }),
                e
              );
            }),
            [P, O] = t.useState(!1);
          c && P && O(!1);
          const I = void 0 === p || c ? P : p;
          let T;
          const M = t.useMemo(
            () => ({
              adornedStart: C,
              setAdornedStart: S,
              color: s,
              disabled: c,
              error: u,
              filled: k,
              focused: I,
              fullWidth: m,
              hiddenLabel: h,
              size: v,
              onBlur: () => {
                O(!1);
              },
              onEmpty: () => {
                w(!1);
              },
              onFilled: () => {
                w(!0);
              },
              onFocus: () => {
                O(!0);
              },
              registerEffect: T,
              required: g,
              variant: b,
            }),
            [C, s, c, u, k, I, m, h, T, g, v, b]
          );
          return (0,
          e.jsx)(Gc.Provider, { value: M, children: (0, e.jsx)(Vu, (0, d.Z)({ as: l, ownerState: y, className: (0, Rt.Z)(x.root, i), ref: r }, _, { children: a })) });
        });
      var $u = Wu;
      function Uu(e) {
        return (0, Zt.ZP)("MuiFormHelperText", e);
      }
      var Ku,
        Gu = (0, Bt.Z)("MuiFormHelperText", [
          "root",
          "error",
          "disabled",
          "sizeSmall",
          "sizeMedium",
          "contained",
          "focused",
          "filled",
          "required",
        ]);
      const qu = [
          "children",
          "className",
          "component",
          "disabled",
          "error",
          "filled",
          "focused",
          "margin",
          "required",
          "variant",
        ],
        Yu = (0, Lt.ZP)("p", {
          name: "MuiFormHelperText",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.size && t[`size${(0, Fn.Z)(n.size)}`],
              n.contained && t.contained,
              n.filled && t.filled,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { color: (e.vars || e).palette.text.secondary },
            e.typography.caption,
            {
              textAlign: "left",
              marginTop: 3,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
              [`&.${Gu.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
              [`&.${Gu.error}`]: { color: (e.vars || e).palette.error.main },
            },
            "small" === t.size && { marginTop: 4 },
            t.contained && { marginLeft: 14, marginRight: 14 }
          )
        );
      var Ju = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiFormHelperText" }),
            { children: o, className: a, component: i = "p" } = r,
            s = (0, jt.Z)(r, qu),
            l = Kc({
              props: r,
              muiFormControl: qc(),
              states: [
                "variant",
                "size",
                "disabled",
                "error",
                "filled",
                "focused",
                "required",
              ],
            }),
            c = (0, d.Z)({}, r, {
              component: i,
              contained: "filled" === l.variant || "outlined" === l.variant,
              variant: l.variant,
              size: l.size,
              disabled: l.disabled,
              error: l.error,
              filled: l.filled,
              focused: l.focused,
              required: l.required,
            }),
            u = ((e) => {
              const {
                  classes: t,
                  contained: n,
                  size: r,
                  disabled: o,
                  error: a,
                  filled: i,
                  focused: s,
                  required: l,
                } = e,
                c = {
                  root: [
                    "root",
                    o && "disabled",
                    a && "error",
                    r && `size${(0, Fn.Z)(r)}`,
                    n && "contained",
                    s && "focused",
                    i && "filled",
                    l && "required",
                  ],
                };
              return (0, Nt.Z)(c, Uu, t);
            })(c);
          return (0,
          e.jsx)(Yu, (0, d.Z)({ as: i, ownerState: c, className: (0, Rt.Z)(u.root, a), ref: n }, s, { children: " " === o ? Ku || (Ku = (0, e.jsx)("span", { className: "notranslate", children: "​" })) : o }));
        }),
        Qu = t.createContext({});
      function Xu(e) {
        return (0, Zt.ZP)("MuiList", e);
      }
      (0, Bt.Z)("MuiList", ["root", "padding", "dense", "subheader"]);
      const ed = [
          "children",
          "className",
          "component",
          "dense",
          "disablePadding",
          "subheader",
        ],
        td = (0, Lt.ZP)("ul", {
          name: "MuiList",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              !n.disablePadding && t.padding,
              n.dense && t.dense,
              n.subheader && t.subheader,
            ];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { listStyle: "none", margin: 0, padding: 0, position: "relative" },
            !e.disablePadding && { paddingTop: 8, paddingBottom: 8 },
            e.subheader && { paddingTop: 0 }
          )
        ),
        nd = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiList" }),
            {
              children: a,
              className: i,
              component: s = "ul",
              dense: l = !1,
              disablePadding: c = !1,
              subheader: u,
            } = o,
            p = (0, jt.Z)(o, ed),
            m = t.useMemo(() => ({ dense: l }), [l]),
            h = (0, d.Z)({}, o, { component: s, dense: l, disablePadding: c }),
            f = ((e) => {
              const {
                  classes: t,
                  disablePadding: n,
                  dense: r,
                  subheader: o,
                } = e,
                a = {
                  root: [
                    "root",
                    !n && "padding",
                    r && "dense",
                    o && "subheader",
                  ],
                };
              return (0, Nt.Z)(a, Xu, t);
            })(h);
          return (0,
          e.jsx)(Qu.Provider, { value: m, children: (0, e.jsxs)(td, (0, d.Z)({ as: s, className: (0, Rt.Z)(f.root, i), ref: r, ownerState: h }, p, { children: [u, a] })) });
        });
      var rd = nd,
        od = dr;
      const ad = [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant",
      ];
      function id(e, t, n) {
        return e === t
          ? e.firstChild
          : t && t.nextElementSibling
          ? t.nextElementSibling
          : n
          ? null
          : e.firstChild;
      }
      function sd(e, t, n) {
        return e === t
          ? n
            ? e.firstChild
            : e.lastChild
          : t && t.previousElementSibling
          ? t.previousElementSibling
          : n
          ? null
          : e.lastChild;
      }
      function ld(e, t) {
        if (void 0 === t) return !0;
        let n = e.innerText;
        return (
          void 0 === n && (n = e.textContent),
          (n = n.trim().toLowerCase()),
          0 !== n.length &&
            (t.repeating
              ? n[0] === t.keys[0]
              : 0 === n.indexOf(t.keys.join("")))
        );
      }
      function cd(e, t, n, r, o, a) {
        let i = !1,
          s = o(e, t, !!t && n);
        for (; s; ) {
          if (s === e.firstChild) {
            if (i) return !1;
            i = !0;
          }
          const t =
            !r && (s.disabled || "true" === s.getAttribute("aria-disabled"));
          if (s.hasAttribute("tabindex") && ld(s, a) && !t)
            return s.focus(), !0;
          s = o(e, s, n);
        }
        return !1;
      }
      var ud = t.forwardRef(function (n, r) {
        const {
            actions: o,
            autoFocus: a = !1,
            autoFocusItem: i = !1,
            children: s,
            className: l,
            disabledItemsFocusable: c = !1,
            disableListWrap: u = !1,
            onKeyDown: p,
            variant: m = "selectedMenu",
          } = n,
          h = (0, jt.Z)(n, ad),
          f = t.useRef(null),
          g = t.useRef({
            keys: [],
            repeating: !0,
            previousKeyMatched: !0,
            lastTime: null,
          });
        (0, $o.Z)(() => {
          a && f.current.focus();
        }, [a]),
          t.useImperativeHandle(
            o,
            () => ({
              adjustStyleForScrollbar: (e, { direction: t }) => {
                const n = !f.current.style.width;
                if (e.clientHeight < f.current.clientHeight && n) {
                  const n = `${od((0, ra.Z)(e))}px`;
                  (f.current.style[
                    "rtl" === t ? "paddingLeft" : "paddingRight"
                  ] = n),
                    (f.current.style.width = `calc(100% + ${n})`);
                }
                return f.current;
              },
            }),
            []
          );
        const v = (0, cn.Z)(f, r);
        let b = -1;
        t.Children.forEach(s, (e, n) => {
          t.isValidElement(e)
            ? (e.props.disabled ||
                ((("selectedMenu" === m && e.props.selected) || -1 === b) &&
                  (b = n)),
              b === n &&
                (e.props.disabled ||
                  e.props.muiSkipListHighlight ||
                  e.type.muiSkipListHighlight) &&
                ((b += 1), b >= s.length && (b = -1)))
            : b === n && ((b += 1), b >= s.length && (b = -1));
        });
        const _ = t.Children.map(s, (e, n) => {
          if (n === b) {
            const n = {};
            return (
              i && (n.autoFocus = !0),
              void 0 === e.props.tabIndex &&
                "selectedMenu" === m &&
                (n.tabIndex = 0),
              t.cloneElement(e, n)
            );
          }
          return e;
        });
        return (0, e.jsx)(
          rd,
          (0, d.Z)(
            {
              role: "menu",
              ref: v,
              className: l,
              onKeyDown: (e) => {
                const t = f.current,
                  n = e.key,
                  r = (0, ra.Z)(t).activeElement;
                if ("ArrowDown" === n) e.preventDefault(), cd(t, r, u, c, id);
                else if ("ArrowUp" === n)
                  e.preventDefault(), cd(t, r, u, c, sd);
                else if ("Home" === n)
                  e.preventDefault(), cd(t, null, u, c, id);
                else if ("End" === n) e.preventDefault(), cd(t, null, u, c, sd);
                else if (1 === n.length) {
                  const o = g.current,
                    a = n.toLowerCase(),
                    i = performance.now();
                  o.keys.length > 0 &&
                    (i - o.lastTime > 500
                      ? ((o.keys = []),
                        (o.repeating = !0),
                        (o.previousKeyMatched = !0))
                      : o.repeating && a !== o.keys[0] && (o.repeating = !1)),
                    (o.lastTime = i),
                    o.keys.push(a);
                  const s = r && !o.repeating && ld(r, o);
                  o.previousKeyMatched && (s || cd(t, r, !1, c, id, o))
                    ? e.preventDefault()
                    : (o.previousKeyMatched = !1);
                }
                p && p(e);
              },
              tabIndex: a ? 0 : -1,
            },
            h,
            { children: _ }
          )
        );
      });
      function dd(e) {
        return (0, Zt.ZP)("MuiMenu", e);
      }
      (0, Bt.Z)("MuiMenu", ["root", "paper", "list"]);
      const pd = ["onEntering"],
        md = [
          "autoFocus",
          "children",
          "className",
          "disableAutoFocusItem",
          "MenuListProps",
          "onClose",
          "open",
          "PaperProps",
          "PopoverClasses",
          "transitionDuration",
          "TransitionProps",
          "variant",
          "slots",
          "slotProps",
        ],
        hd = { vertical: "top", horizontal: "right" },
        fd = { vertical: "top", horizontal: "left" },
        gd = (0, Lt.ZP)(Zl, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiMenu",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        vd = (0, Lt.ZP)(zl, {
          name: "MuiMenu",
          slot: "Paper",
          overridesResolver: (e, t) => t.paper,
        })({
          maxHeight: "calc(100% - 96px)",
          WebkitOverflowScrolling: "touch",
        }),
        bd = (0, Lt.ZP)(ud, {
          name: "MuiMenu",
          slot: "List",
          overridesResolver: (e, t) => t.list,
        })({ outline: 0 });
      var _d = t.forwardRef(function (n, r) {
        var o, a;
        const i = (0, zt.Z)({ props: n, name: "MuiMenu" }),
          {
            autoFocus: s = !0,
            children: l,
            className: c,
            disableAutoFocusItem: u = !1,
            MenuListProps: p = {},
            onClose: m,
            open: h,
            PaperProps: f = {},
            PopoverClasses: g,
            transitionDuration: v = "auto",
            TransitionProps: { onEntering: b } = {},
            variant: _ = "selectedMenu",
            slots: y = {},
            slotProps: x = {},
          } = i,
          C = (0, jt.Z)(i.TransitionProps, pd),
          S = (0, jt.Z)(i, md),
          k = Yn(),
          w = (0, d.Z)({}, i, {
            autoFocus: s,
            disableAutoFocusItem: u,
            MenuListProps: p,
            onEntering: b,
            PaperProps: f,
            transitionDuration: v,
            TransitionProps: C,
            variant: _,
          }),
          P = ((e) => {
            const { classes: t } = e;
            return (0, Nt.Z)(
              { root: ["root"], paper: ["paper"], list: ["list"] },
              dd,
              t
            );
          })(w),
          O = s && !u && h,
          I = t.useRef(null);
        let T = -1;
        t.Children.map(l, (e, n) => {
          t.isValidElement(e) &&
            (e.props.disabled ||
              ((("selectedMenu" === _ && e.props.selected) || -1 === T) &&
                (T = n)));
        });
        const M = null != (o = y.paper) ? o : vd,
          E = null != (a = x.paper) ? a : f,
          D = ir({
            elementType: y.root,
            externalSlotProps: x.root,
            ownerState: w,
            className: [P.root, c],
          }),
          j = ir({
            elementType: M,
            externalSlotProps: E,
            ownerState: w,
            className: P.paper,
          });
        return (0, e.jsx)(
          gd,
          (0, d.Z)(
            {
              onClose: m,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: k ? "right" : "left",
              },
              transformOrigin: k ? hd : fd,
              slots: { paper: M, root: y.root },
              slotProps: { root: D, paper: j },
              open: h,
              ref: r,
              transitionDuration: v,
              TransitionProps: (0, d.Z)(
                {
                  onEntering: (e, t) => {
                    I.current &&
                      I.current.adjustStyleForScrollbar(e, {
                        direction: k ? "rtl" : "ltr",
                      }),
                      b && b(e, t);
                  },
                },
                C
              ),
              ownerState: w,
            },
            S,
            {
              classes: g,
              children: (0, e.jsx)(
                bd,
                (0, d.Z)(
                  {
                    onKeyDown: (e) => {
                      "Tab" === e.key &&
                        (e.preventDefault(), m && m(e, "tabKeyDown"));
                    },
                    actions: I,
                    autoFocus: s && (-1 === T || u),
                    autoFocusItem: O,
                    variant: _,
                  },
                  p,
                  { className: (0, Rt.Z)(P.list, p.className), children: l }
                )
              ),
            }
          )
        );
      });
      function yd(e) {
        return (0, Zt.ZP)("MuiNativeSelect", e);
      }
      var xd = (0, Bt.Z)("MuiNativeSelect", [
        "root",
        "select",
        "multiple",
        "filled",
        "outlined",
        "standard",
        "disabled",
        "icon",
        "iconOpen",
        "iconFilled",
        "iconOutlined",
        "iconStandard",
        "nativeInput",
        "error",
      ]);
      const Cd = [
          "className",
          "disabled",
          "error",
          "IconComponent",
          "inputRef",
          "variant",
        ],
        Sd = ({ ownerState: e, theme: t }) =>
          (0, d.Z)(
            {
              MozAppearance: "none",
              WebkitAppearance: "none",
              userSelect: "none",
              borderRadius: 0,
              cursor: "pointer",
              "&:focus": (0, d.Z)(
                {},
                t.vars
                  ? {
                      backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`,
                    }
                  : {
                      backgroundColor:
                        "light" === t.palette.mode
                          ? "rgba(0, 0, 0, 0.05)"
                          : "rgba(255, 255, 255, 0.05)",
                    },
                { borderRadius: 0 }
              ),
              "&::-ms-expand": { display: "none" },
              [`&.${xd.disabled}`]: { cursor: "default" },
              "&[multiple]": { height: "auto" },
              "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: (t.vars || t).palette.background.paper,
              },
              "&&&": { paddingRight: 24, minWidth: 16 },
            },
            "filled" === e.variant && { "&&&": { paddingRight: 32 } },
            "outlined" === e.variant && {
              borderRadius: (t.vars || t).shape.borderRadius,
              "&:focus": { borderRadius: (t.vars || t).shape.borderRadius },
              "&&&": { paddingRight: 32 },
            }
          ),
        kd = (0, Lt.ZP)("select", {
          name: "MuiNativeSelect",
          slot: "Select",
          shouldForwardProp: so.Z,
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.select,
              t[n.variant],
              n.error && t.error,
              { [`&.${xd.multiple}`]: t.multiple },
            ];
          },
        })(Sd),
        wd = ({ ownerState: e, theme: t }) =>
          (0, d.Z)(
            {
              position: "absolute",
              right: 0,
              top: "calc(50% - .5em)",
              pointerEvents: "none",
              color: (t.vars || t).palette.action.active,
              [`&.${xd.disabled}`]: {
                color: (t.vars || t).palette.action.disabled,
              },
            },
            e.open && { transform: "rotate(180deg)" },
            "filled" === e.variant && { right: 7 },
            "outlined" === e.variant && { right: 7 }
          ),
        Pd = (0, Lt.ZP)("svg", {
          name: "MuiNativeSelect",
          slot: "Icon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.icon,
              n.variant && t[`icon${(0, Fn.Z)(n.variant)}`],
              n.open && t.iconOpen,
            ];
          },
        })(wd);
      var Od = t.forwardRef(function (n, r) {
          const {
              className: o,
              disabled: a,
              error: i,
              IconComponent: s,
              inputRef: l,
              variant: c = "standard",
            } = n,
            u = (0, jt.Z)(n, Cd),
            p = (0, d.Z)({}, n, { disabled: a, variant: c, error: i }),
            m = ((e) => {
              const {
                  classes: t,
                  variant: n,
                  disabled: r,
                  multiple: o,
                  open: a,
                  error: i,
                } = e,
                s = {
                  select: [
                    "select",
                    n,
                    r && "disabled",
                    o && "multiple",
                    i && "error",
                  ],
                  icon: [
                    "icon",
                    `icon${(0, Fn.Z)(n)}`,
                    a && "iconOpen",
                    r && "disabled",
                  ],
                };
              return (0, Nt.Z)(s, yd, t);
            })(p);
          return (0,
          e.jsxs)(t.Fragment, { children: [(0, e.jsx)(kd, (0, d.Z)({ ownerState: p, className: (0, Rt.Z)(m.select, o), disabled: a, ref: l || r }, u)), n.multiple ? null : (0, e.jsx)(Pd, { as: s, ownerState: p, className: m.icon })] });
        }),
        Id = o(5536);
      function Td(e) {
        return (0, Zt.ZP)("MuiSelect", e);
      }
      var Md,
        Ed = (0, Bt.Z)("MuiSelect", [
          "root",
          "select",
          "multiple",
          "filled",
          "outlined",
          "standard",
          "disabled",
          "focused",
          "icon",
          "iconOpen",
          "iconFilled",
          "iconOutlined",
          "iconStandard",
          "nativeInput",
          "error",
        ]);
      const Dd = [
          "aria-describedby",
          "aria-label",
          "autoFocus",
          "autoWidth",
          "children",
          "className",
          "defaultOpen",
          "defaultValue",
          "disabled",
          "displayEmpty",
          "error",
          "IconComponent",
          "inputRef",
          "labelId",
          "MenuProps",
          "multiple",
          "name",
          "onBlur",
          "onChange",
          "onClose",
          "onFocus",
          "onOpen",
          "open",
          "readOnly",
          "renderValue",
          "SelectDisplayProps",
          "tabIndex",
          "type",
          "value",
          "variant",
        ],
        jd = (0, Lt.ZP)("div", {
          name: "MuiSelect",
          slot: "Select",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`&.${Ed.select}`]: t.select },
              { [`&.${Ed.select}`]: t[n.variant] },
              { [`&.${Ed.error}`]: t.error },
              { [`&.${Ed.multiple}`]: t.multiple },
            ];
          },
        })(Sd, {
          [`&.${Ed.select}`]: {
            height: "auto",
            minHeight: "1.4375em",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          },
        }),
        Rd = (0, Lt.ZP)("svg", {
          name: "MuiSelect",
          slot: "Icon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.icon,
              n.variant && t[`icon${(0, Fn.Z)(n.variant)}`],
              n.open && t.iconOpen,
            ];
          },
        })(wd),
        Nd = (0, Lt.ZP)("input", {
          shouldForwardProp: (e) => (0, Id.Z)(e) && "classes" !== e,
          name: "MuiSelect",
          slot: "NativeInput",
          overridesResolver: (e, t) => t.nativeInput,
        })({
          bottom: 0,
          left: 0,
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          width: "100%",
          boxSizing: "border-box",
        });
      function Ad(e, t) {
        return "object" == typeof t && null !== t
          ? e === t
          : String(e) === String(t);
      }
      function Ld(e) {
        return null == e || ("string" == typeof e && !e.trim());
      }
      const zd = t.forwardRef(function (n, r) {
        var o;
        const {
            "aria-describedby": a,
            "aria-label": i,
            autoFocus: s,
            autoWidth: l,
            children: c,
            className: u,
            defaultOpen: p,
            defaultValue: m,
            disabled: h,
            displayEmpty: f,
            error: g = !1,
            IconComponent: v,
            inputRef: b,
            labelId: _,
            MenuProps: y = {},
            multiple: x,
            name: C,
            onBlur: S,
            onChange: k,
            onClose: w,
            onFocus: P,
            onOpen: O,
            open: I,
            readOnly: T,
            renderValue: M,
            SelectDisplayProps: E = {},
            tabIndex: D,
            value: j,
            variant: R = "standard",
          } = n,
          N = (0, jt.Z)(n, Dd),
          [A, L] = (0, ll.Z)({ controlled: j, default: m, name: "Select" }),
          [z, B] = (0, ll.Z)({ controlled: I, default: p, name: "Select" }),
          Z = t.useRef(null),
          F = t.useRef(null),
          [H, V] = t.useState(null),
          { current: W } = t.useRef(null != I),
          [$, U] = t.useState(),
          K = (0, cn.Z)(r, b),
          G = t.useCallback((e) => {
            (F.current = e), e && V(e);
          }, []),
          q = null == H ? void 0 : H.parentNode;
        t.useImperativeHandle(
          K,
          () => ({
            focus: () => {
              F.current.focus();
            },
            node: Z.current,
            value: A,
          }),
          [A]
        ),
          t.useEffect(() => {
            p &&
              z &&
              H &&
              !W &&
              (U(l ? null : q.clientWidth), F.current.focus());
          }, [H, l]),
          t.useEffect(() => {
            s && F.current.focus();
          }, [s]),
          t.useEffect(() => {
            if (!_) return;
            const e = (0, ra.Z)(F.current).getElementById(_);
            if (e) {
              const t = () => {
                getSelection().isCollapsed && F.current.focus();
              };
              return (
                e.addEventListener("click", t),
                () => {
                  e.removeEventListener("click", t);
                }
              );
            }
          }, [_]);
        const Y = (e, t) => {
            e ? O && O(t) : w && w(t), W || (U(l ? null : q.clientWidth), B(e));
          },
          J = t.Children.toArray(c),
          Q = (e) => (t) => {
            let n;
            if (t.currentTarget.hasAttribute("tabindex")) {
              if (x) {
                n = Array.isArray(A) ? A.slice() : [];
                const t = A.indexOf(e.props.value);
                -1 === t ? n.push(e.props.value) : n.splice(t, 1);
              } else n = e.props.value;
              if (
                (e.props.onClick && e.props.onClick(t), A !== n && (L(n), k))
              ) {
                const r = t.nativeEvent || t,
                  o = new r.constructor(r.type, r);
                Object.defineProperty(o, "target", {
                  writable: !0,
                  value: { value: n, name: C },
                }),
                  k(o, e);
              }
              x || Y(!1, t);
            }
          },
          X = null !== H && z;
        let ee, te;
        delete N["aria-invalid"];
        const ne = [];
        let re = !1,
          oe = !1;
        (eu({ value: A }) || f) && (M ? (ee = M(A)) : (re = !0));
        const ae = J.map((e) => {
          if (!t.isValidElement(e)) return null;
          let n;
          if (x) {
            if (!Array.isArray(A)) throw new Error((0, Fc.Z)(2));
            (n = A.some((t) => Ad(t, e.props.value))),
              n && re && ne.push(e.props.children);
          } else (n = Ad(A, e.props.value)), n && re && (te = e.props.children);
          return (
            n && (oe = !0),
            t.cloneElement(e, {
              "aria-selected": n ? "true" : "false",
              onClick: Q(e),
              onKeyUp: (t) => {
                " " === t.key && t.preventDefault(),
                  e.props.onKeyUp && e.props.onKeyUp(t);
              },
              role: "option",
              selected: n,
              value: void 0,
              "data-value": e.props.value,
            })
          );
        });
        re &&
          (ee = x
            ? 0 === ne.length
              ? null
              : ne.reduce(
                  (e, t, n) => (
                    e.push(t), n < ne.length - 1 && e.push(", "), e
                  ),
                  []
                )
            : te);
        let ie,
          se = $;
        !l && W && H && (se = q.clientWidth),
          (ie = void 0 !== D ? D : h ? null : 0);
        const le = E.id || (C ? `mui-component-select-${C}` : void 0),
          ce = (0, d.Z)({}, n, { variant: R, value: A, open: X, error: g }),
          ue = ((e) => {
            const {
                classes: t,
                variant: n,
                disabled: r,
                multiple: o,
                open: a,
                error: i,
              } = e,
              s = {
                select: [
                  "select",
                  n,
                  r && "disabled",
                  o && "multiple",
                  i && "error",
                ],
                icon: [
                  "icon",
                  `icon${(0, Fn.Z)(n)}`,
                  a && "iconOpen",
                  r && "disabled",
                ],
                nativeInput: ["nativeInput"],
              };
            return (0, Nt.Z)(s, Td, t);
          })(ce),
          de = (0, d.Z)(
            {},
            y.PaperProps,
            null == (o = y.slotProps) ? void 0 : o.paper
          ),
          pe = (0, Fl.Z)();
        return (0, e.jsxs)(t.Fragment, {
          children: [
            (0, e.jsx)(
              jd,
              (0, d.Z)(
                {
                  ref: G,
                  tabIndex: ie,
                  role: "combobox",
                  "aria-controls": pe,
                  "aria-disabled": h ? "true" : void 0,
                  "aria-expanded": X ? "true" : "false",
                  "aria-haspopup": "listbox",
                  "aria-label": i,
                  "aria-labelledby":
                    [_, le].filter(Boolean).join(" ") || void 0,
                  "aria-describedby": a,
                  onKeyDown: (e) => {
                    T ||
                      (-1 !==
                        [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) &&
                        (e.preventDefault(), Y(!0, e)));
                  },
                  onMouseDown:
                    h || T
                      ? null
                      : (e) => {
                          0 === e.button &&
                            (e.preventDefault(), F.current.focus(), Y(!0, e));
                        },
                  onBlur: (e) => {
                    !X &&
                      S &&
                      (Object.defineProperty(e, "target", {
                        writable: !0,
                        value: { value: A, name: C },
                      }),
                      S(e));
                  },
                  onFocus: P,
                },
                E,
                {
                  ownerState: ce,
                  className: (0, Rt.Z)(E.className, ue.select, u),
                  id: le,
                  children: Ld(ee)
                    ? Md ||
                      (Md = (0, e.jsx)("span", {
                        className: "notranslate",
                        children: "​",
                      }))
                    : ee,
                }
              )
            ),
            (0, e.jsx)(
              Nd,
              (0, d.Z)(
                {
                  "aria-invalid": g,
                  value: Array.isArray(A) ? A.join(",") : A,
                  name: C,
                  ref: Z,
                  "aria-hidden": !0,
                  onChange: (e) => {
                    const t = J.find((t) => t.props.value === e.target.value);
                    void 0 !== t && (L(t.props.value), k && k(e, t));
                  },
                  tabIndex: -1,
                  disabled: h,
                  className: ue.nativeInput,
                  autoFocus: s,
                  ownerState: ce,
                },
                N
              )
            ),
            (0, e.jsx)(Rd, { as: v, className: ue.icon, ownerState: ce }),
            (0, e.jsx)(
              _d,
              (0, d.Z)(
                {
                  id: `menu-${C || ""}`,
                  anchorEl: q,
                  open: X,
                  onClose: (e) => {
                    Y(!1, e);
                  },
                  anchorOrigin: { vertical: "bottom", horizontal: "center" },
                  transformOrigin: { vertical: "top", horizontal: "center" },
                },
                y,
                {
                  MenuListProps: (0, d.Z)(
                    {
                      "aria-labelledby": _,
                      role: "listbox",
                      "aria-multiselectable": x ? "true" : void 0,
                      disableListWrap: !0,
                      id: pe,
                    },
                    y.MenuListProps
                  ),
                  slotProps: (0, d.Z)({}, y.slotProps, {
                    paper: (0, d.Z)({}, de, {
                      style: (0, d.Z)(
                        { minWidth: se },
                        null != de ? de.style : null
                      ),
                    }),
                  }),
                  children: ae,
                }
              )
            ),
          ],
        });
      });
      var Bd = zd;
      const Zd = [
          "autoWidth",
          "children",
          "classes",
          "className",
          "defaultOpen",
          "displayEmpty",
          "IconComponent",
          "id",
          "input",
          "inputProps",
          "label",
          "labelId",
          "MenuProps",
          "multiple",
          "native",
          "onClose",
          "onOpen",
          "open",
          "renderValue",
          "SelectDisplayProps",
          "variant",
        ],
        Fd = ["root"],
        Hd = {
          name: "MuiSelect",
          overridesResolver: (e, t) => t.root,
          shouldForwardProp: (e) => (0, so.Z)(e) && "variant" !== e,
          slot: "Root",
        },
        Vd = (0, Lt.ZP)(mu, Hd)(""),
        Wd = (0, Lt.ZP)(Iu, Hd)(""),
        $d = (0, Lt.ZP)(_u, Hd)(""),
        Ud = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ name: "MuiSelect", props: n }),
            {
              autoWidth: a = !1,
              children: i,
              classes: s = {},
              className: l,
              defaultOpen: c = !1,
              displayEmpty: u = !1,
              IconComponent: p = bc,
              id: m,
              input: h,
              inputProps: f,
              label: g,
              labelId: v,
              MenuProps: b,
              multiple: _ = !1,
              native: y = !1,
              onClose: x,
              onOpen: C,
              open: S,
              renderValue: k,
              SelectDisplayProps: w,
              variant: P = "outlined",
            } = o,
            O = (0, jt.Z)(o, Zd),
            I = y ? Od : Bd,
            T = Kc({
              props: o,
              muiFormControl: qc(),
              states: ["variant", "error"],
            }),
            M = T.variant || P,
            E = (0, d.Z)({}, o, { variant: M, classes: s }),
            D = ((e) => {
              const { classes: t } = e;
              return t;
            })(E),
            j = (0, jt.Z)(D, Fd),
            R =
              h ||
              {
                standard: (0, e.jsx)(Vd, { ownerState: E }),
                outlined: (0, e.jsx)(Wd, { label: g, ownerState: E }),
                filled: (0, e.jsx)($d, { ownerState: E }),
              }[M],
            N = (0, cn.Z)(r, R.ref);
          return (0,
          e.jsx)(t.Fragment, { children: t.cloneElement(R, (0, d.Z)({ inputComponent: I, inputProps: (0, d.Z)({ children: i, error: T.error, IconComponent: p, variant: M, type: void 0, multiple: _ }, y ? { id: m } : { autoWidth: a, defaultOpen: c, displayEmpty: u, labelId: v, MenuProps: b, onClose: x, onOpen: C, open: S, renderValue: k, SelectDisplayProps: (0, d.Z)({ id: m }, w) }, f, { classes: f ? (0, Zc.Z)(j, f.classes) : j }, h ? h.props.inputProps : {}) }, ((_ && y) || u) && "outlined" === M ? { notched: !0 } : {}, { ref: N, className: (0, Rt.Z)(R.props.className, l, D.root) }, !h && { variant: M }, O)) });
        });
      Ud.muiName = "Select";
      var Kd = Ud;
      function Gd(e) {
        return (0, Zt.ZP)("MuiTextField", e);
      }
      (0, Bt.Z)("MuiTextField", ["root"]);
      const qd = [
          "autoComplete",
          "autoFocus",
          "children",
          "className",
          "color",
          "defaultValue",
          "disabled",
          "error",
          "FormHelperTextProps",
          "fullWidth",
          "helperText",
          "id",
          "InputLabelProps",
          "inputProps",
          "InputProps",
          "inputRef",
          "label",
          "maxRows",
          "minRows",
          "multiline",
          "name",
          "onBlur",
          "onChange",
          "onFocus",
          "placeholder",
          "required",
          "rows",
          "select",
          "SelectProps",
          "type",
          "value",
          "variant",
        ],
        Yd = { standard: mu, filled: _u, outlined: Iu },
        Jd = (0, Lt.ZP)($u, {
          name: "MuiTextField",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        Qd = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiTextField" }),
            {
              autoComplete: o,
              autoFocus: a = !1,
              children: i,
              className: s,
              color: l = "primary",
              defaultValue: c,
              disabled: u = !1,
              error: p = !1,
              FormHelperTextProps: m,
              fullWidth: h = !1,
              helperText: f,
              id: g,
              InputLabelProps: v,
              inputProps: b,
              InputProps: _,
              inputRef: y,
              label: x,
              maxRows: C,
              minRows: S,
              multiline: k = !1,
              name: w,
              onBlur: P,
              onChange: O,
              onFocus: I,
              placeholder: T,
              required: M = !1,
              rows: E,
              select: D = !1,
              SelectProps: j,
              type: R,
              value: N,
              variant: A = "outlined",
            } = r,
            L = (0, jt.Z)(r, qd),
            z = (0, d.Z)({}, r, {
              autoFocus: a,
              color: l,
              disabled: u,
              error: p,
              fullWidth: h,
              multiline: k,
              required: M,
              select: D,
              variant: A,
            }),
            B = ((e) => {
              const { classes: t } = e;
              return (0, Nt.Z)({ root: ["root"] }, Gd, t);
            })(z),
            Z = {};
          "outlined" === A &&
            (v && void 0 !== v.shrink && (Z.notched = v.shrink), (Z.label = x)),
            D &&
              ((j && j.native) || (Z.id = void 0),
              (Z["aria-describedby"] = void 0));
          const F = (0, Fl.Z)(g),
            H = f && F ? `${F}-helper-text` : void 0,
            V = x && F ? `${F}-label` : void 0,
            W = Yd[A],
            $ = (0, e.jsx)(
              W,
              (0, d.Z)(
                {
                  "aria-describedby": H,
                  autoComplete: o,
                  autoFocus: a,
                  defaultValue: c,
                  fullWidth: h,
                  multiline: k,
                  name: w,
                  rows: E,
                  maxRows: C,
                  minRows: S,
                  type: R,
                  value: N,
                  id: F,
                  inputRef: y,
                  onBlur: P,
                  onChange: O,
                  onFocus: I,
                  placeholder: T,
                  inputProps: b,
                },
                Z,
                _
              )
            );
          return (0,
          e.jsxs)(Jd, (0, d.Z)({ className: (0, Rt.Z)(B.root, s), disabled: u, error: p, fullWidth: h, ref: n, required: M, color: l, variant: A, ownerState: z }, L, { children: [null != x && "" !== x && (0, e.jsx)(Bu, (0, d.Z)({ htmlFor: F, id: V }, v, { children: x })), D ? (0, e.jsx)(Kd, (0, d.Z)({ "aria-describedby": H, id: F, labelId: V, value: N, input: $ }, j, { children: i })) : $, f && (0, e.jsx)(Ju, (0, d.Z)({ id: H }, m, { children: f }))] }));
        });
      var Xd = Qd;
      function ep(e) {
        return (0, Zt.ZP)("MuiInputAdornment", e);
      }
      var tp,
        np = (0, Bt.Z)("MuiInputAdornment", [
          "root",
          "filled",
          "standard",
          "outlined",
          "positionStart",
          "positionEnd",
          "disablePointerEvents",
          "hiddenLabel",
          "sizeSmall",
        ]);
      const rp = [
          "children",
          "className",
          "component",
          "disablePointerEvents",
          "disableTypography",
          "position",
          "variant",
        ],
        op = (0, Lt.ZP)("div", {
          name: "MuiInputAdornment",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`position${(0, Fn.Z)(n.position)}`],
              !0 === n.disablePointerEvents && t.disablePointerEvents,
              t[n.variant],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              display: "flex",
              height: "0.01em",
              maxHeight: "2em",
              alignItems: "center",
              whiteSpace: "nowrap",
              color: (e.vars || e).palette.action.active,
            },
            "filled" === t.variant && {
              [`&.${np.positionStart}&:not(.${np.hiddenLabel})`]: {
                marginTop: 16,
              },
            },
            "start" === t.position && { marginRight: 8 },
            "end" === t.position && { marginLeft: 8 },
            !0 === t.disablePointerEvents && { pointerEvents: "none" }
          )
        );
      var ap = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiInputAdornment" }),
            {
              children: a,
              className: i,
              component: s = "div",
              disablePointerEvents: l = !1,
              disableTypography: c = !1,
              position: u,
              variant: p,
            } = o,
            m = (0, jt.Z)(o, rp),
            h = qc() || {};
          let f = p;
          p && h.variant, h && !f && (f = h.variant);
          const g = (0, d.Z)({}, o, {
              hiddenLabel: h.hiddenLabel,
              size: h.size,
              disablePointerEvents: l,
              position: u,
              variant: f,
            }),
            v = ((e) => {
              const {
                  classes: t,
                  disablePointerEvents: n,
                  hiddenLabel: r,
                  position: o,
                  size: a,
                  variant: i,
                } = e,
                s = {
                  root: [
                    "root",
                    n && "disablePointerEvents",
                    o && `position${(0, Fn.Z)(o)}`,
                    i,
                    r && "hiddenLabel",
                    a && `size${(0, Fn.Z)(a)}`,
                  ],
                };
              return (0, Nt.Z)(s, ep, t);
            })(g);
          return (0,
          e.jsx)(Gc.Provider, { value: null, children: (0, e.jsx)(op, (0, d.Z)({ as: s, ownerState: g, className: (0, Rt.Z)(v.root, i), ref: r }, m, { children: "string" != typeof a || c ? (0, e.jsxs)(t.Fragment, { children: ["start" === u ? tp || (tp = (0, e.jsx)("span", { className: "notranslate", children: "​" })) : null, a] }) : (0, e.jsx)(Wa, { color: "text.secondary", children: a }) })) });
        }),
        ip = o(2236);
      function sp(e) {
        return (0, Zt.ZP)("MuiButton", e);
      }
      var lp = (0, Bt.Z)("MuiButton", [
          "root",
          "text",
          "textInherit",
          "textPrimary",
          "textSecondary",
          "textSuccess",
          "textError",
          "textInfo",
          "textWarning",
          "outlined",
          "outlinedInherit",
          "outlinedPrimary",
          "outlinedSecondary",
          "outlinedSuccess",
          "outlinedError",
          "outlinedInfo",
          "outlinedWarning",
          "contained",
          "containedInherit",
          "containedPrimary",
          "containedSecondary",
          "containedSuccess",
          "containedError",
          "containedInfo",
          "containedWarning",
          "disableElevation",
          "focusVisible",
          "disabled",
          "colorInherit",
          "colorPrimary",
          "colorSecondary",
          "colorSuccess",
          "colorError",
          "colorInfo",
          "colorWarning",
          "textSizeSmall",
          "textSizeMedium",
          "textSizeLarge",
          "outlinedSizeSmall",
          "outlinedSizeMedium",
          "outlinedSizeLarge",
          "containedSizeSmall",
          "containedSizeMedium",
          "containedSizeLarge",
          "sizeMedium",
          "sizeSmall",
          "sizeLarge",
          "fullWidth",
          "startIcon",
          "endIcon",
          "icon",
          "iconSizeSmall",
          "iconSizeMedium",
          "iconSizeLarge",
        ]),
        cp = t.createContext({}),
        up = t.createContext(void 0);
      const dp = [
          "children",
          "color",
          "component",
          "className",
          "disabled",
          "disableElevation",
          "disableFocusRipple",
          "endIcon",
          "focusVisibleClassName",
          "fullWidth",
          "size",
          "startIcon",
          "type",
          "variant",
        ],
        pp = (e) =>
          (0, d.Z)(
            {},
            "small" === e.size && { "& > *:nth-of-type(1)": { fontSize: 18 } },
            "medium" === e.size && { "& > *:nth-of-type(1)": { fontSize: 20 } },
            "large" === e.size && { "& > *:nth-of-type(1)": { fontSize: 22 } }
          ),
        mp = (0, Lt.ZP)(Zn, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiButton",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              t[`${n.variant}${(0, Fn.Z)(n.color)}`],
              t[`size${(0, Fn.Z)(n.size)}`],
              t[`${n.variant}Size${(0, Fn.Z)(n.size)}`],
              "inherit" === n.color && t.colorInherit,
              n.disableElevation && t.disableElevation,
              n.fullWidth && t.fullWidth,
            ];
          },
        })(
          ({ theme: e, ownerState: t }) => {
            var n, r;
            const o =
                "light" === e.palette.mode
                  ? e.palette.grey[300]
                  : e.palette.grey[800],
              a =
                "light" === e.palette.mode
                  ? e.palette.grey.A100
                  : e.palette.grey[700];
            return (0, d.Z)(
              {},
              e.typography.button,
              {
                minWidth: 64,
                padding: "6px 16px",
                borderRadius: (e.vars || e).shape.borderRadius,
                transition: e.transitions.create(
                  ["background-color", "box-shadow", "border-color", "color"],
                  { duration: e.transitions.duration.short }
                ),
                "&:hover": (0, d.Z)(
                  {
                    textDecoration: "none",
                    backgroundColor: e.vars
                      ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})`
                      : (0, At.Fq)(
                          e.palette.text.primary,
                          e.palette.action.hoverOpacity
                        ),
                    "@media (hover: none)": { backgroundColor: "transparent" },
                  },
                  "text" === t.variant &&
                    "inherit" !== t.color && {
                      backgroundColor: e.vars
                        ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                            e.vars.palette.action.hoverOpacity
                          })`
                        : (0, At.Fq)(
                            e.palette[t.color].main,
                            e.palette.action.hoverOpacity
                          ),
                      "@media (hover: none)": {
                        backgroundColor: "transparent",
                      },
                    },
                  "outlined" === t.variant &&
                    "inherit" !== t.color && {
                      border: `1px solid ${
                        (e.vars || e).palette[t.color].main
                      }`,
                      backgroundColor: e.vars
                        ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                            e.vars.palette.action.hoverOpacity
                          })`
                        : (0, At.Fq)(
                            e.palette[t.color].main,
                            e.palette.action.hoverOpacity
                          ),
                      "@media (hover: none)": {
                        backgroundColor: "transparent",
                      },
                    },
                  "contained" === t.variant && {
                    backgroundColor: e.vars
                      ? e.vars.palette.Button.inheritContainedHoverBg
                      : a,
                    boxShadow: (e.vars || e).shadows[4],
                    "@media (hover: none)": {
                      boxShadow: (e.vars || e).shadows[2],
                      backgroundColor: (e.vars || e).palette.grey[300],
                    },
                  },
                  "contained" === t.variant &&
                    "inherit" !== t.color && {
                      backgroundColor: (e.vars || e).palette[t.color].dark,
                      "@media (hover: none)": {
                        backgroundColor: (e.vars || e).palette[t.color].main,
                      },
                    }
                ),
                "&:active": (0, d.Z)(
                  {},
                  "contained" === t.variant && {
                    boxShadow: (e.vars || e).shadows[8],
                  }
                ),
                [`&.${lp.focusVisible}`]: (0, d.Z)(
                  {},
                  "contained" === t.variant && {
                    boxShadow: (e.vars || e).shadows[6],
                  }
                ),
                [`&.${lp.disabled}`]: (0, d.Z)(
                  { color: (e.vars || e).palette.action.disabled },
                  "outlined" === t.variant && {
                    border: `1px solid ${
                      (e.vars || e).palette.action.disabledBackground
                    }`,
                  },
                  "contained" === t.variant && {
                    color: (e.vars || e).palette.action.disabled,
                    boxShadow: (e.vars || e).shadows[0],
                    backgroundColor: (e.vars || e).palette.action
                      .disabledBackground,
                  }
                ),
              },
              "text" === t.variant && { padding: "6px 8px" },
              "text" === t.variant &&
                "inherit" !== t.color && {
                  color: (e.vars || e).palette[t.color].main,
                },
              "outlined" === t.variant && {
                padding: "5px 15px",
                border: "1px solid currentColor",
              },
              "outlined" === t.variant &&
                "inherit" !== t.color && {
                  color: (e.vars || e).palette[t.color].main,
                  border: e.vars
                    ? `1px solid rgba(${
                        e.vars.palette[t.color].mainChannel
                      } / 0.5)`
                    : `1px solid ${(0, At.Fq)(e.palette[t.color].main, 0.5)}`,
                },
              "contained" === t.variant && {
                color: e.vars
                  ? e.vars.palette.text.primary
                  : null == (n = (r = e.palette).getContrastText)
                  ? void 0
                  : n.call(r, e.palette.grey[300]),
                backgroundColor: e.vars
                  ? e.vars.palette.Button.inheritContainedBg
                  : o,
                boxShadow: (e.vars || e).shadows[2],
              },
              "contained" === t.variant &&
                "inherit" !== t.color && {
                  color: (e.vars || e).palette[t.color].contrastText,
                  backgroundColor: (e.vars || e).palette[t.color].main,
                },
              "inherit" === t.color && {
                color: "inherit",
                borderColor: "currentColor",
              },
              "small" === t.size &&
                "text" === t.variant && {
                  padding: "4px 5px",
                  fontSize: e.typography.pxToRem(13),
                },
              "large" === t.size &&
                "text" === t.variant && {
                  padding: "8px 11px",
                  fontSize: e.typography.pxToRem(15),
                },
              "small" === t.size &&
                "outlined" === t.variant && {
                  padding: "3px 9px",
                  fontSize: e.typography.pxToRem(13),
                },
              "large" === t.size &&
                "outlined" === t.variant && {
                  padding: "7px 21px",
                  fontSize: e.typography.pxToRem(15),
                },
              "small" === t.size &&
                "contained" === t.variant && {
                  padding: "4px 10px",
                  fontSize: e.typography.pxToRem(13),
                },
              "large" === t.size &&
                "contained" === t.variant && {
                  padding: "8px 22px",
                  fontSize: e.typography.pxToRem(15),
                },
              t.fullWidth && { width: "100%" }
            );
          },
          ({ ownerState: e }) =>
            e.disableElevation && {
              boxShadow: "none",
              "&:hover": { boxShadow: "none" },
              [`&.${lp.focusVisible}`]: { boxShadow: "none" },
              "&:active": { boxShadow: "none" },
              [`&.${lp.disabled}`]: { boxShadow: "none" },
            }
        ),
        hp = (0, Lt.ZP)("span", {
          name: "MuiButton",
          slot: "StartIcon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.startIcon, t[`iconSize${(0, Fn.Z)(n.size)}`]];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { display: "inherit", marginRight: 8, marginLeft: -4 },
            "small" === e.size && { marginLeft: -2 },
            pp(e)
          )
        ),
        fp = (0, Lt.ZP)("span", {
          name: "MuiButton",
          slot: "EndIcon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.endIcon, t[`iconSize${(0, Fn.Z)(n.size)}`]];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { display: "inherit", marginRight: -4, marginLeft: 8 },
            "small" === e.size && { marginRight: -2 },
            pp(e)
          )
        ),
        gp = t.forwardRef(function (n, r) {
          const o = t.useContext(cp),
            a = t.useContext(up),
            i = (0, ip.Z)(o, n),
            s = (0, zt.Z)({ props: i, name: "MuiButton" }),
            {
              children: l,
              color: c = "primary",
              component: u = "button",
              className: p,
              disabled: m = !1,
              disableElevation: h = !1,
              disableFocusRipple: f = !1,
              endIcon: g,
              focusVisibleClassName: v,
              fullWidth: b = !1,
              size: _ = "medium",
              startIcon: y,
              type: x,
              variant: C = "text",
            } = s,
            S = (0, jt.Z)(s, dp),
            k = (0, d.Z)({}, s, {
              color: c,
              component: u,
              disabled: m,
              disableElevation: h,
              disableFocusRipple: f,
              fullWidth: b,
              size: _,
              type: x,
              variant: C,
            }),
            w = ((e) => {
              const {
                  color: t,
                  disableElevation: n,
                  fullWidth: r,
                  size: o,
                  variant: a,
                  classes: i,
                } = e,
                s = {
                  root: [
                    "root",
                    a,
                    `${a}${(0, Fn.Z)(t)}`,
                    `size${(0, Fn.Z)(o)}`,
                    `${a}Size${(0, Fn.Z)(o)}`,
                    `color${(0, Fn.Z)(t)}`,
                    n && "disableElevation",
                    r && "fullWidth",
                  ],
                  label: ["label"],
                  startIcon: ["icon", "startIcon", `iconSize${(0, Fn.Z)(o)}`],
                  endIcon: ["icon", "endIcon", `iconSize${(0, Fn.Z)(o)}`],
                },
                l = (0, Nt.Z)(s, sp, i);
              return (0, d.Z)({}, i, l);
            })(k),
            P =
              y &&
              (0, e.jsx)(hp, {
                className: w.startIcon,
                ownerState: k,
                children: y,
              }),
            O =
              g &&
              (0, e.jsx)(fp, {
                className: w.endIcon,
                ownerState: k,
                children: g,
              }),
            I = a || "";
          return (0,
          e.jsxs)(mp, (0, d.Z)({ ownerState: k, className: (0, Rt.Z)(o.className, w.root, p, I), component: u, disabled: m, focusRipple: !f, focusVisibleClassName: (0, Rt.Z)(w.focusVisible, v), ref: r, type: x }, S, { classes: w, children: [P, l, O] }));
        });
      var vp = gp;
      function bp(e) {
        return (0, Zt.ZP)("MuiBadge", e);
      }
      var _p = (0, Bt.Z)("MuiBadge", [
        "root",
        "badge",
        "dot",
        "standard",
        "anchorOriginTopRight",
        "anchorOriginBottomRight",
        "anchorOriginTopLeft",
        "anchorOriginBottomLeft",
        "invisible",
        "colorError",
        "colorInfo",
        "colorPrimary",
        "colorSecondary",
        "colorSuccess",
        "colorWarning",
        "overlapRectangular",
        "overlapCircular",
        "anchorOriginTopLeftCircular",
        "anchorOriginTopLeftRectangular",
        "anchorOriginTopRightCircular",
        "anchorOriginTopRightRectangular",
        "anchorOriginBottomLeftCircular",
        "anchorOriginBottomLeftRectangular",
        "anchorOriginBottomRightCircular",
        "anchorOriginBottomRightRectangular",
      ]);
      const yp = [
          "anchorOrigin",
          "className",
          "classes",
          "component",
          "components",
          "componentsProps",
          "children",
          "overlap",
          "color",
          "invisible",
          "max",
          "badgeContent",
          "slots",
          "slotProps",
          "showZero",
          "variant",
        ],
        xp = _c(),
        Cp = (0, Lt.ZP)("span", {
          name: "MuiBadge",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({
          position: "relative",
          display: "inline-flex",
          verticalAlign: "middle",
          flexShrink: 0,
        }),
        Sp = (0, Lt.ZP)("span", {
          name: "MuiBadge",
          slot: "Badge",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.badge,
              t[n.variant],
              t[
                `anchorOrigin${(0, Fn.Z)(n.anchorOrigin.vertical)}${(0, Fn.Z)(
                  n.anchorOrigin.horizontal
                )}${(0, Fn.Z)(n.overlap)}`
              ],
              "default" !== n.color && t[`color${(0, Fn.Z)(n.color)}`],
              n.invisible && t.invisible,
            ];
          },
        })(({ theme: e }) => {
          var t;
          return {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            position: "absolute",
            boxSizing: "border-box",
            fontFamily: e.typography.fontFamily,
            fontWeight: e.typography.fontWeightMedium,
            fontSize: e.typography.pxToRem(12),
            minWidth: 20,
            lineHeight: 1,
            padding: "0 6px",
            height: 20,
            borderRadius: 10,
            zIndex: 1,
            transition: e.transitions.create("transform", {
              easing: e.transitions.easing.easeInOut,
              duration: e.transitions.duration.enteringScreen,
            }),
            variants: [
              ...Object.keys((null != (t = e.vars) ? t : e).palette)
                .filter((t) => {
                  var n, r;
                  return (
                    (null != (n = e.vars) ? n : e).palette[t].main &&
                    (null != (r = e.vars) ? r : e).palette[t].contrastText
                  );
                })
                .map((t) => ({
                  props: { color: t },
                  style: {
                    backgroundColor: (e.vars || e).palette[t].main,
                    color: (e.vars || e).palette[t].contrastText,
                  },
                })),
              {
                props: { variant: "dot" },
                style: { borderRadius: 4, height: 8, minWidth: 8, padding: 0 },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  top: 0,
                  right: 0,
                  transform: "scale(1) translate(50%, -50%)",
                  transformOrigin: "100% 0%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  bottom: 0,
                  right: 0,
                  transform: "scale(1) translate(50%, 50%)",
                  transformOrigin: "100% 100%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(50%, 50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  top: 0,
                  left: 0,
                  transform: "scale(1) translate(-50%, -50%)",
                  transformOrigin: "0% 0%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(-50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  bottom: 0,
                  left: 0,
                  transform: "scale(1) translate(-50%, 50%)",
                  transformOrigin: "0% 100%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(-50%, 50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  top: "14%",
                  right: "14%",
                  transform: "scale(1) translate(50%, -50%)",
                  transformOrigin: "100% 0%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  bottom: "14%",
                  right: "14%",
                  transform: "scale(1) translate(50%, 50%)",
                  transformOrigin: "100% 100%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(50%, 50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  top: "14%",
                  left: "14%",
                  transform: "scale(1) translate(-50%, -50%)",
                  transformOrigin: "0% 0%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(-50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  bottom: "14%",
                  left: "14%",
                  transform: "scale(1) translate(-50%, 50%)",
                  transformOrigin: "0% 100%",
                  [`&.${_p.invisible}`]: {
                    transform: "scale(0) translate(-50%, 50%)",
                  },
                },
              },
              {
                props: { invisible: !0 },
                style: {
                  transition: e.transitions.create("transform", {
                    easing: e.transitions.easing.easeInOut,
                    duration: e.transitions.duration.leavingScreen,
                  }),
                },
              },
            ],
          };
        }),
        kp = t.forwardRef(function (t, n) {
          var r, o, a, i, s, l;
          const c = xp({ props: t, name: "MuiBadge" }),
            {
              anchorOrigin: u = { vertical: "top", horizontal: "right" },
              className: p,
              component: m,
              components: h = {},
              componentsProps: f = {},
              children: g,
              overlap: v = "rectangular",
              color: b = "default",
              invisible: _ = !1,
              max: y = 99,
              badgeContent: x,
              slots: C,
              slotProps: S,
              showZero: k = !1,
              variant: w = "standard",
            } = c,
            P = (0, jt.Z)(c, yp),
            {
              badgeContent: O,
              invisible: I,
              max: T,
              displayValue: M,
            } = (function (e) {
              const {
                  badgeContent: t,
                  invisible: n = !1,
                  max: r = 99,
                  showZero: o = !1,
                } = e,
                a = Vl({ badgeContent: t, max: r });
              let i = n;
              !1 !== n || 0 !== t || o || (i = !0);
              const { badgeContent: s, max: l = r } = i ? a : e;
              return {
                badgeContent: s,
                invisible: i,
                max: l,
                displayValue: s && Number(s) > l ? `${l}+` : s,
              };
            })({ max: y, invisible: _, badgeContent: x, showZero: k }),
            E = Vl({
              anchorOrigin: u,
              color: b,
              overlap: v,
              variant: w,
              badgeContent: x,
            }),
            D = I || (null == O && "dot" !== w),
            {
              color: j = b,
              overlap: R = v,
              anchorOrigin: N = u,
              variant: A = w,
            } = D ? E : c,
            L = "dot" !== A ? M : void 0,
            z = (0, d.Z)({}, c, {
              badgeContent: O,
              invisible: D,
              max: T,
              displayValue: L,
              showZero: k,
              anchorOrigin: N,
              color: j,
              overlap: R,
              variant: A,
            }),
            B = ((e) => {
              const {
                  color: t,
                  anchorOrigin: n,
                  invisible: r,
                  overlap: o,
                  variant: a,
                  classes: i = {},
                } = e,
                s = {
                  root: ["root"],
                  badge: [
                    "badge",
                    a,
                    r && "invisible",
                    `anchorOrigin${(0, Fn.Z)(n.vertical)}${(0, Fn.Z)(
                      n.horizontal
                    )}`,
                    `anchorOrigin${(0, Fn.Z)(n.vertical)}${(0, Fn.Z)(
                      n.horizontal
                    )}${(0, Fn.Z)(o)}`,
                    `overlap${(0, Fn.Z)(o)}`,
                    "default" !== t && `color${(0, Fn.Z)(t)}`,
                  ],
                };
              return (0, Nt.Z)(s, bp, i);
            })(z),
            Z =
              null !=
              (r = null != (o = null == C ? void 0 : C.root) ? o : h.Root)
                ? r
                : Cp,
            F =
              null !=
              (a = null != (i = null == C ? void 0 : C.badge) ? i : h.Badge)
                ? a
                : Sp,
            H = null != (s = null == S ? void 0 : S.root) ? s : f.root,
            V = null != (l = null == S ? void 0 : S.badge) ? l : f.badge,
            W = ir({
              elementType: Z,
              externalSlotProps: H,
              externalForwardedProps: P,
              additionalProps: { ref: n, as: m },
              ownerState: z,
              className: (0, Rt.Z)(null == H ? void 0 : H.className, B.root, p),
            }),
            $ = ir({
              elementType: F,
              externalSlotProps: V,
              ownerState: z,
              className: (0, Rt.Z)(B.badge, null == V ? void 0 : V.className),
            });
          return (0,
          e.jsxs)(Z, (0, d.Z)({}, W, { children: [g, (0, e.jsx)(F, (0, d.Z)({}, $, { children: L }))] }));
        });
      var wp = kp,
        Pp = o(7408);
      const Op = ["ownerState"],
        Ip = ["variants"],
        Tp = [
          "name",
          "slot",
          "skipVariantsResolver",
          "skipSx",
          "overridesResolver",
        ];
      function Mp(e) {
        return "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e;
      }
      const Ep = (0, Pp.Z)(),
        Dp = (e) => (e ? e.charAt(0).toLowerCase() + e.slice(1) : e);
      function jp({ defaultTheme: e, theme: t, themeId: n }) {
        return (r = t), 0 === Object.keys(r).length ? e : t[n] || t;
        var r;
      }
      function Rp(e) {
        return e ? (t, n) => n[e] : null;
      }
      function Np(e, t) {
        let { ownerState: n } = t,
          r = (0, jt.Z)(t, Op);
        const o =
          "function" == typeof e ? e((0, d.Z)({ ownerState: n }, r)) : e;
        if (Array.isArray(o))
          return o.flatMap((e) => Np(e, (0, d.Z)({ ownerState: n }, r)));
        if (o && "object" == typeof o && Array.isArray(o.variants)) {
          const { variants: e = [] } = o;
          let t = (0, jt.Z)(o, Ip);
          return (
            e.forEach((e) => {
              let o = !0;
              "function" == typeof e.props
                ? (o = e.props((0, d.Z)({ ownerState: n }, r, n)))
                : Object.keys(e.props).forEach((t) => {
                    (null == n ? void 0 : n[t]) !== e.props[t] &&
                      r[t] !== e.props[t] &&
                      (o = !1);
                  }),
                o &&
                  (Array.isArray(t) || (t = [t]),
                  t.push(
                    "function" == typeof e.style
                      ? e.style((0, d.Z)({ ownerState: n }, r, n))
                      : e.style
                  ));
            }),
            t
          );
        }
        return o;
      }
      const Ap = (function (e = {}) {
        const {
            themeId: t,
            defaultTheme: n = Ep,
            rootShouldForwardProp: r = Mp,
            slotShouldForwardProp: o = Mp,
          } = e,
          a = (e) =>
            (0, Jt.Z)(
              (0, d.Z)({}, e, {
                theme: jp((0, d.Z)({}, e, { defaultTheme: n, themeId: t })),
              })
            );
        return (
          (a.__mui_systemSx = !0),
          (e, i = {}) => {
            (0, Yt.internal_processStyles)(e, (e) =>
              e.filter((e) => !(null != e && e.__mui_systemSx))
            );
            const {
                name: s,
                slot: l,
                skipVariantsResolver: c,
                skipSx: u,
                overridesResolver: p = Rp(Dp(l)),
              } = i,
              m = (0, jt.Z)(i, Tp),
              h = void 0 !== c ? c : (l && "Root" !== l && "root" !== l) || !1,
              f = u || !1;
            let g = Mp;
            "Root" === l || "root" === l
              ? (g = r)
              : l
              ? (g = o)
              : (function (e) {
                  return "string" == typeof e && e.charCodeAt(0) > 96;
                })(e) && (g = void 0);
            const v = (0, Yt.default)(
                e,
                (0, d.Z)({ shouldForwardProp: g, label: void 0 }, m)
              ),
              b = (e) =>
                ("function" == typeof e && e.__emotion_real !== e) ||
                (0, Zc.P)(e)
                  ? (r) =>
                      Np(
                        e,
                        (0, d.Z)({}, r, {
                          theme: jp({
                            theme: r.theme,
                            defaultTheme: n,
                            themeId: t,
                          }),
                        })
                      )
                  : e,
              _ = (r, ...o) => {
                let i = b(r);
                const l = o ? o.map(b) : [];
                s &&
                  p &&
                  l.push((e) => {
                    const r = jp(
                      (0, d.Z)({}, e, { defaultTheme: n, themeId: t })
                    );
                    if (
                      !r.components ||
                      !r.components[s] ||
                      !r.components[s].styleOverrides
                    )
                      return null;
                    const o = r.components[s].styleOverrides,
                      a = {};
                    return (
                      Object.entries(o).forEach(([t, n]) => {
                        a[t] = Np(n, (0, d.Z)({}, e, { theme: r }));
                      }),
                      p(e, a)
                    );
                  }),
                  s &&
                    !h &&
                    l.push((e) => {
                      var r;
                      const o = jp(
                        (0, d.Z)({}, e, { defaultTheme: n, themeId: t })
                      );
                      return Np(
                        {
                          variants:
                            null == o ||
                            null == (r = o.components) ||
                            null == (r = r[s])
                              ? void 0
                              : r.variants,
                        },
                        (0, d.Z)({}, e, { theme: o })
                      );
                    }),
                  f || l.push(a);
                const c = l.length - o.length;
                if (Array.isArray(r) && c > 0) {
                  const e = new Array(c).fill("");
                  (i = [...r, ...e]), (i.raw = [...r.raw, ...e]);
                }
                const u = v(i, ...l);
                return e.muiName && (u.muiName = e.muiName), u;
              };
            return v.withConfig && (_.withConfig = v.withConfig), _;
          }
        );
      })();
      var Lp = Ap,
        zp = o(9628),
        Bp = o(2605);
      const Zp = [
          "component",
          "direction",
          "spacing",
          "divider",
          "children",
          "className",
          "useFlexGap",
        ],
        Fp = (0, Pp.Z)(),
        Hp = Lp("div", {
          name: "MuiStack",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        });
      function Vp(e) {
        return (0, zp.Z)({ props: e, name: "MuiStack", defaultTheme: Fp });
      }
      function Wp(e, n) {
        const r = t.Children.toArray(e).filter(Boolean);
        return r.reduce(
          (e, o, a) => (
            e.push(o),
            a < r.length - 1 &&
              e.push(t.cloneElement(n, { key: `separator-${a}` })),
            e
          ),
          []
        );
      }
      const $p = ({ ownerState: e, theme: t }) => {
          let n = (0, d.Z)(
            { display: "flex", flexDirection: "column" },
            (0, Pa.k9)(
              { theme: t },
              (0, Pa.P$)({
                values: e.direction,
                breakpoints: t.breakpoints.values,
              }),
              (e) => ({ flexDirection: e })
            )
          );
          if (e.spacing) {
            const r = (0, Bp.hB)(t),
              o = Object.keys(t.breakpoints.values).reduce(
                (t, n) => (
                  (("object" == typeof e.spacing && null != e.spacing[n]) ||
                    ("object" == typeof e.direction &&
                      null != e.direction[n])) &&
                    (t[n] = !0),
                  t
                ),
                {}
              ),
              a = (0, Pa.P$)({ values: e.direction, base: o }),
              i = (0, Pa.P$)({ values: e.spacing, base: o });
            "object" == typeof a &&
              Object.keys(a).forEach((e, t, n) => {
                if (!a[e]) {
                  const r = t > 0 ? a[n[t - 1]] : "column";
                  a[e] = r;
                }
              });
            const s = (t, n) => {
              return e.useFlexGap
                ? { gap: (0, Bp.NA)(r, t) }
                : {
                    "& > :not(style):not(style)": { margin: 0 },
                    "& > :not(style) ~ :not(style)": {
                      [`margin${
                        ((o = n ? a[n] : e.direction),
                        {
                          row: "Left",
                          "row-reverse": "Right",
                          column: "Top",
                          "column-reverse": "Bottom",
                        }[o])
                      }`]: (0, Bp.NA)(r, t),
                    },
                  };
              var o;
            };
            n = (0, Zc.Z)(n, (0, Pa.k9)({ theme: t }, i, s));
          }
          return (n = (0, Pa.dt)(t.breakpoints, n)), n;
        },
        Up = (function (n = {}) {
          const {
              createStyledComponent: r = Hp,
              useThemeProps: o = Vp,
              componentName: a = "MuiStack",
            } = n,
            i = r($p),
            s = t.forwardRef(function (t, n) {
              const r = o(t),
                s = (0, Qt.Z)(r),
                {
                  component: l = "div",
                  direction: c = "column",
                  spacing: u = 0,
                  divider: p,
                  children: m,
                  className: h,
                  useFlexGap: f = !1,
                } = s,
                g = (0, jt.Z)(s, Zp),
                v = { direction: c, spacing: u, useFlexGap: f },
                b = (0, Nt.Z)({ root: ["root"] }, (e) => (0, Zt.ZP)(a, e), {});
              return (0,
              e.jsx)(i, (0, d.Z)({ as: l, ownerState: v, ref: n, className: qt(b.root, h) }, g, { children: p ? Wp(m, p) : m }));
            });
          return s;
        })({
          createStyledComponent: (0, Lt.ZP)("div", {
            name: "MuiStack",
            slot: "Root",
            overridesResolver: (e, t) => t.root,
          }),
          useThemeProps: (e) => (0, zt.Z)({ props: e, name: "MuiStack" }),
        });
      var Kp = Up;
      function Gp(e) {
        return (0, Zt.ZP)("MuiFormControlLabel", e);
      }
      var qp = (0, Bt.Z)("MuiFormControlLabel", [
        "root",
        "labelPlacementStart",
        "labelPlacementTop",
        "labelPlacementBottom",
        "disabled",
        "label",
        "error",
        "required",
        "asterisk",
      ]);
      const Yp = [
          "checked",
          "className",
          "componentsProps",
          "control",
          "disabled",
          "disableTypography",
          "inputRef",
          "label",
          "labelPlacement",
          "name",
          "onChange",
          "required",
          "slotProps",
          "value",
        ],
        Jp = (0, Lt.ZP)("label", {
          name: "MuiFormControlLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${qp.label}`]: t.label },
              t.root,
              t[`labelPlacement${(0, Fn.Z)(n.labelPlacement)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
              verticalAlign: "middle",
              WebkitTapHighlightColor: "transparent",
              marginLeft: -11,
              marginRight: 16,
              [`&.${qp.disabled}`]: { cursor: "default" },
            },
            "start" === t.labelPlacement && {
              flexDirection: "row-reverse",
              marginLeft: 16,
              marginRight: -11,
            },
            "top" === t.labelPlacement && {
              flexDirection: "column-reverse",
              marginLeft: 16,
            },
            "bottom" === t.labelPlacement && {
              flexDirection: "column",
              marginLeft: 16,
            },
            {
              [`& .${qp.label}`]: {
                [`&.${qp.disabled}`]: {
                  color: (e.vars || e).palette.text.disabled,
                },
              },
            }
          )
        ),
        Qp = (0, Lt.ZP)("span", {
          name: "MuiFormControlLabel",
          slot: "Asterisk",
          overridesResolver: (e, t) => t.asterisk,
        })(({ theme: e }) => ({
          [`&.${qp.error}`]: { color: (e.vars || e).palette.error.main },
        }));
      var Xp = t.forwardRef(function (n, r) {
        var o, a;
        const i = (0, zt.Z)({ props: n, name: "MuiFormControlLabel" }),
          {
            className: s,
            componentsProps: l = {},
            control: c,
            disabled: u,
            disableTypography: p,
            label: m,
            labelPlacement: h = "end",
            required: f,
            slotProps: g = {},
          } = i,
          v = (0, jt.Z)(i, Yp),
          b = qc(),
          _ =
            null != (o = null != u ? u : c.props.disabled)
              ? o
              : null == b
              ? void 0
              : b.disabled,
          y = null != f ? f : c.props.required,
          x = { disabled: _, required: y };
        ["checked", "name", "onChange", "value", "inputRef"].forEach((e) => {
          void 0 === c.props[e] && void 0 !== i[e] && (x[e] = i[e]);
        });
        const C = Kc({ props: i, muiFormControl: b, states: ["error"] }),
          S = (0, d.Z)({}, i, {
            disabled: _,
            labelPlacement: h,
            required: y,
            error: C.error,
          }),
          k = ((e) => {
            const {
                classes: t,
                disabled: n,
                labelPlacement: r,
                error: o,
                required: a,
              } = e,
              i = {
                root: [
                  "root",
                  n && "disabled",
                  `labelPlacement${(0, Fn.Z)(r)}`,
                  o && "error",
                  a && "required",
                ],
                label: ["label", n && "disabled"],
                asterisk: ["asterisk", o && "error"],
              };
            return (0, Nt.Z)(i, Gp, t);
          })(S),
          w = null != (a = g.typography) ? a : l.typography;
        let P = m;
        return (
          null == P ||
            P.type === Wa ||
            p ||
            (P = (0, e.jsx)(
              Wa,
              (0, d.Z)({ component: "span" }, w, {
                className: (0, Rt.Z)(k.label, null == w ? void 0 : w.className),
                children: P,
              })
            )),
          (0, e.jsxs)(
            Jp,
            (0, d.Z)(
              { className: (0, Rt.Z)(k.root, s), ownerState: S, ref: r },
              v,
              {
                children: [
                  t.cloneElement(c, x),
                  y
                    ? (0, e.jsxs)(Kp, {
                        display: "block",
                        children: [
                          P,
                          (0, e.jsxs)(Qp, {
                            ownerState: S,
                            "aria-hidden": !0,
                            className: k.asterisk,
                            children: [" ", "*"],
                          }),
                        ],
                      })
                    : P,
                ],
              }
            )
          )
        );
      });
      function em(e) {
        return (0, Zt.ZP)("PrivateSwitchBase", e);
      }
      (0, Bt.Z)("PrivateSwitchBase", [
        "root",
        "checked",
        "disabled",
        "input",
        "edgeStart",
        "edgeEnd",
      ]);
      const tm = [
          "autoFocus",
          "checked",
          "checkedIcon",
          "className",
          "defaultChecked",
          "disabled",
          "disableFocusRipple",
          "edge",
          "icon",
          "id",
          "inputProps",
          "inputRef",
          "name",
          "onBlur",
          "onChange",
          "onFocus",
          "readOnly",
          "required",
          "tabIndex",
          "type",
          "value",
        ],
        nm = (0, Lt.ZP)(Zn)(({ ownerState: e }) =>
          (0, d.Z)(
            { padding: 9, borderRadius: "50%" },
            "start" === e.edge && { marginLeft: "small" === e.size ? -3 : -12 },
            "end" === e.edge && { marginRight: "small" === e.size ? -3 : -12 }
          )
        ),
        rm = (0, Lt.ZP)("input", { shouldForwardProp: so.Z })({
          cursor: "inherit",
          position: "absolute",
          opacity: 0,
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          margin: 0,
          padding: 0,
          zIndex: 1,
        }),
        om = t.forwardRef(function (t, n) {
          const {
              autoFocus: r,
              checked: o,
              checkedIcon: a,
              className: i,
              defaultChecked: s,
              disabled: l,
              disableFocusRipple: c = !1,
              edge: u = !1,
              icon: p,
              id: m,
              inputProps: h,
              inputRef: f,
              name: g,
              onBlur: v,
              onChange: b,
              onFocus: _,
              readOnly: y,
              required: x = !1,
              tabIndex: C,
              type: S,
              value: k,
            } = t,
            w = (0, jt.Z)(t, tm),
            [P, O] = (0, ll.Z)({
              controlled: o,
              default: Boolean(s),
              name: "SwitchBase",
              state: "checked",
            }),
            I = qc();
          let T = l;
          I && void 0 === T && (T = I.disabled);
          const M = "checkbox" === S || "radio" === S,
            E = (0, d.Z)({}, t, {
              checked: P,
              disabled: T,
              disableFocusRipple: c,
              edge: u,
            }),
            D = ((e) => {
              const { classes: t, checked: n, disabled: r, edge: o } = e,
                a = {
                  root: [
                    "root",
                    n && "checked",
                    r && "disabled",
                    o && `edge${(0, Fn.Z)(o)}`,
                  ],
                  input: ["input"],
                };
              return (0, Nt.Z)(a, em, t);
            })(E);
          return (0, e.jsxs)(
            nm,
            (0, d.Z)(
              {
                component: "span",
                className: (0, Rt.Z)(D.root, i),
                centerRipple: !0,
                focusRipple: !c,
                disabled: T,
                tabIndex: null,
                role: void 0,
                onFocus: (e) => {
                  _ && _(e), I && I.onFocus && I.onFocus(e);
                },
                onBlur: (e) => {
                  v && v(e), I && I.onBlur && I.onBlur(e);
                },
                ownerState: E,
                ref: n,
              },
              w,
              {
                children: [
                  (0, e.jsx)(
                    rm,
                    (0, d.Z)(
                      {
                        autoFocus: r,
                        checked: o,
                        defaultChecked: s,
                        className: D.input,
                        disabled: T,
                        id: M ? m : void 0,
                        name: g,
                        onChange: (e) => {
                          if (e.nativeEvent.defaultPrevented) return;
                          const t = e.target.checked;
                          O(t), b && b(e, t);
                        },
                        readOnly: y,
                        ref: f,
                        required: x,
                        ownerState: E,
                        tabIndex: C,
                        type: S,
                      },
                      "checkbox" === S && void 0 === k ? {} : { value: k },
                      h
                    )
                  ),
                  P ? a : p,
                ],
              }
            )
          );
        });
      var am = om,
        im = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
          }),
          "CheckBoxOutlineBlank"
        ),
        sm = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
          }),
          "CheckBox"
        ),
        lm = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z",
          }),
          "IndeterminateCheckBox"
        );
      function cm(e) {
        return (0, Zt.ZP)("MuiCheckbox", e);
      }
      var um = (0, Bt.Z)("MuiCheckbox", [
        "root",
        "checked",
        "disabled",
        "indeterminate",
        "colorPrimary",
        "colorSecondary",
        "sizeSmall",
        "sizeMedium",
      ]);
      const dm = [
          "checkedIcon",
          "color",
          "icon",
          "indeterminate",
          "indeterminateIcon",
          "inputProps",
          "size",
          "className",
        ],
        pm = (0, Lt.ZP)(am, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiCheckbox",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.indeterminate && t.indeterminate,
              t[`size${(0, Fn.Z)(n.size)}`],
              "default" !== n.color && t[`color${(0, Fn.Z)(n.color)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { color: (e.vars || e).palette.text.secondary },
            !t.disableRipple && {
              "&:hover": {
                backgroundColor: e.vars
                  ? `rgba(${
                      "default" === t.color
                        ? e.vars.palette.action.activeChannel
                        : e.vars.palette[t.color].mainChannel
                    } / ${e.vars.palette.action.hoverOpacity})`
                  : (0, At.Fq)(
                      "default" === t.color
                        ? e.palette.action.active
                        : e.palette[t.color].main,
                      e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
            },
            "default" !== t.color && {
              [`&.${um.checked}, &.${um.indeterminate}`]: {
                color: (e.vars || e).palette[t.color].main,
              },
              [`&.${um.disabled}`]: {
                color: (e.vars || e).palette.action.disabled,
              },
            }
          )
        ),
        mm = (0, e.jsx)(sm, {}),
        hm = (0, e.jsx)(im, {}),
        fm = (0, e.jsx)(lm, {}),
        gm = t.forwardRef(function (n, r) {
          var o, a;
          const i = (0, zt.Z)({ props: n, name: "MuiCheckbox" }),
            {
              checkedIcon: s = mm,
              color: l = "primary",
              icon: c = hm,
              indeterminate: u = !1,
              indeterminateIcon: p = fm,
              inputProps: m,
              size: h = "medium",
              className: f,
            } = i,
            g = (0, jt.Z)(i, dm),
            v = u ? p : c,
            b = u ? p : s,
            _ = (0, d.Z)({}, i, { color: l, indeterminate: u, size: h }),
            y = ((e) => {
              const { classes: t, indeterminate: n, color: r, size: o } = e,
                a = {
                  root: [
                    "root",
                    n && "indeterminate",
                    `color${(0, Fn.Z)(r)}`,
                    `size${(0, Fn.Z)(o)}`,
                  ],
                },
                i = (0, Nt.Z)(a, cm, t);
              return (0, d.Z)({}, t, i);
            })(_);
          return (0,
          e.jsx)(pm, (0, d.Z)({ type: "checkbox", inputProps: (0, d.Z)({ "data-indeterminate": u }, m), icon: t.cloneElement(v, { fontSize: null != (o = v.props.fontSize) ? o : h }), checkedIcon: t.cloneElement(b, { fontSize: null != (a = b.props.fontSize) ? a : h }), ownerState: _, ref: r, className: (0, Rt.Z)(y.root, f) }, g, { classes: y }));
        });
      var vm = gm,
        bm = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
          }),
          "Person"
        );
      function _m(e) {
        return (0, Zt.ZP)("MuiAvatar", e);
      }
      (0, Bt.Z)("MuiAvatar", [
        "root",
        "colorDefault",
        "circular",
        "rounded",
        "square",
        "img",
        "fallback",
      ]);
      const ym = [
          "className",
          "elementType",
          "ownerState",
          "externalForwardedProps",
          "getSlotOwnerState",
          "internalForwardedProps",
        ],
        xm = ["component", "slots", "slotProps"],
        Cm = ["component"];
      function Sm(e, t) {
        const {
            className: n,
            elementType: r,
            ownerState: o,
            externalForwardedProps: a,
            getSlotOwnerState: i,
            internalForwardedProps: s,
          } = t,
          l = (0, jt.Z)(t, ym),
          {
            component: c,
            slots: u = { [e]: void 0 },
            slotProps: p = { [e]: void 0 },
          } = a,
          m = (0, jt.Z)(a, xm),
          h = u[e] || r,
          f = or(p[e], o),
          g = rr(
            (0, d.Z)({ className: n }, l, {
              externalForwardedProps: "root" === e ? m : void 0,
              externalSlotProps: f,
            })
          ),
          {
            props: { component: v },
            internalRef: b,
          } = g,
          _ = (0, jt.Z)(g.props, Cm),
          y = (0, Qn.Z)(b, null == f ? void 0 : f.ref, t.ref),
          x = i ? i(_) : {},
          C = (0, d.Z)({}, o, x),
          S = "root" === e ? v || c : v,
          k = er(
            h,
            (0, d.Z)(
              {},
              "root" === e && !c && !u[e] && s,
              "root" !== e && !u[e] && s,
              _,
              S && { as: S },
              { ref: y }
            ),
            C
          );
        return (
          Object.keys(x).forEach((e) => {
            delete k[e];
          }),
          [h, k]
        );
      }
      const km = [
          "alt",
          "children",
          "className",
          "component",
          "slots",
          "slotProps",
          "imgProps",
          "sizes",
          "src",
          "srcSet",
          "variant",
        ],
        wm = _c(),
        Pm = (0, Lt.ZP)("div", {
          name: "MuiAvatar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
          },
        })(({ theme: e }) => ({
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          width: 40,
          height: 40,
          fontFamily: e.typography.fontFamily,
          fontSize: e.typography.pxToRem(20),
          lineHeight: 1,
          borderRadius: "50%",
          overflow: "hidden",
          userSelect: "none",
          variants: [
            {
              props: { variant: "rounded" },
              style: { borderRadius: (e.vars || e).shape.borderRadius },
            },
            { props: { variant: "square" }, style: { borderRadius: 0 } },
            {
              props: { colorDefault: !0 },
              style: (0, d.Z)(
                { color: (e.vars || e).palette.background.default },
                e.vars
                  ? { backgroundColor: e.vars.palette.Avatar.defaultBg }
                  : (0, d.Z)(
                      { backgroundColor: e.palette.grey[400] },
                      e.applyStyles("dark", {
                        backgroundColor: e.palette.grey[600],
                      })
                    )
              ),
            },
          ],
        })),
        Om = (0, Lt.ZP)("img", {
          name: "MuiAvatar",
          slot: "Img",
          overridesResolver: (e, t) => t.img,
        })({
          width: "100%",
          height: "100%",
          textAlign: "center",
          objectFit: "cover",
          color: "transparent",
          textIndent: 1e4,
        }),
        Im = (0, Lt.ZP)(bm, {
          name: "MuiAvatar",
          slot: "Fallback",
          overridesResolver: (e, t) => t.fallback,
        })({ width: "75%", height: "75%" });
      var Tm = t.forwardRef(function (n, r) {
        const o = wm({ props: n, name: "MuiAvatar" }),
          {
            alt: a,
            children: i,
            className: s,
            component: l = "div",
            slots: c = {},
            slotProps: u = {},
            imgProps: p,
            sizes: m,
            src: h,
            srcSet: f,
            variant: g = "circular",
          } = o,
          v = (0, jt.Z)(o, km);
        let b = null;
        const _ = (function ({
            crossOrigin: e,
            referrerPolicy: n,
            src: r,
            srcSet: o,
          }) {
            const [a, i] = t.useState(!1);
            return (
              t.useEffect(() => {
                if (!r && !o) return;
                i(!1);
                let t = !0;
                const a = new Image();
                return (
                  (a.onload = () => {
                    t && i("loaded");
                  }),
                  (a.onerror = () => {
                    t && i("error");
                  }),
                  (a.crossOrigin = e),
                  (a.referrerPolicy = n),
                  (a.src = r),
                  o && (a.srcset = o),
                  () => {
                    t = !1;
                  }
                );
              }, [e, n, r, o]),
              a
            );
          })((0, d.Z)({}, p, { src: h, srcSet: f })),
          y = h || f,
          x = y && "error" !== _,
          C = (0, d.Z)({}, o, { colorDefault: !x, component: l, variant: g }),
          S = ((e) => {
            const { classes: t, variant: n, colorDefault: r } = e,
              o = {
                root: ["root", n, r && "colorDefault"],
                img: ["img"],
                fallback: ["fallback"],
              };
            return (0, Nt.Z)(o, _m, t);
          })(C),
          [k, w] = Sm("img", {
            className: S.img,
            elementType: Om,
            externalForwardedProps: {
              slots: c,
              slotProps: { img: (0, d.Z)({}, p, u.img) },
            },
            additionalProps: { alt: a, src: h, srcSet: f, sizes: m },
            ownerState: C,
          });
        return (
          (b = x
            ? (0, e.jsx)(k, (0, d.Z)({}, w))
            : i || 0 === i
            ? i
            : y && a
            ? a[0]
            : (0, e.jsx)(Im, { ownerState: C, className: S.fallback })),
          (0, e.jsx)(
            Pm,
            (0, d.Z)(
              { as: l, ownerState: C, className: (0, Rt.Z)(S.root, s), ref: r },
              v,
              { children: b }
            )
          )
        );
      });
      function Mm(e) {
        return (0, Zt.ZP)("MuiButtonGroup", e);
      }
      var Em = (0, Bt.Z)("MuiButtonGroup", [
        "root",
        "contained",
        "outlined",
        "text",
        "disableElevation",
        "disabled",
        "firstButton",
        "fullWidth",
        "vertical",
        "grouped",
        "groupedHorizontal",
        "groupedVertical",
        "groupedText",
        "groupedTextHorizontal",
        "groupedTextVertical",
        "groupedTextPrimary",
        "groupedTextSecondary",
        "groupedOutlined",
        "groupedOutlinedHorizontal",
        "groupedOutlinedVertical",
        "groupedOutlinedPrimary",
        "groupedOutlinedSecondary",
        "groupedContained",
        "groupedContainedHorizontal",
        "groupedContainedVertical",
        "groupedContainedPrimary",
        "groupedContainedSecondary",
        "lastButton",
        "middleButton",
      ]);
      const Dm = [
          "children",
          "className",
          "color",
          "component",
          "disabled",
          "disableElevation",
          "disableFocusRipple",
          "disableRipple",
          "fullWidth",
          "orientation",
          "size",
          "variant",
        ],
        jm = (0, Lt.ZP)("div", {
          name: "MuiButtonGroup",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${Em.grouped}`]: t.grouped },
              { [`& .${Em.grouped}`]: t[`grouped${(0, Fn.Z)(n.orientation)}`] },
              { [`& .${Em.grouped}`]: t[`grouped${(0, Fn.Z)(n.variant)}`] },
              {
                [`& .${Em.grouped}`]:
                  t[
                    `grouped${(0, Fn.Z)(n.variant)}${(0, Fn.Z)(n.orientation)}`
                  ],
              },
              {
                [`& .${Em.grouped}`]:
                  t[`grouped${(0, Fn.Z)(n.variant)}${(0, Fn.Z)(n.color)}`],
              },
              { [`& .${Em.firstButton}`]: t.firstButton },
              { [`& .${Em.lastButton}`]: t.lastButton },
              { [`& .${Em.middleButton}`]: t.middleButton },
              t.root,
              t[n.variant],
              !0 === n.disableElevation && t.disableElevation,
              n.fullWidth && t.fullWidth,
              "vertical" === n.orientation && t.vertical,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              display: "inline-flex",
              borderRadius: (e.vars || e).shape.borderRadius,
            },
            "contained" === t.variant && {
              boxShadow: (e.vars || e).shadows[2],
            },
            t.disableElevation && { boxShadow: "none" },
            t.fullWidth && { width: "100%" },
            "vertical" === t.orientation && { flexDirection: "column" },
            {
              [`& .${Em.grouped}`]: (0, d.Z)(
                {
                  minWidth: 40,
                  "&:hover": (0, d.Z)(
                    {},
                    "contained" === t.variant && { boxShadow: "none" }
                  ),
                },
                "contained" === t.variant && { boxShadow: "none" }
              ),
              [`& .${Em.firstButton},& .${Em.middleButton}`]: (0, d.Z)(
                {},
                "horizontal" === t.orientation && {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                },
                "vertical" === t.orientation && {
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: 0,
                },
                "text" === t.variant &&
                  "horizontal" === t.orientation && {
                    borderRight: e.vars
                      ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)`
                      : "1px solid " +
                        ("light" === e.palette.mode
                          ? "rgba(0, 0, 0, 0.23)"
                          : "rgba(255, 255, 255, 0.23)"),
                    [`&.${Em.disabled}`]: {
                      borderRight: `1px solid ${
                        (e.vars || e).palette.action.disabled
                      }`,
                    },
                  },
                "text" === t.variant &&
                  "vertical" === t.orientation && {
                    borderBottom: e.vars
                      ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)`
                      : "1px solid " +
                        ("light" === e.palette.mode
                          ? "rgba(0, 0, 0, 0.23)"
                          : "rgba(255, 255, 255, 0.23)"),
                    [`&.${Em.disabled}`]: {
                      borderBottom: `1px solid ${
                        (e.vars || e).palette.action.disabled
                      }`,
                    },
                  },
                "text" === t.variant &&
                  "inherit" !== t.color && {
                    borderColor: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)`
                      : (0, At.Fq)(e.palette[t.color].main, 0.5),
                  },
                "outlined" === t.variant &&
                  "horizontal" === t.orientation && {
                    borderRightColor: "transparent",
                  },
                "outlined" === t.variant &&
                  "vertical" === t.orientation && {
                    borderBottomColor: "transparent",
                  },
                "contained" === t.variant &&
                  "horizontal" === t.orientation && {
                    borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
                    [`&.${Em.disabled}`]: {
                      borderRight: `1px solid ${
                        (e.vars || e).palette.action.disabled
                      }`,
                    },
                  },
                "contained" === t.variant &&
                  "vertical" === t.orientation && {
                    borderBottom: `1px solid ${
                      (e.vars || e).palette.grey[400]
                    }`,
                    [`&.${Em.disabled}`]: {
                      borderBottom: `1px solid ${
                        (e.vars || e).palette.action.disabled
                      }`,
                    },
                  },
                "contained" === t.variant &&
                  "inherit" !== t.color && {
                    borderColor: (e.vars || e).palette[t.color].dark,
                  },
                {
                  "&:hover": (0, d.Z)(
                    {},
                    "outlined" === t.variant &&
                      "horizontal" === t.orientation && {
                        borderRightColor: "currentColor",
                      },
                    "outlined" === t.variant &&
                      "vertical" === t.orientation && {
                        borderBottomColor: "currentColor",
                      }
                  ),
                }
              ),
              [`& .${Em.lastButton},& .${Em.middleButton}`]: (0, d.Z)(
                {},
                "horizontal" === t.orientation && {
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                },
                "vertical" === t.orientation && {
                  borderTopRightRadius: 0,
                  borderTopLeftRadius: 0,
                },
                "outlined" === t.variant &&
                  "horizontal" === t.orientation && { marginLeft: -1 },
                "outlined" === t.variant &&
                  "vertical" === t.orientation && { marginTop: -1 }
              ),
            }
          )
        ),
        Rm = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiButtonGroup" }),
            {
              children: a,
              className: i,
              color: s = "primary",
              component: l = "div",
              disabled: c = !1,
              disableElevation: u = !1,
              disableFocusRipple: p = !1,
              disableRipple: m = !1,
              fullWidth: h = !1,
              orientation: f = "horizontal",
              size: g = "medium",
              variant: v = "outlined",
            } = o,
            b = (0, jt.Z)(o, Dm),
            _ = (0, d.Z)({}, o, {
              color: s,
              component: l,
              disabled: c,
              disableElevation: u,
              disableFocusRipple: p,
              disableRipple: m,
              fullWidth: h,
              orientation: f,
              size: g,
              variant: v,
            }),
            y = ((e) => {
              const {
                  classes: t,
                  color: n,
                  disabled: r,
                  disableElevation: o,
                  fullWidth: a,
                  orientation: i,
                  variant: s,
                } = e,
                l = {
                  root: [
                    "root",
                    s,
                    "vertical" === i && "vertical",
                    a && "fullWidth",
                    o && "disableElevation",
                  ],
                  grouped: [
                    "grouped",
                    `grouped${(0, Fn.Z)(i)}`,
                    `grouped${(0, Fn.Z)(s)}`,
                    `grouped${(0, Fn.Z)(s)}${(0, Fn.Z)(i)}`,
                    `grouped${(0, Fn.Z)(s)}${(0, Fn.Z)(n)}`,
                    r && "disabled",
                  ],
                  firstButton: ["firstButton"],
                  lastButton: ["lastButton"],
                  middleButton: ["middleButton"],
                };
              return (0, Nt.Z)(l, Mm, t);
            })(_),
            x = t.useMemo(
              () => ({
                className: y.grouped,
                color: s,
                disabled: c,
                disableElevation: u,
                disableFocusRipple: p,
                disableRipple: m,
                fullWidth: h,
                size: g,
                variant: v,
              }),
              [s, c, u, p, m, h, g, v, y.grouped]
            ),
            C = (function (e) {
              return t.Children.toArray(e).filter((e) => t.isValidElement(e));
            })(a),
            S = C.length,
            k = (e) => {
              const t = 0 === e,
                n = e === S - 1;
              return t && n
                ? ""
                : t
                ? y.firstButton
                : n
                ? y.lastButton
                : y.middleButton;
            };
          return (0,
          e.jsx)(jm, (0, d.Z)({ as: l, role: "group", className: (0, Rt.Z)(y.root, i), ref: r, ownerState: _ }, b, { children: (0, e.jsx)(cp.Provider, { value: x, children: C.map((t, n) => (0, e.jsx)(up.Provider, { value: k(n), children: t }, n)) }) }));
        });
      var Nm = Rm;
      function Am(e) {
        return e.substring(2).toLowerCase();
      }
      function Lm(n) {
        const {
            children: r,
            disableReactTree: o = !1,
            mouseEvent: a = "onClick",
            onClickAway: i,
            touchEvent: s = "onTouchEnd",
          } = n,
          l = t.useRef(!1),
          c = t.useRef(null),
          u = t.useRef(!1),
          d = t.useRef(!1);
        t.useEffect(
          () => (
            setTimeout(() => {
              u.current = !0;
            }, 0),
            () => {
              u.current = !1;
            }
          ),
          []
        );
        const p = (0, Qn.Z)(r.ref, c),
          m = (0, lr.Z)((e) => {
            const t = d.current;
            d.current = !1;
            const n = (0, sr.Z)(c.current);
            if (
              !u.current ||
              !c.current ||
              ("clientX" in e &&
                (function (e, t) {
                  return (
                    t.documentElement.clientWidth < e.clientX ||
                    t.documentElement.clientHeight < e.clientY
                  );
                })(e, n))
            )
              return;
            if (l.current) return void (l.current = !1);
            let r;
            (r = e.composedPath
              ? e.composedPath().indexOf(c.current) > -1
              : !n.documentElement.contains(e.target) ||
                c.current.contains(e.target)),
              r || (!o && t) || i(e);
          }),
          h = (e) => (t) => {
            d.current = !0;
            const n = r.props[e];
            n && n(t);
          },
          f = { ref: p };
        return (
          !1 !== s && (f[s] = h(s)),
          t.useEffect(() => {
            if (!1 !== s) {
              const e = Am(s),
                t = (0, sr.Z)(c.current),
                n = () => {
                  l.current = !0;
                };
              return (
                t.addEventListener(e, m),
                t.addEventListener("touchmove", n),
                () => {
                  t.removeEventListener(e, m),
                    t.removeEventListener("touchmove", n);
                }
              );
            }
          }, [m, s]),
          !1 !== a && (f[a] = h(a)),
          t.useEffect(() => {
            if (!1 !== a) {
              const e = Am(a),
                t = (0, sr.Z)(c.current);
              return (
                t.addEventListener(e, m),
                () => {
                  t.removeEventListener(e, m);
                }
              );
            }
          }, [m, a]),
          (0, e.jsx)(t.Fragment, { children: t.cloneElement(r, f) })
        );
      }
      function zm(e) {
        return (0, Zt.ZP)("MuiSnackbarContent", e);
      }
      (0, Bt.Z)("MuiSnackbarContent", ["root", "message", "action"]);
      const Bm = ["action", "className", "message", "role"],
        Zm = (0, Lt.ZP)(io, {
          name: "MuiSnackbarContent",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(({ theme: e }) => {
          const t = "light" === e.palette.mode ? 0.8 : 0.98,
            n = (0, At._4)(e.palette.background.default, t);
          return (0, d.Z)({}, e.typography.body2, {
            color: e.vars
              ? e.vars.palette.SnackbarContent.color
              : e.palette.getContrastText(n),
            backgroundColor: e.vars ? e.vars.palette.SnackbarContent.bg : n,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "6px 16px",
            borderRadius: (e.vars || e).shape.borderRadius,
            flexGrow: 1,
            [e.breakpoints.up("sm")]: { flexGrow: "initial", minWidth: 288 },
          });
        }),
        Fm = (0, Lt.ZP)("div", {
          name: "MuiSnackbarContent",
          slot: "Message",
          overridesResolver: (e, t) => t.message,
        })({ padding: "8px 0" }),
        Hm = (0, Lt.ZP)("div", {
          name: "MuiSnackbarContent",
          slot: "Action",
          overridesResolver: (e, t) => t.action,
        })({
          display: "flex",
          alignItems: "center",
          marginLeft: "auto",
          paddingLeft: 16,
          marginRight: -8,
        });
      var Vm = t.forwardRef(function (t, n) {
        const r = (0, zt.Z)({ props: t, name: "MuiSnackbarContent" }),
          { action: o, className: a, message: i, role: s = "alert" } = r,
          l = (0, jt.Z)(r, Bm),
          c = r,
          u = ((e) => {
            const { classes: t } = e;
            return (0, Nt.Z)(
              { root: ["root"], action: ["action"], message: ["message"] },
              zm,
              t
            );
          })(c);
        return (0,
        e.jsxs)(Zm, (0, d.Z)({ role: s, square: !0, elevation: 6, className: (0, Rt.Z)(u.root, a), ownerState: c, ref: n }, l, { children: [(0, e.jsx)(Fm, { className: u.message, ownerState: c, children: i }), o ? (0, e.jsx)(Hm, { className: u.action, ownerState: c, children: o }) : null] }));
      });
      function Wm(e) {
        return (0, Zt.ZP)("MuiSnackbar", e);
      }
      (0, Bt.Z)("MuiSnackbar", [
        "root",
        "anchorOriginTopCenter",
        "anchorOriginBottomCenter",
        "anchorOriginTopRight",
        "anchorOriginBottomRight",
        "anchorOriginTopLeft",
        "anchorOriginBottomLeft",
      ]);
      const $m = ["onEnter", "onExited"],
        Um = [
          "action",
          "anchorOrigin",
          "autoHideDuration",
          "children",
          "className",
          "ClickAwayListenerProps",
          "ContentProps",
          "disableWindowBlurListener",
          "message",
          "onBlur",
          "onClose",
          "onFocus",
          "onMouseEnter",
          "onMouseLeave",
          "open",
          "resumeHideDuration",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ],
        Km = (0, Lt.ZP)("div", {
          name: "MuiSnackbar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[
                `anchorOrigin${(0, Fn.Z)(n.anchorOrigin.vertical)}${(0, Fn.Z)(
                  n.anchorOrigin.horizontal
                )}`
              ],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              zIndex: (e.vars || e).zIndex.snackbar,
              position: "fixed",
              display: "flex",
              left: 8,
              right: 8,
              justifyContent: "center",
              alignItems: "center",
            },
            "top" === t.anchorOrigin.vertical ? { top: 8 } : { bottom: 8 },
            "left" === t.anchorOrigin.horizontal && {
              justifyContent: "flex-start",
            },
            "right" === t.anchorOrigin.horizontal && {
              justifyContent: "flex-end",
            },
            {
              [e.breakpoints.up("sm")]: (0, d.Z)(
                {},
                "top" === t.anchorOrigin.vertical
                  ? { top: 24 }
                  : { bottom: 24 },
                "center" === t.anchorOrigin.horizontal && {
                  left: "50%",
                  right: "auto",
                  transform: "translateX(-50%)",
                },
                "left" === t.anchorOrigin.horizontal && {
                  left: 24,
                  right: "auto",
                },
                "right" === t.anchorOrigin.horizontal && {
                  right: 24,
                  left: "auto",
                }
              ),
            }
          )
        );
      var Gm = t.forwardRef(function (n, r) {
        const o = (0, zt.Z)({ props: n, name: "MuiSnackbar" }),
          a = jr(),
          i = {
            enter: a.transitions.duration.enteringScreen,
            exit: a.transitions.duration.leavingScreen,
          },
          {
            action: s,
            anchorOrigin: { vertical: l, horizontal: c } = {
              vertical: "bottom",
              horizontal: "left",
            },
            autoHideDuration: u = null,
            children: p,
            className: m,
            ClickAwayListenerProps: h,
            ContentProps: f,
            disableWindowBlurListener: g = !1,
            message: v,
            open: b,
            TransitionComponent: _ = Di,
            transitionDuration: y = i,
            TransitionProps: { onEnter: x, onExited: C } = {},
          } = o,
          S = (0, jt.Z)(o.TransitionProps, $m),
          k = (0, jt.Z)(o, Um),
          w = (0, d.Z)({}, o, {
            anchorOrigin: { vertical: l, horizontal: c },
            autoHideDuration: u,
            disableWindowBlurListener: g,
            TransitionComponent: _,
            transitionDuration: y,
          }),
          P = ((e) => {
            const { classes: t, anchorOrigin: n } = e,
              r = {
                root: [
                  "root",
                  `anchorOrigin${(0, Fn.Z)(n.vertical)}${(0, Fn.Z)(
                    n.horizontal
                  )}`,
                ],
              };
            return (0, Nt.Z)(r, Wm, t);
          })(w),
          { getRootProps: O, onClickAway: I } = (function (e = {}) {
            const {
                autoHideDuration: n = null,
                disableWindowBlurListener: r = !1,
                onClose: o,
                open: a,
                resumeHideDuration: i,
              } = e,
              s = (0, xn.Z)();
            t.useEffect(() => {
              if (a)
                return (
                  document.addEventListener("keydown", e),
                  () => {
                    document.removeEventListener("keydown", e);
                  }
                );
              function e(e) {
                e.defaultPrevented ||
                  ("Escape" !== e.key && "Esc" !== e.key) ||
                  null == o ||
                  o(e, "escapeKeyDown");
              }
            }, [a, o]);
            const l = (0, lr.Z)((e, t) => {
                null == o || o(e, t);
              }),
              c = (0, lr.Z)((e) => {
                o &&
                  null != e &&
                  s.start(e, () => {
                    l(null, "timeout");
                  });
              });
            t.useEffect(() => (a && c(n), s.clear), [a, n, c, s]);
            const u = s.clear,
              p = t.useCallback(() => {
                null != n && c(null != i ? i : 0.5 * n);
              }, [n, i, c]),
              m = (e) => (t) => {
                const n = e.onFocus;
                null == n || n(t), u();
              },
              h = (e) => (t) => {
                const n = e.onMouseEnter;
                null == n || n(t), u();
              },
              f = (e) => (t) => {
                const n = e.onMouseLeave;
                null == n || n(t), p();
              };
            return (
              t.useEffect(() => {
                if (!r && a)
                  return (
                    window.addEventListener("focus", p),
                    window.addEventListener("blur", u),
                    () => {
                      window.removeEventListener("focus", p),
                        window.removeEventListener("blur", u);
                    }
                  );
              }, [r, a, p, u]),
              {
                getRootProps: (t = {}) => {
                  const n = (0, d.Z)({}, tr(e), tr(t));
                  return (0, d.Z)({ role: "presentation" }, t, n, {
                    onBlur:
                      ((r = n),
                      (e) => {
                        const t = r.onBlur;
                        null == t || t(e), p();
                      }),
                    onFocus: m(n),
                    onMouseEnter: h(n),
                    onMouseLeave: f(n),
                  });
                  var r;
                },
                onClickAway: (e) => {
                  null == o || o(e, "clickaway");
                },
              }
            );
          })((0, d.Z)({}, w)),
          [T, M] = t.useState(!0),
          E = ir({
            elementType: Km,
            getSlotProps: O,
            externalForwardedProps: k,
            ownerState: w,
            additionalProps: { ref: r },
            className: [P.root, m],
          });
        return !b && T
          ? null
          : (0, e.jsx)(
              Lm,
              (0, d.Z)({ onClickAway: I }, h, {
                children: (0, e.jsx)(
                  Km,
                  (0, d.Z)({}, E, {
                    children: (0, e.jsx)(
                      _,
                      (0, d.Z)(
                        {
                          appear: !0,
                          in: b,
                          timeout: y,
                          direction: "top" === l ? "down" : "up",
                          onEnter: (e, t) => {
                            M(!1), x && x(e, t);
                          },
                          onExited: (e) => {
                            M(!0), C && C(e);
                          },
                        },
                        S,
                        {
                          children:
                            p ||
                            (0, e.jsx)(
                              Vm,
                              (0, d.Z)({ message: v, action: s }, f)
                            ),
                        }
                      )
                    ),
                  })
                ),
              })
            );
      });
      function qm(e) {
        return (0, Zt.ZP)("MuiAlert", e);
      }
      var Ym = (0, Bt.Z)("MuiAlert", [
          "root",
          "action",
          "icon",
          "message",
          "filled",
          "colorSuccess",
          "colorInfo",
          "colorWarning",
          "colorError",
          "filledSuccess",
          "filledInfo",
          "filledWarning",
          "filledError",
          "outlined",
          "outlinedSuccess",
          "outlinedInfo",
          "outlinedWarning",
          "outlinedError",
          "standard",
          "standardSuccess",
          "standardInfo",
          "standardWarning",
          "standardError",
        ]),
        Jm = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z",
          }),
          "SuccessOutlined"
        ),
        Qm = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z",
          }),
          "ReportProblemOutlined"
        ),
        Xm = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
          }),
          "ErrorOutline"
        ),
        eh = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z",
          }),
          "InfoOutlined"
        );
      const th = [
          "action",
          "children",
          "className",
          "closeText",
          "color",
          "components",
          "componentsProps",
          "icon",
          "iconMapping",
          "onClose",
          "role",
          "severity",
          "slotProps",
          "slots",
          "variant",
        ],
        nh = _c(),
        rh = (0, Lt.ZP)(io, {
          name: "MuiAlert",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              t[`${n.variant}${(0, Fn.Z)(n.color || n.severity)}`],
            ];
          },
        })(({ theme: e }) => {
          const t = "light" === e.palette.mode ? At._j : At.$n,
            n = "light" === e.palette.mode ? At.$n : At._j;
          return (0, d.Z)({}, e.typography.body2, {
            backgroundColor: "transparent",
            display: "flex",
            padding: "6px 16px",
            variants: [
              ...Object.entries(e.palette)
                .filter(([, e]) => e.main && e.light)
                .map(([r]) => ({
                  props: { colorSeverity: r, variant: "standard" },
                  style: {
                    color: e.vars
                      ? e.vars.palette.Alert[`${r}Color`]
                      : t(e.palette[r].light, 0.6),
                    backgroundColor: e.vars
                      ? e.vars.palette.Alert[`${r}StandardBg`]
                      : n(e.palette[r].light, 0.9),
                    [`& .${Ym.icon}`]: e.vars
                      ? { color: e.vars.palette.Alert[`${r}IconColor`] }
                      : { color: e.palette[r].main },
                  },
                })),
              ...Object.entries(e.palette)
                .filter(([, e]) => e.main && e.light)
                .map(([n]) => ({
                  props: { colorSeverity: n, variant: "outlined" },
                  style: {
                    color: e.vars
                      ? e.vars.palette.Alert[`${n}Color`]
                      : t(e.palette[n].light, 0.6),
                    border: `1px solid ${(e.vars || e).palette[n].light}`,
                    [`& .${Ym.icon}`]: e.vars
                      ? { color: e.vars.palette.Alert[`${n}IconColor`] }
                      : { color: e.palette[n].main },
                  },
                })),
              ...Object.entries(e.palette)
                .filter(([, e]) => e.main && e.dark)
                .map(([t]) => ({
                  props: { colorSeverity: t, variant: "filled" },
                  style: (0, d.Z)(
                    { fontWeight: e.typography.fontWeightMedium },
                    e.vars
                      ? {
                          color: e.vars.palette.Alert[`${t}FilledColor`],
                          backgroundColor: e.vars.palette.Alert[`${t}FilledBg`],
                        }
                      : {
                          backgroundColor:
                            "dark" === e.palette.mode
                              ? e.palette[t].dark
                              : e.palette[t].main,
                          color: e.palette.getContrastText(e.palette[t].main),
                        }
                  ),
                })),
            ],
          });
        }),
        oh = (0, Lt.ZP)("div", {
          name: "MuiAlert",
          slot: "Icon",
          overridesResolver: (e, t) => t.icon,
        })({
          marginRight: 12,
          padding: "7px 0",
          display: "flex",
          fontSize: 22,
          opacity: 0.9,
        }),
        ah = (0, Lt.ZP)("div", {
          name: "MuiAlert",
          slot: "Message",
          overridesResolver: (e, t) => t.message,
        })({ padding: "8px 0", minWidth: 0, overflow: "auto" }),
        ih = (0, Lt.ZP)("div", {
          name: "MuiAlert",
          slot: "Action",
          overridesResolver: (e, t) => t.action,
        })({
          display: "flex",
          alignItems: "flex-start",
          padding: "4px 0 0 16px",
          marginLeft: "auto",
          marginRight: -8,
        }),
        sh = {
          success: (0, e.jsx)(Jm, { fontSize: "inherit" }),
          warning: (0, e.jsx)(Qm, { fontSize: "inherit" }),
          error: (0, e.jsx)(Xm, { fontSize: "inherit" }),
          info: (0, e.jsx)(eh, { fontSize: "inherit" }),
        },
        lh = t.forwardRef(function (t, n) {
          const r = nh({ props: t, name: "MuiAlert" }),
            {
              action: o,
              children: a,
              className: i,
              closeText: s = "Close",
              color: l,
              components: c = {},
              componentsProps: u = {},
              icon: p,
              iconMapping: m = sh,
              onClose: h,
              role: f = "alert",
              severity: g = "success",
              slotProps: v = {},
              slots: b = {},
              variant: _ = "standard",
            } = r,
            y = (0, jt.Z)(r, th),
            x = (0, d.Z)({}, r, {
              color: l,
              severity: g,
              variant: _,
              colorSeverity: l || g,
            }),
            C = ((e) => {
              const { variant: t, color: n, severity: r, classes: o } = e,
                a = {
                  root: [
                    "root",
                    `color${(0, Fn.Z)(n || r)}`,
                    `${t}${(0, Fn.Z)(n || r)}`,
                    `${t}`,
                  ],
                  icon: ["icon"],
                  message: ["message"],
                  action: ["action"],
                };
              return (0, Nt.Z)(a, qm, o);
            })(x),
            S = {
              slots: (0, d.Z)(
                { closeButton: c.CloseButton, closeIcon: c.CloseIcon },
                b
              ),
              slotProps: (0, d.Z)({}, u, v),
            },
            [k, w] = Sm("closeButton", {
              elementType: Kn,
              externalForwardedProps: S,
              ownerState: x,
            }),
            [P, O] = Sm("closeIcon", {
              elementType: vc,
              externalForwardedProps: S,
              ownerState: x,
            });
          return (0,
          e.jsxs)(rh, (0, d.Z)({ role: f, elevation: 0, ownerState: x, className: (0, Rt.Z)(C.root, i), ref: n }, y, { children: [!1 !== p ? (0, e.jsx)(oh, { ownerState: x, className: C.icon, children: p || m[g] || sh[g] }) : null, (0, e.jsx)(ah, { ownerState: x, className: C.message, children: a }), null != o ? (0, e.jsx)(ih, { ownerState: x, className: C.action, children: o }) : null, null == o && h ? (0, e.jsx)(ih, { ownerState: x, className: C.action, children: (0, e.jsx)(k, (0, d.Z)({ size: "small", "aria-label": s, title: s, color: "inherit", onClick: h }, w, { children: (0, e.jsx)(P, (0, d.Z)({ fontSize: "small" }, O)) })) }) : null] }));
        });
      var ch = lh;
      function uh(e) {
        return (0, Zt.ZP)("MuiCircularProgress", e);
      }
      (0, Bt.Z)("MuiCircularProgress", [
        "root",
        "determinate",
        "indeterminate",
        "colorPrimary",
        "colorSecondary",
        "svg",
        "circle",
        "circleDeterminate",
        "circleIndeterminate",
        "circleDisableShrink",
      ]);
      const dh = [
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant",
      ];
      let ph,
        mh,
        hh,
        fh,
        gh = (e) => e;
      const vh = (0, yn.F4)(
          ph ||
            (ph = gh`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)
        ),
        bh = (0, yn.F4)(
          mh ||
            (mh = gh`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)
        ),
        _h = (0, Lt.ZP)("span", {
          name: "MuiCircularProgress",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[n.variant], t[`color${(0, Fn.Z)(n.color)}`]];
          },
        })(
          ({ ownerState: e, theme: t }) =>
            (0, d.Z)(
              { display: "inline-block" },
              "determinate" === e.variant && {
                transition: t.transitions.create("transform"),
              },
              "inherit" !== e.color && {
                color: (t.vars || t).palette[e.color].main,
              }
            ),
          ({ ownerState: e }) =>
            "indeterminate" === e.variant &&
            (0, yn.iv)(
              hh ||
                (hh = gh`
      animation: ${0} 1.4s linear infinite;
    `),
              vh
            )
        ),
        yh = (0, Lt.ZP)("svg", {
          name: "MuiCircularProgress",
          slot: "Svg",
          overridesResolver: (e, t) => t.svg,
        })({ display: "block" }),
        xh = (0, Lt.ZP)("circle", {
          name: "MuiCircularProgress",
          slot: "Circle",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.circle,
              t[`circle${(0, Fn.Z)(n.variant)}`],
              n.disableShrink && t.circleDisableShrink,
            ];
          },
        })(
          ({ ownerState: e, theme: t }) =>
            (0, d.Z)(
              { stroke: "currentColor" },
              "determinate" === e.variant && {
                transition: t.transitions.create("stroke-dashoffset"),
              },
              "indeterminate" === e.variant && {
                strokeDasharray: "80px, 200px",
                strokeDashoffset: 0,
              }
            ),
          ({ ownerState: e }) =>
            "indeterminate" === e.variant &&
            !e.disableShrink &&
            (0, yn.iv)(
              fh ||
                (fh = gh`
      animation: ${0} 1.4s ease-in-out infinite;
    `),
              bh
            )
        ),
        Ch = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiCircularProgress" }),
            {
              className: o,
              color: a = "primary",
              disableShrink: i = !1,
              size: s = 40,
              style: l,
              thickness: c = 3.6,
              value: u = 0,
              variant: p = "indeterminate",
            } = r,
            m = (0, jt.Z)(r, dh),
            h = (0, d.Z)({}, r, {
              color: a,
              disableShrink: i,
              size: s,
              thickness: c,
              value: u,
              variant: p,
            }),
            f = ((e) => {
              const { classes: t, variant: n, color: r, disableShrink: o } = e,
                a = {
                  root: ["root", n, `color${(0, Fn.Z)(r)}`],
                  svg: ["svg"],
                  circle: [
                    "circle",
                    `circle${(0, Fn.Z)(n)}`,
                    o && "circleDisableShrink",
                  ],
                };
              return (0, Nt.Z)(a, uh, t);
            })(h),
            g = {},
            v = {},
            b = {};
          if ("determinate" === p) {
            const e = 2 * Math.PI * ((44 - c) / 2);
            (g.strokeDasharray = e.toFixed(3)),
              (b["aria-valuenow"] = Math.round(u)),
              (g.strokeDashoffset = `${(((100 - u) / 100) * e).toFixed(3)}px`),
              (v.transform = "rotate(-90deg)");
          }
          return (0,
          e.jsx)(_h, (0, d.Z)({ className: (0, Rt.Z)(f.root, o), style: (0, d.Z)({ width: s, height: s }, v, l), ownerState: h, ref: n, role: "progressbar" }, b, m, { children: (0, e.jsx)(yh, { className: f.svg, ownerState: h, viewBox: "22 22 44 44", children: (0, e.jsx)(xh, { className: f.circle, style: g, ownerState: h, cx: 44, cy: 44, r: (44 - c) / 2, fill: "none", strokeWidth: c }) }) }));
        });
      var Sh = Ch;
      function kh(e) {
        return (0, Zt.ZP)("MuiLoadingButton", e);
      }
      var wh = (0, Bt.Z)("MuiLoadingButton", [
        "root",
        "loading",
        "loadingIndicator",
        "loadingIndicatorCenter",
        "loadingIndicatorStart",
        "loadingIndicatorEnd",
        "endIconLoadingEnd",
        "startIconLoadingStart",
      ]);
      const Ph = [
          "children",
          "disabled",
          "id",
          "loading",
          "loadingIndicator",
          "loadingPosition",
          "variant",
        ],
        Oh = (0, Lt.ZP)(vp, {
          shouldForwardProp: (e) =>
            ((e) =>
              "ownerState" !== e &&
              "theme" !== e &&
              "sx" !== e &&
              "as" !== e &&
              "classes" !== e)(e) || "classes" === e,
          name: "MuiLoadingButton",
          slot: "Root",
          overridesResolver: (e, t) => [
            t.root,
            t.startIconLoadingStart && {
              [`& .${wh.startIconLoadingStart}`]: t.startIconLoadingStart,
            },
            t.endIconLoadingEnd && {
              [`& .${wh.endIconLoadingEnd}`]: t.endIconLoadingEnd,
            },
          ],
        })(({ ownerState: e, theme: t }) =>
          (0, d.Z)(
            {
              [`& .${wh.startIconLoadingStart}, & .${wh.endIconLoadingEnd}`]: {
                transition: t.transitions.create(["opacity"], {
                  duration: t.transitions.duration.short,
                }),
                opacity: 0,
              },
            },
            "center" === e.loadingPosition && {
              transition: t.transitions.create(
                ["background-color", "box-shadow", "border-color"],
                { duration: t.transitions.duration.short }
              ),
              [`&.${wh.loading}`]: { color: "transparent" },
            },
            "start" === e.loadingPosition &&
              e.fullWidth && {
                [`& .${wh.startIconLoadingStart}, & .${wh.endIconLoadingEnd}`]:
                  {
                    transition: t.transitions.create(["opacity"], {
                      duration: t.transitions.duration.short,
                    }),
                    opacity: 0,
                    marginRight: -8,
                  },
              },
            "end" === e.loadingPosition &&
              e.fullWidth && {
                [`& .${wh.startIconLoadingStart}, & .${wh.endIconLoadingEnd}`]:
                  {
                    transition: t.transitions.create(["opacity"], {
                      duration: t.transitions.duration.short,
                    }),
                    opacity: 0,
                    marginLeft: -8,
                  },
              }
          )
        ),
        Ih = (0, Lt.ZP)("div", {
          name: "MuiLoadingButton",
          slot: "LoadingIndicator",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.loadingIndicator,
              t[`loadingIndicator${(0, Fn.Z)(n.loadingPosition)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { position: "absolute", visibility: "visible", display: "flex" },
            "start" === t.loadingPosition &&
              ("outlined" === t.variant || "contained" === t.variant) && {
                left: "small" === t.size ? 10 : 14,
              },
            "start" === t.loadingPosition &&
              "text" === t.variant && { left: 6 },
            "center" === t.loadingPosition && {
              left: "50%",
              transform: "translate(-50%)",
              color: (e.vars || e).palette.action.disabled,
            },
            "end" === t.loadingPosition &&
              ("outlined" === t.variant || "contained" === t.variant) && {
                right: "small" === t.size ? 10 : 14,
              },
            "end" === t.loadingPosition && "text" === t.variant && { right: 6 },
            "start" === t.loadingPosition &&
              t.fullWidth && { position: "relative", left: -10 },
            "end" === t.loadingPosition &&
              t.fullWidth && { position: "relative", right: -10 }
          )
        );
      var Th = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiLoadingButton" }),
            {
              children: o,
              disabled: a = !1,
              id: i,
              loading: s = !1,
              loadingIndicator: l,
              loadingPosition: c = "center",
              variant: u = "text",
            } = r,
            p = (0, jt.Z)(r, Ph),
            m = (0, sl.Z)(i),
            h =
              null != l
                ? l
                : (0, e.jsx)(Sh, {
                    "aria-labelledby": m,
                    color: "inherit",
                    size: 16,
                  }),
            f = (0, d.Z)({}, r, {
              disabled: a,
              loading: s,
              loadingIndicator: h,
              loadingPosition: c,
              variant: u,
            }),
            g = ((e) => {
              const { loading: t, loadingPosition: n, classes: r } = e,
                o = {
                  root: ["root", t && "loading"],
                  startIcon: [t && `startIconLoading${(0, Fn.Z)(n)}`],
                  endIcon: [t && `endIconLoading${(0, Fn.Z)(n)}`],
                  loadingIndicator: [
                    "loadingIndicator",
                    t && `loadingIndicator${(0, Fn.Z)(n)}`,
                  ],
                },
                a = (0, Nt.Z)(o, kh, r);
              return (0, d.Z)({}, r, a);
            })(f),
            v = s
              ? (0, e.jsx)(Ih, {
                  className: g.loadingIndicator,
                  ownerState: f,
                  children: h,
                })
              : null;
          return (0,
          e.jsxs)(Oh, (0, d.Z)({ disabled: a || s, id: m, ref: n }, p, { variant: u, classes: g, ownerState: f, children: ["end" === f.loadingPosition ? o : v, "end" === f.loadingPosition ? v : o] }));
        }),
        Mh = function (e, t) {
          return (
            (Mh =
              Object.setPrototypeOf ||
              ({ __proto__: [] } instanceof Array &&
                function (e, t) {
                  e.__proto__ = t;
                }) ||
              function (e, t) {
                for (var n in t)
                  Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
              }),
            Mh(e, t)
          );
        };
      function Eh(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Class extends value " + String(t) + " is not a constructor or null"
          );
        function n() {
          this.constructor = e;
        }
        Mh(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((n.prototype = t.prototype), new n()));
      }
      function Dh(e) {
        var t = "function" == typeof Symbol && Symbol.iterator,
          n = t && e[t],
          r = 0;
        if (n) return n.call(e);
        if (e && "number" == typeof e.length)
          return {
            next: function () {
              return (
                e && r >= e.length && (e = void 0),
                { value: e && e[r++], done: !e }
              );
            },
          };
        throw new TypeError(
          t ? "Object is not iterable." : "Symbol.iterator is not defined."
        );
      }
      function jh(e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r,
          o,
          a = n.call(e),
          i = [];
        try {
          for (; (void 0 === t || t-- > 0) && !(r = a.next()).done; )
            i.push(r.value);
        } catch (e) {
          o = { error: e };
        } finally {
          try {
            r && !r.done && (n = a.return) && n.call(a);
          } finally {
            if (o) throw o.error;
          }
        }
        return i;
      }
      function Rh(e, t, n) {
        if (n || 2 === arguments.length)
          for (var r, o = 0, a = t.length; o < a; o++)
            (!r && o in t) ||
              (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
        return e.concat(r || Array.prototype.slice.call(t));
      }
      function Nh(e) {
        return "function" == typeof e;
      }
      function Ah(e) {
        var t = e(function (e) {
          Error.call(e), (e.stack = new Error().stack);
        });
        return (
          (t.prototype = Object.create(Error.prototype)),
          (t.prototype.constructor = t),
          t
        );
      }
      Object.create, Object.create;
      var Lh = Ah(function (e) {
        return function (t) {
          e(this),
            (this.message = t
              ? t.length +
                " errors occurred during unsubscription:\n" +
                t
                  .map(function (e, t) {
                    return t + 1 + ") " + e.toString();
                  })
                  .join("\n  ")
              : ""),
            (this.name = "UnsubscriptionError"),
            (this.errors = t);
        };
      });
      function zh(e, t) {
        if (e) {
          var n = e.indexOf(t);
          0 <= n && e.splice(n, 1);
        }
      }
      var Bh = (function () {
          function e(e) {
            (this.initialTeardown = e),
              (this.closed = !1),
              (this._parentage = null),
              (this._finalizers = null);
          }
          var t;
          return (
            (e.prototype.unsubscribe = function () {
              var e, t, n, r, o;
              if (!this.closed) {
                this.closed = !0;
                var a = this._parentage;
                if (a)
                  if (((this._parentage = null), Array.isArray(a)))
                    try {
                      for (var i = Dh(a), s = i.next(); !s.done; s = i.next())
                        s.value.remove(this);
                    } catch (t) {
                      e = { error: t };
                    } finally {
                      try {
                        s && !s.done && (t = i.return) && t.call(i);
                      } finally {
                        if (e) throw e.error;
                      }
                    }
                  else a.remove(this);
                var l = this.initialTeardown;
                if (Nh(l))
                  try {
                    l();
                  } catch (e) {
                    o = e instanceof Lh ? e.errors : [e];
                  }
                var c = this._finalizers;
                if (c) {
                  this._finalizers = null;
                  try {
                    for (var u = Dh(c), d = u.next(); !d.done; d = u.next()) {
                      var p = d.value;
                      try {
                        Hh(p);
                      } catch (e) {
                        (o = null != o ? o : []),
                          e instanceof Lh
                            ? (o = Rh(Rh([], jh(o)), jh(e.errors)))
                            : o.push(e);
                      }
                    }
                  } catch (e) {
                    n = { error: e };
                  } finally {
                    try {
                      d && !d.done && (r = u.return) && r.call(u);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                }
                if (o) throw new Lh(o);
              }
            }),
            (e.prototype.add = function (t) {
              var n;
              if (t && t !== this)
                if (this.closed) Hh(t);
                else {
                  if (t instanceof e) {
                    if (t.closed || t._hasParent(this)) return;
                    t._addParent(this);
                  }
                  (this._finalizers =
                    null !== (n = this._finalizers) && void 0 !== n
                      ? n
                      : []).push(t);
                }
            }),
            (e.prototype._hasParent = function (e) {
              var t = this._parentage;
              return t === e || (Array.isArray(t) && t.includes(e));
            }),
            (e.prototype._addParent = function (e) {
              var t = this._parentage;
              this._parentage = Array.isArray(t)
                ? (t.push(e), t)
                : t
                ? [t, e]
                : e;
            }),
            (e.prototype._removeParent = function (e) {
              var t = this._parentage;
              t === e ? (this._parentage = null) : Array.isArray(t) && zh(t, e);
            }),
            (e.prototype.remove = function (t) {
              var n = this._finalizers;
              n && zh(n, t), t instanceof e && t._removeParent(this);
            }),
            (e.EMPTY = (((t = new e()).closed = !0), t)),
            e
          );
        })(),
        Zh = Bh.EMPTY;
      function Fh(e) {
        return (
          e instanceof Bh ||
          (e && "closed" in e && Nh(e.remove) && Nh(e.add) && Nh(e.unsubscribe))
        );
      }
      function Hh(e) {
        Nh(e) ? e() : e.unsubscribe();
      }
      var Vh = {
          onUnhandledError: null,
          onStoppedNotification: null,
          Promise: void 0,
          useDeprecatedSynchronousErrorHandling: !1,
          useDeprecatedNextContext: !1,
        },
        Wh = {
          setTimeout: function (e, t) {
            for (var n = [], r = 2; r < arguments.length; r++)
              n[r - 2] = arguments[r];
            var o = Wh.delegate;
            return (null == o ? void 0 : o.setTimeout)
              ? o.setTimeout.apply(o, Rh([e, t], jh(n)))
              : setTimeout.apply(void 0, Rh([e, t], jh(n)));
          },
          clearTimeout: function (e) {
            var t = Wh.delegate;
            return ((null == t ? void 0 : t.clearTimeout) || clearTimeout)(e);
          },
          delegate: void 0,
        };
      function $h() {}
      var Uh = Kh("C", void 0, void 0);
      function Kh(e, t, n) {
        return { kind: e, value: t, error: n };
      }
      var Gh = null;
      function qh(e) {
        if (Vh.useDeprecatedSynchronousErrorHandling) {
          var t = !Gh;
          if ((t && (Gh = { errorThrown: !1, error: null }), e(), t)) {
            var n = Gh,
              r = n.errorThrown,
              o = n.error;
            if (((Gh = null), r)) throw o;
          }
        } else e();
      }
      var Yh = (function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return (
              (n.isStopped = !1),
              t
                ? ((n.destination = t), Fh(t) && t.add(n))
                : (n.destination = rf),
              n
            );
          }
          return (
            Eh(t, e),
            (t.create = function (e, t, n) {
              return new ef(e, t, n);
            }),
            (t.prototype.next = function (e) {
              this.isStopped
                ? nf(
                    (function (e) {
                      return Kh("N", e, void 0);
                    })(e),
                    this
                  )
                : this._next(e);
            }),
            (t.prototype.error = function (e) {
              this.isStopped
                ? nf(Kh("E", void 0, e), this)
                : ((this.isStopped = !0), this._error(e));
            }),
            (t.prototype.complete = function () {
              this.isStopped
                ? nf(Uh, this)
                : ((this.isStopped = !0), this._complete());
            }),
            (t.prototype.unsubscribe = function () {
              this.closed ||
                ((this.isStopped = !0),
                e.prototype.unsubscribe.call(this),
                (this.destination = null));
            }),
            (t.prototype._next = function (e) {
              this.destination.next(e);
            }),
            (t.prototype._error = function (e) {
              try {
                this.destination.error(e);
              } finally {
                this.unsubscribe();
              }
            }),
            (t.prototype._complete = function () {
              try {
                this.destination.complete();
              } finally {
                this.unsubscribe();
              }
            }),
            t
          );
        })(Bh),
        Jh = Function.prototype.bind;
      function Qh(e, t) {
        return Jh.call(e, t);
      }
      var Xh = (function () {
          function e(e) {
            this.partialObserver = e;
          }
          return (
            (e.prototype.next = function (e) {
              var t = this.partialObserver;
              if (t.next)
                try {
                  t.next(e);
                } catch (e) {
                  tf(e);
                }
            }),
            (e.prototype.error = function (e) {
              var t = this.partialObserver;
              if (t.error)
                try {
                  t.error(e);
                } catch (e) {
                  tf(e);
                }
              else tf(e);
            }),
            (e.prototype.complete = function () {
              var e = this.partialObserver;
              if (e.complete)
                try {
                  e.complete();
                } catch (e) {
                  tf(e);
                }
            }),
            e
          );
        })(),
        ef = (function (e) {
          function t(t, n, r) {
            var o,
              a,
              i = e.call(this) || this;
            return (
              Nh(t) || !t
                ? (o = {
                    next: null != t ? t : void 0,
                    error: null != n ? n : void 0,
                    complete: null != r ? r : void 0,
                  })
                : i && Vh.useDeprecatedNextContext
                ? (((a = Object.create(t)).unsubscribe = function () {
                    return i.unsubscribe();
                  }),
                  (o = {
                    next: t.next && Qh(t.next, a),
                    error: t.error && Qh(t.error, a),
                    complete: t.complete && Qh(t.complete, a),
                  }))
                : (o = t),
              (i.destination = new Xh(o)),
              i
            );
          }
          return Eh(t, e), t;
        })(Yh);
      function tf(e) {
        var t;
        Vh.useDeprecatedSynchronousErrorHandling
          ? ((t = e),
            Vh.useDeprecatedSynchronousErrorHandling &&
              Gh &&
              ((Gh.errorThrown = !0), (Gh.error = t)))
          : (function (e) {
              Wh.setTimeout(function () {
                var t = Vh.onUnhandledError;
                if (!t) throw e;
                t(e);
              });
            })(e);
      }
      function nf(e, t) {
        var n = Vh.onStoppedNotification;
        n &&
          Wh.setTimeout(function () {
            return n(e, t);
          });
      }
      var rf = {
          closed: !0,
          next: $h,
          error: function (e) {
            throw e;
          },
          complete: $h,
        },
        of =
          ("function" == typeof Symbol && Symbol.observable) || "@@observable";
      function af(e) {
        return e;
      }
      var sf = (function () {
        function e(e) {
          e && (this._subscribe = e);
        }
        return (
          (e.prototype.lift = function (t) {
            var n = new e();
            return (n.source = this), (n.operator = t), n;
          }),
          (e.prototype.subscribe = function (e, t, n) {
            var r,
              o = this,
              a =
                ((r = e) && r instanceof Yh) ||
                ((function (e) {
                  return e && Nh(e.next) && Nh(e.error) && Nh(e.complete);
                })(r) &&
                  Fh(r))
                  ? e
                  : new ef(e, t, n);
            return (
              qh(function () {
                var e = o,
                  t = e.operator,
                  n = e.source;
                a.add(
                  t ? t.call(a, n) : n ? o._subscribe(a) : o._trySubscribe(a)
                );
              }),
              a
            );
          }),
          (e.prototype._trySubscribe = function (e) {
            try {
              return this._subscribe(e);
            } catch (t) {
              e.error(t);
            }
          }),
          (e.prototype.forEach = function (e, t) {
            var n = this;
            return new (t = lf(t))(function (t, r) {
              var o = new ef({
                next: function (t) {
                  try {
                    e(t);
                  } catch (e) {
                    r(e), o.unsubscribe();
                  }
                },
                error: r,
                complete: t,
              });
              n.subscribe(o);
            });
          }),
          (e.prototype._subscribe = function (e) {
            var t;
            return null === (t = this.source) || void 0 === t
              ? void 0
              : t.subscribe(e);
          }),
          (e.prototype[of] = function () {
            return this;
          }),
          (e.prototype.pipe = function () {
            for (var e = [], t = 0; t < arguments.length; t++)
              e[t] = arguments[t];
            return (
              0 === (n = e).length
                ? af
                : 1 === n.length
                ? n[0]
                : function (e) {
                    return n.reduce(function (e, t) {
                      return t(e);
                    }, e);
                  }
            )(this);
            var n;
          }),
          (e.prototype.toPromise = function (e) {
            var t = this;
            return new (e = lf(e))(function (e, n) {
              var r;
              t.subscribe(
                function (e) {
                  return (r = e);
                },
                function (e) {
                  return n(e);
                },
                function () {
                  return e(r);
                }
              );
            });
          }),
          (e.create = function (t) {
            return new e(t);
          }),
          e
        );
      })();
      function lf(e) {
        var t;
        return null !== (t = null != e ? e : Vh.Promise) && void 0 !== t
          ? t
          : Promise;
      }
      var cf = Ah(function (e) {
          return function () {
            e(this),
              (this.name = "ObjectUnsubscribedError"),
              (this.message = "object unsubscribed");
          };
        }),
        uf = (function (e) {
          function t() {
            var t = e.call(this) || this;
            return (
              (t.closed = !1),
              (t.currentObservers = null),
              (t.observers = []),
              (t.isStopped = !1),
              (t.hasError = !1),
              (t.thrownError = null),
              t
            );
          }
          return (
            Eh(t, e),
            (t.prototype.lift = function (e) {
              var t = new df(this, this);
              return (t.operator = e), t;
            }),
            (t.prototype._throwIfClosed = function () {
              if (this.closed) throw new cf();
            }),
            (t.prototype.next = function (e) {
              var t = this;
              qh(function () {
                var n, r;
                if ((t._throwIfClosed(), !t.isStopped)) {
                  t.currentObservers ||
                    (t.currentObservers = Array.from(t.observers));
                  try {
                    for (
                      var o = Dh(t.currentObservers), a = o.next();
                      !a.done;
                      a = o.next()
                    )
                      a.value.next(e);
                  } catch (e) {
                    n = { error: e };
                  } finally {
                    try {
                      a && !a.done && (r = o.return) && r.call(o);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                }
              });
            }),
            (t.prototype.error = function (e) {
              var t = this;
              qh(function () {
                if ((t._throwIfClosed(), !t.isStopped)) {
                  (t.hasError = t.isStopped = !0), (t.thrownError = e);
                  for (var n = t.observers; n.length; ) n.shift().error(e);
                }
              });
            }),
            (t.prototype.complete = function () {
              var e = this;
              qh(function () {
                if ((e._throwIfClosed(), !e.isStopped)) {
                  e.isStopped = !0;
                  for (var t = e.observers; t.length; ) t.shift().complete();
                }
              });
            }),
            (t.prototype.unsubscribe = function () {
              (this.isStopped = this.closed = !0),
                (this.observers = this.currentObservers = null);
            }),
            Object.defineProperty(t.prototype, "observed", {
              get: function () {
                var e;
                return (
                  (null === (e = this.observers) || void 0 === e
                    ? void 0
                    : e.length) > 0
                );
              },
              enumerable: !1,
              configurable: !0,
            }),
            (t.prototype._trySubscribe = function (t) {
              return (
                this._throwIfClosed(), e.prototype._trySubscribe.call(this, t)
              );
            }),
            (t.prototype._subscribe = function (e) {
              return (
                this._throwIfClosed(),
                this._checkFinalizedStatuses(e),
                this._innerSubscribe(e)
              );
            }),
            (t.prototype._innerSubscribe = function (e) {
              var t = this,
                n = this,
                r = n.hasError,
                o = n.isStopped,
                a = n.observers;
              return r || o
                ? Zh
                : ((this.currentObservers = null),
                  a.push(e),
                  new Bh(function () {
                    (t.currentObservers = null), zh(a, e);
                  }));
            }),
            (t.prototype._checkFinalizedStatuses = function (e) {
              var t = this,
                n = t.hasError,
                r = t.thrownError,
                o = t.isStopped;
              n ? e.error(r) : o && e.complete();
            }),
            (t.prototype.asObservable = function () {
              var e = new sf();
              return (e.source = this), e;
            }),
            (t.create = function (e, t) {
              return new df(e, t);
            }),
            t
          );
        })(sf),
        df = (function (e) {
          function t(t, n) {
            var r = e.call(this) || this;
            return (r.destination = t), (r.source = n), r;
          }
          return (
            Eh(t, e),
            (t.prototype.next = function (e) {
              var t, n;
              null ===
                (n =
                  null === (t = this.destination) || void 0 === t
                    ? void 0
                    : t.next) ||
                void 0 === n ||
                n.call(t, e);
            }),
            (t.prototype.error = function (e) {
              var t, n;
              null ===
                (n =
                  null === (t = this.destination) || void 0 === t
                    ? void 0
                    : t.error) ||
                void 0 === n ||
                n.call(t, e);
            }),
            (t.prototype.complete = function () {
              var e, t;
              null ===
                (t =
                  null === (e = this.destination) || void 0 === e
                    ? void 0
                    : e.complete) ||
                void 0 === t ||
                t.call(e);
            }),
            (t.prototype._subscribe = function (e) {
              var t, n;
              return null !==
                (n =
                  null === (t = this.source) || void 0 === t
                    ? void 0
                    : t.subscribe(e)) && void 0 !== n
                ? n
                : Zh;
            }),
            t
          );
        })(uf),
        pf = (function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return (n._value = t), n;
          }
          return (
            Eh(t, e),
            Object.defineProperty(t.prototype, "value", {
              get: function () {
                return this.getValue();
              },
              enumerable: !1,
              configurable: !0,
            }),
            (t.prototype._subscribe = function (t) {
              var n = e.prototype._subscribe.call(this, t);
              return !n.closed && t.next(this._value), n;
            }),
            (t.prototype.getValue = function () {
              var e = this,
                t = e.hasError,
                n = e.thrownError,
                r = e._value;
              if (t) throw n;
              return this._throwIfClosed(), r;
            }),
            (t.prototype.next = function (t) {
              e.prototype.next.call(this, (this._value = t));
            }),
            t
          );
        })(uf),
        mf = new pf(!1),
        hf = new pf(!1),
        ff = new pf(!1),
        gf = new pf(!1),
        vf = o(9669),
        bf = o.n(vf),
        _f = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        yf = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        xf = Ef().shopName;
      function Cf(e, t, n, r) {
        return _f(this, void 0, void 0, function () {
          var o, a;
          return yf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  i.trys.push([0, 8, , 9]),
                  (o = void 0),
                  "GET" !== n
                    ? [3, 3]
                    : [
                        4,
                        Sf(e).then(function (e) {
                          return e;
                        }),
                      ]
                );
              case 1:
                return [4, Pf((o = i.sent()).data)];
              case 2:
                return [2, i.sent()];
              case 3:
                return [
                  4,
                  kf(e, t, r).then(function (e) {
                    return e;
                  }),
                ];
              case 4:
                return 0 == (o = i.sent()).data || 200 !== o.status
                  ? [3, 6]
                  : e.includes("pageIndex=44") ||
                    e.includes("pageIndex=02") ||
                    e.includes("pageIndex=14")
                  ? [2, o]
                  : ((a = o), [4, Pf(o.data)]);
              case 5:
                if (
                  ((a.data = i.sent()),
                  e.includes("pageIndex=0") ||
                    e.includes("pageIndex=31") ||
                    e.includes("pageIndex=30"))
                )
                  return [2, o];
                i.label = 6;
              case 6:
                return [2, o.data];
              case 7:
                return [3, 9];
              case 8:
                return i.sent(), [2, null];
              case 9:
                return [2];
            }
          });
        });
      }
      function Sf(e) {
        return _f(this, void 0, void 0, function () {
          var t = this;
          return yf(this, function (n) {
            return [
              2,
              bf()({ method: "GET", url: e, headers: Rf() })
                .then(function (e) {
                  return _f(t, void 0, void 0, function () {
                    return yf(this, function (t) {
                      return [2, e];
                    });
                  });
                })
                .catch(function (e) {
                  return e.response;
                }),
            ];
          });
        });
      }
      function kf(e, t, n) {
        return _f(this, void 0, void 0, function () {
          return yf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  bf()({
                    method: "POST",
                    url: e,
                    headers: Rf(),
                    params: { shop: xf },
                    data: t ? (n ? t : JSON.stringify(t)) : "",
                  })
                    .then(function (e) {
                      return (function (e) {
                        return (
                          "string" != typeof (null == e ? void 0 : e.data) &&
                            null === (null == e ? void 0 : e.data) &&
                            "" === (null == e ? void 0 : e.data) &&
                            (e.data = !1),
                          e
                        );
                      })(e);
                    })
                    .catch(function (e) {
                      return e.response;
                    }),
                ];
              case 1:
                return [2, r.sent()];
            }
          });
        });
      }
      function wf(e) {
        return _f(this, void 0, void 0, function () {
          var t, n, r, o, a, i, s, l, c;
          return yf(this, function (u) {
            switch (u.label) {
              case 0:
                return (
                  u.trys.push([0, 3, , 4]),
                  (t = JSON.stringify(e)),
                  (n = new TextEncoder()),
                  (r = n.encode(t)),
                  [
                    4,
                    crypto.subtle.importKey(
                      "raw",
                      n.encode("nuH2aoKmHFHl8pNCzAOfbPoEx5JFTZPZ"),
                      "AES-CBC",
                      !1,
                      ["encrypt"]
                    ),
                  ]
                );
              case 1:
                return (
                  (o = u.sent()),
                  (a = crypto.getRandomValues(new Uint8Array(16))),
                  [4, crypto.subtle.encrypt({ name: "AES-CBC", iv: a }, o, r)]
                );
              case 2:
                return (
                  (i = u.sent()),
                  (s = new Uint8Array(a.length + i.byteLength)).set(a),
                  s.set(new Uint8Array(i), a.length),
                  (l = Array.from(s)),
                  [
                    2,
                    null !== (c = btoa(String.fromCharCode.apply(null, l)))
                      ? btoa(c)
                      : null,
                  ]
                );
              case 3:
                return u.sent(), [2, null];
              case 4:
                return [2];
            }
          });
        });
      }
      function Pf(e) {
        return _f(this, void 0, void 0, function () {
          var t, n, r, o, a, i, s, l;
          return yf(this, function (c) {
            switch (c.label) {
              case 0:
                return (
                  c.trys.push([0, 3, , 4]),
                  (t = Array.from(atob(e)).map(function (e) {
                    return e.charCodeAt(0);
                  })),
                  (n = new Uint8Array(t)),
                  (r = n.slice(0, 16)),
                  (o = n.slice(16)),
                  [
                    4,
                    crypto.subtle.importKey(
                      "raw",
                      new TextEncoder().encode(
                        "nuH2aoKmHFHl8pNCzAOfbPoEx5JFTZPZ"
                      ),
                      "AES-CBC",
                      !1,
                      ["decrypt"]
                    ),
                  ]
                );
              case 1:
                return (
                  (a = c.sent()),
                  [4, crypto.subtle.decrypt({ name: "AES-CBC", iv: r }, a, o)]
                );
              case 2:
                return (
                  (i = c.sent()),
                  (s = new TextDecoder()),
                  (l = s.decode(i)),
                  [2, JSON.parse(l)]
                );
              case 3:
                return c.sent(), [2, null];
              case 4:
                return [2];
            }
          });
        });
      }
      var Of = function () {
          return (
            (Of =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Of.apply(this, arguments)
          );
        },
        If = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Tf = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Mf = "";
      function Ef() {
        return z.getState().salesRepData.loggedInRepDetails;
      }
      function Df() {
        hf.next(!0), mf.next(!1);
      }
      function jf() {
        var e = sessionStorage.getItem("Authorization");
        return (Mf = e ? JSON.parse(atob(e)) : "");
      }
      function Rf() {
        var e = sessionStorage.getItem("Authorization");
        return {
          Authorization: "Bearer " + (Mf = e ? JSON.parse(atob(e)) : "").token,
          STApiVersion: "V2",
          XEncryptedPayload: "true",
        };
      }
      var Nf = Ef(),
        Af = (Nf.customerId, Nf.customerName, Nf.shopName),
        Lf = (Mf.CustomerId, Mf.SalesRepName),
        zf = "https://" + Ef().baseUrlShopName + "/apps/SalesRep";
      function Bf() {
        var e = jf(),
          t = e.CustomerId,
          n = e.SalesRepName;
        return zf + "?customerId=" + t + "&customerName=" + n + "&shop=" + Af;
      }
      function Zf() {
        return If(this, void 0, void 0, function () {
          var e;
          return Tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&data=1", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Ff() {
        return If(this, void 0, void 0, function () {
          var e;
          return Tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&data=18", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Hf() {
        return If(this, void 0, void 0, function () {
          var e;
          return Tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&data=8", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Vf(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o;
          return Tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = jf()),
                  (n = t.CustomerId),
                  t.SalesRepName,
                  [
                    4,
                    wf(
                      JSON.stringify({
                        salesrepId: n,
                        couponCode: e.discountCode,
                        Discount: e.discountValue,
                      })
                    ),
                  ]
                );
              case 1:
                return (
                  (r = a.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + r + "&pageIndex=3", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (o = a.sent()) ? [2, o] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Wf(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, wf(JSON.stringify(e))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + t + "&pageIndex=4", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (Df(), [2, !1]);
            }
          });
        });
      }
      function $f(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return Tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = jf()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [
                    4,
                    wf(
                      JSON.stringify(
                        Of(Of({}, e), { SalesRepId: n, SalesRepName: r })
                      )
                    ),
                  ]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + o + "&pageIndex=13", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Uf(e) {
        return If(this, void 0, void 0, function () {
          var t;
          return Tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&clientId=" + e + "&data=25", "", "GET").then(
                    function (e) {
                      return e;
                    }
                  ),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Kf(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r;
          return Tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (
                  (t = jf()).CustomerId,
                  (n = t.SalesRepName),
                  [
                    4,
                    Cf(
                      zf +
                        "?customerId=" +
                        e +
                        "&customerName=" +
                        n +
                        "&data=12",
                      "",
                      "GET"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 1:
                return (r = o.sent()) ? [2, r] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Gf(e) {
        return If(this, void 0, void 0, function () {
          var t;
          return Tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Cf(
                    Bf() +
                      "&clientId=" +
                      e.clientId +
                      "&orderId=" +
                      e.order_id +
                      "&data=19",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (Df(), [2, !1]);
            }
          });
        });
      }
      function qf(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r;
          return Tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (
                  (t = jf()).CustomerId,
                  (n = t.SalesRepName),
                  [
                    4,
                    Cf(
                      zf +
                        "?customerId=" +
                        e +
                        "&customerName=" +
                        n +
                        "&shop=" +
                        Af +
                        "&data=31",
                      "",
                      "GET"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 1:
                return (r = o.sent()) ? [2, r] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Yf() {
        return If(this, void 0, void 0, function () {
          var e;
          return Tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&data=14", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Jf(e, t) {
        return If(this, void 0, void 0, function () {
          var n, r;
          return Tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (
                  (n = zf + "?pageIndex=".concat(t ? 44 : 0)),
                  [4, wf(JSON.stringify(e))]
                );
              case 1:
                return (
                  (r = o.sent()),
                  [
                    4,
                    Cf(n, r, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return [2, o.sent()];
            }
          });
        });
      }
      function Qf(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return Tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = jf()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [
                    4,
                    wf(
                      JSON.stringify({
                        salesrepId: n,
                        email: e.email,
                        name: e.firstName,
                        TeamManagerName: r,
                        Lname: e.lastName,
                        IsTeamManager: !0,
                        RequestSignUpV2: !0,
                      })
                    ),
                  ]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Cf(Bf() + "&data=" + o + "&pageIndex=21", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (Df(), [2, !1]);
            }
          });
        });
      }
      function Xf(e) {
        return If(this, void 0, void 0, function () {
          var t;
          return Tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Cf(
                    zf +
                      "?customerId=" +
                      e.repId +
                      "&customerName=" +
                      e.repName +
                      "&data=18",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (Df(), [2, !1]);
            }
          });
        });
      }
      function eg(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, wf(JSON.stringify(e))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + t + "&pageIndex=31", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (Df(), [2, !1]);
            }
          });
        });
      }
      function tg(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, wf(e)];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + t + "&pageIndex=30", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (Df(), [2, !1]);
            }
          });
        });
      }
      function ng() {
        return If(this, void 0, void 0, function () {
          var e;
          return Tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&data=2", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (Df(), [2, !1]);
            }
          });
        });
      }
      function rg(e) {
        return If(this, void 0, void 0, function () {
          var t;
          return Tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Cf(
                    Bf() + "&orderId=" + e.order_id + "&data=20",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (Df(), [2, !1]);
            }
          });
        });
      }
      function og(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  wf(
                    JSON.stringify({
                      orderid: e.orderid,
                      shopname: Af,
                      emailid: e.emailid,
                    })
                  ),
                ];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + t + "&pageIndex=02", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (Df(), [2, !1]);
            }
          });
        });
      }
      function ag(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, wf(JSON.stringify({ orderid: e }))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(
                      zf +
                        "?&customerName=" +
                        Lf +
                        "&data=" +
                        t +
                        "&pageIndex=14",
                      "",
                      "POST"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) && (null == n ? void 0 : n.data)
                  ? [2, n]
                  : (Df(), [2, !1]);
            }
          });
        });
      }
      function ig(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o;
          return Tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = jf()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [
                    4,
                    Cf(
                      zf +
                        "?shop=" +
                        Af +
                        "&customerId=" +
                        n +
                        "&customerName=" +
                        r +
                        "&orderId=" +
                        e.orderId +
                        "&refundId=" +
                        e.refundId +
                        "&data=35",
                      "",
                      "GET"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 1:
                return (o = a.sent()) ? [2, o] : (Df(), [2, !1]);
            }
          });
        });
      }
      function sg(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return Tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = jf()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [4, wf(JSON.stringify(Of({ repId: n, repname: r }, e)))]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Cf(zf + "?data=" + o + "&pageIndex=8", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (Df(), [2, !1]);
            }
          });
        });
      }
      function lg(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return Tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = jf()),
                  (n = t.CustomerId),
                  t.SalesRepName,
                  (r = new FormData()).append("postedFile", e),
                  [4, wf(JSON.stringify({ repId: n }))]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Cf(
                      zf + "?data=" + o + "&pageIndex=28",
                      r,
                      "POST",
                      "multipart/form-data"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (Df(), [2, !1]);
            }
          });
        });
      }
      function cg() {
        return If(this, void 0, void 0, function () {
          var e;
          return Tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Cf(Bf() + "&data=30", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (Df(), [2, !1]);
            }
          });
        });
      }
      function ug(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o, a, i, s;
          return Tf(this, function (l) {
            switch (l.label) {
              case 0:
                return (
                  (t = jf()).CustomerId,
                  (n = t.SalesRepName),
                  (r = e.fileUpload),
                  (o = new FormData()).append("postedFile", r),
                  (a = {
                    email: e.userDetails.emailId,
                    name: e.userDetails.firstName,
                    TeamManagerName: n,
                    Lname: e.userDetails.lastName,
                    IsTeamManager: !1,
                    PhNumber: e.userDetails.phoneNumber,
                    fbHandle: e.userDetails.fbHandle,
                    InstaHandle: e.userDetails.instHandle,
                    signUpRequestV2: 1,
                  }),
                  [4, wf(JSON.stringify(a))]
                );
              case 1:
                return (
                  (i = l.sent()),
                  [
                    4,
                    Cf(
                      zf + "?data=" + i + "&pageIndex=21",
                      o,
                      "POST",
                      "multipart/form-data"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (s = l.sent()) ? [2, s] : (Df(), [2, !1]);
            }
          });
        });
      }
      function dg(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  wf(
                    JSON.stringify({
                      email: e.emailField,
                      password: e.passwordField,
                    })
                  ),
                ];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(zf + "?pageIndex=45", t, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (Df(), [2, !1]);
            }
          });
        });
      }
      function pg(e) {
        return If(this, void 0, void 0, function () {
          var t, n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, wf(JSON.stringify({ email: e }))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Cf(zf + "?pageIndex=46", t, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (Df(), [2, !1]);
            }
          });
        });
      }
      function mg(e, t) {
        return If(this, void 0, void 0, function () {
          var n;
          return Tf(this, function (r) {
            switch (r.label) {
              case 0:
                return (
                  (n =
                    "add.js" === t
                      ? { items: e }
                      : "update.js" === t
                      ? { updates: e }
                      : e),
                  [
                    4,
                    bf()({
                      method: "post",
                      url: "/cart/" + t,
                      data: JSON.stringify(n),
                      headers: { "Content-type": "application/json" },
                    })
                      .then(function (e) {
                        return !0;
                      })
                      .catch(function (e) {
                        return e;
                      }),
                  ]
                );
              case 1:
                return [2, r.sent()];
            }
          });
        });
      }
      function hg(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return Tf(this, function (i) {
            switch (i.label) {
              case 0:
                setTimeout(function () {
                  console.log("Calculating Shipping cost");
                }, 2e3),
                  (t = ""),
                  (i.label = 1);
              case 1:
                return (
                  i.trys.push([1, 8, , 9]),
                  [
                    4,
                    bf()({
                      method: "post",
                      url: "/cart/prepare_shipping_rates.json",
                      params: {
                        "shipping_address[zip]": e.customerZip,
                        "shipping_address[country]": e.customerCountry,
                        "shipping_address[province]": e.customerProvince,
                      },
                    }),
                  ]
                );
              case 2:
                return 202 !== i.sent().status
                  ? [3, 7]
                  : [
                      4,
                      new Promise(function (e) {
                        return setTimeout(e, 5e3);
                      }),
                    ];
              case 3:
                i.sent(), (i.label = 4);
              case 4:
                return (
                  i.trys.push([4, 6, , 7]),
                  [
                    4,
                    bf()({
                      method: "get",
                      url: "/cart/async_shipping_rates.json",
                      params: {
                        "shipping_address[zip]": e.customerZip,
                        "shipping_address[country]": e.customerCountry,
                        "shipping_address[province]": e.customerProvince,
                      },
                    }),
                  ]
                );
              case 5:
                return (
                  (n = i.sent()),
                  (t = "Success"),
                  [2, Of(Of({}, n.data), { message: t })]
                );
              case 6:
                return (
                  (r = i.sent()), (t = r.message), Df(), [2, { message: t }]
                );
              case 7:
                return [3, 9];
              case 8:
                return (
                  0 === (o = i.sent()).request.status
                    ? (t = "Network Problem")
                    : 404 === o.request.status
                    ? (t = "Not Found")
                    : 422 === o.request.status
                    ? (void 0 !==
                        (a = JSON.parse(o.request.responseText)).zip &&
                        null !== a.zip &&
                        (t = t.concat(",", a.zip[0])),
                      void 0 !== a.country &&
                        null !== a.country &&
                        (t = t.concat(",", a.country[0])),
                      void 0 !== a.province &&
                        null !== a.province &&
                        (t = t.concat(",", a.province[0])),
                      void 0 !== a.error &&
                        null !== a.error &&
                        (t = t.concat(",", a.error[0])))
                    : (t = o.message),
                  [2, { message: t }]
                );
              case 9:
                return [2];
            }
          });
        });
      }
      function fg(e) {
        return If(this, void 0, void 0, function () {
          var t, n, r, o;
          return Tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = Mf.CustomerId),
                  (n = Mf.email),
                  [4, wf(JSON.stringify(Of({ customerId: t, email: n }, e)))]
                );
              case 1:
                return (
                  (r = a.sent()),
                  [
                    4,
                    Cf(zf + "?pageIndex=47", r, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (o = a.sent()) ? [2, o] : (Df(), [2, !1]);
            }
          });
        });
      }
      var gg = function () {
          return (
            (gg =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            gg.apply(this, arguments)
          );
        },
        vg = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        bg = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function _g() {
        var e = this;
        return function (t) {
          return vg(e, void 0, void 0, function () {
            var e, n;
            return bg(this, function (r) {
              switch (r.label) {
                case 0:
                  return [
                    4,
                    Zf().then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (e = r.sent())
                    ? ((n = { payload: e, type: j.BASE_DATA }), [2, t(n)])
                    : [2];
              }
            });
          });
        };
      }
      function yg() {
        var e = this;
        return function (t) {
          return vg(e, void 0, void 0, function () {
            var e, n;
            return bg(this, function (r) {
              switch (r.label) {
                case 0:
                  return [
                    4,
                    Ff().then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (e = r.sent())
                    ? ((n = { payload: e, type: j.ORDERS_DATA }), [2, t(n)])
                    : [2];
              }
            });
          });
        };
      }
      function xg(e) {
        var t = this;
        return function (n) {
          return vg(t, void 0, void 0, function () {
            var t, r, o;
            return bg(this, function (a) {
              switch (a.label) {
                case 0:
                  return [
                    4,
                    qf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (
                    (t = a.sent()),
                    (r = {
                      customerAddressesList: t.customerAddressesList,
                      SingleShopifyCustomers: t.SingleShopifyCustomers,
                    }),
                    t
                      ? ((o = { payload: r, type: j.CUSTOMER_ADDRESS_DATA }),
                        [2, n(o)])
                      : [2]
                  );
              }
            });
          });
        };
      }
      function Cg() {
        var e = this;
        return function (t) {
          return vg(e, void 0, void 0, function () {
            var e, n, r, o;
            return bg(this, function (a) {
              switch (a.label) {
                case 0:
                  return 0 ===
                    (e = z.getState().salesRepData).productsData.length
                    ? [3, 1]
                    : [2, e.productsData];
                case 1:
                  return [
                    4,
                    Yf().then(function (e) {
                      return e.products;
                    }),
                  ];
                case 2:
                  return (
                    (n = a.sent()),
                    (r =
                      null == n
                        ? void 0
                        : n.filter(function (e) {
                            return e.variants.length > 0;
                          })),
                    (o = { payload: r, type: j.PRODUCTS_DATA }),
                    [2, t(o)]
                  );
              }
            });
          });
        };
      }
      var Sg = function (e, t) {
        return vg(void 0, void 0, void 0, function () {
          var n, r, o, a;
          return bg(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, Jf(e, t)];
              case 1:
                return 200 === (null == (n = i.sent()) ? void 0 : n.status)
                  ? t
                    ? [
                        2,
                        "" !== (null == n ? void 0 : n.data) &&
                          void 0 !== (null == n ? void 0 : n.data) &&
                          null !== (null == n ? void 0 : n.data),
                      ]
                    : [
                        2,
                        "" !==
                          (null === (r = null == n ? void 0 : n.data) ||
                          void 0 === r
                            ? void 0
                            : r.id) &&
                          void 0 !==
                            (null === (o = null == n ? void 0 : n.data) ||
                            void 0 === o
                              ? void 0
                              : o.id) &&
                          null !==
                            (null === (a = null == n ? void 0 : n.data) ||
                            void 0 === a
                              ? void 0
                              : a.id),
                      ]
                  : [2, !1];
            }
          });
        });
      };
      function kg() {
        var e = this;
        return function (t) {
          return vg(e, void 0, void 0, function () {
            var e, n;
            return bg(this, function (r) {
              switch (r.label) {
                case 0:
                  return z.getState().salesRepData.viewCouponData.length > 0
                    ? [2, z.getState().salesRepData.viewCouponData]
                    : [3, 1];
                case 1:
                  return [
                    4,
                    Hf().then(function (e) {
                      return e;
                    }),
                  ];
                case 2:
                  if ((e = r.sent()).Coupons)
                    return (
                      (n = { payload: e.Coupons, type: j.VIEW_COUPON_DATA }),
                      [2, t(n)]
                    );
                  r.label = 3;
                case 3:
                  return [2];
              }
            });
          });
        };
      }
      function wg(e) {
        var t = this;
        return function (n) {
          return vg(t, void 0, void 0, function () {
            var t, r;
            return bg(this, function (o) {
              switch (o.label) {
                case 0:
                  return [
                    4,
                    Vf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (
                    "Coupon Created" === (t = o.sent()) &&
                      ((r = { payload: [], type: j.VIEW_COUPON_DATA }), n(r)),
                    [2, t]
                  );
              }
            });
          });
        };
      }
      function Pg(e) {
        var t = this;
        return function (n) {
          return vg(t, void 0, void 0, function () {
            var t, r;
            return bg(this, function (o) {
              switch (o.label) {
                case 0:
                  return [
                    4,
                    Wf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return o.sent() && z.getState().salesRepData.viewCouponData
                    ? ((t = z.getState().salesRepData.viewCouponData).forEach(
                        function (n, r) {
                          e.couponid === n.couponId && t.splice(r, 1);
                        }
                      ),
                      (r = { payload: t, type: j.VIEW_COUPON_DATA }),
                      [2, n(r)])
                    : [2];
              }
            });
          });
        };
      }
      function Og(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    $f(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Ig(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Uf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Tg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Kf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Mg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Gf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Eg() {
        var e = this;
        return function (t) {
          return vg(e, void 0, void 0, function () {
            var e, n;
            return bg(this, function (r) {
              switch (r.label) {
                case 0:
                  return z.getState().salesRepData.draftOrderData.length > 0
                    ? [2, z.getState().salesRepData.draftOrderData]
                    : [3, 1];
                case 1:
                  return [
                    4,
                    ng().then(function (e) {
                      return e;
                    }),
                  ];
                case 2:
                  return (e = r.sent()).ClientInvoiceDetails
                    ? ((n = {
                        payload: e.ClientInvoiceDetails,
                        type: j.DRAFT_ORDER_DATA,
                      }),
                      [2, t(n)])
                    : [2, []];
                case 3:
                  return [2];
              }
            });
          });
        };
      }
      var Dg = function (e) {
        return function (t) {
          return vg(void 0, void 0, void 0, function () {
            var n, r;
            return bg(this, function (o) {
              switch (o.label) {
                case 0:
                  return [4, eg(e)];
                case 1:
                  return o.sent().data &&
                    z.getState().salesRepData.baseData.SharedCartDetails
                    ? ((n =
                        z.getState().salesRepData.baseData
                          .SharedCartDetails).forEach(function (t, r) {
                        void 0 === r && (r = 0),
                          t.CartUniqueId === e.cartUniqueId && n.splice(r, 1);
                      }),
                      (r = {
                        payload: gg(
                          gg({}, z.getState().salesRepData.baseData),
                          { SharedCartDetails: n }
                        ),
                        type: j.BASE_DATA,
                      }),
                      [2, t(r)])
                    : [2, !1];
              }
            });
          });
        };
      };
      function jg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    tg(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Rg(e, t) {
        var n = this;
        return function (r) {
          return vg(n, void 0, void 0, function () {
            var n, o, a, i;
            return bg(this, function (s) {
              switch (s.label) {
                case 0:
                  return [
                    4,
                    rg(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (
                    (n = s.sent()) &&
                      (null ===
                        (a = Object.keys(null == n ? void 0 : n.draftOrder)) ||
                      void 0 === a
                        ? void 0
                        : a.length) > 0 &&
                      (null === (i = null == n ? void 0 : n.ProductDetails) ||
                      void 0 === i
                        ? void 0
                        : i.length) > 0 &&
                      ((o = {
                        payload: {
                          draftOrderObj: null == n ? void 0 : n.draftOrder,
                          productDetailsArray:
                            null == n ? void 0 : n.ProductDetails,
                          actionEvent: t,
                        },
                        type: j.EDIT_DRAFT_ORDER,
                      }),
                      r(o)),
                    [2, n]
                  );
              }
            });
          });
        };
      }
      function Ng(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    og(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Ag(e) {
        var t = this;
        return function (n) {
          return vg(t, void 0, void 0, function () {
            var t, r;
            return bg(this, function (o) {
              switch (o.label) {
                case 0:
                  return [
                    4,
                    ag(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return o.sent() && z.getState().salesRepData.draftOrderData
                    ? ((t = z.getState().salesRepData.draftOrderData).forEach(
                        function (n, r) {
                          e === n.orderid && t.splice(r, 1);
                        }
                      ),
                      (r = { payload: t, type: j.DRAFT_ORDER_DATA }),
                      [2, n(r)])
                    : [2];
              }
            });
          });
        };
      }
      function Lg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    ig(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function zg(e) {
        var t = this;
        return function (n) {
          return vg(t, void 0, void 0, function () {
            var t, r, o;
            return bg(this, function (a) {
              switch (a.label) {
                case 0:
                  return [
                    4,
                    sg(e)
                      .then(function (e) {
                        return e;
                      })
                      .catch(function (e) {
                        return e;
                      }),
                  ];
                case 1:
                  return a.sent()
                    ? (((t =
                        z.getState().salesRepData
                          .baseData).SingleSalesRep.SalesRepUniqueLink =
                        e.uniquelink),
                      (t.SingleSalesRep.Bio = e.bio),
                      (o = {
                        payload: t.SingleSalesRep,
                        type: j.UPDATE_SINGLE_SALES_REP,
                      }),
                      [2, n(o)])
                    : ((r = z.getState().salesRepData.baseData),
                      (o = {
                        payload: r.SingleSalesRep,
                        type: j.UPDATE_SINGLE_SALES_REP,
                      }),
                      [2, n(o)]);
              }
            });
          });
        };
      }
      function Bg(e) {
        var t = this;
        return function (n) {
          return vg(t, void 0, void 0, function () {
            var t, r, o, a, i, s;
            return bg(this, function (l) {
              switch (l.label) {
                case 0:
                  return [
                    4,
                    lg(e)
                      .then(function (e) {
                        return e;
                      })
                      .catch(function (e) {
                        return e;
                      }),
                  ];
                case 1:
                  return l.sent()
                    ? [
                        4,
                        Zf().then(function (e) {
                          return e;
                        }),
                      ]
                    : [3, 3];
                case 2:
                  return (
                    (t = l.sent()),
                    (r =
                      null === (a = null == t ? void 0 : t.SingleSalesRep) ||
                      void 0 === a
                        ? void 0
                        : a.ProfileImagePath)
                      ? ((o = { payload: r, type: j.UPDATE_REP_PROFILE }),
                        n(o),
                        [2, !0])
                      : [3, 4]
                  );
                case 3:
                  return (
                    (r =
                      null ===
                        (s =
                          null === (i = z.getState().salesRepData.baseData) ||
                          void 0 === i
                            ? void 0
                            : i.SingleSalesRep) || void 0 === s
                        ? void 0
                        : s.ProfileImagePath),
                    (o = { payload: r, type: j.UPDATE_REP_PROFILE }),
                    n(o),
                    [2, !1]
                  );
                case 4:
                  return [2];
              }
            });
          });
        };
      }
      function Zg() {
        var e = this;
        return function (t) {
          return vg(e, void 0, void 0, function () {
            var e, n;
            return bg(this, function (r) {
              switch (r.label) {
                case 0:
                  return [
                    4,
                    cg().then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (e = r.sent())
                    ? ((n = { payload: e, type: j.WHOLESALE_PRICE_DATA }),
                      [2, t(n)])
                    : [2];
              }
            });
          });
        };
      }
      function Fg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    ug(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Hg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    dg(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Vg(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    pg(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Wg(e, t) {
        var n = this;
        return function () {
          return vg(n, void 0, void 0, function () {
            var n, r, o, a;
            return bg(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, mg(e, t)];
                case 1:
                  return "boolean" == typeof (n = i.sent()) && !0 === n
                    ? [2, n]
                    : [
                        2,
                        null !==
                          (a =
                            null ===
                              (o =
                                null ===
                                  (r = null == n ? void 0 : n.response) ||
                                void 0 === r
                                  ? void 0
                                  : r.data) || void 0 === o
                              ? void 0
                              : o.description) && void 0 !== a
                          ? a
                          : null == n
                          ? void 0
                          : n.message,
                      ];
              }
            });
          });
        };
      }
      var $g = function (e) {
        return vg(void 0, void 0, void 0, function () {
          return bg(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  hg(e).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return [2, t.sent()];
            }
          });
        });
      };
      function Ug(e) {
        var t = this;
        return function () {
          return vg(t, void 0, void 0, function () {
            return bg(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, fg(e)];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      var Kg = o(539),
        Gg = o(4168);
      function qg(e, n, r, o, a) {
        const [i, s] = t.useState(() =>
          a && r ? r(e).matches : o ? o(e).matches : n
        );
        return (
          (0, xr.Z)(() => {
            let t = !0;
            if (!r) return;
            const n = r(e),
              o = () => {
                t && s(n.matches);
              };
            return (
              o(),
              n.addListener(o),
              () => {
                (t = !1), n.removeListener(o);
              }
            );
          }, [e, r]),
          i
        );
      }
      const Yg = n.useSyncExternalStore;
      function Jg(e, n, r, o, a) {
        const i = t.useCallback(() => n, [n]),
          s = t.useMemo(() => {
            if (a && r) return () => r(e).matches;
            if (null !== o) {
              const { matches: t } = o(e);
              return () => t;
            }
            return i;
          }, [i, e, o, a, r]),
          [l, c] = t.useMemo(() => {
            if (null === r) return [i, () => () => {}];
            const t = r(e);
            return [
              () => t.matches,
              (e) => (
                t.addListener(e),
                () => {
                  t.removeListener(e);
                }
              ),
            ];
          }, [i, r, e]);
        return Yg(c, l, s);
      }
      function Qg(e, t = {}) {
        const n = (0, Gg.Z)(),
          r = "undefined" != typeof window && void 0 !== window.matchMedia,
          {
            defaultMatches: o = !1,
            matchMedia: a = r ? window.matchMedia : null,
            ssrMatchMedia: i = null,
            noSsr: s = !1,
          } = (0, Kg.Z)({ name: "MuiUseMediaQuery", props: t, theme: n });
        let l = "function" == typeof e ? e(n) : e;
        return (
          (l = l.replace(/^@media( ?)/m, "")),
          (void 0 !== Yg ? Jg : qg)(l, o, a, i, s)
        );
      }
      var Xg = function () {
          return (
            (Xg =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Xg.apply(this, arguments)
          );
        },
        ev = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        tv = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        nv = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        },
        rv = { textTransform: "capitalize" },
        ov = "h6",
        av = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$",
        iv = function (e) {
          return ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
        },
        sv = function (e) {
          return (
            ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
          );
        },
        lv =
          "^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9]+[a-zA-Z0-9-]*[a-zA-Z0-9]+\\.)+[a-zA-Z]{2,}$",
        cv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z",
          }),
          "ContentCopy"
        ),
        uv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z",
          }),
          "Delete"
        ),
        dv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
          }),
          "Check"
        ),
        pv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z",
          }),
          "Cancel"
        ),
        mv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14",
          }),
          "Search"
        ),
        hv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8",
          }),
          "InfoOutlined"
        ),
        fv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2m-9.83-3.25.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25",
          }),
          "AddShoppingCart"
        ),
        gv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2M1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2",
          }),
          "ShoppingCart"
        ),
        vv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z",
          }),
          "Image"
        ),
        bv = (0, bo.Z)((0, e.jsx)("path", { d: "M19 13H5v-2h14z" }), "Remove"),
        _v = (0, bo.Z)(
          (0, e.jsx)("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" }),
          "Add"
        ),
        yv = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2m10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2m2-2c0-.55-.45-1-1-1H7l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.24-6.14c.25-.48.08-1.08-.4-1.34-.49-.27-1.1-.08-1.36.41L15.55 11H8.53L4.54 2.57c-.16-.35-.52-.57-.9-.57H2c-.55 0-1 .45-1 1s.45 1 1 1h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1M11.29 2.71c.39-.39 1.02-.39 1.41 0l2.59 2.59c.39.39.39 1.02 0 1.41L12.7 9.3c-.39.39-1.02.39-1.41 0a.9959.9959 0 0 1 0-1.41l.88-.89H9c-.55 0-1-.45-1-1s.45-1 1-1h3.17l-.88-.88a.9959.9959 0 0 1 0-1.41",
          }),
          "ShoppingCartCheckoutRounded"
        ),
        xv = function (e, t) {
          return (
            (xv =
              Object.setPrototypeOf ||
              ({ __proto__: [] } instanceof Array &&
                function (e, t) {
                  e.__proto__ = t;
                }) ||
              function (e, t) {
                for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
              }),
            xv(e, t)
          );
        },
        Cv = function () {
          return (
            (Cv =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Cv.apply(this, arguments)
          );
        },
        Sv = { Pixel: "Pixel", Percent: "Percent" },
        kv = { unit: Sv.Percent, value: 0.8 };
      function wv(e) {
        return "number" == typeof e
          ? { unit: Sv.Percent, value: 100 * e }
          : "string" == typeof e
          ? e.match(/^(\d*(\.\d+)?)px$/)
            ? { unit: Sv.Pixel, value: parseFloat(e) }
            : e.match(/^(\d*(\.\d+)?)%$/)
            ? { unit: Sv.Percent, value: parseFloat(e) }
            : (console.warn(
                'scrollThreshold format is invalid. Valid formats: "120px", "50%"...'
              ),
              kv)
          : (console.warn("scrollThreshold should be string or number"), kv);
      }
      var Pv = (function (e) {
          function n(t) {
            var n = e.call(this, t) || this;
            return (
              (n.lastScrollTop = 0),
              (n.actionTriggered = !1),
              (n.startY = 0),
              (n.currentY = 0),
              (n.dragging = !1),
              (n.maxPullDownDistance = 0),
              (n.getScrollableTarget = function () {
                return n.props.scrollableTarget instanceof HTMLElement
                  ? n.props.scrollableTarget
                  : "string" == typeof n.props.scrollableTarget
                  ? document.getElementById(n.props.scrollableTarget)
                  : (null === n.props.scrollableTarget &&
                      console.warn(
                        "You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      "
                      ),
                    null);
              }),
              (n.onStart = function (e) {
                n.lastScrollTop ||
                  ((n.dragging = !0),
                  e instanceof MouseEvent
                    ? (n.startY = e.pageY)
                    : e instanceof TouchEvent &&
                      (n.startY = e.touches[0].pageY),
                  (n.currentY = n.startY),
                  n._infScroll &&
                    ((n._infScroll.style.willChange = "transform"),
                    (n._infScroll.style.transition =
                      "transform 0.2s cubic-bezier(0,0,0.31,1)")));
              }),
              (n.onMove = function (e) {
                n.dragging &&
                  (e instanceof MouseEvent
                    ? (n.currentY = e.pageY)
                    : e instanceof TouchEvent &&
                      (n.currentY = e.touches[0].pageY),
                  n.currentY < n.startY ||
                    (n.currentY - n.startY >=
                      Number(n.props.pullDownToRefreshThreshold) &&
                      n.setState({ pullToRefreshThresholdBreached: !0 }),
                    n.currentY - n.startY > 1.5 * n.maxPullDownDistance ||
                      (n._infScroll &&
                        ((n._infScroll.style.overflow = "visible"),
                        (n._infScroll.style.transform =
                          "translate3d(0px, " +
                          (n.currentY - n.startY) +
                          "px, 0px)")))));
              }),
              (n.onEnd = function () {
                (n.startY = 0),
                  (n.currentY = 0),
                  (n.dragging = !1),
                  n.state.pullToRefreshThresholdBreached &&
                    (n.props.refreshFunction && n.props.refreshFunction(),
                    n.setState({ pullToRefreshThresholdBreached: !1 })),
                  requestAnimationFrame(function () {
                    n._infScroll &&
                      ((n._infScroll.style.overflow = "auto"),
                      (n._infScroll.style.transform = "none"),
                      (n._infScroll.style.willChange = "unset"));
                  });
              }),
              (n.onScrollListener = function (e) {
                "function" == typeof n.props.onScroll &&
                  setTimeout(function () {
                    return n.props.onScroll && n.props.onScroll(e);
                  }, 0);
                var t =
                  n.props.height || n._scrollableNode
                    ? e.target
                    : document.documentElement.scrollTop
                    ? document.documentElement
                    : document.body;
                n.actionTriggered ||
                  ((n.props.inverse
                    ? n.isElementAtTop(t, n.props.scrollThreshold)
                    : n.isElementAtBottom(t, n.props.scrollThreshold)) &&
                    n.props.hasMore &&
                    ((n.actionTriggered = !0),
                    n.setState({ showLoader: !0 }),
                    n.props.next && n.props.next()),
                  (n.lastScrollTop = t.scrollTop));
              }),
              (n.state = {
                showLoader: !1,
                pullToRefreshThresholdBreached: !1,
                prevDataLength: t.dataLength,
              }),
              (n.throttledOnScrollListener = (function (e, t, n, r) {
                var o,
                  a = !1,
                  i = 0;
                function s() {
                  o && clearTimeout(o);
                }
                function l() {
                  var l = this,
                    c = Date.now() - i,
                    u = arguments;
                  function d() {
                    (i = Date.now()), n.apply(l, u);
                  }
                  a ||
                    (r && !o && d(),
                    s(),
                    void 0 === r && c > e
                      ? d()
                      : !0 !== t &&
                        (o = setTimeout(
                          r
                            ? function () {
                                o = void 0;
                              }
                            : d,
                          void 0 === r ? e - c : e
                        )));
                }
                return (
                  "boolean" != typeof t && ((r = n), (n = t), (t = void 0)),
                  (l.cancel = function () {
                    s(), (a = !0);
                  }),
                  l
                );
              })(150, n.onScrollListener).bind(n)),
              (n.onStart = n.onStart.bind(n)),
              (n.onMove = n.onMove.bind(n)),
              (n.onEnd = n.onEnd.bind(n)),
              n
            );
          }
          return (
            (function (e, t) {
              function n() {
                this.constructor = e;
              }
              xv(e, t),
                (e.prototype =
                  null === t
                    ? Object.create(t)
                    : ((n.prototype = t.prototype), new n()));
            })(n, e),
            (n.prototype.componentDidMount = function () {
              if (void 0 === this.props.dataLength)
                throw new Error(
                  'mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage'
                );
              if (
                ((this._scrollableNode = this.getScrollableTarget()),
                (this.el = this.props.height
                  ? this._infScroll
                  : this._scrollableNode || window),
                this.el &&
                  this.el.addEventListener(
                    "scroll",
                    this.throttledOnScrollListener
                  ),
                "number" == typeof this.props.initialScrollY &&
                  this.el &&
                  this.el instanceof HTMLElement &&
                  this.el.scrollHeight > this.props.initialScrollY &&
                  this.el.scrollTo(0, this.props.initialScrollY),
                this.props.pullDownToRefresh &&
                  this.el &&
                  (this.el.addEventListener("touchstart", this.onStart),
                  this.el.addEventListener("touchmove", this.onMove),
                  this.el.addEventListener("touchend", this.onEnd),
                  this.el.addEventListener("mousedown", this.onStart),
                  this.el.addEventListener("mousemove", this.onMove),
                  this.el.addEventListener("mouseup", this.onEnd),
                  (this.maxPullDownDistance =
                    (this._pullDown &&
                      this._pullDown.firstChild &&
                      this._pullDown.firstChild.getBoundingClientRect()
                        .height) ||
                    0),
                  this.forceUpdate(),
                  "function" != typeof this.props.refreshFunction))
              )
                throw new Error(
                  'Mandatory prop "refreshFunction" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage\''
                );
            }),
            (n.prototype.componentWillUnmount = function () {
              this.el &&
                (this.el.removeEventListener(
                  "scroll",
                  this.throttledOnScrollListener
                ),
                this.props.pullDownToRefresh &&
                  (this.el.removeEventListener("touchstart", this.onStart),
                  this.el.removeEventListener("touchmove", this.onMove),
                  this.el.removeEventListener("touchend", this.onEnd),
                  this.el.removeEventListener("mousedown", this.onStart),
                  this.el.removeEventListener("mousemove", this.onMove),
                  this.el.removeEventListener("mouseup", this.onEnd)));
            }),
            (n.prototype.componentDidUpdate = function (e) {
              this.props.dataLength !== e.dataLength &&
                ((this.actionTriggered = !1),
                this.setState({ showLoader: !1 }));
            }),
            (n.getDerivedStateFromProps = function (e, t) {
              return e.dataLength !== t.prevDataLength
                ? Cv(Cv({}, t), { prevDataLength: e.dataLength })
                : null;
            }),
            (n.prototype.isElementAtTop = function (e, t) {
              void 0 === t && (t = 0.8);
              var n =
                  e === document.body || e === document.documentElement
                    ? window.screen.availHeight
                    : e.clientHeight,
                r = wv(t);
              return r.unit === Sv.Pixel
                ? e.scrollTop <= r.value + n - e.scrollHeight + 1
                : e.scrollTop <= r.value / 100 + n - e.scrollHeight + 1;
            }),
            (n.prototype.isElementAtBottom = function (e, t) {
              void 0 === t && (t = 0.8);
              var n =
                  e === document.body || e === document.documentElement
                    ? window.screen.availHeight
                    : e.clientHeight,
                r = wv(t);
              return r.unit === Sv.Pixel
                ? e.scrollTop + n >= e.scrollHeight - r.value
                : e.scrollTop + n >= (r.value / 100) * e.scrollHeight;
            }),
            (n.prototype.render = function () {
              var e = this,
                n = Cv(
                  {
                    height: this.props.height || "auto",
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                  },
                  this.props.style
                ),
                r =
                  this.props.hasChildren ||
                  !!(
                    this.props.children &&
                    this.props.children instanceof Array &&
                    this.props.children.length
                  ),
                o =
                  this.props.pullDownToRefresh && this.props.height
                    ? { overflow: "auto" }
                    : {};
              return t.createElement(
                "div",
                { style: o, className: "infinite-scroll-component__outerdiv" },
                t.createElement(
                  "div",
                  {
                    className:
                      "infinite-scroll-component " +
                      (this.props.className || ""),
                    ref: function (t) {
                      return (e._infScroll = t);
                    },
                    style: n,
                  },
                  this.props.pullDownToRefresh &&
                    t.createElement(
                      "div",
                      {
                        style: { position: "relative" },
                        ref: function (t) {
                          return (e._pullDown = t);
                        },
                      },
                      t.createElement(
                        "div",
                        {
                          style: {
                            position: "absolute",
                            left: 0,
                            right: 0,
                            top: -1 * this.maxPullDownDistance,
                          },
                        },
                        this.state.pullToRefreshThresholdBreached
                          ? this.props.releaseToRefreshContent
                          : this.props.pullDownToRefreshContent
                      )
                    ),
                  this.props.children,
                  !this.state.showLoader &&
                    !r &&
                    this.props.hasMore &&
                    this.props.loader,
                  this.state.showLoader &&
                    this.props.hasMore &&
                    this.props.loader,
                  !this.props.hasMore && this.props.endMessage
                )
              );
            }),
            n
          );
        })(t.Component),
        Ov = Pv;
      function Iv(e) {
        return (0, Zt.ZP)("MuiDialog", e);
      }
      var Tv = (0, Bt.Z)("MuiDialog", [
          "root",
          "scrollPaper",
          "scrollBody",
          "container",
          "paper",
          "paperScrollPaper",
          "paperScrollBody",
          "paperWidthFalse",
          "paperWidthXs",
          "paperWidthSm",
          "paperWidthMd",
          "paperWidthLg",
          "paperWidthXl",
          "paperFullWidth",
          "paperFullScreen",
        ]),
        Mv = t.createContext({});
      const Ev = [
          "aria-describedby",
          "aria-labelledby",
          "BackdropComponent",
          "BackdropProps",
          "children",
          "className",
          "disableEscapeKeyDown",
          "fullScreen",
          "fullWidth",
          "maxWidth",
          "onBackdropClick",
          "onClose",
          "open",
          "PaperComponent",
          "PaperProps",
          "scroll",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ],
        Dv = (0, Lt.ZP)(Vr, {
          name: "MuiDialog",
          slot: "Backdrop",
          overrides: (e, t) => t.backdrop,
        })({ zIndex: -1 }),
        jv = (0, Lt.ZP)(qr, {
          name: "MuiDialog",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ "@media print": { position: "absolute !important" } }),
        Rv = (0, Lt.ZP)("div", {
          name: "MuiDialog",
          slot: "Container",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.container, t[`scroll${(0, Fn.Z)(n.scroll)}`]];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { height: "100%", "@media print": { height: "auto" }, outline: 0 },
            "paper" === e.scroll && {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            "body" === e.scroll && {
              overflowY: "auto",
              overflowX: "hidden",
              textAlign: "center",
              "&::after": {
                content: '""',
                display: "inline-block",
                verticalAlign: "middle",
                height: "100%",
                width: "0",
              },
            }
          )
        ),
        Nv = (0, Lt.ZP)(io, {
          name: "MuiDialog",
          slot: "Paper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.paper,
              t[`scrollPaper${(0, Fn.Z)(n.scroll)}`],
              t[`paperWidth${(0, Fn.Z)(String(n.maxWidth))}`],
              n.fullWidth && t.paperFullWidth,
              n.fullScreen && t.paperFullScreen,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              margin: 32,
              position: "relative",
              overflowY: "auto",
              "@media print": { overflowY: "visible", boxShadow: "none" },
            },
            "paper" === t.scroll && {
              display: "flex",
              flexDirection: "column",
              maxHeight: "calc(100% - 64px)",
            },
            "body" === t.scroll && {
              display: "inline-block",
              verticalAlign: "middle",
              textAlign: "left",
            },
            !t.maxWidth && { maxWidth: "calc(100% - 64px)" },
            "xs" === t.maxWidth && {
              maxWidth:
                "px" === e.breakpoints.unit
                  ? Math.max(e.breakpoints.values.xs, 444)
                  : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
              [`&.${Tv.paperScrollBody}`]: {
                [e.breakpoints.down(
                  Math.max(e.breakpoints.values.xs, 444) + 64
                )]: { maxWidth: "calc(100% - 64px)" },
              },
            },
            t.maxWidth &&
              "xs" !== t.maxWidth && {
                maxWidth: `${e.breakpoints.values[t.maxWidth]}${
                  e.breakpoints.unit
                }`,
                [`&.${Tv.paperScrollBody}`]: {
                  [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 64)]: {
                    maxWidth: "calc(100% - 64px)",
                  },
                },
              },
            t.fullWidth && { width: "calc(100% - 64px)" },
            t.fullScreen && {
              margin: 0,
              width: "100%",
              maxWidth: "100%",
              height: "100%",
              maxHeight: "none",
              borderRadius: 0,
              [`&.${Tv.paperScrollBody}`]: { margin: 0, maxWidth: "100%" },
            }
          )
        );
      var Av = t.forwardRef(function (n, r) {
        const o = (0, zt.Z)({ props: n, name: "MuiDialog" }),
          a = jr(),
          i = {
            enter: a.transitions.duration.enteringScreen,
            exit: a.transitions.duration.leavingScreen,
          },
          {
            "aria-describedby": s,
            "aria-labelledby": l,
            BackdropComponent: c,
            BackdropProps: u,
            children: p,
            className: m,
            disableEscapeKeyDown: h = !1,
            fullScreen: f = !1,
            fullWidth: g = !1,
            maxWidth: v = "sm",
            onBackdropClick: b,
            onClose: _,
            open: y,
            PaperComponent: x = io,
            PaperProps: C = {},
            scroll: S = "paper",
            TransitionComponent: k = Br,
            transitionDuration: w = i,
            TransitionProps: P,
          } = o,
          O = (0, jt.Z)(o, Ev),
          I = (0, d.Z)({}, o, {
            disableEscapeKeyDown: h,
            fullScreen: f,
            fullWidth: g,
            maxWidth: v,
            scroll: S,
          }),
          T = ((e) => {
            const {
                classes: t,
                scroll: n,
                maxWidth: r,
                fullWidth: o,
                fullScreen: a,
              } = e,
              i = {
                root: ["root"],
                container: ["container", `scroll${(0, Fn.Z)(n)}`],
                paper: [
                  "paper",
                  `paperScroll${(0, Fn.Z)(n)}`,
                  `paperWidth${(0, Fn.Z)(String(r))}`,
                  o && "paperFullWidth",
                  a && "paperFullScreen",
                ],
              };
            return (0, Nt.Z)(i, Iv, t);
          })(I),
          M = t.useRef(),
          E = (0, Fl.Z)(l),
          D = t.useMemo(() => ({ titleId: E }), [E]);
        return (0, e.jsx)(
          jv,
          (0, d.Z)(
            {
              className: (0, Rt.Z)(T.root, m),
              closeAfterTransition: !0,
              components: { Backdrop: Dv },
              componentsProps: {
                backdrop: (0, d.Z)({ transitionDuration: w, as: c }, u),
              },
              disableEscapeKeyDown: h,
              onClose: _,
              open: y,
              ref: r,
              onClick: (e) => {
                M.current &&
                  ((M.current = null), b && b(e), _ && _(e, "backdropClick"));
              },
              ownerState: I,
            },
            O,
            {
              children: (0, e.jsx)(
                k,
                (0, d.Z)(
                  { appear: !0, in: y, timeout: w, role: "presentation" },
                  P,
                  {
                    children: (0, e.jsx)(Rv, {
                      className: (0, Rt.Z)(T.container),
                      onMouseDown: (e) => {
                        M.current = e.target === e.currentTarget;
                      },
                      ownerState: I,
                      children: (0, e.jsx)(
                        Nv,
                        (0, d.Z)(
                          {
                            as: x,
                            elevation: 24,
                            role: "dialog",
                            "aria-describedby": s,
                            "aria-labelledby": E,
                          },
                          C,
                          {
                            className: (0, Rt.Z)(T.paper, C.className),
                            ownerState: I,
                            children: (0, e.jsx)(Mv.Provider, {
                              value: D,
                              children: p,
                            }),
                          }
                        )
                      ),
                    }),
                  }
                )
              ),
            }
          )
        );
      });
      function Lv(e) {
        return (0, Zt.ZP)("MuiDialogContent", e);
      }
      (0, Bt.Z)("MuiDialogContent", ["root", "dividers"]);
      var zv = (0, Bt.Z)("MuiDialogTitle", ["root"]);
      const Bv = ["className", "dividers"],
        Zv = (0, Lt.ZP)("div", {
          name: "MuiDialogContent",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.dividers && t.dividers];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              flex: "1 1 auto",
              WebkitOverflowScrolling: "touch",
              overflowY: "auto",
              padding: "20px 24px",
            },
            t.dividers
              ? {
                  padding: "16px 24px",
                  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
                  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
                }
              : { [`.${zv.root} + &`]: { paddingTop: 0 } }
          )
        );
      var Fv = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiDialogContent" }),
            { className: o, dividers: a = !1 } = r,
            i = (0, jt.Z)(r, Bv),
            s = (0, d.Z)({}, r, { dividers: a }),
            l = ((e) => {
              const { classes: t, dividers: n } = e,
                r = { root: ["root", n && "dividers"] };
              return (0, Nt.Z)(r, Lv, t);
            })(s);
          return (0,
          e.jsx)(Zv, (0, d.Z)({ className: (0, Rt.Z)(l.root, o), ownerState: s, ref: n }, i));
        }),
        Hv = "editOrder",
        Vv = "shopify",
        Wv = "deny",
        $v = function () {
          return (
            ($v =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            $v.apply(this, arguments)
          );
        },
        Uv = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Kv = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function Gv() {
        var n = this,
          r = (0, t.useState)({}),
          o = r[0],
          a = r[1],
          i = (0, t.useState)(!1),
          s = i[0],
          l = i[1],
          c = (0, t.useState)(!0),
          u = c[0],
          d = c[1],
          p = X().t,
          m = (0, e.jsx)(
            Av,
            $v(
              {
                open: s,
                onClose: function () {
                  return l(!1);
                },
                maxWidth: "sm",
                fullWidth: !0,
              },
              {
                children: (0, e.jsxs)(
                  ln,
                  $v(
                    { className: "ST_DB_Dialog_Box" },
                    {
                      children: [
                        (0, e.jsxs)(
                          La,
                          $v(
                            { container: !0, spacing: 2, mb: 2, pl: 2 },
                            {
                              children: [
                                (0, e.jsx)(
                                  La,
                                  $v(
                                    { item: !0, xs: 10, md: 10 },
                                    {
                                      children: (0, e.jsx)(
                                        Wa,
                                        $v(
                                          { variant: "h6" },
                                          {
                                            children: (0, e.jsx)("b", {
                                              children: p("productStatus"),
                                            }),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  $v(
                                    {
                                      item: !0,
                                      xs: 2,
                                      md: 2,
                                      sx: { textAlign: "right" },
                                      pr: 1,
                                    },
                                    {
                                      children: (0, e.jsx)(pv, {
                                        sx: { cursor: "pointer" },
                                        onClick: function () {
                                          l(!1);
                                        },
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)("hr", { className: "ST_DB_Hr" }),
                        u &&
                          (0, e.jsx)(
                            "p",
                            $v(
                              { style: { textAlign: "center" } },
                              { children: p("loading") }
                            )
                          ),
                        (0, e.jsx)(
                          Fv,
                          $v(
                            { sx: { padding: "0px" } },
                            {
                              children: (0, e.jsx)("img", {
                                style: { width: "100%", height: "100%" },
                                src: "https://salesrepapp.azurewebsites.net/assets/img/productTableGuide.png",
                                onLoad: function () {
                                  d(!1);
                                },
                                onError: function () {
                                  d(!1);
                                },
                              }),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          "div",
                          $v(
                            {
                              style: { textAlign: "center", marginTop: "1rem" },
                            },
                            {
                              children: (0, e.jsxs)(
                                Wa,
                                $v(
                                  { variant: "h6" },
                                  {
                                    children: [
                                      p("makeSureInShopify"),
                                      " ",
                                      (0, e.jsx)("b", {
                                        children: p("products"),
                                      }),
                                      " ",
                                      p("sectionTheProductStatusIs"),
                                      " ",
                                      (0, e.jsx)("b", {
                                        children: p("active"),
                                      }),
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
              }
            )
          ),
          h = function (e) {
            var t,
              n,
              r =
                null !==
                  (n =
                    null !== (t = null == e ? void 0 : e.inventory_quantity) &&
                    void 0 !== t
                      ? t
                      : null == e
                      ? void 0
                      : e.inventoryQuantity) && void 0 !== n
                  ? n
                  : 0;
            return (
              (null == e ? void 0 : e.inventory_management) === Vv &&
              (null == e ? void 0 : e.inventory_policy) === Wv &&
              r <= 0
            );
          };
        return {
          copyTextFunction: function (e, t) {
            return Uv(n, void 0, void 0, function () {
              var n, r;
              return Kv(this, function (i) {
                switch (i.label) {
                  case 0:
                    if (!(n = e)) return [3, 4];
                    i.label = 1;
                  case 1:
                    return (
                      i.trys.push([1, 3, , 4]),
                      [4, navigator.clipboard.writeText(n)]
                    );
                  case 2:
                    return (
                      i.sent(),
                      a($v($v({}, o), (((r = {})[t] = "#05bf05"), r))),
                      setTimeout(function () {
                        var e;
                        a(
                          $v(
                            $v({}, o),
                            (((e = {})[t] = "rgba(0, 0, 0, 0.87)"), e)
                          )
                        );
                      }, 2e3),
                      [3, 4]
                    );
                  case 3:
                    return i.sent(), [2];
                  case 4:
                    return [2];
                }
              });
            });
          },
          copyIconSuccessColor: o,
          getProductTableRenderPopup: m,
          handleProductTableGuidePopup: function () {
            l(!s);
          },
          checkVariantIsSoldOut: h,
          checkAllVariantsSoldOutInProduct: function (e) {
            var t, n;
            return (
              !(
                (null === (t = null == e ? void 0 : e.variants) || void 0 === t
                  ? void 0
                  : t.length) > 0
              ) ||
              (null === (n = null == e ? void 0 : e.variants) || void 0 === n
                ? void 0
                : n.every(function (e) {
                    return h(e);
                  }))
            );
          },
          filterVariantsWithOutSoldOut: function (e) {
            var t,
              n,
              r = $v({}, e);
            return (
              (null === (t = null == e ? void 0 : e.variants) || void 0 === t
                ? void 0
                : t.length) > 0 &&
                (r.variants =
                  null === (n = null == r ? void 0 : r.variants) || void 0 === n
                    ? void 0
                    : n.filter(function (e) {
                        return !h(e);
                      })),
              r
            );
          },
          showInventoryQuantity: function (t) {
            return h(t)
              ? (0, e.jsx)(wp, {
                  className: "ST_SoldOut",
                  badgeContent: p("soldOut"),
                  color: "warning",
                })
              : (null == t ? void 0 : t.inventory_management) !== Vv
              ? p("InventoryNotTracked")
              : (null == t ? void 0 : t.inventory_quantity) || 0;
          },
          showCustomCountries: function () {
            return [
              { name: "Canada", code: "ca", dial_code: "+1" },
              { name: "United States of America", code: "us", dial_code: "+1" },
            ];
          },
        };
      }
      var qv = function () {
        return (
          (qv =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          qv.apply(this, arguments)
        );
      };
      function Yv() {
        var n,
          r = Gv(),
          o = r.getProductTableRenderPopup,
          a = r.handleProductTableGuidePopup,
          i = r.copyTextFunction,
          s = r.copyIconSuccessColor,
          l = r.checkVariantIsSoldOut,
          c = r.checkAllVariantsSoldOutInProduct,
          u = r.filterVariantsWithOutSoldOut,
          d = r.showInventoryQuantity,
          p = (function () {
            var e = this,
              n = X().t,
              r = g(),
              o = y(function (e) {
                return e.salesRepData ? e.salesRepData : {};
              }),
              a = Ef().shopCurrency,
              i = 10,
              s = (0, t.useState)(
                o.baseData.SharedCartDetails ? o.baseData.SharedCartDetails : []
              ),
              l = s[0],
              c = s[1],
              u = (0, t.useState)({}),
              d = u[0],
              p = u[1],
              m = (0, t.useState)(""),
              h = m[0],
              f = m[1],
              v = (0, t.useState)(
                o.productsData ? o.productsData.slice(0, i) : []
              ),
              b = v[0],
              _ = v[1],
              x = (0, t.useState)(""),
              C = x[0],
              S = x[1],
              k = (0, t.useState)({}),
              w = k[0],
              P = k[1],
              O = (0, t.useState)(!1),
              I = O[0],
              T = O[1],
              M = (0, t.useState)({}),
              E = M[0],
              D = M[1],
              j = (0, t.useState)([]),
              R = j[0],
              N = j[1],
              A = (0, t.useState)({ msg: "", color: "blue" }),
              L = A[0],
              B = A[1],
              Z = (0, t.useState)(!1),
              F = Z[0],
              H = Z[1],
              V = (0, t.useState)({}),
              W = V[0],
              $ = (V[1], (0, t.useState)(null)),
              U = $[0],
              K = $[1],
              G =
                L.msg === n("cartSharing_CartCreating_Msg") ||
                !("" !== h.trim() && R.length > 0),
              q = (0, t.useState)(!1),
              Y = q[0],
              J = q[1],
              Q = (0, t.useState)([]),
              ee = Q[0],
              te = Q[1],
              ne = (0, t.useState)(),
              re = ne[0],
              oe = ne[1],
              ae = (0, t.useState)({}),
              ie = ae[0],
              se = (ae[1], (0, t.useState)({ msg: "", open: !1 })),
              le = se[0],
              ce = se[1],
              ue = Qg("(max-width: 600px)");
            (0, t.useEffect)(function () {
              var e;
              0 ===
                (null === (e = null == o ? void 0 : o.productsData) ||
                void 0 === e
                  ? void 0
                  : e.length) && mf.next(!0),
                setTimeout(function () {
                  mf.next(!1);
                }, 5e3);
            }, []),
              (0, t.useEffect)(
                function () {
                  var e;
                  (null === (e = null == o ? void 0 : o.productsData) ||
                  void 0 === e
                    ? void 0
                    : e.length) > 0 &&
                    (mf.next(!1), _(o.productsData.slice(0, i)), pe());
                },
                [o.productsData]
              );
            var de = function (e) {
                return null != e;
              },
              pe = function () {
                var e = Y
                  ? ee.slice(0, b.length + i)
                  : I
                  ? R.slice(0, b.length + i)
                  : o.productsData.slice(0, b.length + i);
                _(e);
              };
            return {
              t: n,
              shopCurrency: a,
              shareCartData: l,
              deleteSharedCartLink: function () {
                return ev(e, void 0, void 0, function () {
                  var e, t, n, o, a, i, s, l, c;
                  return tv(this, function (u) {
                    switch (u.label) {
                      case 0:
                        return (
                          (e = null == re ? void 0 : re.delete_Cart_Link_Id),
                          (t = null == re ? void 0 : re.delete_Cart_Id),
                          e && t
                            ? ((n = jf()),
                              (o = n.CustomerId),
                              (a = n.SalesRepName),
                              (i = a),
                              (s = o),
                              (l = Xg({}, d)),
                              (c = {
                                salesRepName: i,
                                SalesrepId: s,
                                cartUniqueId: e,
                              }),
                              (l[t] = !0),
                              p(Xg({}, l)),
                              [4, r(Dg(c))])
                            : [3, 2]
                        );
                      case 1:
                        return (
                          u.sent()
                            ? (delete d[t], K(null))
                            : ((l[t] = !1), p(Xg({}, l))),
                          [3, 3]
                        );
                      case 2:
                        H(!0), (u.label = 3);
                      case 3:
                        return [2];
                    }
                  });
                });
              },
              deleteLink: d,
              cartName: h,
              setCartName: f,
              products: b,
              SearchProduct: function (e) {
                if (o.productsData.length > 0) {
                  var t = o.productsData.filter(function (t) {
                    var n =
                        !!(null == t ? void 0 : t.productTitle) &&
                        t.productTitle
                          .toLowerCase()
                          .includes(e.trim().toLowerCase()),
                      r = t.variants.some(function (t) {
                        return t.variantTitle
                          .toLowerCase()
                          .includes(e.trim().toLowerCase());
                      }),
                      o = t.variants.some(function (t) {
                        return (t.sku || "")
                          .toLowerCase()
                          .includes((e.trim() || "").toLowerCase());
                      }),
                      a = t.variants.some(function (t) {
                        return Number(t.variantPrice) === Number(e.trim());
                      });
                    return !!(n || r || o || a);
                  });
                  te(t), J(!!ee), _(t.slice(0, i));
                }
              },
              renderImageSrc: function (e, t) {
                var n = t[0].src;
                return (
                  e &&
                    0 !== t.length &&
                    t.forEach(function (t) {
                      if (t.imageId === e) return (n = t.src ? t.src : "image");
                    }),
                  n
                );
              },
              searchProductInput: C,
              setSearchProductInput: S,
              product_idObject: w,
              backToShopBtn: I,
              handleBackToShopBtn: function () {
                return (
                  _(o.productsData ? o.productsData.slice(0, i) : []),
                  T(!1),
                  "" !== C ? S("") : null
                );
              },
              handleSelectedBtn: function () {
                T(!0), J(!1), _(R.slice(0, i));
              },
              variant_idObject: E,
              createSharedCart: function () {
                return ev(e, void 0, void 0, function () {
                  var e, t, o, a, i, s, l, u, d;
                  return tv(this, function (p) {
                    switch (p.label) {
                      case 0:
                        return (
                          (e = jf()),
                          (t = e.CustomerId),
                          (o = e.SalesRepName),
                          (a = o),
                          (i = t),
                          "" !== h.trim() && R.length > 0
                            ? ((s = []),
                              R.forEach(function (e) {
                                e.variants.forEach(function (t) {
                                  s = nv(
                                    nv([], s, !0),
                                    [
                                      {
                                        id: t.variantId,
                                        quantity: E[t.variantId],
                                        handle: e.handle,
                                      },
                                    ],
                                    !1
                                  );
                                });
                              }),
                              (l = {
                                salesRepName: a,
                                SalesrepId: i,
                                cartName: h,
                                cartdata: JSON.stringify(s),
                              }),
                              (u = JSON.stringify(l)),
                              B({
                                msg: n("cartSharing_CartCreating_Msg"),
                                color: "blue",
                              }),
                              [4, r(jg(u))])
                            : [3, 4]
                        );
                      case 1:
                        return !0 === (d = p.sent()).data && de(d.data)
                          ? (B({
                              msg: n("cartSharing_CartCreatedSuccessfully_Msg"),
                              color: "green",
                            }),
                            N([]),
                            D({}),
                            P({}),
                            f(""),
                            setTimeout(function () {
                              B({ msg: "", color: "" });
                            }, 2e3),
                            [4, r(_g())])
                          : [3, 3];
                      case 2:
                        return (
                          p.sent(),
                          c(
                            z.getState().salesRepData.baseData.SharedCartDetails
                          ),
                          [3, 4]
                        );
                      case 3:
                        B({
                          msg: n("cartSharing_CartCreateError_Msg"),
                          color: "red",
                        }),
                          setTimeout(function () {
                            B({ msg: "", color: "" });
                          }, 3e3),
                          (p.label = 4);
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              createdCartMsg: L,
              handleQuantity_IncrementDecrement: function (e, t) {
                if (e && t) {
                  var n = Xg({}, E);
                  (n[e] =
                    "add" === t ? parseInt(E[e]) + 1 : Math.max(E[e] - 1, 1)),
                    D(Xg({}, n));
                } else H(!0);
              },
              checkUncheck: function (e, t, n, r) {
                if (0 !== Object.keys(n).length && n.variants.length > 0) {
                  var o = e.target.checked,
                    a = Xg({}, w),
                    i = Xg({}, E),
                    s = n ? JSON.parse(JSON.stringify(n)) : {},
                    l = r ? JSON.parse(JSON.stringify(r)) : {};
                  if ("isProduct" === t)
                    if (o)
                      de(w[n.productId])
                        ? R.forEach(function (e) {
                            e.productId === n.productId &&
                              ((e.variants = s.variants),
                              N(nv([], R, !0)),
                              s.variants.forEach(function (e) {
                                (i[e.variantId] = 1), D(Xg({}, i));
                              }));
                          })
                        : (N(nv(nv([], R, !0), [s], !1)),
                          (a[n.productId] = n.productId),
                          P(Xg({}, a)),
                          s.variants.forEach(function (e) {
                            (i[e.variantId] = 1), D(Xg({}, i));
                          }));
                    else {
                      var c = R.filter(function (e) {
                        return e.productId !== n.productId;
                      });
                      N(nv([], c, !0)),
                        delete w[n.productId],
                        s.variants.forEach(function (e) {
                          delete E[e.variantId];
                        });
                    }
                  else if (o)
                    if (de(w[n.productId]))
                      R.forEach(function (e) {
                        if (e.productId === n.productId)
                          return (
                            (e.variants = nv(
                              nv([], e.variants, !0),
                              [Xg(Xg({}, l), { quantity: 1 })],
                              !1
                            )),
                            N(nv([], R, !0)),
                            (i[r.variantId] = 1),
                            D(Xg({}, i)),
                            e
                          );
                      });
                    else {
                      var u = Xg(Xg({}, s), { variants: [l] });
                      N(nv(nv([], R, !0), [u], !1)),
                        (a[n.productId] = n.productId),
                        P(Xg({}, a)),
                        (i[r.variantId] = 1),
                        D(Xg({}, i));
                    }
                  else {
                    var d;
                    R.forEach(function (e) {
                      return e.variants.forEach(function (t, n) {
                        if (t.variantId === r.variantId)
                          return e.variants.splice(n, 1);
                      });
                    }),
                      (d = R.filter(function (e) {
                        if (e.variants.length >= 1)
                          return e.variants.length >= 1;
                        0 === e.variants.length && delete w[e.productId];
                      })),
                      N(nv([], d, !0)),
                      delete E[r.variantId];
                  }
                } else H(!0);
              },
              NewselectedArray: R,
              handleAlertMsgClose: function (e, t) {
                "clickaway" !== t && (H(!1), ce({ msg: "", open: !1 }));
              },
              alertMsgOpen: F,
              copyLinkObject: W,
              deleteConfirmation: U,
              openDeleteConfirmation: function (e, t, n) {
                K(e.currentTarget),
                  oe({
                    delete_Cart_Link_Id: null == t ? void 0 : t.CartUniqueId,
                    delete_index: n,
                    delete_Cart_Id: null == t ? void 0 : t.Id,
                  });
              },
              setDeleteConfirmation: K,
              CreateCartBtnDisabled: G,
              isNotEmpty: de,
              lazyLoadCartData: pe,
              deleteShareCartDataObject: re,
              handleProductQuantity: function (e, t) {
                var r;
                if (t) {
                  var o = e.target,
                    a = (o.name, o.value);
                  "" === a &&
                    ce({ msg: n("productTable_error_AlertMsg2"), open: !0 }),
                    (function (e, t) {
                      return (
                        parseInt(t) <= 0 &&
                        (ce({
                          msg: n("productTable_error_AlertMsg"),
                          open: !0,
                        }),
                        !0)
                      );
                    })(0, a) ||
                      D(Xg(Xg({}, E), (((r = {})[t] = "0" == a ? "" : a), r)));
                } else H(!0);
              },
              isError: ie,
              isMobile: ue,
              alertErrorMsg: le,
            };
          })(),
          m = p.t,
          h = p.shopCurrency,
          f = p.shareCartData,
          v = p.deleteSharedCartLink,
          b = p.deleteLink,
          _ = p.cartName,
          x = p.setCartName,
          C = p.products,
          S = p.SearchProduct,
          k = p.renderImageSrc,
          w = p.searchProductInput,
          P = p.setSearchProductInput,
          O = p.product_idObject,
          I = p.backToShopBtn,
          T = p.handleBackToShopBtn,
          M = p.handleSelectedBtn,
          E = p.variant_idObject,
          D = p.createSharedCart,
          j = p.createdCartMsg,
          R = p.handleQuantity_IncrementDecrement,
          N = p.checkUncheck,
          A = p.NewselectedArray,
          L = p.handleAlertMsgClose,
          B = p.alertMsgOpen,
          Z = (p.copyLinkObject, p.deleteConfirmation),
          F = p.openDeleteConfirmation,
          H = p.setDeleteConfirmation,
          V = p.CreateCartBtnDisabled,
          W = p.isNotEmpty,
          $ = p.lazyLoadCartData,
          U = p.deleteShareCartDataObject,
          K = p.handleProductQuantity,
          G = p.isError,
          q = p.isMobile,
          Y = p.alertErrorMsg,
          J = { maxHeight: 340, border: "1px solid #bfbfbf" },
          Q = { pt: 0.5, pb: 0.5 },
          ee = { maxWidth: 300, minWidth: 264, mt: 2 },
          te = {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            mb: 3,
            mt: 3,
          },
          ne = { mr: 1, mt: 2, whiteSpace: "nowrap" },
          re = { mt: 2 };
        return (
          (0, t.useEffect)(
            function () {
              if (!0 === I) return M();
            },
            [E, A]
          ),
          (0, e.jsxs)(
            ln,
            qv(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    La,
                    qv(
                      { sx: qv(qv({}, Lo), { marginBottom: "2.5rem" }) },
                      {
                        children: [
                          (0, e.jsx)(
                            Wa,
                            qv(
                              { variant: ov, sx: zo },
                              { children: m("cartSharing_title") }
                            )
                          ),
                          (0, e.jsx)("hr", {
                            className: "ST_CI_Horizontal_Line",
                          }),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Ga,
                    qv(
                      { sx: J },
                      {
                        children: (0, e.jsxs)(
                          ei,
                          qv(
                            {
                              stickyHeader: !0,
                              sx: { minWidth: 650 },
                              "aria-label": "simple table",
                            },
                            {
                              children: [
                                (0, e.jsx)(si, {
                                  children: (0, e.jsxs)(
                                    hi,
                                    qv(
                                      { className: "stickyHeaderRow" },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            yi,
                                            qv(
                                              { sx: qv({ width: "20%" }, Zo) },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  qv(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        m(
                                                          "cartSharing_SharedCartLinkTableColumnCartName"
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            yi,
                                            qv(
                                              { align: "center", sx: Zo },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  qv(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        m(
                                                          "cartSharing_SharedCartLinkTableColumnCartLink"
                                                        ),
                                                        " ",
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            yi,
                                            qv(
                                              { align: "center", sx: Zo },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  qv(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        m(
                                                          "cartSharing_SharedCartLinkTableColumnCopyCartLink"
                                                        ),
                                                        " ",
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            yi,
                                            qv(
                                              { align: "center", sx: Zo },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  qv(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        m(
                                                          "cartSharing_SharedCartLinkTableColumnDeleteCartLink"
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                }),
                                (0, e.jsx)(Pi, {
                                  children:
                                    0 !== f.length
                                      ? (0, e.jsx)(e.Fragment, {
                                          children: f.map(function (t, n) {
                                            return (0, e.jsxs)(
                                              hi,
                                              {
                                                children: [
                                                  (0, e.jsxs)(
                                                    yi,
                                                    qv(
                                                      {
                                                        sx: {
                                                          width: "20%",
                                                          wordBreak:
                                                            "break-all",
                                                        },
                                                      },
                                                      {
                                                        children: [
                                                          " ",
                                                          (null == t
                                                            ? void 0
                                                            : t.CartName) ||
                                                            "-",
                                                          " ",
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    yi,
                                                    qv(
                                                      { align: "center" },
                                                      {
                                                        children: (0, e.jsx)(
                                                          _l,
                                                          qv(
                                                            {
                                                              title:
                                                                (null == t
                                                                  ? void 0
                                                                  : t.CartUrl) ||
                                                                "-",
                                                              arrow: !0,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(
                                                                Il,
                                                                qv(
                                                                  {
                                                                    href:
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.CartUrl) ||
                                                                      "-",
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                  {
                                                                    children: m(
                                                                      "showSharedCartProductcolumn1"
                                                                    ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    yi,
                                                    qv(
                                                      { align: "center" },
                                                      {
                                                        children: (0, e.jsx)(
                                                          _l,
                                                          qv(
                                                            {
                                                              title:
                                                                "#05bf05" ===
                                                                s[
                                                                  ""
                                                                    .concat(
                                                                      "shareCartLink",
                                                                      " "
                                                                    )
                                                                    .concat(n)
                                                                ]
                                                                  ? m(
                                                                      "cartSharing_CopyCartLink_Msg"
                                                                    )
                                                                  : m(
                                                                      "click_to_copy"
                                                                    ),
                                                              arrow: !0,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(
                                                                Kn,
                                                                qv(
                                                                  {
                                                                    onClick:
                                                                      function () {
                                                                        return i(
                                                                          null ==
                                                                            t
                                                                            ? void 0
                                                                            : t.CartUrl,
                                                                          ""
                                                                            .concat(
                                                                              "shareCartLink",
                                                                              " "
                                                                            )
                                                                            .concat(
                                                                              n
                                                                            )
                                                                        );
                                                                      },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsx)(
                                                                        cv,
                                                                        {
                                                                          style:
                                                                            {
                                                                              color:
                                                                                s[
                                                                                  ""
                                                                                    .concat(
                                                                                      "shareCartLink",
                                                                                      " "
                                                                                    )
                                                                                    .concat(
                                                                                      n
                                                                                    )
                                                                                ],
                                                                              cursor:
                                                                                "pointer",
                                                                            },
                                                                        }
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsxs)(
                                                    yi,
                                                    qv(
                                                      { align: "center" },
                                                      {
                                                        children: [
                                                          (0, e.jsx)(
                                                            _l,
                                                            qv(
                                                              {
                                                                title:
                                                                  m(
                                                                    "cartSharing_DeleteCartLink_Msg"
                                                                  ) || "Delete",
                                                                arrow: !0,
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsx)(
                                                                  Kn,
                                                                  qv(
                                                                    {
                                                                      onClick:
                                                                        function (
                                                                          e
                                                                        ) {
                                                                          return F(
                                                                            e,
                                                                            t,
                                                                            n
                                                                          );
                                                                        },
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          uv,
                                                                          {
                                                                            sx: {
                                                                              color:
                                                                                "rgba(0, 0, 0, 0.87)",
                                                                              fontSize:
                                                                                "1.5rem !important",
                                                                            },
                                                                          }
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(
                                                            Zl,
                                                            qv(
                                                              {
                                                                open: Boolean(
                                                                  Z
                                                                ),
                                                                anchorEl: Z,
                                                                onClose:
                                                                  function () {
                                                                    H(null);
                                                                  },
                                                                anchorOrigin: {
                                                                  vertical:
                                                                    "bottom",
                                                                  horizontal:
                                                                    "left",
                                                                },
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsxs)(
                                                                  "div",
                                                                  qv(
                                                                    {
                                                                      className:
                                                                        "ST_CS_DeleteConfirmPopup",
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            Wa,
                                                                            qv(
                                                                              {
                                                                                pb: 2,
                                                                              },
                                                                              {
                                                                                children:
                                                                                  m(
                                                                                    "cartSharing_DeleteConfirmation_Msg"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                          (0,
                                                                          e.jsxs)(
                                                                            "div",
                                                                            qv(
                                                                              {
                                                                                className:
                                                                                  "ST_CS_TextRight",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      Th,
                                                                                      {
                                                                                        size: "large",
                                                                                        sx: {
                                                                                          color:
                                                                                            "green",
                                                                                          p: 0,
                                                                                          minWidth: 0,
                                                                                        },
                                                                                        onClick:
                                                                                          function () {
                                                                                            return v();
                                                                                          },
                                                                                        endIcon:
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            dv,
                                                                                            {}
                                                                                          ),
                                                                                        loading:
                                                                                          !!b[
                                                                                            (null ==
                                                                                            U
                                                                                              ? void 0
                                                                                              : U.delete_Cart_Id) ||
                                                                                              0
                                                                                          ] &&
                                                                                          b[
                                                                                            (null ==
                                                                                            U
                                                                                              ? void 0
                                                                                              : U.delete_Cart_Id) ||
                                                                                              0
                                                                                          ],
                                                                                        loadingPosition:
                                                                                          "center",
                                                                                      }
                                                                                    ),
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      pv,
                                                                                      {
                                                                                        sx: {
                                                                                          color:
                                                                                            "red",
                                                                                          cursor:
                                                                                            "pointer",
                                                                                        },
                                                                                        onClick:
                                                                                          function () {
                                                                                            H(
                                                                                              null
                                                                                            );
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                              }
                                                                            )
                                                                          ),
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                ],
                                              },
                                              n
                                            );
                                          }),
                                        })
                                      : (0, e.jsx)(hi, {
                                          children: (0, e.jsx)(
                                            yi,
                                            qv(
                                              { colSpan: 4, align: "center" },
                                              {
                                                children: m(
                                                  "cartSharing_SharedCartLinkTableEmpty_Msg"
                                                ),
                                              }
                                            )
                                          ),
                                        }),
                                }),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Wa,
                    qv(
                      { mt: 4, fontSize: 14, variant: "subtitle2" },
                      { children: m("cartSharing_CreateCartInformation_Text") }
                    )
                  ),
                  (0, e.jsx)(
                    ln,
                    qv(
                      { sx: te },
                      {
                        children: (0, e.jsxs)(
                          La,
                          qv(
                            { container: !0 },
                            {
                              children: [
                                (0, e.jsx)(
                                  La,
                                  qv(
                                    { item: !0, sx: re, xs: 12, md: 6 },
                                    {
                                      children: (0, e.jsx)(Bc, {
                                        id: "free-solo-demo",
                                        freeSolo: !0,
                                        options: C || [],
                                        groupBy: function (e) {
                                          return (
                                            (null == e
                                              ? void 0
                                              : e.productTitle) || ""
                                          );
                                        },
                                        inputValue: w,
                                        onInputChange: function (e, t) {
                                          return P(t), S(t);
                                        },
                                        getOptionLabel: function (e) {
                                          return e.variants.map(function (e) {
                                            return (
                                              (null == e
                                                ? void 0
                                                : e.variantTitle) || ""
                                            );
                                          });
                                        },
                                        renderInput: function (t) {
                                          return (0, e.jsx)(
                                            Xd,
                                            qv(
                                              {
                                                placeholder: m(
                                                  "customerInvoice_ProductsSearchBy_Placeholder"
                                                ),
                                              },
                                              t,
                                              {
                                                label: m(
                                                  "customerInvoice_SearchProducts_Label"
                                                ),
                                                sx: {
                                                  backgroundColor: "white",
                                                },
                                                InputProps: qv(
                                                  qv({}, t.InputProps),
                                                  {
                                                    startAdornment: (0, e.jsx)(
                                                      ap,
                                                      qv(
                                                        {
                                                          position: "start",
                                                          sx: { mr: 0 },
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            mv,
                                                            {}
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  }
                                                ),
                                              }
                                            )
                                          );
                                        },
                                        size: "small",
                                      }),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  qv(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 6,
                                      sx: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      },
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        "div",
                                        qv(
                                          { style: { display: "flex" } },
                                          {
                                            children: [
                                              (0, e.jsxs)(
                                                "div",
                                                qv(
                                                  {
                                                    style: {
                                                      display: "flex",
                                                      marginTop: "20px",
                                                      marginRight: "0.5rem",
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(hv, {
                                                        sx: {
                                                          color: "#979797",
                                                          height: "0.8em",
                                                          width: "0.8em",
                                                        },
                                                      }),
                                                      (0, e.jsx)(
                                                        Il,
                                                        qv(
                                                          {
                                                            component: "button",
                                                            variant: "body2",
                                                            sx: {
                                                              cursor: "pointer",
                                                              display:
                                                                " inline-flex",
                                                            },
                                                            onClick: a,
                                                          },
                                                          {
                                                            children: m(
                                                              "createOrder_productSearchGuide"
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                              o,
                                              I
                                                ? (0, e.jsx)(
                                                    vp,
                                                    qv(
                                                      {
                                                        sx: [ne, rv],
                                                        variant: "contained",
                                                        color: "success",
                                                        endIcon: (0, e.jsx)(
                                                          fv,
                                                          {}
                                                        ),
                                                        onClick: T,
                                                      },
                                                      {
                                                        children: m(
                                                          "customerInvoice_AddMoreProducts_Btn"
                                                        ),
                                                      }
                                                    )
                                                  )
                                                : null,
                                              (0, e.jsx)(
                                                vp,
                                                qv(
                                                  {
                                                    sx: qv({ mt: 2 }, rv),
                                                    variant: "contained",
                                                    disabled: !(A.length > 0),
                                                    endIcon: (0, e.jsx)(
                                                      wp,
                                                      qv(
                                                        {
                                                          badgeContent:
                                                            A.length,
                                                          color: "success",
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            gv,
                                                            {}
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    onClick: M,
                                                  },
                                                  {
                                                    children: m(
                                                      "customerInvoice_Selected_Btn"
                                                    ),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    "div",
                    qv(
                      {
                        id: "scrollableDiv",
                        style: {
                          maxHeight: "400px",
                          border: "1px solid #bfbfbf",
                        },
                      },
                      {
                        children: (0, e.jsx)(
                          Ov,
                          qv(
                            {
                              next: $,
                              hasMore: !0,
                              loader: (0, e.jsx)(e.Fragment, {}),
                              dataLength: C.length,
                              scrollableTarget: "scrollableDiv",
                            },
                            {
                              children: (0, e.jsx)(
                                Ga,
                                qv(
                                  {
                                    style: { maxHeight: "400px" },
                                    component: io,
                                  },
                                  {
                                    children: (0, e.jsxs)(
                                      ei,
                                      qv(
                                        {
                                          stickyHeader: !0,
                                          sx: { minWidth: 650 },
                                          "aria-label": "simple table",
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(si, {
                                              children: q
                                                ? null
                                                : (0, e.jsxs)(
                                                    hi,
                                                    qv(
                                                      {
                                                        className:
                                                          "stickyHeaderRow",
                                                      },
                                                      {
                                                        children: [
                                                          (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              { sx: Zo },
                                                              {
                                                                children: (0,
                                                                e.jsxs)(
                                                                  "b",
                                                                  qv(
                                                                    {
                                                                      className:
                                                                        "ST_CS_TableHeading",
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          " ",
                                                                          m(
                                                                            "cartSharing_ProductTableColumnProduct"
                                                                          ),
                                                                          " ",
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              {
                                                                align: "center",
                                                                sx: Zo,
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsx)(
                                                                  "b",
                                                                  qv(
                                                                    {
                                                                      className:
                                                                        "ST_CS_TableHeading",
                                                                    },
                                                                    {
                                                                      children:
                                                                        m(
                                                                          "cartSharing_ProductTableColumnQuantity"
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              { sx: Zo },
                                                              {
                                                                children: (0,
                                                                e.jsxs)(
                                                                  "b",
                                                                  qv(
                                                                    {
                                                                      className:
                                                                        "ST_CS_TableHeading",
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          " ",
                                                                          m(
                                                                            "cartSharing_ProductTableColumnSku"
                                                                          ),
                                                                          " ",
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              {
                                                                sx: Zo,
                                                                align: "center",
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsxs)(
                                                                  "b",
                                                                  qv(
                                                                    {
                                                                      className:
                                                                        "ST_CS_TableHeading",
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          " ",
                                                                          m(
                                                                            "cartSharing_ProductTableColumnInventory"
                                                                          ),
                                                                          " ",
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              { sx: Zo },
                                                              {
                                                                children: (0,
                                                                e.jsxs)(
                                                                  "b",
                                                                  qv(
                                                                    {
                                                                      className:
                                                                        "ST_CS_TableHeading",
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          m(
                                                                            "cartSharing_ProductTableColumnItemPrice"
                                                                          ),
                                                                          "(",
                                                                          h,
                                                                          ")",
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                            }),
                                            q
                                              ? (0, e.jsx)(Pi, {
                                                  children:
                                                    0 !== C.length
                                                      ? (0, e.jsx)(e.Fragment, {
                                                          children: C.map(
                                                            function (n, r) {
                                                              return n.variants
                                                                .length > 0
                                                                ? (0, e.jsxs)(
                                                                    t.Fragment,
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            hi,
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  yi,
                                                                                  qv(
                                                                                    {
                                                                                      colSpan: 5,
                                                                                      sx: qv(
                                                                                        {
                                                                                          borderTop:
                                                                                            "1px solid #bfbfbf",
                                                                                        },
                                                                                        Q
                                                                                      ),
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Xp,
                                                                                          {
                                                                                            label:
                                                                                              (null ==
                                                                                              n
                                                                                                ? void 0
                                                                                                : n.productTitle) ||
                                                                                              "-",
                                                                                            control:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                vm,
                                                                                                {
                                                                                                  disabled:
                                                                                                    c(
                                                                                                      n
                                                                                                    ),
                                                                                                  checked:
                                                                                                    !!W(
                                                                                                      O[
                                                                                                        (null ==
                                                                                                        n
                                                                                                          ? void 0
                                                                                                          : n.productId) ||
                                                                                                          0
                                                                                                      ]
                                                                                                    ),
                                                                                                  onChange:
                                                                                                    function (
                                                                                                      e
                                                                                                    ) {
                                                                                                      N(
                                                                                                        e,
                                                                                                        "isProduct",
                                                                                                        u(
                                                                                                          n
                                                                                                        )
                                                                                                      );
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                          }
                                                                                        ),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n.variants.map(
                                                                            function (
                                                                              t,
                                                                              r
                                                                            ) {
                                                                              var o;
                                                                              return (0,
                                                                              e.jsx)(
                                                                                hi,
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsxs)(
                                                                                      yi,
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              ln,
                                                                                              qv(
                                                                                                {
                                                                                                  sx: {
                                                                                                    border:
                                                                                                      "1px solid #bfbfbf",
                                                                                                    p: 1,
                                                                                                  },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      Xp,
                                                                                                      {
                                                                                                        className:
                                                                                                          "ST_CS_product-label",
                                                                                                        sx: {
                                                                                                          ml: 2,
                                                                                                        },
                                                                                                        label:
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            e.Fragment,
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  0 !==
                                                                                                                    (null ==
                                                                                                                    n
                                                                                                                      ? void 0
                                                                                                                      : n
                                                                                                                          .productImages
                                                                                                                          .length) &&
                                                                                                                  (null ==
                                                                                                                  n
                                                                                                                    ? void 0
                                                                                                                    : n
                                                                                                                        .productImages[0]
                                                                                                                        .src)
                                                                                                                    ? (0,
                                                                                                                      e.jsx)(
                                                                                                                        Tm,
                                                                                                                        {
                                                                                                                          alt: "image",
                                                                                                                          src: k(
                                                                                                                            t.image_id,
                                                                                                                            n.productImages
                                                                                                                          ),
                                                                                                                          variant:
                                                                                                                            "rounded",
                                                                                                                        }
                                                                                                                      )
                                                                                                                    : (0,
                                                                                                                      e.jsx)(
                                                                                                                        Tm,
                                                                                                                        qv(
                                                                                                                          {
                                                                                                                            alt: "image",
                                                                                                                            sx: {
                                                                                                                              bgcolor:
                                                                                                                                "white",
                                                                                                                              color:
                                                                                                                                "black",
                                                                                                                            },
                                                                                                                            variant:
                                                                                                                              "rounded",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                vv,
                                                                                                                                {
                                                                                                                                  sx: {
                                                                                                                                    fontSize:
                                                                                                                                      "3.1rem",
                                                                                                                                  },
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    ln,
                                                                                                                    qv(
                                                                                                                      {
                                                                                                                        sx: {
                                                                                                                          ml: 1,
                                                                                                                        },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            "Default Title" !==
                                                                                                                            (null ==
                                                                                                                            t
                                                                                                                              ? void 0
                                                                                                                              : t.variantTitle)
                                                                                                                              ? t.variantTitle
                                                                                                                              : n.productTitle,
                                                                                                                            " ",
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          ),
                                                                                                        control:
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            vm,
                                                                                                            {
                                                                                                              disabled:
                                                                                                                l(
                                                                                                                  t
                                                                                                                ),
                                                                                                              checked:
                                                                                                                !!W(
                                                                                                                  E[
                                                                                                                    (null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantId) ||
                                                                                                                      0
                                                                                                                  ]
                                                                                                                ),
                                                                                                              onChange:
                                                                                                                function (
                                                                                                                  e
                                                                                                                ) {
                                                                                                                  N(
                                                                                                                    e,
                                                                                                                    "isVariant",
                                                                                                                    n,
                                                                                                                    t
                                                                                                                  );
                                                                                                                },
                                                                                                            }
                                                                                                          ),
                                                                                                      }
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              ln,
                                                                                              qv(
                                                                                                {
                                                                                                  sx: {
                                                                                                    border:
                                                                                                      "1px solid #bfbfbf",
                                                                                                    p: 1,
                                                                                                  },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      (0,
                                                                                                      e.jsxs)(
                                                                                                        "b",
                                                                                                        qv(
                                                                                                          {
                                                                                                            className:
                                                                                                              "ST_CS_TableHeading",
                                                                                                            style:
                                                                                                              {
                                                                                                                marginRight:
                                                                                                                  "120px",
                                                                                                              },
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                " ",
                                                                                                                m(
                                                                                                                  "cartSharing_ProductTableColumnSku"
                                                                                                                ),
                                                                                                                " :",
                                                                                                              ],
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                      (null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.sku) ||
                                                                                                        "-",
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              ln,
                                                                                              qv(
                                                                                                {
                                                                                                  sx: {
                                                                                                    border:
                                                                                                      "1px solid #bfbfbf",
                                                                                                    p: 1,
                                                                                                  },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      (0,
                                                                                                      e.jsxs)(
                                                                                                        "b",
                                                                                                        qv(
                                                                                                          {
                                                                                                            className:
                                                                                                              "ST_CS_TableHeading",
                                                                                                            style:
                                                                                                              {
                                                                                                                marginRight:
                                                                                                                  "100px",
                                                                                                              },
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                " ",
                                                                                                                m(
                                                                                                                  "cartSharing_ProductTableColumnInventory"
                                                                                                                ),
                                                                                                                " :",
                                                                                                              ],
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                      d(
                                                                                                        t
                                                                                                      ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              ln,
                                                                                              qv(
                                                                                                {
                                                                                                  sx: {
                                                                                                    border:
                                                                                                      "1px solid #bfbfbf",
                                                                                                    p: 1,
                                                                                                  },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      (0,
                                                                                                      e.jsxs)(
                                                                                                        "b",
                                                                                                        qv(
                                                                                                          {
                                                                                                            className:
                                                                                                              "ST_CS_TableHeading",
                                                                                                            style:
                                                                                                              {
                                                                                                                marginRight:
                                                                                                                  "60px",
                                                                                                              },
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                m(
                                                                                                                  "cartSharing_ProductTableColumnItemPrice"
                                                                                                                ),
                                                                                                                "(",
                                                                                                                h,
                                                                                                                ") :",
                                                                                                              ],
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                      h +
                                                                                                        " ",
                                                                                                      (null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.variantPrice.toFixed(
                                                                                                            2
                                                                                                          )) ||
                                                                                                        (0).toFixed(
                                                                                                          2
                                                                                                        ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              ln,
                                                                                              qv(
                                                                                                {
                                                                                                  sx: {
                                                                                                    border:
                                                                                                      "1px solid #bfbfbf",
                                                                                                    p: 1,
                                                                                                  },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      (0,
                                                                                                      e.jsxs)(
                                                                                                        "b",
                                                                                                        qv(
                                                                                                          {
                                                                                                            className:
                                                                                                              "ST_CS_TableHeading",
                                                                                                            style:
                                                                                                              {
                                                                                                                marginRight:
                                                                                                                  "5px",
                                                                                                              },
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                m(
                                                                                                                  "cartSharing_ProductTableColumnQuantity"
                                                                                                                ),
                                                                                                                " :",
                                                                                                                " ",
                                                                                                              ],
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        Nm,
                                                                                                        qv(
                                                                                                          {
                                                                                                            sx: {
                                                                                                              mt: 1,
                                                                                                            },
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                _l,
                                                                                                                qv(
                                                                                                                  {
                                                                                                                    title:
                                                                                                                      W(
                                                                                                                        E[
                                                                                                                          (null ==
                                                                                                                          t
                                                                                                                            ? void 0
                                                                                                                            : t.variantId) ||
                                                                                                                            0
                                                                                                                        ]
                                                                                                                      )
                                                                                                                        ? ""
                                                                                                                        : m(
                                                                                                                            "cartSharing_ProductTableQuantityUpdate_Btn"
                                                                                                                          ),
                                                                                                                    arrow:
                                                                                                                      !0,
                                                                                                                  },
                                                                                                                  {
                                                                                                                    children:
                                                                                                                      (0,
                                                                                                                      e.jsxs)(
                                                                                                                        "span",
                                                                                                                        qv(
                                                                                                                          {
                                                                                                                            className:
                                                                                                                              "ST_CS_CartButtonGroup",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              [
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  vp,
                                                                                                                                  qv(
                                                                                                                                    {
                                                                                                                                      className:
                                                                                                                                        "ST_CS_ProductIncrementBtn",
                                                                                                                                      "aria-label":
                                                                                                                                        "reduce",
                                                                                                                                      disabled:
                                                                                                                                        !W(
                                                                                                                                          E[
                                                                                                                                            (null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId) ||
                                                                                                                                              0
                                                                                                                                          ]
                                                                                                                                        ),
                                                                                                                                      onClick:
                                                                                                                                        function () {
                                                                                                                                          return R(
                                                                                                                                            null ==
                                                                                                                                              t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId,
                                                                                                                                            "subtract"
                                                                                                                                          );
                                                                                                                                        },
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                      children:
                                                                                                                                        (0,
                                                                                                                                        e.jsx)(
                                                                                                                                          bv,
                                                                                                                                          {
                                                                                                                                            fontSize:
                                                                                                                                              "small",
                                                                                                                                          }
                                                                                                                                        ),
                                                                                                                                    }
                                                                                                                                  )
                                                                                                                                ),
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  Xd,
                                                                                                                                  {
                                                                                                                                    InputProps:
                                                                                                                                      {
                                                                                                                                        inputProps:
                                                                                                                                          {
                                                                                                                                            className:
                                                                                                                                              "ST_Custom_Number_Input",
                                                                                                                                          },
                                                                                                                                      },
                                                                                                                                    onKeyDown:
                                                                                                                                      sv,
                                                                                                                                    name: "".concat(
                                                                                                                                      null ==
                                                                                                                                        t
                                                                                                                                        ? void 0
                                                                                                                                        : t.variantId
                                                                                                                                    ),
                                                                                                                                    disabled:
                                                                                                                                      !W(
                                                                                                                                        E[
                                                                                                                                          (null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId) ||
                                                                                                                                            0
                                                                                                                                        ]
                                                                                                                                      ),
                                                                                                                                    value:
                                                                                                                                      W(
                                                                                                                                        E[
                                                                                                                                          (null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId) ||
                                                                                                                                            0
                                                                                                                                        ]
                                                                                                                                      )
                                                                                                                                        ? E[
                                                                                                                                            (null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId) ||
                                                                                                                                              0
                                                                                                                                          ]
                                                                                                                                        : 1,
                                                                                                                                    className:
                                                                                                                                      "ST_CS_CartTextBox",
                                                                                                                                    variant:
                                                                                                                                      "outlined",
                                                                                                                                    size: "small",
                                                                                                                                    type: "number",
                                                                                                                                    onChange:
                                                                                                                                      function (
                                                                                                                                        e
                                                                                                                                      ) {
                                                                                                                                        return K(
                                                                                                                                          e,
                                                                                                                                          null ==
                                                                                                                                            t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId
                                                                                                                                        );
                                                                                                                                      },
                                                                                                                                    error:
                                                                                                                                      !!G[
                                                                                                                                        null !==
                                                                                                                                          (o =
                                                                                                                                            null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId) &&
                                                                                                                                        void 0 !==
                                                                                                                                          o
                                                                                                                                          ? o
                                                                                                                                          : 0
                                                                                                                                      ],
                                                                                                                                  }
                                                                                                                                ),
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  vp,
                                                                                                                                  qv(
                                                                                                                                    {
                                                                                                                                      className:
                                                                                                                                        "ST_CS_ProductDecrementBtn",
                                                                                                                                      "aria-label":
                                                                                                                                        "increase",
                                                                                                                                      disabled:
                                                                                                                                        !W(
                                                                                                                                          E[
                                                                                                                                            (null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId) ||
                                                                                                                                              0
                                                                                                                                          ]
                                                                                                                                        ),
                                                                                                                                      onClick:
                                                                                                                                        function () {
                                                                                                                                          return R(
                                                                                                                                            null ==
                                                                                                                                              t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId,
                                                                                                                                            "add"
                                                                                                                                          );
                                                                                                                                        },
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                      children:
                                                                                                                                        (0,
                                                                                                                                        e.jsx)(
                                                                                                                                          _v,
                                                                                                                                          {
                                                                                                                                            fontSize:
                                                                                                                                              "small",
                                                                                                                                          }
                                                                                                                                        ),
                                                                                                                                    }
                                                                                                                                  )
                                                                                                                                ),
                                                                                                                              ],
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  }
                                                                                                                )
                                                                                                              ),
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                          ],
                                                                                      }
                                                                                    ),
                                                                                },
                                                                                r
                                                                              );
                                                                            }
                                                                          ),
                                                                        ],
                                                                    },
                                                                    r
                                                                  )
                                                                : "";
                                                            }
                                                          ),
                                                        })
                                                      : (0, e.jsx)(hi, {
                                                          children: (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              {
                                                                align: "center",
                                                                colSpan: 5,
                                                              },
                                                              {
                                                                children: m(
                                                                  "cartSharing_ProductTableEmpty_Msg"
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        }),
                                                })
                                              : (0, e.jsx)(Pi, {
                                                  children:
                                                    0 !== C.length
                                                      ? (0, e.jsx)(e.Fragment, {
                                                          children: C.map(
                                                            function (n, r) {
                                                              return n.variants
                                                                .length > 0
                                                                ? (0, e.jsxs)(
                                                                    t.Fragment,
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            hi,
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  yi,
                                                                                  qv(
                                                                                    {
                                                                                      colSpan: 5,
                                                                                      sx: qv(
                                                                                        {
                                                                                          borderTop:
                                                                                            "1px solid #bfbfbf",
                                                                                        },
                                                                                        Q
                                                                                      ),
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Xp,
                                                                                          {
                                                                                            label:
                                                                                              (null ==
                                                                                              n
                                                                                                ? void 0
                                                                                                : n.productTitle) ||
                                                                                              "-",
                                                                                            control:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                vm,
                                                                                                {
                                                                                                  disabled:
                                                                                                    c(
                                                                                                      n
                                                                                                    ),
                                                                                                  checked:
                                                                                                    !!W(
                                                                                                      O[
                                                                                                        (null ==
                                                                                                        n
                                                                                                          ? void 0
                                                                                                          : n.productId) ||
                                                                                                          0
                                                                                                      ]
                                                                                                    ),
                                                                                                  onChange:
                                                                                                    function (
                                                                                                      e
                                                                                                    ) {
                                                                                                      N(
                                                                                                        e,
                                                                                                        "isProduct",
                                                                                                        u(
                                                                                                          n
                                                                                                        )
                                                                                                      );
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                          }
                                                                                        ),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n.variants.map(
                                                                            function (
                                                                              t,
                                                                              r
                                                                            ) {
                                                                              var o;
                                                                              return (0,
                                                                              e.jsxs)(
                                                                                hi,
                                                                                {
                                                                                  children:
                                                                                    [
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        yi,
                                                                                        qv(
                                                                                          {
                                                                                            sx: Q,
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Xp,
                                                                                                {
                                                                                                  className:
                                                                                                    "ST_CS_product-label",
                                                                                                  sx: {
                                                                                                    ml: 2,
                                                                                                  },
                                                                                                  label:
                                                                                                    (0,
                                                                                                    e.jsxs)(
                                                                                                      e.Fragment,
                                                                                                      {
                                                                                                        children:
                                                                                                          [
                                                                                                            0 !==
                                                                                                              (null ==
                                                                                                              n
                                                                                                                ? void 0
                                                                                                                : n
                                                                                                                    .productImages
                                                                                                                    .length) &&
                                                                                                            (null ==
                                                                                                            n
                                                                                                              ? void 0
                                                                                                              : n
                                                                                                                  .productImages[0]
                                                                                                                  .src)
                                                                                                              ? (0,
                                                                                                                e.jsx)(
                                                                                                                  Tm,
                                                                                                                  {
                                                                                                                    alt: "image",
                                                                                                                    src: k(
                                                                                                                      t.image_id,
                                                                                                                      n.productImages
                                                                                                                    ),
                                                                                                                    variant:
                                                                                                                      "rounded",
                                                                                                                  }
                                                                                                                )
                                                                                                              : (0,
                                                                                                                e.jsx)(
                                                                                                                  Tm,
                                                                                                                  qv(
                                                                                                                    {
                                                                                                                      alt: "image",
                                                                                                                      sx: {
                                                                                                                        bgcolor:
                                                                                                                          "white",
                                                                                                                        color:
                                                                                                                          "black",
                                                                                                                      },
                                                                                                                      variant:
                                                                                                                        "rounded",
                                                                                                                    },
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsx)(
                                                                                                                          vv,
                                                                                                                          {
                                                                                                                            sx: {
                                                                                                                              fontSize:
                                                                                                                                "3.1rem",
                                                                                                                            },
                                                                                                                          }
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  )
                                                                                                                ),
                                                                                                            (0,
                                                                                                            e.jsxs)(
                                                                                                              ln,
                                                                                                              qv(
                                                                                                                {
                                                                                                                  sx: {
                                                                                                                    ml: 1,
                                                                                                                  },
                                                                                                                },
                                                                                                                {
                                                                                                                  children:
                                                                                                                    [
                                                                                                                      "Default Title" !==
                                                                                                                      (null ==
                                                                                                                      t
                                                                                                                        ? void 0
                                                                                                                        : t.variantTitle)
                                                                                                                        ? t.variantTitle
                                                                                                                        : n.productTitle,
                                                                                                                      " ",
                                                                                                                    ],
                                                                                                                }
                                                                                                              )
                                                                                                            ),
                                                                                                          ],
                                                                                                      }
                                                                                                    ),
                                                                                                  control:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      vm,
                                                                                                      {
                                                                                                        disabled:
                                                                                                          l(
                                                                                                            t
                                                                                                          ),
                                                                                                        checked:
                                                                                                          !!W(
                                                                                                            E[
                                                                                                              (null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.variantId) ||
                                                                                                                0
                                                                                                            ]
                                                                                                          ),
                                                                                                        onChange:
                                                                                                          function (
                                                                                                            e
                                                                                                          ) {
                                                                                                            N(
                                                                                                              e,
                                                                                                              "isVariant",
                                                                                                              n,
                                                                                                              t
                                                                                                            );
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                }
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        yi,
                                                                                        qv(
                                                                                          {
                                                                                            sx: Q,
                                                                                            align:
                                                                                              "center",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Nm,
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      _l,
                                                                                                      qv(
                                                                                                        {
                                                                                                          title:
                                                                                                            W(
                                                                                                              E[
                                                                                                                (null ==
                                                                                                                t
                                                                                                                  ? void 0
                                                                                                                  : t.variantId) ||
                                                                                                                  0
                                                                                                              ]
                                                                                                            )
                                                                                                              ? ""
                                                                                                              : m(
                                                                                                                  "cartSharing_ProductTableQuantityUpdate_Btn"
                                                                                                                ),
                                                                                                          arrow:
                                                                                                            !0,
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            (0,
                                                                                                            e.jsxs)(
                                                                                                              "span",
                                                                                                              qv(
                                                                                                                {
                                                                                                                  className:
                                                                                                                    "ST_CS_CartButtonGroup",
                                                                                                                },
                                                                                                                {
                                                                                                                  children:
                                                                                                                    [
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        vp,
                                                                                                                        qv(
                                                                                                                          {
                                                                                                                            className:
                                                                                                                              "ST_CS_ProductIncrementBtn",
                                                                                                                            "aria-label":
                                                                                                                              "reduce",
                                                                                                                            disabled:
                                                                                                                              !W(
                                                                                                                                E[
                                                                                                                                  (null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId) ||
                                                                                                                                    0
                                                                                                                                ]
                                                                                                                              ),
                                                                                                                            onClick:
                                                                                                                              function () {
                                                                                                                                return R(
                                                                                                                                  null ==
                                                                                                                                    t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId,
                                                                                                                                  "subtract"
                                                                                                                                );
                                                                                                                              },
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                bv,
                                                                                                                                {
                                                                                                                                  fontSize:
                                                                                                                                    "small",
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        Xd,
                                                                                                                        {
                                                                                                                          InputProps:
                                                                                                                            {
                                                                                                                              inputProps:
                                                                                                                                {
                                                                                                                                  className:
                                                                                                                                    "ST_Custom_Number_Input",
                                                                                                                                },
                                                                                                                            },
                                                                                                                          onKeyDown:
                                                                                                                            sv,
                                                                                                                          name: "".concat(
                                                                                                                            null ==
                                                                                                                              t
                                                                                                                              ? void 0
                                                                                                                              : t.variantId
                                                                                                                          ),
                                                                                                                          disabled:
                                                                                                                            !W(
                                                                                                                              E[
                                                                                                                                (null ==
                                                                                                                                t
                                                                                                                                  ? void 0
                                                                                                                                  : t.variantId) ||
                                                                                                                                  0
                                                                                                                              ]
                                                                                                                            ),
                                                                                                                          value:
                                                                                                                            W(
                                                                                                                              E[
                                                                                                                                (null ==
                                                                                                                                t
                                                                                                                                  ? void 0
                                                                                                                                  : t.variantId) ||
                                                                                                                                  0
                                                                                                                              ]
                                                                                                                            )
                                                                                                                              ? E[
                                                                                                                                  (null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId) ||
                                                                                                                                    0
                                                                                                                                ]
                                                                                                                              : 1,
                                                                                                                          className:
                                                                                                                            "ST_CS_CartTextBox",
                                                                                                                          variant:
                                                                                                                            "outlined",
                                                                                                                          size: "small",
                                                                                                                          type: "number",
                                                                                                                          onChange:
                                                                                                                            function (
                                                                                                                              e
                                                                                                                            ) {
                                                                                                                              return K(
                                                                                                                                e,
                                                                                                                                null ==
                                                                                                                                  t
                                                                                                                                  ? void 0
                                                                                                                                  : t.variantId
                                                                                                                              );
                                                                                                                            },
                                                                                                                          error:
                                                                                                                            !!G[
                                                                                                                              null !==
                                                                                                                                (o =
                                                                                                                                  null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId) &&
                                                                                                                              void 0 !==
                                                                                                                                o
                                                                                                                                ? o
                                                                                                                                : 0
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        vp,
                                                                                                                        qv(
                                                                                                                          {
                                                                                                                            className:
                                                                                                                              "ST_CS_ProductDecrementBtn",
                                                                                                                            "aria-label":
                                                                                                                              "increase",
                                                                                                                            disabled:
                                                                                                                              !W(
                                                                                                                                E[
                                                                                                                                  (null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId) ||
                                                                                                                                    0
                                                                                                                                ]
                                                                                                                              ),
                                                                                                                            onClick:
                                                                                                                              function () {
                                                                                                                                return R(
                                                                                                                                  null ==
                                                                                                                                    t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId,
                                                                                                                                  "add"
                                                                                                                                );
                                                                                                                              },
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                _v,
                                                                                                                                {
                                                                                                                                  fontSize:
                                                                                                                                    "small",
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                    ],
                                                                                                                }
                                                                                                              )
                                                                                                            ),
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                }
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        yi,
                                                                                        qv(
                                                                                          {
                                                                                            sx: Q,
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                " ",
                                                                                                (null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.sku) ||
                                                                                                  "-",
                                                                                                " ",
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        yi,
                                                                                        qv(
                                                                                          {
                                                                                            sx: Q,
                                                                                            align:
                                                                                              "center",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              d(
                                                                                                t
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        yi,
                                                                                        qv(
                                                                                          {
                                                                                            sx: Q,
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                h +
                                                                                                  " ",
                                                                                                (null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.variantPrice.toFixed(
                                                                                                      2
                                                                                                    )) ||
                                                                                                  (0).toFixed(
                                                                                                    2
                                                                                                  ),
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                    ],
                                                                                },
                                                                                r
                                                                              );
                                                                            }
                                                                          ),
                                                                        ],
                                                                    },
                                                                    r
                                                                  )
                                                                : "";
                                                            }
                                                          ),
                                                        })
                                                      : (0, e.jsx)(hi, {
                                                          children: (0, e.jsx)(
                                                            yi,
                                                            qv(
                                                              {
                                                                align: "center",
                                                                colSpan: 5,
                                                              },
                                                              {
                                                                children: m(
                                                                  "cartSharing_ProductTableEmpty_Msg"
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        }),
                                                }),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    ln,
                    qv(
                      { sx: te },
                      {
                        children: [
                          (0, e.jsx)(
                            La,
                            qv(
                              { item: !0, sx: ee },
                              {
                                children: (0, e.jsx)(Xd, {
                                  required: !0,
                                  sx: {
                                    width: "100%",
                                    backgroundColor: "white",
                                  },
                                  label: m("cartSharing_EnterCartName_Label"),
                                  name: "cartname",
                                  value: _,
                                  onChange: function (e) {
                                    return x(e.target.value);
                                  },
                                  type: "search",
                                  size: "small",
                                }),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            "div",
                            qv(
                              { style: { marginTop: "1.4rem" } },
                              {
                                children: (0, e.jsx)(
                                  _l,
                                  qv(
                                    {
                                      title:
                                        "" === j.msg && V
                                          ? "Please Select Product and Enter Cart Name"
                                          : "",
                                      arrow: !0,
                                      placement: "top",
                                    },
                                    {
                                      children: (0, e.jsx)("span", {
                                        children: (0, e.jsx)(
                                          vp,
                                          qv(
                                            {
                                              sx: rv,
                                              variant: "contained",
                                              endIcon: (0, e.jsx)(yv, {}),
                                              disabled: V,
                                              onClick: function () {
                                                return D();
                                              },
                                            },
                                            {
                                              children:
                                                j.msg ===
                                                m(
                                                  "cartSharing_CartCreating_Msg"
                                                )
                                                  ? j.msg
                                                  : m(
                                                      "cartSharing_CreateCart_Btn"
                                                    ),
                                            }
                                          )
                                        ),
                                      }),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Wa,
                    qv(
                      {
                        variant: "body2",
                        sx: { mt: 2, mr: 1, color: j.color, display: "block" },
                        align: "right",
                      },
                      {
                        children:
                          j.msg !== m("customerInvoice_Creating_Msg")
                            ? j.msg
                            : "",
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Gm,
                    qv(
                      {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                        open: B,
                        autoHideDuration: 4e3,
                        onClose: L,
                      },
                      {
                        children: (0, e.jsx)(
                          ch,
                          qv(
                            {
                              onClose: L,
                              severity: "error",
                              variant: "filled",
                              sx: { width: "100%" },
                            },
                            { children: m("cartSharing_AlertError_Msg") }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Gm,
                    qv(
                      {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                        open: Y.open,
                        autoHideDuration: 4e3,
                        onClose: L,
                      },
                      {
                        children: (0, e.jsx)(
                          ch,
                          qv(
                            {
                              onClose: L,
                              severity:
                                null !==
                                  (n = null == Y ? void 0 : Y.severity) &&
                                void 0 !== n
                                  ? n
                                  : "error",
                              variant: "filled",
                              sx: { width: "100%" },
                            },
                            { children: Y.msg }
                          )
                        ),
                      }
                    )
                  ),
                ],
              }
            )
          )
        );
      }
      var Jv = (0, Bt.Z)("MuiListItemIcon", ["root", "alignItemsFlexStart"]),
        Qv = (0, Bt.Z)("MuiListItemText", [
          "root",
          "multiline",
          "dense",
          "inset",
          "primary",
          "secondary",
        ]);
      function Xv(e) {
        return (0, Zt.ZP)("MuiMenuItem", e);
      }
      var eb = (0, Bt.Z)("MuiMenuItem", [
        "root",
        "focusVisible",
        "dense",
        "disabled",
        "divider",
        "gutters",
        "selected",
      ]);
      const tb = [
          "autoFocus",
          "component",
          "dense",
          "divider",
          "disableGutters",
          "focusVisibleClassName",
          "role",
          "tabIndex",
          "className",
        ],
        nb = (0, Lt.ZP)(Zn, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiMenuItem",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.dense && t.dense,
              n.divider && t.divider,
              !n.disableGutters && t.gutters,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {},
            e.typography.body1,
            {
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              position: "relative",
              textDecoration: "none",
              minHeight: 48,
              paddingTop: 6,
              paddingBottom: 6,
              boxSizing: "border-box",
              whiteSpace: "nowrap",
            },
            !t.disableGutters && { paddingLeft: 16, paddingRight: 16 },
            t.divider && {
              borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
              backgroundClip: "padding-box",
            },
            {
              "&:hover": {
                textDecoration: "none",
                backgroundColor: (e.vars || e).palette.action.hover,
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
              [`&.${eb.selected}`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
                  : (0, At.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity
                    ),
                [`&.${eb.focusVisible}`]: {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                    : (0, At.Fq)(
                        e.palette.primary.main,
                        e.palette.action.selectedOpacity +
                          e.palette.action.focusOpacity
                      ),
                },
              },
              [`&.${eb.selected}:hover`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                  : (0, At.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity +
                        e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
                    : (0, At.Fq)(
                        e.palette.primary.main,
                        e.palette.action.selectedOpacity
                      ),
                },
              },
              [`&.${eb.focusVisible}`]: {
                backgroundColor: (e.vars || e).palette.action.focus,
              },
              [`&.${eb.disabled}`]: {
                opacity: (e.vars || e).palette.action.disabledOpacity,
              },
              [`& + .${Ht.root}`]: {
                marginTop: e.spacing(1),
                marginBottom: e.spacing(1),
              },
              [`& + .${Ht.inset}`]: { marginLeft: 52 },
              [`& .${Qv.root}`]: { marginTop: 0, marginBottom: 0 },
              [`& .${Qv.inset}`]: { paddingLeft: 36 },
              [`& .${Jv.root}`]: { minWidth: 36 },
            },
            !t.dense && { [e.breakpoints.up("sm")]: { minHeight: "auto" } },
            t.dense &&
              (0, d.Z)(
                { minHeight: 32, paddingTop: 4, paddingBottom: 4 },
                e.typography.body2,
                { [`& .${Jv.root} svg`]: { fontSize: "1.25rem" } }
              )
          )
        ),
        rb = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiMenuItem" }),
            {
              autoFocus: a = !1,
              component: i = "li",
              dense: s = !1,
              divider: l = !1,
              disableGutters: c = !1,
              focusVisibleClassName: u,
              role: p = "menuitem",
              tabIndex: m,
              className: h,
            } = o,
            f = (0, jt.Z)(o, tb),
            g = t.useContext(Qu),
            v = t.useMemo(
              () => ({ dense: s || g.dense || !1, disableGutters: c }),
              [g.dense, s, c]
            ),
            b = t.useRef(null);
          (0, $o.Z)(() => {
            a && b.current && b.current.focus();
          }, [a]);
          const _ = (0, d.Z)({}, o, {
              dense: v.dense,
              divider: l,
              disableGutters: c,
            }),
            y = ((e) => {
              const {
                  disabled: t,
                  dense: n,
                  divider: r,
                  disableGutters: o,
                  selected: a,
                  classes: i,
                } = e,
                s = {
                  root: [
                    "root",
                    n && "dense",
                    t && "disabled",
                    !o && "gutters",
                    r && "divider",
                    a && "selected",
                  ],
                },
                l = (0, Nt.Z)(s, Xv, i);
              return (0, d.Z)({}, i, l);
            })(o),
            x = (0, cn.Z)(b, r);
          let C;
          return (
            o.disabled || (C = void 0 !== m ? m : -1),
            (0, e.jsx)(Qu.Provider, {
              value: v,
              children: (0, e.jsx)(
                nb,
                (0, d.Z)(
                  {
                    ref: x,
                    role: p,
                    tabIndex: C,
                    component: i,
                    focusVisibleClassName: (0, Rt.Z)(y.focusVisible, u),
                    className: (0, Rt.Z)(y.root, h),
                  },
                  f,
                  { ownerState: _, classes: y }
                )
              ),
            })
          );
        });
      var ob = rb,
        ab = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z",
          }),
          "KeyboardArrowUp"
        ),
        ib = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z",
          }),
          "KeyboardArrowDown"
        );
      function sb(e) {
        return (0, Zt.ZP)("MuiFormGroup", e);
      }
      (0, Bt.Z)("MuiFormGroup", ["root", "row", "error"]);
      const lb = ["className", "row"],
        cb = (0, Lt.ZP)("div", {
          name: "MuiFormGroup",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.row && t.row];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { display: "flex", flexDirection: "column", flexWrap: "wrap" },
            e.row && { flexDirection: "row" }
          )
        );
      var ub = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiFormGroup" }),
            { className: o, row: a = !1 } = r,
            i = (0, jt.Z)(r, lb),
            s = Kc({ props: r, muiFormControl: qc(), states: ["error"] }),
            l = (0, d.Z)({}, r, { row: a, error: s.error }),
            c = ((e) => {
              const { classes: t, row: n, error: r } = e,
                o = { root: ["root", n && "row", r && "error"] };
              return (0, Nt.Z)(o, sb, t);
            })(l);
          return (0,
          e.jsx)(cb, (0, d.Z)({ className: (0, Rt.Z)(c.root, o), ownerState: l, ref: n }, i));
        }),
        db = t.createContext(void 0);
      const pb = [
        "actions",
        "children",
        "defaultValue",
        "name",
        "onChange",
        "value",
      ];
      var mb = t.forwardRef(function (n, r) {
          const {
              actions: o,
              children: a,
              defaultValue: i,
              name: s,
              onChange: l,
              value: c,
            } = n,
            u = (0, jt.Z)(n, pb),
            p = t.useRef(null),
            [m, h] = (0, ll.Z)({
              controlled: c,
              default: i,
              name: "RadioGroup",
            });
          t.useImperativeHandle(
            o,
            () => ({
              focus: () => {
                let e = p.current.querySelector("input:not(:disabled):checked");
                e || (e = p.current.querySelector("input:not(:disabled)")),
                  e && e.focus();
              },
            }),
            []
          );
          const f = (0, cn.Z)(r, p),
            g = (0, sl.Z)(s),
            v = t.useMemo(
              () => ({
                name: g,
                onChange(e) {
                  h(e.target.value), l && l(e, e.target.value);
                },
                value: m,
              }),
              [g, l, h, m]
            );
          return (0,
          e.jsx)(db.Provider, { value: v, children: (0, e.jsx)(ub, (0, d.Z)({ role: "radiogroup", ref: f }, u, { children: a })) });
        }),
        hb = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
          }),
          "RadioButtonUnchecked"
        ),
        fb = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z",
          }),
          "RadioButtonChecked"
        );
      const gb = (0, Lt.ZP)("span", { shouldForwardProp: so.Z })({
          position: "relative",
          display: "flex",
        }),
        vb = (0, Lt.ZP)(hb)({ transform: "scale(1)" }),
        bb = (0, Lt.ZP)(fb)(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              left: 0,
              position: "absolute",
              transform: "scale(0)",
              transition: e.transitions.create("transform", {
                easing: e.transitions.easing.easeIn,
                duration: e.transitions.duration.shortest,
              }),
            },
            t.checked && {
              transform: "scale(1)",
              transition: e.transitions.create("transform", {
                easing: e.transitions.easing.easeOut,
                duration: e.transitions.duration.shortest,
              }),
            }
          )
        );
      var _b = function (t) {
          const { checked: n = !1, classes: r = {}, fontSize: o } = t,
            a = (0, d.Z)({}, t, { checked: n });
          return (0, e.jsxs)(gb, {
            className: r.root,
            ownerState: a,
            children: [
              (0, e.jsx)(vb, {
                fontSize: o,
                className: r.background,
                ownerState: a,
              }),
              (0, e.jsx)(bb, { fontSize: o, className: r.dot, ownerState: a }),
            ],
          });
        },
        yb = o(7450);
      function xb(e) {
        return (0, Zt.ZP)("MuiRadio", e);
      }
      var Cb = (0, Bt.Z)("MuiRadio", [
        "root",
        "checked",
        "disabled",
        "colorPrimary",
        "colorSecondary",
        "sizeSmall",
      ]);
      const Sb = [
          "checked",
          "checkedIcon",
          "color",
          "icon",
          "name",
          "onChange",
          "size",
          "className",
        ],
        kb = (0, Lt.ZP)(am, {
          shouldForwardProp: (e) => (0, so.Z)(e) || "classes" === e,
          name: "MuiRadio",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              "medium" !== n.size && t[`size${(0, Fn.Z)(n.size)}`],
              t[`color${(0, Fn.Z)(n.color)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            { color: (e.vars || e).palette.text.secondary },
            !t.disableRipple && {
              "&:hover": {
                backgroundColor: e.vars
                  ? `rgba(${
                      "default" === t.color
                        ? e.vars.palette.action.activeChannel
                        : e.vars.palette[t.color].mainChannel
                    } / ${e.vars.palette.action.hoverOpacity})`
                  : (0, At.Fq)(
                      "default" === t.color
                        ? e.palette.action.active
                        : e.palette[t.color].main,
                      e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
            },
            "default" !== t.color && {
              [`&.${Cb.checked}`]: {
                color: (e.vars || e).palette[t.color].main,
              },
            },
            {
              [`&.${Cb.disabled}`]: {
                color: (e.vars || e).palette.action.disabled,
              },
            }
          )
        ),
        wb = (0, e.jsx)(_b, { checked: !0 }),
        Pb = (0, e.jsx)(_b, {}),
        Ob = t.forwardRef(function (n, r) {
          var o, a;
          const i = (0, zt.Z)({ props: n, name: "MuiRadio" }),
            {
              checked: s,
              checkedIcon: l = wb,
              color: c = "primary",
              icon: u = Pb,
              name: p,
              onChange: m,
              size: h = "medium",
              className: f,
            } = i,
            g = (0, jt.Z)(i, Sb),
            v = (0, d.Z)({}, i, { color: c, size: h }),
            b = ((e) => {
              const { classes: t, color: n, size: r } = e,
                o = {
                  root: [
                    "root",
                    `color${(0, Fn.Z)(n)}`,
                    "medium" !== r && `size${(0, Fn.Z)(r)}`,
                  ],
                };
              return (0, d.Z)({}, t, (0, Nt.Z)(o, xb, t));
            })(v),
            _ = t.useContext(db);
          let y = s;
          const x = (0, yb.Z)(m, _ && _.onChange);
          let C = p;
          return (
            _ &&
              (void 0 === y &&
                ((S = _.value),
                (y =
                  "object" == typeof (k = i.value) && null !== k
                    ? S === k
                    : String(S) === String(k))),
              void 0 === C && (C = _.name)),
            (0, e.jsx)(
              kb,
              (0, d.Z)(
                {
                  type: "radio",
                  icon: t.cloneElement(u, {
                    fontSize: null != (o = Pb.props.fontSize) ? o : h,
                  }),
                  checkedIcon: t.cloneElement(l, {
                    fontSize: null != (a = wb.props.fontSize) ? a : h,
                  }),
                  ownerState: v,
                  classes: b,
                  name: C,
                  checked: y,
                  onChange: x,
                  ref: r,
                  className: (0, Rt.Z)(b.root, f),
                },
                g
              )
            )
          );
          var S, k;
        });
      var Ib = Ob,
        Tb = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m13.5-9 1.96 2.5H17V9.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5",
          }),
          "LocalShipping"
        ),
        Mb = (0, bo.Z)(
          (0, e.jsx)("path", { d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" }),
          "Send"
        ),
        Eb = new RegExp("^[0-9]+$"),
        Db = new RegExp(""),
        jb = new RegExp("^[0-9]+$"),
        Rb = function (e) {
          return !e.match(lv);
        },
        Nb = function (e) {
          return !e.match(Eb);
        },
        Ab = function (e) {
          return !e.match(Db);
        },
        Lb = function (e) {
          return !e.match(jb);
        },
        zb = o(8699),
        Bb = function () {
          return (
            (Bb =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Bb.apply(this, arguments)
          );
        },
        Zb = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Fb = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function Hb() {
        var e,
          n = this,
          r = X().t,
          o = g(),
          a = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          i = (0, t.useState)(""),
          s = i[0],
          l = i[1],
          c = (0, t.useState)(""),
          u = c[0],
          d = c[1],
          p = (0, t.useState)(""),
          m = p[0],
          h = p[1],
          f = (0, t.useState)(""),
          v = f[0],
          b = f[1],
          _ = (0, t.useState)(""),
          x = _[0],
          C = _[1],
          S = (0, t.useState)(""),
          k = S[0],
          w = S[1],
          P = (0, t.useState)(""),
          O = P[0],
          I = P[1],
          T = (0, t.useState)(""),
          M = T[0],
          E = T[1],
          D = (0, t.useState)(""),
          R = D[0],
          N = D[1],
          A = (0, t.useState)(""),
          L = A[0],
          B = A[1],
          Z = (0, t.useState)(""),
          F = Z[0],
          H = Z[1],
          V = (0, t.useState)("United States of America"),
          W = V[0],
          $ = V[1],
          U = (0, t.useState)("us"),
          K = U[0],
          G = U[1],
          q = (0, t.useState)(""),
          Y = q[0],
          J = q[1],
          Q = (0, t.useState)((0, zb.getStates)("us")),
          ee = Q[0],
          te = Q[1],
          ne = (0, t.useState)([]),
          re = ne[0],
          oe = ne[1],
          ae = (0, t.useState)(!1),
          ie = ae[0],
          se = ae[1],
          le = (0, t.useState)(!1),
          ce = le[0],
          ue = le[1],
          de = (0, t.useState)(!1),
          pe = de[0],
          me = de[1],
          he = (0, t.useState)([]),
          fe = he[0],
          ge = he[1],
          ve = (0, t.useState)(
            null !== (e = null == a ? void 0 : a.editDraftOrder) && void 0 !== e
              ? e
              : {}
          ),
          be = ve[0],
          _e = ve[1],
          ye = a.baseData.select ? a.baseData.select : {},
          xe = (0, t.useState)({
            customername: !1,
            email: !1,
            mobilenumber: !1,
          }),
          Ce = xe[0],
          Se = xe[1],
          ke = function (e, t) {
            o({ payload: e, type: t });
          },
          we = function () {
            d(""),
              h(""),
              b(""),
              H(""),
              oe([]),
              ge([]),
              ke({}, j.CREATE_ORDER_TAB);
          },
          Pe = function (e) {
            return Zb(n, void 0, void 0, function () {
              var t, n, r, a, i, s;
              return Fb(this, function (c) {
                switch (c.label) {
                  case 0:
                    return (
                      H(""),
                      oe([]),
                      e
                        ? (mf.next(!0),
                          [
                            4,
                            o(
                              xg(
                                null !== (n = e.CustomerId) && void 0 !== n
                                  ? n
                                  : ""
                              )
                            ),
                          ])
                        : [3, 2]
                    );
                  case 1:
                    (t = c.sent()),
                      mf.next(!1),
                      l(
                        (null !== (r = e.CustomerName) && void 0 !== r
                          ? r
                          : ""
                        ).trim()
                          ? e.CustomerName
                          : e.CustomerMailid
                      ),
                      h(
                        null !== (a = e.CustomerMailid) && void 0 !== a ? a : ""
                      ),
                      b(null !== (i = e.CompanyName) && void 0 !== i ? i : ""),
                      "" === e.CustomerPhoneno ||
                      null === e.CustomerPhoneno ||
                      void 0 === e.CustomerPhoneno
                        ? Oe()
                        : d(e.CustomerPhoneno),
                      t && z.getState().salesRepData.wholesalePriceData
                        ? Ie(t)
                        : (ge([]),
                          ke({ wholePriceArray: [] }, j.CREATE_ORDER_TAB)),
                      t &&
                        oe(
                          null ===
                            (s =
                              z.getState().salesRepData
                                .customerNewUpdatedData) || void 0 === s
                            ? void 0
                            : s.customerAddressesList
                        ),
                      (c.label = 2);
                  case 2:
                    return (
                      ((u = Bb({}, Ce)).customername = !1),
                      (u.email = !1),
                      (u.mobilenumber = !1),
                      Se(Bb({}, u)),
                      [2]
                    );
                }
                var u;
              });
            });
          },
          Oe = function () {
            var e,
              t,
              n =
                null ===
                  (t =
                    null ===
                      (e = z.getState().salesRepData.customerNewUpdatedData) ||
                    void 0 === e
                      ? void 0
                      : e.SingleShopifyCustomers) || void 0 === t
                  ? void 0
                  : t.phone;
            null != n && d(n || "");
          },
          Ie = function (e) {
            var t, n, r, o, a, i;
            ge([]), ke({ wholePriceArray: [] }, j.CREATE_ORDER_TAB);
            var s =
                z.getState().salesRepData.wholesalePriceData.AllWholesalePrices,
              l =
                null ===
                  (r =
                    null ===
                      (n =
                        null === (t = null == e ? void 0 : e.payload) ||
                        void 0 === t
                          ? void 0
                          : t.SingleShopifyCustomers) || void 0 === n
                      ? void 0
                      : n.tags) || void 0 === r
                  ? void 0
                  : r.split(","),
              c =
                null == l
                  ? void 0
                  : l.some(function (e) {
                      var t;
                      return null ===
                        (t = null == e ? void 0 : e.toLowerCase()) ||
                        void 0 === t
                        ? void 0
                        : t.includes("price_");
                    });
            if ((null == ye ? void 0 : ye.PriceList) && c && null != s)
              try {
                var u =
                    null == Object
                      ? void 0
                      : Object.keys(
                          JSON.parse(
                            s[null == Object ? void 0 : Object.keys(s)[0]]
                          )
                        ),
                  d =
                    (null ===
                      (o =
                        null == l
                          ? void 0
                          : l.find(function (e) {
                              var t;
                              return null == u
                                ? void 0
                                : u.includes(
                                    null === (t = e.trim()) || void 0 === t
                                      ? void 0
                                      : t.toLowerCase()
                                  );
                            })) || void 0 === o
                      ? void 0
                      : o.toLowerCase().trim()) || "";
                if (d) {
                  var p =
                    null ===
                      (i =
                        null === (a = Object.keys(s)) || void 0 === a
                          ? void 0
                          : a.map(function (e) {
                              try {
                                return {
                                  variantId: e,
                                  wholesalePrice: JSON.parse(s[e])[d],
                                };
                              } catch (e) {
                                return null;
                              }
                            })) || void 0 === i
                      ? void 0
                      : i.filter(function (e) {
                          return null !== e;
                        });
                  ge(p), ke({ wholePriceArray: p }, j.CREATE_ORDER_TAB);
                }
              } catch (e) {
                return [];
              }
          };
        return {
          getCountries: zb.getCountries,
          t: r,
          dispatch: o,
          salesRepData: a,
          customerName: s,
          setCustomerName: l,
          mobileNumber: u,
          setMobileNumber: d,
          emailId: m,
          setEmailId: h,
          companyName: v,
          setCompanyName: b,
          firstName: x,
          setFirstName: C,
          lastName: k,
          setLastName: w,
          address1: O,
          setAddress1: I,
          address2: M,
          setAddress2: E,
          city: R,
          setCity: N,
          zipNumber: L,
          setZipNumber: B,
          selectShippingAddress: F,
          setSelectShippingAddress: H,
          selectCountry: W,
          setSelectCountry: $,
          selectCountryState: Y,
          setSelectSelectCountryState: J,
          countriesStateData: ee,
          setCountriesStateData: te,
          addDetailsBtn: ie,
          setAddDetailsBtn: se,
          addShippingAddressBtn: ce,
          setAddShippingAddressBtn: ue,
          errors: Ce,
          setErrors: Se,
          EmptyFields: we,
          SearchByCustomer: Pe,
          SearchByCountry: function (e) {
            te([]), J("");
            var t = (0, zb.getCountries)().filter(function (t) {
              return t.name.toLowerCase().includes(e.toLowerCase());
            });
            G(t[0].code), te((0, zb.getStates)(t[0].code));
          },
          checkValidation: function (e, t) {
            var n = Bb({}, Ce),
              o = e.target.name;
            switch (t) {
              case "validateOnemail":
                Rb(e.target.value.trim())
                  ? ((n[o] = !0),
                    "email" === o &&
                      (n[o] =
                        "" === e.target.value.trim()
                          ? r("customerInvoice_RequiredErrorMsg")
                          : r("customerInvoice_EmailSuggestionErrorMsg")))
                  : (n[o] = !1);
                break;
              case "validateOnmobileNumber":
                Nb(e.target.value.trim())
                  ? ((n[o] = !0),
                    "mobilenumber" === o &&
                      (n[o] =
                        "" !== e.target.value.trim()
                          ? r("customerInvoice_MobileSuggestionErrorMsg")
                          : ""))
                  : (n[o] = !1);
                break;
              case "validateOnstring":
                Ab(e.target.value)
                  ? ((n[o] = !0),
                    "customername" === o &&
                      (n[o] =
                        "" === e.target.value
                          ? r("customerInvoice_RequiredErrorMsg")
                          : ""))
                  : (n[o] = !1);
                break;
              case "validateOnzipNumber":
                Lb(e.target.value) ? (n[o] = !0) : (n[o] = !1);
            }
            Se(Bb({}, n));
          },
          setOrderCreateBtn: me,
          orderCreateBtn: pe,
          tagWiseWholeSalePrices: fe,
          customerAddressOptionsData: re,
          setCustomerAddressOptionsData: oe,
          selectCountryCode: K,
          editOrderReduxData: be,
          editOrderFlag: Hv,
          handleCustomerChange: function (e, t) {
            Pe(t),
              "string" == typeof t
                ? l("")
                : t && t.inputValue
                ? (l(t.inputValue), ("" === t && "" === s) || we())
                : null === t
                ? we()
                : l(t.CustomerName);
          },
          handleGetOptionLabel: function (e) {
            return "string" == typeof e
              ? e
              : e.inputValue
              ? e.inputValue
              : e.CustomerName;
          },
          setEditOrderReduxData: _e,
          setTagWiseWholeSalePrices: ge,
          handleSelectShippingAddress: function (e) {
            var t,
              n,
              r,
              o =
                null !==
                  (n =
                    null === (t = z.getState().salesRepData) || void 0 === t
                      ? void 0
                      : t.createOrderTab) && void 0 !== n
                  ? n
                  : {},
              a =
                null === (r = e.target.value) || void 0 === r
                  ? void 0
                  : r.toString();
            H(a),
              ke(
                Bb(Bb({}, o), { customer_shippingaddressID: a }),
                j.CREATE_ORDER_TAB
              );
          },
        };
      }
      var Vb = function () {
          return (
            (Vb =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Vb.apply(this, arguments)
          );
        },
        Wb = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        $b = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Ub = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      var Kb = function () {
          return (
            (Kb =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Kb.apply(this, arguments)
          );
        },
        Gb = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        qb = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Yb = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        },
        Jb = function () {
          return (
            (Jb =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Jb.apply(this, arguments)
          );
        };
      function Qb(n) {
        var r,
          o,
          a = Gv(),
          i = a.getProductTableRenderPopup,
          s = a.handleProductTableGuidePopup,
          l = a.checkVariantIsSoldOut,
          c = a.checkAllVariantsSoldOutInProduct,
          u = a.filterVariantsWithOutSoldOut,
          d = a.showInventoryQuantity,
          p = Hb(),
          m = p.orderCreateBtn,
          h = p.setOrderCreateBtn,
          f = (function (e) {
            var n,
              r,
              o,
              a,
              i,
              s,
              l,
              c = this,
              u = Hb().setOrderCreateBtn,
              d = X().t,
              p = Qg("(max-width: 600px)"),
              m = (function () {
                var e,
                  t,
                  n,
                  r,
                  o,
                  a,
                  i = this,
                  s = g(),
                  l = Gv().filterVariantsWithOutSoldOut,
                  c = X().t,
                  u =
                    null !==
                      (t =
                        null === (e = z.getState().salesRepData) || void 0 === e
                          ? void 0
                          : e.editDraftOrder) && void 0 !== t
                      ? t
                      : {},
                  d =
                    null !==
                      (o =
                        null ===
                          (r =
                            null === (n = z.getState().salesRepData) ||
                            void 0 === n
                              ? void 0
                              : n.baseData) || void 0 === r
                          ? void 0
                          : r.select) && void 0 !== o
                      ? o
                      : {},
                  p =
                    null !== (a = null == u ? void 0 : u.draftOrderObj) &&
                    void 0 !== a
                      ? a
                      : {},
                  m = function (e) {
                    return Wb(i, void 0, void 0, function () {
                      var t,
                        n,
                        r,
                        o,
                        a,
                        i,
                        s,
                        l,
                        u,
                        d,
                        m,
                        h,
                        f,
                        g,
                        v,
                        b,
                        _,
                        y,
                        x,
                        C,
                        S,
                        k,
                        w,
                        P,
                        O,
                        I,
                        T,
                        M,
                        E,
                        D,
                        R,
                        N,
                        A,
                        L,
                        B,
                        Z,
                        F,
                        H,
                        V;
                      return $b(this, function (W) {
                        (t =
                          null !==
                            (u = null == p ? void 0 : p.shipping_Address) &&
                          void 0 !== u
                            ? u
                            : {}),
                          (n =
                            null !==
                              (h =
                                null ===
                                  (m =
                                    null === (d = z.getState().salesRepData) ||
                                    void 0 === d
                                      ? void 0
                                      : d.customerNewUpdatedData) ||
                                void 0 === m
                                  ? void 0
                                  : m.customerAddressesList) && void 0 !== h
                              ? h
                              : []),
                          (r =
                            null ===
                              (g =
                                null === (f = z.getState().salesRepData) ||
                                void 0 === f
                                  ? void 0
                                  : f.customerNewUpdatedData) || void 0 === g
                              ? void 0
                              : g.SingleShopifyCustomers),
                          (o =
                            null !==
                              (b =
                                null === (v = z.getState().salesRepData) ||
                                void 0 === v
                                  ? void 0
                                  : v.createOrderTab) && void 0 !== b
                              ? b
                              : {}),
                          (a = !1);
                        try {
                          for (i = 0; i < n.length; i++)
                            if (
                              (null == t ? void 0 : t.address1) ===
                                (null === (_ = n[i]) || void 0 === _
                                  ? void 0
                                  : _.address1) &&
                              (null == t ? void 0 : t.city) ===
                                (null === (y = n[i]) || void 0 === y
                                  ? void 0
                                  : y.city) &&
                              (null == t ? void 0 : t.country) ===
                                (null === (x = n[i]) || void 0 === x
                                  ? void 0
                                  : x.country) &&
                              (null == t ? void 0 : t.province) ===
                                (null === (C = n[i]) || void 0 === C
                                  ? void 0
                                  : C.province) &&
                              (null == t ? void 0 : t.zip) ===
                                (null === (S = n[i]) || void 0 === S
                                  ? void 0
                                  : S.zip)
                            ) {
                              null === (k = null == e ? void 0 : e.props) ||
                                void 0 === k ||
                                k.setSelectShippingAddress(
                                  null === (w = n[i]) || void 0 === w
                                    ? void 0
                                    : w.id.toString()
                                ),
                                null == e ||
                                  e.handleUpdateReduxState(
                                    Vb(Vb({}, o), {
                                      customer_shippingaddressID:
                                        null === (P = n[i]) || void 0 === P
                                          ? void 0
                                          : P.id.toString(),
                                    }),
                                    j.CREATE_ORDER_TAB
                                  ),
                                (a = !0);
                              break;
                            }
                          !a &&
                          ((null == t ? void 0 : t.address1) ||
                            (null == t ? void 0 : t.city) ||
                            (null == t ? void 0 : t.province) ||
                            (null == t ? void 0 : t.country))
                            ? ((s = {
                                address1:
                                  null !==
                                    (O = null == t ? void 0 : t.address1) &&
                                  void 0 !== O
                                    ? O
                                    : "",
                                address2:
                                  null !==
                                    (I = null == t ? void 0 : t.address2) &&
                                  void 0 !== I
                                    ? I
                                    : "",
                                city:
                                  null !== (T = null == t ? void 0 : t.city) &&
                                  void 0 !== T
                                    ? T
                                    : "",
                                company:
                                  null !==
                                    (M = null == t ? void 0 : t.company) &&
                                  void 0 !== M
                                    ? M
                                    : "",
                                country:
                                  null !==
                                    (E = null == t ? void 0 : t.country) &&
                                  void 0 !== E
                                    ? E
                                    : "",
                                customer_id: (null !==
                                  (R =
                                    null ===
                                      (D = null == p ? void 0 : p.customer) ||
                                    void 0 === D
                                      ? void 0
                                      : D.id) && void 0 !== R
                                  ? R
                                  : ""
                                ).toString(),
                                defaultAddr: !1,
                                email:
                                  null !== (N = null == t ? void 0 : t.email) &&
                                  void 0 !== N
                                    ? N
                                    : "",
                                first_name:
                                  null !==
                                    (A = null == t ? void 0 : t.first_name) &&
                                  void 0 !== A
                                    ? A
                                    : "",
                                id: 12345,
                                last_name:
                                  null !==
                                    (L = null == t ? void 0 : t.last_name) &&
                                  void 0 !== L
                                    ? L
                                    : "",
                                phone:
                                  null !== (B = null == t ? void 0 : t.phone) &&
                                  void 0 !== B
                                    ? B
                                    : "",
                                province:
                                  null !==
                                    (Z = null == t ? void 0 : t.province) &&
                                  void 0 !== Z
                                    ? Z
                                    : "",
                                zip:
                                  null !== (F = null == t ? void 0 : t.zip) &&
                                  void 0 !== F
                                    ? F
                                    : "",
                              }),
                              (l = {
                                customerAddressesList: Ub(
                                  Ub([], n, !0),
                                  [s],
                                  !1
                                ),
                                SingleShopifyCustomers: r,
                              }),
                              null == e ||
                                e.handleUpdateReduxState(
                                  l,
                                  j.CUSTOMER_ADDRESS_DATA
                                ),
                              null === (H = null == e ? void 0 : e.props) ||
                                void 0 === H ||
                                H.setCustomerAddressOptionsData(
                                  Ub(Ub([], n, !0), [s], !1)
                                ),
                              null === (V = null == e ? void 0 : e.props) ||
                                void 0 === V ||
                                V.setSelectShippingAddress(
                                  null == s ? void 0 : s.id.toString()
                                ),
                              null == e ||
                                e.handleUpdateReduxState(
                                  Vb(Vb({}, o), {
                                    customer_shippingaddressID:
                                      null == s ? void 0 : s.id.toString(),
                                  }),
                                  j.CREATE_ORDER_TAB
                                ),
                              (a = !0))
                            : a ||
                              null == e ||
                              e.setAlertErrorMsg({
                                msg: c(
                                  "customerInvoice_EditOrder_NoAutoSelectedAddress"
                                ),
                                open: !0,
                              });
                        } catch (t) {
                          null == e ||
                            e.setAlertErrorMsg({
                              msg: c(
                                "customerInvoice_EditOrder_NoAutoSelectedAddress"
                              ),
                              open: !0,
                            });
                        }
                        return [2, a];
                      });
                    });
                  },
                  h = function (e, t) {
                    return Wb(i, void 0, void 0, function () {
                      var n, r, o, a, i, s, l, u, d;
                      return $b(this, function (m) {
                        switch (m.label) {
                          case 0:
                            return (
                              (n = !1),
                              e &&
                              ((null ===
                                (a = null == p ? void 0 : p.shipping_line) ||
                              void 0 === a
                                ? void 0
                                : a.title) ||
                                (null ===
                                  (i = null == p ? void 0 : p.shipping_line) ||
                                void 0 === i
                                  ? void 0
                                  : i.price))
                                ? [
                                    4,
                                    null == t
                                      ? void 0
                                      : t.GetShippingRatesOnSelectedAddress(),
                                  ]
                                : [3, 2]
                            );
                          case 1:
                            m.sent()
                              ? ((r =
                                  null !==
                                    (u =
                                      null ===
                                        (l =
                                          null ===
                                            (s =
                                              null == p
                                                ? void 0
                                                : p.shipping_line) ||
                                          void 0 === s
                                            ? void 0
                                            : s.price) || void 0 === l
                                        ? void 0
                                        : l.toFixed(2)) && void 0 !== u
                                    ? u
                                    : ""),
                                (o = ""
                                  .concat(
                                    null ===
                                      (d =
                                        null == p ? void 0 : p.shipping_line) ||
                                      void 0 === d
                                      ? void 0
                                      : d.title,
                                    "/"
                                  )
                                  .concat(r)),
                                null == t || t.setShippingCost(o),
                                null == t || t.setApplyShippingCost("Yes"),
                                (n = !0))
                              : null == t ||
                                t.setAlertErrorMsg({
                                  msg: c(
                                    "customerInvoice_EditOrder_NoAutoSelectedShippingCost"
                                  ),
                                  open: !0,
                                }),
                              (m.label = 2);
                          case 2:
                            return [2, n];
                        }
                      });
                    });
                  },
                  f = function (e, t) {
                    return Wb(i, void 0, void 0, function () {
                      var n, r, o, a, i, l, u, d, p, m, h, f;
                      return $b(this, function (g) {
                        switch (g.label) {
                          case 0:
                            for (
                              n = !1, r = !1, o = [], a = 0;
                              a < t.length;
                              a++
                            )
                              (null === (u = t[a]) || void 0 === u
                                ? void 0
                                : u.variantId) &&
                                (null === (d = t[a]) || void 0 === d
                                  ? void 0
                                  : d.quantity) &&
                                o.push({
                                  id:
                                    null !==
                                      (m =
                                        null === (p = t[a]) || void 0 === p
                                          ? void 0
                                          : p.variantId) && void 0 !== m
                                      ? m
                                      : "",
                                  quantity:
                                    null !==
                                      (f =
                                        null === (h = t[a]) || void 0 === h
                                          ? void 0
                                          : h.quantity) && void 0 !== f
                                      ? f
                                      : 0,
                                });
                            return (
                              (i = function (e, t) {
                                "Request failed with status code 404" === e
                                  ? null == t ||
                                    t.setAlertErrorMsg({
                                      msg: c(
                                        "customerInvoice_EditOrder_ErrorMsgForCartUpdate"
                                      ),
                                      open: !0,
                                    })
                                  : null == t ||
                                    t.setAlertErrorMsg({ msg: e, open: !0 });
                              }),
                              [4, s(Wg({}, "clear.js"))]
                            );
                          case 1:
                            return "boolean" != typeof (l = g.sent()) ||
                              !0 !== l
                              ? [3, 3]
                              : [4, s(Wg(o, "add.js"))];
                          case 2:
                            return (
                              "boolean" == typeof (r = g.sent()) && !0 === r
                                ? (n = !0)
                                : i(r, e),
                              [3, 4]
                            );
                          case 3:
                            i(l, e), (g.label = 4);
                          case 4:
                            return [2, n];
                        }
                      });
                    });
                  },
                  v = function (e) {
                    return Wb(i, void 0, void 0, function () {
                      var t, n, r, o, a, i, s, l, c, u, d, m, h, f;
                      return $b(this, function (g) {
                        switch (g.label) {
                          case 0:
                            return (
                              (t = {
                                CustomerId:
                                  null !==
                                    (r =
                                      null ===
                                        (n = null == p ? void 0 : p.customer) ||
                                      void 0 === n
                                        ? void 0
                                        : n.id) && void 0 !== r
                                    ? r
                                    : "",
                                CustomerName: (
                                  (null !==
                                    (a =
                                      null ===
                                        (o = null == p ? void 0 : p.customer) ||
                                      void 0 === o
                                        ? void 0
                                        : o.first_name) && void 0 !== a
                                    ? a
                                    : "") +
                                  " " +
                                  (null !==
                                    (s =
                                      null ===
                                        (i = null == p ? void 0 : p.customer) ||
                                      void 0 === i
                                        ? void 0
                                        : i.last_name) && void 0 !== s
                                    ? s
                                    : "")
                                ).trim(),
                                CustomerMailid:
                                  null !==
                                    (c =
                                      null ===
                                        (l = null == p ? void 0 : p.customer) ||
                                      void 0 === l
                                        ? void 0
                                        : l.email) && void 0 !== c
                                    ? c
                                    : "",
                                CompanyName:
                                  null !==
                                    (d =
                                      null ===
                                        (u =
                                          null == p
                                            ? void 0
                                            : p.shipping_Address) ||
                                      void 0 === u
                                        ? void 0
                                        : u.company) && void 0 !== d
                                    ? d
                                    : "",
                                CustomerPhoneno:
                                  null !==
                                    (h =
                                      null ===
                                        (m =
                                          null == p
                                            ? void 0
                                            : p.shipping_Address) ||
                                      void 0 === m
                                        ? void 0
                                        : m.phone) && void 0 !== h
                                    ? h
                                    : "",
                              }),
                              [
                                4,
                                null === (f = null == e ? void 0 : e.props) ||
                                void 0 === f
                                  ? void 0
                                  : f.SearchByCustomer(t),
                              ]
                            );
                          case 1:
                            return g.sent(), [2];
                        }
                      });
                    });
                  };
                return {
                  updateStateForEditOrder: function (e, t) {
                    return Wb(i, void 0, void 0, function () {
                      var n, r, o;
                      return $b(this, function (a) {
                        switch (a.label) {
                          case 0:
                            return "autoFatchDataForEditOrder" === e
                              ? [3, 1]
                              : [3, 9];
                          case 1:
                            return mf.next(!0), [4, v(t)];
                          case 2:
                            return a.sent(), [4, m(t)];
                          case 3:
                            return (
                              (n = a.sent()),
                              [
                                4,
                                Wb(i, void 0, void 0, function () {
                                  var e, t;
                                  return $b(this, function (n) {
                                    switch (n.label) {
                                      case 0:
                                        return [
                                          4,
                                          l({
                                            variants:
                                              null == u
                                                ? void 0
                                                : u.productDetailsArray,
                                          }),
                                        ];
                                      case 1:
                                        return (
                                          (e = n.sent()),
                                          [
                                            2,
                                            null !==
                                              (t =
                                                null == e
                                                  ? void 0
                                                  : e.variants) && void 0 !== t
                                              ? t
                                              : null == u
                                              ? void 0
                                              : u.productDetailsArray,
                                          ]
                                        );
                                    }
                                  });
                                }),
                              ]
                            );
                          case 4:
                            return (null == (r = a.sent())
                              ? void 0
                              : r.length) > 0
                              ? [4, f(t, r)]
                              : [3, 7];
                          case 5:
                            return (
                              (function (e, t, n) {
                                var r;
                                if (e)
                                  try {
                                    for (
                                      var o = [],
                                        a = {},
                                        i = {},
                                        s = {},
                                        l = 0,
                                        p = n;
                                      l < p.length;
                                      l++
                                    ) {
                                      var m = p[l];
                                      if (0 !== Object.keys(m).length) {
                                        var h = m.productId,
                                          f = void 0 === h ? "0" : h,
                                          g = m.variantId,
                                          v = void 0 === g ? "0" : g,
                                          b = m.quantity,
                                          _ = void 0 === b ? 0 : b,
                                          y = m.ItemPrice,
                                          x = void 0 === y ? 0 : y,
                                          C = m.Image,
                                          S = void 0 === C ? "" : C,
                                          k = m.Title,
                                          w = void 0 === k ? "" : k,
                                          P = m.type,
                                          O = void 0 === P ? "" : P,
                                          I = m.tags,
                                          T = void 0 === I ? "" : I,
                                          M = m.inventoryQuantity,
                                          E = void 0 === M ? 0 : M,
                                          D = m.SKU,
                                          j = void 0 === D ? "" : D,
                                          R = m.variantTitle,
                                          N = void 0 === R ? "" : R,
                                          A = m.inventory_policy,
                                          L = void 0 === A ? "" : A,
                                          z = m.inventory_management,
                                          B = void 0 === z ? "" : z;
                                        (a[f] = f), (i[v] = _), (s[v] = x * _);
                                        var Z = {
                                            productId: parseInt(f),
                                            productImages: S
                                              ? [
                                                  {
                                                    imageId: parseInt(v),
                                                    src: S,
                                                  },
                                                ]
                                              : [],
                                            productTitle: w,
                                            product_type: O,
                                            tags: T,
                                            variants: [
                                              {
                                                image_id: parseInt(v),
                                                inventory_quantity: E,
                                                product_id: parseInt(f),
                                                sku: j,
                                                variantId: parseInt(v),
                                                variantPrice: x,
                                                variantTitle: N,
                                                quantity: _,
                                                wholesalePrice: 0,
                                                inventory_policy: L,
                                                inventory_management: B,
                                              },
                                            ],
                                          },
                                          F = o.find(function (e) {
                                            return e.productId === Z.productId;
                                          });
                                        F
                                          ? (r = F.variants).push.apply(
                                              r,
                                              Z.variants
                                            )
                                          : o.push(Z);
                                      }
                                    }
                                    null == t || t.setProduct_idObject(a),
                                      null == t || t.setVariant_idObject(i),
                                      null == t || t.setSubtotal(s),
                                      null == t || t.setProductSelectedArray(o),
                                      (null == d ? void 0 : d.PriceList) &&
                                        (null == t ||
                                          t.addWholeSalePrice(
                                            o,
                                            null == u ? void 0 : u.actionEvent
                                          ));
                                  } catch (e) {
                                    null == t ||
                                      t.setAlertErrorMsg({
                                        msg: c(
                                          "customerInvoice_EditOrder_ErrorMsgForProductSelected"
                                        ),
                                        open: !0,
                                      });
                                  }
                              })(a.sent(), t, r),
                              null == t ||
                                t.setOrderNotes(
                                  null !== (o = null == p ? void 0 : p.note) &&
                                    void 0 !== o
                                    ? o
                                    : ""
                                ),
                              [4, h(n, t)]
                            );
                          case 6:
                            return a.sent(), [3, 8];
                          case 7:
                            null == t ||
                              t.setAlertErrorMsg({
                                msg: c("productsMayBeSoldOutPleaseCheck"),
                                open: !0,
                              }),
                              (a.label = 8);
                          case 8:
                            return mf.next(!1), [3, 10];
                          case 9:
                            return [2, null];
                          case 10:
                            return [2];
                        }
                      });
                    });
                  },
                };
              })().updateStateForEditOrder,
              h = g(),
              f = y(function (e) {
                return e.salesRepData ? e.salesRepData : {};
              }),
              v = f.baseData.select ? f.customerNewUpdatedData : {},
              b = Ef(),
              _ = b.shopCurrency,
              x = b.shopName,
              C = 10,
              S = (0, t.useState)(f ? f.productsData.slice(0, C) : []),
              k = S[0],
              w = S[1],
              P = (0, t.useState)(""),
              O = P[0],
              I = P[1],
              T = (0, t.useState)(""),
              M = T[0],
              E = T[1],
              D = (0, t.useState)({ msg: "", color: "blue" }),
              R = D[0],
              N = D[1],
              A = (0, t.useState)({}),
              L = A[0],
              B = A[1],
              Z = (0, t.useState)(0),
              F = Z[0],
              H = Z[1],
              V = (0, t.useState)(!1),
              W = V[0],
              $ = V[1],
              U = (0, t.useState)({}),
              K = U[0],
              G = U[1],
              q = (0, t.useState)({}),
              Y = q[0],
              J = q[1],
              Q = (0, t.useState)([]),
              ee = Q[0],
              te = Q[1],
              ne = (0, t.useState)(),
              re = ne[0],
              oe = ne[1],
              ae = (0, t.useState)(!1),
              ie = ae[0],
              se = ae[1],
              le = (0, t.useState)([]),
              ce = le[0],
              ue = le[1],
              de =
                z.getState().salesRepData.baseData.CustomizedBackofficeStrings,
              pe = (0, t.useState)({
                customerInvoice_contentHeading2Title3: "",
                customerInvoice_SendInvoiceBtn: "",
              }),
              me = pe[0],
              he = pe[1],
              fe = (0, t.useState)(
                !!z.getState().salesRepData.baseData.hideRetailPriceColumn &&
                  z.getState().salesRepData.baseData.hideRetailPriceColumn
              ),
              ge = fe[0],
              ve = (fe[1], (0, t.useState)("")),
              be = ve[0],
              _e = ve[1],
              ye = (0, t.useState)({ msg: "", open: !1 }),
              xe = ye[0],
              Ce = ye[1],
              Se = (0, t.useState)([]),
              ke = Se[0],
              we = Se[1],
              Pe = !1,
              Oe = (0, t.useState)(""),
              Ie = Oe[0],
              Te = Oe[1],
              Me = Ie,
              Ee = (0, t.useState)("Yes"),
              De = Ee[0],
              je = Ee[1],
              Re = (0, t.useState)(!0),
              Ne = Re[0],
              Ae = Re[1],
              Le = (0, t.useState)(!1),
              ze = Le[0],
              Be = Le[1],
              Ze = (0, t.useState)({}),
              Fe = Ze[0],
              He = Ze[1],
              Ve = (0, t.useState)(!1),
              We = Ve[0],
              $e = Ve[1],
              Ue = (
                null === (n = f.baseData) || void 0 === n ? void 0 : n.select
              )
                ? null === (r = f.baseData) || void 0 === r
                  ? void 0
                  : r.select
                : {},
              Ke = (0, t.useState)(
                null !== (o = null == f ? void 0 : f.editDraftOrder) &&
                  void 0 !== o
                  ? o
                  : {}
              ),
              Ge = Ke[0],
              qe = Ke[1],
              Ye = (0, t.useState)(!1),
              Je = Ye[0],
              Qe = Ye[1],
              Xe =
                (null === (a = null == f ? void 0 : f.editDraftOrder) ||
                void 0 === a
                  ? void 0
                  : a.actionEvent) === Hv,
              et = (0, t.useState)(!1),
              tt = et[0],
              nt = et[1],
              rt = (0, t.useState)(!0),
              ot = rt[0],
              at = rt[1],
              it = (0, t.useState)(
                null !==
                  (l =
                    null ===
                      (s =
                        null === (i = z.getState().salesRepData) || void 0 === i
                          ? void 0
                          : i.baseData) || void 0 === s
                      ? void 0
                      : s.PaymentTermsTemplates) && void 0 !== l
                  ? l
                  : []
              ),
              st = it[0],
              lt = (it[1], (0, t.useState)()),
              ct = lt[0],
              ut = lt[1],
              dt = (0, t.useState)(!1),
              pt = dt[0],
              mt = dt[1],
              ht = new Date(),
              ft =
                ht.getFullYear() +
                "-" +
                (ht.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                ht.getDate().toString().padStart(2, "0");
            (0, t.useEffect)(
              function () {
                var e;
                (null === (e = null == f ? void 0 : f.productsData) ||
                void 0 === e
                  ? void 0
                  : e.length) > 0 &&
                  (mf.next(!1), w(f.productsData.slice(0, C)), xt());
              },
              [f.productsData]
            );
            var gt = {
              newAddress: [
                {
                  0: e.customer_firstname,
                  errorMsg: d("customerInvoice_FirstNameErrorMsg"),
                },
                {
                  1: e.customer_lastname,
                  errorMsg: d("customerInvoice_lastNameErrorMsg"),
                },
                {
                  2: e.customer_address1,
                  errorMsg: d("customerInvoice_Add1ErrorMsg"),
                },
                {
                  3: e.customer_country,
                  errorMsg: d("customerInvoice_CountryErrorMsg"),
                },
                {
                  4: e.customer_state,
                  errorMsg: d("customerInvoice_StateErrorMsg"),
                },
                {
                  5: e.customer_city,
                  errorMsg: d("customerInvoice_CityErrorMsg"),
                },
                {
                  6: e.customer_zipnumber,
                  errorMsg: d("customerInvoice_ZipErrorMsg"),
                },
              ],
            };
            (0, t.useEffect)(function () {
              var t;
              0 ===
                (null === (t = null == f ? void 0 : f.productsData) ||
                void 0 === t
                  ? void 0
                  : t.length) && mf.next(!0),
                he(de[x] ? JSON.parse(de[x]) : me),
                Xe &&
                  m("autoFatchDataForEditOrder", {
                    props: e,
                    setProductSelectedArray: te,
                    setProduct_idObject: G,
                    setVariant_idObject: J,
                    setSubtotal: B,
                    setOrderNotes: E,
                    setAlertErrorMsg: Ce,
                    addWholeSalePrice: Ct,
                    setApplyShippingCost: je,
                    setShippingCost: _e,
                    GetShippingRatesOnSelectedAddress: Pt,
                    handleUpdateReduxState: It,
                  }),
                setTimeout(function () {
                  mf.next(!1);
                }, 5e3);
            }, []),
              (0, t.useEffect)(
                function () {
                  xt(), ee.length > 0 && (G({}), J({}), B({}), te([]), He({}));
                },
                [e.customer_name, e.tagWiseWholeSalePrices]
              ),
              (0, t.useEffect)(
                function () {
                  var e, t;
                  if (v) {
                    var n =
                        (null ===
                          (t =
                            null ===
                              (e =
                                null == v
                                  ? void 0
                                  : v.SingleShopifyCustomers) || void 0 === e
                              ? void 0
                              : e.tags) || void 0 === t
                          ? void 0
                          : t.split(",")) || [],
                      r =
                        null == n
                          ? void 0
                          : n.some(function (e) {
                              var t;
                              return null ===
                                (t = null == e ? void 0 : e.toLowerCase()) ||
                                void 0 === t
                                ? void 0
                                : t.includes("credit_");
                            }),
                      o =
                        null == n
                          ? void 0
                          : n.some(function (e) {
                              var t;
                              return null ===
                                (t = null == e ? void 0 : e.toLowerCase()) ||
                                void 0 === t
                                ? void 0
                                : t.includes("net_");
                            });
                    mt(r || o);
                  }
                },
                [v]
              ),
              (0, t.useEffect)(
                function () {
                  _e(""), we([]), je("Yes"), Be(!1);
                },
                [e.customer_shippingaddressID, e.customer_zipnumber]
              );
            var vt = function () {
                return (
                  $(!1),
                  (null == Ue ? void 0 : Ue.PriceList) &&
                  (null == f ? void 0 : f.productsData)
                    ? St(f.productsData.slice(0, C))
                    : w(f ? f.productsData.slice(0, C) : []),
                  "" !== O ? I("") : null
                );
              },
              bt = {
                sendInvoice: d("customerInvoice_InvoiceSentSuccessfullyMsg"),
                createOrder: d("customerInvoice_OrderCreatedSuccessfullyMsg"),
                draftOrder: d(
                  "customerInvoice_DraftOrderCreatedSuccessfullyMsg"
                ),
              },
              _t = {
                sendInvoice: d("customerInvoice_Sending_Msg"),
                createOrder: d("customerInvoice_Creating_Msg"),
                draftOrder: d("customerInvoice_CreatingDraft_Msg"),
              },
              yt = function (e) {
                return null != e;
              },
              xt = function () {
                var e = ie
                  ? ce.slice(0, k.length + C)
                  : W
                  ? ee.slice(0, k.length + C)
                  : f.productsData.slice(0, k.length + C);
                (null == Ue ? void 0 : Ue.PriceList) ? St(e) : w(e);
              },
              Ct = function (t, n) {
                var r, o, a, i, s, l;
                void 0 === n && (n = "");
                for (
                  var c = {},
                    u = {},
                    d = 0,
                    p =
                      (null == e ? void 0 : e.tagWiseWholeSalePrices) &&
                      (null == e ? void 0 : e.tagWiseWholeSalePrices.length) > 0
                        ? null == e
                          ? void 0
                          : e.tagWiseWholeSalePrices
                        : null !==
                            (a =
                              null ===
                                (o =
                                  null === (r = z.getState().salesRepData) ||
                                  void 0 === r
                                    ? void 0
                                    : r.createOrderTab) || void 0 === o
                                ? void 0
                                : o.wholePriceArray) && void 0 !== a
                        ? a
                        : [];
                  d < p.length;
                  d++
                )
                  c[(f = p[d]).variantId] = f.wholesalePrice;
                for (var m = 0, h = t; m < h.length; m++)
                  for (
                    var f, g = 0, v = (f = h[m]).variants;
                    g < v.length;
                    g++
                  ) {
                    var b = v[g];
                    if (
                      ((b.wholesalePrice =
                        null != c[b.variantId] && null !== c[b.variantId]
                          ? parseFloat(c[b.variantId])
                          : b.variantPrice),
                      n === Hv && !Je)
                    ) {
                      var _ =
                          null !== (i = null == b ? void 0 : b.variantId) &&
                          void 0 !== i
                            ? i
                            : 0,
                        y =
                          null !== (s = null == b ? void 0 : b.quantity) &&
                          void 0 !== s
                            ? s
                            : 0,
                        x =
                          null !==
                            (l = null == b ? void 0 : b.wholesalePrice) &&
                          void 0 !== l
                            ? l
                            : 0;
                      u[_] = x * y;
                    }
                  }
                n !== Hv || Je || (B(u), Qe(!0));
              },
              St = function (e) {
                Ct(e, ""), w(e);
              },
              kt = function (e, t) {
                return Gb(c, void 0, void 0, function () {
                  var n;
                  return qb(this, function (r) {
                    switch (r.label) {
                      case 0:
                        return nt(!1), [4, h(Wg(e, t))];
                      case 1:
                        return (
                          "boolean" == typeof (n = r.sent()) && !0 === n
                            ? (_e(""),
                              we([]),
                              je(""),
                              Be(!1),
                              setTimeout(function () {
                                nt(!0);
                              }, 2e3))
                            : Ce(
                                "Request failed with status code 404" === n
                                  ? {
                                      msg: d(
                                        "customerInvoice_EditOrder_ErrorMsgForCartUpdate"
                                      ),
                                      open: !0,
                                    }
                                  : { msg: n, open: !0 }
                              ),
                          [2]
                        );
                    }
                  });
                });
              },
              wt = function () {
                var t, n, r;
                "" !==
                (e.customer_shippingaddressID
                  ? e.customer_shippingaddressID.toString()
                  : null !==
                      (r =
                        null ===
                          (n =
                            null === (t = z.getState().salesRepData) ||
                            void 0 === t
                              ? void 0
                              : t.createOrderTab) || void 0 === n
                          ? void 0
                          : n.customer_shippingaddressID) && void 0 !== r
                  ? r
                  : "")
                  ? "" !== e.customer_zipnumber && "" === Ie
                    ? Ce({
                        msg: d(
                          "customerInvoice_PleaseSetAnyShippingAddressMsg"
                        ),
                        open: !0,
                      })
                    : "" === e.customer_zipnumber
                    ? ((Pe = !0),
                      Te("customerAddress"),
                      (Me = "customerAddress"))
                    : ("" !== Ie ||
                        (Te("customerAddress"), (Me = "customerAddress")),
                      (Pe = !0))
                  : (
                      null == gt
                        ? void 0
                        : gt.newAddress.every(function (e, t) {
                            return "" === e[t];
                          })
                    )
                  ? ((Pe = !1),
                    Te(""),
                    (Me = ""),
                    Ce({
                      msg: d("customerInvoice_AddShippingAddress_Msg"),
                      open: !0,
                    }))
                  : (
                      null == gt
                        ? void 0
                        : gt.newAddress.every(function (e, t) {
                            return "" !== e[t];
                          })
                    )
                  ? ((Pe = !0), Te("formAddress"), (Me = "formAddress"))
                  : Ot();
              },
              Pt = function () {
                return Gb(c, void 0, void 0, function () {
                  var t, n, r, o, a, i, s, l, c;
                  return qb(this, function (u) {
                    switch (u.label) {
                      case 0:
                        return (
                          _e(""),
                          we([]),
                          je(""),
                          Be(!1),
                          (t = []),
                          (t =
                            (null == e ? void 0 : e.customerAddressesList) &&
                            (null == e
                              ? void 0
                              : e.customerAddressesList.length) > 0
                              ? e.customerAddressesList
                              : null ===
                                  (i =
                                    null === (a = z.getState().salesRepData) ||
                                    void 0 === a
                                      ? void 0
                                      : a.customerNewUpdatedData) ||
                                void 0 === i
                              ? void 0
                              : i.customerAddressesList),
                          (n = (
                            null == e ? void 0 : e.customer_shippingaddressID
                          )
                            ? null == e
                              ? void 0
                              : e.customer_shippingaddressID.toString()
                            : null !==
                                (c =
                                  null ===
                                    (l =
                                      null ===
                                        (s = z.getState().salesRepData) ||
                                      void 0 === s
                                        ? void 0
                                        : s.createOrderTab) || void 0 === l
                                    ? void 0
                                    : l.customer_shippingaddressID) &&
                              void 0 !== c
                            ? c
                            : ""),
                          wt(),
                          Pe && "" !== Me
                            ? ((r = {
                                customerCountry: "",
                                customerProvince: "",
                                customerZip: "",
                              }),
                              "formAddress" == Me
                                ? ((r.customerCountry = e.customer_country),
                                  (r.customerProvince = e.customer_state
                                    ? e.customer_state
                                    : e.customer_city),
                                  (r.customerZip = e.customer_zipnumber))
                                : "customerAddress" == Me &&
                                  t.map(function (e) {
                                    var t;
                                    (null === (t = null == e ? void 0 : e.id) ||
                                    void 0 === t
                                      ? void 0
                                      : t.toString()) === n &&
                                      ((r.customerCountry =
                                        (null == e ? void 0 : e.country) || ""),
                                      (r.customerProvince = (
                                        null == e ? void 0 : e.province
                                      )
                                        ? null == e
                                          ? void 0
                                          : e.province
                                        : null == e
                                        ? void 0
                                        : e.city),
                                      (r.customerZip =
                                        (null == e ? void 0 : e.zip) || ""));
                                  }),
                              "Great Britain (UK)" === r.customerCountry
                                ? (r.customerCountry = "United Kingdom")
                                : "United States of America" ===
                                    r.customerCountry &&
                                  (r.customerCountry = "United States"),
                              _e(
                                d(
                                  "customerInvoice_CalculatingShippingRates_Msg"
                                )
                              ),
                              [4, $g(r)])
                            : [3, 2]
                        );
                      case 1:
                        return (
                          (o = u.sent()),
                          _e(""),
                          null != o &&
                          null != o &&
                          o.hasOwnProperty("shipping_rates") &&
                          "Success" === (null == o ? void 0 : o.message)
                            ? (we(null == o ? void 0 : o.shipping_rates),
                              0 ===
                                (null == o
                                  ? void 0
                                  : o.shipping_rates.length) &&
                                (Ce({
                                  msg: d(
                                    "customerInvoice_ShippingCostIsUnavailable"
                                  ),
                                  open: !0,
                                  severity: "warning",
                                }),
                                je("No"),
                                Be(!0)),
                              [2, !0])
                            : ("Success" === (null == o ? void 0 : o.message)
                                ? Ce({
                                    msg: d(
                                      "customerInvoice_ShippingCostErrorMsg_TryAgain"
                                    ),
                                    open: !0,
                                  })
                                : Ce({
                                    msg: null == o ? void 0 : o.message,
                                    open: !0,
                                  }),
                              [2, !1])
                        );
                      case 2:
                        return [2];
                    }
                  });
                });
              },
              Ot = function () {
                for (
                  var e = 0;
                  e < (null == gt ? void 0 : gt.newAddress.length);
                  e++
                )
                  if ("" === (null == gt ? void 0 : gt.newAddress[e][e])) {
                    Ce({
                      msg: null == gt ? void 0 : gt.newAddress[e].errorMsg,
                      open: !0,
                    });
                    break;
                  }
              },
              It = function (e, t) {
                h({ payload: e, type: t });
              };
            return {
              t: d,
              salesRepData: f,
              shopCurrency: _,
              Products: k,
              setProduct: w,
              search_By_productInfo: O,
              setSearch_By_productInfo: I,
              orderNotes: M,
              setOrderNotes: E,
              orderPlacedMsg: R,
              setOrderPlacedMsg: N,
              subtotal: L,
              setSubtotal: B,
              totalPrice: F,
              setTotalPrice: H,
              backToShopBtn: W,
              setBackToShopBtn: $,
              SearchProduct: function (e) {
                if (f.productsData.length > 0) {
                  var t,
                    n = e.trim().toLocaleLowerCase().split(" "),
                    r = !1,
                    o = !1,
                    a = [],
                    i = [];
                  (t = f.productsData.filter(function (e) {
                    for (var t = 0; t < n.length; t++) {
                      if (
                        !(null == e ? void 0 : e.productTitle) ||
                        !e.productTitle.toLowerCase().includes(n[t].trim())
                      ) {
                        r = !1;
                        break;
                      }
                      r = !0;
                    }
                    return r && i.push(e.productId), !!r;
                  })),
                    (a = f.productsData.filter(function (e) {
                      if (i.indexOf(e.productId) > -1) return !1;
                      for (var t = 0; t < n.length; t++)
                        for (var r = 0; r < e.variants.length; r++)
                          ((e.variants[r].variantTitle &&
                            e.variants[r].variantTitle
                              .toLowerCase()
                              .includes(n[t].trim())) ||
                            (e.variants[r].sku &&
                              e.variants[r].sku
                                .toLowerCase()
                                .includes(n[t].trim()))) &&
                            (o = !0);
                      return !!o;
                    })),
                    r && o && (a = []);
                  var s = Yb(Yb([], t, !0), a, !0);
                  (null == Ue ? void 0 : Ue.PriceList) && Ct(s),
                    ue(s),
                    se(!!ce),
                    w(s.slice(0, C));
                }
              },
              handleQuantityIncrementDecrement: function (e, t, n) {
                var r;
                if (e && t) {
                  var o = Kb({}, L),
                    a = Kb({}, Y);
                  "add" === t
                    ? ((a[e] = parseInt(Y[e]) + 1), (o[e] = a[e] * n))
                    : ((a[e] = Math.max(Y[e] - 1, 1)), (o[e] = a[e] * n));
                  var i = (((r = {})[e] = a[e]), r);
                  kt(i, "update.js"), J(Kb({}, a)), B(Kb({}, o));
                } else
                  Ce({ msg: d("customerInvoice_AlertErrorMsg"), open: !0 });
              },
              handleSelectedBtn: function () {
                $(!0), se(!1), w(ee.slice(0, C));
              },
              handleBackToShopBtn: vt,
              CreateOrder: function (t) {
                return Gb(c, void 0, void 0, function () {
                  var n,
                    r,
                    o,
                    a,
                    i,
                    s,
                    l,
                    c,
                    p,
                    m,
                    h,
                    f,
                    g,
                    b,
                    _,
                    y,
                    x,
                    C,
                    S,
                    k,
                    w,
                    P,
                    O,
                    I,
                    T,
                    E,
                    D,
                    R,
                    A,
                    L,
                    B;
                  return qb(this, function (Z) {
                    switch (Z.label) {
                      case 0:
                        return (
                          Z.trys.push([0, 3, , 4]),
                          (n = jf()),
                          (r = n.CustomerId),
                          (o = n.email),
                          (a = o),
                          (i = r),
                          (s = {}),
                          (l =
                            (null ===
                              (S =
                                null == v
                                  ? void 0
                                  : v.SingleShopifyCustomers.tags) ||
                            void 0 === S
                              ? void 0
                              : S.split(",")) || []),
                          (c =
                            null == l
                              ? void 0
                              : l.some(function (e) {
                                  var t;
                                  return null ===
                                    (t =
                                      null == e ? void 0 : e.toLowerCase()) ||
                                    void 0 === t
                                    ? void 0
                                    : t.includes("credit_");
                                })),
                          (p = c
                            ? null ===
                                (k = l.find(function (e) {
                                  return null == e
                                    ? void 0
                                    : e.includes("credit_");
                                })) || void 0 === k
                              ? void 0
                              : k.trim()
                            : ""),
                          (m = {}),
                          "createOrder" === t &&
                          ((m = (function (e) {
                            var t,
                              n,
                              r,
                              o,
                              a =
                                null == e
                                  ? void 0
                                  : e.some(function (e) {
                                      var t;
                                      return null ===
                                        (t =
                                          null == e
                                            ? void 0
                                            : e.toLowerCase()) || void 0 === t
                                        ? void 0
                                        : t.includes("net_");
                                    }),
                              i = a
                                ? null ===
                                    (t = e.find(function (e) {
                                      return null == e
                                        ? void 0
                                        : e.includes("net_");
                                    })) || void 0 === t
                                  ? void 0
                                  : t.trim()
                                : "";
                            if (a && i) {
                              var s = parseInt(i.match(/\d+/)[0]),
                                l = (
                                  null !==
                                    (o =
                                      null ===
                                        (r =
                                          null ===
                                            (n = z.getState().salesRepData) ||
                                          void 0 === n
                                            ? void 0
                                            : n.baseData) || void 0 === r
                                        ? void 0
                                        : r.PaymentTermsTemplates) &&
                                  void 0 !== o
                                    ? o
                                    : []
                                ).filter(function (e) {
                                  return "NET" === e.paymentTermsType;
                                }),
                                c =
                                  null == l
                                    ? void 0
                                    : l.find(function (e) {
                                        var t;
                                        return (
                                          ("NET" ===
                                          (null == e
                                            ? void 0
                                            : e.paymentTermsType)
                                            ? parseInt(
                                                null === (t = e.name) ||
                                                  void 0 === t
                                                  ? void 0
                                                  : t.match(/\d+/)[0]
                                              )
                                            : 0) === s
                                        );
                                      });
                              return c;
                            }
                          })(l)),
                          p &&
                            ((h = parseInt(
                              null == p ? void 0 : p.match(/\d+/)[0]
                            )),
                            F > h))
                            ? (Ce({
                                msg: d("Credit_Limit_Error_Msg"),
                                open: !0,
                              }),
                              [2])
                            : (wt(),
                              (f = e.customer_shippingaddressID
                                ? e.customer_shippingaddressID.toString()
                                : null !==
                                    (O =
                                      null ===
                                        (P =
                                          null ===
                                            (w = z.getState().salesRepData) ||
                                          void 0 === w
                                            ? void 0
                                            : w.createOrderTab) || void 0 === P
                                        ? void 0
                                        : P.customer_shippingaddressID) &&
                                  void 0 !== O
                                ? O
                                : ""),
                              Pe &&
                                "" !== Me &&
                                "" === De &&
                                Ce({
                                  msg: d(
                                    "createOrderFromCartPage_selectShippingCost"
                                  ),
                                  open: !0,
                                }),
                              !Pe || "" === Me || ("No" !== De && "" === be)
                                ? [3, 2]
                                : ((b = []),
                                  (_ = []),
                                  (y = null),
                                  (x = null),
                                  "" !== (C = be.split("/"))[0] &&
                                    "" !== C[1] &&
                                    ((y = C[0]), (x = C[1])),
                                  ee.map(function (e) {
                                    e.variants.map(function (t) {
                                      var n;
                                      (t.quantity = Y[t.variantId]),
                                        (t.product_type =
                                          null !==
                                            (n =
                                              null == e
                                                ? void 0
                                                : e.product_type) &&
                                          void 0 !== n
                                            ? n
                                            : ""),
                                        (b = Yb(Yb([], b, !0), [t], !1));
                                    });
                                  }),
                                  "customerAddress" == Me
                                    ? e.customerAddressesList.map(function (e) {
                                        e.id.toString() === f.toString() &&
                                          ((s = e),
                                          (_ = [
                                            {
                                              fname:
                                                (null == e
                                                  ? void 0
                                                  : e.first_name) || "",
                                              lastname:
                                                (null == e
                                                  ? void 0
                                                  : e.last_name) || "",
                                              address1:
                                                (null == e
                                                  ? void 0
                                                  : e.address1) || "",
                                              address2:
                                                (null == e
                                                  ? void 0
                                                  : e.address2) || "",
                                              city:
                                                (null == e ? void 0 : e.city) ||
                                                "",
                                              country:
                                                (null == e
                                                  ? void 0
                                                  : e.country) || "",
                                              province:
                                                (null == e
                                                  ? void 0
                                                  : e.province) || "",
                                              zip:
                                                (null == e ? void 0 : e.zip) ||
                                                "",
                                            },
                                          ]));
                                      })
                                    : "formAddress" == Me &&
                                      (_ = [
                                        {
                                          fname: e.customer_firstname,
                                          lastname: e.customer_lastname,
                                          address1: e.customer_address1,
                                          address2: e.customer_address2,
                                          province: e.customer_state,
                                          city: e.customer_city,
                                          country: e.customer_countryCode,
                                          zip: e.customer_zipnumber,
                                        },
                                      ]),
                                  (_[0].company = e.customer_companyname
                                    ? e.customer_companyname
                                    : null !==
                                        (I = null == s ? void 0 : s.company) &&
                                      void 0 !== I
                                    ? I
                                    : ""),
                                  (_[0].phone = e.customer_mobilenumber
                                    ? e.customer_mobilenumber
                                    : null !==
                                        (T = null == s ? void 0 : s.phone) &&
                                      void 0 !== T
                                    ? T
                                    : ""),
                                  (g = Kb(
                                    Kb(
                                      Kb({}, !Xe && { email: a }),
                                      Xe && {
                                        repEmail: a,
                                        orderId:
                                          null ===
                                            (E =
                                              null == Ge
                                                ? void 0
                                                : Ge.draftOrderObj) ||
                                          void 0 === E
                                            ? void 0
                                            : E.id,
                                        orderTags:
                                          null ===
                                            (D =
                                              null == Ge
                                                ? void 0
                                                : Ge.draftOrderObj) ||
                                          void 0 === D
                                            ? void 0
                                            : D.tags,
                                        additionalNoteDetails:
                                          null !==
                                            (A =
                                              null ===
                                                (R =
                                                  null == Ge
                                                    ? void 0
                                                    : Ge.draftOrderObj) ||
                                              void 0 === R
                                                ? void 0
                                                : R.note_attributesList) &&
                                          void 0 !== A
                                            ? A
                                            : [],
                                      }
                                    ),
                                    {
                                      prods: JSON.stringify(b),
                                      customerId: i,
                                      Index: -1,
                                      fnamecus: e.customer_name,
                                      cusemail: e.customer_email,
                                      wholesale: "false",
                                      message: M,
                                      cusAddress: _,
                                      shippingtitle: y,
                                      shippingprice: x,
                                      IsAdressFromCustmerInvoice: !1,
                                      completeDraftOrder: "createOrder" === t,
                                      isNewaddress: !0,
                                      pro: !1,
                                      saveAsDraftOrder: "draftOrder" === t,
                                      paymentTermsTemplateId:
                                        null !==
                                          (L = null == m ? void 0 : m.id) &&
                                        void 0 !== L
                                          ? L
                                          : null,
                                      paymentTermType:
                                        null !==
                                          (B =
                                            null == m
                                              ? void 0
                                              : m.paymentTermsType) &&
                                        void 0 !== B
                                          ? B
                                          : null,
                                      dueDateInput:
                                        "FIXED" ===
                                        (null == m
                                          ? void 0
                                          : m.paymentTermsType)
                                          ? ct
                                          : null,
                                    }
                                  )),
                                  N({ msg: _t[t], color: "blue" }),
                                  [4, Sg(g, Xe)]))
                        );
                      case 1:
                        Z.sent()
                          ? (It({}, j.CREATE_ORDER_TAB),
                            N({ msg: bt[t], color: "green" }),
                            Ce({ msg: bt[t], open: !0, severity: "success" }),
                            $e(!0),
                            u(!0),
                            setTimeout(function () {
                              N({ msg: "", color: "" });
                            }, 5e3),
                            It([], j.DRAFT_ORDER_DATA),
                            It({}, j.EDIT_DRAFT_ORDER),
                            qe({}),
                            (Xe = !1),
                            kt({}, "clear.js"),
                            vt(),
                            se(!1),
                            ut(""))
                          : (N({
                              msg: d("customerInvoice_ErrorMsgTryAgain"),
                              color: "red",
                            }),
                            Ce({
                              msg: d("customerInvoice_ErrorMsgTryAgain"),
                              open: !0,
                              severity: "error",
                            }),
                            u(!1),
                            setTimeout(function () {
                              N({ msg: "", color: "" });
                            }, 2e3)),
                          (Z.label = 2);
                      case 2:
                        return [3, 4];
                      case 3:
                        return (
                          Z.sent(),
                          Ce({
                            msg: d("customerInvoice_ErrorMsgTryAgain"),
                            open: !0,
                            severity: "error",
                          }),
                          [3, 4]
                        );
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              renderImageSrc: function (e, t) {
                var n = t[0].src;
                return (
                  e &&
                    0 !== t.length &&
                    t.map(function (t) {
                      if (t.imageId === e) return (n = t.src ? t.src : "image");
                    }),
                  n
                );
              },
              checkUncheck: function (t, n, r, o) {
                var a;
                if (
                  (0 === ee.length && kt({}, "clear.js"),
                  0 !== Object.keys(r).length && r.variants.length > 0)
                ) {
                  var i = t.target.checked,
                    s = Kb({}, K),
                    l = Kb({}, Y),
                    c = [],
                    u = {},
                    p = Kb({}, L),
                    m = r ? JSON.parse(JSON.stringify(r)) : {},
                    h = o ? JSON.parse(JSON.stringify(o)) : {};
                  if ("isProduct" === n)
                    if (i)
                      yt(K[r.productId])
                        ? ee.map(function (t) {
                            t.productId === r.productId &&
                              ((t.variants = m.variants),
                              te(Yb([], ee, !0)),
                              m.variants.map(function (t) {
                                (l[t.variantId] = 1),
                                  (p[t.variantId] =
                                    1 *
                                    ((null == Ue ? void 0 : Ue.PriceList) &&
                                    "" !== e.customer_name
                                      ? null == t
                                        ? void 0
                                        : t.wholesalePrice
                                      : null == t
                                      ? void 0
                                      : t.variantPrice)),
                                  J(Kb({}, l)),
                                  B(Kb({}, p)),
                                  c.push({ id: t.variantId, quantity: 1 });
                              }),
                              kt(c, "add.js"));
                          })
                        : (te(Yb(Yb([], ee, !0), [m], !1)),
                          (s[r.productId] = r.productId),
                          G(Kb({}, s)),
                          m.variants.map(function (t) {
                            (l[t.variantId] = 1),
                              (p[t.variantId] =
                                1 *
                                ((null == Ue ? void 0 : Ue.PriceList) &&
                                "" !== e.customer_name
                                  ? null == t
                                    ? void 0
                                    : t.wholesalePrice
                                  : null == t
                                  ? void 0
                                  : t.variantPrice)),
                              J(Kb({}, l)),
                              B(Kb({}, p)),
                              c.push({ id: t.variantId, quantity: 1 });
                          }),
                          setTimeout(
                            function () {
                              kt(c, "add.js");
                            },
                            0 === ee.length ? 500 : 10
                          ));
                    else {
                      var f = ee.filter(function (e) {
                        return e.productId !== r.productId;
                      });
                      te(Yb([], f, !0)),
                        delete K[r.productId],
                        m.variants.map(function (e) {
                          var t;
                          delete Y[e.variantId],
                            delete L[e.variantId],
                            B(Kb({}, L)),
                            (u = Kb(
                              Kb({}, u),
                              (((t = {})[e.variantId] = 0), t)
                            ));
                        }),
                        kt(u, "update.js");
                    }
                  else if (i)
                    if (yt(K[r.productId]))
                      ee.map(function (t) {
                        if (t.productId === r.productId)
                          return (
                            (t.variants = Yb(
                              Yb([], t.variants, !0),
                              [Kb(Kb({}, h), { quantity: 1 })],
                              !1
                            )),
                            te(Yb([], ee, !0)),
                            (l[o.variantId] = 1),
                            (p[o.variantId] =
                              1 *
                              ((null == Ue ? void 0 : Ue.PriceList) &&
                              "" !== e.customer_name
                                ? null == o
                                  ? void 0
                                  : o.wholesalePrice
                                : null == o
                                ? void 0
                                : o.variantPrice)),
                            J(Kb({}, l)),
                            B(Kb({}, p)),
                            c.push({ id: o.variantId, quantity: 1 }),
                            kt(c, "add.js"),
                            t
                          );
                      });
                    else {
                      var g = Kb(Kb({}, m), { variants: [h] });
                      te(Yb(Yb([], ee, !0), [g], !1)),
                        (s[r.productId] = r.productId),
                        G(Kb({}, s)),
                        (l[o.variantId] = 1),
                        (p[o.variantId] =
                          1 *
                          ((null == Ue ? void 0 : Ue.PriceList) &&
                          "" !== e.customer_name
                            ? null == o
                              ? void 0
                              : o.wholesalePrice
                            : o.variantPrice)),
                        J(Kb({}, l)),
                        B(Kb({}, p)),
                        c.push({ id: o.variantId, quantity: 1 }),
                        setTimeout(
                          function () {
                            kt(c, "add.js");
                          },
                          0 === ee.length ? 500 : 10
                        );
                    }
                  else {
                    var v;
                    ee.forEach(function (e) {
                      return e.variants.forEach(function (t, n) {
                        if (t.variantId === o.variantId)
                          return e.variants.splice(n, 1);
                      });
                    }),
                      (v = ee.filter(function (e) {
                        if (e.variants.length >= 1)
                          return e.variants.length >= 1;
                        0 === e.variants.length && delete K[e.productId];
                      })),
                      te(Yb([], v, !0)),
                      delete Y[o.variantId],
                      delete L[o.variantId],
                      B(Kb({}, L)),
                      ((a = {})[o.variantId] = 0),
                      kt((u = a), "update.js");
                  }
                } else
                  Ce({ msg: d("customerInvoice_AlertErrorMsg"), open: !0 });
              },
              product_idObject: K,
              variant_idObject: Y,
              productSelectedArray: ee,
              setProductSelectedArray: te,
              setVariant_idObject: J,
              setProduct_idObject: G,
              handleAlertMsgClose: function (e, t) {
                "clickaway" !== t && Ce({ msg: "", open: !1 });
              },
              isNotEmpty: yt,
              lazyLoadData: xt,
              scrollParentRef: re,
              setScrollParentRef: oe,
              customizedTextStrings: me,
              hideRetailPriceColumn: ge,
              GetShippingRatesOnSelectedAddress: Pt,
              shippingCost: be,
              setShippingCost: _e,
              alertErrorMsg: xe,
              handleSelectShippingAddress: function (e) {
                Te(e), _e(""), we([]), je(""), Be(!1);
              },
              shippingAddresSet: Ie,
              setShippingAddressSet: Te,
              shippingCostData: ke,
              setShippingCostData: we,
              handleShippingCostApply: function (e) {
                je(e);
              },
              applyShippingCost: De,
              setApplyShippingCost: je,
              shopName: x,
              isDisabledShippingCostRadioBtn_No: Ne,
              setIsDisabledShippingCostRadioBtn_No: Ae,
              isDisabledShippingCostRadioBtn_YesNo: ze,
              selectFeatures: Ue,
              handleProductQuantity: function (e, t, n) {
                var r, o, a;
                if (t) {
                  var i = e.target,
                    s = (i.name, i.value);
                  if (
                    !(function (e, t) {
                      return (
                        parseInt(t) <= 0 &&
                        (B(0),
                        Ce({ msg: d("productTable_error_AlertMsg"), open: !0 }),
                        !0)
                      );
                    })(0, s)
                  ) {
                    "" === s
                      ? (B(0),
                        Ce({
                          msg: d("productTable_error_AlertMsg2"),
                          open: !0,
                        }))
                      : B(Kb(Kb({}, L), (((r = {})[t] = parseInt(s) * n), r)));
                    var l = (((o = {})[t] = s), o);
                    kt(l, "update.js"),
                      J(Kb(Kb({}, Y), (((a = {})[t] = s), a)));
                  }
                } else
                  Ce({ msg: d("customerInvoice_AlertErrorMsg"), open: !0 });
              },
              isError: Fe,
              isMobile: p,
              checkIsPlacingMessage: function () {
                return (
                  R.msg === d("customerInvoice_Sending_Msg") ||
                  R.msg === d("customerInvoice_Creating_Msg") ||
                  R.msg === d("customerInvoice_CreatingDraft_Msg")
                );
              },
              orderCreatedSuccessfully: We,
              setOrderCreatedSuccessfully: $e,
              cartUpdatedSuccessFully: tt,
              durationTypesOfPayment: st,
              handlePaymentTermsPeriod: function (e) {},
              handleCheckUnCheckPaymentTerm: function (e) {
                at(e.target.checked);
              },
              isPaymentTermEnabled: ot,
              selectDate: function (e, t) {
                var n, r;
                (null === (n = null == e ? void 0 : e.target) || void 0 === n
                  ? void 0
                  : n.value) &&
                "" !==
                  (null === (r = null == e ? void 0 : e.target) || void 0 === r
                    ? void 0
                    : r.value)
                  ? ut(e.target.value)
                  : ut(t);
              },
              defaultDate: ct,
              todayDateString: ft,
              isCustomerHasPaymentTermTag: pt,
            };
          })(n),
          v = f.t,
          b = f.salesRepData,
          _ = f.shopCurrency,
          x = f.Products,
          C = f.search_By_productInfo,
          S = f.setSearch_By_productInfo,
          k = f.orderNotes,
          w = f.setOrderNotes,
          P = f.orderPlacedMsg,
          O = f.subtotal,
          I = f.totalPrice,
          T = f.setTotalPrice,
          M = f.backToShopBtn,
          E = f.SearchProduct,
          D = f.handleQuantityIncrementDecrement,
          R = f.handleSelectedBtn,
          N = f.handleBackToShopBtn,
          A = f.CreateOrder,
          L = f.setSubtotal,
          B = f.renderImageSrc,
          Z = f.checkUncheck,
          F = f.product_idObject,
          H = f.variant_idObject,
          V = f.productSelectedArray,
          W = f.setVariant_idObject,
          $ = f.setProduct_idObject,
          U = f.setProductSelectedArray,
          K = f.handleAlertMsgClose,
          G = f.isNotEmpty,
          q = f.lazyLoadData,
          Y = f.customizedTextStrings,
          J = f.hideRetailPriceColumn,
          Q = f.GetShippingRatesOnSelectedAddress,
          ee = f.shippingCost,
          te = f.setShippingCost,
          ne = f.alertErrorMsg,
          re = f.handleSelectShippingAddress,
          oe = f.shippingAddresSet,
          ae = f.setShippingAddressSet,
          ie = f.shippingCostData,
          se = f.setShippingCostData,
          le = f.handleShippingCostApply,
          ce = f.applyShippingCost,
          ue = f.setApplyShippingCost,
          de = f.isDisabledShippingCostRadioBtn_No,
          pe = f.isDisabledShippingCostRadioBtn_YesNo,
          me = f.selectFeatures,
          he = f.isMobile,
          fe = f.handleProductQuantity,
          ge = f.isError,
          ve = f.checkIsPlacingMessage,
          be = f.orderCreatedSuccessfully,
          _e = f.setOrderCreatedSuccessfully,
          ye = f.cartUpdatedSuccessFully,
          xe =
            (f.durationTypesOfPayment,
            f.handlePaymentTermsPeriod,
            f.handleCheckUnCheckPaymentTerm,
            f.isPaymentTermEnabled,
            f.selectDate,
            f.defaultDate,
            f.todayDateString,
            f.isCustomerHasPaymentTermTag),
          Ce = (function () {
            var e = Qg("(max-width: 600px)");
            return {
              ST_CI_table: { minWidth: 650 },
              ST_CI_tableDataCell: { pt: 0.5, pb: 0.5 },
              ST_CI_renderPriceArea: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                mt: 2,
                mb: 3,
              },
              ST_CI_MinWidth: { minWidth: 228, mt: 1 },
              ST_CI_TotalPriceRenderBox: {
                display: "flex",
                alignItems: "center",
                border: 1,
                borderRadius: 1,
                borderColor: "#d4d4d4",
                backgroundColor: "white",
                mt: 1,
                color: "black",
                "& svg": { m: 1.5 },
                "& hr": {
                  borderColor: "black",
                  borderWidth: 1,
                  background: "black",
                },
                width: e ? 400 : 280,
                height: e ? 50 : 40,
              },
              ST_CI_TotalPriceText: { fontWeight: 600, ml: 2, mr: 2 },
              ST_CI_BtnArea: {
                display: "flex",
                justifyContent: e ? "center" : "flex-end",
                mt: 3,
                mb: 2,
              },
              ST_CI_DisplayFlex: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                mb: 3,
                mt: 3,
              },
              ST_CI_AddMoreProducts_Btn: { mt: 2, mr: 1, whiteSpace: "nowrap" },
              ST_CI_SearchProductGrid: {
                minWidth: e ? 0 : 232,
                mt: 2,
                backgroundColor: "white",
                width: e ? 400 : 0,
              },
              ST_CI_ShippingCost: { display: "flex", flexWrap: "wrap" },
              ST_CI_ApplyShippingCost_Msg: {
                display: "flex",
                justifyContent: "flex-end",
                marginTop: e ? 2 : 0,
              },
              ST_CI_ApplyShippingCostRadio_Btn: {
                pl: "0.1rem",
                pt: "0rem",
                pb: "0rem",
                pr: "0rem",
              },
              ST_CI_SippingCostBtn: {
                mt: 1,
                backgroundColor: "white",
                width: e ? 335 : 190,
                height: 36,
                fontSize: e ? 14 : 11,
              },
              ST_CI_SippingCost_TextField: {
                width: e ? 335 : 180,
                backgroundColor: "white",
                mt: 1,
                ml: e ? 0 : 1,
              },
              ST_CI_SendInvoice_CreateOrder_Btn: {
                width: e ? 170 : 135,
                height: e ? 45 : 36,
                fontSize: e ? 14 : 12,
              },
            };
          })(),
          Se = Ce.ST_CI_table,
          ke = Ce.ST_CI_tableDataCell,
          we = Ce.ST_CI_renderPriceArea,
          Pe = Ce.ST_CI_MinWidth,
          Oe = Ce.ST_CI_TotalPriceRenderBox,
          Ie = Ce.ST_CI_TotalPriceText,
          Te = Ce.ST_CI_BtnArea,
          Me = Ce.ST_CI_DisplayFlex,
          Ee = Ce.ST_CI_AddMoreProducts_Btn,
          De = Ce.ST_CI_SearchProductGrid,
          je = Ce.ST_CI_ShippingCost,
          Re = Ce.ST_CI_ApplyShippingCost_Msg,
          Ne = Ce.ST_CI_ApplyShippingCostRadio_Btn,
          Ae = Ce.ST_CI_SippingCostBtn,
          Le = Ce.ST_CI_SippingCost_TextField,
          ze = Ce.ST_CI_SendInvoice_CreateOrder_Btn,
          Be = m || 0 === V.length || ve();
        return (
          (0, t.useEffect)(
            function () {
              if (!0 === M) return R();
            },
            [H, V]
          ),
          (0, t.useEffect)(
            function () {
              if (Object.values(O).length > 0) {
                var e = Object.values(O).reduce(function (e, t) {
                  return e + t;
                });
                T(e);
              } else T(0);
            },
            [O]
          ),
          (0, t.useEffect)(
            function () {
              "" === n.customer_name.trim() ||
              "" === n.customer_email.trim() ||
              !1 !== n.email_validation ||
              (!1 !== n.mobile_validation && "" !== n.mobile_validation)
                ? h(!0)
                : h(!1);
            },
            [n.customer_name, n.customer_email, n.customer_mobilenumber]
          ),
          (0, t.useEffect)(
            function () {
              be &&
                (n.setCustomerName(""),
                n.setEmailId(""),
                n.setMobileNumber(""),
                n.setCompanyName(""),
                n.setFirstName(""),
                n.setLastName(""),
                n.setAddress1(""),
                n.setAddress2(""),
                n.setCity(""),
                n.setZipNumber(""),
                n.setSelectShippingAddress(""),
                n.setSelectCountry(""),
                n.setSelectSelectCountryState(""),
                n.setCustomerAddressOptionsData([]),
                n.setCountriesStateData([]),
                n.setEditOrderReduxData({}),
                n.setTagWiseWholeSalePrices([]),
                L({}),
                T(0),
                U([]),
                W({}),
                $({}),
                S(""),
                w(""),
                ae(""),
                se([]),
                te(""),
                ue("Yes"),
                _e(!1));
            },
            [be]
          ),
          (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsxs)(
                La,
                Jb(
                  { sx: Lo },
                  {
                    children: [
                      (0, e.jsx)(
                        Wa,
                        Jb(
                          { variant: ov, sx: zo },
                          { children: v("cartSharing_Select_product_Title") }
                        )
                      ),
                      (0, e.jsx)("hr", { className: "ST_CI_Horizontal_Line" }),
                    ],
                  }
                )
              ),
              (0, e.jsxs)(
                La,
                Jb(
                  { sx: Me },
                  {
                    children: [
                      (0, e.jsx)(
                        La,
                        Jb(
                          { item: !0, sx: De },
                          {
                            children: (0, e.jsx)(Bc, {
                              id: "free-solo-demo",
                              freeSolo: !0,
                              inputValue: C,
                              onInputChange: function (e, t) {
                                S(t), E(t);
                              },
                              options: x || [],
                              groupBy: function (e) {
                                return (
                                  (null == e ? void 0 : e.productTitle) || ""
                                );
                              },
                              getOptionLabel: function (e) {
                                return null == e
                                  ? void 0
                                  : e.variants
                                      .map(function (t) {
                                        return "Default Title" !==
                                          (null == t ? void 0 : t.variantTitle)
                                          ? t.variantTitle
                                          : e.productTitle;
                                      })
                                      .toString();
                              },
                              renderInput: function (t) {
                                return (0, e.jsx)(
                                  Xd,
                                  Jb(
                                    {
                                      placeholder: v(
                                        "customerInvoice_ProductsSearchBy_Placeholder"
                                      ),
                                      className: "ST_CI_textfield-details ",
                                    },
                                    t,
                                    {
                                      label: v(
                                        "customerInvoice_SearchProducts_Label"
                                      ),
                                      InputProps: Jb(Jb({}, t.InputProps), {
                                        style: { height: he ? 50 : 40 },
                                        startAdornment: (0, e.jsx)(
                                          ap,
                                          Jb(
                                            { position: "end", sx: { mr: 0 } },
                                            { children: (0, e.jsx)(mv, {}) }
                                          )
                                        ),
                                      }),
                                    }
                                  )
                                );
                              },
                              size: "small",
                            }),
                          }
                        )
                      ),
                      he
                        ? (0, e.jsxs)(
                            La,
                            Jb(
                              { mt: 4 },
                              {
                                children: [
                                  " ",
                                  (0, e.jsx)(
                                    Wa,
                                    Jb(
                                      { variant: ov, sx: zo },
                                      {
                                        children: v(
                                          "wholesaleOrder_table2Column1"
                                        ),
                                      }
                                    )
                                  ),
                                  " ",
                                ],
                              }
                            )
                          )
                        : (0, e.jsx)(e.Fragment, {}),
                      (0, e.jsxs)(
                        La,
                        Jb(
                          { mt: he ? 2 : 0, style: { display: "flex" } },
                          {
                            children: [
                              (0, e.jsxs)(
                                "div",
                                Jb(
                                  {
                                    style: {
                                      display: "flex",
                                      marginTop: "20px",
                                      marginRight: "0.5rem",
                                    },
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)(hv, {
                                        sx: {
                                          color: "#979797",
                                          height: "0.8em",
                                          width: "0.8em",
                                        },
                                      }),
                                      (0, e.jsx)(
                                        Il,
                                        Jb(
                                          {
                                            component: "button",
                                            variant: "body2",
                                            className: "ST_FindProductPopup",
                                            sx: {
                                              cursor: "pointer",
                                              display: " inline-flex",
                                            },
                                            onClick: s,
                                          },
                                          {
                                            children: v(
                                              "createOrder_productSearchGuide"
                                            ),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              i,
                              M
                                ? (0, e.jsx)(
                                    vp,
                                    Jb(
                                      {
                                        sx: [rv, Ee],
                                        variant: "contained",
                                        color: "success",
                                        endIcon: (0, e.jsx)(fv, {}),
                                        onClick: N,
                                      },
                                      {
                                        children: v(
                                          "customerInvoice_AddMoreProducts_Btn"
                                        ),
                                      }
                                    )
                                  )
                                : null,
                              (0, e.jsx)(
                                vp,
                                Jb(
                                  {
                                    sx: [rv, { mt: 2 }],
                                    variant: "contained",
                                    disabled: !(V.length > 0),
                                    endIcon: (0, e.jsx)(
                                      wp,
                                      Jb(
                                        {
                                          badgeContent: V.length,
                                          color: "success",
                                        },
                                        { children: (0, e.jsx)(gv, {}) }
                                      )
                                    ),
                                    onClick: R,
                                  },
                                  {
                                    children: v("customerInvoice_Selected_Btn"),
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
              (0, e.jsx)(
                "div",
                Jb(
                  {
                    id: "scrollableDiv",
                    style: { maxHeight: "400px", border: "1px solid #bfbfbf" },
                  },
                  {
                    children: (0, e.jsx)(
                      Ov,
                      Jb(
                        {
                          next: q,
                          hasMore: !0,
                          loader: (0, e.jsx)(e.Fragment, {}),
                          dataLength: x.length,
                          scrollableTarget: "scrollableDiv",
                        },
                        {
                          children: (0, e.jsx)(
                            "div",
                            Jb(
                              { className: "table-container" },
                              {
                                children: (0, e.jsx)(
                                  Ga,
                                  Jb(
                                    {
                                      style: { maxHeight: "400px" },
                                      component: io,
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        ei,
                                        Jb(
                                          {
                                            stickyHeader: !0,
                                            sx: Se,
                                            "aria-label": "simple table",
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)(si, {
                                                children: he
                                                  ? null
                                                  : (0, e.jsxs)(
                                                      hi,
                                                      Jb(
                                                        {
                                                          className:
                                                            "stickyHeaderRow",
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                { sx: Zo },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          v(
                                                                            "customerInvoice_ProductTableColumnProduct"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  sx: Zo,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            " ",
                                                                            v(
                                                                              "customerInvoice_ProductTableColumnQuantity"
                                                                            ),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                { sx: Zo },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            " ",
                                                                            v(
                                                                              "customerInvoice_ProductTableColumnSku"
                                                                            ),
                                                                            " ",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                {
                                                                  sx: Zo,
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          v(
                                                                            "customerInvoice_ProductTableColumnInventory"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                {
                                                                  sx: J
                                                                    ? {
                                                                        display:
                                                                          "none",
                                                                      }
                                                                    : {
                                                                        display:
                                                                          "table-cell",
                                                                        fontSize:
                                                                          "13px",
                                                                      },
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            v(
                                                                              "customerInvoice_ProductTableColumnPrice"
                                                                            ),
                                                                            "(",
                                                                            _,
                                                                            ")",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                {
                                                                  sx: (
                                                                    null == me
                                                                      ? void 0
                                                                      : me.PriceList
                                                                  )
                                                                    ? {
                                                                        display:
                                                                          "table-cell",
                                                                        fontSize:
                                                                          "13px",
                                                                      }
                                                                    : {
                                                                        display:
                                                                          "none",
                                                                      },
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            v(
                                                                              "customerInvoice_ProductTableColumnWholeSalePrice"
                                                                            ),
                                                                            "(",
                                                                            _,
                                                                            ")",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              Jb(
                                                                { sx: Zo },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    "b",
                                                                    Jb(
                                                                      {
                                                                        className:
                                                                          "ST_CS_TableHeading",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            v(
                                                                              "customerInvoice_ProductTableColumnSubTotal"
                                                                            ),
                                                                            "(",
                                                                            _,
                                                                            ")",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                              }),
                                              he
                                                ? (0, e.jsx)(Pi, {
                                                    children:
                                                      0 !== x.length
                                                        ? (0, e.jsx)(
                                                            e.Fragment,
                                                            {
                                                              children: x.map(
                                                                function (
                                                                  r,
                                                                  o
                                                                ) {
                                                                  return r
                                                                    .variants
                                                                    .length > 0
                                                                    ? (0,
                                                                      e.jsxs)(
                                                                        t.Fragment,
                                                                        {
                                                                          children:
                                                                            [
                                                                              (0,
                                                                              e.jsx)(
                                                                                hi,
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      yi,
                                                                                      Jb(
                                                                                        {
                                                                                          colSpan:
                                                                                            (
                                                                                              null ==
                                                                                              me
                                                                                                ? void 0
                                                                                                : me.PriceList
                                                                                            )
                                                                                              ? 7
                                                                                              : 6,
                                                                                          sx: [
                                                                                            ke,
                                                                                            {
                                                                                              borderTop:
                                                                                                "1px solid #bfbfbf",
                                                                                            },
                                                                                          ],
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Xp,
                                                                                              {
                                                                                                label:
                                                                                                  (null ==
                                                                                                  r
                                                                                                    ? void 0
                                                                                                    : r.productTitle) ||
                                                                                                  "-",
                                                                                                control:
                                                                                                  (0,
                                                                                                  e.jsx)(
                                                                                                    vm,
                                                                                                    {
                                                                                                      disabled:
                                                                                                        c(
                                                                                                          r
                                                                                                        ),
                                                                                                      checked:
                                                                                                        !!G(
                                                                                                          F[
                                                                                                            (null ==
                                                                                                            r
                                                                                                              ? void 0
                                                                                                              : r.productId) ||
                                                                                                              0
                                                                                                          ]
                                                                                                        ),
                                                                                                      onChange:
                                                                                                        function (
                                                                                                          e
                                                                                                        ) {
                                                                                                          return Z(
                                                                                                            e,
                                                                                                            "isProduct",
                                                                                                            u(
                                                                                                              r
                                                                                                            )
                                                                                                          );
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                              }
                                                                                            ),
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                }
                                                                              ),
                                                                              r.variants.map(
                                                                                function (
                                                                                  t,
                                                                                  o
                                                                                ) {
                                                                                  var a,
                                                                                    i,
                                                                                    s;
                                                                                  return (0,
                                                                                  e.jsx)(
                                                                                    hi,
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsxs)(
                                                                                          yi,
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  ln,
                                                                                                  Jb(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        border:
                                                                                                          "1px solid #bfbfbf",
                                                                                                        p: 1,
                                                                                                      },
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        (0,
                                                                                                        e.jsx)(
                                                                                                          Xp,
                                                                                                          {
                                                                                                            className:
                                                                                                              "ST_CI_product-label",
                                                                                                            label:
                                                                                                              (0,
                                                                                                              e.jsxs)(
                                                                                                                e.Fragment,
                                                                                                                {
                                                                                                                  children:
                                                                                                                    [
                                                                                                                      0 !==
                                                                                                                        (null ==
                                                                                                                        r
                                                                                                                          ? void 0
                                                                                                                          : r
                                                                                                                              .productImages
                                                                                                                              .length) &&
                                                                                                                      (null ==
                                                                                                                      r
                                                                                                                        ? void 0
                                                                                                                        : r
                                                                                                                            .productImages[0]
                                                                                                                            .src)
                                                                                                                        ? (0,
                                                                                                                          e.jsx)(
                                                                                                                            Tm,
                                                                                                                            {
                                                                                                                              alt: "image",
                                                                                                                              src: B(
                                                                                                                                t.image_id,
                                                                                                                                r.productImages
                                                                                                                              ),
                                                                                                                              variant:
                                                                                                                                "rounded",
                                                                                                                            }
                                                                                                                          )
                                                                                                                        : (0,
                                                                                                                          e.jsx)(
                                                                                                                            Tm,
                                                                                                                            Jb(
                                                                                                                              {
                                                                                                                                alt: "image",
                                                                                                                                sx: {
                                                                                                                                  bgcolor:
                                                                                                                                    "white",
                                                                                                                                  color:
                                                                                                                                    "black",
                                                                                                                                },
                                                                                                                                variant:
                                                                                                                                  "rounded",
                                                                                                                              },
                                                                                                                              {
                                                                                                                                children:
                                                                                                                                  (0,
                                                                                                                                  e.jsx)(
                                                                                                                                    vv,
                                                                                                                                    {
                                                                                                                                      sx: {
                                                                                                                                        fontSize:
                                                                                                                                          "3.1rem",
                                                                                                                                      },
                                                                                                                                    }
                                                                                                                                  ),
                                                                                                                              }
                                                                                                                            )
                                                                                                                          ),
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        ln,
                                                                                                                        Jb(
                                                                                                                          {
                                                                                                                            sx: {
                                                                                                                              ml: 1,
                                                                                                                            },
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              "Default Title" !==
                                                                                                                              (null ==
                                                                                                                              t
                                                                                                                                ? void 0
                                                                                                                                : t.variantTitle)
                                                                                                                                ? t.variantTitle
                                                                                                                                : r.productTitle,
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                    ],
                                                                                                                }
                                                                                                              ),
                                                                                                            control:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                vm,
                                                                                                                {
                                                                                                                  disabled:
                                                                                                                    l(
                                                                                                                      t
                                                                                                                    ),
                                                                                                                  checked:
                                                                                                                    !!G(
                                                                                                                      H[
                                                                                                                        (null ==
                                                                                                                        t
                                                                                                                          ? void 0
                                                                                                                          : t.variantId) ||
                                                                                                                          0
                                                                                                                      ]
                                                                                                                    ),
                                                                                                                  onChange:
                                                                                                                    function (
                                                                                                                      e
                                                                                                                    ) {
                                                                                                                      return Z(
                                                                                                                        e,
                                                                                                                        "isVariant",
                                                                                                                        r,
                                                                                                                        t
                                                                                                                      );
                                                                                                                    },
                                                                                                                }
                                                                                                              ),
                                                                                                          }
                                                                                                        ),
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  ln,
                                                                                                  Jb(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        border:
                                                                                                          "1px solid #bfbfbf",
                                                                                                        p: 1,
                                                                                                      },
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            "b",
                                                                                                            Jb(
                                                                                                              {
                                                                                                                className:
                                                                                                                  "ST_CS_TableHeading",
                                                                                                                style:
                                                                                                                  {
                                                                                                                    marginRight:
                                                                                                                      "120px",
                                                                                                                  },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    " ",
                                                                                                                    v(
                                                                                                                      "customerInvoice_ProductTableColumnSku"
                                                                                                                    ),
                                                                                                                    " :",
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          (null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.sku) ||
                                                                                                            "-",
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  ln,
                                                                                                  Jb(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        border:
                                                                                                          "1px solid #bfbfbf",
                                                                                                        p: 1,
                                                                                                      },
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            "b",
                                                                                                            Jb(
                                                                                                              {
                                                                                                                className:
                                                                                                                  "ST_CS_TableHeading",
                                                                                                                style:
                                                                                                                  {
                                                                                                                    marginRight:
                                                                                                                      "100px",
                                                                                                                  },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    v(
                                                                                                                      "customerInvoice_ProductTableColumnInventory"
                                                                                                                    ),
                                                                                                                    " :",
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          d(
                                                                                                            t
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  ln,
                                                                                                  Jb(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        border:
                                                                                                          "1px solid #bfbfbf",
                                                                                                        p: 1,
                                                                                                      },
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            ln,
                                                                                                            Jb(
                                                                                                              {
                                                                                                                sx: J
                                                                                                                  ? {
                                                                                                                      display:
                                                                                                                        "none",
                                                                                                                    }
                                                                                                                  : {
                                                                                                                      display:
                                                                                                                        "block",
                                                                                                                      paddingBottom:
                                                                                                                        "5px",
                                                                                                                    },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    (0,
                                                                                                                    e.jsxs)(
                                                                                                                      "b",
                                                                                                                      Jb(
                                                                                                                        {
                                                                                                                          className:
                                                                                                                            "ST_CS_TableHeading",
                                                                                                                          style:
                                                                                                                            {
                                                                                                                              marginRight:
                                                                                                                                "80px",
                                                                                                                            },
                                                                                                                        },
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            [
                                                                                                                              v(
                                                                                                                                "customerInvoice_ProductTableColumnPrice"
                                                                                                                              ),
                                                                                                                              "(",
                                                                                                                              _,
                                                                                                                              ") :",
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      )
                                                                                                                    ),
                                                                                                                    _ +
                                                                                                                      " ",
                                                                                                                    (null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantPrice.toFixed(
                                                                                                                          2
                                                                                                                        )) ||
                                                                                                                      (0).toFixed(
                                                                                                                        2
                                                                                                                      ),
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            ln,
                                                                                                            Jb(
                                                                                                              {
                                                                                                                sx: (
                                                                                                                  null ==
                                                                                                                  me
                                                                                                                    ? void 0
                                                                                                                    : me.PriceList
                                                                                                                )
                                                                                                                  ? {
                                                                                                                      display:
                                                                                                                        "block",
                                                                                                                    }
                                                                                                                  : {
                                                                                                                      display:
                                                                                                                        "none",
                                                                                                                    },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    (0,
                                                                                                                    e.jsxs)(
                                                                                                                      "b",
                                                                                                                      Jb(
                                                                                                                        {
                                                                                                                          className:
                                                                                                                            "ST_CS_TableHeading",
                                                                                                                          style:
                                                                                                                            {
                                                                                                                              marginRight:
                                                                                                                                "20px",
                                                                                                                            },
                                                                                                                        },
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            [
                                                                                                                              v(
                                                                                                                                "customerInvoice_ProductTableColumnWholeSalePrice"
                                                                                                                              ),
                                                                                                                              "(",
                                                                                                                              _,
                                                                                                                              ") :",
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      )
                                                                                                                    ),
                                                                                                                    _ +
                                                                                                                      " ",
                                                                                                                    (null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.wholesalePrice) &&
                                                                                                                    "" !==
                                                                                                                      n.customer_name
                                                                                                                      ? null ===
                                                                                                                          (a =
                                                                                                                            null ==
                                                                                                                            t
                                                                                                                              ? void 0
                                                                                                                              : t.wholesalePrice) ||
                                                                                                                        void 0 ===
                                                                                                                          a
                                                                                                                        ? void 0
                                                                                                                        : a.toFixed(
                                                                                                                            2
                                                                                                                          )
                                                                                                                      : null ===
                                                                                                                          (i =
                                                                                                                            null ==
                                                                                                                            t
                                                                                                                              ? void 0
                                                                                                                              : t.variantPrice) ||
                                                                                                                        void 0 ===
                                                                                                                          i
                                                                                                                      ? void 0
                                                                                                                      : i.toFixed(
                                                                                                                          2
                                                                                                                        ),
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  ln,
                                                                                                  Jb(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        border:
                                                                                                          "1px solid #bfbfbf",
                                                                                                        p: 1,
                                                                                                      },
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            "b",
                                                                                                            Jb(
                                                                                                              {
                                                                                                                className:
                                                                                                                  "ST_CS_TableHeading",
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    " ",
                                                                                                                    v(
                                                                                                                      "customerInvoice_ProductTableColumnQuantity"
                                                                                                                    ),
                                                                                                                    " : ",
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            Nm,
                                                                                                            Jb(
                                                                                                              {
                                                                                                                sx: {
                                                                                                                  marginLeft:
                                                                                                                    "70px",
                                                                                                                  align:
                                                                                                                    "center",
                                                                                                                },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    _l,
                                                                                                                    Jb(
                                                                                                                      {
                                                                                                                        title:
                                                                                                                          G(
                                                                                                                            H[
                                                                                                                              (null ==
                                                                                                                              t
                                                                                                                                ? void 0
                                                                                                                                : t.variantId) ||
                                                                                                                                0
                                                                                                                            ]
                                                                                                                          )
                                                                                                                            ? ""
                                                                                                                            : v(
                                                                                                                                "customerInvoice_ProductTableQuantityUpdate_Btn"
                                                                                                                              ),
                                                                                                                        arrow:
                                                                                                                          !0,
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          (0,
                                                                                                                          e.jsxs)(
                                                                                                                            "span",
                                                                                                                            Jb(
                                                                                                                              {
                                                                                                                                className:
                                                                                                                                  "ST_CI_QuantityButtonGroup",
                                                                                                                              },
                                                                                                                              {
                                                                                                                                children:
                                                                                                                                  [
                                                                                                                                    (0,
                                                                                                                                    e.jsx)(
                                                                                                                                      vp,
                                                                                                                                      Jb(
                                                                                                                                        {
                                                                                                                                          className:
                                                                                                                                            "ST_CI_ProductIncrementBtn",
                                                                                                                                          "aria-label":
                                                                                                                                            "reduce",
                                                                                                                                          disabled:
                                                                                                                                            !G(
                                                                                                                                              H[
                                                                                                                                                (null ==
                                                                                                                                                t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId) ||
                                                                                                                                                  0
                                                                                                                                              ]
                                                                                                                                            ),
                                                                                                                                          onClick:
                                                                                                                                            function () {
                                                                                                                                              D(
                                                                                                                                                null ==
                                                                                                                                                  t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId,
                                                                                                                                                "subtract",
                                                                                                                                                (null ==
                                                                                                                                                me
                                                                                                                                                  ? void 0
                                                                                                                                                  : me.PriceList) &&
                                                                                                                                                  "" !==
                                                                                                                                                    n.customer_name
                                                                                                                                                  ? null ==
                                                                                                                                                    t
                                                                                                                                                    ? void 0
                                                                                                                                                    : t.wholesalePrice
                                                                                                                                                  : null ==
                                                                                                                                                    t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantPrice
                                                                                                                                              );
                                                                                                                                            },
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                          children:
                                                                                                                                            (0,
                                                                                                                                            e.jsx)(
                                                                                                                                              bv,
                                                                                                                                              {
                                                                                                                                                fontSize:
                                                                                                                                                  "small",
                                                                                                                                              }
                                                                                                                                            ),
                                                                                                                                        }
                                                                                                                                      )
                                                                                                                                    ),
                                                                                                                                    (0,
                                                                                                                                    e.jsx)(
                                                                                                                                      Xd,
                                                                                                                                      {
                                                                                                                                        InputProps:
                                                                                                                                          {
                                                                                                                                            inputProps:
                                                                                                                                              {
                                                                                                                                                className:
                                                                                                                                                  "ST_Custom_Number_Input",
                                                                                                                                              },
                                                                                                                                          },
                                                                                                                                        onKeyDown:
                                                                                                                                          sv,
                                                                                                                                        name: "".concat(
                                                                                                                                          null ==
                                                                                                                                            t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId
                                                                                                                                        ),
                                                                                                                                        disabled:
                                                                                                                                          !G(
                                                                                                                                            H[
                                                                                                                                              (null ==
                                                                                                                                              t
                                                                                                                                                ? void 0
                                                                                                                                                : t.variantId) ||
                                                                                                                                                0
                                                                                                                                            ]
                                                                                                                                          ),
                                                                                                                                        value:
                                                                                                                                          G(
                                                                                                                                            H[
                                                                                                                                              (null ==
                                                                                                                                              t
                                                                                                                                                ? void 0
                                                                                                                                                : t.variantId) ||
                                                                                                                                                0
                                                                                                                                            ]
                                                                                                                                          )
                                                                                                                                            ? H[
                                                                                                                                                (null ==
                                                                                                                                                t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId) ||
                                                                                                                                                  0
                                                                                                                                              ]
                                                                                                                                            : 1,
                                                                                                                                        className:
                                                                                                                                          "ST_CI_QuantityTextBox",
                                                                                                                                        variant:
                                                                                                                                          "outlined",
                                                                                                                                        size: "small",
                                                                                                                                        type: "number",
                                                                                                                                        onChange:
                                                                                                                                          function (
                                                                                                                                            e
                                                                                                                                          ) {
                                                                                                                                            return fe(
                                                                                                                                              e,
                                                                                                                                              null ==
                                                                                                                                                t
                                                                                                                                                ? void 0
                                                                                                                                                : t.variantId,
                                                                                                                                              (null ==
                                                                                                                                              me
                                                                                                                                                ? void 0
                                                                                                                                                : me.PriceList) &&
                                                                                                                                                "" !==
                                                                                                                                                  n.customer_name
                                                                                                                                                ? null ==
                                                                                                                                                  t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.wholesalePrice
                                                                                                                                                : null ==
                                                                                                                                                  t
                                                                                                                                                ? void 0
                                                                                                                                                : t.variantPrice
                                                                                                                                            );
                                                                                                                                          },
                                                                                                                                        error:
                                                                                                                                          !!ge[
                                                                                                                                            null !==
                                                                                                                                              (s =
                                                                                                                                                null ==
                                                                                                                                                t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId) &&
                                                                                                                                            void 0 !==
                                                                                                                                              s
                                                                                                                                              ? s
                                                                                                                                              : 0
                                                                                                                                          ],
                                                                                                                                      }
                                                                                                                                    ),
                                                                                                                                    (0,
                                                                                                                                    e.jsx)(
                                                                                                                                      vp,
                                                                                                                                      Jb(
                                                                                                                                        {
                                                                                                                                          className:
                                                                                                                                            "ST_CI_ProductDecrementBtn",
                                                                                                                                          "aria-label":
                                                                                                                                            "increase",
                                                                                                                                          disabled:
                                                                                                                                            !G(
                                                                                                                                              H[
                                                                                                                                                (null ==
                                                                                                                                                t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId) ||
                                                                                                                                                  0
                                                                                                                                              ]
                                                                                                                                            ),
                                                                                                                                          onClick:
                                                                                                                                            function () {
                                                                                                                                              D(
                                                                                                                                                null ==
                                                                                                                                                  t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId,
                                                                                                                                                "add",
                                                                                                                                                me.PriceList &&
                                                                                                                                                  "" !==
                                                                                                                                                    n.customer_name
                                                                                                                                                  ? null ==
                                                                                                                                                    t
                                                                                                                                                    ? void 0
                                                                                                                                                    : t.wholesalePrice
                                                                                                                                                  : null ==
                                                                                                                                                    t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantPrice
                                                                                                                                              );
                                                                                                                                            },
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                          children:
                                                                                                                                            (0,
                                                                                                                                            e.jsx)(
                                                                                                                                              _v,
                                                                                                                                              {
                                                                                                                                                fontSize:
                                                                                                                                                  "small",
                                                                                                                                              }
                                                                                                                                            ),
                                                                                                                                        }
                                                                                                                                      )
                                                                                                                                    ),
                                                                                                                                  ],
                                                                                                                              }
                                                                                                                            )
                                                                                                                          ),
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  ln,
                                                                                                  Jb(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        border:
                                                                                                          "1px solid #bfbfbf",
                                                                                                        p: 1,
                                                                                                        display:
                                                                                                          "flex",
                                                                                                      },
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            "b",
                                                                                                            Jb(
                                                                                                              {
                                                                                                                className:
                                                                                                                  "ST_CS_TableHeading",
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    v(
                                                                                                                      "customerInvoice_ProductTableColumnSubTotal"
                                                                                                                    ),
                                                                                                                    "(",
                                                                                                                    _,
                                                                                                                    ") :",
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            La,
                                                                                                            Jb(
                                                                                                              {
                                                                                                                ml: 8,
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    _ +
                                                                                                                      " ",
                                                                                                                    G(
                                                                                                                      O[
                                                                                                                        (null ==
                                                                                                                        t
                                                                                                                          ? void 0
                                                                                                                          : t.variantId) ||
                                                                                                                          0
                                                                                                                      ]
                                                                                                                    )
                                                                                                                      ? O[
                                                                                                                          (null ==
                                                                                                                          t
                                                                                                                            ? void 0
                                                                                                                            : t.variantId) ||
                                                                                                                            0
                                                                                                                        ].toFixed(
                                                                                                                          2
                                                                                                                        )
                                                                                                                      : (0).toFixed(
                                                                                                                          2
                                                                                                                        ),
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                              ],
                                                                                          }
                                                                                        ),
                                                                                    },
                                                                                    o
                                                                                  );
                                                                                }
                                                                              ),
                                                                            ],
                                                                        },
                                                                        o
                                                                      )
                                                                    : "";
                                                                }
                                                              ),
                                                            }
                                                          )
                                                        : (0, e.jsx)(hi, {
                                                            children: (0,
                                                            e.jsx)(
                                                              yi,
                                                              Jb(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  colSpan: (
                                                                    null == me
                                                                      ? void 0
                                                                      : me.PriceList
                                                                  )
                                                                    ? 7
                                                                    : 6,
                                                                },
                                                                {
                                                                  children: v(
                                                                    "customerInvoice_ProductTableEmpty_Msg"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          }),
                                                  })
                                                : (0, e.jsx)(Pi, {
                                                    children:
                                                      0 !== x.length
                                                        ? (0, e.jsx)(
                                                            e.Fragment,
                                                            {
                                                              children: x.map(
                                                                function (
                                                                  r,
                                                                  o
                                                                ) {
                                                                  return r
                                                                    .variants
                                                                    .length > 0
                                                                    ? (0,
                                                                      e.jsxs)(
                                                                        t.Fragment,
                                                                        {
                                                                          children:
                                                                            [
                                                                              (0,
                                                                              e.jsx)(
                                                                                hi,
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      yi,
                                                                                      Jb(
                                                                                        {
                                                                                          colSpan:
                                                                                            (
                                                                                              null ==
                                                                                              me
                                                                                                ? void 0
                                                                                                : me.PriceList
                                                                                            )
                                                                                              ? 7
                                                                                              : 6,
                                                                                          sx: [
                                                                                            ke,
                                                                                            {
                                                                                              borderTop:
                                                                                                "1px solid #bfbfbf",
                                                                                            },
                                                                                          ],
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Xp,
                                                                                              {
                                                                                                label:
                                                                                                  (null ==
                                                                                                  r
                                                                                                    ? void 0
                                                                                                    : r.productTitle) ||
                                                                                                  "-",
                                                                                                control:
                                                                                                  (0,
                                                                                                  e.jsx)(
                                                                                                    vm,
                                                                                                    {
                                                                                                      disabled:
                                                                                                        c(
                                                                                                          r
                                                                                                        ),
                                                                                                      checked:
                                                                                                        !!G(
                                                                                                          F[
                                                                                                            (null ==
                                                                                                            r
                                                                                                              ? void 0
                                                                                                              : r.productId) ||
                                                                                                              0
                                                                                                          ]
                                                                                                        ),
                                                                                                      onChange:
                                                                                                        function (
                                                                                                          e
                                                                                                        ) {
                                                                                                          return Z(
                                                                                                            e,
                                                                                                            "isProduct",
                                                                                                            u(
                                                                                                              r
                                                                                                            )
                                                                                                          );
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                              }
                                                                                            ),
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                }
                                                                              ),
                                                                              r.variants.map(
                                                                                function (
                                                                                  t,
                                                                                  o
                                                                                ) {
                                                                                  var a,
                                                                                    i,
                                                                                    s;
                                                                                  return (0,
                                                                                  e.jsxs)(
                                                                                    hi,
                                                                                    Jb(
                                                                                      {
                                                                                        sx: {
                                                                                          whiteSpace:
                                                                                            "nowrap",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: ke,
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      Xp,
                                                                                                      {
                                                                                                        className:
                                                                                                          "ST_CI_product-label",
                                                                                                        sx: {
                                                                                                          ml: 2,
                                                                                                        },
                                                                                                        label:
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            e.Fragment,
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  0 !==
                                                                                                                    (null ==
                                                                                                                    r
                                                                                                                      ? void 0
                                                                                                                      : r
                                                                                                                          .productImages
                                                                                                                          .length) &&
                                                                                                                  (null ==
                                                                                                                  r
                                                                                                                    ? void 0
                                                                                                                    : r
                                                                                                                        .productImages[0]
                                                                                                                        .src)
                                                                                                                    ? (0,
                                                                                                                      e.jsx)(
                                                                                                                        Tm,
                                                                                                                        {
                                                                                                                          alt: "image",
                                                                                                                          src: B(
                                                                                                                            t.image_id,
                                                                                                                            r.productImages
                                                                                                                          ),
                                                                                                                          variant:
                                                                                                                            "rounded",
                                                                                                                        }
                                                                                                                      )
                                                                                                                    : (0,
                                                                                                                      e.jsx)(
                                                                                                                        Tm,
                                                                                                                        Jb(
                                                                                                                          {
                                                                                                                            alt: "image",
                                                                                                                            sx: {
                                                                                                                              bgcolor:
                                                                                                                                "white",
                                                                                                                              color:
                                                                                                                                "black",
                                                                                                                            },
                                                                                                                            variant:
                                                                                                                              "rounded",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                vv,
                                                                                                                                {
                                                                                                                                  sx: {
                                                                                                                                    fontSize:
                                                                                                                                      "3.1rem",
                                                                                                                                  },
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    ln,
                                                                                                                    Jb(
                                                                                                                      {
                                                                                                                        sx: {
                                                                                                                          ml: 1,
                                                                                                                        },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          "Default Title" !==
                                                                                                                          (null ==
                                                                                                                          t
                                                                                                                            ? void 0
                                                                                                                            : t.variantTitle)
                                                                                                                            ? t.variantTitle
                                                                                                                            : r.productTitle,
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          ),
                                                                                                        control:
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            vm,
                                                                                                            {
                                                                                                              disabled:
                                                                                                                l(
                                                                                                                  t
                                                                                                                ),
                                                                                                              checked:
                                                                                                                !!G(
                                                                                                                  H[
                                                                                                                    (null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantId) ||
                                                                                                                      0
                                                                                                                  ]
                                                                                                                ),
                                                                                                              onChange:
                                                                                                                function (
                                                                                                                  e
                                                                                                                ) {
                                                                                                                  return Z(
                                                                                                                    e,
                                                                                                                    "isVariant",
                                                                                                                    r,
                                                                                                                    t
                                                                                                                  );
                                                                                                                },
                                                                                                            }
                                                                                                          ),
                                                                                                      }
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: ke,
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      Nm,
                                                                                                      Jb(
                                                                                                        {
                                                                                                          sx: {
                                                                                                            marginLeft:
                                                                                                              "70px",
                                                                                                          },
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            (0,
                                                                                                            e.jsx)(
                                                                                                              _l,
                                                                                                              Jb(
                                                                                                                {
                                                                                                                  title:
                                                                                                                    G(
                                                                                                                      H[
                                                                                                                        (null ==
                                                                                                                        t
                                                                                                                          ? void 0
                                                                                                                          : t.variantId) ||
                                                                                                                          0
                                                                                                                      ]
                                                                                                                    )
                                                                                                                      ? ""
                                                                                                                      : v(
                                                                                                                          "customerInvoice_ProductTableQuantityUpdate_Btn"
                                                                                                                        ),
                                                                                                                  arrow:
                                                                                                                    !0,
                                                                                                                },
                                                                                                                {
                                                                                                                  children:
                                                                                                                    (0,
                                                                                                                    e.jsxs)(
                                                                                                                      "span",
                                                                                                                      Jb(
                                                                                                                        {
                                                                                                                          className:
                                                                                                                            "ST_CI_QuantityButtonGroup",
                                                                                                                        },
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            [
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                vp,
                                                                                                                                Jb(
                                                                                                                                  {
                                                                                                                                    className:
                                                                                                                                      "ST_CI_ProductIncrementBtn",
                                                                                                                                    "aria-label":
                                                                                                                                      "reduce",
                                                                                                                                    disabled:
                                                                                                                                      !G(
                                                                                                                                        H[
                                                                                                                                          (null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId) ||
                                                                                                                                            0
                                                                                                                                        ]
                                                                                                                                      ),
                                                                                                                                    onClick:
                                                                                                                                      function () {
                                                                                                                                        D(
                                                                                                                                          null ==
                                                                                                                                            t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId,
                                                                                                                                          "subtract",
                                                                                                                                          (null ==
                                                                                                                                          me
                                                                                                                                            ? void 0
                                                                                                                                            : me.PriceList) &&
                                                                                                                                            "" !==
                                                                                                                                              n.customer_name
                                                                                                                                            ? null ==
                                                                                                                                              t
                                                                                                                                              ? void 0
                                                                                                                                              : t.wholesalePrice
                                                                                                                                            : null ==
                                                                                                                                              t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantPrice
                                                                                                                                        );
                                                                                                                                      },
                                                                                                                                  },
                                                                                                                                  {
                                                                                                                                    children:
                                                                                                                                      (0,
                                                                                                                                      e.jsx)(
                                                                                                                                        bv,
                                                                                                                                        {
                                                                                                                                          fontSize:
                                                                                                                                            "small",
                                                                                                                                        }
                                                                                                                                      ),
                                                                                                                                  }
                                                                                                                                )
                                                                                                                              ),
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Xd,
                                                                                                                                {
                                                                                                                                  InputProps:
                                                                                                                                    {
                                                                                                                                      inputProps:
                                                                                                                                        {
                                                                                                                                          className:
                                                                                                                                            "ST_Custom_Number_Input",
                                                                                                                                        },
                                                                                                                                    },
                                                                                                                                  onKeyDown:
                                                                                                                                    sv,
                                                                                                                                  name: "".concat(
                                                                                                                                    null ==
                                                                                                                                      t
                                                                                                                                      ? void 0
                                                                                                                                      : t.variantId
                                                                                                                                  ),
                                                                                                                                  disabled:
                                                                                                                                    !G(
                                                                                                                                      H[
                                                                                                                                        (null ==
                                                                                                                                        t
                                                                                                                                          ? void 0
                                                                                                                                          : t.variantId) ||
                                                                                                                                          0
                                                                                                                                      ]
                                                                                                                                    ),
                                                                                                                                  value:
                                                                                                                                    G(
                                                                                                                                      H[
                                                                                                                                        (null ==
                                                                                                                                        t
                                                                                                                                          ? void 0
                                                                                                                                          : t.variantId) ||
                                                                                                                                          0
                                                                                                                                      ]
                                                                                                                                    )
                                                                                                                                      ? H[
                                                                                                                                          (null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId) ||
                                                                                                                                            0
                                                                                                                                        ]
                                                                                                                                      : 1,
                                                                                                                                  className:
                                                                                                                                    "ST_CI_QuantityTextBox",
                                                                                                                                  variant:
                                                                                                                                    "outlined",
                                                                                                                                  size: "small",
                                                                                                                                  type: "number",
                                                                                                                                  onChange:
                                                                                                                                    function (
                                                                                                                                      e
                                                                                                                                    ) {
                                                                                                                                      return fe(
                                                                                                                                        e,
                                                                                                                                        null ==
                                                                                                                                          t
                                                                                                                                          ? void 0
                                                                                                                                          : t.variantId,
                                                                                                                                        (null ==
                                                                                                                                        me
                                                                                                                                          ? void 0
                                                                                                                                          : me.PriceList) &&
                                                                                                                                          "" !==
                                                                                                                                            n.customer_name
                                                                                                                                          ? null ==
                                                                                                                                            t
                                                                                                                                            ? void 0
                                                                                                                                            : t.wholesalePrice
                                                                                                                                          : null ==
                                                                                                                                            t
                                                                                                                                          ? void 0
                                                                                                                                          : t.variantPrice
                                                                                                                                      );
                                                                                                                                    },
                                                                                                                                  error:
                                                                                                                                    !!ge[
                                                                                                                                      null !==
                                                                                                                                        (a =
                                                                                                                                          null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId) &&
                                                                                                                                      void 0 !==
                                                                                                                                        a
                                                                                                                                        ? a
                                                                                                                                        : 0
                                                                                                                                    ],
                                                                                                                                }
                                                                                                                              ),
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                vp,
                                                                                                                                Jb(
                                                                                                                                  {
                                                                                                                                    className:
                                                                                                                                      "ST_CI_ProductDecrementBtn",
                                                                                                                                    "aria-label":
                                                                                                                                      "increase",
                                                                                                                                    disabled:
                                                                                                                                      !G(
                                                                                                                                        H[
                                                                                                                                          (null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId) ||
                                                                                                                                            0
                                                                                                                                        ]
                                                                                                                                      ),
                                                                                                                                    onClick:
                                                                                                                                      function () {
                                                                                                                                        D(
                                                                                                                                          null ==
                                                                                                                                            t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantId,
                                                                                                                                          "add",
                                                                                                                                          me.PriceList &&
                                                                                                                                            "" !==
                                                                                                                                              n.customer_name
                                                                                                                                            ? null ==
                                                                                                                                              t
                                                                                                                                              ? void 0
                                                                                                                                              : t.wholesalePrice
                                                                                                                                            : null ==
                                                                                                                                              t
                                                                                                                                            ? void 0
                                                                                                                                            : t.variantPrice
                                                                                                                                        );
                                                                                                                                      },
                                                                                                                                  },
                                                                                                                                  {
                                                                                                                                    children:
                                                                                                                                      (0,
                                                                                                                                      e.jsx)(
                                                                                                                                        _v,
                                                                                                                                        {
                                                                                                                                          fontSize:
                                                                                                                                            "small",
                                                                                                                                        }
                                                                                                                                      ),
                                                                                                                                  }
                                                                                                                                )
                                                                                                                              ),
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      )
                                                                                                                    ),
                                                                                                                }
                                                                                                              )
                                                                                                            ),
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: ke,
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      " ",
                                                                                                      (null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.sku) ||
                                                                                                        "-",
                                                                                                      " ",
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: ke,
                                                                                                  align:
                                                                                                    "center",
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    d(
                                                                                                      t
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: J
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      _ +
                                                                                                        " ",
                                                                                                      (null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.variantPrice.toFixed(
                                                                                                            2
                                                                                                          )) ||
                                                                                                        (0).toFixed(
                                                                                                          2
                                                                                                        ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: (
                                                                                                    null ==
                                                                                                    me
                                                                                                      ? void 0
                                                                                                      : me.PriceList
                                                                                                  )
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      _ +
                                                                                                        " ",
                                                                                                      (null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.wholesalePrice) &&
                                                                                                      "" !==
                                                                                                        n.customer_name
                                                                                                        ? null ===
                                                                                                            (i =
                                                                                                              null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.wholesalePrice) ||
                                                                                                          void 0 ===
                                                                                                            i
                                                                                                          ? void 0
                                                                                                          : i.toFixed(
                                                                                                              2
                                                                                                            )
                                                                                                        : null ===
                                                                                                            (s =
                                                                                                              null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.variantPrice) ||
                                                                                                          void 0 ===
                                                                                                            s
                                                                                                        ? void 0
                                                                                                        : s.toFixed(
                                                                                                            2
                                                                                                          ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              yi,
                                                                                              Jb(
                                                                                                {
                                                                                                  sx: ke,
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      _ +
                                                                                                        " ",
                                                                                                      G(
                                                                                                        O[
                                                                                                          (null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId) ||
                                                                                                            0
                                                                                                        ]
                                                                                                      )
                                                                                                        ? O[
                                                                                                            (null ==
                                                                                                            t
                                                                                                              ? void 0
                                                                                                              : t.variantId) ||
                                                                                                              0
                                                                                                          ].toFixed(
                                                                                                            2
                                                                                                          )
                                                                                                        : (0).toFixed(
                                                                                                            2
                                                                                                          ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                          ],
                                                                                      }
                                                                                    ),
                                                                                    o
                                                                                  );
                                                                                }
                                                                              ),
                                                                            ],
                                                                        },
                                                                        o
                                                                      )
                                                                    : "";
                                                                }
                                                              ),
                                                            }
                                                          )
                                                        : (0, e.jsx)(hi, {
                                                            children: (0,
                                                            e.jsx)(
                                                              yi,
                                                              Jb(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  colSpan: (
                                                                    null == me
                                                                      ? void 0
                                                                      : me.PriceList
                                                                  )
                                                                    ? 7
                                                                    : 6,
                                                                },
                                                                {
                                                                  children: v(
                                                                    "customerInvoice_ProductTableEmpty_Msg"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          }),
                                                  }),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsxs)(
                La,
                Jb(
                  { sx: we },
                  {
                    children: [
                      (0, e.jsx)(
                        La,
                        Jb(
                          { sx: De },
                          {
                            children: (0, e.jsx)(Xd, {
                              InputProps: {
                                style: Jb(Jb({}, Pe), { height: he ? 70 : 40 }),
                              },
                              label:
                                "" != Y.customerInvoice_contentHeading2Title3
                                  ? null == Y
                                    ? void 0
                                    : Y.customerInvoice_contentHeading2Title3
                                  : v("customerInvoice_contentHeading2Title3"),
                              value: k,
                              onChange: function (e) {
                                return w(e.target.value);
                              },
                              className: "ST_CI_textfield-details ",
                              type: "search",
                              size: "small",
                            }),
                          }
                        )
                      ),
                      (0, e.jsxs)(
                        La,
                        Jb(
                          { sx: Oe },
                          {
                            children: [
                              (0, e.jsxs)(
                                Wa,
                                Jb(
                                  { variant: "subtitle1", sx: Ie },
                                  {
                                    children: [
                                      v("customerInvoice_OrderSubTotal"),
                                      "(",
                                      _,
                                      ")",
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsx)(Kt, {
                                orientation: "vertical",
                                variant: "middle",
                                flexItem: !0,
                                sx: { width: "auto !important" },
                              }),
                              (0, e.jsxs)(
                                Wa,
                                Jb(
                                  { variant: "subtitle1", sx: Ie },
                                  { children: [_ + " ", I.toFixed(2)] }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
              "" !== n.customer_shippingaddressID.toString() &&
              "" !== n.customer_zipnumber
                ? (0, e.jsxs)($u, {
                    children: [
                      (0, e.jsx)(
                        Nu,
                        Jb(
                          {
                            required: !0,
                            id: "demo-controlled-radio-buttons-group",
                          },
                          {
                            children: v(
                              "customerInvoice_PleaseSetAnyShippingAddressMsg"
                            ),
                          }
                        )
                      ),
                      (0, e.jsxs)(
                        mb,
                        Jb(
                          {
                            "aria-labelledby":
                              "demo-controlled-radio-buttons-group",
                            name: "controlled-radio-buttons-group",
                            value: oe,
                          },
                          {
                            children: [
                              null ===
                                (r =
                                  null == b
                                    ? void 0
                                    : b.customerNewUpdatedData) || void 0 === r
                                ? void 0
                                : r.customerAddressesList.map(function (r, o) {
                                    var a, i, s, l, c;
                                    return (0, e.jsx)(
                                      t.Fragment,
                                      {
                                        children:
                                          r.id.toString() ===
                                          n.customer_shippingaddressID.toString()
                                            ? (0, e.jsx)(Xp, {
                                                value: "customerAddress",
                                                control: (0, e.jsx)(Ib, {
                                                  size: "small",
                                                  onChange: function () {
                                                    return re(
                                                      "customerAddress"
                                                    );
                                                  },
                                                }),
                                                label:
                                                  (null !==
                                                    (a =
                                                      null == r
                                                        ? void 0
                                                        : r.address1) &&
                                                  void 0 !== a
                                                    ? a
                                                    : "") +
                                                  " " +
                                                  (null !==
                                                    (i =
                                                      null == r
                                                        ? void 0
                                                        : r.city) &&
                                                  void 0 !== i
                                                    ? i
                                                    : "") +
                                                  " " +
                                                  (null !==
                                                    (s =
                                                      null == r
                                                        ? void 0
                                                        : r.province) &&
                                                  void 0 !== s
                                                    ? s
                                                    : "") +
                                                  " " +
                                                  (null !==
                                                    (l =
                                                      null == r
                                                        ? void 0
                                                        : r.country) &&
                                                  void 0 !== l
                                                    ? l
                                                    : "") +
                                                  " " +
                                                  (null !==
                                                    (c =
                                                      null == r
                                                        ? void 0
                                                        : r.zip) && void 0 !== c
                                                    ? c
                                                    : ""),
                                              })
                                            : null,
                                      },
                                      o
                                    );
                                  }),
                              (0, e.jsx)(Xp, {
                                value: "formAddress",
                                control: (0, e.jsx)(Ib, {
                                  size: "small",
                                  onChange: function () {
                                    return re("formAddress");
                                  },
                                }),
                                label:
                                  n.customer_address1 +
                                  " " +
                                  n.customer_city +
                                  " " +
                                  n.customer_state +
                                  " " +
                                  n.customer_country +
                                  " " +
                                  n.customer_zipnumber,
                              }),
                            ],
                          }
                        )
                      ),
                    ],
                  })
                : null,
              (0, e.jsxs)(
                La,
                Jb(
                  { sx: { ST_CI_MinWidth: Pe, ST_CI_ShippingCost: je } },
                  {
                    children: [
                      (0, e.jsx)(
                        _l,
                        Jb(
                          {
                            title:
                              v("customerInvoice_CalculateShippingCost_Btn") ||
                              "",
                            arrow: !0,
                          },
                          {
                            children: (0, e.jsxs)(
                              vp,
                              Jb(
                                {
                                  disabled: !ye || Be,
                                  sx: [rv, Ae],
                                  size: "small",
                                  variant: "outlined",
                                  onClick: function () {
                                    return Q();
                                  },
                                },
                                {
                                  children: [
                                    v(
                                      "customerInvoice_CalculateShippingCost_Btn"
                                    ),
                                    (0, e.jsx)(Tb, {
                                      color: "primary",
                                      sx: { ml: 1, fontSize: 30 },
                                    }),
                                  ],
                                }
                              )
                            ),
                          }
                        )
                      ),
                      (0, e.jsxs)(
                        Xd,
                        Jb(
                          {
                            sx: Jb(Jb({}, Le), {
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    "Yes" == ce && "" == ee ? "red" : "none",
                                },
                              },
                            }),
                            id: "outlined-select-shippingCost",
                            select: !0,
                            label: v("customerInvoice_selectShippingCost"),
                            value: ee,
                            onChange: function (e) {
                              return te(e.target.value), ue("Yes");
                            },
                            type: "search",
                            size: "small",
                          },
                          {
                            children: [
                              (0, e.jsx)(
                                ob,
                                Jb(
                                  {
                                    disabled: !0,
                                    value:
                                      ee ==
                                      v(
                                        "customerInvoice_CalculatingShippingRates_Msg"
                                      )
                                        ? ee
                                        : "",
                                  },
                                  {
                                    children:
                                      ee ==
                                      v(
                                        "customerInvoice_CalculatingShippingRates_Msg"
                                      )
                                        ? ee
                                        : v(
                                            "customerInvoice_selectShippingCost"
                                          ),
                                  }
                                )
                              ),
                              ie.length > 0
                                ? null == ie
                                  ? void 0
                                  : ie.map(function (t, n) {
                                      return (0,
                                      e.jsxs)(ob, Jb({ value: t.name + "/" + t.price }, { children: [t.name, " / ", t.price] }), n);
                                    })
                                : null,
                            ],
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
              de || "" !== ee
                ? null
                : (0, e.jsxs)(
                    Wa,
                    Jb(
                      { sx: Re, variant: "subtitle1" },
                      {
                        children: [
                          v("customerInvoice_ShippingCostAddOrNot_Msg"),
                          (0, e.jsxs)(
                            "span",
                            Jb(
                              {
                                style: {
                                  marginLeft: he ? "0rem" : "0.5rem",
                                  cursor: "pointer",
                                  color: "Yes" == ce ? "green" : "blue",
                                },
                                onClick: function () {
                                  return pe ? null : le("Yes");
                                },
                              },
                              {
                                children: [
                                  v("customerInvoice_ShippingCostAddOrNot_Yes"),
                                  (0, e.jsx)(Ib, {
                                    sx: Jb({ mr: "0.5rem" }, Ne),
                                    checked: "Yes" === ce,
                                    value: "Yes",
                                    disabled: pe,
                                    inputProps: { "aria-label": "Yes" },
                                    size: "small",
                                    color: "success",
                                  }),
                                ],
                              }
                            )
                          ),
                          "/",
                          (0, e.jsxs)(
                            "span",
                            Jb(
                              {
                                style: {
                                  marginLeft: "0.5rem",
                                  cursor: "pointer",
                                  color: "No" == ce ? "green" : "blue",
                                  pointerEvents: de ? "none" : "auto",
                                },
                                onClick: function () {
                                  return pe ? null : le("No");
                                },
                              },
                              {
                                children: [
                                  v("customerInvoice_ShippingCostAddOrNot_No"),
                                  (0, e.jsx)(Ib, {
                                    sx: Ne,
                                    checked: "No" === ce,
                                    value: "No",
                                    disabled: pe || de,
                                    inputProps: { "aria-label": "No" },
                                    size: "small",
                                    color: "success",
                                  }),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
              (0, e.jsxs)(
                ln,
                Jb(
                  { sx: Te },
                  {
                    children: [
                      me.CreateInvoice
                        ? (0, e.jsxs)(e.Fragment, {
                            children: [
                              (0, e.jsx)(
                                vp,
                                Jb(
                                  {
                                    sx: [rv, ze],
                                    variant: "contained",
                                    disabled: Be,
                                    onClick: function () {
                                      return A("draftOrder");
                                    },
                                  },
                                  {
                                    children:
                                      P.msg ===
                                      v("customerInvoice_CreatingDraft_Msg")
                                        ? P.msg
                                        : v("customerInvoice_DraftOrderBtn"),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                vp,
                                Jb(
                                  {
                                    sx: [{ ml: 1 }, rv, ze],
                                    variant: "contained",
                                    endIcon: (0, e.jsx)(Mb, {}),
                                    disabled: Be,
                                    onClick: function () {
                                      return A("sendInvoice");
                                    },
                                  },
                                  {
                                    children:
                                      P.msg === v("customerInvoice_Sending_Msg")
                                        ? P.msg
                                        : "" != Y.customerInvoice_SendInvoiceBtn
                                        ? null == Y
                                          ? void 0
                                          : Y.customerInvoice_SendInvoiceBtn
                                        : v("customerInvoice_SendInvoiceBtn"),
                                  }
                                )
                              ),
                            ],
                          })
                        : null,
                      xe
                        ? (0, e.jsx)(
                            vp,
                            Jb(
                              {
                                sx: [{ ml: 1 }, ze, rv],
                                variant: "contained",
                                endIcon: (0, e.jsx)(fv, {}),
                                disabled: Be,
                                onClick: function () {
                                  return A("createOrder");
                                },
                              },
                              {
                                children:
                                  P.msg === v("customerInvoice_Creating_Msg")
                                    ? P.msg
                                    : v("customerInvoice_CreateOrderBtn"),
                              }
                            )
                          )
                        : null,
                    ],
                  }
                )
              ),
              (0, e.jsx)(
                Wa,
                Jb(
                  {
                    variant: "body2",
                    sx: { mt: 2, mr: 1, display: " block", color: P.color },
                    align: "right",
                  },
                  { children: ve() ? "" : P.msg }
                )
              ),
              (0, e.jsx)(
                Gm,
                Jb(
                  {
                    anchorOrigin: { vertical: "bottom", horizontal: "center" },
                    open: ne.open,
                    autoHideDuration: 4e3,
                    onClose: K,
                  },
                  {
                    children: (0, e.jsx)(
                      ch,
                      Jb(
                        {
                          onClose: K,
                          severity:
                            null !== (o = null == ne ? void 0 : ne.severity) &&
                            void 0 !== o
                              ? o
                              : "error",
                          variant: "filled",
                          sx: { width: "100%" },
                        },
                        { children: ne.msg }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)("br", {}),
            ],
          })
        );
      }
      var Xb = function () {
        return (
          (Xb =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          Xb.apply(this, arguments)
        );
      };
      function e_() {
        var n = Gv().showCustomCountries,
          r = Hb(),
          o = (r.getCountries, r.t),
          a = r.salesRepData,
          i = r.customerName,
          s = r.setCustomerName,
          l = r.mobileNumber,
          c = r.setMobileNumber,
          u = r.emailId,
          d = r.setEmailId,
          p = r.companyName,
          m = r.setCompanyName,
          h = r.firstName,
          f = r.setFirstName,
          g = r.lastName,
          v = r.setLastName,
          b = r.address1,
          _ = r.setAddress1,
          y = r.address2,
          x = r.setAddress2,
          C = r.city,
          S = r.setCity,
          k = r.zipNumber,
          w = r.setZipNumber,
          P = r.selectShippingAddress,
          O = r.setSelectShippingAddress,
          I = r.selectCountry,
          T = r.setSelectCountry,
          M = r.selectCountryState,
          E = r.setSelectSelectCountryState,
          D = r.countriesStateData,
          j = r.addDetailsBtn,
          R = r.setAddDetailsBtn,
          N = r.addShippingAddressBtn,
          A = r.setAddShippingAddressBtn,
          L = r.errors,
          z = r.SearchByCountry,
          B = r.checkValidation,
          Z = r.setOrderCreateBtn,
          F = r.orderCreateBtn,
          H = r.tagWiseWholeSalePrices,
          V = r.customerAddressOptionsData,
          W = r.setCustomerAddressOptionsData,
          $ = r.setCountriesStateData,
          U = r.selectCountryCode,
          K = r.editOrderReduxData,
          G = r.editOrderFlag,
          q = r.EmptyFields,
          Y = r.handleCustomerChange,
          J = r.handleGetOptionLabel,
          Q = r.SearchByCustomer,
          X = r.setEditOrderReduxData,
          ee = r.setTagWiseWholeSalePrices,
          te = r.handleSelectShippingAddress,
          ne = { mt: 2, ml: 0 },
          re = { backgroundColor: "white" };
        (0, t.useEffect)(
          function () {
            "" === i.trim() ||
            "" === u.trim() ||
            !1 !== L.email ||
            (!1 !== L.mobilenumber && "" !== L.mobilenumber)
              ? Z(!0)
              : Z(!1);
          },
          [i, u, l]
        );
        var oe = {
          customer_name: i,
          customer_email: u,
          customer_mobilenumber: l,
          customer_companyname: p,
          customer_firstname: h,
          customer_lastname: g,
          customer_address1: b,
          customer_address2: y,
          customer_city: C,
          customer_zipnumber: k,
          customer_shippingaddressID: P,
          customer_country: I,
          customer_countryCode: U,
          customer_state: M,
          email_validation: L.email,
          mobile_validation: L.mobilenumber,
          orderCreateBtn: F,
          setOrderCreateBtn: Z,
          customerAddressesList: V,
          setCustomerName: s,
          setEmailId: d,
          setMobileNumber: c,
          setCompanyName: m,
          setFirstName: f,
          setLastName: v,
          setAddress1: _,
          setAddress2: x,
          setCity: S,
          setZipNumber: w,
          setSelectShippingAddress: O,
          setSelectCountry: T,
          setSelectSelectCountryState: E,
          tagWiseWholeSalePrices: H,
          setCustomerAddressOptionsData: W,
          setCountriesStateData: $,
          SearchByCustomer: Q,
          setEditOrderReduxData: X,
          setTagWiseWholeSalePrices: ee,
        };
        return (0, e.jsxs)(
          ln,
          Xb(
            { className: "ST_Main_Card" },
            {
              children: [
                (0, e.jsxs)(
                  La,
                  Xb(
                    { sx: Lo },
                    {
                      children: [
                        (0, e.jsx)(
                          Wa,
                          Xb(
                            { variant: ov, sx: zo },
                            { children: o("customerInvoice_title") }
                          )
                        ),
                        (0, e.jsx)("hr", {
                          className: "ST_CI_Horizontal_Line",
                        }),
                      ],
                    }
                  )
                ),
                (0, e.jsx)(
                  ln,
                  Xb(
                    { sx: { flexGrow: 1 } },
                    {
                      children: (0, e.jsxs)(
                        La,
                        Xb(
                          {
                            container: !0,
                            spacing: 2,
                            sx: ne,
                            className: "ST_CI_textfield-details",
                          },
                          {
                            children: [
                              (0, e.jsx)(
                                La,
                                Xb(
                                  {
                                    item: !0,
                                    md: 4,
                                    className: "ST_CI_textfield-details",
                                  },
                                  {
                                    children: (0, e.jsx)(Bc, {
                                      disabled:
                                        (null == K ? void 0 : K.actionEvent) ===
                                        G,
                                      value: i,
                                      id: "searchByCustomerName",
                                      freeSolo: !0,
                                      inputValue: i,
                                      onChange: function (e, t) {
                                        return Y(e, t);
                                      },
                                      getOptionLabel: function (e) {
                                        return J(e);
                                      },
                                      onInputChange: function (e, t) {
                                        return (
                                          s(t), "" !== t || "" !== i ? q() : ""
                                        );
                                      },
                                      options: a.baseData.repcustomers
                                        ? a.baseData.repcustomers
                                        : [],
                                      renderOption: function (e, n) {
                                        var r;
                                        return (0, t.createElement)(
                                          ln,
                                          Xb({ component: "li" }, e, {
                                            key: n.CustomerId
                                              ? n.CustomerId
                                              : "",
                                          }),
                                          (null !== (r = n.CustomerName) &&
                                          void 0 !== r
                                            ? r
                                            : ""
                                          ).trim()
                                            ? n.CustomerName
                                            : n.CustomerMailid
                                        );
                                      },
                                      renderInput: function (t) {
                                        return (0, e.jsx)(
                                          Xd,
                                          Xb(
                                            {
                                              required: !0,
                                              className:
                                                "ST_CI_textfield-details ",
                                              sx: re,
                                            },
                                            t,
                                            {
                                              label: o(
                                                "customerInvoice_contentHeading2Title1"
                                              ),
                                              InputProps: Xb(
                                                Xb({}, t.InputProps),
                                                {
                                                  style: { height: 47 },
                                                  endAdornment: (0, e.jsx)(
                                                    ap,
                                                    Xb(
                                                      { position: "start" },
                                                      {
                                                        children: (0, e.jsx)(
                                                          mv,
                                                          {}
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                }
                                              ),
                                              name: "customername",
                                              onChange: function (e) {
                                                return B(e, "validateOnstring");
                                              },
                                              type: "search",
                                              error: L.customername,
                                            },
                                            L.customername && {
                                              error: !0,
                                              helperText: L.customername,
                                            }
                                          )
                                        );
                                      },
                                      size: "small",
                                    }),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                La,
                                Xb(
                                  {
                                    item: !0,
                                    md: 4,
                                    className:
                                      "ST_CI_textfield-details ST_CI_responsive-textfield",
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      Xd,
                                      Xb(
                                        {
                                          disabled:
                                            (null == K
                                              ? void 0
                                              : K.actionEvent) === G,
                                          required: !0,
                                          label: o(
                                            "customerInvoice_contentHeading2Title2"
                                          ),
                                          className: "ST_CI_textfield-details",
                                          sx: re,
                                          name: "email",
                                          value: u,
                                          onChange: function (e) {
                                            return (
                                              d(e.target.value),
                                              B(e, "validateOnemail")
                                            );
                                          },
                                          type: "search",
                                          size: "small",
                                          error: L.email,
                                        },
                                        L.email && {
                                          error: !0,
                                          helperText: L.email,
                                        },
                                        {
                                          InputProps: { style: { height: 47 } },
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                La,
                                Xb(
                                  {
                                    item: !0,
                                    md: 4,
                                    className:
                                      "ST_CI_textfield-details ST_CI_responsive-textfield",
                                  },
                                  {
                                    children: (0, e.jsxs)(
                                      $u,
                                      Xb(
                                        { fullWidth: !0, size: "small" },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              Bu,
                                              Xb(
                                                {
                                                  required: !0,
                                                  id: "demo-select-small",
                                                },
                                                {
                                                  children: o(
                                                    "customerInvoice_contentHeading2Title4"
                                                  ),
                                                }
                                              )
                                            ),
                                            (0, e.jsxs)(
                                              Kd,
                                              Xb(
                                                {
                                                  labelId: "demo-select-small",
                                                  value: P,
                                                  sx: Xb(Xb({}, re), {
                                                    height: 47,
                                                  }),
                                                  label: o(
                                                    "customerInvoice_contentHeading2Title4"
                                                  ),
                                                  onChange: function (e) {
                                                    return te(e);
                                                  },
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      ob,
                                                      Xb(
                                                        { value: "" },
                                                        {
                                                          children: o(
                                                            "customerInvoice_SelectShippingAddress"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    V.length > 0
                                                      ? V.map(function (t, n) {
                                                          return (null == t
                                                            ? void 0
                                                            : t.address1) ||
                                                            (null == t
                                                              ? void 0
                                                              : t.city) ||
                                                            (null == t
                                                              ? void 0
                                                              : t.province) ||
                                                            (null == t
                                                              ? void 0
                                                              : t.country) ||
                                                            (null == t
                                                              ? void 0
                                                              : t.zip)
                                                            ? (0, e.jsxs)(
                                                                ob,
                                                                Xb(
                                                                  {
                                                                    value:
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.id) ||
                                                                      "",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.address1) ||
                                                                        "",
                                                                      " ",
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.address2) ||
                                                                        "",
                                                                      " ",
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.city) ||
                                                                        "",
                                                                      " ",
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.province) ||
                                                                        "",
                                                                      " ",
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.country) ||
                                                                        "",
                                                                      " ",
                                                                      (null == t
                                                                        ? void 0
                                                                        : t.zip) ||
                                                                        "",
                                                                    ],
                                                                  }
                                                                ),
                                                                n
                                                              )
                                                            : (0, e.jsx)(
                                                                ob,
                                                                { value: "" },
                                                                n
                                                              );
                                                        })
                                                      : null,
                                                  ],
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    }
                  )
                ),
                (0, e.jsx)("br", {}),
                (0, e.jsx)(
                  Il,
                  Xb(
                    {
                      component: "button",
                      variant: "body2",
                      sx: { display: " inline-flex" },
                      onClick: function () {
                        return A(!N);
                      },
                    },
                    {
                      children: N
                        ? (0, e.jsxs)(e.Fragment, {
                            children: [
                              o("customerInvoice_HideAddress"),
                              " ",
                              (0, e.jsx)(ab, {}),
                            ],
                          })
                        : (0, e.jsxs)(e.Fragment, {
                            children: [
                              o("customerInvoice_add_shipping_address"),
                              " ",
                              (0, e.jsx)(ib, {}),
                            ],
                          }),
                    }
                  )
                ),
                N
                  ? (0, e.jsxs)(
                      ln,
                      Xb(
                        { sx: { flexGrow: 1 } },
                        {
                          children: [
                            (0, e.jsxs)(
                              La,
                              Xb(
                                {
                                  container: !0,
                                  spacing: 2,
                                  sx: ne,
                                  className: "ST_CI_textfield-details",
                                },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className: "ST_CI_textfield-details",
                                        },
                                        {
                                          children: (0, e.jsx)(Xd, {
                                            label: o(
                                              "customerInvoice_enterFirstName"
                                            ),
                                            className:
                                              "ST_CI_textfield-details",
                                            sx: re,
                                            name: "firstname",
                                            required: "" === P,
                                            value: h,
                                            onChange: function (e) {
                                              return f(e.target.value);
                                            },
                                            type: "search",
                                            size: "small",
                                            InputProps: {
                                              style: { height: 47 },
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className:
                                            "ST_CI_textfield-details ST_CI_responsive-textfield",
                                        },
                                        {
                                          children: (0, e.jsx)(Xd, {
                                            label: o(
                                              "customerInvoice_enterLastName"
                                            ),
                                            className:
                                              "ST_CI_textfield-details ",
                                            sx: re,
                                            name: "lastname",
                                            required: "" === P,
                                            value: g,
                                            onChange: function (e) {
                                              return v(e.target.value);
                                            },
                                            type: "search",
                                            size: "small",
                                            InputProps: {
                                              style: { height: 47 },
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsxs)(
                              La,
                              Xb(
                                {
                                  container: !0,
                                  spacing: 2,
                                  sx: ne,
                                  className: "ST_CI_textfield-details",
                                },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className: "ST_CI_textfield-details",
                                        },
                                        {
                                          children: (0, e.jsx)(Xd, {
                                            label: o(
                                              "customerInvoice_enterAddress1"
                                            ),
                                            className:
                                              "ST_CI_textfield-details ",
                                            sx: re,
                                            name: "address1",
                                            required: "" === P,
                                            value: b,
                                            onChange: function (e) {
                                              return _(e.target.value);
                                            },
                                            type: "search",
                                            size: "small",
                                            InputProps: {
                                              style: { height: 47 },
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className:
                                            "ST_CI_textfield-details ST_CI_responsive-textfield",
                                        },
                                        {
                                          children: (0, e.jsx)(Xd, {
                                            label: o(
                                              "customerInvoice_enterAddress2"
                                            ),
                                            className:
                                              "ST_CI_textfield-details ",
                                            sx: re,
                                            name: "address2",
                                            value: y,
                                            onChange: function (e) {
                                              return x(e.target.value);
                                            },
                                            type: "search",
                                            size: "small",
                                            InputProps: {
                                              style: { height: 47 },
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsxs)(
                              La,
                              Xb(
                                {
                                  container: !0,
                                  spacing: 2,
                                  sx: ne,
                                  className: "ST_CI_textfield-details",
                                },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className: "ST_CI_textfield-details",
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            Xd,
                                            Xb(
                                              {
                                                id: "outlined-select-state",
                                                select: !0,
                                                label: o(
                                                  "customerInvoice_selectCountry"
                                                ),
                                                required: "" === P,
                                                value: I,
                                                onChange: function (e) {
                                                  T(e.target.value),
                                                    z(e.target.value);
                                                },
                                                className:
                                                  "ST_CI_textfield-details ",
                                                sx: re,
                                                type: "search",
                                                size: "small",
                                                InputProps: {
                                                  style: { height: 47 },
                                                },
                                              },
                                              {
                                                children: n().map(function (
                                                  t,
                                                  n
                                                ) {
                                                  return (0, e.jsx)(
                                                    ob,
                                                    Xb(
                                                      {
                                                        value:
                                                          (null == t
                                                            ? void 0
                                                            : t.name) || "",
                                                      },
                                                      {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.name) || "",
                                                      }
                                                    ),
                                                    n
                                                  );
                                                }),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className:
                                            "ST_CI_textfield-details ST_CI_responsive-textfield",
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            Xd,
                                            Xb(
                                              {
                                                id: "outlined-select-state",
                                                select: !0,
                                                label: o(
                                                  "customerInvoice_selectState"
                                                ),
                                                required: "" === P,
                                                value: M,
                                                onChange: function (e) {
                                                  E(e.target.value);
                                                },
                                                className:
                                                  "ST_CI_textfield-details ",
                                                sx: re,
                                                type: "search",
                                                size: "small",
                                                InputProps: {
                                                  style: { height: 47 },
                                                },
                                              },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    ob,
                                                    Xb(
                                                      {
                                                        disabled: !0,
                                                        value: o(
                                                          "customerInvoice_selectState"
                                                        ),
                                                      },
                                                      {
                                                        children: o(
                                                          "customerInvoice_selectState"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  D.map(function (t, n) {
                                                    return (0,
                                                    e.jsx)(ob, Xb({ value: t || "" }, { children: t || "" }), n);
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsxs)(
                              La,
                              Xb(
                                {
                                  container: !0,
                                  spacing: 2,
                                  sx: ne,
                                  className: "ST_CI_textfield-details",
                                },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className: "ST_CI_textfield-details",
                                        },
                                        {
                                          children: (0, e.jsx)(Xd, {
                                            label: o(
                                              "customerInvoice_enterCity"
                                            ),
                                            className:
                                              "ST_CI_textfield-details ",
                                            sx: re,
                                            name: "city",
                                            required: "" === P,
                                            value: C,
                                            onChange: function (e) {
                                              return S(e.target.value);
                                            },
                                            type: "search",
                                            size: "small",
                                            InputProps: {
                                              style: { height: 47 },
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      Xb(
                                        {
                                          item: !0,
                                          md: 6,
                                          className:
                                            "ST_CI_textfield-details ST_CI_responsive-textfield",
                                        },
                                        {
                                          children: (0, e.jsx)(Xd, {
                                            label: o(
                                              "customerInvoice_enterZipNumber"
                                            ),
                                            className:
                                              "ST_CI_textfield-details ",
                                            sx: re,
                                            name: "zipnumber",
                                            required: "" === P,
                                            value: k,
                                            onChange: function (e) {
                                              return w(e.target.value);
                                            },
                                            type: "search",
                                            size: "small",
                                            InputProps: {
                                              style: { height: 47 },
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                          ],
                        }
                      )
                    )
                  : null,
                (0, e.jsx)(
                  "div",
                  Xb(
                    { style: { marginTop: "15px" } },
                    {
                      children: (0, e.jsx)(
                        Il,
                        Xb(
                          {
                            component: "button",
                            variant: "body2",
                            sx: { display: " inline-flex" },
                            onClick: function () {
                              return R(!j);
                            },
                          },
                          {
                            children: j
                              ? (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    o("customerInvoice_HideDetails"),
                                    " ",
                                    (0, e.jsx)(ab, {}),
                                  ],
                                })
                              : (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    o("customerInvoice_add_more_details"),
                                    " ",
                                    (0, e.jsx)(ib, {}),
                                  ],
                                }),
                          }
                        )
                      ),
                    }
                  )
                ),
                j
                  ? (0, e.jsx)(
                      ln,
                      Xb(
                        { sx: { flexGrow: 1 } },
                        {
                          children: (0, e.jsxs)(
                            La,
                            Xb(
                              {
                                container: !0,
                                spacing: 2,
                                sx: { ml: 0, mt: "2px" },
                                className: "ST_CI_textfield-details",
                              },
                              {
                                children: [
                                  (0, e.jsx)(
                                    La,
                                    Xb(
                                      {
                                        item: !0,
                                        md: 6,
                                        className: "ST_CI_textfield-details",
                                      },
                                      {
                                        children: (0, e.jsx)(Xd, {
                                          disabled:
                                            (null == K
                                              ? void 0
                                              : K.actionEvent) === G,
                                          label: o(
                                            "customerInvoice_contentHeading2Title7"
                                          ),
                                          className: "ST_CI_textfield-details",
                                          sx: re,
                                          name: "companyname",
                                          value: p,
                                          onChange: function (e) {
                                            return m(e.target.value);
                                          },
                                          type: "search",
                                          size: "small",
                                          InputProps: { style: { height: 47 } },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    La,
                                    Xb(
                                      {
                                        item: !0,
                                        md: 6,
                                        className:
                                          "ST_CI_textfield-details ST_CI_responsive-textfield",
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          Xd,
                                          Xb(
                                            {
                                              disabled:
                                                (null == K
                                                  ? void 0
                                                  : K.actionEvent) === G,
                                              label: o(
                                                "customerInvoice_contentHeading2Title5"
                                              ),
                                              className:
                                                "ST_CI_textfield-details ",
                                              sx: re,
                                              name: "mobilenumber",
                                              value: l,
                                              onChange: function (e) {
                                                c(e.target.value),
                                                  B(
                                                    e,
                                                    "validateOnmobileNumber"
                                                  );
                                              },
                                              type: "search",
                                              size: "small",
                                              error: L.mobilenumber,
                                            },
                                            L.mobilenumber && {
                                              error: !0,
                                              helperText: L.mobilenumber,
                                            },
                                            {
                                              InputProps: {
                                                style: { height: 47 },
                                              },
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        }
                      )
                    )
                  : null,
                (0, e.jsx)("br", {}),
                (0, e.jsx)(Qb, Xb({}, oe)),
              ],
            }
          )
        );
      }
      function t_(e) {
        return (0, Zt.ZP)("MuiCard", e);
      }
      (0, Bt.Z)("MuiCard", ["root"]);
      const n_ = ["className", "raised"],
        r_ = (0, Lt.ZP)(io, {
          name: "MuiCard",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(() => ({ overflow: "hidden" }));
      var o_ = t.forwardRef(function (t, n) {
        const r = (0, zt.Z)({ props: t, name: "MuiCard" }),
          { className: o, raised: a = !1 } = r,
          i = (0, jt.Z)(r, n_),
          s = (0, d.Z)({}, r, { raised: a }),
          l = ((e) => {
            const { classes: t } = e;
            return (0, Nt.Z)({ root: ["root"] }, t_, t);
          })(s);
        return (0,
        e.jsx)(r_, (0, d.Z)({ className: (0, Rt.Z)(l.root, o), elevation: a ? 8 : void 0, ref: n, ownerState: s }, i));
      });
      function a_(e) {
        return (0, Zt.ZP)("MuiCardContent", e);
      }
      (0, Bt.Z)("MuiCardContent", ["root"]);
      const i_ = ["className", "component"],
        s_ = (0, Lt.ZP)("div", {
          name: "MuiCardContent",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(() => ({ padding: 16, "&:last-child": { paddingBottom: 24 } }));
      var l_ = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiCardContent" }),
            { className: o, component: a = "div" } = r,
            i = (0, jt.Z)(r, i_),
            s = (0, d.Z)({}, r, { component: a }),
            l = ((e) => {
              const { classes: t } = e;
              return (0, Nt.Z)({ root: ["root"] }, a_, t);
            })(s);
          return (0,
          e.jsx)(s_, (0, d.Z)({ as: a, className: (0, Rt.Z)(l.root, o), ownerState: s, ref: n }, i));
        }),
        c_ = tn({
          defaultClassName: (0, Bt.Z)("MuiBox", ["root"]).root,
          generateClassName: nn.Z.generate,
        });
      function u_() {}
      const d_ = (function () {
        let e = 0;
        return function () {
          return e++;
        };
      })();
      function p_(e) {
        return null == e;
      }
      function m_(e) {
        if (Array.isArray && Array.isArray(e)) return !0;
        const t = Object.prototype.toString.call(e);
        return "[object" === t.slice(0, 7) && "Array]" === t.slice(-6);
      }
      function h_(e) {
        return (
          null !== e && "[object Object]" === Object.prototype.toString.call(e)
        );
      }
      const f_ = (e) =>
        ("number" == typeof e || e instanceof Number) && isFinite(+e);
      function g_(e, t) {
        return f_(e) ? e : t;
      }
      function v_(e, t) {
        return void 0 === e ? t : e;
      }
      const b_ = (e, t) =>
        "string" == typeof e && e.endsWith("%")
          ? (parseFloat(e) / 100) * t
          : +e;
      function __(e, t, n) {
        if (e && "function" == typeof e.call) return e.apply(n, t);
      }
      function y_(e, t, n, r) {
        let o, a, i;
        if (m_(e))
          if (((a = e.length), r))
            for (o = a - 1; o >= 0; o--) t.call(n, e[o], o);
          else for (o = 0; o < a; o++) t.call(n, e[o], o);
        else if (h_(e))
          for (i = Object.keys(e), a = i.length, o = 0; o < a; o++)
            t.call(n, e[i[o]], i[o]);
      }
      function x_(e, t) {
        let n, r, o, a;
        if (!e || !t || e.length !== t.length) return !1;
        for (n = 0, r = e.length; n < r; ++n)
          if (
            ((o = e[n]),
            (a = t[n]),
            o.datasetIndex !== a.datasetIndex || o.index !== a.index)
          )
            return !1;
        return !0;
      }
      function C_(e) {
        if (m_(e)) return e.map(C_);
        if (h_(e)) {
          const t = Object.create(null),
            n = Object.keys(e),
            r = n.length;
          let o = 0;
          for (; o < r; ++o) t[n[o]] = C_(e[n[o]]);
          return t;
        }
        return e;
      }
      function S_(e) {
        return -1 === ["__proto__", "prototype", "constructor"].indexOf(e);
      }
      function k_(e, t, n, r) {
        if (!S_(e)) return;
        const o = t[e],
          a = n[e];
        h_(o) && h_(a) ? w_(o, a, r) : (t[e] = C_(a));
      }
      function w_(e, t, n) {
        const r = m_(t) ? t : [t],
          o = r.length;
        if (!h_(e)) return e;
        const a = (n = n || {}).merger || k_;
        for (let i = 0; i < o; ++i) {
          if (!h_((t = r[i]))) continue;
          const o = Object.keys(t);
          for (let r = 0, i = o.length; r < i; ++r) a(o[r], e, t, n);
        }
        return e;
      }
      function P_(e, t) {
        return w_(e, t, { merger: O_ });
      }
      function O_(e, t, n) {
        if (!S_(e)) return;
        const r = t[e],
          o = n[e];
        h_(r) && h_(o)
          ? P_(r, o)
          : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = C_(o));
      }
      const I_ = { "": (e) => e, x: (e) => e.x, y: (e) => e.y };
      function T_(e, t) {
        const n =
          I_[t] ||
          (I_[t] = (function (e) {
            const t = (function (e) {
              const t = e.split("."),
                n = [];
              let r = "";
              for (const e of t)
                (r += e),
                  r.endsWith("\\")
                    ? (r = r.slice(0, -1) + ".")
                    : (n.push(r), (r = ""));
              return n;
            })(e);
            return (e) => {
              for (const n of t) {
                if ("" === n) break;
                e = e && e[n];
              }
              return e;
            };
          })(t));
        return n(e);
      }
      function M_(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }
      const E_ = (e) => void 0 !== e,
        D_ = (e) => "function" == typeof e,
        j_ = (e, t) => {
          if (e.size !== t.size) return !1;
          for (const n of e) if (!t.has(n)) return !1;
          return !0;
        },
        R_ = Math.PI,
        N_ = 2 * R_,
        A_ = N_ + R_,
        L_ = Number.POSITIVE_INFINITY,
        z_ = R_ / 180,
        B_ = R_ / 2,
        Z_ = R_ / 4,
        F_ = (2 * R_) / 3,
        H_ = Math.log10,
        V_ = Math.sign;
      function W_(e) {
        const t = Math.round(e);
        e = U_(e, t, e / 1e3) ? t : e;
        const n = Math.pow(10, Math.floor(H_(e))),
          r = e / n;
        return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
      }
      function $_(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
      }
      function U_(e, t, n) {
        return Math.abs(e - t) < n;
      }
      function K_(e, t, n) {
        let r, o, a;
        for (r = 0, o = e.length; r < o; r++)
          (a = e[r][n]),
            isNaN(a) ||
              ((t.min = Math.min(t.min, a)), (t.max = Math.max(t.max, a)));
      }
      function G_(e) {
        return e * (R_ / 180);
      }
      function q_(e) {
        return e * (180 / R_);
      }
      function Y_(e) {
        if (!f_(e)) return;
        let t = 1,
          n = 0;
        for (; Math.round(e * t) / t !== e; ) (t *= 10), n++;
        return n;
      }
      function J_(e, t) {
        const n = t.x - e.x,
          r = t.y - e.y,
          o = Math.sqrt(n * n + r * r);
        let a = Math.atan2(r, n);
        return a < -0.5 * R_ && (a += N_), { angle: a, distance: o };
      }
      function Q_(e, t) {
        return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
      }
      function X_(e, t) {
        return ((e - t + A_) % N_) - R_;
      }
      function ey(e) {
        return ((e % N_) + N_) % N_;
      }
      function ty(e, t, n, r) {
        const o = ey(e),
          a = ey(t),
          i = ey(n),
          s = ey(a - o),
          l = ey(i - o),
          c = ey(o - a),
          u = ey(o - i);
        return o === a || o === i || (r && a === i) || (s > l && c < u);
      }
      function ny(e, t, n) {
        return Math.max(t, Math.min(n, e));
      }
      function ry(e, t, n, r = 1e-6) {
        return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
      }
      function oy(e, t, n) {
        n = n || ((n) => e[n] < t);
        let r,
          o = e.length - 1,
          a = 0;
        for (; o - a > 1; ) (r = (a + o) >> 1), n(r) ? (a = r) : (o = r);
        return { lo: a, hi: o };
      }
      const ay = (e, t, n, r) =>
          oy(e, n, r ? (r) => e[r][t] <= n : (r) => e[r][t] < n),
        iy = (e, t, n) => oy(e, n, (r) => e[r][t] >= n),
        sy = ["push", "pop", "shift", "splice", "unshift"];
      function ly(e, t) {
        const n = e._chartjs;
        if (!n) return;
        const r = n.listeners,
          o = r.indexOf(t);
        -1 !== o && r.splice(o, 1),
          r.length > 0 ||
            (sy.forEach((t) => {
              delete e[t];
            }),
            delete e._chartjs);
      }
      function cy(e) {
        const t = new Set();
        let n, r;
        for (n = 0, r = e.length; n < r; ++n) t.add(e[n]);
        return t.size === r ? e : Array.from(t);
      }
      const uy =
        "undefined" == typeof window
          ? function (e) {
              return e();
            }
          : window.requestAnimationFrame;
      function dy(e, t, n) {
        const r = n || ((e) => Array.prototype.slice.call(e));
        let o = !1,
          a = [];
        return function (...n) {
          (a = r(n)),
            o ||
              ((o = !0),
              uy.call(window, () => {
                (o = !1), e.apply(t, a);
              }));
        };
      }
      const py = (e) =>
          "start" === e ? "left" : "end" === e ? "right" : "center",
        my = (e, t, n) => ("start" === e ? t : "end" === e ? n : (t + n) / 2);
      function hy(e, t, n) {
        const r = t.length;
        let o = 0,
          a = r;
        if (e._sorted) {
          const { iScale: i, _parsed: s } = e,
            l = i.axis,
            {
              min: c,
              max: u,
              minDefined: d,
              maxDefined: p,
            } = i.getUserBounds();
          d &&
            (o = ny(
              Math.min(
                ay(s, i.axis, c).lo,
                n ? r : ay(t, l, i.getPixelForValue(c)).lo
              ),
              0,
              r - 1
            )),
            (a = p
              ? ny(
                  Math.max(
                    ay(s, i.axis, u, !0).hi + 1,
                    n ? 0 : ay(t, l, i.getPixelForValue(u), !0).hi + 1
                  ),
                  o,
                  r
                ) - o
              : r - o);
        }
        return { start: o, count: a };
      }
      function fy(e) {
        const { xScale: t, yScale: n, _scaleRanges: r } = e,
          o = { xmin: t.min, xmax: t.max, ymin: n.min, ymax: n.max };
        if (!r) return (e._scaleRanges = o), !0;
        const a =
          r.xmin !== t.min ||
          r.xmax !== t.max ||
          r.ymin !== n.min ||
          r.ymax !== n.max;
        return Object.assign(r, o), a;
      }
      const gy = (e) => 0 === e || 1 === e,
        vy = (e, t, n) =>
          -Math.pow(2, 10 * (e -= 1)) * Math.sin(((e - t) * N_) / n),
        by = (e, t, n) =>
          Math.pow(2, -10 * e) * Math.sin(((e - t) * N_) / n) + 1,
        _y = {
          linear: (e) => e,
          easeInQuad: (e) => e * e,
          easeOutQuad: (e) => -e * (e - 2),
          easeInOutQuad: (e) =>
            (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
          easeInCubic: (e) => e * e * e,
          easeOutCubic: (e) => (e -= 1) * e * e + 1,
          easeInOutCubic: (e) =>
            (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
          easeInQuart: (e) => e * e * e * e,
          easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
          easeInOutQuart: (e) =>
            (e /= 0.5) < 1
              ? 0.5 * e * e * e * e
              : -0.5 * ((e -= 2) * e * e * e - 2),
          easeInQuint: (e) => e * e * e * e * e,
          easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
          easeInOutQuint: (e) =>
            (e /= 0.5) < 1
              ? 0.5 * e * e * e * e * e
              : 0.5 * ((e -= 2) * e * e * e * e + 2),
          easeInSine: (e) => 1 - Math.cos(e * B_),
          easeOutSine: (e) => Math.sin(e * B_),
          easeInOutSine: (e) => -0.5 * (Math.cos(R_ * e) - 1),
          easeInExpo: (e) => (0 === e ? 0 : Math.pow(2, 10 * (e - 1))),
          easeOutExpo: (e) => (1 === e ? 1 : 1 - Math.pow(2, -10 * e)),
          easeInOutExpo: (e) =>
            gy(e)
              ? e
              : e < 0.5
              ? 0.5 * Math.pow(2, 10 * (2 * e - 1))
              : 0.5 * (2 - Math.pow(2, -10 * (2 * e - 1))),
          easeInCirc: (e) => (e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1)),
          easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
          easeInOutCirc: (e) =>
            (e /= 0.5) < 1
              ? -0.5 * (Math.sqrt(1 - e * e) - 1)
              : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
          easeInElastic: (e) => (gy(e) ? e : vy(e, 0.075, 0.3)),
          easeOutElastic: (e) => (gy(e) ? e : by(e, 0.075, 0.3)),
          easeInOutElastic(e) {
            const t = 0.1125;
            return gy(e)
              ? e
              : e < 0.5
              ? 0.5 * vy(2 * e, t, 0.45)
              : 0.5 + 0.5 * by(2 * e - 1, t, 0.45);
          },
          easeInBack(e) {
            const t = 1.70158;
            return e * e * ((t + 1) * e - t);
          },
          easeOutBack(e) {
            const t = 1.70158;
            return (e -= 1) * e * ((t + 1) * e + t) + 1;
          },
          easeInOutBack(e) {
            let t = 1.70158;
            return (e /= 0.5) < 1
              ? e * e * ((1 + (t *= 1.525)) * e - t) * 0.5
              : 0.5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
          },
          easeInBounce: (e) => 1 - _y.easeOutBounce(1 - e),
          easeOutBounce(e) {
            const t = 7.5625,
              n = 2.75;
            return e < 1 / n
              ? t * e * e
              : e < 2 / n
              ? t * (e -= 1.5 / n) * e + 0.75
              : e < 2.5 / n
              ? t * (e -= 2.25 / n) * e + 0.9375
              : t * (e -= 2.625 / n) * e + 0.984375;
          },
          easeInOutBounce: (e) =>
            e < 0.5
              ? 0.5 * _y.easeInBounce(2 * e)
              : 0.5 * _y.easeOutBounce(2 * e - 1) + 0.5,
        };
      function yy(e) {
        return (e + 0.5) | 0;
      }
      const xy = (e, t, n) => Math.max(Math.min(e, n), t);
      function Cy(e) {
        return xy(yy(2.55 * e), 0, 255);
      }
      function Sy(e) {
        return xy(yy(255 * e), 0, 255);
      }
      function ky(e) {
        return xy(yy(e / 2.55) / 100, 0, 1);
      }
      function wy(e) {
        return xy(yy(100 * e), 0, 100);
      }
      const Py = {
          0: 0,
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: 5,
          6: 6,
          7: 7,
          8: 8,
          9: 9,
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          a: 10,
          b: 11,
          c: 12,
          d: 13,
          e: 14,
          f: 15,
        },
        Oy = [..."0123456789ABCDEF"],
        Iy = (e) => Oy[15 & e],
        Ty = (e) => Oy[(240 & e) >> 4] + Oy[15 & e],
        My = (e) => (240 & e) >> 4 == (15 & e),
        Ey =
          /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
      function Dy(e, t, n) {
        const r = t * Math.min(n, 1 - n),
          o = (t, o = (t + e / 30) % 12) =>
            n - r * Math.max(Math.min(o - 3, 9 - o, 1), -1);
        return [o(0), o(8), o(4)];
      }
      function jy(e, t, n) {
        const r = (r, o = (r + e / 60) % 6) =>
          n - n * t * Math.max(Math.min(o, 4 - o, 1), 0);
        return [r(5), r(3), r(1)];
      }
      function Ry(e, t, n) {
        const r = Dy(e, 1, 0.5);
        let o;
        for (
          t + n > 1 && ((o = 1 / (t + n)), (t *= o), (n *= o)), o = 0;
          o < 3;
          o++
        )
          (r[o] *= 1 - t - n), (r[o] += t);
        return r;
      }
      function Ny(e) {
        const t = e.r / 255,
          n = e.g / 255,
          r = e.b / 255,
          o = Math.max(t, n, r),
          a = Math.min(t, n, r),
          i = (o + a) / 2;
        let s, l, c;
        return (
          o !== a &&
            ((c = o - a),
            (l = i > 0.5 ? c / (2 - o - a) : c / (o + a)),
            (s = (function (e, t, n, r, o) {
              return e === o
                ? (t - n) / r + (t < n ? 6 : 0)
                : t === o
                ? (n - e) / r + 2
                : (e - t) / r + 4;
            })(t, n, r, c, o)),
            (s = 60 * s + 0.5)),
          [0 | s, l || 0, i]
        );
      }
      function Ay(e, t, n, r) {
        return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(Sy);
      }
      function Ly(e, t, n) {
        return Ay(Dy, e, t, n);
      }
      function zy(e) {
        return ((e % 360) + 360) % 360;
      }
      const By = {
          x: "dark",
          Z: "light",
          Y: "re",
          X: "blu",
          W: "gr",
          V: "medium",
          U: "slate",
          A: "ee",
          T: "ol",
          S: "or",
          B: "ra",
          C: "lateg",
          D: "ights",
          R: "in",
          Q: "turquois",
          E: "hi",
          P: "ro",
          O: "al",
          N: "le",
          M: "de",
          L: "yello",
          F: "en",
          K: "ch",
          G: "arks",
          H: "ea",
          I: "ightg",
          J: "wh",
        },
        Zy = {
          OiceXe: "f0f8ff",
          antiquewEte: "faebd7",
          aqua: "ffff",
          aquamarRe: "7fffd4",
          azuY: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "0",
          blanKedOmond: "ffebcd",
          Xe: "ff",
          XeviTet: "8a2be2",
          bPwn: "a52a2a",
          burlywood: "deb887",
          caMtXe: "5f9ea0",
          KartYuse: "7fff00",
          KocTate: "d2691e",
          cSO: "ff7f50",
          cSnflowerXe: "6495ed",
          cSnsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "ffff",
          xXe: "8b",
          xcyan: "8b8b",
          xgTMnPd: "b8860b",
          xWay: "a9a9a9",
          xgYF: "6400",
          xgYy: "a9a9a9",
          xkhaki: "bdb76b",
          xmagFta: "8b008b",
          xTivegYF: "556b2f",
          xSange: "ff8c00",
          xScEd: "9932cc",
          xYd: "8b0000",
          xsOmon: "e9967a",
          xsHgYF: "8fbc8f",
          xUXe: "483d8b",
          xUWay: "2f4f4f",
          xUgYy: "2f4f4f",
          xQe: "ced1",
          xviTet: "9400d3",
          dAppRk: "ff1493",
          dApskyXe: "bfff",
          dimWay: "696969",
          dimgYy: "696969",
          dodgerXe: "1e90ff",
          fiYbrick: "b22222",
          flSOwEte: "fffaf0",
          foYstWAn: "228b22",
          fuKsia: "ff00ff",
          gaRsbSo: "dcdcdc",
          ghostwEte: "f8f8ff",
          gTd: "ffd700",
          gTMnPd: "daa520",
          Way: "808080",
          gYF: "8000",
          gYFLw: "adff2f",
          gYy: "808080",
          honeyMw: "f0fff0",
          hotpRk: "ff69b4",
          RdianYd: "cd5c5c",
          Rdigo: "4b0082",
          ivSy: "fffff0",
          khaki: "f0e68c",
          lavFMr: "e6e6fa",
          lavFMrXsh: "fff0f5",
          lawngYF: "7cfc00",
          NmoncEffon: "fffacd",
          ZXe: "add8e6",
          ZcSO: "f08080",
          Zcyan: "e0ffff",
          ZgTMnPdLw: "fafad2",
          ZWay: "d3d3d3",
          ZgYF: "90ee90",
          ZgYy: "d3d3d3",
          ZpRk: "ffb6c1",
          ZsOmon: "ffa07a",
          ZsHgYF: "20b2aa",
          ZskyXe: "87cefa",
          ZUWay: "778899",
          ZUgYy: "778899",
          ZstAlXe: "b0c4de",
          ZLw: "ffffe0",
          lime: "ff00",
          limegYF: "32cd32",
          lRF: "faf0e6",
          magFta: "ff00ff",
          maPon: "800000",
          VaquamarRe: "66cdaa",
          VXe: "cd",
          VScEd: "ba55d3",
          VpurpN: "9370db",
          VsHgYF: "3cb371",
          VUXe: "7b68ee",
          VsprRggYF: "fa9a",
          VQe: "48d1cc",
          VviTetYd: "c71585",
          midnightXe: "191970",
          mRtcYam: "f5fffa",
          mistyPse: "ffe4e1",
          moccasR: "ffe4b5",
          navajowEte: "ffdead",
          navy: "80",
          Tdlace: "fdf5e6",
          Tive: "808000",
          TivedBb: "6b8e23",
          Sange: "ffa500",
          SangeYd: "ff4500",
          ScEd: "da70d6",
          pOegTMnPd: "eee8aa",
          pOegYF: "98fb98",
          pOeQe: "afeeee",
          pOeviTetYd: "db7093",
          papayawEp: "ffefd5",
          pHKpuff: "ffdab9",
          peru: "cd853f",
          pRk: "ffc0cb",
          plum: "dda0dd",
          powMrXe: "b0e0e6",
          purpN: "800080",
          YbeccapurpN: "663399",
          Yd: "ff0000",
          Psybrown: "bc8f8f",
          PyOXe: "4169e1",
          saddNbPwn: "8b4513",
          sOmon: "fa8072",
          sandybPwn: "f4a460",
          sHgYF: "2e8b57",
          sHshell: "fff5ee",
          siFna: "a0522d",
          silver: "c0c0c0",
          skyXe: "87ceeb",
          UXe: "6a5acd",
          UWay: "708090",
          UgYy: "708090",
          snow: "fffafa",
          sprRggYF: "ff7f",
          stAlXe: "4682b4",
          tan: "d2b48c",
          teO: "8080",
          tEstN: "d8bfd8",
          tomato: "ff6347",
          Qe: "40e0d0",
          viTet: "ee82ee",
          JHt: "f5deb3",
          wEte: "ffffff",
          wEtesmoke: "f5f5f5",
          Lw: "ffff00",
          LwgYF: "9acd32",
        };
      let Fy;
      const Hy =
          /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/,
        Vy = (e) =>
          e <= 0.0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055,
        Wy = (e) =>
          e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
      function $y(e, t, n) {
        if (e) {
          let r = Ny(e);
          (r[t] = Math.max(0, Math.min(r[t] + r[t] * n, 0 === t ? 360 : 1))),
            (r = Ly(r)),
            (e.r = r[0]),
            (e.g = r[1]),
            (e.b = r[2]);
        }
      }
      function Uy(e, t) {
        return e ? Object.assign(t || {}, e) : e;
      }
      function Ky(e) {
        var t = { r: 0, g: 0, b: 0, a: 255 };
        return (
          Array.isArray(e)
            ? e.length >= 3 &&
              ((t = { r: e[0], g: e[1], b: e[2], a: 255 }),
              e.length > 3 && (t.a = Sy(e[3])))
            : ((t = Uy(e, { r: 0, g: 0, b: 0, a: 1 })).a = Sy(t.a)),
          t
        );
      }
      function Gy(e) {
        return "r" === e.charAt(0)
          ? (function (e) {
              const t = Hy.exec(e);
              let n,
                r,
                o,
                a = 255;
              if (t) {
                if (t[7] !== n) {
                  const e = +t[7];
                  a = t[8] ? Cy(e) : xy(255 * e, 0, 255);
                }
                return (
                  (n = +t[1]),
                  (r = +t[3]),
                  (o = +t[5]),
                  (n = 255 & (t[2] ? Cy(n) : xy(n, 0, 255))),
                  (r = 255 & (t[4] ? Cy(r) : xy(r, 0, 255))),
                  (o = 255 & (t[6] ? Cy(o) : xy(o, 0, 255))),
                  { r: n, g: r, b: o, a: a }
                );
              }
            })(e)
          : (function (e) {
              const t = Ey.exec(e);
              let n,
                r = 255;
              if (!t) return;
              t[5] !== n && (r = t[6] ? Cy(+t[5]) : Sy(+t[5]));
              const o = zy(+t[2]),
                a = +t[3] / 100,
                i = +t[4] / 100;
              return (
                (n =
                  "hwb" === t[1]
                    ? (function (e, t, n) {
                        return Ay(Ry, e, t, n);
                      })(o, a, i)
                    : "hsv" === t[1]
                    ? (function (e, t, n) {
                        return Ay(jy, e, t, n);
                      })(o, a, i)
                    : Ly(o, a, i)),
                { r: n[0], g: n[1], b: n[2], a: r }
              );
            })(e);
      }
      class qy {
        constructor(e) {
          if (e instanceof qy) return e;
          const t = typeof e;
          let n;
          var r, o, a;
          "object" === t
            ? (n = Ky(e))
            : "string" === t &&
              ((a = (r = e).length),
              "#" === r[0] &&
                (4 === a || 5 === a
                  ? (o = {
                      r: 255 & (17 * Py[r[1]]),
                      g: 255 & (17 * Py[r[2]]),
                      b: 255 & (17 * Py[r[3]]),
                      a: 5 === a ? 17 * Py[r[4]] : 255,
                    })
                  : (7 !== a && 9 !== a) ||
                    (o = {
                      r: (Py[r[1]] << 4) | Py[r[2]],
                      g: (Py[r[3]] << 4) | Py[r[4]],
                      b: (Py[r[5]] << 4) | Py[r[6]],
                      a: 9 === a ? (Py[r[7]] << 4) | Py[r[8]] : 255,
                    })),
              (n =
                o ||
                (function (e) {
                  Fy ||
                    ((Fy = (function () {
                      const e = {},
                        t = Object.keys(Zy),
                        n = Object.keys(By);
                      let r, o, a, i, s;
                      for (r = 0; r < t.length; r++) {
                        for (i = s = t[r], o = 0; o < n.length; o++)
                          (a = n[o]), (s = s.replace(a, By[a]));
                        (a = parseInt(Zy[i], 16)),
                          (e[s] = [(a >> 16) & 255, (a >> 8) & 255, 255 & a]);
                      }
                      return e;
                    })()),
                    (Fy.transparent = [0, 0, 0, 0]));
                  const t = Fy[e.toLowerCase()];
                  return (
                    t && {
                      r: t[0],
                      g: t[1],
                      b: t[2],
                      a: 4 === t.length ? t[3] : 255,
                    }
                  );
                })(e) ||
                Gy(e))),
            (this._rgb = n),
            (this._valid = !!n);
        }
        get valid() {
          return this._valid;
        }
        get rgb() {
          var e = Uy(this._rgb);
          return e && (e.a = ky(e.a)), e;
        }
        set rgb(e) {
          this._rgb = Ky(e);
        }
        rgbString() {
          return this._valid
            ? (e = this._rgb) &&
                (e.a < 255
                  ? `rgba(${e.r}, ${e.g}, ${e.b}, ${ky(e.a)})`
                  : `rgb(${e.r}, ${e.g}, ${e.b})`)
            : void 0;
          var e;
        }
        hexString() {
          return this._valid
            ? ((t = ((e) => My(e.r) && My(e.g) && My(e.b) && My(e.a))(
                (e = this._rgb)
              )
                ? Iy
                : Ty),
              e
                ? "#" +
                  t(e.r) +
                  t(e.g) +
                  t(e.b) +
                  ((e, t) => (e < 255 ? t(e) : ""))(e.a, t)
                : void 0)
            : void 0;
          var e, t;
        }
        hslString() {
          return this._valid
            ? (function (e) {
                if (!e) return;
                const t = Ny(e),
                  n = t[0],
                  r = wy(t[1]),
                  o = wy(t[2]);
                return e.a < 255
                  ? `hsla(${n}, ${r}%, ${o}%, ${ky(e.a)})`
                  : `hsl(${n}, ${r}%, ${o}%)`;
              })(this._rgb)
            : void 0;
        }
        mix(e, t) {
          if (e) {
            const n = this.rgb,
              r = e.rgb;
            let o;
            const a = t === o ? 0.5 : t,
              i = 2 * a - 1,
              s = n.a - r.a,
              l = ((i * s == -1 ? i : (i + s) / (1 + i * s)) + 1) / 2;
            (o = 1 - l),
              (n.r = 255 & (l * n.r + o * r.r + 0.5)),
              (n.g = 255 & (l * n.g + o * r.g + 0.5)),
              (n.b = 255 & (l * n.b + o * r.b + 0.5)),
              (n.a = a * n.a + (1 - a) * r.a),
              (this.rgb = n);
          }
          return this;
        }
        interpolate(e, t) {
          return (
            e &&
              (this._rgb = (function (e, t, n) {
                const r = Wy(ky(e.r)),
                  o = Wy(ky(e.g)),
                  a = Wy(ky(e.b));
                return {
                  r: Sy(Vy(r + n * (Wy(ky(t.r)) - r))),
                  g: Sy(Vy(o + n * (Wy(ky(t.g)) - o))),
                  b: Sy(Vy(a + n * (Wy(ky(t.b)) - a))),
                  a: e.a + n * (t.a - e.a),
                };
              })(this._rgb, e._rgb, t)),
            this
          );
        }
        clone() {
          return new qy(this.rgb);
        }
        alpha(e) {
          return (this._rgb.a = Sy(e)), this;
        }
        clearer(e) {
          return (this._rgb.a *= 1 - e), this;
        }
        greyscale() {
          const e = this._rgb,
            t = yy(0.3 * e.r + 0.59 * e.g + 0.11 * e.b);
          return (e.r = e.g = e.b = t), this;
        }
        opaquer(e) {
          return (this._rgb.a *= 1 + e), this;
        }
        negate() {
          const e = this._rgb;
          return (e.r = 255 - e.r), (e.g = 255 - e.g), (e.b = 255 - e.b), this;
        }
        lighten(e) {
          return $y(this._rgb, 2, e), this;
        }
        darken(e) {
          return $y(this._rgb, 2, -e), this;
        }
        saturate(e) {
          return $y(this._rgb, 1, e), this;
        }
        desaturate(e) {
          return $y(this._rgb, 1, -e), this;
        }
        rotate(e) {
          return (
            (function (e, t) {
              var n = Ny(e);
              (n[0] = zy(n[0] + t)),
                (n = Ly(n)),
                (e.r = n[0]),
                (e.g = n[1]),
                (e.b = n[2]);
            })(this._rgb, e),
            this
          );
        }
      }
      function Yy(e) {
        return new qy(e);
      }
      function Jy(e) {
        if (e && "object" == typeof e) {
          const t = e.toString();
          return (
            "[object CanvasPattern]" === t || "[object CanvasGradient]" === t
          );
        }
        return !1;
      }
      function Qy(e) {
        return Jy(e) ? e : Yy(e);
      }
      function Xy(e) {
        return Jy(e) ? e : Yy(e).saturate(0.5).darken(0.1).hexString();
      }
      const ex = Object.create(null),
        tx = Object.create(null);
      function nx(e, t) {
        if (!t) return e;
        const n = t.split(".");
        for (let t = 0, r = n.length; t < r; ++t) {
          const r = n[t];
          e = e[r] || (e[r] = Object.create(null));
        }
        return e;
      }
      function rx(e, t, n) {
        return "string" == typeof t ? w_(nx(e, t), n) : w_(nx(e, ""), t);
      }
      var ox = new (class {
        constructor(e) {
          (this.animation = void 0),
            (this.backgroundColor = "rgba(0,0,0,0.1)"),
            (this.borderColor = "rgba(0,0,0,0.1)"),
            (this.color = "#666"),
            (this.datasets = {}),
            (this.devicePixelRatio = (e) =>
              e.chart.platform.getDevicePixelRatio()),
            (this.elements = {}),
            (this.events = [
              "mousemove",
              "mouseout",
              "click",
              "touchstart",
              "touchmove",
            ]),
            (this.font = {
              family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              size: 12,
              style: "normal",
              lineHeight: 1.2,
              weight: null,
            }),
            (this.hover = {}),
            (this.hoverBackgroundColor = (e, t) => Xy(t.backgroundColor)),
            (this.hoverBorderColor = (e, t) => Xy(t.borderColor)),
            (this.hoverColor = (e, t) => Xy(t.color)),
            (this.indexAxis = "x"),
            (this.interaction = {
              mode: "nearest",
              intersect: !0,
              includeInvisible: !1,
            }),
            (this.maintainAspectRatio = !0),
            (this.onHover = null),
            (this.onClick = null),
            (this.parsing = !0),
            (this.plugins = {}),
            (this.responsive = !0),
            (this.scale = void 0),
            (this.scales = {}),
            (this.showLine = !0),
            (this.drawActiveElementsOnTop = !0),
            this.describe(e);
        }
        set(e, t) {
          return rx(this, e, t);
        }
        get(e) {
          return nx(this, e);
        }
        describe(e, t) {
          return rx(tx, e, t);
        }
        override(e, t) {
          return rx(ex, e, t);
        }
        route(e, t, n, r) {
          const o = nx(this, e),
            a = nx(this, n),
            i = "_" + t;
          Object.defineProperties(o, {
            [i]: { value: o[t], writable: !0 },
            [t]: {
              enumerable: !0,
              get() {
                const e = this[i],
                  t = a[r];
                return h_(e) ? Object.assign({}, t, e) : v_(e, t);
              },
              set(e) {
                this[i] = e;
              },
            },
          });
        }
      })({
        _scriptable: (e) => !e.startsWith("on"),
        _indexable: (e) => "events" !== e,
        hover: { _fallback: "interaction" },
        interaction: { _scriptable: !1, _indexable: !1 },
      });
      function ax(e, t, n, r, o) {
        let a = t[o];
        return (
          a || ((a = t[o] = e.measureText(o).width), n.push(o)),
          a > r && (r = a),
          r
        );
      }
      function ix(e, t, n, r) {
        let o = ((r = r || {}).data = r.data || {}),
          a = (r.garbageCollect = r.garbageCollect || []);
        r.font !== t &&
          ((o = r.data = {}), (a = r.garbageCollect = []), (r.font = t)),
          e.save(),
          (e.font = t);
        let i = 0;
        const s = n.length;
        let l, c, u, d, p;
        for (l = 0; l < s; l++)
          if (((d = n[l]), null != d && !0 !== m_(d))) i = ax(e, o, a, i, d);
          else if (m_(d))
            for (c = 0, u = d.length; c < u; c++)
              (p = d[c]), null == p || m_(p) || (i = ax(e, o, a, i, p));
        e.restore();
        const m = a.length / 2;
        if (m > n.length) {
          for (l = 0; l < m; l++) delete o[a[l]];
          a.splice(0, m);
        }
        return i;
      }
      function sx(e, t, n) {
        const r = e.currentDevicePixelRatio,
          o = 0 !== n ? Math.max(n / 2, 0.5) : 0;
        return Math.round((t - o) * r) / r + o;
      }
      function lx(e, t) {
        (t = t || e.getContext("2d")).save(),
          t.resetTransform(),
          t.clearRect(0, 0, e.width, e.height),
          t.restore();
      }
      function cx(e, t, n, r) {
        ux(e, t, n, r, null);
      }
      function ux(e, t, n, r, o) {
        let a, i, s, l, c, u;
        const d = t.pointStyle,
          p = t.rotation,
          m = t.radius;
        let h = (p || 0) * z_;
        if (
          d &&
          "object" == typeof d &&
          ((a = d.toString()),
          "[object HTMLImageElement]" === a ||
            "[object HTMLCanvasElement]" === a)
        )
          return (
            e.save(),
            e.translate(n, r),
            e.rotate(h),
            e.drawImage(d, -d.width / 2, -d.height / 2, d.width, d.height),
            void e.restore()
          );
        if (!(isNaN(m) || m <= 0)) {
          switch ((e.beginPath(), d)) {
            default:
              o ? e.ellipse(n, r, o / 2, m, 0, 0, N_) : e.arc(n, r, m, 0, N_),
                e.closePath();
              break;
            case "triangle":
              e.moveTo(n + Math.sin(h) * m, r - Math.cos(h) * m),
                (h += F_),
                e.lineTo(n + Math.sin(h) * m, r - Math.cos(h) * m),
                (h += F_),
                e.lineTo(n + Math.sin(h) * m, r - Math.cos(h) * m),
                e.closePath();
              break;
            case "rectRounded":
              (c = 0.516 * m),
                (l = m - c),
                (i = Math.cos(h + Z_) * l),
                (s = Math.sin(h + Z_) * l),
                e.arc(n - i, r - s, c, h - R_, h - B_),
                e.arc(n + s, r - i, c, h - B_, h),
                e.arc(n + i, r + s, c, h, h + B_),
                e.arc(n - s, r + i, c, h + B_, h + R_),
                e.closePath();
              break;
            case "rect":
              if (!p) {
                (l = Math.SQRT1_2 * m),
                  (u = o ? o / 2 : l),
                  e.rect(n - u, r - l, 2 * u, 2 * l);
                break;
              }
              h += Z_;
            case "rectRot":
              (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + s, r - i),
                e.lineTo(n + i, r + s),
                e.lineTo(n - s, r + i),
                e.closePath();
              break;
            case "crossRot":
              h += Z_;
            case "cross":
              (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s),
                e.moveTo(n + s, r - i),
                e.lineTo(n - s, r + i);
              break;
            case "star":
              (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s),
                e.moveTo(n + s, r - i),
                e.lineTo(n - s, r + i),
                (h += Z_),
                (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s),
                e.moveTo(n + s, r - i),
                e.lineTo(n - s, r + i);
              break;
            case "line":
              (i = o ? o / 2 : Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s);
              break;
            case "dash":
              e.moveTo(n, r),
                e.lineTo(n + Math.cos(h) * m, r + Math.sin(h) * m);
          }
          e.fill(), t.borderWidth > 0 && e.stroke();
        }
      }
      function dx(e, t, n) {
        return (
          (n = n || 0.5),
          !t ||
            (e &&
              e.x > t.left - n &&
              e.x < t.right + n &&
              e.y > t.top - n &&
              e.y < t.bottom + n)
        );
      }
      function px(e, t) {
        e.save(),
          e.beginPath(),
          e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top),
          e.clip();
      }
      function mx(e) {
        e.restore();
      }
      function hx(e, t, n, r, o) {
        if (!t) return e.lineTo(n.x, n.y);
        if ("middle" === o) {
          const r = (t.x + n.x) / 2;
          e.lineTo(r, t.y), e.lineTo(r, n.y);
        } else ("after" === o) != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
        e.lineTo(n.x, n.y);
      }
      function fx(e, t, n, r) {
        if (!t) return e.lineTo(n.x, n.y);
        e.bezierCurveTo(
          r ? t.cp1x : t.cp2x,
          r ? t.cp1y : t.cp2y,
          r ? n.cp2x : n.cp1x,
          r ? n.cp2y : n.cp1y,
          n.x,
          n.y
        );
      }
      function gx(e, t, n, r, o, a = {}) {
        const i = m_(t) ? t : [t],
          s = a.strokeWidth > 0 && "" !== a.strokeColor;
        let l, c;
        for (
          e.save(),
            e.font = o.string,
            (function (e, t) {
              t.translation && e.translate(t.translation[0], t.translation[1]),
                p_(t.rotation) || e.rotate(t.rotation),
                t.color && (e.fillStyle = t.color),
                t.textAlign && (e.textAlign = t.textAlign),
                t.textBaseline && (e.textBaseline = t.textBaseline);
            })(e, a),
            l = 0;
          l < i.length;
          ++l
        )
          (c = i[l]),
            s &&
              (a.strokeColor && (e.strokeStyle = a.strokeColor),
              p_(a.strokeWidth) || (e.lineWidth = a.strokeWidth),
              e.strokeText(c, n, r, a.maxWidth)),
            e.fillText(c, n, r, a.maxWidth),
            vx(e, n, r, c, a),
            (r += o.lineHeight);
        e.restore();
      }
      function vx(e, t, n, r, o) {
        if (o.strikethrough || o.underline) {
          const a = e.measureText(r),
            i = t - a.actualBoundingBoxLeft,
            s = t + a.actualBoundingBoxRight,
            l = n - a.actualBoundingBoxAscent,
            c = n + a.actualBoundingBoxDescent,
            u = o.strikethrough ? (l + c) / 2 : c;
          (e.strokeStyle = e.fillStyle),
            e.beginPath(),
            (e.lineWidth = o.decorationWidth || 2),
            e.moveTo(i, u),
            e.lineTo(s, u),
            e.stroke();
        }
      }
      function bx(e, t) {
        const { x: n, y: r, w: o, h: a, radius: i } = t;
        e.arc(n + i.topLeft, r + i.topLeft, i.topLeft, -B_, R_, !0),
          e.lineTo(n, r + a - i.bottomLeft),
          e.arc(
            n + i.bottomLeft,
            r + a - i.bottomLeft,
            i.bottomLeft,
            R_,
            B_,
            !0
          ),
          e.lineTo(n + o - i.bottomRight, r + a),
          e.arc(
            n + o - i.bottomRight,
            r + a - i.bottomRight,
            i.bottomRight,
            B_,
            0,
            !0
          ),
          e.lineTo(n + o, r + i.topRight),
          e.arc(n + o - i.topRight, r + i.topRight, i.topRight, 0, -B_, !0),
          e.lineTo(n + i.topLeft, r);
      }
      const _x = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/),
        yx = new RegExp(
          /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/
        );
      function xx(e, t) {
        const n = ("" + e).match(_x);
        if (!n || "normal" === n[1]) return 1.2 * t;
        switch (((e = +n[2]), n[3])) {
          case "px":
            return e;
          case "%":
            e /= 100;
        }
        return t * e;
      }
      const Cx = (e) => +e || 0;
      function Sx(e, t) {
        const n = {},
          r = h_(t),
          o = r ? Object.keys(t) : t,
          a = h_(e) ? (r ? (n) => v_(e[n], e[t[n]]) : (t) => e[t]) : () => e;
        for (const e of o) n[e] = Cx(a(e));
        return n;
      }
      function kx(e) {
        return Sx(e, { top: "y", right: "x", bottom: "y", left: "x" });
      }
      function wx(e) {
        return Sx(e, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
      }
      function Px(e) {
        const t = kx(e);
        return (t.width = t.left + t.right), (t.height = t.top + t.bottom), t;
      }
      function Ox(e, t) {
        (e = e || {}), (t = t || ox.font);
        let n = v_(e.size, t.size);
        "string" == typeof n && (n = parseInt(n, 10));
        let r = v_(e.style, t.style);
        r &&
          !("" + r).match(yx) &&
          (console.warn('Invalid font style specified: "' + r + '"'), (r = ""));
        const o = {
          family: v_(e.family, t.family),
          lineHeight: xx(v_(e.lineHeight, t.lineHeight), n),
          size: n,
          style: r,
          weight: v_(e.weight, t.weight),
          string: "",
        };
        return (
          (o.string = (function (e) {
            return !e || p_(e.size) || p_(e.family)
              ? null
              : (e.style ? e.style + " " : "") +
                  (e.weight ? e.weight + " " : "") +
                  e.size +
                  "px " +
                  e.family;
          })(o)),
          o
        );
      }
      function Ix(e, t, n, r) {
        let o,
          a,
          i,
          s = !0;
        for (o = 0, a = e.length; o < a; ++o)
          if (
            ((i = e[o]),
            void 0 !== i &&
              (void 0 !== t && "function" == typeof i && ((i = i(t)), (s = !1)),
              void 0 !== n && m_(i) && ((i = i[n % i.length]), (s = !1)),
              void 0 !== i))
          )
            return r && !s && (r.cacheable = !1), i;
      }
      function Tx(e, t) {
        return Object.assign(Object.create(e), t);
      }
      function Mx(e, t = [""], n = e, r, o = () => e[0]) {
        E_(r) || (r = Fx("_fallback", e));
        const a = {
          [Symbol.toStringTag]: "Object",
          _cacheable: !0,
          _scopes: e,
          _rootScopes: n,
          _fallback: r,
          _getTarget: o,
          override: (o) => Mx([o, ...e], t, n, r),
        };
        return new Proxy(a, {
          deleteProperty(t, n) {
            return delete t[n], delete t._keys, delete e[0][n], !0;
          },
          get(n, r) {
            return Nx(n, r, () =>
              (function (e, t, n, r) {
                let o;
                for (const a of t)
                  if (((o = Fx(jx(a, e), n)), E_(o)))
                    return Rx(e, o) ? Bx(n, r, e, o) : o;
              })(r, t, e, n)
            );
          },
          getOwnPropertyDescriptor(e, t) {
            return Reflect.getOwnPropertyDescriptor(e._scopes[0], t);
          },
          getPrototypeOf() {
            return Reflect.getPrototypeOf(e[0]);
          },
          has(e, t) {
            return Hx(e).includes(t);
          },
          ownKeys(e) {
            return Hx(e);
          },
          set(e, t, n) {
            const r = e._storage || (e._storage = o());
            return (e[t] = r[t] = n), delete e._keys, !0;
          },
        });
      }
      function Ex(e, t, n, r) {
        const o = {
          _cacheable: !1,
          _proxy: e,
          _context: t,
          _subProxy: n,
          _stack: new Set(),
          _descriptors: Dx(e, r),
          setContext: (t) => Ex(e, t, n, r),
          override: (o) => Ex(e.override(o), t, n, r),
        };
        return new Proxy(o, {
          deleteProperty(t, n) {
            return delete t[n], delete e[n], !0;
          },
          get(e, t, n) {
            return Nx(e, t, () =>
              (function (e, t, n) {
                const {
                  _proxy: r,
                  _context: o,
                  _subProxy: a,
                  _descriptors: i,
                } = e;
                let s = r[t];
                return (
                  D_(s) &&
                    i.isScriptable(t) &&
                    (s = (function (e, t, n, r) {
                      const {
                        _proxy: o,
                        _context: a,
                        _subProxy: i,
                        _stack: s,
                      } = n;
                      if (s.has(e))
                        throw new Error(
                          "Recursion detected: " +
                            Array.from(s).join("->") +
                            "->" +
                            e
                        );
                      return (
                        s.add(e),
                        (t = t(a, i || r)),
                        s.delete(e),
                        Rx(e, t) && (t = Bx(o._scopes, o, e, t)),
                        t
                      );
                    })(t, s, e, n)),
                  m_(s) &&
                    s.length &&
                    (s = (function (e, t, n, r) {
                      const {
                        _proxy: o,
                        _context: a,
                        _subProxy: i,
                        _descriptors: s,
                      } = n;
                      if (E_(a.index) && r(e)) t = t[a.index % t.length];
                      else if (h_(t[0])) {
                        const n = t,
                          r = o._scopes.filter((e) => e !== n);
                        t = [];
                        for (const l of n) {
                          const n = Bx(r, o, e, l);
                          t.push(Ex(n, a, i && i[e], s));
                        }
                      }
                      return t;
                    })(t, s, e, i.isIndexable)),
                  Rx(t, s) && (s = Ex(s, o, a && a[t], i)),
                  s
                );
              })(e, t, n)
            );
          },
          getOwnPropertyDescriptor(t, n) {
            return t._descriptors.allKeys
              ? Reflect.has(e, n)
                ? { enumerable: !0, configurable: !0 }
                : void 0
              : Reflect.getOwnPropertyDescriptor(e, n);
          },
          getPrototypeOf() {
            return Reflect.getPrototypeOf(e);
          },
          has(t, n) {
            return Reflect.has(e, n);
          },
          ownKeys() {
            return Reflect.ownKeys(e);
          },
          set(t, n, r) {
            return (e[n] = r), delete t[n], !0;
          },
        });
      }
      function Dx(e, t = { scriptable: !0, indexable: !0 }) {
        const {
          _scriptable: n = t.scriptable,
          _indexable: r = t.indexable,
          _allKeys: o = t.allKeys,
        } = e;
        return {
          allKeys: o,
          scriptable: n,
          indexable: r,
          isScriptable: D_(n) ? n : () => n,
          isIndexable: D_(r) ? r : () => r,
        };
      }
      const jx = (e, t) => (e ? e + M_(t) : t),
        Rx = (e, t) =>
          h_(t) &&
          "adapters" !== e &&
          (null === Object.getPrototypeOf(t) || t.constructor === Object);
      function Nx(e, t, n) {
        if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        const r = n();
        return (e[t] = r), r;
      }
      function Ax(e, t, n) {
        return D_(e) ? e(t, n) : e;
      }
      const Lx = (e, t) =>
        !0 === e ? t : "string" == typeof e ? T_(t, e) : void 0;
      function zx(e, t, n, r, o) {
        for (const a of t) {
          const t = Lx(n, a);
          if (t) {
            e.add(t);
            const a = Ax(t._fallback, n, o);
            if (E_(a) && a !== n && a !== r) return a;
          } else if (!1 === t && E_(r) && n !== r) return null;
        }
        return !1;
      }
      function Bx(e, t, n, r) {
        const o = t._rootScopes,
          a = Ax(t._fallback, n, r),
          i = [...e, ...o],
          s = new Set();
        s.add(r);
        let l = Zx(s, i, n, a || n, r);
        return (
          null !== l &&
          (!E_(a) || a === n || ((l = Zx(s, i, a, l, r)), null !== l)) &&
          Mx(Array.from(s), [""], o, a, () =>
            (function (e, t, n) {
              const r = e._getTarget();
              t in r || (r[t] = {});
              const o = r[t];
              return m_(o) && h_(n) ? n : o;
            })(t, n, r)
          )
        );
      }
      function Zx(e, t, n, r, o) {
        for (; n; ) n = zx(e, t, n, r, o);
        return n;
      }
      function Fx(e, t) {
        for (const n of t) {
          if (!n) continue;
          const t = n[e];
          if (E_(t)) return t;
        }
      }
      function Hx(e) {
        let t = e._keys;
        return (
          t ||
            (t = e._keys =
              (function (e) {
                const t = new Set();
                for (const n of e)
                  for (const e of Object.keys(n).filter(
                    (e) => !e.startsWith("_")
                  ))
                    t.add(e);
                return Array.from(t);
              })(e._scopes)),
          t
        );
      }
      function Vx(e, t, n, r) {
        const { iScale: o } = e,
          { key: a = "r" } = this._parsing,
          i = new Array(r);
        let s, l, c, u;
        for (s = 0, l = r; s < l; ++s)
          (c = s + n), (u = t[c]), (i[s] = { r: o.parse(T_(u, a), c) });
        return i;
      }
      const Wx = Number.EPSILON || 1e-14,
        $x = (e, t) => t < e.length && !e[t].skip && e[t],
        Ux = (e) => ("x" === e ? "y" : "x");
      function Kx(e, t, n, r) {
        const o = e.skip ? t : e,
          a = t,
          i = n.skip ? t : n,
          s = Q_(a, o),
          l = Q_(i, a);
        let c = s / (s + l),
          u = l / (s + l);
        (c = isNaN(c) ? 0 : c), (u = isNaN(u) ? 0 : u);
        const d = r * c,
          p = r * u;
        return {
          previous: { x: a.x - d * (i.x - o.x), y: a.y - d * (i.y - o.y) },
          next: { x: a.x + p * (i.x - o.x), y: a.y + p * (i.y - o.y) },
        };
      }
      function Gx(e, t, n) {
        return Math.max(Math.min(e, n), t);
      }
      function qx(e, t, n, r, o) {
        let a, i, s, l;
        if (
          (t.spanGaps && (e = e.filter((e) => !e.skip)),
          "monotone" === t.cubicInterpolationMode)
        )
          !(function (e, t = "x") {
            const n = Ux(t),
              r = e.length,
              o = Array(r).fill(0),
              a = Array(r);
            let i,
              s,
              l,
              c = $x(e, 0);
            for (i = 0; i < r; ++i)
              if (((s = l), (l = c), (c = $x(e, i + 1)), l)) {
                if (c) {
                  const e = c[t] - l[t];
                  o[i] = 0 !== e ? (c[n] - l[n]) / e : 0;
                }
                a[i] = s
                  ? c
                    ? V_(o[i - 1]) !== V_(o[i])
                      ? 0
                      : (o[i - 1] + o[i]) / 2
                    : o[i - 1]
                  : o[i];
              }
            !(function (e, t, n) {
              const r = e.length;
              let o,
                a,
                i,
                s,
                l,
                c = $x(e, 0);
              for (let u = 0; u < r - 1; ++u)
                (l = c),
                  (c = $x(e, u + 1)),
                  l &&
                    c &&
                    (U_(t[u], 0, Wx)
                      ? (n[u] = n[u + 1] = 0)
                      : ((o = n[u] / t[u]),
                        (a = n[u + 1] / t[u]),
                        (s = Math.pow(o, 2) + Math.pow(a, 2)),
                        s <= 9 ||
                          ((i = 3 / Math.sqrt(s)),
                          (n[u] = o * i * t[u]),
                          (n[u + 1] = a * i * t[u]))));
            })(e, o, a),
              (function (e, t, n = "x") {
                const r = Ux(n),
                  o = e.length;
                let a,
                  i,
                  s,
                  l = $x(e, 0);
                for (let c = 0; c < o; ++c) {
                  if (((i = s), (s = l), (l = $x(e, c + 1)), !s)) continue;
                  const o = s[n],
                    u = s[r];
                  i &&
                    ((a = (o - i[n]) / 3),
                    (s[`cp1${n}`] = o - a),
                    (s[`cp1${r}`] = u - a * t[c])),
                    l &&
                      ((a = (l[n] - o) / 3),
                      (s[`cp2${n}`] = o + a),
                      (s[`cp2${r}`] = u + a * t[c]));
                }
              })(e, a, t);
          })(e, o);
        else {
          let n = r ? e[e.length - 1] : e[0];
          for (a = 0, i = e.length; a < i; ++a)
            (s = e[a]),
              (l = Kx(
                n,
                s,
                e[Math.min(a + 1, i - (r ? 0 : 1)) % i],
                t.tension
              )),
              (s.cp1x = l.previous.x),
              (s.cp1y = l.previous.y),
              (s.cp2x = l.next.x),
              (s.cp2y = l.next.y),
              (n = s);
        }
        t.capBezierPoints &&
          (function (e, t) {
            let n,
              r,
              o,
              a,
              i,
              s = dx(e[0], t);
            for (n = 0, r = e.length; n < r; ++n)
              (i = a),
                (a = s),
                (s = n < r - 1 && dx(e[n + 1], t)),
                a &&
                  ((o = e[n]),
                  i &&
                    ((o.cp1x = Gx(o.cp1x, t.left, t.right)),
                    (o.cp1y = Gx(o.cp1y, t.top, t.bottom))),
                  s &&
                    ((o.cp2x = Gx(o.cp2x, t.left, t.right)),
                    (o.cp2y = Gx(o.cp2y, t.top, t.bottom))));
          })(e, n);
      }
      function Yx() {
        return "undefined" != typeof window && "undefined" != typeof document;
      }
      function Jx(e) {
        let t = e.parentNode;
        return t && "[object ShadowRoot]" === t.toString() && (t = t.host), t;
      }
      function Qx(e, t, n) {
        let r;
        return (
          "string" == typeof e
            ? ((r = parseInt(e, 10)),
              -1 !== e.indexOf("%") && (r = (r / 100) * t.parentNode[n]))
            : (r = e),
          r
        );
      }
      const Xx = (e) => window.getComputedStyle(e, null),
        eC = ["top", "right", "bottom", "left"];
      function tC(e, t, n) {
        const r = {};
        n = n ? "-" + n : "";
        for (let o = 0; o < 4; o++) {
          const a = eC[o];
          r[a] = parseFloat(e[t + "-" + a + n]) || 0;
        }
        return (r.width = r.left + r.right), (r.height = r.top + r.bottom), r;
      }
      const nC = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
      function rC(e, t) {
        if ("native" in e) return e;
        const { canvas: n, currentDevicePixelRatio: r } = t,
          o = Xx(n),
          a = "border-box" === o.boxSizing,
          i = tC(o, "padding"),
          s = tC(o, "border", "width"),
          {
            x: l,
            y: c,
            box: u,
          } = (function (e, t) {
            const n = e.touches,
              r = n && n.length ? n[0] : e,
              { offsetX: o, offsetY: a } = r;
            let i,
              s,
              l = !1;
            if (nC(o, a, e.target)) (i = o), (s = a);
            else {
              const e = t.getBoundingClientRect();
              (i = r.clientX - e.left), (s = r.clientY - e.top), (l = !0);
            }
            return { x: i, y: s, box: l };
          })(e, n),
          d = i.left + (u && s.left),
          p = i.top + (u && s.top);
        let { width: m, height: h } = t;
        return (
          a && ((m -= i.width + s.width), (h -= i.height + s.height)),
          {
            x: Math.round((((l - d) / m) * n.width) / r),
            y: Math.round((((c - p) / h) * n.height) / r),
          }
        );
      }
      const oC = (e) => Math.round(10 * e) / 10;
      function aC(e, t, n) {
        const r = t || 1,
          o = Math.floor(e.height * r),
          a = Math.floor(e.width * r);
        (e.height = o / r), (e.width = a / r);
        const i = e.canvas;
        return (
          i.style &&
            (n || (!i.style.height && !i.style.width)) &&
            ((i.style.height = `${e.height}px`),
            (i.style.width = `${e.width}px`)),
          (e.currentDevicePixelRatio !== r ||
            i.height !== o ||
            i.width !== a) &&
            ((e.currentDevicePixelRatio = r),
            (i.height = o),
            (i.width = a),
            e.ctx.setTransform(r, 0, 0, r, 0, 0),
            !0)
        );
      }
      const iC = (function () {
        let e = !1;
        try {
          const t = {
            get passive() {
              return (e = !0), !1;
            },
          };
          window.addEventListener("test", null, t),
            window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
      })();
      function sC(e, t) {
        const n = (function (e, t) {
            return Xx(e).getPropertyValue(t);
          })(e, t),
          r = n && n.match(/^(\d+)(\.\d+)?px$/);
        return r ? +r[1] : void 0;
      }
      function lC(e, t, n, r) {
        return { x: e.x + n * (t.x - e.x), y: e.y + n * (t.y - e.y) };
      }
      function cC(e, t, n, r) {
        return {
          x: e.x + n * (t.x - e.x),
          y:
            "middle" === r
              ? n < 0.5
                ? e.y
                : t.y
              : "after" === r
              ? n < 1
                ? e.y
                : t.y
              : n > 0
              ? t.y
              : e.y,
        };
      }
      function uC(e, t, n, r) {
        const o = { x: e.cp2x, y: e.cp2y },
          a = { x: t.cp1x, y: t.cp1y },
          i = lC(e, o, n),
          s = lC(o, a, n),
          l = lC(a, t, n),
          c = lC(i, s, n),
          u = lC(s, l, n);
        return lC(c, u, n);
      }
      const dC = new Map();
      function pC(e, t, n) {
        return (function (e, t) {
          t = t || {};
          const n = e + JSON.stringify(t);
          let r = dC.get(n);
          return r || ((r = new Intl.NumberFormat(e, t)), dC.set(n, r)), r;
        })(t, n).format(e);
      }
      const mC = function (e, t) {
          return {
            x(n) {
              return e + e + t - n;
            },
            setWidth(e) {
              t = e;
            },
            textAlign(e) {
              return "center" === e ? e : "right" === e ? "left" : "right";
            },
            xPlus(e, t) {
              return e - t;
            },
            leftForLtr(e, t) {
              return e - t;
            },
          };
        },
        hC = function () {
          return {
            x(e) {
              return e;
            },
            setWidth(e) {},
            textAlign(e) {
              return e;
            },
            xPlus(e, t) {
              return e + t;
            },
            leftForLtr(e, t) {
              return e;
            },
          };
        };
      function fC(e, t, n) {
        return e ? mC(t, n) : hC();
      }
      function gC(e, t) {
        let n, r;
        ("ltr" !== t && "rtl" !== t) ||
          ((n = e.canvas.style),
          (r = [
            n.getPropertyValue("direction"),
            n.getPropertyPriority("direction"),
          ]),
          n.setProperty("direction", t, "important"),
          (e.prevTextDirection = r));
      }
      function vC(e, t) {
        void 0 !== t &&
          (delete e.prevTextDirection,
          e.canvas.style.setProperty("direction", t[0], t[1]));
      }
      function bC(e) {
        return "angle" === e
          ? { between: ty, compare: X_, normalize: ey }
          : { between: ry, compare: (e, t) => e - t, normalize: (e) => e };
      }
      function _C({ start: e, end: t, count: n, loop: r, style: o }) {
        return {
          start: e % n,
          end: t % n,
          loop: r && (t - e + 1) % n == 0,
          style: o,
        };
      }
      function yC(e, t, n) {
        if (!n) return [e];
        const { property: r, start: o, end: a } = n,
          i = t.length,
          { compare: s, between: l, normalize: c } = bC(r),
          {
            start: u,
            end: d,
            loop: p,
            style: m,
          } = (function (e, t, n) {
            const { property: r, start: o, end: a } = n,
              { between: i, normalize: s } = bC(r),
              l = t.length;
            let c,
              u,
              { start: d, end: p, loop: m } = e;
            if (m) {
              for (
                d += l, p += l, c = 0, u = l;
                c < u && i(s(t[d % l][r]), o, a);
                ++c
              )
                d--, p--;
              (d %= l), (p %= l);
            }
            return (
              p < d && (p += l), { start: d, end: p, loop: m, style: e.style }
            );
          })(e, t, n),
          h = [];
        let f,
          g,
          v,
          b = !1,
          _ = null;
        for (let e = u, n = u; e <= d; ++e)
          (g = t[e % i]),
            g.skip ||
              ((f = c(g[r])),
              f !== v &&
                ((b = l(f, o, a)),
                null === _ &&
                  (b || (l(o, v, f) && 0 !== s(o, v))) &&
                  (_ = 0 === s(f, o) ? e : n),
                null !== _ &&
                  (!b || 0 === s(a, f) || l(a, v, f)) &&
                  (h.push(
                    _C({ start: _, end: e, loop: p, count: i, style: m })
                  ),
                  (_ = null)),
                (n = e),
                (v = f)));
        return (
          null !== _ &&
            h.push(_C({ start: _, end: d, loop: p, count: i, style: m })),
          h
        );
      }
      function xC(e) {
        return {
          backgroundColor: e.backgroundColor,
          borderCapStyle: e.borderCapStyle,
          borderDash: e.borderDash,
          borderDashOffset: e.borderDashOffset,
          borderJoinStyle: e.borderJoinStyle,
          borderWidth: e.borderWidth,
          borderColor: e.borderColor,
        };
      }
      function CC(e, t) {
        return t && JSON.stringify(e) !== JSON.stringify(t);
      }
      var SC = new (class {
        constructor() {
          (this._request = null),
            (this._charts = new Map()),
            (this._running = !1),
            (this._lastDate = void 0);
        }
        _notify(e, t, n, r) {
          const o = t.listeners[r],
            a = t.duration;
          o.forEach((r) =>
            r({
              chart: e,
              initial: t.initial,
              numSteps: a,
              currentStep: Math.min(n - t.start, a),
            })
          );
        }
        _refresh() {
          this._request ||
            ((this._running = !0),
            (this._request = uy.call(window, () => {
              this._update(),
                (this._request = null),
                this._running && this._refresh();
            })));
        }
        _update(e = Date.now()) {
          let t = 0;
          this._charts.forEach((n, r) => {
            if (!n.running || !n.items.length) return;
            const o = n.items;
            let a,
              i = o.length - 1,
              s = !1;
            for (; i >= 0; --i)
              (a = o[i]),
                a._active
                  ? (a._total > n.duration && (n.duration = a._total),
                    a.tick(e),
                    (s = !0))
                  : ((o[i] = o[o.length - 1]), o.pop());
            s && (r.draw(), this._notify(r, n, e, "progress")),
              o.length ||
                ((n.running = !1),
                this._notify(r, n, e, "complete"),
                (n.initial = !1)),
              (t += o.length);
          }),
            (this._lastDate = e),
            0 === t && (this._running = !1);
        }
        _getAnims(e) {
          const t = this._charts;
          let n = t.get(e);
          return (
            n ||
              ((n = {
                running: !1,
                initial: !0,
                items: [],
                listeners: { complete: [], progress: [] },
              }),
              t.set(e, n)),
            n
          );
        }
        listen(e, t, n) {
          this._getAnims(e).listeners[t].push(n);
        }
        add(e, t) {
          t && t.length && this._getAnims(e).items.push(...t);
        }
        has(e) {
          return this._getAnims(e).items.length > 0;
        }
        start(e) {
          const t = this._charts.get(e);
          t &&
            ((t.running = !0),
            (t.start = Date.now()),
            (t.duration = t.items.reduce(
              (e, t) => Math.max(e, t._duration),
              0
            )),
            this._refresh());
        }
        running(e) {
          if (!this._running) return !1;
          const t = this._charts.get(e);
          return !!(t && t.running && t.items.length);
        }
        stop(e) {
          const t = this._charts.get(e);
          if (!t || !t.items.length) return;
          const n = t.items;
          let r = n.length - 1;
          for (; r >= 0; --r) n[r].cancel();
          (t.items = []), this._notify(e, t, Date.now(), "complete");
        }
        remove(e) {
          return this._charts.delete(e);
        }
      })();
      const kC = "transparent",
        wC = {
          boolean(e, t, n) {
            return n > 0.5 ? t : e;
          },
          color(e, t, n) {
            const r = Qy(e || kC),
              o = r.valid && Qy(t || kC);
            return o && o.valid ? o.mix(r, n).hexString() : t;
          },
          number(e, t, n) {
            return e + (t - e) * n;
          },
        };
      class PC {
        constructor(e, t, n, r) {
          const o = t[n];
          r = Ix([e.to, r, o, e.from]);
          const a = Ix([e.from, o, r]);
          (this._active = !0),
            (this._fn = e.fn || wC[e.type || typeof a]),
            (this._easing = _y[e.easing] || _y.linear),
            (this._start = Math.floor(Date.now() + (e.delay || 0))),
            (this._duration = this._total = Math.floor(e.duration)),
            (this._loop = !!e.loop),
            (this._target = t),
            (this._prop = n),
            (this._from = a),
            (this._to = r),
            (this._promises = void 0);
        }
        active() {
          return this._active;
        }
        update(e, t, n) {
          if (this._active) {
            this._notify(!1);
            const r = this._target[this._prop],
              o = n - this._start,
              a = this._duration - o;
            (this._start = n),
              (this._duration = Math.floor(Math.max(a, e.duration))),
              (this._total += o),
              (this._loop = !!e.loop),
              (this._to = Ix([e.to, t, r, e.from])),
              (this._from = Ix([e.from, r, t]));
          }
        }
        cancel() {
          this._active &&
            (this.tick(Date.now()), (this._active = !1), this._notify(!1));
        }
        tick(e) {
          const t = e - this._start,
            n = this._duration,
            r = this._prop,
            o = this._from,
            a = this._loop,
            i = this._to;
          let s;
          if (((this._active = o !== i && (a || t < n)), !this._active))
            return (this._target[r] = i), void this._notify(!0);
          t < 0
            ? (this._target[r] = o)
            : ((s = (t / n) % 2),
              (s = a && s > 1 ? 2 - s : s),
              (s = this._easing(Math.min(1, Math.max(0, s)))),
              (this._target[r] = this._fn(o, i, s)));
        }
        wait() {
          const e = this._promises || (this._promises = []);
          return new Promise((t, n) => {
            e.push({ res: t, rej: n });
          });
        }
        _notify(e) {
          const t = e ? "res" : "rej",
            n = this._promises || [];
          for (let e = 0; e < n.length; e++) n[e][t]();
        }
      }
      ox.set("animation", {
        delay: void 0,
        duration: 1e3,
        easing: "easeOutQuart",
        fn: void 0,
        from: void 0,
        loop: void 0,
        to: void 0,
        type: void 0,
      });
      const OC = Object.keys(ox.animation);
      ox.describe("animation", {
        _fallback: !1,
        _indexable: !1,
        _scriptable: (e) =>
          "onProgress" !== e && "onComplete" !== e && "fn" !== e,
      }),
        ox.set("animations", {
          colors: {
            type: "color",
            properties: ["color", "borderColor", "backgroundColor"],
          },
          numbers: {
            type: "number",
            properties: ["x", "y", "borderWidth", "radius", "tension"],
          },
        }),
        ox.describe("animations", { _fallback: "animation" }),
        ox.set("transitions", {
          active: { animation: { duration: 400 } },
          resize: { animation: { duration: 0 } },
          show: {
            animations: {
              colors: { from: "transparent" },
              visible: { type: "boolean", duration: 0 },
            },
          },
          hide: {
            animations: {
              colors: { to: "transparent" },
              visible: { type: "boolean", easing: "linear", fn: (e) => 0 | e },
            },
          },
        });
      class IC {
        constructor(e, t) {
          (this._chart = e), (this._properties = new Map()), this.configure(t);
        }
        configure(e) {
          if (!h_(e)) return;
          const t = this._properties;
          Object.getOwnPropertyNames(e).forEach((n) => {
            const r = e[n];
            if (!h_(r)) return;
            const o = {};
            for (const e of OC) o[e] = r[e];
            ((m_(r.properties) && r.properties) || [n]).forEach((e) => {
              (e !== n && t.has(e)) || t.set(e, o);
            });
          });
        }
        _animateOptions(e, t) {
          const n = t.options,
            r = (function (e, t) {
              if (!t) return;
              let n = e.options;
              if (n)
                return (
                  n.$shared &&
                    (e.options = n =
                      Object.assign({}, n, { $shared: !1, $animations: {} })),
                  n
                );
              e.options = t;
            })(e, n);
          if (!r) return [];
          const o = this._createAnimations(r, n);
          return (
            n.$shared &&
              (function (e, t) {
                const n = [],
                  r = Object.keys(t);
                for (let t = 0; t < r.length; t++) {
                  const o = e[r[t]];
                  o && o.active() && n.push(o.wait());
                }
                return Promise.all(n);
              })(e.options.$animations, n).then(
                () => {
                  e.options = n;
                },
                () => {}
              ),
            o
          );
        }
        _createAnimations(e, t) {
          const n = this._properties,
            r = [],
            o = e.$animations || (e.$animations = {}),
            a = Object.keys(t),
            i = Date.now();
          let s;
          for (s = a.length - 1; s >= 0; --s) {
            const l = a[s];
            if ("$" === l.charAt(0)) continue;
            if ("options" === l) {
              r.push(...this._animateOptions(e, t));
              continue;
            }
            const c = t[l];
            let u = o[l];
            const d = n.get(l);
            if (u) {
              if (d && u.active()) {
                u.update(d, c, i);
                continue;
              }
              u.cancel();
            }
            d && d.duration
              ? ((o[l] = u = new PC(d, e, l, c)), r.push(u))
              : (e[l] = c);
          }
          return r;
        }
        update(e, t) {
          if (0 === this._properties.size) return void Object.assign(e, t);
          const n = this._createAnimations(e, t);
          return n.length ? (SC.add(this._chart, n), !0) : void 0;
        }
      }
      function TC(e, t) {
        const n = (e && e.options) || {},
          r = n.reverse,
          o = void 0 === n.min ? t : 0,
          a = void 0 === n.max ? t : 0;
        return { start: r ? a : o, end: r ? o : a };
      }
      function MC(e, t) {
        const n = [],
          r = e._getSortedDatasetMetas(t);
        let o, a;
        for (o = 0, a = r.length; o < a; ++o) n.push(r[o].index);
        return n;
      }
      function EC(e, t, n, r = {}) {
        const o = e.keys,
          a = "single" === r.mode;
        let i, s, l, c;
        if (null !== t) {
          for (i = 0, s = o.length; i < s; ++i) {
            if (((l = +o[i]), l === n)) {
              if (r.all) continue;
              break;
            }
            (c = e.values[l]),
              f_(c) && (a || 0 === t || V_(t) === V_(c)) && (t += c);
          }
          return t;
        }
      }
      function DC(e, t) {
        const n = e && e.options.stacked;
        return n || (void 0 === n && void 0 !== t.stack);
      }
      function jC(e, t, n) {
        const r = e[t] || (e[t] = {});
        return r[n] || (r[n] = {});
      }
      function RC(e, t, n, r) {
        for (const o of t.getMatchingVisibleMetas(r).reverse()) {
          const t = e[o.index];
          if ((n && t > 0) || (!n && t < 0)) return o.index;
        }
        return null;
      }
      function NC(e, t) {
        const { chart: n, _cachedMeta: r } = e,
          o = n._stacks || (n._stacks = {}),
          { iScale: a, vScale: i, index: s } = r,
          l = a.axis,
          c = i.axis,
          u = (function (e, t, n) {
            return `${e.id}.${t.id}.${n.stack || n.type}`;
          })(a, i, r),
          d = t.length;
        let p;
        for (let e = 0; e < d; ++e) {
          const n = t[e],
            { [l]: a, [c]: d } = n;
          (p = (n._stacks || (n._stacks = {}))[c] = jC(o, u, a)),
            (p[s] = d),
            (p._top = RC(p, i, !0, r.type)),
            (p._bottom = RC(p, i, !1, r.type));
        }
      }
      function AC(e, t) {
        const n = e.scales;
        return Object.keys(n)
          .filter((e) => n[e].axis === t)
          .shift();
      }
      function LC(e, t) {
        const n = e.controller.index,
          r = e.vScale && e.vScale.axis;
        if (r) {
          t = t || e._parsed;
          for (const e of t) {
            const t = e._stacks;
            if (!t || void 0 === t[r] || void 0 === t[r][n]) return;
            delete t[r][n];
          }
        }
      }
      const zC = (e) => "reset" === e || "none" === e,
        BC = (e, t) => (t ? e : Object.assign({}, e));
      class ZC {
        constructor(e, t) {
          (this.chart = e),
            (this._ctx = e.ctx),
            (this.index = t),
            (this._cachedDataOpts = {}),
            (this._cachedMeta = this.getMeta()),
            (this._type = this._cachedMeta.type),
            (this.options = void 0),
            (this._parsing = !1),
            (this._data = void 0),
            (this._objectData = void 0),
            (this._sharedOptions = void 0),
            (this._drawStart = void 0),
            (this._drawCount = void 0),
            (this.enableOptionSharing = !1),
            (this.supportsDecimation = !1),
            (this.$context = void 0),
            (this._syncList = []),
            this.initialize();
        }
        initialize() {
          const e = this._cachedMeta;
          this.configure(),
            this.linkScales(),
            (e._stacked = DC(e.vScale, e)),
            this.addElements();
        }
        updateIndex(e) {
          this.index !== e && LC(this._cachedMeta), (this.index = e);
        }
        linkScales() {
          const e = this.chart,
            t = this._cachedMeta,
            n = this.getDataset(),
            r = (e, t, n, r) => ("x" === e ? t : "r" === e ? r : n),
            o = (t.xAxisID = v_(n.xAxisID, AC(e, "x"))),
            a = (t.yAxisID = v_(n.yAxisID, AC(e, "y"))),
            i = (t.rAxisID = v_(n.rAxisID, AC(e, "r"))),
            s = t.indexAxis,
            l = (t.iAxisID = r(s, o, a, i)),
            c = (t.vAxisID = r(s, a, o, i));
          (t.xScale = this.getScaleForId(o)),
            (t.yScale = this.getScaleForId(a)),
            (t.rScale = this.getScaleForId(i)),
            (t.iScale = this.getScaleForId(l)),
            (t.vScale = this.getScaleForId(c));
        }
        getDataset() {
          return this.chart.data.datasets[this.index];
        }
        getMeta() {
          return this.chart.getDatasetMeta(this.index);
        }
        getScaleForId(e) {
          return this.chart.scales[e];
        }
        _getOtherScale(e) {
          const t = this._cachedMeta;
          return e === t.iScale ? t.vScale : t.iScale;
        }
        reset() {
          this._update("reset");
        }
        _destroy() {
          const e = this._cachedMeta;
          this._data && ly(this._data, this), e._stacked && LC(e);
        }
        _dataCheck() {
          const e = this.getDataset(),
            t = e.data || (e.data = []),
            n = this._data;
          if (h_(t))
            this._data = (function (e) {
              const t = Object.keys(e),
                n = new Array(t.length);
              let r, o, a;
              for (r = 0, o = t.length; r < o; ++r)
                (a = t[r]), (n[r] = { x: a, y: e[a] });
              return n;
            })(t);
          else if (n !== t) {
            if (n) {
              ly(n, this);
              const e = this._cachedMeta;
              LC(e), (e._parsed = []);
            }
            t &&
              Object.isExtensible(t) &&
              (this,
              (r = t)._chartjs
                ? r._chartjs.listeners.push(this)
                : (Object.defineProperty(r, "_chartjs", {
                    configurable: !0,
                    enumerable: !1,
                    value: { listeners: [this] },
                  }),
                  sy.forEach((e) => {
                    const t = "_onData" + M_(e),
                      n = r[e];
                    Object.defineProperty(r, e, {
                      configurable: !0,
                      enumerable: !1,
                      value(...e) {
                        const o = n.apply(this, e);
                        return (
                          r._chartjs.listeners.forEach((n) => {
                            "function" == typeof n[t] && n[t](...e);
                          }),
                          o
                        );
                      },
                    });
                  }))),
              (this._syncList = []),
              (this._data = t);
          }
          var r;
        }
        addElements() {
          const e = this._cachedMeta;
          this._dataCheck(),
            this.datasetElementType &&
              (e.dataset = new this.datasetElementType());
        }
        buildOrUpdateElements(e) {
          const t = this._cachedMeta,
            n = this.getDataset();
          let r = !1;
          this._dataCheck();
          const o = t._stacked;
          (t._stacked = DC(t.vScale, t)),
            t.stack !== n.stack && ((r = !0), LC(t), (t.stack = n.stack)),
            this._resyncElements(e),
            (r || o !== t._stacked) && NC(this, t._parsed);
        }
        configure() {
          const e = this.chart.config,
            t = e.datasetScopeKeys(this._type),
            n = e.getOptionScopes(this.getDataset(), t, !0);
          (this.options = e.createResolver(n, this.getContext())),
            (this._parsing = this.options.parsing),
            (this._cachedDataOpts = {});
        }
        parse(e, t) {
          const { _cachedMeta: n, _data: r } = this,
            { iScale: o, _stacked: a } = n,
            i = o.axis;
          let s,
            l,
            c,
            u = (0 === e && t === r.length) || n._sorted,
            d = e > 0 && n._parsed[e - 1];
          if (!1 === this._parsing) (n._parsed = r), (n._sorted = !0), (c = r);
          else {
            c = m_(r[e])
              ? this.parseArrayData(n, r, e, t)
              : h_(r[e])
              ? this.parseObjectData(n, r, e, t)
              : this.parsePrimitiveData(n, r, e, t);
            const o = () => null === l[i] || (d && l[i] < d[i]);
            for (s = 0; s < t; ++s)
              (n._parsed[s + e] = l = c[s]), u && (o() && (u = !1), (d = l));
            n._sorted = u;
          }
          a && NC(this, c);
        }
        parsePrimitiveData(e, t, n, r) {
          const { iScale: o, vScale: a } = e,
            i = o.axis,
            s = a.axis,
            l = o.getLabels(),
            c = o === a,
            u = new Array(r);
          let d, p, m;
          for (d = 0, p = r; d < p; ++d)
            (m = d + n),
              (u[d] = { [i]: c || o.parse(l[m], m), [s]: a.parse(t[m], m) });
          return u;
        }
        parseArrayData(e, t, n, r) {
          const { xScale: o, yScale: a } = e,
            i = new Array(r);
          let s, l, c, u;
          for (s = 0, l = r; s < l; ++s)
            (c = s + n),
              (u = t[c]),
              (i[s] = { x: o.parse(u[0], c), y: a.parse(u[1], c) });
          return i;
        }
        parseObjectData(e, t, n, r) {
          const { xScale: o, yScale: a } = e,
            { xAxisKey: i = "x", yAxisKey: s = "y" } = this._parsing,
            l = new Array(r);
          let c, u, d, p;
          for (c = 0, u = r; c < u; ++c)
            (d = c + n),
              (p = t[d]),
              (l[c] = { x: o.parse(T_(p, i), d), y: a.parse(T_(p, s), d) });
          return l;
        }
        getParsed(e) {
          return this._cachedMeta._parsed[e];
        }
        getDataElement(e) {
          return this._cachedMeta.data[e];
        }
        applyStack(e, t, n) {
          const r = this.chart,
            o = this._cachedMeta,
            a = t[e.axis];
          return EC(
            { keys: MC(r, !0), values: t._stacks[e.axis] },
            a,
            o.index,
            { mode: n }
          );
        }
        updateRangeFromParsed(e, t, n, r) {
          const o = n[t.axis];
          let a = null === o ? NaN : o;
          const i = r && n._stacks[t.axis];
          r && i && ((r.values = i), (a = EC(r, o, this._cachedMeta.index))),
            (e.min = Math.min(e.min, a)),
            (e.max = Math.max(e.max, a));
        }
        getMinMax(e, t) {
          const n = this._cachedMeta,
            r = n._parsed,
            o = n._sorted && e === n.iScale,
            a = r.length,
            i = this._getOtherScale(e),
            s = ((e, t, n) =>
              e &&
              !t.hidden &&
              t._stacked && { keys: MC(n, !0), values: null })(
              t,
              n,
              this.chart
            ),
            l = {
              min: Number.POSITIVE_INFINITY,
              max: Number.NEGATIVE_INFINITY,
            },
            { min: c, max: u } = (function (e) {
              const {
                min: t,
                max: n,
                minDefined: r,
                maxDefined: o,
              } = e.getUserBounds();
              return {
                min: r ? t : Number.NEGATIVE_INFINITY,
                max: o ? n : Number.POSITIVE_INFINITY,
              };
            })(i);
          let d, p;
          function m() {
            p = r[d];
            const t = p[i.axis];
            return !f_(p[e.axis]) || c > t || u < t;
          }
          for (
            d = 0;
            d < a && (m() || (this.updateRangeFromParsed(l, e, p, s), !o));
            ++d
          );
          if (o)
            for (d = a - 1; d >= 0; --d)
              if (!m()) {
                this.updateRangeFromParsed(l, e, p, s);
                break;
              }
          return l;
        }
        getAllParsedValues(e) {
          const t = this._cachedMeta._parsed,
            n = [];
          let r, o, a;
          for (r = 0, o = t.length; r < o; ++r)
            (a = t[r][e.axis]), f_(a) && n.push(a);
          return n;
        }
        getMaxOverflow() {
          return !1;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            n = t.iScale,
            r = t.vScale,
            o = this.getParsed(e);
          return {
            label: n ? "" + n.getLabelForValue(o[n.axis]) : "",
            value: r ? "" + r.getLabelForValue(o[r.axis]) : "",
          };
        }
        _update(e) {
          const t = this._cachedMeta;
          this.update(e || "default"),
            (t._clip = (function (e) {
              let t, n, r, o;
              return (
                h_(e)
                  ? ((t = e.top), (n = e.right), (r = e.bottom), (o = e.left))
                  : (t = n = r = o = e),
                { top: t, right: n, bottom: r, left: o, disabled: !1 === e }
              );
            })(
              v_(
                this.options.clip,
                (function (e, t, n) {
                  if (!1 === n) return !1;
                  const r = TC(e, n),
                    o = TC(t, n);
                  return {
                    top: o.end,
                    right: r.end,
                    bottom: o.start,
                    left: r.start,
                  };
                })(t.xScale, t.yScale, this.getMaxOverflow())
              )
            ));
        }
        update(e) {}
        draw() {
          const e = this._ctx,
            t = this.chart,
            n = this._cachedMeta,
            r = n.data || [],
            o = t.chartArea,
            a = [],
            i = this._drawStart || 0,
            s = this._drawCount || r.length - i,
            l = this.options.drawActiveElementsOnTop;
          let c;
          for (n.dataset && n.dataset.draw(e, o, i, s), c = i; c < i + s; ++c) {
            const t = r[c];
            t.hidden || (t.active && l ? a.push(t) : t.draw(e, o));
          }
          for (c = 0; c < a.length; ++c) a[c].draw(e, o);
        }
        getStyle(e, t) {
          const n = t ? "active" : "default";
          return void 0 === e && this._cachedMeta.dataset
            ? this.resolveDatasetElementOptions(n)
            : this.resolveDataElementOptions(e || 0, n);
        }
        getContext(e, t, n) {
          const r = this.getDataset();
          let o;
          if (e >= 0 && e < this._cachedMeta.data.length) {
            const t = this._cachedMeta.data[e];
            (o =
              t.$context ||
              (t.$context = (function (e, t, n) {
                return Tx(e, {
                  active: !1,
                  dataIndex: t,
                  parsed: void 0,
                  raw: void 0,
                  element: n,
                  index: t,
                  mode: "default",
                  type: "data",
                });
              })(this.getContext(), e, t))),
              (o.parsed = this.getParsed(e)),
              (o.raw = r.data[e]),
              (o.index = o.dataIndex = e);
          } else
            (o =
              this.$context ||
              (this.$context = (function (e, t) {
                return Tx(e, {
                  active: !1,
                  dataset: void 0,
                  datasetIndex: t,
                  index: t,
                  mode: "default",
                  type: "dataset",
                });
              })(this.chart.getContext(), this.index))),
              (o.dataset = r),
              (o.index = o.datasetIndex = this.index);
          return (o.active = !!t), (o.mode = n), o;
        }
        resolveDatasetElementOptions(e) {
          return this._resolveElementOptions(this.datasetElementType.id, e);
        }
        resolveDataElementOptions(e, t) {
          return this._resolveElementOptions(this.dataElementType.id, t, e);
        }
        _resolveElementOptions(e, t = "default", n) {
          const r = "active" === t,
            o = this._cachedDataOpts,
            a = e + "-" + t,
            i = o[a],
            s = this.enableOptionSharing && E_(n);
          if (i) return BC(i, s);
          const l = this.chart.config,
            c = l.datasetElementScopeKeys(this._type, e),
            u = r ? [`${e}Hover`, "hover", e, ""] : [e, ""],
            d = l.getOptionScopes(this.getDataset(), c),
            p = Object.keys(ox.elements[e]),
            m = l.resolveNamedOptions(d, p, () => this.getContext(n, r), u);
          return (
            m.$shared && ((m.$shared = s), (o[a] = Object.freeze(BC(m, s)))), m
          );
        }
        _resolveAnimations(e, t, n) {
          const r = this.chart,
            o = this._cachedDataOpts,
            a = `animation-${t}`,
            i = o[a];
          if (i) return i;
          let s;
          if (!1 !== r.options.animation) {
            const r = this.chart.config,
              o = r.datasetAnimationScopeKeys(this._type, t),
              a = r.getOptionScopes(this.getDataset(), o);
            s = r.createResolver(a, this.getContext(e, n, t));
          }
          const l = new IC(r, s && s.animations);
          return s && s._cacheable && (o[a] = Object.freeze(l)), l;
        }
        getSharedOptions(e) {
          if (e.$shared)
            return (
              this._sharedOptions ||
              (this._sharedOptions = Object.assign({}, e))
            );
        }
        includeOptions(e, t) {
          return !t || zC(e) || this.chart._animationsDisabled;
        }
        _getSharedOptions(e, t) {
          const n = this.resolveDataElementOptions(e, t),
            r = this._sharedOptions,
            o = this.getSharedOptions(n),
            a = this.includeOptions(t, o) || o !== r;
          return (
            this.updateSharedOptions(o, t, n),
            { sharedOptions: o, includeOptions: a }
          );
        }
        updateElement(e, t, n, r) {
          zC(r)
            ? Object.assign(e, n)
            : this._resolveAnimations(t, r).update(e, n);
        }
        updateSharedOptions(e, t, n) {
          e && !zC(t) && this._resolveAnimations(void 0, t).update(e, n);
        }
        _setStyle(e, t, n, r) {
          e.active = r;
          const o = this.getStyle(t, r);
          this._resolveAnimations(t, n, r).update(e, {
            options: (!r && this.getSharedOptions(o)) || o,
          });
        }
        removeHoverStyle(e, t, n) {
          this._setStyle(e, n, "active", !1);
        }
        setHoverStyle(e, t, n) {
          this._setStyle(e, n, "active", !0);
        }
        _removeDatasetHoverStyle() {
          const e = this._cachedMeta.dataset;
          e && this._setStyle(e, void 0, "active", !1);
        }
        _setDatasetHoverStyle() {
          const e = this._cachedMeta.dataset;
          e && this._setStyle(e, void 0, "active", !0);
        }
        _resyncElements(e) {
          const t = this._data,
            n = this._cachedMeta.data;
          for (const [e, t, n] of this._syncList) this[e](t, n);
          this._syncList = [];
          const r = n.length,
            o = t.length,
            a = Math.min(o, r);
          a && this.parse(0, a),
            o > r
              ? this._insertElements(r, o - r, e)
              : o < r && this._removeElements(o, r - o);
        }
        _insertElements(e, t, n = !0) {
          const r = this._cachedMeta,
            o = r.data,
            a = e + t;
          let i;
          const s = (e) => {
            for (e.length += t, i = e.length - 1; i >= a; i--) e[i] = e[i - t];
          };
          for (s(o), i = e; i < a; ++i) o[i] = new this.dataElementType();
          this._parsing && s(r._parsed),
            this.parse(e, t),
            n && this.updateElements(o, e, t, "reset");
        }
        updateElements(e, t, n, r) {}
        _removeElements(e, t) {
          const n = this._cachedMeta;
          if (this._parsing) {
            const r = n._parsed.splice(e, t);
            n._stacked && LC(n, r);
          }
          n.data.splice(e, t);
        }
        _sync(e) {
          if (this._parsing) this._syncList.push(e);
          else {
            const [t, n, r] = e;
            this[t](n, r);
          }
          this.chart._dataChanges.push([this.index, ...e]);
        }
        _onDataPush() {
          const e = arguments.length;
          this._sync(["_insertElements", this.getDataset().data.length - e, e]);
        }
        _onDataPop() {
          this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
        }
        _onDataShift() {
          this._sync(["_removeElements", 0, 1]);
        }
        _onDataSplice(e, t) {
          t && this._sync(["_removeElements", e, t]);
          const n = arguments.length - 2;
          n && this._sync(["_insertElements", e, n]);
        }
        _onDataUnshift() {
          this._sync(["_insertElements", 0, arguments.length]);
        }
      }
      function FC(e) {
        const t = e.iScale,
          n = (function (e, t) {
            if (!e._cache.$bar) {
              const n = e.getMatchingVisibleMetas(t);
              let r = [];
              for (let t = 0, o = n.length; t < o; t++)
                r = r.concat(n[t].controller.getAllParsedValues(e));
              e._cache.$bar = cy(r.sort((e, t) => e - t));
            }
            return e._cache.$bar;
          })(t, e.type);
        let r,
          o,
          a,
          i,
          s = t._length;
        const l = () => {
          32767 !== a &&
            -32768 !== a &&
            (E_(i) && (s = Math.min(s, Math.abs(a - i) || s)), (i = a));
        };
        for (r = 0, o = n.length; r < o; ++r)
          (a = t.getPixelForValue(n[r])), l();
        for (i = void 0, r = 0, o = t.ticks.length; r < o; ++r)
          (a = t.getPixelForTick(r)), l();
        return s;
      }
      function HC(e, t, n, r) {
        return (
          m_(e)
            ? (function (e, t, n, r) {
                const o = n.parse(e[0], r),
                  a = n.parse(e[1], r),
                  i = Math.min(o, a),
                  s = Math.max(o, a);
                let l = i,
                  c = s;
                Math.abs(i) > Math.abs(s) && ((l = s), (c = i)),
                  (t[n.axis] = c),
                  (t._custom = {
                    barStart: l,
                    barEnd: c,
                    start: o,
                    end: a,
                    min: i,
                    max: s,
                  });
              })(e, t, n, r)
            : (t[n.axis] = n.parse(e, r)),
          t
        );
      }
      function VC(e, t, n, r) {
        const o = e.iScale,
          a = e.vScale,
          i = o.getLabels(),
          s = o === a,
          l = [];
        let c, u, d, p;
        for (c = n, u = n + r; c < u; ++c)
          (p = t[c]),
            (d = {}),
            (d[o.axis] = s || o.parse(i[c], c)),
            l.push(HC(p, d, a, c));
        return l;
      }
      function WC(e) {
        return e && void 0 !== e.barStart && void 0 !== e.barEnd;
      }
      function $C(e, t, n, r) {
        let o = t.borderSkipped;
        const a = {};
        if (!o) return void (e.borderSkipped = a);
        if (!0 === o)
          return void (e.borderSkipped = {
            top: !0,
            right: !0,
            bottom: !0,
            left: !0,
          });
        const {
          start: i,
          end: s,
          reverse: l,
          top: c,
          bottom: u,
        } = (function (e) {
          let t, n, r, o, a;
          return (
            e.horizontal
              ? ((t = e.base > e.x), (n = "left"), (r = "right"))
              : ((t = e.base < e.y), (n = "bottom"), (r = "top")),
            t ? ((o = "end"), (a = "start")) : ((o = "start"), (a = "end")),
            { start: n, end: r, reverse: t, top: o, bottom: a }
          );
        })(e);
        "middle" === o &&
          n &&
          ((e.enableBorderRadius = !0),
          (n._top || 0) === r
            ? (o = c)
            : (n._bottom || 0) === r
            ? (o = u)
            : ((a[UC(u, i, s, l)] = !0), (o = c))),
          (a[UC(o, i, s, l)] = !0),
          (e.borderSkipped = a);
      }
      function UC(e, t, n, r) {
        var o, a, i;
        return (
          r
            ? ((i = n),
              (e = KC((e = (o = e) === (a = t) ? i : o === i ? a : o), n, t)))
            : (e = KC(e, t, n)),
          e
        );
      }
      function KC(e, t, n) {
        return "start" === e ? t : "end" === e ? n : e;
      }
      function GC(e, { inflateAmount: t }, n) {
        e.inflateAmount = "auto" === t ? (1 === n ? 0.33 : 0) : t;
      }
      (ZC.defaults = {}),
        (ZC.prototype.datasetElementType = null),
        (ZC.prototype.dataElementType = null);
      class qC extends ZC {
        parsePrimitiveData(e, t, n, r) {
          return VC(e, t, n, r);
        }
        parseArrayData(e, t, n, r) {
          return VC(e, t, n, r);
        }
        parseObjectData(e, t, n, r) {
          const { iScale: o, vScale: a } = e,
            { xAxisKey: i = "x", yAxisKey: s = "y" } = this._parsing,
            l = "x" === o.axis ? i : s,
            c = "x" === a.axis ? i : s,
            u = [];
          let d, p, m, h;
          for (d = n, p = n + r; d < p; ++d)
            (h = t[d]),
              (m = {}),
              (m[o.axis] = o.parse(T_(h, l), d)),
              u.push(HC(T_(h, c), m, a, d));
          return u;
        }
        updateRangeFromParsed(e, t, n, r) {
          super.updateRangeFromParsed(e, t, n, r);
          const o = n._custom;
          o &&
            t === this._cachedMeta.vScale &&
            ((e.min = Math.min(e.min, o.min)),
            (e.max = Math.max(e.max, o.max)));
        }
        getMaxOverflow() {
          return 0;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            { iScale: n, vScale: r } = t,
            o = this.getParsed(e),
            a = o._custom,
            i = WC(a)
              ? "[" + a.start + ", " + a.end + "]"
              : "" + r.getLabelForValue(o[r.axis]);
          return { label: "" + n.getLabelForValue(o[n.axis]), value: i };
        }
        initialize() {
          (this.enableOptionSharing = !0),
            super.initialize(),
            (this._cachedMeta.stack = this.getDataset().stack);
        }
        update(e) {
          const t = this._cachedMeta;
          this.updateElements(t.data, 0, t.data.length, e);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            {
              index: a,
              _cachedMeta: { vScale: i },
            } = this,
            s = i.getBasePixel(),
            l = i.isHorizontal(),
            c = this._getRuler(),
            { sharedOptions: u, includeOptions: d } = this._getSharedOptions(
              t,
              r
            );
          for (let p = t; p < t + n; p++) {
            const t = this.getParsed(p),
              n =
                o || p_(t[i.axis])
                  ? { base: s, head: s }
                  : this._calculateBarValuePixels(p),
              m = this._calculateBarIndexPixels(p, c),
              h = (t._stacks || {})[i.axis],
              f = {
                horizontal: l,
                base: n.base,
                enableBorderRadius:
                  !h || WC(t._custom) || a === h._top || a === h._bottom,
                x: l ? n.head : m.center,
                y: l ? m.center : n.head,
                height: l ? m.size : Math.abs(n.size),
                width: l ? Math.abs(n.size) : m.size,
              };
            d &&
              (f.options =
                u ||
                this.resolveDataElementOptions(p, e[p].active ? "active" : r));
            const g = f.options || e[p].options;
            $C(f, g, h, a),
              GC(f, g, c.ratio),
              this.updateElement(e[p], p, f, r);
          }
        }
        _getStacks(e, t) {
          const { iScale: n } = this._cachedMeta,
            r = n
              .getMatchingVisibleMetas(this._type)
              .filter((e) => e.controller.options.grouped),
            o = n.options.stacked,
            a = [],
            i = (e) => {
              const n = e.controller.getParsed(t),
                r = n && n[e.vScale.axis];
              if (p_(r) || isNaN(r)) return !0;
            };
          for (const n of r)
            if (
              (void 0 === t || !i(n)) &&
              ((!1 === o ||
                -1 === a.indexOf(n.stack) ||
                (void 0 === o && void 0 === n.stack)) &&
                a.push(n.stack),
              n.index === e)
            )
              break;
          return a.length || a.push(void 0), a;
        }
        _getStackCount(e) {
          return this._getStacks(void 0, e).length;
        }
        _getStackIndex(e, t, n) {
          const r = this._getStacks(e, n),
            o = void 0 !== t ? r.indexOf(t) : -1;
          return -1 === o ? r.length - 1 : o;
        }
        _getRuler() {
          const e = this.options,
            t = this._cachedMeta,
            n = t.iScale,
            r = [];
          let o, a;
          for (o = 0, a = t.data.length; o < a; ++o)
            r.push(n.getPixelForValue(this.getParsed(o)[n.axis], o));
          const i = e.barThickness;
          return {
            min: i || FC(t),
            pixels: r,
            start: n._startPixel,
            end: n._endPixel,
            stackCount: this._getStackCount(),
            scale: n,
            grouped: e.grouped,
            ratio: i ? 1 : e.categoryPercentage * e.barPercentage,
          };
        }
        _calculateBarValuePixels(e) {
          const {
              _cachedMeta: { vScale: t, _stacked: n },
              options: { base: r, minBarLength: o },
            } = this,
            a = r || 0,
            i = this.getParsed(e),
            s = i._custom,
            l = WC(s);
          let c,
            u,
            d = i[t.axis],
            p = 0,
            m = n ? this.applyStack(t, i, n) : d;
          m !== d && ((p = m - d), (m = d)),
            l &&
              ((d = s.barStart),
              (m = s.barEnd - s.barStart),
              0 !== d && V_(d) !== V_(s.barEnd) && (p = 0),
              (p += d));
          const h = p_(r) || l ? p : r;
          let f = t.getPixelForValue(h);
          if (
            ((c = this.chart.getDataVisibility(e)
              ? t.getPixelForValue(p + m)
              : f),
            (u = c - f),
            Math.abs(u) < o)
          ) {
            (u =
              (function (e, t, n) {
                return 0 !== e
                  ? V_(e)
                  : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
              })(u, t, a) * o),
              d === a && (f -= u / 2);
            const e = t.getPixelForDecimal(0),
              n = t.getPixelForDecimal(1),
              r = Math.min(e, n),
              i = Math.max(e, n);
            (f = Math.max(Math.min(f, i), r)), (c = f + u);
          }
          if (f === t.getPixelForValue(a)) {
            const e = (V_(u) * t.getLineWidthForValue(a)) / 2;
            (f += e), (u -= e);
          }
          return { size: u, base: f, head: c, center: c + u / 2 };
        }
        _calculateBarIndexPixels(e, t) {
          const n = t.scale,
            r = this.options,
            o = r.skipNull,
            a = v_(r.maxBarThickness, 1 / 0);
          let i, s;
          if (t.grouped) {
            const n = o ? this._getStackCount(e) : t.stackCount,
              l =
                "flex" === r.barThickness
                  ? (function (e, t, n, r) {
                      const o = t.pixels,
                        a = o[e];
                      let i = e > 0 ? o[e - 1] : null,
                        s = e < o.length - 1 ? o[e + 1] : null;
                      const l = n.categoryPercentage;
                      null === i &&
                        (i = a - (null === s ? t.end - t.start : s - a)),
                        null === s && (s = a + a - i);
                      const c = a - ((a - Math.min(i, s)) / 2) * l;
                      return {
                        chunk: ((Math.abs(s - i) / 2) * l) / r,
                        ratio: n.barPercentage,
                        start: c,
                      };
                    })(e, t, r, n)
                  : (function (e, t, n, r) {
                      const o = n.barThickness;
                      let a, i;
                      return (
                        p_(o)
                          ? ((a = t.min * n.categoryPercentage),
                            (i = n.barPercentage))
                          : ((a = o * r), (i = 1)),
                        { chunk: a / r, ratio: i, start: t.pixels[e] - a / 2 }
                      );
                    })(e, t, r, n),
              c = this._getStackIndex(
                this.index,
                this._cachedMeta.stack,
                o ? e : void 0
              );
            (i = l.start + l.chunk * c + l.chunk / 2),
              (s = Math.min(a, l.chunk * l.ratio));
          } else
            (i = n.getPixelForValue(this.getParsed(e)[n.axis], e)),
              (s = Math.min(a, t.min * t.ratio));
          return { base: i - s / 2, head: i + s / 2, center: i, size: s };
        }
        draw() {
          const e = this._cachedMeta,
            t = e.vScale,
            n = e.data,
            r = n.length;
          let o = 0;
          for (; o < r; ++o)
            null !== this.getParsed(o)[t.axis] && n[o].draw(this._ctx);
        }
      }
      (qC.id = "bar"),
        (qC.defaults = {
          datasetElementType: !1,
          dataElementType: "bar",
          categoryPercentage: 0.8,
          barPercentage: 0.9,
          grouped: !0,
          animations: {
            numbers: {
              type: "number",
              properties: ["x", "y", "base", "width", "height"],
            },
          },
        }),
        (qC.overrides = {
          scales: {
            _index_: { type: "category", offset: !0, grid: { offset: !0 } },
            _value_: { type: "linear", beginAtZero: !0 },
          },
        });
      class YC extends ZC {
        initialize() {
          (this.enableOptionSharing = !0), super.initialize();
        }
        parsePrimitiveData(e, t, n, r) {
          const o = super.parsePrimitiveData(e, t, n, r);
          for (let e = 0; e < o.length; e++)
            o[e]._custom = this.resolveDataElementOptions(e + n).radius;
          return o;
        }
        parseArrayData(e, t, n, r) {
          const o = super.parseArrayData(e, t, n, r);
          for (let e = 0; e < o.length; e++) {
            const r = t[n + e];
            o[e]._custom = v_(
              r[2],
              this.resolveDataElementOptions(e + n).radius
            );
          }
          return o;
        }
        parseObjectData(e, t, n, r) {
          const o = super.parseObjectData(e, t, n, r);
          for (let e = 0; e < o.length; e++) {
            const r = t[n + e];
            o[e]._custom = v_(
              r && r.r && +r.r,
              this.resolveDataElementOptions(e + n).radius
            );
          }
          return o;
        }
        getMaxOverflow() {
          const e = this._cachedMeta.data;
          let t = 0;
          for (let n = e.length - 1; n >= 0; --n)
            t = Math.max(t, e[n].size(this.resolveDataElementOptions(n)) / 2);
          return t > 0 && t;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            { xScale: n, yScale: r } = t,
            o = this.getParsed(e),
            a = n.getLabelForValue(o.x),
            i = r.getLabelForValue(o.y),
            s = o._custom;
          return {
            label: t.label,
            value: "(" + a + ", " + i + (s ? ", " + s : "") + ")",
          };
        }
        update(e) {
          const t = this._cachedMeta.data;
          this.updateElements(t, 0, t.length, e);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            { iScale: a, vScale: i } = this._cachedMeta,
            { sharedOptions: s, includeOptions: l } = this._getSharedOptions(
              t,
              r
            ),
            c = a.axis,
            u = i.axis;
          for (let d = t; d < t + n; d++) {
            const t = e[d],
              n = !o && this.getParsed(d),
              p = {},
              m = (p[c] = o
                ? a.getPixelForDecimal(0.5)
                : a.getPixelForValue(n[c])),
              h = (p[u] = o ? i.getBasePixel() : i.getPixelForValue(n[u]));
            (p.skip = isNaN(m) || isNaN(h)),
              l &&
                ((p.options =
                  s ||
                  this.resolveDataElementOptions(d, t.active ? "active" : r)),
                o && (p.options.radius = 0)),
              this.updateElement(t, d, p, r);
          }
        }
        resolveDataElementOptions(e, t) {
          const n = this.getParsed(e);
          let r = super.resolveDataElementOptions(e, t);
          r.$shared && (r = Object.assign({}, r, { $shared: !1 }));
          const o = r.radius;
          return (
            "active" !== t && (r.radius = 0),
            (r.radius += v_(n && n._custom, o)),
            r
          );
        }
      }
      (YC.id = "bubble"),
        (YC.defaults = {
          datasetElementType: !1,
          dataElementType: "point",
          animations: {
            numbers: {
              type: "number",
              properties: ["x", "y", "borderWidth", "radius"],
            },
          },
        }),
        (YC.overrides = {
          scales: { x: { type: "linear" }, y: { type: "linear" } },
          plugins: {
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
              },
            },
          },
        });
      class JC extends ZC {
        constructor(e, t) {
          super(e, t),
            (this.enableOptionSharing = !0),
            (this.innerRadius = void 0),
            (this.outerRadius = void 0),
            (this.offsetX = void 0),
            (this.offsetY = void 0);
        }
        linkScales() {}
        parse(e, t) {
          const n = this.getDataset().data,
            r = this._cachedMeta;
          if (!1 === this._parsing) r._parsed = n;
          else {
            let o,
              a,
              i = (e) => +n[e];
            if (h_(n[e])) {
              const { key: e = "value" } = this._parsing;
              i = (t) => +T_(n[t], e);
            }
            for (o = e, a = e + t; o < a; ++o) r._parsed[o] = i(o);
          }
        }
        _getRotation() {
          return G_(this.options.rotation - 90);
        }
        _getCircumference() {
          return G_(this.options.circumference);
        }
        _getRotationExtents() {
          let e = N_,
            t = -N_;
          for (let n = 0; n < this.chart.data.datasets.length; ++n)
            if (this.chart.isDatasetVisible(n)) {
              const r = this.chart.getDatasetMeta(n).controller,
                o = r._getRotation(),
                a = r._getCircumference();
              (e = Math.min(e, o)), (t = Math.max(t, o + a));
            }
          return { rotation: e, circumference: t - e };
        }
        update(e) {
          const t = this.chart,
            { chartArea: n } = t,
            r = this._cachedMeta,
            o = r.data,
            a =
              this.getMaxBorderWidth() +
              this.getMaxOffset(o) +
              this.options.spacing,
            i = Math.max((Math.min(n.width, n.height) - a) / 2, 0),
            s = Math.min(
              ((c = i),
              "string" == typeof (l = this.options.cutout) && l.endsWith("%")
                ? parseFloat(l) / 100
                : l / c),
              1
            );
          var l, c;
          const u = this._getRingWeight(this.index),
            { circumference: d, rotation: p } = this._getRotationExtents(),
            {
              ratioX: m,
              ratioY: h,
              offsetX: f,
              offsetY: g,
            } = (function (e, t, n) {
              let r = 1,
                o = 1,
                a = 0,
                i = 0;
              if (t < N_) {
                const s = e,
                  l = s + t,
                  c = Math.cos(s),
                  u = Math.sin(s),
                  d = Math.cos(l),
                  p = Math.sin(l),
                  m = (e, t, r) =>
                    ty(e, s, l, !0) ? 1 : Math.max(t, t * n, r, r * n),
                  h = (e, t, r) =>
                    ty(e, s, l, !0) ? -1 : Math.min(t, t * n, r, r * n),
                  f = m(0, c, d),
                  g = m(B_, u, p),
                  v = h(R_, c, d),
                  b = h(R_ + B_, u, p);
                (r = (f - v) / 2),
                  (o = (g - b) / 2),
                  (a = -(f + v) / 2),
                  (i = -(g + b) / 2);
              }
              return { ratioX: r, ratioY: o, offsetX: a, offsetY: i };
            })(p, d, s),
            v = (n.width - a) / m,
            b = (n.height - a) / h,
            _ = Math.max(Math.min(v, b) / 2, 0),
            y = b_(this.options.radius, _),
            x = (y - Math.max(y * s, 0)) / this._getVisibleDatasetWeightTotal();
          (this.offsetX = f * y),
            (this.offsetY = g * y),
            (r.total = this.calculateTotal()),
            (this.outerRadius = y - x * this._getRingWeightOffset(this.index)),
            (this.innerRadius = Math.max(this.outerRadius - x * u, 0)),
            this.updateElements(o, 0, o.length, e);
        }
        _circumference(e, t) {
          const n = this.options,
            r = this._cachedMeta,
            o = this._getCircumference();
          return (t && n.animation.animateRotate) ||
            !this.chart.getDataVisibility(e) ||
            null === r._parsed[e] ||
            r.data[e].hidden
            ? 0
            : this.calculateCircumference((r._parsed[e] * o) / N_);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            a = this.chart,
            i = a.chartArea,
            s = a.options.animation,
            l = (i.left + i.right) / 2,
            c = (i.top + i.bottom) / 2,
            u = o && s.animateScale,
            d = u ? 0 : this.innerRadius,
            p = u ? 0 : this.outerRadius,
            { sharedOptions: m, includeOptions: h } = this._getSharedOptions(
              t,
              r
            );
          let f,
            g = this._getRotation();
          for (f = 0; f < t; ++f) g += this._circumference(f, o);
          for (f = t; f < t + n; ++f) {
            const t = this._circumference(f, o),
              n = e[f],
              a = {
                x: l + this.offsetX,
                y: c + this.offsetY,
                startAngle: g,
                endAngle: g + t,
                circumference: t,
                outerRadius: p,
                innerRadius: d,
              };
            h &&
              (a.options =
                m ||
                this.resolveDataElementOptions(f, n.active ? "active" : r)),
              (g += t),
              this.updateElement(n, f, a, r);
          }
        }
        calculateTotal() {
          const e = this._cachedMeta,
            t = e.data;
          let n,
            r = 0;
          for (n = 0; n < t.length; n++) {
            const o = e._parsed[n];
            null === o ||
              isNaN(o) ||
              !this.chart.getDataVisibility(n) ||
              t[n].hidden ||
              (r += Math.abs(o));
          }
          return r;
        }
        calculateCircumference(e) {
          const t = this._cachedMeta.total;
          return t > 0 && !isNaN(e) ? N_ * (Math.abs(e) / t) : 0;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            n = this.chart,
            r = n.data.labels || [],
            o = pC(t._parsed[e], n.options.locale);
          return { label: r[e] || "", value: o };
        }
        getMaxBorderWidth(e) {
          let t = 0;
          const n = this.chart;
          let r, o, a, i, s;
          if (!e)
            for (r = 0, o = n.data.datasets.length; r < o; ++r)
              if (n.isDatasetVisible(r)) {
                (a = n.getDatasetMeta(r)), (e = a.data), (i = a.controller);
                break;
              }
          if (!e) return 0;
          for (r = 0, o = e.length; r < o; ++r)
            (s = i.resolveDataElementOptions(r)),
              "inner" !== s.borderAlign &&
                (t = Math.max(t, s.borderWidth || 0, s.hoverBorderWidth || 0));
          return t;
        }
        getMaxOffset(e) {
          let t = 0;
          for (let n = 0, r = e.length; n < r; ++n) {
            const e = this.resolveDataElementOptions(n);
            t = Math.max(t, e.offset || 0, e.hoverOffset || 0);
          }
          return t;
        }
        _getRingWeightOffset(e) {
          let t = 0;
          for (let n = 0; n < e; ++n)
            this.chart.isDatasetVisible(n) && (t += this._getRingWeight(n));
          return t;
        }
        _getRingWeight(e) {
          return Math.max(v_(this.chart.data.datasets[e].weight, 1), 0);
        }
        _getVisibleDatasetWeightTotal() {
          return (
            this._getRingWeightOffset(this.chart.data.datasets.length) || 1
          );
        }
      }
      (JC.id = "doughnut"),
        (JC.defaults = {
          datasetElementType: !1,
          dataElementType: "arc",
          animation: { animateRotate: !0, animateScale: !1 },
          animations: {
            numbers: {
              type: "number",
              properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing",
              ],
            },
          },
          cutout: "50%",
          rotation: 0,
          circumference: 360,
          radius: "100%",
          spacing: 0,
          indexAxis: "r",
        }),
        (JC.descriptors = {
          _scriptable: (e) => "spacing" !== e,
          _indexable: (e) => "spacing" !== e,
        }),
        (JC.overrides = {
          aspectRatio: 1,
          plugins: {
            legend: {
              labels: {
                generateLabels(e) {
                  const t = e.data;
                  if (t.labels.length && t.datasets.length) {
                    const {
                      labels: { pointStyle: n },
                    } = e.legend.options;
                    return t.labels.map((t, r) => {
                      const o = e.getDatasetMeta(0).controller.getStyle(r);
                      return {
                        text: t,
                        fillStyle: o.backgroundColor,
                        strokeStyle: o.borderColor,
                        lineWidth: o.borderWidth,
                        pointStyle: n,
                        hidden: !e.getDataVisibility(r),
                        index: r,
                      };
                    });
                  }
                  return [];
                },
              },
              onClick(e, t, n) {
                n.chart.toggleDataVisibility(t.index), n.chart.update();
              },
            },
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
                label(e) {
                  let t = e.label;
                  const n = ": " + e.formattedValue;
                  return m_(t) ? ((t = t.slice()), (t[0] += n)) : (t += n), t;
                },
              },
            },
          },
        });
      class QC extends ZC {
        initialize() {
          (this.enableOptionSharing = !0),
            (this.supportsDecimation = !0),
            super.initialize();
        }
        update(e) {
          const t = this._cachedMeta,
            { dataset: n, data: r = [], _dataset: o } = t,
            a = this.chart._animationsDisabled;
          let { start: i, count: s } = hy(t, r, a);
          (this._drawStart = i),
            (this._drawCount = s),
            fy(t) && ((i = 0), (s = r.length)),
            (n._chart = this.chart),
            (n._datasetIndex = this.index),
            (n._decimated = !!o._decimated),
            (n.points = r);
          const l = this.resolveDatasetElementOptions(e);
          this.options.showLine || (l.borderWidth = 0),
            (l.segment = this.options.segment),
            this.updateElement(n, void 0, { animated: !a, options: l }, e),
            this.updateElements(r, i, s, e);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            {
              iScale: a,
              vScale: i,
              _stacked: s,
              _dataset: l,
            } = this._cachedMeta,
            { sharedOptions: c, includeOptions: u } = this._getSharedOptions(
              t,
              r
            ),
            d = a.axis,
            p = i.axis,
            { spanGaps: m, segment: h } = this.options,
            f = $_(m) ? m : Number.POSITIVE_INFINITY,
            g = this.chart._animationsDisabled || o || "none" === r;
          let v = t > 0 && this.getParsed(t - 1);
          for (let m = t; m < t + n; ++m) {
            const t = e[m],
              n = this.getParsed(m),
              b = g ? t : {},
              _ = p_(n[p]),
              y = (b[d] = a.getPixelForValue(n[d], m)),
              x = (b[p] =
                o || _
                  ? i.getBasePixel()
                  : i.getPixelForValue(s ? this.applyStack(i, n, s) : n[p], m));
            (b.skip = isNaN(y) || isNaN(x) || _),
              (b.stop = m > 0 && Math.abs(n[d] - v[d]) > f),
              h && ((b.parsed = n), (b.raw = l.data[m])),
              u &&
                (b.options =
                  c ||
                  this.resolveDataElementOptions(m, t.active ? "active" : r)),
              g || this.updateElement(t, m, b, r),
              (v = n);
          }
        }
        getMaxOverflow() {
          const e = this._cachedMeta,
            t = e.dataset,
            n = (t.options && t.options.borderWidth) || 0,
            r = e.data || [];
          if (!r.length) return n;
          const o = r[0].size(this.resolveDataElementOptions(0)),
            a = r[r.length - 1].size(
              this.resolveDataElementOptions(r.length - 1)
            );
          return Math.max(n, o, a) / 2;
        }
        draw() {
          const e = this._cachedMeta;
          e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis),
            super.draw();
        }
      }
      (QC.id = "line"),
        (QC.defaults = {
          datasetElementType: "line",
          dataElementType: "point",
          showLine: !0,
          spanGaps: !1,
        }),
        (QC.overrides = {
          scales: {
            _index_: { type: "category" },
            _value_: { type: "linear" },
          },
        });
      class XC extends ZC {
        constructor(e, t) {
          super(e, t), (this.innerRadius = void 0), (this.outerRadius = void 0);
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            n = this.chart,
            r = n.data.labels || [],
            o = pC(t._parsed[e].r, n.options.locale);
          return { label: r[e] || "", value: o };
        }
        parseObjectData(e, t, n, r) {
          return Vx.bind(this)(e, t, n, r);
        }
        update(e) {
          const t = this._cachedMeta.data;
          this._updateRadius(), this.updateElements(t, 0, t.length, e);
        }
        getMinMax() {
          const e = this._cachedMeta,
            t = {
              min: Number.POSITIVE_INFINITY,
              max: Number.NEGATIVE_INFINITY,
            };
          return (
            e.data.forEach((e, n) => {
              const r = this.getParsed(n).r;
              !isNaN(r) &&
                this.chart.getDataVisibility(n) &&
                (r < t.min && (t.min = r), r > t.max && (t.max = r));
            }),
            t
          );
        }
        _updateRadius() {
          const e = this.chart,
            t = e.chartArea,
            n = e.options,
            r = Math.min(t.right - t.left, t.bottom - t.top),
            o = Math.max(r / 2, 0),
            a =
              (o -
                Math.max(
                  n.cutoutPercentage ? (o / 100) * n.cutoutPercentage : 1,
                  0
                )) /
              e.getVisibleDatasetCount();
          (this.outerRadius = o - a * this.index),
            (this.innerRadius = this.outerRadius - a);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            a = this.chart,
            i = a.options.animation,
            s = this._cachedMeta.rScale,
            l = s.xCenter,
            c = s.yCenter,
            u = s.getIndexAngle(0) - 0.5 * R_;
          let d,
            p = u;
          const m = 360 / this.countVisibleElements();
          for (d = 0; d < t; ++d) p += this._computeAngle(d, r, m);
          for (d = t; d < t + n; d++) {
            const t = e[d];
            let n = p,
              h = p + this._computeAngle(d, r, m),
              f = a.getDataVisibility(d)
                ? s.getDistanceFromCenterForValue(this.getParsed(d).r)
                : 0;
            (p = h),
              o && (i.animateScale && (f = 0), i.animateRotate && (n = h = u));
            const g = {
              x: l,
              y: c,
              innerRadius: 0,
              outerRadius: f,
              startAngle: n,
              endAngle: h,
              options: this.resolveDataElementOptions(
                d,
                t.active ? "active" : r
              ),
            };
            this.updateElement(t, d, g, r);
          }
        }
        countVisibleElements() {
          const e = this._cachedMeta;
          let t = 0;
          return (
            e.data.forEach((e, n) => {
              !isNaN(this.getParsed(n).r) &&
                this.chart.getDataVisibility(n) &&
                t++;
            }),
            t
          );
        }
        _computeAngle(e, t, n) {
          return this.chart.getDataVisibility(e)
            ? G_(this.resolveDataElementOptions(e, t).angle || n)
            : 0;
        }
      }
      (XC.id = "polarArea"),
        (XC.defaults = {
          dataElementType: "arc",
          animation: { animateRotate: !0, animateScale: !0 },
          animations: {
            numbers: {
              type: "number",
              properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
              ],
            },
          },
          indexAxis: "r",
          startAngle: 0,
        }),
        (XC.overrides = {
          aspectRatio: 1,
          plugins: {
            legend: {
              labels: {
                generateLabels(e) {
                  const t = e.data;
                  if (t.labels.length && t.datasets.length) {
                    const {
                      labels: { pointStyle: n },
                    } = e.legend.options;
                    return t.labels.map((t, r) => {
                      const o = e.getDatasetMeta(0).controller.getStyle(r);
                      return {
                        text: t,
                        fillStyle: o.backgroundColor,
                        strokeStyle: o.borderColor,
                        lineWidth: o.borderWidth,
                        pointStyle: n,
                        hidden: !e.getDataVisibility(r),
                        index: r,
                      };
                    });
                  }
                  return [];
                },
              },
              onClick(e, t, n) {
                n.chart.toggleDataVisibility(t.index), n.chart.update();
              },
            },
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
                label(e) {
                  return (
                    e.chart.data.labels[e.dataIndex] + ": " + e.formattedValue
                  );
                },
              },
            },
          },
          scales: {
            r: {
              type: "radialLinear",
              angleLines: { display: !1 },
              beginAtZero: !0,
              grid: { circular: !0 },
              pointLabels: { display: !1 },
              startAngle: 0,
            },
          },
        });
      class eS extends JC {}
      (eS.id = "pie"),
        (eS.defaults = {
          cutout: 0,
          rotation: 0,
          circumference: 360,
          radius: "100%",
        });
      class tS extends ZC {
        getLabelAndValue(e) {
          const t = this._cachedMeta.vScale,
            n = this.getParsed(e);
          return {
            label: t.getLabels()[e],
            value: "" + t.getLabelForValue(n[t.axis]),
          };
        }
        parseObjectData(e, t, n, r) {
          return Vx.bind(this)(e, t, n, r);
        }
        update(e) {
          const t = this._cachedMeta,
            n = t.dataset,
            r = t.data || [],
            o = t.iScale.getLabels();
          if (((n.points = r), "resize" !== e)) {
            const t = this.resolveDatasetElementOptions(e);
            this.options.showLine || (t.borderWidth = 0);
            const a = {
              _loop: !0,
              _fullLoop: o.length === r.length,
              options: t,
            };
            this.updateElement(n, void 0, a, e);
          }
          this.updateElements(r, 0, r.length, e);
        }
        updateElements(e, t, n, r) {
          const o = this._cachedMeta.rScale,
            a = "reset" === r;
          for (let i = t; i < t + n; i++) {
            const t = e[i],
              n = this.resolveDataElementOptions(i, t.active ? "active" : r),
              s = o.getPointPositionForValue(i, this.getParsed(i).r),
              l = a ? o.xCenter : s.x,
              c = a ? o.yCenter : s.y,
              u = {
                x: l,
                y: c,
                angle: s.angle,
                skip: isNaN(l) || isNaN(c),
                options: n,
              };
            this.updateElement(t, i, u, r);
          }
        }
      }
      (tS.id = "radar"),
        (tS.defaults = {
          datasetElementType: "line",
          dataElementType: "point",
          indexAxis: "r",
          showLine: !0,
          elements: { line: { fill: "start" } },
        }),
        (tS.overrides = {
          aspectRatio: 1,
          scales: { r: { type: "radialLinear" } },
        });
      class nS {
        constructor() {
          (this.x = void 0),
            (this.y = void 0),
            (this.active = !1),
            (this.options = void 0),
            (this.$animations = void 0);
        }
        tooltipPosition(e) {
          const { x: t, y: n } = this.getProps(["x", "y"], e);
          return { x: t, y: n };
        }
        hasValue() {
          return $_(this.x) && $_(this.y);
        }
        getProps(e, t) {
          const n = this.$animations;
          if (!t || !n) return this;
          const r = {};
          return (
            e.forEach((e) => {
              r[e] = n[e] && n[e].active() ? n[e]._to : this[e];
            }),
            r
          );
        }
      }
      (nS.defaults = {}), (nS.defaultRoutes = void 0);
      const rS = {
        values(e) {
          return m_(e) ? e : "" + e;
        },
        numeric(e, t, n) {
          if (0 === e) return "0";
          const r = this.chart.options.locale;
          let o,
            a = e;
          if (n.length > 1) {
            const t = Math.max(
              Math.abs(n[0].value),
              Math.abs(n[n.length - 1].value)
            );
            (t < 1e-4 || t > 1e15) && (o = "scientific"),
              (a = (function (e, t) {
                let n =
                  t.length > 3
                    ? t[2].value - t[1].value
                    : t[1].value - t[0].value;
                return (
                  Math.abs(n) >= 1 &&
                    e !== Math.floor(e) &&
                    (n = e - Math.floor(e)),
                  n
                );
              })(e, n));
          }
          const i = H_(Math.abs(a)),
            s = Math.max(Math.min(-1 * Math.floor(i), 20), 0),
            l = {
              notation: o,
              minimumFractionDigits: s,
              maximumFractionDigits: s,
            };
          return Object.assign(l, this.options.ticks.format), pC(e, r, l);
        },
        logarithmic(e, t, n) {
          if (0 === e) return "0";
          const r = e / Math.pow(10, Math.floor(H_(e)));
          return 1 === r || 2 === r || 5 === r
            ? rS.numeric.call(this, e, t, n)
            : "";
        },
      };
      var oS = { formatters: rS };
      function aS(e, t, n, r, o) {
        const a = v_(r, 0),
          i = Math.min(v_(o, e.length), e.length);
        let s,
          l,
          c,
          u = 0;
        for (
          n = Math.ceil(n),
            o && ((s = o - r), (n = s / Math.floor(s / n))),
            c = a;
          c < 0;

        )
          u++, (c = Math.round(a + u * n));
        for (l = Math.max(a, 0); l < i; l++)
          l === c && (t.push(e[l]), u++, (c = Math.round(a + u * n)));
      }
      ox.set("scale", {
        display: !0,
        offset: !1,
        reverse: !1,
        beginAtZero: !1,
        bounds: "ticks",
        grace: 0,
        grid: {
          display: !0,
          lineWidth: 1,
          drawBorder: !0,
          drawOnChartArea: !0,
          drawTicks: !0,
          tickLength: 8,
          tickWidth: (e, t) => t.lineWidth,
          tickColor: (e, t) => t.color,
          offset: !1,
          borderDash: [],
          borderDashOffset: 0,
          borderWidth: 1,
        },
        title: { display: !1, text: "", padding: { top: 4, bottom: 4 } },
        ticks: {
          minRotation: 0,
          maxRotation: 50,
          mirror: !1,
          textStrokeWidth: 0,
          textStrokeColor: "",
          padding: 3,
          display: !0,
          autoSkip: !0,
          autoSkipPadding: 3,
          labelOffset: 0,
          callback: oS.formatters.values,
          minor: {},
          major: {},
          align: "center",
          crossAlign: "near",
          showLabelBackdrop: !1,
          backdropColor: "rgba(255, 255, 255, 0.75)",
          backdropPadding: 2,
        },
      }),
        ox.route("scale.ticks", "color", "", "color"),
        ox.route("scale.grid", "color", "", "borderColor"),
        ox.route("scale.grid", "borderColor", "", "borderColor"),
        ox.route("scale.title", "color", "", "color"),
        ox.describe("scale", {
          _fallback: !1,
          _scriptable: (e) =>
            !e.startsWith("before") &&
            !e.startsWith("after") &&
            "callback" !== e &&
            "parser" !== e,
          _indexable: (e) => "borderDash" !== e && "tickBorderDash" !== e,
        }),
        ox.describe("scales", { _fallback: "scale" }),
        ox.describe("scale.ticks", {
          _scriptable: (e) => "backdropPadding" !== e && "callback" !== e,
          _indexable: (e) => "backdropPadding" !== e,
        });
      const iS = (e) => ("left" === e ? "right" : "right" === e ? "left" : e),
        sS = (e, t, n) => ("top" === t || "left" === t ? e[t] + n : e[t] - n);
      function lS(e, t) {
        const n = [],
          r = e.length / t,
          o = e.length;
        let a = 0;
        for (; a < o; a += r) n.push(e[Math.floor(a)]);
        return n;
      }
      function cS(e, t, n) {
        const r = e.ticks.length,
          o = Math.min(t, r - 1),
          a = e._startPixel,
          i = e._endPixel,
          s = 1e-6;
        let l,
          c = e.getPixelForTick(o);
        if (
          !(
            n &&
            ((l =
              1 === r
                ? Math.max(c - a, i - c)
                : 0 === t
                ? (e.getPixelForTick(1) - c) / 2
                : (c - e.getPixelForTick(o - 1)) / 2),
            (c += o < t ? l : -l),
            c < a - s || c > i + s)
          )
        )
          return c;
      }
      function uS(e) {
        return e.drawTicks ? e.tickLength : 0;
      }
      function dS(e, t) {
        if (!e.display) return 0;
        const n = Ox(e.font, t),
          r = Px(e.padding);
        return (m_(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
      }
      function pS(e, t, n) {
        let r = py(e);
        return (
          ((n && "right" !== t) || (!n && "right" === t)) && (r = iS(r)), r
        );
      }
      class mS extends nS {
        constructor(e) {
          super(),
            (this.id = e.id),
            (this.type = e.type),
            (this.options = void 0),
            (this.ctx = e.ctx),
            (this.chart = e.chart),
            (this.top = void 0),
            (this.bottom = void 0),
            (this.left = void 0),
            (this.right = void 0),
            (this.width = void 0),
            (this.height = void 0),
            (this._margins = { left: 0, right: 0, top: 0, bottom: 0 }),
            (this.maxWidth = void 0),
            (this.maxHeight = void 0),
            (this.paddingTop = void 0),
            (this.paddingBottom = void 0),
            (this.paddingLeft = void 0),
            (this.paddingRight = void 0),
            (this.axis = void 0),
            (this.labelRotation = void 0),
            (this.min = void 0),
            (this.max = void 0),
            (this._range = void 0),
            (this.ticks = []),
            (this._gridLineItems = null),
            (this._labelItems = null),
            (this._labelSizes = null),
            (this._length = 0),
            (this._maxLength = 0),
            (this._longestTextCache = {}),
            (this._startPixel = void 0),
            (this._endPixel = void 0),
            (this._reversePixels = !1),
            (this._userMax = void 0),
            (this._userMin = void 0),
            (this._suggestedMax = void 0),
            (this._suggestedMin = void 0),
            (this._ticksLength = 0),
            (this._borderValue = 0),
            (this._cache = {}),
            (this._dataLimitsCached = !1),
            (this.$context = void 0);
        }
        init(e) {
          (this.options = e.setContext(this.getContext())),
            (this.axis = e.axis),
            (this._userMin = this.parse(e.min)),
            (this._userMax = this.parse(e.max)),
            (this._suggestedMin = this.parse(e.suggestedMin)),
            (this._suggestedMax = this.parse(e.suggestedMax));
        }
        parse(e, t) {
          return e;
        }
        getUserBounds() {
          let {
            _userMin: e,
            _userMax: t,
            _suggestedMin: n,
            _suggestedMax: r,
          } = this;
          return (
            (e = g_(e, Number.POSITIVE_INFINITY)),
            (t = g_(t, Number.NEGATIVE_INFINITY)),
            (n = g_(n, Number.POSITIVE_INFINITY)),
            (r = g_(r, Number.NEGATIVE_INFINITY)),
            {
              min: g_(e, n),
              max: g_(t, r),
              minDefined: f_(e),
              maxDefined: f_(t),
            }
          );
        }
        getMinMax(e) {
          let t,
            {
              min: n,
              max: r,
              minDefined: o,
              maxDefined: a,
            } = this.getUserBounds();
          if (o && a) return { min: n, max: r };
          const i = this.getMatchingVisibleMetas();
          for (let s = 0, l = i.length; s < l; ++s)
            (t = i[s].controller.getMinMax(this, e)),
              o || (n = Math.min(n, t.min)),
              a || (r = Math.max(r, t.max));
          return (
            (n = a && n > r ? r : n),
            (r = o && n > r ? n : r),
            { min: g_(n, g_(r, n)), max: g_(r, g_(n, r)) }
          );
        }
        getPadding() {
          return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0,
          };
        }
        getTicks() {
          return this.ticks;
        }
        getLabels() {
          const e = this.chart.data;
          return (
            this.options.labels ||
            (this.isHorizontal() ? e.xLabels : e.yLabels) ||
            e.labels ||
            []
          );
        }
        beforeLayout() {
          (this._cache = {}), (this._dataLimitsCached = !1);
        }
        beforeUpdate() {
          __(this.options.beforeUpdate, [this]);
        }
        update(e, t, n) {
          const { beginAtZero: r, grace: o, ticks: a } = this.options,
            i = a.sampleSize;
          this.beforeUpdate(),
            (this.maxWidth = e),
            (this.maxHeight = t),
            (this._margins = n =
              Object.assign({ left: 0, right: 0, top: 0, bottom: 0 }, n)),
            (this.ticks = null),
            (this._labelSizes = null),
            (this._gridLineItems = null),
            (this._labelItems = null),
            this.beforeSetDimensions(),
            this.setDimensions(),
            this.afterSetDimensions(),
            (this._maxLength = this.isHorizontal()
              ? this.width + n.left + n.right
              : this.height + n.top + n.bottom),
            this._dataLimitsCached ||
              (this.beforeDataLimits(),
              this.determineDataLimits(),
              this.afterDataLimits(),
              (this._range = (function (e, t, n) {
                const { min: r, max: o } = e,
                  a = b_(t, (o - r) / 2),
                  i = (e, t) => (n && 0 === e ? 0 : e + t);
                return { min: i(r, -Math.abs(a)), max: i(o, a) };
              })(this, o, r)),
              (this._dataLimitsCached = !0)),
            this.beforeBuildTicks(),
            (this.ticks = this.buildTicks() || []),
            this.afterBuildTicks();
          const s = i < this.ticks.length;
          this._convertTicksToLabels(s ? lS(this.ticks, i) : this.ticks),
            this.configure(),
            this.beforeCalculateLabelRotation(),
            this.calculateLabelRotation(),
            this.afterCalculateLabelRotation(),
            a.display &&
              (a.autoSkip || "auto" === a.source) &&
              ((this.ticks = (function (e, t) {
                const n = e.options.ticks,
                  r =
                    n.maxTicksLimit ||
                    (function (e) {
                      const t = e.options.offset,
                        n = e._tickSize(),
                        r = e._length / n + (t ? 0 : 1),
                        o = e._maxLength / n;
                      return Math.floor(Math.min(r, o));
                    })(e),
                  o = n.major.enabled
                    ? (function (e) {
                        const t = [];
                        let n, r;
                        for (n = 0, r = e.length; n < r; n++)
                          e[n].major && t.push(n);
                        return t;
                      })(t)
                    : [],
                  a = o.length,
                  i = o[0],
                  s = o[a - 1],
                  l = [];
                if (a > r)
                  return (
                    (function (e, t, n, r) {
                      let o,
                        a = 0,
                        i = n[0];
                      for (r = Math.ceil(r), o = 0; o < e.length; o++)
                        o === i && (t.push(e[o]), a++, (i = n[a * r]));
                    })(t, l, o, a / r),
                    l
                  );
                const c = (function (e, t, n) {
                  const r = (function (e) {
                      const t = e.length;
                      let n, r;
                      if (t < 2) return !1;
                      for (r = e[0], n = 1; n < t; ++n)
                        if (e[n] - e[n - 1] !== r) return !1;
                      return r;
                    })(e),
                    o = t.length / n;
                  if (!r) return Math.max(o, 1);
                  const a = (function (e) {
                    const t = [],
                      n = Math.sqrt(e);
                    let r;
                    for (r = 1; r < n; r++)
                      e % r == 0 && (t.push(r), t.push(e / r));
                    return (
                      n === (0 | n) && t.push(n),
                      t.sort((e, t) => e - t).pop(),
                      t
                    );
                  })(r);
                  for (let e = 0, t = a.length - 1; e < t; e++) {
                    const t = a[e];
                    if (t > o) return t;
                  }
                  return Math.max(o, 1);
                })(o, t, r);
                if (a > 0) {
                  let e, n;
                  const r = a > 1 ? Math.round((s - i) / (a - 1)) : null;
                  for (
                    aS(t, l, c, p_(r) ? 0 : i - r, i), e = 0, n = a - 1;
                    e < n;
                    e++
                  )
                    aS(t, l, c, o[e], o[e + 1]);
                  return aS(t, l, c, s, p_(r) ? t.length : s + r), l;
                }
                return aS(t, l, c), l;
              })(this, this.ticks)),
              (this._labelSizes = null),
              this.afterAutoSkip()),
            s && this._convertTicksToLabels(this.ticks),
            this.beforeFit(),
            this.fit(),
            this.afterFit(),
            this.afterUpdate();
        }
        configure() {
          let e,
            t,
            n = this.options.reverse;
          this.isHorizontal()
            ? ((e = this.left), (t = this.right))
            : ((e = this.top), (t = this.bottom), (n = !n)),
            (this._startPixel = e),
            (this._endPixel = t),
            (this._reversePixels = n),
            (this._length = t - e),
            (this._alignToPixels = this.options.alignToPixels);
        }
        afterUpdate() {
          __(this.options.afterUpdate, [this]);
        }
        beforeSetDimensions() {
          __(this.options.beforeSetDimensions, [this]);
        }
        setDimensions() {
          this.isHorizontal()
            ? ((this.width = this.maxWidth),
              (this.left = 0),
              (this.right = this.width))
            : ((this.height = this.maxHeight),
              (this.top = 0),
              (this.bottom = this.height)),
            (this.paddingLeft = 0),
            (this.paddingTop = 0),
            (this.paddingRight = 0),
            (this.paddingBottom = 0);
        }
        afterSetDimensions() {
          __(this.options.afterSetDimensions, [this]);
        }
        _callHooks(e) {
          this.chart.notifyPlugins(e, this.getContext()),
            __(this.options[e], [this]);
        }
        beforeDataLimits() {
          this._callHooks("beforeDataLimits");
        }
        determineDataLimits() {}
        afterDataLimits() {
          this._callHooks("afterDataLimits");
        }
        beforeBuildTicks() {
          this._callHooks("beforeBuildTicks");
        }
        buildTicks() {
          return [];
        }
        afterBuildTicks() {
          this._callHooks("afterBuildTicks");
        }
        beforeTickToLabelConversion() {
          __(this.options.beforeTickToLabelConversion, [this]);
        }
        generateTickLabels(e) {
          const t = this.options.ticks;
          let n, r, o;
          for (n = 0, r = e.length; n < r; n++)
            (o = e[n]), (o.label = __(t.callback, [o.value, n, e], this));
        }
        afterTickToLabelConversion() {
          __(this.options.afterTickToLabelConversion, [this]);
        }
        beforeCalculateLabelRotation() {
          __(this.options.beforeCalculateLabelRotation, [this]);
        }
        calculateLabelRotation() {
          const e = this.options,
            t = e.ticks,
            n = this.ticks.length,
            r = t.minRotation || 0,
            o = t.maxRotation;
          let a,
            i,
            s,
            l = r;
          if (
            !this._isVisible() ||
            !t.display ||
            r >= o ||
            n <= 1 ||
            !this.isHorizontal()
          )
            return void (this.labelRotation = r);
          const c = this._getLabelSizes(),
            u = c.widest.width,
            d = c.highest.height,
            p = ny(this.chart.width - u, 0, this.maxWidth);
          (a = e.offset ? this.maxWidth / n : p / (n - 1)),
            u + 6 > a &&
              ((a = p / (n - (e.offset ? 0.5 : 1))),
              (i =
                this.maxHeight -
                uS(e.grid) -
                t.padding -
                dS(e.title, this.chart.options.font)),
              (s = Math.sqrt(u * u + d * d)),
              (l = q_(
                Math.min(
                  Math.asin(ny((c.highest.height + 6) / a, -1, 1)),
                  Math.asin(ny(i / s, -1, 1)) - Math.asin(ny(d / s, -1, 1))
                )
              )),
              (l = Math.max(r, Math.min(o, l)))),
            (this.labelRotation = l);
        }
        afterCalculateLabelRotation() {
          __(this.options.afterCalculateLabelRotation, [this]);
        }
        afterAutoSkip() {}
        beforeFit() {
          __(this.options.beforeFit, [this]);
        }
        fit() {
          const e = { width: 0, height: 0 },
            {
              chart: t,
              options: { ticks: n, title: r, grid: o },
            } = this,
            a = this._isVisible(),
            i = this.isHorizontal();
          if (a) {
            const a = dS(r, t.options.font);
            if (
              (i
                ? ((e.width = this.maxWidth), (e.height = uS(o) + a))
                : ((e.height = this.maxHeight), (e.width = uS(o) + a)),
              n.display && this.ticks.length)
            ) {
              const {
                  first: t,
                  last: r,
                  widest: o,
                  highest: a,
                } = this._getLabelSizes(),
                s = 2 * n.padding,
                l = G_(this.labelRotation),
                c = Math.cos(l),
                u = Math.sin(l);
              if (i) {
                const t = n.mirror ? 0 : u * o.width + c * a.height;
                e.height = Math.min(this.maxHeight, e.height + t + s);
              } else {
                const t = n.mirror ? 0 : c * o.width + u * a.height;
                e.width = Math.min(this.maxWidth, e.width + t + s);
              }
              this._calculatePadding(t, r, u, c);
            }
          }
          this._handleMargins(),
            i
              ? ((this.width = this._length =
                  t.width - this._margins.left - this._margins.right),
                (this.height = e.height))
              : ((this.width = e.width),
                (this.height = this._length =
                  t.height - this._margins.top - this._margins.bottom));
        }
        _calculatePadding(e, t, n, r) {
          const {
              ticks: { align: o, padding: a },
              position: i,
            } = this.options,
            s = 0 !== this.labelRotation,
            l = "top" !== i && "x" === this.axis;
          if (this.isHorizontal()) {
            const i = this.getPixelForTick(0) - this.left,
              c = this.right - this.getPixelForTick(this.ticks.length - 1);
            let u = 0,
              d = 0;
            s
              ? l
                ? ((u = r * e.width), (d = n * t.height))
                : ((u = n * e.height), (d = r * t.width))
              : "start" === o
              ? (d = t.width)
              : "end" === o
              ? (u = e.width)
              : "inner" !== o && ((u = e.width / 2), (d = t.width / 2)),
              (this.paddingLeft = Math.max(
                ((u - i + a) * this.width) / (this.width - i),
                0
              )),
              (this.paddingRight = Math.max(
                ((d - c + a) * this.width) / (this.width - c),
                0
              ));
          } else {
            let n = t.height / 2,
              r = e.height / 2;
            "start" === o
              ? ((n = 0), (r = e.height))
              : "end" === o && ((n = t.height), (r = 0)),
              (this.paddingTop = n + a),
              (this.paddingBottom = r + a);
          }
        }
        _handleMargins() {
          this._margins &&
            ((this._margins.left = Math.max(
              this.paddingLeft,
              this._margins.left
            )),
            (this._margins.top = Math.max(this.paddingTop, this._margins.top)),
            (this._margins.right = Math.max(
              this.paddingRight,
              this._margins.right
            )),
            (this._margins.bottom = Math.max(
              this.paddingBottom,
              this._margins.bottom
            )));
        }
        afterFit() {
          __(this.options.afterFit, [this]);
        }
        isHorizontal() {
          const { axis: e, position: t } = this.options;
          return "top" === t || "bottom" === t || "x" === e;
        }
        isFullSize() {
          return this.options.fullSize;
        }
        _convertTicksToLabels(e) {
          let t, n;
          for (
            this.beforeTickToLabelConversion(),
              this.generateTickLabels(e),
              t = 0,
              n = e.length;
            t < n;
            t++
          )
            p_(e[t].label) && (e.splice(t, 1), n--, t--);
          this.afterTickToLabelConversion();
        }
        _getLabelSizes() {
          let e = this._labelSizes;
          if (!e) {
            const t = this.options.ticks.sampleSize;
            let n = this.ticks;
            t < n.length && (n = lS(n, t)),
              (this._labelSizes = e = this._computeLabelSizes(n, n.length));
          }
          return e;
        }
        _computeLabelSizes(e, t) {
          const { ctx: n, _longestTextCache: r } = this,
            o = [],
            a = [];
          let i,
            s,
            l,
            c,
            u,
            d,
            p,
            m,
            h,
            f,
            g,
            v = 0,
            b = 0;
          for (i = 0; i < t; ++i) {
            if (
              ((c = e[i].label),
              (u = this._resolveTickFontOptions(i)),
              (n.font = d = u.string),
              (p = r[d] = r[d] || { data: {}, gc: [] }),
              (m = u.lineHeight),
              (h = f = 0),
              p_(c) || m_(c))
            ) {
              if (m_(c))
                for (s = 0, l = c.length; s < l; ++s)
                  (g = c[s]),
                    p_(g) ||
                      m_(g) ||
                      ((h = ax(n, p.data, p.gc, h, g)), (f += m));
            } else (h = ax(n, p.data, p.gc, h, c)), (f = m);
            o.push(h), a.push(f), (v = Math.max(h, v)), (b = Math.max(f, b));
          }
          !(function (e, t) {
            y_(e, (e) => {
              const n = e.gc,
                r = n.length / 2;
              let o;
              if (r > t) {
                for (o = 0; o < r; ++o) delete e.data[n[o]];
                n.splice(0, r);
              }
            });
          })(r, t);
          const _ = o.indexOf(v),
            y = a.indexOf(b),
            x = (e) => ({ width: o[e] || 0, height: a[e] || 0 });
          return {
            first: x(0),
            last: x(t - 1),
            widest: x(_),
            highest: x(y),
            widths: o,
            heights: a,
          };
        }
        getLabelForValue(e) {
          return e;
        }
        getPixelForValue(e, t) {
          return NaN;
        }
        getValueForPixel(e) {}
        getPixelForTick(e) {
          const t = this.ticks;
          return e < 0 || e > t.length - 1
            ? null
            : this.getPixelForValue(t[e].value);
        }
        getPixelForDecimal(e) {
          this._reversePixels && (e = 1 - e);
          const t = this._startPixel + e * this._length;
          return ny(
            this._alignToPixels ? sx(this.chart, t, 0) : t,
            -32768,
            32767
          );
        }
        getDecimalForPixel(e) {
          const t = (e - this._startPixel) / this._length;
          return this._reversePixels ? 1 - t : t;
        }
        getBasePixel() {
          return this.getPixelForValue(this.getBaseValue());
        }
        getBaseValue() {
          const { min: e, max: t } = this;
          return e < 0 && t < 0 ? t : e > 0 && t > 0 ? e : 0;
        }
        getContext(e) {
          const t = this.ticks || [];
          if (e >= 0 && e < t.length) {
            const n = t[e];
            return (
              n.$context ||
              (n.$context = (function (e, t, n) {
                return Tx(e, { tick: n, index: t, type: "tick" });
              })(this.getContext(), e, n))
            );
          }
          return (
            this.$context ||
            (this.$context = Tx(this.chart.getContext(), {
              scale: this,
              type: "scale",
            }))
          );
        }
        _tickSize() {
          const e = this.options.ticks,
            t = G_(this.labelRotation),
            n = Math.abs(Math.cos(t)),
            r = Math.abs(Math.sin(t)),
            o = this._getLabelSizes(),
            a = e.autoSkipPadding || 0,
            i = o ? o.widest.width + a : 0,
            s = o ? o.highest.height + a : 0;
          return this.isHorizontal()
            ? s * n > i * r
              ? i / n
              : s / r
            : s * r < i * n
            ? s / n
            : i / r;
        }
        _isVisible() {
          const e = this.options.display;
          return "auto" !== e ? !!e : this.getMatchingVisibleMetas().length > 0;
        }
        _computeGridLineItems(e) {
          const t = this.axis,
            n = this.chart,
            r = this.options,
            { grid: o, position: a } = r,
            i = o.offset,
            s = this.isHorizontal(),
            l = this.ticks.length + (i ? 1 : 0),
            c = uS(o),
            u = [],
            d = o.setContext(this.getContext()),
            p = d.drawBorder ? d.borderWidth : 0,
            m = p / 2,
            h = function (e) {
              return sx(n, e, p);
            };
          let f, g, v, b, _, y, x, C, S, k, w, P;
          if ("top" === a)
            (f = h(this.bottom)),
              (y = this.bottom - c),
              (C = f - m),
              (k = h(e.top) + m),
              (P = e.bottom);
          else if ("bottom" === a)
            (f = h(this.top)),
              (k = e.top),
              (P = h(e.bottom) - m),
              (y = f + m),
              (C = this.top + c);
          else if ("left" === a)
            (f = h(this.right)),
              (_ = this.right - c),
              (x = f - m),
              (S = h(e.left) + m),
              (w = e.right);
          else if ("right" === a)
            (f = h(this.left)),
              (S = e.left),
              (w = h(e.right) - m),
              (_ = f + m),
              (x = this.left + c);
          else if ("x" === t) {
            if ("center" === a) f = h((e.top + e.bottom) / 2 + 0.5);
            else if (h_(a)) {
              const e = Object.keys(a)[0],
                t = a[e];
              f = h(this.chart.scales[e].getPixelForValue(t));
            }
            (k = e.top), (P = e.bottom), (y = f + m), (C = y + c);
          } else if ("y" === t) {
            if ("center" === a) f = h((e.left + e.right) / 2);
            else if (h_(a)) {
              const e = Object.keys(a)[0],
                t = a[e];
              f = h(this.chart.scales[e].getPixelForValue(t));
            }
            (_ = f - m), (x = _ - c), (S = e.left), (w = e.right);
          }
          const O = v_(r.ticks.maxTicksLimit, l),
            I = Math.max(1, Math.ceil(l / O));
          for (g = 0; g < l; g += I) {
            const e = o.setContext(this.getContext(g)),
              t = e.lineWidth,
              r = e.color,
              a = e.borderDash || [],
              l = e.borderDashOffset,
              c = e.tickWidth,
              d = e.tickColor,
              p = e.tickBorderDash || [],
              m = e.tickBorderDashOffset;
            (v = cS(this, g, i)),
              void 0 !== v &&
                ((b = sx(n, v, t)),
                s ? (_ = x = S = w = b) : (y = C = k = P = b),
                u.push({
                  tx1: _,
                  ty1: y,
                  tx2: x,
                  ty2: C,
                  x1: S,
                  y1: k,
                  x2: w,
                  y2: P,
                  width: t,
                  color: r,
                  borderDash: a,
                  borderDashOffset: l,
                  tickWidth: c,
                  tickColor: d,
                  tickBorderDash: p,
                  tickBorderDashOffset: m,
                }));
          }
          return (this._ticksLength = l), (this._borderValue = f), u;
        }
        _computeLabelItems(e) {
          const t = this.axis,
            n = this.options,
            { position: r, ticks: o } = n,
            a = this.isHorizontal(),
            i = this.ticks,
            { align: s, crossAlign: l, padding: c, mirror: u } = o,
            d = uS(n.grid),
            p = d + c,
            m = u ? -c : p,
            h = -G_(this.labelRotation),
            f = [];
          let g,
            v,
            b,
            _,
            y,
            x,
            C,
            S,
            k,
            w,
            P,
            O,
            I = "middle";
          if ("top" === r)
            (x = this.bottom - m), (C = this._getXAxisLabelAlignment());
          else if ("bottom" === r)
            (x = this.top + m), (C = this._getXAxisLabelAlignment());
          else if ("left" === r) {
            const e = this._getYAxisLabelAlignment(d);
            (C = e.textAlign), (y = e.x);
          } else if ("right" === r) {
            const e = this._getYAxisLabelAlignment(d);
            (C = e.textAlign), (y = e.x);
          } else if ("x" === t) {
            if ("center" === r) x = (e.top + e.bottom) / 2 + p;
            else if (h_(r)) {
              const e = Object.keys(r)[0],
                t = r[e];
              x = this.chart.scales[e].getPixelForValue(t) + p;
            }
            C = this._getXAxisLabelAlignment();
          } else if ("y" === t) {
            if ("center" === r) y = (e.left + e.right) / 2 - p;
            else if (h_(r)) {
              const e = Object.keys(r)[0],
                t = r[e];
              y = this.chart.scales[e].getPixelForValue(t);
            }
            C = this._getYAxisLabelAlignment(d).textAlign;
          }
          "y" === t &&
            ("start" === s ? (I = "top") : "end" === s && (I = "bottom"));
          const T = this._getLabelSizes();
          for (g = 0, v = i.length; g < v; ++g) {
            (b = i[g]), (_ = b.label);
            const e = o.setContext(this.getContext(g));
            (S = this.getPixelForTick(g) + o.labelOffset),
              (k = this._resolveTickFontOptions(g)),
              (w = k.lineHeight),
              (P = m_(_) ? _.length : 1);
            const t = P / 2,
              n = e.color,
              s = e.textStrokeColor,
              c = e.textStrokeWidth;
            let d,
              p = C;
            if (
              (a
                ? ((y = S),
                  "inner" === C &&
                    (p =
                      g === v - 1
                        ? this.options.reverse
                          ? "left"
                          : "right"
                        : 0 === g
                        ? this.options.reverse
                          ? "right"
                          : "left"
                        : "center"),
                  (O =
                    "top" === r
                      ? "near" === l || 0 !== h
                        ? -P * w + w / 2
                        : "center" === l
                        ? -T.highest.height / 2 - t * w + w
                        : -T.highest.height + w / 2
                      : "near" === l || 0 !== h
                      ? w / 2
                      : "center" === l
                      ? T.highest.height / 2 - t * w
                      : T.highest.height - P * w),
                  u && (O *= -1))
                : ((x = S), (O = ((1 - P) * w) / 2)),
              e.showLabelBackdrop)
            ) {
              const t = Px(e.backdropPadding),
                n = T.heights[g],
                r = T.widths[g];
              let o = x + O - t.top,
                a = y - t.left;
              switch (I) {
                case "middle":
                  o -= n / 2;
                  break;
                case "bottom":
                  o -= n;
              }
              switch (C) {
                case "center":
                  a -= r / 2;
                  break;
                case "right":
                  a -= r;
              }
              d = {
                left: a,
                top: o,
                width: r + t.width,
                height: n + t.height,
                color: e.backdropColor,
              };
            }
            f.push({
              rotation: h,
              label: _,
              font: k,
              color: n,
              strokeColor: s,
              strokeWidth: c,
              textOffset: O,
              textAlign: p,
              textBaseline: I,
              translation: [y, x],
              backdrop: d,
            });
          }
          return f;
        }
        _getXAxisLabelAlignment() {
          const { position: e, ticks: t } = this.options;
          if (-G_(this.labelRotation)) return "top" === e ? "left" : "right";
          let n = "center";
          return (
            "start" === t.align
              ? (n = "left")
              : "end" === t.align
              ? (n = "right")
              : "inner" === t.align && (n = "inner"),
            n
          );
        }
        _getYAxisLabelAlignment(e) {
          const {
              position: t,
              ticks: { crossAlign: n, mirror: r, padding: o },
            } = this.options,
            a = e + o,
            i = this._getLabelSizes().widest.width;
          let s, l;
          return (
            "left" === t
              ? r
                ? ((l = this.right + o),
                  "near" === n
                    ? (s = "left")
                    : "center" === n
                    ? ((s = "center"), (l += i / 2))
                    : ((s = "right"), (l += i)))
                : ((l = this.right - a),
                  "near" === n
                    ? (s = "right")
                    : "center" === n
                    ? ((s = "center"), (l -= i / 2))
                    : ((s = "left"), (l = this.left)))
              : "right" === t
              ? r
                ? ((l = this.left + o),
                  "near" === n
                    ? (s = "right")
                    : "center" === n
                    ? ((s = "center"), (l -= i / 2))
                    : ((s = "left"), (l -= i)))
                : ((l = this.left + a),
                  "near" === n
                    ? (s = "left")
                    : "center" === n
                    ? ((s = "center"), (l += i / 2))
                    : ((s = "right"), (l = this.right)))
              : (s = "right"),
            { textAlign: s, x: l }
          );
        }
        _computeLabelArea() {
          if (this.options.ticks.mirror) return;
          const e = this.chart,
            t = this.options.position;
          return "left" === t || "right" === t
            ? { top: 0, left: this.left, bottom: e.height, right: this.right }
            : "top" === t || "bottom" === t
            ? { top: this.top, left: 0, bottom: this.bottom, right: e.width }
            : void 0;
        }
        drawBackground() {
          const {
            ctx: e,
            options: { backgroundColor: t },
            left: n,
            top: r,
            width: o,
            height: a,
          } = this;
          t &&
            (e.save(), (e.fillStyle = t), e.fillRect(n, r, o, a), e.restore());
        }
        getLineWidthForValue(e) {
          const t = this.options.grid;
          if (!this._isVisible() || !t.display) return 0;
          const n = this.ticks.findIndex((t) => t.value === e);
          return n >= 0 ? t.setContext(this.getContext(n)).lineWidth : 0;
        }
        drawGrid(e) {
          const t = this.options.grid,
            n = this.ctx,
            r =
              this._gridLineItems ||
              (this._gridLineItems = this._computeGridLineItems(e));
          let o, a;
          const i = (e, t, r) => {
            r.width &&
              r.color &&
              (n.save(),
              (n.lineWidth = r.width),
              (n.strokeStyle = r.color),
              n.setLineDash(r.borderDash || []),
              (n.lineDashOffset = r.borderDashOffset),
              n.beginPath(),
              n.moveTo(e.x, e.y),
              n.lineTo(t.x, t.y),
              n.stroke(),
              n.restore());
          };
          if (t.display)
            for (o = 0, a = r.length; o < a; ++o) {
              const e = r[o];
              t.drawOnChartArea &&
                i({ x: e.x1, y: e.y1 }, { x: e.x2, y: e.y2 }, e),
                t.drawTicks &&
                  i(
                    { x: e.tx1, y: e.ty1 },
                    { x: e.tx2, y: e.ty2 },
                    {
                      color: e.tickColor,
                      width: e.tickWidth,
                      borderDash: e.tickBorderDash,
                      borderDashOffset: e.tickBorderDashOffset,
                    }
                  );
            }
        }
        drawBorder() {
          const {
              chart: e,
              ctx: t,
              options: { grid: n },
            } = this,
            r = n.setContext(this.getContext()),
            o = n.drawBorder ? r.borderWidth : 0;
          if (!o) return;
          const a = n.setContext(this.getContext(0)).lineWidth,
            i = this._borderValue;
          let s, l, c, u;
          this.isHorizontal()
            ? ((s = sx(e, this.left, o) - o / 2),
              (l = sx(e, this.right, a) + a / 2),
              (c = u = i))
            : ((c = sx(e, this.top, o) - o / 2),
              (u = sx(e, this.bottom, a) + a / 2),
              (s = l = i)),
            t.save(),
            (t.lineWidth = r.borderWidth),
            (t.strokeStyle = r.borderColor),
            t.beginPath(),
            t.moveTo(s, c),
            t.lineTo(l, u),
            t.stroke(),
            t.restore();
        }
        drawLabels(e) {
          if (!this.options.ticks.display) return;
          const t = this.ctx,
            n = this._computeLabelArea();
          n && px(t, n);
          const r =
            this._labelItems || (this._labelItems = this._computeLabelItems(e));
          let o, a;
          for (o = 0, a = r.length; o < a; ++o) {
            const e = r[o],
              n = e.font,
              a = e.label;
            e.backdrop &&
              ((t.fillStyle = e.backdrop.color),
              t.fillRect(
                e.backdrop.left,
                e.backdrop.top,
                e.backdrop.width,
                e.backdrop.height
              )),
              gx(t, a, 0, e.textOffset, n, e);
          }
          n && mx(t);
        }
        drawTitle() {
          const {
            ctx: e,
            options: { position: t, title: n, reverse: r },
          } = this;
          if (!n.display) return;
          const o = Ox(n.font),
            a = Px(n.padding),
            i = n.align;
          let s = o.lineHeight / 2;
          "bottom" === t || "center" === t || h_(t)
            ? ((s += a.bottom),
              m_(n.text) && (s += o.lineHeight * (n.text.length - 1)))
            : (s += a.top);
          const {
            titleX: l,
            titleY: c,
            maxWidth: u,
            rotation: d,
          } = (function (e, t, n, r) {
            const { top: o, left: a, bottom: i, right: s, chart: l } = e,
              { chartArea: c, scales: u } = l;
            let d,
              p,
              m,
              h = 0;
            const f = i - o,
              g = s - a;
            if (e.isHorizontal()) {
              if (((p = my(r, a, s)), h_(n))) {
                const e = Object.keys(n)[0],
                  r = n[e];
                m = u[e].getPixelForValue(r) + f - t;
              } else
                m =
                  "center" === n ? (c.bottom + c.top) / 2 + f - t : sS(e, n, t);
              d = s - a;
            } else {
              if (h_(n)) {
                const e = Object.keys(n)[0],
                  r = n[e];
                p = u[e].getPixelForValue(r) - g + t;
              } else
                p =
                  "center" === n ? (c.left + c.right) / 2 - g + t : sS(e, n, t);
              (m = my(r, i, o)), (h = "left" === n ? -B_ : B_);
            }
            return { titleX: p, titleY: m, maxWidth: d, rotation: h };
          })(this, s, t, i);
          gx(e, n.text, 0, 0, o, {
            color: n.color,
            maxWidth: u,
            rotation: d,
            textAlign: pS(i, t, r),
            textBaseline: "middle",
            translation: [l, c],
          });
        }
        draw(e) {
          this._isVisible() &&
            (this.drawBackground(),
            this.drawGrid(e),
            this.drawBorder(),
            this.drawTitle(),
            this.drawLabels(e));
        }
        _layers() {
          const e = this.options,
            t = (e.ticks && e.ticks.z) || 0,
            n = v_(e.grid && e.grid.z, -1);
          return this._isVisible() && this.draw === mS.prototype.draw
            ? [
                {
                  z: n,
                  draw: (e) => {
                    this.drawBackground(), this.drawGrid(e), this.drawTitle();
                  },
                },
                {
                  z: n + 1,
                  draw: () => {
                    this.drawBorder();
                  },
                },
                {
                  z: t,
                  draw: (e) => {
                    this.drawLabels(e);
                  },
                },
              ]
            : [
                {
                  z: t,
                  draw: (e) => {
                    this.draw(e);
                  },
                },
              ];
        }
        getMatchingVisibleMetas(e) {
          const t = this.chart.getSortedVisibleDatasetMetas(),
            n = this.axis + "AxisID",
            r = [];
          let o, a;
          for (o = 0, a = t.length; o < a; ++o) {
            const a = t[o];
            a[n] !== this.id || (e && a.type !== e) || r.push(a);
          }
          return r;
        }
        _resolveTickFontOptions(e) {
          return Ox(this.options.ticks.setContext(this.getContext(e)).font);
        }
        _maxDigits() {
          const e = this._resolveTickFontOptions(0).lineHeight;
          return (this.isHorizontal() ? this.width : this.height) / e;
        }
      }
      class hS {
        constructor(e, t, n) {
          (this.type = e),
            (this.scope = t),
            (this.override = n),
            (this.items = Object.create(null));
        }
        isForType(e) {
          return Object.prototype.isPrototypeOf.call(
            this.type.prototype,
            e.prototype
          );
        }
        register(e) {
          const t = Object.getPrototypeOf(e);
          let n;
          (function (e) {
            return "id" in e && "defaults" in e;
          })(t) && (n = this.register(t));
          const r = this.items,
            o = e.id,
            a = this.scope + "." + o;
          if (!o) throw new Error("class does not have id: " + e);
          return (
            o in r ||
              ((r[o] = e),
              (function (e, t, n) {
                const r = w_(Object.create(null), [
                  n ? ox.get(n) : {},
                  ox.get(t),
                  e.defaults,
                ]);
                ox.set(t, r),
                  e.defaultRoutes &&
                    (function (e, t) {
                      Object.keys(t).forEach((n) => {
                        const r = n.split("."),
                          o = r.pop(),
                          a = [e].concat(r).join("."),
                          i = t[n].split("."),
                          s = i.pop(),
                          l = i.join(".");
                        ox.route(a, o, l, s);
                      });
                    })(t, e.defaultRoutes),
                  e.descriptors && ox.describe(t, e.descriptors);
              })(e, a, n),
              this.override && ox.override(e.id, e.overrides)),
            a
          );
        }
        get(e) {
          return this.items[e];
        }
        unregister(e) {
          const t = this.items,
            n = e.id,
            r = this.scope;
          n in t && delete t[n],
            r && n in ox[r] && (delete ox[r][n], this.override && delete ex[n]);
        }
      }
      var fS = new (class {
        constructor() {
          (this.controllers = new hS(ZC, "datasets", !0)),
            (this.elements = new hS(nS, "elements")),
            (this.plugins = new hS(Object, "plugins")),
            (this.scales = new hS(mS, "scales")),
            (this._typedRegistries = [
              this.controllers,
              this.scales,
              this.elements,
            ]);
        }
        add(...e) {
          this._each("register", e);
        }
        remove(...e) {
          this._each("unregister", e);
        }
        addControllers(...e) {
          this._each("register", e, this.controllers);
        }
        addElements(...e) {
          this._each("register", e, this.elements);
        }
        addPlugins(...e) {
          this._each("register", e, this.plugins);
        }
        addScales(...e) {
          this._each("register", e, this.scales);
        }
        getController(e) {
          return this._get(e, this.controllers, "controller");
        }
        getElement(e) {
          return this._get(e, this.elements, "element");
        }
        getPlugin(e) {
          return this._get(e, this.plugins, "plugin");
        }
        getScale(e) {
          return this._get(e, this.scales, "scale");
        }
        removeControllers(...e) {
          this._each("unregister", e, this.controllers);
        }
        removeElements(...e) {
          this._each("unregister", e, this.elements);
        }
        removePlugins(...e) {
          this._each("unregister", e, this.plugins);
        }
        removeScales(...e) {
          this._each("unregister", e, this.scales);
        }
        _each(e, t, n) {
          [...t].forEach((t) => {
            const r = n || this._getRegistryForType(t);
            n || r.isForType(t) || (r === this.plugins && t.id)
              ? this._exec(e, r, t)
              : y_(t, (t) => {
                  const r = n || this._getRegistryForType(t);
                  this._exec(e, r, t);
                });
          });
        }
        _exec(e, t, n) {
          const r = M_(e);
          __(n["before" + r], [], n), t[e](n), __(n["after" + r], [], n);
        }
        _getRegistryForType(e) {
          for (let t = 0; t < this._typedRegistries.length; t++) {
            const n = this._typedRegistries[t];
            if (n.isForType(e)) return n;
          }
          return this.plugins;
        }
        _get(e, t, n) {
          const r = t.get(e);
          if (void 0 === r)
            throw new Error('"' + e + '" is not a registered ' + n + ".");
          return r;
        }
      })();
      class gS extends ZC {
        update(e) {
          const t = this._cachedMeta,
            { data: n = [] } = t,
            r = this.chart._animationsDisabled;
          let { start: o, count: a } = hy(t, n, r);
          if (
            ((this._drawStart = o),
            (this._drawCount = a),
            fy(t) && ((o = 0), (a = n.length)),
            this.options.showLine)
          ) {
            const { dataset: o, _dataset: a } = t;
            (o._chart = this.chart),
              (o._datasetIndex = this.index),
              (o._decimated = !!a._decimated),
              (o.points = n);
            const i = this.resolveDatasetElementOptions(e);
            (i.segment = this.options.segment),
              this.updateElement(o, void 0, { animated: !r, options: i }, e);
          }
          this.updateElements(n, o, a, e);
        }
        addElements() {
          const { showLine: e } = this.options;
          !this.datasetElementType &&
            e &&
            (this.datasetElementType = fS.getElement("line")),
            super.addElements();
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            {
              iScale: a,
              vScale: i,
              _stacked: s,
              _dataset: l,
            } = this._cachedMeta,
            c = this.resolveDataElementOptions(t, r),
            u = this.getSharedOptions(c),
            d = this.includeOptions(r, u),
            p = a.axis,
            m = i.axis,
            { spanGaps: h, segment: f } = this.options,
            g = $_(h) ? h : Number.POSITIVE_INFINITY,
            v = this.chart._animationsDisabled || o || "none" === r;
          let b = t > 0 && this.getParsed(t - 1);
          for (let c = t; c < t + n; ++c) {
            const t = e[c],
              n = this.getParsed(c),
              h = v ? t : {},
              _ = p_(n[m]),
              y = (h[p] = a.getPixelForValue(n[p], c)),
              x = (h[m] =
                o || _
                  ? i.getBasePixel()
                  : i.getPixelForValue(s ? this.applyStack(i, n, s) : n[m], c));
            (h.skip = isNaN(y) || isNaN(x) || _),
              (h.stop = c > 0 && Math.abs(n[p] - b[p]) > g),
              f && ((h.parsed = n), (h.raw = l.data[c])),
              d &&
                (h.options =
                  u ||
                  this.resolveDataElementOptions(c, t.active ? "active" : r)),
              v || this.updateElement(t, c, h, r),
              (b = n);
          }
          this.updateSharedOptions(u, r, c);
        }
        getMaxOverflow() {
          const e = this._cachedMeta,
            t = e.data || [];
          if (!this.options.showLine) {
            let e = 0;
            for (let n = t.length - 1; n >= 0; --n)
              e = Math.max(e, t[n].size(this.resolveDataElementOptions(n)) / 2);
            return e > 0 && e;
          }
          const n = e.dataset,
            r = (n.options && n.options.borderWidth) || 0;
          if (!t.length) return r;
          const o = t[0].size(this.resolveDataElementOptions(0)),
            a = t[t.length - 1].size(
              this.resolveDataElementOptions(t.length - 1)
            );
          return Math.max(r, o, a) / 2;
        }
      }
      function vS() {
        throw new Error(
          "This method is not implemented: Check that a complete date adapter is provided."
        );
      }
      (gS.id = "scatter"),
        (gS.defaults = {
          datasetElementType: !1,
          dataElementType: "point",
          showLine: !1,
          fill: !1,
        }),
        (gS.overrides = {
          interaction: { mode: "point" },
          plugins: {
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
                label(e) {
                  return "(" + e.label + ", " + e.formattedValue + ")";
                },
              },
            },
          },
          scales: { x: { type: "linear" }, y: { type: "linear" } },
        });
      class bS {
        constructor(e) {
          this.options = e || {};
        }
        init(e) {}
        formats() {
          return vS();
        }
        parse(e, t) {
          return vS();
        }
        format(e, t) {
          return vS();
        }
        add(e, t, n) {
          return vS();
        }
        diff(e, t, n) {
          return vS();
        }
        startOf(e, t, n) {
          return vS();
        }
        endOf(e, t) {
          return vS();
        }
      }
      bS.override = function (e) {
        Object.assign(bS.prototype, e);
      };
      var _S = { _date: bS };
      function yS(e, t, n, r) {
        const { controller: o, data: a, _sorted: i } = e,
          s = o._cachedMeta.iScale;
        if (s && t === s.axis && "r" !== t && i && a.length) {
          const e = s._reversePixels ? iy : ay;
          if (!r) return e(a, t, n);
          if (o._sharedOptions) {
            const r = a[0],
              o = "function" == typeof r.getRange && r.getRange(t);
            if (o) {
              const r = e(a, t, n - o),
                i = e(a, t, n + o);
              return { lo: r.lo, hi: i.hi };
            }
          }
        }
        return { lo: 0, hi: a.length - 1 };
      }
      function xS(e, t, n, r, o) {
        const a = e.getSortedVisibleDatasetMetas(),
          i = n[t];
        for (let e = 0, n = a.length; e < n; ++e) {
          const { index: n, data: s } = a[e],
            { lo: l, hi: c } = yS(a[e], t, i, o);
          for (let e = l; e <= c; ++e) {
            const t = s[e];
            t.skip || r(t, n, e);
          }
        }
      }
      function CS(e, t, n, r, o) {
        const a = [];
        return o || e.isPointInArea(t)
          ? (xS(
              e,
              n,
              t,
              function (n, i, s) {
                (o || dx(n, e.chartArea, 0)) &&
                  n.inRange(t.x, t.y, r) &&
                  a.push({ element: n, datasetIndex: i, index: s });
              },
              !0
            ),
            a)
          : a;
      }
      function SS(e, t, n, r, o, a) {
        return a || e.isPointInArea(t)
          ? "r" !== n || r
            ? (function (e, t, n, r, o, a) {
                let i = [];
                const s = (function (e) {
                  const t = -1 !== e.indexOf("x"),
                    n = -1 !== e.indexOf("y");
                  return function (e, r) {
                    const o = t ? Math.abs(e.x - r.x) : 0,
                      a = n ? Math.abs(e.y - r.y) : 0;
                    return Math.sqrt(Math.pow(o, 2) + Math.pow(a, 2));
                  };
                })(n);
                let l = Number.POSITIVE_INFINITY;
                return (
                  xS(e, n, t, function (n, c, u) {
                    const d = n.inRange(t.x, t.y, o);
                    if (r && !d) return;
                    const p = n.getCenterPoint(o);
                    if (!a && !e.isPointInArea(p) && !d) return;
                    const m = s(t, p);
                    m < l
                      ? ((i = [{ element: n, datasetIndex: c, index: u }]),
                        (l = m))
                      : m === l &&
                        i.push({ element: n, datasetIndex: c, index: u });
                  }),
                  i
                );
              })(e, t, n, r, o, a)
            : (function (e, t, n, r) {
                let o = [];
                return (
                  xS(e, n, t, function (e, n, a) {
                    const { startAngle: i, endAngle: s } = e.getProps(
                        ["startAngle", "endAngle"],
                        r
                      ),
                      { angle: l } = J_(e, { x: t.x, y: t.y });
                    ty(l, i, s) &&
                      o.push({ element: e, datasetIndex: n, index: a });
                  }),
                  o
                );
              })(e, t, n, o)
          : [];
      }
      function kS(e, t, n, r, o) {
        const a = [],
          i = "x" === n ? "inXRange" : "inYRange";
        let s = !1;
        return (
          xS(e, n, t, (e, r, l) => {
            e[i](t[n], o) &&
              (a.push({ element: e, datasetIndex: r, index: l }),
              (s = s || e.inRange(t.x, t.y, o)));
          }),
          r && !s ? [] : a
        );
      }
      var wS = {
        evaluateInteractionItems: xS,
        modes: {
          index(e, t, n, r) {
            const o = rC(t, e),
              a = n.axis || "x",
              i = n.includeInvisible || !1,
              s = n.intersect ? CS(e, o, a, r, i) : SS(e, o, a, !1, r, i),
              l = [];
            return s.length
              ? (e.getSortedVisibleDatasetMetas().forEach((e) => {
                  const t = s[0].index,
                    n = e.data[t];
                  n &&
                    !n.skip &&
                    l.push({ element: n, datasetIndex: e.index, index: t });
                }),
                l)
              : [];
          },
          dataset(e, t, n, r) {
            const o = rC(t, e),
              a = n.axis || "xy",
              i = n.includeInvisible || !1;
            let s = n.intersect ? CS(e, o, a, r, i) : SS(e, o, a, !1, r, i);
            if (s.length > 0) {
              const t = s[0].datasetIndex,
                n = e.getDatasetMeta(t).data;
              s = [];
              for (let e = 0; e < n.length; ++e)
                s.push({ element: n[e], datasetIndex: t, index: e });
            }
            return s;
          },
          point(e, t, n, r) {
            return CS(e, rC(t, e), n.axis || "xy", r, n.includeInvisible || !1);
          },
          nearest(e, t, n, r) {
            const o = rC(t, e),
              a = n.axis || "xy",
              i = n.includeInvisible || !1;
            return SS(e, o, a, n.intersect, r, i);
          },
          x(e, t, n, r) {
            return kS(e, rC(t, e), "x", n.intersect, r);
          },
          y(e, t, n, r) {
            return kS(e, rC(t, e), "y", n.intersect, r);
          },
        },
      };
      const PS = ["left", "top", "right", "bottom"];
      function OS(e, t) {
        return e.filter((e) => e.pos === t);
      }
      function IS(e, t) {
        return e.filter((e) => -1 === PS.indexOf(e.pos) && e.box.axis === t);
      }
      function TS(e, t) {
        return e.sort((e, n) => {
          const r = t ? n : e,
            o = t ? e : n;
          return r.weight === o.weight
            ? r.index - o.index
            : r.weight - o.weight;
        });
      }
      function MS(e, t, n, r) {
        return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
      }
      function ES(e, t) {
        (e.top = Math.max(e.top, t.top)),
          (e.left = Math.max(e.left, t.left)),
          (e.bottom = Math.max(e.bottom, t.bottom)),
          (e.right = Math.max(e.right, t.right));
      }
      function DS(e, t, n, r) {
        const { pos: o, box: a } = n,
          i = e.maxPadding;
        if (!h_(o)) {
          n.size && (e[o] -= n.size);
          const t = r[n.stack] || { size: 0, count: 1 };
          (t.size = Math.max(t.size, n.horizontal ? a.height : a.width)),
            (n.size = t.size / t.count),
            (e[o] += n.size);
        }
        a.getPadding && ES(i, a.getPadding());
        const s = Math.max(0, t.outerWidth - MS(i, e, "left", "right")),
          l = Math.max(0, t.outerHeight - MS(i, e, "top", "bottom")),
          c = s !== e.w,
          u = l !== e.h;
        return (
          (e.w = s),
          (e.h = l),
          n.horizontal ? { same: c, other: u } : { same: u, other: c }
        );
      }
      function jS(e, t) {
        const n = t.maxPadding;
        return (function (e) {
          const r = { left: 0, top: 0, right: 0, bottom: 0 };
          return (
            e.forEach((e) => {
              r[e] = Math.max(t[e], n[e]);
            }),
            r
          );
        })(e ? ["left", "right"] : ["top", "bottom"]);
      }
      function RS(e, t, n, r) {
        const o = [];
        let a, i, s, l, c, u;
        for (a = 0, i = e.length, c = 0; a < i; ++a) {
          (s = e[a]),
            (l = s.box),
            l.update(s.width || t.w, s.height || t.h, jS(s.horizontal, t));
          const { same: i, other: d } = DS(t, n, s, r);
          (c |= i && o.length), (u = u || d), l.fullSize || o.push(s);
        }
        return (c && RS(o, t, n, r)) || u;
      }
      function NS(e, t, n, r, o) {
        (e.top = n),
          (e.left = t),
          (e.right = t + r),
          (e.bottom = n + o),
          (e.width = r),
          (e.height = o);
      }
      function AS(e, t, n, r) {
        const o = n.padding;
        let { x: a, y: i } = t;
        for (const s of e) {
          const e = s.box,
            l = r[s.stack] || { count: 1, placed: 0, weight: 1 },
            c = s.stackWeight / l.weight || 1;
          if (s.horizontal) {
            const r = t.w * c,
              a = l.size || e.height;
            E_(l.start) && (i = l.start),
              e.fullSize
                ? NS(e, o.left, i, n.outerWidth - o.right - o.left, a)
                : NS(e, t.left + l.placed, i, r, a),
              (l.start = i),
              (l.placed += r),
              (i = e.bottom);
          } else {
            const r = t.h * c,
              i = l.size || e.width;
            E_(l.start) && (a = l.start),
              e.fullSize
                ? NS(e, a, o.top, i, n.outerHeight - o.bottom - o.top)
                : NS(e, a, t.top + l.placed, i, r),
              (l.start = a),
              (l.placed += r),
              (a = e.right);
          }
        }
        (t.x = a), (t.y = i);
      }
      ox.set("layout", {
        autoPadding: !0,
        padding: { top: 0, right: 0, bottom: 0, left: 0 },
      });
      var LS = {
        addBox(e, t) {
          e.boxes || (e.boxes = []),
            (t.fullSize = t.fullSize || !1),
            (t.position = t.position || "top"),
            (t.weight = t.weight || 0),
            (t._layers =
              t._layers ||
              function () {
                return [
                  {
                    z: 0,
                    draw(e) {
                      t.draw(e);
                    },
                  },
                ];
              }),
            e.boxes.push(t);
        },
        removeBox(e, t) {
          const n = e.boxes ? e.boxes.indexOf(t) : -1;
          -1 !== n && e.boxes.splice(n, 1);
        },
        configure(e, t, n) {
          (t.fullSize = n.fullSize),
            (t.position = n.position),
            (t.weight = n.weight);
        },
        update(e, t, n, r) {
          if (!e) return;
          const o = Px(e.options.layout.padding),
            a = Math.max(t - o.width, 0),
            i = Math.max(n - o.height, 0),
            s = (function (e) {
              const t = (function (e) {
                  const t = [];
                  let n, r, o, a, i, s;
                  for (n = 0, r = (e || []).length; n < r; ++n)
                    (o = e[n]),
                      ({
                        position: a,
                        options: { stack: i, stackWeight: s = 1 },
                      } = o),
                      t.push({
                        index: n,
                        box: o,
                        pos: a,
                        horizontal: o.isHorizontal(),
                        weight: o.weight,
                        stack: i && a + i,
                        stackWeight: s,
                      });
                  return t;
                })(e),
                n = TS(
                  t.filter((e) => e.box.fullSize),
                  !0
                ),
                r = TS(OS(t, "left"), !0),
                o = TS(OS(t, "right")),
                a = TS(OS(t, "top"), !0),
                i = TS(OS(t, "bottom")),
                s = IS(t, "x"),
                l = IS(t, "y");
              return {
                fullSize: n,
                leftAndTop: r.concat(a),
                rightAndBottom: o.concat(l).concat(i).concat(s),
                chartArea: OS(t, "chartArea"),
                vertical: r.concat(o).concat(l),
                horizontal: a.concat(i).concat(s),
              };
            })(e.boxes),
            l = s.vertical,
            c = s.horizontal;
          y_(e.boxes, (e) => {
            "function" == typeof e.beforeLayout && e.beforeLayout();
          });
          const u =
              l.reduce(
                (e, t) =>
                  t.box.options && !1 === t.box.options.display ? e : e + 1,
                0
              ) || 1,
            d = Object.freeze({
              outerWidth: t,
              outerHeight: n,
              padding: o,
              availableWidth: a,
              availableHeight: i,
              vBoxMaxWidth: a / 2 / u,
              hBoxMaxHeight: i / 2,
            }),
            p = Object.assign({}, o);
          ES(p, Px(r));
          const m = Object.assign(
              { maxPadding: p, w: a, h: i, x: o.left, y: o.top },
              o
            ),
            h = (function (e, t) {
              const n = (function (e) {
                  const t = {};
                  for (const n of e) {
                    const { stack: e, pos: r, stackWeight: o } = n;
                    if (!e || !PS.includes(r)) continue;
                    const a =
                      t[e] ||
                      (t[e] = { count: 0, placed: 0, weight: 0, size: 0 });
                    a.count++, (a.weight += o);
                  }
                  return t;
                })(e),
                { vBoxMaxWidth: r, hBoxMaxHeight: o } = t;
              let a, i, s;
              for (a = 0, i = e.length; a < i; ++a) {
                s = e[a];
                const { fullSize: i } = s.box,
                  l = n[s.stack],
                  c = l && s.stackWeight / l.weight;
                s.horizontal
                  ? ((s.width = c ? c * r : i && t.availableWidth),
                    (s.height = o))
                  : ((s.width = r),
                    (s.height = c ? c * o : i && t.availableHeight));
              }
              return n;
            })(l.concat(c), d);
          RS(s.fullSize, m, d, h),
            RS(l, m, d, h),
            RS(c, m, d, h) && RS(l, m, d, h),
            (function (e) {
              const t = e.maxPadding;
              function n(n) {
                const r = Math.max(t[n] - e[n], 0);
                return (e[n] += r), r;
              }
              (e.y += n("top")), (e.x += n("left")), n("right"), n("bottom");
            })(m),
            AS(s.leftAndTop, m, d, h),
            (m.x += m.w),
            (m.y += m.h),
            AS(s.rightAndBottom, m, d, h),
            (e.chartArea = {
              left: m.left,
              top: m.top,
              right: m.left + m.w,
              bottom: m.top + m.h,
              height: m.h,
              width: m.w,
            }),
            y_(s.chartArea, (t) => {
              const n = t.box;
              Object.assign(n, e.chartArea),
                n.update(m.w, m.h, { left: 0, top: 0, right: 0, bottom: 0 });
            });
        },
      };
      class zS {
        acquireContext(e, t) {}
        releaseContext(e) {
          return !1;
        }
        addEventListener(e, t, n) {}
        removeEventListener(e, t, n) {}
        getDevicePixelRatio() {
          return 1;
        }
        getMaximumSize(e, t, n, r) {
          return (
            (t = Math.max(0, t || e.width)),
            (n = n || e.height),
            { width: t, height: Math.max(0, r ? Math.floor(t / r) : n) }
          );
        }
        isAttached(e) {
          return !0;
        }
        updateConfig(e) {}
      }
      class BS extends zS {
        acquireContext(e) {
          return (e && e.getContext && e.getContext("2d")) || null;
        }
        updateConfig(e) {
          e.options.animation = !1;
        }
      }
      const ZS = "$chartjs",
        FS = {
          touchstart: "mousedown",
          touchmove: "mousemove",
          touchend: "mouseup",
          pointerenter: "mouseenter",
          pointerdown: "mousedown",
          pointermove: "mousemove",
          pointerup: "mouseup",
          pointerleave: "mouseout",
          pointerout: "mouseout",
        },
        HS = (e) => null === e || "" === e,
        VS = !!iC && { passive: !0 };
      function WS(e, t, n) {
        e.canvas.removeEventListener(t, n, VS);
      }
      function $S(e, t) {
        for (const n of e) if (n === t || n.contains(t)) return !0;
      }
      function US(e, t, n) {
        const r = e.canvas,
          o = new MutationObserver((e) => {
            let t = !1;
            for (const n of e)
              (t = t || $S(n.addedNodes, r)), (t = t && !$S(n.removedNodes, r));
            t && n();
          });
        return o.observe(document, { childList: !0, subtree: !0 }), o;
      }
      function KS(e, t, n) {
        const r = e.canvas,
          o = new MutationObserver((e) => {
            let t = !1;
            for (const n of e)
              (t = t || $S(n.removedNodes, r)), (t = t && !$S(n.addedNodes, r));
            t && n();
          });
        return o.observe(document, { childList: !0, subtree: !0 }), o;
      }
      const GS = new Map();
      let qS = 0;
      function YS() {
        const e = window.devicePixelRatio;
        e !== qS &&
          ((qS = e),
          GS.forEach((t, n) => {
            n.currentDevicePixelRatio !== e && t();
          }));
      }
      function JS(e, t, n) {
        const r = e.canvas,
          o = r && Jx(r);
        if (!o) return;
        const a = dy((e, t) => {
            const r = o.clientWidth;
            n(e, t), r < o.clientWidth && n();
          }, window),
          i = new ResizeObserver((e) => {
            const t = e[0],
              n = t.contentRect.width,
              r = t.contentRect.height;
            (0 === n && 0 === r) || a(n, r);
          });
        return (
          i.observe(o),
          (function (e, t) {
            GS.size || window.addEventListener("resize", YS), GS.set(e, t);
          })(e, a),
          i
        );
      }
      function QS(e, t, n) {
        n && n.disconnect(),
          "resize" === t &&
            (function (e) {
              GS.delete(e), GS.size || window.removeEventListener("resize", YS);
            })(e);
      }
      function XS(e, t, n) {
        const r = e.canvas,
          o = dy(
            (t) => {
              null !== e.ctx &&
                n(
                  (function (e, t) {
                    const n = FS[e.type] || e.type,
                      { x: r, y: o } = rC(e, t);
                    return {
                      type: n,
                      chart: t,
                      native: e,
                      x: void 0 !== r ? r : null,
                      y: void 0 !== o ? o : null,
                    };
                  })(t, e)
                );
            },
            e,
            (e) => {
              const t = e[0];
              return [t, t.offsetX, t.offsetY];
            }
          );
        return (
          (function (e, t, n) {
            e.addEventListener(t, n, VS);
          })(r, t, o),
          o
        );
      }
      class ek extends zS {
        acquireContext(e, t) {
          const n = e && e.getContext && e.getContext("2d");
          return n && n.canvas === e
            ? ((function (e, t) {
                const n = e.style,
                  r = e.getAttribute("height"),
                  o = e.getAttribute("width");
                if (
                  ((e[ZS] = {
                    initial: {
                      height: r,
                      width: o,
                      style: {
                        display: n.display,
                        height: n.height,
                        width: n.width,
                      },
                    },
                  }),
                  (n.display = n.display || "block"),
                  (n.boxSizing = n.boxSizing || "border-box"),
                  HS(o))
                ) {
                  const t = sC(e, "width");
                  void 0 !== t && (e.width = t);
                }
                if (HS(r))
                  if ("" === e.style.height) e.height = e.width / (t || 2);
                  else {
                    const t = sC(e, "height");
                    void 0 !== t && (e.height = t);
                  }
              })(e, t),
              n)
            : null;
        }
        releaseContext(e) {
          const t = e.canvas;
          if (!t[ZS]) return !1;
          const n = t[ZS].initial;
          ["height", "width"].forEach((e) => {
            const r = n[e];
            p_(r) ? t.removeAttribute(e) : t.setAttribute(e, r);
          });
          const r = n.style || {};
          return (
            Object.keys(r).forEach((e) => {
              t.style[e] = r[e];
            }),
            (t.width = t.width),
            delete t[ZS],
            !0
          );
        }
        addEventListener(e, t, n) {
          this.removeEventListener(e, t);
          const r = e.$proxies || (e.$proxies = {}),
            o = { attach: US, detach: KS, resize: JS }[t] || XS;
          r[t] = o(e, t, n);
        }
        removeEventListener(e, t) {
          const n = e.$proxies || (e.$proxies = {}),
            r = n[t];
          r &&
            (({ attach: QS, detach: QS, resize: QS }[t] || WS)(e, t, r),
            (n[t] = void 0));
        }
        getDevicePixelRatio() {
          return window.devicePixelRatio;
        }
        getMaximumSize(e, t, n, r) {
          return (function (e, t, n, r) {
            const o = Xx(e),
              a = tC(o, "margin"),
              i = Qx(o.maxWidth, e, "clientWidth") || L_,
              s = Qx(o.maxHeight, e, "clientHeight") || L_,
              l = (function (e, t, n) {
                let r, o;
                if (void 0 === t || void 0 === n) {
                  const a = Jx(e);
                  if (a) {
                    const e = a.getBoundingClientRect(),
                      i = Xx(a),
                      s = tC(i, "border", "width"),
                      l = tC(i, "padding");
                    (t = e.width - l.width - s.width),
                      (n = e.height - l.height - s.height),
                      (r = Qx(i.maxWidth, a, "clientWidth")),
                      (o = Qx(i.maxHeight, a, "clientHeight"));
                  } else (t = e.clientWidth), (n = e.clientHeight);
                }
                return {
                  width: t,
                  height: n,
                  maxWidth: r || L_,
                  maxHeight: o || L_,
                };
              })(e, t, n);
            let { width: c, height: u } = l;
            if ("content-box" === o.boxSizing) {
              const e = tC(o, "border", "width"),
                t = tC(o, "padding");
              (c -= t.width + e.width), (u -= t.height + e.height);
            }
            return (
              (c = Math.max(0, c - a.width)),
              (u = Math.max(0, r ? Math.floor(c / r) : u - a.height)),
              (c = oC(Math.min(c, i, l.maxWidth))),
              (u = oC(Math.min(u, s, l.maxHeight))),
              c && !u && (u = oC(c / 2)),
              { width: c, height: u }
            );
          })(e, t, n, r);
        }
        isAttached(e) {
          const t = Jx(e);
          return !(!t || !t.isConnected);
        }
      }
      class tk {
        constructor() {
          this._init = [];
        }
        notify(e, t, n, r) {
          "beforeInit" === t &&
            ((this._init = this._createDescriptors(e, !0)),
            this._notify(this._init, e, "install"));
          const o = r ? this._descriptors(e).filter(r) : this._descriptors(e),
            a = this._notify(o, e, t, n);
          return (
            "afterDestroy" === t &&
              (this._notify(o, e, "stop"),
              this._notify(this._init, e, "uninstall")),
            a
          );
        }
        _notify(e, t, n, r) {
          r = r || {};
          for (const o of e) {
            const e = o.plugin;
            if (!1 === __(e[n], [t, r, o.options], e) && r.cancelable)
              return !1;
          }
          return !0;
        }
        invalidate() {
          p_(this._cache) ||
            ((this._oldCache = this._cache), (this._cache = void 0));
        }
        _descriptors(e) {
          if (this._cache) return this._cache;
          const t = (this._cache = this._createDescriptors(e));
          return this._notifyStateChanges(e), t;
        }
        _createDescriptors(e, t) {
          const n = e && e.config,
            r = v_(n.options && n.options.plugins, {}),
            o = (function (e) {
              const t = {},
                n = [],
                r = Object.keys(fS.plugins.items);
              for (let e = 0; e < r.length; e++) n.push(fS.getPlugin(r[e]));
              const o = e.plugins || [];
              for (let e = 0; e < o.length; e++) {
                const r = o[e];
                -1 === n.indexOf(r) && (n.push(r), (t[r.id] = !0));
              }
              return { plugins: n, localIds: t };
            })(n);
          return !1 !== r || t
            ? (function (e, { plugins: t, localIds: n }, r, o) {
                const a = [],
                  i = e.getContext();
                for (const s of t) {
                  const t = s.id,
                    l = nk(r[t], o);
                  null !== l &&
                    a.push({
                      plugin: s,
                      options: rk(e.config, { plugin: s, local: n[t] }, l, i),
                    });
                }
                return a;
              })(e, o, r, t)
            : [];
        }
        _notifyStateChanges(e) {
          const t = this._oldCache || [],
            n = this._cache,
            r = (e, t) =>
              e.filter((e) => !t.some((t) => e.plugin.id === t.plugin.id));
          this._notify(r(t, n), e, "stop"), this._notify(r(n, t), e, "start");
        }
      }
      function nk(e, t) {
        return t || !1 !== e ? (!0 === e ? {} : e) : null;
      }
      function rk(e, { plugin: t, local: n }, r, o) {
        const a = e.pluginScopeKeys(t),
          i = e.getOptionScopes(r, a);
        return (
          n && t.defaults && i.push(t.defaults),
          e.createResolver(i, o, [""], {
            scriptable: !1,
            indexable: !1,
            allKeys: !0,
          })
        );
      }
      function ok(e, t) {
        const n = ox.datasets[e] || {};
        return (
          ((t.datasets || {})[e] || {}).indexAxis ||
          t.indexAxis ||
          n.indexAxis ||
          "x"
        );
      }
      function ak(e, t) {
        return "x" === e || "y" === e
          ? e
          : t.axis ||
              ("top" === (n = t.position) || "bottom" === n
                ? "x"
                : "left" === n || "right" === n
                ? "y"
                : void 0) ||
              e.charAt(0).toLowerCase();
        var n;
      }
      function ik(e) {
        const t = e.options || (e.options = {});
        (t.plugins = v_(t.plugins, {})),
          (t.scales = (function (e, t) {
            const n = ex[e.type] || { scales: {} },
              r = t.scales || {},
              o = ok(e.type, t),
              a = Object.create(null),
              i = Object.create(null);
            return (
              Object.keys(r).forEach((e) => {
                const t = r[e];
                if (!h_(t))
                  return console.error(
                    `Invalid scale configuration for scale: ${e}`
                  );
                if (t._proxy)
                  return console.warn(
                    `Ignoring resolver passed as options for scale: ${e}`
                  );
                const s = ak(e, t),
                  l = (function (e, t) {
                    return e === t ? "_index_" : "_value_";
                  })(s, o),
                  c = n.scales || {};
                (a[s] = a[s] || e),
                  (i[e] = P_(Object.create(null), [
                    { axis: s },
                    t,
                    c[s],
                    c[l],
                  ]));
              }),
              e.data.datasets.forEach((n) => {
                const o = n.type || e.type,
                  s = n.indexAxis || ok(o, t),
                  l = (ex[o] || {}).scales || {};
                Object.keys(l).forEach((e) => {
                  const t = (function (e, t) {
                      let n = e;
                      return (
                        "_index_" === e
                          ? (n = t)
                          : "_value_" === e && (n = "x" === t ? "y" : "x"),
                        n
                      );
                    })(e, s),
                    o = n[t + "AxisID"] || a[t] || t;
                  (i[o] = i[o] || Object.create(null)),
                    P_(i[o], [{ axis: t }, r[o], l[e]]);
                });
              }),
              Object.keys(i).forEach((e) => {
                const t = i[e];
                P_(t, [ox.scales[t.type], ox.scale]);
              }),
              i
            );
          })(e, t));
      }
      function sk(e) {
        return (
          ((e = e || {}).datasets = e.datasets || []),
          (e.labels = e.labels || []),
          e
        );
      }
      const lk = new Map(),
        ck = new Set();
      function uk(e, t) {
        let n = lk.get(e);
        return n || ((n = t()), lk.set(e, n), ck.add(n)), n;
      }
      const dk = (e, t, n) => {
        const r = T_(t, n);
        void 0 !== r && e.add(r);
      };
      class pk {
        constructor(e) {
          (this._config = (function (e) {
            return ((e = e || {}).data = sk(e.data)), ik(e), e;
          })(e)),
            (this._scopeCache = new Map()),
            (this._resolverCache = new Map());
        }
        get platform() {
          return this._config.platform;
        }
        get type() {
          return this._config.type;
        }
        set type(e) {
          this._config.type = e;
        }
        get data() {
          return this._config.data;
        }
        set data(e) {
          this._config.data = sk(e);
        }
        get options() {
          return this._config.options;
        }
        set options(e) {
          this._config.options = e;
        }
        get plugins() {
          return this._config.plugins;
        }
        update() {
          const e = this._config;
          this.clearCache(), ik(e);
        }
        clearCache() {
          this._scopeCache.clear(), this._resolverCache.clear();
        }
        datasetScopeKeys(e) {
          return uk(e, () => [[`datasets.${e}`, ""]]);
        }
        datasetAnimationScopeKeys(e, t) {
          return uk(`${e}.transition.${t}`, () => [
            [`datasets.${e}.transitions.${t}`, `transitions.${t}`],
            [`datasets.${e}`, ""],
          ]);
        }
        datasetElementScopeKeys(e, t) {
          return uk(`${e}-${t}`, () => [
            [
              `datasets.${e}.elements.${t}`,
              `datasets.${e}`,
              `elements.${t}`,
              "",
            ],
          ]);
        }
        pluginScopeKeys(e) {
          const t = e.id;
          return uk(`${this.type}-plugin-${t}`, () => [
            [`plugins.${t}`, ...(e.additionalOptionScopes || [])],
          ]);
        }
        _cachedScopes(e, t) {
          const n = this._scopeCache;
          let r = n.get(e);
          return (r && !t) || ((r = new Map()), n.set(e, r)), r;
        }
        getOptionScopes(e, t, n) {
          const { options: r, type: o } = this,
            a = this._cachedScopes(e, n),
            i = a.get(t);
          if (i) return i;
          const s = new Set();
          t.forEach((t) => {
            e && (s.add(e), t.forEach((t) => dk(s, e, t))),
              t.forEach((e) => dk(s, r, e)),
              t.forEach((e) => dk(s, ex[o] || {}, e)),
              t.forEach((e) => dk(s, ox, e)),
              t.forEach((e) => dk(s, tx, e));
          });
          const l = Array.from(s);
          return (
            0 === l.length && l.push(Object.create(null)),
            ck.has(t) && a.set(t, l),
            l
          );
        }
        chartOptionScopes() {
          const { options: e, type: t } = this;
          return [e, ex[t] || {}, ox.datasets[t] || {}, { type: t }, ox, tx];
        }
        resolveNamedOptions(e, t, n, r = [""]) {
          const o = { $shared: !0 },
            { resolver: a, subPrefixes: i } = mk(this._resolverCache, e, r);
          let s = a;
          (function (e, t) {
            const { isScriptable: n, isIndexable: r } = Dx(e);
            for (const o of t) {
              const t = n(o),
                a = r(o),
                i = (a || t) && e[o];
              if ((t && (D_(i) || hk(i))) || (a && m_(i))) return !0;
            }
            return !1;
          })(a, t) &&
            ((o.$shared = !1),
            (s = Ex(a, (n = D_(n) ? n() : n), this.createResolver(e, n, i))));
          for (const e of t) o[e] = s[e];
          return o;
        }
        createResolver(e, t, n = [""], r) {
          const { resolver: o } = mk(this._resolverCache, e, n);
          return h_(t) ? Ex(o, t, void 0, r) : o;
        }
      }
      function mk(e, t, n) {
        let r = e.get(t);
        r || ((r = new Map()), e.set(t, r));
        const o = n.join();
        let a = r.get(o);
        return (
          a ||
            ((a = {
              resolver: Mx(t, n),
              subPrefixes: n.filter((e) => !e.toLowerCase().includes("hover")),
            }),
            r.set(o, a)),
          a
        );
      }
      const hk = (e) =>
          h_(e) &&
          Object.getOwnPropertyNames(e).reduce((t, n) => t || D_(e[n]), !1),
        fk = ["top", "bottom", "left", "right", "chartArea"];
      function gk(e, t) {
        return (
          "top" === e || "bottom" === e || (-1 === fk.indexOf(e) && "x" === t)
        );
      }
      function vk(e, t) {
        return function (n, r) {
          return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
        };
      }
      function bk(e) {
        const t = e.chart,
          n = t.options.animation;
        t.notifyPlugins("afterRender"), __(n && n.onComplete, [e], t);
      }
      function _k(e) {
        const t = e.chart,
          n = t.options.animation;
        __(n && n.onProgress, [e], t);
      }
      function yk(e) {
        return (
          Yx() && "string" == typeof e
            ? (e = document.getElementById(e))
            : e && e.length && (e = e[0]),
          e && e.canvas && (e = e.canvas),
          e
        );
      }
      const xk = {},
        Ck = (e) => {
          const t = yk(e);
          return Object.values(xk)
            .filter((e) => e.canvas === t)
            .pop();
        };
      function Sk(e, t, n) {
        const r = Object.keys(e);
        for (const o of r) {
          const r = +o;
          if (r >= t) {
            const a = e[o];
            delete e[o], (n > 0 || r > t) && (e[r + n] = a);
          }
        }
      }
      class kk {
        constructor(e, t) {
          const n = (this.config = new pk(t)),
            r = yk(e),
            o = Ck(r);
          if (o)
            throw new Error(
              "Canvas is already in use. Chart with ID '" +
                o.id +
                "' must be destroyed before the canvas with ID '" +
                o.canvas.id +
                "' can be reused."
            );
          const a = n.createResolver(n.chartOptionScopes(), this.getContext());
          (this.platform = new (n.platform ||
            (function (e) {
              return !Yx() ||
                ("undefined" != typeof OffscreenCanvas &&
                  e instanceof OffscreenCanvas)
                ? BS
                : ek;
            })(r))()),
            this.platform.updateConfig(n);
          const i = this.platform.acquireContext(r, a.aspectRatio),
            s = i && i.canvas,
            l = s && s.height,
            c = s && s.width;
          (this.id = d_()),
            (this.ctx = i),
            (this.canvas = s),
            (this.width = c),
            (this.height = l),
            (this._options = a),
            (this._aspectRatio = this.aspectRatio),
            (this._layers = []),
            (this._metasets = []),
            (this._stacks = void 0),
            (this.boxes = []),
            (this.currentDevicePixelRatio = void 0),
            (this.chartArea = void 0),
            (this._active = []),
            (this._lastEvent = void 0),
            (this._listeners = {}),
            (this._responsiveListeners = void 0),
            (this._sortedMetasets = []),
            (this.scales = {}),
            (this._plugins = new tk()),
            (this.$proxies = {}),
            (this._hiddenIndices = {}),
            (this.attached = !1),
            (this._animationsDisabled = void 0),
            (this.$context = void 0),
            (this._doResize = (function (e, t) {
              let n;
              return function (...r) {
                return (
                  t
                    ? (clearTimeout(n), (n = setTimeout(e, t, r)))
                    : e.apply(this, r),
                  t
                );
              };
            })((e) => this.update(e), a.resizeDelay || 0)),
            (this._dataChanges = []),
            (xk[this.id] = this),
            i && s
              ? (SC.listen(this, "complete", bk),
                SC.listen(this, "progress", _k),
                this._initialize(),
                this.attached && this.update())
              : console.error(
                  "Failed to create chart: can't acquire context from the given item"
                );
        }
        get aspectRatio() {
          const {
            options: { aspectRatio: e, maintainAspectRatio: t },
            width: n,
            height: r,
            _aspectRatio: o,
          } = this;
          return p_(e) ? (t && o ? o : r ? n / r : null) : e;
        }
        get data() {
          return this.config.data;
        }
        set data(e) {
          this.config.data = e;
        }
        get options() {
          return this._options;
        }
        set options(e) {
          this.config.options = e;
        }
        _initialize() {
          return (
            this.notifyPlugins("beforeInit"),
            this.options.responsive
              ? this.resize()
              : aC(this, this.options.devicePixelRatio),
            this.bindEvents(),
            this.notifyPlugins("afterInit"),
            this
          );
        }
        clear() {
          return lx(this.canvas, this.ctx), this;
        }
        stop() {
          return SC.stop(this), this;
        }
        resize(e, t) {
          SC.running(this)
            ? (this._resizeBeforeDraw = { width: e, height: t })
            : this._resize(e, t);
        }
        _resize(e, t) {
          const n = this.options,
            r = this.canvas,
            o = n.maintainAspectRatio && this.aspectRatio,
            a = this.platform.getMaximumSize(r, e, t, o),
            i = n.devicePixelRatio || this.platform.getDevicePixelRatio(),
            s = this.width ? "resize" : "attach";
          (this.width = a.width),
            (this.height = a.height),
            (this._aspectRatio = this.aspectRatio),
            aC(this, i, !0) &&
              (this.notifyPlugins("resize", { size: a }),
              __(n.onResize, [this, a], this),
              this.attached && this._doResize(s) && this.render());
        }
        ensureScalesHaveIDs() {
          y_(this.options.scales || {}, (e, t) => {
            e.id = t;
          });
        }
        buildOrUpdateScales() {
          const e = this.options,
            t = e.scales,
            n = this.scales,
            r = Object.keys(n).reduce((e, t) => ((e[t] = !1), e), {});
          let o = [];
          t &&
            (o = o.concat(
              Object.keys(t).map((e) => {
                const n = t[e],
                  r = ak(e, n),
                  o = "r" === r,
                  a = "x" === r;
                return {
                  options: n,
                  dposition: o ? "chartArea" : a ? "bottom" : "left",
                  dtype: o ? "radialLinear" : a ? "category" : "linear",
                };
              })
            )),
            y_(o, (t) => {
              const o = t.options,
                a = o.id,
                i = ak(a, o),
                s = v_(o.type, t.dtype);
              (void 0 !== o.position &&
                gk(o.position, i) === gk(t.dposition)) ||
                (o.position = t.dposition),
                (r[a] = !0);
              let l = null;
              a in n && n[a].type === s
                ? (l = n[a])
                : ((l = new (fS.getScale(s))({
                    id: a,
                    type: s,
                    ctx: this.ctx,
                    chart: this,
                  })),
                  (n[l.id] = l)),
                l.init(o, e);
            }),
            y_(r, (e, t) => {
              e || delete n[t];
            }),
            y_(n, (e) => {
              LS.configure(this, e, e.options), LS.addBox(this, e);
            });
        }
        _updateMetasets() {
          const e = this._metasets,
            t = this.data.datasets.length,
            n = e.length;
          if ((e.sort((e, t) => e.index - t.index), n > t)) {
            for (let e = t; e < n; ++e) this._destroyDatasetMeta(e);
            e.splice(t, n - t);
          }
          this._sortedMetasets = e.slice(0).sort(vk("order", "index"));
        }
        _removeUnreferencedMetasets() {
          const {
            _metasets: e,
            data: { datasets: t },
          } = this;
          e.length > t.length && delete this._stacks,
            e.forEach((e, n) => {
              0 === t.filter((t) => t === e._dataset).length &&
                this._destroyDatasetMeta(n);
            });
        }
        buildOrUpdateControllers() {
          const e = [],
            t = this.data.datasets;
          let n, r;
          for (
            this._removeUnreferencedMetasets(), n = 0, r = t.length;
            n < r;
            n++
          ) {
            const r = t[n];
            let o = this.getDatasetMeta(n);
            const a = r.type || this.config.type;
            if (
              (o.type &&
                o.type !== a &&
                (this._destroyDatasetMeta(n), (o = this.getDatasetMeta(n))),
              (o.type = a),
              (o.indexAxis = r.indexAxis || ok(a, this.options)),
              (o.order = r.order || 0),
              (o.index = n),
              (o.label = "" + r.label),
              (o.visible = this.isDatasetVisible(n)),
              o.controller)
            )
              o.controller.updateIndex(n), o.controller.linkScales();
            else {
              const t = fS.getController(a),
                { datasetElementType: r, dataElementType: i } = ox.datasets[a];
              Object.assign(t.prototype, {
                dataElementType: fS.getElement(i),
                datasetElementType: r && fS.getElement(r),
              }),
                (o.controller = new t(this, n)),
                e.push(o.controller);
            }
          }
          return this._updateMetasets(), e;
        }
        _resetElements() {
          y_(
            this.data.datasets,
            (e, t) => {
              this.getDatasetMeta(t).controller.reset();
            },
            this
          );
        }
        reset() {
          this._resetElements(), this.notifyPlugins("reset");
        }
        update(e) {
          const t = this.config;
          t.update();
          const n = (this._options = t.createResolver(
              t.chartOptionScopes(),
              this.getContext()
            )),
            r = (this._animationsDisabled = !n.animation);
          if (
            (this._updateScales(),
            this._checkEventBindings(),
            this._updateHiddenIndices(),
            this._plugins.invalidate(),
            !1 ===
              this.notifyPlugins("beforeUpdate", { mode: e, cancelable: !0 }))
          )
            return;
          const o = this.buildOrUpdateControllers();
          this.notifyPlugins("beforeElementsUpdate");
          let a = 0;
          for (let e = 0, t = this.data.datasets.length; e < t; e++) {
            const { controller: t } = this.getDatasetMeta(e),
              n = !r && -1 === o.indexOf(t);
            t.buildOrUpdateElements(n), (a = Math.max(+t.getMaxOverflow(), a));
          }
          (a = this._minPadding = n.layout.autoPadding ? a : 0),
            this._updateLayout(a),
            r ||
              y_(o, (e) => {
                e.reset();
              }),
            this._updateDatasets(e),
            this.notifyPlugins("afterUpdate", { mode: e }),
            this._layers.sort(vk("z", "_idx"));
          const { _active: i, _lastEvent: s } = this;
          s
            ? this._eventHandler(s, !0)
            : i.length && this._updateHoverStyles(i, i, !0),
            this.render();
        }
        _updateScales() {
          y_(this.scales, (e) => {
            LS.removeBox(this, e);
          }),
            this.ensureScalesHaveIDs(),
            this.buildOrUpdateScales();
        }
        _checkEventBindings() {
          const e = this.options,
            t = new Set(Object.keys(this._listeners)),
            n = new Set(e.events);
          (j_(t, n) && !!this._responsiveListeners === e.responsive) ||
            (this.unbindEvents(), this.bindEvents());
        }
        _updateHiddenIndices() {
          const { _hiddenIndices: e } = this,
            t = this._getUniformDataChanges() || [];
          for (const { method: n, start: r, count: o } of t)
            Sk(e, r, "_removeElements" === n ? -o : o);
        }
        _getUniformDataChanges() {
          const e = this._dataChanges;
          if (!e || !e.length) return;
          this._dataChanges = [];
          const t = this.data.datasets.length,
            n = (t) =>
              new Set(
                e
                  .filter((e) => e[0] === t)
                  .map((e, t) => t + "," + e.splice(1).join(","))
              ),
            r = n(0);
          for (let e = 1; e < t; e++) if (!j_(r, n(e))) return;
          return Array.from(r)
            .map((e) => e.split(","))
            .map((e) => ({ method: e[1], start: +e[2], count: +e[3] }));
        }
        _updateLayout(e) {
          if (!1 === this.notifyPlugins("beforeLayout", { cancelable: !0 }))
            return;
          LS.update(this, this.width, this.height, e);
          const t = this.chartArea,
            n = t.width <= 0 || t.height <= 0;
          (this._layers = []),
            y_(
              this.boxes,
              (e) => {
                (n && "chartArea" === e.position) ||
                  (e.configure && e.configure(),
                  this._layers.push(...e._layers()));
              },
              this
            ),
            this._layers.forEach((e, t) => {
              e._idx = t;
            }),
            this.notifyPlugins("afterLayout");
        }
        _updateDatasets(e) {
          if (
            !1 !==
            this.notifyPlugins("beforeDatasetsUpdate", {
              mode: e,
              cancelable: !0,
            })
          ) {
            for (let e = 0, t = this.data.datasets.length; e < t; ++e)
              this.getDatasetMeta(e).controller.configure();
            for (let t = 0, n = this.data.datasets.length; t < n; ++t)
              this._updateDataset(t, D_(e) ? e({ datasetIndex: t }) : e);
            this.notifyPlugins("afterDatasetsUpdate", { mode: e });
          }
        }
        _updateDataset(e, t) {
          const n = this.getDatasetMeta(e),
            r = { meta: n, index: e, mode: t, cancelable: !0 };
          !1 !== this.notifyPlugins("beforeDatasetUpdate", r) &&
            (n.controller._update(t),
            (r.cancelable = !1),
            this.notifyPlugins("afterDatasetUpdate", r));
        }
        render() {
          !1 !== this.notifyPlugins("beforeRender", { cancelable: !0 }) &&
            (SC.has(this)
              ? this.attached && !SC.running(this) && SC.start(this)
              : (this.draw(), bk({ chart: this })));
        }
        draw() {
          let e;
          if (this._resizeBeforeDraw) {
            const { width: e, height: t } = this._resizeBeforeDraw;
            this._resize(e, t), (this._resizeBeforeDraw = null);
          }
          if ((this.clear(), this.width <= 0 || this.height <= 0)) return;
          if (!1 === this.notifyPlugins("beforeDraw", { cancelable: !0 }))
            return;
          const t = this._layers;
          for (e = 0; e < t.length && t[e].z <= 0; ++e)
            t[e].draw(this.chartArea);
          for (this._drawDatasets(); e < t.length; ++e)
            t[e].draw(this.chartArea);
          this.notifyPlugins("afterDraw");
        }
        _getSortedDatasetMetas(e) {
          const t = this._sortedMetasets,
            n = [];
          let r, o;
          for (r = 0, o = t.length; r < o; ++r) {
            const o = t[r];
            (e && !o.visible) || n.push(o);
          }
          return n;
        }
        getSortedVisibleDatasetMetas() {
          return this._getSortedDatasetMetas(!0);
        }
        _drawDatasets() {
          if (
            !1 === this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 })
          )
            return;
          const e = this.getSortedVisibleDatasetMetas();
          for (let t = e.length - 1; t >= 0; --t) this._drawDataset(e[t]);
          this.notifyPlugins("afterDatasetsDraw");
        }
        _drawDataset(e) {
          const t = this.ctx,
            n = e._clip,
            r = !n.disabled,
            o = this.chartArea,
            a = { meta: e, index: e.index, cancelable: !0 };
          !1 !== this.notifyPlugins("beforeDatasetDraw", a) &&
            (r &&
              px(t, {
                left: !1 === n.left ? 0 : o.left - n.left,
                right: !1 === n.right ? this.width : o.right + n.right,
                top: !1 === n.top ? 0 : o.top - n.top,
                bottom: !1 === n.bottom ? this.height : o.bottom + n.bottom,
              }),
            e.controller.draw(),
            r && mx(t),
            (a.cancelable = !1),
            this.notifyPlugins("afterDatasetDraw", a));
        }
        isPointInArea(e) {
          return dx(e, this.chartArea, this._minPadding);
        }
        getElementsAtEventForMode(e, t, n, r) {
          const o = wS.modes[t];
          return "function" == typeof o ? o(this, e, n, r) : [];
        }
        getDatasetMeta(e) {
          const t = this.data.datasets[e],
            n = this._metasets;
          let r = n.filter((e) => e && e._dataset === t).pop();
          return (
            r ||
              ((r = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: (t && t.order) || 0,
                index: e,
                _dataset: t,
                _parsed: [],
                _sorted: !1,
              }),
              n.push(r)),
            r
          );
        }
        getContext() {
          return (
            this.$context ||
            (this.$context = Tx(null, { chart: this, type: "chart" }))
          );
        }
        getVisibleDatasetCount() {
          return this.getSortedVisibleDatasetMetas().length;
        }
        isDatasetVisible(e) {
          const t = this.data.datasets[e];
          if (!t) return !1;
          const n = this.getDatasetMeta(e);
          return "boolean" == typeof n.hidden ? !n.hidden : !t.hidden;
        }
        setDatasetVisibility(e, t) {
          this.getDatasetMeta(e).hidden = !t;
        }
        toggleDataVisibility(e) {
          this._hiddenIndices[e] = !this._hiddenIndices[e];
        }
        getDataVisibility(e) {
          return !this._hiddenIndices[e];
        }
        _updateVisibility(e, t, n) {
          const r = n ? "show" : "hide",
            o = this.getDatasetMeta(e),
            a = o.controller._resolveAnimations(void 0, r);
          E_(t)
            ? ((o.data[t].hidden = !n), this.update())
            : (this.setDatasetVisibility(e, n),
              a.update(o, { visible: n }),
              this.update((t) => (t.datasetIndex === e ? r : void 0)));
        }
        hide(e, t) {
          this._updateVisibility(e, t, !1);
        }
        show(e, t) {
          this._updateVisibility(e, t, !0);
        }
        _destroyDatasetMeta(e) {
          const t = this._metasets[e];
          t && t.controller && t.controller._destroy(),
            delete this._metasets[e];
        }
        _stop() {
          let e, t;
          for (
            this.stop(), SC.remove(this), e = 0, t = this.data.datasets.length;
            e < t;
            ++e
          )
            this._destroyDatasetMeta(e);
        }
        destroy() {
          this.notifyPlugins("beforeDestroy");
          const { canvas: e, ctx: t } = this;
          this._stop(),
            this.config.clearCache(),
            e &&
              (this.unbindEvents(),
              lx(e, t),
              this.platform.releaseContext(t),
              (this.canvas = null),
              (this.ctx = null)),
            this.notifyPlugins("destroy"),
            delete xk[this.id],
            this.notifyPlugins("afterDestroy");
        }
        toBase64Image(...e) {
          return this.canvas.toDataURL(...e);
        }
        bindEvents() {
          this.bindUserEvents(),
            this.options.responsive
              ? this.bindResponsiveEvents()
              : (this.attached = !0);
        }
        bindUserEvents() {
          const e = this._listeners,
            t = this.platform,
            n = (n, r) => {
              t.addEventListener(this, n, r), (e[n] = r);
            },
            r = (e, t, n) => {
              (e.offsetX = t), (e.offsetY = n), this._eventHandler(e);
            };
          y_(this.options.events, (e) => n(e, r));
        }
        bindResponsiveEvents() {
          this._responsiveListeners || (this._responsiveListeners = {});
          const e = this._responsiveListeners,
            t = this.platform,
            n = (n, r) => {
              t.addEventListener(this, n, r), (e[n] = r);
            },
            r = (n, r) => {
              e[n] && (t.removeEventListener(this, n, r), delete e[n]);
            },
            o = (e, t) => {
              this.canvas && this.resize(e, t);
            };
          let a;
          const i = () => {
            r("attach", i),
              (this.attached = !0),
              this.resize(),
              n("resize", o),
              n("detach", a);
          };
          (a = () => {
            (this.attached = !1),
              r("resize", o),
              this._stop(),
              this._resize(0, 0),
              n("attach", i);
          }),
            t.isAttached(this.canvas) ? i() : a();
        }
        unbindEvents() {
          y_(this._listeners, (e, t) => {
            this.platform.removeEventListener(this, t, e);
          }),
            (this._listeners = {}),
            y_(this._responsiveListeners, (e, t) => {
              this.platform.removeEventListener(this, t, e);
            }),
            (this._responsiveListeners = void 0);
        }
        updateHoverStyle(e, t, n) {
          const r = n ? "set" : "remove";
          let o, a, i, s;
          for (
            "dataset" === t &&
              ((o = this.getDatasetMeta(e[0].datasetIndex)),
              o.controller["_" + r + "DatasetHoverStyle"]()),
              i = 0,
              s = e.length;
            i < s;
            ++i
          ) {
            a = e[i];
            const t = a && this.getDatasetMeta(a.datasetIndex).controller;
            t && t[r + "HoverStyle"](a.element, a.datasetIndex, a.index);
          }
        }
        getActiveElements() {
          return this._active || [];
        }
        setActiveElements(e) {
          const t = this._active || [],
            n = e.map(({ datasetIndex: e, index: t }) => {
              const n = this.getDatasetMeta(e);
              if (!n) throw new Error("No dataset found at index " + e);
              return { datasetIndex: e, element: n.data[t], index: t };
            });
          !x_(n, t) &&
            ((this._active = n),
            (this._lastEvent = null),
            this._updateHoverStyles(n, t));
        }
        notifyPlugins(e, t, n) {
          return this._plugins.notify(this, e, t, n);
        }
        _updateHoverStyles(e, t, n) {
          const r = this.options.hover,
            o = (e, t) =>
              e.filter(
                (e) =>
                  !t.some(
                    (t) =>
                      e.datasetIndex === t.datasetIndex && e.index === t.index
                  )
              ),
            a = o(t, e),
            i = n ? e : o(e, t);
          a.length && this.updateHoverStyle(a, r.mode, !1),
            i.length && r.mode && this.updateHoverStyle(i, r.mode, !0);
        }
        _eventHandler(e, t) {
          const n = {
              event: e,
              replay: t,
              cancelable: !0,
              inChartArea: this.isPointInArea(e),
            },
            r = (t) =>
              (t.options.events || this.options.events).includes(e.native.type);
          if (!1 === this.notifyPlugins("beforeEvent", n, r)) return;
          const o = this._handleEvent(e, t, n.inChartArea);
          return (
            (n.cancelable = !1),
            this.notifyPlugins("afterEvent", n, r),
            (o || n.changed) && this.render(),
            this
          );
        }
        _handleEvent(e, t, n) {
          const { _active: r = [], options: o } = this,
            a = t,
            i = this._getActiveElements(e, r, n, a),
            s = (function (e) {
              return (
                "mouseup" === e.type ||
                "click" === e.type ||
                "contextmenu" === e.type
              );
            })(e),
            l = (function (e, t, n, r) {
              return n && "mouseout" !== e.type ? (r ? t : e) : null;
            })(e, this._lastEvent, n, s);
          n &&
            ((this._lastEvent = null),
            __(o.onHover, [e, i, this], this),
            s && __(o.onClick, [e, i, this], this));
          const c = !x_(i, r);
          return (
            (c || t) && ((this._active = i), this._updateHoverStyles(i, r, t)),
            (this._lastEvent = l),
            c
          );
        }
        _getActiveElements(e, t, n, r) {
          if ("mouseout" === e.type) return [];
          if (!n) return t;
          const o = this.options.hover;
          return this.getElementsAtEventForMode(e, o.mode, o, r);
        }
      }
      const wk = () => y_(kk.instances, (e) => e._plugins.invalidate()),
        Pk = !0;
      function Ok(e, t, n) {
        const {
          startAngle: r,
          pixelMargin: o,
          x: a,
          y: i,
          outerRadius: s,
          innerRadius: l,
        } = t;
        let c = o / s;
        e.beginPath(),
          e.arc(a, i, s, r - c, n + c),
          l > o
            ? ((c = o / l), e.arc(a, i, l, n + c, r - c, !0))
            : e.arc(a, i, o, n + B_, r - B_),
          e.closePath(),
          e.clip();
      }
      function Ik(e, t, n, r) {
        return { x: n + e * Math.cos(t), y: r + e * Math.sin(t) };
      }
      function Tk(e, t, n, r, o, a) {
        const { x: i, y: s, startAngle: l, pixelMargin: c, innerRadius: u } = t,
          d = Math.max(t.outerRadius + r + n - c, 0),
          p = u > 0 ? u + r + n + c : 0;
        let m = 0;
        const h = o - l;
        if (r) {
          const e = ((u > 0 ? u - r : 0) + (d > 0 ? d - r : 0)) / 2;
          m = (h - (0 !== e ? (h * e) / (e + r) : h)) / 2;
        }
        const f = (h - Math.max(0.001, h * d - n / R_) / d) / 2,
          g = l + f + m,
          v = o - f - m,
          {
            outerStart: b,
            outerEnd: _,
            innerStart: y,
            innerEnd: x,
          } = (function (e, t, n, r) {
            const o = Sx(e.options.borderRadius, [
                "outerStart",
                "outerEnd",
                "innerStart",
                "innerEnd",
              ]),
              a = (n - t) / 2,
              i = Math.min(a, (r * t) / 2),
              s = (e) => {
                const t = ((n - Math.min(a, e)) * r) / 2;
                return ny(e, 0, Math.min(a, t));
              };
            return {
              outerStart: s(o.outerStart),
              outerEnd: s(o.outerEnd),
              innerStart: ny(o.innerStart, 0, i),
              innerEnd: ny(o.innerEnd, 0, i),
            };
          })(t, p, d, v - g),
          C = d - b,
          S = d - _,
          k = g + b / C,
          w = v - _ / S,
          P = p + y,
          O = p + x,
          I = g + y / P,
          T = v - x / O;
        if ((e.beginPath(), a)) {
          if ((e.arc(i, s, d, k, w), _ > 0)) {
            const t = Ik(S, w, i, s);
            e.arc(t.x, t.y, _, w, v + B_);
          }
          const t = Ik(O, v, i, s);
          if ((e.lineTo(t.x, t.y), x > 0)) {
            const t = Ik(O, T, i, s);
            e.arc(t.x, t.y, x, v + B_, T + Math.PI);
          }
          if ((e.arc(i, s, p, v - x / p, g + y / p, !0), y > 0)) {
            const t = Ik(P, I, i, s);
            e.arc(t.x, t.y, y, I + Math.PI, g - B_);
          }
          const n = Ik(C, g, i, s);
          if ((e.lineTo(n.x, n.y), b > 0)) {
            const t = Ik(C, k, i, s);
            e.arc(t.x, t.y, b, g - B_, k);
          }
        } else {
          e.moveTo(i, s);
          const t = Math.cos(k) * d + i,
            n = Math.sin(k) * d + s;
          e.lineTo(t, n);
          const r = Math.cos(w) * d + i,
            o = Math.sin(w) * d + s;
          e.lineTo(r, o);
        }
        e.closePath();
      }
      Object.defineProperties(kk, {
        defaults: { enumerable: Pk, value: ox },
        instances: { enumerable: Pk, value: xk },
        overrides: { enumerable: Pk, value: ex },
        registry: { enumerable: Pk, value: fS },
        version: { enumerable: Pk, value: "3.9.1" },
        getChart: { enumerable: Pk, value: Ck },
        register: {
          enumerable: Pk,
          value: (...e) => {
            fS.add(...e), wk();
          },
        },
        unregister: {
          enumerable: Pk,
          value: (...e) => {
            fS.remove(...e), wk();
          },
        },
      });
      class Mk extends nS {
        constructor(e) {
          super(),
            (this.options = void 0),
            (this.circumference = void 0),
            (this.startAngle = void 0),
            (this.endAngle = void 0),
            (this.innerRadius = void 0),
            (this.outerRadius = void 0),
            (this.pixelMargin = 0),
            (this.fullCircles = 0),
            e && Object.assign(this, e);
        }
        inRange(e, t, n) {
          const r = this.getProps(["x", "y"], n),
            { angle: o, distance: a } = J_(r, { x: e, y: t }),
            {
              startAngle: i,
              endAngle: s,
              innerRadius: l,
              outerRadius: c,
              circumference: u,
            } = this.getProps(
              [
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "circumference",
              ],
              n
            ),
            d = this.options.spacing / 2,
            p = v_(u, s - i) >= N_ || ty(o, i, s),
            m = ry(a, l + d, c + d);
          return p && m;
        }
        getCenterPoint(e) {
          const {
              x: t,
              y: n,
              startAngle: r,
              endAngle: o,
              innerRadius: a,
              outerRadius: i,
            } = this.getProps(
              [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "circumference",
              ],
              e
            ),
            { offset: s, spacing: l } = this.options,
            c = (r + o) / 2,
            u = (a + i + l + s) / 2;
          return { x: t + Math.cos(c) * u, y: n + Math.sin(c) * u };
        }
        tooltipPosition(e) {
          return this.getCenterPoint(e);
        }
        draw(e) {
          const { options: t, circumference: n } = this,
            r = (t.offset || 0) / 2,
            o = (t.spacing || 0) / 2,
            a = t.circular;
          if (
            ((this.pixelMargin = "inner" === t.borderAlign ? 0.33 : 0),
            (this.fullCircles = n > N_ ? Math.floor(n / N_) : 0),
            0 === n || this.innerRadius < 0 || this.outerRadius < 0)
          )
            return;
          e.save();
          let i = 0;
          if (r) {
            i = r / 2;
            const t = (this.startAngle + this.endAngle) / 2;
            e.translate(Math.cos(t) * i, Math.sin(t) * i),
              this.circumference >= R_ && (i = r);
          }
          (e.fillStyle = t.backgroundColor), (e.strokeStyle = t.borderColor);
          const s = (function (e, t, n, r, o) {
            const { fullCircles: a, startAngle: i, circumference: s } = t;
            let l = t.endAngle;
            if (a) {
              Tk(e, t, n, r, i + N_, o);
              for (let t = 0; t < a; ++t) e.fill();
              isNaN(s) || ((l = i + (s % N_)), s % N_ == 0 && (l += N_));
            }
            return Tk(e, t, n, r, l, o), e.fill(), l;
          })(e, this, i, o, a);
          (function (e, t, n, r, o, a) {
            const { options: i } = t,
              { borderWidth: s, borderJoinStyle: l } = i,
              c = "inner" === i.borderAlign;
            s &&
              (c
                ? ((e.lineWidth = 2 * s), (e.lineJoin = l || "round"))
                : ((e.lineWidth = s), (e.lineJoin = l || "bevel")),
              t.fullCircles &&
                (function (e, t, n) {
                  const {
                      x: r,
                      y: o,
                      startAngle: a,
                      pixelMargin: i,
                      fullCircles: s,
                    } = t,
                    l = Math.max(t.outerRadius - i, 0),
                    c = t.innerRadius + i;
                  let u;
                  for (
                    n && Ok(e, t, a + N_),
                      e.beginPath(),
                      e.arc(r, o, c, a + N_, a, !0),
                      u = 0;
                    u < s;
                    ++u
                  )
                    e.stroke();
                  for (
                    e.beginPath(), e.arc(r, o, l, a, a + N_), u = 0;
                    u < s;
                    ++u
                  )
                    e.stroke();
                })(e, t, c),
              c && Ok(e, t, o),
              Tk(e, t, n, r, o, a),
              e.stroke());
          })(e, this, i, o, s, a),
            e.restore();
        }
      }
      function Ek(e, t, n = t) {
        (e.lineCap = v_(n.borderCapStyle, t.borderCapStyle)),
          e.setLineDash(v_(n.borderDash, t.borderDash)),
          (e.lineDashOffset = v_(n.borderDashOffset, t.borderDashOffset)),
          (e.lineJoin = v_(n.borderJoinStyle, t.borderJoinStyle)),
          (e.lineWidth = v_(n.borderWidth, t.borderWidth)),
          (e.strokeStyle = v_(n.borderColor, t.borderColor));
      }
      function Dk(e, t, n) {
        e.lineTo(n.x, n.y);
      }
      function jk(e, t, n = {}) {
        const r = e.length,
          { start: o = 0, end: a = r - 1 } = n,
          { start: i, end: s } = t,
          l = Math.max(o, i),
          c = Math.min(a, s),
          u = (o < i && a < i) || (o > s && a > s);
        return {
          count: r,
          start: l,
          loop: t.loop,
          ilen: c < l && !u ? r + c - l : c - l,
        };
      }
      function Rk(e, t, n, r) {
        const { points: o, options: a } = t,
          { count: i, start: s, loop: l, ilen: c } = jk(o, n, r),
          u = (function (e) {
            return e.stepped
              ? hx
              : e.tension || "monotone" === e.cubicInterpolationMode
              ? fx
              : Dk;
          })(a);
        let d,
          p,
          m,
          { move: h = !0, reverse: f } = r || {};
        for (d = 0; d <= c; ++d)
          (p = o[(s + (f ? c - d : d)) % i]),
            p.skip ||
              (h ? (e.moveTo(p.x, p.y), (h = !1)) : u(e, m, p, f, a.stepped),
              (m = p));
        return (
          l && ((p = o[(s + (f ? c : 0)) % i]), u(e, m, p, f, a.stepped)), !!l
        );
      }
      function Nk(e, t, n, r) {
        const o = t.points,
          { count: a, start: i, ilen: s } = jk(o, n, r),
          { move: l = !0, reverse: c } = r || {};
        let u,
          d,
          p,
          m,
          h,
          f,
          g = 0,
          v = 0;
        const b = (e) => (i + (c ? s - e : e)) % a,
          _ = () => {
            m !== h && (e.lineTo(g, h), e.lineTo(g, m), e.lineTo(g, f));
          };
        for (l && ((d = o[b(0)]), e.moveTo(d.x, d.y)), u = 0; u <= s; ++u) {
          if (((d = o[b(u)]), d.skip)) continue;
          const t = d.x,
            n = d.y,
            r = 0 | t;
          r === p
            ? (n < m ? (m = n) : n > h && (h = n), (g = (v * g + t) / ++v))
            : (_(), e.lineTo(t, n), (p = r), (v = 0), (m = h = n)),
            (f = n);
        }
        _();
      }
      function Ak(e) {
        const t = e.options,
          n = t.borderDash && t.borderDash.length;
        return e._decimated ||
          e._loop ||
          t.tension ||
          "monotone" === t.cubicInterpolationMode ||
          t.stepped ||
          n
          ? Rk
          : Nk;
      }
      (Mk.id = "arc"),
        (Mk.defaults = {
          borderAlign: "center",
          borderColor: "#fff",
          borderJoinStyle: void 0,
          borderRadius: 0,
          borderWidth: 2,
          offset: 0,
          spacing: 0,
          angle: void 0,
          circular: !0,
        }),
        (Mk.defaultRoutes = { backgroundColor: "backgroundColor" });
      const Lk = "function" == typeof Path2D;
      class zk extends nS {
        constructor(e) {
          super(),
            (this.animated = !0),
            (this.options = void 0),
            (this._chart = void 0),
            (this._loop = void 0),
            (this._fullLoop = void 0),
            (this._path = void 0),
            (this._points = void 0),
            (this._segments = void 0),
            (this._decimated = !1),
            (this._pointsUpdated = !1),
            (this._datasetIndex = void 0),
            e && Object.assign(this, e);
        }
        updateControlPoints(e, t) {
          const n = this.options;
          if (
            (n.tension || "monotone" === n.cubicInterpolationMode) &&
            !n.stepped &&
            !this._pointsUpdated
          ) {
            const r = n.spanGaps ? this._loop : this._fullLoop;
            qx(this._points, n, e, r, t), (this._pointsUpdated = !0);
          }
        }
        set points(e) {
          (this._points = e),
            delete this._segments,
            delete this._path,
            (this._pointsUpdated = !1);
        }
        get points() {
          return this._points;
        }
        get segments() {
          return (
            this._segments ||
            (this._segments = (function (e, t) {
              const n = e.points,
                r = e.options.spanGaps,
                o = n.length;
              if (!o) return [];
              const a = !!e._loop,
                { start: i, end: s } = (function (e, t, n, r) {
                  let o = 0,
                    a = t - 1;
                  if (n && !r) for (; o < t && !e[o].skip; ) o++;
                  for (; o < t && e[o].skip; ) o++;
                  for (o %= t, n && (a += o); a > o && e[a % t].skip; ) a--;
                  return (a %= t), { start: o, end: a };
                })(n, o, a, r);
              return (function (e, t, n, r) {
                return r && r.setContext && n
                  ? (function (e, t, n, r) {
                      const o = e._chart.getContext(),
                        a = xC(e.options),
                        {
                          _datasetIndex: i,
                          options: { spanGaps: s },
                        } = e,
                        l = n.length,
                        c = [];
                      let u = a,
                        d = t[0].start,
                        p = d;
                      function m(e, t, r, o) {
                        const a = s ? -1 : 1;
                        if (e !== t) {
                          for (e += l; n[e % l].skip; ) e -= a;
                          for (; n[t % l].skip; ) t += a;
                          e % l != t % l &&
                            (c.push({
                              start: e % l,
                              end: t % l,
                              loop: r,
                              style: o,
                            }),
                            (u = o),
                            (d = t % l));
                        }
                      }
                      for (const e of t) {
                        d = s ? d : e.start;
                        let t,
                          a = n[d % l];
                        for (p = d + 1; p <= e.end; p++) {
                          const s = n[p % l];
                          (t = xC(
                            r.setContext(
                              Tx(o, {
                                type: "segment",
                                p0: a,
                                p1: s,
                                p0DataIndex: (p - 1) % l,
                                p1DataIndex: p % l,
                                datasetIndex: i,
                              })
                            )
                          )),
                            CC(t, u) && m(d, p - 1, e.loop, u),
                            (a = s),
                            (u = t);
                        }
                        d < p - 1 && m(d, p - 1, e.loop, u);
                      }
                      return c;
                    })(e, t, n, r)
                  : t;
              })(
                e,
                !0 === r
                  ? [{ start: i, end: s, loop: a }]
                  : (function (e, t, n, r) {
                      const o = e.length,
                        a = [];
                      let i,
                        s = t,
                        l = e[t];
                      for (i = t + 1; i <= n; ++i) {
                        const n = e[i % o];
                        n.skip || n.stop
                          ? l.skip ||
                            ((r = !1),
                            a.push({ start: t % o, end: (i - 1) % o, loop: r }),
                            (t = s = n.stop ? i : null))
                          : ((s = i), l.skip && (t = i)),
                          (l = n);
                      }
                      return (
                        null !== s &&
                          a.push({ start: t % o, end: s % o, loop: r }),
                        a
                      );
                    })(
                      n,
                      i,
                      s < i ? s + o : s,
                      !!e._fullLoop && 0 === i && s === o - 1
                    ),
                n,
                t
              );
            })(this, this.options.segment))
          );
        }
        first() {
          const e = this.segments,
            t = this.points;
          return e.length && t[e[0].start];
        }
        last() {
          const e = this.segments,
            t = this.points,
            n = e.length;
          return n && t[e[n - 1].end];
        }
        interpolate(e, t) {
          const n = this.options,
            r = e[t],
            o = this.points,
            a = (function (e, t) {
              const n = [],
                r = e.segments;
              for (let o = 0; o < r.length; o++) {
                const a = yC(r[o], e.points, t);
                a.length && n.push(...a);
              }
              return n;
            })(this, { property: t, start: r, end: r });
          if (!a.length) return;
          const i = [],
            s = (function (e) {
              return e.stepped
                ? cC
                : e.tension || "monotone" === e.cubicInterpolationMode
                ? uC
                : lC;
            })(n);
          let l, c;
          for (l = 0, c = a.length; l < c; ++l) {
            const { start: c, end: u } = a[l],
              d = o[c],
              p = o[u];
            if (d === p) {
              i.push(d);
              continue;
            }
            const m = s(d, p, Math.abs((r - d[t]) / (p[t] - d[t])), n.stepped);
            (m[t] = e[t]), i.push(m);
          }
          return 1 === i.length ? i[0] : i;
        }
        pathSegment(e, t, n) {
          return Ak(this)(e, this, t, n);
        }
        path(e, t, n) {
          const r = this.segments,
            o = Ak(this);
          let a = this._loop;
          (t = t || 0), (n = n || this.points.length - t);
          for (const i of r) a &= o(e, this, i, { start: t, end: t + n - 1 });
          return !!a;
        }
        draw(e, t, n, r) {
          const o = this.options || {};
          (this.points || []).length &&
            o.borderWidth &&
            (e.save(),
            (function (e, t, n, r) {
              Lk && !t.options.segment
                ? (function (e, t, n, r) {
                    let o = t._path;
                    o ||
                      ((o = t._path = new Path2D()),
                      t.path(o, n, r) && o.closePath()),
                      Ek(e, t.options),
                      e.stroke(o);
                  })(e, t, n, r)
                : (function (e, t, n, r) {
                    const { segments: o, options: a } = t,
                      i = Ak(t);
                    for (const s of o)
                      Ek(e, a, s.style),
                        e.beginPath(),
                        i(e, t, s, { start: n, end: n + r - 1 }) &&
                          e.closePath(),
                        e.stroke();
                  })(e, t, n, r);
            })(e, this, n, r),
            e.restore()),
            this.animated &&
              ((this._pointsUpdated = !1), (this._path = void 0));
        }
      }
      function Bk(e, t, n, r) {
        const o = e.options,
          { [n]: a } = e.getProps([n], r);
        return Math.abs(t - a) < o.radius + o.hitRadius;
      }
      (zk.id = "line"),
        (zk.defaults = {
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0,
          borderJoinStyle: "miter",
          borderWidth: 3,
          capBezierPoints: !0,
          cubicInterpolationMode: "default",
          fill: !1,
          spanGaps: !1,
          stepped: !1,
          tension: 0,
        }),
        (zk.defaultRoutes = {
          backgroundColor: "backgroundColor",
          borderColor: "borderColor",
        }),
        (zk.descriptors = {
          _scriptable: !0,
          _indexable: (e) => "borderDash" !== e && "fill" !== e,
        });
      class Zk extends nS {
        constructor(e) {
          super(),
            (this.options = void 0),
            (this.parsed = void 0),
            (this.skip = void 0),
            (this.stop = void 0),
            e && Object.assign(this, e);
        }
        inRange(e, t, n) {
          const r = this.options,
            { x: o, y: a } = this.getProps(["x", "y"], n);
          return (
            Math.pow(e - o, 2) + Math.pow(t - a, 2) <
            Math.pow(r.hitRadius + r.radius, 2)
          );
        }
        inXRange(e, t) {
          return Bk(this, e, "x", t);
        }
        inYRange(e, t) {
          return Bk(this, e, "y", t);
        }
        getCenterPoint(e) {
          const { x: t, y: n } = this.getProps(["x", "y"], e);
          return { x: t, y: n };
        }
        size(e) {
          let t = (e = e || this.options || {}).radius || 0;
          return (
            (t = Math.max(t, (t && e.hoverRadius) || 0)),
            2 * (t + ((t && e.borderWidth) || 0))
          );
        }
        draw(e, t) {
          const n = this.options;
          this.skip ||
            n.radius < 0.1 ||
            !dx(this, t, this.size(n) / 2) ||
            ((e.strokeStyle = n.borderColor),
            (e.lineWidth = n.borderWidth),
            (e.fillStyle = n.backgroundColor),
            cx(e, n, this.x, this.y));
        }
        getRange() {
          const e = this.options || {};
          return e.radius + e.hitRadius;
        }
      }
      function Fk(e, t) {
        const {
          x: n,
          y: r,
          base: o,
          width: a,
          height: i,
        } = e.getProps(["x", "y", "base", "width", "height"], t);
        let s, l, c, u, d;
        return (
          e.horizontal
            ? ((d = i / 2),
              (s = Math.min(n, o)),
              (l = Math.max(n, o)),
              (c = r - d),
              (u = r + d))
            : ((d = a / 2),
              (s = n - d),
              (l = n + d),
              (c = Math.min(r, o)),
              (u = Math.max(r, o))),
          { left: s, top: c, right: l, bottom: u }
        );
      }
      function Hk(e, t, n, r) {
        return e ? 0 : ny(t, n, r);
      }
      function Vk(e, t, n, r) {
        const o = null === t,
          a = null === n,
          i = e && !(o && a) && Fk(e, r);
        return (
          i && (o || ry(t, i.left, i.right)) && (a || ry(n, i.top, i.bottom))
        );
      }
      function Wk(e, t) {
        e.rect(t.x, t.y, t.w, t.h);
      }
      function $k(e, t, n = {}) {
        const r = e.x !== n.x ? -t : 0,
          o = e.y !== n.y ? -t : 0,
          a = (e.x + e.w !== n.x + n.w ? t : 0) - r,
          i = (e.y + e.h !== n.y + n.h ? t : 0) - o;
        return {
          x: e.x + r,
          y: e.y + o,
          w: e.w + a,
          h: e.h + i,
          radius: e.radius,
        };
      }
      (Zk.id = "point"),
        (Zk.defaults = {
          borderWidth: 1,
          hitRadius: 1,
          hoverBorderWidth: 1,
          hoverRadius: 4,
          pointStyle: "circle",
          radius: 3,
          rotation: 0,
        }),
        (Zk.defaultRoutes = {
          backgroundColor: "backgroundColor",
          borderColor: "borderColor",
        });
      class Uk extends nS {
        constructor(e) {
          super(),
            (this.options = void 0),
            (this.horizontal = void 0),
            (this.base = void 0),
            (this.width = void 0),
            (this.height = void 0),
            (this.inflateAmount = void 0),
            e && Object.assign(this, e);
        }
        draw(e) {
          const {
              inflateAmount: t,
              options: { borderColor: n, backgroundColor: r },
            } = this,
            { inner: o, outer: a } = (function (e) {
              const t = Fk(e),
                n = t.right - t.left,
                r = t.bottom - t.top,
                o = (function (e, t, n) {
                  const r = e.options.borderWidth,
                    o = e.borderSkipped,
                    a = kx(r);
                  return {
                    t: Hk(o.top, a.top, 0, n),
                    r: Hk(o.right, a.right, 0, t),
                    b: Hk(o.bottom, a.bottom, 0, n),
                    l: Hk(o.left, a.left, 0, t),
                  };
                })(e, n / 2, r / 2),
                a = (function (e, t, n) {
                  const { enableBorderRadius: r } = e.getProps([
                      "enableBorderRadius",
                    ]),
                    o = e.options.borderRadius,
                    a = wx(o),
                    i = Math.min(t, n),
                    s = e.borderSkipped,
                    l = r || h_(o);
                  return {
                    topLeft: Hk(!l || s.top || s.left, a.topLeft, 0, i),
                    topRight: Hk(!l || s.top || s.right, a.topRight, 0, i),
                    bottomLeft: Hk(
                      !l || s.bottom || s.left,
                      a.bottomLeft,
                      0,
                      i
                    ),
                    bottomRight: Hk(
                      !l || s.bottom || s.right,
                      a.bottomRight,
                      0,
                      i
                    ),
                  };
                })(e, n / 2, r / 2);
              return {
                outer: { x: t.left, y: t.top, w: n, h: r, radius: a },
                inner: {
                  x: t.left + o.l,
                  y: t.top + o.t,
                  w: n - o.l - o.r,
                  h: r - o.t - o.b,
                  radius: {
                    topLeft: Math.max(0, a.topLeft - Math.max(o.t, o.l)),
                    topRight: Math.max(0, a.topRight - Math.max(o.t, o.r)),
                    bottomLeft: Math.max(0, a.bottomLeft - Math.max(o.b, o.l)),
                    bottomRight: Math.max(
                      0,
                      a.bottomRight - Math.max(o.b, o.r)
                    ),
                  },
                },
              };
            })(this),
            i =
              (s = a.radius).topLeft ||
              s.topRight ||
              s.bottomLeft ||
              s.bottomRight
                ? bx
                : Wk;
          var s;
          e.save(),
            (a.w === o.w && a.h === o.h) ||
              (e.beginPath(),
              i(e, $k(a, t, o)),
              e.clip(),
              i(e, $k(o, -t, a)),
              (e.fillStyle = n),
              e.fill("evenodd")),
            e.beginPath(),
            i(e, $k(o, t)),
            (e.fillStyle = r),
            e.fill(),
            e.restore();
        }
        inRange(e, t, n) {
          return Vk(this, e, t, n);
        }
        inXRange(e, t) {
          return Vk(this, e, null, t);
        }
        inYRange(e, t) {
          return Vk(this, null, e, t);
        }
        getCenterPoint(e) {
          const {
            x: t,
            y: n,
            base: r,
            horizontal: o,
          } = this.getProps(["x", "y", "base", "horizontal"], e);
          return { x: o ? (t + r) / 2 : t, y: o ? n : (n + r) / 2 };
        }
        getRange(e) {
          return "x" === e ? this.width / 2 : this.height / 2;
        }
      }
      (Uk.id = "bar"),
        (Uk.defaults = {
          borderSkipped: "start",
          borderWidth: 0,
          borderRadius: 0,
          inflateAmount: "auto",
          pointStyle: void 0,
        }),
        (Uk.defaultRoutes = {
          backgroundColor: "backgroundColor",
          borderColor: "borderColor",
        });
      const Kk = (e, t) => {
        let { boxHeight: n = t, boxWidth: r = t } = e;
        return (
          e.usePointStyle &&
            ((n = Math.min(n, t)), (r = e.pointStyleWidth || Math.min(r, t))),
          { boxWidth: r, boxHeight: n, itemHeight: Math.max(t, n) }
        );
      };
      class Gk extends nS {
        constructor(e) {
          super(),
            (this._added = !1),
            (this.legendHitBoxes = []),
            (this._hoveredItem = null),
            (this.doughnutMode = !1),
            (this.chart = e.chart),
            (this.options = e.options),
            (this.ctx = e.ctx),
            (this.legendItems = void 0),
            (this.columnSizes = void 0),
            (this.lineWidths = void 0),
            (this.maxHeight = void 0),
            (this.maxWidth = void 0),
            (this.top = void 0),
            (this.bottom = void 0),
            (this.left = void 0),
            (this.right = void 0),
            (this.height = void 0),
            (this.width = void 0),
            (this._margins = void 0),
            (this.position = void 0),
            (this.weight = void 0),
            (this.fullSize = void 0);
        }
        update(e, t, n) {
          (this.maxWidth = e),
            (this.maxHeight = t),
            (this._margins = n),
            this.setDimensions(),
            this.buildLabels(),
            this.fit();
        }
        setDimensions() {
          this.isHorizontal()
            ? ((this.width = this.maxWidth),
              (this.left = this._margins.left),
              (this.right = this.width))
            : ((this.height = this.maxHeight),
              (this.top = this._margins.top),
              (this.bottom = this.height));
        }
        buildLabels() {
          const e = this.options.labels || {};
          let t = __(e.generateLabels, [this.chart], this) || [];
          e.filter && (t = t.filter((t) => e.filter(t, this.chart.data))),
            e.sort && (t = t.sort((t, n) => e.sort(t, n, this.chart.data))),
            this.options.reverse && t.reverse(),
            (this.legendItems = t);
        }
        fit() {
          const { options: e, ctx: t } = this;
          if (!e.display) return void (this.width = this.height = 0);
          const n = e.labels,
            r = Ox(n.font),
            o = r.size,
            a = this._computeTitleHeight(),
            { boxWidth: i, itemHeight: s } = Kk(n, o);
          let l, c;
          (t.font = r.string),
            this.isHorizontal()
              ? ((l = this.maxWidth), (c = this._fitRows(a, o, i, s) + 10))
              : ((c = this.maxHeight), (l = this._fitCols(a, o, i, s) + 10)),
            (this.width = Math.min(l, e.maxWidth || this.maxWidth)),
            (this.height = Math.min(c, e.maxHeight || this.maxHeight));
        }
        _fitRows(e, t, n, r) {
          const {
              ctx: o,
              maxWidth: a,
              options: {
                labels: { padding: i },
              },
            } = this,
            s = (this.legendHitBoxes = []),
            l = (this.lineWidths = [0]),
            c = r + i;
          let u = e;
          (o.textAlign = "left"), (o.textBaseline = "middle");
          let d = -1,
            p = -c;
          return (
            this.legendItems.forEach((e, m) => {
              const h = n + t / 2 + o.measureText(e.text).width;
              (0 === m || l[l.length - 1] + h + 2 * i > a) &&
                ((u += c), (l[l.length - (m > 0 ? 0 : 1)] = 0), (p += c), d++),
                (s[m] = { left: 0, top: p, row: d, width: h, height: r }),
                (l[l.length - 1] += h + i);
            }),
            u
          );
        }
        _fitCols(e, t, n, r) {
          const {
              ctx: o,
              maxHeight: a,
              options: {
                labels: { padding: i },
              },
            } = this,
            s = (this.legendHitBoxes = []),
            l = (this.columnSizes = []),
            c = a - e;
          let u = i,
            d = 0,
            p = 0,
            m = 0,
            h = 0;
          return (
            this.legendItems.forEach((e, a) => {
              const f = n + t / 2 + o.measureText(e.text).width;
              a > 0 &&
                p + r + 2 * i > c &&
                ((u += d + i),
                l.push({ width: d, height: p }),
                (m += d + i),
                h++,
                (d = p = 0)),
                (s[a] = { left: m, top: p, col: h, width: f, height: r }),
                (d = Math.max(d, f)),
                (p += r + i);
            }),
            (u += d),
            l.push({ width: d, height: p }),
            u
          );
        }
        adjustHitBoxes() {
          if (!this.options.display) return;
          const e = this._computeTitleHeight(),
            {
              legendHitBoxes: t,
              options: {
                align: n,
                labels: { padding: r },
                rtl: o,
              },
            } = this,
            a = fC(o, this.left, this.width);
          if (this.isHorizontal()) {
            let o = 0,
              i = my(n, this.left + r, this.right - this.lineWidths[o]);
            for (const s of t)
              o !== s.row &&
                ((o = s.row),
                (i = my(n, this.left + r, this.right - this.lineWidths[o]))),
                (s.top += this.top + e + r),
                (s.left = a.leftForLtr(a.x(i), s.width)),
                (i += s.width + r);
          } else {
            let o = 0,
              i = my(
                n,
                this.top + e + r,
                this.bottom - this.columnSizes[o].height
              );
            for (const s of t)
              s.col !== o &&
                ((o = s.col),
                (i = my(
                  n,
                  this.top + e + r,
                  this.bottom - this.columnSizes[o].height
                ))),
                (s.top = i),
                (s.left += this.left + r),
                (s.left = a.leftForLtr(a.x(s.left), s.width)),
                (i += s.height + r);
          }
        }
        isHorizontal() {
          return (
            "top" === this.options.position ||
            "bottom" === this.options.position
          );
        }
        draw() {
          if (this.options.display) {
            const e = this.ctx;
            px(e, this), this._draw(), mx(e);
          }
        }
        _draw() {
          const { options: e, columnSizes: t, lineWidths: n, ctx: r } = this,
            { align: o, labels: a } = e,
            i = ox.color,
            s = fC(e.rtl, this.left, this.width),
            l = Ox(a.font),
            { color: c, padding: u } = a,
            d = l.size,
            p = d / 2;
          let m;
          this.drawTitle(),
            (r.textAlign = s.textAlign("left")),
            (r.textBaseline = "middle"),
            (r.lineWidth = 0.5),
            (r.font = l.string);
          const { boxWidth: h, boxHeight: f, itemHeight: g } = Kk(a, d),
            v = this.isHorizontal(),
            b = this._computeTitleHeight();
          (m = v
            ? {
                x: my(o, this.left + u, this.right - n[0]),
                y: this.top + u + b,
                line: 0,
              }
            : {
                x: this.left + u,
                y: my(o, this.top + b + u, this.bottom - t[0].height),
                line: 0,
              }),
            gC(this.ctx, e.textDirection);
          const _ = g + u;
          this.legendItems.forEach((y, x) => {
            (r.strokeStyle = y.fontColor || c),
              (r.fillStyle = y.fontColor || c);
            const C = r.measureText(y.text).width,
              S = s.textAlign(y.textAlign || (y.textAlign = a.textAlign)),
              k = h + p + C;
            let w = m.x,
              P = m.y;
            s.setWidth(this.width),
              v
                ? x > 0 &&
                  w + k + u > this.right &&
                  ((P = m.y += _),
                  m.line++,
                  (w = m.x = my(o, this.left + u, this.right - n[m.line])))
                : x > 0 &&
                  P + _ > this.bottom &&
                  ((w = m.x = w + t[m.line].width + u),
                  m.line++,
                  (P = m.y =
                    my(o, this.top + b + u, this.bottom - t[m.line].height))),
              (function (e, t, n) {
                if (isNaN(h) || h <= 0 || isNaN(f) || f < 0) return;
                r.save();
                const o = v_(n.lineWidth, 1);
                if (
                  ((r.fillStyle = v_(n.fillStyle, i)),
                  (r.lineCap = v_(n.lineCap, "butt")),
                  (r.lineDashOffset = v_(n.lineDashOffset, 0)),
                  (r.lineJoin = v_(n.lineJoin, "miter")),
                  (r.lineWidth = o),
                  (r.strokeStyle = v_(n.strokeStyle, i)),
                  r.setLineDash(v_(n.lineDash, [])),
                  a.usePointStyle)
                ) {
                  const i = {
                      radius: (f * Math.SQRT2) / 2,
                      pointStyle: n.pointStyle,
                      rotation: n.rotation,
                      borderWidth: o,
                    },
                    l = s.xPlus(e, h / 2);
                  ux(r, i, l, t + p, a.pointStyleWidth && h);
                } else {
                  const a = t + Math.max((d - f) / 2, 0),
                    i = s.leftForLtr(e, h),
                    l = wx(n.borderRadius);
                  r.beginPath(),
                    Object.values(l).some((e) => 0 !== e)
                      ? bx(r, { x: i, y: a, w: h, h: f, radius: l })
                      : r.rect(i, a, h, f),
                    r.fill(),
                    0 !== o && r.stroke();
                }
                r.restore();
              })(s.x(w), P, y),
              (w = ((e, t, n, r) =>
                e === (r ? "left" : "right")
                  ? n
                  : "center" === e
                  ? (t + n) / 2
                  : t)(S, w + h + p, v ? w + k : this.right, e.rtl)),
              (function (e, t, n) {
                gx(r, n.text, e, t + g / 2, l, {
                  strikethrough: n.hidden,
                  textAlign: s.textAlign(n.textAlign),
                });
              })(s.x(w), P, y),
              v ? (m.x += k + u) : (m.y += _);
          }),
            vC(this.ctx, e.textDirection);
        }
        drawTitle() {
          const e = this.options,
            t = e.title,
            n = Ox(t.font),
            r = Px(t.padding);
          if (!t.display) return;
          const o = fC(e.rtl, this.left, this.width),
            a = this.ctx,
            i = t.position,
            s = n.size / 2,
            l = r.top + s;
          let c,
            u = this.left,
            d = this.width;
          if (this.isHorizontal())
            (d = Math.max(...this.lineWidths)),
              (c = this.top + l),
              (u = my(e.align, u, this.right - d));
          else {
            const t = this.columnSizes.reduce(
              (e, t) => Math.max(e, t.height),
              0
            );
            c =
              l +
              my(
                e.align,
                this.top,
                this.bottom - t - e.labels.padding - this._computeTitleHeight()
              );
          }
          const p = my(i, u, u + d);
          (a.textAlign = o.textAlign(py(i))),
            (a.textBaseline = "middle"),
            (a.strokeStyle = t.color),
            (a.fillStyle = t.color),
            (a.font = n.string),
            gx(a, t.text, p, c, n);
        }
        _computeTitleHeight() {
          const e = this.options.title,
            t = Ox(e.font),
            n = Px(e.padding);
          return e.display ? t.lineHeight + n.height : 0;
        }
        _getLegendItemAt(e, t) {
          let n, r, o;
          if (ry(e, this.left, this.right) && ry(t, this.top, this.bottom))
            for (o = this.legendHitBoxes, n = 0; n < o.length; ++n)
              if (
                ((r = o[n]),
                ry(e, r.left, r.left + r.width) &&
                  ry(t, r.top, r.top + r.height))
              )
                return this.legendItems[n];
          return null;
        }
        handleEvent(e) {
          const t = this.options;
          if (
            !(function (e, t) {
              return (
                !(
                  ("mousemove" !== e && "mouseout" !== e) ||
                  (!t.onHover && !t.onLeave)
                ) || !(!t.onClick || ("click" !== e && "mouseup" !== e))
              );
            })(e.type, t)
          )
            return;
          const n = this._getLegendItemAt(e.x, e.y);
          if ("mousemove" === e.type || "mouseout" === e.type) {
            const a = this._hoveredItem,
              i =
                ((o = n),
                null !== (r = a) &&
                  null !== o &&
                  r.datasetIndex === o.datasetIndex &&
                  r.index === o.index);
            a && !i && __(t.onLeave, [e, a, this], this),
              (this._hoveredItem = n),
              n && !i && __(t.onHover, [e, n, this], this);
          } else n && __(t.onClick, [e, n, this], this);
          var r, o;
        }
      }
      var qk = {
        id: "legend",
        _element: Gk,
        start(e, t, n) {
          const r = (e.legend = new Gk({ ctx: e.ctx, options: n, chart: e }));
          LS.configure(e, r, n), LS.addBox(e, r);
        },
        stop(e) {
          LS.removeBox(e, e.legend), delete e.legend;
        },
        beforeUpdate(e, t, n) {
          const r = e.legend;
          LS.configure(e, r, n), (r.options = n);
        },
        afterUpdate(e) {
          const t = e.legend;
          t.buildLabels(), t.adjustHitBoxes();
        },
        afterEvent(e, t) {
          t.replay || e.legend.handleEvent(t.event);
        },
        defaults: {
          display: !0,
          position: "top",
          align: "center",
          fullSize: !0,
          reverse: !1,
          weight: 1e3,
          onClick(e, t, n) {
            const r = t.datasetIndex,
              o = n.chart;
            o.isDatasetVisible(r)
              ? (o.hide(r), (t.hidden = !0))
              : (o.show(r), (t.hidden = !1));
          },
          onHover: null,
          onLeave: null,
          labels: {
            color: (e) => e.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels(e) {
              const t = e.data.datasets,
                {
                  labels: {
                    usePointStyle: n,
                    pointStyle: r,
                    textAlign: o,
                    color: a,
                  },
                } = e.legend.options;
              return e._getSortedDatasetMetas().map((e) => {
                const i = e.controller.getStyle(n ? 0 : void 0),
                  s = Px(i.borderWidth);
                return {
                  text: t[e.index].label,
                  fillStyle: i.backgroundColor,
                  fontColor: a,
                  hidden: !e.visible,
                  lineCap: i.borderCapStyle,
                  lineDash: i.borderDash,
                  lineDashOffset: i.borderDashOffset,
                  lineJoin: i.borderJoinStyle,
                  lineWidth: (s.width + s.height) / 4,
                  strokeStyle: i.borderColor,
                  pointStyle: r || i.pointStyle,
                  rotation: i.rotation,
                  textAlign: o || i.textAlign,
                  borderRadius: 0,
                  datasetIndex: e.index,
                };
              }, this);
            },
          },
          title: {
            color: (e) => e.chart.options.color,
            display: !1,
            position: "center",
            text: "",
          },
        },
        descriptors: {
          _scriptable: (e) => !e.startsWith("on"),
          labels: {
            _scriptable: (e) =>
              !["generateLabels", "filter", "sort"].includes(e),
          },
        },
      };
      class Yk extends nS {
        constructor(e) {
          super(),
            (this.chart = e.chart),
            (this.options = e.options),
            (this.ctx = e.ctx),
            (this._padding = void 0),
            (this.top = void 0),
            (this.bottom = void 0),
            (this.left = void 0),
            (this.right = void 0),
            (this.width = void 0),
            (this.height = void 0),
            (this.position = void 0),
            (this.weight = void 0),
            (this.fullSize = void 0);
        }
        update(e, t) {
          const n = this.options;
          if (((this.left = 0), (this.top = 0), !n.display))
            return void (this.width =
              this.height =
              this.right =
              this.bottom =
                0);
          (this.width = this.right = e), (this.height = this.bottom = t);
          const r = m_(n.text) ? n.text.length : 1;
          this._padding = Px(n.padding);
          const o = r * Ox(n.font).lineHeight + this._padding.height;
          this.isHorizontal() ? (this.height = o) : (this.width = o);
        }
        isHorizontal() {
          const e = this.options.position;
          return "top" === e || "bottom" === e;
        }
        _drawArgs(e) {
          const { top: t, left: n, bottom: r, right: o, options: a } = this,
            i = a.align;
          let s,
            l,
            c,
            u = 0;
          return (
            this.isHorizontal()
              ? ((l = my(i, n, o)), (c = t + e), (s = o - n))
              : ("left" === a.position
                  ? ((l = n + e), (c = my(i, r, t)), (u = -0.5 * R_))
                  : ((l = o - e), (c = my(i, t, r)), (u = 0.5 * R_)),
                (s = r - t)),
            { titleX: l, titleY: c, maxWidth: s, rotation: u }
          );
        }
        draw() {
          const e = this.ctx,
            t = this.options;
          if (!t.display) return;
          const n = Ox(t.font),
            r = n.lineHeight / 2 + this._padding.top,
            {
              titleX: o,
              titleY: a,
              maxWidth: i,
              rotation: s,
            } = this._drawArgs(r);
          gx(e, t.text, 0, 0, n, {
            color: t.color,
            maxWidth: i,
            rotation: s,
            textAlign: py(t.align),
            textBaseline: "middle",
            translation: [o, a],
          });
        }
      }
      var Jk = {
        id: "title",
        _element: Yk,
        start(e, t, n) {
          !(function (e, t) {
            const n = new Yk({ ctx: e.ctx, options: t, chart: e });
            LS.configure(e, n, t), LS.addBox(e, n), (e.titleBlock = n);
          })(e, n);
        },
        stop(e) {
          const t = e.titleBlock;
          LS.removeBox(e, t), delete e.titleBlock;
        },
        beforeUpdate(e, t, n) {
          const r = e.titleBlock;
          LS.configure(e, r, n), (r.options = n);
        },
        defaults: {
          align: "center",
          display: !1,
          font: { weight: "bold" },
          fullSize: !0,
          padding: 10,
          position: "top",
          text: "",
          weight: 2e3,
        },
        defaultRoutes: { color: "color" },
        descriptors: { _scriptable: !0, _indexable: !1 },
      };
      new WeakMap();
      const Qk = {
        average(e) {
          if (!e.length) return !1;
          let t,
            n,
            r = 0,
            o = 0,
            a = 0;
          for (t = 0, n = e.length; t < n; ++t) {
            const n = e[t].element;
            if (n && n.hasValue()) {
              const e = n.tooltipPosition();
              (r += e.x), (o += e.y), ++a;
            }
          }
          return { x: r / a, y: o / a };
        },
        nearest(e, t) {
          if (!e.length) return !1;
          let n,
            r,
            o,
            a = t.x,
            i = t.y,
            s = Number.POSITIVE_INFINITY;
          for (n = 0, r = e.length; n < r; ++n) {
            const r = e[n].element;
            if (r && r.hasValue()) {
              const e = Q_(t, r.getCenterPoint());
              e < s && ((s = e), (o = r));
            }
          }
          if (o) {
            const e = o.tooltipPosition();
            (a = e.x), (i = e.y);
          }
          return { x: a, y: i };
        },
      };
      function Xk(e, t) {
        return t && (m_(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
      }
      function ew(e) {
        return ("string" == typeof e || e instanceof String) &&
          e.indexOf("\n") > -1
          ? e.split("\n")
          : e;
      }
      function tw(e, t) {
        const { element: n, datasetIndex: r, index: o } = t,
          a = e.getDatasetMeta(r).controller,
          { label: i, value: s } = a.getLabelAndValue(o);
        return {
          chart: e,
          label: i,
          parsed: a.getParsed(o),
          raw: e.data.datasets[r].data[o],
          formattedValue: s,
          dataset: a.getDataset(),
          dataIndex: o,
          datasetIndex: r,
          element: n,
        };
      }
      function nw(e, t) {
        const n = e.chart.ctx,
          { body: r, footer: o, title: a } = e,
          { boxWidth: i, boxHeight: s } = t,
          l = Ox(t.bodyFont),
          c = Ox(t.titleFont),
          u = Ox(t.footerFont),
          d = a.length,
          p = o.length,
          m = r.length,
          h = Px(t.padding);
        let f = h.height,
          g = 0,
          v = r.reduce(
            (e, t) => e + t.before.length + t.lines.length + t.after.length,
            0
          );
        (v += e.beforeBody.length + e.afterBody.length),
          d &&
            (f +=
              d * c.lineHeight +
              (d - 1) * t.titleSpacing +
              t.titleMarginBottom),
          v &&
            (f +=
              m * (t.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight) +
              (v - m) * l.lineHeight +
              (v - 1) * t.bodySpacing),
          p &&
            (f +=
              t.footerMarginTop + p * u.lineHeight + (p - 1) * t.footerSpacing);
        let b = 0;
        const _ = function (e) {
          g = Math.max(g, n.measureText(e).width + b);
        };
        return (
          n.save(),
          (n.font = c.string),
          y_(e.title, _),
          (n.font = l.string),
          y_(e.beforeBody.concat(e.afterBody), _),
          (b = t.displayColors ? i + 2 + t.boxPadding : 0),
          y_(r, (e) => {
            y_(e.before, _), y_(e.lines, _), y_(e.after, _);
          }),
          (b = 0),
          (n.font = u.string),
          y_(e.footer, _),
          n.restore(),
          (g += h.width),
          { width: g, height: f }
        );
      }
      function rw(e, t, n, r) {
        const { x: o, width: a } = n,
          {
            width: i,
            chartArea: { left: s, right: l },
          } = e;
        let c = "center";
        return (
          "center" === r
            ? (c = o <= (s + l) / 2 ? "left" : "right")
            : o <= a / 2
            ? (c = "left")
            : o >= i - a / 2 && (c = "right"),
          (function (e, t, n, r) {
            const { x: o, width: a } = r,
              i = n.caretSize + n.caretPadding;
            return (
              ("left" === e && o + a + i > t.width) ||
              ("right" === e && o - a - i < 0) ||
              void 0
            );
          })(c, e, t, n) && (c = "center"),
          c
        );
      }
      function ow(e, t, n) {
        const r =
          n.yAlign ||
          t.yAlign ||
          (function (e, t) {
            const { y: n, height: r } = t;
            return n < r / 2
              ? "top"
              : n > e.height - r / 2
              ? "bottom"
              : "center";
          })(e, n);
        return { xAlign: n.xAlign || t.xAlign || rw(e, t, n, r), yAlign: r };
      }
      function aw(e, t, n, r) {
        const { caretSize: o, caretPadding: a, cornerRadius: i } = e,
          { xAlign: s, yAlign: l } = n,
          c = o + a,
          { topLeft: u, topRight: d, bottomLeft: p, bottomRight: m } = wx(i);
        let h = (function (e, t) {
          let { x: n, width: r } = e;
          return "right" === t ? (n -= r) : "center" === t && (n -= r / 2), n;
        })(t, s);
        const f = (function (e, t, n) {
          let { y: r, height: o } = e;
          return (
            "top" === t ? (r += n) : (r -= "bottom" === t ? o + n : o / 2), r
          );
        })(t, l, c);
        return (
          "center" === l
            ? "left" === s
              ? (h += c)
              : "right" === s && (h -= c)
            : "left" === s
            ? (h -= Math.max(u, p) + o)
            : "right" === s && (h += Math.max(d, m) + o),
          { x: ny(h, 0, r.width - t.width), y: ny(f, 0, r.height - t.height) }
        );
      }
      function iw(e, t, n) {
        const r = Px(n.padding);
        return "center" === t
          ? e.x + e.width / 2
          : "right" === t
          ? e.x + e.width - r.right
          : e.x + r.left;
      }
      function sw(e) {
        return Xk([], ew(e));
      }
      function lw(e, t) {
        const n =
          t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
        return n ? e.override(n) : e;
      }
      class cw extends nS {
        constructor(e) {
          super(),
            (this.opacity = 0),
            (this._active = []),
            (this._eventPosition = void 0),
            (this._size = void 0),
            (this._cachedAnimations = void 0),
            (this._tooltipItems = []),
            (this.$animations = void 0),
            (this.$context = void 0),
            (this.chart = e.chart || e._chart),
            (this._chart = this.chart),
            (this.options = e.options),
            (this.dataPoints = void 0),
            (this.title = void 0),
            (this.beforeBody = void 0),
            (this.body = void 0),
            (this.afterBody = void 0),
            (this.footer = void 0),
            (this.xAlign = void 0),
            (this.yAlign = void 0),
            (this.x = void 0),
            (this.y = void 0),
            (this.height = void 0),
            (this.width = void 0),
            (this.caretX = void 0),
            (this.caretY = void 0),
            (this.labelColors = void 0),
            (this.labelPointStyles = void 0),
            (this.labelTextColors = void 0);
        }
        initialize(e) {
          (this.options = e),
            (this._cachedAnimations = void 0),
            (this.$context = void 0);
        }
        _resolveAnimations() {
          const e = this._cachedAnimations;
          if (e) return e;
          const t = this.chart,
            n = this.options.setContext(this.getContext()),
            r = n.enabled && t.options.animation && n.animations,
            o = new IC(this.chart, r);
          return r._cacheable && (this._cachedAnimations = Object.freeze(o)), o;
        }
        getContext() {
          return (
            this.$context ||
            (this.$context =
              (this,
              Tx(this.chart.getContext(), {
                tooltip: this,
                tooltipItems: this._tooltipItems,
                type: "tooltip",
              })))
          );
        }
        getTitle(e, t) {
          const { callbacks: n } = t,
            r = n.beforeTitle.apply(this, [e]),
            o = n.title.apply(this, [e]),
            a = n.afterTitle.apply(this, [e]);
          let i = [];
          return (i = Xk(i, ew(r))), (i = Xk(i, ew(o))), (i = Xk(i, ew(a))), i;
        }
        getBeforeBody(e, t) {
          return sw(t.callbacks.beforeBody.apply(this, [e]));
        }
        getBody(e, t) {
          const { callbacks: n } = t,
            r = [];
          return (
            y_(e, (e) => {
              const t = { before: [], lines: [], after: [] },
                o = lw(n, e);
              Xk(t.before, ew(o.beforeLabel.call(this, e))),
                Xk(t.lines, o.label.call(this, e)),
                Xk(t.after, ew(o.afterLabel.call(this, e))),
                r.push(t);
            }),
            r
          );
        }
        getAfterBody(e, t) {
          return sw(t.callbacks.afterBody.apply(this, [e]));
        }
        getFooter(e, t) {
          const { callbacks: n } = t,
            r = n.beforeFooter.apply(this, [e]),
            o = n.footer.apply(this, [e]),
            a = n.afterFooter.apply(this, [e]);
          let i = [];
          return (i = Xk(i, ew(r))), (i = Xk(i, ew(o))), (i = Xk(i, ew(a))), i;
        }
        _createItems(e) {
          const t = this._active,
            n = this.chart.data,
            r = [],
            o = [],
            a = [];
          let i,
            s,
            l = [];
          for (i = 0, s = t.length; i < s; ++i) l.push(tw(this.chart, t[i]));
          return (
            e.filter && (l = l.filter((t, r, o) => e.filter(t, r, o, n))),
            e.itemSort && (l = l.sort((t, r) => e.itemSort(t, r, n))),
            y_(l, (t) => {
              const n = lw(e.callbacks, t);
              r.push(n.labelColor.call(this, t)),
                o.push(n.labelPointStyle.call(this, t)),
                a.push(n.labelTextColor.call(this, t));
            }),
            (this.labelColors = r),
            (this.labelPointStyles = o),
            (this.labelTextColors = a),
            (this.dataPoints = l),
            l
          );
        }
        update(e, t) {
          const n = this.options.setContext(this.getContext()),
            r = this._active;
          let o,
            a = [];
          if (r.length) {
            const e = Qk[n.position].call(this, r, this._eventPosition);
            (a = this._createItems(n)),
              (this.title = this.getTitle(a, n)),
              (this.beforeBody = this.getBeforeBody(a, n)),
              (this.body = this.getBody(a, n)),
              (this.afterBody = this.getAfterBody(a, n)),
              (this.footer = this.getFooter(a, n));
            const t = (this._size = nw(this, n)),
              i = Object.assign({}, e, t),
              s = ow(this.chart, n, i),
              l = aw(n, i, s, this.chart);
            (this.xAlign = s.xAlign),
              (this.yAlign = s.yAlign),
              (o = {
                opacity: 1,
                x: l.x,
                y: l.y,
                width: t.width,
                height: t.height,
                caretX: e.x,
                caretY: e.y,
              });
          } else 0 !== this.opacity && (o = { opacity: 0 });
          (this._tooltipItems = a),
            (this.$context = void 0),
            o && this._resolveAnimations().update(this, o),
            e &&
              n.external &&
              n.external.call(this, {
                chart: this.chart,
                tooltip: this,
                replay: t,
              });
        }
        drawCaret(e, t, n, r) {
          const o = this.getCaretPosition(e, n, r);
          t.lineTo(o.x1, o.y1), t.lineTo(o.x2, o.y2), t.lineTo(o.x3, o.y3);
        }
        getCaretPosition(e, t, n) {
          const { xAlign: r, yAlign: o } = this,
            { caretSize: a, cornerRadius: i } = n,
            { topLeft: s, topRight: l, bottomLeft: c, bottomRight: u } = wx(i),
            { x: d, y: p } = e,
            { width: m, height: h } = t;
          let f, g, v, b, _, y;
          return (
            "center" === o
              ? ((_ = p + h / 2),
                "left" === r
                  ? ((f = d), (g = f - a), (b = _ + a), (y = _ - a))
                  : ((f = d + m), (g = f + a), (b = _ - a), (y = _ + a)),
                (v = f))
              : ((g =
                  "left" === r
                    ? d + Math.max(s, c) + a
                    : "right" === r
                    ? d + m - Math.max(l, u) - a
                    : this.caretX),
                "top" === o
                  ? ((b = p), (_ = b - a), (f = g - a), (v = g + a))
                  : ((b = p + h), (_ = b + a), (f = g + a), (v = g - a)),
                (y = b)),
            { x1: f, x2: g, x3: v, y1: b, y2: _, y3: y }
          );
        }
        drawTitle(e, t, n) {
          const r = this.title,
            o = r.length;
          let a, i, s;
          if (o) {
            const l = fC(n.rtl, this.x, this.width);
            for (
              e.x = iw(this, n.titleAlign, n),
                t.textAlign = l.textAlign(n.titleAlign),
                t.textBaseline = "middle",
                a = Ox(n.titleFont),
                i = n.titleSpacing,
                t.fillStyle = n.titleColor,
                t.font = a.string,
                s = 0;
              s < o;
              ++s
            )
              t.fillText(r[s], l.x(e.x), e.y + a.lineHeight / 2),
                (e.y += a.lineHeight + i),
                s + 1 === o && (e.y += n.titleMarginBottom - i);
          }
        }
        _drawColorBox(e, t, n, r, o) {
          const a = this.labelColors[n],
            i = this.labelPointStyles[n],
            { boxHeight: s, boxWidth: l, boxPadding: c } = o,
            u = Ox(o.bodyFont),
            d = iw(this, "left", o),
            p = r.x(d),
            m = s < u.lineHeight ? (u.lineHeight - s) / 2 : 0,
            h = t.y + m;
          if (o.usePointStyle) {
            const t = {
                radius: Math.min(l, s) / 2,
                pointStyle: i.pointStyle,
                rotation: i.rotation,
                borderWidth: 1,
              },
              n = r.leftForLtr(p, l) + l / 2,
              c = h + s / 2;
            (e.strokeStyle = o.multiKeyBackground),
              (e.fillStyle = o.multiKeyBackground),
              cx(e, t, n, c),
              (e.strokeStyle = a.borderColor),
              (e.fillStyle = a.backgroundColor),
              cx(e, t, n, c);
          } else {
            (e.lineWidth = h_(a.borderWidth)
              ? Math.max(...Object.values(a.borderWidth))
              : a.borderWidth || 1),
              (e.strokeStyle = a.borderColor),
              e.setLineDash(a.borderDash || []),
              (e.lineDashOffset = a.borderDashOffset || 0);
            const t = r.leftForLtr(p, l - c),
              n = r.leftForLtr(r.xPlus(p, 1), l - c - 2),
              i = wx(a.borderRadius);
            Object.values(i).some((e) => 0 !== e)
              ? (e.beginPath(),
                (e.fillStyle = o.multiKeyBackground),
                bx(e, { x: t, y: h, w: l, h: s, radius: i }),
                e.fill(),
                e.stroke(),
                (e.fillStyle = a.backgroundColor),
                e.beginPath(),
                bx(e, { x: n, y: h + 1, w: l - 2, h: s - 2, radius: i }),
                e.fill())
              : ((e.fillStyle = o.multiKeyBackground),
                e.fillRect(t, h, l, s),
                e.strokeRect(t, h, l, s),
                (e.fillStyle = a.backgroundColor),
                e.fillRect(n, h + 1, l - 2, s - 2));
          }
          e.fillStyle = this.labelTextColors[n];
        }
        drawBody(e, t, n) {
          const { body: r } = this,
            {
              bodySpacing: o,
              bodyAlign: a,
              displayColors: i,
              boxHeight: s,
              boxWidth: l,
              boxPadding: c,
            } = n,
            u = Ox(n.bodyFont);
          let d = u.lineHeight,
            p = 0;
          const m = fC(n.rtl, this.x, this.width),
            h = function (n) {
              t.fillText(n, m.x(e.x + p), e.y + d / 2), (e.y += d + o);
            },
            f = m.textAlign(a);
          let g, v, b, _, y, x, C;
          for (
            t.textAlign = a,
              t.textBaseline = "middle",
              t.font = u.string,
              e.x = iw(this, f, n),
              t.fillStyle = n.bodyColor,
              y_(this.beforeBody, h),
              p =
                i && "right" !== f
                  ? "center" === a
                    ? l / 2 + c
                    : l + 2 + c
                  : 0,
              _ = 0,
              x = r.length;
            _ < x;
            ++_
          ) {
            for (
              g = r[_],
                v = this.labelTextColors[_],
                t.fillStyle = v,
                y_(g.before, h),
                b = g.lines,
                i &&
                  b.length &&
                  (this._drawColorBox(t, e, _, m, n),
                  (d = Math.max(u.lineHeight, s))),
                y = 0,
                C = b.length;
              y < C;
              ++y
            )
              h(b[y]), (d = u.lineHeight);
            y_(g.after, h);
          }
          (p = 0), (d = u.lineHeight), y_(this.afterBody, h), (e.y -= o);
        }
        drawFooter(e, t, n) {
          const r = this.footer,
            o = r.length;
          let a, i;
          if (o) {
            const s = fC(n.rtl, this.x, this.width);
            for (
              e.x = iw(this, n.footerAlign, n),
                e.y += n.footerMarginTop,
                t.textAlign = s.textAlign(n.footerAlign),
                t.textBaseline = "middle",
                a = Ox(n.footerFont),
                t.fillStyle = n.footerColor,
                t.font = a.string,
                i = 0;
              i < o;
              ++i
            )
              t.fillText(r[i], s.x(e.x), e.y + a.lineHeight / 2),
                (e.y += a.lineHeight + n.footerSpacing);
          }
        }
        drawBackground(e, t, n, r) {
          const { xAlign: o, yAlign: a } = this,
            { x: i, y: s } = e,
            { width: l, height: c } = n,
            {
              topLeft: u,
              topRight: d,
              bottomLeft: p,
              bottomRight: m,
            } = wx(r.cornerRadius);
          (t.fillStyle = r.backgroundColor),
            (t.strokeStyle = r.borderColor),
            (t.lineWidth = r.borderWidth),
            t.beginPath(),
            t.moveTo(i + u, s),
            "top" === a && this.drawCaret(e, t, n, r),
            t.lineTo(i + l - d, s),
            t.quadraticCurveTo(i + l, s, i + l, s + d),
            "center" === a && "right" === o && this.drawCaret(e, t, n, r),
            t.lineTo(i + l, s + c - m),
            t.quadraticCurveTo(i + l, s + c, i + l - m, s + c),
            "bottom" === a && this.drawCaret(e, t, n, r),
            t.lineTo(i + p, s + c),
            t.quadraticCurveTo(i, s + c, i, s + c - p),
            "center" === a && "left" === o && this.drawCaret(e, t, n, r),
            t.lineTo(i, s + u),
            t.quadraticCurveTo(i, s, i + u, s),
            t.closePath(),
            t.fill(),
            r.borderWidth > 0 && t.stroke();
        }
        _updateAnimationTarget(e) {
          const t = this.chart,
            n = this.$animations,
            r = n && n.x,
            o = n && n.y;
          if (r || o) {
            const n = Qk[e.position].call(
              this,
              this._active,
              this._eventPosition
            );
            if (!n) return;
            const a = (this._size = nw(this, e)),
              i = Object.assign({}, n, this._size),
              s = ow(t, e, i),
              l = aw(e, i, s, t);
            (r._to === l.x && o._to === l.y) ||
              ((this.xAlign = s.xAlign),
              (this.yAlign = s.yAlign),
              (this.width = a.width),
              (this.height = a.height),
              (this.caretX = n.x),
              (this.caretY = n.y),
              this._resolveAnimations().update(this, l));
          }
        }
        _willRender() {
          return !!this.opacity;
        }
        draw(e) {
          const t = this.options.setContext(this.getContext());
          let n = this.opacity;
          if (!n) return;
          this._updateAnimationTarget(t);
          const r = { width: this.width, height: this.height },
            o = { x: this.x, y: this.y };
          n = Math.abs(n) < 0.001 ? 0 : n;
          const a = Px(t.padding),
            i =
              this.title.length ||
              this.beforeBody.length ||
              this.body.length ||
              this.afterBody.length ||
              this.footer.length;
          t.enabled &&
            i &&
            (e.save(),
            (e.globalAlpha = n),
            this.drawBackground(o, e, r, t),
            gC(e, t.textDirection),
            (o.y += a.top),
            this.drawTitle(o, e, t),
            this.drawBody(o, e, t),
            this.drawFooter(o, e, t),
            vC(e, t.textDirection),
            e.restore());
        }
        getActiveElements() {
          return this._active || [];
        }
        setActiveElements(e, t) {
          const n = this._active,
            r = e.map(({ datasetIndex: e, index: t }) => {
              const n = this.chart.getDatasetMeta(e);
              if (!n) throw new Error("Cannot find a dataset at index " + e);
              return { datasetIndex: e, element: n.data[t], index: t };
            }),
            o = !x_(n, r),
            a = this._positionChanged(r, t);
          (o || a) &&
            ((this._active = r),
            (this._eventPosition = t),
            (this._ignoreReplayEvents = !0),
            this.update(!0));
        }
        handleEvent(e, t, n = !0) {
          if (t && this._ignoreReplayEvents) return !1;
          this._ignoreReplayEvents = !1;
          const r = this.options,
            o = this._active || [],
            a = this._getActiveElements(e, o, t, n),
            i = this._positionChanged(a, e),
            s = t || !x_(a, o) || i;
          return (
            s &&
              ((this._active = a),
              (r.enabled || r.external) &&
                ((this._eventPosition = { x: e.x, y: e.y }),
                this.update(!0, t))),
            s
          );
        }
        _getActiveElements(e, t, n, r) {
          const o = this.options;
          if ("mouseout" === e.type) return [];
          if (!r) return t;
          const a = this.chart.getElementsAtEventForMode(e, o.mode, o, n);
          return o.reverse && a.reverse(), a;
        }
        _positionChanged(e, t) {
          const { caretX: n, caretY: r, options: o } = this,
            a = Qk[o.position].call(this, e, t);
          return !1 !== a && (n !== a.x || r !== a.y);
        }
      }
      cw.positioners = Qk;
      var uw = {
        id: "tooltip",
        _element: cw,
        positioners: Qk,
        afterInit(e, t, n) {
          n && (e.tooltip = new cw({ chart: e, options: n }));
        },
        beforeUpdate(e, t, n) {
          e.tooltip && e.tooltip.initialize(n);
        },
        reset(e, t, n) {
          e.tooltip && e.tooltip.initialize(n);
        },
        afterDraw(e) {
          const t = e.tooltip;
          if (t && t._willRender()) {
            const n = { tooltip: t };
            if (!1 === e.notifyPlugins("beforeTooltipDraw", n)) return;
            t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
          }
        },
        afterEvent(e, t) {
          if (e.tooltip) {
            const n = t.replay;
            e.tooltip.handleEvent(t.event, n, t.inChartArea) &&
              (t.changed = !0);
          }
        },
        defaults: {
          enabled: !0,
          external: null,
          position: "average",
          backgroundColor: "rgba(0,0,0,0.8)",
          titleColor: "#fff",
          titleFont: { weight: "bold" },
          titleSpacing: 2,
          titleMarginBottom: 6,
          titleAlign: "left",
          bodyColor: "#fff",
          bodySpacing: 2,
          bodyFont: {},
          bodyAlign: "left",
          footerColor: "#fff",
          footerSpacing: 2,
          footerMarginTop: 6,
          footerFont: { weight: "bold" },
          footerAlign: "left",
          padding: 6,
          caretPadding: 2,
          caretSize: 5,
          cornerRadius: 6,
          boxHeight: (e, t) => t.bodyFont.size,
          boxWidth: (e, t) => t.bodyFont.size,
          multiKeyBackground: "#fff",
          displayColors: !0,
          boxPadding: 0,
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          animation: { duration: 400, easing: "easeOutQuart" },
          animations: {
            numbers: {
              type: "number",
              properties: ["x", "y", "width", "height", "caretX", "caretY"],
            },
            opacity: { easing: "linear", duration: 200 },
          },
          callbacks: {
            beforeTitle: u_,
            title(e) {
              if (e.length > 0) {
                const t = e[0],
                  n = t.chart.data.labels,
                  r = n ? n.length : 0;
                if (this && this.options && "dataset" === this.options.mode)
                  return t.dataset.label || "";
                if (t.label) return t.label;
                if (r > 0 && t.dataIndex < r) return n[t.dataIndex];
              }
              return "";
            },
            afterTitle: u_,
            beforeBody: u_,
            beforeLabel: u_,
            label(e) {
              if (this && this.options && "dataset" === this.options.mode)
                return e.label + ": " + e.formattedValue || e.formattedValue;
              let t = e.dataset.label || "";
              t && (t += ": ");
              const n = e.formattedValue;
              return p_(n) || (t += n), t;
            },
            labelColor(e) {
              const t = e.chart
                .getDatasetMeta(e.datasetIndex)
                .controller.getStyle(e.dataIndex);
              return {
                borderColor: t.borderColor,
                backgroundColor: t.backgroundColor,
                borderWidth: t.borderWidth,
                borderDash: t.borderDash,
                borderDashOffset: t.borderDashOffset,
                borderRadius: 0,
              };
            },
            labelTextColor() {
              return this.options.bodyColor;
            },
            labelPointStyle(e) {
              const t = e.chart
                .getDatasetMeta(e.datasetIndex)
                .controller.getStyle(e.dataIndex);
              return { pointStyle: t.pointStyle, rotation: t.rotation };
            },
            afterLabel: u_,
            afterBody: u_,
            beforeFooter: u_,
            footer: u_,
            afterFooter: u_,
          },
        },
        defaultRoutes: {
          bodyFont: "font",
          footerFont: "font",
          titleFont: "font",
        },
        descriptors: {
          _scriptable: (e) =>
            "filter" !== e && "itemSort" !== e && "external" !== e,
          _indexable: !1,
          callbacks: { _scriptable: !1, _indexable: !1 },
          animation: { _fallback: !1 },
          animations: { _fallback: "animation" },
        },
        additionalOptionScopes: ["interaction"],
      };
      class dw extends mS {
        constructor(e) {
          super(e),
            (this._startValue = void 0),
            (this._valueRange = 0),
            (this._addedLabels = []);
        }
        init(e) {
          const t = this._addedLabels;
          if (t.length) {
            const e = this.getLabels();
            for (const { index: n, label: r } of t)
              e[n] === r && e.splice(n, 1);
            this._addedLabels = [];
          }
          super.init(e);
        }
        parse(e, t) {
          if (p_(e)) return null;
          const n = this.getLabels();
          return (
            (t =
              isFinite(t) && n[t] === e
                ? t
                : (function (e, t, n, r) {
                    const o = e.indexOf(t);
                    return -1 === o
                      ? ((e, t, n, r) => (
                          "string" == typeof t
                            ? ((n = e.push(t) - 1),
                              r.unshift({ index: n, label: t }))
                            : isNaN(t) && (n = null),
                          n
                        ))(e, t, n, r)
                      : o !== e.lastIndexOf(t)
                      ? n
                      : o;
                  })(n, e, v_(t, e), this._addedLabels)),
            ((e, t) => (null === e ? null : ny(Math.round(e), 0, t)))(
              t,
              n.length - 1
            )
          );
        }
        determineDataLimits() {
          const { minDefined: e, maxDefined: t } = this.getUserBounds();
          let { min: n, max: r } = this.getMinMax(!0);
          "ticks" === this.options.bounds &&
            (e || (n = 0), t || (r = this.getLabels().length - 1)),
            (this.min = n),
            (this.max = r);
        }
        buildTicks() {
          const e = this.min,
            t = this.max,
            n = this.options.offset,
            r = [];
          let o = this.getLabels();
          (o = 0 === e && t === o.length - 1 ? o : o.slice(e, t + 1)),
            (this._valueRange = Math.max(o.length - (n ? 0 : 1), 1)),
            (this._startValue = this.min - (n ? 0.5 : 0));
          for (let n = e; n <= t; n++) r.push({ value: n });
          return r;
        }
        getLabelForValue(e) {
          const t = this.getLabels();
          return e >= 0 && e < t.length ? t[e] : e;
        }
        configure() {
          super.configure(),
            this.isHorizontal() || (this._reversePixels = !this._reversePixels);
        }
        getPixelForValue(e) {
          return (
            "number" != typeof e && (e = this.parse(e)),
            null === e
              ? NaN
              : this.getPixelForDecimal(
                  (e - this._startValue) / this._valueRange
                )
          );
        }
        getPixelForTick(e) {
          const t = this.ticks;
          return e < 0 || e > t.length - 1
            ? null
            : this.getPixelForValue(t[e].value);
        }
        getValueForPixel(e) {
          return Math.round(
            this._startValue + this.getDecimalForPixel(e) * this._valueRange
          );
        }
        getBasePixel() {
          return this.bottom;
        }
      }
      function pw(e, t, { horizontal: n, minRotation: r }) {
        const o = G_(r),
          a = (n ? Math.sin(o) : Math.cos(o)) || 0.001,
          i = 0.75 * t * ("" + e).length;
        return Math.min(t / a, i);
      }
      (dw.id = "category"),
        (dw.defaults = { ticks: { callback: dw.prototype.getLabelForValue } });
      class mw extends mS {
        constructor(e) {
          super(e),
            (this.start = void 0),
            (this.end = void 0),
            (this._startValue = void 0),
            (this._endValue = void 0),
            (this._valueRange = 0);
        }
        parse(e, t) {
          return p_(e) ||
            (("number" == typeof e || e instanceof Number) && !isFinite(+e))
            ? null
            : +e;
        }
        handleTickRangeOptions() {
          const { beginAtZero: e } = this.options,
            { minDefined: t, maxDefined: n } = this.getUserBounds();
          let { min: r, max: o } = this;
          const a = (e) => (r = t ? r : e),
            i = (e) => (o = n ? o : e);
          if (e) {
            const e = V_(r),
              t = V_(o);
            e < 0 && t < 0 ? i(0) : e > 0 && t > 0 && a(0);
          }
          if (r === o) {
            let t = 1;
            (o >= Number.MAX_SAFE_INTEGER || r <= Number.MIN_SAFE_INTEGER) &&
              (t = Math.abs(0.05 * o)),
              i(o + t),
              e || a(r - t);
          }
          (this.min = r), (this.max = o);
        }
        getTickLimit() {
          const e = this.options.ticks;
          let t,
            { maxTicksLimit: n, stepSize: r } = e;
          return (
            r
              ? ((t = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1),
                t > 1e3 &&
                  (console.warn(
                    `scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${t} ticks. Limiting to 1000.`
                  ),
                  (t = 1e3)))
              : ((t = this.computeTickLimit()), (n = n || 11)),
            n && (t = Math.min(n, t)),
            t
          );
        }
        computeTickLimit() {
          return Number.POSITIVE_INFINITY;
        }
        buildTicks() {
          const e = this.options,
            t = e.ticks;
          let n = this.getTickLimit();
          n = Math.max(2, n);
          const r = (function (e, t) {
            const n = [],
              {
                bounds: r,
                step: o,
                min: a,
                max: i,
                precision: s,
                count: l,
                maxTicks: c,
                maxDigits: u,
                includeBounds: d,
              } = e,
              p = o || 1,
              m = c - 1,
              { min: h, max: f } = t,
              g = !p_(a),
              v = !p_(i),
              b = !p_(l),
              _ = (f - h) / (u + 1);
            let y,
              x,
              C,
              S,
              k = W_((f - h) / m / p) * p;
            if (k < 1e-14 && !g && !v) return [{ value: h }, { value: f }];
            (S = Math.ceil(f / k) - Math.floor(h / k)),
              S > m && (k = W_((S * k) / m / p) * p),
              p_(s) || ((y = Math.pow(10, s)), (k = Math.ceil(k * y) / y)),
              "ticks" === r
                ? ((x = Math.floor(h / k) * k), (C = Math.ceil(f / k) * k))
                : ((x = h), (C = f)),
              g &&
              v &&
              o &&
              (function (e, t) {
                const n = Math.round(e);
                return n - t <= e && n + t >= e;
              })((i - a) / o, k / 1e3)
                ? ((S = Math.round(Math.min((i - a) / k, c))),
                  (k = (i - a) / S),
                  (x = a),
                  (C = i))
                : b
                ? ((x = g ? a : x),
                  (C = v ? i : C),
                  (S = l - 1),
                  (k = (C - x) / S))
                : ((S = (C - x) / k),
                  (S = U_(S, Math.round(S), k / 1e3)
                    ? Math.round(S)
                    : Math.ceil(S)));
            const w = Math.max(Y_(k), Y_(x));
            (y = Math.pow(10, p_(s) ? w : s)),
              (x = Math.round(x * y) / y),
              (C = Math.round(C * y) / y);
            let P = 0;
            for (
              g &&
              (d && x !== a
                ? (n.push({ value: a }),
                  x < a && P++,
                  U_(Math.round((x + P * k) * y) / y, a, pw(a, _, e)) && P++)
                : x < a && P++);
              P < S;
              ++P
            )
              n.push({ value: Math.round((x + P * k) * y) / y });
            return (
              v && d && C !== i
                ? n.length && U_(n[n.length - 1].value, i, pw(i, _, e))
                  ? (n[n.length - 1].value = i)
                  : n.push({ value: i })
                : (v && C !== i) || n.push({ value: C }),
              n
            );
          })(
            {
              maxTicks: n,
              bounds: e.bounds,
              min: e.min,
              max: e.max,
              precision: t.precision,
              step: t.stepSize,
              count: t.count,
              maxDigits: this._maxDigits(),
              horizontal: this.isHorizontal(),
              minRotation: t.minRotation || 0,
              includeBounds: !1 !== t.includeBounds,
            },
            this._range || this
          );
          return (
            "ticks" === e.bounds && K_(r, this, "value"),
            e.reverse
              ? (r.reverse(), (this.start = this.max), (this.end = this.min))
              : ((this.start = this.min), (this.end = this.max)),
            r
          );
        }
        configure() {
          const e = this.ticks;
          let t = this.min,
            n = this.max;
          if ((super.configure(), this.options.offset && e.length)) {
            const r = (n - t) / Math.max(e.length - 1, 1) / 2;
            (t -= r), (n += r);
          }
          (this._startValue = t),
            (this._endValue = n),
            (this._valueRange = n - t);
        }
        getLabelForValue(e) {
          return pC(e, this.chart.options.locale, this.options.ticks.format);
        }
      }
      class hw extends mw {
        determineDataLimits() {
          const { min: e, max: t } = this.getMinMax(!0);
          (this.min = f_(e) ? e : 0),
            (this.max = f_(t) ? t : 1),
            this.handleTickRangeOptions();
        }
        computeTickLimit() {
          const e = this.isHorizontal(),
            t = e ? this.width : this.height,
            n = G_(this.options.ticks.minRotation),
            r = (e ? Math.sin(n) : Math.cos(n)) || 0.001,
            o = this._resolveTickFontOptions(0);
          return Math.ceil(t / Math.min(40, o.lineHeight / r));
        }
        getPixelForValue(e) {
          return null === e
            ? NaN
            : this.getPixelForDecimal(
                (e - this._startValue) / this._valueRange
              );
        }
        getValueForPixel(e) {
          return (
            this._startValue + this.getDecimalForPixel(e) * this._valueRange
          );
        }
      }
      function fw(e) {
        return 1 == e / Math.pow(10, Math.floor(H_(e)));
      }
      (hw.id = "linear"),
        (hw.defaults = { ticks: { callback: oS.formatters.numeric } });
      class gw extends mS {
        constructor(e) {
          super(e),
            (this.start = void 0),
            (this.end = void 0),
            (this._startValue = void 0),
            (this._valueRange = 0);
        }
        parse(e, t) {
          const n = mw.prototype.parse.apply(this, [e, t]);
          if (0 !== n) return f_(n) && n > 0 ? n : null;
          this._zero = !0;
        }
        determineDataLimits() {
          const { min: e, max: t } = this.getMinMax(!0);
          (this.min = f_(e) ? Math.max(0, e) : null),
            (this.max = f_(t) ? Math.max(0, t) : null),
            this.options.beginAtZero && (this._zero = !0),
            this.handleTickRangeOptions();
        }
        handleTickRangeOptions() {
          const { minDefined: e, maxDefined: t } = this.getUserBounds();
          let n = this.min,
            r = this.max;
          const o = (t) => (n = e ? n : t),
            a = (e) => (r = t ? r : e),
            i = (e, t) => Math.pow(10, Math.floor(H_(e)) + t);
          n === r && (n <= 0 ? (o(1), a(10)) : (o(i(n, -1)), a(i(r, 1)))),
            n <= 0 && o(i(r, -1)),
            r <= 0 && a(i(n, 1)),
            this._zero &&
              this.min !== this._suggestedMin &&
              n === i(this.min, 0) &&
              o(i(n, -1)),
            (this.min = n),
            (this.max = r);
        }
        buildTicks() {
          const e = this.options,
            t = (function (e, t) {
              const n = Math.floor(H_(t.max)),
                r = Math.ceil(t.max / Math.pow(10, n)),
                o = [];
              let a = g_(e.min, Math.pow(10, Math.floor(H_(t.min)))),
                i = Math.floor(H_(a)),
                s = Math.floor(a / Math.pow(10, i)),
                l = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
              do {
                o.push({ value: a, major: fw(a) }),
                  ++s,
                  10 === s && ((s = 1), ++i, (l = i >= 0 ? 1 : l)),
                  (a = Math.round(s * Math.pow(10, i) * l) / l);
              } while (i < n || (i === n && s < r));
              const c = g_(e.max, a);
              return o.push({ value: c, major: fw(a) }), o;
            })({ min: this._userMin, max: this._userMax }, this);
          return (
            "ticks" === e.bounds && K_(t, this, "value"),
            e.reverse
              ? (t.reverse(), (this.start = this.max), (this.end = this.min))
              : ((this.start = this.min), (this.end = this.max)),
            t
          );
        }
        getLabelForValue(e) {
          return void 0 === e
            ? "0"
            : pC(e, this.chart.options.locale, this.options.ticks.format);
        }
        configure() {
          const e = this.min;
          super.configure(),
            (this._startValue = H_(e)),
            (this._valueRange = H_(this.max) - H_(e));
        }
        getPixelForValue(e) {
          return (
            (void 0 !== e && 0 !== e) || (e = this.min),
            null === e || isNaN(e)
              ? NaN
              : this.getPixelForDecimal(
                  e === this.min
                    ? 0
                    : (H_(e) - this._startValue) / this._valueRange
                )
          );
        }
        getValueForPixel(e) {
          const t = this.getDecimalForPixel(e);
          return Math.pow(10, this._startValue + t * this._valueRange);
        }
      }
      function vw(e) {
        const t = e.ticks;
        if (t.display && e.display) {
          const e = Px(t.backdropPadding);
          return v_(t.font && t.font.size, ox.font.size) + e.height;
        }
        return 0;
      }
      function bw(e, t, n, r, o) {
        return e === r || e === o
          ? { start: t - n / 2, end: t + n / 2 }
          : e < r || e > o
          ? { start: t - n, end: t }
          : { start: t, end: t + n };
      }
      function _w(e, t, n, r, o) {
        const a = Math.abs(Math.sin(n)),
          i = Math.abs(Math.cos(n));
        let s = 0,
          l = 0;
        r.start < t.l
          ? ((s = (t.l - r.start) / a), (e.l = Math.min(e.l, t.l - s)))
          : r.end > t.r &&
            ((s = (r.end - t.r) / a), (e.r = Math.max(e.r, t.r + s))),
          o.start < t.t
            ? ((l = (t.t - o.start) / i), (e.t = Math.min(e.t, t.t - l)))
            : o.end > t.b &&
              ((l = (o.end - t.b) / i), (e.b = Math.max(e.b, t.b + l)));
      }
      function yw(e) {
        return 0 === e || 180 === e ? "center" : e < 180 ? "left" : "right";
      }
      function xw(e, t, n) {
        return (
          90 === n || 270 === n
            ? (e -= t / 2)
            : (n > 270 || n < 90) && (e -= t),
          e
        );
      }
      function Cw(e, t, n, r) {
        const { ctx: o } = e;
        if (n) o.arc(e.xCenter, e.yCenter, t, 0, N_);
        else {
          let n = e.getPointPosition(0, t);
          o.moveTo(n.x, n.y);
          for (let a = 1; a < r; a++)
            (n = e.getPointPosition(a, t)), o.lineTo(n.x, n.y);
        }
      }
      (gw.id = "logarithmic"),
        (gw.defaults = {
          ticks: {
            callback: oS.formatters.logarithmic,
            major: { enabled: !0 },
          },
        });
      class Sw extends mw {
        constructor(e) {
          super(e),
            (this.xCenter = void 0),
            (this.yCenter = void 0),
            (this.drawingArea = void 0),
            (this._pointLabels = []),
            (this._pointLabelItems = []);
        }
        setDimensions() {
          const e = (this._padding = Px(vw(this.options) / 2)),
            t = (this.width = this.maxWidth - e.width),
            n = (this.height = this.maxHeight - e.height);
          (this.xCenter = Math.floor(this.left + t / 2 + e.left)),
            (this.yCenter = Math.floor(this.top + n / 2 + e.top)),
            (this.drawingArea = Math.floor(Math.min(t, n) / 2));
        }
        determineDataLimits() {
          const { min: e, max: t } = this.getMinMax(!1);
          (this.min = f_(e) && !isNaN(e) ? e : 0),
            (this.max = f_(t) && !isNaN(t) ? t : 0),
            this.handleTickRangeOptions();
        }
        computeTickLimit() {
          return Math.ceil(this.drawingArea / vw(this.options));
        }
        generateTickLabels(e) {
          mw.prototype.generateTickLabels.call(this, e),
            (this._pointLabels = this.getLabels()
              .map((e, t) => {
                const n = __(this.options.pointLabels.callback, [e, t], this);
                return n || 0 === n ? n : "";
              })
              .filter((e, t) => this.chart.getDataVisibility(t)));
        }
        fit() {
          const e = this.options;
          e.display && e.pointLabels.display
            ? (function (e) {
                const t = {
                    l: e.left + e._padding.left,
                    r: e.right - e._padding.right,
                    t: e.top + e._padding.top,
                    b: e.bottom - e._padding.bottom,
                  },
                  n = Object.assign({}, t),
                  r = [],
                  o = [],
                  a = e._pointLabels.length,
                  i = e.options.pointLabels,
                  s = i.centerPointLabels ? R_ / a : 0;
                for (let d = 0; d < a; d++) {
                  const a = i.setContext(e.getPointLabelContext(d));
                  o[d] = a.padding;
                  const p = e.getPointPosition(d, e.drawingArea + o[d], s),
                    m = Ox(a.font),
                    h =
                      ((l = e.ctx),
                      (c = m),
                      (u = m_((u = e._pointLabels[d])) ? u : [u]),
                      { w: ix(l, c.string, u), h: u.length * c.lineHeight });
                  r[d] = h;
                  const f = ey(e.getIndexAngle(d) + s),
                    g = Math.round(q_(f));
                  _w(
                    n,
                    t,
                    f,
                    bw(g, p.x, h.w, 0, 180),
                    bw(g, p.y, h.h, 90, 270)
                  );
                }
                var l, c, u;
                e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b),
                  (e._pointLabelItems = (function (e, t, n) {
                    const r = [],
                      o = e._pointLabels.length,
                      a = e.options,
                      i = vw(a) / 2,
                      s = e.drawingArea,
                      l = a.pointLabels.centerPointLabels ? R_ / o : 0;
                    for (let a = 0; a < o; a++) {
                      const o = e.getPointPosition(a, s + i + n[a], l),
                        p = Math.round(q_(ey(o.angle + B_))),
                        m = t[a],
                        h = xw(o.y, m.h, p),
                        f = yw(p),
                        g =
                          ((c = o.x),
                          (u = m.w),
                          "right" === (d = f)
                            ? (c -= u)
                            : "center" === d && (c -= u / 2),
                          c);
                      r.push({
                        x: o.x,
                        y: h,
                        textAlign: f,
                        left: g,
                        top: h,
                        right: g + m.w,
                        bottom: h + m.h,
                      });
                    }
                    var c, u, d;
                    return r;
                  })(e, r, o));
              })(this)
            : this.setCenterPoint(0, 0, 0, 0);
        }
        setCenterPoint(e, t, n, r) {
          (this.xCenter += Math.floor((e - t) / 2)),
            (this.yCenter += Math.floor((n - r) / 2)),
            (this.drawingArea -= Math.min(
              this.drawingArea / 2,
              Math.max(e, t, n, r)
            ));
        }
        getIndexAngle(e) {
          return ey(
            e * (N_ / (this._pointLabels.length || 1)) +
              G_(this.options.startAngle || 0)
          );
        }
        getDistanceFromCenterForValue(e) {
          if (p_(e)) return NaN;
          const t = this.drawingArea / (this.max - this.min);
          return this.options.reverse ? (this.max - e) * t : (e - this.min) * t;
        }
        getValueForDistanceFromCenter(e) {
          if (p_(e)) return NaN;
          const t = e / (this.drawingArea / (this.max - this.min));
          return this.options.reverse ? this.max - t : this.min + t;
        }
        getPointLabelContext(e) {
          const t = this._pointLabels || [];
          if (e >= 0 && e < t.length) {
            const n = t[e];
            return (function (e, t, n) {
              return Tx(e, { label: n, index: t, type: "pointLabel" });
            })(this.getContext(), e, n);
          }
        }
        getPointPosition(e, t, n = 0) {
          const r = this.getIndexAngle(e) - B_ + n;
          return {
            x: Math.cos(r) * t + this.xCenter,
            y: Math.sin(r) * t + this.yCenter,
            angle: r,
          };
        }
        getPointPositionForValue(e, t) {
          return this.getPointPosition(
            e,
            this.getDistanceFromCenterForValue(t)
          );
        }
        getBasePosition(e) {
          return this.getPointPositionForValue(e || 0, this.getBaseValue());
        }
        getPointLabelPosition(e) {
          const {
            left: t,
            top: n,
            right: r,
            bottom: o,
          } = this._pointLabelItems[e];
          return { left: t, top: n, right: r, bottom: o };
        }
        drawBackground() {
          const {
            backgroundColor: e,
            grid: { circular: t },
          } = this.options;
          if (e) {
            const n = this.ctx;
            n.save(),
              n.beginPath(),
              Cw(
                this,
                this.getDistanceFromCenterForValue(this._endValue),
                t,
                this._pointLabels.length
              ),
              n.closePath(),
              (n.fillStyle = e),
              n.fill(),
              n.restore();
          }
        }
        drawGrid() {
          const e = this.ctx,
            t = this.options,
            { angleLines: n, grid: r } = t,
            o = this._pointLabels.length;
          let a, i, s;
          if (
            (t.pointLabels.display &&
              (function (e, t) {
                const {
                  ctx: n,
                  options: { pointLabels: r },
                } = e;
                for (let o = t - 1; o >= 0; o--) {
                  const t = r.setContext(e.getPointLabelContext(o)),
                    a = Ox(t.font),
                    {
                      x: i,
                      y: s,
                      textAlign: l,
                      left: c,
                      top: u,
                      right: d,
                      bottom: p,
                    } = e._pointLabelItems[o],
                    { backdropColor: m } = t;
                  if (!p_(m)) {
                    const e = wx(t.borderRadius),
                      r = Px(t.backdropPadding);
                    n.fillStyle = m;
                    const o = c - r.left,
                      a = u - r.top,
                      i = d - c + r.width,
                      s = p - u + r.height;
                    Object.values(e).some((e) => 0 !== e)
                      ? (n.beginPath(),
                        bx(n, { x: o, y: a, w: i, h: s, radius: e }),
                        n.fill())
                      : n.fillRect(o, a, i, s);
                  }
                  gx(n, e._pointLabels[o], i, s + a.lineHeight / 2, a, {
                    color: t.color,
                    textAlign: l,
                    textBaseline: "middle",
                  });
                }
              })(this, o),
            r.display &&
              this.ticks.forEach((e, t) => {
                0 !== t &&
                  ((i = this.getDistanceFromCenterForValue(e.value)),
                  (function (e, t, n, r) {
                    const o = e.ctx,
                      a = t.circular,
                      { color: i, lineWidth: s } = t;
                    (!a && !r) ||
                      !i ||
                      !s ||
                      n < 0 ||
                      (o.save(),
                      (o.strokeStyle = i),
                      (o.lineWidth = s),
                      o.setLineDash(t.borderDash),
                      (o.lineDashOffset = t.borderDashOffset),
                      o.beginPath(),
                      Cw(e, n, a, r),
                      o.closePath(),
                      o.stroke(),
                      o.restore());
                  })(this, r.setContext(this.getContext(t - 1)), i, o));
              }),
            n.display)
          ) {
            for (e.save(), a = o - 1; a >= 0; a--) {
              const r = n.setContext(this.getPointLabelContext(a)),
                { color: o, lineWidth: l } = r;
              l &&
                o &&
                ((e.lineWidth = l),
                (e.strokeStyle = o),
                e.setLineDash(r.borderDash),
                (e.lineDashOffset = r.borderDashOffset),
                (i = this.getDistanceFromCenterForValue(
                  t.ticks.reverse ? this.min : this.max
                )),
                (s = this.getPointPosition(a, i)),
                e.beginPath(),
                e.moveTo(this.xCenter, this.yCenter),
                e.lineTo(s.x, s.y),
                e.stroke());
            }
            e.restore();
          }
        }
        drawBorder() {}
        drawLabels() {
          const e = this.ctx,
            t = this.options,
            n = t.ticks;
          if (!n.display) return;
          const r = this.getIndexAngle(0);
          let o, a;
          e.save(),
            e.translate(this.xCenter, this.yCenter),
            e.rotate(r),
            (e.textAlign = "center"),
            (e.textBaseline = "middle"),
            this.ticks.forEach((r, i) => {
              if (0 === i && !t.reverse) return;
              const s = n.setContext(this.getContext(i)),
                l = Ox(s.font);
              if (
                ((o = this.getDistanceFromCenterForValue(this.ticks[i].value)),
                s.showLabelBackdrop)
              ) {
                (e.font = l.string),
                  (a = e.measureText(r.label).width),
                  (e.fillStyle = s.backdropColor);
                const t = Px(s.backdropPadding);
                e.fillRect(
                  -a / 2 - t.left,
                  -o - l.size / 2 - t.top,
                  a + t.width,
                  l.size + t.height
                );
              }
              gx(e, r.label, 0, -o, l, { color: s.color });
            }),
            e.restore();
        }
        drawTitle() {}
      }
      (Sw.id = "radialLinear"),
        (Sw.defaults = {
          display: !0,
          animate: !0,
          position: "chartArea",
          angleLines: {
            display: !0,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0,
          },
          grid: { circular: !1 },
          startAngle: 0,
          ticks: { showLabelBackdrop: !0, callback: oS.formatters.numeric },
          pointLabels: {
            backdropColor: void 0,
            backdropPadding: 2,
            display: !0,
            font: { size: 10 },
            callback(e) {
              return e;
            },
            padding: 5,
            centerPointLabels: !1,
          },
        }),
        (Sw.defaultRoutes = {
          "angleLines.color": "borderColor",
          "pointLabels.color": "color",
          "ticks.color": "color",
        }),
        (Sw.descriptors = { angleLines: { _fallback: "grid" } });
      const kw = {
          millisecond: { common: !0, size: 1, steps: 1e3 },
          second: { common: !0, size: 1e3, steps: 60 },
          minute: { common: !0, size: 6e4, steps: 60 },
          hour: { common: !0, size: 36e5, steps: 24 },
          day: { common: !0, size: 864e5, steps: 30 },
          week: { common: !1, size: 6048e5, steps: 4 },
          month: { common: !0, size: 2628e6, steps: 12 },
          quarter: { common: !1, size: 7884e6, steps: 4 },
          year: { common: !0, size: 3154e7 },
        },
        ww = Object.keys(kw);
      function Pw(e, t) {
        return e - t;
      }
      function Ow(e, t) {
        if (p_(t)) return null;
        const n = e._adapter,
          { parser: r, round: o, isoWeekday: a } = e._parseOpts;
        let i = t;
        return (
          "function" == typeof r && (i = r(i)),
          f_(i) || (i = "string" == typeof r ? n.parse(i, r) : n.parse(i)),
          null === i
            ? null
            : (o &&
                (i =
                  "week" !== o || (!$_(a) && !0 !== a)
                    ? n.startOf(i, o)
                    : n.startOf(i, "isoWeek", a)),
              +i)
        );
      }
      function Iw(e, t, n, r) {
        const o = ww.length;
        for (let a = ww.indexOf(e); a < o - 1; ++a) {
          const e = kw[ww[a]],
            o = e.steps ? e.steps : Number.MAX_SAFE_INTEGER;
          if (e.common && Math.ceil((n - t) / (o * e.size)) <= r) return ww[a];
        }
        return ww[o - 1];
      }
      function Tw(e, t, n) {
        if (n) {
          if (n.length) {
            const { lo: r, hi: o } = oy(n, t);
            e[n[r] >= t ? n[r] : n[o]] = !0;
          }
        } else e[t] = !0;
      }
      function Mw(e, t, n) {
        const r = [],
          o = {},
          a = t.length;
        let i, s;
        for (i = 0; i < a; ++i)
          (s = t[i]), (o[s] = i), r.push({ value: s, major: !1 });
        return 0 !== a && n
          ? (function (e, t, n, r) {
              const o = e._adapter,
                a = +o.startOf(t[0].value, r),
                i = t[t.length - 1].value;
              let s, l;
              for (s = a; s <= i; s = +o.add(s, 1, r))
                (l = n[s]), l >= 0 && (t[l].major = !0);
              return t;
            })(e, r, o, n)
          : r;
      }
      class Ew extends mS {
        constructor(e) {
          super(e),
            (this._cache = { data: [], labels: [], all: [] }),
            (this._unit = "day"),
            (this._majorUnit = void 0),
            (this._offsets = {}),
            (this._normalized = !1),
            (this._parseOpts = void 0);
        }
        init(e, t) {
          const n = e.time || (e.time = {}),
            r = (this._adapter = new _S._date(e.adapters.date));
          r.init(t),
            P_(n.displayFormats, r.formats()),
            (this._parseOpts = {
              parser: n.parser,
              round: n.round,
              isoWeekday: n.isoWeekday,
            }),
            super.init(e),
            (this._normalized = t.normalized);
        }
        parse(e, t) {
          return void 0 === e ? null : Ow(this, e);
        }
        beforeLayout() {
          super.beforeLayout(),
            (this._cache = { data: [], labels: [], all: [] });
        }
        determineDataLimits() {
          const e = this.options,
            t = this._adapter,
            n = e.time.unit || "day";
          let {
            min: r,
            max: o,
            minDefined: a,
            maxDefined: i,
          } = this.getUserBounds();
          function s(e) {
            a || isNaN(e.min) || (r = Math.min(r, e.min)),
              i || isNaN(e.max) || (o = Math.max(o, e.max));
          }
          (a && i) ||
            (s(this._getLabelBounds()),
            ("ticks" === e.bounds && "labels" === e.ticks.source) ||
              s(this.getMinMax(!1))),
            (r = f_(r) && !isNaN(r) ? r : +t.startOf(Date.now(), n)),
            (o = f_(o) && !isNaN(o) ? o : +t.endOf(Date.now(), n) + 1),
            (this.min = Math.min(r, o - 1)),
            (this.max = Math.max(r + 1, o));
        }
        _getLabelBounds() {
          const e = this.getLabelTimestamps();
          let t = Number.POSITIVE_INFINITY,
            n = Number.NEGATIVE_INFINITY;
          return (
            e.length && ((t = e[0]), (n = e[e.length - 1])), { min: t, max: n }
          );
        }
        buildTicks() {
          const e = this.options,
            t = e.time,
            n = e.ticks,
            r =
              "labels" === n.source
                ? this.getLabelTimestamps()
                : this._generate();
          "ticks" === e.bounds &&
            r.length &&
            ((this.min = this._userMin || r[0]),
            (this.max = this._userMax || r[r.length - 1]));
          const o = this.min,
            a = (function (e, t, n) {
              let r = 0,
                o = e.length;
              for (; r < o && e[r] < t; ) r++;
              for (; o > r && e[o - 1] > n; ) o--;
              return r > 0 || o < e.length ? e.slice(r, o) : e;
            })(r, o, this.max);
          return (
            (this._unit =
              t.unit ||
              (n.autoSkip
                ? Iw(t.minUnit, this.min, this.max, this._getLabelCapacity(o))
                : (function (e, t, n, r, o) {
                    for (let a = ww.length - 1; a >= ww.indexOf(n); a--) {
                      const n = ww[a];
                      if (kw[n].common && e._adapter.diff(o, r, n) >= t - 1)
                        return n;
                    }
                    return ww[n ? ww.indexOf(n) : 0];
                  })(this, a.length, t.minUnit, this.min, this.max))),
            (this._majorUnit =
              n.major.enabled && "year" !== this._unit
                ? (function (e) {
                    for (let t = ww.indexOf(e) + 1, n = ww.length; t < n; ++t)
                      if (kw[ww[t]].common) return ww[t];
                  })(this._unit)
                : void 0),
            this.initOffsets(r),
            e.reverse && a.reverse(),
            Mw(this, a, this._majorUnit)
          );
        }
        afterAutoSkip() {
          this.options.offsetAfterAutoskip &&
            this.initOffsets(this.ticks.map((e) => +e.value));
        }
        initOffsets(e) {
          let t,
            n,
            r = 0,
            o = 0;
          this.options.offset &&
            e.length &&
            ((t = this.getDecimalForValue(e[0])),
            (r =
              1 === e.length ? 1 - t : (this.getDecimalForValue(e[1]) - t) / 2),
            (n = this.getDecimalForValue(e[e.length - 1])),
            (o =
              1 === e.length
                ? n
                : (n - this.getDecimalForValue(e[e.length - 2])) / 2));
          const a = e.length < 3 ? 0.5 : 0.25;
          (r = ny(r, 0, a)),
            (o = ny(o, 0, a)),
            (this._offsets = { start: r, end: o, factor: 1 / (r + 1 + o) });
        }
        _generate() {
          const e = this._adapter,
            t = this.min,
            n = this.max,
            r = this.options,
            o = r.time,
            a = o.unit || Iw(o.minUnit, t, n, this._getLabelCapacity(t)),
            i = v_(o.stepSize, 1),
            s = "week" === a && o.isoWeekday,
            l = $_(s) || !0 === s,
            c = {};
          let u,
            d,
            p = t;
          if (
            (l && (p = +e.startOf(p, "isoWeek", s)),
            (p = +e.startOf(p, l ? "day" : a)),
            e.diff(n, t, a) > 1e5 * i)
          )
            throw new Error(
              t +
                " and " +
                n +
                " are too far apart with stepSize of " +
                i +
                " " +
                a
            );
          const m = "data" === r.ticks.source && this.getDataTimestamps();
          for (u = p, d = 0; u < n; u = +e.add(u, i, a), d++) Tw(c, u, m);
          return (
            (u !== n && "ticks" !== r.bounds && 1 !== d) || Tw(c, u, m),
            Object.keys(c)
              .sort((e, t) => e - t)
              .map((e) => +e)
          );
        }
        getLabelForValue(e) {
          const t = this._adapter,
            n = this.options.time;
          return n.tooltipFormat
            ? t.format(e, n.tooltipFormat)
            : t.format(e, n.displayFormats.datetime);
        }
        _tickFormatFunction(e, t, n, r) {
          const o = this.options,
            a = o.time.displayFormats,
            i = this._unit,
            s = this._majorUnit,
            l = i && a[i],
            c = s && a[s],
            u = n[t],
            d = s && c && u && u.major,
            p = this._adapter.format(e, r || (d ? c : l)),
            m = o.ticks.callback;
          return m ? __(m, [p, t, n], this) : p;
        }
        generateTickLabels(e) {
          let t, n, r;
          for (t = 0, n = e.length; t < n; ++t)
            (r = e[t]), (r.label = this._tickFormatFunction(r.value, t, e));
        }
        getDecimalForValue(e) {
          return null === e ? NaN : (e - this.min) / (this.max - this.min);
        }
        getPixelForValue(e) {
          const t = this._offsets,
            n = this.getDecimalForValue(e);
          return this.getPixelForDecimal((t.start + n) * t.factor);
        }
        getValueForPixel(e) {
          const t = this._offsets,
            n = this.getDecimalForPixel(e) / t.factor - t.end;
          return this.min + n * (this.max - this.min);
        }
        _getLabelSize(e) {
          const t = this.options.ticks,
            n = this.ctx.measureText(e).width,
            r = G_(this.isHorizontal() ? t.maxRotation : t.minRotation),
            o = Math.cos(r),
            a = Math.sin(r),
            i = this._resolveTickFontOptions(0).size;
          return { w: n * o + i * a, h: n * a + i * o };
        }
        _getLabelCapacity(e) {
          const t = this.options.time,
            n = t.displayFormats,
            r = n[t.unit] || n.millisecond,
            o = this._tickFormatFunction(
              e,
              0,
              Mw(this, [e], this._majorUnit),
              r
            ),
            a = this._getLabelSize(o),
            i =
              Math.floor(
                this.isHorizontal() ? this.width / a.w : this.height / a.h
              ) - 1;
          return i > 0 ? i : 1;
        }
        getDataTimestamps() {
          let e,
            t,
            n = this._cache.data || [];
          if (n.length) return n;
          const r = this.getMatchingVisibleMetas();
          if (this._normalized && r.length)
            return (this._cache.data =
              r[0].controller.getAllParsedValues(this));
          for (e = 0, t = r.length; e < t; ++e)
            n = n.concat(r[e].controller.getAllParsedValues(this));
          return (this._cache.data = this.normalize(n));
        }
        getLabelTimestamps() {
          const e = this._cache.labels || [];
          let t, n;
          if (e.length) return e;
          const r = this.getLabels();
          for (t = 0, n = r.length; t < n; ++t) e.push(Ow(this, r[t]));
          return (this._cache.labels = this._normalized
            ? e
            : this.normalize(e));
        }
        normalize(e) {
          return cy(e.sort(Pw));
        }
      }
      function Dw(e, t, n) {
        let r,
          o,
          a,
          i,
          s = 0,
          l = e.length - 1;
        n
          ? (t >= e[s].pos &&
              t <= e[l].pos &&
              ({ lo: s, hi: l } = ay(e, "pos", t)),
            ({ pos: r, time: a } = e[s]),
            ({ pos: o, time: i } = e[l]))
          : (t >= e[s].time &&
              t <= e[l].time &&
              ({ lo: s, hi: l } = ay(e, "time", t)),
            ({ time: r, pos: a } = e[s]),
            ({ time: o, pos: i } = e[l]));
        const c = o - r;
        return c ? a + ((i - a) * (t - r)) / c : a;
      }
      (Ew.id = "time"),
        (Ew.defaults = {
          bounds: "data",
          adapters: {},
          time: {
            parser: !1,
            unit: !1,
            round: !1,
            isoWeekday: !1,
            minUnit: "millisecond",
            displayFormats: {},
          },
          ticks: { source: "auto", major: { enabled: !1 } },
        });
      class jw extends Ew {
        constructor(e) {
          super(e),
            (this._table = []),
            (this._minPos = void 0),
            (this._tableRange = void 0);
        }
        initOffsets() {
          const e = this._getTimestampsForTable(),
            t = (this._table = this.buildLookupTable(e));
          (this._minPos = Dw(t, this.min)),
            (this._tableRange = Dw(t, this.max) - this._minPos),
            super.initOffsets(e);
        }
        buildLookupTable(e) {
          const { min: t, max: n } = this,
            r = [],
            o = [];
          let a, i, s, l, c;
          for (a = 0, i = e.length; a < i; ++a)
            (l = e[a]), l >= t && l <= n && r.push(l);
          if (r.length < 2)
            return [
              { time: t, pos: 0 },
              { time: n, pos: 1 },
            ];
          for (a = 0, i = r.length; a < i; ++a)
            (c = r[a + 1]),
              (s = r[a - 1]),
              (l = r[a]),
              Math.round((c + s) / 2) !== l &&
                o.push({ time: l, pos: a / (i - 1) });
          return o;
        }
        _getTimestampsForTable() {
          let e = this._cache.all || [];
          if (e.length) return e;
          const t = this.getDataTimestamps(),
            n = this.getLabelTimestamps();
          return (
            (e =
              t.length && n.length
                ? this.normalize(t.concat(n))
                : t.length
                ? t
                : n),
            (e = this._cache.all = e),
            e
          );
        }
        getDecimalForValue(e) {
          return (Dw(this._table, e) - this._minPos) / this._tableRange;
        }
        getValueForPixel(e) {
          const t = this._offsets,
            n = this.getDecimalForPixel(e) / t.factor - t.end;
          return Dw(this._table, n * this._tableRange + this._minPos, !0);
        }
      }
      (jw.id = "timeseries"), (jw.defaults = Ew.defaults);
      var Rw = function () {
          return (
            (Rw =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Rw.apply(this, arguments)
          );
        },
        Nw = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Aw = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function Lw() {
        var n,
          r,
          o,
          a = this,
          i = z.getState().salesRepData.baseData.select
            ? z.getState().salesRepData.baseData.select
            : {},
          s = g(),
          l = X().t,
          c = z.getState().salesRepData.loggedInRepDetails.shopCurrency,
          u = Qg("(min-width: 1360px)"),
          d = z.getState().salesRepData.loggedInRepDetails,
          p =
            null !==
              (r =
                null === (n = z.getState().salesRepData) || void 0 === n
                  ? void 0
                  : n.baseData) && void 0 !== r
              ? r
              : {},
          m = [
            l("dashboard_clientInvoice"),
            l("dashboard_affiliateLink"),
            l("dashboard_returnCustomer"),
            l("dashboard_discountCoupon"),
            l("dashboard_SharedCart"),
            l("dashboard_AdminTaggedOrders"),
          ],
          h = [
            { name: l("Dashboard_Month"), hide: !1 },
            { name: l("Dashboard_Orders_Total"), hide: !1 },
            { name: l("Dashboard_Total_Sale"), hide: !1 },
            { name: l("Dashboard_Commission"), hide: !1 },
            {
              name: l("Dashboard_Bonus"),
              hide: !(null == i ? void 0 : i.Bonus),
            },
          ],
          f = (0, t.useState)({
            commissionMonthLabels: [],
            commissionMonthPoints: [],
          }),
          v = f[0],
          b = f[1],
          _ = (0, t.useState)({ orderMonthLabels: [], orderMonthPoints: [] }),
          y = _[0],
          x = _[1],
          C = (0, t.useState)({ salesMonthLabels: [], salesMonthPoints: [] }),
          S = C[0],
          k = C[1],
          w = (0, t.useState)([]),
          P = w[0],
          O = w[1],
          I = (0, t.useState)([]),
          T = I[0],
          M = I[1],
          E = (0, t.useState)([]),
          D = E[0],
          j = E[1],
          R = (0, t.useState)(p || ""),
          N = R[0],
          A = R[1],
          L = (0, t.useState)(!1),
          B = L[0],
          Z = L[1],
          F = (0, t.useState)({
            orderFeatureLabels: 0,
            commissionFeatureLabels: 0,
            salesFeatureLabels: 0,
          }),
          H = F[0],
          V = F[1],
          W = (0, t.useState)("-"),
          $ = W[0],
          U = W[1],
          K = (0, t.useState)(!1),
          G = K[0],
          q = K[1],
          Y = (0, t.useState)([]),
          J = Y[0],
          Q = Y[1],
          ee = (0, t.useState)(!1),
          te = ee[0],
          ne = ee[1],
          re = (0, t.useState)([]),
          oe = re[0],
          ae = re[1],
          ie =
            null === (o = null == N ? void 0 : N.CommissionDiscountOn) ||
            void 0 === o
              ? void 0
              : o.CommissionDiscountType,
          se = {
            labels: y.orderMonthLabels,
            datasets: [
              {
                type: "line",
                data: y.orderMonthPoints,
                borderColor: "#4ED8DA",
                borderWidth: 3,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "top",
                  anchor: "end",
                },
              },
            ],
          },
          le = {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: l("Graph_SalesRepOrders_YAxisTitle"),
                padding: { bottom: 20 },
              },
              legend: { display: !1 },
            },
            scales: {
              x: {
                title: {
                  display: !0,
                  text: l("Graph_SalesRep_XAxisTitle_ForMonth"),
                },
              },
            },
          },
          ce = {
            labels: v.commissionMonthLabels,
            datasets: [
              {
                data: v.commissionMonthPoints,
                backgroundColor: "#36A2EB",
                barThickness: 35,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "top",
                  anchor: "end",
                },
              },
            ],
          },
          ue = {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: l("Graph_SalesRepCommissions_YAxisTitle"),
                padding: { bottom: 20 },
              },
              legend: { display: !1 },
            },
            scales: {
              x: {
                title: {
                  display: !0,
                  text: l("Graph_SalesRep_XAxisTitle_ForMonth"),
                },
                grid: { display: !1 },
              },
            },
          },
          de = {
            type: "horizontalBar",
            labels: S.salesMonthLabels,
            datasets: [
              {
                data: S.salesMonthPoints,
                backgroundColor: "#2371CB",
                barThickness: 30,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "right",
                  anchor: "end",
                },
              },
            ],
          },
          pe = {
            indexAxis: "y",
            responsive: !0,
            plugins: {
              title: {
                display: !0,
                text: l("dashboard_sales_of_last_six_months"),
              },
              legend: { display: !1 },
            },
            scales: {
              x: { title: { display: !0, text: l("dashboar_cardHeading3") } },
              y: { title: { display: !1 }, grid: { display: !1 } },
            },
          },
          me = {
            type: "pie",
            labels: H.salesFeatureLabels > 0 ? m : [],
            datasets: [
              {
                data: D,
                backgroundColor: [
                  "#eda0b0ba",
                  "#b75066",
                  "#7b3040",
                  "#501e29",
                  "#7a696d",
                  "#362428",
                ],
                borderColor: [
                  "#eda0b0ba",
                  "#b75066",
                  "#7b3040",
                  "#501e29",
                  "#7a696d",
                  "#362428",
                ],
                borderWidth: 2,
              },
            ],
          },
          he = {
            responsive: !0,
            plugins: {
              title: {
                display: !0,
                text: l("dashboard_sales_of_current_month"),
              },
              datalabels: { display: !1 },
              legend: {
                display: !0,
                position: "bottom",
                labels: {
                  usePointStyle: !0,
                  PointStyle: "circle",
                  filter: function (e, t) {
                    return 0 !== t.datasets[0].data[e.index];
                  },
                },
              },
            },
          },
          fe = {
            labels: H.orderFeatureLabels > 0 ? m : [],
            datasets: [
              {
                data: P,
                backgroundColor: "#8566FB",
                barThickness: 35,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "top",
                  anchor: "end",
                },
              },
            ],
          },
          ge = {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: l("Graph_FeatureWiseOrder_title"),
                padding: { bottom: 20 },
              },
              legend: { display: !1 },
            },
            scales: {
              y: {
                title: {
                  display: !0,
                  text: l("Graph_SalesRepOrders_YAxisTitle"),
                },
                ticks: {
                  callback: function (e) {
                    return e;
                  },
                },
              },
              x: {
                title: {
                  display: !0,
                  text: l("Graph_FeatureWiseOrder_XAxisTitle"),
                },
              },
            },
          },
          ve = {
            type: "pie",
            labels: H.commissionFeatureLabels > 0 ? m : [],
            datasets: [
              {
                data: T,
                backgroundColor: [
                  "#4ED8DA",
                  "#EAF0B7",
                  "#36A2EB",
                  "#FAD9FF",
                  "#F9A48E",
                  "#73BF53",
                ],
                borderWidth: 2,
              },
            ],
          },
          be = {
            responsive: !0,
            maintainAspectRatio: !1,
            title: { display: !0, position: "top", padding: { bottom: 20 } },
            plugins: {
              title: {
                display: !0,
                position: "top",
                text: l("Graph_featureWiseCommission_title"),
                padding: { bottom: 20 },
              },
              legend: {
                display: (null == H ? void 0 : H.commissionFeatureLabels) > 0,
                position: "left",
                labels: {
                  usePointStyle: !0,
                  PointStyle: "square",
                  filter: function (e, t) {
                    return 0 !== t.datasets[0].data[e.index];
                  },
                },
                title: {
                  display: !0,
                  position: "start",
                  text: l("Graph_FeatureWiseOrder_XAxisTitle"),
                },
              },
            },
          };
        (0, t.useEffect)(
          function () {
            ff.subscribe(function (e) {
              q(e);
            }),
              ae(
                Object.keys(
                  (null == N ? void 0 : N.SalesRepMonthlyCommission) || {}
                ).map(function (e) {
                  return null == N ? void 0 : N.SalesRepMonthlyCommission[e];
                })
              ),
              _e();
          },
          [G, N]
        ),
          (0, t.useEffect)(function () {
            Object.keys(z.getState().salesRepData.baseData).length > 0 && ye();
          }, []);
        var _e = function () {
            var e,
              t,
              n,
              r =
                null === (e = z.getState().salesRepData) || void 0 === e
                  ? void 0
                  : e.baseData,
              o =
                (null == r ? void 0 : r.salesrepCustomerOrders) &&
                null !==
                  (n =
                    null ===
                      (t = null == r ? void 0 : r.salesrepCustomerOrders[0]) ||
                    void 0 === t
                      ? void 0
                      : t.Month) &&
                void 0 !== n
                  ? n
                  : "-";
            Q(
              "-" != o
                ? null == r
                  ? void 0
                  : r.SalesRepMonthlyCommission[o]
                : []
            );
          },
          ye = function () {
            var e, t, n, r, o, a, i, s, l, c, u, d, m, h, f, g, v, _, y, C, S;
            if (
              Object.keys(z.getState().salesRepData.baseData).length > 0 &&
              ((p =
                null === (e = z.getState().salesRepData) || void 0 === e
                  ? void 0
                  : e.baseData),
              U(
                (null == p ? void 0 : p.salesrepCustomerOrders) &&
                  null !==
                    (n =
                      null ===
                        (t =
                          null == p ? void 0 : p.salesrepCustomerOrders[0]) ||
                      void 0 === t
                        ? void 0
                        : t.Month) &&
                  void 0 !== n
                  ? n
                  : "-"
              ),
              A(p),
              p)
            ) {
              var w = [],
                P = [],
                I = [],
                T = [],
                E = [],
                D = [];
              if (
                (Object.entries(
                  null == p ? void 0 : p.SalesRepMonthlyCommission
                ).forEach(function (e) {
                  var t = e[0],
                    n = e[1];
                  w.push(t),
                    P.push(t),
                    I.push(t),
                    T.push(null == n ? void 0 : n.TotalCommission),
                    E.push(null == n ? void 0 : n.TotalNoOfOrders),
                    D.push(null == n ? void 0 : n.TotalSale);
                }),
                b({
                  commissionMonthLabels: w.reverse(),
                  commissionMonthPoints: T.reverse(),
                }),
                x({
                  orderMonthLabels: P.reverse(),
                  orderMonthPoints: E.reverse(),
                }),
                k({
                  salesMonthLabels: I.reverse(),
                  salesMonthPoints: D.map(function (e) {
                    return parseFloat(e.toFixed(2));
                  }).reverse(),
                }),
                Object.keys(p).length > 0)
              ) {
                var R =
                    null !==
                      (r = p.salesrepCustomerOrders[0].CustomerOrderCount) &&
                    void 0 !== r
                      ? r
                      : 0,
                  N =
                    null !==
                      (o = p.salesrepAffiliateOrders[0].AffiliateOrderCount) &&
                    void 0 !== o
                      ? o
                      : 0,
                  L =
                    null !==
                      (a =
                        p.TaggedCustomerOrdersDetails[0]
                          .TagCustomerOrderCount) && void 0 !== a
                      ? a
                      : 0,
                  B =
                    null !==
                      (i = p.salesrepCouponOrders[0].CouponCodeOrderCount) &&
                    void 0 !== i
                      ? i
                      : 0,
                  Z =
                    null !== (s = p.salesrepSharedCart[0].OrderCount) &&
                    void 0 !== s
                      ? s
                      : 0,
                  F =
                    null !==
                      (l = p.AdminTaggedOrdersDetails[0].TagOrderCount) &&
                    void 0 !== l
                      ? l
                      : 0;
                V(function (e) {
                  return Rw(Rw({}, e), {
                    orderFeatureLabels: R + N + L + B + Z + F,
                  });
                }),
                  O([R, N, L, B, Z, F]);
                var H =
                    null !==
                      (c =
                        p.salesrepCustomerOrders[0].CustomerOrderCommission) &&
                    void 0 !== c
                      ? c
                      : 0,
                  W =
                    null !==
                      (u =
                        p.salesrepAffiliateOrders[0]
                          .AffiliateOrderCommission) && void 0 !== u
                      ? u
                      : 0,
                  $ =
                    null !==
                      (d =
                        p.TaggedCustomerOrdersDetails[0]
                          .TagCustomerCommission) && void 0 !== d
                      ? d
                      : 0,
                  K =
                    null !==
                      (m =
                        p.salesrepCouponOrders[0].CouponCodeOrderCommission) &&
                    void 0 !== m
                      ? m
                      : 0,
                  G =
                    null !== (h = p.salesrepSharedCart[0].OrderCommission) &&
                    void 0 !== h
                      ? h
                      : 0,
                  q =
                    null !==
                      (f = p.AdminTaggedOrdersDetails[0].TagOrderCommission) &&
                    void 0 !== f
                      ? f
                      : 0;
                V(function (e) {
                  return Rw(Rw({}, e), {
                    commissionFeatureLabels: H + W + $ + K + G + q,
                  });
                }),
                  M([H, W, $, K, G, q]);
                var Y =
                    null !==
                      (g = p.salesrepCustomerOrders[0].CustomerOrderSubtotal) &&
                    void 0 !== g
                      ? g
                      : 0,
                  J =
                    null !==
                      (v =
                        p.salesrepAffiliateOrders[0].AffiliateOrderSubTotal) &&
                    void 0 !== v
                      ? v
                      : 0,
                  Q =
                    null !==
                      (_ =
                        p.TaggedCustomerOrdersDetails[0].TagCustomerSubTotal) &&
                    void 0 !== _
                      ? _
                      : 0,
                  X =
                    null !==
                      (y = p.salesrepCouponOrders[0].CouponCodeOrderSubtotal) &&
                    void 0 !== y
                      ? y
                      : 0,
                  ee =
                    null !== (C = p.salesrepSharedCart[0].OrderSubTotal) &&
                    void 0 !== C
                      ? C
                      : 0,
                  te =
                    null !==
                      (S = p.AdminTaggedOrdersDetails[0].TagOrderSubTotal) &&
                    void 0 !== S
                      ? S
                      : 0;
                V(function (e) {
                  return Rw(Rw({}, e), {
                    salesFeatureLabels: Y + J + Q + X + ee + te,
                  });
                }),
                  j([Y, J, Q, X, ee, te]);
              }
            }
          },
          xe =
            null == T
              ? void 0
              : T.reduce(function (e, t) {
                  return e + (null != t ? t : 0);
                }, 0),
          Ce =
            null == S
              ? void 0
              : S.salesMonthPoints.reduce(function (e, t) {
                  return e + (null != t ? t : 0);
                }, 0),
          Se =
            Ce /
              (null == y
                ? void 0
                : y.orderMonthPoints.reduce(function (e, t) {
                    return e + (null != t ? t : 0);
                  }, 0)) || 0;
        return {
          drawerStatus: G,
          callDefaultFunctions: function () {
            return Nw(a, void 0, void 0, function () {
              return Aw(this, function (e) {
                switch (e.label) {
                  case 0:
                    return 0 ===
                      Object.keys(z.getState().salesRepData.baseData).length ||
                      G
                      ? (mf.next(!0), [4, s(_g())])
                      : [3, 6];
                  case 1:
                    return (
                      e.sent(),
                      _e(),
                      ye(),
                      mf.next(!1),
                      (z.getState().salesRepData.baseData.select
                        ? z.getState().salesRepData.baseData.select
                        : {}
                      ).PriceList
                        ? [4, s(Zg())]
                        : [3, 3]
                    );
                  case 2:
                    e.sent(), (e.label = 3);
                  case 3:
                    return [4, s(Cg())];
                  case 4:
                    return e.sent(), [4, s(yg())];
                  case 5:
                    e.sent(), (e.label = 6);
                  case 6:
                    return [2];
                }
              });
            });
          },
          currentMonth: $,
          dataLine: se,
          optionsLine: le,
          sixMonthsBar: de,
          optionSixMonthsBar: pe,
          currentMonthPie: me,
          optionCurrentMonthPie: he,
          commissionMonthBar: ce,
          optionsCommissionMonthBar: ue,
          ordersFeatureBar: fe,
          optionsOrdersFeatureBar: ge,
          commisionFeaturePie: ve,
          optionsCommisionFeaturePie: be,
          salesRepData: N,
          openCommissionDialog: B,
          setOpenCommissionDialog: Z,
          getCommissionStructure: function (t, n, r) {
            var o =
              t && t.length > 0
                ? t.map(function (t, o) {
                    var a, i;
                    return (
                      void 0 === o && (o = 0),
                      (0, e.jsx)(Pi, {
                        children: (0, e.jsxs)(
                          hi,
                          {
                            children: [
                              (0, e.jsx)(yi, { children: t[n] }),
                              (0, e.jsx)(
                                yi,
                                Rw(
                                  { align: "center" },
                                  {
                                    children:
                                      "FixedDollarAmount" === ie
                                        ? c +
                                          (null === (a = t[r]) || void 0 === a
                                            ? void 0
                                            : a.toFixed(2))
                                        : (null === (i = t[r]) || void 0 === i
                                            ? void 0
                                            : i.toFixed(2)) + "%",
                                  }
                                )
                              ),
                            ],
                          },
                          o
                        ),
                      })
                    );
                  })
                : (0, e.jsx)(Pi, {
                    children: (0, e.jsx)(hi, {
                      children: (0, e.jsx)(
                        yi,
                        Rw(
                          { colSpan: 2 },
                          {
                            children: l(
                              "Graph_SalesRepCommission_nocommissiontitle"
                            ),
                          }
                        )
                      ),
                    }),
                  });
            return o;
          },
          loggedInRepData: d,
          getTimeZone: function () {
            var e = new Date().getHours();
            return l(
              e < 12
                ? "dashboard_morningMsg"
                : e < 18
                ? "dashboard_afternoonMsg"
                : "dashboard_eveningMsg"
            );
          },
          showNoDataMessage: function (t) {
            var n,
              r = [];
            switch (t) {
              case 1:
                r = P;
                break;
              case 2:
                r = T;
                break;
              case 3:
                r = y.orderMonthPoints;
                break;
              case 4:
                r = v.commissionMonthPoints;
                break;
              case 5:
                r = S.salesMonthPoints;
                break;
              case 6:
                r = D;
            }
            return (0, e.jsx)(
              Wa,
              Rw(
                {
                  variant: "body2",
                  className: "ST_DB_No_Data",
                  hidden:
                    ((n = r),
                    0 !== n.length &&
                      0 !=
                        n.reduce(function (e, t) {
                          return parseFloat(e) + parseFloat(t);
                        }, 0)),
                },
                { children: l("dashboard_no_data") }
              )
            );
          },
          t: l,
          shopCurrency: c,
          currentMonthCommissionDetails: J,
          totalCommissionPie: xe,
          totalRevenue: Ce,
          avgTicketSize: Se,
          isDesktop: u,
          performanceDetailsPopup: te,
          setPerformanceDetailsPopup: ne,
          handlePerformanceDetailsPopup: function () {
            ne(!te);
          },
          salesRepMonthlyPerformance: oe,
          performance_Details_Headers: h,
          selectFeatures: i,
        };
      }
      function zw() {
        var e = Qg("(min-width: 1360px)");
        return {
          ST_DB_Min_Cards: {
            mb: 1,
            p: "0px !important",
            height: "120px",
            boxShadow: "none",
          },
          ST_DB_Graph_Cards: {
            backgroundColor: "white",
            p: 2,
            borderRadius: "5px",
            position: "relative",
            border: "1px solid #B6DAF3",
          },
          ST_DB_Horizontal_Line: { flexGrow: 1, background: "#DBDEE0" },
          ST_DB_Information_Box: {
            backgroundColor: "#EBF9FC",
            alignItems: "center",
            borderRadius: "5px",
            border: "1px solid #98C6CD",
          },
          ST_DB_Min_Cards_Graph: {
            mb: 2,
            p: "0px !important",
            height: "150px",
            boxShadow: "none",
          },
          ST_DB_Graph_CardTotal: {
            fontSize: 18,
            fontWeight: "bold",
            marginLeft: "0.6rem",
          },
          ST_DB_cardText_Font: {
            fontSize: 16,
            fontWeight: "bold",
            alignItems: "center",
          },
          ST_DB_Graph_catrdTotal_Text: {
            color: "#ffffff",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "14rem",
            height: "3rem",
            fontSize: "2rem",
          },
          ST_DB_HowItWorksButton: {
            border: " 1px solid #C9CCCF",
            height: "33px",
            padding: "5px",
            borderRadius: "5px ",
            backgroundColor: "#FFFFFF",
            alignItems: "center",
            display: "flex",
            marginLeft: e ? "0px" : "auto",
            fontSize: "14px",
            marginTop: e ? "0px" : "15px",
          },
          ST_CI_VirticalLine: {
            borderRight: "1px solid #98C6CD",
            height: "100%",
          },
          ST_CI_VirticalLineGrid: {
            display: "flex",
            alignItems: "center",
            marginRight: "1rem",
          },
        };
      }
      ox.font.size = 12;
      const Bw = "label";
      function Zw(e, t) {
        "function" == typeof e ? e(t) : e && (e.current = t);
      }
      function Fw(e, t) {
        e.labels = t;
      }
      function Hw(e, t) {
        let n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Bw;
        const r = [];
        e.datasets = t.map((t) => {
          const o = e.datasets.find((e) => e[n] === t[n]);
          return o && t.data && !r.includes(o)
            ? (r.push(o), Object.assign(o, t), o)
            : { ...t };
        });
      }
      function Vw(e) {
        let t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Bw;
        const n = { labels: [], datasets: [] };
        return Fw(n, e.labels), Hw(n, e.datasets, t), n;
      }
      function Ww(e, n) {
        let {
          height: r = 150,
          width: o = 300,
          redraw: a = !1,
          datasetIdKey: i,
          type: s,
          data: l,
          options: c,
          plugins: u = [],
          fallbackContent: d,
          updateMode: p,
          ...m
        } = e;
        const h = (0, t.useRef)(null),
          f = (0, t.useRef)(),
          g = () => {
            h.current &&
              ((f.current = new kk(h.current, {
                type: s,
                data: Vw(l, i),
                options: c && { ...c },
                plugins: u,
              })),
              Zw(n, f.current));
          },
          v = () => {
            Zw(n, null), f.current && (f.current.destroy(), (f.current = null));
          };
        return (
          (0, t.useEffect)(() => {
            var e, t;
            !a &&
              f.current &&
              c &&
              ((e = f.current), (t = c), Object.assign(e.options, t));
          }, [a, c]),
          (0, t.useEffect)(() => {
            !a && f.current && Fw(f.current.config.data, l.labels);
          }, [a, l.labels]),
          (0, t.useEffect)(() => {
            !a &&
              f.current &&
              l.datasets &&
              Hw(f.current.config.data, l.datasets, i);
          }, [a, l.datasets]),
          (0, t.useEffect)(() => {
            f.current && (a ? (v(), setTimeout(g)) : f.current.update(p));
          }, [a, c, l.labels, l.datasets, p]),
          (0, t.useEffect)(() => {
            f.current && (v(), setTimeout(g));
          }, [s]),
          (0, t.useEffect)(() => (g(), () => v()), []),
          t.createElement(
            "canvas",
            Object.assign({ ref: h, role: "img", height: r, width: o }, m),
            d
          )
        );
      }
      const $w = (0, t.forwardRef)(Ww);
      function Uw(e, n) {
        return (
          kk.register(n),
          (0, t.forwardRef)((n, r) =>
            t.createElement($w, Object.assign({}, n, { ref: r, type: e }))
          )
        );
      }
      const Kw = Uw("line", QC),
        Gw = Uw("bar", qC),
        qw = Uw("pie", eS);
      var Yw = (function () {
          if ("undefined" != typeof window) {
            if (window.devicePixelRatio) return window.devicePixelRatio;
            var e = window.screen;
            if (e) return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
          }
          return 1;
        })(),
        Jw = function (e, t, n) {
          var r,
            o = [].concat(t),
            a = o.length,
            i = e.font,
            s = 0;
          for (e.font = n.string, r = 0; r < a; ++r)
            s = Math.max(e.measureText(o[r]).width, s);
          return (e.font = i), { height: a * n.lineHeight, width: s };
        };
      function Qw(e, t) {
        var n = t.x,
          r = t.y;
        if (null === n) return { x: 0, y: -1 };
        if (null === r) return { x: 1, y: 0 };
        var o = e.x - n,
          a = e.y - r,
          i = Math.sqrt(o * o + a * a);
        return { x: i ? o / i : 0, y: i ? a / i : -1 };
      }
      var Xw = 0,
        eP = 1,
        tP = 2,
        nP = 4,
        rP = 8;
      function oP(e, t, n) {
        var r = Xw;
        return (
          e < n.left ? (r |= eP) : e > n.right && (r |= tP),
          t < n.top ? (r |= rP) : t > n.bottom && (r |= nP),
          r
        );
      }
      function aP(e, t) {
        var n,
          r,
          o = t.anchor,
          a = e;
        return (
          t.clamp &&
            (a = (function (e, t) {
              for (
                var n,
                  r,
                  o,
                  a = e.x0,
                  i = e.y0,
                  s = e.x1,
                  l = e.y1,
                  c = oP(a, i, t),
                  u = oP(s, l, t);
                c | u && !(c & u);

              )
                (n = c || u) & rP
                  ? ((r = a + ((s - a) * (t.top - i)) / (l - i)), (o = t.top))
                  : n & nP
                  ? ((r = a + ((s - a) * (t.bottom - i)) / (l - i)),
                    (o = t.bottom))
                  : n & tP
                  ? ((o = i + ((l - i) * (t.right - a)) / (s - a)),
                    (r = t.right))
                  : n & eP &&
                    ((o = i + ((l - i) * (t.left - a)) / (s - a)),
                    (r = t.left)),
                  n === c
                    ? (c = oP((a = r), (i = o), t))
                    : (u = oP((s = r), (l = o), t));
              return { x0: a, x1: s, y0: i, y1: l };
            })(a, t.area)),
          "start" === o
            ? ((n = a.x0), (r = a.y0))
            : "end" === o
            ? ((n = a.x1), (r = a.y1))
            : ((n = (a.x0 + a.x1) / 2), (r = (a.y0 + a.y1) / 2)),
          (function (e, t, n, r, o) {
            switch (o) {
              case "center":
                n = r = 0;
                break;
              case "bottom":
                (n = 0), (r = 1);
                break;
              case "right":
                (n = 1), (r = 0);
                break;
              case "left":
                (n = -1), (r = 0);
                break;
              case "top":
                (n = 0), (r = -1);
                break;
              case "start":
                (n = -n), (r = -r);
                break;
              case "end":
                break;
              default:
                (o *= Math.PI / 180), (n = Math.cos(o)), (r = Math.sin(o));
            }
            return { x: e, y: t, vx: n, vy: r };
          })(n, r, e.vx, e.vy, t.align)
        );
      }
      var iP = {
          arc: function (e, t) {
            var n = (e.startAngle + e.endAngle) / 2,
              r = Math.cos(n),
              o = Math.sin(n),
              a = e.innerRadius,
              i = e.outerRadius;
            return aP(
              {
                x0: e.x + r * a,
                y0: e.y + o * a,
                x1: e.x + r * i,
                y1: e.y + o * i,
                vx: r,
                vy: o,
              },
              t
            );
          },
          point: function (e, t) {
            var n = Qw(e, t.origin),
              r = n.x * e.options.radius,
              o = n.y * e.options.radius;
            return aP(
              {
                x0: e.x - r,
                y0: e.y - o,
                x1: e.x + r,
                y1: e.y + o,
                vx: n.x,
                vy: n.y,
              },
              t
            );
          },
          bar: function (e, t) {
            var n = Qw(e, t.origin),
              r = e.x,
              o = e.y,
              a = 0,
              i = 0;
            return (
              e.horizontal
                ? ((r = Math.min(e.x, e.base)), (a = Math.abs(e.base - e.x)))
                : ((o = Math.min(e.y, e.base)), (i = Math.abs(e.base - e.y))),
              aP({ x0: r, y0: o + i, x1: r + a, y1: o, vx: n.x, vy: n.y }, t)
            );
          },
          fallback: function (e, t) {
            var n = Qw(e, t.origin);
            return aP(
              {
                x0: e.x,
                y0: e.y,
                x1: e.x + (e.width || 0),
                y1: e.y + (e.height || 0),
                vx: n.x,
                vy: n.y,
              },
              t
            );
          },
        },
        sP = function (e) {
          return Math.round(e * Yw) / Yw;
        };
      function lP(e, t) {
        var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
        if (!n) return null;
        if (void 0 !== n.xCenter && void 0 !== n.yCenter)
          return { x: n.xCenter, y: n.yCenter };
        var r = n.getBasePixel();
        return e.horizontal ? { x: r, y: null } : { x: null, y: r };
      }
      function cP(e, t, n) {
        var r = e.shadowBlur,
          o = n.stroked,
          a = sP(n.x),
          i = sP(n.y),
          s = sP(n.w);
        o && e.strokeText(t, a, i, s),
          n.filled &&
            (r && o && (e.shadowBlur = 0),
            e.fillText(t, a, i, s),
            r && o && (e.shadowBlur = r));
      }
      var uP = function (e, t, n, r) {
        var o = this;
        (o._config = e),
          (o._index = r),
          (o._model = null),
          (o._rects = null),
          (o._ctx = t),
          (o._el = n);
      };
      w_(uP.prototype, {
        _modelize: function (e, t, n, r) {
          var o,
            a = this,
            i = a._index,
            s = Ox(Ix([n.font, {}], r, i)),
            l = Ix([n.color, ox.color], r, i);
          return {
            align: Ix([n.align, "center"], r, i),
            anchor: Ix([n.anchor, "center"], r, i),
            area: r.chart.chartArea,
            backgroundColor: Ix([n.backgroundColor, null], r, i),
            borderColor: Ix([n.borderColor, null], r, i),
            borderRadius: Ix([n.borderRadius, 0], r, i),
            borderWidth: Ix([n.borderWidth, 0], r, i),
            clamp: Ix([n.clamp, !1], r, i),
            clip: Ix([n.clip, !1], r, i),
            color: l,
            display: e,
            font: s,
            lines: t,
            offset: Ix([n.offset, 4], r, i),
            opacity: Ix([n.opacity, 1], r, i),
            origin: lP(a._el, r),
            padding: Px(Ix([n.padding, 4], r, i)),
            positioner:
              ((o = a._el),
              o instanceof Mk
                ? iP.arc
                : o instanceof Zk
                ? iP.point
                : o instanceof Uk
                ? iP.bar
                : iP.fallback),
            rotation: Ix([n.rotation, 0], r, i) * (Math.PI / 180),
            size: Jw(a._ctx, t, s),
            textAlign: Ix([n.textAlign, "start"], r, i),
            textShadowBlur: Ix([n.textShadowBlur, 0], r, i),
            textShadowColor: Ix([n.textShadowColor, l], r, i),
            textStrokeColor: Ix([n.textStrokeColor, l], r, i),
            textStrokeWidth: Ix([n.textStrokeWidth, 0], r, i),
          };
        },
        update: function (e) {
          var t,
            n,
            r,
            o = this,
            a = null,
            i = null,
            s = o._index,
            l = o._config,
            c = Ix([l.display, !0], e, s);
          c &&
            ((t = e.dataset.data[s]),
            (r = p_((n = v_(__(l.formatter, [t, e]), t)))
              ? []
              : (function (e) {
                  var t,
                    n = [];
                  for (e = [].concat(e); e.length; )
                    "string" == typeof (t = e.pop())
                      ? n.unshift.apply(n, t.split("\n"))
                      : Array.isArray(t)
                      ? e.push.apply(e, t)
                      : p_(e) || n.unshift("" + t);
                  return n;
                })(n)).length &&
              (i = (function (e) {
                var t = e.borderWidth || 0,
                  n = e.padding,
                  r = e.size.height,
                  o = e.size.width,
                  a = -o / 2,
                  i = -r / 2;
                return {
                  frame: {
                    x: a - n.left - t,
                    y: i - n.top - t,
                    w: o + n.width + 2 * t,
                    h: r + n.height + 2 * t,
                  },
                  text: { x: a, y: i, w: o, h: r },
                };
              })((a = o._modelize(c, r, l, e))))),
            (o._model = a),
            (o._rects = i);
        },
        geometry: function () {
          return this._rects ? this._rects.frame : {};
        },
        rotation: function () {
          return this._model ? this._model.rotation : 0;
        },
        visible: function () {
          return this._model && this._model.opacity;
        },
        model: function () {
          return this._model;
        },
        draw: function (e, t) {
          var n,
            r,
            o,
            a,
            i = e.ctx,
            s = this._model,
            l = this._rects;
          this.visible() &&
            (i.save(),
            s.clip &&
              ((n = s.area),
              i.beginPath(),
              i.rect(n.left, n.top, n.right - n.left, n.bottom - n.top),
              i.clip()),
            (i.globalAlpha =
              ((r = 0), (o = s.opacity), (a = 1), Math.max(r, Math.min(o, a)))),
            i.translate(sP(t.x), sP(t.y)),
            i.rotate(s.rotation),
            (function (e, t, n) {
              var r = n.backgroundColor,
                o = n.borderColor,
                a = n.borderWidth;
              (r || (o && a)) &&
                (e.beginPath(),
                (function (e, t, n, r, o, a) {
                  var i = Math.PI / 2;
                  if (a) {
                    var s = Math.min(a, o / 2, r / 2),
                      l = t + s,
                      c = n + s,
                      u = t + r - s,
                      d = n + o - s;
                    e.moveTo(t, c),
                      l < u && c < d
                        ? (e.arc(l, c, s, -Math.PI, -i),
                          e.arc(u, c, s, -i, 0),
                          e.arc(u, d, s, 0, i),
                          e.arc(l, d, s, i, Math.PI))
                        : l < u
                        ? (e.moveTo(l, n),
                          e.arc(u, c, s, -i, i),
                          e.arc(l, c, s, i, Math.PI + i))
                        : c < d
                        ? (e.arc(l, c, s, -Math.PI, 0),
                          e.arc(l, d, s, 0, Math.PI))
                        : e.arc(l, c, s, -Math.PI, Math.PI),
                      e.closePath(),
                      e.moveTo(t, n);
                  } else e.rect(t, n, r, o);
                })(
                  e,
                  sP(t.x) + a / 2,
                  sP(t.y) + a / 2,
                  sP(t.w) - a,
                  sP(t.h) - a,
                  n.borderRadius
                ),
                e.closePath(),
                r && ((e.fillStyle = r), e.fill()),
                o &&
                  a &&
                  ((e.strokeStyle = o),
                  (e.lineWidth = a),
                  (e.lineJoin = "miter"),
                  e.stroke()));
            })(i, l.frame, s),
            (function (e, t, n, r) {
              var o,
                a = r.textAlign,
                i = r.color,
                s = !!i,
                l = r.font,
                c = t.length,
                u = r.textStrokeColor,
                d = r.textStrokeWidth,
                p = u && d;
              if (c && (s || p))
                for (
                  n = (function (e, t, n) {
                    var r = n.lineHeight,
                      o = e.w,
                      a = e.x;
                    return (
                      "center" === t
                        ? (a += o / 2)
                        : ("end" !== t && "right" !== t) || (a += o),
                      { h: r, w: o, x: a, y: e.y + r / 2 }
                    );
                  })(n, a, l),
                    e.font = l.string,
                    e.textAlign = a,
                    e.textBaseline = "middle",
                    e.shadowBlur = r.textShadowBlur,
                    e.shadowColor = r.textShadowColor,
                    s && (e.fillStyle = i),
                    p &&
                      ((e.lineJoin = "round"),
                      (e.lineWidth = d),
                      (e.strokeStyle = u)),
                    o = 0,
                    c = t.length;
                  o < c;
                  ++o
                )
                  cP(e, t[o], {
                    stroked: p,
                    filled: s,
                    w: n.w,
                    x: n.x,
                    y: n.y + n.h * o,
                  });
            })(i, s.lines, l.text, s),
            i.restore());
        },
      });
      var dP = Number.MIN_SAFE_INTEGER || -9007199254740991,
        pP = Number.MAX_SAFE_INTEGER || 9007199254740991;
      function mP(e, t, n) {
        var r = Math.cos(n),
          o = Math.sin(n),
          a = t.x,
          i = t.y;
        return {
          x: a + r * (e.x - a) - o * (e.y - i),
          y: i + o * (e.x - a) + r * (e.y - i),
        };
      }
      function hP(e, t) {
        var n,
          r,
          o,
          a,
          i,
          s = pP,
          l = dP,
          c = t.origin;
        for (n = 0; n < e.length; ++n)
          (o = (r = e[n]).x - c.x),
            (a = r.y - c.y),
            (i = t.vx * o + t.vy * a),
            (s = Math.min(s, i)),
            (l = Math.max(l, i));
        return { min: s, max: l };
      }
      function fP(e, t) {
        var n = t.x - e.x,
          r = t.y - e.y,
          o = Math.sqrt(n * n + r * r);
        return { vx: (t.x - e.x) / o, vy: (t.y - e.y) / o, origin: e, ln: o };
      }
      var gP = function () {
        (this._rotation = 0), (this._rect = { x: 0, y: 0, w: 0, h: 0 });
      };
      function vP(e, t, n) {
        var r = t.positioner(e, t),
          o = r.vx,
          a = r.vy;
        if (!o && !a) return { x: r.x, y: r.y };
        var i = n.w,
          s = n.h,
          l = t.rotation,
          c = Math.abs((i / 2) * Math.cos(l)) + Math.abs((s / 2) * Math.sin(l)),
          u = Math.abs((i / 2) * Math.sin(l)) + Math.abs((s / 2) * Math.cos(l)),
          d = 1 / Math.max(Math.abs(o), Math.abs(a));
        return (
          (c *= o * d),
          (u *= a * d),
          (c += t.offset * o),
          (u += t.offset * a),
          { x: r.x + c, y: r.y + u }
        );
      }
      w_(gP.prototype, {
        center: function () {
          var e = this._rect;
          return { x: e.x + e.w / 2, y: e.y + e.h / 2 };
        },
        update: function (e, t, n) {
          (this._rotation = n),
            (this._rect = { x: t.x + e.x, y: t.y + e.y, w: t.w, h: t.h });
        },
        contains: function (e) {
          var t = this,
            n = t._rect;
          return !(
            (e = mP(e, t.center(), -t._rotation)).x < n.x - 1 ||
            e.y < n.y - 1 ||
            e.x > n.x + n.w + 2 ||
            e.y > n.y + n.h + 2
          );
        },
        intersects: function (e) {
          var t,
            n,
            r,
            o = this._points(),
            a = e._points(),
            i = [fP(o[0], o[1]), fP(o[0], o[3])];
          for (
            this._rotation !== e._rotation &&
              i.push(fP(a[0], a[1]), fP(a[0], a[3])),
              t = 0;
            t < i.length;
            ++t
          )
            if (
              ((n = hP(o, i[t])),
              (r = hP(a, i[t])),
              n.max < r.min || r.max < n.min)
            )
              return !1;
          return !0;
        },
        _points: function () {
          var e = this,
            t = e._rect,
            n = e._rotation,
            r = e.center();
          return [
            mP({ x: t.x, y: t.y }, r, n),
            mP({ x: t.x + t.w, y: t.y }, r, n),
            mP({ x: t.x + t.w, y: t.y + t.h }, r, n),
            mP({ x: t.x, y: t.y + t.h }, r, n),
          ];
        },
      });
      var bP = {
          prepare: function (e) {
            var t,
              n,
              r,
              o,
              a,
              i = [];
            for (t = 0, r = e.length; t < r; ++t)
              for (n = 0, o = e[t].length; n < o; ++n)
                (a = e[t][n]),
                  i.push(a),
                  (a.$layout = {
                    _box: new gP(),
                    _hidable: !1,
                    _visible: !0,
                    _set: t,
                    _idx: a._index,
                  });
            return (
              i.sort(function (e, t) {
                var n = e.$layout,
                  r = t.$layout;
                return n._idx === r._idx ? r._set - n._set : r._idx - n._idx;
              }),
              this.update(i),
              i
            );
          },
          update: function (e) {
            var t,
              n,
              r,
              o,
              a,
              i = !1;
            for (t = 0, n = e.length; t < n; ++t)
              (o = (r = e[t]).model()),
                ((a = r.$layout)._hidable = o && "auto" === o.display),
                (a._visible = r.visible()),
                (i |= a._hidable);
            i &&
              (function (e) {
                var t, n, r, o, a, i, s;
                for (t = 0, n = e.length; t < n; ++t)
                  (o = (r = e[t]).$layout)._visible &&
                    ((s = new Proxy(r._el, {
                      get: (e, t) => e.getProps([t], !0)[t],
                    })),
                    (a = r.geometry()),
                    (i = vP(s, r.model(), a)),
                    o._box.update(i, a, r.rotation()));
                !(function (e, t) {
                  var n, r, o, a;
                  for (n = e.length - 1; n >= 0; --n)
                    for (o = e[n].$layout, r = n - 1; r >= 0 && o._visible; --r)
                      (a = e[r].$layout)._visible &&
                        o._box.intersects(a._box) &&
                        t(o, a);
                })(e, function (e, t) {
                  var n = e._hidable,
                    r = t._hidable;
                  (n && r) || r ? (t._visible = !1) : n && (e._visible = !1);
                });
              })(e);
          },
          lookup: function (e, t) {
            var n, r;
            for (n = e.length - 1; n >= 0; --n)
              if ((r = e[n].$layout) && r._visible && r._box.contains(t))
                return e[n];
            return null;
          },
          draw: function (e, t) {
            var n, r, o, a, i, s;
            for (n = 0, r = t.length; n < r; ++n)
              (a = (o = t[n]).$layout)._visible &&
                ((i = o.geometry()),
                (s = vP(o._el, o.model(), i)),
                a._box.update(s, i, o.rotation()),
                o.draw(e, s));
          },
        },
        _P = "$datalabels",
        yP = "$default";
      function xP(e, t, n, r) {
        if (t) {
          var o,
            a = n.$context,
            i = n.$groups;
          t[i._set] &&
            (o = t[i._set][i._key]) &&
            !0 === __(o, [a, r]) &&
            ((e[_P]._dirty = !0), n.update(a));
        }
      }
      var CP = {
          id: "datalabels",
          defaults: {
            align: "center",
            anchor: "center",
            backgroundColor: null,
            borderColor: null,
            borderRadius: 0,
            borderWidth: 0,
            clamp: !1,
            clip: !1,
            color: void 0,
            display: !0,
            font: {
              family: void 0,
              lineHeight: 1.2,
              size: void 0,
              style: void 0,
              weight: null,
            },
            formatter: function (e) {
              if (p_(e)) return null;
              var t,
                n,
                r,
                o = e;
              if (h_(e))
                if (p_(e.label))
                  if (p_(e.r))
                    for (
                      o = "", r = 0, n = (t = Object.keys(e)).length;
                      r < n;
                      ++r
                    )
                      o += (0 !== r ? ", " : "") + t[r] + ": " + e[t[r]];
                  else o = e.r;
                else o = e.label;
              return "" + o;
            },
            labels: void 0,
            listeners: {},
            offset: 4,
            opacity: 1,
            padding: { top: 4, right: 4, bottom: 4, left: 4 },
            rotation: 0,
            textAlign: "start",
            textStrokeColor: void 0,
            textStrokeWidth: 0,
            textShadowBlur: 0,
            textShadowColor: void 0,
          },
          beforeInit: function (e) {
            e[_P] = { _actives: [] };
          },
          beforeUpdate: function (e) {
            var t = e[_P];
            (t._listened = !1),
              (t._listeners = {}),
              (t._datasets = []),
              (t._labels = []);
          },
          afterDatasetUpdate: function (e, t, n) {
            var r,
              o,
              a,
              i,
              s,
              l,
              c,
              u,
              d = t.index,
              p = e[_P],
              m = (p._datasets[d] = []),
              h = e.isDatasetVisible(d),
              f = e.data.datasets[d],
              g = (function (e, t) {
                var n,
                  r,
                  o,
                  a = e.datalabels,
                  i = [];
                return !1 === a
                  ? null
                  : (!0 === a && (a = {}),
                    (t = w_({}, [t, a])),
                    (r = t.labels || {}),
                    (o = Object.keys(r)),
                    delete t.labels,
                    o.length
                      ? o.forEach(function (e) {
                          r[e] && i.push(w_({}, [t, r[e], { _key: e }]));
                        })
                      : i.push(t),
                    (n = i.reduce(function (e, t) {
                      return (
                        y_(t.listeners || {}, function (n, r) {
                          (e[r] = e[r] || {}), (e[r][t._key || yP] = n);
                        }),
                        delete t.listeners,
                        e
                      );
                    }, {})),
                    { labels: i, listeners: n });
              })(f, n),
              v = t.meta.data || [],
              b = e.ctx;
            for (b.save(), r = 0, a = v.length; r < a; ++r)
              if (
                (((c = v[r])[_P] = []),
                h && c && e.getDataVisibility(r) && !c.skip)
              )
                for (o = 0, i = g.labels.length; o < i; ++o)
                  (l = (s = g.labels[o])._key),
                    ((u = new uP(s, b, c, r)).$groups = {
                      _set: d,
                      _key: l || yP,
                    }),
                    (u.$context = {
                      active: !1,
                      chart: e,
                      dataIndex: r,
                      dataset: f,
                      datasetIndex: d,
                    }),
                    u.update(u.$context),
                    c[_P].push(u),
                    m.push(u);
            b.restore(),
              w_(p._listeners, g.listeners, {
                merger: function (e, n, r) {
                  (n[e] = n[e] || {}),
                    (n[e][t.index] = r[e]),
                    (p._listened = !0);
                },
              });
          },
          afterUpdate: function (e) {
            e[_P]._labels = bP.prepare(e[_P]._datasets);
          },
          afterDatasetsDraw: function (e) {
            bP.draw(e, e[_P]._labels);
          },
          beforeEvent: function (e, t) {
            if (e[_P]._listened) {
              var n = t.event;
              switch (n.type) {
                case "mousemove":
                case "mouseout":
                  !(function (e, t) {
                    var n,
                      r,
                      o = e[_P],
                      a = o._listeners;
                    if (a.enter || a.leave) {
                      if ("mousemove" === t.type) r = bP.lookup(o._labels, t);
                      else if ("mouseout" !== t.type) return;
                      (n = o._hovered),
                        (o._hovered = r),
                        (function (e, t, n, r, o) {
                          var a, i;
                          (n || r) &&
                            (n
                              ? r
                                ? n !== r && (i = a = !0)
                                : (i = !0)
                              : (a = !0),
                            i && xP(e, t.leave, n, o),
                            a && xP(e, t.enter, r, o));
                        })(e, a, n, r, t);
                    }
                  })(e, n);
                  break;
                case "click":
                  !(function (e, t) {
                    var n = e[_P],
                      r = n._listeners.click,
                      o = r && bP.lookup(n._labels, t);
                    o && xP(e, r, o, t);
                  })(e, n);
              }
            }
          },
          afterEvent: function (e) {
            var t,
              n,
              r,
              o,
              a,
              i,
              s,
              l = e[_P],
              c = (function (e, t) {
                var n,
                  r,
                  o,
                  a,
                  i = e.slice(),
                  s = [];
                for (n = 0, o = t.length; n < o; ++n)
                  (a = t[n]),
                    -1 === (r = i.indexOf(a)) ? s.push([a, 1]) : i.splice(r, 1);
                for (n = 0, o = i.length; n < o; ++n) s.push([i[n], -1]);
                return s;
              })(l._actives, (l._actives = e.getActiveElements()));
            for (t = 0, n = c.length; t < n; ++t)
              if ((a = c[t])[1])
                for (r = 0, o = (s = a[0].element[_P] || []).length; r < o; ++r)
                  ((i = s[r]).$context.active = 1 === a[1]),
                    i.update(i.$context);
            (l._dirty || c.length) && (bP.update(l._labels), e.render()),
              delete l._dirty;
          },
        },
        SP = (0, bo.Z)(
          (0, e.jsx)("path", { d: "m10 17 5-5-5-5z" }),
          "ArrowRight"
        ),
        kP = function () {
          return (
            (kP =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            kP.apply(this, arguments)
          );
        },
        wP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                kP(
                  {
                    id: "Group_6879",
                    "data-name": "Group 6879",
                    transform: "translate(-337 -282.331)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "17.5",
                        r: "17.5",
                        transform: "translate(337 282.331)",
                        fill: "#e3f4fe",
                      }),
                      (0, e.jsx)("path", {
                        id: "DiscountsMajor_2_",
                        "data-name": "DiscountsMajor (2)",
                        d: "M12.64.721a2.392,2.392,0,0,0-3.423,0L8.166,1.8a2.392,2.392,0,0,1-1.74.721L4.921,2.5A2.392,2.392,0,0,0,2.5,4.921l.017,1.5A2.392,2.392,0,0,1,1.8,8.166L.721,9.217a2.392,2.392,0,0,0,0,3.423L1.8,13.692a2.4,2.4,0,0,1,.721,1.74l-.019,1.5a2.392,2.392,0,0,0,2.421,2.421l1.5-.017a2.392,2.392,0,0,1,1.74.721l1.051,1.075a2.391,2.391,0,0,0,3.423,0l1.051-1.077a2.392,2.392,0,0,1,1.74-.721l1.5.019a2.392,2.392,0,0,0,2.421-2.421l-.017-1.5a2.392,2.392,0,0,1,.721-1.74l1.075-1.051a2.391,2.391,0,0,0,0-3.423L20.06,8.166a2.392,2.392,0,0,1-.721-1.74l.019-1.5A2.392,2.392,0,0,0,16.937,2.5l-1.5.017a2.392,2.392,0,0,1-1.74-.721ZM7.65,9.29A1.639,1.639,0,1,0,6.011,7.65,1.639,1.639,0,0,0,7.65,9.29Zm6.557,6.557a1.639,1.639,0,1,0-1.639-1.639A1.639,1.639,0,0,0,14.208,15.847Zm.85-9.047a1.2,1.2,0,0,1,0,1.7L8.5,15.058a1.2,1.2,0,1,1-1.7-1.7L13.357,6.8a1.2,1.2,0,0,1,1.7,0Z",
                        transform: "translate(343.571 289.429)",
                        fill: "#2371cb",
                        "fill-rule": "evenodd",
                      }),
                    ],
                  }
                )
              ),
            }
          )
        ),
        PP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                kP(
                  {
                    id: "Group_6883",
                    "data-name": "Group 6883",
                    transform: "translate(-1201 -257)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "17.5",
                        r: "17.5",
                        transform: "translate(1201 257)",
                        fill: "#eafaeb",
                      }),
                      (0, e.jsx)("path", {
                        id: "ProductsMinor",
                        d: "M11.75,3h6.605a1.181,1.181,0,0,1,1.181,1.181v6.605a2.362,2.362,0,0,1-.673,1.652l-6.1,6.233a2.953,2.953,0,0,1-4.177,0L3.865,13.947a2.953,2.953,0,0,1,0-4.177l.009-.009L10.1,3.673A2.362,2.362,0,0,1,11.749,3ZM15.4,8.906a1.772,1.772,0,1,0-1.772-1.772A1.772,1.772,0,0,0,15.4,8.906Z",
                        transform: "translate(1206.361 264.464)",
                        fill: "#28b433",
                      }),
                    ],
                  }
                )
              ),
            }
          )
        ),
        OP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 36",
            },
            {
              children: (0, e.jsxs)(
                "g",
                kP(
                  {
                    id: "Group_6880",
                    "data-name": "Group 6880",
                    transform: "translate(-646 -274)",
                  },
                  {
                    children: [
                      (0, e.jsx)("ellipse", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "18",
                        rx: "17.5",
                        ry: "18",
                        transform: "translate(646 274)",
                        fill: "#f1eefe",
                      }),
                      (0, e.jsx)("path", {
                        id: "CheckoutMajor_1_",
                        "data-name": "CheckoutMajor (1)",
                        d: "M1,.986A.989.989,0,0,1,1.99,0H3.474A1.482,1.482,0,0,1,4.958,1.479v.552l12.4.9a1.482,1.482,0,0,1,1.378,1.686l-.854,5.95a1.483,1.483,0,0,1-1.468,1.27H4.958v1.972h9.9a2.955,2.955,0,1,1-2.8,1.972H6.769a2.97,2.97,0,1,1-3.79-1.8v-12H1.99A.988.988,0,0,1,1,.986ZM13.873,16.764a.99.99,0,1,1,.989.986.988.988,0,0,1-.989-.986Zm-10.894,0a.99.99,0,1,1,.99.986.989.989,0,0,1-.99-.986Z",
                        transform: "translate(653.625 282.835)",
                        fill: "#8566fb",
                        "fill-rule": "evenodd",
                      }),
                    ],
                  }
                )
              ),
            }
          )
        ),
        IP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16.338",
              height: "16.338",
              viewBox: "16.338 16.338",
            },
            {
              children: (0, e.jsx)("path", {
                id: "CircleInformationMajor",
                d: "M8.169,16.338A8.169,8.169,0,1,0,0,8.169,8.178,8.178,0,0,0,8.169,16.338Zm.817-4.9a.817.817,0,0,1-1.634,0V8.169a.817.817,0,0,1,1.634,0ZM8.169,4.085a.817.817,0,1,0,.817.817A.817.817,0,0,0,8.169,4.085Z",
                fill: "#00a0ac",
                "fill-rule": "evenodd",
              }),
            }
          )
        ),
        TP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                kP(
                  {
                    id: "Group_6931",
                    "data-name": "Group 6931",
                    transform: "translate(-912 -271)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "17.5",
                        r: "17.5",
                        transform: "translate(912 271)",
                        fill: "#e7fcff",
                      }),
                      (0, e.jsx)(
                        "g",
                        kP(
                          {
                            id: "Group_6917",
                            "data-name": "Group 6917",
                            transform: "translate(-0.872 -1)",
                          },
                          {
                            children: (0, e.jsx)(
                              "g",
                              kP(
                                {
                                  id: "Group_6918",
                                  "data-name": "Group 6918",
                                  transform: "translate(919.891 278.02)",
                                },
                                {
                                  children: (0, e.jsx)(
                                    "g",
                                    kP(
                                      {
                                        id: "Group_6927",
                                        "data-name": "Group 6927",
                                        transform: "translate(0 0)",
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          "g",
                                          kP(
                                            {
                                              id: "money_2_",
                                              "data-name": "money (2)",
                                            },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6920",
                                                      "data-name": "Group 6920",
                                                      transform:
                                                        "translate(0 9.734)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "g",
                                                        kP(
                                                          {
                                                            id: "Group_6919",
                                                            "data-name":
                                                              "Group 6919",
                                                            transform:
                                                              "translate(0)",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)("path", {
                                                              id: "Path_4897",
                                                              "data-name":
                                                                "Path 4897",
                                                              d: "M.286,238.525a.437.437,0,0,0-.259.559l.274.755,2.088-2.088Z",
                                                              transform:
                                                                "translate(-0.001 -237.75)",
                                                              fill: "#2dacae",
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6922",
                                                      "data-name": "Group 6922",
                                                      transform:
                                                        "translate(2.262 17.216)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "g",
                                                        kP(
                                                          {
                                                            id: "Group_6921",
                                                            "data-name":
                                                              "Group 6921",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)("path", {
                                                              id: "Path_4898",
                                                              "data-name":
                                                                "Path 4898",
                                                              d: "M55.257,420.513l1.258,3.459a.433.433,0,0,0,.226.246.439.439,0,0,0,.184.041.428.428,0,0,0,.151-.027l1.388-.512Z",
                                                              transform:
                                                                "translate(-55.257 -420.513)",
                                                              fill: "#2dacae",
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6924",
                                                      "data-name": "Group 6924",
                                                      transform:
                                                        "translate(11.66 10.306)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "g",
                                                        kP(
                                                          {
                                                            id: "Group_6923",
                                                            "data-name":
                                                              "Group 6923",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)("path", {
                                                              id: "Path_4899",
                                                              "data-name":
                                                                "Path 4899",
                                                              d: "M294.06,255.682l-1.439-3.958-3.454,3.454,1.712-.631a.437.437,0,1,1,.3.819l-2.175.8a.436.436,0,0,1-.561-.259s0-.005,0-.008l-3.661,3.661,9.017-3.323A.435.435,0,0,0,294.06,255.682Z",
                                                              transform:
                                                                "translate(-284.783 -251.724)",
                                                              fill: "#2dacae",
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6926",
                                                      "data-name": "Group 6926",
                                                      transform:
                                                        "translate(0.001 0)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "g",
                                                        kP(
                                                          {
                                                            id: "Group_6925",
                                                            "data-name":
                                                              "Group 6925",
                                                            transform:
                                                              "translate(0 0)",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)("path", {
                                                              id: "Path_4900",
                                                              "data-name":
                                                                "Path 4900",
                                                              d: "M20.853,7.121,13.866.134a.437.437,0,0,0-.618,0l-13.1,13.1a.437.437,0,0,0,0,.618L7.134,20.84a.432.432,0,0,0,.308.128.439.439,0,0,0,.309-.128l13.1-13.1A.438.438,0,0,0,20.853,7.121ZM5.131,12.107,3.385,13.854a.437.437,0,0,1-.618-.618l1.747-1.747a.437.437,0,0,1,.618.618Zm7.542.555a1.649,1.649,0,0,1-1.2.458,3.609,3.609,0,0,1-2.429-1.16A4,4,0,0,1,7.957,10.1a1.825,1.825,0,0,1,.389-1.767,1.819,1.819,0,0,1,1.767-.389,3.994,3.994,0,0,1,1.859,1.091C13.184,10.248,13.494,11.841,12.674,12.661ZM18.233,7.74,16.486,9.486a.437.437,0,1,1-.618-.618l1.747-1.747a.437.437,0,0,1,.618.618Z",
                                                              transform:
                                                                "translate(-0.019 -0.006)",
                                                              fill: "#2dacae",
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
            }
          )
        ),
        MP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "37",
              height: "37",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsx)(
                "g",
                kP(
                  {
                    id: "Group_6981",
                    "data-name": "Group 6981",
                    transform: "translate(-826 -320)",
                  },
                  {
                    children: (0, e.jsxs)(
                      "g",
                      kP(
                        { id: "Group_6980", "data-name": "Group 6980" },
                        {
                          children: [
                            (0, e.jsx)("circle", {
                              id: "Ellipse_81",
                              "data-name": "Ellipse 81",
                              cx: "17.5",
                              cy: "17.5",
                              r: "17.5",
                              transform: "translate(826 320)",
                              fill: "#e3f4fe",
                            }),
                            (0, e.jsx)(
                              "g",
                              kP(
                                {
                                  id: "Group_6979",
                                  "data-name": "Group 6979",
                                  transform: "translate(-0.877 -0.356)",
                                },
                                {
                                  children: (0, e.jsx)(
                                    "g",
                                    kP(
                                      {
                                        id: "line-chart",
                                        transform: "translate(832.877 328.356)",
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          "g",
                                          kP(
                                            {
                                              id: "Group_6978",
                                              "data-name": "Group 6978",
                                              transform: "translate(0 0)",
                                            },
                                            {
                                              children: [
                                                (0, e.jsx)("path", {
                                                  id: "Path_4901",
                                                  "data-name": "Path 4901",
                                                  d: "M33,305.3v3.728a.416.416,0,0,0,.416.416H36.3a.416.416,0,0,0,.416-.416v-6.558l-2.093,2.093A2.539,2.539,0,0,1,33,305.3Z",
                                                  transform:
                                                    "translate(-31.441 -289.913)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4902",
                                                  "data-name": "Path 4902",
                                                  d: "M142,301.471v6.6a.416.416,0,0,0,.416.416H145.3a.416.416,0,0,0,.416-.416v-3.888a2.512,2.512,0,0,1-1.734-.737Z",
                                                  transform:
                                                    "translate(-135.291 -288.96)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4903",
                                                  "data-name": "Path 4903",
                                                  d: "M251,277v4.3a.416.416,0,0,0,.416.416H254.3a.416.416,0,0,0,.416-.416v-7.932l-3.3,3.3A2.469,2.469,0,0,1,251,277Z",
                                                  transform:
                                                    "translate(-239.141 -262.188)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4904",
                                                  "data-name": "Path 4904",
                                                  d: "M363.435,170.171,360,173.606v9.373a.416.416,0,0,0,.416.416H363.3a.416.416,0,0,0,.416-.416V170.431c-.094-.08-.165-.151-.217-.2Z",
                                                  transform:
                                                    "translate(-342.992 -163.864)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4905",
                                                  "data-name": "Path 4905",
                                                  d: "M22.8,36.893a.8.8,0,0,0-.609-.222h-.076c-1.342.061-2.679.128-4.021.189a.868.868,0,0,0-.619.213.7.7,0,0,0-.146.217.7.7,0,0,0,.213.841l.335.34c.232.236.468.472.7.7l-8.107,8.112L6.832,43.644a1.158,1.158,0,0,0-1.639,0L.34,48.492a1.158,1.158,0,0,0,0,1.639l.217.217a1.158,1.158,0,0,0,1.639,0L6.01,46.536l3.643,3.643a1.163,1.163,0,0,0,1.644,0l9.147-9.147,1.035,1.03a.784.784,0,0,0,.553.293.684.684,0,0,0,.331-.09.9.9,0,0,0,.2-.146.961.961,0,0,0,.25-.666c.038-.869.08-1.739.123-2.613l.061-1.309A.813.813,0,0,0,22.8,36.893Z",
                                                  transform:
                                                    "translate(0 -36.671)",
                                                  fill: "#2371cb",
                                                }),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            }
          )
        ),
        EP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "35",
              height: "35",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                kP(
                  {
                    id: "Group_6929",
                    "data-name": "Group 6929",
                    transform: "translate(-1066 -792)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_80",
                        "data-name": "Ellipse 80",
                        cx: "15.5",
                        cy: "15.5",
                        r: "15.5",
                        transform: "translate(1066 792)",
                        fill: "#4ed8da",
                      }),
                      (0, e.jsx)(
                        "g",
                        kP(
                          {
                            id: "Group_6930",
                            "data-name": "Group 6930",
                            transform: "translate(150.072 516.494)",
                          },
                          {
                            children: (0, e.jsx)(
                              "g",
                              kP(
                                {
                                  id: "Group_6927",
                                  "data-name": "Group 6927",
                                  transform: "translate(920.412 279.02)",
                                },
                                {
                                  children: (0, e.jsxs)(
                                    "g",
                                    kP(
                                      {
                                        id: "money_2_",
                                        "data-name": "money (2)",
                                        transform: "translate(0 0)",
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            "g",
                                            kP(
                                              {
                                                id: "Group_6920",
                                                "data-name": "Group 6920",
                                                transform:
                                                  "translate(0 10.231)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6919",
                                                      "data-name": "Group 6919",
                                                      transform: "translate(0)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4897",
                                                          "data-name":
                                                            "Path 4897",
                                                          d: "M.3,238.564a.459.459,0,0,0-.273.588l.288.793,2.195-2.195Z",
                                                          transform:
                                                            "translate(-0.001 -237.75)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            "g",
                                            kP(
                                              {
                                                id: "Group_6922",
                                                "data-name": "Group 6922",
                                                transform:
                                                  "translate(2.378 18.095)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6921",
                                                      "data-name": "Group 6921",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4898",
                                                          "data-name":
                                                            "Path 4898",
                                                          d: "M55.257,420.513l1.322,3.635a.455.455,0,0,0,.238.259.461.461,0,0,0,.194.043.45.45,0,0,0,.159-.028l1.459-.538Z",
                                                          transform:
                                                            "translate(-55.257 -420.513)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            "g",
                                            kP(
                                              {
                                                id: "Group_6924",
                                                "data-name": "Group 6924",
                                                transform:
                                                  "translate(12.255 10.832)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6923",
                                                      "data-name": "Group 6923",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4899",
                                                          "data-name":
                                                            "Path 4899",
                                                          d: "M294.533,255.884l-1.513-4.16-3.631,3.631,1.8-.663a.459.459,0,1,1,.318.861l-2.286.843a.459.459,0,0,1-.589-.272s0-.006,0-.008l-3.847,3.847,9.478-3.492A.458.458,0,0,0,294.533,255.884Z",
                                                          transform:
                                                            "translate(-284.783 -251.724)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            "g",
                                            kP(
                                              {
                                                id: "Group_6926",
                                                "data-name": "Group 6926",
                                                transform: "translate(0.001)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  kP(
                                                    {
                                                      id: "Group_6925",
                                                      "data-name": "Group 6925",
                                                      transform:
                                                        "translate(0 0)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4900",
                                                          "data-name":
                                                            "Path 4900",
                                                          d: "M21.917,7.484,14.573.14a.459.459,0,0,0-.649,0L.153,13.911a.459.459,0,0,0,0,.649L7.5,21.9a.454.454,0,0,0,.324.135.461.461,0,0,0,.325-.134l13.77-13.77A.46.46,0,0,0,21.917,7.484ZM5.392,12.724,3.556,14.56a.459.459,0,0,1-.65-.649l1.836-1.836a.459.459,0,0,1,.65.649Zm7.927.583a1.733,1.733,0,0,1-1.258.481,3.793,3.793,0,0,1-2.553-1.219,4.206,4.206,0,0,1-1.147-1.954,1.918,1.918,0,0,1,.409-1.857,1.912,1.912,0,0,1,1.857-.409A4.2,4.2,0,0,1,12.581,9.5C13.857,10.771,14.181,12.445,13.319,13.307Zm5.843-5.173L17.327,9.97a.459.459,0,0,1-.65-.649l1.836-1.836a.459.459,0,0,1,.65.649Z",
                                                          transform:
                                                            "translate(-0.019 -0.006)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
            }
          )
        ),
        DP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "35",
              height: "35",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsx)(
                "g",
                kP(
                  {
                    id: "Group_6885",
                    "data-name": "Group 6885",
                    transform: "translate(-1067.5 -1310)",
                  },
                  {
                    children: (0, e.jsx)("path", {
                      id: "MarkPaidMinor_1_",
                      "data-name": "MarkPaidMinor (1)",
                      d: "M24.618,10.317a1.929,1.929,0,0,1,0,2.728l-8.68,8.68a1.929,1.929,0,0,1-2.728,0L8.388,16.9a1.929,1.929,0,1,1,2.728-2.728l3.458,3.459,7.317-7.317A1.929,1.929,0,0,1,24.618,10.317ZM5.893,3A2.893,2.893,0,0,0,3,5.893V30.005a1.933,1.933,0,0,0,2.51,1.838,1.921,1.921,0,0,0,.843-.648l2.164-2.55,2.6,2.7a1.932,1.932,0,0,0,1.354.59,1.852,1.852,0,0,0,1.375-.542l2.631-2.54L19,31.369a1.923,1.923,0,0,0,2.728,0l2.739-2.739,2.2,2.573a1.879,1.879,0,0,0,3.347-1.2V5.893A2.893,2.893,0,0,0,27.112,3Z",
                      transform: "translate(1064.5 1307)",
                      fill: "#9c6ade",
                    }),
                  }
                )
              ),
            }
          )
        ),
        jP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "22.515",
              height: "15.386",
              viewBox: "0 0 20.515 15.386",
            },
            {
              children: (0, e.jsx)("path", {
                id: "id-card",
                d: "M18.164,3H2.351A2.353,2.353,0,0,0,0,5.351V16.035a2.353,2.353,0,0,0,2.351,2.351H18.164a2.353,2.353,0,0,0,2.351-2.351V5.351A2.353,2.353,0,0,0,18.164,3ZM6.411,6.419A2.137,2.137,0,1,1,4.274,8.556,2.14,2.14,0,0,1,6.411,6.419Zm3.847,7.907a.641.641,0,0,1-.641.641H3.205a.641.641,0,0,1-.641-.641V13.9a2.353,2.353,0,0,1,2.351-2.351H7.907A2.353,2.353,0,0,1,10.257,13.9Zm7.052.641h-4.7a.641.641,0,0,1,0-1.282h4.7a.641.641,0,1,1,0,1.282Zm0-3.419h-4.7a.641.641,0,0,1,0-1.282h4.7a.641.641,0,1,1,0,1.282Zm0-3.419h-4.7a.641.641,0,0,1,0-1.282h4.7a.641.641,0,1,1,0,1.282Z",
                transform: "translate(0 -3)",
                fill: "#5c5f62",
                "fill-rule": "evenodd",
              }),
            }
          )
        ),
        RP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18.321",
              height: "18.321",
              viewBox: "0 0 18.321 18.321",
            },
            {
              children: (0, e.jsx)("path", {
                id: "DiscountsMajor",
                d: "M10.6.6A2.005,2.005,0,0,0,7.726.6l-.881.9a2.005,2.005,0,0,1-1.458.6L4.125,2.1A2.005,2.005,0,0,0,2.1,4.125l.015,1.261a2.005,2.005,0,0,1-.6,1.458l-.9.881A2.005,2.005,0,0,0,.6,10.6l.9.881a2.007,2.007,0,0,1,.6,1.458L2.1,14.2a2.005,2.005,0,0,0,2.029,2.029l1.261-.015a2.005,2.005,0,0,1,1.458.6l.881.9a2,2,0,0,0,2.869,0l.881-.9a2.005,2.005,0,0,1,1.458-.6l1.261.016A2.005,2.005,0,0,0,16.225,14.2l-.015-1.261a2.005,2.005,0,0,1,.6-1.458l.9-.881a2,2,0,0,0,0-2.869l-.9-.881a2.005,2.005,0,0,1-.6-1.458l.016-1.261A2.005,2.005,0,0,0,14.2,2.1l-1.261.015a2.005,2.005,0,0,1-1.458-.6ZM6.412,7.787A1.374,1.374,0,1,0,5.038,6.412,1.374,1.374,0,0,0,6.412,7.787Zm5.5,5.5a1.374,1.374,0,1,0-1.374-1.374A1.374,1.374,0,0,0,11.909,13.283ZM12.621,5.7a1.008,1.008,0,0,1,0,1.425l-5.5,5.5A1.008,1.008,0,0,1,5.7,11.2l5.5-5.5a1.008,1.008,0,0,1,1.425,0Z",
                transform: "translate(0 0)",
                fill: "#5c5f62",
                "fill-rule": "evenodd",
              }),
            }
          )
        ),
        NP = (0, e.jsx)(
          "svg",
          kP(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "20.515",
              height: "20.515",
              viewBox: "0 0 20.515 15.386",
            },
            {
              children: (0, e.jsx)(
                "g",
                kP(
                  {
                    id: "Group_6934",
                    "data-name": "Group 6934",
                    transform: "translate(-30 -603)",
                  },
                  {
                    children: (0, e.jsx)(
                      "g",
                      kP(
                        {
                          id: "Group_6933",
                          "data-name": "Group 6933",
                          transform: "translate(-30 13.36)",
                        },
                        {
                          children: (0, e.jsxs)(
                            "g",
                            kP(
                              {
                                id: "Layer_2",
                                "data-name": "Layer 2",
                                transform: "translate(60 589.64)",
                              },
                              {
                                children: [
                                  (0, e.jsx)("circle", {
                                    id: "Ellipse_81",
                                    "data-name": "Ellipse 81",
                                    cx: "1.749",
                                    cy: "1.749",
                                    r: "1.749",
                                    transform: "translate(6.704 21.277)",
                                    fill: "#5c5f62",
                                  }),
                                  (0, e.jsx)("circle", {
                                    id: "Ellipse_82",
                                    "data-name": "Ellipse 82",
                                    cx: "1.749",
                                    cy: "1.749",
                                    r: "1.749",
                                    transform: "translate(16.03 21.277)",
                                    fill: "#5c5f62",
                                  }),
                                  (0, e.jsx)("path", {
                                    id: "Path_4901",
                                    "data-name": "Path 4901",
                                    d: "M4.643,1.25H2.124A.874.874,0,0,0,2.124,3H4.643a.3.3,0,0,1,.291.233L7.266,16.406a2.623,2.623,0,0,0,.093,5.235H21.944a.874.874,0,1,0,0-1.749H7.371a.874.874,0,1,1,0-1.749H21.2a3.229,3.229,0,0,0,3.148-2.576l1.679-8.394a2.052,2.052,0,0,0-2.005-2.437H6.986L6.659,2.917A2.064,2.064,0,0,0,4.643,1.25Zm7.974,9.583L14.949,8.5a.909.909,0,0,1,.28-.187.851.851,0,0,1,.676,0,.909.909,0,0,1,.28.187l2.332,2.332a.874.874,0,1,1-1.236,1.236l-.839-.839v2.553a.874.874,0,0,1-1.749,0V11.23l-.839.839a.874.874,0,0,1-1.236-1.236Z",
                                    transform: "translate(-1.25 -1.25)",
                                    fill: "#5c5f62",
                                    "fill-rule": "evenodd",
                                  }),
                                ],
                              }
                            )
                          ),
                        }
                      )
                    ),
                  }
                )
              ),
            }
          )
        ),
        AP =
          ((0, e.jsx)(
            "svg",
            kP(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.228",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "HomeMinor",
                  d: "M11.218,3.183a1.088,1.088,0,0,0-1.207,0L3.969,7.21A2.175,2.175,0,0,0,3,9.021v7.032a2.175,2.175,0,0,0,2.175,2.175H7.351A1.088,1.088,0,0,0,8.439,17.14V12.79H12.79V17.14a1.088,1.088,0,0,0,1.088,1.088h2.175a2.175,2.175,0,0,0,2.175-2.175V9.021a2.176,2.176,0,0,0-.968-1.81L11.218,3.183Z",
                  transform: "translate(-3 -3)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            kP(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.125",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
                className: "icon-hover",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "CheckoutMajor",
                  d: "M1,.84A.842.842,0,0,1,1.844,0H3.108A1.263,1.263,0,0,1,4.373,1.26v.471l10.565.763a1.263,1.263,0,0,1,1.174,1.437L15.384,9a1.264,1.264,0,0,1-1.251,1.082H4.373v1.68h8.439a2.518,2.518,0,1,1-2.385,1.68H5.915a2.531,2.531,0,1,1-3.229-1.538V1.68H1.844A.842.842,0,0,1,1,.84ZM11.969,14.284a.843.843,0,1,1,.843.84.842.842,0,0,1-.843-.84Zm-9.282,0a.843.843,0,1,1,.844.84.842.842,0,0,1-.844-.84Z",
                  transform: "translate(-1)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            kP(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.228",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "CustomersMajor",
                  d: "M14.288,5.195A4.194,4.194,0,1,1,10.094,1a4.194,4.194,0,0,1,4.194,4.195ZM2.666,14.388a12.486,12.486,0,0,1,7.429-2.836,12.5,12.5,0,0,1,7.429,2.836,1.843,1.843,0,0,1,.564,2.044l-.331,1.014a2.1,2.1,0,0,1-1.994,1.446H4.426a2.1,2.1,0,0,1-1.993-1.446L2.1,16.431a1.838,1.838,0,0,1,.564-2.044Z",
                  transform: "translate(-2 -1)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            kP(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.228",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "ReceiptMajor",
                  d: "M13.826,0H4.3A1.3,1.3,0,0,0,3,1.31V17.079a.173.173,0,0,0,.289.13L4.73,15.9a.43.43,0,0,1,.58,0l1.441,1.311a.431.431,0,0,0,.58,0L8.773,15.9a.43.43,0,0,1,.58,0l1.44,1.311a.431.431,0,0,0,.58,0L12.815,15.9a.43.43,0,0,1,.58,0l1.441,1.312a.173.173,0,0,0,.289-.13V1.31A1.3,1.3,0,0,0,13.826,0Zm-.433,4.33V3.464H4.732V5.2h8.661Zm0,2.6V8.661H4.732V6.929Zm-3.464,4.33v-.866h-5.2v1.732h5.2Z",
                  transform: "translate(-3)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsxs)(
            "svg",
            kP(
              {
                version: "1.1",
                id: "Capa_1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "50.228",
                height: "20.228",
                viewBox: "0 0 50.999 511.999",
                fill: "#5c5f62",
                "fill-rule": "evenodd",
              },
              {
                children: [
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M438.09,273.32h-39.596c4.036,11.05,6.241,22.975,6.241,35.404v149.65c0,5.182-0.902,10.156-2.543,14.782h65.461\r\n\t\t\tc24.453,0,44.346-19.894,44.346-44.346v-81.581C512,306.476,478.844,273.32,438.09,273.32z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M107.265,308.725c0-12.43,2.205-24.354,6.241-35.404H73.91c-40.754,0-73.91,33.156-73.91,73.91v81.581\r\n\t\t\tc0,24.452,19.893,44.346,44.346,44.346h65.462c-1.641-4.628-2.543-9.601-2.543-14.783V308.725z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M301.261,234.815h-90.522c-40.754,0-73.91,33.156-73.91,73.91v149.65c0,8.163,6.618,14.782,14.782,14.782h208.778\r\n\t\t\tc8.164,0,14.782-6.618,14.782-14.782v-149.65C375.171,267.971,342.015,234.815,301.261,234.815z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M256,38.84c-49.012,0-88.886,39.874-88.886,88.887c0,33.245,18.349,62.28,45.447,77.524\r\n\t\t\tc12.853,7.23,27.671,11.362,43.439,11.362c15.768,0,30.586-4.132,43.439-11.362c27.099-15.244,45.447-44.28,45.447-77.524\r\n\t\t\tC344.886,78.715,305.012,38.84,256,38.84z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M99.918,121.689c-36.655,0-66.475,29.82-66.475,66.475c0,36.655,29.82,66.475,66.475,66.475\r\n\t\t\tc9.298,0,18.152-1.926,26.195-5.388c13.906-5.987,25.372-16.585,32.467-29.86c4.98-9.317,7.813-19.946,7.813-31.227\r\n\t\t\tC166.393,151.51,136.573,121.689,99.918,121.689z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M412.082,121.689c-36.655,0-66.475,29.82-66.475,66.475c0,11.282,2.833,21.911,7.813,31.227\r\n\t\t\tc7.095,13.276,18.561,23.874,32.467,29.86c8.043,3.462,16.897,5.388,26.195,5.388c36.655,0,66.475-29.82,66.475-66.475\r\n\t\t\tC478.557,151.509,448.737,121.689,412.082,121.689z",
                      }),
                    }),
                  }),
                ],
              }
            )
          ),
          function () {
            return (
              (AP =
                Object.assign ||
                function (e) {
                  for (var t, n = 1, r = arguments.length; n < r; n++)
                    for (var o in (t = arguments[n]))
                      Object.prototype.hasOwnProperty.call(t, o) &&
                        (e[o] = t[o]);
                  return e;
                }),
              AP.apply(this, arguments)
            );
          }),
        LP = function () {
          var n,
            r,
            o,
            a,
            i,
            s,
            l,
            c,
            u = zw(),
            d = u.ST_DB_Min_Cards,
            p = u.ST_DB_Graph_Cards,
            m = u.ST_DB_Horizontal_Line,
            h = u.ST_DB_Information_Box,
            f = u.ST_DB_Min_Cards_Graph,
            g = u.ST_DB_Graph_CardTotal,
            v = u.ST_DB_cardText_Font,
            b = u.ST_DB_Graph_catrdTotal_Text,
            _ = u.ST_DB_HowItWorksButton,
            y = u.ST_CI_VirticalLine,
            x = u.ST_CI_VirticalLineGrid,
            C = Lw(),
            S = C.drawerStatus,
            k = C.callDefaultFunctions,
            w = C.currentMonth,
            P = C.dataLine,
            O = C.optionsLine,
            I = C.sixMonthsBar,
            T = C.optionSixMonthsBar,
            M =
              (C.currentMonthPie,
              C.optionCurrentMonthPie,
              C.commissionMonthBar),
            E = C.optionsCommissionMonthBar,
            D = C.ordersFeatureBar,
            j = C.optionsOrdersFeatureBar,
            R = C.commisionFeaturePie,
            N = C.optionsCommisionFeaturePie,
            A = C.salesRepData,
            L = C.openCommissionDialog,
            z = C.setOpenCommissionDialog,
            B = C.getCommissionStructure,
            Z = (C.loggedInRepData, C.getTimeZone, C.showNoDataMessage),
            F = C.t,
            H = C.shopCurrency,
            V = C.currentMonthCommissionDetails,
            W = C.totalCommissionPie,
            $ = C.totalRevenue,
            U = C.avgTicketSize,
            K = C.isDesktop,
            G = C.performanceDetailsPopup,
            q = C.setPerformanceDetailsPopup,
            Y = C.handlePerformanceDetailsPopup,
            J = C.salesRepMonthlyPerformance,
            Q = C.performance_Details_Headers,
            X = C.selectFeatures;
          kk.register(zk, Zk, hw, Jk, dw, uw, Mk, qk, Uk, CP);
          var ee =
            null === (n = null == A ? void 0 : A.CommissionDiscountOn) ||
            void 0 === n
              ? void 0
              : n.CommissionDiscountOn;
          return (
            (0, t.useEffect)(
              function () {
                k();
              },
              [S]
            ),
            (0, e.jsxs)(e.Fragment, {
              children: [
                (0, e.jsxs)(
                  c_,
                  AP(
                    { className: "ST_Main_Card" },
                    {
                      children: [
                        (0, e.jsxs)(
                          La,
                          AP(
                            {
                              container: !0,
                              spacing: 2,
                              mb: 1,
                              justifyContent: "space-between",
                            },
                            {
                              children: [
                                (0, e.jsxs)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 12,
                                      mb: 1,
                                      sx: AP(AP({}, xo), {
                                        justifyContent: K
                                          ? "space-between"
                                          : "flex-start",
                                        flexDirection: K ? "row" : "column",
                                      }),
                                    },
                                    {
                                      children: [
                                        (0, e.jsxs)(
                                          Wa,
                                          AP(
                                            {
                                              variant: K ? "body2" : "body1",
                                              sx: {
                                                fontWeight: "bold",
                                                fontSize: K ? "1.4rem" : "1rem",
                                                mt: K ? 1 : 0,
                                                mb: K ? 0 : 1,
                                              },
                                            },
                                            {
                                              children: [
                                                F("dashboard_subTitle1"),
                                                " : ",
                                                w,
                                              ],
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          Wa,
                                          AP(
                                            { sx: h },
                                            {
                                              children: (0, e.jsx)(
                                                La,
                                                AP(
                                                  {
                                                    container: !0,
                                                    style: AP(AP({}, xo), {
                                                      margin: "0px",
                                                      flexDirection: K
                                                        ? "unset"
                                                        : "column",
                                                      paddingInlineStart: K
                                                        ? "1rem"
                                                        : "0.7rem",
                                                      lineHeight: K
                                                        ? "3rem"
                                                        : "1.5rem",
                                                    }),
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      La,
                                                      AP(
                                                        {
                                                          container: !0,
                                                          style: AP(
                                                            AP({}, xo),
                                                            {
                                                              margin: "0px",
                                                              flexDirection: K
                                                                ? "unset"
                                                                : "column",
                                                              paddingInlineStart:
                                                                K ? "" : "0px",
                                                            }
                                                          ),
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsxs)(
                                                              La,
                                                              AP(
                                                                {
                                                                  item: !0,
                                                                  style: AP(
                                                                    AP({}, xo),
                                                                    {
                                                                      fontSize:
                                                                        K
                                                                          ? "15px"
                                                                          : "14px",
                                                                      marginRight:
                                                                        "20px",
                                                                      marginTop:
                                                                        K
                                                                          ? "0rem"
                                                                          : "0.5rem",
                                                                    }
                                                                  ),
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsx)(
                                                                      "span",
                                                                      AP(
                                                                        {
                                                                          className:
                                                                            "ST_DB_InformationText",
                                                                        },
                                                                        {
                                                                          children:
                                                                            IP,
                                                                        }
                                                                      )
                                                                    ),
                                                                    " ",
                                                                    (0, e.jsx)(
                                                                      "span",
                                                                      AP(
                                                                        {
                                                                          style:
                                                                            {
                                                                              fontSize:
                                                                                K
                                                                                  ? "15px"
                                                                                  : "14px",
                                                                              marginTop:
                                                                                "0.25rem",
                                                                            },
                                                                        },
                                                                        {
                                                                          children:
                                                                            F(
                                                                              "dashbord_informationMsg"
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                            K
                                                              ? (0, e.jsx)(
                                                                  La,
                                                                  AP(
                                                                    {
                                                                      item: !0,
                                                                      sx: x,
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          La,
                                                                          {
                                                                            sx: y,
                                                                          }
                                                                        ),
                                                                    }
                                                                  )
                                                                )
                                                              : "",
                                                            (0, e.jsx)(
                                                              La,
                                                              AP(
                                                                {
                                                                  item: !0,
                                                                  component:
                                                                    "li",
                                                                  className:
                                                                    "ST_DB_DashboardMsg",
                                                                },
                                                                {
                                                                  children: F(
                                                                    "dashboard_BannerMsg"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              La,
                                                              AP(
                                                                {
                                                                  item: !0,
                                                                  component:
                                                                    "li",
                                                                  className:
                                                                    "ST_DB_DashboardMsg",
                                                                  sx: {
                                                                    marginBottom:
                                                                      K
                                                                        ? "0rem"
                                                                        : "0.6rem",
                                                                  },
                                                                },
                                                                {
                                                                  children: F(
                                                                    "dashboard_Information_Message"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsxs)(
                                          c_,
                                          AP(
                                            { sx: _ },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  Il,
                                                  AP(
                                                    {
                                                      target: "_blank",
                                                      href: "https://youtu.be/-p3GxLRxpIU?si=V5srtDDLzzQRzhzd",
                                                      sx: {
                                                        textDecoration: "none",
                                                        color: "#6D7175",
                                                      },
                                                    },
                                                    {
                                                      children:
                                                        F("dashbord_Msg_New"),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(SP, {}),
                                              ],
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 2,
                                      className: "ST_DB_Min_Class",
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        o_,
                                        AP(
                                          {
                                            sx: AP(AP({}, d), {
                                              border: "0.5px solid #2371CB",
                                              borderBottom: "2px solid #2371CB",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              l_,
                                              AP(
                                                { sx: { textAlign: "center" } },
                                                {
                                                  children: [
                                                    wP,
                                                    "SalesRep" === ee
                                                      ? (0, e.jsxs)(
                                                          Wa,
                                                          AP(
                                                            {
                                                              variant: "body2",
                                                              sx: v,
                                                            },
                                                            {
                                                              children: [
                                                                (null ===
                                                                  (r =
                                                                    null == A
                                                                      ? void 0
                                                                      : A.SalesRepCommissionModel) ||
                                                                void 0 === r
                                                                  ? void 0
                                                                  : r.Commissionforsalerep) &&
                                                                  100 *
                                                                    (null ===
                                                                      (o =
                                                                        null ==
                                                                        A
                                                                          ? void 0
                                                                          : A.SalesRepCommissionModel) ||
                                                                    void 0 === o
                                                                      ? void 0
                                                                      : o.Commissionforsalerep),
                                                                "%",
                                                                (0, e.jsx)(
                                                                  Wa,
                                                                  AP(
                                                                    {
                                                                      variant:
                                                                        "body2",
                                                                      mb: 1,
                                                                      align:
                                                                        "center",
                                                                    },
                                                                    {
                                                                      children:
                                                                        F(
                                                                          "dashboard_CardTitle1"
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        )
                                                      : "ProfitMargin" === ee
                                                      ? (0, e.jsx)(
                                                          Wa,
                                                          AP(
                                                            {
                                                              variant: "body2",
                                                              align: "center",
                                                            },
                                                            {
                                                              children: F(
                                                                "dashboard_commissionOn_profitMargin"
                                                              ),
                                                            }
                                                          )
                                                        )
                                                      : "ProductType" === ee ||
                                                        "Product" === ee
                                                      ? (0, e.jsx)(
                                                          Wa,
                                                          AP(
                                                            {
                                                              variant: "body2",
                                                              mt: 2,
                                                              sx: AP(
                                                                {
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                },
                                                                Io
                                                              ),
                                                              align: "center",
                                                              onClick:
                                                                function () {
                                                                  z(!0);
                                                                },
                                                            },
                                                            {
                                                              children: F(
                                                                "show_commission_list"
                                                              ),
                                                            }
                                                          )
                                                        )
                                                      : (0, e.jsx)(
                                                          Wa,
                                                          AP(
                                                            {
                                                              variant: "body2",
                                                              align: "center",
                                                            },
                                                            { children: "-" }
                                                          )
                                                        ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 2,
                                      className: "ST_DB_Min_Class",
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        o_,
                                        AP(
                                          {
                                            sx: AP(AP({}, d), {
                                              border: "0.5px solid #8566FB",
                                              borderBottom: "2px solid #8566FB",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              l_,
                                              AP(
                                                { sx: { textAlign: "center" } },
                                                {
                                                  children: [
                                                    OP,
                                                    (0, e.jsx)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "body2",
                                                          sx: v,
                                                        },
                                                        {
                                                          children:
                                                            null !==
                                                              (a =
                                                                null == V
                                                                  ? void 0
                                                                  : V.TotalNoOfOrders) &&
                                                            void 0 !== a
                                                              ? a
                                                              : "0",
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "body2",
                                                          mb: 1,
                                                          align: "center",
                                                        },
                                                        {
                                                          children: F(
                                                            "dashboar_cardHeading1"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 2,
                                      className: "ST_DB_Min_Class",
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        o_,
                                        AP(
                                          {
                                            sx: AP(AP({}, d), {
                                              border: "0.5px solid #4ED8DA",
                                              borderBottom: "2px solid #4ED8DA",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              l_,
                                              AP(
                                                { sx: { textAlign: "center" } },
                                                {
                                                  children: [
                                                    TP,
                                                    (0, e.jsxs)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "body2",
                                                          sx: v,
                                                        },
                                                        {
                                                          children: [
                                                            H,
                                                            " ",
                                                            (
                                                              null == V
                                                                ? void 0
                                                                : V.TotalCommission
                                                            )
                                                              ? V.TotalCommission.toFixed(
                                                                  2
                                                                )
                                                              : "0.00",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "body2",
                                                          mb: 1,
                                                          align: "center",
                                                        },
                                                        {
                                                          children: F(
                                                            "dashboard_CardTitle3"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 2,
                                      className: "ST_DB_Min_Class",
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        o_,
                                        AP(
                                          {
                                            sx: AP(AP({}, d), {
                                              border: "0.5px solid #28B433",
                                              borderBottom: "2px solid #28B433",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              l_,
                                              AP(
                                                { sx: { textAlign: "center" } },
                                                {
                                                  children: [
                                                    PP,
                                                    (0, e.jsxs)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "body2",
                                                          sx: v,
                                                        },
                                                        {
                                                          children: [
                                                            H,
                                                            " ",
                                                            (
                                                              null == V
                                                                ? void 0
                                                                : V.TotalSale
                                                            )
                                                              ? null ===
                                                                  (i =
                                                                    null == V
                                                                      ? void 0
                                                                      : V.TotalSale) ||
                                                                void 0 === i
                                                                ? void 0
                                                                : i.toFixed(2)
                                                              : "0.00",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "body2",
                                                          mb: 1,
                                                          align: "center",
                                                        },
                                                        {
                                                          children: F(
                                                            "dashboard_CardTitle4"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 2,
                                      className: "ST_DB_Min_Class",
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        o_,
                                        AP(
                                          {
                                            sx: AP(AP({}, d), {
                                              border: "0.5px solid #4ED8DA",
                                              borderBottom: "2px solid #4ED8DA",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              l_,
                                              AP(
                                                { sx: { textAlign: "center" } },
                                                {
                                                  children: [
                                                    MP,
                                                    (0, e.jsx)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "h6",
                                                          sx: {
                                                            fontSize: "14px",
                                                          },
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            "b",
                                                            {
                                                              children: [
                                                                " ",
                                                                F(
                                                                  "Performance_Details"
                                                                ),
                                                              ],
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      Wa,
                                                      AP(
                                                        {
                                                          variant: "subtitle2",
                                                          sx: AP(
                                                            {
                                                              whiteSpace:
                                                                "nowrap",
                                                            },
                                                            Io
                                                          ),
                                                          align: "center",
                                                          onClick: function () {
                                                            Y();
                                                          },
                                                        },
                                                        {
                                                          children: F(
                                                            "Show_Performance_Details"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsxs)(
                          La,
                          AP(
                            { container: !0, spacing: 2, mb: 1 },
                            {
                              children: [
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 12,
                                      sx: { textAlign: "center" },
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        La,
                                        AP(
                                          {
                                            sx: AP(AP({}, xo), {
                                              alignItems: "center",
                                            }),
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)("hr", {
                                                className:
                                                  "ST_DB_HorizontalLine",
                                                style: m,
                                              }),
                                              (0, e.jsx)(
                                                "span",
                                                AP(
                                                  {
                                                    className:
                                                      "ST_DB_Dashboard_GraphHeading",
                                                  },
                                                  {
                                                    children: F(
                                                      "dashboard_graphHeading1"
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)("hr", {
                                                className:
                                                  "ST_DB_HorizontalLine",
                                                style: m,
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: 6 },
                                    {
                                      children: (0, e.jsxs)(
                                        c_,
                                        AP(
                                          { sx: p },
                                          {
                                            children: [
                                              (0, e.jsx)(Kw, {
                                                data: P,
                                                options: O,
                                                className: "ST_DB_Graph",
                                              }),
                                              Z(3),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: 6 },
                                    {
                                      children: (0, e.jsxs)(
                                        c_,
                                        AP(
                                          { sx: p },
                                          {
                                            children: [
                                              (0, e.jsx)(Gw, {
                                                data: M,
                                                options: E,
                                                className: "ST_DB_Graph",
                                              }),
                                              Z(4),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: K ? 8 : 6 },
                                    {
                                      children: (0, e.jsx)(
                                        c_,
                                        AP(
                                          {
                                            sx: AP(AP({}, p), xo),
                                            justifyContent: "center",
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              c_,
                                              AP(
                                                {
                                                  sx: {
                                                    width: K ? "77%" : "100%",
                                                  },
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsx)(Gw, {
                                                      data: I,
                                                      options: T,
                                                    }),
                                                    Z(5),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: K ? 4 : 6 },
                                    {
                                      children: (0, e.jsx)(
                                        c_,
                                        AP(
                                          { sx: xo, justifyContent: "center" },
                                          {
                                            children: (0, e.jsxs)(
                                              c_,
                                              AP(
                                                { sx: { width: "100%" } },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      o_,
                                                      AP(
                                                        {
                                                          sx: AP(AP({}, f), {
                                                            border:
                                                              "0.5px solid #4ED8DA",
                                                            borderBottom:
                                                              "2px solid #4ED8DA",
                                                            mb: K ? 5 : 2,
                                                          }),
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            l_,
                                                            AP(
                                                              {
                                                                sx: {
                                                                  textAlign:
                                                                    "center",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsxs)(
                                                                    c_,
                                                                    AP(
                                                                      {
                                                                        sx: {
                                                                          display:
                                                                            "inline-flex",
                                                                          paddingTop:
                                                                            "2rem",
                                                                        },
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsx)(
                                                                              Wa,
                                                                              {
                                                                                children:
                                                                                  EP,
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              Wa,
                                                                              AP(
                                                                                {
                                                                                  variant:
                                                                                    "body2",
                                                                                  sx: g,
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    F(
                                                                                      "dashboard_TotalRevenue"
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Wa,
                                                                    AP(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                        align:
                                                                          "center",
                                                                        mb: 1,
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsxs)(
                                                                            c_,
                                                                            AP(
                                                                              {
                                                                                sx: AP(
                                                                                  AP(
                                                                                    {},
                                                                                    b
                                                                                  ),
                                                                                  {
                                                                                    backgroundColor:
                                                                                      "#4ED8DA",
                                                                                  }
                                                                                ),
                                                                              },
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    H,
                                                                                    null !==
                                                                                      (s =
                                                                                        null ==
                                                                                        $
                                                                                          ? void 0
                                                                                          : $.toFixed(
                                                                                              2
                                                                                            )) &&
                                                                                    void 0 !==
                                                                                      s
                                                                                      ? s
                                                                                      : 0,
                                                                                  ],
                                                                              }
                                                                            )
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      o_,
                                                      AP(
                                                        {
                                                          sx: AP(AP({}, f), {
                                                            border:
                                                              "0.5px solid #9C6ADE",
                                                            borderBottom:
                                                              "2px solid #9C6ADE",
                                                          }),
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            l_,
                                                            AP(
                                                              {
                                                                sx: {
                                                                  textAlign:
                                                                    "center",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsxs)(
                                                                    c_,
                                                                    AP(
                                                                      {
                                                                        sx: {
                                                                          display:
                                                                            "inline-flex",
                                                                          paddingTop:
                                                                            "2rem",
                                                                        },
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsx)(
                                                                              Wa,
                                                                              {
                                                                                children:
                                                                                  DP,
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              Wa,
                                                                              AP(
                                                                                {
                                                                                  variant:
                                                                                    "body2",
                                                                                  sx: g,
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    F(
                                                                                      "dashboard_TotalAvg_Ticket_Size"
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Wa,
                                                                    AP(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                        align:
                                                                          "center",
                                                                        mb: 1,
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsxs)(
                                                                            c_,
                                                                            AP(
                                                                              {
                                                                                sx: AP(
                                                                                  AP(
                                                                                    {},
                                                                                    b
                                                                                  ),
                                                                                  {
                                                                                    backgroundColor:
                                                                                      "#9C6ADE",
                                                                                  }
                                                                                ),
                                                                              },
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    H,
                                                                                    null !==
                                                                                      (l =
                                                                                        null ==
                                                                                        U
                                                                                          ? void 0
                                                                                          : U.toFixed(
                                                                                              2
                                                                                            )) &&
                                                                                    void 0 !==
                                                                                      l
                                                                                      ? l
                                                                                      : 0,
                                                                                  ],
                                                                              }
                                                                            )
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: 12 },
                                    {
                                      children: (0, e.jsxs)(
                                        La,
                                        AP(
                                          {
                                            sx: AP(AP({}, xo), {
                                              alignItems: "center",
                                            }),
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)("hr", {
                                                className:
                                                  "ST_DB_HorizontalLine",
                                                style: m,
                                              }),
                                              (0, e.jsxs)(
                                                "span",
                                                AP(
                                                  {
                                                    className:
                                                      "ST_DB_Dashboard_GraphHeading",
                                                  },
                                                  {
                                                    children: [
                                                      F(
                                                        "dashboard_graphHeading2"
                                                      ),
                                                      " : ",
                                                      w,
                                                    ],
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)("hr", {
                                                className:
                                                  "ST_DB_HorizontalLine",
                                                style: m,
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: 6 },
                                    {
                                      children: (0, e.jsxs)(
                                        c_,
                                        AP(
                                          { sx: p },
                                          {
                                            children: [
                                              (0, e.jsx)(Gw, {
                                                data: D,
                                                options: j,
                                                className: "ST_DB_Graph",
                                              }),
                                              Z(1),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  La,
                                  AP(
                                    { item: !0, xs: 12, md: 6 },
                                    {
                                      children: (0, e.jsxs)(
                                        c_,
                                        AP(
                                          { sx: p },
                                          {
                                            children: [
                                              (0, e.jsx)(qw, {
                                                data: R,
                                                options: N,
                                                className: "ST_DB_Graph",
                                              }),
                                              Z(2),
                                              (0, e.jsx)(
                                                Wa,
                                                AP(
                                                  { mt: 0 },
                                                  {
                                                    children: (0, e.jsxs)("b", {
                                                      children: [
                                                        " ",
                                                        F(
                                                          "dashboard_CardTitle3"
                                                        ),
                                                        " : ",
                                                        null !==
                                                          (c =
                                                            null == W
                                                              ? void 0
                                                              : W.toFixed(2)) &&
                                                        void 0 !== c
                                                          ? c
                                                          : 0,
                                                      ],
                                                    }),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
                (0, e.jsx)(
                  Av,
                  AP(
                    {
                      open: L,
                      onClose: function () {
                        return z(!1);
                      },
                      maxWidth: "sm",
                      fullWidth: !0,
                    },
                    {
                      children: (0, e.jsxs)(
                        c_,
                        AP(
                          { className: "ST_DB_Dialog_Box" },
                          {
                            children: [
                              (0, e.jsxs)(
                                La,
                                AP(
                                  { container: !0, spacing: 2, mb: 2, pl: 2 },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        La,
                                        AP(
                                          { item: !0, xs: 10, md: 10 },
                                          {
                                            children: (0, e.jsx)(
                                              Wa,
                                              AP(
                                                { variant: "h6" },
                                                {
                                                  children:
                                                    F("commission_list"),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        La,
                                        AP(
                                          {
                                            item: !0,
                                            xs: 2,
                                            md: 2,
                                            sx: { textAlign: "right" },
                                            pr: 1,
                                          },
                                          {
                                            children: (0, e.jsx)(pv, {
                                              sx: { cursor: "pointer" },
                                              onClick: function () {
                                                z(!1);
                                              },
                                            }),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                Fv,
                                AP(
                                  { sx: { padding: "0px" } },
                                  {
                                    children: (0, e.jsx)(
                                      Ga,
                                      AP(
                                        { sx: { maxHeight: 500, mt: 3 } },
                                        {
                                          children: (0, e.jsxs)(
                                            ei,
                                            AP(
                                              { stickyHeader: !0 },
                                              {
                                                children: [
                                                  (0, e.jsx)(si, {
                                                    children: (0, e.jsxs)(hi, {
                                                      children: [
                                                        (0, e.jsx)(
                                                          yi,
                                                          AP(
                                                            {
                                                              className:
                                                                "ST_DC_Thead",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)("b", {
                                                                children:
                                                                  "ProductType" ===
                                                                  ee
                                                                    ? "Product Type"
                                                                    : "Product Name",
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          yi,
                                                          AP(
                                                            {
                                                              className:
                                                                "ST_DC_Thead",
                                                              align: "center",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)("b", {
                                                                children: F(
                                                                  "dashboar_cardHeading2"
                                                                ),
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }),
                                                  }),
                                                  ee && "ProductType" === ee
                                                    ? B(
                                                        null == A
                                                          ? void 0
                                                          : A.CommissionandDiscountPerProductType,
                                                        "productType",
                                                        "ClientCommission"
                                                      )
                                                    : B(
                                                        null == A
                                                          ? void 0
                                                          : A.CommissionandDiscountPerProduct,
                                                        "ProductName",
                                                        "CommissionForCustomerOrder"
                                                      ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    }
                  )
                ),
                (0, e.jsx)(
                  Av,
                  AP(
                    {
                      open: G,
                      onClose: function () {
                        return q(!1);
                      },
                      maxWidth: "sm",
                      fullWidth: !0,
                    },
                    {
                      children: (0, e.jsxs)(
                        c_,
                        AP(
                          { className: "ST_DB_Dialog_Box" },
                          {
                            children: [
                              (0, e.jsxs)(
                                La,
                                AP(
                                  { container: !0, spacing: 2, mb: 2, pl: 2 },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        La,
                                        AP(
                                          { item: !0, xs: 10, md: 10 },
                                          {
                                            children: (0, e.jsx)(
                                              Wa,
                                              AP(
                                                { variant: "h6" },
                                                {
                                                  children: (0, e.jsx)("b", {
                                                    children: F(
                                                      "Performance_Details"
                                                    ),
                                                  }),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        La,
                                        AP(
                                          {
                                            item: !0,
                                            xs: 2,
                                            md: 2,
                                            sx: { textAlign: "right" },
                                            pr: 1,
                                          },
                                          {
                                            children: (0, e.jsx)(pv, {
                                              sx: { cursor: "pointer" },
                                              onClick: function () {
                                                q(!1);
                                              },
                                            }),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsx)("hr", { className: "ST_DB_Hr" }),
                              (0, e.jsx)(
                                Fv,
                                AP(
                                  { sx: { padding: "0px" } },
                                  {
                                    children: (0, e.jsx)(
                                      Ga,
                                      AP(
                                        {
                                          style: { maxHeight: "400px" },
                                          component: io,
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            ei,
                                            AP(
                                              { stickyHeader: !0 },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    si,
                                                    AP(
                                                      {
                                                        className:
                                                          "stickyHeaderRow",
                                                      },
                                                      {
                                                        children: Q.map(
                                                          function (t, n) {
                                                            return (0, e.jsx)(
                                                              yi,
                                                              AP(
                                                                {
                                                                  className:
                                                                    "ST_PerformanceDetailsTable",
                                                                  sx: (
                                                                    null == t
                                                                      ? void 0
                                                                      : t.hide
                                                                  )
                                                                    ? {
                                                                        display:
                                                                          "none",
                                                                      }
                                                                    : {
                                                                        display:
                                                                          "table-cell",
                                                                      },
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)("b", {
                                                                    children: [
                                                                      " ",
                                                                      null == t
                                                                        ? void 0
                                                                        : t.name,
                                                                    ],
                                                                  }),
                                                                }
                                                              ),
                                                              n
                                                            );
                                                          }
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(Pi, {
                                                    children:
                                                      (null == J
                                                        ? void 0
                                                        : J.length) > 0
                                                        ? null == J
                                                          ? void 0
                                                          : J.map(function (t) {
                                                              var n, r, o;
                                                              return (0,
                                                              e.jsxs)(hi, { children: [(0, e.jsx)(yi, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.Month }) }), (0, e.jsx)(yi, { children: null == t ? void 0 : t.TotalNoOfOrders }), (0, e.jsx)(yi, { children: null === (n = null == t ? void 0 : t.TotalSale) || void 0 === n ? void 0 : n.toFixed(2) }), (0, e.jsx)(yi, { children: null === (r = null == t ? void 0 : t.TotalCommission) || void 0 === r ? void 0 : r.toFixed(2) }), (null == X ? void 0 : X.Bonus) ? (0, e.jsx)(yi, { children: null === (o = null == t ? void 0 : t.TotalBonus) || void 0 === o ? void 0 : o.toFixed(2) }) : (0, e.jsx)(e.Fragment, {})] });
                                                            })
                                                        : (0, e.jsx)(hi, {
                                                            children:
                                                              "No Data to Show",
                                                          }),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    }
                  )
                ),
              ],
            })
          );
        },
        zP = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z",
          }),
          "Facebook"
        ),
        BP = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z",
          }),
          "Instagram"
        ),
        ZP = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z",
          }),
          "Twitter"
        ),
        FP = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M9.04 21.54c.96.29 1.93.46 2.96.46a10 10 0 0 0 10-10A10 10 0 0 0 12 2 10 10 0 0 0 2 12c0 4.25 2.67 7.9 6.44 9.34-.09-.78-.18-2.07 0-2.96l1.15-4.94s-.29-.58-.29-1.5c0-1.38.86-2.41 1.84-2.41.86 0 1.26.63 1.26 1.44 0 .86-.57 2.09-.86 3.27-.17.98.52 1.84 1.52 1.84 1.78 0 3.16-1.9 3.16-4.58 0-2.4-1.72-4.04-4.19-4.04-2.82 0-4.48 2.1-4.48 4.31 0 .86.28 1.73.74 2.3.09.06.09.14.06.29l-.29 1.09c0 .17-.11.23-.28.11-1.28-.56-2.02-2.38-2.02-3.85 0-3.16 2.24-6.03 6.56-6.03 3.44 0 6.12 2.47 6.12 5.75 0 3.44-2.13 6.2-5.18 6.2-.97 0-1.92-.52-2.26-1.13l-.67 2.37c-.23.86-.86 2.01-1.29 2.7v-.03z",
          }),
          "Pinterest"
        ),
        HP = (0, bo.Z)(
          [
            (0, e.jsx)(
              "path",
              {
                d: "M12.79 21 3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83z",
              },
              "0"
            ),
            (0, e.jsx)(
              "path",
              {
                d: "M11.38 17.41c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.63.58C12.25.21 11.74 0 11.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41zM7.25 3c.69 0 1.25.56 1.25 1.25S7.94 5.5 7.25 5.5 6 4.94 6 4.25 6.56 3 7.25 3",
              },
              "1"
            ),
          ],
          "DiscountRounded"
        );
      const VP = [
          "addEndListener",
          "appear",
          "children",
          "easing",
          "in",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExited",
          "onExiting",
          "style",
          "timeout",
          "TransitionComponent",
        ],
        WP = {
          entering: { transform: "none" },
          entered: { transform: "none" },
        },
        $P = t.forwardRef(function (n, r) {
          const o = jr(),
            a = {
              enter: o.transitions.duration.enteringScreen,
              exit: o.transitions.duration.leavingScreen,
            },
            {
              addEndListener: i,
              appear: s = !0,
              children: l,
              easing: c,
              in: u,
              onEnter: p,
              onEntered: m,
              onEntering: h,
              onExit: f,
              onExited: g,
              onExiting: v,
              style: b,
              timeout: _ = a,
              TransitionComponent: y = Er,
            } = n,
            x = (0, jt.Z)(n, VP),
            C = t.useRef(null),
            S = (0, cn.Z)(C, l.ref, r),
            k = (e) => (t) => {
              if (e) {
                const n = C.current;
                void 0 === t ? e(n) : e(n, t);
              }
            },
            w = k(h),
            P = k((e, t) => {
              Rr(e);
              const n = Nr(
                { style: b, timeout: _, easing: c },
                { mode: "enter" }
              );
              (e.style.webkitTransition = o.transitions.create("transform", n)),
                (e.style.transition = o.transitions.create("transform", n)),
                p && p(e, t);
            }),
            O = k(m),
            I = k(v),
            T = k((e) => {
              const t = Nr(
                { style: b, timeout: _, easing: c },
                { mode: "exit" }
              );
              (e.style.webkitTransition = o.transitions.create("transform", t)),
                (e.style.transition = o.transitions.create("transform", t)),
                f && f(e);
            }),
            M = k(g);
          return (0, e.jsx)(
            y,
            (0, d.Z)(
              {
                appear: s,
                in: u,
                nodeRef: C,
                onEnter: P,
                onEntered: O,
                onEntering: w,
                onExit: T,
                onExited: M,
                onExiting: I,
                addEndListener: (e) => {
                  i && i(C.current, e);
                },
                timeout: _,
              },
              x,
              {
                children: (e, n) =>
                  t.cloneElement(
                    l,
                    (0, d.Z)(
                      {
                        style: (0, d.Z)(
                          {
                            transform: "scale(0)",
                            visibility: "exited" !== e || u ? void 0 : "hidden",
                          },
                          WP[e],
                          b,
                          l.props.style
                        ),
                        ref: S,
                      },
                      n
                    )
                  ),
              }
            )
          );
        });
      var UP = $P;
      function KP() {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        var n = !1;
        try {
          return (
            e.forEach(function (e) {
              (null != e && "" !== e.toString().trim()) || (n = !0);
            }),
            n
          );
        } catch (e) {
          return !0;
        }
      }
      var GP = function () {
          return (
            (GP =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            GP.apply(this, arguments)
          );
        },
        qP = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        YP = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        JP = function () {
          return (
            (JP =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            JP.apply(this, arguments)
          );
        },
        QP = function () {
          var n,
            r,
            o,
            a,
            i,
            s,
            l,
            c,
            u,
            d,
            p,
            m,
            h = Gv(),
            f = h.copyTextFunction,
            v = h.copyIconSuccessColor,
            b = (function () {
              var e,
                n = this,
                r = X().t,
                o = g(),
                a = (0, t.useState)(!1),
                i = a[0],
                s = a[1],
                l = (0, t.useState)([]),
                c = l[0],
                u = l[1],
                d = (0, t.useState)(!1),
                p = d[0],
                m = d[1],
                h = (0, t.useState)(r("discountCoupon_button3")),
                f = h[0],
                v = h[1],
                b = (0, t.useState)(!1),
                _ = b[0],
                y = b[1],
                x = (0, t.useState)(0),
                C = x[0],
                S = x[1],
                k = (0, t.useState)("ST_DC_Pointer_Events_All"),
                w = k[0],
                P = k[1],
                O = (0, t.useState)({
                  discountCode: "",
                  discountCodeErrMsg: "",
                  discountValue: "",
                  discountValueErrMsg: "",
                }),
                I = O[0],
                T = O[1],
                M = z.getState().salesRepData.baseData,
                E = (0, t.useState)(r("discountCoupon_button1")),
                D = E[0],
                j =
                  (E[1],
                  (0, t.useState)(
                    r("discountCoupon_contentHeading4PlaceHolder1") +
                      " " +
                      (0 !== Object.keys(M).length &&
                      null !== (null == M ? void 0 : M.CouponCodeForSalesRep)
                        ? null ===
                            (e =
                              null == M ? void 0 : M.CouponCodeForSalesRep) ||
                          void 0 === e
                          ? void 0
                          : e.DiscountCode
                        : "-") +
                      " " +
                      r("discountCoupon_contentHeading4PlaceHolder2")
                  )),
                R = j[0],
                N = j[1],
                A = I.discountCode.length > 0 && I.discountValue.length > 0,
                L = (0, t.useState)(M ? M.select.SalesrepCoupon : {}),
                B = L[0],
                Z = (L[1], (0, t.useState)({ msg: "", open: !1 })),
                F = Z[0],
                H = Z[1];
              return (
                (0, t.useEffect)(
                  function () {
                    var e;
                    v(r("discountCoupon_button3")),
                      N(
                        r("discountCoupon_contentHeading4PlaceHolder1") +
                          " " +
                          (0 !== Object.keys(M).length &&
                          null !==
                            (null == M ? void 0 : M.CouponCodeForSalesRep)
                            ? null ===
                                (e =
                                  null == M
                                    ? void 0
                                    : M.CouponCodeForSalesRep) || void 0 === e
                              ? void 0
                              : e.DiscountCode
                            : "-") +
                          " " +
                          r("discountCoupon_contentHeading4PlaceHolder2")
                      );
                  },
                  [r]
                ),
                {
                  checkViewCoupon: i,
                  viewCouponData: c,
                  copyDisocuntCode: D,
                  openViewCoupon: p,
                  isDelete: _,
                  removeIndex: C,
                  pointerEvents: w,
                  handleViewCouponOpen: function () {
                    return qP(n, void 0, void 0, function () {
                      return YP(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return s(!0), [4, o(kg())];
                          case 1:
                            return (
                              KP(e.sent()) ||
                                (u(z.getState().salesRepData.viewCouponData),
                                m(!0)),
                              s(!1),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  handleViewCouponClose: function () {
                    return m(!1);
                  },
                  changeValue: function (e) {
                    var t;
                    "discountCode" === e.target.name
                      ? (T(function (t) {
                          return GP(GP({}, t), {
                            discountCode: e.target.value,
                          });
                        }),
                        "" === e.target.value
                          ? T(function (e) {
                              return GP(GP({}, e), {
                                discountCodeErrMsg: r(
                                  "addCustomer_leadEmptyErrrorMsg"
                                ),
                              });
                            })
                          : T(function (e) {
                              return GP(GP({}, e), { discountCodeErrMsg: "" });
                            }))
                      : (T(function (t) {
                          return GP(GP({}, t), {
                            discountValue: e.target.value,
                          });
                        }),
                        e.target.value >
                        (null ===
                          (t =
                            null == M
                              ? void 0
                              : M.DiscountAndCommissionForCoupon) ||
                        void 0 === t
                          ? void 0
                          : t.SalesRepMaxDiscount)
                          ? T(function (e) {
                              return GP(GP({}, e), {
                                discountValueErrMsg: r(
                                  "discountCoupon_contentHeading8PlaceHolder"
                                ),
                              });
                            })
                          : T(function (e) {
                              return GP(GP({}, e), { discountValueErrMsg: "" });
                            }));
                  },
                  createCoupon: function () {
                    return qP(n, void 0, void 0, function () {
                      var e, t;
                      return YP(this, function (n) {
                        switch (n.label) {
                          case 0:
                            return (
                              (e = {
                                discountCode: I.discountCode,
                                discountValue: I.discountValue,
                              }),
                              v(r("createCoupon_btnlbl1")),
                              P("ST_DC_Pointer_Events_None"),
                              [4, o(wg(e))]
                            );
                          case 1:
                            return (
                              "Coupon Created" === (t = n.sent())
                                ? (v(r("createCoupon_btnlbl2")),
                                  H({
                                    msg: r("createCoupon_btnlbl2"),
                                    open: !0,
                                    severity: "success",
                                  }),
                                  setTimeout(function () {
                                    P("ST_DC_Pointer_Events_All"),
                                      v(r("discountCoupon_button3")),
                                      T({
                                        discountCode: "",
                                        discountCodeErrMsg: "",
                                        discountValue: "",
                                        discountValueErrMsg: "",
                                      });
                                  }, 3e3))
                                : (H({ msg: t, open: !0, severity: "error" }),
                                  P("ST_DC_Pointer_Events_All"),
                                  v(r("discountCoupon_button3"))),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  removeCoupon: function (e, t) {
                    return qP(n, void 0, void 0, function () {
                      var n;
                      return YP(this, function (r) {
                        switch (r.label) {
                          case 0:
                            return (
                              (n = {
                                coupon: e.CouponeCode,
                                customerId: e.SalesRepId,
                                couponid: e.couponId,
                              }),
                              y(!0),
                              S(t),
                              [4, o(Pg(n))]
                            );
                          case 1:
                            return (
                              KP(r.sent())
                                ? y(!1)
                                : (y(!1),
                                  setTimeout(function () {
                                    S(0),
                                      u(
                                        z.getState().salesRepData.viewCouponData
                                      );
                                  }, 2e3)),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  t: r,
                  inputState: I,
                  discountCouponData: M,
                  copyDiscountText: R,
                  setcopyDiscountText: N,
                  createOneCoupon: f,
                  createCouponBtnEnabled: A,
                  oneTimeCouponCode: B,
                  handleAlertMsgClose: function (e, t) {
                    "clickaway" !== t && H({ msg: "", open: !1 });
                  },
                  alertMsg: F,
                }
              );
            })(),
            _ = b.checkViewCoupon,
            y = b.viewCouponData,
            x = b.copyDisocuntCode,
            C = b.openViewCoupon,
            S = b.isDelete,
            k = b.removeIndex,
            w = b.pointerEvents,
            P = b.handleViewCouponOpen,
            O = b.handleViewCouponClose,
            I = b.changeValue,
            T = b.createCoupon,
            M = b.removeCoupon,
            E = b.t,
            D = b.inputState,
            j = b.discountCouponData,
            R = b.copyDiscountText,
            N = b.setcopyDiscountText,
            A = b.createOneCoupon,
            L = b.createCouponBtnEnabled,
            B = b.oneTimeCouponCode,
            Z = b.handleAlertMsgClose,
            F = b.alertMsg,
            H = {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              width: "50%",
              boxShadow: 24,
              p: 3,
            },
            V = {
              display: "flex",
              backgroundColor: "#F5F5F5",
              borderRadius: "4px",
              width: "90%",
              height: "60px",
              justifyContent: "center",
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "transparent" },
              },
            };
          return (0, e.jsxs)(
            ln,
            JP(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    La,
                    JP(
                      { sx: JP(JP({}, Lo), { marginBottom: "1rem" }) },
                      {
                        children: [
                          (0, e.jsx)(
                            Wa,
                            JP(
                              { variant: ov, sx: zo },
                              { children: E("discountCoupon_titleOne") }
                            )
                          ),
                          (0, e.jsx)("hr", {
                            className: "ST_CI_Horizontal_Line",
                          }),
                        ],
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    o_,
                    JP(
                      { className: "ST_DC_Card1Color" },
                      {
                        children: [
                          (0, e.jsx)(
                            Wa,
                            JP(
                              { variant: "body2", mb: 2, fontSize: 16 },
                              { children: E("discountCoupon_contentHeading1") }
                            )
                          ),
                          (0, e.jsx)(ln, {
                            children: (0, e.jsxs)(
                              "div",
                              JP(
                                { className: "ST_DC_DiscountCouponBox" },
                                {
                                  children: [
                                    (0, e.jsx)(ln, {
                                      children: (0, e.jsx)(
                                        "div",
                                        JP(
                                          { className: "ST_DC_DiscountCoupon" },
                                          {
                                            children: (0, e.jsxs)(
                                              Wa,
                                              JP(
                                                {
                                                  className:
                                                    "ST_DC_CouponCopyTextBox",
                                                  variant: "body2",
                                                  color: "black",
                                                  fontSize: 14,
                                                  textAlign: "center",
                                                },
                                                {
                                                  children: [
                                                    E(
                                                      "discountCoupon_contentHeading2"
                                                    ),
                                                    ": ",
                                                    (0, e.jsx)("b", {
                                                      children:
                                                        null ===
                                                          (n =
                                                            null == j
                                                              ? void 0
                                                              : j.CouponCodeForSalesRep) ||
                                                        void 0 === n
                                                          ? void 0
                                                          : n.DiscountCode,
                                                    }),
                                                    (0, e.jsx)(
                                                      _l,
                                                      JP(
                                                        {
                                                          TransitionComponent:
                                                            UP,
                                                          title:
                                                            "#05bf05" ===
                                                            v.copyDiscountCode
                                                              ? E(
                                                                  "affiliateLink_searchColumn8"
                                                                )
                                                              : E(
                                                                  "click_to_copy"
                                                                ),
                                                          placement: "bottom",
                                                          arrow: !0,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            cv,
                                                            {
                                                              onClick:
                                                                function () {
                                                                  var e;
                                                                  f(
                                                                    0 !==
                                                                      Object.keys(
                                                                        j
                                                                      )
                                                                        .length &&
                                                                      null !==
                                                                        (null ==
                                                                        j
                                                                          ? void 0
                                                                          : j.CouponCodeForSalesRep)
                                                                      ? null ===
                                                                          (e =
                                                                            null ==
                                                                            j
                                                                              ? void 0
                                                                              : j.CouponCodeForSalesRep) ||
                                                                        void 0 ===
                                                                          e
                                                                        ? void 0
                                                                        : e.DiscountCode
                                                                      : "-",
                                                                    "copyDiscountCode"
                                                                  );
                                                                },
                                                              style: {
                                                                cursor:
                                                                  "pointer",
                                                                marginLeft:
                                                                  "10px",
                                                                color:
                                                                  v.copyDiscountCode,
                                                              },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }),
                                    (0, e.jsx)(ln, {
                                      children: (0, e.jsx)(
                                        "div",
                                        JP(
                                          { className: "ST_DC_DiscountCoupon" },
                                          {
                                            children: (0, e.jsxs)(
                                              Wa,
                                              JP(
                                                {
                                                  variant: "body2",
                                                  color: "black",
                                                  fontSize: 14,
                                                  textAlign: "center",
                                                },
                                                {
                                                  children: [
                                                    E(
                                                      "discountCoupon_contentHeading3"
                                                    ),
                                                    ": ",
                                                    (0, e.jsxs)("b", {
                                                      children: [
                                                        null ===
                                                          (r =
                                                            null == j
                                                              ? void 0
                                                              : j.CouponCodeForSalesRep) ||
                                                        void 0 === r
                                                          ? void 0
                                                          : r.CustomerDiscount,
                                                        "%",
                                                      ],
                                                    }),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }),
                                    (0, e.jsx)(ln, {
                                      children: (0, e.jsx)(
                                        "div",
                                        JP(
                                          { className: "ST_DC_DiscountCoupon" },
                                          {
                                            children: (0, e.jsxs)(
                                              Wa,
                                              JP(
                                                {
                                                  variant: "body2",
                                                  color: "black",
                                                  fontSize: 14,
                                                  textAlign: "center",
                                                },
                                                {
                                                  children: [
                                                    E(
                                                      "discountCoupon_contentHeading4"
                                                    ),
                                                    ": ",
                                                    (0, e.jsxs)("b", {
                                                      children: [
                                                        null ===
                                                          (o =
                                                            null == j
                                                              ? void 0
                                                              : j.CouponCodeForSalesRep) ||
                                                        void 0 === o
                                                          ? void 0
                                                          : o.SalesRepCommission,
                                                        "%",
                                                      ],
                                                    }),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }),
                                  ],
                                }
                              )
                            ),
                          }),
                          (0, e.jsx)(
                            ln,
                            JP(
                              {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              },
                              {
                                children: (0, e.jsx)(Xd, {
                                  sx: V,
                                  value: R,
                                  id: "ST_DC_Discount_Code",
                                  hiddenLabel: !0,
                                  size: "small",
                                  onChange: function (e) {
                                    return N(e.target.value);
                                  },
                                  InputProps: {
                                    style: { fontSize: "15px" },
                                    startAdornment: (0, e.jsx)(
                                      ap,
                                      JP(
                                        {
                                          position: "end",
                                          title: x,
                                          onClick: function () {
                                            f(R, "copyDiscountText");
                                          },
                                        },
                                        {
                                          children: (0, e.jsx)(cv, {
                                            style: {
                                              color: v.copyDiscountText,
                                            },
                                            className: "ST_DC_Discount_Copy",
                                          }),
                                        }
                                      )
                                    ),
                                  },
                                }),
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            "div",
                            JP(
                              { className: "ST_DC_Icons" },
                              {
                                children: [
                                  (0, e.jsx)(
                                    Il,
                                    JP(
                                      {
                                        target: "_blank",
                                        href:
                                          "http://www.facebook.com/sharer.php?u=https://" +
                                          (null ===
                                            (a =
                                              null == j
                                                ? void 0
                                                : j.CouponCodeForSalesRep) ||
                                          void 0 === a
                                            ? void 0
                                            : a.ShopName),
                                      },
                                      {
                                        children: (0, e.jsx)(zP, {
                                          sx: {
                                            mr: 2,
                                            color: "#00007e",
                                            fontSize: "25px",
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    Il,
                                    JP(
                                      {
                                        target: "_blank",
                                        href:
                                          "https://www.instagram.com/###?ref=https://" +
                                          (null ===
                                            (i =
                                              null == j
                                                ? void 0
                                                : j.CouponCodeForSalesRep) ||
                                          void 0 === i
                                            ? void 0
                                            : i.ShopName),
                                      },
                                      {
                                        children: (0, e.jsx)(BP, {
                                          sx: {
                                            mr: 2,
                                            color: "#c54e63",
                                            fontSize: "25px",
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    Il,
                                    JP(
                                      {
                                        target: "_blank",
                                        href:
                                          "https://twitter.com/share?url=https://" +
                                          (null ===
                                            (s =
                                              null == j
                                                ? void 0
                                                : j.CouponCodeForSalesRep) ||
                                          void 0 === s
                                            ? void 0
                                            : s.ShopName),
                                      },
                                      {
                                        children: (0, e.jsx)(ZP, {
                                          sx: {
                                            mr: 2,
                                            color: "#00a7eb",
                                            fontSize: "25px",
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    Il,
                                    JP(
                                      {
                                        target: "_blank",
                                        href:
                                          "http://pinterest.com/pin/create/bookmarklet/?is_video=false&url=https://" +
                                          (null ===
                                            (l =
                                              null == j
                                                ? void 0
                                                : j.CouponCodeForSalesRep) ||
                                          void 0 === l
                                            ? void 0
                                            : l.ShopName),
                                      },
                                      {
                                        children: (0, e.jsx)(FP, {
                                          sx: {
                                            color: "#d01313",
                                            fontSize: "25px",
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    La,
                    JP(
                      { hidden: !B },
                      {
                        children: [
                          (0, e.jsxs)(
                            La,
                            JP(
                              { container: !0, spacing: 2 },
                              {
                                children: [
                                  (0, e.jsx)(
                                    La,
                                    JP(
                                      { item: !0, xs: 12, md: 8, mb: 3 },
                                      {
                                        children: (0, e.jsx)(
                                          Wa,
                                          JP(
                                            { variant: ov, sx: zo },
                                            {
                                              children: E(
                                                "discountCoupon_titleTwo"
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    La,
                                    JP(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 4,
                                        className: "ST_DC_Card_Grid",
                                        sx: { textAlign: "right" },
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          vp,
                                          JP(
                                            {
                                              variant: "contained",
                                              onClick: P,
                                              className: "ST_DC_ViewCoupon",
                                            },
                                            {
                                              children: [
                                                E(
                                                  _
                                                    ? "showCouponTable_txt1"
                                                    : "discountCoupon_button2"
                                                ),
                                                (0, e.jsx)(HP, {
                                                  fontSize: "small",
                                                  style: { marginLeft: "5px" },
                                                }),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            o_,
                            JP(
                              { className: "ST_DC_Card2Color" },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    ln,
                                    JP(
                                      { display: "flex", mb: 3 },
                                      {
                                        children: [
                                          (0, e.jsxs)(
                                            Wa,
                                            JP(
                                              {
                                                variant: "body2",
                                                marginRight: 15,
                                                fontSize: 15,
                                              },
                                              {
                                                children: [
                                                  E(
                                                    "discountCoupon_contentHeading5"
                                                  ),
                                                  ":",
                                                  " ",
                                                  (0, e.jsx)("b", {
                                                    children: (
                                                      null ===
                                                        (c =
                                                          null == j
                                                            ? void 0
                                                            : j.DiscountAndCommissionForCoupon) ||
                                                      void 0 === c
                                                        ? void 0
                                                        : c.SalesRepMaxDiscount
                                                    )
                                                      ? (null ===
                                                          (u =
                                                            null == j
                                                              ? void 0
                                                              : j.DiscountAndCommissionForCoupon) ||
                                                        void 0 === u
                                                          ? void 0
                                                          : u.SalesRepMaxDiscount) +
                                                        "%"
                                                      : E(
                                                          "discount_couponErrorMsg"
                                                        ),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                          (0, e.jsxs)(
                                            Wa,
                                            JP(
                                              {
                                                variant: "body2",
                                                alignContent: "center",
                                                fontSize: 15,
                                              },
                                              {
                                                children: [
                                                  E(
                                                    "discountCoupon_contentHeading6"
                                                  ),
                                                  ":",
                                                  " ",
                                                  (0, e.jsx)("b", {
                                                    children: (
                                                      null ===
                                                        (d =
                                                          null == j
                                                            ? void 0
                                                            : j.DiscountAndCommissionForCoupon) ||
                                                      void 0 === d
                                                        ? void 0
                                                        : d.SalesRepCommission
                                                    )
                                                      ? (null ===
                                                          (p =
                                                            null == j
                                                              ? void 0
                                                              : j.DiscountAndCommissionForCoupon) ||
                                                        void 0 === p
                                                          ? void 0
                                                          : p.SalesRepCommission) +
                                                        "%"
                                                      : E(
                                                          "discount_couponErrorMsg2"
                                                        ),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(Xd, {
                                    type: "text",
                                    size: "small",
                                    name: "discountCode",
                                    label: E("discountCoupon_contentHeading7"),
                                    value: null == D ? void 0 : D.discountCode,
                                    fullWidth: !0,
                                    onChange: function (e) {
                                      return I(e);
                                    },
                                    error:
                                      "" !==
                                      (null == D
                                        ? void 0
                                        : D.discountCodeErrMsg),
                                    helperText:
                                      null == D ? void 0 : D.discountCodeErrMsg,
                                  }),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsx)(Xd, {
                                    type: "number",
                                    onKeyDown: iv,
                                    size: "small",
                                    name: "discountValue",
                                    label: E("discountCoupon_contentHeading8"),
                                    value: null == D ? void 0 : D.discountValue,
                                    fullWidth: !0,
                                    onChange: function (e) {
                                      return I(e);
                                    },
                                    error:
                                      "" !==
                                      (null == D
                                        ? void 0
                                        : D.discountValueErrMsg),
                                    helperText:
                                      null == D
                                        ? void 0
                                        : D.discountValueErrMsg,
                                  }),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsxs)(
                                    vp,
                                    JP(
                                      {
                                        variant: "contained",
                                        onClick: T,
                                        className: w,
                                        disabled: !L,
                                        sx: { textTransform: "capitalize" },
                                      },
                                      {
                                        children: [
                                          A,
                                          (0, e.jsx)(HP, {
                                            fontSize: "small",
                                            style: { marginLeft: "5px" },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    Wa,
                                    JP(
                                      {
                                        variant: "body2",
                                        sx: {
                                          mt: 2,
                                          mr: 1,
                                          color: "green",
                                          display: "block",
                                        },
                                      },
                                      {
                                        children:
                                          A === E("createCoupon_btnlbl2")
                                            ? A
                                            : "",
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    qr,
                    JP(
                      { open: C, onClose: O },
                      {
                        children: (0, e.jsxs)(
                          ln,
                          JP(
                            { sx: H, className: "ST_DC_Modal_CSS" },
                            {
                              children: [
                                (0, e.jsxs)(
                                  La,
                                  JP(
                                    { container: !0, spacing: 2 },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          La,
                                          JP(
                                            { item: !0, xs: 10, md: 10 },
                                            {
                                              children: (0, e.jsx)(
                                                Wa,
                                                JP(
                                                  { variant: "h6" },
                                                  {
                                                    children: E(
                                                      "discountCoupons_header"
                                                    ),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          La,
                                          JP(
                                            {
                                              item: !0,
                                              xs: 2,
                                              md: 2,
                                              sx: { textAlign: "right" },
                                            },
                                            {
                                              children: (0, e.jsx)(pv, {
                                                sx: { cursor: "pointer" },
                                                onClick: O,
                                              }),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                0 !== y.length
                                  ? (0, e.jsx)(
                                      Ga,
                                      JP(
                                        { sx: { maxHeight: 500, mt: 3 } },
                                        {
                                          children: (0, e.jsxs)(
                                            ei,
                                            JP(
                                              { stickyHeader: !0 },
                                              {
                                                children: [
                                                  (0, e.jsx)(si, {
                                                    children: (0, e.jsxs)(
                                                      hi,
                                                      JP(
                                                        {
                                                          className:
                                                            "stickyHeaderRow",
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: E(
                                                                      "discountCoupons_tblColumn1"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: E(
                                                                      "discountCoupons_tblColumn2"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: E(
                                                                      "discount_code_copy_coupon"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: E(
                                                                      "discountCoupons_tblColumn3"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }),
                                                  (0, e.jsx)(Pi, {
                                                    children: y.map(function (
                                                      t,
                                                      n
                                                    ) {
                                                      return (0, e.jsxs)(
                                                        hi,
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  sx: {
                                                                    width:
                                                                      "40%",
                                                                  },
                                                                },
                                                                {
                                                                  children:
                                                                    t.CouponeCode,
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsxs)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  sx: {
                                                                    width:
                                                                      "25%",
                                                                  },
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: [
                                                                    t.Discount,
                                                                    "%",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  sx: {
                                                                    width:
                                                                      "10%",
                                                                  },
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(
                                                                    _l,
                                                                    JP(
                                                                      {
                                                                        TransitionComponent:
                                                                          UP,
                                                                        title:
                                                                          "#05bf05" ===
                                                                          v[
                                                                            ""
                                                                              .concat(
                                                                                "couponcode",
                                                                                " "
                                                                              )
                                                                              .concat(
                                                                                n
                                                                              )
                                                                          ]
                                                                            ? E(
                                                                                "affiliateLink_searchColumn8"
                                                                              )
                                                                            : E(
                                                                                "click_to_copy"
                                                                              ),
                                                                        placement:
                                                                          "bottom",
                                                                        arrow:
                                                                          !0,
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            cv,
                                                                            {
                                                                              onClick:
                                                                                function () {
                                                                                  f(
                                                                                    t.CouponeCode,
                                                                                    ""
                                                                                      .concat(
                                                                                        "couponcode",
                                                                                        " "
                                                                                      )
                                                                                      .concat(
                                                                                        n
                                                                                      )
                                                                                  );
                                                                                },
                                                                              style:
                                                                                {
                                                                                  cursor:
                                                                                    "pointer",
                                                                                  color:
                                                                                    v[
                                                                                      ""
                                                                                        .concat(
                                                                                          "couponcode",
                                                                                          " "
                                                                                        )
                                                                                        .concat(
                                                                                          n
                                                                                        )
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              JP(
                                                                {
                                                                  sx: {
                                                                    width:
                                                                      "25%",
                                                                  },
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children:
                                                                    S && k === n
                                                                      ? E(
                                                                          "deleteCoupon_btnlbl"
                                                                        )
                                                                      : (0,
                                                                        e.jsx)(
                                                                          uv,
                                                                          {
                                                                            sx: {
                                                                              cursor:
                                                                                "pointer",
                                                                            },
                                                                            onClick:
                                                                              function () {
                                                                                return M(
                                                                                  t,
                                                                                  n
                                                                                );
                                                                              },
                                                                          }
                                                                        ),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        },
                                                        n
                                                      );
                                                    }),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    )
                                  : (0, e.jsx)(
                                      Wa,
                                      JP(
                                        {
                                          variant: "body2",
                                          mt: 3,
                                          sx: { color: "red" },
                                        },
                                        {
                                          children: E(
                                            "discountCoupons_nodiscountcoupon"
                                          ),
                                        }
                                      )
                                    ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Gm,
                    JP(
                      {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                        open: F.open,
                        autoHideDuration: 4e3,
                        onClose: Z,
                      },
                      {
                        children: (0, e.jsx)(
                          ch,
                          JP(
                            {
                              onClose: Z,
                              severity:
                                null !==
                                  (m = null == F ? void 0 : F.severity) &&
                                void 0 !== m
                                  ? m
                                  : "error",
                              variant: "filled",
                              sx: { width: "100%" },
                            },
                            { children: F.msg }
                          )
                        ),
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        XP = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
          }),
          "ArrowDownward"
        );
      function eO(e) {
        return (0, Zt.ZP)("MuiTableSortLabel", e);
      }
      var tO = (0, Bt.Z)("MuiTableSortLabel", [
        "root",
        "active",
        "icon",
        "iconDirectionDesc",
        "iconDirectionAsc",
      ]);
      const nO = [
          "active",
          "children",
          "className",
          "direction",
          "hideSortIcon",
          "IconComponent",
        ],
        rO = (0, Lt.ZP)(Zn, {
          name: "MuiTableSortLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.active && t.active];
          },
        })(({ theme: e }) => ({
          cursor: "pointer",
          display: "inline-flex",
          justifyContent: "flex-start",
          flexDirection: "inherit",
          alignItems: "center",
          "&:focus": { color: (e.vars || e).palette.text.secondary },
          "&:hover": {
            color: (e.vars || e).palette.text.secondary,
            [`& .${tO.icon}`]: { opacity: 0.5 },
          },
          [`&.${tO.active}`]: {
            color: (e.vars || e).palette.text.primary,
            [`& .${tO.icon}`]: {
              opacity: 1,
              color: (e.vars || e).palette.text.secondary,
            },
          },
        })),
        oO = (0, Lt.ZP)("span", {
          name: "MuiTableSortLabel",
          slot: "Icon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.icon, t[`iconDirection${(0, Fn.Z)(n.direction)}`]];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, d.Z)(
            {
              fontSize: 18,
              marginRight: 4,
              marginLeft: 4,
              opacity: 0,
              transition: e.transitions.create(["opacity", "transform"], {
                duration: e.transitions.duration.shorter,
              }),
              userSelect: "none",
            },
            "desc" === t.direction && { transform: "rotate(0deg)" },
            "asc" === t.direction && { transform: "rotate(180deg)" }
          )
        );
      var aO = t.forwardRef(function (t, n) {
        const r = (0, zt.Z)({ props: t, name: "MuiTableSortLabel" }),
          {
            active: o = !1,
            children: a,
            className: i,
            direction: s = "asc",
            hideSortIcon: l = !1,
            IconComponent: c = XP,
          } = r,
          u = (0, jt.Z)(r, nO),
          p = (0, d.Z)({}, r, {
            active: o,
            direction: s,
            hideSortIcon: l,
            IconComponent: c,
          }),
          m = ((e) => {
            const { classes: t, direction: n, active: r } = e,
              o = {
                root: ["root", r && "active"],
                icon: ["icon", `iconDirection${(0, Fn.Z)(n)}`],
              };
            return (0, Nt.Z)(o, eO, t);
          })(p);
        return (0,
        e.jsxs)(rO, (0, d.Z)({ className: (0, Rt.Z)(m.root, i), component: "span", disableRipple: !0, ownerState: p, ref: n }, u, { children: [a, l && !o ? null : (0, e.jsx)(oO, { as: c, className: (0, Rt.Z)(m.icon), ownerState: p })] }));
      });
      function iO(e) {
        return (0, Zt.ZP)("MuiDialogActions", e);
      }
      (0, Bt.Z)("MuiDialogActions", ["root", "spacing"]);
      const sO = ["className", "disableSpacing"],
        lO = (0, Lt.ZP)("div", {
          name: "MuiDialogActions",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, !n.disableSpacing && t.spacing];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              display: "flex",
              alignItems: "center",
              padding: 8,
              justifyContent: "flex-end",
              flex: "0 0 auto",
            },
            !e.disableSpacing && {
              "& > :not(style) ~ :not(style)": { marginLeft: 8 },
            }
          )
        );
      var cO = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiDialogActions" }),
            { className: o, disableSpacing: a = !1 } = r,
            i = (0, jt.Z)(r, sO),
            s = (0, d.Z)({}, r, { disableSpacing: a }),
            l = ((e) => {
              const { classes: t, disableSpacing: n } = e,
                r = { root: ["root", !n && "spacing"] };
              return (0, Nt.Z)(r, iO, t);
            })(s);
          return (0,
          e.jsx)(lO, (0, d.Z)({ className: (0, Rt.Z)(l.root, o), ownerState: s, ref: n }, i));
        }),
        uO = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M5 18h14v2H5zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2z",
          }),
          "FileDownloadDone"
        ),
        dO = function () {
          return (
            (dO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            dO.apply(this, arguments)
          );
        },
        pO = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        mO = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        hO = o(6693),
        fO = function () {
          return (
            (fO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            fO.apply(this, arguments)
          );
        },
        gO = function () {
          var n,
            r,
            o = (function () {
              var e,
                n,
                r,
                o = this,
                a = Gv().showCustomCountries,
                i = g(),
                s = X().t,
                l = z.getState().salesRepData.loggedInRepDetails.shopCurrency,
                c = [
                  {
                    id: "ClientName",
                    label: s("myCustomers_table1Column1"),
                    inlineCSS: { width: "30%" },
                  },
                  {
                    id: "companyName",
                    label: s("myCustomers_table1Column2"),
                    inlineCSS: { width: "25%" },
                  },
                  {
                    id: "CustomerMailid",
                    label: s("myCustomers_table1Column3"),
                    inlineCSS: { width: "30%" },
                  },
                  {
                    id: "shopifyOrdersCount",
                    label: s("myCustomers_table1Column4"),
                    inlineCSS: { width: "15%", textAlign: "center" },
                  },
                ],
                u = [
                  { label: s("myOrders_table1Column1") },
                  { label: s("myOrders_table1Column2") },
                  { label: s("myOrders_table1Column4") },
                  { label: s("myOrders_table1Column5") },
                  { label: s("myOrders_content1") + "(" + l + ")" },
                  { label: s("myOrders_content3") + "(" + l + ")" },
                  { label: s("myOrders_content2") + "(" + l + ")" },
                  { label: s("myOrders_content4") + "(" + l + ")" },
                ],
                d = [
                  { label: s("myOrders_table2Column1") },
                  { label: s("myOrders_table2Column2") },
                  { label: s("variant_title") },
                  { label: "SKU" },
                  { label: s("myOrders_table2Column3") },
                  { label: s("myOrders_table2Column4") + "(" + l + ")" },
                  { label: s("viewProductModelColumn6") + "(" + l + ")" },
                  { label: s("myOrders_table2Column5") },
                  { label: s("myOrders_table2Column6") },
                  { label: s("myOrders_table2Column7") + "(" + l + ")" },
                ],
                p = {
                  customer_fname: "",
                  customer_lname: "",
                  customer_email: "",
                  customer_phoneno: 0,
                  customer_note: "",
                  customer_address: "",
                  customer_city: "",
                  customer_country: "United States of America",
                  customer_state: "",
                  customer_pincode: 0,
                  business_name: "",
                  cust_company_address: "",
                  cust_company_city: "",
                  cust_company_country: "United States of America",
                  cust_company_state: "",
                  cust_company_pincode: 0,
                  subTotal: 0,
                  noOfOrders: 0,
                  tags: "price_1",
                },
                m = z.getState().salesRepData.baseData.ClientOrders,
                h = (0, t.useState)("asc"),
                f = h[0],
                v = h[1],
                b = (0, t.useState)("name"),
                _ = b[0],
                y = b[1],
                C = (0, t.useState)(""),
                S = C[0],
                k = C[1],
                w = (0, t.useState)(m),
                P = w[0],
                O = w[1],
                I = (0, t.useState)(!1),
                T = I[0],
                M = I[1],
                E = (0, t.useState)(!1),
                D = E[0],
                j = E[1],
                R = (0, t.useState)(p),
                N = R[0],
                A = R[1],
                L = (0, t.useState)(!0),
                B = L[0],
                Z = L[1],
                F = (0, t.useState)({ fnameErrMsg: "", emailErrMsg: "" }),
                H = F[0],
                V = F[1],
                W =
                  (null === (e = null == N ? void 0 : N.customer_fname) ||
                  void 0 === e
                    ? void 0
                    : e.length) > 0 &&
                  (null === (n = null == N ? void 0 : N.customer_email) ||
                  void 0 === n
                    ? void 0
                    : n.length) > 0 &&
                  "" === H.fnameErrMsg &&
                  "" === H.emailErrMsg,
                $ = (0, t.useState)(s("submit_btn_text")),
                U = $[0],
                K = $[1],
                G = (0, t.useState)(!0),
                q = G[0],
                Y = G[1],
                J = (0, t.useState)([]),
                Q = J[0],
                ee = J[1],
                te = (0, t.useState)([]),
                ne = te[0],
                re = te[1],
                oe = (0, t.useState)(),
                ae = oe[0],
                ie = oe[1],
                se = (0, t.useState)(""),
                le = se[0],
                ce = se[1],
                ue = (0, t.useState)(!1),
                de = ue[0],
                pe = ue[1],
                me = (0, t.useState)("us"),
                he = me[0],
                fe = me[1],
                ge = (0, t.useState)("us"),
                ve = ge[0],
                be = ge[1],
                _e = (function (e, t, n) {
                  if (n || 2 === arguments.length)
                    for (var r, o = 0, a = t.length; o < a; o++)
                      (!r && o in t) ||
                        (r || (r = Array.prototype.slice.call(t, 0, o)),
                        (r[o] = t[o]));
                  return e.concat(r || Array.prototype.slice.call(t));
                })([], m, !0),
                ye = "",
                xe = (0, t.useState)(
                  z.getState().salesRepData.baseData
                    .hideCompanyAddressInAddCustomer
                ),
                Ce = xe[0];
              xe[1],
                mf.subscribe(function (e) {
                  e !== de && pe(e);
                }),
                (0, t.useEffect)(function () {
                  Se("");
                }, []);
              var Se = function (e) {
                  e === _
                    ? v((ye = "asc" === f ? "desc" : "asc"))
                    : (v((ye = "asc")), y(e)),
                    ke(e);
                },
                ke = function (e) {
                  var t, n;
                  "asc" === ye
                    ? P.sort(function (r, o) {
                        return x(r[e]) && "string" == typeof o[e]
                          ? (void 0 !== r[e] &&
                              null !== r[e] &&
                              "" !== r[e] &&
                              void 0 !== o[e] &&
                              null !== o[e] &&
                              "" !== o[e] &&
                              ((t = r[e].toLowerCase()),
                              (n = o[e].toLowerCase())),
                            t > n ? 1 : -1)
                          : r[e] - o[e];
                      })
                    : P.sort(function (r, o) {
                        return x(r[e]) && "string" == typeof o[e]
                          ? (void 0 !== r[e] &&
                              null !== r[e] &&
                              "" !== r[e] &&
                              void 0 !== o[e] &&
                              null !== o[e] &&
                              "" !== o[e] &&
                              ((t = r[e].toLowerCase()),
                              (n = o[e].toLowerCase())),
                            t < n ? 1 : -1)
                          : o[e] - r[e];
                      }),
                    O(P);
                },
                we = function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    o = n.value;
                  A(dO(dO({}, N), (((t = {})[r] = o), t))), Pe(r, o);
                },
                Pe = function (e, t) {
                  if (
                    ("customer_fname" === e &&
                      V(
                        "" === t
                          ? function (e) {
                              return dO(dO({}, e), {
                                fnameErrMsg: s(
                                  "addCustomer_leadEmptyErrrorMsg"
                                ),
                              });
                            }
                          : function (e) {
                              return dO(dO({}, e), { fnameErrMsg: "" });
                            }
                      ),
                    "customer_email" === e)
                  ) {
                    var n = lv;
                    "" === t
                      ? V(function (e) {
                          return dO(dO({}, e), {
                            emailErrMsg: s("addCustomer_leadEmptyErrrorMsg"),
                          });
                        })
                      : t.match(n)
                      ? V(function (e) {
                          return dO(dO({}, e), { emailErrMsg: "" });
                        })
                      : V(function (e) {
                          return dO(dO({}, e), {
                            emailErrMsg: s("email_id_validation_errmsg"),
                          });
                        });
                  }
                };
              return {
                filterState: S,
                applyFilter: function (e) {
                  k(e.target.value),
                    (_e = _e.filter(function (t) {
                      return (
                        (void 0 !== t.ClientName &&
                          null !== t.ClientName &&
                          "" !== t.ClientName &&
                          t.ClientName.toLowerCase().includes(
                            e.target.value.toLowerCase()
                          )) ||
                        (void 0 !== t.companyName &&
                          null !== t.companyName &&
                          "" !== t.companyName &&
                          t.companyName
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()))
                      );
                    })),
                    O(_e);
                },
                HeaderNames: c,
                sortHeaderData: Se,
                byColumnName: _,
                orderType: f,
                customerArray: P,
                openDialog: T,
                setOpenDialog: M,
                addCustomerForm: N,
                setAddCustomerForm: A,
                defaultFormValues: p,
                isAddCustomer: B,
                setIsAddCustomer: Z,
                changeValue: we,
                submitCustomerData: function () {
                  return pO(o, void 0, void 0, function () {
                    var e, t;
                    return mO(this, function (n) {
                      switch (n.label) {
                        case 0:
                          return (
                            K(s("submitting_btn_text")),
                            ce(""),
                            (e = {
                              firstname: null == N ? void 0 : N.customer_fname,
                              lastname: null == N ? void 0 : N.customer_lname,
                              phoneno:
                                0 === (null == N ? void 0 : N.customer_phoneno)
                                  ? ""
                                  : null == N
                                  ? void 0
                                  : N.customer_phoneno,
                              email: null == N ? void 0 : N.customer_email,
                              note: null == N ? void 0 : N.customer_note,
                              address: null == N ? void 0 : N.customer_address,
                              customercity:
                                null == N ? void 0 : N.customer_city,
                              customerstate:
                                null == N ? void 0 : N.customer_state,
                              customercountry: he,
                              customerpincode:
                                0 === (null == N ? void 0 : N.customer_pincode)
                                  ? ""
                                  : null == N
                                  ? void 0
                                  : N.customer_pincode,
                              companyaddress:
                                null == N ? void 0 : N.cust_company_address,
                              companycity:
                                null == N ? void 0 : N.cust_company_city,
                              companystate:
                                null == N ? void 0 : N.cust_company_state,
                              companycountry: ve,
                              companypincode:
                                0 ===
                                (null == N ? void 0 : N.cust_company_pincode)
                                  ? ""
                                  : null == N
                                  ? void 0
                                  : N.cust_company_pincode,
                              business_name:
                                null == N ? void 0 : N.business_name,
                              tags: null == N ? void 0 : N.tags,
                            }),
                            [4, i(Og(e))]
                          );
                        case 1:
                          return "Customer sucessfully tagged to a rep." !==
                            (t = n.sent())
                            ? [3, 3]
                            : (K(s("submitted_btn_text")), [4, i(_g())]);
                        case 2:
                          return (
                            n.sent(),
                            O(z.getState().salesRepData.baseData.ClientOrders),
                            setTimeout(function () {
                              K(s("submit_btn_text")),
                                A(p),
                                M(!1),
                                fe("us"),
                                be("us");
                            }, 3e3),
                            [3, 4]
                          );
                        case 3:
                          K(s("submit_btn_text")),
                            ce(
                              "phone Enter a valid phone number to use this delivery method" ===
                                t
                                ? s("addCustomer_ErrorMsgOnSubmitBtn")
                                : t
                            ),
                            (n.label = 4);
                        case 4:
                          return [2];
                      }
                    });
                  });
                },
                submitBtnEnabled: W,
                inputState: H,
                changeCountry: function (e, t) {
                  var n,
                    r,
                    o = e.target.value,
                    i = a().filter(function (e) {
                      return e.name.toLowerCase().includes(o.toLowerCase());
                    });
                  switch (t) {
                    case "customer_country":
                      fe(
                        "" !== o
                          ? null === (n = i[0]) || void 0 === n
                            ? void 0
                            : n.code
                          : "us"
                      );
                      break;
                    case "cust_company_country":
                      be(
                        "" !== o
                          ? null === (r = i[0]) || void 0 === r
                            ? void 0
                            : r.code
                          : "us"
                      );
                  }
                  we(e);
                },
                submitDataText: U,
                getSingleCustomerData: function (e) {
                  return pO(o, void 0, void 0, function () {
                    var t, n, r;
                    return mO(this, function (o) {
                      switch (o.label) {
                        case 0:
                          return Z(!1), ce(""), mf.next(!0), [4, i(Ig(e))];
                        case 1:
                          return (
                            (t = o.sent()),
                            M(!0),
                            (null == t ? void 0 : t.SingleClientOrders) &&
                              (mf.next(!1),
                              (n = null == t ? void 0 : t.SingleClientOrders),
                              console.log(n, "responseData"),
                              (r = ""
                                .concat(
                                  (null == n ? void 0 : n.address1) || "NA",
                                  " "
                                )
                                .concat((null == n ? void 0 : n.address2) || "")
                                .trim()),
                              console.log(r, "addressFull"),
                              console.log(
                                null == n ? void 0 : n.address1,
                                "responseData?.address1 "
                              ),
                              console.log(
                                null == n ? void 0 : n.address2,
                                "responseData?.address2  "
                              ),
                              A({
                                customer_fname:
                                  (null == n
                                    ? void 0
                                    : n.ClientName.split(" ")[0]) || "NA",
                                customer_lname:
                                  (null == n
                                    ? void 0
                                    : n.ClientName.split(" ")[1]) || "NA",
                                customer_email:
                                  (null == n ? void 0 : n.CustomerMailid) ||
                                  "NA",
                                customer_phoneno: parseInt(
                                  null == n ? void 0 : n.phoneno
                                ),
                                customer_note:
                                  (null == n ? void 0 : n.notes) || "NA",
                                customer_address: r,
                                customer_city: "",
                                customer_country: "",
                                customer_state: "",
                                customer_pincode: 0,
                                business_name:
                                  (null == n ? void 0 : n.companyName) || "NA",
                                cust_company_address: "",
                                cust_company_city: "",
                                cust_company_country: "",
                                cust_company_state: "",
                                cust_company_pincode: 0,
                                subTotal:
                                  null == n ? void 0 : n.shopifyTotalSpent,
                                noOfOrders:
                                  null == n ? void 0 : n.shopifyOrdersCount,
                                tags: (null == n ? void 0 : n.tags) || "NA",
                              })),
                            [2]
                          );
                      }
                    });
                  });
                },
                getOrderCountDetails: function (e) {
                  return pO(o, void 0, void 0, function () {
                    var t;
                    return mO(this, function (n) {
                      switch (n.label) {
                        case 0:
                          return (r = e), mf.next(!0), [4, i(Tg(e))];
                        case 1:
                          return (
                            (t = n.sent()),
                            Y(!0),
                            ee(t.clientallorders ? t.clientallorders : []),
                            mf.next(!1),
                            j(!0),
                            [2]
                          );
                      }
                    });
                  });
                },
                orderCountDialog: D,
                setOrderCountDialog: j,
                OrderDetailsHeaderNames: u,
                getOrderWiseProductsData: function (e) {
                  return pO(o, void 0, void 0, function () {
                    var t, n;
                    return mO(this, function (o) {
                      switch (o.label) {
                        case 0:
                          return (
                            (t = { order_id: e.order_id, clientId: r }),
                            mf.next(!0),
                            ie(e),
                            [4, i(Mg(t))]
                          );
                        case 1:
                          return (
                            (n = o.sent()),
                            Y(!1),
                            re(n.ProductDetails),
                            mf.next(!1),
                            [2]
                          );
                      }
                    });
                  });
                },
                orderDetailsArray: Q,
                orderWiseProductDetailsArray: ne,
                orderCountFlag: q,
                setOrderCountFlag: Y,
                ProductDetailsHeaderNames: d,
                activeClientObj: ae,
                getDateFormat: function (e) {
                  return e.includes("-")
                    ? e
                        .split("T")[0]
                        .replace(/(\d{4})-(\d{2})-(\d{2}).*/, "$2/$3/$1")
                    : new Date(
                        parseInt(e.replace("/Date(", "").replace(")/", ""))
                      ).toLocaleDateString();
                },
                addCustomerErr: le,
                loadingDisabled: de,
                t: s,
                shopCurrency: l,
                hideCompanySection: Ce,
                showCustomCountries: a,
                customerCountryCode: he,
                companyCountryCode: ve,
              };
            })(),
            a = o.filterState,
            i = o.applyFilter,
            s = o.HeaderNames,
            l = o.sortHeaderData,
            c = o.byColumnName,
            u = o.orderType,
            d = o.customerArray,
            p = o.openDialog,
            m = o.setOpenDialog,
            h = o.addCustomerForm,
            f = o.isAddCustomer,
            v = o.setAddCustomerForm,
            b = o.defaultFormValues,
            _ = o.setIsAddCustomer,
            y = o.changeValue,
            C = o.submitCustomerData,
            S = o.submitBtnEnabled,
            k = o.inputState,
            w = o.changeCountry,
            P = o.submitDataText,
            O = o.getSingleCustomerData,
            I = o.getOrderCountDetails,
            T = o.orderCountDialog,
            M = o.setOrderCountDialog,
            E = o.OrderDetailsHeaderNames,
            D = o.getOrderWiseProductsData,
            j = o.orderDetailsArray,
            R = o.orderWiseProductDetailsArray,
            N = o.orderCountFlag,
            A = o.setOrderCountFlag,
            L = o.ProductDetailsHeaderNames,
            B = o.activeClientObj,
            Z = o.getDateFormat,
            F = o.addCustomerErr,
            H = o.loadingDisabled,
            V = o.t,
            W = o.shopCurrency,
            $ = o.hideCompanySection,
            U = o.showCustomCountries,
            K = o.customerCountryCode,
            G = o.companyCountryCode,
            q = { padding: "10px", fontSize: "12px", whiteSpace: "nowrap" };
          return (0, e.jsxs)(
            c_,
            fO(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    La,
                    fO(
                      { container: !0, spacing: 2 },
                      {
                        children: [
                          (0, e.jsx)(
                            La,
                            fO(
                              { item: !0, xs: 6, md: 8, mb: 2, sx: Lo },
                              {
                                children: (0, e.jsx)(
                                  Wa,
                                  fO(
                                    {
                                      variant: ov,
                                      mb: 4,
                                      sx: fO({ whiteSpace: "nowrap" }, zo),
                                    },
                                    { children: V("tab_MyCustomers") }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            La,
                            fO(
                              {
                                item: !0,
                                xs: 6,
                                md: 4,
                                sx: { textAlign: "right" },
                              },
                              {
                                children: (0, e.jsxs)(
                                  vp,
                                  fO(
                                    {
                                      variant: "contained",
                                      onClick: function () {
                                        m(!0), _(!0);
                                      },
                                      sx: {
                                        textTransform: "capitalize",
                                        whiteSpace: "nowrap",
                                        height: "40px",
                                      },
                                    },
                                    {
                                      children: [
                                        V("tab9_AddCustomer"),
                                        (0, e.jsx)(_v, {
                                          fontSize: "small",
                                          style: { marginLeft: "5px" },
                                        }),
                                      ],
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    o_,
                    fO(
                      { className: "ST_Main_Card" },
                      {
                        children: [
                          (0, e.jsx)(Xd, {
                            sx: { display: "flex" },
                            id: "ST_MC_Search",
                            placeholder: "Search by Customer or Company Name",
                            value: a,
                            hiddenLabel: !0,
                            variant: "standard",
                            size: "small",
                            onChange: function (e) {
                              return i(e);
                            },
                            InputProps: {
                              startAdornment: (0, e.jsx)(
                                ap,
                                fO(
                                  {
                                    position: "end",
                                    title: V("myCustomers_searchButton"),
                                  },
                                  {
                                    children: (0, e.jsx)(mv, {
                                      className: "ST_MC_Search_Icon",
                                    }),
                                  }
                                )
                              ),
                            },
                          }),
                          (0, e.jsx)(
                            Ga,
                            fO(
                              { sx: fO({ mt: 5 }, jo) },
                              {
                                children: (0, e.jsxs)(
                                  ei,
                                  fO(
                                    { stickyHeader: !0 },
                                    {
                                      children: [
                                        (0, e.jsx)(si, {
                                          children: (0, e.jsx)(hi, {
                                            children: s.map(function (t, n) {
                                              return (0, e.jsx)(
                                                yi,
                                                fO(
                                                  {
                                                    onClick: function () {
                                                      return l(
                                                        null == t
                                                          ? void 0
                                                          : t.id
                                                      );
                                                    },
                                                    sx: fO(
                                                      fO(
                                                        {
                                                          whiteSpace: "nowrap",
                                                        },
                                                        t.inlineCSS
                                                      ),
                                                      {
                                                        display:
                                                          $ &&
                                                          "companyName" == t.id
                                                            ? "none"
                                                            : "",
                                                        fontSize: "13px",
                                                      }
                                                    ),
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      aO,
                                                      fO(
                                                        {
                                                          active:
                                                            c ===
                                                            (null == t
                                                              ? void 0
                                                              : t.id),
                                                          direction: u,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            "b",
                                                            {
                                                              children: t.label,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  }
                                                ),
                                                null == t ? void 0 : t.id
                                              );
                                            }),
                                          }),
                                        }),
                                        (0, e.jsx)(
                                          Pi,
                                          fO(
                                            { className: "ST_MC_Thead" },
                                            {
                                              children:
                                                d.length > 0
                                                  ? d.map(function (t, n) {
                                                      return (0, e.jsxs)(
                                                        hi,
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              yi,
                                                              fO(
                                                                {
                                                                  component:
                                                                    "th",
                                                                  scope: "row",
                                                                  sx: Io,
                                                                  onClick:
                                                                    function () {
                                                                      return O(
                                                                        null ==
                                                                          t
                                                                          ? void 0
                                                                          : t.CustomerId
                                                                      );
                                                                    },
                                                                },
                                                                {
                                                                  children:
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.ClientName) ||
                                                                    "-",
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              yi,
                                                              fO(
                                                                {
                                                                  sx: {
                                                                    textTransform:
                                                                      "capitalize",
                                                                    display: $
                                                                      ? "none"
                                                                      : "",
                                                                  },
                                                                },
                                                                {
                                                                  children:
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.companyName) ||
                                                                    "-",
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(yi, {
                                                              children:
                                                                (null == t
                                                                  ? void 0
                                                                  : t.CustomerMailid) ||
                                                                "-",
                                                            }),
                                                            (0, e.jsx)(
                                                              yi,
                                                              fO(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  sx:
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.shopifyOrdersCount) >
                                                                    0
                                                                      ? Io
                                                                      : void 0,
                                                                  onClick:
                                                                    function () {
                                                                      return (null ==
                                                                      t
                                                                        ? void 0
                                                                        : t.shopifyOrdersCount) >
                                                                        0
                                                                        ? I(
                                                                            null ==
                                                                              t
                                                                              ? void 0
                                                                              : t.CustomerId
                                                                          )
                                                                        : "";
                                                                    },
                                                                },
                                                                {
                                                                  children:
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.shopifyOrdersCount) >
                                                                    0
                                                                      ? "View"
                                                                      : "-",
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        },
                                                        n
                                                      );
                                                    })
                                                  : (0, e.jsx)(hi, {
                                                      children: (0, e.jsx)(
                                                        yi,
                                                        fO(
                                                          {
                                                            align: "center",
                                                            colSpan: 4,
                                                          },
                                                          {
                                                            children: V(
                                                              "myCustomer_no_salesRep_details"
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    }),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Av,
                    fO(
                      {
                        open: p,
                        onClose: function () {
                          return m(!1);
                        },
                        maxWidth: "md",
                        fullWidth: !0,
                      },
                      {
                        children: (0, e.jsxs)(
                          c_,
                          fO(
                            { className: "ST_MC_Dialog_Box" },
                            {
                              children: [
                                (0, e.jsxs)(
                                  La,
                                  fO(
                                    { container: !0, spacing: 2, mb: 2, pl: 2 },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          La,
                                          fO(
                                            { item: !0, xs: 10, md: 10 },
                                            {
                                              children: (0, e.jsx)(
                                                Wa,
                                                fO(
                                                  { variant: "h6" },
                                                  {
                                                    children: V(
                                                      f
                                                        ? "addCustomer_title"
                                                        : "myCustomers_table2Title"
                                                    ),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          La,
                                          fO(
                                            {
                                              item: !0,
                                              xs: 2,
                                              md: 2,
                                              sx: { textAlign: "right" },
                                              pr: 1,
                                            },
                                            {
                                              children: (0, e.jsx)(pv, {
                                                sx: { cursor: "pointer" },
                                                onClick: function () {
                                                  m(!1), v(b);
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Fv,
                                  fO(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: (0, e.jsx)(
                                        "form",
                                        fO(
                                          {
                                            className: f
                                              ? ""
                                              : "ST_MC_Disable_Form",
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              La,
                                              fO(
                                                { container: !0 },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "customer_fname",
                                                              label: V(
                                                                "addCustomer_content1"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.customer_fname.toString(),
                                                              fullWidth: !0,
                                                              error:
                                                                "" !==
                                                                (null == k
                                                                  ? void 0
                                                                  : k.fnameErrMsg),
                                                              helperText:
                                                                null == k
                                                                  ? void 0
                                                                  : k.fnameErrMsg,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                              required: !0,
                                                              disabled: !f,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "customer_lname",
                                                              label: V(
                                                                "addCustomer_content2"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.customer_lname.toString(),
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                              disabled: !f,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "email",
                                                              size: "small",
                                                              name: "customer_email",
                                                              label: V(
                                                                "addCustomer_content3"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.customer_email.toString(),
                                                              fullWidth: !0,
                                                              error:
                                                                "" !==
                                                                (null == k
                                                                  ? void 0
                                                                  : k.emailErrMsg),
                                                              helperText:
                                                                null == k
                                                                  ? void 0
                                                                  : k.emailErrMsg,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                              required: !0,
                                                              disabled: !f,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "number",
                                                              size: "small",
                                                              onKeyDown: iv,
                                                              name: "customer_phoneno",
                                                              label:
                                                                V(
                                                                  "signUp_content4"
                                                                ),
                                                              value:
                                                                0 ===
                                                                (null == h
                                                                  ? void 0
                                                                  : h.customer_phoneno)
                                                                  ? ""
                                                                  : null == h
                                                                  ? void 0
                                                                  : h.customer_phoneno.toString(),
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                              disabled: !f,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f,
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            $u,
                                                            fO(
                                                              {
                                                                fullWidth: !0,
                                                                size: "small",
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Bu,
                                                                    {
                                                                      children:
                                                                        V(
                                                                          "customer_country"
                                                                        ),
                                                                    }
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Kd,
                                                                    fO(
                                                                      {
                                                                        value:
                                                                          null ==
                                                                          h
                                                                            ? void 0
                                                                            : h.customer_country,
                                                                        name: "customer_country",
                                                                        label:
                                                                          V(
                                                                            "customer_country"
                                                                          ),
                                                                        onChange:
                                                                          function (
                                                                            e
                                                                          ) {
                                                                            return w(
                                                                              e,
                                                                              "customer_country"
                                                                            );
                                                                          },
                                                                        MenuProps:
                                                                          {
                                                                            PaperProps:
                                                                              {
                                                                                sx: {
                                                                                  maxHeight: 200,
                                                                                },
                                                                              },
                                                                          },
                                                                      },
                                                                      {
                                                                        children:
                                                                          U().map(
                                                                            function (
                                                                              t,
                                                                              n
                                                                            ) {
                                                                              return (0,
                                                                              e.jsx)(
                                                                                ob,
                                                                                fO(
                                                                                  {
                                                                                    value:
                                                                                      t.name,
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      t.name,
                                                                                  }
                                                                                ),
                                                                                n
                                                                              );
                                                                            }
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f,
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            $u,
                                                            fO(
                                                              {
                                                                fullWidth: !0,
                                                                size: "small",
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Bu,
                                                                    {
                                                                      children:
                                                                        V(
                                                                          "customer_state"
                                                                        ),
                                                                    }
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Kd,
                                                                    fO(
                                                                      {
                                                                        value:
                                                                          null ==
                                                                          h
                                                                            ? void 0
                                                                            : h.customer_state,
                                                                        name: "customer_state",
                                                                        label:
                                                                          V(
                                                                            "customer_state"
                                                                          ),
                                                                        onChange:
                                                                          function (
                                                                            e
                                                                          ) {
                                                                            return y(
                                                                              e
                                                                            );
                                                                          },
                                                                        MenuProps:
                                                                          {
                                                                            PaperProps:
                                                                              {
                                                                                sx: {
                                                                                  maxHeight: 200,
                                                                                },
                                                                              },
                                                                          },
                                                                      },
                                                                      {
                                                                        children:
                                                                          "" ===
                                                                          (null ==
                                                                          h
                                                                            ? void 0
                                                                            : h.customer_country)
                                                                            ? (0,
                                                                              e.jsx)(
                                                                                ob,
                                                                                {
                                                                                  children:
                                                                                    V(
                                                                                      "myCustomer_select_customer_country"
                                                                                    ),
                                                                                }
                                                                              )
                                                                            : null ===
                                                                                (n =
                                                                                  (0,
                                                                                  zb.getStates)(
                                                                                    K
                                                                                  )) ||
                                                                              void 0 ===
                                                                                n
                                                                            ? void 0
                                                                            : n.map(
                                                                                function (
                                                                                  t,
                                                                                  n
                                                                                ) {
                                                                                  return (0,
                                                                                  e.jsx)(
                                                                                    ob,
                                                                                    fO(
                                                                                      {
                                                                                        value:
                                                                                          t,
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t,
                                                                                      }
                                                                                    ),
                                                                                    n
                                                                                  );
                                                                                }
                                                                              ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "customer_city",
                                                              label: V(
                                                                "addCustomer_customerCityPlaceholder"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.customer_city,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "customer_pincode",
                                                              label: V(
                                                                "addCustomer_customerZipCode"
                                                              ),
                                                              value:
                                                                0 ===
                                                                (null == h
                                                                  ? void 0
                                                                  : h.customer_pincode)
                                                                  ? ""
                                                                  : null == h
                                                                  ? void 0
                                                                  : h.customer_pincode,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              multiline: !0,
                                                              rows: 2,
                                                              name: "customer_address",
                                                              label: V(
                                                                "addCustomer_customerAddress"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.customer_address,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                              disabled: !f,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              multiline: !0,
                                                              rows: 2,
                                                              name: "customer_note",
                                                              label: V(
                                                                "addCustomer_content4Placeholder"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.customer_note,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                              disabled: !f,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "business_name",
                                                              label: V(
                                                                "addCustomer_companyName"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.business_name,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "cust_company_address",
                                                              label: V(
                                                                "addCustomer_companyAddress"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.cust_company_address,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            $u,
                                                            fO(
                                                              {
                                                                fullWidth: !0,
                                                                size: "small",
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Bu,
                                                                    {
                                                                      children:
                                                                        V(
                                                                          "myCustomer_company_country"
                                                                        ),
                                                                    }
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Kd,
                                                                    fO(
                                                                      {
                                                                        value:
                                                                          null ==
                                                                          h
                                                                            ? void 0
                                                                            : h.cust_company_country,
                                                                        name: "cust_company_country",
                                                                        label:
                                                                          V(
                                                                            "company_country"
                                                                          ),
                                                                        onChange:
                                                                          function (
                                                                            e
                                                                          ) {
                                                                            return w(
                                                                              e,
                                                                              "cust_company_country"
                                                                            );
                                                                          },
                                                                        MenuProps:
                                                                          {
                                                                            PaperProps:
                                                                              {
                                                                                sx: {
                                                                                  maxHeight: 200,
                                                                                },
                                                                              },
                                                                          },
                                                                      },
                                                                      {
                                                                        children:
                                                                          U().map(
                                                                            function (
                                                                              t,
                                                                              n
                                                                            ) {
                                                                              return (0,
                                                                              e.jsx)(
                                                                                ob,
                                                                                fO(
                                                                                  {
                                                                                    value:
                                                                                      t.name,
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      t.name,
                                                                                  }
                                                                                ),
                                                                                n
                                                                              );
                                                                            }
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            $u,
                                                            fO(
                                                              {
                                                                fullWidth: !0,
                                                                size: "small",
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Bu,
                                                                    {
                                                                      children:
                                                                        V(
                                                                          "myCustomer_company_state"
                                                                        ),
                                                                    }
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Kd,
                                                                    fO(
                                                                      {
                                                                        value:
                                                                          null ==
                                                                          h
                                                                            ? void 0
                                                                            : h.cust_company_state,
                                                                        name: "cust_company_state",
                                                                        label:
                                                                          V(
                                                                            "company_state"
                                                                          ),
                                                                        onChange:
                                                                          function (
                                                                            e
                                                                          ) {
                                                                            return y(
                                                                              e
                                                                            );
                                                                          },
                                                                        MenuProps:
                                                                          {
                                                                            PaperProps:
                                                                              {
                                                                                sx: {
                                                                                  maxHeight: 200,
                                                                                },
                                                                              },
                                                                          },
                                                                      },
                                                                      {
                                                                        children:
                                                                          "" ===
                                                                          (null ==
                                                                          h
                                                                            ? void 0
                                                                            : h.cust_company_country)
                                                                            ? (0,
                                                                              e.jsx)(
                                                                                ob,
                                                                                {
                                                                                  children:
                                                                                    V(
                                                                                      "myCustomer_select_company_country"
                                                                                    ),
                                                                                }
                                                                              )
                                                                            : null ===
                                                                                (r =
                                                                                  (0,
                                                                                  zb.getStates)(
                                                                                    G
                                                                                  )) ||
                                                                              void 0 ===
                                                                                r
                                                                            ? void 0
                                                                            : r.map(
                                                                                function (
                                                                                  t,
                                                                                  n
                                                                                ) {
                                                                                  return (0,
                                                                                  e.jsx)(
                                                                                    ob,
                                                                                    fO(
                                                                                      {
                                                                                        value:
                                                                                          t,
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t,
                                                                                      }
                                                                                    ),
                                                                                    n
                                                                                  );
                                                                                }
                                                                              ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "cust_company_city",
                                                              label: V(
                                                                "addCustomer_companyCity"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.cust_company_city,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "cust_company_pincode",
                                                              label: V(
                                                                "addCustomer_companyZipCode"
                                                              ),
                                                              value:
                                                                0 ===
                                                                (null == h
                                                                  ? void 0
                                                                  : h.cust_company_pincode)
                                                                  ? ""
                                                                  : null == h
                                                                  ? void 0
                                                                  : h.cust_company_pincode,
                                                              fullWidth: !0,
                                                              onChange:
                                                                function (e) {
                                                                  return y(e);
                                                                },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 6,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: !f || $,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "customer_fname",
                                                              label:
                                                                "Price Tag",
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.tags,
                                                              fullWidth: !0,
                                                              disabled: !0,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: f,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "subTotal",
                                                              label: V(
                                                                "myCustomers_table2Row6"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.subTotal,
                                                              fullWidth: !0,
                                                              disabled: !0,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      fO(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 6,
                                                          p: 2,
                                                          hidden: f,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Xd,
                                                            {
                                                              type: "text",
                                                              size: "small",
                                                              name: "tags",
                                                              label: V(
                                                                "myCustomers_table2Row8"
                                                              ),
                                                              value:
                                                                null == h
                                                                  ? void 0
                                                                  : h.tags,
                                                              fullWidth: !0,
                                                              disabled: !0,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(cO, {
                                  children: (0, e.jsx)(
                                    La,
                                    fO(
                                      { pr: 1 },
                                      {
                                        children: f
                                          ? (0, e.jsxs)(
                                              vp,
                                              fO(
                                                {
                                                  variant: "contained",
                                                  onClick: C,
                                                  sx: {
                                                    textTransform: "capitalize",
                                                  },
                                                  disabled: !S,
                                                  className:
                                                    P ===
                                                    V("submitting_btn_text")
                                                      ? "ST_MC_No_Pointer"
                                                      : "ST_MC_All_Pointer",
                                                },
                                                {
                                                  children: [
                                                    P,
                                                    (0, e.jsx)(uO, {
                                                      fontSize: "small",
                                                      style: {
                                                        marginLeft: "5px",
                                                      },
                                                    }),
                                                  ],
                                                }
                                              )
                                            )
                                          : "",
                                      }
                                    )
                                  ),
                                }),
                                (0, e.jsx)(
                                  La,
                                  fO(
                                    {
                                      pr: 4,
                                      className: "" !== F ? "ST_MC_ErrMsg" : "",
                                    },
                                    { children: F }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    Av,
                    fO(
                      {
                        open: T,
                        onClose: function () {
                          M(!1), A(!1);
                        },
                        maxWidth: "xl",
                        fullWidth: !0,
                        sx: { pointerEvents: H ? "none" : "all" },
                      },
                      {
                        children: [
                          (0, e.jsxs)(
                            c_,
                            fO(
                              { className: "ST_MC_Dialog_Box", hidden: !N },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    La,
                                    fO(
                                      { container: !0, spacing: 2, mb: 2 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            La,
                                            fO(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  Wa,
                                                  fO(
                                                    { variant: "h6" },
                                                    {
                                                      children:
                                                        V("client_orders"),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            La,
                                            fO(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                              },
                                              {
                                                children: (0, e.jsx)(pv, {
                                                  sx: { cursor: "pointer" },
                                                  onClick: function () {
                                                    M(!1);
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  j.length > 0
                                    ? (0, e.jsx)(
                                        Fv,
                                        fO(
                                          { sx: { padding: "0px" } },
                                          {
                                            children: (0, e.jsx)(
                                              Ga,
                                              fO(
                                                { sx: fO({ mt: 1 }, jo) },
                                                {
                                                  children: (0, e.jsxs)(
                                                    ei,
                                                    fO(
                                                      { stickyHeader: !0 },
                                                      {
                                                        children: [
                                                          (0, e.jsx)(si, {
                                                            children: (0,
                                                            e.jsx)(
                                                              hi,
                                                              fO(
                                                                {
                                                                  className:
                                                                    "stickyHeaderRow",
                                                                },
                                                                {
                                                                  children:
                                                                    E.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          yi,
                                                                          fO(
                                                                            {
                                                                              sx: {
                                                                                whiteSpace:
                                                                                  "nowrap",
                                                                              },
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "b",
                                                                                  {
                                                                                    children:
                                                                                      null ==
                                                                                      t
                                                                                        ? void 0
                                                                                        : t.label,
                                                                                  }
                                                                                ),
                                                                            }
                                                                          ),
                                                                          (null ==
                                                                          t
                                                                            ? void 0
                                                                            : t.label) +
                                                                            "_" +
                                                                            n
                                                                        );
                                                                      }
                                                                    ),
                                                                }
                                                              )
                                                            ),
                                                          }),
                                                          (0, e.jsx)(
                                                            Pi,
                                                            fO(
                                                              {
                                                                className:
                                                                  "ST_MC_Thead",
                                                              },
                                                              {
                                                                children: j.map(
                                                                  function (
                                                                    t,
                                                                    n
                                                                  ) {
                                                                    return (0,
                                                                    e.jsxs)(
                                                                      hi,
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsx)(
                                                                              yi,
                                                                              fO(
                                                                                {
                                                                                  component:
                                                                                    "th",
                                                                                  scope:
                                                                                    "row",
                                                                                  sx: Io,
                                                                                  onClick:
                                                                                    function () {
                                                                                      return D(
                                                                                        t
                                                                                      );
                                                                                    },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.order_number,
                                                                                }
                                                                              )
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  Z(
                                                                                    null ==
                                                                                      t
                                                                                      ? void 0
                                                                                      : t.created_at
                                                                                  ),
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.financial_status) ||
                                                                                  "-",
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.fulfillment_status) ||
                                                                                  "-",
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsxs)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    W +
                                                                                      " ",
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.subtotal_price.toFixed(
                                                                                          2
                                                                                        ),
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsxs)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    W +
                                                                                      " ",
                                                                                    (null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.shippingCharges) ||
                                                                                      "0.00",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsxs)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    W +
                                                                                      " ",
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.total_tax,
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsxs)(
                                                                              yi,
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    W +
                                                                                      " ",
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.total_price.toFixed(
                                                                                          2
                                                                                        ),
                                                                                  ],
                                                                              }
                                                                            ),
                                                                          ],
                                                                      },
                                                                      n
                                                                    );
                                                                  }
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      )
                                    : (0, e.jsx)(
                                        Fv,
                                        fO(
                                          { sx: { padding: "0px" } },
                                          { children: V("no_orders_to_show") }
                                        )
                                      ),
                                ],
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            c_,
                            fO(
                              { className: "ST_MC_Dialog_Box", hidden: N },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    La,
                                    fO(
                                      { container: !0, spacing: 2, mb: 2 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            La,
                                            fO(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  Wa,
                                                  fO(
                                                    { variant: "h6" },
                                                    {
                                                      children: V(
                                                        "viewRepClientOrdersDetails_column5"
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            La,
                                            fO(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                              },
                                              {
                                                children: (0, e.jsx)(pv, {
                                                  sx: { cursor: "pointer" },
                                                  onClick: function () {
                                                    A(!0);
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  R && R.length > 0
                                    ? (0, e.jsxs)(Fv, {
                                        children: [
                                          B
                                            ? (0, e.jsx)(c_, {
                                                children: (0, e.jsxs)(
                                                  La,
                                                  fO(
                                                    {
                                                      container: !0,
                                                      spacing: 2,
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          La,
                                                          fO(
                                                            {
                                                              item: !0,
                                                              xs: 6,
                                                              md: 4,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                Wa,
                                                                fO(
                                                                  {
                                                                    variant:
                                                                      "body2",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              V(
                                                                                "viewRepClientOrdersDetails_column1"
                                                                              ),
                                                                              " :",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      " ",
                                                                      null == B
                                                                        ? void 0
                                                                        : B.order_number,
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          La,
                                                          fO(
                                                            {
                                                              item: !0,
                                                              xs: 6,
                                                              md: 4,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                Wa,
                                                                fO(
                                                                  {
                                                                    variant:
                                                                      "body2",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              V(
                                                                                "viewRepClientOrdersDetails_column3"
                                                                              ),
                                                                              " :",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      " ",
                                                                      W + " ",
                                                                      (null == B
                                                                        ? void 0
                                                                        : B.subtotal_price.toFixed(
                                                                            2
                                                                          )) ||
                                                                        "0.00",
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          La,
                                                          fO(
                                                            {
                                                              item: !0,
                                                              xs: 6,
                                                              md: 4,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                Wa,
                                                                fO(
                                                                  {
                                                                    variant:
                                                                      "body2",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              V(
                                                                                "myOrders_content3"
                                                                              ),
                                                                              " :",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      " ",
                                                                      W + " ",
                                                                      (null == B
                                                                        ? void 0
                                                                        : B.shippingCharges) ||
                                                                        "0.00",
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          La,
                                                          fO(
                                                            {
                                                              item: !0,
                                                              xs: 6,
                                                              md: 4,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                Wa,
                                                                fO(
                                                                  {
                                                                    variant:
                                                                      "body2",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              V(
                                                                                "myOrders_content2"
                                                                              ),
                                                                              " :",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      " ",
                                                                      W + " ",
                                                                      (null == B
                                                                        ? void 0
                                                                        : B.total_tax) ||
                                                                        "0.00",
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          La,
                                                          fO(
                                                            {
                                                              item: !0,
                                                              xs: 6,
                                                              md: 4,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                Wa,
                                                                fO(
                                                                  {
                                                                    variant:
                                                                      "body2",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              V(
                                                                                "myOrders_table2Column7"
                                                                              ),
                                                                              " :",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      " ",
                                                                      W + " ",
                                                                      (null == B
                                                                        ? void 0
                                                                        : B.total_price.toFixed(
                                                                            2
                                                                          )) ||
                                                                        "0.00",
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          La,
                                                          fO(
                                                            {
                                                              item: !0,
                                                              xs: 6,
                                                              md: 4,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                Wa,
                                                                fO(
                                                                  {
                                                                    variant:
                                                                      "body2",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              V(
                                                                                "myOrders_content5"
                                                                              ),
                                                                              " :",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      " ",
                                                                      (null == B
                                                                        ? void 0
                                                                        : B.note) ||
                                                                        "-",
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              })
                                            : "",
                                          (0, e.jsx)(
                                            Ga,
                                            fO(
                                              {
                                                sx: fO(fO({ mt: 1 }, jo), {
                                                  borderTop:
                                                    "1px solid #dadada",
                                                }),
                                              },
                                              {
                                                children: (0, e.jsxs)(
                                                  ei,
                                                  fO(
                                                    { stickyHeader: !0 },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(si, {
                                                          children: (0, e.jsx)(
                                                            hi,
                                                            {
                                                              children: L.map(
                                                                function (
                                                                  t,
                                                                  n
                                                                ) {
                                                                  return (0,
                                                                  e.jsx)(
                                                                    yi,
                                                                    fO(
                                                                      { sx: q },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            "b",
                                                                            {
                                                                              children:
                                                                                null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.label,
                                                                            }
                                                                          ),
                                                                      }
                                                                    ),
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.label) +
                                                                      "_" +
                                                                      n
                                                                  );
                                                                }
                                                              ),
                                                            }
                                                          ),
                                                        }),
                                                        (0, e.jsx)(
                                                          Pi,
                                                          fO(
                                                            {
                                                              className:
                                                                "ST_MC_Thead",
                                                            },
                                                            {
                                                              children: R.map(
                                                                function (
                                                                  t,
                                                                  n
                                                                ) {
                                                                  return (0,
                                                                  e.jsxs)(
                                                                    hi,
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            fO(
                                                                              {
                                                                                component:
                                                                                  "th",
                                                                                scope:
                                                                                  "row",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.Image
                                                                                  )
                                                                                    ? (0,
                                                                                      e.jsx)(
                                                                                        c_,
                                                                                        {
                                                                                          component:
                                                                                            "img",
                                                                                          sx: Ro,
                                                                                          src:
                                                                                            null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.Image,
                                                                                        }
                                                                                      )
                                                                                    : (0,
                                                                                      e.jsx)(
                                                                                        hO.Z,
                                                                                        {
                                                                                          sx: {
                                                                                            height: 50,
                                                                                            width: 50,
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                              }
                                                                            )
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            fO(
                                                                              {
                                                                                sx: {
                                                                                  width:
                                                                                    "10%",
                                                                                },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.Title) ||
                                                                                  "-",
                                                                              }
                                                                            )
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            fO(
                                                                              {
                                                                                sx: {
                                                                                  width:
                                                                                    "10%",
                                                                                },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.variantTitle) ||
                                                                                  "-",
                                                                              }
                                                                            )
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            {
                                                                              children:
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.SKU) ||
                                                                                "-",
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            {
                                                                              children:
                                                                                null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.quantity,
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsxs)(
                                                                            yi,
                                                                            {
                                                                              children:
                                                                                [
                                                                                  W +
                                                                                    " ",
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.ItemPrice.toFixed(
                                                                                        2
                                                                                      )) ||
                                                                                    "0.00",
                                                                                ],
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsxs)(
                                                                            yi,
                                                                            {
                                                                              children:
                                                                                [
                                                                                  W +
                                                                                    " ",
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.discountedPrice.toFixed(
                                                                                        2
                                                                                      )) ||
                                                                                    "0.00",
                                                                                ],
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            {
                                                                              children:
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.trackingNumber) ||
                                                                                "-",
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            yi,
                                                                            fO(
                                                                              {
                                                                                sx: {
                                                                                  width:
                                                                                    "9%",
                                                                                },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  Z(
                                                                                    null ==
                                                                                      t
                                                                                      ? void 0
                                                                                      : t.ShipDate
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                          (0,
                                                                          e.jsxs)(
                                                                            yi,
                                                                            fO(
                                                                              {
                                                                                sx: {
                                                                                  width:
                                                                                    "9%",
                                                                                },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    W +
                                                                                      " ",
                                                                                    (null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.Subtotal.toFixed(
                                                                                          2
                                                                                        )) ||
                                                                                      "0.00",
                                                                                  ],
                                                                              }
                                                                            )
                                                                          ),
                                                                        ],
                                                                    },
                                                                    n
                                                                  );
                                                                }
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      })
                                    : (0, e.jsxs)(
                                        Fv,
                                        fO(
                                          { sx: { padding: "0px" } },
                                          {
                                            children: [
                                              V("no_product_details"),
                                              ".",
                                            ],
                                          }
                                        )
                                      ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                ],
              }
            )
          );
        };
      const vO = t.createContext(null);
      function bO(n) {
        const { children: r, value: o } = n,
          a = (function () {
            const [e, n] = t.useState(null);
            return (
              t.useEffect(() => {
                n(`mui-p-${Math.round(1e5 * Math.random())}`);
              }, []),
              e
            );
          })(),
          i = t.useMemo(() => ({ idPrefix: a, value: o }), [a, o]);
        return (0, e.jsx)(vO.Provider, { value: i, children: r });
      }
      function _O() {
        return t.useContext(vO);
      }
      function yO(e, t) {
        const { idPrefix: n } = e;
        return null === n ? null : `${e.idPrefix}-P-${t}`;
      }
      function xO(e, t) {
        const { idPrefix: n } = e;
        return null === n ? null : `${e.idPrefix}-T-${t}`;
      }
      const CO = ["children"],
        SO = t.forwardRef(function (n, r) {
          const { children: o } = n,
            a = (0, jt.Z)(n, CO),
            i = _O();
          if (null === i) throw new TypeError("No TabContext provided");
          const s = t.Children.map(o, (e) =>
            t.isValidElement(e)
              ? t.cloneElement(e, {
                  "aria-controls": yO(i, e.props.value),
                  id: xO(i, e.props.value),
                })
              : null
          );
          return (0,
          e.jsx)(fa, (0, d.Z)({}, a, { ref: r, value: i.value, children: s }));
        });
      var kO = SO;
      function wO(e) {
        var t,
          n,
          r = "";
        if ("string" == typeof e || "number" == typeof e) r += e;
        else if ("object" == typeof e)
          if (Array.isArray(e))
            for (t = 0; t < e.length; t++)
              e[t] && (n = wO(e[t])) && (r && (r += " "), (r += n));
          else for (t in e) e[t] && (r && (r += " "), (r += t));
        return r;
      }
      var PO = function () {
        for (var e, t, n = 0, r = ""; n < arguments.length; )
          (e = arguments[n++]) && (t = wO(e)) && (r && (r += " "), (r += t));
        return r;
      };
      function OO(e) {
        return (0, Zt.ZP)("MuiTabPanel", e);
      }
      (0, Bt.Z)("MuiTabPanel", ["root"]);
      const IO = ["children", "className", "value"],
        TO = (0, Lt.ZP)("div", {
          name: "MuiTabPanel",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(({ theme: e }) => ({ padding: e.spacing(3) })),
        MO = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiTabPanel" }),
            { children: o, className: a, value: i } = r,
            s = (0, jt.Z)(r, IO),
            l = (0, d.Z)({}, r),
            c = ((e) => {
              const { classes: t } = e;
              return (0, Nt.Z)({ root: ["root"] }, OO, t);
            })(l),
            u = _O();
          if (null === u) throw new TypeError("No TabContext provided");
          const p = yO(u, i),
            m = xO(u, i);
          return (0,
          e.jsx)(TO, (0, d.Z)({ "aria-labelledby": m, className: PO(c.root, a), hidden: i !== u.value, id: p, ref: n, role: "tabpanel", ownerState: l }, s, { children: i === u.value && o }));
        });
      var EO = MO,
        DO = o(3162),
        jO = o.n(DO),
        RO = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        NO = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function AO() {
        var e,
          n,
          r = this,
          o = X().t,
          a = g(),
          i = z.getState().salesRepData.loggedInRepDetails.shopCurrency,
          s =
            null !== (e = z.getState().salesRepData.baseData.select) &&
            void 0 !== e
              ? e
              : {},
          l = [
            { label: o("draftOrder_OrderNumber") },
            { label: o("draftOrder_CustName") },
            { label: o("draftOrder_OrderDate") },
            {
              label: o("draftOrder_SubTotal") + "(" + i + ")",
              inlineCSS: { textAlign: "center" },
            },
            {
              label: o("draftOrder_Status"),
              inlineCSS: { textAlign: "center" },
            },
            {
              label: o("draftOrder_Invoice"),
              inlineCSS: { textAlign: "center" },
            },
          ],
          c = [
            { label: o("draftOrder_Product") },
            { label: o("draftOrder_ProductName") },
            { label: o("draftOrder_Size") },
            { label: o("draftOrder_Quantity") },
            { label: o("draftOrder_Price") },
            { label: o("draftOrder_Status") },
            { label: o("draftOrder_SubTotal") },
          ],
          u = (0, t.useState)(!1),
          d = u[0],
          p = u[1],
          m = (0, t.useState)(
            null !== (n = z.getState().salesRepData.draftOrderData) &&
              void 0 !== n
              ? n
              : []
          ),
          h = m[0],
          f = m[1],
          v = (0, t.useState)(),
          b = v[0],
          _ = v[1],
          y = (0, t.useState)([]),
          x = y[0],
          C = y[1],
          S = (0, t.useState)(0),
          k = S[0],
          w = S[1],
          P = (0, t.useState)(!1),
          O = P[0],
          I = P[1],
          T = (0, t.useState)(0),
          M = T[0],
          E = T[1],
          D = (0, t.useState)(!1),
          R = D[0],
          N = D[1],
          A = (0, t.useState)(!1),
          L = A[0],
          B = A[1],
          Z = (0, t.useState)(null),
          F = Z[0],
          H = Z[1],
          V = (0, t.useState)({ itemOrderId: 0, index: 0 }),
          W = V[0],
          $ = V[1];
        (0, t.useEffect)(function () {
          U();
        }, []);
        var U = function () {
            return RO(r, void 0, void 0, function () {
              var e;
              return NO(this, function (t) {
                switch (t.label) {
                  case 0:
                    return mf.next(!0), [4, a(Eg())];
                  case 1:
                    return (
                      (e = t.sent()),
                      mf.next(!1),
                      e &&
                        z.getState().salesRepData.draftOrderData &&
                        f(z.getState().salesRepData.draftOrderData),
                      [2]
                    );
                }
              });
            });
          },
          K = function (e, t) {
            return (
              void 0 === t && (t = ""),
              RO(r, void 0, void 0, function () {
                var n, r, o, i;
                return NO(this, function (s) {
                  switch (s.label) {
                    case 0:
                      return (
                        mf.next(!0),
                        (n = { order_id: e.orderid }),
                        [4, a(Rg(n, t))]
                      );
                    case 1:
                      return (
                        (r = s.sent()),
                        t !== Hv && p(!0),
                        C(
                          null !==
                            (o = null == r ? void 0 : r.ProductDetails) &&
                            void 0 !== o
                            ? o
                            : []
                        ),
                        _(
                          null !== (i = null == r ? void 0 : r.draftOrder) &&
                            void 0 !== i
                            ? i
                            : {}
                        ),
                        mf.next(!1),
                        [2]
                      );
                  }
                });
              })
            );
          };
        return {
          DraftOrdersHeaderNames: l,
          DraftOrderProductHeaderNames: c,
          openDraftProductDataDialog: d,
          setOpenDraftProductDataDialog: p,
          draftOrderArray: h,
          getDraftOrderDetails: K,
          activeClientObj: b,
          draftOrderProductDetailsArray: x,
          t: o,
          sendInvoice: function (e, t) {
            return RO(r, void 0, void 0, function () {
              var n;
              return NO(this, function (r) {
                switch (r.label) {
                  case 0:
                    return (
                      w(t),
                      I(!0),
                      (n = { orderid: e.orderid, emailid: e.emailid }),
                      [4, a(Ng(n))]
                    );
                  case 1:
                    return (
                      r.sent() &&
                        (B(!0),
                        setTimeout(function () {
                          B(!1);
                        }, 3e3)),
                      I(!1),
                      [2]
                    );
                }
              });
            });
          },
          openDeleteInvoiceConfirmation: function (e, t, n) {
            H(e.currentTarget), $({ itemOrderId: t.orderid, index: n });
          },
          sendInvoiceIndex: k,
          sendInvoiceFlag: O,
          deleteInvoiceFlag: R,
          setDeleteInvoiceFlag: N,
          deleteInvoiceIndex: M,
          successFlag: L,
          deleteConfirmation: F,
          setDeleteConfirmation: H,
          deleteInvoice: function () {
            return RO(r, void 0, void 0, function () {
              var e;
              return NO(this, function (t) {
                switch (t.label) {
                  case 0:
                    return E(W.index), N(!0), [4, a(Ag(W.itemOrderId))];
                  case 1:
                    return (
                      (e = t.sent()) &&
                        null !== e &&
                        (E(0),
                        f(z.getState().salesRepData.draftOrderData),
                        H(null)),
                      N(!1),
                      [2]
                    );
                }
              });
            });
          },
          shopCurrency: i,
          getDraftOrder: U,
          handleEditOrder: function (e) {
            return RO(r, void 0, void 0, function () {
              var t, n, r, o, i, s;
              return NO(this, function (l) {
                switch (l.label) {
                  case 0:
                    return [4, K(e, Hv)];
                  case 1:
                    return (
                      l.sent(),
                      (t =
                        null !==
                          (o =
                            null === (r = z.getState().salesRepData) ||
                            void 0 === r
                              ? void 0
                              : r.editDraftOrder) && void 0 !== o
                          ? o
                          : {}) &&
                        0 !==
                          (null ===
                            (i = Object.keys(
                              null == t ? void 0 : t.draftOrderObj
                            )) || void 0 === i
                            ? void 0
                            : i.length) &&
                        (null ===
                          (s = null == t ? void 0 : t.productDetailsArray) ||
                        void 0 === s
                          ? void 0
                          : s.length) > 0 &&
                        ((n = {
                          payload: { activeTabIndex: 1, actionEvent: Hv },
                          type: j.ACTIVE_TAB,
                        }),
                        a(n)),
                      [2]
                    );
                }
              });
            });
          },
          selectFeatures: s,
        };
      }
      var LO = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        },
        zO = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3m-3 11H8v-5h8zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m-1-9H6v4h12z",
          }),
          "Print"
        ),
        BO = function () {
          return (
            (BO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            BO.apply(this, arguments)
          );
        },
        ZO = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a = this,
                i = X().t,
                s = g(),
                l = y(function (e) {
                  return e.salesRepData ? e.salesRepData : {};
                }),
                c = (0, t.useState)(
                  null !==
                    (n =
                      null === (e = null == l ? void 0 : l.ordersData) ||
                      void 0 === e
                        ? void 0
                        : e.AllOrdersCommission) && void 0 !== n
                    ? n
                    : []
                ),
                u = c[0],
                d = c[1],
                p = z.getState().salesRepData.loggedInRepDetails.shopCurrency;
              (0, t.useEffect)(function () {
                mf.next(!0),
                  setTimeout(function () {
                    mf.next(!1);
                  }, 5e3);
              }, []),
                (0, t.useEffect)(
                  function () {
                    var e, t, n;
                    (null ===
                      (t =
                        null === (e = null == l ? void 0 : l.ordersData) ||
                        void 0 === e
                          ? void 0
                          : e.AllOrdersCommission) || void 0 === t
                      ? void 0
                      : t.length) > 0 &&
                      (mf.next(!1),
                      d(
                        null === (n = null == l ? void 0 : l.ordersData) ||
                          void 0 === n
                          ? void 0
                          : n.AllOrdersCommission
                      ));
                  },
                  [l.ordersData]
                );
              var m = [
                  { label: i("yourSales_table1Column1") },
                  { label: i("yourSales_table1Column2") },
                  { label: i("yourSales_table1Column3") },
                  {
                    label: i("yourSales_table1Column4") + "(" + p + ")",
                    inlineCSS: { textAlign: "center" },
                  },
                  {
                    label: i("yourSales_table1Column5") + "(" + p + ")",
                    inlineCSS: { textAlign: "center" },
                  },
                  { label: i("yourSales_table1Column6") },
                  {
                    label: i("yourSales_table1Column7"),
                    inlineCSS: { textAlign: "center" },
                  },
                ],
                h = [
                  { label: i("yourSales_column1") },
                  { label: i("yourSales_column2") },
                  { label: i("variant_title") },
                  { label: "SKU" },
                  { label: i("yourSales_column3") },
                  { label: i("yourSales_column4") + "(" + p + ")" },
                  { label: i("viewProductModelColumn6") + "(" + p + ")" },
                  { label: i("yourSales_column5") },
                  { label: i("yourSales_column6") },
                  { label: i("yourSales_column7") + "(" + p + ")" },
                ],
                f =
                  null !==
                    (r =
                      null == u
                        ? void 0
                        : u.filter(function (e) {
                            return (
                              "paid" === e.OrderStatus ||
                              "partially_refunded" === e.OrderStatus ||
                              "completed" === e.OrderStatus
                            );
                          })) && void 0 !== r
                    ? r
                    : [],
                v = (0, t.useState)(!1),
                b = v[0],
                _ = v[1],
                x = (0, t.useState)(),
                C = x[0],
                S = x[1],
                k = (0, t.useState)([]),
                w = k[0],
                P = k[1],
                O =
                  null !== (o = z.getState().salesRepData.baseData.ShopName) &&
                  void 0 !== o
                    ? o
                    : null;
              return {
                HeaderSalesNames: m,
                getYourSalesProductsData: function (e) {
                  return (
                    (t = a),
                    (n = void 0),
                    (o = function () {
                      var t, n;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (r) {
                        switch (r.label) {
                          case 0:
                            return (
                              (t = { order_id: e.OrderId }),
                              mf.next(!0),
                              [4, s(Mg(t))]
                            );
                          case 1:
                            return (
                              (n = r.sent()),
                              _(!0),
                              P(n ? n.ProductDetails : []),
                              S(n.singleOrderDetailsFromShopify),
                              mf.next(!1),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((r = void 0) || (r = Promise))(function (e, a) {
                      function i(e) {
                        try {
                          l(o.next(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(o.throw(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof r
                              ? n
                              : new r(function (e) {
                                  e(n);
                                })).then(i, s);
                      }
                      l((o = o.apply(t, n || [])).next());
                    })
                  );
                  var t, n, r, o;
                },
                ProductSalesDetailsHeaderNames: h,
                openProductDataDialog: b,
                setOpenProductDataDialog: _,
                yorSalesArray: f,
                activeClientObj: C,
                yorSalesProductArray: w,
                t: i,
                getDateFormat: function (e) {
                  return e.includes("-")
                    ? "-"
                    : new Date(
                        parseInt(e.replace("/Date(", ""))
                      ).toLocaleDateString();
                },
                getPrintOrderDetails: function (e) {
                  return (
                    (z.getState().salesRepData.baseData.salesRepUrl
                      ? z.getState().salesRepData.baseData.salesRepUrl
                      : "") +
                    "/SalesRepTenant/PrintInvoicesBySalesRep?hmac=" +
                    (z.getState().salesRepData.baseData.hmac
                      ? z.getState().salesRepData.baseData.hmac
                      : "") +
                    "&customerName=" +
                    e.CustomerName +
                    "&orderId=" +
                    e.OrderId +
                    "&shop=" +
                    O
                  );
                },
                shopCurrency: p,
                shopName: O,
              };
            })(),
            r = n.HeaderSalesNames,
            o = n.getYourSalesProductsData,
            a = n.ProductSalesDetailsHeaderNames,
            i = n.openProductDataDialog,
            s = n.setOpenProductDataDialog,
            l = n.yorSalesArray,
            c = n.activeClientObj,
            u = n.yorSalesProductArray,
            d = n.t,
            p = n.getDateFormat,
            m = n.getPrintOrderDetails,
            h = n.shopCurrency,
            f = n.shopName;
          return (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(
                Ga,
                BO(
                  { sx: jo },
                  {
                    children: (0, e.jsxs)(
                      ei,
                      BO(
                        { stickyHeader: !0 },
                        {
                          children: [
                            (0, e.jsx)(si, {
                              children: (0, e.jsx)(
                                hi,
                                BO(
                                  { className: "stickyHeaderRow" },
                                  {
                                    children: r.map(function (t, n) {
                                      return (0,
                                      e.jsx)(yi, BO({ sx: BO(BO({ whiteSpace: "nowrap" }, null == t ? void 0 : t.inlineCSS), { fontSize: "13px" }) }, { children: (0, e.jsx)("b", { children: t.label }) }), n);
                                    }),
                                  }
                                )
                              ),
                            }),
                            (0, e.jsx)(
                              Pi,
                              BO(
                                { className: "ST_SO_Thead" },
                                {
                                  children:
                                    l.length > 0
                                      ? l.map(function (t, n) {
                                          return "open" !== t.OrderStatus
                                            ? (0, e.jsxs)(
                                                hi,
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      yi,
                                                      BO(
                                                        {
                                                          sx: Io,
                                                          onClick: function () {
                                                            return o(t);
                                                          },
                                                        },
                                                        {
                                                          children:
                                                            null == t
                                                              ? void 0
                                                              : t.orderNumber,
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(yi, {
                                                      children:
                                                        (null == t
                                                          ? void 0
                                                          : t.orderDate) || "-",
                                                    }),
                                                    (0, e.jsx)(
                                                      yi,
                                                      BO(
                                                        {
                                                          sx: { width: "15%" },
                                                        },
                                                        {
                                                          children:
                                                            (null == t
                                                              ? void 0
                                                              : t.CustomerName) ||
                                                            "-",
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsxs)(
                                                      yi,
                                                      BO(
                                                        { align: "center" },
                                                        {
                                                          children: [
                                                            h + " ",
                                                            " ",
                                                            (null == t
                                                              ? void 0
                                                              : t.subtotal.toFixed(
                                                                  2
                                                                )) || "0.00",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsxs)(
                                                      yi,
                                                      BO(
                                                        { align: "center" },
                                                        {
                                                          children: [
                                                            h + " ",
                                                            " ",
                                                            (null == t
                                                              ? void 0
                                                              : t.commission.toFixed(
                                                                  2
                                                                )) || "0",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(yi, {
                                                      children:
                                                        (null == t
                                                          ? void 0
                                                          : t.CommissionType) ||
                                                        "-",
                                                    }),
                                                    (0, e.jsx)(
                                                      yi,
                                                      BO(
                                                        {
                                                          align: "center",
                                                          sx: {
                                                            cursor:
                                                              null == f
                                                                ? "not-allowed"
                                                                : "curosr",
                                                          },
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Il,
                                                            BO(
                                                              {
                                                                href: m(t),
                                                                target:
                                                                  "_blank",
                                                                sx: {
                                                                  pointerEvents:
                                                                    null == f
                                                                      ? "none"
                                                                      : "all",
                                                                },
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsx)(zO, {
                                                                  sx: {
                                                                    cursor:
                                                                      "pointer",
                                                                    color:
                                                                      "#1976d2",
                                                                  },
                                                                }),
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                },
                                                n
                                              )
                                            : "";
                                        })
                                      : (0, e.jsx)(hi, {
                                          children: (0, e.jsxs)(
                                            yi,
                                            BO(
                                              { align: "center", colSpan: 7 },
                                              {
                                                children: [
                                                  d("no_orders_to_show"),
                                                  ".",
                                                ],
                                              }
                                            )
                                          ),
                                        }),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                Av,
                BO(
                  {
                    open: i,
                    maxWidth: "xl",
                    fullWidth: !0,
                    onClose: function () {
                      return s(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      ln,
                      BO(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              La,
                              BO(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      BO(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            Wa,
                                            BO(
                                              {
                                                variant: "h6",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children: d(
                                                  "yourSales_tableTitle"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      BO(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(pv, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              s(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            u.length > 0
                              ? (0, e.jsxs)(
                                  Fv,
                                  BO(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: [
                                        c
                                          ? (0, e.jsx)(ln, {
                                              children: (0, e.jsxs)(
                                                La,
                                                BO(
                                                  { container: !0, spacing: 2 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        La,
                                                        BO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "yourSales_table1Column1"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    null == c
                                                                      ? void 0
                                                                      : c.order_number,
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "yourSales_table1Column4"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    h + " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.subtotal_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "yourSales_content3"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    h + " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.shippingCharges.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "yourSales_content2"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    h + " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.total_tax) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "yourSales_column7"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    h + " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.total_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "yourSales_content5"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.note) ||
                                                                      "-",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            })
                                          : "",
                                        (0, e.jsx)(
                                          Ga,
                                          BO(
                                            {
                                              sx: BO(BO({ mt: 1 }, jo), {
                                                borderTop: "1px solid #dadada",
                                              }),
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                ei,
                                                BO(
                                                  { stickyHeader: !0 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(si, {
                                                        children: (0, e.jsx)(
                                                          hi,
                                                          {
                                                            children: a.map(
                                                              function (t, n) {
                                                                return (0,
                                                                e.jsx)(
                                                                  yi,
                                                                  BO(
                                                                    { sx: Mo },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          "b",
                                                                          {
                                                                            children:
                                                                              t.label,
                                                                          }
                                                                        ),
                                                                    }
                                                                  ),
                                                                  n
                                                                );
                                                              }
                                                            ),
                                                          }
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Pi,
                                                        BO(
                                                          {
                                                            className:
                                                              "ST_SO_Thead",
                                                          },
                                                          {
                                                            children: u.map(
                                                              function (t, n) {
                                                                return (0,
                                                                e.jsxs)(
                                                                  hi,
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        BO(
                                                                          {
                                                                            component:
                                                                              "th",
                                                                            scope:
                                                                              "row",
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.Image
                                                                                ? (0,
                                                                                  e.jsx)(
                                                                                    ln,
                                                                                    {
                                                                                      component:
                                                                                        "img",
                                                                                      sx: Ro,
                                                                                      src: t.Image,
                                                                                    }
                                                                                  )
                                                                                : (0,
                                                                                  e.jsx)(
                                                                                    vv,
                                                                                    {
                                                                                      sx: {
                                                                                        height: 50,
                                                                                        width: 50,
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        BO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "10%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.Title ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        BO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "10%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.variantTitle ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.SKU ||
                                                                            "-",
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.quantity,
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            [
                                                                              h +
                                                                                " ",
                                                                              t.ItemPrice.toFixed(
                                                                                2
                                                                              ) ||
                                                                                "0.00",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            [
                                                                              h +
                                                                                " ",
                                                                              t.discountedPrice.toFixed(
                                                                                2
                                                                              ) ||
                                                                                "0.00",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.trackingNumber ||
                                                                            "-",
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        BO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "9%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              p(
                                                                                t.ShipDate
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        BO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "9%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                h +
                                                                                  " ",
                                                                                t.Subtotal.toFixed(
                                                                                  2
                                                                                ) ||
                                                                                  "0.00",
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                    ],
                                                                  },
                                                                  n
                                                                );
                                                              }
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                )
                              : (0, e.jsxs)(Fv, {
                                  children: [d("no_product_details"), "."],
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        FO = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z",
          }),
          "Edit"
        ),
        HO = function () {
          return (
            (HO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            HO.apply(this, arguments)
          );
        },
        VO = function () {
          var t,
            n = AO(),
            r = n.DraftOrdersHeaderNames,
            o = n.DraftOrderProductHeaderNames,
            a = n.openDraftProductDataDialog,
            i = n.setOpenDraftProductDataDialog,
            s = n.draftOrderArray,
            l = n.getDraftOrderDetails,
            c = n.activeClientObj,
            u = n.draftOrderProductDetailsArray,
            d = n.t,
            p = n.sendInvoice,
            m = n.openDeleteInvoiceConfirmation,
            h = n.sendInvoiceIndex,
            f = n.sendInvoiceFlag,
            g = n.deleteInvoiceFlag,
            v = n.setDeleteInvoiceFlag,
            b = n.successFlag,
            _ = n.deleteConfirmation,
            y = n.setDeleteConfirmation,
            x = n.deleteInvoice,
            C = n.shopCurrency,
            S = n.handleEditOrder,
            k = n.selectFeatures;
          return (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(
                Ga,
                HO(
                  { sx: jo },
                  {
                    children: (0, e.jsxs)(
                      ei,
                      HO(
                        { stickyHeader: !0 },
                        {
                          children: [
                            (0, e.jsx)(si, {
                              children: (0, e.jsx)(hi, {
                                children: r.map(function (t, n) {
                                  return (0,
                                  e.jsx)(yi, HO({ sx: HO(HO({ whiteSpace: "nowrap" }, null == t ? void 0 : t.inlineCSS), { fontSize: "13px" }) }, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.label }) }), n);
                                }),
                              }),
                            }),
                            (0, e.jsx)(
                              Pi,
                              HO(
                                { className: "ST_SO_Thead" },
                                {
                                  children:
                                    (null == s ? void 0 : s.length) > 0
                                      ? null == s
                                        ? void 0
                                        : s.map(function (t, n) {
                                            return "open" == t.status ||
                                              "voided" == t.status
                                              ? (0, e.jsxs)(
                                                  hi,
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        yi,
                                                        HO(
                                                          {
                                                            sx:
                                                              "voided" ===
                                                              (null == t
                                                                ? void 0
                                                                : t.OrderStatus)
                                                                ? To
                                                                : Io,
                                                            onClick:
                                                              function () {
                                                                return l(t);
                                                              },
                                                          },
                                                          {
                                                            children:
                                                              null == t
                                                                ? void 0
                                                                : t.orderName,
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(yi, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.customername) ||
                                                          "-",
                                                      }),
                                                      (0, e.jsx)(yi, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.orderDate) ||
                                                          "-",
                                                      }),
                                                      (0, e.jsxs)(
                                                        yi,
                                                        HO(
                                                          { align: "center" },
                                                          {
                                                            children: [
                                                              C,
                                                              " ",
                                                              (null == t
                                                                ? void 0
                                                                : t.subtotalprice.toFixed(
                                                                    2
                                                                  )) || "0.00",
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        yi,
                                                        HO(
                                                          { align: "center" },
                                                          {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.status) ||
                                                              "0",
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsxs)(
                                                        yi,
                                                        HO(
                                                          {
                                                            align: "center",
                                                            sx: {
                                                              display: "flex",
                                                              justifyContent:
                                                                "center",
                                                            },
                                                          },
                                                          {
                                                            children: [
                                                              (null == k
                                                                ? void 0
                                                                : k.CustomerInvoice) &&
                                                                (0, e.jsx)(
                                                                  vp,
                                                                  HO(
                                                                    {
                                                                      disabled:
                                                                        "open" !==
                                                                        (null ==
                                                                        t
                                                                          ? void 0
                                                                          : t.status),
                                                                      onClick:
                                                                        function () {
                                                                          S(t);
                                                                        },
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          FO,
                                                                          {
                                                                            sx: {
                                                                              cursor:
                                                                                "pointer",
                                                                            },
                                                                          }
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              (0, e.jsx)(
                                                                Th,
                                                                HO(
                                                                  {
                                                                    loading:
                                                                      h === n &&
                                                                      f,
                                                                    size: "large",
                                                                  },
                                                                  {
                                                                    children:
                                                                      f || b
                                                                        ? h ===
                                                                            n &&
                                                                          b
                                                                          ? (0,
                                                                            e.jsx)(
                                                                              dv,
                                                                              {}
                                                                            )
                                                                          : (0,
                                                                            e.jsx)(
                                                                              Mb,
                                                                              {
                                                                                sx:
                                                                                  h ===
                                                                                  n
                                                                                    ? Eo
                                                                                    : Do,
                                                                              }
                                                                            )
                                                                        : (0,
                                                                          e.jsx)(
                                                                            Mb,
                                                                            {
                                                                              sx: Do,
                                                                              onClick:
                                                                                function () {
                                                                                  p(
                                                                                    t,
                                                                                    n
                                                                                  );
                                                                                },
                                                                            }
                                                                          ),
                                                                  }
                                                                )
                                                              ),
                                                              (0, e.jsx)(
                                                                vp,
                                                                HO(
                                                                  {
                                                                    onClick:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        m(
                                                                          e,
                                                                          t,
                                                                          n
                                                                        );
                                                                      },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsx)(
                                                                        uv,
                                                                        {
                                                                          sx: {
                                                                            cursor:
                                                                              "pointer",
                                                                            color:
                                                                              "black",
                                                                          },
                                                                        }
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                              (0, e.jsx)(
                                                                Zl,
                                                                HO(
                                                                  {
                                                                    open: Boolean(
                                                                      _
                                                                    ),
                                                                    anchorEl: _,
                                                                    onClose:
                                                                      function () {
                                                                        y(null),
                                                                          v(!1);
                                                                      },
                                                                    anchorOrigin:
                                                                      {
                                                                        vertical:
                                                                          "bottom",
                                                                        horizontal:
                                                                          "left",
                                                                      },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "div",
                                                                        HO(
                                                                          {
                                                                            className:
                                                                              "ST_DO_DeleteConfirmPopup",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Wa,
                                                                                  HO(
                                                                                    {
                                                                                      pb: 2,
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        d(
                                                                                          "delete_confirmation_text"
                                                                                        ),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                                (0,
                                                                                e.jsxs)(
                                                                                  "div",
                                                                                  HO(
                                                                                    {
                                                                                      className:
                                                                                        "ST_DO_TextRight",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            Th,
                                                                                            HO(
                                                                                              {
                                                                                                loading:
                                                                                                  g,
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  g
                                                                                                    ? null
                                                                                                    : (0,
                                                                                                      e.jsx)(
                                                                                                        dv,
                                                                                                        {
                                                                                                          sx: {
                                                                                                            color:
                                                                                                              "green",
                                                                                                            paddingRight:
                                                                                                              "10px",
                                                                                                            cursor:
                                                                                                              "pointer",
                                                                                                          },
                                                                                                          onClick:
                                                                                                            function () {
                                                                                                              x();
                                                                                                            },
                                                                                                        }
                                                                                                      ),
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            pv,
                                                                                            {
                                                                                              sx: {
                                                                                                color:
                                                                                                  "red",
                                                                                                cursor:
                                                                                                  "pointer",
                                                                                              },
                                                                                              onClick:
                                                                                                function () {
                                                                                                  y(
                                                                                                    null
                                                                                                  ),
                                                                                                    v(
                                                                                                      !1
                                                                                                    );
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ],
                                                                                    }
                                                                                  )
                                                                                ),
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  },
                                                  n
                                                )
                                              : null;
                                          })
                                      : (0, e.jsx)(hi, {
                                          children: (0, e.jsxs)(
                                            yi,
                                            HO(
                                              { align: "center", colSpan: 6 },
                                              {
                                                children: [
                                                  d("no_draft_to_show"),
                                                  ".",
                                                ],
                                              }
                                            )
                                          ),
                                        }),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                Av,
                HO(
                  {
                    open: a,
                    maxWidth: "xl",
                    fullWidth: !0,
                    onClose: function () {
                      return i(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      ln,
                      HO(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              La,
                              HO(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      HO(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            Wa,
                                            HO(
                                              {
                                                variant: "h6",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children: d(
                                                  "yourSalesDraft_tableTitle"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      HO(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(pv, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              i(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            u.length > 0
                              ? (0, e.jsxs)(
                                  Fv,
                                  HO(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: [
                                        c
                                          ? (0, e.jsx)(ln, {
                                              children: (0, e.jsxs)(
                                                La,
                                                HO(
                                                  { container: !0, spacing: 2 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        La,
                                                        HO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              HO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "draftOrder_DraftId"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    null == c
                                                                      ? void 0
                                                                      : c.id,
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        HO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              HO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "draftOrder_SubTotal"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    C,
                                                                    " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.subtotal_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        HO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              HO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "draftOrder_ShippingCost"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    C,
                                                                    " ",
                                                                    (null ===
                                                                      (t =
                                                                        null ==
                                                                        c
                                                                          ? void 0
                                                                          : c.shipping_line) ||
                                                                    void 0 === t
                                                                      ? void 0
                                                                      : t.price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        HO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              HO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "draftOrder_Tax"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    C,
                                                                    " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.total_tax) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        HO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              HO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "draftOrder_TotalPrice"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    C,
                                                                    " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.total_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        HO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              HO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            d(
                                                                              "draftOrder_Note"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.note) ||
                                                                      "-",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            })
                                          : null,
                                        (0, e.jsx)(
                                          Ga,
                                          HO(
                                            {
                                              sx: HO(HO({ mt: 1 }, jo), {
                                                borderTop: "1px solid #dadada",
                                              }),
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                ei,
                                                HO(
                                                  { stickyHeader: !0 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(si, {
                                                        children: (0, e.jsx)(
                                                          hi,
                                                          {
                                                            children: o.map(
                                                              function (t, n) {
                                                                return (0,
                                                                e.jsx)(
                                                                  yi,
                                                                  HO(
                                                                    { sx: Mo },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          "b",
                                                                          {
                                                                            children:
                                                                              t.label,
                                                                          }
                                                                        ),
                                                                    }
                                                                  ),
                                                                  n
                                                                );
                                                              }
                                                            ),
                                                          }
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Pi,
                                                        HO(
                                                          {
                                                            className:
                                                              "ST_SO_Thead",
                                                          },
                                                          {
                                                            children: u.map(
                                                              function (t, n) {
                                                                return (0,
                                                                e.jsxs)(
                                                                  hi,
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        HO(
                                                                          {
                                                                            component:
                                                                              "th",
                                                                            scope:
                                                                              "row",
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.Image
                                                                                ? (0,
                                                                                  e.jsx)(
                                                                                    ln,
                                                                                    {
                                                                                      component:
                                                                                        "img",
                                                                                      sx: Ro,
                                                                                      src: t.Image,
                                                                                    }
                                                                                  )
                                                                                : (0,
                                                                                  e.jsx)(
                                                                                    hO.Z,
                                                                                    {
                                                                                      sx: {
                                                                                        height: 50,
                                                                                        width: 50,
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        HO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "20%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.Title ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.size ||
                                                                            "-",
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.quantity,
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            [
                                                                              C,
                                                                              " ",
                                                                              t.ItemPrice.toFixed(
                                                                                2
                                                                              ) ||
                                                                                "0.00",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.fulfillmentStatus ||
                                                                            "-",
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            [
                                                                              C,
                                                                              " ",
                                                                              t.quantity.toFixed(
                                                                                2
                                                                              ) *
                                                                                t.ItemPrice.toFixed(
                                                                                  2
                                                                                ) ||
                                                                                "0.00",
                                                                            ],
                                                                        }
                                                                      ),
                                                                    ],
                                                                  },
                                                                  n
                                                                );
                                                              }
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                )
                              : (0, e.jsx)(Fv, {
                                  children: d("noDraftOrderProducts"),
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        WO = function () {
          return (
            (WO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            WO.apply(this, arguments)
          );
        },
        $O = function () {
          var n = (function () {
              var e,
                n,
                r,
                o = this,
                a = g(),
                i = X().t,
                s = z.getState().salesRepData.loggedInRepDetails.shopCurrency,
                l = [
                  { label: i("refundOrders_column1") },
                  { label: i("refundOrders_column2") },
                  { label: i("refundOrders_column3") },
                  { label: i("refundOrders_column5") + "(" + s + ")" },
                  { label: i("refundOrders_column6") + "(" + s + ")" },
                  { label: i("refundOrders_column8") + "(" + s + ")" },
                  { label: i("refundOrders_column9") },
                  { label: i("refundOrders_column10") },
                ],
                c = [
                  { label: i("refundOrderNumber_column1") },
                  { label: i("refundOrderNumber_column3") },
                  { label: i("refundOrderNumber_column4") + "(" + s + ")" },
                  { label: i("refundOrderNumber_column5") + "(" + s + ")" },
                ],
                u =
                  null !==
                    (r =
                      null ===
                        (n =
                          null === (e = z.getState().salesRepData) ||
                          void 0 === e
                            ? void 0
                            : e.ordersData) || void 0 === n
                        ? void 0
                        : n.allRefundOrdersDetails) && void 0 !== r
                    ? r
                    : [],
                d = (0, t.useState)([]),
                p = d[0],
                m = d[1],
                h = (0, t.useState)(!1),
                f = h[0],
                v = h[1];
              return {
                RefundOrdersHeaderNames: l,
                refundOrderArray: u,
                getDateFormat: function (e) {
                  return e.includes("-")
                    ? "-"
                    : new Date(
                        parseInt(e.replace("/Date(", ""))
                      ).toLocaleDateString();
                },
                RefundOrdersProductHeaderNames: c,
                refundOrderProductArray: p,
                openRefundProductDataDialog: f,
                setRefundDraftProductDataDialog: v,
                getRefundOrderProducts: function (e) {
                  return (
                    (t = o),
                    (n = void 0),
                    (i = function () {
                      var t, n;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (r) {
                        switch (r.label) {
                          case 0:
                            return (
                              mf.next(!0),
                              (t = {
                                refundId: e.RefundId,
                                orderId: e.orderId,
                              }),
                              [4, a(Lg(t))]
                            );
                          case 1:
                            return (
                              (n = r.sent()).refunds.refund_line_items &&
                                (v(!0),
                                m(n.refunds.refund_line_items),
                                mf.next(!1)),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((r = void 0) || (r = Promise))(function (e, o) {
                      function a(e) {
                        try {
                          l(i.next(e));
                        } catch (e) {
                          o(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(i.throw(e));
                        } catch (e) {
                          o(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof r
                              ? n
                              : new r(function (e) {
                                  e(n);
                                })).then(a, s);
                      }
                      l((i = i.apply(t, n || [])).next());
                    })
                  );
                  var t, n, r, i;
                },
                t: i,
                shopCurrency: s,
              };
            })(),
            r = n.RefundOrdersHeaderNames,
            o = n.refundOrderArray,
            a = n.getDateFormat,
            i = n.RefundOrdersProductHeaderNames,
            s = n.refundOrderProductArray,
            l = n.openRefundProductDataDialog,
            c = n.setRefundDraftProductDataDialog,
            u = n.getRefundOrderProducts,
            d = n.t,
            p = n.shopCurrency;
          return (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(
                Ga,
                WO(
                  { sx: jo },
                  {
                    children: (0, e.jsxs)(
                      ei,
                      WO(
                        { stickyHeader: !0 },
                        {
                          children: [
                            (0, e.jsx)(si, {
                              children: (0, e.jsx)(hi, {
                                children: r.map(function (t, n) {
                                  return (0,
                                  e.jsx)(yi, WO({ sx: { fontSize: "13px" } }, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.label }) }), n);
                                }),
                              }),
                            }),
                            (0, e.jsx)(
                              Pi,
                              WO(
                                { className: "ST_SO_Thead" },
                                {
                                  children:
                                    o.length > 0
                                      ? o.map(function (t, n) {
                                          return (0, e.jsxs)(
                                            hi,
                                            {
                                              children: [
                                                (0, e.jsx)(yi, {
                                                  children:
                                                    (null == t
                                                      ? void 0
                                                      : t.RefundId) || "-",
                                                }),
                                                (0, e.jsx)(yi, {
                                                  children: a(
                                                    null == t
                                                      ? void 0
                                                      : t.OrderDate
                                                  ),
                                                }),
                                                (0, e.jsx)(
                                                  yi,
                                                  WO(
                                                    {
                                                      sx:
                                                        "refunded" ===
                                                          (null == t
                                                            ? void 0
                                                            : t.OrderStatus) ||
                                                        "partially_refunded" ===
                                                          (null == t
                                                            ? void 0
                                                            : t.OrderStatus)
                                                          ? Io
                                                          : To,
                                                      onClick: function () {
                                                        return u(t);
                                                      },
                                                    },
                                                    {
                                                      children:
                                                        (null == t
                                                          ? void 0
                                                          : t.ShopifyOrderNumber) ||
                                                        "-",
                                                    }
                                                  )
                                                ),
                                                (0, e.jsxs)(yi, {
                                                  children: [
                                                    p + " ",
                                                    " ",
                                                    (null == t
                                                      ? void 0
                                                      : t.Commission.toFixed(
                                                          2
                                                        )) || "0.00",
                                                  ],
                                                }),
                                                (0, e.jsxs)(yi, {
                                                  children: [
                                                    p + " ",
                                                    " ",
                                                    (null == t
                                                      ? void 0
                                                      : t.TeamManagerCommission.toFixed(
                                                          2
                                                        )) || "0.00",
                                                  ],
                                                }),
                                                (0, e.jsxs)(yi, {
                                                  children: [
                                                    p + " ",
                                                    " ",
                                                    (null == t
                                                      ? void 0
                                                      : t.RefundSubTotal.toFixed(
                                                          2
                                                        )) || "0.00",
                                                  ],
                                                }),
                                                (0, e.jsx)(yi, {
                                                  children:
                                                    (null == t
                                                      ? void 0
                                                      : t.OrderStatus) || "-",
                                                }),
                                                (0, e.jsx)(yi, {
                                                  children:
                                                    (null == t
                                                      ? void 0
                                                      : t.OrderType) || "-",
                                                }),
                                              ],
                                            },
                                            n
                                          );
                                        })
                                      : (0, e.jsx)(hi, {
                                          children: (0, e.jsx)(
                                            yi,
                                            WO(
                                              { align: "center", colSpan: 8 },
                                              { children: d("tableDataError") }
                                            )
                                          ),
                                        }),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                Av,
                WO(
                  {
                    open: l,
                    maxWidth: "md",
                    fullWidth: !0,
                    onClose: function () {
                      return c(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      ln,
                      WO(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              La,
                              WO(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      WO(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            Wa,
                                            WO(
                                              { variant: "h6" },
                                              {
                                                children: d(
                                                  "refundOrderNumber_title"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      WO(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(pv, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              c(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            s.length > 0
                              ? (0, e.jsx)(
                                  Fv,
                                  WO(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: (0, e.jsx)(
                                        Ga,
                                        WO(
                                          { sx: WO({ mt: 2 }, jo) },
                                          {
                                            children: (0, e.jsxs)(
                                              ei,
                                              WO(
                                                { stickyHeader: !0 },
                                                {
                                                  children: [
                                                    (0, e.jsx)(si, {
                                                      children: (0, e.jsx)(hi, {
                                                        children: i.map(
                                                          function (t, n) {
                                                            return (0, e.jsx)(
                                                              yi,
                                                              WO(
                                                                { sx: Mo },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children:
                                                                      t.label,
                                                                  }),
                                                                }
                                                              ),
                                                              n
                                                            );
                                                          }
                                                        ),
                                                      }),
                                                    }),
                                                    (0, e.jsx)(
                                                      Pi,
                                                      WO(
                                                        {
                                                          className:
                                                            "ST_SO_Thead",
                                                        },
                                                        {
                                                          children: s.map(
                                                            function (t, n) {
                                                              return (0,
                                                              e.jsxs)(
                                                                hi,
                                                                {
                                                                  children: [
                                                                    (0, e.jsx)(
                                                                      yi,
                                                                      WO(
                                                                        {
                                                                          sx: {
                                                                            width:
                                                                              "25%",
                                                                          },
                                                                        },
                                                                        {
                                                                          children:
                                                                            t
                                                                              .line_item
                                                                              .title ||
                                                                            "-",
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      yi,
                                                                      {
                                                                        children:
                                                                          t
                                                                            .line_item
                                                                            .quantity,
                                                                      }
                                                                    ),
                                                                    (0, e.jsxs)(
                                                                      yi,
                                                                      {
                                                                        children:
                                                                          [
                                                                            p,
                                                                            " ",
                                                                            t
                                                                              .line_item
                                                                              .total_discount ||
                                                                              "0.00",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    (0, e.jsxs)(
                                                                      yi,
                                                                      {
                                                                        children:
                                                                          [
                                                                            p,
                                                                            " ",
                                                                            t.subtotal.toFixed(
                                                                              2
                                                                            ) ||
                                                                              "0.00",
                                                                          ],
                                                                      }
                                                                    ),
                                                                  ],
                                                                },
                                                                n
                                                              );
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                )
                              : (0, e.jsx)(Fv, {
                                  children: d("noRefundOrderProduct"),
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        UO = function () {
          return (
            (UO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            UO.apply(this, arguments)
          );
        },
        KO = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a = this,
                i = X().t,
                s = g(),
                l = z.getState().salesRepData.loggedInRepDetails.shopCurrency,
                c = [
                  { label: i("draftOrder_OrderNumber") },
                  { label: i("draftOrder_CustName") },
                  { label: i("draftOrder_OrderDate") },
                  { label: i("draftOrder_SubTotal") + "(" + l + ")" },
                  { label: i("draftOrder_Status") },
                ],
                u = [
                  { label: i("yourSales_column1") },
                  { label: i("yourSales_column2") },
                  { label: i("variant_title") },
                  { label: "SKU" },
                  { label: i("yourSales_column3") },
                  { label: i("yourSales_column4") + "(" + l + ")" },
                  { label: i("viewProductModelColumn6") + "(" + l + ")" },
                  { label: i("yourSales_column5") },
                  { label: i("yourSales_column6") },
                  { label: i("yourSales_column7") + "(" + l + ")" },
                ],
                d =
                  null !==
                    (o =
                      null ===
                        (r =
                          null ===
                            (n =
                              null === (e = z.getState().salesRepData) ||
                              void 0 === e
                                ? void 0
                                : e.ordersData) || void 0 === n
                            ? void 0
                            : n.AllOrdersCommission) || void 0 === r
                        ? void 0
                        : r.filter(function (e) {
                            return "pending" === e.OrderStatus;
                          })) && void 0 !== o
                    ? o
                    : [],
                p = (0, t.useState)(!1),
                m = p[0],
                h = p[1],
                f = (0, t.useState)(),
                v = f[0],
                b = f[1],
                _ = (0, t.useState)([]),
                y = _[0],
                x = _[1];
              return {
                PendingOrdersHeaderNames: c,
                pendingOrdersArray: d,
                t: i,
                getPendingProductsData: function (e) {
                  return (
                    (t = a),
                    (n = void 0),
                    (o = function () {
                      var t, n;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (r) {
                        switch (r.label) {
                          case 0:
                            return (
                              (t = { order_id: e.OrderId }),
                              mf.next(!0),
                              [4, s(Mg(t))]
                            );
                          case 1:
                            return (
                              (n = r.sent()),
                              h(!0),
                              x(n ? n.ProductDetails : []),
                              b(n.singleOrderDetailsFromShopify),
                              mf.next(!1),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((r = void 0) || (r = Promise))(function (e, a) {
                      function i(e) {
                        try {
                          l(o.next(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(o.throw(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof r
                              ? n
                              : new r(function (e) {
                                  e(n);
                                })).then(i, s);
                      }
                      l((o = o.apply(t, n || [])).next());
                    })
                  );
                  var t, n, r, o;
                },
                openProductDataDialog: m,
                activeClientObj: v,
                pendingProductArray: y,
                setOpenProductDataDialog: h,
                getDateFormat: function (e) {
                  return e.includes("-")
                    ? "-"
                    : new Date(
                        parseInt(e.replace("/Date(", ""))
                      ).toLocaleDateString();
                },
                shopCurrency: l,
                ProductSalesDetailsHeaderNames: u,
              };
            })(),
            r = n.PendingOrdersHeaderNames,
            o = n.pendingOrdersArray,
            a = n.t,
            i = n.getPendingProductsData,
            s = n.openProductDataDialog,
            l = n.activeClientObj,
            c = n.pendingProductArray,
            u = n.setOpenProductDataDialog,
            d = n.getDateFormat,
            p = n.shopCurrency,
            m = n.ProductSalesDetailsHeaderNames;
          return (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(
                Ga,
                UO(
                  { sx: jo },
                  {
                    children: (0, e.jsxs)(
                      ei,
                      UO(
                        { stickyHeader: !0 },
                        {
                          children: [
                            (0, e.jsx)(si, {
                              children: (0, e.jsx)(hi, {
                                children: r.map(function (t, n) {
                                  return (0,
                                  e.jsx)(yi, UO({ sx: { whiteSpace: "nowrap", fontSize: "13px" } }, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.label }) }), n);
                                }),
                              }),
                            }),
                            (0, e.jsx)(
                              Pi,
                              UO(
                                { className: "ST_SO_Thead" },
                                {
                                  children:
                                    o.length > 0
                                      ? o.map(function (t, n) {
                                          return (0, e.jsxs)(
                                            hi,
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  yi,
                                                  UO(
                                                    {
                                                      sx: Io,
                                                      onClick: function () {
                                                        i(t);
                                                      },
                                                    },
                                                    {
                                                      children:
                                                        null == t
                                                          ? void 0
                                                          : t.orderNumber,
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(
                                                  yi,
                                                  UO(
                                                    { sx: { width: "15%" } },
                                                    {
                                                      children:
                                                        (null == t
                                                          ? void 0
                                                          : t.CustomerName) ||
                                                        "-",
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(yi, {
                                                  children:
                                                    (null == t
                                                      ? void 0
                                                      : t.orderDate) || "-",
                                                }),
                                                (0, e.jsxs)(yi, {
                                                  children: [
                                                    p + " ",
                                                    " ",
                                                    (null == t
                                                      ? void 0
                                                      : t.subtotal.toFixed(
                                                          2
                                                        )) || "0",
                                                  ],
                                                }),
                                                (0, e.jsx)(yi, {
                                                  children: "Pending",
                                                }),
                                              ],
                                            },
                                            n
                                          );
                                        })
                                      : (0, e.jsx)(hi, {
                                          children: (0, e.jsxs)(
                                            yi,
                                            UO(
                                              { align: "center", colSpan: 7 },
                                              {
                                                children: [
                                                  a("no_orders_to_show"),
                                                  ".",
                                                ],
                                              }
                                            )
                                          ),
                                        }),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                Av,
                UO(
                  {
                    open: s,
                    maxWidth: "xl",
                    fullWidth: !0,
                    onClose: function () {
                      return u(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      ln,
                      UO(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              La,
                              UO(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      La,
                                      UO(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            Wa,
                                            UO(
                                              {
                                                variant: "h6",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children: a(
                                                  "yourSales_tableTitle"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      La,
                                      UO(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(pv, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              u(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            c.length > 0
                              ? (0, e.jsxs)(
                                  Fv,
                                  UO(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: [
                                        l
                                          ? (0, e.jsx)(ln, {
                                              children: (0, e.jsxs)(
                                                La,
                                                UO(
                                                  { container: !0, spacing: 2 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        La,
                                                        UO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              UO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            a(
                                                                              "yourSales_table1Column1"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    null == l
                                                                      ? void 0
                                                                      : l.order_number,
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        UO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              UO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            a(
                                                                              "yourSales_table1Column4"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    p + " ",
                                                                    (null == l
                                                                      ? void 0
                                                                      : l.subtotal_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        UO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              UO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            a(
                                                                              "yourSales_content3"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    p + " ",
                                                                    (null == l
                                                                      ? void 0
                                                                      : l.shippingCharges.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        UO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              UO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            a(
                                                                              "yourSales_content2"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    p + " ",
                                                                    (null == l
                                                                      ? void 0
                                                                      : l.total_tax) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        UO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              UO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            a(
                                                                              "yourSales_column7"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    p + " ",
                                                                    (null == l
                                                                      ? void 0
                                                                      : l.total_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        UO(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              UO(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            a(
                                                                              "yourSales_content5"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    (null == l
                                                                      ? void 0
                                                                      : l.note) ||
                                                                      "-",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            })
                                          : "",
                                        (0, e.jsx)(
                                          Ga,
                                          UO(
                                            {
                                              sx: UO(UO({ mt: 1 }, jo), {
                                                borderTop: "1px solid #dadada",
                                              }),
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                ei,
                                                UO(
                                                  { stickyHeader: !0 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(si, {
                                                        children: (0, e.jsx)(
                                                          hi,
                                                          {
                                                            children: m.map(
                                                              function (t, n) {
                                                                return (0,
                                                                e.jsx)(
                                                                  yi,
                                                                  UO(
                                                                    { sx: Mo },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          "b",
                                                                          {
                                                                            children:
                                                                              t.label,
                                                                          }
                                                                        ),
                                                                    }
                                                                  ),
                                                                  n
                                                                );
                                                              }
                                                            ),
                                                          }
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Pi,
                                                        UO(
                                                          {
                                                            className:
                                                              "ST_SO_Thead",
                                                          },
                                                          {
                                                            children: c.map(
                                                              function (t, n) {
                                                                return (0,
                                                                e.jsxs)(
                                                                  hi,
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        UO(
                                                                          {
                                                                            component:
                                                                              "th",
                                                                            scope:
                                                                              "row",
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.Image
                                                                                ? (0,
                                                                                  e.jsx)(
                                                                                    ln,
                                                                                    {
                                                                                      component:
                                                                                        "img",
                                                                                      sx: Ro,
                                                                                      src: t.Image,
                                                                                    }
                                                                                  )
                                                                                : (0,
                                                                                  e.jsx)(
                                                                                    vv,
                                                                                    {
                                                                                      sx: {
                                                                                        height: 50,
                                                                                        width: 50,
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        UO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "10%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.Title ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        UO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "10%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.variantTitle ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.SKU ||
                                                                            "-",
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.quantity,
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            [
                                                                              p +
                                                                                " ",
                                                                              t.ItemPrice.toFixed(
                                                                                2
                                                                              ) ||
                                                                                "0.00",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            [
                                                                              p +
                                                                                " ",
                                                                              t.discountedPrice.toFixed(
                                                                                2
                                                                              ) ||
                                                                                "0.00",
                                                                            ],
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        {
                                                                          children:
                                                                            t.trackingNumber ||
                                                                            "-",
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        yi,
                                                                        UO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "9%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              d(
                                                                                t.ShipDate
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        yi,
                                                                        UO(
                                                                          {
                                                                            sx: {
                                                                              width:
                                                                                "9%",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                p +
                                                                                  " ",
                                                                                t.Subtotal.toFixed(
                                                                                  2
                                                                                ) ||
                                                                                  "0.00",
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                    ],
                                                                  },
                                                                  n
                                                                );
                                                              }
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                )
                              : (0, e.jsxs)(Fv, {
                                  children: [a("no_product_details"), "."],
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        GO = function () {
          return (
            (GO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            GO.apply(this, arguments)
          );
        },
        qO = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a,
                i = this,
                s = (0, t.useState)(null),
                l = s[0],
                c = s[1],
                u = Boolean(l),
                d = u ? "simple-popover" : void 0,
                p = Qg("(min-width: 960px)"),
                m = (0, t.useState)("1"),
                h = m[0],
                f = m[1],
                g = X().t,
                v =
                  null !==
                    (e =
                      z.getState().salesRepData.ordersData
                        .allRefundOrdersDetails) && void 0 !== e
                    ? e
                    : [],
                b =
                  null !==
                    (a =
                      null ===
                        (o =
                          null ===
                            (r =
                              null === (n = z.getState().salesRepData) ||
                              void 0 === n
                                ? void 0
                                : n.ordersData) || void 0 === r
                            ? void 0
                            : r.AllOrdersCommission) || void 0 === o
                        ? void 0
                        : o.filter(function (e) {
                            return (
                              "pending" === e.OrderStatus ||
                              "paid" === e.OrderStatus ||
                              "partially_refunded" === e.OrderStatus ||
                              "completed" === e.OrderStatus
                            );
                          })) && void 0 !== a
                    ? a
                    : [],
                _ = AO().getDraftOrder;
              return {
                tabValue: h,
                setTabValue: f,
                handleTabChange: function (e, t) {
                  f(t);
                },
                t: g,
                handleClick: function (e) {
                  c(e.currentTarget);
                },
                handleClose: function () {
                  c(null);
                },
                open: u,
                id: d,
                anchorEl: l,
                ExportOrderCSV: function (e) {
                  return (
                    (t = i),
                    (n = void 0),
                    (o = function () {
                      var t, n, r, o, a;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (i) {
                        switch (i.label) {
                          case 0:
                            switch (((t = ""), (n = {}), e)) {
                              case "PaidOrPendingOrder":
                                return [3, 1];
                              case "DraftOrder":
                                return [3, 2];
                              case "RefundOrder":
                                return [3, 5];
                            }
                            return [3, 6];
                          case 1:
                            return (
                              (n = LO(
                                [
                                  [
                                    "Order No",
                                    "Order Date",
                                    "Customer Name",
                                    "SubTotal",
                                    "Commission",
                                    "Commission Type",
                                    "Order Status",
                                  ].join(","),
                                ],
                                b.map(function (e) {
                                  return [
                                    e.orderNumber,
                                    e.orderDate,
                                    e.CustomerName,
                                    e.subtotal.toFixed(2),
                                    e.commission.toFixed(2),
                                    e.CommissionType,
                                    e.OrderStatus,
                                  ].join(",");
                                }),
                                !0
                              ).join("\n")),
                              (t = "Paid/Pending Order.csv"),
                              [3, 7]
                            );
                          case 2:
                            return z.getState().salesRepData.draftOrderData
                              ? [3, 4]
                              : [4, _()];
                          case 3:
                            i.sent(), (i.label = 4);
                          case 4:
                            return (
                              (r =
                                null !==
                                  (a = z
                                    .getState()
                                    .salesRepData.draftOrderData.filter(
                                      function (e) {
                                        return "open" === e.status;
                                      }
                                    )) && void 0 !== a
                                  ? a
                                  : []),
                              (n = LO(
                                [
                                  [
                                    "Order Number",
                                    "Customer Name\t",
                                    "Order Date",
                                    "Sub Total",
                                    "Status",
                                  ].join(","),
                                ],
                                r.map(function (e) {
                                  return [
                                    e.orderName,
                                    e.customername,
                                    e.orderDate,
                                    e.subtotalprice.toFixed(2),
                                    e.status,
                                  ].join(",");
                                }),
                                !0
                              ).join("\n")),
                              (t = "Draft Order.csv"),
                              [3, 7]
                            );
                          case 5:
                            return (
                              (n = LO(
                                [
                                  [
                                    "Refund Id",
                                    "Order Date",
                                    "Order No",
                                    "Commission",
                                    "Team Manager Commission",
                                    "Refund SubTotal",
                                    "Order Status",
                                    "Order Type",
                                  ].join(","),
                                ],
                                v.map(function (e) {
                                  return [
                                    e.RefundId,
                                    ((t = e.OrderDate),
                                    t.includes("-")
                                      ? "-"
                                      : new Date(
                                          parseInt(t.replace("/Date(", ""))
                                        ).toLocaleDateString()),
                                    e.ShopifyOrderNumber,
                                    e.Commission.toFixed(2),
                                    e.TeamManagerCommission.toFixed(2),
                                    e.RefundSubTotal.toFixed(2),
                                    e.OrderStatus,
                                    e.OrderType,
                                  ].join(",");
                                  var t;
                                }),
                                !0
                              ).join("\n")),
                              (t = "Refund Order.csv"),
                              [3, 7]
                            );
                          case 6:
                            return [2, null];
                          case 7:
                            return (
                              (o = new Blob([n], {
                                type: "text/csv;charset=utf-8;",
                              })),
                              jO().saveAs(o, t),
                              c(null),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((r = void 0) || (r = Promise))(function (e, a) {
                      function i(e) {
                        try {
                          l(o.next(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(o.throw(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof r
                              ? n
                              : new r(function (e) {
                                  e(n);
                                })).then(i, s);
                      }
                      l((o = o.apply(t, n || [])).next());
                    })
                  );
                  var t, n, r, o;
                },
                isDesktop: p,
              };
            })(),
            r = n.tabValue,
            o = n.handleTabChange,
            a = n.t,
            i = n.handleClick,
            s = n.handleClose,
            l = n.open,
            c = n.id,
            u = n.anchorEl,
            d = n.ExportOrderCSV,
            p = n.isDesktop,
            m = zw().ST_DB_Information_Box;
          return (0, e.jsxs)(
            ln,
            GO(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    La,
                    GO(
                      {
                        item: !0,
                        xs: 12,
                        md: 12,
                        sx: GO(GO({}, xo), {
                          justifyContent: p ? "space-between" : "flex-start",
                          flexDirection: p ? "row" : "column",
                        }),
                      },
                      {
                        children: [
                          (0, e.jsx)(
                            La,
                            GO(
                              { item: !0, xs: 6, md: 6 },
                              {
                                children: (0, e.jsx)(
                                  Wa,
                                  GO(
                                    {
                                      variant: p ? "body2" : "body1",
                                      sx: {
                                        fontWeight: "bold",
                                        fontSize: p ? "1.4rem" : "1rem",
                                        mt: p ? 1 : 0,
                                        mb: p ? 0 : 1,
                                      },
                                    },
                                    {
                                      children: a(
                                        "yourSales_SalesOrderDetailsTitle"
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            La,
                            GO(
                              { item: !0, xs: 6, md: 6 },
                              {
                                children: (0, e.jsx)(
                                  Wa,
                                  GO(
                                    { sx: m },
                                    {
                                      children: (0, e.jsx)(
                                        La,
                                        GO(
                                          {
                                            container: !0,
                                            style: GO(GO({}, xo), {
                                              margin: "0px",
                                              flexDirection: p
                                                ? "unset"
                                                : "column",
                                              paddingInlineStart: p
                                                ? "1rem"
                                                : "0.7rem",
                                              lineHeight: p ? "3rem" : "1.5rem",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              La,
                                              GO(
                                                {
                                                  container: !0,
                                                  style: GO(GO({}, xo), {
                                                    margin: "0px",
                                                    flexDirection: p
                                                      ? "unset"
                                                      : "column",
                                                    paddingInlineStart: p
                                                      ? ""
                                                      : "0px",
                                                  }),
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsxs)(
                                                      La,
                                                      GO(
                                                        {
                                                          item: !0,
                                                          style: GO(
                                                            GO({}, xo),
                                                            {
                                                              fontSize: p
                                                                ? "15px"
                                                                : "14px",
                                                              marginRight:
                                                                "20px",
                                                              marginTop: p
                                                                ? "0rem"
                                                                : "0.5rem",
                                                            }
                                                          ),
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              "span",
                                                              GO(
                                                                {
                                                                  className:
                                                                    "ST_DB_InformationText",
                                                                },
                                                                { children: IP }
                                                              )
                                                            ),
                                                            " ",
                                                            (0, e.jsx)(
                                                              "span",
                                                              GO(
                                                                {
                                                                  style: {
                                                                    fontSize: p
                                                                      ? "15px"
                                                                      : "14px",
                                                                    marginTop:
                                                                      "0.25rem",
                                                                  },
                                                                },
                                                                {
                                                                  children: a(
                                                                    "dashbord_informationMsg"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                    p
                                                      ? (0, e.jsx)(
                                                          La,
                                                          GO(
                                                            {
                                                              item: !0,
                                                              sx: {
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                marginRight:
                                                                  "1rem",
                                                              },
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(La, {
                                                                sx: {
                                                                  borderRight:
                                                                    "1px solid #98C6CD",
                                                                  height:
                                                                    "100%",
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        )
                                                      : "",
                                                    (0, e.jsx)(
                                                      La,
                                                      GO(
                                                        {
                                                          item: !0,
                                                          component: "li",
                                                          className:
                                                            "ST_DB_DashboardMsg",
                                                        },
                                                        {
                                                          children: a(
                                                            "dashboard_BannerMsg"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      La,
                                                      GO(
                                                        {
                                                          item: !0,
                                                          component: "li",
                                                          className:
                                                            "ST_DB_DashboardMsg",
                                                          sx: {
                                                            marginBottom: p
                                                              ? "0rem"
                                                              : "0.6rem",
                                                          },
                                                        },
                                                        {
                                                          children: a(
                                                            "dashboard_Information_Message"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            La,
                            GO(
                              { item: !0, xs: 6, md: 6, mt: 1 },
                              {
                                children: [
                                  (0, e.jsx)(
                                    vp,
                                    GO(
                                      {
                                        className: "ST_DO_ExportCsv",
                                        "aria-describedby": c,
                                        variant: "contained",
                                        onClick: i,
                                      },
                                      { children: "Export CSV" }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    Zl,
                                    GO(
                                      {
                                        id: c,
                                        open: l,
                                        anchorEl: u,
                                        onClose: s,
                                        anchorOrigin: {
                                          vertical: "bottom",
                                          horizontal: "left",
                                        },
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            ob,
                                            GO(
                                              {
                                                onClick: function () {
                                                  return d(
                                                    "PaidOrPendingOrder"
                                                  );
                                                },
                                              },
                                              { children: "Paid/Pending Order" }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            ob,
                                            GO(
                                              {
                                                onClick: function () {
                                                  return d("DraftOrder");
                                                },
                                              },
                                              { children: "Draft Order" }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            ob,
                                            GO(
                                              {
                                                onClick: function () {
                                                  return d("RefundOrder");
                                                },
                                              },
                                              { children: "Refund Order" }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Wa,
                    GO(
                      { variant: "subtitle1", mb: 2 },
                      { children: a("yourSales_title") }
                    )
                  ),
                  (0, e.jsx)(
                    ln,
                    GO(
                      { sx: { width: "100%", typography: "body1" } },
                      {
                        children: (0, e.jsxs)(
                          bO,
                          GO(
                            { value: r },
                            {
                              children: [
                                (0, e.jsx)(
                                  ln,
                                  GO(
                                    {
                                      sx: {
                                        borderBottom: 1,
                                        borderColor: "divider",
                                      },
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        kO,
                                        GO(
                                          { onChange: o },
                                          {
                                            children: [
                                              (0, e.jsx)(ya, {
                                                label: a(
                                                  "yourSales_tabHeading1"
                                                ),
                                                value: "1",
                                                className: "ST_SOD_Tab_Style",
                                              }),
                                              (0, e.jsx)(ya, {
                                                label: a(
                                                  "yourSales_tabHeading4"
                                                ),
                                                value: "2",
                                                className: "ST_SOD_Tab_Style",
                                              }),
                                              (0, e.jsx)(ya, {
                                                label: a(
                                                  "yourSales_tabHeading2"
                                                ),
                                                value: "3",
                                                className: "ST_SOD_Tab_Style",
                                              }),
                                              (0, e.jsx)(ya, {
                                                label: a(
                                                  "yourSales_tabHeading3"
                                                ),
                                                value: "4",
                                                className: "ST_SOD_Tab_Style",
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  EO,
                                  GO(
                                    { value: r },
                                    {
                                      children:
                                        "1" == r
                                          ? (0, e.jsx)(ZO, {})
                                          : "2" == r
                                          ? (0, e.jsx)(KO, {})
                                          : "3" == r
                                          ? (0, e.jsx)(VO, {})
                                          : (0, e.jsx)($O, {}),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        YO = o(2908);
      const JO = [
          "className",
          "component",
          "disableGutters",
          "fixed",
          "maxWidth",
          "classes",
        ],
        QO = (0, Pp.Z)(),
        XO = Lp("div", {
          name: "MuiContainer",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`maxWidth${(0, YO.Z)(String(n.maxWidth))}`],
              n.fixed && t.fixed,
              n.disableGutters && t.disableGutters,
            ];
          },
        }),
        eI = (e) =>
          (0, zp.Z)({ props: e, name: "MuiContainer", defaultTheme: QO }),
        tI = (function (n = {}) {
          const {
              createStyledComponent: r = XO,
              useThemeProps: o = eI,
              componentName: a = "MuiContainer",
            } = n,
            i = r(
              ({ theme: e, ownerState: t }) =>
                (0, d.Z)(
                  {
                    width: "100%",
                    marginLeft: "auto",
                    boxSizing: "border-box",
                    marginRight: "auto",
                    display: "block",
                  },
                  !t.disableGutters && {
                    paddingLeft: e.spacing(2),
                    paddingRight: e.spacing(2),
                    [e.breakpoints.up("sm")]: {
                      paddingLeft: e.spacing(3),
                      paddingRight: e.spacing(3),
                    },
                  }
                ),
              ({ theme: e, ownerState: t }) =>
                t.fixed &&
                Object.keys(e.breakpoints.values).reduce((t, n) => {
                  const r = n,
                    o = e.breakpoints.values[r];
                  return (
                    0 !== o &&
                      (t[e.breakpoints.up(r)] = {
                        maxWidth: `${o}${e.breakpoints.unit}`,
                      }),
                    t
                  );
                }, {}),
              ({ theme: e, ownerState: t }) =>
                (0, d.Z)(
                  {},
                  "xs" === t.maxWidth && {
                    [e.breakpoints.up("xs")]: {
                      maxWidth: Math.max(e.breakpoints.values.xs, 444),
                    },
                  },
                  t.maxWidth &&
                    "xs" !== t.maxWidth && {
                      [e.breakpoints.up(t.maxWidth)]: {
                        maxWidth: `${e.breakpoints.values[t.maxWidth]}${
                          e.breakpoints.unit
                        }`,
                      },
                    }
                )
            );
          return t.forwardRef(function (t, n) {
            const r = o(t),
              {
                className: s,
                component: l = "div",
                disableGutters: c = !1,
                fixed: u = !1,
                maxWidth: p = "lg",
              } = r,
              m = (0, jt.Z)(r, JO),
              h = (0, d.Z)({}, r, {
                component: l,
                disableGutters: c,
                fixed: u,
                maxWidth: p,
              }),
              f = ((e, t) => {
                const {
                    classes: n,
                    fixed: r,
                    disableGutters: o,
                    maxWidth: a,
                  } = e,
                  i = {
                    root: [
                      "root",
                      a && `maxWidth${(0, YO.Z)(String(a))}`,
                      r && "fixed",
                      o && "disableGutters",
                    ],
                  };
                return (0, Nt.Z)(i, (e) => (0, Zt.ZP)(t, e), n);
              })(h, a);
            return (0,
            e.jsx)(i, (0, d.Z)({ as: l, ownerState: h, className: qt(f.root, s), ref: n }, m));
          });
        })({
          createStyledComponent: (0, Lt.ZP)("div", {
            name: "MuiContainer",
            slot: "Root",
            overridesResolver: (e, t) => {
              const { ownerState: n } = e;
              return [
                t.root,
                t[`maxWidth${(0, Fn.Z)(String(n.maxWidth))}`],
                n.fixed && t.fixed,
                n.disableGutters && t.disableGutters,
              ];
            },
          }),
          useThemeProps: (e) => (0, zt.Z)({ props: e, name: "MuiContainer" }),
        });
      var nI = tI,
        rI = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M15.39 14.56C13.71 13.7 11.53 13 9 13s-4.71.7-6.39 1.56C1.61 15.07 1 16.1 1 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m11-3V6h-2v3h-3v2h3v3h2v-3h3V9z",
          }),
          "PersonAddAltSharp"
        ),
        oI = function () {
          return (
            (oI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            oI.apply(this, arguments)
          );
        },
        aI = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        iI = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        sI = function () {
          return (
            (sI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            sI.apply(this, arguments)
          );
        },
        lI = function () {
          var n = X().t,
            r = (function () {
              var n,
                r,
                o = y(function (e) {
                  return e.salesRepData;
                }),
                a = g(),
                i = X().t,
                s = (0, t.useState)(),
                l = s[0],
                c = s[1],
                u =
                  null === (n = null == o ? void 0 : o.baseData) || void 0 === n
                    ? void 0
                    : n.teammemberdetails,
                d = u.map(function (e) {
                  return e.Name;
                }),
                p = z.getState().salesRepData.loggedInRepDetails.shopCurrency,
                m = (0, t.useState)(""),
                h = m[0],
                f = m[1],
                v = (0, t.useState)(!1),
                b = v[0],
                _ = v[1],
                x = (0, t.useState)(!1),
                C = x[0],
                S = x[1],
                k = (0, t.useState)(!1),
                w = k[0],
                P = k[1],
                O = (0, t.useState)(!1),
                I = O[0],
                T = O[1],
                M = (0, t.useState)(!1),
                E = M[0],
                D = M[1],
                j = (0, t.useState)({
                  repFirstName: "",
                  repEmail: "",
                  repLastName: "",
                }),
                R = j[0],
                N = j[1],
                A = (0, t.useState)({ firstName: !1, email: !1, lastName: !1 }),
                L = A[0],
                B = A[1],
                Z = lv,
                F = /^[a-zA-Z\s]*$/,
                H =
                  null === (r = null == o ? void 0 : o.loggedInRepDetails) ||
                  void 0 === r
                    ? void 0
                    : r.shopName,
                V =
                  void 0 !== o.baseData.SingleSalesRep &&
                  null !== o.baseData.SingleSalesRep &&
                  void 0 !== o.baseData.SingleSalesRep.SalesRepAffiliateUrl &&
                  null !== o.baseData.SingleSalesRep.SalesRepAffiliateUrl
                    ? o.baseData.SingleSalesRep.SalesRepAffiliateUrl.split(
                        "?"
                      )[1]
                    : "ambassador=",
                W =
                  "https://" +
                  H +
                  "/pages/sales-representative-sign-up?manager=" +
                  new URLSearchParams(V).get("ambassador");
              mf.subscribe(function (e) {
                e !== I && T(e);
              });
              var $ = [
                { id: "order_number", headerName: i("team_column1") },
                { id: "order_date", headerName: i("team_column2") },
                { id: "customer_name", headerName: i("team_column3") },
                { id: "sub_total", headerName: i("team_column5") },
                { id: "sales_rep_commission", headerName: i("team_column6") },
                {
                  id: "team_manager_commission",
                  headerName: i("team_column7"),
                },
                { id: "commission_type", headerName: i("team_column8") },
              ];
              return {
                saveRepInvite: !!(
                  KP(R.repFirstName, R.repEmail) ||
                  !R.repEmail.match(Z) ||
                  R.repEmail.indexOf(" ") >= 0
                ),
                shopCurrency: p,
                rep: h,
                openRepDropDown: function (e) {
                  return aI(this, void 0, void 0, function () {
                    var t, n, r, o, a;
                    return iI(this, function (i) {
                      switch (i.label) {
                        case 0:
                          return (
                            f(e.target.value),
                            "None" === e.target.value ||
                            "" === e.target.value ||
                            null === e.target.value
                              ? [3, 2]
                              : ((t = u.filter(function (t) {
                                  return t.Name === e.target.value;
                                })),
                                (n = {
                                  repName: e.target.value,
                                  repId: t[0].Id,
                                }),
                                mf.next(!0),
                                [4, Xf(n)])
                          );
                        case 1:
                          return (
                            null != (r = i.sent()) &&
                              ((o = r.AllOrdersCommission),
                              (a = o.map(function (e) {
                                var t = {};
                                return (
                                  Object.assign(t, {
                                    orderNumber: e.orderNumber,
                                    orderDate: e.orderDate,
                                    orderName: e.orderName,
                                    CustomerName: e.CustomerName,
                                    subtotal: e.subtotal,
                                    commission: e.commission,
                                    TeamManagerCommission:
                                      e.TeamManagerCommission,
                                    CommissionType: e.CommissionType,
                                  }),
                                  t
                                );
                              })),
                              c(a)),
                            [3, 3]
                          );
                        case 2:
                          f(e.target.value), c(null), (i.label = 3);
                        case 3:
                          return mf.next(!1), [2];
                      }
                    });
                  });
                },
                sendRepInvite: function () {
                  return aI(this, void 0, void 0, function () {
                    var e;
                    return iI(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return (
                            _(!0),
                            B(oI(oI({}, L), { email: !1 })),
                            KP(R.repFirstName, R.repEmail)
                              ? [3, 2]
                              : [
                                  4,
                                  Qf({
                                    firstName: R.repFirstName,
                                    lastName: R.repLastName,
                                    email: R.repEmail,
                                  }),
                                ]
                          );
                        case 1:
                          return (
                            !0 === (e = t.sent()) ||
                            (void 0 !== e.StatusCode &&
                              null !== e.StatusCode &&
                              200 === e.StatusCode)
                              ? (a(_g()),
                                _(!1),
                                S(!0),
                                N({
                                  repFirstName: "",
                                  repEmail: "",
                                  repLastName: "",
                                }))
                              : (_(!1), P(!0)),
                            setTimeout(function () {
                              D(!1),
                                S(!1),
                                P(!1),
                                N({
                                  repFirstName: "",
                                  repEmail: "",
                                  repLastName: "",
                                });
                            }, 3e3),
                            [3, 3]
                          );
                        case 2:
                          B(oI(oI({}, L), { email: !0 })), (t.label = 3);
                        case 3:
                          return [2];
                      }
                    });
                  });
                },
                createHeaders: function (t) {
                  return t.map(function (t, n) {
                    return (0,
                    e.jsxs)(yi, oI({ align: "center" }, { children: [" ", (0, e.jsx)("b", { children: t.headerName }), " "] }), n);
                  });
                },
                orderRows: l,
                orderTableColumns: $,
                showRepForm: function () {
                  return D(!0);
                },
                newRepForm: R,
                inputChange: function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    o = n.value;
                  "repEmail" === e.target.name
                    ? e.target.value.match(Z)
                      ? B(oI(oI({}, L), { email: !1 }))
                      : B(oI(oI({}, L), { email: !0 }))
                    : "repFirstName" === e.target.name &&
                      (F.test(e.target.value)
                        ? B(oI(oI({}, L), { firstName: !1 }))
                        : B(oI(oI({}, L), { firstName: !0 }))),
                    N(oI(oI({}, R), (((t = {})[r] = o), t)));
                },
                signupUrl: W,
                Names: d,
                loadingBtn: b,
                isError: L,
                successMsg: C,
                failureMsg: w,
                addRep: E,
                setAddRep: D,
              };
            })(),
            o = r.saveRepInvite,
            a = r.shopCurrency,
            i = r.rep,
            s = r.openRepDropDown,
            l = r.sendRepInvite,
            c = r.createHeaders,
            u = r.orderRows,
            d = r.orderTableColumns,
            p = r.showRepForm,
            m = r.newRepForm,
            h = r.inputChange,
            f = (r.signupUrl, r.Names),
            v = r.loadingBtn,
            b = r.isError,
            _ = r.successMsg,
            x = r.failureMsg,
            C = r.addRep,
            S = r.setAddRep;
          return (0, e.jsx)(nI, {
            children: (0, e.jsxs)(
              o_,
              sI(
                { className: "ST_MC_Dialog_Box" },
                {
                  children: [
                    (0, e.jsxs)(
                      La,
                      sI(
                        { container: !0, spacing: 2 },
                        {
                          children: [
                            (0, e.jsx)(
                              La,
                              sI(
                                { item: !0, xs: 6, md: 8, mb: 3 },
                                {
                                  children: (0, e.jsx)(
                                    Wa,
                                    sI(
                                      { variant: "h6", mb: 3, mt: 0.5 },
                                      { children: n("team_title2") }
                                    )
                                  ),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              La,
                              sI(
                                {
                                  item: !0,
                                  xs: 6,
                                  md: 4,
                                  sx: { textAlign: "right" },
                                },
                                {
                                  children: (0, e.jsx)(
                                    vp,
                                    sI(
                                      {
                                        endIcon: (0, e.jsx)(rI, {}),
                                        variant: "contained",
                                        sx: { textTransform: "capitalize" },
                                        onClick: function () {
                                          return p();
                                        },
                                      },
                                      { children: n("addSalesRep_txt1") }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    (0, e.jsxs)(
                      La,
                      sI(
                        { item: !0, xs: 6, md: 8, mb: 3 },
                        {
                          children: [
                            (0, e.jsx)("br", {}),
                            (0, e.jsxs)(
                              $u,
                              sI(
                                { fullWidth: !0, size: "small" },
                                {
                                  children: [
                                    (0, e.jsx)(Bu, {
                                      children: n("team_content5"),
                                    }),
                                    (0, e.jsxs)(
                                      Kd,
                                      sI(
                                        {
                                          labelId: "select-name",
                                          label: n("team_content5"),
                                          value: i,
                                          onChange: s,
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              ob,
                                              sI(
                                                { value: "" },
                                                {
                                                  children: (0, e.jsx)("em", {
                                                    children: "None",
                                                  }),
                                                }
                                              )
                                            ),
                                            f.map(function (t, n) {
                                              return (0,
                                              e.jsx)(ob, sI({ value: t }, { children: t }), n);
                                            }),
                                          ],
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    (0, e.jsx)(
                      Ga,
                      sI(
                        { component: io },
                        {
                          children: (0, e.jsxs)(
                            ei,
                            sI(
                              { stickyHeader: !0 },
                              {
                                children: [
                                  (0, e.jsx)(si, {
                                    children: (0, e.jsx)(
                                      hi,
                                      sI(
                                        { className: "stickyHeaderRow" },
                                        { children: c(d) }
                                      )
                                    ),
                                  }),
                                  (0, e.jsx)(Pi, {
                                    children:
                                      null != u && u.length > 0
                                        ? u.map(function (t, n) {
                                            return (0,
                                            e.jsxs)(hi, { children: [(0, e.jsx)(yi, sI({ align: "center" }, { children: null == t ? void 0 : t.orderNumber })), (0, e.jsx)(yi, sI({ align: "center" }, { children: null == t ? void 0 : t.orderDate })), (0, e.jsx)(yi, sI({ align: "center" }, { children: null == t ? void 0 : t.CustomerName })), (0, e.jsx)(yi, sI({ align: "center" }, { children: a + " " + (null == t ? void 0 : t.subtotal.toFixed(2)) })), (0, e.jsx)(yi, sI({ align: "center" }, { children: a + " " + (null == t ? void 0 : t.commission.toFixed(2)) })), (0, e.jsx)(yi, sI({ align: "center" }, { children: a + " " + (null == t ? void 0 : t.TeamManagerCommission.toFixed(2)) })), (0, e.jsx)(yi, sI({ align: "center" }, { children: null == t ? void 0 : t.CommissionType }))] }, n);
                                          })
                                        : (0, e.jsx)(hi, {
                                            children: (0, e.jsx)(
                                              yi,
                                              sI(
                                                { align: "center", colSpan: 7 },
                                                {
                                                  children: (0, e.jsx)(Wa, {
                                                    children:
                                                      n("no_orders_to_show"),
                                                  }),
                                                }
                                              )
                                            ),
                                          }),
                                  }),
                                ],
                              }
                            )
                          ),
                        }
                      )
                    ),
                    (0, e.jsx)(
                      Av,
                      sI(
                        {
                          open: C,
                          onClose: function () {
                            return S(!1);
                          },
                          maxWidth: "sm",
                          fullWidth: !0,
                        },
                        {
                          children: (0, e.jsxs)(
                            ln,
                            sI(
                              { className: "ST-Dialog-Box" },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    La,
                                    sI(
                                      { container: !0, mt: 2, pl: 5, pr: 4 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            La,
                                            sI(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  Wa,
                                                  sI(
                                                    { variant: "h6" },
                                                    {
                                                      children:
                                                        n("addSalesRep_txt1"),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            La,
                                            sI(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                              },
                                              {
                                                children: (0, e.jsx)(pv, {
                                                  sx: { cursor: "pointer" },
                                                  onClick: function () {
                                                    S(!1);
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(Fv, {
                                    children: (0, e.jsxs)(
                                      La,
                                      sI(
                                        { container: !0 },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              La,
                                              sI(
                                                {
                                                  item: !0,
                                                  xs: 12,
                                                  md: 12,
                                                  p: 2,
                                                },
                                                {
                                                  children: (0, e.jsx)(Xd, {
                                                    size: "small",
                                                    placeholder: n(
                                                      "team_content1PlaceHolder"
                                                    ),
                                                    label: n("team_content1"),
                                                    value: m.repEmail,
                                                    name: "repEmail",
                                                    onChange: function (e) {
                                                      return h(e);
                                                    },
                                                    error: b.email,
                                                    helperText: b.email
                                                      ? n("team_emailerrorMsg")
                                                      : "",
                                                    required: !0,
                                                    fullWidth: !0,
                                                  }),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(
                                              La,
                                              sI(
                                                {
                                                  item: !0,
                                                  xs: 12,
                                                  md: 12,
                                                  p: 2,
                                                },
                                                {
                                                  children: (0, e.jsx)(Xd, {
                                                    type: "text",
                                                    size: "small",
                                                    placeholder: n(
                                                      "team_content2PlaceHolder"
                                                    ),
                                                    label: n("team_content2"),
                                                    name: "repFirstName",
                                                    value: m.repFirstName,
                                                    onChange: function (e) {
                                                      return h(e);
                                                    },
                                                    error: b.firstName,
                                                    required: !0,
                                                    helperText: b.firstName
                                                      ? n("team_fnameerrorMsg")
                                                      : "",
                                                    fullWidth: !0,
                                                  }),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(
                                              La,
                                              sI(
                                                {
                                                  item: !0,
                                                  xs: 12,
                                                  md: 12,
                                                  p: 2,
                                                },
                                                {
                                                  children: (0, e.jsx)(Xd, {
                                                    type: "text",
                                                    size: "small",
                                                    placeholder: n(
                                                      "team_content3PlaceHolder"
                                                    ),
                                                    label: n("team_content3"),
                                                    value: m.repLastName,
                                                    name: "repLastName",
                                                    onChange: function (e) {
                                                      return h(e);
                                                    },
                                                    fullWidth: !0,
                                                  }),
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                  }),
                                  (0, e.jsxs)(
                                    cO,
                                    sI(
                                      { style: { alignItems: "stretch" } },
                                      {
                                        children: [
                                          (0, e.jsxs)(
                                            La,
                                            sI(
                                              { pr: 4 },
                                              {
                                                children: [
                                                  _
                                                    ? (0, e.jsx)(
                                                        Wa,
                                                        sI(
                                                          {
                                                            variant: "caption",
                                                            display: "block",
                                                            style: {
                                                              color: "green",
                                                            },
                                                            gutterBottom: !0,
                                                          },
                                                          {
                                                            children:
                                                              n(
                                                                "team_successmsg"
                                                              ),
                                                          }
                                                        )
                                                      )
                                                    : (0, e.jsx)(Wa, {
                                                        style: {
                                                          visibility: "hidden",
                                                        },
                                                      }),
                                                  x
                                                    ? (0, e.jsx)(
                                                        Wa,
                                                        sI(
                                                          {
                                                            variant: "caption",
                                                            display: "block",
                                                            style: {
                                                              color: "red",
                                                            },
                                                            gutterBottom: !0,
                                                          },
                                                          {
                                                            children:
                                                              n(
                                                                "team_errorsmsg"
                                                              ),
                                                          }
                                                        )
                                                      )
                                                    : (0, e.jsx)(Wa, {
                                                        style: {
                                                          visibility: "hidden",
                                                        },
                                                      }),
                                                ],
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            La,
                                            sI(
                                              { pr: 4, mb: 2 },
                                              {
                                                children:
                                                  m.repEmail && m.repFirstName
                                                    ? (0, e.jsxs)(
                                                        Th,
                                                        sI(
                                                          {
                                                            style: {
                                                              textTransform:
                                                                "capitalize",
                                                            },
                                                            loading: v,
                                                            disabled: o,
                                                            loadingPosition:
                                                              "end",
                                                            endIcon: (0, e.jsx)(
                                                              rI,
                                                              {}
                                                            ),
                                                            variant:
                                                              "contained",
                                                            onClick:
                                                              function () {
                                                                return l();
                                                              },
                                                          },
                                                          {
                                                            children: [
                                                              " ",
                                                              n(
                                                                v
                                                                  ? "addSalesRep_txt2"
                                                                  : "team_button1"
                                                              ),
                                                            ],
                                                          }
                                                        )
                                                      )
                                                    : (0, e.jsx)(
                                                        vp,
                                                        sI(
                                                          {
                                                            style: {
                                                              textTransform:
                                                                "capitalize",
                                                            },
                                                            variant:
                                                              "contained",
                                                            disabled: !0,
                                                            endIcon: (0, e.jsx)(
                                                              rI,
                                                              {}
                                                            ),
                                                          },
                                                          {
                                                            children:
                                                              n("team_button1"),
                                                          }
                                                        )
                                                      ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        }
                      )
                    ),
                  ],
                }
              )
            ),
          });
        },
        cI = (0, bo.Z)(
          [
            (0, e.jsx)(
              "path",
              {
                d: "M3 8c0 .55.45 1 1 1s1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1H5V2c0-.55-.45-1-1-1s-1 .45-1 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2z",
              },
              "0"
            ),
            (0, e.jsx)("circle", { cx: "13", cy: "14", r: "3" }, "1"),
            (0, e.jsx)(
              "path",
              {
                d: "M21 6h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65h-6.4c.17.3.28.63.28 1 0 1.1-.9 2-2 2H6v1c0 1.1-.9 2-2 2-.37 0-.7-.11-1-.28V20c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5",
              },
              "2"
            ),
          ],
          "AddAPhotoRounded"
        ),
        uI = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5z",
          }),
          "FileUploadOutlined"
        ),
        dI = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z",
          }),
          "Save"
        ),
        pI = function () {
          return (
            (pI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            pI.apply(this, arguments)
          );
        },
        mI = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        hI = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        fI = function () {
          return (
            (fI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            fI.apply(this, arguments)
          );
        },
        gI = function () {
          var n,
            r,
            o = Gv(),
            a =
              (o.copyTextFunction,
              o.copyIconSuccessColor,
              (function () {
                var e,
                  n,
                  r,
                  o = X().t,
                  a = g(),
                  i = y(function (e) {
                    return e.salesRepData;
                  }),
                  s =
                    null === (e = null == i ? void 0 : i.baseData) ||
                    void 0 === e
                      ? void 0
                      : e.SingleSalesRep,
                  l = {
                    isLoading: !1,
                    imageName: "",
                    imagePreview: KP(s.ProfileImagePath)
                      ? ""
                      : s.ProfileImagePath,
                    imageSize: 0,
                  },
                  c = (0, t.useState)(s ? (null == s ? void 0 : s.Bio) : ""),
                  u = c[0],
                  d = c[1],
                  p = (0, t.useState)(u && u.length < 100 ? 100 - u.length : 0),
                  m = p[0],
                  h = p[1],
                  f = i.productsData,
                  v = i.baseData,
                  b =
                    null == v
                      ? void 0
                      : v.CommissionDiscountOn.CommissionDiscountOn,
                  _ =
                    null !== (n = null == v ? void 0 : v.ShopDomainName) &&
                    void 0 !== n
                      ? n
                      : null == v
                      ? void 0
                      : v.ShopName;
                (0, t.useEffect)(
                  function () {
                    (null == f ? void 0 : f.length) > 0 && mf.next(!1);
                  },
                  [f]
                );
                var x = [
                  { id: "product", headerName: o("viewProductModelColumn1") },
                  {
                    id: "product_title",
                    headerName: o("affiliateLink_searchColumn2"),
                  },
                  { id: "price", headerName: o("affiliateLink_searchColumn3") },
                  { id: "commission", headerName: o("affliateOrder_column6") },
                  {
                    id: "affiliate_link",
                    headerName: o("affiliate_product_link"),
                  },
                  {
                    id: "copy_link",
                    headerName: o("affiliateLink_searchColumn7"),
                  },
                  {
                    id: "share_link",
                    headerName: o("affiliateCartProdtableColumn6"),
                  },
                ];
                function C(e, t) {
                  for (var n = 0, r = e; n < r.length; n++) {
                    var o = r[n],
                      a = o.imageId,
                      i = o.src;
                    return a === t ? i : null;
                  }
                }
                function S(e, t) {
                  var n,
                    r =
                      null == v
                        ? void 0
                        : v.CommissionandDiscountPerProductType,
                    o = null == v ? void 0 : v.AffiliateCommissionPerProduct,
                    a = null == v ? void 0 : v.AffiliateCommissionPerRepModel,
                    s =
                      null ===
                        (n = null == i ? void 0 : i.loggedInRepDetails) ||
                      void 0 === n
                        ? void 0
                        : n.customerId.toString();
                  switch (b) {
                    case "ProductType":
                      if (KP(r)) return 0;
                      for (var l = 0, c = r; l < c.length; l++) {
                        var u = c[l],
                          d = u.productType,
                          p = u.AffiliateCommission;
                        if (e.toLowerCase() === d.toLowerCase()) return p;
                      }
                      break;
                    case "Product":
                      if (KP(o)) return 0;
                      for (var m = 0, h = o; m < h.length; m++) {
                        var f = h[m],
                          g = f.variantId,
                          _ = f.Commission;
                        if (t === g) return 100 * _;
                      }
                      break;
                    case "SalesRep":
                      if (KP(a)) return 0;
                      for (var y = 0, x = a; y < x.length; y++) {
                        var C = x[y],
                          S = C.SalesRepId;
                        if (((_ = C.Commission), s === S)) return _;
                      }
                      break;
                    default:
                      return 0;
                  }
                }
                function k(e, t) {
                  var n = KP(v.SingleSalesRep.SalesRepAffiliateUrl)
                    ? "ambassador="
                    : v.SingleSalesRep.SalesRepAffiliateUrl.split("?")[1];
                  return (
                    "https://" +
                      e +
                      "/products/" +
                      t +
                      "/?ambassador=" +
                      new URLSearchParams(n).get("ambassador") || "https://" + e
                  );
                }
                var w = (function (e) {
                    for (var t = [], n = 0, r = e; n < r.length; n++) {
                      var o = r[n],
                        a = o.productTitle,
                        i = o.variants,
                        s = o.productImages,
                        l = o.product_type,
                        c = o.handle,
                        u = k(_, c);
                      if (!(i.length > 0)) return t;
                      for (var d = 0, p = i; d < p.length; d++) {
                        var m = p[d],
                          h = m.variantPrice,
                          f = m.image_id,
                          g = m.variantId,
                          v = m.variantTitle,
                          b = m.sku,
                          y = C(s, f),
                          x = S(l, g) || 0;
                        t.push({
                          src: y,
                          productTitle: a,
                          variantPrice: h,
                          commission: x,
                          handle: c,
                          url: u,
                          variantId: g,
                          variantTitle: v,
                          sku: b,
                        });
                      }
                    }
                    return t;
                  })(f),
                  P = (0, t.useRef)(null),
                  O = (0, t.useState)(""),
                  I = O[0],
                  T = O[1],
                  M = (0, t.useState)(!1),
                  E = M[0],
                  D = M[1],
                  j = (0, t.useState)(!1),
                  R = j[0],
                  N = j[1],
                  A = (0, t.useState)(),
                  L = A[0],
                  B = A[1],
                  Z = (0, t.useState)(!1),
                  F = Z[0],
                  H = Z[1],
                  V = (0, t.useState)(l),
                  W = V[0],
                  $ = V[1],
                  U = (0, t.useState)(o("yourBio_button2")),
                  K = U[0],
                  G = U[1],
                  q = (0, t.useState)(!1),
                  Y = q[0],
                  J = q[1],
                  Q = (0, t.useState)(""),
                  ee = Q[0],
                  te = Q[1],
                  ne = (0, t.useState)(!1),
                  re = ne[0],
                  oe = ne[1],
                  ae = (0, t.useState)(o("yourBio_button3")),
                  ie = ae[0],
                  se = ae[1],
                  le = (0, t.useState)(""),
                  ce = le[0],
                  ue = le[1],
                  de = (0, t.useState)(!1),
                  pe = de[0],
                  me = de[1],
                  he = (0, t.useState)(
                    null == s ? void 0 : s.SalesRepUniqueLink
                  ),
                  fe = he[0],
                  ge = he[1],
                  ve = (0, t.useState)(!0),
                  be = ve[0],
                  _e = ve[1],
                  ye = W.imagePreview;
                (0, t.useEffect)(
                  function () {
                    se(o("yourBio_button3"));
                  },
                  [o]
                );
                var xe =
                    null !== (null == s ? void 0 : s.SalesRepUniqueLink) ||
                    ee.length > 0
                      ? "https://" + _ + "/" + ee
                      : "https://" +
                        _ +
                        "/?" +
                        (null == s
                          ? void 0
                          : s.SalesRepAffiliateUrl.split("?")[1]),
                  Ce =
                    z.getState().salesRepData.loggedInRepDetails.shopCurrency,
                  Se =
                    null === (r = null == i ? void 0 : i.baseData) ||
                    void 0 === r
                      ? void 0
                      : r.CommissionDiscountOn.CommissionDiscountType,
                  ke = (0, t.useState)(w.slice(0, 10)),
                  we = ke[0],
                  Pe = ke[1],
                  Oe = (0, t.useState)(!1),
                  Ie = Oe[0],
                  Te = Oe[1];
                return {
                  isImageInput: R,
                  repProfile: i,
                  saveBtn: be,
                  searchProductTable: function (e) {
                    var t = e.target.value.trim().toLowerCase();
                    Te(!!t);
                    var n = w.filter(function (e) {
                      var n = e.productTitle.toLowerCase(),
                        r = e.variantTitle.toLowerCase();
                      return n.includes(t) || r.includes(t);
                    });
                    Pe(n);
                  },
                  commissionDiscountType: Se,
                  shopCurrency: Ce,
                  products: we,
                  showTable: Ie,
                  shopName: _,
                  productsContent: w,
                  productTableColumns: x,
                  showNewImage: F,
                  imagePreview: ye,
                  saveState: ie,
                  profile: s,
                  setBio: d,
                  uploadInputImage: P,
                  setLinkText: te,
                  setImage: $,
                  image: W,
                  bio: u,
                  uploadImageState: K,
                  linkText: ee,
                  imageLoading: Y,
                  updatedLink: fe,
                  savingLinkBio: pe,
                  helperTextLink: ce,
                  errorLink: re,
                  handleUploadImage: function (e) {
                    var t = e.target.files;
                    return mI(void 0, void 0, void 0, function () {
                      var e;
                      return hI(this, function (n) {
                        return (
                          T(""),
                          D(!1),
                          KP((e = t[0])) ||
                            (e.size < 5e6
                              ? ($(function (e) {
                                  return pI(pI({}, e), { isLoading: !0 });
                                }),
                                B(e),
                                H(!0),
                                $(function (t) {
                                  return pI(pI({}, t), {
                                    imageName: e.name,
                                    imagePreview: URL.createObjectURL(e),
                                    imageSize: e.size,
                                    isLoading: !1,
                                  });
                                }))
                              : (setTimeout(function () {
                                  D(!1);
                                }, 3e3),
                                D(!0),
                                T(o("yourBio_error_image_size")),
                                $(l),
                                (P.current.value = null))),
                          [2]
                        );
                      });
                    });
                  },
                  uploadImage: function () {
                    return mI(void 0, void 0, void 0, function () {
                      var e;
                      return hI(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return (
                              G(o("yourBio_Uploadbtn1")),
                              J(!0),
                              T(""),
                              D(!1),
                              N(!0),
                              !KP(L) &&
                              W.imageSize < 5e6 &&
                              "" !== W.imagePreview
                                ? (e = L)
                                  ? [4, a(Bg(L))]
                                  : [3, 2]
                                : [3, 3]
                            );
                          case 1:
                            (e = t.sent()), (t.label = 2);
                          case 2:
                            return (
                              e
                                ? (G(o("yourBio_Uploadbtn2")),
                                  $(function (e) {
                                    return pI(pI({}, e), { isLoading: !1 });
                                  }),
                                  T(""),
                                  D(!1))
                                : (D(!0),
                                  $(l),
                                  (P.current.value = null),
                                  G(o("yourBio_button2")),
                                  T(o("addCustomer_leadErrrorMsg"))),
                              [3, 4]
                            );
                          case 3:
                            T(o("yourBio_error_image_size")),
                              D(!0),
                              H(!1),
                              $(l),
                              (P.current.value = null),
                              (t.label = 4);
                          case 4:
                            return (
                              setTimeout(function () {
                                D(!1);
                              }, 3e3),
                              H(!1),
                              J(!1),
                              N(!1),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  linkTextValidation: function (e) {
                    te(e.target.value),
                      "" === e.target.value.trim() ||
                      /^[A-Za-z0-9]+$/.test(e.target.value)
                        ? (_e(!1), oe(!1), ue(""))
                        : (_e(!0),
                          oe(!0),
                          ue(o("affiliateLink_input_error_msg")));
                  },
                  bioTextValidation: function (e) {
                    h(100 - e.target.value.length), d(e.target.value), _e(!1);
                  },
                  saveAffiliateInfo: function () {
                    return mI(void 0, void 0, void 0, function () {
                      var e;
                      return hI(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return (
                              me(!0),
                              se(o("yourBio_Savebtn")),
                              [4, a(zg({ uniquelink: ee, bio: u }))]
                            );
                          case 1:
                            return (
                              t.sent(),
                              (e =
                                z.getState().salesRepData.baseData
                                  .SingleSalesRep),
                              ee === e.SalesRepUniqueLink && u === e.Bio
                                ? (se(o("yourBio_button4")),
                                  ge(ee),
                                  setTimeout(function () {
                                    se(o("yourBio_button3")), _e(!1);
                                  }, 2e3))
                                : se(o("yourBio_button3")),
                              me(!1),
                              _e(!0),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  helperImage: I,
                  imageError: E,
                  lazyLoadAffiliateData: function () {
                    var e = w.slice(0, we.length + 10);
                    Pe(e);
                  },
                  contactCardCharLength: m,
                  charMaxLength: 100,
                  productsData: f,
                  salesRepUniqueLink: xe,
                };
              })()),
            i = a.isImageInput,
            s = a.repProfile,
            l = a.saveBtn,
            c = a.shopName,
            u = a.imagePreview,
            d = a.profile,
            p = a.setImage,
            m = a.setLinkText,
            h = a.uploadInputImage,
            f = a.bio,
            v = a.uploadImageState,
            b = (a.linkText, a.imageLoading),
            _ = a.showNewImage,
            x = a.saveState,
            C = (a.updatedLink, a.savingLinkBio),
            S = (a.helperTextLink, a.errorLink, a.handleUploadImage),
            k = a.uploadImage,
            w = (a.linkTextValidation, a.bioTextValidation),
            P = a.saveAffiliateInfo,
            O = a.helperImage,
            I = a.imageError,
            T = a.contactCardCharLength,
            M = a.charMaxLength,
            E = a.productsData,
            D = (a.salesRepUniqueLink, X().t),
            j = {
              borderBottom: "4px solid #4ED8DA",
              width: "95%",
              margin: "0 auto",
              display: "inline-flex",
            },
            R = { marginBottom: "1rem", display: "inline-flex", width: "95%" };
          return (
            (0, t.useEffect)(function () {
              if (
                (0 === (null == E ? void 0 : E.length) && mf.next(!0), !KP(d))
              ) {
                var e = null == d ? void 0 : d.ProfileImagePath;
                p(function (t) {
                  return fI(fI({}, t), { imagePreview: e, isLoading: !1 });
                }),
                  KP(null == d ? void 0 : d.SalesRepUniqueLink)
                    ? m("")
                    : m(null == d ? void 0 : d.SalesRepUniqueLink);
              }
              setTimeout(function () {
                mf.next(!1);
              }, 5e3);
            }, []),
            (0, e.jsx)(e.Fragment, {
              children: s.baseData.select.microsites
                ? (0, e.jsxs)(
                    ln,
                    fI(
                      { className: "ST_Main_Card" },
                      {
                        children: [
                          (0, e.jsxs)(
                            La,
                            fI(
                              { sx: [Lo, R] },
                              {
                                children: [
                                  (0, e.jsx)(
                                    Wa,
                                    fI(
                                      { variant: ov, sx: zo },
                                      {
                                        children: D("affiliateLink_card_Title"),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)("hr", {
                                    className: "ST_CI_Horizontal_Line",
                                  }),
                                ],
                              }
                            )
                          ),
                          (0, e.jsx)(
                            ln,
                            fI(
                              { className: "ST_Main_Card" },
                              {
                                children: (0, e.jsx)(
                                  o_,
                                  fI(
                                    { sx: j },
                                    {
                                      children: (0, e.jsx)(
                                        La,
                                        fI(
                                          {
                                            container: !0,
                                            direction: "row",
                                            spacing: 1,
                                            justifyContent: "center",
                                            alignItems: "center",
                                          },
                                          {
                                            children: (0, e.jsx)(
                                              La,
                                              fI(
                                                {
                                                  item: !0,
                                                  xs: 10,
                                                  md: 12,
                                                  sm: 12,
                                                  lg: 10,
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                  m: 3,
                                                },
                                                {
                                                  children: (0, e.jsxs)(
                                                    Wa,
                                                    fI(
                                                      {
                                                        style: {
                                                          marginTop: "1rem",
                                                          wordBreak:
                                                            "break-word",
                                                        },
                                                      },
                                                      {
                                                        children: [
                                                          "Collection link -",
                                                          " ",
                                                          (0, e.jsx)(
                                                            Il,
                                                            fI(
                                                              {
                                                                href:
                                                                  "https://" +
                                                                  c +
                                                                  "/collections/wholesale/?" +
                                                                  (null ===
                                                                    (n =
                                                                      null == d
                                                                        ? void 0
                                                                        : d.SalesRepAffiliateUrl) ||
                                                                  void 0 === n
                                                                    ? void 0
                                                                    : n.split(
                                                                        "?"
                                                                      )[1]),
                                                                target:
                                                                  "_blank",
                                                                variant:
                                                                  "body2",
                                                              },
                                                              {
                                                                children:
                                                                  "https://" +
                                                                  c +
                                                                  "/collections/wholesale/?" +
                                                                  (null ===
                                                                    (r =
                                                                      null == d
                                                                        ? void 0
                                                                        : d.SalesRepAffiliateUrl) ||
                                                                  void 0 === r
                                                                    ? void 0
                                                                    : r.split(
                                                                        "?"
                                                                      )[1]),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            ln,
                            fI(
                              { className: "ST_Main_Card" },
                              {
                                children: (0, e.jsx)(
                                  o_,
                                  fI(
                                    { sx: j },
                                    {
                                      children: (0, e.jsxs)(
                                        La,
                                        fI(
                                          {
                                            container: !0,
                                            direction: "row",
                                            spacing: 1,
                                            justifyContent: "space-evenly",
                                            alignItems: "center",
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)(
                                                La,
                                                fI(
                                                  {
                                                    item: !0,
                                                    xs: 12,
                                                    md: 12,
                                                    lg: 3,
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    m: 3,
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      La,
                                                      fI(
                                                        {
                                                          container: !0,
                                                          direction: "column",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              La,
                                                              fI(
                                                                {
                                                                  item: !0,
                                                                  columns: {
                                                                    lg: 3,
                                                                  },
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    La,
                                                                    fI(
                                                                      {
                                                                        container:
                                                                          !0,
                                                                        direction:
                                                                          "column",
                                                                        justifyContent:
                                                                          "center",
                                                                        alignItems:
                                                                          "center",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsx)(
                                                                              "input",
                                                                              {
                                                                                accept:
                                                                                  "image/jpeg,image/gif,image/png",
                                                                                style:
                                                                                  {
                                                                                    display:
                                                                                      "none",
                                                                                  },
                                                                                disabled:
                                                                                  i,
                                                                                id: "button-file",
                                                                                type: "file",
                                                                                ref: h,
                                                                                onChange:
                                                                                  S,
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              "label",
                                                                              fI(
                                                                                {
                                                                                  htmlFor:
                                                                                    "button-file",
                                                                                  style:
                                                                                    {
                                                                                      cursor:
                                                                                        "pointer",
                                                                                    },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      "div",
                                                                                      {
                                                                                        children:
                                                                                          u
                                                                                            ? (0,
                                                                                              e.jsx)(
                                                                                                e.Fragment,
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      wp,
                                                                                                      fI(
                                                                                                        {
                                                                                                          overlap:
                                                                                                            "circular",
                                                                                                          anchorOrigin:
                                                                                                            {
                                                                                                              vertical:
                                                                                                                "bottom",
                                                                                                              horizontal:
                                                                                                                "right",
                                                                                                            },
                                                                                                          badgeContent:
                                                                                                            (0,
                                                                                                            e.jsx)(
                                                                                                              "div",
                                                                                                              fI(
                                                                                                                {
                                                                                                                  style:
                                                                                                                    Bo,
                                                                                                                },
                                                                                                                {
                                                                                                                  children:
                                                                                                                    (0,
                                                                                                                    e.jsx)(
                                                                                                                      cI,
                                                                                                                      {
                                                                                                                        style:
                                                                                                                          {
                                                                                                                            color:
                                                                                                                              "#1976d2",
                                                                                                                          },
                                                                                                                        fontSize:
                                                                                                                          "large",
                                                                                                                      }
                                                                                                                    ),
                                                                                                                }
                                                                                                              )
                                                                                                            ),
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            (0,
                                                                                                            e.jsx)(
                                                                                                              Tm,
                                                                                                              {
                                                                                                                alt: "CSS",
                                                                                                                src: u,
                                                                                                                sx: {
                                                                                                                  width: 200,
                                                                                                                  height: 200,
                                                                                                                },
                                                                                                              }
                                                                                                            ),
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            : (0,
                                                                                              e.jsx)(
                                                                                                wp,
                                                                                                fI(
                                                                                                  {
                                                                                                    overlap:
                                                                                                      "circular",
                                                                                                    anchorOrigin:
                                                                                                      {
                                                                                                        vertical:
                                                                                                          "bottom",
                                                                                                        horizontal:
                                                                                                          "right",
                                                                                                      },
                                                                                                    badgeContent:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        "div",
                                                                                                        fI(
                                                                                                          {
                                                                                                            style:
                                                                                                              Bo,
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                cI,
                                                                                                                {
                                                                                                                  style:
                                                                                                                    {
                                                                                                                      color:
                                                                                                                        "#1976d2",
                                                                                                                    },
                                                                                                                  fontSize:
                                                                                                                    "large",
                                                                                                                }
                                                                                                              ),
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        Tm,
                                                                                                        {
                                                                                                          alt: "CSS",
                                                                                                          sx: {
                                                                                                            width: 200,
                                                                                                            height: 200,
                                                                                                          },
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                      }
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              La,
                                                                              fI(
                                                                                {
                                                                                  container:
                                                                                    !0,
                                                                                  direction:
                                                                                    "row",
                                                                                  justifyContent:
                                                                                    "center",
                                                                                  mt: 4,
                                                                                  columnSpacing: 2,
                                                                                  style:
                                                                                    {
                                                                                      position:
                                                                                        "relative",
                                                                                    },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      La,
                                                                                      fI(
                                                                                        {
                                                                                          item: !0,
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            _
                                                                                              ? (0,
                                                                                                e.jsx)(
                                                                                                  Th,
                                                                                                  fI(
                                                                                                    {
                                                                                                      loading:
                                                                                                        b,
                                                                                                      disabled:
                                                                                                        !_,
                                                                                                      loadingPosition:
                                                                                                        "end",
                                                                                                      endIcon:
                                                                                                        (0,
                                                                                                        e.jsx)(
                                                                                                          uI,
                                                                                                          {}
                                                                                                        ),
                                                                                                      variant:
                                                                                                        "contained",
                                                                                                      style:
                                                                                                        {
                                                                                                          textTransform:
                                                                                                            "capitalize",
                                                                                                        },
                                                                                                      onClick:
                                                                                                        k,
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        v,
                                                                                                    }
                                                                                                  )
                                                                                                )
                                                                                              : "",
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                            I
                                                                              ? (0,
                                                                                e.jsx)(
                                                                                  Wa,
                                                                                  fI(
                                                                                    {
                                                                                      variant:
                                                                                        "body2",
                                                                                      style:
                                                                                        {
                                                                                          color:
                                                                                            "red",
                                                                                          marginTop:
                                                                                            "revert",
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        O,
                                                                                    }
                                                                                  )
                                                                                )
                                                                              : "",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsxs)(
                                                              Wa,
                                                              fI(
                                                                {
                                                                  variant: "h6",
                                                                },
                                                                {
                                                                  children: [
                                                                    " ",
                                                                    D(
                                                                      "uploadImage"
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                La,
                                                fI(
                                                  {
                                                    item: !0,
                                                    xs: 12,
                                                    md: 12,
                                                    sm: 12,
                                                    lg: 7,
                                                    mt: 2,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    columnSpacing: "3",
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      La,
                                                      fI(
                                                        {
                                                          container: !0,
                                                          direction: "column",
                                                          mt: 2,
                                                        },
                                                        {
                                                          children: (0, e.jsxs)(
                                                            La,
                                                            fI(
                                                              {
                                                                item: !0,
                                                                xs: 12,
                                                                md: 12,
                                                                sm: 12,
                                                                lg: 8,
                                                                style: {
                                                                  width:
                                                                    "inherit",
                                                                  padding:
                                                                    "1rem",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Wa,
                                                                    fI(
                                                                      {
                                                                        style: {
                                                                          marginTop:
                                                                            "1rem",
                                                                          fontFamily:
                                                                            "Segoe UI",
                                                                          fontSize:
                                                                            "16px",
                                                                        },
                                                                        align:
                                                                          "justify",
                                                                        noWrap:
                                                                          !1,
                                                                      },
                                                                      {
                                                                        children:
                                                                          D(
                                                                            "yourBio_content4"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Xd,
                                                                    {
                                                                      fullWidth:
                                                                        !0,
                                                                      size: "small",
                                                                      style: {
                                                                        marginTop:
                                                                          "1rem",
                                                                        fontFamily:
                                                                          "Segoe UI",
                                                                      },
                                                                      multiline:
                                                                        !0,
                                                                      inputProps:
                                                                        {
                                                                          maxLength:
                                                                            M,
                                                                        },
                                                                      onChange:
                                                                        function (
                                                                          e
                                                                        ) {
                                                                          return w(
                                                                            e
                                                                          );
                                                                        },
                                                                      value: f,
                                                                      label:
                                                                        D(
                                                                          "yourBio_content3"
                                                                        ),
                                                                      rows: 4,
                                                                    }
                                                                  ),
                                                                  (0, e.jsxs)(
                                                                    "div",
                                                                    fI(
                                                                      {
                                                                        style: {
                                                                          marginTop:
                                                                            "0px",
                                                                          color:
                                                                            "green",
                                                                          fontSize:
                                                                            "11px",
                                                                        },
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            T &&
                                                                            f.length <
                                                                              100
                                                                              ? T
                                                                              : 0,
                                                                            " chars left",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    La,
                                                                    fI(
                                                                      {
                                                                        item: !0,
                                                                        style: {
                                                                          textAlign:
                                                                            "right",
                                                                        },
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            Th,
                                                                            fI(
                                                                              {
                                                                                style:
                                                                                  {
                                                                                    textTransform:
                                                                                      "capitalize",
                                                                                    marginTop:
                                                                                      "2rem",
                                                                                    fontSize:
                                                                                      "14px",
                                                                                  },
                                                                                loading:
                                                                                  C,
                                                                                disabled:
                                                                                  l,
                                                                                loadingPosition:
                                                                                  "end",
                                                                                endIcon:
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    dI,
                                                                                    {}
                                                                                  ),
                                                                                variant:
                                                                                  "contained",
                                                                                onClick:
                                                                                  function () {
                                                                                    return P();
                                                                                  },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  x,
                                                                              }
                                                                            )
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  )
                : null,
            })
          );
        };
      function vI() {
        var t = X().t,
          n = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          r = n.baseData.select ? n.baseData.select : {},
          o = n.baseData,
          a =
            "SalesManager" ===
            (o && o.SingleSalesRep && o.SingleSalesRep.RepType);
        return [
          {
            index: 0,
            isActive: !0,
            icon: (0, e.jsx)(xa, {}),
            label: t("dashbord_Tab"),
            component: (0, e.jsx)(LP, {}),
          },
          {
            index: 1,
            isActive: r.CustomerInvoice,
            icon: (0, e.jsx)(Ca, {}),
            label: t("tab_CustomerInvoice"),
            component: (0, e.jsx)(e_, {}),
          },
          {
            index: 2,
            isActive: r.AffiliateLink,
            icon: jP,
            label: r.microsites
              ? t("tab7_YourBio") + " & " + t("tab_AffiliateLink")
              : t("tab_AffiliateLink"),
            component: (0, e.jsx)(gI, {}),
          },
          {
            index: 3,
            isActive: r.CartSharing,
            icon: NP,
            label: t("tab_CartSharing"),
            component: (0, e.jsx)(Yv, {}),
          },
          {
            index: 4,
            isActive: r.CouponeCode,
            icon: RP,
            label: t("tab_DiscountCoupon"),
            component: (0, e.jsx)(QP, {}),
          },
          {
            index: 5,
            isActive: !!r.referralpage && !!a,
            icon: (0, e.jsx)(Sa, {}),
            label: t("tab8_Team"),
            component: (0, e.jsx)(lI, {}),
          },
          {
            index: 6,
            isActive: r.Tagcustomer,
            icon: (0, e.jsx)(ka, {}),
            label: t("tab_MyCustomers"),
            component: (0, e.jsx)(gO, {}),
          },
          {
            index: 7,
            isActive: !0,
            icon: (0, e.jsx)(wa, {}),
            label: t("tab_YourSalesOrderDetails"),
            component: (0, e.jsx)(qO, {}),
          },
        ];
      }
      var bI = function () {
        return (
          (bI =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          bI.apply(this, arguments)
        );
      };
      function _I(n) {
        var r = (function (e) {
            var n,
              r,
              o,
              a,
              i = g(),
              s = (0, t.useState)(0),
              l = s[0],
              c = s[1],
              u =
                null !==
                  (r =
                    null === (n = z.getState().salesRepData) || void 0 === n
                      ? void 0
                      : n.activeTab) && void 0 !== r
                  ? r
                  : {},
              d =
                null !==
                  (a =
                    null === (o = z.getState().salesRepData) || void 0 === o
                      ? void 0
                      : o.editDraftOrder) && void 0 !== a
                  ? a
                  : {},
              p = vI().filter(function (e) {
                return e.isActive;
              });
            (0, t.useEffect)(
              function () {
                1 === (null == u ? void 0 : u.activeTabIndex) &&
                  (null == u ? void 0 : u.actionEvent) === Hv &&
                  m(u.activeTabIndex);
              },
              [u]
            );
            var m = function (t) {
                null == e || e.setActiveTab(p[t]),
                  c(t),
                  ((null == d ? void 0 : d.actionEvent) === Hv && 1 === t) ||
                    h({}, j.EDIT_DRAFT_ORDER),
                  h({ activeTabIndex: t, actionEvent: "" }, j.ACTIVE_TAB);
              },
              h = function (e, t) {
                i({ payload: e, type: t });
              };
            return {
              handleChange: function () {
                null == e || e.setMobileOpen(!1);
              },
              componentIndex: l,
              handleChangeTab: m,
              tabsArray: p,
              a11yProps: function (e) {
                return {
                  id: "vertical-tab-".concat(e),
                  "aria-controls": "vertical-tabpanel-".concat(e),
                };
              },
            };
          })(n),
          o = r.handleChange,
          a = r.componentIndex,
          i = r.handleChangeTab,
          s = r.tabsArray,
          l = r.a11yProps;
        return (0, e.jsx)(
          fa,
          bI(
            {
              className: "navigation-Tabs",
              orientation: "vertical",
              variant: "scrollable",
              value: a,
              onChange: o,
              "aria-label": "Vertical tabs example",
            },
            {
              children: s.map(function (t, n) {
                if (t.isActive)
                  return (0, e.jsx)(
                    ya,
                    bI(
                      {
                        sx: { justifyContent: "wrap", textAlign: "left" },
                        onClick: function () {
                          i(n);
                        },
                        className: "navigation-Tab",
                        icon: t.icon,
                        iconPosition: "start",
                        label: t.label,
                      },
                      l(t.index)
                    ),
                    t.index
                  );
              }),
            }
          )
        );
      }
      function yI(e) {
        return (0, Zt.ZP)("MuiAppBar", e);
      }
      (0, Bt.Z)("MuiAppBar", [
        "root",
        "positionFixed",
        "positionAbsolute",
        "positionSticky",
        "positionStatic",
        "positionRelative",
        "colorDefault",
        "colorPrimary",
        "colorSecondary",
        "colorInherit",
        "colorTransparent",
        "colorError",
        "colorInfo",
        "colorSuccess",
        "colorWarning",
      ]);
      const xI = ["className", "color", "enableColorOnDark", "position"],
        CI = (e, t) =>
          e ? `${null == e ? void 0 : e.replace(")", "")}, ${t})` : t,
        SI = (0, Lt.ZP)(io, {
          name: "MuiAppBar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`position${(0, Fn.Z)(n.position)}`],
              t[`color${(0, Fn.Z)(n.color)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) => {
          const n =
            "light" === e.palette.mode
              ? e.palette.grey[100]
              : e.palette.grey[900];
          return (0, d.Z)(
            {
              display: "flex",
              flexDirection: "column",
              width: "100%",
              boxSizing: "border-box",
              flexShrink: 0,
            },
            "fixed" === t.position && {
              position: "fixed",
              zIndex: (e.vars || e).zIndex.appBar,
              top: 0,
              left: "auto",
              right: 0,
              "@media print": { position: "absolute" },
            },
            "absolute" === t.position && {
              position: "absolute",
              zIndex: (e.vars || e).zIndex.appBar,
              top: 0,
              left: "auto",
              right: 0,
            },
            "sticky" === t.position && {
              position: "sticky",
              zIndex: (e.vars || e).zIndex.appBar,
              top: 0,
              left: "auto",
              right: 0,
            },
            "static" === t.position && { position: "static" },
            "relative" === t.position && { position: "relative" },
            !e.vars &&
              (0, d.Z)(
                {},
                "default" === t.color && {
                  backgroundColor: n,
                  color: e.palette.getContrastText(n),
                },
                t.color &&
                  "default" !== t.color &&
                  "inherit" !== t.color &&
                  "transparent" !== t.color && {
                    backgroundColor: e.palette[t.color].main,
                    color: e.palette[t.color].contrastText,
                  },
                "inherit" === t.color && { color: "inherit" },
                "dark" === e.palette.mode &&
                  !t.enableColorOnDark && {
                    backgroundColor: null,
                    color: null,
                  },
                "transparent" === t.color &&
                  (0, d.Z)(
                    { backgroundColor: "transparent", color: "inherit" },
                    "dark" === e.palette.mode && { backgroundImage: "none" }
                  )
              ),
            e.vars &&
              (0, d.Z)(
                {},
                "default" === t.color && {
                  "--AppBar-background": t.enableColorOnDark
                    ? e.vars.palette.AppBar.defaultBg
                    : CI(
                        e.vars.palette.AppBar.darkBg,
                        e.vars.palette.AppBar.defaultBg
                      ),
                  "--AppBar-color": t.enableColorOnDark
                    ? e.vars.palette.text.primary
                    : CI(
                        e.vars.palette.AppBar.darkColor,
                        e.vars.palette.text.primary
                      ),
                },
                t.color &&
                  !t.color.match(/^(default|inherit|transparent)$/) && {
                    "--AppBar-background": t.enableColorOnDark
                      ? e.vars.palette[t.color].main
                      : CI(
                          e.vars.palette.AppBar.darkBg,
                          e.vars.palette[t.color].main
                        ),
                    "--AppBar-color": t.enableColorOnDark
                      ? e.vars.palette[t.color].contrastText
                      : CI(
                          e.vars.palette.AppBar.darkColor,
                          e.vars.palette[t.color].contrastText
                        ),
                  },
                {
                  backgroundColor: "var(--AppBar-background)",
                  color:
                    "inherit" === t.color ? "inherit" : "var(--AppBar-color)",
                },
                "transparent" === t.color && {
                  backgroundImage: "none",
                  backgroundColor: "transparent",
                  color: "inherit",
                }
              )
          );
        }),
        kI = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiAppBar" }),
            {
              className: o,
              color: a = "primary",
              enableColorOnDark: i = !1,
              position: s = "fixed",
            } = r,
            l = (0, jt.Z)(r, xI),
            c = (0, d.Z)({}, r, {
              color: a,
              position: s,
              enableColorOnDark: i,
            }),
            u = ((e) => {
              const { color: t, position: n, classes: r } = e,
                o = {
                  root: [
                    "root",
                    `color${(0, Fn.Z)(t)}`,
                    `position${(0, Fn.Z)(n)}`,
                  ],
                };
              return (0, Nt.Z)(o, yI, r);
            })(c);
          return (0,
          e.jsx)(SI, (0, d.Z)({ square: !0, component: "header", ownerState: c, elevation: 4, className: (0, Rt.Z)(u.root, o, "fixed" === s && "mui-fixed"), ref: n }, l));
        });
      var wI = kI;
      function PI(e) {
        return (0, Zt.ZP)("MuiToolbar", e);
      }
      (0, Bt.Z)("MuiToolbar", ["root", "gutters", "regular", "dense"]);
      const OI = ["className", "component", "disableGutters", "variant"],
        II = (0, Lt.ZP)("div", {
          name: "MuiToolbar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
          },
        })(
          ({ theme: e, ownerState: t }) =>
            (0, d.Z)(
              { position: "relative", display: "flex", alignItems: "center" },
              !t.disableGutters && {
                paddingLeft: e.spacing(2),
                paddingRight: e.spacing(2),
                [e.breakpoints.up("sm")]: {
                  paddingLeft: e.spacing(3),
                  paddingRight: e.spacing(3),
                },
              },
              "dense" === t.variant && { minHeight: 48 }
            ),
          ({ theme: e, ownerState: t }) =>
            "regular" === t.variant && e.mixins.toolbar
        );
      var TI = t.forwardRef(function (t, n) {
          const r = (0, zt.Z)({ props: t, name: "MuiToolbar" }),
            {
              className: o,
              component: a = "div",
              disableGutters: i = !1,
              variant: s = "regular",
            } = r,
            l = (0, jt.Z)(r, OI),
            c = (0, d.Z)({}, r, {
              component: a,
              disableGutters: i,
              variant: s,
            }),
            u = ((e) => {
              const { classes: t, disableGutters: n, variant: r } = e,
                o = { root: ["root", !n && "gutters", r] };
              return (0, Nt.Z)(o, PI, t);
            })(c);
          return (0,
          e.jsx)(II, (0, d.Z)({ as: a, className: (0, Rt.Z)(u.root, o), ref: n, ownerState: c }, l));
        }),
        MI = [
          { name: "Eng (US)", code: "en" },
          { name: "Spanish", code: "es" },
          { name: "French", code: "fr" },
          { name: "Italian", code: "it" },
          { name: "Malay", code: "ms" },
          { name: "Swedish", code: "sv" },
          { name: "Portuguese", code: "pt" },
        ];
      function EI() {
        return (
          (EI = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          EI.apply(this, arguments)
        );
      }
      var DI = ["cdnSuffix", "cdnUrl", "countryCode", "style", "svg"],
        jI = function (e) {
          var n = e.cdnSuffix,
            r = void 0 === n ? "svg" : n,
            o = e.cdnUrl,
            a =
              void 0 === o
                ? "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/"
                : o,
            i = e.countryCode,
            s = e.style,
            l = e.svg,
            c = void 0 !== l && l,
            u = (function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                a = Object.keys(e);
              for (r = 0; r < a.length; r++)
                (n = a[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            })(e, DI);
          if ("string" != typeof i) return null;
          if (c) {
            var d = "" + a + i.toLowerCase() + "." + r;
            return (0, t.createElement)(
              "img",
              Object.assign({}, u, {
                src: d,
                style: EI(
                  {
                    display: "inline-block",
                    width: "1em",
                    height: "1em",
                    verticalAlign: "middle",
                  },
                  s
                ),
              })
            );
          }
          var p = i.toUpperCase().replace(/./g, function (e) {
            return String.fromCodePoint(e.charCodeAt(0) + 127397);
          });
          return (0, t.createElement)(
            "span",
            Object.assign({ role: "img" }, u, {
              style: EI(
                {
                  display: "inline-block",
                  fontSize: "1em",
                  lineHeight: "1em",
                  verticalAlign: "middle",
                },
                s
              ),
            }),
            p
          );
        },
        RI = function () {
          return (
            (RI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            RI.apply(this, arguments)
          );
        };
      function NI(t) {
        return (0, e.jsx)(
          ee,
          RI(
            { i18n: Dt },
            {
              children: (0, e.jsx)(ln, {
                children: (0, e.jsx)(
                  $u,
                  RI(
                    {
                      fullWidth: !0,
                      sx: { mt: 1, minWidth: 120 },
                      size: "small",
                    },
                    {
                      children: (0, e.jsx)(
                        Kd,
                        RI(
                          {
                            sx: RI(
                              { color: t.color, backgroundColor: "#F5F5F5" },
                              Ao
                            ),
                            defaultValue: "en",
                            onChange: function (e) {
                              return Dt.changeLanguage(e.target.value);
                            },
                          },
                          {
                            children: MI.map(function (t, n) {
                              return (0,
                              e.jsx)(ob, RI({ value: t.code }, { children: (0, e.jsxs)(ln, RI({ sx: { display: "flex", alignItems: "center" } }, { children: [(0, e.jsx)(jI, { style: { marginRight: 8 }, countryCode: "en" === t.code ? "gb" : t.code, svg: !0 }), (0, e.jsx)(Wa, { children: t.name })] })) }), n);
                            }),
                          }
                        )
                      ),
                    }
                  )
                ),
              }),
            }
          )
        );
      }
      var AI = function () {
          return (
            (AI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            AI.apply(this, arguments)
          );
        },
        LI = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        zI = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        BI = function () {
          return (
            (BI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            BI.apply(this, arguments)
          );
        },
        ZI = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a,
                i,
                s,
                l,
                c,
                u,
                d = this,
                p = X().t,
                m = Lw(),
                h = m.loggedInRepData,
                f = m.getTimeZone,
                v = Qg("(max-width: 600px)"),
                b = g(),
                _ = y(function (e) {
                  return e.salesRepData;
                }),
                x =
                  null === (e = null == _ ? void 0 : _.loggedInRepDetails) ||
                  void 0 === e
                    ? void 0
                    : e.customerName,
                C = {
                  currentPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                },
                S = (0, t.useState)(!1),
                k = S[0],
                w = S[1],
                P =
                  null ===
                    (r =
                      null === (n = _.baseData) || void 0 === n
                        ? void 0
                        : n.SingleSalesRep) || void 0 === r
                    ? void 0
                    : r.ProfileImagePath,
                O =
                  null ===
                    (a =
                      null === (o = null == _ ? void 0 : _.baseData) ||
                      void 0 === o
                        ? void 0
                        : o.SingleSalesRep) || void 0 === a
                    ? void 0
                    : a.RepType,
                I =
                  null ===
                    (s =
                      null === (i = null == _ ? void 0 : _.baseData) ||
                      void 0 === i
                        ? void 0
                        : i.SingleSalesRep) || void 0 === s
                    ? void 0
                    : s.SalesRepName,
                T =
                  null ===
                    (c =
                      null === (l = null == _ ? void 0 : _.baseData) ||
                      void 0 === l
                        ? void 0
                        : l.SingleSalesRep) || void 0 === c
                    ? void 0
                    : c.SalesRepLastName,
                M = "".concat(I || "", " ").concat(T || ""),
                E =
                  null === (u = null == _ ? void 0 : _.baseData) || void 0 === u
                    ? void 0
                    : u.SingleSalesRep,
                D = (0, t.useState)(C),
                R = D[0],
                N = D[1],
                A = (0, t.useState)({
                  currentPasswordErrMsg: "",
                  newPasswordErrMsg: "",
                  confirmPasswordErrMsg: "",
                }),
                L = A[0],
                z = A[1],
                B =
                  R.currentPassword.length > 0 &&
                  R.newPassword.length > 0 &&
                  R.confirmPassword.length > 0 &&
                  "" === L.currentPasswordErrMsg &&
                  "" === L.newPasswordErrMsg &&
                  "" === L.confirmPasswordErrMsg,
                Z = (0, t.useState)(!1),
                F = Z[0],
                H = Z[1],
                V = (0, t.useState)(!1),
                W = V[0],
                $ = V[1],
                U = (0, t.useState)({ successMsg: "", errorMsg: "" }),
                K = U[0],
                G = U[1],
                q = {
                  isLoading: !1,
                  imageName: "",
                  imagePreview: KP(null == E ? void 0 : E.ProfileImagePath)
                    ? ""
                    : E.ProfileImagePath,
                  imageSize: 0,
                },
                Y = (0, t.useRef)(null),
                J = (0, t.useState)(""),
                Q = J[0],
                ee = J[1],
                te = (0, t.useState)(!1),
                ne = te[0],
                re = te[1],
                oe = (0, t.useState)(!1),
                ae = oe[0],
                ie = oe[1],
                se = (0, t.useState)(),
                le = se[0],
                ce = se[1],
                ue = (0, t.useState)(!1),
                de = ue[0],
                pe = ue[1],
                me = (0, t.useState)(q),
                he = me[0],
                fe = me[1],
                ge = (0, t.useState)(p("yourBio_button2")),
                ve = ge[0],
                be = ge[1],
                _e = (0, t.useState)(!1),
                ye = _e[0],
                xe = _e[1],
                Ce = (0, t.useState)(!1),
                Se = Ce[0],
                ke = Ce[1],
                we = he.imagePreview,
                Pe = function () {
                  return LI(d, void 0, void 0, function () {
                    var e;
                    return zI(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return $(!0), [4, b(Ug(R))];
                        case 1:
                          return (
                            200 == (null == (e = t.sent()) ? void 0 : e.status)
                              ? (H(!0),
                                G({ errorMsg: "", successMsg: e.message }))
                              : G({ successMsg: "", errorMsg: e.message }),
                            $(!1),
                            [2]
                          );
                      }
                    });
                  });
                };
              return {
                loggedInRepData: h,
                getTimeZone: f,
                repName: x,
                propsColor: { color: "black" },
                passwordDialog: k,
                profileSrc: P,
                updatePasswordSuccess: F,
                restLoadingFlag: W,
                passwordErrMsg: K,
                userLogout: function () {
                  return LI(d, void 0, void 0, function () {
                    var e;
                    return zI(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return (
                            sessionStorage.setItem("Authorization", ""),
                            gf.next(!1),
                            sessionStorage.clear(),
                            (e = { payload: "", type: j.RESET_INITIAL_STATE }),
                            [4, b(e)]
                          );
                        case 1:
                          return t.sent(), [2];
                      }
                    });
                  });
                },
                stringAvatar: function (e) {
                  return {
                    sx: {
                      bgcolor: "#d0f4ff",
                      color: "#1976d2",
                      fontSize: ".8rem",
                      borderRadius: "18%",
                    },
                    children: ""
                      .concat(e.split(" ")[0][0])
                      .concat(e.split(" ")[1][0]),
                  };
                },
                changeFormValue: function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    o = n.value;
                  N(AI(AI({}, R), (((t = {})[r] = o), t))),
                    (function (e, t) {
                      var n;
                      switch (e) {
                        case "":
                          "" === t
                            ? z(function (e) {
                                return AI(AI({}, e), {
                                  currentPasswordErrMsg: p(
                                    "resetPassword_validation_Msg"
                                  ),
                                });
                              })
                            : t.match(av)
                            ? z(function (e) {
                                return AI(AI({}, e), {
                                  currentPasswordErrMsg: "",
                                });
                              })
                            : z(function (e) {
                                return AI(AI({}, e), {
                                  currentPasswordErrMsg: p(
                                    "resetPassword_validation_Msg2"
                                  ),
                                });
                              });
                          break;
                        case "newPassword":
                          "" === t
                            ? z(function (e) {
                                return AI(AI({}, e), {
                                  newPasswordErrMsg: p(
                                    "resetPassword_validation_Msg"
                                  ),
                                });
                              })
                            : t.match(av)
                            ? z(function (e) {
                                return AI(AI({}, e), { newPasswordErrMsg: "" });
                              })
                            : z(function (e) {
                                return AI(AI({}, e), {
                                  newPasswordErrMsg: p(
                                    "resetPassword_validation_Msg2"
                                  ),
                                });
                              }),
                            t !== R.confirmPassword &&
                            (null === (n = R.confirmPassword) || void 0 === n
                              ? void 0
                              : n.length) > 0
                              ? z(function (e) {
                                  return AI(AI({}, e), {
                                    confirmPasswordErrMsg: p(
                                      "resetPassword_validation_Msg3"
                                    ),
                                  });
                                })
                              : z(function (e) {
                                  return AI(AI({}, e), {
                                    confirmPasswordErrMsg: "",
                                  });
                                });
                          break;
                        case "confirmPassword":
                          "" === t
                            ? z(function (e) {
                                return AI(AI({}, e), {
                                  confirmPasswordErrMsg: p(
                                    "resetPassword_validation_Msg"
                                  ),
                                });
                              })
                            : t === R.newPassword
                            ? z(function (e) {
                                return AI(AI({}, e), {
                                  confirmPasswordErrMsg: "",
                                });
                              })
                            : z(function (e) {
                                return AI(AI({}, e), {
                                  confirmPasswordErrMsg: p(
                                    "resetPassword_validation_Msg3"
                                  ),
                                });
                              });
                      }
                    })(r, o);
                },
                handleKeyDown: function (e) {
                  "Enter" === e.key && 13 === e.keyCode && B && Pe();
                },
                resetPassword: Pe,
                clearFormValues: function () {
                  w(!1),
                    N(C),
                    H(!1),
                    G({ successMsg: "", errorMsg: "" }),
                    z({
                      currentPasswordErrMsg: "",
                      newPasswordErrMsg: "",
                      confirmPasswordErrMsg: "",
                    });
                },
                viewProps: {
                  noWrap: !0,
                  flexGrow: 1,
                  sx: {
                    fontWeight: v ? 700 : 610,
                    textDecoration: "none",
                    display: v
                      ? { xs: "flex", md: "none" }
                      : { xs: "none", md: "flex" },
                    fontSize: v ? "h5.fontSize" : "16px",
                    color: "#1565C4",
                    fontFamily: "Segoe UI",
                    backgroundColor: "#FFF",
                  },
                },
                handlePasswordDialogOpen: function () {
                  w(!0);
                },
                passwordForm: R,
                resetBtnEnabled: B,
                formErrMsg: L,
                t: p,
                isMobile: v,
                repFullName: M,
                repType: O,
                openCommissionDialog: Se,
                setOpenCommissionDialog: ke,
                isImageInput: ae,
                showNewImage: de,
                profile: _,
                uploadInputImage: Y,
                setImage: fe,
                image: he,
                uploadImageState: ve,
                imageLoading: ye,
                handleUploadImage: function (e) {
                  var t = e.target.files;
                  return LI(d, void 0, void 0, function () {
                    var e;
                    return zI(this, function (n) {
                      return (
                        ee(""),
                        re(!1),
                        KP((e = t[0])) ||
                          (e.size < 5e6
                            ? (fe(function (e) {
                                return AI(AI({}, e), { isLoading: !0 });
                              }),
                              ce(e),
                              pe(!0),
                              fe(function (t) {
                                return AI(AI({}, t), {
                                  imageName: e.name,
                                  imagePreview: URL.createObjectURL(e),
                                  imageSize: e.size,
                                  isLoading: !1,
                                });
                              }))
                            : (setTimeout(function () {
                                re(!1);
                              }, 3e3),
                              re(!0),
                              ee(p("yourBio_error_image_size")),
                              fe(q),
                              (Y.current.value = null))),
                        [2]
                      );
                    });
                  });
                },
                uploadImage: function () {
                  return LI(d, void 0, void 0, function () {
                    var e;
                    return zI(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return (
                            be(p("yourBio_Uploadbtn1")),
                            xe(!0),
                            ee(""),
                            re(!1),
                            ie(!0),
                            !KP(le) &&
                            he.imageSize < 5e6 &&
                            "" !== he.imagePreview
                              ? (e = le)
                                ? [4, b(Bg(le))]
                                : [3, 2]
                              : [3, 3]
                          );
                        case 1:
                          (e = t.sent()), (t.label = 2);
                        case 2:
                          return (
                            e
                              ? (be(p("yourBio_Uploadbtn2")),
                                fe(function (e) {
                                  return AI(AI({}, e), { isLoading: !1 });
                                }),
                                ee(""),
                                re(!1))
                              : (re(!0),
                                fe(q),
                                (Y.current.value = null),
                                be(p("yourBio_button2")),
                                ee(p("addCustomer_leadErrrorMsg"))),
                            [3, 4]
                          );
                        case 3:
                          ee(p("yourBio_error_image_size")),
                            re(!0),
                            pe(!1),
                            fe(q),
                            (Y.current.value = null),
                            (t.label = 4);
                        case 4:
                          return (
                            setTimeout(function () {
                              re(!1);
                            }, 3e3),
                            pe(!1),
                            xe(!1),
                            ie(!1),
                            [2]
                          );
                      }
                    });
                  });
                },
                helperImage: Q,
                imageError: ne,
                imagePreview: we,
                profilePic: E,
              };
            })(),
            r = n.loggedInRepData,
            o = n.getTimeZone,
            a = (n.repName, n.propsColor),
            i = n.passwordDialog,
            s = n.profileSrc,
            l = n.updatePasswordSuccess,
            c = n.restLoadingFlag,
            u = n.passwordErrMsg,
            d = n.userLogout,
            p = n.stringAvatar,
            m = n.changeFormValue,
            h = n.handleKeyDown,
            f = n.resetPassword,
            v = n.clearFormValues,
            b = n.viewProps,
            _ = n.handlePasswordDialogOpen,
            x = n.passwordForm,
            C = n.resetBtnEnabled,
            S = n.formErrMsg,
            k = n.t,
            w = n.isMobile,
            P = n.repFullName,
            O = n.repType,
            I = n.openCommissionDialog,
            T = n.setOpenCommissionDialog,
            M = n.isImageInput,
            E = n.showNewImage,
            D = (n.profile, n.uploadInputImage),
            R = n.setImage,
            N = (n.image, n.uploadImageState),
            A = n.imageLoading,
            L = n.handleUploadImage,
            z = n.uploadImage,
            B = n.helperImage,
            Z = n.imageError,
            F = n.imagePreview,
            H = n.profilePic;
          return (
            (0, t.useEffect)(function () {
              if (!KP(H)) {
                var e = null == H ? void 0 : H.ProfileImagePath;
                R(function (t) {
                  return BI(BI({}, t), { imagePreview: e, isLoading: !1 });
                });
              }
            }, []),
            (0, e.jsx)(
              wI,
              BI(
                {
                  position: "static",
                  elevation: 0,
                  sx: {
                    backgroundColor: "#FFF",
                    borderBottom: "0.7px solid #ccc",
                  },
                },
                {
                  children: (0, e.jsx)(
                    nI,
                    BI(
                      { maxWidth: "xl" },
                      {
                        children: (0, e.jsxs)(
                          TI,
                          BI(
                            { disableGutters: !0 },
                            {
                              children: [
                                (0, e.jsxs)(
                                  Wa,
                                  BI({}, b, {
                                    children: [" ", k("tab_Dashboard"), " "],
                                  })
                                ),
                                (0, e.jsxs)(
                                  ln,
                                  BI(
                                    {
                                      sx: BI(
                                        {
                                          flexGrow: 1,
                                          mb: 1,
                                          justifyContent: "left",
                                        },
                                        No
                                      ),
                                    },
                                    {
                                      children: [
                                        " ",
                                        (0, e.jsx)(NI, BI({}, a)),
                                        " ",
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  ln,
                                  BI(
                                    {
                                      sx: BI(
                                        BI(
                                          {
                                            flexGrow: 2,
                                            justifyContent: "left",
                                            marginLeft: "2rem",
                                          },
                                          No
                                        ),
                                        { fontWeight: "bold" }
                                      ),
                                    },
                                    {
                                      children: [
                                        o(),
                                        " ",
                                        null == r ? void 0 : r.customerName,
                                        " ! ",
                                        k("dashboard_welcomeMsg"),
                                        " ",
                                        "Chalkless",
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  ln,
                                  BI(
                                    {
                                      sx: {
                                        flexGrow: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        mt: w ? 0 : 1,
                                      },
                                    },
                                    {
                                      children: [
                                        s
                                          ? (0, e.jsx)(Tm, {
                                              sx: { borderRadius: "18%" },
                                              alt: "",
                                              src: s,
                                            })
                                          : P
                                          ? (0, e.jsx)(Tm, BI({}, p(P)))
                                          : (0, e.jsx)(Tm, {
                                              src: "/broken-image.jpg",
                                            }),
                                        !w &&
                                          P &&
                                          (0, e.jsxs)(
                                            ln,
                                            BI(
                                              { sx: { ml: 2 } },
                                              {
                                                children: [
                                                  " ",
                                                  (0, e.jsx)(
                                                    Wa,
                                                    BI(
                                                      {
                                                        sx: {
                                                          color: "#202223",
                                                          fontSize: "14px",
                                                        },
                                                      },
                                                      { children: P }
                                                    )
                                                  ),
                                                  " ",
                                                  (0, e.jsx)(
                                                    Wa,
                                                    BI(
                                                      {
                                                        sx: {
                                                          color: "#666666",
                                                          fontSize: "10px",
                                                        },
                                                      },
                                                      { children: O }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        (0, e.jsx)(
                                          $u,
                                          BI(
                                            {
                                              fullWidth: !0,
                                              sx: { maxWidth: w ? 25 : 30 },
                                              size: w ? "small" : "medium",
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                Kd,
                                                BI(
                                                  {
                                                    sx: BI(
                                                      {
                                                        py: w ? 1 : 0,
                                                        pl: w ? 1 : 0,
                                                        pr: w ? 0 : 1,
                                                      },
                                                      Ao
                                                    ),
                                                    MenuProps: {
                                                      PaperProps: {
                                                        style: { width: 150 },
                                                      },
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        ob,
                                                        BI(
                                                          {
                                                            className:
                                                              "ST_CI_Menu",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              Wa,
                                                              BI(
                                                                {
                                                                  className:
                                                                    "ST_CI_Menu_Items",
                                                                  onClick: _,
                                                                },
                                                                {
                                                                  children: [
                                                                    " ",
                                                                    k(
                                                                      "profile_Change_Password"
                                                                    ),
                                                                    " ",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        ob,
                                                        BI(
                                                          {
                                                            className:
                                                              "ST_CI_Menu",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(
                                                              Wa,
                                                              BI(
                                                                {
                                                                  className:
                                                                    "ST_CI_Menu_Items",
                                                                  onClick:
                                                                    function () {
                                                                      T(!0);
                                                                    },
                                                                },
                                                                {
                                                                  children: k(
                                                                    "dashbord_profile_pic"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(ob, {
                                                        children: (0, e.jsxs)(
                                                          Wa,
                                                          BI(
                                                            {
                                                              onClick: d,
                                                              className:
                                                                "ST_CI_Menu_Items",
                                                            },
                                                            {
                                                              children: [
                                                                " ",
                                                                k(
                                                                  "tab13_Logout"
                                                                ),
                                                                " ",
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Av,
                                  BI(
                                    {
                                      open: i,
                                      onClose: v,
                                      maxWidth: "sm",
                                      fullWidth: !0,
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        ln,
                                        BI(
                                          { className: "ST_Dialog_Box" },
                                          {
                                            children: [
                                              (0, e.jsxs)(
                                                La,
                                                BI(
                                                  {
                                                    container: !0,
                                                    spacing: 2,
                                                    mb: 2,
                                                    pl: 2,
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        La,
                                                        BI(
                                                          {
                                                            item: !0,
                                                            xs: 10,
                                                            md: 10,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(
                                                              Wa,
                                                              BI(
                                                                {
                                                                  variant: "h6",
                                                                },
                                                                {
                                                                  children: k(
                                                                    "profile_Change_Password"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BI(
                                                          {
                                                            item: !0,
                                                            xs: 2,
                                                            md: 2,
                                                            sx: {
                                                              textAlign:
                                                                "right",
                                                            },
                                                            pr: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(pv, {
                                                              sx: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              onClick: v,
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                Fv,
                                                BI(
                                                  { hidden: l },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      La,
                                                      BI(
                                                        { container: !0 },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              La,
                                                              BI(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 12,
                                                                  mb: 3,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(Xd, {
                                                                    type: "password",
                                                                    size: "small",
                                                                    name: "currentPassword",
                                                                    label:
                                                                      "Current Password",
                                                                    value:
                                                                      null == x
                                                                        ? void 0
                                                                        : x.currentPassword,
                                                                    fullWidth:
                                                                      !0,
                                                                    onChange:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        return m(
                                                                          e
                                                                        );
                                                                      },
                                                                    error:
                                                                      "" !==
                                                                      (null == S
                                                                        ? void 0
                                                                        : S.currentPasswordErrMsg),
                                                                    helperText:
                                                                      null == S
                                                                        ? void 0
                                                                        : S.currentPasswordErrMsg,
                                                                    onKeyDown:
                                                                      h,
                                                                    required:
                                                                      !0,
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              La,
                                                              BI(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 12,
                                                                  mb: 3,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(Xd, {
                                                                    type: "password",
                                                                    size: "small",
                                                                    name: "newPassword",
                                                                    label:
                                                                      "New Password",
                                                                    value:
                                                                      null == x
                                                                        ? void 0
                                                                        : x.newPassword,
                                                                    fullWidth:
                                                                      !0,
                                                                    onChange:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        return m(
                                                                          e
                                                                        );
                                                                      },
                                                                    error:
                                                                      "" !==
                                                                      (null == S
                                                                        ? void 0
                                                                        : S.newPasswordErrMsg),
                                                                    helperText:
                                                                      null == S
                                                                        ? void 0
                                                                        : S.newPasswordErrMsg,
                                                                    onKeyDown:
                                                                      h,
                                                                    required:
                                                                      !0,
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              La,
                                                              BI(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 12,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(Xd, {
                                                                    type: "password",
                                                                    size: "small",
                                                                    name: "confirmPassword",
                                                                    label:
                                                                      "Confirm Password",
                                                                    value:
                                                                      null == x
                                                                        ? void 0
                                                                        : x.confirmPassword,
                                                                    fullWidth:
                                                                      !0,
                                                                    onChange:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        return m(
                                                                          e
                                                                        );
                                                                      },
                                                                    error:
                                                                      "" !==
                                                                      (null == S
                                                                        ? void 0
                                                                        : S.confirmPasswordErrMsg),
                                                                    helperText:
                                                                      null == S
                                                                        ? void 0
                                                                        : S.confirmPasswordErrMsg,
                                                                    onKeyDown:
                                                                      h,
                                                                    required:
                                                                      !0,
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(cO, {
                                                children: (0, e.jsx)(
                                                  Wa,
                                                  BI(
                                                    {
                                                      component: "div",
                                                      pr: 2,
                                                      hidden: l,
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        Th,
                                                        BI(
                                                          {
                                                            loading: c,
                                                            disabled: !C,
                                                            variant:
                                                              "contained",
                                                            style: {
                                                              textTransform:
                                                                "capitalize",
                                                            },
                                                            onClick: f,
                                                          },
                                                          {
                                                            children:
                                                              k(
                                                                "forgotPwd_ResetBtn"
                                                              ),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }),
                                              (0, e.jsx)(
                                                "div",
                                                BI(
                                                  {
                                                    className: "ST_Text_Right",
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      Wa,
                                                      BI(
                                                        {
                                                          variant: "subtitle1",
                                                          sx: { color: "red" },
                                                          hidden:
                                                            "" == u.errorMsg,
                                                        },
                                                        { children: u.errorMsg }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                Fv,
                                                BI(
                                                  {
                                                    sx: { padding: "0px" },
                                                    hidden: "" == u.successMsg,
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      Wa,
                                                      BI(
                                                        {
                                                          variant: "body1",
                                                          sx: {
                                                            color: "green",
                                                            padding: "0px 17px",
                                                          },
                                                        },
                                                        {
                                                          children:
                                                            u.successMsg,
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Av,
                                  BI(
                                    {
                                      open: I,
                                      onClose: function () {
                                        return T(!1);
                                      },
                                      maxWidth: "sm",
                                      fullWidth: !0,
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        ln,
                                        BI(
                                          { className: "ST_Dialog_Box" },
                                          {
                                            children: [
                                              (0, e.jsxs)(
                                                La,
                                                BI(
                                                  {
                                                    container: !0,
                                                    spacing: 2,
                                                    mb: 2,
                                                    pl: 2,
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        La,
                                                        BI(
                                                          {
                                                            item: !0,
                                                            xs: 10,
                                                            md: 10,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(
                                                              Wa,
                                                              BI(
                                                                {
                                                                  variant: "h6",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: k(
                                                                      "dashbord_profile_pic"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        La,
                                                        BI(
                                                          {
                                                            item: !0,
                                                            xs: 2,
                                                            md: 2,
                                                            sx: {
                                                              textAlign:
                                                                "right",
                                                            },
                                                            pr: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(pv, {
                                                              sx: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              onClick:
                                                                function () {
                                                                  T(!1);
                                                                },
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                Fv,
                                                BI(
                                                  { sx: { padding: "0px" } },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      La,
                                                      BI(
                                                        {
                                                          container: !0,
                                                          direction: "column",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              La,
                                                              BI(
                                                                {
                                                                  item: !0,
                                                                  columns: {
                                                                    lg: 3,
                                                                  },
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    La,
                                                                    BI(
                                                                      {
                                                                        container:
                                                                          !0,
                                                                        direction:
                                                                          "column",
                                                                        justifyContent:
                                                                          "center",
                                                                        alignItems:
                                                                          "center",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsx)(
                                                                              "input",
                                                                              {
                                                                                accept:
                                                                                  "image/jpeg,image/gif,image/png",
                                                                                style:
                                                                                  {
                                                                                    display:
                                                                                      "none",
                                                                                  },
                                                                                disabled:
                                                                                  M,
                                                                                id: "button-file",
                                                                                type: "file",
                                                                                ref: D,
                                                                                onChange:
                                                                                  L,
                                                                              }
                                                                            ),
                                                                            (0,
                                                                            e.jsx)(
                                                                              "label",
                                                                              BI(
                                                                                {
                                                                                  htmlFor:
                                                                                    "button-file",
                                                                                  style:
                                                                                    {
                                                                                      cursor:
                                                                                        "pointer",
                                                                                    },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      "div",
                                                                                      {
                                                                                        children:
                                                                                          F
                                                                                            ? (0,
                                                                                              e.jsx)(
                                                                                                e.Fragment,
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      wp,
                                                                                                      BI(
                                                                                                        {
                                                                                                          overlap:
                                                                                                            "circular",
                                                                                                          anchorOrigin:
                                                                                                            {
                                                                                                              vertical:
                                                                                                                "bottom",
                                                                                                              horizontal:
                                                                                                                "right",
                                                                                                            },
                                                                                                          badgeContent:
                                                                                                            (0,
                                                                                                            e.jsx)(
                                                                                                              "div",
                                                                                                              BI(
                                                                                                                {
                                                                                                                  style:
                                                                                                                    Bo,
                                                                                                                },
                                                                                                                {
                                                                                                                  children:
                                                                                                                    (0,
                                                                                                                    e.jsx)(
                                                                                                                      cI,
                                                                                                                      {
                                                                                                                        style:
                                                                                                                          {
                                                                                                                            color:
                                                                                                                              "#1976d2",
                                                                                                                          },
                                                                                                                        fontSize:
                                                                                                                          "large",
                                                                                                                      }
                                                                                                                    ),
                                                                                                                }
                                                                                                              )
                                                                                                            ),
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            (0,
                                                                                                            e.jsx)(
                                                                                                              Tm,
                                                                                                              {
                                                                                                                alt: "CSS",
                                                                                                                src: F,
                                                                                                                sx: {
                                                                                                                  width: 200,
                                                                                                                  height: 200,
                                                                                                                },
                                                                                                              }
                                                                                                            ),
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            : (0,
                                                                                              e.jsx)(
                                                                                                wp,
                                                                                                BI(
                                                                                                  {
                                                                                                    overlap:
                                                                                                      "circular",
                                                                                                    anchorOrigin:
                                                                                                      {
                                                                                                        vertical:
                                                                                                          "bottom",
                                                                                                        horizontal:
                                                                                                          "right",
                                                                                                      },
                                                                                                    badgeContent:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        "div",
                                                                                                        BI(
                                                                                                          {
                                                                                                            style:
                                                                                                              Bo,
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                cI,
                                                                                                                {
                                                                                                                  style:
                                                                                                                    {
                                                                                                                      color:
                                                                                                                        "#1976d2",
                                                                                                                    },
                                                                                                                  fontSize:
                                                                                                                    "large",
                                                                                                                }
                                                                                                              ),
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        Tm,
                                                                                                        {
                                                                                                          alt: "CSS",
                                                                                                          sx: {
                                                                                                            width: 200,
                                                                                                            height: 200,
                                                                                                          },
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                      }
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                            Z
                                                                              ? (0,
                                                                                e.jsx)(
                                                                                  Wa,
                                                                                  BI(
                                                                                    {
                                                                                      variant:
                                                                                        "body2",
                                                                                      style:
                                                                                        {
                                                                                          color:
                                                                                            "red",
                                                                                          marginTop:
                                                                                            "revert",
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        B,
                                                                                    }
                                                                                  )
                                                                                )
                                                                              : "",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsxs)(
                                                              Wa,
                                                              BI(
                                                                {
                                                                  variant: "h6",
                                                                },
                                                                {
                                                                  children: [
                                                                    " ",
                                                                    k(
                                                                      "uploadImage"
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(cO, {
                                                children: (0, e.jsx)(
                                                  Wa,
                                                  BI(
                                                    { component: "div", pr: 2 },
                                                    {
                                                      children: (0, e.jsx)(
                                                        Th,
                                                        BI(
                                                          {
                                                            loading: A,
                                                            disabled: !E,
                                                            loadingPosition:
                                                              "end",
                                                            endIcon: (0, e.jsx)(
                                                              uI,
                                                              {}
                                                            ),
                                                            variant:
                                                              "contained",
                                                            style: {
                                                              textTransform:
                                                                "capitalize",
                                                            },
                                                            onClick: z,
                                                          },
                                                          { children: N }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                }
              )
            )
          );
        },
        FI = function () {
          return (
            (FI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            FI.apply(this, arguments)
          );
        };
      function HI(n) {
        var r = (0, t.useState)(!1),
          o = r[0],
          a = r[1],
          i = (0, t.useState)(vI()[0]),
          s = i[0],
          l = i[1],
          c = n.window,
          u =
            (n.setIsDrawerOpen,
            void 0 !== c
              ? function () {
                  return c().document.body;
                }
              : void 0),
          d = function () {
            a(!o);
          },
          p = (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(_I, { setActiveTab: l, setMobileOpen: a }),
              (0, e.jsx)(Kt, {}),
            ],
          });
        return (0, e.jsxs)(e.Fragment, {
          children: [
            (0, e.jsx)(ZI, {}),
            (0, e.jsxs)(ln, {
              children: [
                (0, e.jsx)(
                  "div",
                  FI(
                    { style: { paddingLeft: "1.5rem" } },
                    {
                      children: (0, e.jsx)(
                        Kn,
                        FI(
                          {
                            color: "inherit",
                            className: "mobile-menu",
                            "aria-label": "open drawer",
                            edge: "start",
                            onClick: d,
                            sx: Co,
                          },
                          { children: (0, e.jsx)(_o, {}) }
                        )
                      ),
                    }
                  )
                ),
                (0, e.jsxs)(
                  ln,
                  FI(
                    { sx: xo },
                    {
                      children: [
                        (0, e.jsxs)(
                          ln,
                          FI(
                            {
                              component: "nav",
                              sx: So,
                              "aria-label": "mailbox folders",
                            },
                            {
                              children: [
                                (0, e.jsx)(
                                  vo,
                                  FI(
                                    {
                                      container: u,
                                      variant: "temporary",
                                      open: o,
                                      onClose: d,
                                      ModalProps: { keepMounted: !0 },
                                      sx: ko,
                                    },
                                    { children: p }
                                  )
                                ),
                                (0, e.jsx)(
                                  vo,
                                  FI(
                                    { variant: "permanent", sx: wo, open: !0 },
                                    { children: p }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)(
                          ln,
                          FI(
                            {
                              component: "main",
                              sx: Po,
                              style: { width: "100%", marginTop: "0.1px" },
                            },
                            {
                              children: (0, e.jsx)(
                                "div",
                                FI(
                                  {
                                    role: "tabpanel",
                                    hidden: !1,
                                    id: "vertical-tabpanel-".concat(s.index),
                                    "aria-labelledby": "vertical-tab-".concat(
                                      s.index
                                    ),
                                  },
                                  {
                                    children: (0, e.jsx)(ln, {
                                      children: s.component,
                                    }),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
              ],
            }),
          ],
        });
      }
      var VI = t.createContext(null);
      function WI() {
        return t.useContext(VI);
      }
      var $I =
          "function" == typeof Symbol && Symbol.for
            ? Symbol.for("mui.nested")
            : "__THEME_NESTED__",
        UI = function (n) {
          const { children: r, theme: o } = n,
            a = WI(),
            i = t.useMemo(() => {
              const e =
                null === a
                  ? o
                  : (function (e, t) {
                      return "function" == typeof t ? t(e) : (0, d.Z)({}, e, t);
                    })(a, o);
              return null != e && (e[$I] = null !== a), e;
            }, [o, a]);
          return (0, e.jsx)(VI.Provider, { value: i, children: r });
        },
        KI = o(2443);
      const GI = {};
      function qI(e, n, r, o = !1) {
        return t.useMemo(() => {
          const t = (e && n[e]) || n;
          if ("function" == typeof r) {
            const a = r(t),
              i = e ? (0, d.Z)({}, n, { [e]: a }) : a;
            return o ? () => i : i;
          }
          return e ? (0, d.Z)({}, n, { [e]: r }) : (0, d.Z)({}, n, r);
        }, [e, n, r, o]);
      }
      var YI = function (t) {
        const { children: n, theme: r, themeId: o } = t,
          a = (0, Gg.Z)(GI),
          i = WI() || GI,
          s = qI(o, a, r),
          l = qI(o, i, r, !0),
          c = "rtl" === s.direction;
        return (0, e.jsx)(UI, {
          theme: l,
          children: (0, e.jsx)(KI.T.Provider, {
            value: s,
            children: (0, e.jsx)(Jn, { value: c, children: n }),
          }),
        });
      };
      const JI = ["theme"];
      function QI(t) {
        let { theme: n } = t,
          r = (0, jt.Z)(t, JI);
        const o = n[on.Z];
        return (0, e.jsx)(
          YI,
          (0, d.Z)({}, r, { themeId: o ? on.Z : void 0, theme: o || n })
        );
      }
      var XI;
      !(function (e) {
        (e.Pop = "POP"), (e.Push = "PUSH"), (e.Replace = "REPLACE");
      })(XI || (XI = {}));
      var eT = function (e) {
          return e;
        },
        tT = "beforeunload";
      function nT(e) {
        e.preventDefault(), (e.returnValue = "");
      }
      function rT() {
        var e = [];
        return {
          get length() {
            return e.length;
          },
          push: function (t) {
            return (
              e.push(t),
              function () {
                e = e.filter(function (e) {
                  return e !== t;
                });
              }
            );
          },
          call: function (t) {
            e.forEach(function (e) {
              return e && e(t);
            });
          },
        };
      }
      var oT = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5",
          }),
          "People"
        ),
        aT = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z",
          }),
          "ChevronLeft"
        ),
        iT = function () {
          return (
            (iT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            iT.apply(this, arguments)
          );
        };
      function sT(e) {
        return (0, Zt.ZP)("MuiStepper", e);
      }
      (0, Bt.Z)("MuiStepper", [
        "root",
        "horizontal",
        "vertical",
        "alternativeLabel",
      ]);
      var lT = t.createContext({});
      var cT = t.createContext({});
      function uT(e) {
        return (0, Zt.ZP)("MuiStepConnector", e);
      }
      (0, Bt.Z)("MuiStepConnector", [
        "root",
        "horizontal",
        "vertical",
        "alternativeLabel",
        "active",
        "completed",
        "disabled",
        "line",
        "lineHorizontal",
        "lineVertical",
      ]);
      const dT = ["className"],
        pT = (0, Lt.ZP)("div", {
          name: "MuiStepConnector",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.orientation],
              n.alternativeLabel && t.alternativeLabel,
              n.completed && t.completed,
            ];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { flex: "1 1 auto" },
            "vertical" === e.orientation && { marginLeft: 12 },
            e.alternativeLabel && {
              position: "absolute",
              top: 12,
              left: "calc(-50% + 20px)",
              right: "calc(50% + 20px)",
            }
          )
        ),
        mT = (0, Lt.ZP)("span", {
          name: "MuiStepConnector",
          slot: "Line",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.line, t[`line${(0, Fn.Z)(n.orientation)}`]];
          },
        })(({ ownerState: e, theme: t }) => {
          const n =
            "light" === t.palette.mode
              ? t.palette.grey[400]
              : t.palette.grey[600];
          return (0, d.Z)(
            {
              display: "block",
              borderColor: t.vars ? t.vars.palette.StepConnector.border : n,
            },
            "horizontal" === e.orientation && {
              borderTopStyle: "solid",
              borderTopWidth: 1,
            },
            "vertical" === e.orientation && {
              borderLeftStyle: "solid",
              borderLeftWidth: 1,
              minHeight: 24,
            }
          );
        });
      var hT = t.forwardRef(function (n, r) {
        const o = (0, zt.Z)({ props: n, name: "MuiStepConnector" }),
          { className: a } = o,
          i = (0, jt.Z)(o, dT),
          { alternativeLabel: s, orientation: l = "horizontal" } =
            t.useContext(lT),
          { active: c, disabled: u, completed: p } = t.useContext(cT),
          m = (0, d.Z)({}, o, {
            alternativeLabel: s,
            orientation: l,
            active: c,
            completed: p,
            disabled: u,
          }),
          h = ((e) => {
            const {
                classes: t,
                orientation: n,
                alternativeLabel: r,
                active: o,
                completed: a,
                disabled: i,
              } = e,
              s = {
                root: [
                  "root",
                  n,
                  r && "alternativeLabel",
                  o && "active",
                  a && "completed",
                  i && "disabled",
                ],
                line: ["line", `line${(0, Fn.Z)(n)}`],
              };
            return (0, Nt.Z)(s, uT, t);
          })(m);
        return (0,
        e.jsx)(pT, (0, d.Z)({ className: (0, Rt.Z)(h.root, a), ref: r, ownerState: m }, i, { children: (0, e.jsx)(mT, { className: h.line, ownerState: m }) }));
      });
      const fT = [
          "activeStep",
          "alternativeLabel",
          "children",
          "className",
          "component",
          "connector",
          "nonLinear",
          "orientation",
        ],
        gT = (0, Lt.ZP)("div", {
          name: "MuiStepper",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.orientation],
              n.alternativeLabel && t.alternativeLabel,
            ];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            { display: "flex" },
            "horizontal" === e.orientation && {
              flexDirection: "row",
              alignItems: "center",
            },
            "vertical" === e.orientation && { flexDirection: "column" },
            e.alternativeLabel && { alignItems: "flex-start" }
          )
        ),
        vT = (0, e.jsx)(hT, {});
      var bT = t.forwardRef(function (n, r) {
        const o = (0, zt.Z)({ props: n, name: "MuiStepper" }),
          {
            activeStep: a = 0,
            alternativeLabel: i = !1,
            children: s,
            className: l,
            component: c = "div",
            connector: u = vT,
            nonLinear: p = !1,
            orientation: m = "horizontal",
          } = o,
          h = (0, jt.Z)(o, fT),
          f = (0, d.Z)({}, o, {
            alternativeLabel: i,
            orientation: m,
            component: c,
          }),
          g = ((e) => {
            const { orientation: t, alternativeLabel: n, classes: r } = e,
              o = { root: ["root", t, n && "alternativeLabel"] };
            return (0, Nt.Z)(o, sT, r);
          })(f),
          v = t.Children.toArray(s).filter(Boolean),
          b = v.map((e, n) =>
            t.cloneElement(
              e,
              (0, d.Z)({ index: n, last: n + 1 === v.length }, e.props)
            )
          ),
          _ = t.useMemo(
            () => ({
              activeStep: a,
              alternativeLabel: i,
              connector: u,
              nonLinear: p,
              orientation: m,
            }),
            [a, i, u, p, m]
          );
        return (0,
        e.jsx)(lT.Provider, { value: _, children: (0, e.jsx)(gT, (0, d.Z)({ as: c, ownerState: f, className: (0, Rt.Z)(g.root, l), ref: r }, h, { children: b })) });
      });
      function _T(e) {
        return (0, Zt.ZP)("MuiStep", e);
      }
      (0, Bt.Z)("MuiStep", [
        "root",
        "horizontal",
        "vertical",
        "alternativeLabel",
        "completed",
      ]);
      const yT = [
          "active",
          "children",
          "className",
          "component",
          "completed",
          "disabled",
          "expanded",
          "index",
          "last",
        ],
        xT = (0, Lt.ZP)("div", {
          name: "MuiStep",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.orientation],
              n.alternativeLabel && t.alternativeLabel,
              n.completed && t.completed,
            ];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {},
            "horizontal" === e.orientation && {
              paddingLeft: 8,
              paddingRight: 8,
            },
            e.alternativeLabel && { flex: 1, position: "relative" }
          )
        );
      var CT = t.forwardRef(function (n, r) {
          const o = (0, zt.Z)({ props: n, name: "MuiStep" }),
            {
              active: a,
              children: i,
              className: s,
              component: l = "div",
              completed: c,
              disabled: u,
              expanded: p = !1,
              index: m,
              last: h,
            } = o,
            f = (0, jt.Z)(o, yT),
            {
              activeStep: g,
              connector: v,
              alternativeLabel: b,
              orientation: _,
              nonLinear: y,
            } = t.useContext(lT);
          let [x = !1, C = !1, S = !1] = [a, c, u];
          g === m
            ? (x = void 0 === a || a)
            : !y && g > m
            ? (C = void 0 === c || c)
            : !y && g < m && (S = void 0 === u || u);
          const k = t.useMemo(
              () => ({
                index: m,
                last: h,
                expanded: p,
                icon: m + 1,
                active: x,
                completed: C,
                disabled: S,
              }),
              [m, h, p, x, C, S]
            ),
            w = (0, d.Z)({}, o, {
              active: x,
              orientation: _,
              alternativeLabel: b,
              completed: C,
              disabled: S,
              expanded: p,
              component: l,
            }),
            P = ((e) => {
              const {
                  classes: t,
                  orientation: n,
                  alternativeLabel: r,
                  completed: o,
                } = e,
                a = {
                  root: ["root", n, r && "alternativeLabel", o && "completed"],
                };
              return (0, Nt.Z)(a, _T, t);
            })(w),
            O = (0, e.jsxs)(
              xT,
              (0, d.Z)(
                {
                  as: l,
                  className: (0, Rt.Z)(P.root, s),
                  ref: r,
                  ownerState: w,
                },
                f,
                { children: [v && b && 0 !== m ? v : null, i] }
              )
            );
          return (0,
          e.jsx)(cT.Provider, { value: k, children: v && !b && 0 !== m ? (0, e.jsxs)(t.Fragment, { children: [v, O] }) : O });
        }),
        ST = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z",
          }),
          "CheckCircle"
        ),
        kT = (0, bo.Z)(
          (0, e.jsx)("path", {
            d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
          }),
          "Warning"
        ),
        wT = o(3502);
      function PT(e) {
        return (0, Zt.ZP)("MuiStepIcon", e);
      }
      var OT,
        IT = (0, Bt.Z)("MuiStepIcon", [
          "root",
          "active",
          "completed",
          "error",
          "text",
        ]);
      const TT = ["active", "className", "completed", "error", "icon"],
        MT = (0, Lt.ZP)(wT.Z, {
          name: "MuiStepIcon",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(({ theme: e }) => ({
          display: "block",
          transition: e.transitions.create("color", {
            duration: e.transitions.duration.shortest,
          }),
          color: (e.vars || e).palette.text.disabled,
          [`&.${IT.completed}`]: { color: (e.vars || e).palette.primary.main },
          [`&.${IT.active}`]: { color: (e.vars || e).palette.primary.main },
          [`&.${IT.error}`]: { color: (e.vars || e).palette.error.main },
        })),
        ET = (0, Lt.ZP)("text", {
          name: "MuiStepIcon",
          slot: "Text",
          overridesResolver: (e, t) => t.text,
        })(({ theme: e }) => ({
          fill: (e.vars || e).palette.primary.contrastText,
          fontSize: e.typography.caption.fontSize,
          fontFamily: e.typography.fontFamily,
        }));
      var DT = t.forwardRef(function (t, n) {
        const r = (0, zt.Z)({ props: t, name: "MuiStepIcon" }),
          {
            active: o = !1,
            className: a,
            completed: i = !1,
            error: s = !1,
            icon: l,
          } = r,
          c = (0, jt.Z)(r, TT),
          u = (0, d.Z)({}, r, { active: o, completed: i, error: s }),
          p = ((e) => {
            const { classes: t, active: n, completed: r, error: o } = e,
              a = {
                root: ["root", n && "active", r && "completed", o && "error"],
                text: ["text"],
              };
            return (0, Nt.Z)(a, PT, t);
          })(u);
        if ("number" == typeof l || "string" == typeof l) {
          const t = (0, Rt.Z)(a, p.root);
          return s
            ? (0, e.jsx)(
                MT,
                (0, d.Z)({ as: kT, className: t, ref: n, ownerState: u }, c)
              )
            : i
            ? (0, e.jsx)(
                MT,
                (0, d.Z)({ as: ST, className: t, ref: n, ownerState: u }, c)
              )
            : (0, e.jsxs)(
                MT,
                (0, d.Z)({ className: t, ref: n, ownerState: u }, c, {
                  children: [
                    OT ||
                      (OT = (0, e.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                      })),
                    (0, e.jsx)(ET, {
                      className: p.text,
                      x: "12",
                      y: "12",
                      textAnchor: "middle",
                      dominantBaseline: "central",
                      ownerState: u,
                      children: l,
                    }),
                  ],
                })
              );
        }
        return l;
      });
      function jT(e) {
        return (0, Zt.ZP)("MuiStepLabel", e);
      }
      var RT = (0, Bt.Z)("MuiStepLabel", [
        "root",
        "horizontal",
        "vertical",
        "label",
        "active",
        "completed",
        "error",
        "disabled",
        "iconContainer",
        "alternativeLabel",
        "labelContainer",
      ]);
      const NT = [
          "children",
          "className",
          "componentsProps",
          "error",
          "icon",
          "optional",
          "slotProps",
          "StepIconComponent",
          "StepIconProps",
        ],
        AT = (0, Lt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[n.orientation]];
          },
        })(({ ownerState: e }) =>
          (0, d.Z)(
            {
              display: "flex",
              alignItems: "center",
              [`&.${RT.alternativeLabel}`]: { flexDirection: "column" },
              [`&.${RT.disabled}`]: { cursor: "default" },
            },
            "vertical" === e.orientation && {
              textAlign: "left",
              padding: "8px 0",
            }
          )
        ),
        LT = (0, Lt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "Label",
          overridesResolver: (e, t) => t.label,
        })(({ theme: e }) =>
          (0, d.Z)({}, e.typography.body2, {
            display: "block",
            transition: e.transitions.create("color", {
              duration: e.transitions.duration.shortest,
            }),
            [`&.${RT.active}`]: {
              color: (e.vars || e).palette.text.primary,
              fontWeight: 500,
            },
            [`&.${RT.completed}`]: {
              color: (e.vars || e).palette.text.primary,
              fontWeight: 500,
            },
            [`&.${RT.alternativeLabel}`]: { marginTop: 16 },
            [`&.${RT.error}`]: { color: (e.vars || e).palette.error.main },
          })
        ),
        zT = (0, Lt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "IconContainer",
          overridesResolver: (e, t) => t.iconContainer,
        })(() => ({
          flexShrink: 0,
          display: "flex",
          paddingRight: 8,
          [`&.${RT.alternativeLabel}`]: { paddingRight: 0 },
        })),
        BT = (0, Lt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "LabelContainer",
          overridesResolver: (e, t) => t.labelContainer,
        })(({ theme: e }) => ({
          width: "100%",
          color: (e.vars || e).palette.text.secondary,
          [`&.${RT.alternativeLabel}`]: { textAlign: "center" },
        })),
        ZT = t.forwardRef(function (n, r) {
          var o;
          const a = (0, zt.Z)({ props: n, name: "MuiStepLabel" }),
            {
              children: i,
              className: s,
              componentsProps: l = {},
              error: c = !1,
              icon: u,
              optional: p,
              slotProps: m = {},
              StepIconComponent: h,
              StepIconProps: f,
            } = a,
            g = (0, jt.Z)(a, NT),
            { alternativeLabel: v, orientation: b } = t.useContext(lT),
            {
              active: _,
              disabled: y,
              completed: x,
              icon: C,
            } = t.useContext(cT),
            S = u || C;
          let k = h;
          S && !k && (k = DT);
          const w = (0, d.Z)({}, a, {
              active: _,
              alternativeLabel: v,
              completed: x,
              disabled: y,
              error: c,
              orientation: b,
            }),
            P = ((e) => {
              const {
                  classes: t,
                  orientation: n,
                  active: r,
                  completed: o,
                  error: a,
                  disabled: i,
                  alternativeLabel: s,
                } = e,
                l = {
                  root: [
                    "root",
                    n,
                    a && "error",
                    i && "disabled",
                    s && "alternativeLabel",
                  ],
                  label: [
                    "label",
                    r && "active",
                    o && "completed",
                    a && "error",
                    i && "disabled",
                    s && "alternativeLabel",
                  ],
                  iconContainer: [
                    "iconContainer",
                    r && "active",
                    o && "completed",
                    a && "error",
                    i && "disabled",
                    s && "alternativeLabel",
                  ],
                  labelContainer: ["labelContainer", s && "alternativeLabel"],
                };
              return (0, Nt.Z)(l, jT, t);
            })(w),
            O = null != (o = m.label) ? o : l.label;
          return (0,
          e.jsxs)(AT, (0, d.Z)({ className: (0, Rt.Z)(P.root, s), ref: r, ownerState: w }, g, { children: [S || k ? (0, e.jsx)(zT, { className: P.iconContainer, ownerState: w, children: (0, e.jsx)(k, (0, d.Z)({ completed: x, active: _, error: c, icon: S }, f)) }) : null, (0, e.jsxs)(BT, { className: P.labelContainer, ownerState: w, children: [i ? (0, e.jsx)(LT, (0, d.Z)({ ownerState: w }, O, { className: (0, Rt.Z)(P.label, null == O ? void 0 : O.className), children: i })) : null, p] })] }));
        });
      ZT.muiName = "StepLabel";
      var FT = ZT,
        HT = function () {
          return (
            (HT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            HT.apply(this, arguments)
          );
        },
        VT = function () {
          return (
            (VT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            VT.apply(this, arguments)
          );
        },
        WT = function () {
          var n = (function () {
              var e = this,
                n = g(),
                r = (0, t.useState)(0),
                o = r[0],
                a = r[1],
                i = (0, t.useState)({
                  fileName: "",
                  filePath: "",
                  fileSize: "",
                }),
                s = i[0],
                l = i[1],
                c = (0, t.useState)({
                  firstName: "",
                  lastName: "",
                  emailId: "",
                  phoneNumber: "",
                  fbHandle: "",
                  instHandle: "",
                }),
                u = c[0],
                d = c[1],
                p = (0, t.useState)({
                  firstNameErrMsg: "",
                  lastNameErrMsg: "",
                  emailIdErrMsg: "",
                  phoneNumberErrMsg: "",
                  fileSizeErrMsg: "",
                }),
                m = p[0],
                h = p[1],
                f =
                  u.firstName.length > 0 &&
                  u.lastName.length > 0 &&
                  u.emailId.length > 0 &&
                  u.phoneNumber.length > 0 &&
                  "" === m.firstNameErrMsg &&
                  "" === m.lastNameErrMsg &&
                  "" === m.emailIdErrMsg &&
                  "" === m.phoneNumberErrMsg &&
                  "" === m.fileSizeErrMsg,
                v = (0, t.useState)(),
                b = v[0],
                _ = v[1],
                y = (0, t.useState)(!1),
                x = y[0],
                C = y[1],
                S = (0, t.useState)(!1),
                k = S[0],
                w = S[1],
                P = (0, t.useState)(),
                O = P[0],
                I = P[1],
                T = X().t,
                M = (0, t.useState)(!1),
                E = M[0],
                D = M[1],
                j = function () {
                  l({ fileName: "", filePath: "", fileSize: "" });
                };
              return {
                stepper: ["", "", "", ""],
                activeStep: o,
                handleNext: function () {
                  a(function (e) {
                    return e + 1;
                  });
                },
                handleBack: function () {
                  a(function (e) {
                    return e - 1;
                  });
                },
                getUploadedFileDetails: function (e) {
                  e.target.files &&
                  e.target.files[0] &&
                  e.target.files[0].size <= 5e6
                    ? (l({
                        fileName: e.target.files[0].name,
                        filePath: URL.createObjectURL(e.target.files[0]),
                        fileSize: e.target.files[0].size,
                      }),
                      _(e.target.files[0]),
                      h(function (e) {
                        return HT(HT({}, e), { fileSizeErrMsg: "" });
                      }))
                    : e.target.files[0].size > 5e6 &&
                      (j(),
                      h(function (e) {
                        return HT(HT({}, e), {
                          fileSizeErrMsg: T("signup_fileSizeError"),
                        });
                      }));
                },
                selectFile: s,
                signupBtnEnabled: f,
                requiredFields: u,
                errMsgFields: m,
                changeFormValue: function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    o = n.value;
                  d(HT(HT({}, u), (((t = {})[r] = o), t))),
                    (function (e, t) {
                      switch (e) {
                        case "firstName":
                          h(
                            "" === t
                              ? function (e) {
                                  return HT(HT({}, e), {
                                    firstNameErrMsg: T("required_ErrorMsg"),
                                  });
                                }
                              : function (e) {
                                  return HT(HT({}, e), { firstNameErrMsg: "" });
                                }
                          );
                          break;
                        case "lastName":
                          h(
                            "" === t
                              ? function (e) {
                                  return HT(HT({}, e), {
                                    lastNameErrMsg: T("required_ErrorMsg"),
                                  });
                                }
                              : function (e) {
                                  return HT(HT({}, e), { lastNameErrMsg: "" });
                                }
                          );
                          break;
                        case "emailId":
                          "" === t
                            ? h(function (e) {
                                return HT(HT({}, e), {
                                  emailIdErrMsg: T("required_ErrorMsg"),
                                });
                              })
                            : Rb(t.trim())
                            ? h(function (e) {
                                return HT(HT({}, e), {
                                  emailIdErrMsg: T("emailValidation_ErrorMsg"),
                                });
                              })
                            : h(function (e) {
                                return HT(HT({}, e), { emailIdErrMsg: "" });
                              });
                          break;
                        case "phoneNumber":
                          "" === t
                            ? h(function (e) {
                                return HT(HT({}, e), {
                                  phoneNumberErrMsg: T("required_ErrorMsg"),
                                });
                              })
                            : t.length < 10
                            ? h(function (e) {
                                return HT(HT({}, e), {
                                  phoneNumberErrMsg: T(
                                    "signup_phone_number_Error"
                                  ),
                                });
                              })
                            : h(function (e) {
                                return HT(HT({}, e), { phoneNumberErrMsg: "" });
                              });
                      }
                    })(r, o);
                },
                removeSelectedFile: j,
                saveDetails: function () {
                  return (
                    (t = e),
                    (r = void 0),
                    (a = function () {
                      var e;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return (
                              C(!0),
                              [4, n(Fg({ fileUpload: b, userDetails: u }))]
                            );
                          case 1:
                            return (
                              200 === (e = t.sent()).StatusCode
                                ? (D(!0), w(!0))
                                : D(!1),
                              I(e.StatusDescription),
                              C(!1),
                              d({
                                firstName: "",
                                lastName: "",
                                emailId: "",
                                phoneNumber: "",
                                fbHandle: "",
                                instHandle: "",
                              }),
                              l({ fileName: "", filePath: "", fileSize: "" }),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((o = void 0) || (o = Promise))(function (e, n) {
                      function i(e) {
                        try {
                          l(a.next(e));
                        } catch (e) {
                          n(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(a.throw(e));
                        } catch (e) {
                          n(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof o
                              ? n
                              : new o(function (e) {
                                  e(n);
                                })).then(i, s);
                      }
                      l((a = a.apply(t, r || [])).next());
                    })
                  );
                  var t, r, o, a;
                },
                saveDetailsFlag: k,
                loadingFlag: x,
                onInputClick: function (e) {
                  (e.target.value = ""),
                    h(function (e) {
                      return HT(HT({}, e), { fileSizeErrMsg: "" });
                    });
                },
                responseMessage: O,
                successFlag: E,
              };
            })(),
            r = n.stepper,
            o = n.activeStep,
            a = n.handleNext,
            i = n.handleBack,
            s = n.getUploadedFileDetails,
            l = n.selectFile,
            c = n.signupBtnEnabled,
            u = n.requiredFields,
            d = n.errMsgFields,
            p = n.changeFormValue,
            m = n.removeSelectedFile,
            h = n.saveDetails,
            f = n.saveDetailsFlag,
            v = n.loadingFlag,
            b = n.onInputClick,
            _ = n.responseMessage,
            y = n.successFlag,
            x = X().t;
          return (0, e.jsxs)(
            c_,
            VT(
              { p: 2 },
              {
                children: [
                  (0, e.jsxs)(
                    Wa,
                    VT(
                      { component: "div", hidden: f },
                      {
                        children: [
                          (0, e.jsx)(
                            bT,
                            VT(
                              { activeStep: o },
                              {
                                children: r.map(function (t, n) {
                                  return (0,
                                  e.jsx)(CT, { children: (0, e.jsx)(FT, { children: t }) }, t + "_" + n);
                                }),
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            La,
                            VT(
                              { container: !0, mt: 3 },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    La,
                                    VT(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 0 != o,
                                        p: 2,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(Xd, {
                                            type: "text",
                                            fullWidth: !0,
                                            required: !0,
                                            label: x("signup_firstName"),
                                            name: "firstName",
                                            sx: { mb: 5 },
                                            value: u.firstName,
                                            error:
                                              "" !==
                                              (null == d
                                                ? void 0
                                                : d.firstNameErrMsg),
                                            helperText:
                                              null == d
                                                ? void 0
                                                : d.firstNameErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                          (0, e.jsx)(Xd, {
                                            type: "text",
                                            fullWidth: !0,
                                            required: !0,
                                            label: x("signup_lastName"),
                                            name: "lastName",
                                            sx: { mb: 3 },
                                            value: u.lastName,
                                            error:
                                              "" !==
                                              (null == d
                                                ? void 0
                                                : d.lastNameErrMsg),
                                            helperText:
                                              null == d
                                                ? void 0
                                                : d.lastNameErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    La,
                                    VT(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 1 != o,
                                        p: 2,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(Xd, {
                                            type: "email",
                                            fullWidth: !0,
                                            required: !0,
                                            label: x("login_email"),
                                            name: "emailId",
                                            sx: { mb: 5 },
                                            value: u.emailId,
                                            error:
                                              "" !==
                                              (null == d
                                                ? void 0
                                                : d.emailIdErrMsg),
                                            helperText:
                                              null == d
                                                ? void 0
                                                : d.emailIdErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                          (0, e.jsx)(Xd, {
                                            type: "number",
                                            fullWidth: !0,
                                            onKeyDown: iv,
                                            required: !0,
                                            label: x("signup_phone_number"),
                                            name: "phoneNumber",
                                            sx: { mb: 3 },
                                            value: u.phoneNumber,
                                            error:
                                              "" !==
                                              (null == d
                                                ? void 0
                                                : d.phoneNumberErrMsg),
                                            helperText:
                                              null == d
                                                ? void 0
                                                : d.phoneNumberErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    La,
                                    VT(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 2 != o,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            "div",
                                            VT(
                                              { className: "ST_SU_Display" },
                                              {
                                                children: (0, e.jsxs)(
                                                  vp,
                                                  VT(
                                                    {
                                                      component: "label",
                                                      sx: {
                                                        height: "100px",
                                                        width: "50%",
                                                        border: "1px dashed",
                                                        textTransform:
                                                          "capitalize",
                                                      },
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          Wa,
                                                          VT(
                                                            {
                                                              component: "span",
                                                              hidden:
                                                                l.filePath,
                                                            },
                                                            {
                                                              children: x(
                                                                "signup_uploadPicture"
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          Wa,
                                                          VT(
                                                            {
                                                              component: "span",
                                                              hidden:
                                                                !l.filePath,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(Tm, {
                                                                alt: "image",
                                                                src: l.filePath,
                                                                variant:
                                                                  "rounded",
                                                                sx: {
                                                                  width: "100%",
                                                                  height:
                                                                    "85px",
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)("input", {
                                                          type: "file",
                                                          hidden: !0,
                                                          onChange: s,
                                                          onClick: b,
                                                        }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Wa,
                                            VT(
                                              {
                                                component: "div",
                                                p: 2,
                                                className:
                                                  "ST_SU_TextField ST_SU_TextColor",
                                              },
                                              {
                                                children: (0, e.jsxs)("b", {
                                                  children: [
                                                    " ",
                                                    x("signup_filePath_lable"),
                                                    " :",
                                                    (0, e.jsxs)(
                                                      Wa,
                                                      VT(
                                                        {
                                                          component: "span",
                                                          hidden:
                                                            "" !==
                                                            (null == d
                                                              ? void 0
                                                              : d.fileSizeErrMsg),
                                                        },
                                                        {
                                                          children: [
                                                            " ",
                                                            (null == l
                                                              ? void 0
                                                              : l.fileName) ||
                                                              "  -",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Wa,
                                            VT(
                                              {
                                                align: "center",
                                                hidden:
                                                  "" ==
                                                  (null == d
                                                    ? void 0
                                                    : d.fileSizeErrMsg),
                                                sx: { color: "red" },
                                              },
                                              { children: d.fileSizeErrMsg }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Wa,
                                            VT(
                                              {
                                                component: "div",
                                                className: "ST_SU_TextField",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  vp,
                                                  VT(
                                                    {
                                                      disabled:
                                                        "" == l.filePath,
                                                    },
                                                    {
                                                      children: (0, e.jsx)(uv, {
                                                        sx: {
                                                          cursor: "pointer",
                                                        },
                                                        onClick: function () {
                                                          return m();
                                                        },
                                                      }),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    La,
                                    VT(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 3 != o,
                                        p: 2,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            Wa,
                                            VT(
                                              {
                                                variant: "subtitle1",
                                                sx: { mb: 3 },
                                              },
                                              {
                                                children:
                                                  x("signup_MediaTitle2"),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(Xd, {
                                            type: "text",
                                            fullWidth: !0,
                                            label: x("signup_facebookHandle"),
                                            name: "fbHandle",
                                            sx: { mb: 3 },
                                            value: u.fbHandle,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                          (0, e.jsx)(Xd, {
                                            type: "text",
                                            fullWidth: !0,
                                            label: x("signup_InstaHandle"),
                                            name: "instHandle",
                                            sx: { mb: 3 },
                                            value: u.instHandle,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    La,
                                    VT(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 12,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        mt: 3,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            vp,
                                            VT(
                                              {
                                                disabled: 0 === o,
                                                onClick: i,
                                                variant: "contained",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              { children: x("signup_BackBtn") }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Th,
                                            VT(
                                              {
                                                loading: v,
                                                size: "large",
                                                disabled:
                                                  o === r.length - 1 && !c,
                                                onClick:
                                                  o === r.length - 1 ? h : a,
                                                variant: "contained",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children:
                                                  o === r.length - 1
                                                    ? x("submit_btn_text")
                                                    : x("signup_NextBtn"),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Wa,
                    VT(
                      {
                        variant: "h6",
                        hidden: !f,
                        sx: { color: y ? "green" : "red" },
                      },
                      { children: _ }
                    )
                  ),
                ],
              }
            )
          );
        },
        $T = function () {
          return (
            ($T =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            $T.apply(this, arguments)
          );
        },
        UT = function () {
          return (
            (UT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            UT.apply(this, arguments)
          );
        },
        KT = function () {
          var n = (function () {
              var e = this,
                n = g(),
                r = (0, t.useState)(!1),
                o = r[0],
                a = r[1],
                i = (0, t.useState)(""),
                s = i[0],
                l = i[1],
                c = (0, t.useState)({ emailErrMsg: "" }),
                u = c[0],
                d = c[1],
                p = s.length > 0 && "" === u.emailErrMsg,
                m = (0, t.useState)(""),
                h = m[0],
                f = m[1],
                v = (0, t.useState)(!1),
                b = v[0],
                _ = v[1],
                y = X().t,
                x = function () {
                  return (
                    (t = e),
                    (r = void 0),
                    (i = function () {
                      var e;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return a(!0), [4, n(Vg(s))];
                          case 1:
                            return (
                              200 == (e = t.sent()).status
                                ? (_(!0), a(!1), l(""))
                                : 500 == e.status &&
                                  (_(!1), a(!1), f(e.message)),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((o = void 0) || (o = Promise))(function (e, n) {
                      function a(e) {
                        try {
                          l(i.next(e));
                        } catch (e) {
                          n(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(i.throw(e));
                        } catch (e) {
                          n(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof o
                              ? n
                              : new o(function (e) {
                                  e(n);
                                })).then(a, s);
                      }
                      l((i = i.apply(t, r || [])).next());
                    })
                  );
                  var t, r, o, i;
                };
              return {
                errorMessage: u,
                isLoadingFlag: o,
                resetPasswordErrMsg: h,
                resetBtnEnabled: p,
                emailField: s,
                emailValidFlag: b,
                handleEmailChange: function (e) {
                  var t = e.target.value;
                  (function (e) {
                    "" === e
                      ? d(function (e) {
                          return $T($T({}, e), {
                            emailErrMsg: y("required_ErrorMsg"),
                          });
                        })
                      : Rb(e.trim())
                      ? d(function (e) {
                          return $T($T({}, e), {
                            emailErrMsg: y("emailValidation_ErrorMsg"),
                          });
                        })
                      : d(function (e) {
                          return $T($T({}, e), { emailErrMsg: "" });
                        });
                  })(t),
                    l(t),
                    f("");
                },
                resetPassword: x,
                handleKeyDown: function (e) {
                  "Enter" === e.key && 13 === e.keyCode && p && x();
                },
              };
            })(),
            r = n.errorMessage,
            o = n.resetPasswordErrMsg,
            a = n.resetBtnEnabled,
            i = n.isLoadingFlag,
            s = n.handleEmailChange,
            l = n.resetPassword,
            c = n.emailValidFlag,
            u = n.handleKeyDown,
            d = X().t;
          return (0, e.jsxs)(c_, {
            children: [
              (0, e.jsx)(
                Wa,
                UT(
                  { component: "div", hidden: c },
                  {
                    children: (0, e.jsxs)(
                      La,
                      UT(
                        { container: !0, p: 3, display: "flex" },
                        {
                          children: [
                            (0, e.jsxs)(
                              La,
                              UT(
                                { item: !0, xs: 12, md: 12 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      Wa,
                                      UT(
                                        { variant: "subtitle1", mb: 2 },
                                        {
                                          children: (0, e.jsx)("b", {
                                            children:
                                              "Enter your email to receive new password",
                                          }),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(Xd, {
                                      type: "email",
                                      fullWidth: !0,
                                      label: d("login_email"),
                                      name: "emailid",
                                      error: null == r ? void 0 : r.emailErrMsg,
                                      helperText:
                                        null == r ? void 0 : r.emailErrMsg,
                                      onChange: function (e) {
                                        return s(e);
                                      },
                                      onKeyDown: u,
                                    }),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsx)(
                              La,
                              UT(
                                {
                                  item: !0,
                                  xs: 12,
                                  mt: 5,
                                  display: "flex",
                                  justifyContent: "center",
                                },
                                {
                                  children: (0, e.jsx)(
                                    Th,
                                    UT(
                                      {
                                        size: "large",
                                        variant: "contained",
                                        disabled: !a,
                                        loading: i,
                                        sx: {
                                          fontSize: "16px",
                                          textTransform: "capitalize",
                                          cursor: "pointer",
                                        },
                                        onClick: l,
                                      },
                                      { children: d("forgotPwd_ResetBtn") }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                La,
                UT(
                  {
                    item: !0,
                    xs: 12,
                    display: "flex",
                    justifyContent: "center",
                  },
                  {
                    children: (0, e.jsx)(
                      Wa,
                      UT(
                        {
                          variant: "h6",
                          justifyContent: "center",
                          my: 5,
                          hidden: !c,
                          sx: { color: "green", margin: "2rem" },
                        },
                        { children: d("forgotPwd_SuccessMsg") }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                La,
                UT(
                  {
                    item: !0,
                    xs: 12,
                    display: "flex",
                    justifyContent: "center",
                  },
                  {
                    children: (0, e.jsx)(
                      Wa,
                      UT(
                        {
                          variant: "subtitle1",
                          my: 3,
                          hidden: "" == o,
                          sx: { color: "red" },
                        },
                        { children: o }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        GT = function () {
          return (
            (GT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            GT.apply(this, arguments)
          );
        },
        qT = function () {
          var n = (function () {
              var e = this,
                n = X().t,
                r = [
                  { description: n("login_sliderContent_1") },
                  { description: n("login_sliderContent_2") },
                  { description: n("login_sliderContent_3") },
                  { description: n("login_sliderContent_4") },
                  { description: n("login_sliderContent_5") },
                  { description: n("login_sliderContent_6") },
                ],
                o = g(),
                a = (0, t.useState)(0),
                i = a[0],
                s = a[1],
                l = (0, t.useState)({ emailField: "", passwordField: "" }),
                c = l[0],
                u = l[1],
                d = (0, t.useState)({ emailErrMsg: "", passwordErrMsg: "" }),
                p = d[0],
                m = d[1],
                h = (0, t.useState)(!0),
                f = h[0],
                v = h[1],
                b = (0, t.useState)(!1),
                _ = b[0],
                y = b[1],
                x = (0, t.useState)(!1),
                C = x[0],
                S = x[1],
                k =
                  c.emailField.length > 0 &&
                  c.passwordField.length > 0 &&
                  "" === p.emailErrMsg &&
                  "" === p.passwordErrMsg,
                w = (0, t.useState)(""),
                P = w[0],
                O = w[1],
                I = (0, t.useState)(!1),
                T = I[0],
                M = I[1],
                E = function () {
                  return (
                    (t = e),
                    (n = void 0),
                    (a = function () {
                      var e;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return M(!0), [4, o(Hg(c))];
                          case 1:
                            return (
                              200 == (e = t.sent()).status
                                ? (sessionStorage.setItem(
                                    "Authorization",
                                    btoa(JSON.stringify(e))
                                  ),
                                  M(!1),
                                  u({ emailField: "", passwordField: "" }),
                                  gf.next(!0))
                                : 500 == e.status &&
                                  (O(e.message),
                                  M(!1),
                                  setTimeout(function () {
                                    O("");
                                  }, 15e3)),
                              M(!1),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((r = void 0) || (r = Promise))(function (e, o) {
                      function i(e) {
                        try {
                          l(a.next(e));
                        } catch (e) {
                          o(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(a.throw(e));
                        } catch (e) {
                          o(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof r
                              ? n
                              : new r(function (e) {
                                  e(n);
                                })).then(i, s);
                      }
                      l((a = a.apply(t, n || [])).next());
                    })
                  );
                  var t, n, r, a;
                },
                D = Qg("(min-width:930px");
              return {
                sliderContent: r,
                index: i,
                setIndex: s,
                handleChange: function (e) {
                  s(e);
                },
                formFields: c,
                errorMessage: p,
                changeFieldsValue: function (e) {
                  var t,
                    r = e.target,
                    o = r.name,
                    a = r.value;
                  u(iT(iT({}, c), (((t = {})[o] = a), t))),
                    (function (e, t) {
                      "emailField" === e &&
                        ("" === t
                          ? m(function (e) {
                              return iT(iT({}, e), {
                                emailErrMsg: n("required_ErrorMsg"),
                              });
                            })
                          : Rb(t.trim())
                          ? m(function (e) {
                              return iT(iT({}, e), {
                                emailErrMsg: n("emailValidation_ErrorMsg"),
                              });
                            })
                          : m(function (e) {
                              return iT(iT({}, e), { emailErrMsg: "" });
                            })),
                        "passwordField" === e &&
                          ("" === t
                            ? m(function (e) {
                                return iT(iT({}, e), {
                                  passwordErrMsg: n("required_ErrorMsg"),
                                });
                              })
                            : t.match(av)
                            ? m(function (e) {
                                return iT(iT({}, e), { passwordErrMsg: "" });
                              })
                            : m(function (e) {
                                return iT(iT({}, e), {
                                  passwordErrMsg:
                                    "Password should contain minimum 8 characters,1 uppercase,1 lowercase,1 digit etc.",
                                });
                              }));
                    })(o, a);
                },
                userLogin: E,
                loginBtnEnabled: k,
                loginUI: f,
                signupUI: _,
                forgotPasswordUI: C,
                toggleUI: function (e) {
                  switch (e) {
                    case 1:
                      u({ emailField: "", passwordField: "" }),
                        m({ emailErrMsg: "", passwordErrMsg: "" }),
                        v(!0),
                        y(!1),
                        S(!1);
                      break;
                    case 2:
                      y(!0), v(!1), S(!1);
                      break;
                    case 3:
                      S(!0), v(!1), y(!1);
                  }
                },
                userLoginErrMsg: P,
                loginLoadingFlag: T,
                matchWidth: D,
                handleKeyDown: function (e) {
                  "Enter" === e.key && 13 === e.keyCode && k && E();
                },
              };
            })(),
            r = (n.sliderContent, n.index, n.handleChange, n.formFields),
            o = n.errorMessage,
            a = n.changeFieldsValue,
            i = n.userLogin,
            s = n.loginBtnEnabled,
            l = n.loginUI,
            c = n.signupUI,
            u = n.toggleUI,
            d = n.userLoginErrMsg,
            p = n.loginLoadingFlag,
            m = n.matchWidth,
            h = n.handleKeyDown,
            f = X().t;
          return (0, e.jsxs)(
            c_,
            GT(
              { sx: { backgroundColor: "#e9e9e9", height: "100vh" } },
              {
                children: [
                  (0, e.jsx)(
                    La,
                    GT(
                      {
                        item: !0,
                        md: 1,
                        mt: 2,
                        hidden: !m,
                        sx: { textAlign: "center" },
                        position: "absolute",
                        right: "15px",
                      },
                      { children: (0, e.jsx)(NI, GT({}, { color: "black" })) }
                    )
                  ),
                  (0, e.jsxs)(
                    nI,
                    GT(
                      { sx: { backgroundColor: "#e9e9e9" } },
                      {
                        children: [
                          (0, e.jsx)(
                            La,
                            GT(
                              { container: !0, p: 3, alignItems: "center" },
                              {
                                children: (0, e.jsx)(
                                  La,
                                  GT(
                                    { item: !0, xs: 12, md: 12 },
                                    {
                                      children: (0, e.jsx)(
                                        Wa,
                                        GT(
                                          {
                                            variant: "h4",
                                            pt: 2,
                                            sx: {
                                              color: "#000000",
                                              textAlign: "center",
                                            },
                                          },
                                          { children: f("login_welcome_Msg") }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            La,
                            GT(
                              { container: !0, p: 3, alignItems: "center" },
                              {
                                children: (0, e.jsx)(
                                  La,
                                  GT(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 12,
                                      display: "flex",
                                      justifyContent: "center",
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        La,
                                        GT(
                                          {
                                            item: !0,
                                            mt: 3,
                                            xs: 12,
                                            md: 6,
                                            sx: {
                                              backgroundColor: "#e9e9e9",
                                              borderRadius: "22px",
                                            },
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)("div", {
                                                children: (0, e.jsxs)(
                                                  Wa,
                                                  GT(
                                                    {
                                                      variant: "h5",
                                                      p: 1,
                                                      mt: 2,
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      sx: { color: "#555555" },
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(oT, {
                                                          sx: {
                                                            fontSize: "2.8rem",
                                                            mr: 2,
                                                          },
                                                        }),
                                                        " ",
                                                        (0, e.jsx)("b", {
                                                          children: f(
                                                            l
                                                              ? "login_title"
                                                              : c
                                                              ? "signup_title"
                                                              : "forgotPwd_title"
                                                          ),
                                                        }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }),
                                              (0, e.jsx)(
                                                Wa,
                                                GT(
                                                  {
                                                    component: "div",
                                                    hidden: l,
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      Wa,
                                                      GT(
                                                        {
                                                          variant: "subtitle1",
                                                          className:
                                                            "ST_CursorCss",
                                                          p: 1,
                                                          mt: 2,
                                                          display: "flex",
                                                          justifyContent:
                                                            "flex-start",
                                                          sx: {
                                                            color: "#004aab",
                                                            textDecoration:
                                                              "underline",
                                                          },
                                                          onClick: function () {
                                                            u(1);
                                                          },
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(aT, {
                                                              sx: {
                                                                fontSize:
                                                                  "2rem",
                                                              },
                                                            }),
                                                            f(
                                                              "signup_BackTo_login"
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              l
                                                ? (0, e.jsx)(
                                                    c_,
                                                    GT(
                                                      { mt: 1 },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "div",
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              La,
                                                              GT(
                                                                {
                                                                  container: !0,
                                                                  p: 3,
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsx)(
                                                                      La,
                                                                      GT(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          md: 12,
                                                                          mt: 2,
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Xd,
                                                                              {
                                                                                type: "email",
                                                                                fullWidth:
                                                                                  !0,
                                                                                required:
                                                                                  !0,
                                                                                label:
                                                                                  f(
                                                                                    "login_email"
                                                                                  ),
                                                                                name: "emailField",
                                                                                value:
                                                                                  null ==
                                                                                  r
                                                                                    ? void 0
                                                                                    : r.emailField,
                                                                                error:
                                                                                  "" !==
                                                                                  (null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.emailErrMsg),
                                                                                helperText:
                                                                                  null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.emailErrMsg,
                                                                                onChange:
                                                                                  function (
                                                                                    e
                                                                                  ) {
                                                                                    return a(
                                                                                      e
                                                                                    );
                                                                                  },
                                                                                onKeyDown:
                                                                                  h,
                                                                                autoComplete:
                                                                                  "new-password",
                                                                              }
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      La,
                                                                      GT(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          md: 12,
                                                                          mt: 5,
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Xd,
                                                                              {
                                                                                type: "password",
                                                                                fullWidth:
                                                                                  !0,
                                                                                required:
                                                                                  !0,
                                                                                label:
                                                                                  f(
                                                                                    "login_password"
                                                                                  ),
                                                                                name: "passwordField",
                                                                                value:
                                                                                  null ==
                                                                                  r
                                                                                    ? void 0
                                                                                    : r.passwordField,
                                                                                error:
                                                                                  "" !==
                                                                                  (null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.passwordErrMsg),
                                                                                helperText:
                                                                                  null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.passwordErrMsg,
                                                                                onChange:
                                                                                  function (
                                                                                    e
                                                                                  ) {
                                                                                    return a(
                                                                                      e
                                                                                    );
                                                                                  },
                                                                                autoComplete:
                                                                                  "new-password",
                                                                                onKeyDown:
                                                                                  h,
                                                                              }
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsxs)(
                                                                      "div",
                                                                      GT(
                                                                        {
                                                                          style:
                                                                            {
                                                                              display:
                                                                                "flex",
                                                                              justifyContent:
                                                                                "space-between",
                                                                              width:
                                                                                "100%",
                                                                              flexDirection:
                                                                                m
                                                                                  ? "row"
                                                                                  : "column",
                                                                              paddingTop:
                                                                                m
                                                                                  ? "10px"
                                                                                  : "24px",
                                                                            },
                                                                        },
                                                                        {
                                                                          children:
                                                                            [
                                                                              (0,
                                                                              e.jsx)(
                                                                                "div",
                                                                                GT(
                                                                                  {
                                                                                    style:
                                                                                      {
                                                                                        paddingTop:
                                                                                          "10px",
                                                                                      },
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Wa,
                                                                                        GT(
                                                                                          {
                                                                                            component:
                                                                                              "div",
                                                                                            variant:
                                                                                              "subtitle1",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsxs)(
                                                                                                Il,
                                                                                                GT(
                                                                                                  {
                                                                                                    className:
                                                                                                      "ST_CursorCss",
                                                                                                    onClick:
                                                                                                      function () {
                                                                                                        u(
                                                                                                          2
                                                                                                        );
                                                                                                      },
                                                                                                    style:
                                                                                                      {
                                                                                                        color:
                                                                                                          "#555555",
                                                                                                        textDecorationColor:
                                                                                                          "#555555",
                                                                                                      },
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      [
                                                                                                        f(
                                                                                                          "login_newUser"
                                                                                                        ),
                                                                                                        (0,
                                                                                                        e.jsxs)(
                                                                                                          "b",
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                " ",
                                                                                                                f(
                                                                                                                  "login_SignUp"
                                                                                                                ),
                                                                                                              ],
                                                                                                          }
                                                                                                        ),
                                                                                                      ],
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                  }
                                                                                )
                                                                              ),
                                                                              (0,
                                                                              e.jsx)(
                                                                                "div",
                                                                                GT(
                                                                                  {
                                                                                    style:
                                                                                      {
                                                                                        paddingTop:
                                                                                          "10px",
                                                                                      },
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Wa,
                                                                                        GT(
                                                                                          {
                                                                                            component:
                                                                                              "div",
                                                                                            variant:
                                                                                              "subtitle1",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Il,
                                                                                                GT(
                                                                                                  {
                                                                                                    className:
                                                                                                      "ST_CursorCss",
                                                                                                    onClick:
                                                                                                      function () {
                                                                                                        u(
                                                                                                          3
                                                                                                        );
                                                                                                      },
                                                                                                    style:
                                                                                                      {
                                                                                                        color:
                                                                                                          "#555555",
                                                                                                        textDecorationColor:
                                                                                                          "#555555",
                                                                                                      },
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        "b",
                                                                                                        {
                                                                                                          children:
                                                                                                            f(
                                                                                                              "login_forgotPassword_link"
                                                                                                            ),
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                  }
                                                                                )
                                                                              ),
                                                                            ],
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      La,
                                                                      GT(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          mt: 5,
                                                                          display:
                                                                            "flex",
                                                                          justifyContent:
                                                                            "center",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Th,
                                                                              GT(
                                                                                {
                                                                                  loading:
                                                                                    p,
                                                                                  size: "large",
                                                                                  disabled:
                                                                                    !s,
                                                                                  onClick:
                                                                                    i,
                                                                                  variant:
                                                                                    "contained",
                                                                                  sx: {
                                                                                    fontSize:
                                                                                      "16px",
                                                                                    textTransform:
                                                                                      "uppercase",
                                                                                    cursor:
                                                                                      "pointer",
                                                                                    backgroundColor:
                                                                                      "#000000",
                                                                                    color:
                                                                                      "#ffffff",
                                                                                  },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    f(
                                                                                      "login_LogInBtn"
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      La,
                                                                      GT(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          display:
                                                                            "flex",
                                                                          justifyContent:
                                                                            "center",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Wa,
                                                                              GT(
                                                                                {
                                                                                  variant:
                                                                                    "subtitle1",
                                                                                  mt: 2,
                                                                                  sx: {
                                                                                    color:
                                                                                      "red",
                                                                                    display:
                                                                                      "" ===
                                                                                      d
                                                                                        ? "none"
                                                                                        : "block",
                                                                                  },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    d,
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        ),
                                                      }
                                                    )
                                                  )
                                                : c
                                                ? (0, e.jsx)(
                                                    c_,
                                                    GT(
                                                      { mt: 1 },
                                                      {
                                                        children: (0, e.jsx)(
                                                          WT,
                                                          {}
                                                        ),
                                                      }
                                                    )
                                                  )
                                                : (0, e.jsxs)(
                                                    c_,
                                                    GT(
                                                      { mt: 1 },
                                                      {
                                                        children: [
                                                          (0, e.jsx)("div", {
                                                            onClick:
                                                              function () {
                                                                u(1);
                                                              },
                                                          }),
                                                          (0, e.jsx)(KT, {}),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        YT = function () {
          return (
            (YT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            YT.apply(this, arguments)
          );
        },
        JT = function () {
          return (
            (JT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            JT.apply(this, arguments)
          );
        };
      r.render(
        (0, e.jsx)(t.StrictMode, {
          children: (0, e.jsx)(
            function (e) {
              var n = e.store,
                r = e.context,
                o = e.children,
                i = (0, t.useMemo)(
                  function () {
                    var e = c(n);
                    return { store: n, subscription: e };
                  },
                  [n]
                ),
                s = (0, t.useMemo)(
                  function () {
                    return n.getState();
                  },
                  [n]
                );
              u(
                function () {
                  var e = i.subscription;
                  return (
                    (e.onStateChange = e.notifyNestedSubs),
                    e.trySubscribe(),
                    s !== n.getState() && e.notifyNestedSubs(),
                    function () {
                      e.tryUnsubscribe(), (e.onStateChange = null);
                    }
                  );
                },
                [i, s]
              );
              var l = r || a;
              return t.createElement(l.Provider, { value: i }, o);
            },
            JT(
              { store: z },
              {
                children: (0, e.jsx)(function () {
                  var n = (0, t.useState)(!1),
                    r = n[0],
                    o = n[1],
                    a = (0, t.useState)(!1),
                    i = a[0],
                    s = a[1],
                    l = (0, t.useState)(!1),
                    c = l[0],
                    u = l[1],
                    p = (0, t.useState)(""),
                    m = p[0],
                    h = p[1],
                    f = (0, rn.Z)({
                      zIndex: {
                        modal: 99999,
                        tooltip: 99999,
                        snackbar: 99999,
                        drawer: 99999,
                      },
                    });
                  mf.subscribe(function (e) {
                    e !== r && o(e);
                  }),
                    hf.subscribe(function (e) {
                      e !== i && s(e);
                    }),
                    (0, t.useEffect)(
                      function () {
                        gf.subscribe(function (e) {
                          var t = sessionStorage.getItem("Authorization");
                          h(t ? JSON.parse(atob(t)) : "");
                        });
                      },
                      [gf]
                    ),
                    (0, t.useEffect)(function () {
                      !(function (e) {
                        document
                          .querySelectorAll('[href$="/account"]')
                          .forEach(function (t) {
                            t.addEventListener("click", function (n) {
                              var r = t.getAttribute("href");
                              r &&
                                r.split("?")[0].indexOf("/account") > -1 &&
                                (n.preventDefault(), e(!0));
                            });
                          });
                      })(u);
                    }),
                    (0, t.useEffect)(
                      function () {
                        c ? v() : b(), ff.next(c);
                      },
                      [c]
                    );
                  var g = (function (e) {
                    void 0 === e && (e = {});
                    var t = e.window,
                      n = void 0 === t ? document.defaultView : t,
                      r = n.history;
                    function o() {
                      var e = n.location,
                        t = e.pathname,
                        o = e.search,
                        a = e.hash,
                        i = r.state || {};
                      return [
                        i.idx,
                        eT({
                          pathname: t,
                          search: o,
                          hash: a,
                          state: i.usr || null,
                          key: i.key || "default",
                        }),
                      ];
                    }
                    var a = null;
                    n.addEventListener("popstate", function () {
                      if (a) p.call(a), (a = null);
                      else {
                        var e = XI.Pop,
                          t = o(),
                          n = t[0],
                          r = t[1];
                        if (p.length) {
                          if (null != n) {
                            var i = l - n;
                            i &&
                              ((a = {
                                action: e,
                                location: r,
                                retry: function () {
                                  b(-1 * i);
                                },
                              }),
                              b(i));
                          }
                        } else v(e);
                      }
                    });
                    var i = XI.Pop,
                      s = o(),
                      l = s[0],
                      c = s[1],
                      u = rT(),
                      p = rT();
                    function m(e) {
                      return "string" == typeof e
                        ? e
                        : (function (e) {
                            var t = e.pathname,
                              n = void 0 === t ? "/" : t,
                              r = e.search,
                              o = void 0 === r ? "" : r,
                              a = e.hash,
                              i = void 0 === a ? "" : a;
                            return (
                              o &&
                                "?" !== o &&
                                (n += "?" === o.charAt(0) ? o : "?" + o),
                              i &&
                                "#" !== i &&
                                (n += "#" === i.charAt(0) ? i : "#" + i),
                              n
                            );
                          })(e);
                    }
                    function h(e, t) {
                      return (
                        void 0 === t && (t = null),
                        eT(
                          (0, d.Z)(
                            { pathname: c.pathname, hash: "", search: "" },
                            "string" == typeof e
                              ? (function (e) {
                                  var t = {};
                                  if (e) {
                                    var n = e.indexOf("#");
                                    n >= 0 &&
                                      ((t.hash = e.substr(n)),
                                      (e = e.substr(0, n)));
                                    var r = e.indexOf("?");
                                    r >= 0 &&
                                      ((t.search = e.substr(r)),
                                      (e = e.substr(0, r))),
                                      e && (t.pathname = e);
                                  }
                                  return t;
                                })(e)
                              : e,
                            {
                              state: t,
                              key: Math.random().toString(36).substr(2, 8),
                            }
                          )
                        )
                      );
                    }
                    function f(e, t) {
                      return [{ usr: e.state, key: e.key, idx: t }, m(e)];
                    }
                    function g(e, t, n) {
                      return (
                        !p.length ||
                        (p.call({ action: e, location: t, retry: n }), !1)
                      );
                    }
                    function v(e) {
                      i = e;
                      var t = o();
                      (l = t[0]),
                        (c = t[1]),
                        u.call({ action: i, location: c });
                    }
                    function b(e) {
                      r.go(e);
                    }
                    null == l &&
                      ((l = 0),
                      r.replaceState((0, d.Z)({}, r.state, { idx: l }), ""));
                    var _ = {
                      get action() {
                        return i;
                      },
                      get location() {
                        return c;
                      },
                      createHref: m,
                      push: function e(t, o) {
                        var a = XI.Push,
                          i = h(t, o);
                        if (
                          g(a, i, function () {
                            e(t, o);
                          })
                        ) {
                          var s = f(i, l + 1),
                            c = s[0],
                            u = s[1];
                          try {
                            r.pushState(c, "", u);
                          } catch (e) {
                            n.location.assign(u);
                          }
                          v(a);
                        }
                      },
                      replace: function e(t, n) {
                        var o = XI.Replace,
                          a = h(t, n);
                        if (
                          g(o, a, function () {
                            e(t, n);
                          })
                        ) {
                          var i = f(a, l),
                            s = i[0],
                            c = i[1];
                          r.replaceState(s, "", c), v(o);
                        }
                      },
                      go: b,
                      back: function () {
                        b(-1);
                      },
                      forward: function () {
                        b(1);
                      },
                      listen: function (e) {
                        return u.push(e);
                      },
                      block: function (e) {
                        var t = p.push(e);
                        return (
                          1 === p.length && n.addEventListener(tT, nT),
                          function () {
                            t(), p.length || n.removeEventListener(tT, nT);
                          }
                        );
                      },
                    };
                    return _;
                  })();
                  (0, t.useEffect)(
                    function () {
                      var e = window.location.href,
                        t = "/account";
                      e.includes(t) && e.substring(e.indexOf(t)) === t && u(!0);
                    },
                    [g]
                  ),
                    (0, t.useEffect)(
                      function () {
                        (document.getElementsByTagName(
                          "body"
                        )[0].style.overflow = c ? "hidden" : "auto"),
                          ff.next(c);
                      },
                      [c]
                    );
                  var v = function () {
                      document.getElementsByTagName("html")[0].style.fontSize =
                        "14px";
                    },
                    b = function () {
                      document.getElementsByTagName("html")[0].style.fontSize =
                        "small";
                    };
                  return (0, e.jsx)(
                    ee,
                    YT(
                      { i18n: Dt },
                      {
                        children: (0, e.jsx)(
                          QI,
                          YT(
                            { theme: f },
                            {
                              children: (0, e.jsxs)(
                                "div",
                                YT(
                                  {
                                    style: r
                                      ? { pointerEvents: "none" }
                                      : { pointerEvents: "all" },
                                  },
                                  {
                                    children: [
                                      r ? (0, e.jsx)(Sh, { sx: Oo }) : "",
                                      (0, e.jsxs)("div", {
                                        children: [
                                          (0, e.jsx)(
                                            Gm,
                                            YT(
                                              {
                                                anchorOrigin: {
                                                  vertical: "bottom",
                                                  horizontal: "right",
                                                },
                                                open: i,
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  ch,
                                                  YT(
                                                    {
                                                      severity: "error",
                                                      onClose: function () {
                                                        hf.next(!1);
                                                      },
                                                    },
                                                    {
                                                      children:
                                                        "Error while processing your request...!!!",
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          m && "" !== m.token
                                            ? (0, e.jsx)(HI, {
                                                setIsDrawerOpen: u,
                                              })
                                            : (0, e.jsx)(qT, {}),
                                        ],
                                      }),
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      }
                    )
                  );
                }, {}),
              }
            )
          ),
        }),
        document.getElementById("css-backoffice")
      );
    })();
})();
